const DICTIONARY = [
  {
    character: '⺀',
    definition: 'ice',
    pinyin: [],
    decomposition: '？',
    radical: '⺀',
    matches: [null, null],
  },
  {
    character: '⺈',
    pinyin: [],
    decomposition: '？',
    radical: '⺈',
    matches: [null, null],
  },
  {
    character: '⺊',
    pinyin: [],
    decomposition: '⿰丨？',
    etymology: {
      type: 'ideographic',
      hint: 'A crack on an oracle bone; compare 卜',
    },
    radical: '⺊',
    matches: [[0], null],
  },
  {
    character: '⺌',
    pinyin: [],
    decomposition: '？',
    radical: '⺌',
    matches: [null, null, null],
  },
  {
    character: '⺍',
    pinyin: [],
    decomposition: '？',
    radical: '⺍',
    matches: [null, null, null],
  },
  {
    character: '⺗',
    definition: 'heart; mind; soul',
    pinyin: [],
    decomposition: '？',
    radical: '⺗',
    matches: [null, null, null, null],
  },
  {
    character: '⺮',
    definition: 'bamboo; flute',
    pinyin: ['zhú'],
    decomposition: '？',
    etymology: { type: 'pictographic', hint: 'Two stalks of bamboo; see 竹' },
    radical: '⺮',
    matches: [null, null, null, null, null, null],
  },
  {
    character: '⺳',
    definition: 'net, network',
    pinyin: [],
    decomposition: '⿱冖八',
    radical: '⺳',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '⺼',
    definition: 'meat, flesh; organic compound',
    pinyin: [],
    decomposition: '？',
    etymology: {
      type: 'pictographic',
      hint: 'Meat on the ribs of an animal; compare 肉',
    },
    radical: '⺼',
    matches: [null, null, null, null],
  },
  {
    character: '㐆',
    definition: 'old form of 隱',
    pinyin: ['yǐn'],
    decomposition: '⿻尸？',
    radical: '尸',
    matches: [null, [0], [0], null, [0], null],
  },
  {
    character: '㐌',
    definition: 'a tribe of savages in South China',
    pinyin: ['yí'],
    decomposition: '⿱亻也',
    etymology: {
      type: 'pictophonetic',
      phonetic: '也',
      semantic: '亻',
      hint: 'people',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '㐬',
    definition: 'pennant; wild, barren, uncultivated',
    pinyin: ['liú'],
    decomposition: '⿳亠厶川',
    radical: '川',
    matches: [[0], [0], [1], [1], [2], [2], [2]],
  },
  {
    character: '㐭',
    definition: 'granary; to stockpile, to supply',
    pinyin: ['lǐn'],
    decomposition: '⿱亠回',
    etymology: { type: 'ideographic', hint: 'Compare 廩' },
    radical: '亠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '㐱',
    definition: 'bushy, black hair; variant of 鬒',
    pinyin: ['zhěn'],
    decomposition: '⿱人彡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '人',
      semantic: '彡',
      hint: 'hair',
    },
    radical: '彡',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '㒸',
    definition: 'to obey, to follow; year, season, harvest',
    pinyin: ['suì'],
    decomposition: '⿱丷豕',
    radical: '豕',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '㒼',
    definition: 'average; equivalent',
    pinyin: ['mán'],
    decomposition: '⿱廿⿻巾⿰入入',
    etymology: {
      type: 'ideographic',
      hint: 'To weights 入 balanced on a scale 巾',
    },
    radical: '巾',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 1],
      [1, 1, 1],
    ],
  },
  {
    character: '㓞',
    definition: 'to engrave; a written contract or agreement',
    pinyin: ['qià'],
    decomposition: '⿰丰刀',
    etymology: { type: 'pictophonetic', semantic: '刀', hint: 'knife' },
    radical: '刀',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '㔾',
    definition: 'seal; kneeling person',
    pinyin: ['xiān'],
    decomposition: '？',
    etymology: {
      type: 'pictographic',
      hint: 'A rolled-up scroll or kneeling person; compare 卩',
    },
    radical: '㔾',
    matches: [null, null],
  },
  {
    character: '㕡',
    definition: 'gully, pool; a ditch carved by a torrential rain',
    pinyin: ['hé'],
    decomposition: '⿰⿱？谷又',
    etymology: {
      type: 'ideographic',
      hint: 'Water flowing through a gorge 谷',
    },
    radical: '谷',
    matches: [
      null,
      null,
      null,
      null,
      null,
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
    ],
  },
  {
    character: '㝵',
    definition: 'to obtain, to get, to acquire; ancient form of 得',
    pinyin: ['dé'],
    decomposition: '⿱旦寸',
    etymology: { type: 'ideographic', hint: 'A hand 寸 grabbing a shell 旦' },
    radical: '寸',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '㠯',
    definition: 'according to, for, with; to use',
    pinyin: ['yǐ'],
    decomposition: '⿻己？',
    radical: '己',
    matches: [[0], [0], [0], null, null],
  },
  {
    character: '㡭',
    definition: 'to continue; to carry on; to succeed, to inherit',
    pinyin: ['jì'],
    decomposition: '⿺⿳⿰纟纟一⿰纟纟？',
    etymology: {
      type: 'ideographic',
      hint: 'An unbroken thread 纟 from the top to the bottom',
    },
    radical: '纟',
    matches: [
      [0, 0, 0],
      [0, 0, 0],
      [0, 0, 0],
      [0, 0, 1],
      [0, 0, 1],
      [0, 0, 1],
      [0, 1],
      [0, 2, 0],
      [0, 2, 0],
      [0, 2, 0],
      [0, 2, 1],
      [0, 2, 1],
      [0, 2, 1],
      null,
    ],
  },
  {
    character: '㢆',
    definition: 'store, shop, living space',
    pinyin: ['chán'],
    decomposition: '⿸广里',
    etymology: { type: 'ideographic', hint: 'A house 广 in a village 里' },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '㢟',
    definition: 'to walk slowly; to stroll; to ramble',
    pinyin: ['chān'],
    decomposition: '⿺廴止',
    etymology: {
      type: 'ideographic',
      hint: 'A foot 止 strolling down the road 廴',
    },
    radical: '廴',
    matches: [[1], [1], [1], [0], [0]],
  },
  {
    character: '㣎',
    definition: 'fine, delicate',
    pinyin: ['mù'],
    decomposition: '⿳白小彡',
    etymology: {
      type: 'ideographic',
      hint: 'Seeds 彡 falling off a ripe 白 plant 小',
    },
    radical: '白',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [2], [2], [2]],
  },
  {
    character: '㥯',
    definition: 'careful, prudent; compassionate; grieved; worried',
    pinyin: ['yǐn'],
    decomposition: '⿱⿳爫工彐心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彐',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 2],
      [0, 2],
      [0, 2],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '㧜',
    definition: 'to grasp, to hold, to pull at',
    pinyin: ['liè'],
    decomposition: '⿰扌匝',
    etymology: {
      type: 'ideographic',
      hint: 'To surround 匝 something with a hand 扌',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '㬎',
    definition: 'motes in a sunbeam; illustrious, bright',
    pinyin: ['xiǎn'],
    decomposition: '⿳日⿰幺幺灬',
    etymology: {
      type: 'ideographic',
      hint: 'Tiny 幺 motes of dust 灬 in a sunbeam 日',
    },
    radical: '日',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '㲋',
    definition: 'rabbit, hare',
    pinyin: ['chuò'],
    decomposition: '⿳⺈口比',
    etymology: { type: 'pictographic', hint: 'A rabbit looking to the left' },
    radical: '比',
    matches: [[0], [0], [1], [1], [1], [2], [2], [2], [2]],
  },
  {
    character: '㳄',
    definition: 'saliva, spittle',
    pinyin: ['xián'],
    decomposition: '⿰氵欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '欠',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '㼌',
    definition: 'melon patch; weary, feeble',
    pinyin: ['yǔ'],
    decomposition: '⿰瓜瓜',
    etymology: { type: 'ideographic', hint: 'Several melons 瓜 growing' },
    radical: '瓜',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '㿽',
    definition: 'small bowl, small basin',
    pinyin: ['xī'],
    decomposition: '⿱兮皿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兮',
      semantic: '皿',
      hint: 'dish',
    },
    radical: '皿',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '䍃',
    definition: 'vase, pitcher, earthenware',
    pinyin: ['yóu'],
    decomposition: '⿱爫缶',
    etymology: { type: 'pictographic', hint: 'Pottery; compare 缶' },
    radical: '缶',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '䕭',
    definition: 'a kind of grass; a vegetable; nettle, Urtica',
    pinyin: ['qián'],
    decomposition: '⿱艹燅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '燅',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '䙴',
    definition: 'to fly, to move, to change',
    pinyin: ['qiān'],
    decomposition: '⿳覀大㔾',
    etymology: { type: 'pictophonetic', phonetic: '㔾' },
    radical: '覀',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [2], [2]],
  },
  {
    character: '䜌',
    definition: 'chaos, distraction; to manage, to tie together',
    pinyin: ['luán'],
    decomposition: '⿲糹言糹',
    etymology: { type: 'ideographic', hint: 'A spool 言 bound by thread 糹' },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '䠀',
    definition: 'to meditate; to sit cross-legged',
    pinyin: ['tāng'],
    decomposition: '⿰足尚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尚',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '䧹',
    definition: 'eagle, falcon, hawk',
    pinyin: ['yīng'],
    decomposition: '⿸广倠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '广',
      semantic: '隹',
      hint: 'bird',
    },
    radical: '隹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '䰾',
    definition: 'shark; bonito',
    pinyin: ['bā'],
    decomposition: '⿰魚巴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巴',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '䴉',
    definition: 'spoonbill, ibis; Threskiornidae',
    pinyin: ['huán'],
    decomposition: '⿰睘鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '睘',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '一',
    definition: 'one; a, an; alone',
    pinyin: ['yī'],
    decomposition: '？',
    etymology: {
      type: 'ideographic',
      hint: 'Represents heaven (天), earth (旦), or the number 1',
    },
    radical: '一',
    matches: [null],
  },
  {
    character: '丁',
    definition: 'male adult; robust, vigorous; 4th heavenly stem',
    pinyin: ['dīng'],
    decomposition: '一',
    etymology: { type: 'pictographic', hint: 'A nail' },
    radical: '一',
    matches: [[], null],
  },
  {
    character: '丂',
    definition: 'obstruction of breath (qi); variant of 考',
    pinyin: ['kǎo'],
    decomposition: '⿱一？',
    radical: '一',
    matches: [[0], null],
  },
  {
    character: '七',
    definition: 'seven',
    pinyin: ['qī'],
    decomposition: '⿻一乚',
    radical: '一',
    matches: [[0], [1]],
  },
  {
    character: '丄',
    definition: 'above',
    pinyin: ['shàng'],
    decomposition: '⿱丨一',
    etymology: {
      type: 'ideographic',
      hint: 'One stroke on top of another; variant of 上',
    },
    radical: '一',
    matches: [[0], [1]],
  },
  {
    character: '万',
    definition: 'ten thousand; innumerable',
    pinyin: ['wàn'],
    decomposition: '⿱一？',
    radical: '一',
    matches: [[0], null, null],
  },
  {
    character: '丈',
    definition: 'gentleman, man, husband; unit of length equal to 3.3 meters',
    pinyin: ['zhàng'],
    decomposition: '⿻一又',
    radical: '一',
    matches: [[0], [1], [1]],
  },
  {
    character: '三',
    definition: 'three',
    pinyin: ['sān'],
    decomposition: '⿱一二',
    etymology: {
      type: 'ideographic',
      hint: 'Three  parallel lines; compare 一 (one) and 二 (two)',
    },
    radical: '一',
    matches: [[0], [1], [1]],
  },
  {
    character: '上',
    definition: 'above, on top, superior; to go up; to attend; previous',
    pinyin: ['shàng'],
    decomposition: '⿱⺊一',
    etymology: {
      type: 'ideographic',
      hint: 'One stroke on top of another; compare 下 (below)',
    },
    radical: '一',
    matches: [[0], [0], [1]],
  },
  {
    character: '下',
    definition: 'below, underneath; inferior; to bring down; next',
    pinyin: ['xià'],
    decomposition: '⿱一卜',
    etymology: {
      type: 'ideographic',
      hint: 'One stroke under another; compare 上 (above)',
    },
    radical: '一',
    matches: [[0], [1], [1]],
  },
  {
    character: '丌',
    definition: 'table',
    pinyin: ['jī'],
    decomposition: '⿱一？',
    etymology: { type: 'pictographic', hint: 'A table' },
    radical: '一',
    matches: [[0], null, null],
  },
  {
    character: '不',
    definition: 'no, not, un-; negative prefix',
    pinyin: ['bù'],
    decomposition: '⿱一？',
    etymology: { type: 'ideographic', hint: 'A bird flying toward the sky 一' },
    radical: '一',
    matches: [[0], null, null, null],
  },
  {
    character: '与',
    definition: 'and; with; to; for; to give, to grant',
    pinyin: ['yǔ'],
    decomposition: '⿹？一',
    radical: '一',
    matches: [null, null, [1]],
  },
  {
    character: '丏',
    definition: 'parapet; invisible, hidden',
    pinyin: ['miǎn'],
    decomposition: '⿱一？',
    radical: '一',
    matches: [[0], null, null, null],
  },
  {
    character: '丐',
    definition: 'beggar; to beg; to give',
    pinyin: ['gài'],
    decomposition: '⿱下？',
    etymology: {
      type: 'pictographic',
      hint: 'A person leaning forward to ask for help',
    },
    radical: '一',
    matches: [[0], [0], [0], null],
  },
  {
    character: '丑',
    definition: 'ugly; shameful; comedian, clown',
    pinyin: ['chǒu'],
    decomposition: '⿻刀二',
    radical: '一',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '专',
    definition: 'concentrated, specialized; to monopolize',
    pinyin: ['zhuān'],
    decomposition: '⿻？一',
    radical: '一',
    matches: [null, [1], null, null],
  },
  {
    character: '且',
    definition: 'moreover, also (post-subject); about to, will soon (pre-verb)',
    pinyin: ['qiě'],
    decomposition: '⿱月一',
    etymology: { type: 'pictographic', hint: 'A stone altar' },
    radical: '一',
    matches: [[0], [0], [0], [0], [1]],
  },
  {
    character: '丕',
    definition: 'great, grand, glorious, distinguished',
    pinyin: ['pī'],
    decomposition: '⿱不一',
    radical: '一',
    matches: [[0], [0], [0], [0], [1]],
  },
  {
    character: '世',
    definition: 'generation, era, age; world',
    pinyin: ['shì'],
    decomposition: '⿻廿？',
    etymology: { type: 'pictographic', hint: 'Three leaves on a branch' },
    radical: '一',
    matches: [[0], [0], [0], [0], null],
  },
  {
    character: '丘',
    definition: 'mound, hill; surname',
    pinyin: ['qiū'],
    decomposition: '⿱斤一',
    etymology: { type: 'pictographic', hint: 'Two hills' },
    radical: '一',
    matches: [[0], [0], [0], [0], [1]],
  },
  {
    character: '丙',
    definition: 'third; 3rd heavenly stem',
    pinyin: ['bǐng'],
    decomposition: '⿱一内',
    radical: '一',
    matches: [[0], [1], [1], [1], [1]],
  },
  {
    character: '业',
    definition: 'business, profession; to study, to work',
    pinyin: ['yè'],
    decomposition: '⿱？一',
    radical: '一',
    matches: [null, null, null, null, [1]],
  },
  {
    character: '丛',
    definition: 'bush, shrub; thicket; collection',
    pinyin: ['cóng'],
    decomposition: '⿱从一',
    etymology: {
      type: 'pictophonetic',
      phonetic: '从',
      semantic: '一',
      hint: 'one',
    },
    radical: '一',
    matches: [[0], [0], [0], [0], [1]],
  },
  {
    character: '东',
    definition: 'east, eastern, eastward',
    pinyin: ['dōng'],
    decomposition: '⿻七小',
    etymology: {
      type: 'pictographic',
      hint: 'Simplified form of 東, the sun 日 rising behind a tree 木',
    },
    radical: '一',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '丝',
    definition: 'silk, fine thread; wire; strings',
    pinyin: ['sī'],
    decomposition: '⿱⿰？？一',
    etymology: {
      type: 'ideographic',
      hint: 'Simplified form of 絲, two threads',
    },
    radical: '一',
    matches: [null, null, null, null, [1]],
  },
  {
    character: '丞',
    definition: 'to aid, to assist, to rescue',
    pinyin: ['chéng'],
    decomposition: '⿱氶一',
    etymology: {
      type: 'pictophonetic',
      phonetic: '氶',
      semantic: '一',
      hint: 'one',
    },
    radical: '一',
    matches: [[0], [0], [0], [0], [0], [1]],
  },
  {
    character: '丟',
    definition: 'to lose; to discard',
    pinyin: ['diū'],
    decomposition: '⿱王厶',
    radical: '一',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '丢',
    definition: 'to lose; to discard',
    pinyin: ['diū'],
    decomposition: '⿱王厶',
    etymology: { type: 'ideographic', hint: 'A lost 厶 jade 玉' },
    radical: '一',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '两',
    definition: 'two, both, pair, couple; ounce',
    pinyin: ['liǎng'],
    decomposition: '⿱一⿻冂从',
    etymology: {
      type: 'ideographic',
      hint: 'Two people 从 together in a cart',
    },
    radical: '一',
    matches: [[0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '严',
    definition: 'strict, rigorous, rigid; stern',
    pinyin: ['yán'],
    decomposition: '⿻亚厂',
    radical: '一',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '並',
    definition: "to combine, to annex; also, what's more",
    pinyin: ['bìng'],
    decomposition: '⿱丷亚',
    etymology: {
      type: 'ideographic',
      hint: 'Two people sitting side-by-side; compare 竝',
    },
    radical: '一',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '丧',
    definition: 'mourning; mourn; funeral',
    pinyin: ['sàng'],
    decomposition: '⿱？亡',
    etymology: {
      type: 'pictographic',
      hint: 'Simplified form of 喪; to cry 哭 over the dead 亡',
    },
    radical: '十',
    matches: [null, null, null, null, null, [1], [1], [1]],
  },
  {
    character: '丨',
    definition: 'number one; line',
    pinyin: ['shù'],
    decomposition: '？',
    radical: '丨',
    matches: [null],
  },
  {
    character: '丩',
    definition: 'to connect, to join; vine',
    pinyin: ['jiū'],
    decomposition: '⿰？丨',
    radical: '丨',
    matches: [null, [1]],
  },
  {
    character: '个',
    definition: 'this, that; single; measure word for individuals',
    pinyin: ['gè'],
    decomposition: '⿱人丨',
    etymology: { type: 'ideographic', hint: 'A tally 丨 of people 人' },
    radical: '丨',
    matches: [[0], [0], [1]],
  },
  {
    character: '丫',
    definition: 'forked; bifurcation',
    pinyin: ['yā'],
    decomposition: '⿱丷丨',
    etymology: { type: 'ideographic', hint: 'A forked line 丨' },
    radical: '丨',
    matches: [[0], [0], [1]],
  },
  {
    character: '丬',
    definition: 'half of tree trunk',
    pinyin: ['qiáng'],
    decomposition: '⿰冫丨',
    radical: '丬',
    matches: [[0], [0], [1]],
  },
  {
    character: '中',
    definition:
      'central; center, middle; amidst; to hit (target), to attain; China; Chinese',
    pinyin: ['zhōng'],
    decomposition: '⿻口丨',
    etymology: {
      type: 'ideographic',
      hint: 'A line 丨 through the center of a box 口',
    },
    radical: '丨',
    matches: [[0], [0], [0], [1]],
  },
  {
    character: '丰',
    definition: 'abundant, lush, bountiful, plenty',
    pinyin: ['fēng'],
    decomposition: '⿻三丨',
    etymology: { type: 'pictographic', hint: 'An ear of grass' },
    radical: '丨',
    matches: [[0], [0], [0], [1]],
  },
  {
    character: '丱',
    definition: "a child's hair bound in two tufts; ore",
    pinyin: ['guàn'],
    decomposition: '⿰丩？',
    etymology: { type: 'pictographic', hint: 'Two braids 丱 of hair' },
    radical: '丨',
    matches: [[0], [0], null, null, null],
  },
  {
    character: '串',
    definition: 'string; relatives; to conspire',
    pinyin: ['chuàn'],
    decomposition: '⿻⿱口口丨',
    etymology: {
      type: 'ideographic',
      hint: 'Two objects 口 strung 丨 together',
    },
    radical: '丨',
    matches: [[0, 0], [0, 0], [0, 0], [0, 1], [0, 1], [0, 1], [1]],
  },
  {
    character: '临',
    definition: 'to draw near, to approach; to descend',
    pinyin: ['lín'],
    decomposition: '⿰⿰？丨？',
    radical: '丨',
    matches: [null, [0, 1], null, null, null, null, null, null, null],
  },
  {
    character: '丵',
    definition: 'thick (grass)',
    pinyin: ['zhuó'],
    decomposition: '⿱业⿱丷干',
    radical: '丨',
    matches: [[0], [0], [0], [0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '丶',
    definition: 'dot',
    pinyin: ['diǎn'],
    decomposition: '？',
    radical: '丶',
    matches: [null],
  },
  {
    character: '丷',
    definition: 'kwukyel',
    pinyin: ['ha'],
    decomposition: '⿰丶？',
    radical: '丷',
    matches: [[0], null],
  },
  {
    character: '丸',
    definition: 'ball, pebble, pellet, pill',
    pinyin: ['wán'],
    decomposition: '⿻九丶',
    etymology: { type: 'pictographic', hint: 'A fist 九 holding a pebble 丶' },
    radical: '丶',
    matches: [[0], [0], [1]],
  },
  {
    character: '丹',
    definition: 'cinnabar, red, vermilion; pellet, powder',
    pinyin: ['dān'],
    decomposition: '⿻冂亠',
    etymology: { type: 'ideographic', hint: 'A red pellet 丶 from a mine 井' },
    radical: '丶',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '为',
    definition: 'to do, to act; to handle, to govern; to be',
    pinyin: ['wèi'],
    decomposition: '⿻丶⿴力丶',
    radical: '丶',
    matches: [[0], [1, 0], [1, 0], [1, 1]],
  },
  {
    character: '主',
    definition: 'to own; to host; master; host; lord',
    pinyin: ['zhǔ'],
    decomposition: '⿱丶王',
    etymology: { type: 'pictographic', hint: 'A lamp 王 with a flame 丶' },
    radical: '丶',
    matches: [[0], [1], [1], [1], [1]],
  },
  {
    character: '丽',
    definition: 'beautiful, elegant, magnificent',
    pinyin: ['lì'],
    decomposition: '⿱一⿰⿵冂丶⿵冂丶',
    etymology: {
      type: 'ideographic',
      hint: 'Simplified form of 麗; the antlers of a deer 鹿',
    },
    radical: '丶',
    matches: [
      [0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 1],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 1],
    ],
  },
  {
    character: '举',
    definition: 'to raise; to recommend; to praise',
    pinyin: ['jǔ'],
    decomposition: '⿱兴扌',
    etymology: {
      type: 'pictophonetic',
      semantic: '扌',
      hint: 'hand',
      phonetic: '舉',
    },
    radical: '丶',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '丿',
    definition: 'slash',
    pinyin: ['piě'],
    decomposition: '？',
    radical: '丿',
    matches: [null],
  },
  {
    character: '乂',
    definition: 'to govern; to control; to nurture',
    pinyin: ['yì'],
    decomposition: '⿻丿？',
    etymology: {
      type: 'ideographic',
      hint: 'Shears, for cultivating a garden',
    },
    radical: '丿',
    matches: [[0], null],
  },
  {
    character: '乃',
    definition: 'then; really, indeed, after all',
    pinyin: ['nǎi'],
    decomposition: '⿹？丿',
    etymology: { type: 'ideographic', hint: 'A pregnant woman; compare 孕' },
    radical: '丿',
    matches: [null, [1]],
  },
  {
    character: '久',
    definition: 'long ago; a long time',
    pinyin: ['jiǔ'],
    decomposition: '⿻勹？',
    radical: '丿',
    matches: [[0], [0], null],
  },
  {
    character: '乇',
    definition: 'to depend on, to entrust with',
    pinyin: ['tuō'],
    decomposition: '⿱丿七',
    radical: '丿',
    matches: [[0], [1], [1]],
  },
  {
    character: '么',
    definition: 'interrogative particle',
    pinyin: ['me'],
    decomposition: '⿱丿厶',
    radical: '丿',
    matches: [[0], [1], [1]],
  },
  {
    character: '义',
    definition: 'right conduct, propriety; justice',
    pinyin: ['yì'],
    decomposition: '⿻丶乂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乂',
      semantic: '⺷',
      hint: 'sheep; simplified form of 義',
    },
    radical: '丿',
    matches: [[0], [1], [1]],
  },
  {
    character: '之',
    definition:
      'marks preceding phrase as modifier of following phrase; it, him her, them; to go to',
    pinyin: ['zhī'],
    decomposition: '⿱丶？',
    etymology: {
      type: 'ideographic',
      hint: 'A foot meaning "to follow"; cursive version of 止',
    },
    radical: '丿',
    matches: [[0], null, null],
  },
  {
    character: '乌',
    definition: 'crow, rook, raven; black, dark',
    pinyin: ['wū'],
    decomposition: '⿱丿？',
    etymology: {
      type: 'pictographic',
      hint: 'Simplified form of 烏; a crow; compare 鸟',
    },
    radical: '丿',
    matches: [[0], null, null, null],
  },
  {
    character: '乍',
    definition: 'first time, for the first time, suddenly',
    pinyin: ['zhà'],
    decomposition: '⿸丿⿻下一',
    radical: '丿',
    matches: [[0], [1, 0], [1, 0], [1, 0], [1, 1]],
  },
  {
    character: '乎',
    definition: 'interrogative or exclamatory final particle',
    pinyin: ['hū'],
    decomposition: '⿻丿⿻？丷',
    radical: '丿',
    matches: [[0], [1, 1], [1, 1], null, null],
  },
  {
    character: '乏',
    definition: 'poor; short, lacking; tired',
    pinyin: ['fá'],
    decomposition: '⿱丿之',
    etymology: {
      type: 'ideographic',
      hint: 'A foot 之 running into a wall or barrier 丿',
    },
    radical: '丿',
    matches: [[0], [1], [1], [1]],
  },
  {
    character: '乐',
    definition: 'cheerful, happy, laughing; music',
    pinyin: ['lè'],
    decomposition: '⿻⿱丿？小',
    etymology: {
      type: 'ideographic',
      hint: 'Simplified form of 樂, a musical instrument with wood 木, strings 幺, and a pick 白',
    },
    radical: '丿',
    matches: [[0, 0], null, [1], [1], [1]],
  },
  {
    character: '乑',
    definition: 'to stand side by side',
    pinyin: ['yín'],
    decomposition: '⿱丿？',
    radical: '丿',
    matches: [[0], null, null, null, null, null],
  },
  {
    character: '乒',
    definition: 'used with pong for ping pong',
    pinyin: ['pīng'],
    decomposition: '⿱丘丿',
    etymology: {
      type: 'ideographic',
      hint: 'A ball bouncing back and forth; compare 乓',
    },
    radical: '丿',
    matches: [[0], [0], [0], [0], [0], [1]],
  },
  {
    character: '乓',
    definition: 'used with ping for ping pong',
    pinyin: ['pāng'],
    decomposition: '⿱丘丶',
    etymology: {
      type: 'ideographic',
      hint: 'A ball bouncing back and forth; compare 乒',
    },
    radical: '丿',
    matches: [[0], [0], [0], [0], [0], [1]],
  },
  {
    character: '乔',
    definition: 'tall, lofty; proud, stately',
    pinyin: ['qiáo'],
    decomposition: '⿱夭？',
    etymology: { type: 'ideographic', hint: 'A person 夭 on stilts' },
    radical: '大',
    matches: [[0], [0], [0], [0], null, null],
  },
  {
    character: '乖',
    definition: 'obedient, well-behaved; clever',
    pinyin: ['guāi'],
    decomposition: '⿻千北',
    radical: '丿',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '乘',
    definition: 'ride, mount; to make use of; to ascend; to multiply',
    pinyin: ['chéng'],
    decomposition: '⿻禾北',
    etymology: {
      type: 'ideographic',
      hint: 'Two feet 北 climbing a beanstalk 禾',
    },
    radical: '丿',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [0], [0]],
  },
  {
    character: '乙',
    definition: 'second; 2nd heavenly stem',
    pinyin: ['yǐ'],
    decomposition: '？',
    etymology: { type: 'pictographic', hint: 'A swallow' },
    radical: '乙',
    matches: [null],
  },
  {
    character: '乚',
    definition: 'secret, hidden, mysterious; small, minute; to conceal',
    pinyin: ['gōu'],
    decomposition: '？',
    radical: '乚',
    matches: [null],
  },
  {
    character: '乛',
    definition: 'kwukyel',
    pinyin: ['ya'],
    decomposition: '？',
    radical: '乛',
    matches: [null],
  },
  {
    character: '乜',
    definition: 'to squint',
    pinyin: ['miē'],
    decomposition: '⿻？乚',
    radical: '乚',
    matches: [null, [1]],
  },
  {
    character: '九',
    definition: 'nine',
    pinyin: ['jiǔ'],
    decomposition: '⿻丿乙',
    etymology: { type: 'pictographic', hint: 'An elbow' },
    radical: '乙',
    matches: [[0], [1]],
  },
  {
    character: '乞',
    definition: 'to beg; to request',
    pinyin: ['qǐ'],
    decomposition: '⿱？乙',
    radical: '乙',
    matches: [null, null, [1]],
  },
  {
    character: '也',
    definition: 'also, too',
    pinyin: ['yě'],
    decomposition: '⿻？乚',
    radical: '乚',
    matches: [null, null, [1]],
  },
  {
    character: '习',
    definition: 'to study, to practice; habit',
    pinyin: ['xí'],
    decomposition: '⿹？冫',
    radical: '冫',
    matches: [null, [1], [1]],
  },
  {
    character: '乡',
    definition: 'country, village; rural',
    pinyin: ['xiāng'],
    decomposition: '幺',
    radical: '幺',
    matches: [[], [], []],
  },
  {
    character: '书',
    definition: 'book, letter, document; writing',
    pinyin: ['shū'],
    decomposition: '⿻？丨',
    etymology: { type: 'ideographic', hint: 'A mark made by a pen ⺺' },
    radical: '丨',
    matches: [null, null, [1], null],
  },
  {
    character: '乩',
    definition: 'to divine',
    pinyin: ['jī'],
    decomposition: '⿰占乚',
    etymology: {
      type: 'pictophonetic',
      semantic: '占',
      hint: 'divine',
      phonetic: '乚',
    },
    radical: '乚',
    matches: [[0], [0], [0], [0], [0], [1]],
  },
  {
    character: '买',
    definition: 'to buy, to purchase; to bribe, to persuade',
    pinyin: ['mǎi'],
    decomposition: '⿱乛头',
    radical: '大',
    matches: [[0], [1], [1], [1], [1], [1]],
  },
  {
    character: '乱',
    definition: 'anarchy, chaos; revolt',
    pinyin: ['luàn'],
    decomposition: '⿰舌乚',
    radical: '乚',
    matches: [[0], [0], [0], [0], [0], [0], [1]],
  },
  {
    character: '乳',
    definition: 'breast, nipples; milk; to suckle',
    pinyin: ['rǔ'],
    decomposition: '⿰孚乚',
    etymology: {
      type: 'pictophonetic',
      semantic: '乚',
      hint: 'hidden',
      phonetic: '孚',
    },
    radical: '乚',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1]],
  },
  {
    character: '乶',
    definition: 'Pholha, a place in Korea',
    pinyin: ['fǔ'],
    decomposition: '⿱甫乙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甫',
      semantic: '乙',
      hint: 'second',
    },
    radical: '乙',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1]],
  },
  {
    character: '乹',
    definition: 'to clean; to dry up',
    pinyin: ['gān'],
    decomposition: '⿰龺乚',
    etymology: {
      type: 'ideographic',
      hint: 'Heat 乚from the sun 龺; 龺 also provides the pronunciation',
    },
    radical: '乚',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1]],
  },
  {
    character: '乾',
    definition:
      'arid, dry; to fertilize; to penetrate; heavenly generative principle (male)',
    pinyin: ['gān'],
    decomposition: '⿰龺乞',
    etymology: {
      type: 'ideographic',
      hint: 'Rays 十 emanating from the 日; 乞 provides the pronunciation',
    },
    radical: '乙',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '乿',
    definition: 'to heal, to cure',
    pinyin: ['zhì'],
    decomposition: '⿰⿱爫糸乚',
    radical: '乚',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
    ],
  },
  {
    character: '亂',
    definition: 'anarchy, chaos; revolt',
    pinyin: ['luàn'],
    decomposition: '⿰⿳爫？⿵冂⿱厶又乚',
    etymology: {
      type: 'ideographic',
      hint: 'A kneeling person 乚 using their hands 爫 to unravel a knot',
    },
    radical: '乚',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      null,
      null,
      [0, 2, 0],
      [0, 2, 0],
      [0, 2, 1, 0],
      [0, 2, 1, 0],
      [0, 2, 1, 1],
      [0, 2, 1, 1],
      [1],
    ],
  },
  {
    character: '亅',
    definition: 'hook',
    pinyin: ['jué'],
    decomposition: '？',
    radical: '亅',
    matches: [null],
  },
  {
    character: '了',
    definition: 'clear; to finish; particle of completed action',
    pinyin: ['le', 'liǎo'],
    decomposition: '⿱乛亅',
    etymology: {
      type: 'pictographic',
      hint: 'A child swaddled in blanklets; compare 子',
    },
    radical: '亅',
    matches: [[0], [1]],
  },
  {
    character: '予',
    definition: 'to give; to award',
    pinyin: ['yǔ'],
    decomposition: '⿱？丁',
    radical: '亅',
    matches: [null, null, [1], [1]],
  },
  {
    character: '争',
    definition: 'to dispute, to fight, to contend, to strive',
    pinyin: ['zhēng'],
    decomposition: '⿱⺈⿻彐亅',
    etymology: {
      type: 'ideographic',
      hint: 'Simplified form of 爭, two hands 爪 and 彐 fighting over 亅',
    },
    radical: '亅',
    matches: [[0], [0], [1, 0], [1, 0], [1, 0], [1, 1]],
  },
  {
    character: '事',
    definition: 'affair, matter, business; to serve; accident, incident',
    pinyin: ['shì'],
    decomposition: '⿻⿳一口彐亅',
    radical: '亅',
    matches: [[0, 0], [0, 1], [0, 1], [0, 1], [0, 2], [0, 2], [0, 2], [1]],
  },
  {
    character: '二',
    definition: 'two; twice',
    pinyin: ['èr'],
    decomposition: '⿱一一',
    etymology: {
      type: 'ideographic',
      hint: 'Two  parallel lines; compare 一 (one) and 三 (three)',
    },
    radical: '二',
    matches: [[0], [1]],
  },
  {
    character: '亍',
    definition: 'to take small steps; Korean place name',
    pinyin: ['chù'],
    decomposition: '⿱一丁',
    radical: '二',
    matches: [[0], [1], [1]],
  },
  {
    character: '于',
    definition: 'at, in, on; to, from; alas!',
    pinyin: ['yú'],
    decomposition: '⿻二亅',
    radical: '二',
    matches: [[0], [0], [1]],
  },
  {
    character: '亏',
    definition: 'to lose, to fail; loss, damages; deficient',
    pinyin: ['kuī'],
    decomposition: '⿱二？',
    radical: '二',
    matches: [[0], [0], null],
  },
  {
    character: '云',
    definition: 'cloud; to say, to speak',
    pinyin: ['yún'],
    decomposition: '⿱二厶',
    etymology: { type: 'pictographic', hint: 'A cloud' },
    radical: '二',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '互',
    definition: 'mutually, reciprocally',
    pinyin: ['hù'],
    decomposition: '⿴二？',
    etymology: { type: 'ideographic', hint: 'Two hooks hooking eachother' },
    radical: '二',
    matches: [[0], null, null, [0]],
  },
  {
    character: '亓',
    definition: 'that; surname',
    pinyin: ['qí'],
    decomposition: '⿱二？',
    radical: '二',
    matches: [[0], [0], null, null],
  },
  {
    character: '五',
    definition: 'five; surname',
    pinyin: ['wǔ'],
    decomposition: '⿴二？',
    etymology: {
      type: 'ideographic',
      hint: 'Five elements (the cross with the extra stroke) between heaven 一 and earth 一 ',
    },
    radical: '二',
    matches: [[0], null, null, [0]],
  },
  {
    character: '井',
    definition: 'well, mine shaft, pit',
    pinyin: ['jǐng'],
    decomposition: '⿻二？',
    etymology: { type: 'pictographic', hint: 'A mine or well' },
    radical: '二',
    matches: [[0], [0], null, null],
  },
  {
    character: '亘',
    definition: 'to extend across, through; from',
    pinyin: ['gèn'],
    decomposition: '⿻二日',
    etymology: {
      type: 'ideographic',
      hint: 'Stretching from heaven 一 to earth 一 ',
    },
    radical: '二',
    matches: [[0], [1], [1], [1], [1], [0]],
  },
  {
    character: '亙',
    definition: 'through; to extend across; to, from',
    pinyin: ['gèn'],
    decomposition: '⿻二？',
    etymology: { type: 'ideographic', hint: 'A bridge laid across a river 二' },
    radical: '二',
    matches: [[0], null, null, null, null, [0]],
  },
  {
    character: '亚',
    definition: 'Asia; second',
    pinyin: ['yà'],
    decomposition: '⿱一业',
    etymology: {
      type: 'pictographic',
      hint: 'Picture of a cross-shaped house or temple',
    },
    radical: '一',
    matches: [[0], [1], [1], [1], [1], [1]],
  },
  {
    character: '些',
    definition: 'little, few; rather, somewhat',
    pinyin: ['xiē'],
    decomposition: '⿱此二',
    etymology: {
      type: 'pictophonetic',
      phonetic: '此',
      semantic: '二',
      hint: 'two',
    },
    radical: '二',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '亞',
    definition: 'Asia; second',
    pinyin: ['yà'],
    decomposition: '⿻二？',
    etymology: { type: 'pictographic', hint: 'A cross-shaped house or temple' },
    radical: '二',
    matches: [[0], null, null, null, null, null, null, [0]],
  },
  {
    character: '亟',
    definition: 'urgently, immediately, extremely',
    pinyin: ['jí'],
    decomposition: '⿱⿻了叹一',
    radical: '二',
    matches: [[0, 0], [0, 0], [0, 1], [0, 1], [0, 1], [0, 1], [0, 1], [1]],
  },
  {
    character: '亠',
    definition: 'lid, cover; head',
    pinyin: ['tóu'],
    decomposition: '⿱丶一',
    radical: '亠',
    matches: [[0], [1]],
  },
  {
    character: '亡',
    definition: 'death, destruction; to lose; to perish',
    pinyin: ['wáng'],
    decomposition: '⿱亠？',
    etymology: { type: 'ideographic', hint: 'A man 人 in a coffin; see 亾' },
    radical: '亠',
    matches: [[0], [0], null],
  },
  {
    character: '亢',
    definition: 'high, proud; violent, excessive; skilled; surname',
    pinyin: ['kàng'],
    decomposition: '⿱亠几',
    radical: '亠',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '交',
    definition: 'to connect; to deliver, to exchange; to intersect; to mix',
    pinyin: ['jiāo'],
    decomposition: '⿱六乂',
    etymology: {
      type: 'ideographic',
      hint: 'A person with crossed (intersecting) legs',
    },
    radical: '亠',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '亥',
    definition: '12th terrestrial branch; used in transliterations',
    pinyin: ['hài'],
    decomposition: '⿱亠？',
    radical: '亠',
    matches: [[0], [0], null, null, null, null],
  },
  {
    character: '亦',
    definition: 'also, too; likewise',
    pinyin: ['yì'],
    decomposition: '⿱亠？',
    etymology: {
      type: 'ideographic',
      hint: 'A man standing with arrows pointing to his armpits',
    },
    radical: '亠',
    matches: [[0], [0], null, null, null, null],
  },
  {
    character: '产',
    definition: 'to give birth, to bring forth, to produce',
    pinyin: ['chǎn'],
    decomposition: '⿳亠丷厂',
    etymology: { type: 'pictophonetic', phonetic: '厂' },
    radical: '亠',
    matches: [[0], [0], [1], [1], [2], [2]],
  },
  {
    character: '亨',
    definition: 'prospering, going smoothly',
    pinyin: ['hēng'],
    decomposition: '⿳亠口了',
    radical: '亠',
    matches: [[0], [0], [1], [1], [1], [2], [2]],
  },
  {
    character: '亩',
    definition: 'fields; unit of area equal to 660 sq. m.',
    pinyin: ['mǔ'],
    decomposition: '⿱亠田',
    etymology: { type: 'pictophonetic', semantic: '田', hint: 'field' },
    radical: '亠',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '享',
    definition: 'to share; to enjoy; to benefit from',
    pinyin: ['xiǎng'],
    decomposition: '⿳亠口子',
    etymology: {
      type: 'ideographic',
      hint: 'Children 子 living and eating 口 in the house 亠',
    },
    radical: '亠',
    matches: [[0], [0], [1], [1], [1], [2], [2], [2]],
  },
  {
    character: '京',
    definition: 'capital city',
    pinyin: ['jīng'],
    decomposition: '⿳亠口小',
    etymology: { type: 'pictographic', hint: 'A capital building on a hill' },
    radical: '亠',
    matches: [[0], [0], [1], [1], [1], [2], [2], [2]],
  },
  {
    character: '亭',
    definition: 'pavilion; erect',
    pinyin: ['tíng'],
    decomposition: '⿱⿳亠口冖丁',
    etymology: {
      type: 'pictographic',
      hint: '亠, 口, and 冖 form a picture of a pavilion; 丁 provides the pronunciation',
    },
    radical: '亠',
    matches: [[0, 0], [0, 0], [0, 1], [0, 1], [0, 1], [0, 2], [0, 2], [1], [1]],
  },
  {
    character: '亮',
    definition: 'bright, brilliant, radiant, light',
    pinyin: ['liàng'],
    decomposition: '⿳亠口⿱冖几',
    etymology: { type: 'pictographic', hint: 'A lit oil lamp' },
    radical: '亠',
    matches: [[0], [0], [1], [1], [1], [2, 0], [2, 0], [2, 1], [2, 1]],
  },
  {
    character: '亲',
    definition: 'relatives, parents; intimate; the hazelnut tree',
    pinyin: ['qīn'],
    decomposition: '⿱立⿻一小',
    etymology: { type: 'ideographic', hint: 'A tree 木 bearing fruit 立' },
    radical: '立',
    matches: [[0], [0], [0], [0], [0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '亳',
    definition: 'name of district in Anhui; capital of Yin',
    pinyin: ['bó'],
    decomposition: '⿳亠口⿱冖乇',
    radical: '亠',
    matches: [[0], [0], [1], [1], [1], [2, 0], [2, 0], [2, 1], [2, 1], [2, 1]],
  },
  {
    character: '亵',
    definition: 'dirty, ragged; slight, insult, disrespect',
    pinyin: ['xiè'],
    decomposition: '⿴衣执',
    etymology: {
      type: 'ideographic',
      hint: 'Hands grasping 执 and tearing apart a dress 衣',
    },
    radical: '亠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [0], [0], [0], [0]],
  },
  {
    character: '亶',
    definition: 'real, sincere, true; truth',
    pinyin: ['dǎn'],
    decomposition: '⿱亠⿱回旦',
    etymology: { type: 'pictophonetic', phonetic: '旦' },
    radical: '亠',
    matches: [
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '亹',
    definition: 'busy; resolute; to exert; to make progress',
    pinyin: ['mén'],
    decomposition: '⿱亠舋',
    radical: '亠',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '人',
    definition: 'man, person; people',
    pinyin: ['rén'],
    decomposition: '？',
    etymology: { type: 'pictographic', hint: 'The legs of a human being' },
    radical: '人',
    matches: [null, null],
  },
  {
    character: '亻',
    definition: 'man, person; people',
    pinyin: ['rén'],
    decomposition: '？',
    etymology: { type: 'ideographic', hint: 'Visual abbreviation of 人' },
    radical: '亻',
    matches: [null, null],
  },
  {
    character: '亼',
    definition: 'to assemble, to gather together',
    pinyin: ['jí'],
    decomposition: '⿱人一',
    radical: '人',
    matches: [[0], [0], [1]],
  },
  {
    character: '亾',
    definition: 'death, destruction; to lose, to perish',
    pinyin: ['wáng'],
    decomposition: '⿺？人',
    etymology: { type: 'ideographic', hint: 'A man 人 in a coffin' },
    radical: '人',
    matches: [[1], [1], null],
  },
  {
    character: '亿',
    definition: 'hundred million; many',
    pinyin: ['yì'],
    decomposition: '⿰亻乙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乙',
      semantic: '亻',
      hint: 'people',
    },
    radical: '亻',
    matches: [[0], [0], [1]],
  },
  {
    character: '什',
    definition: 'what? mixed, miscellaneous',
    pinyin: ['shén'],
    decomposition: '⿰亻十',
    etymology: { type: 'ideographic', hint: 'A file of ten 十 people 亻' },
    radical: '亻',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '仁',
    definition: 'benevolent, humane, kind',
    pinyin: ['rén'],
    decomposition: '⿰亻二',
    etymology: {
      type: 'ideographic',
      hint: 'A caring relationship between two 二 people 亻',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '仂',
    definition: 'excess, remainder, surplus',
    pinyin: ['lè'],
    decomposition: '⿰亻力',
    etymology: { type: 'pictophonetic', phonetic: '力' },
    radical: '亻',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '仃',
    definition: 'lonely, solitary',
    pinyin: ['dīng'],
    decomposition: '⿰亻丁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丁',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '仄',
    definition: 'slanting, oblique; oblique tones',
    pinyin: ['zè'],
    decomposition: '⿸厂人',
    etymology: {
      type: 'ideographic',
      hint: 'A man 人 taking shelter in a lean-to 厂',
    },
    radical: '人',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '仅',
    definition: 'only, merely, solely, just',
    pinyin: ['jǐn'],
    decomposition: '⿰亻又',
    etymology: { type: 'pictophonetic', semantic: '亻', hint: 'person' },
    radical: '亻',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '仆',
    definition: 'to fall forward; prostrate, prone; servant',
    pinyin: ['pú'],
    decomposition: '⿰亻卜',
    etymology: {
      type: 'pictophonetic',
      semantic: '亻',
      hint: 'person',
      phonetic: '卜',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '仇',
    definition: 'enemy; hatred, enmity',
    pinyin: ['chóu'],
    decomposition: '⿰亻九',
    etymology: {
      type: 'pictophonetic',
      semantic: '亻',
      hint: 'person',
      phonetic: '九',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '仉',
    definition: 'mother; surname of the mother of Mencius',
    pinyin: ['zhǎng'],
    decomposition: '⿰亻几',
    radical: '亻',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '今',
    definition: 'modern, current; today, now',
    pinyin: ['jīn'],
    decomposition: '⿱人？',
    etymology: { type: 'ideographic', hint: 'A mouth 亼 talking about things' },
    radical: '人',
    matches: [[0], [0], null, null],
  },
  {
    character: '介',
    definition: 'agent, go-between, intermediary; to introduce; shell, armor',
    pinyin: ['jiè'],
    decomposition: '⿱人？',
    etymology: { type: 'ideographic', hint: 'A border 八 dividing people 人' },
    radical: '人',
    matches: [[0], [0], null, null],
  },
  {
    character: '仌',
    definition: 'frozen; ice-cold',
    pinyin: ['bīng'],
    decomposition: '⿱人人',
    etymology: { type: 'ideographic', hint: 'Old variant of 冰 ("ice-water")' },
    radical: '人',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '仍',
    definition: 'yet, still; keeping, continuing; again',
    pinyin: ['réng'],
    decomposition: '⿰亻乃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亻',
      semantic: '乃',
      hint: 'then',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '从',
    definition: 'from, by, since, whence, through',
    pinyin: ['cóng'],
    decomposition: '⿰人人',
    etymology: { type: 'ideographic', hint: 'One person 人 following another' },
    radical: '人',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '仑',
    definition: 'logical reasons, logical order',
    pinyin: ['lún'],
    decomposition: '⿱人匕',
    radical: '人',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '仓',
    definition: 'granary, barn; cabin, berth',
    pinyin: ['cāng'],
    decomposition: '⿱人㔾',
    etymology: {
      type: 'ideographic',
      hint: 'Simplified form of 倉; grains 食 kept in storage 口',
    },
    radical: '人',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '仔',
    definition: 'small thing, child; young animal',
    pinyin: ['zǐ'],
    decomposition: '⿰亻子',
    etymology: {
      type: 'ideographic',
      hint: 'A person 亻 keeping watch over a child 子; 子 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '仕',
    definition: 'official; to serve in the government',
    pinyin: ['shì'],
    decomposition: '⿰亻士',
    etymology: {
      type: 'pictophonetic',
      phonetic: '士',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '他',
    definition: 'other, another; he, she, it',
    pinyin: ['tā'],
    decomposition: '⿰亻也',
    etymology: {
      type: 'ideographic',
      hint: 'An additional, "also" 也  person 亻',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '仗',
    definition: '1to rely upon; protector; to fight; war, weaponry',
    pinyin: ['zhàng'],
    decomposition: '⿰亻丈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丈',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '付',
    definition: 'give, deliver, pay, hand over; entrust',
    pinyin: ['fù'],
    decomposition: '⿰亻寸',
    etymology: {
      type: 'ideographic',
      hint: 'To hand 寸 something over to someone 亻 ',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '仙',
    definition: 'god; fairy; immortal, transcendent',
    pinyin: ['xiān'],
    decomposition: '⿰亻山',
    etymology: {
      type: 'pictophonetic',
      phonetic: '山',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '仝',
    definition: 'together, same; surname',
    pinyin: ['tóng'],
    decomposition: '⿱人工',
    etymology: {
      type: 'pictophonetic',
      phonetic: '工',
      semantic: '人',
      hint: 'person',
    },
    radical: '人',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '仞',
    definition: 'ancient unit of measure (about 8 feet); a fathom',
    pinyin: ['rèn'],
    decomposition: '⿰亻刃',
    etymology: { type: 'pictophonetic', phonetic: '刃' },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '仟',
    definition: 'one thousand; leader of one thousand men',
    pinyin: ['qiān'],
    decomposition: '⿰亻千',
    etymology: {
      type: 'pictophonetic',
      phonetic: '千',
      semantic: '亻',
      hint: 'people',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '仡',
    definition: 'strong; valiant, brave',
    pinyin: ['gē'],
    decomposition: '⿰亻乞',
    radical: '亻',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '代',
    definition: 'era, generation; to substitute for, to replace',
    pinyin: ['dài'],
    decomposition: '⿰亻弋',
    etymology: {
      type: 'ideographic',
      hint: 'A man 亻 caught 弋 by the passing of time',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '令',
    definition: 'command, decree, order; magistrate; to allow, to cause',
    pinyin: ['lìng'],
    decomposition: '⿱人？',
    etymology: {
      type: 'ideographic',
      hint: 'A person kneeling before a master 人',
    },
    radical: '人',
    matches: [[0], [0], null, null, null],
  },
  {
    character: '以',
    definition: 'according to; so as to; because of; then',
    pinyin: ['yǐ'],
    decomposition: '⿰？人',
    radical: '人',
    matches: [null, null, [1], [1]],
  },
  {
    character: '仨',
    definition: 'three (cannot be followed by a measure word)',
    pinyin: ['sā'],
    decomposition: '⿰亻三',
    etymology: {
      type: 'pictophonetic',
      phonetic: '三',
      semantic: '三',
      hint: 'three',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '仪',
    definition: 'instrument, apparatus; ceremony, rites',
    pinyin: ['yí'],
    decomposition: '⿰亻义',
    etymology: { type: 'pictophonetic', phonetic: '义' },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '仫',
    definition: 'tribe',
    pinyin: ['mù'],
    decomposition: '⿰亻么',
    etymology: {
      type: 'pictophonetic',
      semantic: '亻',
      hint: 'people',
      phonetic: '么',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '们',
    definition: 'plural marker for pronouns and some nouns',
    pinyin: ['men'],
    decomposition: '⿰亻门',
    etymology: {
      type: 'pictophonetic',
      phonetic: '门',
      semantic: '亻',
      hint: 'people',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '仰',
    definition: 'raise the head to look; look up to, rely on, admire',
    pinyin: ['yǎng'],
    decomposition: '⿰亻卬',
    etymology: { type: 'ideographic', hint: 'To exalt 卬 a person 亻' },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '仲',
    definition: 'middle brother; go between, mediator; surname',
    pinyin: ['zhòng'],
    decomposition: '⿰亻中',
    etymology: {
      type: 'ideographic',
      hint: 'The middle 中 person 亻; 中 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '仳',
    definition: 'separate, part company',
    pinyin: ['pǐ'],
    decomposition: '⿰亻比',
    etymology: {
      type: 'pictophonetic',
      phonetic: '比',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '仵',
    definition: 'similar',
    pinyin: ['wǔ'],
    decomposition: '⿰亻午',
    etymology: { type: 'pictophonetic', phonetic: '午', semantic: '亻' },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '件',
    definition: 'item, matter; component, part; measure word for events',
    pinyin: ['jiàn'],
    decomposition: '⿰亻牛',
    etymology: { type: 'ideographic', hint: 'A man 亻 dividing up a cow 牛' },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '价',
    definition: 'price, value',
    pinyin: ['jià'],
    decomposition: '⿰亻介',
    etymology: { type: 'pictophonetic', phonetic: '介' },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '任',
    definition: 'to trust, to rely on; to appoint; to bear; duty, office',
    pinyin: ['rèn'],
    decomposition: '⿰亻壬',
    etymology: {
      type: 'pictophonetic',
      semantic: '亻',
      hint: 'person',
      phonetic: '壬',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '份',
    definition: 'job, part, role; duty',
    pinyin: ['fèn'],
    decomposition: '⿰亻分',
    etymology: {
      type: 'ideographic',
      hint: 'The lot or portion 分 allotted to a man 亻',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '仿',
    definition: 'to imitate, to copy; fake; as if',
    pinyin: ['fǎng'],
    decomposition: '⿰亻方',
    etymology: {
      type: 'pictophonetic',
      phonetic: '方',
      semantic: '亻',
      hint: 'to imitate a person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '企',
    definition: 'to plan a project; to stand on tiptoe',
    pinyin: ['qǐ'],
    decomposition: '⿱人止',
    etymology: {
      type: 'ideographic',
      hint: 'A man 人 on his feet 止; 止 also provides the pronunciation',
    },
    radical: '人',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '伄',
    definition: 'seldom, irregularly',
    pinyin: ['diào'],
    decomposition: '⿰亻弔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弔',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '伉',
    definition: 'husband, wife; pair; compare, match',
    pinyin: ['kàng'],
    decomposition: '⿰亻亢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亢',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '伊',
    definition: 'he she; this, that; used in transliterations',
    pinyin: ['yī'],
    decomposition: '⿰亻尹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尹',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '伍',
    definition: 'five, company of five; troops',
    pinyin: ['wǔ'],
    decomposition: '⿰亻五',
    etymology: {
      type: 'ideographic',
      hint: 'Five 五 people 亻; 五 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '伎',
    definition: 'talent, skill, craft, ability',
    pinyin: ['jì'],
    decomposition: '⿰亻支',
    etymology: {
      type: 'ideographic',
      hint: 'A man 亻 who can support 支 someone',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '伏',
    definition: 'to crouch, to crawl, to lie hidden, to conceal',
    pinyin: ['fú'],
    decomposition: '⿰亻犬',
    etymology: {
      type: 'ideographic',
      hint: 'A person 亻 acting like a dog 犬',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '伐',
    definition: 'cut down, subjugate, attack',
    pinyin: ['fá'],
    decomposition: '⿰亻戈',
    etymology: { type: 'ideographic', hint: 'A person 亻 attacked 戈' },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '休',
    definition: 'to rest; to stop; to retire',
    pinyin: ['xiū'],
    decomposition: '⿰亻木',
    etymology: {
      type: 'ideographic',
      hint: 'A person 亻 leaning against a tree 木',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '伕',
    definition: 'manual laborer',
    pinyin: ['fū'],
    decomposition: '⿰亻夫',
    etymology: {
      type: 'ideographic',
      hint: 'A working 夫 man 亻; 夫 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '众',
    definition: 'multitude, crowd; masses, public',
    pinyin: ['zhòng'],
    decomposition: '⿱人⿰人人',
    etymology: {
      type: 'ideographic',
      hint: 'Three people 人 representing a crowd',
    },
    radical: '人',
    matches: [[0], [0], [1, 0], [1, 0], [1, 1], [1, 1]],
  },
  {
    character: '优',
    definition: 'superior; elegant',
    pinyin: ['yōu'],
    decomposition: '⿰亻尤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尤',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '伙',
    definition: 'companion, colleague; utensils',
    pinyin: ['huǒ'],
    decomposition: '⿰亻火',
    etymology: {
      type: 'pictophonetic',
      phonetic: '火',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '会',
    definition: 'to assemble, to meet; meeting; association, group',
    pinyin: ['huì'],
    decomposition: '⿱人云',
    etymology: { type: 'ideographic', hint: 'People 人 speaking 云' },
    radical: '人',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '伛',
    definition: 'humpback; stoop',
    pinyin: ['yǔ'],
    decomposition: '⿰亻区',
    etymology: {
      type: 'ideographic',
      hint: 'A person 亻 forced into a box 区',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '伞',
    definition: 'umbrella, parasol, parachute',
    pinyin: ['sǎn'],
    decomposition: '⿱人？',
    etymology: { type: 'pictographic', hint: 'An umbrella' },
    radical: '人',
    matches: [[0], [0], null, null, null, null],
  },
  {
    character: '伟',
    definition: 'great, imposing; extraordinary',
    pinyin: ['wěi'],
    decomposition: '⿰亻韦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韦',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '传',
    definition: 'to pass on; to propagate; to transmit; summons',
    pinyin: ['chuán'],
    decomposition: '⿰亻专',
    etymology: {
      type: 'pictophonetic',
      phonetic: '专',
      semantic: '亻',
      hint: 'people',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '伢',
    definition: 'child',
    pinyin: ['yá'],
    decomposition: '⿰亻牙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '牙',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '伤',
    definition: 'to injure, to harm; wound, injury; to fall ill',
    pinyin: ['shāng'],
    decomposition: '⿰亻⿱？力',
    radical: '亻',
    matches: [[0], [0], null, null, [1, 1], [1, 1]],
  },
  {
    character: '伥',
    definition: 'the ghost of one devoured by a tiger',
    pinyin: ['chāng'],
    decomposition: '⿰亻长',
    etymology: {
      type: 'pictophonetic',
      phonetic: '长',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '伦',
    definition: 'human relationships; society',
    pinyin: ['lún'],
    decomposition: '⿰亻仑',
    etymology: {
      type: 'ideographic',
      hint: 'The logical order 仑 of human 亻 society; 仑 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '伧',
    definition: 'vulgar person, country man',
    pinyin: ['cāng'],
    decomposition: '⿰亻仓',
    etymology: {
      type: 'ideographic',
      hint: 'A person 亻 from the farm 仓; 仓 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '伪',
    definition: 'false, counterfeit, bogus',
    pinyin: ['wěi'],
    decomposition: '⿰亻为',
    etymology: { type: 'pictophonetic', phonetic: '为', semantic: '亻' },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '伫',
    definition: "to wait; to look towards; to turn one's back on",
    pinyin: ['zhù'],
    decomposition: '⿰亻⿱宀一',
    radical: '亻',
    matches: [[0], [0], [1, 0], [1, 0], [1, 0], [1, 1]],
  },
  {
    character: '伯',
    definition: "older brother; father's elder brother; sir, sire, count",
    pinyin: ['bó'],
    decomposition: '⿰亻白',
    etymology: {
      type: 'pictophonetic',
      phonetic: '白',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '估',
    definition: 'merchant; to estimate, to guess, to presume',
    pinyin: ['gū'],
    decomposition: '⿰亻古',
    etymology: {
      type: 'pictophonetic',
      phonetic: '古',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '伲',
    definition: 'we (Shanghai dialect)',
    pinyin: ['nì'],
    decomposition: '⿰亻尼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尼',
      semantic: '亻',
      hint: 'people',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '伴',
    definition: 'companion, comrade, partner; to accompany',
    pinyin: ['bàn'],
    decomposition: '⿰亻半',
    etymology: {
      type: 'pictophonetic',
      phonetic: '半',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '伶',
    definition: 'clever; lonely, solitary',
    pinyin: ['líng'],
    decomposition: '⿰亻令',
    etymology: {
      type: 'pictophonetic',
      phonetic: '令',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '伸',
    definition: 'to extend, to stretch out, to open up; to trust',
    pinyin: ['shēn'],
    decomposition: '⿰亻申',
    etymology: {
      type: 'ideographic',
      hint: 'To extend your confidence 申 to another person 亻; 申 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '伺',
    definition: 'to serve, to wait upon, to attend; to examine',
    pinyin: ['cì'],
    decomposition: '⿰亻司',
    etymology: {
      type: 'pictophonetic',
      phonetic: '司',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '似',
    definition: 'resembling, similar to; as if, to seem',
    pinyin: ['shì'],
    decomposition: '⿰亻以',
    etymology: { type: 'ideographic', hint: 'One person 亻 resembles another' },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '伽',
    definition: 'temple; used to transliterations',
    pinyin: ['jiā', 'gā'],
    decomposition: '⿰亻加',
    etymology: {
      type: 'pictophonetic',
      phonetic: '加',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '伾',
    definition: 'mighty',
    pinyin: ['pī'],
    decomposition: '⿰亻丕',
    etymology: {
      type: 'ideographic',
      hint: 'A great 丕 man 亻; 丕 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '佃',
    definition: 'tenant farmer; to be a tenant farmer',
    pinyin: ['diàn'],
    decomposition: '⿰亻田',
    etymology: {
      type: 'ideographic',
      hint: 'A person 亻 on the farm 田; 田 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '但',
    definition: 'only; but, however, yet, still',
    pinyin: ['dàn'],
    decomposition: '⿰亻旦',
    etymology: { type: 'pictophonetic', phonetic: '旦' },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '佇',
    definition: "to wait; to look towards; to turn one's back on",
    pinyin: ['zhù'],
    decomposition: '⿰亻宁',
    etymology: { type: 'ideographic', hint: 'A calm 宁 person 亻' },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '佈',
    definition: 'to spread, to publicize, to announce',
    pinyin: ['bù'],
    decomposition: '⿰亻布',
    etymology: {
      type: 'ideographic',
      hint: 'A person 亻 making an announcement 布; 布 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '佉',
    definition: 'the name of a divine being; surname',
    pinyin: ['qū'],
    decomposition: '⿰亻去',
    etymology: {
      type: 'pictophonetic',
      phonetic: '去',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '位',
    definition: 'seat, throne; rank, status; position, location',
    pinyin: ['wèi'],
    decomposition: '⿰亻立',
    etymology: {
      type: 'ideographic',
      hint: 'The place where a person 亻 stands 立',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '低',
    definition: 'low; to lower, to hang; to bend, to bow',
    pinyin: ['dī'],
    decomposition: '⿰亻氐',
    etymology: { type: 'pictophonetic', phonetic: '氐' },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '住',
    definition: 'to reside, to live at, to dwell, to lodge; to stop',
    pinyin: ['zhù'],
    decomposition: '⿰亻主',
    etymology: {
      type: 'ideographic',
      hint: 'A person 亻 who hosts 主; 主 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '佐',
    definition: 'to assist, to aid; subordinate, second',
    pinyin: ['zuǒ'],
    decomposition: '⿰亻左',
    etymology: {
      type: 'pictophonetic',
      phonetic: '左',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '佑',
    definition: 'to help; to protect; to bless',
    pinyin: ['yòu'],
    decomposition: '⿰亻右',
    etymology: {
      type: 'pictophonetic',
      phonetic: '右',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '体',
    definition: 'body; group, class; form, style, system',
    pinyin: ['tǐ'],
    decomposition: '⿰亻本',
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '佔',
    definition: 'to possess, to usurp, to take by force',
    pinyin: ['zhàn'],
    decomposition: '⿰亻占',
    etymology: {
      type: 'pictophonetic',
      phonetic: '占',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '何',
    definition: 'what, why, where, which, how',
    pinyin: ['hé'],
    decomposition: '⿰亻可',
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '佗',
    definition: 'other, he; surname; a load',
    pinyin: ['tuó'],
    decomposition: '⿰亻它',
    etymology: {
      type: 'ideographic',
      hint: 'Another 它 person 亻; see 他 and 她 for modern variants',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '佘',
    definition: 'surname',
    pinyin: ['shé'],
    decomposition: '⿱人示',
    etymology: {
      type: 'pictophonetic',
      phonetic: '示',
      semantic: '人',
      hint: 'person',
    },
    radical: '人',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '余',
    definition: 'surplus, remainder; surname',
    pinyin: ['yú'],
    decomposition: '⿱人？',
    radical: '人',
    matches: [[0], [0], null, null, null, null, null],
  },
  {
    character: '佚',
    definition: 'to indulge in pleasures; to flee',
    pinyin: ['yì'],
    decomposition: '⿰亻失',
    etymology: { type: 'ideographic', hint: 'To lose 失 a person 亻' },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '佛',
    definition: 'Buddha; Buddhist',
    pinyin: ['fú'],
    decomposition: '⿰亻弗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弗',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '作',
    definition: 'to make; to write, to compose; to act, to perform',
    pinyin: ['zuò'],
    decomposition: '⿰亻乍',
    etymology: {
      type: 'ideographic',
      hint: 'A person 亻 making something for the first time 乍; 乍 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '佝',
    definition: 'rickets',
    pinyin: ['gōu'],
    decomposition: '⿰亻句',
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '佞',
    definition: 'flattery; glib',
    pinyin: ['nìng'],
    decomposition: '⿰亻⿱二女',
    etymology: { type: 'ideographic', hint: 'Kindness 仁 toward a woman 女' },
    radical: '亻',
    matches: [[0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '佟',
    definition: 'surname',
    pinyin: ['tóng'],
    decomposition: '⿰亻冬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冬',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '你',
    definition: 'you, second person pronoun',
    pinyin: ['nǐ'],
    decomposition: '⿰亻尔',
    etymology: { type: 'ideographic', hint: 'Pronoun 尔 for a person 亻' },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '佣',
    definition: 'to hire, to employ; commission; servant',
    pinyin: ['yōng'],
    decomposition: '⿰亻用',
    etymology: {
      type: 'ideographic',
      hint: 'An employed 用 person 亻; 用 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '佤',
    definition:
      'The Va people (an ethnic group in Myanmar and southwest China)',
    pinyin: ['wǎ'],
    decomposition: '⿰亻瓦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '瓦',
      semantic: '亻',
      hint: 'people',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '佥',
    definition: 'all, together, unanimous',
    pinyin: ['qiān'],
    decomposition: '⿳亼⺍一',
    etymology: {
      type: 'ideographic',
      hint: 'Many people gathered 亼 under one roof',
    },
    radical: '人',
    matches: [[0], [0], [0], [1], [1], [1], [2]],
  },
  {
    character: '佧',
    definition: 'an ancient tribe in China',
    pinyin: ['kǎ'],
    decomposition: '⿰亻卡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卡',
      semantic: '亻',
      hint: 'people',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '佩',
    definition:
      'belt ornament, pendant; wear at waist, tie to the belt; respect',
    pinyin: ['pèi'],
    decomposition: '⿰亻⿵凡巾',
    etymology: {
      type: 'ideographic',
      hint: 'Common 凡 cloth 巾 ornaments worn by people 亻',
    },
    radical: '亻',
    matches: [[0], [0], [1, 0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '佬',
    definition: 'elder; mature',
    pinyin: ['lǎo'],
    decomposition: '⿰亻老',
    etymology: {
      type: 'ideographic',
      hint: 'An old 老 person 亻; 老 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '佯',
    definition: 'to pretend, to feign; false, deceitful',
    pinyin: ['yáng'],
    decomposition: '⿰亻羊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羊',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '佰',
    definition: 'hundred',
    pinyin: ['bǎi'],
    decomposition: '⿰亻百',
    etymology: {
      type: 'ideographic',
      hint: 'One hundred 百 people 亻; 百 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '佳',
    definition: 'good, auspicious; beautiful; delightful',
    pinyin: ['jiā'],
    decomposition: '⿰亻圭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '圭',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '佴',
    definition: 'a second, an assistant',
    pinyin: ['èr'],
    decomposition: '⿰亻耳',
    etymology: {
      type: 'ideographic',
      hint: 'A second 耳 person 亻; 耳 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '併',
    definition: "to combine, to annex; also, what's more",
    pinyin: ['bìng'],
    decomposition: '⿰亻并',
    etymology: {
      type: 'ideographic',
      hint: 'A conqueror 亻 taking land 并; 并 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '佶',
    definition: 'strong, robust; exact, correct',
    pinyin: ['jí'],
    decomposition: '⿰亻吉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吉',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '佻',
    definition: 'frivolous, unsteady; delay',
    pinyin: ['tiāo'],
    decomposition: '⿰亻兆',
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '佼',
    definition: 'beautiful, handsome, good-looking',
    pinyin: ['jiǎo'],
    decomposition: '⿰亻交',
    etymology: {
      type: 'pictophonetic',
      phonetic: '交',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '佽',
    definition: 'to help, to aid',
    pinyin: ['cì'],
    decomposition: '⿰亻次',
    etymology: {
      type: 'pictophonetic',
      phonetic: '次',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '佾',
    definition: 'a row or file of dancers',
    pinyin: ['yì'],
    decomposition: '⿰亻⿱八月',
    radical: '亻',
    matches: [[0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '使',
    definition: 'cause, mission, orders; envoy, messenger, ambassador',
    pinyin: ['shǐ'],
    decomposition: '⿰亻吏',
    etymology: {
      type: 'ideographic',
      hint: 'A person 亻 working for the government 吏',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '侃',
    definition: 'upright and strong; amiable',
    pinyin: ['kǎn'],
    decomposition: '⿰亻⿱口川',
    etymology: {
      type: 'ideographic',
      hint: 'As trustworthy 㐰 as spring-water 川',
    },
    radical: '亻',
    matches: [[0], [0], [1, 0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '侄',
    definition: 'nephew',
    pinyin: ['zhí'],
    decomposition: '⿰亻至',
    etymology: {
      type: 'pictophonetic',
      phonetic: '至',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '來',
    definition: 'to arrive, to come, to return; in the future, later on',
    pinyin: ['lái'],
    decomposition: '⿻木从',
    etymology: {
      type: 'ideographic',
      hint: 'A wheat plant that has just borne fruit; compare 来',
    },
    radical: '人',
    matches: [[0], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '侈',
    definition: 'luxurious, extravagant',
    pinyin: ['chǐ'],
    decomposition: '⿰亻多',
    etymology: {
      type: 'ideographic',
      hint: 'A person 亻 with more than they need 多',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '侉',
    definition: 'to speak with an accent; big and clumsy',
    pinyin: ['kuǎ'],
    decomposition: '⿰亻夸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夸',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '例',
    definition: 'precedent, example, case; regulation',
    pinyin: ['lì'],
    decomposition: '⿰亻列',
    etymology: {
      type: 'pictophonetic',
      phonetic: '列',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '侌',
    pinyin: ['yīn'],
    decomposition: '⿱今云',
    etymology: { type: 'pictophonetic', phonetic: '今' },
    radical: '人',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '侍',
    definition: 'to serve, to attend upon; servant, attendant; samurai',
    pinyin: ['shì'],
    decomposition: '⿰亻寺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寺',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '侏',
    definition: 'small, tiny; dwarf',
    pinyin: ['zhū'],
    decomposition: '⿰亻朱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朱',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '侑',
    definition: 'help, assist, repay kindness',
    pinyin: ['yòu'],
    decomposition: '⿰亻有',
    etymology: {
      type: 'pictophonetic',
      phonetic: '有',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '侔',
    definition: 'equal',
    pinyin: ['móu'],
    decomposition: '⿰亻牟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '牟',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '侖',
    definition: 'logical reasons, logical order',
    pinyin: ['lún'],
    decomposition: '⿱亼冊',
    etymology: {
      type: 'ideographic',
      hint: 'To assemble 亼 a book 冊; to prepare an argument',
    },
    radical: '人',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '侗',
    definition: 'big; ignorant, rude, rustic',
    pinyin: ['dòng'],
    decomposition: '⿰亻同',
    etymology: {
      type: 'pictophonetic',
      phonetic: '同',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '供',
    definition: 'to supply, to provide for; to offer in worship',
    pinyin: ['gōng'],
    decomposition: '⿰亻共',
    etymology: {
      type: 'ideographic',
      hint: 'A person 亻 making an offering with both hands 共; 共 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '依',
    definition: 'to rely on; to consent, to obey; according to',
    pinyin: ['yī'],
    decomposition: '⿰亻衣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '衣',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '侠',
    definition: 'chivalrous person; knight-errant',
    pinyin: ['xiá'],
    decomposition: '⿰亻夹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夹',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '侣',
    definition: 'companion; associate with',
    pinyin: ['lǚ'],
    decomposition: '⿰亻吕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吕',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '侥',
    definition: 'to be lucky; by chance, by luck',
    pinyin: ['jiǎo'],
    decomposition: '⿰亻尧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尧',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '侦',
    definition: 'to spy, to reconnoiter; detective',
    pinyin: ['zhēn'],
    decomposition: '⿰亻贞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贞',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '侧',
    definition: 'side; to slant, to lean, to incline',
    pinyin: ['cè'],
    decomposition: '⿰亻则',
    etymology: {
      type: 'pictophonetic',
      phonetic: '则',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '侨',
    definition: 'emigrant; to sojourn',
    pinyin: ['qiáo'],
    decomposition: '⿰亻乔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乔',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '侩',
    definition: 'go-between, broker, proxy',
    pinyin: ['kuài'],
    decomposition: '⿰亻会',
    etymology: {
      type: 'ideographic',
      hint: 'A person 亻 who organizes a meeting 会',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '侪',
    definition: 'a class, a company; companion; together',
    pinyin: ['chái'],
    decomposition: '⿰亻齐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '齐',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '侬',
    definition: 'I; you; surname',
    pinyin: ['nóng'],
    decomposition: '⿰亻农',
    etymology: {
      type: 'pictophonetic',
      phonetic: '农',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '侮',
    definition: 'insult, ridicule, disgrace',
    pinyin: ['wǔ'],
    decomposition: '⿰亻每',
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '侯',
    definition: 'marquis, lord; target in archery',
    pinyin: ['hóu'],
    decomposition: '⿰亻矦',
    etymology: {
      type: 'pictographic',
      hint: 'A person 亻 who might be a target 矦',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '侵',
    definition: 'to invade, to encroach upon, to raid',
    pinyin: ['qīn'],
    decomposition: '⿰亻⿳彐冖又',
    radical: '亻',
    matches: [[0], [0], [1, 0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 2], [1, 2]],
  },
  {
    character: '侶',
    definition: 'companion; associate with',
    pinyin: ['lǚ'],
    decomposition: '⿰亻呂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '呂',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '侷',
    definition: 'narrow, cramped, confined',
    pinyin: ['jú'],
    decomposition: '⿰亻局',
    etymology: {
      type: 'pictophonetic',
      phonetic: '局',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '便',
    definition: 'easy, convenient; expedient',
    pinyin: ['biàn'],
    decomposition: '⿰亻更',
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '係',
    definition: 'system; line, link, connection',
    pinyin: ['xì'],
    decomposition: '⿰亻系',
    etymology: {
      type: 'ideographic',
      hint: 'Someone 亻 who connects 系 people; 系 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '促',
    definition: 'to urge, to rush, to hurry; hasty; near, close',
    pinyin: ['cù'],
    decomposition: '⿰亻足',
    etymology: {
      type: 'ideographic',
      hint: 'Someone 亻 on your heels 足; 足 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '俄',
    definition: 'sudden, abrupt; used in transliterations',
    pinyin: ['é'],
    decomposition: '⿰亻我',
    etymology: { type: 'pictophonetic', phonetic: '我' },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '俅',
    definition: 'ornamental cap',
    pinyin: ['qiú'],
    decomposition: '⿰亻求',
    etymology: { type: 'pictophonetic', phonetic: '求' },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '俉',
    definition: 'scary; to frighten',
    pinyin: ['wǔ'],
    decomposition: '⿰亻吾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吾',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '俊',
    definition: 'talented, capable; handsome',
    pinyin: ['jùn'],
    decomposition: '⿰亻夋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夋',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '俎',
    definition: 'chopping board or block; painted',
    pinyin: ['zǔ'],
    decomposition: '⿰仌且',
    etymology: {
      type: 'pictographic',
      hint: 'A slab of meat on a chopping board 且',
    },
    radical: '人',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '俏',
    definition: 'to resemble; similar, alike; pretty',
    pinyin: ['qiào'],
    decomposition: '⿰亻肖',
    etymology: {
      type: 'ideographic',
      hint: 'A similar 肖 person 亻; 肖 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '俐',
    definition: 'smooth; active; clever, sharp',
    pinyin: ['lì'],
    decomposition: '⿰亻利',
    etymology: {
      type: 'pictophonetic',
      phonetic: '利',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '俑',
    definition: 'wooden figure buried with dead',
    pinyin: ['yǒng'],
    decomposition: '⿰亻甬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甬',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '俗',
    definition: 'social customs; vulgar, unrefined',
    pinyin: ['sú'],
    decomposition: '⿰亻谷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '谷',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '俘',
    definition: 'prisoner of war; take as prisoner',
    pinyin: ['fú'],
    decomposition: '⿰亻孚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孚',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '俚',
    definition: 'rustic, vulgar, unpolished; mean',
    pinyin: ['lǐ'],
    decomposition: '⿰亻里',
    etymology: {
      type: 'pictophonetic',
      phonetic: '里',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '俛',
    definition: 'to make an effort, to endeavor; to bear down',
    pinyin: ['fǔ'],
    decomposition: '⿰亻免',
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '俜',
    definition: 'to trust to; send a message',
    pinyin: ['pīng'],
    decomposition: '⿰亻甹',
    etymology: {
      type: 'ideographic',
      hint: 'A trusted 甹 person 亻;  甹 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '保',
    definition: 'to safeguard, to protect, to defend, to care for',
    pinyin: ['bǎo'],
    decomposition: '⿰亻呆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '呆',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '俞',
    definition: 'to consent, to approve; surname',
    pinyin: ['yú'],
    decomposition: '⿱亼刖',
    radical: '人',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '俟',
    definition: 'wait for, wait until, as soon as',
    pinyin: ['qí'],
    decomposition: '⿰亻矣',
    etymology: {
      type: 'ideographic',
      hint: 'A person 亻 waiting for something to finish 矣; 矣 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '俠',
    definition: 'chivalrous person; knight-errant',
    pinyin: ['xiá'],
    decomposition: '⿰亻夾',
    etymology: {
      type: 'ideographic',
      hint: 'Someone 亻 who supports 夾 others; 夾 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '信',
    definition: 'to trust, to believe; letter, sign',
    pinyin: ['xìn'],
    decomposition: '⿰亻言',
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '俣',
    definition: 'big',
    pinyin: ['yǔ'],
    decomposition: '⿰亻吴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吴',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '俦',
    definition: 'companion, mate, colleague',
    pinyin: ['chóu'],
    decomposition: '⿰亻寿',
    etymology: {
      type: 'ideographic',
      hint: 'Someone 亻 with you all your life 寿; 寿 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '俨',
    definition: 'grave, respectful; majestic',
    pinyin: ['yǎn'],
    decomposition: '⿰亻严',
    etymology: {
      type: 'pictophonetic',
      phonetic: '严',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '俩',
    definition: 'two, a pair, a couple',
    pinyin: ['liǎ'],
    decomposition: '⿰亻两',
    etymology: {
      type: 'ideographic',
      hint: 'A couple 寿; 寿 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '俪',
    definition: 'spouse; pair, couple',
    pinyin: ['lì'],
    decomposition: '⿰亻丽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丽',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '俭',
    definition: 'temperate, frugal, economical',
    pinyin: ['jiǎn'],
    decomposition: '⿰亻佥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '佥',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '修',
    definition: 'to study; to repair; to decorate; to cultivate',
    pinyin: ['xiū'],
    decomposition: '⿱攸彡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '攸',
      semantic: '彡',
      hint: 'hair',
    },
    radical: '亻',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '俯',
    definition: 'to bow down, to face down, to look down',
    pinyin: ['fǔ'],
    decomposition: '⿰亻府',
    etymology: {
      type: 'pictophonetic',
      phonetic: '府',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '俱',
    definition: 'all, together; accompany',
    pinyin: ['jù'],
    decomposition: '⿰亻具',
    etymology: {
      type: 'pictophonetic',
      phonetic: '具',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '俳',
    definition: 'actor; vaudeville show; insincere',
    pinyin: ['pái'],
    decomposition: '⿰亻非',
    etymology: {
      type: 'pictophonetic',
      phonetic: '非',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '俸',
    definition: 'wages, salary, official emolument',
    pinyin: ['fèng'],
    decomposition: '⿰亻奉',
    etymology: {
      type: 'ideographic',
      hint: 'Wages offered 奉 to a person 亻; 奉 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '俺',
    definition: 'I, me, my (some dialects)',
    pinyin: ['ǎn'],
    decomposition: '⿰亻奄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奄',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '俾',
    definition: 'so that, in order that; to cause',
    pinyin: ['bǐ'],
    decomposition: '⿰亻卑',
    etymology: { type: 'pictophonetic', phonetic: '卑' },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '倀',
    definition: 'the ghost of one devoured by a tiger',
    pinyin: ['chāng'],
    decomposition: '⿰亻長',
    etymology: {
      type: 'pictophonetic',
      phonetic: '長',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '倆',
    definition: 'two, a pair, a couple',
    pinyin: ['liǎ'],
    decomposition: '⿰亻兩',
    etymology: {
      type: 'ideographic',
      hint: 'A couple 兩; 兩 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '倉',
    definition: 'granary, barn; cabin, berth',
    pinyin: ['cāng'],
    decomposition: '⿱人⿸户口',
    etymology: {
      type: 'ideographic',
      hint: 'A granary with a roof 人, door 户, and foundation 口',
    },
    radical: '人',
    matches: [
      [0],
      [0],
      null,
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '個',
    definition: 'this, that; single; measure word for individuals',
    pinyin: ['gè'],
    decomposition: '⿰亻固',
    etymology: {
      type: 'pictophonetic',
      phonetic: '固',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '倌',
    definition: 'assistant, hired hand',
    pinyin: ['guān'],
    decomposition: '⿰亻官',
    etymology: {
      type: 'pictophonetic',
      phonetic: '官',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '倍',
    definition: 'to double; to increase or multiply',
    pinyin: ['bèi'],
    decomposition: '⿰亻咅',
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '倏',
    definition: 'hastily, suddenly, abruptly',
    pinyin: ['shū'],
    decomposition: '⿸攸犬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '攸',
      semantic: '犬',
      hint: 'dog',
    },
    radical: '亻',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '們',
    definition: 'plural marker for pronouns and some nouns',
    pinyin: ['men'],
    decomposition: '⿰亻門',
    etymology: {
      type: 'pictophonetic',
      phonetic: '門',
      semantic: '亻',
      hint: 'people',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '倒',
    definition: 'to collapse, to fall over; to lie down',
    pinyin: ['dào'],
    decomposition: '⿰亻到',
    etymology: {
      type: 'pictophonetic',
      phonetic: '到',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '倔',
    definition: 'stubborn, obstinate, intransigent; firm',
    pinyin: ['jué'],
    decomposition: '⿰亻屈',
    etymology: {
      type: 'ideographic',
      hint: 'Someone 亻 who does not bend 屈; 屈 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '倖',
    definition: 'lucky, fortunate; to spoil, to dote on',
    pinyin: ['xìng'],
    decomposition: '⿰亻幸',
    etymology: {
      type: 'ideographic',
      hint: 'A lucky 幸 person 亻; 幸 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '倘',
    definition: 'if, supposing, in event of',
    pinyin: ['tǎng'],
    decomposition: '⿰亻尚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尚',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '候',
    definition: 'to wait, to expect; to visit; to greet',
    pinyin: ['hòu'],
    decomposition: '⿰亻矦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '矦',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '倚',
    definition: 'to rely on, to depend on',
    pinyin: ['yǐ'],
    decomposition: '⿰亻奇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奇',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '倜',
    definition: 'lofty, exalted',
    pinyin: ['tì'],
    decomposition: '⿰亻周',
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '倝',
    definition: 'sunrise, dawn',
    pinyin: ['gàn'],
    decomposition: '⿰龺人',
    etymology: {
      type: 'pictophonetic',
      phonetic: '人',
      semantic: '龺',
      hint: 'sunlight',
    },
    radical: '人',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '倞',
    definition: 'far',
    pinyin: ['jìng'],
    decomposition: '⿰亻京',
    etymology: {
      type: 'ideographic',
      hint: 'Someone 亻 living in the capital 京; 京 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '借',
    definition: 'to borrow; to lend; excuse, pretext',
    pinyin: ['jiè'],
    decomposition: '⿰亻昔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昔',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '倠',
    pinyin: ['suī'],
    decomposition: '⿰亻隹',
    etymology: { type: 'pictophonetic', phonetic: '隹', semantic: '亻' },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '倡',
    definition: 'guide, leader; lead, introduce',
    pinyin: ['chàng'],
    decomposition: '⿰亻昌',
    etymology: {
      type: 'ideographic',
      hint: 'Someone 亻 who lights the way 昌; 昌 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '倥',
    definition: 'boorish, ignorant; urgent, pressing',
    pinyin: ['kōng'],
    decomposition: '⿰亻空',
    etymology: {
      type: 'pictophonetic',
      phonetic: '空',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '倦',
    definition: 'tired, weary',
    pinyin: ['juàn'],
    decomposition: '⿰亻卷',
    etymology: {
      type: 'ideographic',
      hint: 'A curled-up 卷 person 亻; 卷 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '倨',
    definition: 'arrogant, haughty, rude',
    pinyin: ['jù'],
    decomposition: '⿰亻居',
    etymology: {
      type: 'pictophonetic',
      phonetic: '居',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '倩',
    definition: 'beautiful, lovely; son-in-law',
    pinyin: ['qiàn'],
    decomposition: '⿰亻青',
    etymology: {
      type: 'ideographic',
      hint: 'A young 青 person 亻; 青 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '倪',
    definition: 'feeble, tiny, young and weak',
    pinyin: ['ní'],
    decomposition: '⿰亻兒',
    etymology: { type: 'ideographic', hint: 'A young child 兒' },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '倫',
    definition: 'human relationships; society',
    pinyin: ['lún'],
    decomposition: '⿰亻侖',
    etymology: {
      type: 'ideographic',
      hint: 'The logical order 侖 of human 亻 society; 侖 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '倬',
    definition: 'noticeable, large; distinct, clear',
    pinyin: ['zhuō'],
    decomposition: '⿰亻卓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卓',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '倭',
    definition: 'dwarf; dwarfish, short',
    pinyin: ['wō'],
    decomposition: '⿰亻委',
    etymology: {
      type: 'pictophonetic',
      phonetic: '委',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '倮',
    definition: 'bare, naked, uncovered',
    pinyin: ['luǒ'],
    decomposition: '⿰亻果',
    etymology: {
      type: 'pictophonetic',
      phonetic: '果',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '债',
    definition: 'debt, loan, liability',
    pinyin: ['zhài'],
    decomposition: '⿰亻责',
    etymology: {
      type: 'ideographic',
      hint: "A person's 亻 duty 责; 责 also provides the pronunciation",
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '倻',
    definition: 'used to transliterate Korean place names',
    pinyin: ['yē'],
    decomposition: '⿰亻耶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '耶',
      semantic: '亻',
      hint: 'people',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '值',
    definition: 'price, value, worth',
    pinyin: ['zhí'],
    decomposition: '⿰亻直',
    etymology: {
      type: 'pictophonetic',
      phonetic: '直',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '倾',
    definition: 'to upset, to pour out, to overflow',
    pinyin: ['qīng'],
    decomposition: '⿰亻顷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '顷',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '偃',
    definition: 'to cease, to lay down, to lay off',
    pinyin: ['yǎn'],
    decomposition: '⿰亻匽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匽',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '假',
    definition: 'fake, false, deceitful; vacation',
    pinyin: ['jiǎ'],
    decomposition: '⿰亻叚',
    etymology: {
      type: 'ideographic',
      hint: 'A false 叚 person 亻; 叚 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '偈',
    definition: 'brave; martial; hasty; scudding',
    pinyin: ['jì'],
    decomposition: '⿰亻曷',
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '偉',
    definition: 'great, imposing; extraordinary',
    pinyin: ['wěi'],
    decomposition: '⿰亻韋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韋',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '偌',
    definition: 'thus, so, like, such',
    pinyin: ['ruò'],
    decomposition: '⿰亻若',
    etymology: {
      type: 'pictophonetic',
      phonetic: '若',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '偎',
    definition: 'to cling to, to cuddle, to embrace, to fondle',
    pinyin: ['wēi'],
    decomposition: '⿰亻畏',
    etymology: {
      type: 'ideographic',
      hint: 'To cling to someone 亻 in fear 畏; 畏 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '偏',
    definition: 'slanting, inclined; prejudiced',
    pinyin: ['piān'],
    decomposition: '⿰亻扁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '扁',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '偕',
    definition: 'together, accompanied by; in order',
    pinyin: ['xié'],
    decomposition: '⿰亻皆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皆',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '做',
    definition: 'to work, to make; to act',
    pinyin: ['zuò'],
    decomposition: '⿰亻故',
    etymology: {
      type: 'ideographic',
      hint: 'Someone 亻 who causes things to happen 故; 故 also provides the pronuncation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '停',
    definition: 'to suspend, to halt, to delay; suitable',
    pinyin: ['tíng'],
    decomposition: '⿰亻亭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亭',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '健',
    definition: 'strong, robust, healthy; strength',
    pinyin: ['jiàn'],
    decomposition: '⿰亻建',
    etymology: {
      type: 'ideographic',
      hint: 'Someone 亻 who can build 建 things; 建 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '偬',
    definition: 'busy, hurried; urgent',
    pinyin: ['zǒng'],
    decomposition: '⿰亻怱',
    etymology: {
      type: 'ideographic',
      hint: 'Someone 亻 in a rush 怱; 怱 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '側',
    definition: 'side; to slant, to lean, to incline',
    pinyin: ['cè'],
    decomposition: '⿰亻則',
    etymology: {
      type: 'pictophonetic',
      phonetic: '則',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '偵',
    definition: 'to spy, to reconnoiter; detective',
    pinyin: ['zhēn'],
    decomposition: '⿰亻貞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '貞',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '偶',
    definition: 'accidentally, coincidently; mate, image, idol',
    pinyin: ['ǒu'],
    decomposition: '⿰亻禺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '禺',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '偷',
    definition: 'to steal; burglar, thief',
    pinyin: ['tōu'],
    decomposition: '⿰亻俞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '俞',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '偻',
    definition: 'humpback; surname',
    pinyin: ['lóu'],
    decomposition: '⿰亻娄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '娄',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '偽',
    definition: 'false, counterfeit, bogus',
    pinyin: ['wěi'],
    decomposition: '⿰亻為',
    etymology: { type: 'pictophonetic', phonetic: '為', semantic: '亻' },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '偾',
    definition: 'to ruin, to destroy; overthrown',
    pinyin: ['fèn'],
    decomposition: '⿰亻贲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贲',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '偿',
    definition: 'to repay, to recompense; restitution',
    pinyin: ['cháng'],
    decomposition: '⿰亻尝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尝',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '傀',
    definition: 'great, gigantic; puppet',
    pinyin: ['kuǐ'],
    decomposition: '⿰亻鬼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鬼',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '傅',
    definition: 'tutor, teacher; to assist; surname',
    pinyin: ['fù'],
    decomposition: '⿰亻尃',
    etymology: {
      type: 'ideographic',
      hint: 'Someone 亻 who lectures 尃; 尃 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '傈',
    definition: 'the Lisu tribe',
    pinyin: ['lì'],
    decomposition: '⿰亻栗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '栗',
      semantic: '亻',
      hint: 'people',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '傍',
    definition: 'beside, close, nearby; to depend on',
    pinyin: ['bàng'],
    decomposition: '⿰亻旁',
    etymology: {
      type: 'ideographic',
      hint: 'Someone 亻 by your side 旁; 旁 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '傑',
    definition: 'hero; heroic, outstanding',
    pinyin: ['jié'],
    decomposition: '⿰亻桀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '桀',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '傕',
    definition: 'used in old names',
    pinyin: ['jué'],
    decomposition: '⿰亻隺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隺',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '傖',
    definition: 'vulgar person, country man',
    pinyin: ['cāng'],
    decomposition: '⿰亻倉',
    etymology: {
      type: 'ideographic',
      hint: 'A person 亻 from the farm 倉; 倉 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '傘',
    definition: 'umbrella, parasol, parachute',
    pinyin: ['sǎn'],
    decomposition: '⿱人⿻十？',
    etymology: {
      type: 'ideographic',
      hint: 'People 人 huddling under an umbrella',
    },
    radical: '人',
    matches: [
      [0],
      [0],
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [1, 0],
      [1, 0],
    ],
  },
  {
    character: '備',
    definition: 'to prepare; to get ready, to equip; ready; perfect',
    pinyin: ['bèi'],
    decomposition: '⿰亻？',
    radical: '亻',
    matches: [
      [0],
      [0],
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    ],
  },
  {
    character: '傚',
    definition: 'to mimic, to imitate',
    pinyin: ['xiào'],
    decomposition: '⿰亻效',
    etymology: {
      type: 'ideographic',
      hint: 'To effect 效 another person 亻; 效 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '傢',
    definition: 'stubborn, obstinate, intransigent',
    pinyin: ['jiā'],
    decomposition: '⿰亻家',
    etymology: {
      type: 'pictophonetic',
      phonetic: '家',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '傣',
    definition: 'the Dai minority living in South China',
    pinyin: ['dǎi'],
    decomposition: '⿰亻泰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '泰',
      semantic: '亻',
      hint: 'people',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '傥',
    definition: 'if, supposing, in case',
    pinyin: ['tǎng'],
    decomposition: '⿰亻党',
    etymology: {
      type: 'pictophonetic',
      phonetic: '党',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '傧',
    definition: 'to entertain guests',
    pinyin: ['bīn'],
    decomposition: '⿰亻宾',
    etymology: {
      type: 'ideographic',
      hint: 'Someone 亻 who hosts guests 宾; 宾 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '储',
    definition: 'to save money, to store, to reserve; heir',
    pinyin: ['chǔ'],
    decomposition: '⿰亻诸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '诸',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '傩',
    definition: 'rich',
    pinyin: ['nuó'],
    decomposition: '⿰亻难',
    etymology: {
      type: 'pictophonetic',
      phonetic: '难',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '催',
    definition: 'to press, to urge',
    pinyin: ['cuī'],
    decomposition: '⿰亻崔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '崔',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '傭',
    definition: 'to hire, to employ; commission; servant',
    pinyin: ['yōng'],
    decomposition: '⿰亻庸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '庸',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '傯',
    definition: 'busy, hurried; urgent',
    pinyin: ['zǒng'],
    decomposition: '⿰亻悤',
    etymology: {
      type: 'ideographic',
      hint: 'Someone 亻 in a rush 悤; 悤 also provides the pronunciation',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '傲',
    definition: 'proud, haughty, overbearing',
    pinyin: ['ào'],
    decomposition: '⿰亻敖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敖',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '傳',
    definition: 'to pass on; to propagate; to transmit; summons',
    pinyin: ['chuán'],
    decomposition: '⿰亻專',
    etymology: {
      type: 'pictophonetic',
      phonetic: '專',
      semantic: '亻',
      hint: 'people',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '債',
    definition: 'debt, loan, liability',
    pinyin: ['zhài'],
    decomposition: '⿰亻責',
    etymology: {
      type: 'ideographic',
      hint: "A person's 亻 duty 責; 責 also provides the pronunciation",
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '傷',
    definition: 'to injure, to harm; wound, injury; to fall ill',
    pinyin: ['shāng'],
    decomposition: '⿰亻⿱？昜',
    radical: '亻',
    matches: [
      [0],
      [0],
      null,
      null,
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '傺',
    definition: 'to hinder; to detain',
    pinyin: ['chì'],
    decomposition: '⿰亻祭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '祭',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '傻',
    definition: 'foolish, silly, stupid; an imbecile',
    pinyin: ['shǎ'],
    decomposition: '⿰亻⿳囟八夂',
    etymology: {
      type: 'ideographic',
      hint: 'A man 亻 being hit 夂 on the head 囟',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 2],
      [1, 2],
      [1, 2],
    ],
  },
  {
    character: '傾',
    definition: 'to upset, to pour out, to overflow',
    pinyin: ['qīng'],
    decomposition: '⿰亻頃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '頃',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '傿',
    definition: 'the name of an immortal; surname',
    pinyin: ['yàn'],
    decomposition: '⿰亻焉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '焉',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '僂',
    definition: 'humpback; surname',
    pinyin: ['lóu'],
    decomposition: '⿰亻婁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '婁',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '僅',
    definition: 'only, merely, solely, just',
    pinyin: ['jǐn'],
    decomposition: '⿰亻堇',
    etymology: {
      type: 'pictophonetic',
      semantic: '亻',
      hint: 'person',
      phonetic: '堇',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '僉',
    definition: 'all, together, unanimous',
    pinyin: ['qiān'],
    decomposition: '⿳亼⿰口口从',
    etymology: {
      type: 'ideographic',
      hint: 'Many people 从 talking 口 under one roof 亼',
    },
    radical: '人',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '像',
    definition: 'picture, image, figure; to resemble',
    pinyin: ['xiàng'],
    decomposition: '⿰亻象',
    etymology: {
      type: 'pictophonetic',
      phonetic: '象',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '僑',
    definition: 'emigrant; to sojourn',
    pinyin: ['qiáo'],
    decomposition: '⿰亻喬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '喬',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '僕',
    definition: 'to fall forward; prostrate, prone; servant',
    pinyin: ['pú'],
    decomposition: '⿰亻菐',
    etymology: {
      type: 'pictophonetic',
      semantic: '亻',
      hint: 'person',
      phonetic: '菐',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '僖',
    definition: 'joy, gladness, delight; surname',
    pinyin: ['xī'],
    decomposition: '⿰亻喜',
    etymology: {
      type: 'ideographic',
      hint: 'Someone 亻 in love 喜; 喜 also provides the pronunciation',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '僚',
    definition: 'companion, colleague; officials; bureaucracy; a pretty face',
    pinyin: ['liáo'],
    decomposition: '⿰亻尞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尞',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '僥',
    definition: 'to be lucky; by chance, by luck',
    pinyin: ['jiǎo'],
    decomposition: '⿰亻堯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堯',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '僦',
    definition: 'to hire; to rent',
    pinyin: ['jiù'],
    decomposition: '⿰亻就',
    etymology: {
      type: 'pictophonetic',
      phonetic: '就',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '僧',
    definition: 'Buddhist priest, monk',
    pinyin: ['sēng'],
    decomposition: '⿰亻曾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曾',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '僬',
    definition: 'clever, alert; pigmy',
    pinyin: ['jiāo'],
    decomposition: '⿰亻焦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '焦',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '僭',
    definition: 'to assume, to usurp',
    pinyin: ['jiàn'],
    decomposition: '⿰亻朁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朁',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '僮',
    definition: 'page, servant boy',
    pinyin: ['tóng'],
    decomposition: '⿰亻童',
    etymology: {
      type: 'ideographic',
      hint: 'A servant boy 童; 童 also provides the pronunciation',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '僱',
    definition: 'to hire, to employ',
    pinyin: ['gù'],
    decomposition: '⿰亻雇',
    etymology: {
      type: 'ideographic',
      hint: 'To hire 雇 someone 亻; 雇 also provides the pronunciation',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '僳',
    definition: 'The Lisu tribe',
    pinyin: ['sù'],
    decomposition: '⿰亻粟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '粟',
      semantic: '亻',
      hint: 'people',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '僵',
    definition: 'still, stiff, motionless',
    pinyin: ['jiāng'],
    decomposition: '⿰亻畺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畺',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '價',
    definition: 'price, value',
    pinyin: ['jià'],
    decomposition: '⿰亻賈',
    etymology: {
      type: 'ideographic',
      hint: 'A merchant 亻賈; 賈 also provides the pronunciation',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '僻',
    definition: 'out-of-the-way, remote; unorthodox',
    pinyin: ['pì'],
    decomposition: '⿰亻辟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辟',
      semantic: '亻',
      hint: 'people living out of the way',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '儀',
    definition: 'instrument, apparatus; ceremony, rites',
    pinyin: ['yí'],
    decomposition: '⿰亻義',
    etymology: {
      type: 'pictophonetic',
      phonetic: '義',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '儂',
    definition: 'I; you; surname',
    pinyin: ['nóng'],
    decomposition: '⿰亻農',
    etymology: {
      type: 'pictophonetic',
      phonetic: '農',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '億',
    definition: 'hundred million; many',
    pinyin: ['yì'],
    decomposition: '⿰亻意',
    etymology: {
      type: 'pictophonetic',
      phonetic: '意',
      semantic: '亻',
      hint: 'people',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '儅',
    definition: 'to stop',
    pinyin: ['dàng'],
    decomposition: '⿰亻當',
    etymology: {
      type: 'pictophonetic',
      phonetic: '當',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '儆',
    definition: 'to warn; warning',
    pinyin: ['jǐng'],
    decomposition: '⿰亻敬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敬',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '儇',
    definition: 'clever, nimble',
    pinyin: ['xuān'],
    decomposition: '⿰亻睘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '睘',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '儈',
    definition: 'go-between, broker, proxy',
    pinyin: ['kuài'],
    decomposition: '⿰亻會',
    etymology: {
      type: 'ideographic',
      hint: 'A person 亻 who organizes a meeting 會',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '儉',
    definition: 'temperate, frugal, economical',
    pinyin: ['jiǎn'],
    decomposition: '⿰亻僉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '僉',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '儋',
    definition: 'a small jar; to bear a burden; a load of two',
    pinyin: ['dān'],
    decomposition: '⿰亻詹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '詹',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '儒',
    definition: 'Confucian scholar',
    pinyin: ['rú'],
    decomposition: '⿰亻需',
    etymology: {
      type: 'pictophonetic',
      phonetic: '需',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '儕',
    definition: 'a class, a company; companion; together',
    pinyin: ['chái'],
    decomposition: '⿰亻齊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '齊',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '儘',
    definition: 'to exhaust, to use up, to deplete',
    pinyin: ['jǐn'],
    decomposition: '⿰亻盡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '盡',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '償',
    definition: 'to repay, to recompense; restitution',
    pinyin: ['cháng'],
    decomposition: '⿰亻賞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '賞',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '儡',
    definition: 'puppet, dummy',
    pinyin: ['lěi'],
    decomposition: '⿰亻畾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畾',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '優',
    definition: 'superior; elegant',
    pinyin: ['yōu'],
    decomposition: '⿰亻憂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '憂',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '儲',
    definition: 'to save money, to store, to reserve; heir',
    pinyin: ['chǔ'],
    decomposition: '⿰亻諸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '諸',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '儷',
    definition: 'spouse; pair, couple',
    pinyin: ['lì'],
    decomposition: '⿰亻麗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '麗',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '儸',
    definition: 'smart; clever',
    pinyin: ['luó'],
    decomposition: '⿰亻羅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羅',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '儺',
    definition: 'rich',
    pinyin: ['nuó'],
    decomposition: '⿰亻難',
    etymology: {
      type: 'pictophonetic',
      phonetic: '難',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '儻',
    definition: 'if, supposing, in case',
    pinyin: ['tǎng'],
    decomposition: '⿰亻黨',
    etymology: {
      type: 'pictophonetic',
      phonetic: '黨',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '儼',
    definition: 'grave, respectful; majestic',
    pinyin: ['yǎn'],
    decomposition: '⿰亻嚴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '嚴',
      semantic: '亻',
      hint: 'person',
    },
    radical: '亻',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '儿',
    definition: 'son, child',
    pinyin: ['ér'],
    decomposition: '⿰丿乚',
    etymology: {
      type: 'pictographic',
      hint: 'Simplified form of 兒, a picture of a child; compare 人',
    },
    radical: '儿',
    matches: [[0], [1]],
  },
  {
    character: '兀',
    definition: 'weak; lame',
    pinyin: ['wù'],
    decomposition: '⿱一儿',
    etymology: { type: 'ideographic', hint: 'Cutting 一 off the feet 儿' },
    radical: '兀',
    matches: [[0], [1], [1]],
  },
  {
    character: '允',
    definition: 'to grant, to consent; just, fair',
    pinyin: ['yǔn'],
    decomposition: '⿱厶儿',
    radical: '儿',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '元',
    definition: 'first; dollar; origin; head',
    pinyin: ['yuán'],
    decomposition: '⿱二儿',
    etymology: {
      type: 'pictographic',
      hint: 'A man 儿 with two lines emphasizing their head 二',
    },
    radical: '儿',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '兄',
    definition: 'elder brother',
    pinyin: ['xiōng'],
    decomposition: '⿱口儿',
    etymology: {
      type: 'ideographic',
      hint: 'Older brother 儿 speaking 口 to younger ones',
    },
    radical: '儿',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '充',
    definition: 'to fill, to supply; to be full',
    pinyin: ['chōng'],
    decomposition: '⿱亠允',
    radical: '儿',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '兆',
    definition: 'omen; mega-, million',
    pinyin: ['zhào'],
    decomposition: '⿻儿？',
    etymology: {
      type: 'pictographic',
      hint: 'Cracks in oracle bones used in fortune-telling',
    },
    radical: '儿',
    matches: [[0], null, null, [0], null, null],
  },
  {
    character: '兇',
    definition: 'atrocious, brutal, ferocious',
    pinyin: ['xiōng'],
    decomposition: '⿱凶儿',
    etymology: { type: 'ideographic', hint: 'A container 凵 of wickedness 乂' },
    radical: '儿',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '先',
    definition: 'first, former, previous',
    pinyin: ['xiān'],
    decomposition: '⿱⿰？土儿',
    etymology: {
      type: 'ideographic',
      hint: 'Someone stepping 止 in front of another person 儿',
    },
    radical: '儿',
    matches: [null, [0, 1], [0, 1], [0, 1], [1], [1]],
  },
  {
    character: '光',
    definition: 'light; bright, brilliant; only, merely',
    pinyin: ['guāng'],
    decomposition: '⿱⺌兀',
    etymology: { type: 'ideographic', hint: 'A person 儿 carrying a torch 火' },
    radical: '儿',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '克',
    definition: 'to subdue, to restrain, to overcome; used in transliterations',
    pinyin: ['kè'],
    decomposition: '⿱十兄',
    etymology: {
      type: 'ideographic',
      hint: 'A weapon 十 used to subdue a beast 兄',
    },
    radical: '儿',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '兌',
    definition: 'cash, check; to exchange',
    pinyin: ['duì'],
    decomposition: '⿳八口儿',
    etymology: { type: 'ideographic', hint: 'A beast 兄 with two horns 丷' },
    radical: '儿',
    matches: [[0], [0], [1], [1], [1], [2], [2]],
  },
  {
    character: '免',
    definition: 'to spare, to excuse from; to evade',
    pinyin: ['miǎn'],
    decomposition: '⿱⺈⿻口儿',
    radical: '儿',
    matches: [[0], [0], [1, 0], [1, 0], [1, 0], [1, 1], [1, 1]],
  },
  {
    character: '兑',
    definition: 'cash, check; to exchange',
    pinyin: ['duì'],
    decomposition: '⿱丷兄',
    etymology: { type: 'ideographic', hint: 'A beast 兄 with two horns 丷' },
    radical: '儿',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '兒',
    definition: 'son, child',
    pinyin: ['ér'],
    decomposition: '⿱臼儿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '儿',
      semantic: '儿',
      hint: 'son',
    },
    radical: '儿',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '兓',
    pinyin: ['jīn'],
    decomposition: '⿰旡旡',
    etymology: { type: 'pictophonetic', phonetic: '旡' },
    radical: '儿',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '兔',
    definition: 'rabbit, hare',
    pinyin: ['tù'],
    decomposition: '⿸免丶',
    etymology: { type: 'pictographic', hint: 'A rabbit' },
    radical: '儿',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1]],
  },
  {
    character: '兕',
    definition: 'a female rhinoceros',
    pinyin: ['sì'],
    decomposition: '⿱凹儿',
    radical: '儿',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '兖',
    definition: 'to establish; a province',
    pinyin: ['yǎn'],
    decomposition: '⿱六允',
    radical: '儿',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '兗',
    definition: 'to establish; a province',
    pinyin: ['yǎn'],
    decomposition: '⿱六兄',
    radical: '儿',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '党',
    definition: 'political party, gang, faction',
    pinyin: ['dǎng'],
    decomposition: '⿻尚兄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尚',
      semantic: '兄',
      hint: 'elder brother',
    },
    radical: '儿',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '兜',
    definition: 'pouch',
    pinyin: ['dōu'],
    decomposition: '⿱⿴？白儿',
    etymology: {
      type: 'ideographic',
      hint: 'A man wearing a helmet, now meaning "pouch"',
    },
    radical: '儿',
    matches: [
      null,
      null,
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      null,
      null,
      [1],
      [1],
    ],
  },
  {
    character: '兟',
    definition: 'to advance',
    pinyin: ['shēn'],
    decomposition: '⿰先先',
    etymology: {
      type: 'ideographic',
      hint: 'Two people 先 marching; 先 also provides the pronunciation',
    },
    radical: '儿',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '兢',
    definition: 'fearful, cautious, wary',
    pinyin: ['jīng'],
    decomposition: '⿰克克',
    radical: '儿',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '入',
    definition: 'to enter, to come in; to join',
    pinyin: ['rù'],
    decomposition: '？',
    etymology: { type: 'ideographic', hint: 'An arrow indicating "enter"' },
    radical: '入',
    matches: [null, null],
  },
  {
    character: '內',
    definition: 'inside',
    pinyin: ['nèi'],
    decomposition: '⿻冂入',
    etymology: { type: 'ideographic', hint: 'A man 入  entering a door 冂' },
    radical: '入',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '全',
    definition: 'whole, entire, complete; to preserve',
    pinyin: ['quán'],
    decomposition: '⿱入玉',
    etymology: {
      type: 'ideographic',
      hint: 'Jade 玉 put away 入 for safe-keeping',
    },
    radical: '入',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '兩',
    definition: 'two, both, pair, couple; ounce',
    pinyin: ['liǎng'],
    decomposition: '⿱一⿻巾⿰入入',
    etymology: {
      type: 'ideographic',
      hint: 'Two people 入 together in a cart',
    },
    radical: '入',
    matches: [
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 1],
      [1, 1, 1],
    ],
  },
  {
    character: '八',
    definition: 'eight; all around, all sides',
    pinyin: ['bā'],
    decomposition: '？',
    etymology: {
      type: 'ideographic',
      hint: 'Two bent lines meaning "to divide"',
    },
    radical: '八',
    matches: [null, null],
  },
  {
    character: '公',
    definition: 'fair, equitable; public; duke',
    pinyin: ['gōng'],
    decomposition: '⿱八厶',
    etymology: { type: 'ideographic', hint: 'To divide 八 what is private 厶' },
    radical: '八',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '六',
    definition: 'six',
    pinyin: ['liù'],
    decomposition: '⿱亠八',
    radical: '八',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '兮',
    definition: 'exclamatory particle',
    pinyin: ['xī'],
    decomposition: '⿱八丂',
    radical: '八',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '兰',
    definition: 'orchid; elegant, graceful',
    pinyin: ['lán'],
    decomposition: '⿱丷三',
    etymology: { type: 'pictographic', hint: 'An orchid in bloom' },
    radical: '丷',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '共',
    definition: 'all, total; together; to share',
    pinyin: ['gòng'],
    decomposition: '⿳廾一八',
    etymology: {
      type: 'ideographic',
      hint: 'Two hands 八 holding one object 廾',
    },
    radical: '八',
    matches: [[0], [0], [0], [1], [2], [2]],
  },
  {
    character: '关',
    definition: 'frontier pass; to close, to shut; relation',
    pinyin: ['guān'],
    decomposition: '⿱丷天',
    radical: '丷',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '兴',
    definition: 'to thrive, to prosper, to flourish',
    pinyin: ['xìng'],
    decomposition: '⿳⺍一八',
    radical: '八',
    matches: [[0], [0], [0], [1], [2], [2]],
  },
  {
    character: '兵',
    definition: 'soldier; troops, an army; warlike',
    pinyin: ['bīng'],
    decomposition: '⿱丘八',
    etymology: { type: 'ideographic', hint: 'Two hands 八 holding an axe 丘' },
    radical: '八',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '其',
    definition: 'his, her, its, their; that',
    pinyin: ['qí'],
    decomposition: '⿱甘⿱一八',
    radical: '八',
    matches: [[0], [0], [0], [0], [0], [1, 0], [1, 1], [1, 1]],
  },
  {
    character: '具',
    definition: 'tool, implement; to draw up, to write',
    pinyin: ['jù'],
    decomposition: '⿱目⿱一八',
    etymology: {
      type: 'ideographic',
      hint: 'Two hands 八 writing on a tablet 目',
    },
    radical: '八',
    matches: [[0], [0], [0], [0], [0], [1, 0], [1, 1], [1, 1]],
  },
  {
    character: '典',
    definition: 'law, canon; scripture, classic; documentation',
    pinyin: ['diǎn'],
    decomposition: '⿱曲八',
    etymology: { type: 'ideographic', hint: 'Two hands 八 holding a book 冊' },
    radical: '八',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '兹',
    definition: 'now, here; this; time, year',
    pinyin: ['zī'],
    decomposition: '⿳八一⿰幺幺',
    radical: '艹',
    matches: [[0], [0], [1], [2, 0], [2, 0], [2, 0], [2, 1], [2, 1], [2, 1]],
  },
  {
    character: '养',
    definition: 'to raise, to rear, to bring up; to support',
    pinyin: ['yǎng'],
    decomposition: '⿱羊儿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羊',
      semantic: '儿',
      hint: 'child',
    },
    radical: '丷',
    matches: [[0], [0], [0], [0], [0], [0], null, [1], [1]],
  },
  {
    character: '兼',
    definition: 'both, and; at the same time; to unite, to combine',
    pinyin: ['jiān'],
    decomposition: '⿱丷⿱彐⿰禾禾',
    etymology: {
      type: 'ideographic',
      hint: 'A hand holding two sheafs of grain 禾',
    },
    radical: '丷',
    matches: [
      [0],
      [0],
      null,
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1, 0],
      [1, 1, 1],
      [1, 1, 0],
      [1, 1, 1],
    ],
  },
  {
    character: '兽',
    definition: 'beast, animal; bestial',
    pinyin: ['shòu'],
    decomposition: '⿱⿱丷田⿱一口',
    etymology: {
      type: 'ideographic',
      hint: 'An animal with horns 丷, eyes 田, nose 一, and mouth 口',
    },
    radical: '丷',
    matches: [
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '冀',
    definition: 'to hope for; to wish; Hebei province',
    pinyin: ['jì'],
    decomposition: '⿱北異',
    etymology: {
      type: 'pictophonetic',
      phonetic: '異',
      semantic: '北',
      hint: 'north',
    },
    radical: '八',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '冁',
    definition: 'smile',
    pinyin: ['chǎn'],
    decomposition: '⿰单展',
    etymology: {
      type: 'ideographic',
      hint: 'When an individual 单 opens up 展; 展 also provides the pronunciation',
    },
    radical: '丷',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '冂',
    definition: 'wide',
    pinyin: ['jiōng'],
    decomposition: '⿰丨？',
    radical: '冂',
    matches: [[0], null],
  },
  {
    character: '内',
    definition: 'inside',
    pinyin: ['nèi'],
    decomposition: '⿻冂人',
    etymology: { type: 'ideographic', hint: 'A man 人  entering a door 冂' },
    radical: '入',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '円',
    definition: 'circle; yen',
    pinyin: ['yuán'],
    decomposition: '⿵冂丄',
    radical: '冂',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '冈',
    definition: 'ridge or crest of hill',
    pinyin: ['gāng'],
    decomposition: '⿵冂乂',
    etymology: {
      type: 'pictographic',
      hint: 'Simplified form of 岡, clouds 网 forming over a mountain 山',
    },
    radical: '冂',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '冉',
    definition: 'tender; weak; to proceed gradually',
    pinyin: ['rǎn'],
    decomposition: '⿻冂土',
    radical: '冂',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '冊',
    definition: 'book, volume, register, list',
    pinyin: ['cè'],
    decomposition: '⿻冂卄',
    etymology: {
      type: 'ideographic',
      hint: 'Bamboo strips 冂 tied together to form a book; compare 册',
    },
    radical: '冂',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '冋',
    definition: 'desert; border',
    pinyin: ['jiōng'],
    decomposition: '⿵冂口',
    etymology: {
      type: 'ideographic',
      hint: 'A plot of land 口 surrounded by a border 冂; 冂 also provides the pronunciation',
    },
    radical: '冂',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '册',
    definition: 'book, volume, register, list',
    pinyin: ['cè'],
    decomposition: '⿻⿰冂冂一',
    etymology: {
      type: 'pictographic',
      hint: 'Bamboo strips 冂 tied together to form a book',
    },
    radical: '冂',
    matches: [[0, 0], [0, 0], [0, 1], [0, 1], [1]],
  },
  {
    character: '再',
    definition: 'again, twice, re-',
    pinyin: ['zài'],
    decomposition: '⿱一冉',
    etymology: {
      type: 'pictographic',
      hint: 'Two fish 冉 caught on a line 一',
    },
    radical: '冂',
    matches: [[0], [1], [1], [1], [1], [1]],
  },
  {
    character: '冎',
    definition: 'bone',
    pinyin: ['guǎ'],
    decomposition: '⿱？冂',
    etymology: { type: 'pictographic', hint: 'Cross-section of a bone' },
    radical: '冂',
    matches: [null, null, null, [1], [1]],
  },
  {
    character: '冏',
    definition: 'bright, brilliant; clear; hot',
    pinyin: ['jiǒng'],
    decomposition: '⿵冂⿱八口',
    etymology: { type: 'ideographic', hint: 'Archaic form of 炯' },
    radical: '冂',
    matches: [[0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '冑',
    definition: 'helmet',
    pinyin: ['zhòu'],
    decomposition: '⿱由⺼',
    etymology: { type: 'ideographic', hint: 'A man ⺼ wearing a helmet 由' },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '冒',
    definition: 'to risk, to brave, to dare',
    pinyin: ['mào'],
    decomposition: '⿱日目',
    etymology: { type: 'pictophonetic', phonetic: '冃', semantic: '目' },
    radical: '冂',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '冓',
    definition: 'secret, niche, hiding-hole, cabinet',
    pinyin: ['gòu'],
    decomposition: '⿱井再',
    radical: '冂',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '冕',
    definition: 'crown; ceremonial cap',
    pinyin: ['miǎn'],
    decomposition: '⿱日免',
    etymology: {
      type: 'pictophonetic',
      phonetic: '免',
      semantic: '冂',
      hint: 'crown',
    },
    radical: '冂',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '冖',
    definition: 'cover',
    pinyin: ['mì'],
    decomposition: '？',
    etymology: { type: 'pictographic', hint: 'A cover-cloth' },
    radical: '冖',
    matches: [null, null],
  },
  {
    character: '冗',
    definition: 'excessive; superfluous',
    pinyin: ['rǒng'],
    decomposition: '⿱冖几',
    etymology: { type: 'ideographic', hint: 'A cover-cloth 冖 on a table 几' },
    radical: '冖',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '冘',
    definition: 'to move on; doubtful',
    pinyin: ['yín'],
    decomposition: '⿸巾乚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乚',
      semantic: '巾',
      hint: 'towel',
    },
    radical: '冖',
    matches: [[0], [0], [0], [1]],
  },
  {
    character: '写',
    definition: 'to write; to draw, to sketch; to compose',
    pinyin: ['xiě'],
    decomposition: '⿱冖与',
    radical: '冖',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '军',
    definition: 'army, military; soldiers, troops',
    pinyin: ['jūn'],
    decomposition: '⿱冖车',
    etymology: {
      type: 'ideographic',
      hint: 'Soldiers 冖 (distorted 力) in a cart 车',
    },
    radical: '车',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '农',
    definition: 'agriculture, farming; farmer',
    pinyin: ['nóng'],
    decomposition: '⿻冖？',
    etymology: {
      type: 'pictographic',
      hint: 'Simplified form of 農, tilling the field 田 with a hoe 辰',
    },
    radical: '冖',
    matches: [[0], [0], null, null, null, null],
  },
  {
    character: '冝',
    definition: 'suitable, right, proper',
    pinyin: ['yí'],
    decomposition: '⿱冖且',
    radical: '冖',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '冠',
    definition: 'cap, crown, headgear',
    pinyin: ['guān'],
    decomposition: '⿱冖⿺元寸',
    etymology: {
      type: 'ideographic',
      hint: 'A man 元 puts on a cap 冖 with his hand 寸',
    },
    radical: '冖',
    matches: [[0], [0], [1, 0], [1, 0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '冡',
    pinyin: ['méng'],
    decomposition: '⿱⿱冖一豕',
    radical: '冖',
    matches: [[0, 0], [0, 0], [0, 1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '冢',
    definition: 'burial mound, mausoleum; grand',
    pinyin: ['zhǒng'],
    decomposition: '⿱冖豖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豖',
      semantic: '冖',
      hint: 'shroud',
    },
    radical: '冖',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '冣',
    definition: 'to assemble, to collect, to meet',
    pinyin: ['jù'],
    decomposition: '⿱冖取',
    etymology: {
      type: 'pictophonetic',
      phonetic: '取',
      semantic: '冖',
      hint: 'cover',
    },
    radical: '冖',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '冤',
    definition: 'grievance, injustice, wrong',
    pinyin: ['yuān'],
    decomposition: '⿱冖兔',
    radical: '冖',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '冥',
    definition: 'dark, gloomy, night; deep',
    pinyin: ['míng'],
    decomposition: '⿳冖日六',
    etymology: {
      type: 'ideographic',
      hint: 'The sun 日, covered 冖, with 六 providing the pronunciation',
    },
    radical: '冖',
    matches: [[0], [0], [1], [1], [1], [1], [2], [2], [2], [2]],
  },
  {
    character: '冪',
    definition: 'cover-cloth; exponent, power',
    pinyin: ['mì'],
    decomposition: '⿱冖幕',
    etymology: {
      type: 'ideographic',
      hint: 'A cover 冖 cloth 幕; 冖 also provides the pronunciation',
    },
    radical: '冖',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '冫',
    definition: 'ice',
    pinyin: ['bīng'],
    decomposition: '⿱丶？',
    radical: '冫',
    matches: [[0], null],
  },
  {
    character: '冬',
    definition: 'winter, 11th lunar month',
    pinyin: ['dōng'],
    decomposition: '⿱夂⺀',
    etymology: { type: 'ideographic', hint: 'A man walking 夂 on ice ⺀' },
    radical: '⺀',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '冯',
    definition: 'to gallop; by dint of; surname',
    pinyin: ['féng'],
    decomposition: '⿰冫马',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冫',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '冰',
    definition: 'ice; ice-cold',
    pinyin: ['bīng'],
    decomposition: '⿰冫水',
    etymology: { type: 'ideographic', hint: 'Ice-cold冫 water 水' },
    radical: '冫',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '冱',
    definition: 'freezing; stopped up, closed off',
    pinyin: ['hù'],
    decomposition: '⿰冫互',
    etymology: { type: 'pictophonetic', phonetic: '互', semantic: '冫' },
    radical: '冫',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '冲',
    definition: 'wash, rinse, flush; dash; soar',
    pinyin: ['chōng'],
    decomposition: '⿰冫中',
    etymology: {
      type: 'pictophonetic',
      phonetic: '中',
      semantic: '冫',
      hint: 'water',
    },
    radical: '冫',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '决',
    definition: 'to decide, to determine, to judge',
    pinyin: ['jué'],
    decomposition: '⿰冫夬',
    radical: '冫',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '况',
    definition: 'condition, situation; furthermore',
    pinyin: ['kuàng'],
    decomposition: '⿰冫兄',
    radical: '冫',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '冶',
    definition: 'to smelt, to fuse metals, to cast',
    pinyin: ['yě'],
    decomposition: '⿰冫台',
    radical: '冫',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '冷',
    definition: 'cold, cool; lonely',
    pinyin: ['lěng'],
    decomposition: '⿰冫令',
    etymology: {
      type: 'pictophonetic',
      phonetic: '令',
      semantic: '冫',
      hint: 'ice',
    },
    radical: '冫',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '冻',
    definition: 'cold; to freeze, to congeal; jelly',
    pinyin: ['dòng'],
    decomposition: '⿰冫东',
    etymology: {
      type: 'pictophonetic',
      phonetic: '东',
      semantic: '冫',
      hint: 'ice',
    },
    radical: '冫',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '冼',
    definition: 'surname',
    pinyin: ['xiǎn'],
    decomposition: '⿰冫先',
    etymology: { type: 'pictophonetic', phonetic: '先' },
    radical: '冫',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '冽',
    definition: 'cold and raw; pure, clear',
    pinyin: ['liè'],
    decomposition: '⿰冫列',
    etymology: {
      type: 'pictophonetic',
      phonetic: '列',
      semantic: '冫',
      hint: 'ice',
    },
    radical: '冫',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '净',
    definition: 'clean, pure; to cleanse',
    pinyin: ['jìng'],
    decomposition: '⿰冫争',
    etymology: {
      type: 'pictophonetic',
      phonetic: '争',
      semantic: '冫',
      hint: 'water',
    },
    radical: '冫',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '凄',
    definition: 'bitter cold, miserable, dreary',
    pinyin: ['qī'],
    decomposition: '⿰冫妻',
    etymology: {
      type: 'pictophonetic',
      phonetic: '妻',
      semantic: '冫',
      hint: 'ice',
    },
    radical: '冫',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '准',
    definition: 'standard, accurate; to permit, to approve, to allow',
    pinyin: ['zhǔn'],
    decomposition: '⿰冫隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隹',
      semantic: '冫',
      hint: 'water in a spirit level',
    },
    radical: '冫',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '凇',
    definition: 'dewdrop; icicle',
    pinyin: ['sōng'],
    decomposition: '⿰冫松',
    etymology: {
      type: 'pictophonetic',
      phonetic: '松',
      semantic: '冫',
      hint: 'ice',
    },
    radical: '冫',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '凈',
    definition: 'clean, pure; to cleanse',
    pinyin: ['jìng'],
    decomposition: '⿰冫爭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爭',
      semantic: '冫',
      hint: 'water',
    },
    radical: '冫',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '凉',
    definition: 'cool, cold; disheartened',
    pinyin: ['liáng'],
    decomposition: '⿰冫京',
    etymology: {
      type: 'pictophonetic',
      semantic: '冫',
      hint: 'ice',
      phonetic: '京',
    },
    radical: '冫',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '凋',
    definition: 'withered, fallen; exhausted',
    pinyin: ['diāo'],
    decomposition: '⿰冫周',
    etymology: {
      type: 'pictophonetic',
      semantic: '冫',
      phonetic: '周',
      hint: 'ice',
    },
    radical: '冫',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '凌',
    definition: 'pure; virtuous; to insult; to maltreat',
    pinyin: ['líng'],
    decomposition: '⿰冫夌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夌',
      semantic: '冫',
      hint: 'ice',
    },
    radical: '冫',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '凍',
    definition: 'cold; to freeze, to congeal; jelly',
    pinyin: ['dòng'],
    decomposition: '⿰冫東',
    etymology: {
      type: 'pictophonetic',
      phonetic: '東',
      semantic: '冫',
      hint: 'ice',
    },
    radical: '冫',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '减',
    definition: 'to decrease, to subtract, to diminish',
    pinyin: ['jiǎn'],
    decomposition: '⿰冫咸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咸',
      semantic: '冫',
      hint: 'ice',
    },
    radical: '冫',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '凑',
    definition: 'to piece together, to assemble',
    pinyin: ['còu'],
    decomposition: '⿰冫奏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奏',
      semantic: '冫',
      hint: 'ice',
    },
    radical: '冫',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '凛',
    definition: 'to shiver with cold or fear',
    pinyin: ['lǐn'],
    decomposition: '⿰冫禀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '禀',
      semantic: '冫',
      hint: 'ice',
    },
    radical: '冫',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '凜',
    definition: 'to shiver with cold or fear',
    pinyin: ['lǐn'],
    decomposition: '⿰冫稟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '稟',
      semantic: '冫',
      hint: 'ice',
    },
    radical: '冫',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '凝',
    definition: 'to coagulate, to congeal; to freeze',
    pinyin: ['níng'],
    decomposition: '⿰冫疑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '疑',
      semantic: '冫',
      hint: 'ice',
    },
    radical: '冫',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '几',
    definition: 'small table; how many; a few, some',
    pinyin: ['jǐ'],
    decomposition: '⿰丿乙',
    etymology: { type: 'pictographic', hint: 'A small table; compare 丌' },
    radical: '几',
    matches: [[0], [1]],
  },
  {
    character: '凡',
    definition: 'any, every, all; common, ordinary',
    pinyin: ['fán'],
    decomposition: '⿵几丶',
    etymology: {
      type: 'ideographic',
      hint: 'A plate or flat dish; an everyday item',
    },
    radical: '几',
    matches: [[0], [0], [1]],
  },
  {
    character: '凤',
    definition: 'male phoenix; symbol of joy',
    pinyin: ['fèng'],
    decomposition: '⿵几又',
    etymology: {
      type: 'pictophonetic',
      phonetic: '凡',
      semantic: '又',
      hint: 'simplified form of 鳥 bird',
    },
    radical: '几',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '処',
    definition: 'place, locale; department',
    pinyin: ['chǔ'],
    decomposition: '⿺夂几',
    etymology: {
      type: 'pictophonetic',
      phonetic: '几',
      semantic: '夂',
      hint: 'go',
    },
    radical: '夂',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '凫',
    definition: 'wild duck; teal; swim',
    pinyin: ['fú'],
    decomposition: '⿱鸟几',
    etymology: {
      type: 'pictophonetic',
      semantic: '鸟',
      hint: 'bird',
      phonetic: '凡',
    },
    radical: '几',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '凭',
    definition: 'to lean on; to rely on',
    pinyin: ['píng'],
    decomposition: '⿱任几',
    etymology: {
      type: 'ideographic',
      hint: 'Leaning on (trusting) 任 a table 几',
    },
    radical: '几',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '凯',
    definition: 'triumphant; triumph, victory',
    pinyin: ['kǎi'],
    decomposition: '⿰岂几',
    radical: '几',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '凰',
    definition: 'female phoenix',
    pinyin: ['huáng'],
    decomposition: '⿵几皇',
    etymology: { type: 'pictophonetic', phonetic: '皇', semantic: '几' },
    radical: '几',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '凱',
    definition: 'triumphant; triumph, victory',
    pinyin: ['kǎi'],
    decomposition: '⿰豈几',
    radical: '几',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '凳',
    definition: 'bench; stool',
    pinyin: ['dèng'],
    decomposition: '⿱登几',
    etymology: {
      type: 'pictophonetic',
      phonetic: '登',
      semantic: '几',
      hint: 'table',
    },
    radical: '几',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '凵',
    definition: 'container; receptacle',
    pinyin: ['qiǎn'],
    decomposition: '？',
    etymology: { type: 'pictographic', hint: 'A tray' },
    radical: '凵',
    matches: [null, null],
  },
  {
    character: '凶',
    definition: 'culprit; murder; bad, sad',
    pinyin: ['xiōng'],
    decomposition: '⿶凵乂',
    etymology: { type: 'ideographic', hint: 'A container 凵 of wickedness 乂' },
    radical: '凵',
    matches: [[1], [1], [0], [0]],
  },
  {
    character: '凸',
    definition: 'to protrude, to bulge out; convex',
    pinyin: ['tū'],
    decomposition: '⿱⿰？？一',
    etymology: { type: 'ideographic', hint: 'A rectangle with a bulge' },
    radical: '凵',
    matches: [null, null, null, null, [1]],
  },
  {
    character: '凹',
    definition: 'concave, hollow; depressed; pass, valley',
    pinyin: ['āo'],
    decomposition: '⿱？一',
    etymology: { type: 'ideographic', hint: 'A rectangle with a hollow' },
    radical: '凵',
    matches: [null, null, null, null, [1]],
  },
  {
    character: '出',
    definition: 'to go out, to send out; stand; produce',
    pinyin: ['chū'],
    decomposition: '⿱屮凵',
    etymology: {
      type: 'ideographic',
      hint: 'A sprout 屮 growing out of a container 凵',
    },
    radical: '凵',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '击',
    definition: 'to strike, to hit, to beat; to attack, to fight',
    pinyin: ['jī'],
    decomposition: '⿱？凵',
    etymology: {
      type: 'ideographic',
      hint: 'Simplified form of 擊; 手 provides the meaning',
    },
    radical: '凵',
    matches: [null, null, null, [1], [1]],
  },
  {
    character: '凼',
    definition: 'ditch; pool',
    pinyin: ['dàng'],
    decomposition: '⿶凵水',
    etymology: { type: 'ideographic', hint: 'Water 水 in a container 凵' },
    radical: '水',
    matches: [[1], [1], [1], [1], [0], [0]],
  },
  {
    character: '函',
    definition: 'correspondence; a case, a box',
    pinyin: ['hán'],
    decomposition: '⿶凵⿻了？',
    etymology: {
      type: 'ideographic',
      hint: 'Letters placed in a container 凵',
    },
    radical: '凵',
    matches: [[1, 0], [1, 0], null, null, null, null, [0], [0]],
  },
  {
    character: '凿',
    definition: 'chisel; to bore, to pierce',
    pinyin: ['záo'],
    decomposition: '⿶凵丵',
    etymology: { type: 'ideographic', hint: 'A drill 丵 making a hole 凵' },
    radical: '凵',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [0], [0]],
  },
  {
    character: '刀',
    definition: 'knife; old coin; measure',
    pinyin: ['dāo'],
    decomposition: '⿹？丿',
    radical: '刀',
    matches: [null, [1]],
  },
  {
    character: '刁',
    definition: 'tricky, sly, crafty, cunning',
    pinyin: ['diāo'],
    decomposition: '？',
    radical: '刁',
    matches: [null, null],
  },
  {
    character: '刂',
    definition: 'knife',
    pinyin: ['dāo'],
    decomposition: '⿰丨亅',
    radical: '刂',
    matches: [[0], [1]],
  },
  {
    character: '刃',
    definition: 'edged tool, cutlery, knife edge',
    pinyin: ['rèn'],
    decomposition: '⿹刀丶',
    etymology: {
      type: 'ideographic',
      hint: 'A knife 刀 sharp enough to draw blood 丶',
    },
    radical: '刀',
    matches: [[0], [0], [1]],
  },
  {
    character: '刅',
    definition: 'to create, to make, to invent',
    pinyin: ['chuāng'],
    decomposition: '⿻刀八',
    etymology: { type: 'pictophonetic', semantic: '刀', hint: 'knife' },
    radical: '刀',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '分',
    definition:
      'to divide, to allocate; fraction; small unit of time or other quantity',
    pinyin: ['fēn'],
    decomposition: '⿱八刀',
    etymology: {
      type: 'ideographic',
      hint: 'Pieces 八 being further subdivided with a knife 刀 ',
    },
    radical: '刀',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '切',
    definition: 'to cut, to mince, to slice, to carve; close to; eager',
    pinyin: ['qiè'],
    decomposition: '⿰七刀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '七',
      semantic: '刀',
      hint: 'knife',
    },
    radical: '刀',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '刈',
    definition: 'to cut off, to reap, to mow; sickle',
    pinyin: ['yì'],
    decomposition: '⿰乂刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乂',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '刊',
    definition: 'publication, periodical; to publish, to print',
    pinyin: ['kān'],
    decomposition: '⿰干刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '干',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '刍',
    definition: 'to mow, to cut grass; hay, fodder',
    pinyin: ['chú'],
    decomposition: '⿱⺈彐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彐',
      semantic: '⺈',
      hint: 'knife',
    },
    radical: '彐',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '刎',
    definition: 'to behead, to cut the throat',
    pinyin: ['wěn'],
    decomposition: '⿰勿刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '勿',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '刑',
    definition: 'punishment, penalty; law',
    pinyin: ['xíng'],
    decomposition: '⿰开刂',
    etymology: { type: 'ideographic', hint: 'A man 刂 in jail 开' },
    radical: '刂',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '划',
    definition: 'to row or paddle a boat; to scratch; to plan; profitable',
    pinyin: ['huà'],
    decomposition: '⿰戈刂',
    radical: '刂',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '刖',
    definition: 'cutting off the feet as a form of punishment',
    pinyin: ['yuè'],
    decomposition: '⿰月刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '月',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '列',
    definition: 'a line; to arrange, to classify',
    pinyin: ['liè'],
    decomposition: '⿰歹刂',
    etymology: { type: 'pictophonetic', semantic: '刂', hint: 'line' },
    radical: '刂',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '刘',
    definition: 'to kill, to destroy; surname',
    pinyin: ['liú'],
    decomposition: '⿰文刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '文',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '则',
    definition: 'rule, law, regulation; grades',
    pinyin: ['zé'],
    decomposition: '⿰贝刂',
    etymology: { type: 'ideographic', hint: 'Laws inscribed 刂 on a slate 贝' },
    radical: '刂',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '刚',
    definition: 'hard, strong, tough; just, barely',
    pinyin: ['gāng'],
    decomposition: '⿰冈刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冈',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '创',
    definition: 'to establish, to create; cut, wound, trauma',
    pinyin: ['chuàng'],
    decomposition: '⿰仓刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '仓',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '初',
    definition: 'beginning, initial, primary',
    pinyin: ['chū'],
    decomposition: '⿰衤刀',
    etymology: {
      type: 'ideographic',
      hint: 'Cutting 刀 the cloth 衤 is the first step in making clothes',
    },
    radical: '刀',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '删',
    definition: 'to delete; to cut; to censor',
    pinyin: ['shān'],
    decomposition: '⿰册刂',
    etymology: {
      type: 'ideographic',
      hint: 'To cut 刂 out passages from a book 册',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '判',
    definition: 'to judge; to discriminate; to conclude',
    pinyin: ['pàn'],
    decomposition: '⿰半刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '半',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '別',
    definition:
      'to separate, to distinguish, to classify; to leave; other; do not, must not',
    pinyin: ['bié'],
    decomposition: '⿰另刂',
    etymology: {
      type: 'ideographic',
      hint: 'To draw boundaries 刂 between classes 另',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '刨',
    definition: "carpenter's plane; plane, level",
    pinyin: ['páo'],
    decomposition: '⿰包刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '包',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '利',
    definition: 'gains, advantage, profit, merit',
    pinyin: ['lì'],
    decomposition: '⿰禾刂',
    etymology: { type: 'ideographic', hint: 'Harvesting 刂 grain 禾' },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '刪',
    definition: 'to delete; to cut; to censor',
    pinyin: ['shān'],
    decomposition: '⿰冊刂',
    etymology: {
      type: 'ideographic',
      hint: 'To cut 刂 out passages from a book 冊',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '别',
    definition:
      'to separate, to distinguish, to classify; to leave; other; do not, must not',
    pinyin: ['bié'],
    decomposition: '⿰另刂',
    etymology: {
      type: 'ideographic',
      hint: 'To draw boundaries 刂 between classes 另',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '刭',
    definition: 'to cut the throat',
    pinyin: ['jǐng'],
    decomposition: '⿰？刂',
    etymology: { type: 'pictophonetic', semantic: '刂', hint: 'knife' },
    radical: '刂',
    matches: [null, null, null, null, null, [1], [1]],
  },
  {
    character: '刮',
    definition: 'to shave; to scrape; to blow',
    pinyin: ['guā'],
    decomposition: '⿰舌刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '舌',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '到',
    definition: 'to go to, to arrive',
    pinyin: ['dào'],
    decomposition: '⿰至刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '刂',
      semantic: '至',
      hint: 'arrive',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '刳',
    definition: 'to cut open, to dig out, to rip up, to scoop out',
    pinyin: ['kū'],
    decomposition: '⿰夸刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夸',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '制',
    definition: 'system; to establish; to manufacture; to overpower',
    pinyin: ['zhì'],
    decomposition: '⿰⿻？巾刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巾',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [null, null, null, [0, 1], [0, 1], [0, 1], [1], [1]],
  },
  {
    character: '刷',
    definition: 'brush; to clean, to scrub',
    pinyin: ['shuā'],
    decomposition: '⿰⿸尸巾刂',
    etymology: {
      type: 'ideographic',
      hint: 'A person bent over 尸 with a towel 巾',
    },
    radical: '刂',
    matches: [[0, 0], [0, 0], [0, 0], [0, 1], [0, 1], [0, 1], [1], [1]],
  },
  {
    character: '券',
    definition: 'bond, certificate, deed; ticket; contract',
    pinyin: ['quàn'],
    decomposition: '⿱龹刀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龹',
      semantic: '刀',
      hint: 'knife',
    },
    radical: '刀',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '刹',
    definition: 'temple, shrine, monastary; an instant, a moment; to brake',
    pinyin: ['shā'],
    decomposition: '⿰杀刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '杀',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '刺',
    definition: 'to stab; to prick, to irritate; to prod',
    pinyin: ['cì'],
    decomposition: '⿰朿刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朿',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '刻',
    definition: 'to carve, to engrave; a quarter hour; a moment',
    pinyin: ['kè'],
    decomposition: '⿰亥刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亥',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '刽',
    definition: 'to amputate, to cut off',
    pinyin: ['guì'],
    decomposition: '⿰会刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '会',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '刿',
    definition: 'to cut, to injure, to stab; to stick on',
    pinyin: ['guì'],
    decomposition: '⿰岁刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '岁',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '剀',
    definition: 'to sharpen; careful, thorough',
    pinyin: ['kǎi'],
    decomposition: '⿰岂刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '岂',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '剁',
    definition: 'to chop by pounding, to hash, to mince',
    pinyin: ['duò'],
    decomposition: '⿰朵刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朵',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '剂',
    definition: 'dose; medicine; measure word for medicines',
    pinyin: ['jì'],
    decomposition: '⿰齐刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '齐',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '剃',
    definition: 'to shave',
    pinyin: ['tì'],
    decomposition: '⿰弟刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弟',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '則',
    definition: 'rule, law, regulation; grades',
    pinyin: ['zé'],
    decomposition: '⿰貝刂',
    etymology: { type: 'ideographic', hint: 'Laws inscribed 刂 on a slate 貝' },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '削',
    definition: 'to pare, to scrape, to trim',
    pinyin: ['xuē'],
    decomposition: '⿰肖刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肖',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '剋',
    definition: 'to subdue, to restrain, to overcome; used in transliterations',
    pinyin: ['kè'],
    decomposition: '⿰克刂',
    etymology: {
      type: 'ideographic',
      hint: 'A weapon 刂 used to subdue 十 a beast 兄',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '剌',
    definition: 'to slash, to cut in two; to contradict',
    pinyin: ['lá'],
    decomposition: '⿰束刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '束',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '前',
    definition: 'in front, forward; former, preceding',
    pinyin: ['qián'],
    decomposition: '⿱⿱丷一刖',
    radical: '刂',
    matches: [[0, 0], [0, 0], [0, 1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '剎',
    definition: 'temple, shrine, monastary; an instant, a moment; to brake',
    pinyin: ['shā'],
    decomposition: '⿰杀刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '杀',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], null, [1], [1]],
  },
  {
    character: '剐',
    definition: 'to cut; to sever flesh from bone',
    pinyin: ['guǎ'],
    decomposition: '⿰呙刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '呙',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '剑',
    definition: 'sword, dagger, saber',
    pinyin: ['jiàn'],
    decomposition: '⿰佥刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '佥',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '剔',
    definition: 'to pick out; to scrape off; picky',
    pinyin: ['tī'],
    decomposition: '⿰易刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '易',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '剖',
    definition: 'to bisect, to dissect, to slice',
    pinyin: ['pōu'],
    decomposition: '⿰咅刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咅',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '剛',
    definition: 'hard, strong, tough; just, barely',
    pinyin: ['gāng'],
    decomposition: '⿰岡刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '岡',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '剜',
    definition: 'to cut; to cut out, to pick out, to scoop out',
    pinyin: ['wān'],
    decomposition: '⿰宛刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宛',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '剝',
    definition: 'to peel, to skin; to exploit',
    pinyin: ['bō'],
    decomposition: '⿰彔刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彔',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '剞',
    definition: 'carving or engraving; knife; grave',
    pinyin: ['jī'],
    decomposition: '⿰奇刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奇',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '剡',
    definition: 'sharp, pointed; to sharpen',
    pinyin: ['shàn'],
    decomposition: '⿰炎刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '炎',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '剥',
    definition: 'to peel, to skin; to exploit',
    pinyin: ['bō'],
    decomposition: '⿰录刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '录',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '剧',
    definition: 'theatrical plays, opera, drama; severe, acute',
    pinyin: ['jù'],
    decomposition: '⿰居刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '居',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '剩',
    definition: 'leftovers, residue, remains',
    pinyin: ['shèng'],
    decomposition: '⿰乘刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乘',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '剪',
    definition: 'scissors; to cut, to divide, to separate',
    pinyin: ['jiǎn'],
    decomposition: '⿱前刀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '前',
      semantic: '刀',
      hint: 'knife',
    },
    radical: '刀',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '剮',
    definition: 'to cut; to sever flesh from bone',
    pinyin: ['guǎ'],
    decomposition: '⿰咼刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咼',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '副',
    definition: 'to assist, to supplement; assistant; secondary; auxiliary',
    pinyin: ['fù'],
    decomposition: '⿰畐刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畐',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '割',
    definition: 'to cut, to divide, to partition; to cede',
    pinyin: ['gē'],
    decomposition: '⿰害刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '害',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '剳',
    definition: 'note, memo, official communique',
    pinyin: ['dá'],
    decomposition: '⿰荅刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '刂',
      semantic: '荅',
      hint: 'answer',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '創',
    definition: 'to establish, to create; cut, wound, trauma',
    pinyin: ['chuàng'],
    decomposition: '⿰倉刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '倉',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '剷',
    definition: 'to raze, to pare, to level off',
    pinyin: ['chǎn'],
    decomposition: '⿰産刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '産',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '剽',
    definition: 'to rob, to plunder, to slice off; nimble, quick',
    pinyin: ['piāo'],
    decomposition: '⿰票刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '票',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '剿',
    definition: 'to annihilate, to destroy, to exterminate',
    pinyin: ['jiǎo'],
    decomposition: '⿰巢刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巢',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '劁',
    definition: 'to castrate, to neuter',
    pinyin: ['qiāo'],
    decomposition: '⿰焦刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '焦',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '劂',
    definition: 'chisel; to engrave',
    pinyin: ['jué'],
    decomposition: '⿰厥刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厥',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '劃',
    definition: 'to row or paddle a boat; to scratch; to plan; profitable',
    pinyin: ['huà'],
    decomposition: '⿰畫刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畫',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '劄',
    definition: 'memo, note, official communique',
    pinyin: ['zhā'],
    decomposition: '⿰答刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '刂',
      semantic: '答',
      hint: 'answer',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '劇',
    definition: 'theatrical plays, opera, drama; severe, acute',
    pinyin: ['jù'],
    decomposition: '⿰豦刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豦',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '劈',
    definition: 'to chop, to cut apart; to split',
    pinyin: ['pī'],
    decomposition: '⿱辟刀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辟',
      semantic: '刀',
      hint: 'knife',
    },
    radical: '刀',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '劉',
    definition: 'to kill, to destroy; surname',
    pinyin: ['liú'],
    decomposition: '⿰⿱卯金刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卯',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
    ],
  },
  {
    character: '劊',
    definition: 'to amputate, to cut off',
    pinyin: ['guì'],
    decomposition: '⿰會刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '會',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '劍',
    definition: 'sword, dagger, saber',
    pinyin: ['jiàn'],
    decomposition: '⿰僉刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '僉',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '劐',
    definition: 'to destroy',
    pinyin: ['huō'],
    decomposition: '⿰蒦刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蒦',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '劑',
    definition: 'dose; medicine; measure word for medicines',
    pinyin: ['jì'],
    decomposition: '⿰齊刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '齊',
      semantic: '刂',
      hint: 'knife',
    },
    radical: '刂',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '劓',
    definition: 'to cut off the nose',
    pinyin: ['yì'],
    decomposition: '⿰鼻刂',
    etymology: {
      type: 'ideographic',
      hint: 'To cut 刂 the nose 鼻; 鼻 also provides the pronunciation',
    },
    radical: '刂',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '力',
    definition: 'strength, power; capability, influence',
    pinyin: ['lì'],
    decomposition: '⿻丿？',
    etymology: {
      type: 'ideographic',
      hint: "A plow's head representing strength",
    },
    radical: '力',
    matches: [null, [0]],
  },
  {
    character: '劝',
    definition: 'to recommend, to advise; to urge, to exhort',
    pinyin: ['quàn'],
    decomposition: '⿰又力',
    etymology: {
      type: 'ideographic',
      hint: 'The power 力 beside 又 the throne',
    },
    radical: '力',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '办',
    definition: 'to set up; to manage, to run; to deal with, to handle',
    pinyin: ['bàn'],
    decomposition: '⿻力八',
    etymology: {
      type: 'pictophonetic',
      phonetic: '八',
      semantic: '力',
      hint: 'strength',
    },
    radical: '力',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '功',
    definition: 'achievement, good work; merit; service',
    pinyin: ['gōng'],
    decomposition: '⿰工力',
    etymology: {
      type: 'ideographic',
      hint: 'Results produced by capable 力 labor 工; 工 also provides the pronunciation',
    },
    radical: '力',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '加',
    definition: 'to add to, to increase, to augment',
    pinyin: ['jiā'],
    decomposition: '⿰力口',
    etymology: {
      type: 'ideographic',
      hint: "Supporting a cause with the strength 力 of one's words 口",
    },
    radical: '力',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '务',
    definition: 'affairs, business; should; must',
    pinyin: ['wù'],
    decomposition: '⿱夂力',
    radical: '夂',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '劢',
    definition: 'to put forth effort, to strive for',
    pinyin: ['mài'],
    decomposition: '⿰万力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '万',
      semantic: '力',
      hint: 'strength',
    },
    radical: '力',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '劣',
    definition: 'low-quality, inferior, bad',
    pinyin: ['liè'],
    decomposition: '⿱少力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '力',
      semantic: '少',
      hint: 'inadequate',
    },
    radical: '力',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '劦',
    definition: 'to cooperate, to work together; joint labor',
    pinyin: ['xié'],
    decomposition: '⿱力⿰力力',
    etymology: { type: 'ideographic', hint: 'Many people working 力 together' },
    radical: '力',
    matches: [[0], [0], [1, 0], [1, 0], [1, 1], [1, 1]],
  },
  {
    character: '动',
    definition: 'to move, to happen; movement, action',
    pinyin: ['dòng'],
    decomposition: '⿰云力',
    etymology: { type: 'pictophonetic', semantic: '力', hint: 'strength' },
    radical: '力',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '助',
    definition: 'to help, to aid, to assist',
    pinyin: ['zhù'],
    decomposition: '⿰且力',
    etymology: {
      type: 'pictophonetic',
      semantic: '力',
      hint: 'strength',
      phonetic: '且',
    },
    radical: '力',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '努',
    definition: 'to exert, to strive, to make an effort; to pout',
    pinyin: ['nǔ'],
    decomposition: '⿱奴力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奴',
      semantic: '力',
      hint: 'strength',
    },
    radical: '力',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '劫',
    definition: 'to take by force, to coerce; disaster; misfortune',
    pinyin: ['jié'],
    decomposition: '⿰去力',
    etymology: {
      type: 'pictophonetic',
      hint: 'strength',
      semantic: '力',
      phonetic: '去',
    },
    radical: '力',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '劬',
    definition: 'diligent; to toil, to endeavor',
    pinyin: ['qú'],
    decomposition: '⿰句力',
    etymology: {
      type: 'pictophonetic',
      semantic: '力',
      hint: 'strength',
      phonetic: '句',
    },
    radical: '力',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '劭',
    definition: 'to encourage; to excel; excellent',
    pinyin: ['shào'],
    decomposition: '⿰召力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '召',
      semantic: '力',
      hint: 'strength',
    },
    radical: '力',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '励',
    definition: 'to encourage; to strive',
    pinyin: ['lì'],
    decomposition: '⿰厉力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厉',
      semantic: '力',
      hint: 'strength',
    },
    radical: '力',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '劲',
    definition: 'strong, tough, unyielding; power, energy',
    pinyin: ['jìn'],
    decomposition: '⿰？力',
    etymology: { type: 'pictophonetic', semantic: '力', hint: 'strength' },
    radical: '力',
    matches: [null, null, null, null, null, [1], [1]],
  },
  {
    character: '劳',
    definition: 'to labor, to toil; to do manual work',
    pinyin: ['láo'],
    decomposition: '⿱艹⿱冖力',
    etymology: {
      type: 'ideographic',
      hint: 'A man lifting 力 a load 冖 of grass 艹',
    },
    radical: '力',
    matches: [[0], [0], [0], [1, 0], [1, 0], [1, 1], [1, 1]],
  },
  {
    character: '劵',
    definition: 'certificate, ticket; title deed',
    pinyin: ['juàn'],
    decomposition: '⿱龹力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龹',
      semantic: '力',
      hint: 'strength',
    },
    radical: '力',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '劼',
    definition: 'cautious, discreet, prudent',
    pinyin: ['jié'],
    decomposition: '⿰吉力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吉',
      semantic: '力',
      hint: 'strength',
    },
    radical: '力',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '劾',
    definition: 'to look into; to impeach, to charge',
    pinyin: ['hé'],
    decomposition: '⿰亥力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亥',
      semantic: '力',
      hint: 'strength',
    },
    radical: '力',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '势',
    definition: 'power, force; tendency, attitude',
    pinyin: ['shì'],
    decomposition: '⿱执力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '执',
      semantic: '力',
      hint: 'strength',
    },
    radical: '力',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '勁',
    definition: 'strong, tough, unyielding; power, energy',
    pinyin: ['jìn'],
    decomposition: '⿰巠力',
    etymology: { type: 'pictophonetic', semantic: '力', hint: 'strength' },
    radical: '力',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '勃',
    definition: 'thriving, prosperous; sudden, quick',
    pinyin: ['bó'],
    decomposition: '⿰孛力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孛',
      semantic: '力',
      hint: 'strength',
    },
    radical: '力',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '勇',
    definition: 'brave, courageous, fierce',
    pinyin: ['yǒng'],
    decomposition: '⿱甬力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甬',
      semantic: '力',
      hint: 'strength',
    },
    radical: '力',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '勈',
    definition: 'brave',
    pinyin: ['yǒng'],
    decomposition: '⿰甬力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甬',
      semantic: '力',
      hint: 'strength',
    },
    radical: '力',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '勉',
    definition: 'to endeavor, to make an effort; to urge',
    pinyin: ['miǎn'],
    decomposition: '⿺免力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '免',
      semantic: '力',
      hint: 'strength',
    },
    radical: '力',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '勋',
    definition: 'deeds, feats; merit; rank',
    pinyin: ['xūn'],
    decomposition: '⿰员力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '员',
      semantic: '力',
      hint: 'strength',
    },
    radical: '力',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '勐',
    definition: 'imperial decree; daoist magic',
    pinyin: ['měng'],
    decomposition: '⿰孟力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孟',
      semantic: '力',
      hint: 'strength',
    },
    radical: '力',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '勒',
    definition: 'to strangle; to tighten',
    pinyin: ['lēi'],
    decomposition: '⿰革力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '革',
      semantic: '力',
      hint: 'strength',
    },
    radical: '力',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '動',
    definition: 'to move, to happen; movement, action',
    pinyin: ['dòng'],
    decomposition: '⿰重力',
    etymology: {
      type: 'pictophonetic',
      semantic: '力',
      hint: 'strength',
      phonetic: '重',
    },
    radical: '力',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '勖',
    definition: 'to advise; to exhort; to preach to',
    pinyin: ['xù'],
    decomposition: '⿰冒力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冒',
      semantic: '力',
      hint: 'strength',
    },
    radical: '力',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '勘',
    definition: 'to investigate; to survey, to explore; to compare; to collate',
    pinyin: ['kān'],
    decomposition: '⿰甚力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甚',
      semantic: '力',
      hint: 'strength',
    },
    radical: '力',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '務',
    definition: 'affairs, business; should; must',
    pinyin: ['wù'],
    decomposition: '⿰矛务',
    etymology: {
      type: 'pictophonetic',
      phonetic: '务',
      semantic: '矛',
      hint: 'affairs',
    },
    radical: '力',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '勛',
    definition: 'deeds, feats; merit; rank',
    pinyin: ['xūn'],
    decomposition: '⿰員力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '員',
      semantic: '力',
      hint: 'strength',
    },
    radical: '力',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '勝',
    definition: 'victory; to excel, to truimph',
    pinyin: ['shèng'],
    decomposition: '⿰月劵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '劵',
      semantic: '月',
      hint: 'flesh',
    },
    radical: '力',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '勞',
    definition: 'to labor, to toil; to do manual work',
    pinyin: ['láo'],
    decomposition: '⿳炏冖力',
    etymology: {
      type: 'ideographic',
      hint: 'A man lifting 力 a load 冖 of grass 炏',
    },
    radical: '力',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [2], [2]],
  },
  {
    character: '募',
    definition: 'to levy, to raise; to recruit; to summon',
    pinyin: ['mù'],
    decomposition: '⿱莫力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '莫',
      semantic: '力',
      hint: 'strength',
    },
    radical: '力',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '勢',
    definition: 'power, force; tendency, attitude',
    pinyin: ['shì'],
    decomposition: '⿱埶力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '埶',
      semantic: '力',
      hint: 'strength',
    },
    radical: '力',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '勤',
    definition: 'industrious, diligent, attentive',
    pinyin: ['qín'],
    decomposition: '⿰堇力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堇',
      semantic: '力',
      hint: 'strength',
    },
    radical: '力',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '勦',
    definition: 'to annihilate, to destroy, to exterminate',
    pinyin: ['chāo'],
    decomposition: '⿰巢力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巢',
      semantic: '力',
      hint: 'strength',
    },
    radical: '力',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '勰',
    definition: 'peaceful, harmonious',
    pinyin: ['xié'],
    decomposition: '⿰劦思',
    etymology: {
      type: 'pictophonetic',
      phonetic: '劦',
      semantic: '思',
      hint: 'think',
    },
    radical: '力',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '勳',
    definition: 'dead, feat; merit, rank',
    pinyin: ['xūn'],
    decomposition: '⿰熏力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '熏',
      semantic: '力',
      hint: 'strength',
    },
    radical: '力',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '勵',
    definition: 'to encourage; to strive',
    pinyin: ['lì'],
    decomposition: '⿰厲力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厲',
      semantic: '力',
      hint: 'strength',
    },
    radical: '力',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '勸',
    definition: 'to recommend, to advise; to urge, to exhort',
    pinyin: ['quàn'],
    decomposition: '⿰雚力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '雚',
      semantic: '力',
      hint: 'power',
    },
    radical: '力',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '勹',
    definition: 'wrap',
    pinyin: ['bāo'],
    decomposition: '⿰丿？',
    radical: '勹',
    matches: [[0], null],
  },
  {
    character: '勺',
    definition: 'spoon, ladle; unit of volume',
    pinyin: ['sháo'],
    decomposition: '⿹勹丶',
    etymology: {
      type: 'ideographic',
      hint: 'A spoon 勹 with something in it 丶',
    },
    radical: '勹',
    matches: [[0], [0], [1]],
  },
  {
    character: '勻',
    definition: 'equal; even, uniform',
    pinyin: ['yún'],
    decomposition: '⿹勹二',
    etymology: {
      type: 'ideographic',
      hint: 'Using a spoon 勹 to measure out two equal parts 二',
    },
    radical: '勹',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '勾',
    definition: 'to hook, to join, to connect; to entice',
    pinyin: ['gōu'],
    decomposition: '⿹勹厶',
    radical: '勹',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '勿',
    definition: 'must not, do not; without, never',
    pinyin: ['wù'],
    decomposition: '⿹勹⿰丿丿',
    etymology: {
      type: 'ideographic',
      hint: 'A knife 勹 cutting fragments 丿 off',
    },
    radical: '勹',
    matches: [[0], [0], [1, 0], [1, 1]],
  },
  {
    character: '匀',
    definition: 'equal; even, uniform',
    pinyin: ['yún'],
    decomposition: '⿻勹冫',
    etymology: {
      type: 'ideographic',
      hint: 'Using a spoon 勹 to measure out two equal parts 冫',
    },
    radical: '勹',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '包',
    definition: 'wrap, pack, bundle; package',
    pinyin: ['bāo'],
    decomposition: '⿹勹巳',
    etymology: {
      type: 'ideographic',
      hint: 'To swaddle 勹 a baby 巳; 勹 also provides the pronunciation',
    },
    radical: '勹',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '匆',
    definition: 'hastily, hurriedly, in a rush',
    pinyin: ['cōng'],
    decomposition: '⿻勿丶',
    radical: '勹',
    matches: [[0], [0], [0], [0], [1]],
  },
  {
    character: '匈',
    definition: 'breast, chest, thorax; to clamor; Hungary',
    pinyin: ['xiōng'],
    decomposition: '⿹勹凶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '凶',
      semantic: '勹',
      hint: 'wrap',
    },
    radical: '勹',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '匊',
    definition: 'handful',
    pinyin: ['jū'],
    decomposition: '⿹勹米',
    etymology: {
      type: 'ideographic',
      hint: 'A handful of rice 米 in a bowl 勹',
    },
    radical: '勹',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '匋',
    definition: 'pottery',
    pinyin: ['táo'],
    decomposition: '⿹勹缶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '勹',
      semantic: '缶',
      hint: 'pottery',
    },
    radical: '勹',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '匍',
    definition: 'to crawl; to lie prostrate',
    pinyin: ['pú'],
    decomposition: '⿹勹甫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甫',
      semantic: '勹',
      hint: 'wrap',
    },
    radical: '勹',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '匏',
    definition: 'gourd; musical instrument',
    pinyin: ['páo'],
    decomposition: '⿰夸包',
    etymology: {
      type: 'pictophonetic',
      phonetic: '包',
      semantic: '夸',
      hint: 'extravagant',
    },
    radical: '勹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '匐',
    definition: 'to crawl; to lie prostrate',
    pinyin: ['fú'],
    decomposition: '⿹勹畐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畐',
      semantic: '勹',
      hint: 'wrap',
    },
    radical: '勹',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '匕',
    definition: 'spoon, ladle; knife, dirk',
    pinyin: ['bǐ'],
    decomposition: '⿺乚丿',
    etymology: { type: 'pictographic', hint: 'A spoon' },
    radical: '匕',
    matches: [[1], [0]],
  },
  {
    character: '化',
    definition: 'to change, to convert, to reform; -ize',
    pinyin: ['huà'],
    decomposition: '⿰亻匕',
    radical: '匕',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '北',
    definition: 'north; northern; northward',
    pinyin: ['běi'],
    decomposition: '⿰？匕',
    etymology: {
      type: 'pictographic',
      hint: 'Two people 匕 sitting back-to-back; phonetic loan for "north"',
    },
    radical: '匕',
    matches: [null, null, null, [1], [1]],
  },
  {
    character: '匙',
    definition: 'spoon; surname',
    pinyin: ['chí', 'shī'],
    decomposition: '⿺是匕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '是',
      semantic: '匕',
      hint: 'spoon',
    },
    radical: '匕',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '匚',
    definition: 'box; basket',
    pinyin: ['fāng'],
    decomposition: '⿱一？',
    radical: '匚',
    matches: [[0], null],
  },
  {
    character: '匛',
    pinyin: ['jiù'],
    decomposition: '⿷匚久',
    etymology: { type: 'pictophonetic', phonetic: '久', semantic: '匚' },
    radical: '匚',
    matches: [[0], [1], [1], [1], [0]],
  },
  {
    character: '匝',
    definition: 'full circle; to encircle',
    pinyin: ['zā'],
    decomposition: '⿷匚巾',
    radical: '匚',
    matches: [[0], [1], [1], [1], [0]],
  },
  {
    character: '匠',
    definition: 'artisan, craftsman, workman',
    pinyin: ['jiàng'],
    decomposition: '⿷匚斤',
    radical: '匚',
    matches: [[0], [1], [1], [1], [1], [0]],
  },
  {
    character: '匡',
    definition: 'to correct, to revise; to restore',
    pinyin: ['kuāng'],
    decomposition: '⿷匚王',
    etymology: {
      type: 'pictophonetic',
      phonetic: '王',
      semantic: '匚',
      hint: 'box',
    },
    radical: '匚',
    matches: [[0], [1], [1], [1], [1], [0]],
  },
  {
    character: '匣',
    definition: 'case, coffer, small box',
    pinyin: ['xiá'],
    decomposition: '⿷匚甲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甲',
      semantic: '匚',
      hint: 'box',
    },
    radical: '匚',
    matches: [[0], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '匦',
    definition: 'chest, casket, small box',
    pinyin: ['guǐ'],
    decomposition: '⿷匚轨',
    etymology: {
      type: 'pictophonetic',
      phonetic: '轨',
      semantic: '匚',
      hint: 'box',
    },
    radical: '匚',
    matches: [[0], [1], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '匧',
    definition: 'trunk, suitcase; portfolio',
    pinyin: ['qiè'],
    decomposition: '⿷匚夾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夾',
      semantic: '匚',
      hint: 'box',
    },
    radical: '匚',
    matches: [[0], [1], [1], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '匪',
    definition: 'bandits, robbers, gangsters',
    pinyin: ['fěi'],
    decomposition: '⿷匚非',
    etymology: {
      type: 'pictophonetic',
      phonetic: '非',
      semantic: '匚',
      hint: 'basket',
    },
    radical: '匚',
    matches: [[0], [1], [1], [1], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '匭',
    definition: 'chest, casket, small box',
    pinyin: ['guǐ'],
    decomposition: '⿷匚軌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '軌',
      semantic: '匚',
      hint: 'box',
    },
    radical: '匚',
    matches: [[0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '匮',
    definition: 'to lack; lacking, deficient; exhausted; empty',
    pinyin: ['kuì'],
    decomposition: '⿷匚贵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贵',
      semantic: '匚',
      hint: 'box',
    },
    radical: '匚',
    matches: [[0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '匯',
    definition: 'to gather, to collect; confluence',
    pinyin: ['huì'],
    decomposition: '⿷匚淮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '淮',
      semantic: '匚',
      hint: 'box',
    },
    radical: '匚',
    matches: [[0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '匱',
    definition: 'to lack; lacking, deficient; exhausted; empty',
    pinyin: ['kuì'],
    decomposition: '⿷匚貴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '貴',
      semantic: '匚',
      hint: 'box',
    },
    radical: '匚',
    matches: [
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
    ],
  },
  {
    character: '匸',
    definition: 'box',
    pinyin: ['xì'],
    decomposition: '？',
    radical: '匸',
    matches: [null, null],
  },
  {
    character: '匹',
    definition: 'bolt of cloth; mate, one of a pair; measure word for horses',
    pinyin: ['pǐ'],
    decomposition: '⿷匸儿',
    etymology: { type: 'pictographic', hint: 'A roll of cloth' },
    radical: '匸',
    matches: [[0], [1], [1], [0]],
  },
  {
    character: '区',
    definition: 'area, district, region, ward; surname',
    pinyin: ['qū'],
    decomposition: '⿷匸乂',
    etymology: {
      type: 'ideographic',
      hint: "A place 匸 under a lord's control 乂",
    },
    radical: '匸',
    matches: [[0], [1], [1], [0]],
  },
  {
    character: '医',
    definition: 'to cure, to heal, to treat; doctor; medicine',
    pinyin: ['yī'],
    decomposition: '⿷匸矢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匸',
      semantic: '矢',
      hint: 'arrow',
    },
    radical: '匸',
    matches: [[0], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '匽',
    definition: 'to hide, to repress; to bend',
    pinyin: ['yǎn'],
    decomposition: '⿷匸妟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '妟',
      semantic: '匸',
      hint: 'box',
    },
    radical: '匸',
    matches: [[0], [1], [1], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '匾',
    definition: 'a board, sign, or tablet made from bamboo',
    pinyin: ['biǎn'],
    decomposition: '⿷匸扁',
    etymology: {
      type: 'ideographic',
      hint: 'A board 扁 made of bamboo 匸; 扁 also provides the pronunciation',
    },
    radical: '匸',
    matches: [[0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '匿',
    definition: 'to hide; to go into hiding',
    pinyin: ['nì'],
    decomposition: '⿷匸若',
    etymology: {
      type: 'pictophonetic',
      phonetic: '若',
      semantic: '匸',
      hint: 'box',
    },
    radical: '匸',
    matches: [[0], [1], [1], [1], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '區',
    definition: 'area, district, region, ward; surname',
    pinyin: ['qū'],
    decomposition: '⿷匸品',
    etymology: {
      type: 'ideographic',
      hint: 'A place 匸 where many mouths 品 live',
    },
    radical: '匸',
    matches: [[0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '十',
    definition: 'ten, tenth; complete; perfect',
    pinyin: ['shí'],
    decomposition: '⿻一丨',
    radical: '十',
    matches: [[0], [1]],
  },
  {
    character: '卂',
    definition: 'to fly rapidly',
    pinyin: ['xùn'],
    decomposition: '⿹乙十',
    radical: '十',
    matches: [[0], [1], [1]],
  },
  {
    character: '千',
    definition: 'thousand; many, numerous; very',
    pinyin: ['qiān'],
    decomposition: '⿱丿十',
    radical: '十',
    matches: [[0], [1], [1]],
  },
  {
    character: '卄',
    definition: 'twenty, twentieth',
    pinyin: ['niàn'],
    decomposition: '⿻十丨',
    etymology: { type: 'ideographic', hint: 'Two tens 十 side by side' },
    radical: '十',
    matches: [[0], [0], [1]],
  },
  {
    character: '卅',
    definition: 'thirty, thirtieth',
    pinyin: ['sà'],
    decomposition: '⿻一川',
    etymology: {
      type: 'ideographic',
      hint: 'Three tally marks; compare ten 十 and twenty 廿',
    },
    radical: '十',
    matches: [[0], [1], [1], [1]],
  },
  {
    character: '升',
    definition: 'to advance; to arise; to hoist, to raise',
    pinyin: ['shēng'],
    decomposition: '⿻十？',
    radical: '十',
    matches: [null, [0], null, [0]],
  },
  {
    character: '午',
    definition: 'noon; 7th terrestrial branch',
    pinyin: ['wǔ'],
    decomposition: '⿻丿干',
    radical: '十',
    matches: [[0], [1], [1], [1]],
  },
  {
    character: '卉',
    definition: 'general term for plants; myriads',
    pinyin: ['huì'],
    decomposition: '⿱十艹',
    etymology: {
      type: 'ideographic',
      hint: 'Ten 十 different types of grass 艹',
    },
    radical: '十',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '半',
    definition: 'half; semi-, incomplete',
    pinyin: ['bàn'],
    decomposition: '⿻丷牛',
    etymology: {
      type: 'ideographic',
      hint: 'A cow 牛 splitting 丷 wood in half',
    },
    radical: '十',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '卌',
    definition: 'forty, fortieth',
    pinyin: ['xì'],
    decomposition: '⿻一？',
    etymology: {
      type: 'ideographic',
      hint: 'Four tally marks; compare ten 十, twenty 廿, and thirty 卅',
    },
    radical: '十',
    matches: [[0], null, null, null, null],
  },
  {
    character: '华',
    definition: 'flowery; illustrious; Chinese',
    pinyin: ['huá'],
    decomposition: '⿱化十',
    etymology: {
      type: 'pictophonetic',
      phonetic: '化',
      semantic: '十',
      hint: 'ten',
    },
    radical: '十',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '协',
    definition: 'to assist; to cooperate, to join; to harmonize',
    pinyin: ['xié'],
    decomposition: '⿰十办',
    etymology: {
      type: 'pictophonetic',
      phonetic: '十',
      semantic: '办',
      hint: 'manage',
    },
    radical: '十',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '卑',
    definition: 'humble, low, inferior; to despise',
    pinyin: ['bēi'],
    decomposition: '⿱白十',
    etymology: {
      type: 'ideographic',
      hint: 'A hand 又(altered) holding an empty shell 甲 (altered)',
    },
    radical: '十',
    matches: [[0], [0], [0], [0], [0], null, [1], [1]],
  },
  {
    character: '卒',
    definition: 'soldier; servant; at last, finally',
    pinyin: ['zú'],
    decomposition: '⿱亠⿱从十',
    etymology: { type: 'pictographic', hint: 'A soldier in armor' },
    radical: '十',
    matches: [[0], [0], [1, 0], [1, 0], [1, 0], [1, 0], [1, 1], [1, 1]],
  },
  {
    character: '卓',
    definition: 'profound, lofty, brilliant',
    pinyin: ['zhuō'],
    decomposition: '⿱⺊早',
    etymology: {
      type: 'ideographic',
      hint: 'To foresee ⺊ the dawn 早 coming; 早 also provides the pronunciation',
    },
    radical: '十',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '協',
    definition: 'to assist; to cooperate, to join; to harmonize',
    pinyin: ['xié'],
    decomposition: '⿰十劦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '十',
      semantic: '劦',
      hint: 'cooperate',
    },
    radical: '十',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '单',
    definition: 'single, individual, only; lone',
    pinyin: ['dān'],
    decomposition: '⿱丷？',
    radical: '丷',
    matches: [[0], [0], null, null, null, null, null, null],
  },
  {
    character: '卖',
    definition: 'to sell; to betray; to show off',
    pinyin: ['mài'],
    decomposition: '⿱十买',
    etymology: {
      type: 'pictophonetic',
      phonetic: '买',
      semantic: '买',
      hint: 'buy',
    },
    radical: '十',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '南',
    definition: 'south; southern; southward',
    pinyin: ['nán'],
    decomposition: '⿱十⿵冂⿱丷干',
    etymology: { type: 'pictographic', hint: 'A musical bell' },
    radical: '十',
    matches: [
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
    ],
  },
  {
    character: '博',
    definition:
      'to gamble, to play games; to win; rich, plentiful, extensive; wide, broad',
    pinyin: ['bó'],
    decomposition: '⿰十尃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尃',
      semantic: '十',
      hint: 'ten',
    },
    radical: '十',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '卜',
    definition: 'divination, fortune-telling; prophecy',
    pinyin: ['bo'],
    decomposition: '⿻丨丶',
    etymology: { type: 'pictographic', hint: 'A crack on an oracle bone' },
    radical: '卜',
    matches: [[0], [1]],
  },
  {
    character: '卞',
    definition: 'to be impatient; hasty, excitable',
    pinyin: ['biàn'],
    decomposition: '⿱亠卜',
    radical: '卜',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '卟',
    definition: 'a chemical compound; divination; to consider',
    pinyin: ['bǔ'],
    decomposition: '⿰口卜',
    etymology: {
      type: 'ideographic',
      hint: 'To speak 口 of the future 卜; 卜 also provides the pronunciation',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '占',
    definition: 'to divine; to observe; to versify',
    pinyin: ['zhàn'],
    decomposition: '⿱⺊口',
    etymology: { type: 'ideographic', hint: 'To speak 口 omens ⺊' },
    radical: '⺊',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '卡',
    definition: 'card, punch card; calorie',
    pinyin: ['kǎ'],
    decomposition: '⿱上卜',
    etymology: {
      type: 'ideographic',
      hint: 'A card squeezed between 上 and 下',
    },
    radical: '卜',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '卢',
    definition: 'cottage, hut; black; surname',
    pinyin: ['lú'],
    decomposition: '⿱⺊尸',
    radical: '⺊',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '卣',
    definition: 'a vessel of wine',
    pinyin: ['yǒu'],
    decomposition: '⿱⺊⿴囗？',
    etymology: { type: 'pictographic', hint: 'A wine flask' },
    radical: '⺊',
    matches: [[0], [0], [1, 0], [1, 0], null, null, [1, 0]],
  },
  {
    character: '卤',
    definition: 'salt',
    pinyin: ['lǔ'],
    decomposition: '⿱⺊⿴囗乂',
    etymology: {
      type: 'pictographic',
      hint: 'A container used to brine pickles',
    },
    radical: '卤',
    matches: [[0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 0]],
  },
  {
    character: '卦',
    definition: 'divination, fortune-telling',
    pinyin: ['guà'],
    decomposition: '⿰圭卜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '圭',
      semantic: '卜',
      hint: 'divination',
    },
    radical: '卜',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '卧',
    definition: 'to crouch; to lie down',
    pinyin: ['wò'],
    decomposition: '⿰臣卜',
    etymology: {
      type: 'ideographic',
      hint: 'A person 卜 (altered form of 人) laying in bed 臣',
    },
    radical: '臣',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '卩',
    definition: 'seal; kneeling person',
    pinyin: ['jié'],
    decomposition: '⿰丨？',
    etymology: {
      type: 'pictographic',
      hint: 'A rolled-up scroll or kneeling person',
    },
    radical: '卩',
    matches: [null, [0]],
  },
  {
    character: '卫',
    definition: 'to guard, to protect, to defend',
    pinyin: ['wèi'],
    decomposition: '⿱乛一',
    radical: '乛',
    matches: [[0], null, [1]],
  },
  {
    character: '卬',
    definition: 'lofty; high; to raise; high-priced, expensive',
    pinyin: ['áng'],
    decomposition: '⿰匕卩',
    etymology: {
      type: 'ideographic',
      hint: 'A person kneeling 卩 before a person (a king) sitting 匕',
    },
    radical: '卩',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '卮',
    definition: 'measuring cup; goblet, vessel of wine',
    pinyin: ['zhī'],
    decomposition: '⿸？⿱一㔾',
    radical: '㔾',
    matches: [null, null, [1, 0], [1, 1], [1, 1]],
  },
  {
    character: '卯',
    definition: '4th terrestrial branch; period from 5-7 a.m.',
    pinyin: ['mǎo'],
    decomposition: '⿰？卩',
    radical: '卩',
    matches: [null, null, null, [1], [1]],
  },
  {
    character: '印',
    definition: 'print; mark; seal, stamp',
    pinyin: ['yìn'],
    decomposition: '⿰？卩',
    etymology: { type: 'ideographic', hint: 'A hand 爪 stamping a seal 卩' },
    radical: '卩',
    matches: [null, null, null, [1], [1]],
  },
  {
    character: '危',
    definition: 'dangerous, precarious; high',
    pinyin: ['wēi'],
    decomposition: '⿱厃㔾',
    etymology: {
      type: 'ideographic',
      hint: 'A person 㔾 at the edge of a cliff 厃; 厃 also provides the pronunciation',
    },
    radical: '㔾',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '即',
    definition: 'promptly, quickly, immediately',
    pinyin: ['jí'],
    decomposition: '⿰？卩',
    etymology: {
      type: 'ideographic',
      hint: 'A hungry person卩 kneeling over food 皀; compare 既',
    },
    radical: '卩',
    matches: [null, null, null, null, null, [1], [1]],
  },
  {
    character: '却',
    definition: 'still, but; decline; retreat',
    pinyin: ['què'],
    decomposition: '⿰去卩',
    etymology: {
      type: 'pictophonetic',
      phonetic: '去',
      semantic: '卩',
      hint: 'seal',
    },
    radical: '卩',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '卵',
    definition: 'egg, ovum, roe; ovary, testes; to spawn',
    pinyin: ['luǎn'],
    decomposition: '⿰？卩',
    etymology: { type: 'pictographic', hint: 'Two ovaries containing eggs' },
    radical: '卩',
    matches: [null, null, null, null, [1], [1], null],
  },
  {
    character: '卷',
    definition: 'book, scroll, volume; curled up; to curl, to roll',
    pinyin: ['juǎn'],
    decomposition: '⿱龹㔾',
    etymology: { type: 'ideographic', hint: 'A curled up scroll 㔾' },
    radical: '㔾',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '卸',
    definition: 'to unload; to lay down; to resign',
    pinyin: ['xiè'],
    decomposition: '⿰⿱午止卩',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卩',
      semantic: '止',
      hint: 'stop',
    },
    radical: '卩',
    matches: [[0, 0], [0, 0], [0, 0], [0, 1], [0, 1], [0, 1], [0, 1], [1], [1]],
  },
  {
    character: '卺',
    definition: 'nuptial wine cup',
    pinyin: ['jǐn'],
    decomposition: '⿱丞㔾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丞',
      semantic: '㔾',
      hint: 'seal',
    },
    radical: '㔾',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '卻',
    definition: 'still, but; decline; retreat',
    pinyin: ['què'],
    decomposition: '⿰谷卩',
    etymology: {
      type: 'pictophonetic',
      phonetic: '谷',
      semantic: '卩',
      hint: 'seal',
    },
    radical: '卩',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '卿',
    definition: 'noble; minister; thou (poetic)',
    pinyin: ['qīng'],
    decomposition: '⿴卯？',
    radical: '卩',
    matches: [[0], [0], [0], null, null, null, null, null, [0], [0]],
  },
  {
    character: '厂',
    definition: 'cliff; factory, workshop; building',
    pinyin: ['chǎng'],
    decomposition: '？',
    radical: '厂',
    matches: [null, null],
  },
  {
    character: '厃',
    definition: 'to look upward',
    pinyin: ['wěi'],
    decomposition: '⿱⺈厂',
    radical: '厂',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '厄',
    definition: 'adversity, difficulty, distress',
    pinyin: ['è'],
    decomposition: '⿸厂㔾',
    etymology: {
      type: 'ideographic',
      hint: 'A person 㔾 being crushed under pressure 厂',
    },
    radical: '厂',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '厅',
    definition: 'hall, central room',
    pinyin: ['tīng'],
    decomposition: '⿸厂丁',
    etymology: {
      type: 'pictophonetic',
      hint: 'spacious',
      semantic: '广',
      phonetic: '丁',
    },
    radical: '厂',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '历',
    definition: 'history; calendar',
    pinyin: ['lì'],
    decomposition: '⿸厂力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '力',
      semantic: '厤',
      hint: 'calendar',
    },
    radical: '厂',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '厉',
    definition: 'whetstone; to grind, to sharpen, to whet',
    pinyin: ['lì'],
    decomposition: '⿸厂万',
    radical: '厂',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '压',
    definition: 'press; oppress; crush; pressure',
    pinyin: ['yā'],
    decomposition: '⿸厂⿰土丶',
    etymology: {
      type: 'ideographic',
      hint: 'Soil 土 crushed under pressure 厂',
    },
    radical: '厂',
    matches: [[0], [0], [1, 0], [1, 0], [1, 0], [1, 1]],
  },
  {
    character: '厌',
    definition: 'to dislike, to detest; to reject; to satiate',
    pinyin: ['yàn'],
    decomposition: '⿸厂犬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '犬',
      semantic: '厂',
      hint: 'cliff',
    },
    radical: '厂',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '厍',
    definition: 'surname',
    pinyin: ['shè'],
    decomposition: '⿸厂车',
    etymology: { type: 'pictophonetic', phonetic: '车' },
    radical: '厂',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '厓',
    definition: 'precipice; river bank, shore; surname',
    pinyin: ['yá'],
    decomposition: '⿸厂⿱土土',
    etymology: { type: 'ideographic', hint: 'A cliff 厂 formed of earth 土' },
    radical: '厂',
    matches: [[0], [0], [1, 0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '厕',
    definition: 'toilet, washroom; to mingle',
    pinyin: ['cè'],
    decomposition: '⿸厂则',
    etymology: {
      type: 'pictophonetic',
      phonetic: '则',
      semantic: '厂',
      hint: 'building',
    },
    radical: '厂',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '厗',
    definition: 'stone, mineral; antimony',
    pinyin: ['tí'],
    decomposition: '⿸厂辛',
    etymology: { type: 'ideographic', hint: 'A bitter 辛 mineral 厂' },
    radical: '厂',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '厘',
    definition: 'one thousandth',
    pinyin: ['lí'],
    decomposition: '⿸厂里',
    etymology: {
      type: 'pictophonetic',
      phonetic: '里',
      semantic: '厂',
      hint: 'workshop',
    },
    radical: '厂',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '厚',
    definition: 'generous; substantial; deep (as a friendship)',
    pinyin: ['hòu'],
    decomposition: '⿸⿸厂日子',
    etymology: {
      type: 'ideographic',
      hint: 'Sunlight 日 and children 子 in a building 厂',
    },
    radical: '厂',
    matches: [[0, 0], [0, 0], [0, 1], [0, 1], [0, 1], [0, 1], [1], [1], [1]],
  },
  {
    character: '厝',
    definition: 'to bury; grave, tombstone; to cut, to engrave',
    pinyin: ['cuò'],
    decomposition: '⿸厂昔',
    etymology: {
      type: 'ideographic',
      hint: 'A building 厂 containing the past 昔',
    },
    radical: '厂',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '原',
    definition: 'source, origin, beginning',
    pinyin: ['yuán'],
    decomposition: '⿸厂泉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '泉',
      semantic: '厂',
      hint: 'cliff',
    },
    radical: '厂',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '厢',
    definition: 'side-room, wing; theatre box',
    pinyin: ['xiāng'],
    decomposition: '⿸厂相',
    etymology: {
      type: 'pictophonetic',
      phonetic: '相',
      semantic: '厂',
      hint: 'building',
    },
    radical: '厂',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '厣',
    definition: 'shell',
    pinyin: ['yǎn'],
    decomposition: '⿸厂⿱犬甲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '犬',
      semantic: '甲',
      hint: 'armor',
    },
    radical: '厂',
    matches: [
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '厤',
    definition: 'to calculate; the calendar',
    pinyin: ['lì'],
    decomposition: '⿸厂秝',
    etymology: { type: 'pictophonetic', phonetic: '秝' },
    radical: '厂',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '厥',
    definition: 'personal pronoun; he, she, it',
    pinyin: ['jué'],
    decomposition: '⿸厂欮',
    etymology: { type: 'pictophonetic', phonetic: '欮' },
    radical: '厂',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '厦',
    definition: 'large building; mansion',
    pinyin: ['shà'],
    decomposition: '⿸厂夏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夏',
      semantic: '厂',
      hint: 'building',
    },
    radical: '厂',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '厨',
    definition: 'kitchen; closet, cupboard',
    pinyin: ['chú'],
    decomposition: '⿸厂⿰豆寸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豆',
      semantic: '厂',
      hint: 'building',
    },
    radical: '厂',
    matches: [
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '厩',
    definition: 'stable; barnyard',
    pinyin: ['jiù'],
    decomposition: '⿸厂既',
    etymology: {
      type: 'pictophonetic',
      phonetic: '既',
      semantic: '厂',
      hint: 'building',
    },
    radical: '厂',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '厪',
    definition: 'hut; diligent; careful',
    pinyin: ['jǐn'],
    decomposition: '⿸厂堇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堇',
      semantic: '厂',
      hint: 'building',
    },
    radical: '厂',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '厭',
    definition: 'to dislike, to detest; to reject; to satiate',
    pinyin: ['yàn'],
    decomposition: '⿸厂猒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '猒',
      semantic: '厂',
      hint: 'cliff',
    },
    radical: '厂',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '厮',
    definition: 'servant; to cause a disturbance',
    pinyin: ['sī'],
    decomposition: '⿸厂斯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斯',
      semantic: '厂',
      hint: 'building',
    },
    radical: '厂',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '厲',
    definition: 'whetstone; to grind, to sharpen, to whet',
    pinyin: ['lì'],
    decomposition: '⿸厂萬',
    radical: '厂',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '厶',
    definition: 'private, secret',
    pinyin: ['sī'],
    decomposition: '？',
    etymology: { type: 'pictographic', hint: 'A silk cocoon' },
    radical: '厶',
    matches: [null, null],
  },
  {
    character: '厷',
    definition: 'forearm, upper arm; round',
    pinyin: ['gōng'],
    decomposition: '⿸？厶',
    etymology: {
      type: 'pictographic',
      hint: 'A bent arm; flexing the muscles',
    },
    radical: '厶',
    matches: [null, null, [1], [1]],
  },
  {
    character: '厹',
    definition: 'spear; the name of a tribe',
    pinyin: ['róu'],
    decomposition: '⿱九厶',
    radical: '厶',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '去',
    definition: 'to go away, to leave, to depart',
    pinyin: ['qù'],
    decomposition: '⿱土厶',
    radical: '厶',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '厽',
    pinyin: ['lěi'],
    decomposition: '⿱厶⿰厶厶',
    radical: '厶',
    matches: [[0], [0], [1, 0], [1, 0], [1, 1], [1, 1]],
  },
  {
    character: '县',
    definition: 'county, district, subdivision',
    pinyin: ['xiàn'],
    decomposition: '⿱且厶',
    radical: '厶',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '叀',
    definition: 'spindle; to hang',
    pinyin: ['zhuān'],
    decomposition: '⿱？厶',
    radical: '厶',
    matches: [null, null, null, null, null, null, [1], [1]],
  },
  {
    character: '叁',
    definition: "three (bankers' anti-fraud numeral)",
    pinyin: ['sān'],
    decomposition: '⿱⿱厶大三',
    etymology: {
      type: 'ideographic',
      hint: 'Three 三 with accents to prevent forgery',
    },
    radical: '厶',
    matches: [[0, 0], [0, 0], [0, 1], [0, 1], [0, 1], [1], [1], [1]],
  },
  {
    character: '参',
    definition: 'to take part in, to intervene; ginseng',
    pinyin: ['cān'],
    decomposition: '⿱⿱厶大彡',
    etymology: { type: 'pictophonetic', phonetic: '彡' },
    radical: '厶',
    matches: [[0, 0], [0, 0], [0, 1], [0, 1], [0, 1], [1], [1], [1]],
  },
  {
    character: '參',
    definition: 'to take part in, to intervene; ginseng',
    pinyin: ['cān'],
    decomposition: '⿳厽人彡',
    etymology: { type: 'pictophonetic', phonetic: '彡' },
    radical: '厶',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [2], [2], [2]],
  },
  {
    character: '又',
    definition: 'and, also, again, in addition',
    pinyin: ['yòu'],
    decomposition: '？',
    etymology: {
      type: 'pictographic',
      hint: 'A right hand, representing a pair; compare 左',
    },
    radical: '又',
    matches: [null, null],
  },
  {
    character: '叉',
    definition: 'fork; prong; cross, intersect',
    pinyin: ['chā'],
    decomposition: '⿴又丶',
    etymology: { type: 'ideographic', hint: 'A hand 又 grasping an object 丶' },
    radical: '又',
    matches: [[0], [0], [1]],
  },
  {
    character: '及',
    definition: 'to extend; to reach; and; in time',
    pinyin: ['jí'],
    decomposition: '⿻？又',
    radical: '又',
    matches: [null, [1], [1]],
  },
  {
    character: '友',
    definition: 'friend, companion; fraternity',
    pinyin: ['yǒu'],
    decomposition: '⿸？又',
    etymology: {
      type: 'ideographic',
      hint: 'Two hands 又 joined, representing friendship; 又 also provides the pronunciation',
    },
    radical: '又',
    matches: [null, null, [1], [1]],
  },
  {
    character: '双',
    definition:
      'pair, couple; both; measure word for things that come in pairs',
    pinyin: ['shuāng'],
    decomposition: '⿰又又',
    etymology: { type: 'ideographic', hint: 'Two hands 又 side-by-side' },
    radical: '又',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '反',
    definition: 'reverse, opposite; contrary, anti-',
    pinyin: ['fǎn'],
    decomposition: '⿸厂又',
    etymology: {
      type: 'ideographic',
      hint: 'A hand 又 held up against a cliff 厂',
    },
    radical: '又',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '发',
    definition: 'to issue, to dispatch, to send out; hair',
    pinyin: ['fā'],
    decomposition: '⿸？又',
    radical: '又',
    matches: [null, null, [1], [1], null],
  },
  {
    character: '叒',
    definition: 'obedient; united',
    pinyin: ['ruò'],
    decomposition: '⿱又⿰又又',
    etymology: {
      type: 'ideographic',
      hint: 'Three hands 又 joined, representing unity',
    },
    radical: '又',
    matches: [[0], [0], [1, 0], [1, 0], [1, 1], [1, 1]],
  },
  {
    character: '叔',
    definition: "uncle; father's younger brother",
    pinyin: ['shū'],
    decomposition: '⿰⿱上小又',
    etymology: { type: 'ideographic', hint: 'The smaller 小 brother' },
    radical: '又',
    matches: [[0, 0], [0, 0], [0, 0], [0, 1], [0, 1], [0, 1], [1], [1]],
  },
  {
    character: '叕',
    definition: 'to connect',
    pinyin: ['zhuó'],
    decomposition: '⿱⿰又又⿰又又',
    etymology: { type: 'ideographic', hint: 'Many hooks 又 forming a net' },
    radical: '又',
    matches: [
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '取',
    definition: 'to take, to receive, to obtain; to select',
    pinyin: ['qǔ'],
    decomposition: '⿰耳又',
    etymology: {
      type: 'ideographic',
      hint: 'A hand 又 taking the ear 耳 of a fallen enemy',
    },
    radical: '又',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '受',
    definition: 'to receive, to get, to accept; to bear',
    pinyin: ['shòu'],
    decomposition: '⿳爫冖又',
    etymology: {
      type: 'ideographic',
      hint: 'Something 冖 passed from one hand 爫 to another 又',
    },
    radical: '又',
    matches: [[0], [0], [0], [0], [1], [1], [2], [2]],
  },
  {
    character: '变',
    definition: 'to change, to transform, to alter; rebel',
    pinyin: ['biàn'],
    decomposition: '⿱亦又',
    radical: '又',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '叙',
    definition: 'to express, to state; to relate, to narrate',
    pinyin: ['xù'],
    decomposition: '⿰余又',
    etymology: {
      type: 'pictophonetic',
      phonetic: '余',
      semantic: '又',
      hint: 'again',
    },
    radical: '又',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '叚',
    definition: 'false',
    pinyin: ['jiǎ'],
    decomposition: '⿰？⿱？又',
    radical: '又',
    matches: [null, null, null, null, null, null, null, [1, 1], [1, 1]],
  },
  {
    character: '叛',
    definition: 'rebel; rebellion; rebellious',
    pinyin: ['pàn'],
    decomposition: '⿰半反',
    etymology: {
      type: 'pictophonetic',
      phonetic: '半',
      semantic: '反',
      hint: 'contrary',
    },
    radical: '又',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '叟',
    definition: 'old man; elder',
    pinyin: ['sǒu'],
    decomposition: '⿱⿻臼丨又',
    etymology: {
      type: 'ideographic',
      hint: 'A hand 又 holding up a candle, representing failing vision',
    },
    radical: '又',
    matches: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 1], [1], [1]],
  },
  {
    character: '叠',
    definition: 'pile; layer; to fold up; to repeat, to duplicate',
    pinyin: ['dié'],
    decomposition: '⿱叒冝',
    etymology: {
      type: 'ideographic',
      hint: 'Clothes 叒 stacked on top of a drawer 冝',
    },
    radical: '又',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '叢',
    definition: 'bush, shrub; thicket; collection',
    pinyin: ['cóng'],
    decomposition: '⿱丵⿸耳又',
    etymology: { type: 'pictophonetic', semantic: '丵', hint: 'thick' },
    radical: '又',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '口',
    definition: 'mouth; entrance, gate, opening',
    pinyin: ['kǒu'],
    decomposition: '⿱冂一',
    etymology: { type: 'pictographic', hint: 'An open mouth' },
    radical: '口',
    matches: [[0], [0], [1]],
  },
  {
    character: '古',
    definition: 'old, classic, ancient',
    pinyin: ['gǔ'],
    decomposition: '⿱十口',
    etymology: {
      type: 'ideographic',
      hint: 'Words passing through ten 十 mouths 口',
    },
    radical: '口',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '句',
    definition: 'sentence, clause, phrase, paragraph; stanza',
    pinyin: ['jù', 'gōu'],
    decomposition: '⿹勹口',
    etymology: { type: 'ideographic', hint: 'A phrase 勹 from the mouth 口' },
    radical: '口',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '另',
    definition: 'another; separate, other',
    pinyin: ['lìng'],
    decomposition: '⿱口力',
    radical: '口',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '叨',
    definition: 'talkative; grumbling',
    pinyin: ['dāo'],
    decomposition: '⿰口刀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '刀',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '叩',
    definition: 'to ask; to bow, to kowtow; to knock',
    pinyin: ['kòu'],
    decomposition: '⿰口卩',
    etymology: {
      type: 'pictophonetic',
      phonetic: '口',
      semantic: '卩',
      hint: 'kneel',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '只',
    definition: 'only, merely, just',
    pinyin: ['zhī'],
    decomposition: '⿱口八',
    etymology: {
      type: 'ideographic',
      hint: 'Simple words 八 coming from the mouth 口',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '叫',
    definition: 'cry, shout; to call, to greet, to hail',
    pinyin: ['jiào'],
    decomposition: '⿰口丩',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丩',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '召',
    definition: 'imperial decree; to summon, to call, to beckon',
    pinyin: ['zhào'],
    decomposition: '⿱刀口',
    etymology: {
      type: 'pictophonetic',
      phonetic: '刀',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '叭',
    definition: 'trumpet',
    pinyin: ['bā'],
    decomposition: '⿰口八',
    etymology: {
      type: 'pictophonetic',
      phonetic: '八',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '叮',
    definition: 'to persistently exhort or urge; sting (as of an insect)',
    pinyin: ['dīng'],
    decomposition: '⿰口丁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丁',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '可',
    definition: 'may, can, -able; possibly',
    pinyin: ['kě'],
    decomposition: '⿻丁口',
    etymology: {
      type: 'pictophonetic',
      semantic: '丁',
      hint: 'vigorous',
      phonetic: '口',
    },
    radical: '口',
    matches: [[0], [1], [1], [1], [0]],
  },
  {
    character: '台',
    definition: 'platform; unit; term of address',
    pinyin: ['tái'],
    decomposition: '⿱厶口',
    radical: '口',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '叱',
    definition: 'to scold, to upbraid; to shout at',
    pinyin: ['chì'],
    decomposition: '⿰口匕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匕',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '史',
    definition: 'history, chronicle, annals',
    pinyin: ['shǐ'],
    decomposition: '⿻口乂',
    etymology: {
      type: 'ideographic',
      hint: 'A hand 乂 using a pen to record a history',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '右',
    definition: 'right; right-wing',
    pinyin: ['yòu'],
    decomposition: '⿸？口',
    radical: '口',
    matches: [null, null, [1], [1], [1]],
  },
  {
    character: '叵',
    definition: 'cannot; to be unable; improbable; thereupon',
    pinyin: ['pǒ'],
    decomposition: '⿷匚口',
    radical: '口',
    matches: [[0], [1], [1], [1], [0]],
  },
  {
    character: '叶',
    definition: 'leaf, page; surname',
    pinyin: ['yè'],
    decomposition: '⿰口十',
    radical: '口',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '号',
    definition: 'mark, sign; symbol; number; to call, to cry, to roar',
    pinyin: ['hào'],
    decomposition: '⿱口丂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丂',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '司',
    definition: 'to take charge of, to control, to manage; officer',
    pinyin: ['sī'],
    decomposition: '⿹？口',
    etymology: {
      type: 'ideographic',
      hint: 'A person speaking orders 口 and raising their arm',
    },
    radical: '口',
    matches: [null, null, [1], [1], [1]],
  },
  {
    character: '叹',
    definition: 'to sigh, to admire',
    pinyin: ['tàn'],
    decomposition: '⿰口又',
    etymology: { type: 'ideographic', hint: 'A mouth 口 exhaling 又' },
    radical: '口',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '叻',
    definition: 'used in transliterations',
    pinyin: ['lè'],
    decomposition: '⿰口力',
    radical: '口',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '叼',
    definition: 'to hold in the mouth',
    pinyin: ['diāo'],
    decomposition: '⿰口刁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '刁',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '叽',
    definition: 'to grumble; to sigh',
    pinyin: ['jī'],
    decomposition: '⿰口几',
    etymology: {
      type: 'pictophonetic',
      phonetic: '几',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '吁',
    definition: 'alas; to sigh',
    pinyin: ['xū'],
    decomposition: '⿰口于',
    etymology: {
      type: 'pictophonetic',
      phonetic: '于',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '吂',
    pinyin: ['máng'],
    decomposition: '⿱亡口',
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '吃',
    definition: 'to eat; to drink; to suffer, to endure, to bear',
    pinyin: ['chī'],
    decomposition: '⿰口乞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乞',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '各',
    definition: 'individual; each, every; all',
    pinyin: ['gè'],
    decomposition: '⿱夂口',
    etymology: { type: 'ideographic', hint: 'Walking 夂 and talking 口' },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '吆',
    definition: 'to cry, to bawl; to yell, to shout',
    pinyin: ['yāo'],
    decomposition: '⿰口幺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '幺',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '合',
    definition: 'to combine, to join, to unite; to gather',
    pinyin: ['hé'],
    decomposition: '⿱亼口',
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '吉',
    definition: 'lucky, propitious, good',
    pinyin: ['jí'],
    decomposition: '⿱士口',
    etymology: { type: 'ideographic', hint: 'The words 口 of a scholar 士' },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '吊',
    definition: 'to condole, to mourn, to pity; to hang',
    pinyin: ['diào'],
    decomposition: '⿱口巾',
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '吋',
    definition:
      'English inch (unlike 寸, which could be the English or the Chinese inch)',
    pinyin: ['cùn'],
    decomposition: '⿰口寸',
    etymology: {
      type: 'ideographic',
      hint: 'A foreign 口 inch 寸; 寸 also provides the pronunciation',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '同',
    definition: 'same, similar; together with, alike',
    pinyin: ['tóng'],
    decomposition: '⿵凡口',
    etymology: { type: 'ideographic', hint: 'Sharing a common 凡 tongue 口' },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '名',
    definition: 'name; position, rank, title',
    pinyin: ['míng'],
    decomposition: '⿸夕口',
    etymology: {
      type: 'ideographic',
      hint: 'A name called out 口 to hail someone at night 夕',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '后',
    definition: 'after; behind, rear; descendants',
    pinyin: ['hòu'],
    decomposition: '⿸？口',
    radical: '口',
    matches: [null, null, null, [1], [1], [1]],
  },
  {
    character: '吏',
    definition: 'government official, magistrate',
    pinyin: ['lì'],
    decomposition: '⿻丈口',
    radical: '口',
    matches: [[0], [1], [1], [1], [0], [0]],
  },
  {
    character: '吐',
    definition: 'to vomit, to spew out, to cough up; to say',
    pinyin: ['tǔ'],
    decomposition: '⿰口土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '土',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '向',
    definition: 'towards; direction, trend',
    pinyin: ['xiàng'],
    decomposition: '⿵？口',
    radical: '口',
    matches: [null, null, null, [1], [1], [1]],
  },
  {
    character: '吒',
    definition: 'to scold; to shout, to roar, to bellow',
    pinyin: ['zhà'],
    decomposition: '⿰口乇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乇',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '吓',
    definition: 'to scare, to frighten; to threaten, to intimidate',
    pinyin: ['xià'],
    decomposition: '⿰口下',
    etymology: {
      type: 'pictophonetic',
      phonetic: '下',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '吕',
    definition: 'a musical note; surname',
    pinyin: ['lǚ'],
    decomposition: '⿱口口',
    etymology: { type: 'ideographic', hint: 'Two mouths 口 in harmony' },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '吖',
    definition: 'used in transliterations',
    pinyin: ['yā'],
    decomposition: '⿰口丫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丫',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '吗',
    definition: 'final interrogative particle',
    pinyin: ['ma'],
    decomposition: '⿰口马',
    etymology: {
      type: 'pictophonetic',
      phonetic: '马',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '君',
    definition: 'sovereign, ruler, prince, monarch, chief',
    pinyin: ['jūn'],
    decomposition: '⿸尹口',
    etymology: { type: 'ideographic', hint: 'A leader 尹 giving orders 口' },
    radical: '口',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '吝',
    definition: 'stingy, miserly; parsimonious',
    pinyin: ['lìn'],
    decomposition: '⿱文口',
    radical: '口',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '吞',
    definition: 'to absorb, to annex; to engulf; to swallow',
    pinyin: ['tūn'],
    decomposition: '⿱天口',
    etymology: {
      type: 'pictophonetic',
      phonetic: '天',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '吟',
    definition: 'to sing, to hum; to recite; a type of poetry',
    pinyin: ['yín'],
    decomposition: '⿰口今',
    etymology: {
      type: 'pictophonetic',
      phonetic: '今',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '吠',
    definition: 'to bark',
    pinyin: ['fèi'],
    decomposition: '⿰口犬',
    etymology: {
      type: 'ideographic',
      hint: 'The sound a dog 犬 makes with their mouth 口',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '吡',
    definition: 'to blame',
    pinyin: ['bǐ'],
    decomposition: '⿰口比',
    etymology: {
      type: 'pictophonetic',
      phonetic: '比',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '吣',
    definition: 'to vomit',
    pinyin: ['qìn'],
    decomposition: '⿰口心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '心',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '否',
    definition: 'no, not, un-; final particle',
    pinyin: ['fǒu'],
    decomposition: '⿱不口',
    etymology: {
      type: 'pictophonetic',
      phonetic: '口',
      semantic: '不',
      hint: 'no',
    },
    radical: '口',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '吧',
    definition: 'emphatic final particle',
    pinyin: ['bā'],
    decomposition: '⿰口巴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巴',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '吨',
    definition: 'a metric ton',
    pinyin: ['dūn'],
    decomposition: '⿰口屯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屯',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '吩',
    definition: 'to order, to command; to instruct',
    pinyin: ['fēn'],
    decomposition: '⿰口分',
    etymology: {
      type: 'pictophonetic',
      phonetic: '分',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '含',
    definition: 'to hold in the mouth; to contain; to cherish',
    pinyin: ['hán'],
    decomposition: '⿱今口',
    etymology: {
      type: 'pictophonetic',
      phonetic: '今',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '听',
    definition: 'to hear, to listen; to understand; to obey',
    pinyin: ['tīng'],
    decomposition: '⿰口斤',
    etymology: { type: 'ideographic', hint: 'Words 口 reaching an ear 斤' },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '吭',
    definition: 'throat',
    pinyin: ['kēng'],
    decomposition: '⿰口亢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亢',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '吮',
    definition: 'to suck, to sip, to lick',
    pinyin: ['shǔn'],
    decomposition: '⿰口允',
    etymology: {
      type: 'pictophonetic',
      phonetic: '允',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '启',
    definition: 'to open; to begin, to commence; to explain',
    pinyin: ['qǐ'],
    decomposition: '⿸户口',
    etymology: { type: 'ideographic', hint: 'A door 户 being opened 口' },
    radical: '口',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '吱',
    definition: 'to chirp; to hiss; to squeak',
    pinyin: ['zhī'],
    decomposition: '⿰口支',
    etymology: {
      type: 'pictophonetic',
      phonetic: '支',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '吲',
    definition: 'to smile at; to sneer at',
    pinyin: ['yǐn'],
    decomposition: '⿰口引',
    etymology: {
      type: 'ideographic',
      hint: 'To stretch 引 the mouth 口; 引 also provides the pronunciation',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '吳',
    definition: 'one of several warring states; surname',
    pinyin: ['wú'],
    decomposition: '⿱口⿻？大',
    radical: '口',
    matches: [[0], [0], [0], null, [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '吴',
    definition: 'one of several warring states; surname',
    pinyin: ['wú'],
    decomposition: '⿱口天',
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '吵',
    definition: 'to argue, to dispute; to annoy, to disturb',
    pinyin: ['chǎo'],
    decomposition: '⿰口少',
    etymology: {
      type: 'pictophonetic',
      phonetic: '少',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '吸',
    definition: 'to inhale, to suck in; to absorb; to attract',
    pinyin: ['xī'],
    decomposition: '⿰口及',
    etymology: {
      type: 'pictophonetic',
      phonetic: '及',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '吹',
    definition: 'to blow, to puff; to brag, to boast',
    pinyin: ['chuī'],
    decomposition: '⿰口欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '欠',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '吻',
    definition: 'to kiss; lips; coinciding',
    pinyin: ['wěn'],
    decomposition: '⿰口勿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '勿',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '吼',
    definition: 'to roar, to shout; to bark, to howl',
    pinyin: ['hǒu'],
    decomposition: '⿰口孔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孔',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '吾',
    definition: 'I, my, our; to resist, to impede',
    pinyin: ['wú'],
    decomposition: '⿱五口',
    etymology: {
      type: 'pictophonetic',
      phonetic: '五',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '呀',
    definition: 'particle used to express surprise',
    pinyin: ['ya'],
    decomposition: '⿰口牙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '牙',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '呂',
    definition: 'a musical note; surname',
    pinyin: ['lǚ'],
    decomposition: '⿳口丿口',
    radical: '口',
    matches: [[0], [0], [0], [1], [2], [2], [2]],
  },
  {
    character: '呃',
    definition: 'belch; hiccup',
    pinyin: ['è'],
    decomposition: '⿰口厄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厄',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '呆',
    definition: 'dull, simple, stupid',
    pinyin: ['dāi'],
    decomposition: '⿱口木',
    etymology: { type: 'ideographic', hint: 'One with wooden 木 speech 口' },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '呈',
    definition: 'to petition, to submit; to appear, to show',
    pinyin: ['chéng'],
    decomposition: '⿱口王',
    etymology: { type: 'ideographic', hint: 'To speak 口 before a king 王' },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '告',
    definition: 'to tell, to inform, to announce; to accuse',
    pinyin: ['gào'],
    decomposition: '⿱牛口',
    etymology: {
      type: 'ideographic',
      hint: 'To speak 口 with the force of an ox 牛',
    },
    radical: '口',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '呋',
    definition: 'used in transliterations',
    pinyin: ['fū'],
    decomposition: '⿰口夫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夫',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '呐',
    definition: "to raise one's voice; to yell, to shout; to stammer",
    pinyin: ['nà'],
    decomposition: '⿰口内',
    etymology: {
      type: 'pictophonetic',
      phonetic: '内',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '呑',
    definition: 'to swallow; to absorb',
    pinyin: ['tūn'],
    decomposition: '⿱夭口',
    etymology: { type: 'pictophonetic', semantic: '口', hint: 'mouth' },
    radical: '口',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '呒',
    definition: 'unclear; an expletive',
    pinyin: ['fǔ'],
    decomposition: '⿰口无',
    etymology: {
      type: 'pictophonetic',
      phonetic: '无',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '呓',
    definition: "to talk in one's sleep; somniloquy",
    pinyin: ['yì'],
    decomposition: '⿰口艺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '艺',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '呔',
    definition: 'tire; neck-tie',
    pinyin: ['dāi'],
    decomposition: '⿰口太',
    etymology: { type: 'pictophonetic', phonetic: '太' },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '呕',
    definition: 'to vomit; to annoy, to enrage',
    pinyin: ['ǒu'],
    decomposition: '⿰口区',
    etymology: {
      type: 'pictophonetic',
      phonetic: '区',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '呖',
    definition: 'the sound of something cracking or splitting',
    pinyin: ['lì'],
    decomposition: '⿰口历',
    etymology: {
      type: 'pictophonetic',
      phonetic: '历',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '呗',
    definition: 'final particle of an assertion',
    pinyin: ['bei'],
    decomposition: '⿰口贝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贝',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '员',
    definition: 'employee; member; personnel, staff',
    pinyin: ['yuán'],
    decomposition: '⿱口贝',
    etymology: { type: 'pictophonetic', semantic: '贝', hint: 'money' },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '呙',
    definition: 'to chat, to gossip, to jaw, to talk; mouth',
    pinyin: ['guō'],
    decomposition: '⿱口内',
    etymology: { type: 'ideographic', hint: 'Words 内 coming from a mouth 口' },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '呛',
    definition:
      'choking, as by smoke; something that irritates the nose or throat',
    pinyin: ['qiāng'],
    decomposition: '⿰口仓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '仓',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '呜',
    definition: 'the sound of someone crying or sobbing',
    pinyin: ['wū'],
    decomposition: '⿰口乌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乌',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '呢',
    definition: 'wool; interrogative or emphatic final particle',
    pinyin: ['né', 'ne'],
    decomposition: '⿰口尼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尼',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '呣',
    definition: 'interjection or exclamation indicating a question',
    pinyin: ['ḿ'],
    decomposition: '⿰口母',
    etymology: {
      type: 'pictophonetic',
      phonetic: '母',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '呤',
    definition: 'purine',
    pinyin: ['lìng'],
    decomposition: '⿰口令',
    etymology: {
      type: 'pictophonetic',
      phonetic: '令',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '呦',
    definition: 'the sound of a deer bleating',
    pinyin: ['yōu'],
    decomposition: '⿰口幼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '幼',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '周',
    definition: 'Zhou dynasty; circumference',
    pinyin: ['zhōu'],
    decomposition: '⿵冂⿱土口',
    etymology: {
      type: 'ideographic',
      hint: 'Border 冂 around land 土 with a well 口',
    },
    radical: '口',
    matches: [[0], [0], [1, 0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '呫',
    definition: 'to taste, to sip, to lick; to whisper; petty',
    pinyin: ['tiè'],
    decomposition: '⿰口占',
    etymology: {
      type: 'ideographic',
      hint: "To divine 占 with one's tongue 口",
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '呱',
    definition: 'to wail, to cry; to swear at',
    pinyin: ['gū'],
    decomposition: '⿰口瓜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '瓜',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '呲',
    definition: "to grimace; to bare one's teeth",
    pinyin: ['cī'],
    decomposition: '⿰口此',
    etymology: {
      type: 'pictophonetic',
      phonetic: '此',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '味',
    definition: 'taste; smell, odor; delicacy',
    pinyin: ['wèi'],
    decomposition: '⿰口未',
    etymology: {
      type: 'pictophonetic',
      phonetic: '未',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '呵',
    definition:
      'to scold; to yawn; the sound of someone laughing (when repeated)',
    pinyin: ['hē'],
    decomposition: '⿰口可',
    etymology: {
      type: 'pictophonetic',
      phonetic: '可',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '呶',
    definition: 'talkative; clamour, hubbub',
    pinyin: ['náo'],
    decomposition: '⿰口奴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奴',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '呷',
    definition: 'to swallow, to suck, to drink',
    pinyin: ['gā'],
    decomposition: '⿰口甲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甲',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '呸',
    definition: 'to spit at',
    pinyin: ['pēi'],
    decomposition: '⿰口丕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丕',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '呻',
    definition: 'to moan, to groan; to chant',
    pinyin: ['shēn'],
    decomposition: '⿰口申',
    etymology: {
      type: 'pictophonetic',
      phonetic: '申',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '呼',
    definition: 'to breathe, to exhale, to sigh; to call, to shout',
    pinyin: ['hū'],
    decomposition: '⿰口乎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乎',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '命',
    definition: 'life; destiny, fate, luck; an order, instruction',
    pinyin: ['mìng'],
    decomposition: '⿹令口',
    etymology: { type: 'ideographic', hint: 'An order 令 given by mouth 口' },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [0], [0]],
  },
  {
    character: '咀',
    definition: 'to suck; to chew',
    pinyin: ['jǔ'],
    decomposition: '⿰口且',
    etymology: {
      type: 'pictophonetic',
      phonetic: '且',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '咂',
    definition: 'to suck, to smack the lips',
    pinyin: ['zā'],
    decomposition: '⿰口匝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匝',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '咄',
    definition: 'a cry of anger',
    pinyin: ['duō'],
    decomposition: '⿰口出',
    etymology: {
      type: 'pictophonetic',
      phonetic: '出',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '咅',
    definition: 'to spit out',
    pinyin: ['pǒu'],
    decomposition: '⿱立口',
    radical: '口',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '咆',
    definition: 'to roar',
    pinyin: ['páo'],
    decomposition: '⿰口包',
    etymology: {
      type: 'pictophonetic',
      phonetic: '包',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '咋',
    definition: 'question-forming particle: why? what? how?; to bite; loud',
    pinyin: ['zǎ'],
    decomposition: '⿰口乍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乍',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '和',
    definition: 'harmony, peace; calm, peaceful',
    pinyin: ['hé'],
    decomposition: '⿰禾口',
    etymology: {
      type: 'pictophonetic',
      phonetic: '禾',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '咎',
    definition: 'fault, defect; error, mistake',
    pinyin: ['jiù'],
    decomposition: '⿱处口',
    etymology: {
      type: 'pictophonetic',
      phonetic: '处',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '咏',
    definition: 'to sing, to hum, to chant',
    pinyin: ['yǒng'],
    decomposition: '⿰口永',
    etymology: {
      type: 'pictophonetic',
      phonetic: '永',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '咐',
    definition: 'to instruct; to order',
    pinyin: ['fù'],
    decomposition: '⿰口付',
    etymology: {
      type: 'pictophonetic',
      phonetic: '付',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '咑',
    definition: 'trumpet',
    pinyin: ['dā'],
    decomposition: '⿰口打',
    etymology: {
      type: 'pictophonetic',
      phonetic: '打',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '咒',
    definition: 'to curse; to damn; incantation',
    pinyin: ['zhòu'],
    decomposition: '⿱⿰口口几',
    radical: '口',
    matches: [[0, 0], [0, 0], [0, 0], [0, 1], [0, 1], [0, 1], [1], [1]],
  },
  {
    character: '咔',
    definition: 'used in transliterations',
    pinyin: ['kā'],
    decomposition: '⿰口卡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卡',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '咕',
    definition: 'mumble, mutter, murmur; rumble',
    pinyin: ['gū'],
    decomposition: '⿰口古',
    etymology: {
      type: 'pictophonetic',
      phonetic: '古',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '咖',
    definition: 'coffee; used in transliterations',
    pinyin: ['kā'],
    decomposition: '⿰口加',
    etymology: {
      type: 'pictophonetic',
      phonetic: '加',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '咙',
    definition: 'throat',
    pinyin: ['lóng'],
    decomposition: '⿰口龙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龙',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '咚',
    definition: 'onomatopoetic, a thumping sound',
    pinyin: ['dōng'],
    decomposition: '⿰口冬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冬',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '咛',
    definition: 'to enjoin, to instruct; to charge',
    pinyin: ['níng'],
    decomposition: '⿰口宁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宁',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '咝',
    definition: 'onomatopoetic, a hissing sound',
    pinyin: ['sī'],
    decomposition: '⿰口丝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丝',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '咠',
    definition: 'to whisper, to slander, to blame',
    pinyin: ['qì'],
    decomposition: '⿱口耳',
    etymology: {
      type: 'ideographic',
      hint: "To whisper 口 in someone's ear 耳",
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '咢',
    definition: 'onomatopoetic, a drumming sound',
    pinyin: ['è'],
    decomposition: '⿱⿰口口亏',
    radical: '口',
    matches: [[0, 0], [0, 0], [0, 0], [0, 1], [0, 1], [0, 1], [1], [1], [1]],
  },
  {
    character: '咣',
    definition: 'onomatopoetic, a crash or bang',
    pinyin: ['guāng'],
    decomposition: '⿰口光',
    etymology: {
      type: 'pictophonetic',
      phonetic: '光',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '咤',
    definition: 'to scold; to shout, to roar, to bellow',
    pinyin: ['zhà'],
    decomposition: '⿰口宅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宅',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '咥',
    definition: 'the sound of a cat; to laugh; to bite',
    pinyin: ['xì'],
    decomposition: '⿰口至',
    etymology: {
      type: 'pictophonetic',
      phonetic: '至',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '咦',
    definition: 'exclamation of surprise',
    pinyin: ['yí'],
    decomposition: '⿰口夷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夷',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '咧',
    definition: 'to grimace, to grin',
    pinyin: ['liě'],
    decomposition: '⿰口列',
    etymology: {
      type: 'pictophonetic',
      phonetic: '列',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '咨',
    definition: 'to inquire, to consult, to discuss; to plan',
    pinyin: ['zī'],
    decomposition: '⿱次口',
    etymology: {
      type: 'pictophonetic',
      phonetic: '次',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '咩',
    definition: 'the bleating of sheep',
    pinyin: ['miē'],
    decomposition: '⿰口羊',
    etymology: {
      type: 'ideographic',
      hint: 'The sound a sheep 羊 makes with its mouth 口',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '咪',
    definition: "a cat's meow; a meter",
    pinyin: ['mī'],
    decomposition: '⿰口米',
    etymology: {
      type: 'pictophonetic',
      phonetic: '米',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '咫',
    definition: 'unit of length used during the Zhou dynasty',
    pinyin: ['zhǐ'],
    decomposition: '⿺尺只',
    etymology: {
      type: 'pictophonetic',
      phonetic: '只',
      semantic: '尺',
      hint: 'ruler',
    },
    radical: '口',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '咬',
    definition: 'to bite, to gnaw',
    pinyin: ['yǎo'],
    decomposition: '⿰口交',
    etymology: {
      type: 'pictophonetic',
      phonetic: '交',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '咭',
    definition:
      "(Cant.) to guard (from Engl. 'guard'); a card (from Engl. 'card'); young and pretty (from Engl. 'kid')",
    pinyin: ['jī'],
    decomposition: '⿰口吉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吉',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '咯',
    definition: 'final particle',
    pinyin: ['gē'],
    decomposition: '⿰口各',
    etymology: {
      type: 'pictophonetic',
      phonetic: '各',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '咱',
    definition: 'we, us',
    pinyin: ['zán'],
    decomposition: '⿰口自',
    etymology: {
      type: 'pictophonetic',
      phonetic: '自',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '咳',
    definition: 'to cough',
    pinyin: ['hāi'],
    decomposition: '⿰口亥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亥',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '咴',
    definition: 'to neigh, to whinny',
    pinyin: ['huī'],
    decomposition: '⿰口灰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '灰',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '咸',
    definition: 'all, together, united; salted',
    pinyin: ['xián'],
    decomposition: '⿵戊⿱一口',
    etymology: {
      type: 'ideographic',
      hint: 'One 一 voice 口 surrounded by conflict 戈',
    },
    radical: '口',
    matches: [[0], [0], [1, 0], [1, 1], [1, 1], [1, 1], [0], [0], [0]],
  },
  {
    character: '咻',
    definition: 'to shout; to jeer at',
    pinyin: ['xiū'],
    decomposition: '⿰口休',
    etymology: {
      type: 'pictophonetic',
      phonetic: '休',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '咼',
    definition: 'to chat, to gossip, to jaw, to talk; mouth',
    pinyin: ['guō'],
    decomposition: '⿵冎口',
    etymology: { type: 'ideographic', hint: 'A jaw 口 bone 冎' },
    radical: '口',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '咽',
    definition: 'throat; pharynx',
    pinyin: ['yàn'],
    decomposition: '⿰口因',
    etymology: {
      type: 'pictophonetic',
      phonetic: '因',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '咾',
    definition: 'onomatopoeic; sound, noise',
    pinyin: ['lǎo'],
    decomposition: '⿰口老',
    etymology: {
      type: 'pictophonetic',
      phonetic: '老',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '咿',
    definition: 'a creaking sound; to laugh',
    pinyin: ['yī'],
    decomposition: '⿰口伊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '伊',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哀',
    definition: 'sad, mournful, pitiful; to pity; to grieve',
    pinyin: ['āi'],
    decomposition: '⿻衣口',
    etymology: {
      type: 'pictophonetic',
      phonetic: '衣',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [1], [1], [1], [0], [0], [0], [0]],
  },
  {
    character: '品',
    definition: 'article, good, product; commodity; quality, character',
    pinyin: ['pǐn'],
    decomposition: '⿱口⿰口口',
    etymology: {
      type: 'ideographic',
      hint: 'Something that everyone is talking 口 about',
    },
    radical: '口',
    matches: [[0], [0], [0], [1, 0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '哂',
    definition: 'to smile; to laugh at; to sneer',
    pinyin: ['shěn'],
    decomposition: '⿰口西',
    etymology: {
      type: 'pictophonetic',
      phonetic: '西',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哄',
    definition: 'to coax; to beguile, to cheat, to deceive; tumult, uproar',
    pinyin: ['hōng'],
    decomposition: '⿰口共',
    etymology: {
      type: 'pictophonetic',
      phonetic: '共',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哆',
    definition: 'to quiver, to tremble, to shudder',
    pinyin: ['duō'],
    decomposition: '⿰口多',
    etymology: {
      type: 'pictophonetic',
      phonetic: '多',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哇',
    definition: "to vomit; an infant's cry",
    pinyin: ['wa'],
    decomposition: '⿰口圭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '圭',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哈',
    definition: 'the sound of laughter',
    pinyin: ['hā'],
    decomposition: '⿰口合',
    etymology: {
      type: 'pictophonetic',
      phonetic: '合',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哉',
    definition: 'final exclamatory particle',
    pinyin: ['zāi'],
    decomposition: '⿹？口',
    etymology: { type: 'pictophonetic', semantic: '口', hint: 'mouth' },
    radical: '口',
    matches: [null, null, null, [1], [1], [1], null, null, null],
  },
  {
    character: '哌',
    definition: 'used in transliterations',
    pinyin: ['pài'],
    decomposition: '⿰口⿸？氏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '氏',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], null, null, [1, 1], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '响',
    definition: 'to make noise, to make sound; sound',
    pinyin: ['xiǎng'],
    decomposition: '⿰口向',
    etymology: {
      type: 'pictophonetic',
      phonetic: '向',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哎',
    definition: 'interjection of surprise',
    pinyin: ['āi'],
    decomposition: '⿰口艾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '艾',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '哏',
    definition: 'the clamor of an argument; funny; odd',
    pinyin: ['gén'],
    decomposition: '⿰口艮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '艮',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哐',
    definition: 'onomatopoetic, a clang or clatter',
    pinyin: ['kuāng'],
    decomposition: '⿰口匡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匡',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哑',
    definition: 'dumb, mute, hoarse',
    pinyin: ['yǎ'],
    decomposition: '⿰口亚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亚',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哒',
    definition: 'a sound made to get a horse to move',
    pinyin: ['dā'],
    decomposition: '⿰口达',
    etymology: {
      type: 'pictophonetic',
      phonetic: '达',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哓',
    definition: 'garrulous; disturbed; restless',
    pinyin: ['xiāo'],
    decomposition: '⿰口尧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尧',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哔',
    definition: 'used in transliterations',
    pinyin: ['bì'],
    decomposition: '⿰口毕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '毕',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哕',
    definition: 'to belch; to vomit',
    pinyin: ['huì'],
    decomposition: '⿰口岁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '岁',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哗',
    definition: 'uproar, tumult, hubbub',
    pinyin: ['huā'],
    decomposition: '⿰口华',
    etymology: {
      type: 'pictophonetic',
      phonetic: '华',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哙',
    definition: 'to swallow, to gulp down; greedy',
    pinyin: ['kuài'],
    decomposition: '⿰口会',
    etymology: {
      type: 'pictophonetic',
      phonetic: '会',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哚',
    definition: 'a chemical element',
    pinyin: ['duǒ'],
    decomposition: '⿰口朵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朵',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哜',
    definition: 'to sip',
    pinyin: ['jì'],
    decomposition: '⿰口齐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '齐',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哝',
    definition: 'to whisper',
    pinyin: ['nóng'],
    decomposition: '⿰口农',
    etymology: {
      type: 'pictophonetic',
      phonetic: '农',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哞',
    definition: "a cow's moo",
    pinyin: ['mōu'],
    decomposition: '⿰口牟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '牟',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哟',
    definition: 'ah, final particle',
    pinyin: ['yō'],
    decomposition: '⿰口约',
    etymology: {
      type: 'pictophonetic',
      phonetic: '约',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '員',
    definition: 'employee; member; personnel, staff',
    pinyin: ['yuán'],
    decomposition: '⿱口貝',
    etymology: { type: 'pictophonetic', semantic: '貝', hint: 'money' },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哥',
    definition: 'elder brother',
    pinyin: ['gē'],
    decomposition: '⿱可可',
    etymology: {
      type: 'ideographic',
      hint: 'One person talking 可 over another 可',
    },
    radical: '口',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '哦',
    definition: 'oh? really? is that so?',
    pinyin: ['ó'],
    decomposition: '⿰口我',
    etymology: {
      type: 'pictophonetic',
      phonetic: '我',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哧',
    definition: 'the sound of ripping or giggling',
    pinyin: ['chī'],
    decomposition: '⿰口赤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '赤',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哨',
    definition: 'to whistle; to chirp',
    pinyin: ['shào'],
    decomposition: '⿰口肖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肖',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哩',
    definition: 'mile',
    pinyin: ['lī'],
    decomposition: '⿰口里',
    etymology: {
      type: 'pictophonetic',
      phonetic: '里',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哪',
    definition: 'which? where? how?',
    pinyin: ['nǎ'],
    decomposition: '⿰口那',
    etymology: {
      type: 'pictophonetic',
      phonetic: '那',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哭',
    definition: 'to weep, to cry, to wail',
    pinyin: ['kū'],
    decomposition: '⿱⿰口口犬',
    etymology: {
      type: 'ideographic',
      hint: 'To shed a tear from your eyes 口 over a person 犬',
    },
    radical: '口',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '哮',
    definition: 'to cough; to pant; to roar',
    pinyin: ['xiāo'],
    decomposition: '⿰口孝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孝',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哱',
    definition: 'onomatopoeic',
    pinyin: ['bō'],
    decomposition: '⿰口孛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孛',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哲',
    definition: 'wise, sagacious; wise man; philosopher',
    pinyin: ['zhé'],
    decomposition: '⿱折口',
    etymology: {
      type: 'pictophonetic',
      phonetic: '折',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '哳',
    definition: 'the sound of ripping or giggling',
    pinyin: ['zhā'],
    decomposition: '⿰口折',
    etymology: { type: 'pictophonetic', phonetic: '折', semantic: '口' },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哺',
    definition: 'to chew; to feed',
    pinyin: ['bǔ'],
    decomposition: '⿰口甫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甫',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哼',
    definition: 'to hum; to sing softly; to moan, to groan',
    pinyin: ['hēng'],
    decomposition: '⿰口亨',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亨',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哽',
    definition: 'to sob; to choke up',
    pinyin: ['gěng'],
    decomposition: '⿰口更',
    etymology: {
      type: 'pictophonetic',
      phonetic: '更',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '哿',
    definition: 'excellent, capable; happy; to commend',
    pinyin: ['gě'],
    decomposition: '⿱加可',
    etymology: {
      type: 'pictophonetic',
      phonetic: '可',
      semantic: '加',
      hint: 'add',
    },
    radical: '口',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '唁',
    definition: 'to offer condolences',
    pinyin: ['yàn'],
    decomposition: '⿰口言',
    etymology: {
      type: 'pictophonetic',
      phonetic: '言',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '唄',
    definition: 'final particle of an assertion',
    pinyin: ['bei'],
    decomposition: '⿰口貝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '貝',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '唅',
    definition: 'to swallow; to grunt, to grumble',
    pinyin: ['hán'],
    decomposition: '⿰口含',
    etymology: {
      type: 'ideographic',
      hint: 'To hold 含 in the mouth 口; 含 also provides the pronunciation',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '唆',
    definition: 'to make mischief; to instigate, to incite',
    pinyin: ['suō'],
    decomposition: '⿰口夋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夋',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '唇',
    definition: 'lips',
    pinyin: ['chún'],
    decomposition: '⿸辰口',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辰',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '唉',
    definition: 'alas; exclamation of surprise or pain',
    pinyin: ['āi'],
    decomposition: '⿰口矣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '矣',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '唎',
    definition: 'final particle; and? ok?',
    pinyin: ['lì'],
    decomposition: '⿰口利',
    etymology: {
      type: 'pictophonetic',
      phonetic: '利',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '唏',
    definition: 'to weep, to sob; to grieve',
    pinyin: ['xī'],
    decomposition: '⿰口希',
    etymology: {
      type: 'pictophonetic',
      phonetic: '希',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '唐',
    definition: 'the Tang dynasty; Chinese; empty, exaggerated; surname',
    pinyin: ['táng'],
    decomposition: '⿸广⿱肀口',
    etymology: {
      type: 'ideographic',
      hint: 'Children learning how to read 口 and write 肀 in school 广',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '唑',
    definition: 'in chemistry, -azole',
    pinyin: ['zuò'],
    decomposition: '⿰口坐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '坐',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '唔',
    definition: 'to hold in the mouth; bite',
    pinyin: ['wú'],
    decomposition: '⿰口吾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吾',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '唚',
    definition: 'to vomit',
    pinyin: ['qìn'],
    decomposition: '⿰口⿱⿱彐冖又',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彐',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 1],
      [1, 0, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '唛',
    definition: 'mark',
    pinyin: ['mà'],
    decomposition: '⿰口麦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '麦',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '唝',
    definition: 'to sing',
    pinyin: ['gòng'],
    decomposition: '⿰口贡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贡',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '唠',
    definition: 'to chat, to gossip, to jaw, to talk',
    pinyin: ['láo'],
    decomposition: '⿰口劳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '劳',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '唢',
    definition: 'a flute-like musical instrument',
    pinyin: ['suǒ'],
    decomposition: '⿰口⿱⺌贝',
    etymology: {
      type: 'ideographic',
      hint: 'A mouth 口 blowing ⺌ through a conch 贝',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '唣',
    definition: 'chatter',
    pinyin: ['zào'],
    decomposition: '⿰口皂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皂',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '唤',
    definition: 'to call',
    pinyin: ['huàn'],
    decomposition: '⿰口奂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奂',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '唧',
    definition: 'the chirping of insects',
    pinyin: ['jī'],
    decomposition: '⿰口即',
    etymology: {
      type: 'pictophonetic',
      phonetic: '即',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '唪',
    definition: 'to recite, to intone, to chant',
    pinyin: ['fěng'],
    decomposition: '⿰口奉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奉',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '唫',
    definition: 'to hum, to intone; to close, to shut',
    pinyin: ['jìn'],
    decomposition: '⿰口金',
    etymology: {
      type: 'pictophonetic',
      phonetic: '金',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '唬',
    definition: 'to intimidate; to scare',
    pinyin: ['hǔ'],
    decomposition: '⿰口虎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '虎',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '售',
    definition: 'to sell',
    pinyin: ['shòu'],
    decomposition: '⿱隹口',
    etymology: {
      type: 'ideographic',
      hint: 'A street vendor talks 口 incessantly, like a bird 隹',
    },
    radical: '口',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '唯',
    definition: 'only; sole',
    pinyin: ['wéi'],
    decomposition: '⿰口隹',
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '唰',
    definition: 'swish, rustle',
    pinyin: ['shuā'],
    decomposition: '⿰口刷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '刷',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '唱',
    definition: 'to sing, to chant, to call; ditty, song',
    pinyin: ['chàng'],
    decomposition: '⿰口昌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昌',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '唳',
    definition: "a bird's cry",
    pinyin: ['lì'],
    decomposition: '⿰口戾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戾',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '唵',
    definition: "to eat with one's hands; used in transliterations",
    pinyin: ['ǎn'],
    decomposition: '⿰口奄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奄',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '唷',
    definition: 'final particle',
    pinyin: ['yō'],
    decomposition: '⿰口育',
    etymology: {
      type: 'pictophonetic',
      phonetic: '育',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '唸',
    definition: 'to recite, to read, to chant',
    pinyin: ['niàn'],
    decomposition: '⿰口念',
    etymology: {
      type: 'pictophonetic',
      phonetic: '念',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '唼',
    definition: 'to speak evil; a gobbling sound made by ducks',
    pinyin: ['shà'],
    decomposition: '⿰口妾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '妾',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '唾',
    definition: 'to spit; to spit on; saliva',
    pinyin: ['tuò'],
    decomposition: '⿰口垂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '垂',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '唿',
    definition: 'sad',
    pinyin: ['hū'],
    decomposition: '⿰口忽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '忽',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '啁',
    definition: 'to chirp, to twitter',
    pinyin: ['zhāo'],
    decomposition: '⿰口周',
    etymology: {
      type: 'pictophonetic',
      phonetic: '周',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '啃',
    definition: 'to gnaw, to chew, to bite',
    pinyin: ['kěn'],
    decomposition: '⿰口肯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肯',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '啄',
    definition: 'to peck',
    pinyin: ['zhuó'],
    decomposition: '⿰口豖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豖',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '商',
    definition: 'commerce, business, trade',
    pinyin: ['shāng'],
    decomposition: '⿱⿱亠丷冏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '章',
      semantic: '冏',
      hint: 'bright',
    },
    radical: '口',
    matches: [
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '啇',
    definition: 'stalk, stem, root, foot, base',
    pinyin: ['dì'],
    decomposition: '⿱⿱亠丷⿵冂古',
    radical: '口',
    matches: [
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '啉',
    definition: 'stupid; slow',
    pinyin: ['lín'],
    decomposition: '⿰口林',
    etymology: {
      type: 'pictophonetic',
      phonetic: '林',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '啊',
    definition: 'ah, exclamatory particle',
    pinyin: ['a'],
    decomposition: '⿰口阿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '阿',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '問',
    definition: 'to ask about, to inquire after',
    pinyin: ['wèn'],
    decomposition: '⿵門口',
    etymology: {
      type: 'pictophonetic',
      phonetic: '門',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '啐',
    definition: 'to taste, to sip; to spit; the sound of sipping',
    pinyin: ['cuì'],
    decomposition: '⿰口卒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卒',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '啓',
    definition: 'to open; to explain; to begin',
    pinyin: ['qǐ'],
    decomposition: '⿱⿰户攵口',
    etymology: { type: 'ideographic', hint: 'To knock 攵 at the door 户' },
    radical: '口',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '啕',
    definition: 'to wail',
    pinyin: ['táo'],
    decomposition: '⿰口匋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匋',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '啖',
    definition: 'to feed; to eat; to chew, to bite; to entice',
    pinyin: ['dàn'],
    decomposition: '⿰口炎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '炎',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '啚',
    definition: 'mean, low',
    pinyin: ['bǐ'],
    decomposition: '⿱口㐭',
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '啜',
    definition: 'to drink, to sip; to sob, to weep',
    pinyin: ['chuài'],
    decomposition: '⿰口叕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叕',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '啞',
    definition: 'dumb, mute, hoarse',
    pinyin: ['yǎ'],
    decomposition: '⿰口亞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亞',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '啟',
    definition: 'to open; to begin, to commence; to explain',
    pinyin: ['qǐ'],
    decomposition: '⿰启攵',
    etymology: {
      type: 'ideographic',
      hint: 'To knock 攵 on a door 启; 启 also provides the pronunciation',
    },
    radical: '口',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '啡',
    definition: 'coffee; morphine',
    pinyin: ['fēi'],
    decomposition: '⿰口非',
    etymology: {
      type: 'pictophonetic',
      phonetic: '非',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '啤',
    definition: 'beer',
    pinyin: ['pí'],
    decomposition: '⿰口卑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卑',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '啥',
    definition: 'what?',
    pinyin: ['shà'],
    decomposition: '⿰口舍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '舍',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '啦',
    definition: 'final particle of an assertion',
    pinyin: ['la'],
    decomposition: '⿰口拉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '拉',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '啧',
    definition: 'interjection of approval or admiration',
    pinyin: ['zé'],
    decomposition: '⿰口责',
    etymology: {
      type: 'pictophonetic',
      phonetic: '责',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '啪',
    definition: 'onomatopoetic, a bang sound',
    pinyin: ['pā'],
    decomposition: '⿰口拍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '拍',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '啫',
    definition: 'onomatopoeic; an interjection of warning',
    pinyin: ['zhě'],
    decomposition: '⿰口者',
    etymology: {
      type: 'pictophonetic',
      phonetic: '者',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '啬',
    definition: 'miserly, stingy, thrifty',
    pinyin: ['sè'],
    decomposition: '⿱⿻土丷回',
    radical: '十',
    matches: [
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '啭',
    definition: 'to sing; to chirp, to twitter, to warble',
    pinyin: ['zhuàn'],
    decomposition: '⿰口转',
    etymology: {
      type: 'pictophonetic',
      phonetic: '转',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '啮',
    definition: 'to bite, to gnaw',
    pinyin: ['niè'],
    decomposition: '⿰口齿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '齿',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '啰',
    definition: 'long-winded, verbose',
    pinyin: ['luō'],
    decomposition: '⿰口罗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '罗',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '罒',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '啴',
    definition: 'many; to pant',
    pinyin: ['chǎn'],
    decomposition: '⿰口单',
    etymology: {
      type: 'pictophonetic',
      phonetic: '单',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '啵',
    definition: 'onomatopoetic, the sound of a brook bubbling',
    pinyin: ['bo'],
    decomposition: '⿰口波',
    etymology: {
      type: 'ideographic',
      hint: 'The sound 口 of ripples in the water 波; 波 also provides the pronunciation',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '啶',
    definition: 'in chemistry, -dine',
    pinyin: ['dìng'],
    decomposition: '⿰口定',
    etymology: {
      type: 'pictophonetic',
      phonetic: '定',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '啷',
    definition: 'a clanging or rattling sound',
    pinyin: ['lāng'],
    decomposition: '⿰口郎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '郎',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '啸',
    definition: 'to roar, to howl; to scream; to whistle',
    pinyin: ['xiào'],
    decomposition: '⿰口肃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肃',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '啻',
    definition: 'only, merely, just; to stop at',
    pinyin: ['chì'],
    decomposition: '⿱帝口',
    etymology: {
      type: 'pictophonetic',
      phonetic: '帝',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '啼',
    definition: 'to weep, to whimper; to howl; to crow',
    pinyin: ['tí'],
    decomposition: '⿰口帝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '帝',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '啾',
    definition: 'the wailing of a child',
    pinyin: ['jiū'],
    decomposition: '⿰口秋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '秋',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '喀',
    definition: 'to vomit; used in transliterations',
    pinyin: ['kā'],
    decomposition: '⿰口客',
    etymology: {
      type: 'pictophonetic',
      phonetic: '客',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '喁',
    definition: 'to breathe like a fish; to gasp for breath',
    pinyin: ['yóng'],
    decomposition: '⿰口禺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '禺',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '喂',
    definition: 'interjection used to call attention',
    pinyin: ['wèi'],
    decomposition: '⿰口畏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畏',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '喃',
    definition: 'to chatter, to keep talking; to mumble',
    pinyin: ['nán'],
    decomposition: '⿰口南',
    etymology: {
      type: 'pictophonetic',
      phonetic: '南',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '善',
    definition: 'good, virtuous, charitable, kind',
    pinyin: ['shàn'],
    decomposition: '⿱羊⿱⿱丷一口',
    etymology: {
      type: 'ideographic',
      hint: 'To give someone food 羊 and conversation 口',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '喆',
    definition: 'sage; wise, sagacious',
    pinyin: ['zhé'],
    decomposition: '⿰吉吉',
    etymology: {
      type: 'ideographic',
      hint: 'Extremely lucky 吉; 吉 also provides the pronunciation',
    },
    radical: '口',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '喇',
    definition: 'horn, bugle; llama; final particle',
    pinyin: ['lǎ'],
    decomposition: '⿰口剌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '剌',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '喈',
    definition: 'melody, music; harmonious',
    pinyin: ['jiē'],
    decomposition: '⿰口皆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皆',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '喉',
    definition: 'throat, larynx, gullet; guttural',
    pinyin: ['hóu'],
    decomposition: '⿰口侯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '侯',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '喊',
    definition: 'to shout, to yell, to call out; to howl; to cry',
    pinyin: ['hǎn'],
    decomposition: '⿰口咸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咸',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '喋',
    definition: 'to nag; babble, chatter',
    pinyin: ['dié'],
    decomposition: '⿰口枼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '枼',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '喏',
    definition: 'respectful reply of assent to superiors',
    pinyin: ['nuò'],
    decomposition: '⿰口若',
    etymology: {
      type: 'pictophonetic',
      phonetic: '若',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '喑',
    definition: 'dumb, mute; the sobbing of an infant',
    pinyin: ['yīn'],
    decomposition: '⿰口音',
    etymology: {
      type: 'pictophonetic',
      phonetic: '音',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '喔',
    definition: 'onomatopoetic, the sound of crowing or crying',
    pinyin: ['ō'],
    decomposition: '⿰口屋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屋',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '喘',
    definition: 'to pant, to gasp, to breathe heavily',
    pinyin: ['chuǎn'],
    decomposition: '⿰口耑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '耑',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '喙',
    definition: 'beak, bill, snout; to pant',
    pinyin: ['huì'],
    decomposition: '⿰口彖',
    etymology: { type: 'ideographic', hint: "A hedgehog's 彖 mouth 口" },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '喚',
    definition: 'to call',
    pinyin: ['huàn'],
    decomposition: '⿰口奐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奐',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '喜',
    definition: 'to love; to enjoy, to be happy; joyful, glad',
    pinyin: ['xǐ'],
    decomposition: '⿱壴口',
    etymology: { type: 'ideographic', hint: 'Singing 口 and beating drums 壴' },
    radical: '口',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '喝',
    definition: 'to drink; to shout, to call out',
    pinyin: ['hē'],
    decomposition: '⿰口曷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曷',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '喟',
    definition: 'heave sigh, sigh',
    pinyin: ['kuì'],
    decomposition: '⿰口胃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '胃',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '喧',
    definition: 'lively, noisy; to clamor, to talk loudly',
    pinyin: ['xuān'],
    decomposition: '⿰口宣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宣',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '喨',
    definition: 'to yell; to wail, to cry; to neigh',
    pinyin: ['liàng'],
    decomposition: '⿰口亮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亮',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '喪',
    definition: 'mourning; mourn; funeral',
    pinyin: ['sàng'],
    decomposition: '⿱⿻土⿰口口亡',
    etymology: { type: 'pictographic', hint: 'To cry 哭 over the dead 亡' },
    radical: '口',
    matches: [
      [0, 0],
      [0, 0],
      [0, 1, 0],
      [0, 1, 0],
      [0, 1, 0],
      [0, 1, 1],
      [0, 1, 1],
      [0, 1, 1],
      [0, 0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '喬',
    definition: 'tall, lofty; proud, stately',
    pinyin: ['qiáo'],
    decomposition: '⿱夭高',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夭',
      semantic: '高',
      hint: 'tall',
    },
    radical: '口',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '單',
    definition: 'single, individual, only; lone',
    pinyin: ['dān'],
    decomposition: '⿱⿰口口？',
    radical: '口',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      null,
      null,
      null,
      null,
      null,
      null,
    ],
  },
  {
    character: '喱',
    definition: 'gram; the weight of one grain',
    pinyin: ['lí'],
    decomposition: '⿰口厘',
    etymology: {
      type: 'ideographic',
      hint: 'A thousandth 厘 of a meal 口; 厘 also provides the pronunciation',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '喲',
    definition: 'ah, final particle',
    pinyin: ['yō'],
    decomposition: '⿰口約',
    etymology: {
      type: 'pictophonetic',
      phonetic: '約',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '喳',
    definition: 'to whisper',
    pinyin: ['zhā'],
    decomposition: '⿰口查',
    etymology: {
      type: 'pictophonetic',
      phonetic: '查',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '喵',
    definition: "a cat's meow",
    pinyin: ['miāo'],
    decomposition: '⿰口苗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '苗',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '喷',
    definition: 'to blow, to puff, to spray, to spurt',
    pinyin: ['pēn'],
    decomposition: '⿰口贲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贲',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '喹',
    definition: 'in chemistry, quinoline',
    pinyin: ['kuí'],
    decomposition: '⿰口奎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奎',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '喻',
    definition: 'metaphor, analogy; example; such as, like',
    pinyin: ['yù'],
    decomposition: '⿰口俞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '俞',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '喼',
    definition: 'used in transliterations',
    pinyin: ['jié'],
    decomposition: '⿰口急',
    etymology: {
      type: 'pictophonetic',
      phonetic: '急',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '喽',
    definition: 'used in onomatopoetic expressions',
    pinyin: ['lóu'],
    decomposition: '⿰口娄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '娄',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '喾',
    definition: 'one of five legendary emperors',
    pinyin: ['kù'],
    decomposition: '⿳⺍冖告',
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [2], [2], [2], [2], [2], [2], [2]],
  },
  {
    character: '喿',
    definition: 'the sound of birds chirping',
    pinyin: ['zào'],
    decomposition: '⿱品木',
    etymology: {
      type: 'ideographic',
      hint: 'Several birds 品 chirping in a tree 木',
    },
    radical: '口',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '嗄',
    definition: 'hoarse',
    pinyin: ['á'],
    decomposition: '⿰口夏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夏',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗅',
    definition: 'to sniff, to smell, to scent',
    pinyin: ['xiù'],
    decomposition: '⿰口臭',
    etymology: {
      type: 'ideographic',
      hint: 'To taste 口 an odor 臭; 臭 also provides the pronunciation',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗆',
    definition:
      'choking, as by smoke; something that irritates the nose or throat',
    pinyin: ['qiāng'],
    decomposition: '⿰口倉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '倉',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗇',
    definition: 'miserly, stingy, thrifty',
    pinyin: ['sè'],
    decomposition: '⿱坐回',
    radical: '口',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗉',
    definition: "a bird's crop; wine pot",
    pinyin: ['sù'],
    decomposition: '⿰口素',
    etymology: {
      type: 'pictophonetic',
      phonetic: '素',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗊',
    definition: 'to sing',
    pinyin: ['gòng'],
    decomposition: '⿰口貢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '貢',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗌',
    definition: 'throat; to quarrel, to choke',
    pinyin: ['ài'],
    decomposition: '⿰口益',
    etymology: {
      type: 'pictophonetic',
      phonetic: '益',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗍',
    definition: 'to drink, to imbibe',
    pinyin: ['suō'],
    decomposition: '⿰口朔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朔',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗎',
    definition: 'final interrogative particle',
    pinyin: ['ma'],
    decomposition: '⿰口馬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '馬',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗑',
    definition: 'to eat seeds; to reproach; loquacious',
    pinyin: ['kē'],
    decomposition: '⿰口盍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '盍',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗒',
    definition: 'absent-minded',
    pinyin: ['dā'],
    decomposition: '⿰口荅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '荅',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗓',
    definition: 'throat; voice',
    pinyin: ['sǎng'],
    decomposition: '⿰口桑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '桑',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗔',
    definition: 'to be angry at, to rebuke, to scold',
    pinyin: ['chēn'],
    decomposition: '⿰口真',
    etymology: {
      type: 'pictophonetic',
      phonetic: '真',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗖',
    definition: 'a whizzing sound',
    pinyin: ['sōu'],
    decomposition: '⿰口叟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叟',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗚',
    definition: 'the sound of someone crying or sobbing',
    pinyin: ['wū'],
    decomposition: '⿰口烏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '烏',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗜',
    definition: 'addicted to, fond of, with a weakness for',
    pinyin: ['shì'],
    decomposition: '⿰口耆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '耆',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗝',
    definition: 'the cackling of a fowl; to gag, to vomit',
    pinyin: ['gé'],
    decomposition: '⿰口鬲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鬲',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗟',
    definition: 'sigh, alas',
    pinyin: ['jiē'],
    decomposition: '⿰口差',
    etymology: {
      type: 'pictophonetic',
      phonetic: '差',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗡',
    definition: 'the droning sound made by an airplane or a bee flying',
    pinyin: ['wēng'],
    decomposition: '⿰口翁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '翁',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗣',
    definition: 'to connect; to inherit; descendants, heirs',
    pinyin: ['sì'],
    decomposition: '⿰⿱口冊司',
    etymology: {
      type: 'pictophonetic',
      phonetic: '司',
      semantic: '冊',
      hint: 'book',
    },
    radical: '口',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嗤',
    definition: 'to laugh at, to ridicule, to sneer at; to snort',
    pinyin: ['chī'],
    decomposition: '⿰口蚩',
    etymology: {
      type: 'ideographic',
      hint: 'To laugh 蚩 out loud 口; 蚩 also provides the pronunciation',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗥',
    definition: 'to call out; to roar, to bark; to wail; to yelp',
    pinyin: ['háo'],
    decomposition: '⿰口皋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皋',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗦',
    definition: 'to suck',
    pinyin: ['suo'],
    decomposition: '⿰口索',
    etymology: {
      type: 'pictophonetic',
      phonetic: '索',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗨',
    definition: 'an exclamation',
    pinyin: ['hāi'],
    decomposition: '⿰口海',
    etymology: {
      type: 'pictophonetic',
      phonetic: '海',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗩',
    definition: 'a flute-like musical instrument',
    pinyin: ['suǒ'],
    decomposition: '⿰口⿱⺌貝',
    etymology: {
      type: 'ideographic',
      hint: 'A mouth 口 blowing ⺌ through a conch 貝',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '嗪',
    definition: 'used in transliterations',
    pinyin: ['qín'],
    decomposition: '⿰口秦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '秦',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗫',
    definition: 'to move the lips as if speaking; hesitation',
    pinyin: ['niè'],
    decomposition: '⿰口聂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '聂',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗬',
    definition: 'hey, hello; interrogative particle',
    pinyin: ['hē'],
    decomposition: '⿰口荷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '荷',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗯',
    definition: 'interjection indicating agreement or appreciation',
    pinyin: ['en'],
    decomposition: '⿰口恩',
    etymology: {
      type: 'pictophonetic',
      phonetic: '恩',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗲',
    definition: 'childish, coquettish, coy; inviting; "daddy"',
    pinyin: ['diǎ'],
    decomposition: '⿰口爹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爹',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗳',
    definition: 'interjection indicating regret',
    pinyin: ['āi'],
    decomposition: '⿰口爱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爱',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗵',
    definition: 'onomatopoetic',
    pinyin: ['tōng'],
    decomposition: '⿰口通',
    etymology: {
      type: 'pictophonetic',
      phonetic: '通',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗶',
    definition: 'used in transliterations',
    pinyin: ['bì'],
    decomposition: '⿰口畢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畢',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗷',
    definition: 'clamor; the sound of wailing',
    pinyin: ['áo'],
    decomposition: '⿰口敖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敖',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嗽',
    definition: 'to gargle; to cough; to clear the throat',
    pinyin: ['sòu'],
    decomposition: '⿰口欶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '欶',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嗾',
    definition: 'to set a dog on; to incite, to instigate, to urge on',
    pinyin: ['sǒu'],
    decomposition: '⿰口族',
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘀',
    definition: 'to whisper',
    pinyin: ['dí'],
    decomposition: '⿰口啇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '啇',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘁',
    definition: 'ashamed; grieving; onomatopoetic',
    pinyin: ['qī'],
    decomposition: '⿰口戚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戚',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘅',
    definition: 'the sound of a sigh',
    pinyin: ['kǎi'],
    decomposition: '⿰口既',
    etymology: {
      type: 'pictophonetic',
      phonetic: '既',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嘆',
    definition: 'to sigh, to admire',
    pinyin: ['tàn'],
    decomposition: '⿰口堇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堇',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘈',
    definition: 'bustling, noisy',
    pinyin: ['cáo'],
    decomposition: '⿰口曹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曹',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘉',
    definition: 'excellent; joyful; auspicious',
    pinyin: ['jiā'],
    decomposition: '⿱壴加',
    etymology: {
      type: 'pictophonetic',
      phonetic: '加',
      semantic: '壴',
      hint: 'drum',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘌',
    definition: 'fast, speedy',
    pinyin: ['piào'],
    decomposition: '⿰口票',
    etymology: {
      type: 'pictophonetic',
      phonetic: '票',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘎',
    definition: 'a cackling sound; bad, malevolent',
    pinyin: ['gā'],
    decomposition: '⿰口戛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戛',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘏',
    definition: 'felicity, prosperity; large and strong',
    pinyin: ['gǔ'],
    decomposition: '⿰古叚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '古',
      semantic: '叚',
      hint: 'false',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘔',
    definition: 'to vomit; to annoy, to enrage',
    pinyin: ['ǒu'],
    decomposition: '⿰口區',
    etymology: {
      type: 'pictophonetic',
      phonetic: '區',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘖',
    definition: 'interjection of approval or admiration',
    pinyin: ['zé'],
    decomposition: '⿰口責',
    etymology: {
      type: 'pictophonetic',
      phonetic: '責',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘗',
    definition: 'to taste; to experience, to experiment with',
    pinyin: ['cháng'],
    decomposition: '⿱尚旨',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尚',
      semantic: '旨',
      hint: 'purpose',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘘',
    definition: 'to blow, to exhale, to hiss, to sigh; to praise',
    pinyin: ['xū'],
    decomposition: '⿰口虚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '虚',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘚',
    definition: "onomatopoeic; the sound of a horse's hooves",
    pinyin: ['dē'],
    decomposition: '⿰口得',
    etymology: {
      type: 'pictophonetic',
      phonetic: '得',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘛',
    definition: 'final exclamatory particle',
    pinyin: ['ma'],
    decomposition: '⿰口麻',
    etymology: {
      type: 'pictophonetic',
      phonetic: '麻',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘜',
    definition: 'mark',
    pinyin: ['mà'],
    decomposition: '⿰口麥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '麥',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘞',
    definition: 'final particle used to indicate polite refusal',
    pinyin: ['lei'],
    decomposition: '⿰口勒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '勒',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘟',
    definition: 'the sound of a horn tooting',
    pinyin: ['dū'],
    decomposition: '⿰口都',
    etymology: {
      type: 'pictophonetic',
      phonetic: '都',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嘢',
    definition: 'thing; matter, substance',
    pinyin: ['yě'],
    decomposition: '⿰口野',
    etymology: {
      type: 'pictophonetic',
      phonetic: '野',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘣',
    definition: 'onomatopoetic, the sound of an explosion; bang',
    pinyin: ['bēng'],
    decomposition: '⿰口崩',
    etymology: {
      type: 'pictophonetic',
      phonetic: '崩',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘤',
    definition: 'onomatopoetic, a bird call; to seek friends',
    pinyin: ['yīng'],
    decomposition: '⿰口婴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '婴',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘧',
    definition: 'in chemistry, -mi as in pyramidine',
    pinyin: ['mì'],
    decomposition: '⿰口密',
    etymology: {
      type: 'pictophonetic',
      phonetic: '密',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘩',
    definition: 'uproar, tumult, hubbub',
    pinyin: ['huā'],
    decomposition: '⿰口華',
    etymology: {
      type: 'pictophonetic',
      phonetic: '華',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘬',
    definition: 'to lap; to suck',
    pinyin: ['chuài'],
    decomposition: '⿰口最',
    etymology: {
      type: 'pictophonetic',
      phonetic: '最',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘭',
    definition: 'onomatopoetic, the sound of a crash or bang',
    pinyin: ['pēng'],
    decomposition: '⿰口彭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彭',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘮',
    definition: 'to chat, to gossip, to jaw, to talk',
    pinyin: ['láo'],
    decomposition: '⿰口勞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '勞',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘯',
    definition: 'to roar, to howl; to scream; to whistle',
    pinyin: ['xiào'],
    decomposition: '⿰口肅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肅',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘰',
    definition: 'to grumble; to sigh',
    pinyin: ['jī'],
    decomposition: '⿰口幾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '幾',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘱',
    definition: 'to instruct, to order, to tell; testament',
    pinyin: ['zhǔ'],
    decomposition: '⿰口属',
    etymology: {
      type: 'pictophonetic',
      phonetic: '属',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘲',
    definition: 'to deride, to jeer at, to ridicule, to scorn',
    pinyin: ['cháo'],
    decomposition: '⿰口朝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朝',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘴',
    definition: 'mouth, lips',
    pinyin: ['zuǐ'],
    decomposition: '⿰口觜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '觜',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘶',
    definition: 'the neighing of a hoarse, gravel-voiced, hoarse',
    pinyin: ['sī'],
    decomposition: '⿰口斯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斯',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘸',
    definition: 'unclear; an expletive',
    pinyin: ['fǔ'],
    decomposition: '⿰口無',
    etymology: {
      type: 'pictophonetic',
      phonetic: '無',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘹',
    definition: 'a clear sound, such as a bell or a soprano; resonant',
    pinyin: ['liáo'],
    decomposition: '⿰口尞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尞',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘻',
    definition: 'happy, giggling, laughing; an interjection',
    pinyin: ['xī'],
    decomposition: '⿰口喜',
    etymology: {
      type: 'ideographic',
      hint: 'A happy 喜 sound 口; 喜 also provides the pronunciation',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘼',
    pinyin: ['chù'],
    decomposition: '⿱⿰口口⿳田一口',
    radical: '口',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 2],
      [1, 2],
      [1, 2],
    ],
  },
  {
    character: '嘽',
    definition: 'many; to pant',
    pinyin: ['chǎn'],
    decomposition: '⿰口單',
    etymology: {
      type: 'pictophonetic',
      phonetic: '單',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嘿',
    definition: 'quiet, silent',
    pinyin: ['hēi'],
    decomposition: '⿰口黑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '黑',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '噁',
    definition: 'bad, wicked; foul, nauseating',
    pinyin: ['ě'],
    decomposition: '⿰口惡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '惡',
      semantic: '惡',
      hint: 'foul',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '噌',
    definition: 'to scold, to shout at',
    pinyin: ['cēng'],
    decomposition: '⿰口曾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曾',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '噍',
    definition: 'to chew, to eat, to munch',
    pinyin: ['jiào'],
    decomposition: '⿰口焦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '焦',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '噎',
    definition: 'to choke; to hiccup',
    pinyin: ['yē'],
    decomposition: '⿰口壹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '壹',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '噓',
    definition: 'to blow, to exhale, to hiss, to sigh; to praise',
    pinyin: ['xū'],
    decomposition: '⿰口虛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '虛',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '噔',
    definition: 'for (a recipient of pity or sympathy); surname',
    pinyin: ['dēng'],
    decomposition: '⿰口登',
    etymology: {
      type: 'pictophonetic',
      phonetic: '登',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '噗',
    definition: 'to burst',
    pinyin: ['pū'],
    decomposition: '⿰口菐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '菐',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '噘',
    definition: 'to pout',
    pinyin: ['juē'],
    decomposition: '⿰口厥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厥',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '噙',
    definition: 'to bite; to hold in the mouth',
    pinyin: ['qín'],
    decomposition: '⿰口禽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '禽',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '噜',
    definition: 'verbose, talkative; mumbling',
    pinyin: ['lū'],
    decomposition: '⿰口鲁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鲁',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '噠',
    definition: 'a sound made to get a horse to move',
    pinyin: ['dā'],
    decomposition: '⿰口達',
    etymology: {
      type: 'pictophonetic',
      phonetic: '達',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '噢',
    definition: 'to moan; interjection indicating pain or sadness',
    pinyin: ['ō'],
    decomposition: '⿰口奥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奥',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '噤',
    definition: 'close; quiet, silent',
    pinyin: ['jìn'],
    decomposition: '⿰口禁',
    etymology: {
      type: 'ideographic',
      hint: 'Forbidden 禁 to speak 口; 禁 also provides the pronunciation',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '噥',
    definition: 'to whisper',
    pinyin: ['nóng'],
    decomposition: '⿰口農',
    etymology: {
      type: 'pictophonetic',
      phonetic: '農',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '噦',
    definition: 'to belch; to vomit',
    pinyin: ['huì'],
    decomposition: '⿰口歲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '歲',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '器',
    definition: 'device, instrument, tool; receptacle, vessel',
    pinyin: ['qì'],
    decomposition: '⿳⿰口口犬⿰口口',
    etymology: {
      type: 'ideographic',
      hint: 'Four cooking vessels 口 guarded by a dog 犬',
    },
    radical: '口',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [2, 0],
      [2, 0],
      [2, 0],
      [2, 1],
      [2, 1],
      [2, 1],
    ],
  },
  {
    character: '噩',
    definition: 'bad, ill-omened, unlucky',
    pinyin: ['è'],
    decomposition: '⿻王⿱⿰口口⿰口口',
    etymology: {
      type: 'ideographic',
      hint: 'A jade statue 王 with four holes made in it 口',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 1],
      [1, 0, 1],
      [1, 0, 1],
      [0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
      [0],
    ],
  },
  {
    character: '噪',
    definition: 'to be noisy; to chirp loudly',
    pinyin: ['zào'],
    decomposition: '⿰口喿',
    etymology: {
      type: 'ideographic',
      hint: 'The sound 口 of birds chirping 喿; 喿 also provides the pronunciation',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '噫',
    definition: 'belch; interjection of approval',
    pinyin: ['yī'],
    decomposition: '⿰口意',
    etymology: {
      type: 'pictophonetic',
      phonetic: '意',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '噬',
    definition: 'to bite, to gnaw; to snap at',
    pinyin: ['shì'],
    decomposition: '⿰口筮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '筮',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '噯',
    definition: 'interjection indicating regret',
    pinyin: ['āi'],
    decomposition: '⿰口愛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '愛',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '噱',
    definition: 'to laugh heartily',
    pinyin: ['jué'],
    decomposition: '⿰口豦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豦',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '噲',
    definition: 'to swallow, to gulp down; greedy',
    pinyin: ['kuài'],
    decomposition: '⿰口會',
    etymology: {
      type: 'pictophonetic',
      phonetic: '會',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '噴',
    definition: 'to blow, to puff, to spray, to spurt',
    pinyin: ['pēn'],
    decomposition: '⿰口賁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '賁',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '噶',
    definition: 'used in transliterations',
    pinyin: ['gá'],
    decomposition: '⿰口葛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '葛',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '噸',
    definition: 'a metric ton',
    pinyin: ['dūn'],
    decomposition: '⿰口頓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '頓',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '噹',
    definition: 'appropriate, timely; to act, to serve; the sound of bells',
    pinyin: ['dāng'],
    decomposition: '⿰口當',
    etymology: {
      type: 'pictophonetic',
      phonetic: '當',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '噻',
    definition: 'character used in translation',
    pinyin: ['sāi'],
    decomposition: '⿰口塞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '塞',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '噼',
    definition: 'onomatopoetic, the sound of something cracking',
    pinyin: ['pī'],
    decomposition: '⿰口辟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辟',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嚀',
    definition: 'to enjoin, to instruct; to charge',
    pinyin: ['níng'],
    decomposition: '⿰口寧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寧',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嚄',
    definition: 'to roar',
    pinyin: ['huō'],
    decomposition: '⿰口蒦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蒦',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嚅',
    definition: 'to mumble, to stutter',
    pinyin: ['rú'],
    decomposition: '⿰口需',
    etymology: {
      type: 'pictophonetic',
      phonetic: '需',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嚆',
    definition: 'noise, sound',
    pinyin: ['hāo'],
    decomposition: '⿰口蒿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蒿',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嚇',
    definition: 'to scare, to frighten; to threaten, to intimidate',
    pinyin: ['xià'],
    decomposition: '⿰口赫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '赫',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嚎',
    definition: 'to cry loudly, to scream, to yell',
    pinyin: ['háo'],
    decomposition: '⿰口豪',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豪',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嚏',
    definition: 'to sneeze',
    pinyin: ['tì'],
    decomposition: '⿰口疐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '疐',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嚓',
    definition: 'a cracking or snapping sound',
    pinyin: ['cā'],
    decomposition: '⿰口察',
    etymology: {
      type: 'pictophonetic',
      phonetic: '察',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嚕',
    definition: 'verbose, talkative; mumbling',
    pinyin: ['lū'],
    decomposition: '⿰口魯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '魯',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嚙',
    definition: 'to bite, to gnaw',
    pinyin: ['niè'],
    decomposition: '⿰口齒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '齒',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嚣',
    definition: 'to make noise; to treat with contempt',
    pinyin: ['xiāo'],
    decomposition: '⿳⿰口口页⿰口口',
    radical: '口',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [2, 0],
      [2, 0],
      [2, 0],
      [2, 1],
      [2, 1],
      [2, 1],
    ],
  },
  {
    character: '嚥',
    definition: 'to swallow, to gulp',
    pinyin: ['yàn'],
    decomposition: '⿰口燕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '燕',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嚨',
    definition: 'throat',
    pinyin: ['lóng'],
    decomposition: '⿰口龍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龍',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嚮',
    definition: 'to direct, to guide; to favor, to incline towards',
    pinyin: ['xiàng'],
    decomposition: '⿱鄉向',
    etymology: {
      type: 'ideographic',
      hint: 'Towards 向 the country 鄉; 鄉 also provides the pronunciation',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嚯',
    definition: 'a cracking or snapping sound',
    pinyin: ['huò'],
    decomposition: '⿰口霍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '霍',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嚳',
    definition: 'one of five legendary emperors',
    pinyin: ['kù'],
    decomposition: '⿱？告',
    radical: '口',
    matches: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嚴',
    definition: 'strict, rigorous, rigid; stern',
    pinyin: ['yán'],
    decomposition: '⿱⿰口口⿸厂敢',
    radical: '口',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '嚷',
    definition: 'to shout, to roar, to cry; to brawl',
    pinyin: ['rǎng'],
    decomposition: '⿰口襄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '襄',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嚼',
    definition: 'to prattle, to be glib',
    pinyin: ['jué'],
    decomposition: '⿰口爵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爵',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '囀',
    definition: 'to sing; to chirp, to twitter, to warble',
    pinyin: ['zhuàn'],
    decomposition: '⿰口轉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '轉',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '囂',
    definition: 'to make noise; to treat with contempt',
    pinyin: ['xiāo'],
    decomposition: '⿳⿰口口頁⿰口口',
    radical: '口',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [2, 0],
      [2, 0],
      [2, 0],
      [2, 1],
      [2, 1],
      [2, 1],
    ],
  },
  {
    character: '囈',
    definition: "to talk in one's sleep; somniloquy",
    pinyin: ['yì'],
    decomposition: '⿰口藝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '藝',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '囉',
    definition: 'long-winded, verbose',
    pinyin: ['luō'],
    decomposition: '⿰口羅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羅',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '囊',
    definition: 'bag, purse, sack; to pocket, to stow',
    pinyin: ['náng'],
    decomposition: '⿱⿻口？襄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '襄',
      semantic: '口',
      hint: 'gate',
    },
    radical: '口',
    matches: [
      null,
      [0, 0],
      [0, 0],
      [0, 0],
      null,
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '囌',
    definition: 'loquacious; to nag',
    pinyin: ['sū'],
    decomposition: '⿰口蘇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蘇',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '囑',
    definition: 'to instruct, to order, to tell; testament',
    pinyin: ['zhǔ'],
    decomposition: '⿰口屬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屬',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '囔',
    definition: 'to mumble, to mutter',
    pinyin: ['nāng'],
    decomposition: '⿰口囊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '囊',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '囗',
    definition: 'enclosure; border',
    pinyin: ['wéi'],
    decomposition: '⿱冂一',
    radical: '囗',
    matches: [[0], [0], [1]],
  },
  {
    character: '囚',
    definition: 'prisoner, convict; to confine',
    pinyin: ['qiú'],
    decomposition: '⿴囗人',
    etymology: { type: 'ideographic', hint: 'A person 人 in a cell 囗' },
    radical: '囗',
    matches: [[0], [0], [1], [1], [0]],
  },
  {
    character: '四',
    definition: 'four',
    pinyin: ['sì'],
    decomposition: '⿴囗儿',
    etymology: {
      type: 'ideographic',
      hint: 'A child 儿 in a room with four walls 囗',
    },
    radical: '囗',
    matches: [[0], [0], [1], [1], [0]],
  },
  {
    character: '囝',
    definition: 'baby, infant',
    pinyin: ['jiǎn'],
    decomposition: '⿴囗子',
    etymology: { type: 'ideographic', hint: 'A baby 子 in a crib 囗' },
    radical: '囗',
    matches: [[0], [0], [1], [1], [1], [0]],
  },
  {
    character: '回',
    definition: 'to return, to turn around; a time',
    pinyin: ['huí'],
    decomposition: '⿴囗口',
    etymology: {
      type: 'ideographic',
      hint: 'Originally, a spiral signifying return',
    },
    radical: '囗',
    matches: [[0], [0], [1], [1], [1], [0]],
  },
  {
    character: '囟',
    definition: 'top of the head; skull',
    pinyin: ['xìn'],
    decomposition: '⿱丿⿴囗乂',
    etymology: {
      type: 'ideographic',
      hint: 'A skull from above, with 乂 marking the fontanelle',
    },
    radical: '囗',
    matches: [[0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 0]],
  },
  {
    character: '因',
    definition: 'cause, reason; by; because',
    pinyin: ['yīn'],
    decomposition: '⿴囗大',
    radical: '囗',
    matches: [[0], [0], [1], [1], [1], [0]],
  },
  {
    character: '囡',
    definition: 'child, daughter',
    pinyin: ['nān'],
    decomposition: '⿴囗女',
    etymology: { type: 'ideographic', hint: 'A girl 女 in a crib 囗' },
    radical: '囗',
    matches: [[0], [0], [1], [1], [1], [0]],
  },
  {
    character: '团',
    definition: 'sphere, circle, ball; mass, lump; group, regiment; to gather',
    pinyin: ['tuán'],
    decomposition: '⿴囗才',
    etymology: {
      type: 'ideographic',
      hint: 'A lot of talent 才 gathered in one place 囗',
    },
    radical: '囗',
    matches: [[0], [0], [1], [1], [1], [0]],
  },
  {
    character: '囤',
    definition: 'grain basket; to store, to hoard',
    pinyin: ['dùn'],
    decomposition: '⿴囗屯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屯',
      semantic: '囗',
      hint: 'enclosure',
    },
    radical: '囗',
    matches: [[0], [0], [1], [1], [1], [1], [0]],
  },
  {
    character: '囪',
    definition: 'chimney',
    pinyin: ['cōng'],
    decomposition: '⿴囗？',
    etymology: {
      type: 'ideographic',
      hint: 'A fire burning and giving off smoke',
    },
    radical: '囗',
    matches: [null, [0], [0], null, null, null, [0]],
  },
  {
    character: '囫',
    definition: 'entire, whole',
    pinyin: ['hú'],
    decomposition: '⿴囗勿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '勿',
      semantic: '囗',
      hint: 'enclosure',
    },
    radical: '囗',
    matches: [[0], [0], [1], [1], [1], [1], [0]],
  },
  {
    character: '园',
    definition: 'garden, park; orchard',
    pinyin: ['yuán'],
    decomposition: '⿴囗元',
    etymology: {
      type: 'pictophonetic',
      phonetic: '元',
      semantic: '囗',
      hint: 'enclosure',
    },
    radical: '囗',
    matches: [[0], [0], [1], [1], [1], [1], [0]],
  },
  {
    character: '困',
    definition:
      'to surround; to besiege; surrounded, in distress; poor; tired, sleepy',
    pinyin: ['kùn'],
    decomposition: '⿴囗木',
    etymology: {
      type: 'ideographic',
      hint: 'A fence 囗 built around a tree 木',
    },
    radical: '囗',
    matches: [[0], [0], [1], [1], [1], [1], [0]],
  },
  {
    character: '囱',
    definition: 'chimney',
    pinyin: ['cōng'],
    decomposition: '⿴囗夂',
    etymology: {
      type: 'ideographic',
      hint: 'A fire 夂 burning and giving off smoke',
    },
    radical: '囗',
    matches: [null, [0], [0], [1], [1], [1], [0]],
  },
  {
    character: '围',
    definition: 'to surround, to encircle, to corral',
    pinyin: ['wéi'],
    decomposition: '⿴囗韦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韦',
      semantic: '囗',
      hint: 'enclosure',
    },
    radical: '囗',
    matches: [[0], [0], [1], [1], [1], [1], [0]],
  },
  {
    character: '囵',
    definition: 'all, complete, entire',
    pinyin: ['lún'],
    decomposition: '⿴囗仑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '仑',
      semantic: '囗',
      hint: 'enclosure',
    },
    radical: '囗',
    matches: [[0], [0], [1], [1], [1], [1], [0]],
  },
  {
    character: '囷',
    definition: 'a round bin for storing grain',
    pinyin: ['qūn'],
    decomposition: '⿴囗禾',
    etymology: { type: 'ideographic', hint: 'A bin 囗 for storing grain 禾' },
    radical: '囗',
    matches: [[0], [0], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '囹',
    definition: 'prison, enclosure',
    pinyin: ['líng'],
    decomposition: '⿴囗令',
    etymology: {
      type: 'pictophonetic',
      phonetic: '令',
      semantic: '囗',
      hint: 'enclosure',
    },
    radical: '囗',
    matches: [[0], [0], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '固',
    definition: 'to solidify; strength',
    pinyin: ['gù'],
    decomposition: '⿴囗古',
    etymology: {
      type: 'pictophonetic',
      phonetic: '古',
      semantic: '囗',
      hint: 'border',
    },
    radical: '囗',
    matches: [[0], [0], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '国',
    definition: 'country, nation, state; national',
    pinyin: ['guó'],
    decomposition: '⿴囗玉',
    etymology: {
      type: 'ideographic',
      hint: "Treasure 玉 within a country's borders 囗",
    },
    radical: '囗',
    matches: [[0], [0], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '图',
    definition: 'diagram, chart, map, picture; to plan',
    pinyin: ['tú'],
    decomposition: '⿴囗冬',
    etymology: {
      type: 'ideographic',
      hint: "Simplified form of 圖; a map of a district's 啚 borders 囗",
    },
    radical: '囗',
    matches: [[0], [0], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '囿',
    definition: 'to limit, to constrain; pen, cell',
    pinyin: ['yòu'],
    decomposition: '⿴囗有',
    etymology: {
      type: 'pictophonetic',
      phonetic: '有',
      semantic: '囗',
      hint: 'enclosure',
    },
    radical: '囗',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '圂',
    definition: 'pig-sty; privy',
    pinyin: ['hùn'],
    decomposition: '⿴囗豕',
    etymology: { type: 'ideographic', hint: 'A pig 豕 in a pen 囗' },
    radical: '囗',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '圃',
    definition: 'garden, orchard, plot of farmland',
    pinyin: ['pǔ'],
    decomposition: '⿴囗甫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甫',
      semantic: '囗',
      hint: 'enclosure',
    },
    radical: '囗',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '圄',
    definition: 'prison, jail',
    pinyin: ['yǔ'],
    decomposition: '⿴囗吾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吾',
      semantic: '囗',
      hint: 'enclosure',
    },
    radical: '囗',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '圆',
    definition: 'circle; circular, round; complete',
    pinyin: ['yuán'],
    decomposition: '⿴囗员',
    etymology: {
      type: 'pictophonetic',
      phonetic: '员',
      semantic: '囗',
      hint: 'enclosure',
    },
    radical: '囗',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '圇',
    definition: 'all, complete, entire',
    pinyin: ['lún'],
    decomposition: '⿴囗侖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '侖',
      semantic: '囗',
      hint: 'enclosure',
    },
    radical: '囗',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '圈',
    definition: 'circle, ring, loop; to encircle',
    pinyin: ['quān'],
    decomposition: '⿴囗卷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卷',
      semantic: '囗',
      hint: 'enclosure',
    },
    radical: '囗',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '圉',
    definition: 'stable, fence, corral; frontier, border',
    pinyin: ['yǔ'],
    decomposition: '⿴囗幸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '幸',
      semantic: '囗',
      hint: 'enclosure',
    },
    radical: '囗',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '圊',
    definition: 'restroom',
    pinyin: ['qīng'],
    decomposition: '⿴囗青',
    etymology: {
      type: 'pictophonetic',
      phonetic: '青',
      semantic: '囗',
      hint: 'enclosure',
    },
    radical: '囗',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '國',
    definition: 'country, nation, state; national',
    pinyin: ['guó'],
    decomposition: '⿴囗或',
    etymology: {
      type: 'ideographic',
      hint: "Treasure 或 within a country's borders 囗",
    },
    radical: '囗',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '圍',
    definition: 'to surround, to encircle, to corral',
    pinyin: ['wéi'],
    decomposition: '⿴囗韋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韋',
      semantic: '囗',
      hint: 'enclosure',
    },
    radical: '囗',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '園',
    definition: 'garden, park; orchard',
    pinyin: ['yuán'],
    decomposition: '⿴囗袁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '袁',
      semantic: '囗',
      hint: 'enclosure',
    },
    radical: '囗',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '圓',
    definition: 'circle; circular, round; complete',
    pinyin: ['yuán'],
    decomposition: '⿴囗員',
    etymology: {
      type: 'pictophonetic',
      phonetic: '員',
      semantic: '囗',
      hint: 'enclosure',
    },
    radical: '囗',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [0]],
  },
  {
    character: '圖',
    definition: 'diagram, chart, map, picture; to plan',
    pinyin: ['tú'],
    decomposition: '⿴囗啚',
    etymology: {
      type: 'ideographic',
      hint: "A map of a district's 啚 borders 囗",
    },
    radical: '囗',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
    ],
  },
  {
    character: '團',
    definition: 'sphere, circle, ball; mass, lump; group, regiment; to gather',
    pinyin: ['tuán'],
    decomposition: '⿴囗專',
    etymology: {
      type: 'ideographic',
      hint: 'A lot of talent 專 gathered in one place 囗',
    },
    radical: '囗',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
    ],
  },
  {
    character: '圙',
    definition: 'enclosed pasture',
    pinyin: ['lüè'],
    decomposition: '⿴囗⿱八面',
    etymology: { type: 'pictophonetic', semantic: '囗', hint: 'enclosure' },
    radical: '囗',
    matches: [
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [0],
    ],
  },
  {
    character: '圜',
    definition: 'circle; to surround, to encircle',
    pinyin: ['huán'],
    decomposition: '⿴囗睘',
    etymology: { type: 'ideographic', hint: 'A round 睘 fence 囗' },
    radical: '囗',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
    ],
  },
  {
    character: '土',
    definition: 'soil, earth; items made of earth',
    pinyin: ['tǔ'],
    decomposition: '⿱十一',
    etymology: {
      type: 'pictographic',
      hint: "A lump of clay on a potter's wheel",
    },
    radical: '土',
    matches: [[0], [0], [1]],
  },
  {
    character: '圣',
    definition: 'holy, sacred; sage, saint',
    pinyin: ['shèng'],
    decomposition: '⿱又土',
    etymology: {
      type: 'ideographic',
      hint: 'Simplified form of 聖; a king 王 of listening 耳  and speaking口',
    },
    radical: '土',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '圤',
    pinyin: ['pǔ'],
    decomposition: '⿰土卜',
    etymology: { type: 'pictophonetic', phonetic: '土' },
    radical: '土',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '在',
    definition:
      'at, in, on; to exist; used to indicate the present progressive tense',
    pinyin: ['zài'],
    decomposition: '⿸才土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '才',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '圩',
    definition: 'dike, embankment',
    pinyin: ['wéi'],
    decomposition: '⿰土于',
    etymology: {
      type: 'pictophonetic',
      phonetic: '于',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '圪',
    pinyin: ['gē'],
    decomposition: '⿰土乞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乞',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '圬',
    definition: 'to whitewash, to plaster over with mud',
    pinyin: ['wū'],
    decomposition: '⿰土亏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亏',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '圭',
    definition: 'jade tablet',
    pinyin: ['guī'],
    decomposition: '⿱土土',
    etymology: { type: 'ideographic', hint: 'A stack of tablets' },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '圮',
    definition: 'destroyed, ruined; to injure; to subvert',
    pinyin: ['pǐ'],
    decomposition: '⿰土己',
    etymology: {
      type: 'pictophonetic',
      phonetic: '己',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '圯',
    definition: 'bridge; river bank',
    pinyin: ['yí'],
    decomposition: '⿰土巳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巳',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '地',
    definition:
      'earth, ground, soil; land, region; structural particle used before a verb',
    pinyin: ['de'],
    decomposition: '⿰土也',
    etymology: {
      type: 'pictophonetic',
      phonetic: '也',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '圳',
    definition: 'a furrow in a field; a small drainage ditch',
    pinyin: ['zhèn'],
    decomposition: '⿰土川',
    etymology: {
      type: 'ideographic',
      hint: 'A furrow cut in the earth 土 by a stream 川; 川 also provides the pronunciation',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '圹',
    definition: 'tomb, grave: prairie, range, wilderness',
    pinyin: ['kuàng'],
    decomposition: '⿰土广',
    etymology: {
      type: 'pictophonetic',
      phonetic: '广',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '场',
    definition: 'field, open space; market, square; stage',
    pinyin: ['chǎng'],
    decomposition: '⿰土勿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昜',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '圻',
    definition: 'border, boundary',
    pinyin: ['qí'],
    decomposition: '⿰土斤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斤',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '圼',
    definition: 'slime, black mud',
    pinyin: ['niè'],
    decomposition: '⿱日土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '日',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '圾',
    definition: 'garbage, rubbish; shaking; danger',
    pinyin: ['jī'],
    decomposition: '⿰土及',
    etymology: {
      type: 'pictophonetic',
      phonetic: '及',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '址',
    definition: 'location, site; the foundation of a house',
    pinyin: ['zhǐ'],
    decomposition: '⿰土止',
    etymology: {
      type: 'pictophonetic',
      phonetic: '止',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '坂',
    definition: 'hillside, slope',
    pinyin: ['bǎn'],
    decomposition: '⿰土反',
    etymology: {
      type: 'pictophonetic',
      phonetic: '反',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '均',
    definition: 'equal, even, fair; level, uniform; also, too',
    pinyin: ['jūn'],
    decomposition: '⿰土匀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匀',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '坊',
    definition: 'neighborhood, district, community; street, lane; mill',
    pinyin: ['fāng'],
    decomposition: '⿰土方',
    etymology: {
      type: 'pictophonetic',
      phonetic: '方',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '坌',
    definition: 'dust; earth; river bank; to dig; to unite',
    pinyin: ['bèn'],
    decomposition: '⿱分土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '分',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '坍',
    definition: 'collapse; landslide',
    pinyin: ['tān'],
    decomposition: '⿰土丹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丹',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '坎',
    definition: 'pit, hole; to trap, to snare; crisis',
    pinyin: ['kǎn'],
    decomposition: '⿰土欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '欠',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '坏',
    definition: 'bad, rotten, spoiled; to break down',
    pinyin: ['huài'],
    decomposition: '⿰土不',
    etymology: {
      type: 'pictophonetic',
      phonetic: '不',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '坐',
    definition: 'seat; to sit; to ride, to travel by',
    pinyin: ['zuò'],
    decomposition: '⿻从土',
    etymology: {
      type: 'ideographic',
      hint: 'Two people 从 sitting on the ground 土',
    },
    radical: '土',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '坑',
    definition: 'pit, hole; to trap, to bury; to harry',
    pinyin: ['kēng'],
    decomposition: '⿰土亢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亢',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '坒',
    definition: 'to compare, to equal, to match',
    pinyin: ['bì'],
    decomposition: '⿱比土',
    etymology: {
      type: 'ideographic',
      hint: 'Comparing 比 pottery 土; 比 also provides the pronunciation',
    },
    radical: '土',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '块',
    definition: 'piece, lump, chunk; dollar; measure word for currency',
    pinyin: ['kuài'],
    decomposition: '⿰土夬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夬',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '坚',
    definition: 'hard, strong; firm, resolute',
    pinyin: ['jiān'],
    decomposition: '⿱⿰？又土',
    radical: '土',
    matches: [null, null, [0, 1], [0, 1], [1], [1], [1]],
  },
  {
    character: '坛',
    definition: 'altar; arena; examination hall',
    pinyin: ['tán'],
    decomposition: '⿰土云',
    etymology: {
      type: 'pictophonetic',
      phonetic: '云',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '坜',
    definition: 'drain, ditch, channel',
    pinyin: ['lì'],
    decomposition: '⿰土历',
    etymology: {
      type: 'pictophonetic',
      phonetic: '历',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '坝',
    definition: 'embankment; dam',
    pinyin: ['bà'],
    decomposition: '⿰土贝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贝',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '坞',
    definition: 'bank, entrenchment, low wall; dock',
    pinyin: ['wù'],
    decomposition: '⿰土乌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乌',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '坟',
    definition: 'grave, mound, bulge; bulging',
    pinyin: ['fén'],
    decomposition: '⿰土文',
    etymology: {
      type: 'pictophonetic',
      phonetic: '文',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '坠',
    definition: 'to drop, to fall down, to sink; heavy; weight',
    pinyin: ['zhuì'],
    decomposition: '⿱队土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '队',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '坡',
    definition: 'slope, hillside, embankment',
    pinyin: ['pō'],
    decomposition: '⿰土皮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皮',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '坤',
    definition: 'earth; feminine',
    pinyin: ['kūn'],
    decomposition: '⿰土申',
    etymology: {
      type: 'pictophonetic',
      phonetic: '土',
      semantic: '申',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '坦',
    definition: 'flat, level, smooth; candid, open',
    pinyin: ['tǎn'],
    decomposition: '⿰土旦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旦',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '坨',
    definition: 'lump, heap',
    pinyin: ['tuó'],
    decomposition: '⿰土它',
    etymology: {
      type: 'pictophonetic',
      phonetic: '它',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '坩',
    definition: 'crucible; earthenware, pottery',
    pinyin: ['gān'],
    decomposition: '⿰土甘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甘',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '坪',
    definition: 'plain; level ground',
    pinyin: ['píng'],
    decomposition: '⿰土平',
    etymology: {
      type: 'pictophonetic',
      phonetic: '平',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '坫',
    definition: 'a stand on which to replace goblets after drinking',
    pinyin: ['diàn'],
    decomposition: '⿰土占',
    etymology: {
      type: 'pictophonetic',
      phonetic: '占',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '坭',
    definition: 'mud, mire; to paste, to plaster',
    pinyin: ['ní'],
    decomposition: '⿰土尼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尼',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '坯',
    definition: 'clay; unburnt earthenware',
    pinyin: ['pī'],
    decomposition: '⿰土丕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丕',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '坳',
    definition: 'cavity, depression, hollow; depressed; undulating',
    pinyin: ['ào'],
    decomposition: '⿰土幼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '幼',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '坴',
    definition: 'a clod of earth; land',
    pinyin: ['lù'],
    decomposition: '⿱⿱土八土',
    etymology: {
      type: 'ideographic',
      hint: 'Soil 土 heaped 八 on the earth 土',
    },
    radical: '土',
    matches: [[0, 0], [0, 0], [0, 0], [0, 1], [0, 1], [1], [1], [1]],
  },
  {
    character: '坶',
    definition: 'mud, mire; to paste, to plaster',
    pinyin: ['mǔ'],
    decomposition: '⿰土母',
    etymology: {
      type: 'pictophonetic',
      phonetic: '母',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '坷',
    definition: 'uneven, bumpy; a clod of earth; a lump of soil',
    pinyin: ['kě'],
    decomposition: '⿰土可',
    etymology: {
      type: 'pictophonetic',
      phonetic: '可',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '坻',
    definition: 'islet; river delta, embankment; to stop',
    pinyin: ['chí'],
    decomposition: '⿰土氐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '氐',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '坼',
    definition: 'to crack, to open, to split, to tear',
    pinyin: ['chè'],
    decomposition: '⿰土斥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斥',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '垂',
    definition: 'to hang, to dangle; to hand down, to bequeath; almost, near',
    pinyin: ['chuí'],
    decomposition: '⿻⿱？士卄',
    etymology: { type: 'pictographic', hint: 'A tree with drooping branches' },
    radical: '土',
    matches: [null, null, [0, 1], [1], [1], [1], [0, 1], [0, 1]],
  },
  {
    character: '垃',
    definition: 'garbage, refuse, trash, waste',
    pinyin: ['lā'],
    decomposition: '⿰土立',
    etymology: {
      type: 'pictophonetic',
      phonetic: '立',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '垄',
    definition: 'grave, mound; furrow, ridge',
    pinyin: ['lǒng'],
    decomposition: '⿱龙土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龙',
      semantic: '土',
      hint: 'earth',
    },
    radical: '龙',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '垅',
    definition: 'grave, mound; furrow, ridge',
    pinyin: ['lǒng'],
    decomposition: '⿰土龙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龙',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '垆',
    definition: 'clay; hut, shop',
    pinyin: ['lú'],
    decomposition: '⿰土卢',
    etymology: {
      type: 'ideographic',
      hint: 'A cottage 卢 with earthen walls 土; 卢 also provides the pronunciation',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '型',
    definition: 'pattern, model, type; mold; law',
    pinyin: ['xíng'],
    decomposition: '⿱刑土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '刑',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '垌',
    definition: 'farm, field; used in place names',
    pinyin: ['dòng'],
    decomposition: '⿰土同',
    etymology: {
      type: 'pictophonetic',
      phonetic: '同',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '垒',
    definition: 'rampart; base (in baseball)',
    pinyin: ['lěi'],
    decomposition: '⿱厽土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厽',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '垓',
    definition: 'border, boundary, frontier',
    pinyin: ['gāi'],
    decomposition: '⿰土亥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亥',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '垔',
    definition:
      'to restrain; to dam a stream and change its direction; a mound',
    pinyin: ['yīn'],
    decomposition: '⿱西土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '西',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '垚',
    definition: 'mound, lump, round mass',
    pinyin: ['yáo'],
    decomposition: '⿱土⿰土土',
    etymology: { type: 'ideographic', hint: 'A mound 土 of clay 土' },
    radical: '土',
    matches: [[0], [0], [0], [1, 0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '垛',
    definition: 'heap, pile; to heap, to pile',
    pinyin: ['duǒ'],
    decomposition: '⿰土朵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朵',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '垠',
    definition: 'boundary, river bank',
    pinyin: ['yín'],
    decomposition: '⿰土艮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '艮',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '垡',
    definition: 'to plow; place name',
    pinyin: ['fá'],
    decomposition: '⿱伐土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '伐',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '垢',
    definition: 'dirt, filth, stains; dirty; disgraceful',
    pinyin: ['gòu'],
    decomposition: '⿰土后',
    etymology: {
      type: 'pictophonetic',
      phonetic: '后',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '垣',
    definition: 'low wall',
    pinyin: ['yuán'],
    decomposition: '⿰土亘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亘',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '垤',
    definition: 'anthill; hill mound',
    pinyin: ['dié'],
    decomposition: '⿰土至',
    etymology: {
      type: 'pictophonetic',
      phonetic: '至',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '垦',
    definition: 'to cultivate, to farm; to reclaim',
    pinyin: ['kěn'],
    decomposition: '⿱艮土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '艮',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '垧',
    definition: 'unit of area',
    pinyin: ['shǎng'],
    decomposition: '⿰土向',
    etymology: {
      type: 'pictophonetic',
      phonetic: '向',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '垩',
    definition: 'chalk; to daub with chalk; holy, sacred, sagacious',
    pinyin: ['è'],
    decomposition: '⿱亚土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亚',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '垫',
    definition: 'cushion, mat, pad; to advance money, to pay for another',
    pinyin: ['diàn'],
    decomposition: '⿱执土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '执',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '垭',
    definition: 'used in place names',
    pinyin: ['yā'],
    decomposition: '⿰土亚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亚',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '垮',
    definition: 'to be defeated, to collapse, to fail',
    pinyin: ['kuǎ'],
    decomposition: '⿰土夸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夸',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '垯',
    definition: 'lump, mound; pimple',
    pinyin: ['da'],
    decomposition: '⿰土达',
    etymology: {
      type: 'pictophonetic',
      phonetic: '达',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '垲',
    definition: 'a high and dry place',
    pinyin: ['kǎi'],
    decomposition: '⿰土岂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '岂',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '垴',
    definition: 'small hillock, used in place names',
    pinyin: ['nǎo'],
    decomposition: '⿰土⿱亠凶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '凶',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '垸',
    definition: 'dike, embankment',
    pinyin: ['yuàn'],
    decomposition: '⿰土完',
    etymology: {
      type: 'pictophonetic',
      phonetic: '完',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '埂',
    definition: 'ditch (for irrigation); hole',
    pinyin: ['gěng'],
    decomposition: '⿰土更',
    etymology: {
      type: 'pictophonetic',
      phonetic: '更',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '埃',
    definition: 'fine dust; dirt; Angstrom',
    pinyin: ['āi'],
    decomposition: '⿰土矣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '矣',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '埄',
    definition: 'dust storm; dust in the wind',
    pinyin: ['běng'],
    decomposition: '⿰土夆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夆',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '埇',
    definition: 'the name of a bridge',
    pinyin: ['yǒng'],
    decomposition: '⿰土甬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甬',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '埋',
    definition: 'to bury; to conceal; to plant',
    pinyin: ['mái'],
    decomposition: '⿰土里',
    etymology: {
      type: 'pictophonetic',
      phonetic: '里',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '城',
    definition: 'castle, city, town; municipality',
    pinyin: ['chéng'],
    decomposition: '⿰土成',
    etymology: {
      type: 'pictophonetic',
      phonetic: '成',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '埏',
    definition: 'boundary, limit',
    pinyin: ['shān'],
    decomposition: '⿰土延',
    etymology: { type: 'ideographic', hint: 'An earthen 土 roadblock 延' },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '埒',
    definition: 'enclosure, embankment, dike',
    pinyin: ['liè'],
    decomposition: '⿰土寽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寽',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '埔',
    definition: 'arena; market; plain; port',
    pinyin: ['bù'],
    decomposition: '⿰土甫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甫',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '埕',
    definition: 'a large, pear-shaped earthenware jar',
    pinyin: ['chéng'],
    decomposition: '⿰土呈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '呈',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '埗',
    definition: 'jetty, quay; port city, trade hub',
    pinyin: ['bù'],
    decomposition: '⿰土步',
    etymology: {
      type: 'pictophonetic',
      phonetic: '步',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '埘',
    definition: 'a chicken roost',
    pinyin: ['shí'],
    decomposition: '⿰土时',
    etymology: {
      type: 'pictophonetic',
      phonetic: '时',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '埙',
    definition: 'ocarina',
    pinyin: ['xūn'],
    decomposition: '⿰土员',
    etymology: {
      type: 'pictophonetic',
      phonetic: '员',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '埚',
    definition: 'crucible',
    pinyin: ['guō'],
    decomposition: '⿰土呙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '呙',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '埝',
    definition: 'dike, embankment; protuberance',
    pinyin: ['niàn'],
    decomposition: '⿰土念',
    etymology: {
      type: 'pictophonetic',
      phonetic: '念',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '域',
    definition:
      'area, district, field, land, region; boundary; domain (in taxonomy)',
    pinyin: ['yù'],
    decomposition: '⿰土或',
    etymology: {
      type: 'pictophonetic',
      phonetic: '或',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '埠',
    definition: 'jetty, quay; port city, trade hub',
    pinyin: ['bù'],
    decomposition: '⿰土阜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '阜',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '埡',
    definition: 'used in place names',
    pinyin: ['yā'],
    decomposition: '⿰土亞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亞',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '埤',
    definition: 'to add, to increase; to attach; fence, wall',
    pinyin: ['pí'],
    decomposition: '⿰土卑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卑',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '埭',
    definition: 'dam; a ramp leading up to a canal',
    pinyin: ['dài'],
    decomposition: '⿰土隶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隶',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '埯',
    definition: 'pit, hole; to bury',
    pinyin: ['ǎn'],
    decomposition: '⿰土奄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奄',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '埲',
    definition: 'dust storm',
    pinyin: ['běng'],
    decomposition: '⿰土奉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奉',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '埴',
    definition: 'soil with high clay content',
    pinyin: ['zhí'],
    decomposition: '⿰土直',
    etymology: {
      type: 'pictophonetic',
      phonetic: '直',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '埵',
    definition: 'hardened dirt or clay; cluster',
    pinyin: ['duǒ'],
    decomposition: '⿰土垂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '垂',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '埶',
    definition: 'art',
    pinyin: ['yì'],
    decomposition: '⿰坴丸',
    etymology: { type: 'ideographic', hint: 'Clay 坴 formed into a ball 丸' },
    radical: '土',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '執',
    definition: 'to execute; to grasp, to hold; to keep; to sieze, to detain',
    pinyin: ['zhí'],
    decomposition: '⿰幸丸',
    etymology: { type: 'ideographic', hint: 'A hand 幸 clutching a pebble 丸' },
    radical: '土',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '埸',
    definition: 'border, limit, frontier; dike',
    pinyin: ['yì'],
    decomposition: '⿰土易',
    etymology: {
      type: 'pictophonetic',
      phonetic: '易',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '培',
    definition: 'to cultivate, to farm; to shore up',
    pinyin: ['péi'],
    decomposition: '⿰土咅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咅',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '基',
    definition: 'foundation, base',
    pinyin: ['jī'],
    decomposition: '⿱其土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '其',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '埼',
    definition: 'headland',
    pinyin: ['qí'],
    decomposition: '⿰土奇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奇',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '埽',
    definition: 'broom; to sweep, to clear away',
    pinyin: ['sào'],
    decomposition: '⿰土帚',
    etymology: { type: 'ideographic', hint: 'To sweep 帚 away dirt 土' },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '堀',
    definition: 'cave, hole',
    pinyin: ['kū'],
    decomposition: '⿰土屈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屈',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '堂',
    definition: 'hall, large room; government office; cousins',
    pinyin: ['táng'],
    decomposition: '⿱尚土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尚',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '堃',
    definition: 'compliance, obedience; female',
    pinyin: ['kūn'],
    decomposition: '⿱⿰方方土',
    etymology: { type: 'pictophonetic', semantic: '土', hint: 'earth' },
    radical: '土',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '堅',
    definition: 'hard, strong; firm, resolute',
    pinyin: ['jiān'],
    decomposition: '⿱臤土',
    etymology: {
      type: 'ideographic',
      hint: 'A stern 臤 fortification 土; 臤 also provides the pronunciation',
    },
    radical: '土',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '堆',
    definition:
      'crowd, heap, pile, mass; to pile up; measure word for things in piles or stacks',
    pinyin: ['duī'],
    decomposition: '⿰土隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隹',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '堇',
    definition: 'yellow loam; clay; season; few',
    pinyin: ['jǐn'],
    decomposition: '⿱黄土',
    etymology: { type: 'ideographic', hint: 'Yellow 黄 earth 土' },
    radical: '土',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '堊',
    definition: 'chalk; to daub with chalk; holy, sacred, sagacious',
    pinyin: ['è'],
    decomposition: '⿱亞土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亞',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '堋',
    definition: 'to bury',
    pinyin: ['péng'],
    decomposition: '⿰土朋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朋',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '堍',
    definition: 'embankment',
    pinyin: ['tù'],
    decomposition: '⿰土兔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兔',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '堑',
    definition: 'moat, pit, trench; cavity',
    pinyin: ['qiàn'],
    decomposition: '⿱斩土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斩',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '堕',
    definition: 'to drop, to fall, to sink; degenerate',
    pinyin: ['duò'],
    decomposition: '⿱陏土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '陏',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '堙',
    definition: 'to bury; to dam, to block up; mound',
    pinyin: ['yīn'],
    decomposition: '⿰土垔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '垔',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '堞',
    definition: 'battlement; plate',
    pinyin: ['dié'],
    decomposition: '⿰土枼',
    etymology: { type: 'ideographic', hint: 'A flat 枼 earthen 土' },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '堠',
    definition: 'battlement, rampart',
    pinyin: ['hòu'],
    decomposition: '⿰土侯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '侯',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '堡',
    definition: 'fort, fortress; town, village',
    pinyin: ['bǎo'],
    decomposition: '⿱保土',
    etymology: {
      type: 'ideographic',
      hint: 'Earthen 土 walls built for defense 保; 保 also provides the meaning',
    },
    radical: '土',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '堤',
    definition: 'dike',
    pinyin: ['dī'],
    decomposition: '⿰土是',
    etymology: {
      type: 'pictophonetic',
      phonetic: '是',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '堪',
    definition: 'to endure; adequate, capable, worthy',
    pinyin: ['kān'],
    decomposition: '⿰土甚',
    etymology: {
      type: 'ideographic',
      hint: 'One with a considerable amount 甚 of land 土',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '堯',
    definition: 'a legendary ancient emperor-sage',
    pinyin: ['yáo'],
    decomposition: '⿱垚兀',
    etymology: {
      type: 'ideographic',
      hint: 'A mound 垚 borne by a man 兀; 垚 also provides the pronunciation',
    },
    radical: '土',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '堰',
    definition: 'dam, dike, embankment',
    pinyin: ['yàn'],
    decomposition: '⿰土匽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匽',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '報',
    definition: 'to announce, to report; newspaper; payback, revenge',
    pinyin: ['bào'],
    decomposition: '⿰幸⿱卩又',
    etymology: {
      type: 'ideographic',
      hint: 'A hand 幸 cuffing 又 a criminal 卩, representing sentencing',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '場',
    definition: 'field, open space; market, square; stage',
    pinyin: ['chǎng'],
    decomposition: '⿰土昜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昜',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '堵',
    definition: 'wall; to stop, to prevent, to block',
    pinyin: ['dǔ'],
    decomposition: '⿰土者',
    etymology: {
      type: 'pictophonetic',
      phonetic: '者',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '堿',
    definition: 'salty',
    pinyin: ['jiǎn'],
    decomposition: '⿰土咸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咸',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '塄',
    definition: 'a furrow in a field',
    pinyin: ['léng'],
    decomposition: '⿰土⿱罒方',
    etymology: {
      type: 'pictophonetic',
      phonetic: '罒',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '塊',
    definition: 'piece, lump, chunk; dollar; measure word for currency',
    pinyin: ['kuài'],
    decomposition: '⿰土鬼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鬼',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '塋',
    definition: 'grave, tomb, cemetary',
    pinyin: ['yíng'],
    decomposition: '⿳炏冖土',
    etymology: {
      type: 'ideographic',
      hint: 'Grass 炏 covering a buried 土 casket 冖',
    },
    radical: '土',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [2], [2], [2]],
  },
  {
    character: '塌',
    definition: 'to collapse, to fall into ruin',
    pinyin: ['tā'],
    decomposition: '⿰土⿱日羽',
    etymology: { type: 'pictophonetic', semantic: '土', hint: 'earth' },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '塍',
    definition: 'a raised path between fields, a dike',
    pinyin: ['chéng'],
    decomposition: '⿰月⿱龹土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '月',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '塑',
    definition: 'to sculpt, to model in clay; plastic',
    pinyin: ['sù'],
    decomposition: '⿱朔土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朔',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '塔',
    definition: 'tower, spire, tall building',
    pinyin: ['tǎ'],
    decomposition: '⿰土荅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '荅',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '塕',
    definition: 'airborne dust',
    pinyin: ['wěng'],
    decomposition: '⿰土翁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '翁',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '塗',
    definition: 'to smear, to scribble, to daub; surname',
    pinyin: ['tú'],
    decomposition: '⿱涂土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '余',
      semantic: '氵',
      hint: 'water',
    },
    radical: '土',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '塘',
    definition: 'pond, tank; dike, embankment',
    pinyin: ['táng'],
    decomposition: '⿰土唐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '唐',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '塚',
    definition: 'cemetery; tomb, burial mound',
    pinyin: ['zhǒng'],
    decomposition: '⿰土冢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冢',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '塞',
    definition:
      'to stop up, to seal, to cork, to block; pass, frontier; fortress',
    pinyin: ['sāi'],
    decomposition: '⿱宀⿱？土',
    etymology: { type: 'pictophonetic', semantic: '土', hint: 'earth' },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '塢',
    definition: 'bank, entrenchment, low wall; dock',
    pinyin: ['wù'],
    decomposition: '⿰土烏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '烏',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '塥',
    definition: 'a lump of clay',
    pinyin: ['gé'],
    decomposition: '⿰土鬲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鬲',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '填',
    definition: 'to fill, to pad, to stuff',
    pinyin: ['tián'],
    decomposition: '⿰土真',
    etymology: {
      type: 'pictophonetic',
      phonetic: '真',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '塬',
    definition: 'plateau',
    pinyin: ['yuán'],
    decomposition: '⿰土原',
    etymology: {
      type: 'pictophonetic',
      phonetic: '原',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '塲',
    definition: 'field, market, open space',
    pinyin: ['cháng'],
    decomposition: '⿰土⿱？昜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昜',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      null,
      null,
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '塵',
    definition: 'cinders, ashes, dust, dirt',
    pinyin: ['chén'],
    decomposition: '⿱鹿土',
    etymology: {
      type: 'ideographic',
      hint: 'Dust 土 kicked up by a fleeing deer 鹿',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '塹',
    definition: 'moat, pit, trench; cavity',
    pinyin: ['qiàn'],
    decomposition: '⿱斬土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斬',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '塾',
    definition: 'village school; private tutorage',
    pinyin: ['shú'],
    decomposition: '⿱孰土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孰',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '墀',
    definition: 'porch; courtyard; steps leading into a building',
    pinyin: ['chí'],
    decomposition: '⿰土犀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '犀',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '墁',
    definition: 'to plaster; to pave',
    pinyin: ['màn'],
    decomposition: '⿰土曼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曼',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '境',
    definition: 'boundary, frontier; area, region',
    pinyin: ['jìng'],
    decomposition: '⿰土竟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '竟',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '墅',
    definition: 'villa, country house',
    pinyin: ['shù'],
    decomposition: '⿱野土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '土',
      semantic: '野',
      hint: 'country',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '墉',
    definition: 'wall; fortification',
    pinyin: ['yōng'],
    decomposition: '⿰土庸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '庸',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '墊',
    definition: 'cushion, mat, pad; to advance money, to pay for another',
    pinyin: ['diàn'],
    decomposition: '⿱執土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '執',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '墒',
    definition: 'silt; moist soil',
    pinyin: ['shāng'],
    decomposition: '⿰土商',
    etymology: {
      type: 'pictophonetic',
      phonetic: '商',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '墓',
    definition: 'grave, tomb',
    pinyin: ['mù'],
    decomposition: '⿱莫土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '莫',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '墙',
    definition: 'wall',
    pinyin: ['qiáng'],
    decomposition: '⿰土啬',
    etymology: {
      type: 'pictophonetic',
      semantic: '土',
      hint: 'earth',
      phonetic: '啬',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '墚',
    definition: 'mountain range',
    pinyin: ['liáng'],
    decomposition: '⿰土梁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '梁',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '墜',
    definition: 'to drop, to fall down, to sink; heavy; weight',
    pinyin: ['zhuì'],
    decomposition: '⿱隊土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隊',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '增',
    definition: 'to increase; to expand; to augment; to add',
    pinyin: ['zēng'],
    decomposition: '⿰土曾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曾',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '墟',
    definition: 'high mound; hilly countryside; wasteland',
    pinyin: ['xū'],
    decomposition: '⿰土虚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '虚',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '墨',
    definition: 'ink; writing; Mexico',
    pinyin: ['mò'],
    decomposition: '⿱黑土',
    etymology: {
      type: 'ideographic',
      hint: 'Chalk made from black 黑 earth 土',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '墩',
    definition: 'stone block; heap, mound; pier',
    pinyin: ['dūn'],
    decomposition: '⿰土敦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敦',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '墮',
    definition: 'to drop, to fall, to sink; degenerate',
    pinyin: ['duò'],
    decomposition: '⿱隋土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隋',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '墳',
    definition: 'grave, mound, bulge; bulging',
    pinyin: ['fén'],
    decomposition: '⿰土賁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '賁',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '墻',
    definition: 'wall',
    pinyin: ['qiáng'],
    decomposition: '⿰土嗇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '嗇',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '墼',
    definition: 'unburnt bricks',
    pinyin: ['jī'],
    decomposition: '⿱⿰車殳土',
    etymology: { type: 'pictophonetic', semantic: '土', hint: 'earth' },
    radical: '土',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      null,
      null,
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '墾',
    definition: 'to cultivate, to farm; to reclaim',
    pinyin: ['kěn'],
    decomposition: '⿱貇土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '貇',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '壁',
    definition: 'partition, wall; rampart',
    pinyin: ['bì'],
    decomposition: '⿱辟土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辟',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '壅',
    definition: 'to block; to obstruct',
    pinyin: ['yōng'],
    decomposition: '⿱雍土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '雍',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '壇',
    definition: 'altar; arena; examination hall',
    pinyin: ['tán'],
    decomposition: '⿰土亶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亶',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '壑',
    definition: 'gully, pool; a ditch carved by a torrential rain',
    pinyin: ['hè'],
    decomposition: '⿱㕡土',
    etymology: {
      type: 'ideographic',
      hint: 'A ditch 㕡 carved in the earth 土; 㕡 also provides the pronunciation',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '壓',
    definition: 'press; oppress; crush; pressure',
    pinyin: ['yā'],
    decomposition: '⿱厭土',
    etymology: {
      type: 'ideographic',
      hint: 'Soil 土 crushed under pressure 厭; 厭 also provides the pronunciation',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '壕',
    definition: 'ditch; trench; channel, moat',
    pinyin: ['háo'],
    decomposition: '⿰土豪',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豪',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '壘',
    definition: 'rampart; base (in baseball)',
    pinyin: ['lěi'],
    decomposition: '⿱畾土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畾',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '壞',
    definition: 'bad, rotten, spoiled; to break down',
    pinyin: ['huài'],
    decomposition: '⿰土褱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '褱',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '壟',
    definition: 'grave, mound; furrow, ridge',
    pinyin: ['lǒng'],
    decomposition: '⿱龍土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龍',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '壢',
    definition: 'drain, ditch, channel',
    pinyin: ['lì'],
    decomposition: '⿰土歷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '歷',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '壤',
    definition: 'soil, loam, earth; rich',
    pinyin: ['rǎng'],
    decomposition: '⿰土襄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '襄',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '壩',
    definition: 'embankment; dam',
    pinyin: ['bà'],
    decomposition: '⿰土霸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '霸',
      semantic: '土',
      hint: 'earth',
    },
    radical: '土',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '士',
    definition: 'scholar, gentleman; soldier',
    pinyin: ['shì'],
    decomposition: '？',
    radical: '士',
    matches: [null, null, null],
  },
  {
    character: '壬',
    definition: '9th heavenly stem',
    pinyin: ['rén'],
    decomposition: '⿱丿士',
    radical: '士',
    matches: [[0], [1], [1], [1]],
  },
  {
    character: '壮',
    definition: 'big, large; robust, strong; the name of a tribe',
    pinyin: ['zhuàng'],
    decomposition: '⿰丬士',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丬',
      semantic: '士',
      hint: 'soldier',
    },
    radical: '士',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '壯',
    definition: 'big, large; robust, strong; the name of a tribe',
    pinyin: ['zhuàng'],
    decomposition: '⿰爿士',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爿',
      semantic: '士',
      hint: 'soldier',
    },
    radical: '士',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '声',
    definition: 'sound, noise; voice, tone, music',
    pinyin: ['shēng'],
    decomposition: '⿱士？',
    etymology: {
      type: 'ideographic',
      hint: 'Simplified form of 聲; see that character for the etymology',
    },
    radical: '士',
    matches: [[0], [0], [0], null, null, null, null],
  },
  {
    character: '壳',
    definition: 'casing, husk, shell',
    pinyin: ['ké'],
    decomposition: '⿱士冗',
    etymology: {
      type: 'ideographic',
      hint: 'A shell discarded 冗 by a soldier 士',
    },
    radical: '士',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '壴',
    definition: 'drum',
    pinyin: ['zhù'],
    decomposition: '⿱土口',
    etymology: {
      type: 'pictographic',
      hint: 'A drum 口 on a stand with feathers 土 on top',
    },
    radical: '士',
    matches: [[0], [0], [0], [1], [1], [1], null, null, null],
  },
  {
    character: '壶',
    definition: 'jar, pot, jug, vase; surname',
    pinyin: ['hú'],
    decomposition: '⿱士⿱冖业',
    etymology: { type: 'pictographic', hint: 'A jar of wine' },
    radical: '士',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '壹',
    definition: "one (bankers' anti-fraud numeral)",
    pinyin: ['yī'],
    decomposition: '⿱士⿱冖豆',
    radical: '士',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '壺',
    definition: 'jar, pot, jug, vase; surname',
    pinyin: ['hú'],
    decomposition: '⿱士亞',
    etymology: { type: 'pictographic', hint: 'A jar of wine' },
    radical: '士',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '壽',
    definition: 'old age, longevity; lifespan',
    pinyin: ['shòu'],
    decomposition: '⿳⿳士乛工一吋',
    etymology: { type: 'ideographic', hint: 'Ancient form of 老' },
    radical: '士',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 2],
      [0, 2],
      [0, 2],
      [1],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '夂',
    definition: 'to go',
    pinyin: ['zhǐ'],
    decomposition: '⿻丿又',
    radical: '夂',
    matches: [[0], [1], [1]],
  },
  {
    character: '夃',
    pinyin: ['gǔ'],
    decomposition: '⿵乃又',
    radical: '夂',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '处',
    definition: 'to reside at, to live in; place, locale; department',
    pinyin: ['chù'],
    decomposition: '⿺夂卜',
    etymology: {
      type: 'ideographic',
      hint: 'To go somewhere 夂 and put down a flag 卜',
    },
    radical: '夂',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '夅',
    definition: 'to descend, to fall; to drop, to lower',
    pinyin: ['jiàng'],
    decomposition: '⿱夂？',
    radical: '夂',
    matches: [[0], [0], [0], null, null, null],
  },
  {
    character: '夆',
    definition: 'to resist; to headbutt',
    pinyin: ['féng'],
    decomposition: '⿱夂丰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丰',
      semantic: '夂',
      hint: 'go',
    },
    radical: '夂',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '备',
    definition: 'to prepare; to get ready, to equip; ready; perfect',
    pinyin: ['bèi'],
    decomposition: '⿱夂田',
    etymology: {
      type: 'ideographic',
      hint: 'To go 夂 to the farm 田 to prepare for a harvest',
    },
    radical: '夂',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '夊',
    definition: 'to go slowly',
    pinyin: ['suī'],
    decomposition: '？',
    radical: '夊',
    matches: [null, null, null],
  },
  {
    character: '夋',
    definition: "to dawdle; the emperor Yao's father",
    pinyin: ['qūn'],
    decomposition: '⿳厶八夂',
    radical: '夂',
    matches: [[0], [0], [1], [1], [2], [2], [2]],
  },
  {
    character: '夌',
    definition: 'to dawdle; the name of the father of the Emperor Yao',
    pinyin: ['líng'],
    decomposition: '⿱⿱土八夂',
    radical: '夊',
    matches: [[0, 0], [0, 0], [0, 0], [0, 1], [0, 1], [1], [1], [1]],
  },
  {
    character: '复',
    definition: 'again, repeatedly; copy, duplicate; to restore, to return',
    pinyin: ['fù'],
    decomposition: '⿱亻⿱日夂',
    etymology: {
      type: 'ideographic',
      hint: 'A person 亻 who goes  somewhere 夂 every day 日',
    },
    radical: '夊',
    matches: [[0], [0], [1, 0], [1, 0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '夏',
    definition: 'summer; the Xia or Hsia dynasty',
    pinyin: ['xià'],
    decomposition: '⿳一自夂',
    radical: '夊',
    matches: [[0], [1], [1], [1], [1], [1], [1], [2], [2], [2]],
  },
  {
    character: '夔',
    definition: 'one-legged monster; walrus',
    pinyin: ['kuí'],
    decomposition: '⿳？⿲止自巳夊',
    etymology: {
      type: 'ideographic',
      hint: 'A monster with a face, a nose 自, and one foot 夊',
    },
    radical: '夊',
    matches: [
      null,
      null,
      null,
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 2],
      [1, 2],
      [1, 2],
      null,
      null,
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '夕',
    definition: 'evening, night, dusk; slanted',
    pinyin: ['xī'],
    decomposition: '⿻勹丶',
    etymology: { type: 'pictographic', hint: 'A crescent moon' },
    radical: '夕',
    matches: [[0], [0], [1]],
  },
  {
    character: '外',
    definition: 'out, outside, external; foreign; in addition',
    pinyin: ['wài'],
    decomposition: '⿰夕卜',
    etymology: {
      type: 'ideographic',
      hint: 'Night-time 夕 divinations 卜; the supernatural, the foreign',
    },
    radical: '夕',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '夗',
    definition: 'to turn over when asleep',
    pinyin: ['yuàn'],
    decomposition: '⿰夕㔾',
    etymology: {
      type: 'ideographic',
      hint: 'A person 㔾 curled up at night 夕',
    },
    radical: '夕',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '夙',
    definition: 'dawn, early in the morning; previous; long-held',
    pinyin: ['sù'],
    decomposition: '⿵几歹',
    radical: '夕',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '多',
    definition: 'much, many, multi-; more than, over',
    pinyin: ['duō'],
    decomposition: '⿱夕夕',
    etymology: { type: 'ideographic', hint: 'Two nights 夕, suggesting many' },
    radical: '夕',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '夜',
    definition: 'night, dark; under cover of night',
    pinyin: ['yè'],
    decomposition: '⿱亠⿰亻夕',
    etymology: {
      type: 'ideographic',
      hint: 'A person 亻 sneaking by under cover 亠 of night 夕',
    },
    radical: '夕',
    matches: [[0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1], null],
  },
  {
    character: '够',
    definition: 'enough, adequate; to reach, to attain; to pass muster',
    pinyin: ['gòu'],
    decomposition: '⿰句多',
    etymology: {
      type: 'pictophonetic',
      phonetic: '句',
      semantic: '多',
      hint: 'more',
    },
    radical: '夕',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '夠',
    definition: 'enough, adequate; to reach, to attain; to pass muster',
    pinyin: ['gòu'],
    decomposition: '⿰多句',
    etymology: {
      type: 'pictophonetic',
      phonetic: '多',
      semantic: '句',
      hint: 'more',
    },
    radical: '夕',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '夢',
    definition: 'dream',
    pinyin: ['mèng'],
    decomposition: '⿱艹⿱罒⿱冖夕',
    etymology: { type: 'ideographic', hint: 'Two eyes 艹 shut 罒 at night 夕' },
    radical: '夕',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
    ],
  },
  {
    character: '夤',
    definition: 'late at night; distant, remote; deep',
    pinyin: ['yín'],
    decomposition: '⿱夕寅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寅',
      semantic: '夕',
      hint: 'night',
    },
    radical: '夕',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '夥',
    definition: 'assistant; companion; partner; many, numerous',
    pinyin: ['huǒ'],
    decomposition: '⿰果多',
    etymology: {
      type: 'pictophonetic',
      phonetic: '果',
      semantic: '多',
      hint: 'more',
    },
    radical: '夕',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '大',
    definition: 'big, great, vast, high, deep',
    pinyin: ['dà'],
    decomposition: '⿻一人',
    etymology: { type: 'ideographic', hint: 'A man 人 with outstretched arms' },
    radical: '大',
    matches: [[0], [1], [1]],
  },
  {
    character: '天',
    definition: 'sky, heaven; god, celestial',
    pinyin: ['tiān'],
    decomposition: '⿱一大',
    etymology: { type: 'ideographic', hint: 'The heavens 一 above a man 大' },
    radical: '大',
    matches: [[0], [1], [1], [1]],
  },
  {
    character: '太',
    definition: 'very, too much; big; extreme',
    pinyin: ['tài'],
    decomposition: '⿵大丶',
    etymology: {
      type: 'ideographic',
      hint: 'A giant 大 with a normal-sized man 丶 for scale',
    },
    radical: '大',
    matches: [[0], [0], [0], [1]],
  },
  {
    character: '夫',
    definition: 'man, husband; worker; those',
    pinyin: ['fū'],
    decomposition: '⿻一大',
    etymology: {
      type: 'ideographic',
      hint: 'A man 大 wearing a coming-of-age hairpin 一',
    },
    radical: '大',
    matches: [[0], [1], [1], [1]],
  },
  {
    character: '夬',
    definition: 'decisive, certain; parted; fork',
    pinyin: ['guài'],
    decomposition: '⿻大？',
    radical: '大',
    matches: [null, [0], [0], [0]],
  },
  {
    character: '夭',
    definition: 'young, energetic; to die young',
    pinyin: ['yāo'],
    decomposition: '⿱丿大',
    etymology: {
      type: 'pictographic',
      hint: 'A person with head tilted - leaning forward, running, energetic',
    },
    radical: '大',
    matches: [[0], [1], [1], [1]],
  },
  {
    character: '央',
    definition: 'central; to beg; to run out',
    pinyin: ['yāng'],
    decomposition: '⿻冂大',
    radical: '大',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '夯',
    definition: 'burden, load; to lift up; to tamp down',
    pinyin: ['hāng'],
    decomposition: '⿱大力',
    etymology: {
      type: 'ideographic',
      hint: 'A load that takes great 大 strength 力',
    },
    radical: '大',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '失',
    definition: 'to lose; to make a mistake, to neglect',
    pinyin: ['shī'],
    decomposition: '⿻丿夫',
    etymology: {
      type: 'ideographic',
      hint: 'Something 丿 falling from a hand 夫',
    },
    radical: '大',
    matches: [[0], [1], [1], [1], [1]],
  },
  {
    character: '夲',
    definition: 'to advance quickly; to go back and forth; origin, source',
    pinyin: ['tāo'],
    decomposition: '⿱大十',
    radical: '大',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '头',
    definition: 'head; chief, boss; first, top',
    pinyin: ['tóu'],
    decomposition: '⿻⺀大',
    etymology: { type: 'pictophonetic', semantic: '大', hint: 'high' },
    radical: '大',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '夷',
    definition: 'ancient barbarian tribes',
    pinyin: ['yí'],
    decomposition: '⿻大弓',
    etymology: { type: 'ideographic', hint: 'A man 大 armed with a bow 弓' },
    radical: '大',
    matches: [[0], [1], [1], [1], [0], [0]],
  },
  {
    character: '夸',
    definition: 'extravagant, luxurious; handsome',
    pinyin: ['kuā'],
    decomposition: '⿱大亏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亏',
      semantic: '大',
      hint: 'great',
    },
    radical: '大',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '夹',
    definition: 'to support; to be wedged between',
    pinyin: ['jiā'],
    decomposition: '⿻夫丷',
    etymology: {
      type: 'ideographic',
      hint: 'A person 夫 stuck between two others 丷',
    },
    radical: '一',
    matches: [[0], [1], [1], [0], [0], [0]],
  },
  {
    character: '夺',
    definition: 'to rob, to snatch, to take by force',
    pinyin: ['duó'],
    decomposition: '⿱大寸',
    etymology: { type: 'ideographic', hint: 'A man 大 grasping something 寸' },
    radical: '大',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '夼',
    definition: 'depression, hollow, low ground',
    pinyin: ['kuǎng'],
    decomposition: '⿱大川',
    etymology: { type: 'ideographic', hint: 'A great 大 river bed 川' },
    radical: '大',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '夾',
    definition: 'to support; to be wedged between',
    pinyin: ['jiā'],
    decomposition: '⿻大从',
    etymology: {
      type: 'ideographic',
      hint: 'Two people 从 supporting someone 大 from either side',
    },
    radical: '大',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '奁',
    definition: "lady's vanity case; trousseau",
    pinyin: ['lián'],
    decomposition: '⿱大区',
    etymology: { type: 'ideographic', hint: 'A man 大 packing a suitcase 区' },
    radical: '大',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '奂',
    definition: 'numerous; brilliant',
    pinyin: ['huàn'],
    decomposition: '⿱⺈央',
    radical: '大',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '奄',
    definition: 'to remain, to tarry; feeble',
    pinyin: ['yǎn'],
    decomposition: '⿱大电',
    radical: '大',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '奇',
    definition: 'strange, unusual, odd; uncanny, occult',
    pinyin: ['qí'],
    decomposition: '⿱大可',
    etymology: { type: 'ideographic', hint: 'A person 大 riding a horse 可' },
    radical: '大',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '奈',
    definition: 'but, how; to bear, to stand, to endure',
    pinyin: ['nài'],
    decomposition: '⿱大示',
    etymology: { type: 'ideographic', hint: 'A man 大 with spirit 示' },
    radical: '大',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '奉',
    definition: 'to offer, to respect, to server; to receive',
    pinyin: ['fèng'],
    decomposition: '⿱⿻？大？',
    radical: '大',
    matches: [null, null, [0, 1], [0, 1], [0, 1], null, null, null],
  },
  {
    character: '奋',
    definition: 'to strive, to exert effort; to arouse',
    pinyin: ['fèn'],
    decomposition: '⿱大田',
    etymology: { type: 'ideographic', hint: 'A man 大 working on the farm 田' },
    radical: '大',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '奎',
    definition: "a man's stride; a constellation",
    pinyin: ['kuí'],
    decomposition: '⿱大圭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '圭',
      semantic: '大',
      hint: 'big',
    },
    radical: '大',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '奏',
    definition: 'to play; to memorialize; to report',
    pinyin: ['zòu'],
    decomposition: '⿱？天',
    etymology: {
      type: 'ideographic',
      hint: 'A report about (above) the emperor 天',
    },
    radical: '大',
    matches: [null, null, null, null, null, [1], [1], [1], [1]],
  },
  {
    character: '奐',
    definition: 'numerous; brilliant',
    pinyin: ['huàn'],
    decomposition: '⿱⿱？？大',
    radical: '大',
    matches: [null, null, null, null, null, null, [1], [1], [1]],
  },
  {
    character: '契',
    definition: 'deed, bond, contract; to engrave',
    pinyin: ['qì'],
    decomposition: '⿱⿰丰刀大',
    etymology: {
      type: 'ideographic',
      hint: 'A contract signed by cutting 刀 notches 丰 in wood 木 (now changed to 大)',
    },
    radical: '大',
    matches: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 1], [0, 1], [1], [1], [1]],
  },
  {
    character: '奓',
    definition: 'extravagant',
    pinyin: ['zhā'],
    decomposition: '⿱大多',
    etymology: { type: 'ideographic', hint: 'Excessive 多 largess 大' },
    radical: '大',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '奔',
    definition: 'to rush about; to run, to flee',
    pinyin: ['bēn'],
    decomposition: '⿱大卉',
    etymology: {
      type: 'ideographic',
      hint: 'A man 大 running through a field of grass 卉',
    },
    radical: '大',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '奕',
    definition: 'abundant; ordered, in sequence',
    pinyin: ['yì'],
    decomposition: '⿱亦大',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亦',
      semantic: '大',
      hint: 'big',
    },
    radical: '大',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '奖',
    definition: 'prize, reward; to award',
    pinyin: ['jiǎng'],
    decomposition: '⿱⿰丬夕大',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丬',
      semantic: '大',
      hint: 'big',
    },
    radical: '大',
    matches: [[0, 0], [0, 0], [0, 0], [0, 1], [0, 1], [0, 1], [1], [1], [1]],
  },
  {
    character: '套',
    definition: 'case, cover, envelope, wrapper',
    pinyin: ['tào'],
    decomposition: '⿱大镸',
    etymology: {
      type: 'ideographic',
      hint: 'A man 大 wrapped in a long 镸 cloth ',
    },
    radical: '大',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '奘',
    definition: 'fat, stout, thick; powerful, stocky',
    pinyin: ['zàng'],
    decomposition: '⿱壯大',
    etymology: {
      type: 'pictophonetic',
      phonetic: '壯',
      semantic: '大',
      hint: 'big',
    },
    radical: '大',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '奚',
    definition: 'where, what, why, how',
    pinyin: ['xī'],
    decomposition: '⿱爫⿱幺大',
    radical: '大',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '奠',
    definition: 'to found, to settle; to pay respects; a libation for the dead',
    pinyin: ['diàn'],
    decomposition: '⿱酋大',
    etymology: {
      type: 'ideographic',
      hint: 'A man 大 lifting up an offering of wine 酋',
    },
    radical: '大',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '奢',
    definition: 'exaggerated; extravagant, wasteful',
    pinyin: ['shē'],
    decomposition: '⿱大者',
    etymology: {
      type: 'pictophonetic',
      phonetic: '者',
      semantic: '大',
      hint: 'big',
    },
    radical: '大',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '奥',
    definition: 'mysterious, obscure, profound; used in transliterations',
    pinyin: ['ào'],
    decomposition: '⿱⿵宀米大',
    etymology: {
      type: 'ideographic',
      hint: 'A person 大 discovering a house 宀 full of rice 米',
    },
    radical: '大',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '奧',
    definition: 'mysterious, obscure, profound; used in transliterations',
    pinyin: ['ào'],
    decomposition: '⿱⿵？釆大',
    etymology: {
      type: 'ideographic',
      hint: 'A person 大 discovering a house full of rice 釆',
    },
    radical: '大',
    matches: [
      null,
      null,
      null,
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '奩',
    definition: "lady's vanity case; trousseau",
    pinyin: ['lián'],
    decomposition: '⿱大區',
    etymology: { type: 'ideographic', hint: 'A man 大 packing a suitcase 區' },
    radical: '大',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '奪',
    definition: 'to rob, to snatch, to take by force',
    pinyin: ['duó'],
    decomposition: '⿳大隹寸',
    etymology: { type: 'ideographic', hint: 'A man 大 grasping 寸 a bird 隹' },
    radical: '大',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '奭',
    definition: 'majestic, red; anger, ire; surname',
    pinyin: ['shì'],
    decomposition: '⿻大皕',
    radical: '大',
    matches: [
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
    ],
  },
  {
    character: '奮',
    definition: 'to strive, to exert effort; to arouse',
    pinyin: ['fèn'],
    decomposition: '⿳大隹田',
    etymology: { type: 'ideographic', hint: 'A man 大 working on the farm 田' },
    radical: '大',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '女',
    definition: 'woman, girl; female',
    pinyin: ['nǚ'],
    decomposition: '？',
    etymology: { type: 'pictographic', hint: 'A woman turned to the side' },
    radical: '女',
    matches: [null, null, null],
  },
  {
    character: '奴',
    definition: 'slave, servant',
    pinyin: ['nú'],
    decomposition: '⿰女又',
    etymology: {
      type: 'ideographic',
      hint: "A woman 女 standing by her master's right hand 又; 女 also provides the pronunciation",
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '奶',
    definition: 'milk; breasts; nurse, grandmother',
    pinyin: ['nǎi'],
    decomposition: '⿰女乃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乃',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '奸',
    definition: 'crafty, dishonest, selfish; evil, villainous; adultery',
    pinyin: ['jiān'],
    decomposition: '⿰女干',
    etymology: {
      type: 'pictophonetic',
      phonetic: '干',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '她',
    definition: 'she, her',
    pinyin: ['tā'],
    decomposition: '⿰女也',
    etymology: { type: 'ideographic', hint: 'A woman 女 beside you 也' },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '奼',
    definition: 'beautiful, colorful; girl',
    pinyin: ['chà'],
    decomposition: '⿰女乇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乇',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '好',
    definition: 'good, excellent, fine; proper, suitable; well',
    pinyin: ['hǎo'],
    decomposition: '⿰女子',
    etymology: { type: 'ideographic', hint: 'A woman 女 with a son 子' },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '妁',
    definition: 'matchmaker, go-between',
    pinyin: ['shuò'],
    decomposition: '⿰女勺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '勺',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '如',
    definition: 'as, as if, like, such as, supposing',
    pinyin: ['rú'],
    decomposition: '⿰女口',
    etymology: {
      type: 'ideographic',
      hint: "A wife 女 following her husband's words 口",
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '妃',
    definition: 'wife, spouse; imperial concubine',
    pinyin: ['fēi'],
    decomposition: '⿰女己',
    etymology: { type: 'ideographic', hint: "One's own 己 woman 女" },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '妄',
    definition: 'absurd, foolish, ignorant; rash, reckless, wild',
    pinyin: ['wàng'],
    decomposition: '⿱亡女',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亡',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '妆',
    definition: 'adornment, make-up; to dress up, to use make-up',
    pinyin: ['zhuāng'],
    decomposition: '⿰丬女',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丬',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '妇',
    definition: 'married woman; wife',
    pinyin: ['fù'],
    decomposition: '⿰女彐',
    etymology: {
      type: 'ideographic',
      hint: 'Simplified form of 婦; a woman 女 with a broom 彐',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '妈',
    definition: 'mother, mama',
    pinyin: ['mā'],
    decomposition: '⿰女马',
    etymology: {
      type: 'pictophonetic',
      phonetic: '马',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '妊',
    definition: 'to conceive; to be pregnant',
    pinyin: ['rèn'],
    decomposition: '⿰女壬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '壬',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '妍',
    definition: 'beautiful, handsome; seductive',
    pinyin: ['yán'],
    decomposition: '⿰女开',
    etymology: {
      type: 'ideographic',
      hint: 'A woman 女 who appears forward or open 开',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '妒',
    definition: 'jealous, envious',
    pinyin: ['dù'],
    decomposition: '⿰女户',
    etymology: {
      type: 'pictophonetic',
      phonetic: '户',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '妓',
    definition: 'prostitute',
    pinyin: ['jì'],
    decomposition: '⿰女支',
    etymology: {
      type: 'ideographic',
      hint: 'A working 支 woman 女; 支 also provides the pronunciation',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '妖',
    definition:
      'strange, weird, supernatural; bewitching, enchanting, seductive',
    pinyin: ['yāo'],
    decomposition: '⿰女夭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夭',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '妗',
    definition: "mother's brother's wife",
    pinyin: ['jìn'],
    decomposition: '⿰女今',
    etymology: {
      type: 'pictophonetic',
      phonetic: '今',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '妙',
    definition: 'mysterious, subtle; clever, exquisite, wonderful',
    pinyin: ['miào'],
    decomposition: '⿰女少',
    etymology: {
      type: 'pictophonetic',
      phonetic: '少',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '妝',
    definition: 'adornment, make-up; to dress up, to use make-up',
    pinyin: ['zhuāng'],
    decomposition: '⿰爿女',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爿',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '妞',
    definition: 'girl',
    pinyin: ['niū'],
    decomposition: '⿰女丑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丑',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '妟',
    definition: 'banquet, feast; to entertain',
    pinyin: ['yàn'],
    decomposition: '⿱日女',
    etymology: {
      type: 'ideographic',
      hint: 'A woman 女 cooking food 日 for a 宀 banquet; compare 宴',
    },
    radical: '女',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '妣',
    definition: "one's deceased mother",
    pinyin: ['bǐ'],
    decomposition: '⿰女比',
    etymology: {
      type: 'pictophonetic',
      phonetic: '比',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '妤',
    definition: 'beautiful, handsome, fair',
    pinyin: ['yú'],
    decomposition: '⿰女予',
    etymology: {
      type: 'pictophonetic',
      phonetic: '予',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '妥',
    definition: 'secure, sound; satisfactory, appropriate',
    pinyin: ['tuǒ'],
    decomposition: '⿱爫女',
    etymology: {
      type: 'ideographic',
      hint: 'A hand 爫 over a woman 女, representing control',
    },
    radical: '女',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '妨',
    definition: 'damage, harm; to impede, to obstruct; to undermine',
    pinyin: ['fáng'],
    decomposition: '⿰女方',
    etymology: {
      type: 'pictophonetic',
      phonetic: '方',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '妩',
    definition: 'charming, enchanting; to flatter, to please',
    pinyin: ['wǔ'],
    decomposition: '⿰女无',
    etymology: {
      type: 'pictophonetic',
      phonetic: '无',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '妪',
    definition: 'old woman, hag; to protect; to brood over',
    pinyin: ['yù'],
    decomposition: '⿰女区',
    etymology: {
      type: 'ideographic',
      hint: 'A woman 女 watching over her ward 区',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '妫',
    definition: 'surname',
    pinyin: ['guī'],
    decomposition: '⿰女为',
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '妮',
    definition: 'maid, servant girl; cute girl',
    pinyin: ['nī'],
    decomposition: '⿰女尼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尼',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '妯',
    definition: 'sister-in law',
    pinyin: ['zhóu'],
    decomposition: '⿰女由',
    etymology: {
      type: 'pictophonetic',
      phonetic: '由',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '妲',
    definition: 'concubine of the last Shang emperor',
    pinyin: ['dá'],
    decomposition: '⿰女旦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旦',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '妳',
    definition: 'you (female)',
    pinyin: ['nǎi'],
    decomposition: '⿰女尔',
    etymology: { type: 'ideographic', hint: 'You 尔 (female) 女' },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '妹',
    definition: 'younger sister',
    pinyin: ['mèi'],
    decomposition: '⿰女未',
    etymology: {
      type: 'pictophonetic',
      phonetic: '未',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '妻',
    definition: 'wife',
    pinyin: ['qī'],
    decomposition: '⿱⿻十彐女',
    etymology: {
      type: 'ideographic',
      hint: 'A woman 女 holding a broom 十 in her hand 彐',
    },
    radical: '女',
    matches: [[0, 0], [0, 1], [0, 1], [0, 1], [0, 0], [1], [1], [1]],
  },
  {
    character: '妾',
    definition: 'concubine',
    pinyin: ['qiè'],
    decomposition: '⿱辛女',
    etymology: {
      type: 'ideographic',
      hint: 'A woman 女 branded 辛 as a slave',
    },
    radical: '女',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '姆',
    definition: 'governess, matron, nanny',
    pinyin: ['mǔ'],
    decomposition: '⿰女母',
    etymology: {
      type: 'pictophonetic',
      phonetic: '母',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '姊',
    definition: 'elder sister',
    pinyin: ['zǐ'],
    decomposition: '⿰女？',
    radical: '女',
    matches: [[0], [0], [0], null, null, null, null],
  },
  {
    character: '始',
    definition: 'to begin, to start; beginning',
    pinyin: ['shǐ'],
    decomposition: '⿰女台',
    etymology: {
      type: 'pictophonetic',
      phonetic: '台',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '姐',
    definition: 'elder sister; miss, young lady',
    pinyin: ['jiě'],
    decomposition: '⿰女且',
    etymology: {
      type: 'pictophonetic',
      phonetic: '且',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '姑',
    definition: "father's sister; husband's mother",
    pinyin: ['gū'],
    decomposition: '⿰女古',
    etymology: {
      type: 'ideographic',
      hint: 'An older 古 woman 女; 古 also provides the pronunciation',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '姒',
    definition: "elder brother's wife; surname",
    pinyin: ['sì'],
    decomposition: '⿰女以',
    etymology: {
      type: 'pictophonetic',
      phonetic: '以',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '姓',
    definition: 'name, family name, surname; clan, people',
    pinyin: ['xìng'],
    decomposition: '⿰女生',
    etymology: {
      type: 'pictophonetic',
      phonetic: '生',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '委',
    definition: 'to appoint, to commission, to send',
    pinyin: ['wěi'],
    decomposition: '⿱禾女',
    radical: '女',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '姗',
    definition: 'to slander, to ridicule; to go slowly; graceful',
    pinyin: ['shān'],
    decomposition: '⿰女册',
    etymology: {
      type: 'pictophonetic',
      phonetic: '册',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '姘',
    definition: 'mistress, lover; an affair',
    pinyin: ['pīn'],
    decomposition: '⿰女并',
    etymology: {
      type: 'ideographic',
      hint: 'An affair 并 with a woman 女; 并 also provides the pronunciation',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '姚',
    definition: 'handsome, elegant, attractive; surname',
    pinyin: ['yáo'],
    decomposition: '⿰女兆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兆',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '姜',
    definition: 'ginger; surname',
    pinyin: ['jiāng'],
    decomposition: '⿱羊女',
    etymology: {
      type: 'ideographic',
      hint: 'Simplified form of 薑; grass 艹 provides the meaning while 畺 provides the pronunciation',
    },
    radical: '女',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '姝',
    definition: 'beautiful, charming, gorgeous; pretty girl',
    pinyin: ['shū'],
    decomposition: '⿰女朱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朱',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '姣',
    definition: 'beautiful, handsome, pretty',
    pinyin: ['jiāo'],
    decomposition: '⿰女交',
    etymology: {
      type: 'pictophonetic',
      phonetic: '交',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '姥',
    definition: 'maternal grandmother; midwife',
    pinyin: ['lǎo'],
    decomposition: '⿰女老',
    etymology: {
      type: 'ideographic',
      hint: 'An older 老 woman 女; 老 also provides the pronunciation',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '姦',
    definition: 'crafty, dishonest, selfish; evil, villainous; adultery',
    pinyin: ['jiān'],
    decomposition: '⿱女⿰女女',
    etymology: {
      type: 'ideographic',
      hint: 'Someone who flirts with many women 女',
    },
    radical: '女',
    matches: [[0], [0], [0], [1, 0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '姨',
    definition: "aunt, mother's sister",
    pinyin: ['yí'],
    decomposition: '⿰女夷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夷',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '姪',
    definition: 'niece',
    pinyin: ['zhí'],
    decomposition: '⿰女至',
    etymology: {
      type: 'pictophonetic',
      phonetic: '至',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '姫',
    definition: 'beauty; imperial concubine',
    pinyin: ['jī'],
    decomposition: '⿰女臣',
    etymology: { type: 'ideographic', hint: "A minister's 臣 consort 女" },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '姬',
    definition: 'beauty; imperial concubine',
    pinyin: ['jī'],
    decomposition: '⿰女臣',
    etymology: { type: 'ideographic', hint: 'An official 臣 woman 女' },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '姮',
    definition: 'lady',
    pinyin: ['héng'],
    decomposition: '⿰女亘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亘',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '姹',
    definition: 'beautiful, colorful; girl',
    pinyin: ['chà'],
    decomposition: '⿰女宅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宅',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '姻',
    definition: 'relatives by marriage',
    pinyin: ['yīn'],
    decomposition: '⿰女因',
    etymology: {
      type: 'ideographic',
      hint: 'A woman 女 related by 因 marriage',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '姿',
    definition: 'grace, good looks; bearing, poise, posture',
    pinyin: ['zī'],
    decomposition: '⿱次女',
    etymology: {
      type: 'pictophonetic',
      phonetic: '次',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '威',
    definition: 'might, power, prestige; to dominate',
    pinyin: ['wēi'],
    decomposition: '⿻戌女',
    etymology: {
      type: 'ideographic',
      hint: 'Dominating a woman 女 by force of arms 戈',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '娃',
    definition: 'baby; doll; pretty girl',
    pinyin: ['wá'],
    decomposition: '⿰女圭',
    etymology: {
      type: 'ideographic',
      hint: 'A girl 女 made of beautiful jade 圭',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '娄',
    definition: 'a constellation; to wear; surname',
    pinyin: ['lóu'],
    decomposition: '⿱米女',
    etymology: {
      type: 'ideographic',
      hint: 'A woman 女 looking up at a star 米',
    },
    radical: '女',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '娅',
    definition: 'a mutual term of address for sons-in-law or brothers-in-law',
    pinyin: ['yà'],
    decomposition: '⿰女亚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亚',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '娆',
    definition: 'graceful, charming, fascinating',
    pinyin: ['ráo'],
    decomposition: '⿰女尧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尧',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '娇',
    definition: 'seductive, lovable, tender; pampered; frail',
    pinyin: ['jiāo'],
    decomposition: '⿰女乔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乔',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '娈',
    definition: 'lovely, beautiful; docile, obedient',
    pinyin: ['luán'],
    decomposition: '⿱亦女',
    etymology: { type: 'ideographic', hint: 'Like 亦 a woman 女' },
    radical: '女',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '娉',
    definition: 'beautiful, charming, graceful',
    pinyin: ['pīng'],
    decomposition: '⿰女甹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甹',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '娌',
    definition: "brother's wife",
    pinyin: ['lǐ'],
    decomposition: '⿰女里',
    etymology: {
      type: 'pictophonetic',
      phonetic: '里',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '娑',
    definition: 'to dance, to frolic; to lounge; to saunter',
    pinyin: ['suō'],
    decomposition: '⿱沙女',
    etymology: {
      type: 'pictophonetic',
      phonetic: '沙',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '娓',
    definition: 'agreeable, compliant; to comply, to go along with',
    pinyin: ['wěi'],
    decomposition: '⿰女尾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尾',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '娘',
    definition: 'mother; young girl; woman; wife',
    pinyin: ['niáng'],
    decomposition: '⿰女良',
    etymology: {
      type: 'pictophonetic',
      phonetic: '良',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '娛',
    definition: 'pleasure, enjoyment, amusement',
    pinyin: ['yú'],
    decomposition: '⿰女吳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吳',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '娜',
    definition: 'elegant, graceful, delicate',
    pinyin: ['nà'],
    decomposition: '⿰女那',
    etymology: {
      type: 'pictophonetic',
      phonetic: '那',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '娟',
    definition: 'beautiful, graceful',
    pinyin: ['juān'],
    decomposition: '⿰女肙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肙',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '娠',
    definition: 'pregnant',
    pinyin: ['shēn'],
    decomposition: '⿰女辰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辰',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '娣',
    definition: "younger sister; younger brother's wife",
    pinyin: ['dì'],
    decomposition: '⿰女弟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弟',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '娥',
    definition: 'beautiful, pretty; good; surname',
    pinyin: ['é'],
    decomposition: '⿰女我',
    etymology: {
      type: 'pictophonetic',
      phonetic: '我',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '娩',
    definition: 'childbirth, labor',
    pinyin: ['miǎn'],
    decomposition: '⿰女免',
    etymology: {
      type: 'pictophonetic',
      phonetic: '免',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '娭',
    definition: "grandmother, father's mother; a term of respect",
    pinyin: ['āi'],
    decomposition: '⿰女矣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '矣',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '娱',
    definition: 'pleasure, enjoyment, amusement',
    pinyin: ['yú'],
    decomposition: '⿰女吴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吴',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '娲',
    definition: 'a goddess, the mythological sister and successor to Fuxi',
    pinyin: ['wā'],
    decomposition: '⿰女呙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '呙',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '娴',
    definition: 'elegant, refined, skillful',
    pinyin: ['xián'],
    decomposition: '⿰女闲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '闲',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '娶',
    definition: 'to marry, to take a wife',
    pinyin: ['qǔ'],
    decomposition: '⿱取女',
    etymology: {
      type: 'ideographic',
      hint: 'To take 取 a wife 女; 取 also provides the pronunciation',
    },
    radical: '女',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '娼',
    definition: 'prostitute, harlot',
    pinyin: ['chāng'],
    decomposition: '⿰女昌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昌',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '婀',
    definition: 'beautiful, graceful; lithe, willowy; unstable',
    pinyin: ['ē'],
    decomposition: '⿰女阿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '阿',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '婁',
    definition: 'a constellation; to wear; surname',
    pinyin: ['lóu'],
    decomposition: '⿱母女',
    etymology: {
      type: 'ideographic',
      hint: 'A daughter 女 looking up at her mother 母',
    },
    radical: '女',
    matches: [[0], [0], [0], [0], null, null, null, [0], [1], [1], [1]],
  },
  {
    character: '婆',
    definition: 'old woman; grandmother',
    pinyin: ['pó'],
    decomposition: '⿱波女',
    etymology: {
      type: 'pictophonetic',
      phonetic: '波',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '婉',
    definition: 'amiable, graceful, tactful; restrained',
    pinyin: ['wǎn'],
    decomposition: '⿰女宛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宛',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '婊',
    definition: 'whore, prostitute',
    pinyin: ['biǎo'],
    decomposition: '⿰女表',
    etymology: {
      type: 'pictophonetic',
      phonetic: '表',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '婕',
    definition: 'handsome',
    pinyin: ['jié'],
    decomposition: '⿰女疌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '疌',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '婚',
    definition: 'to get married; marriage, wedding',
    pinyin: ['hūn'],
    decomposition: '⿰女昏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昏',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '婢',
    definition: 'servant girl; maidservant',
    pinyin: ['bì'],
    decomposition: '⿰女卑',
    etymology: {
      type: 'ideographic',
      hint: 'A humble 卑 woman 女; 卑 also provides the pronunciation',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '婦',
    definition: 'married woman; wife',
    pinyin: ['fù'],
    decomposition: '⿰女帚',
    etymology: { type: 'ideographic', hint: 'A woman 女 with a broom 帚' },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '婧',
    definition: 'modest; supple',
    pinyin: ['jìng'],
    decomposition: '⿰女青',
    etymology: {
      type: 'ideographic',
      hint: 'Like a young 青 woman 女; 青 also provides the pronunciation',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '婪',
    definition: 'to covet; covetous, avaricious',
    pinyin: ['lán'],
    decomposition: '⿱林女',
    etymology: {
      type: 'pictophonetic',
      phonetic: '林',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '婭',
    definition: 'a mutual term of address for sons-in-law or brothers-in-law',
    pinyin: ['yà'],
    decomposition: '⿰女亞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亞',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '婴',
    definition: 'baby, infant; to bother',
    pinyin: ['yīng'],
    decomposition: '⿱⿰贝贝女',
    etymology: { type: 'pictophonetic', semantic: '女', hint: 'woman' },
    radical: '女',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '婵',
    definition: 'beautiful, graceful, lovely, pretty',
    pinyin: ['chán'],
    decomposition: '⿰女单',
    etymology: {
      type: 'pictophonetic',
      phonetic: '单',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '婶',
    definition: "father's younger brother's wife",
    pinyin: ['shěn'],
    decomposition: '⿰女审',
    etymology: {
      type: 'pictophonetic',
      phonetic: '审',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '婷',
    definition: 'attractive, graceful, pretty',
    pinyin: ['tíng'],
    decomposition: '⿰女亭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亭',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '婺',
    definition: 'beautiful; the name of a star',
    pinyin: ['wù'],
    decomposition: '⿱敄女',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敄',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '婿',
    definition: 'son-in-law; husband',
    pinyin: ['xù'],
    decomposition: '⿰女胥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '胥',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '媒',
    definition: 'go-between, matchmaker; medium',
    pinyin: ['méi'],
    decomposition: '⿰女某',
    etymology: {
      type: 'pictophonetic',
      phonetic: '某',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '媕',
    definition: 'undecided',
    pinyin: ['ān'],
    decomposition: '⿰女弇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弇',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '媚',
    definition: 'attractive, charming; to charm, to flatter',
    pinyin: ['mèi'],
    decomposition: '⿰女眉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '眉',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '媛',
    definition: 'beauty; beautiful woman',
    pinyin: ['yuàn'],
    decomposition: '⿰女爰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爰',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '媠',
    definition: 'beautiful',
    pinyin: ['tuǒ'],
    decomposition: '⿰女⿱？⺼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '⺼',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      null,
      null,
      null,
      null,
      null,
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '媧',
    definition: 'a goddess, the mythological sister and successor to Fuxi',
    pinyin: ['wā'],
    decomposition: '⿰女咼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咼',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '媪',
    definition: 'old woman; lower-class woman',
    pinyin: ['ǎo'],
    decomposition: '⿰女昷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昷',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '媲',
    definition: 'to marry off; to compare, to match, to pair up',
    pinyin: ['pì'],
    decomposition: '⿰女？',
    etymology: { type: 'pictophonetic', semantic: '女', hint: 'woman' },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    ],
  },
  {
    character: '媳',
    definition: 'daughter-in-law',
    pinyin: ['xí'],
    decomposition: '⿰女息',
    etymology: {
      type: 'pictophonetic',
      phonetic: '息',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '媵',
    definition:
      'concubine; escort; a maid who accompanies a bride to her new home',
    pinyin: ['yìng'],
    decomposition: '⿸朕女',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朕',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '媷',
    pinyin: ['rù'],
    decomposition: '⿰女辱',
    etymology: { type: 'pictophonetic', phonetic: '辱', semantic: '女' },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '媸',
    definition: 'ugly; an ugly woman',
    pinyin: ['chī'],
    decomposition: '⿰女蚩',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蚩',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '媽',
    definition: 'mother, mama',
    pinyin: ['mā'],
    decomposition: '⿰女馬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '馬',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '媾',
    definition: 'to marry; to be intimate with',
    pinyin: ['gòu'],
    decomposition: '⿰女冓',
    etymology: {
      type: 'ideographic',
      hint: "To know a woman's 女 secret 冓; 冓 also provides the pronunciation",
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嫁',
    definition: 'to marry, to give a daughter in marriage',
    pinyin: ['jià'],
    decomposition: '⿰女家',
    etymology: {
      type: 'pictophonetic',
      phonetic: '家',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嫂',
    definition: "sister-in-law, elder brother's wife",
    pinyin: ['sǎo'],
    decomposition: '⿰女叟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叟',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嫉',
    definition: 'jealous, envious',
    pinyin: ['jí'],
    decomposition: '⿰女疾',
    etymology: {
      type: 'ideographic',
      hint: 'An envious 疾 woman 女; 疾 also provides the pronunciation',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嫌',
    definition: 'to hate, to detest; to criticize; to suspect',
    pinyin: ['xián'],
    decomposition: '⿰女兼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兼',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嫒',
    definition: "one's daughter (honorific)",
    pinyin: ['ài'],
    decomposition: '⿰女爱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爱',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嫔',
    definition: 'courtesan; palace maid',
    pinyin: ['pín'],
    decomposition: '⿰女宾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宾',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嫖',
    definition: 'to patronize a prostitute; to frequent',
    pinyin: ['piáo'],
    decomposition: '⿰女票',
    etymology: {
      type: 'pictophonetic',
      phonetic: '票',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嫗',
    definition: 'old woman, hag; to protect; to brood over',
    pinyin: ['yù'],
    decomposition: '⿰女區',
    etymology: {
      type: 'ideographic',
      hint: 'A woman 女 watching over her ward 區',
    },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嫘',
    definition: 'surname',
    pinyin: ['léi'],
    decomposition: '⿰女累',
    etymology: {
      type: 'pictophonetic',
      phonetic: '累',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嫚',
    definition: 'to scorn, to despise; to be rude to, to affront',
    pinyin: ['mān'],
    decomposition: '⿰女曼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曼',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嫜',
    definition: "husband's mother; the lady in the moon",
    pinyin: ['zhāng'],
    decomposition: '⿰女章',
    etymology: {
      type: 'pictophonetic',
      phonetic: '章',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嫠',
    definition: 'widow',
    pinyin: ['lí'],
    decomposition: '⿱⿰未攵⿸厂女',
    etymology: { type: 'pictophonetic', semantic: '女' },
    radical: '女',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '嫡',
    definition: "wife, wife's child",
    pinyin: ['dí'],
    decomposition: '⿰女啇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '啇',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嫣',
    definition: 'captivating, charming, fascinating',
    pinyin: ['yān'],
    decomposition: '⿰女焉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '焉',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嫦',
    definition: 'a moon goddess, the lady in the moon',
    pinyin: ['cháng'],
    decomposition: '⿰女常',
    etymology: {
      type: 'pictophonetic',
      phonetic: '常',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嫩',
    definition: 'soft, delicate; young, tender',
    pinyin: ['nèn'],
    decomposition: '⿰女敕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敕',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嫪',
    definition: 'to hanker after',
    pinyin: ['lào'],
    decomposition: '⿰女翏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '翏',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嫫',
    definition: "Huangdi's ugly concubine; ugly woman, nurse",
    pinyin: ['mó'],
    decomposition: '⿰女莫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '莫',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嫱',
    definition: 'lady',
    pinyin: ['qiáng'],
    decomposition: '⿰女啬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '啬',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嫵',
    definition: 'charming, enchanting; to flatter, to please',
    pinyin: ['wǔ'],
    decomposition: '⿰女無',
    etymology: {
      type: 'pictophonetic',
      phonetic: '無',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嫻',
    definition: 'elegant, refined, skillful',
    pinyin: ['xián'],
    decomposition: '⿰女閑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '閑',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嬈',
    definition: 'graceful, charming, fascinating',
    pinyin: ['ráo'],
    decomposition: '⿰女堯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堯',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嬉',
    definition: 'to enjoy; to play, to amuse oneself',
    pinyin: ['xī'],
    decomposition: '⿰女喜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '喜',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嬋',
    definition: 'beautiful, graceful, lovely, pretty',
    pinyin: ['chán'],
    decomposition: '⿰女單',
    etymology: {
      type: 'pictophonetic',
      phonetic: '單',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嬌',
    definition: 'seductive, lovable, tender; pampered; frail',
    pinyin: ['jiāo'],
    decomposition: '⿰女喬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '喬',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嬖',
    definition: 'a favorite, a minion; to show favor; to enjoy the favor of',
    pinyin: ['bì'],
    decomposition: '⿱辟女',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辟',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嬗',
    definition: 'succession to the throne',
    pinyin: ['shàn'],
    decomposition: '⿰女亶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亶',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嬛',
    definition: 'apt, clever; flatterer, sycophant',
    pinyin: ['huán'],
    decomposition: '⿰女睘',
    etymology: {
      type: 'ideographic',
      hint: 'To stare 睘 after a woman 女; 睘 also provides the pronunciation',
    },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嬪',
    definition: 'courtesan; palace maid',
    pinyin: ['pín'],
    decomposition: '⿰女賓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '賓',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嬰',
    definition: 'baby, infant; to bother',
    pinyin: ['yīng'],
    decomposition: '⿱賏女',
    etymology: { type: 'pictophonetic', semantic: '女', hint: 'woman' },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嬲',
    definition: 'to tease, to play, to flirt; to frolic',
    pinyin: ['niǎo'],
    decomposition: '⿲男女男',
    etymology: {
      type: 'ideographic',
      hint: 'A woman 女 flirting with two men 男',
    },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '嬴',
    definition: 'victory; to win; surname',
    pinyin: ['yíng'],
    decomposition: '⿳亡口⿲月女凡',
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [2, 0],
      [2, 0],
      [2, 0],
      [2, 0],
      [2, 1],
      [2, 1],
      [2, 1],
      [2, 2],
      [2, 2],
      [2, 2],
    ],
  },
  {
    character: '嬷',
    definition: 'mother',
    pinyin: ['mā'],
    decomposition: '⿰女麽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '麽',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嬸',
    definition: "father's younger brother's wife",
    pinyin: ['shěn'],
    decomposition: '⿰女審',
    etymology: {
      type: 'pictophonetic',
      phonetic: '審',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '孀',
    definition: 'widow',
    pinyin: ['shuāng'],
    decomposition: '⿰女霜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '霜',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '孃',
    definition: 'troubled, oppressed; fat; mother',
    pinyin: ['niáng'],
    decomposition: '⿰女襄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '襄',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '孌',
    definition: 'lovely, beautiful; docile, obedient',
    pinyin: ['luán'],
    decomposition: '⿱䜌女',
    etymology: {
      type: 'pictophonetic',
      phonetic: '䜌',
      semantic: '女',
      hint: 'woman',
    },
    radical: '女',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '子',
    definition: 'son, child; seed, egg; fruit; small thing',
    pinyin: ['zi'],
    decomposition: '⿻了一',
    etymology: {
      type: 'pictographic',
      hint: 'A child in a wrap, with outstretched arms but bundled legs',
    },
    radical: '子',
    matches: [[0], [0], [1]],
  },
  {
    character: '孑',
    definition: 'alone, lonely, solitary; remaining, left-over',
    pinyin: ['jié'],
    decomposition: '？',
    radical: '孑',
    matches: [null, null, null],
  },
  {
    character: '孓',
    definition: 'mosquito larva',
    pinyin: ['jué'],
    decomposition: '子',
    etymology: { type: 'pictophonetic', semantic: '子', hint: 'seed' },
    radical: '子',
    matches: [[], [], []],
  },
  {
    character: '孔',
    definition: 'opening, hole, orifice; great',
    pinyin: ['kǒng'],
    decomposition: '⿰子乚',
    etymology: {
      type: 'ideographic',
      hint: 'The mouth 乚 of a crying baby 子',
    },
    radical: '子',
    matches: [[0], [0], [0], [1]],
  },
  {
    character: '孕',
    definition: 'pregnant; pregnancy',
    pinyin: ['yùn'],
    decomposition: '⿱乃子',
    etymology: {
      type: 'ideographic',
      hint: 'A woman delivering 乃 a child 子',
    },
    radical: '子',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '字',
    definition: 'character, letter, symbol, word',
    pinyin: ['zì'],
    decomposition: '⿱宀子',
    etymology: {
      type: 'ideographic',
      hint: 'A child 子 in a house 宀; 子 also provides the pronunciation',
    },
    radical: '子',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '存',
    definition:
      'to exist; to survive, to maintain; to keep, to store; to deposit',
    pinyin: ['cún'],
    decomposition: '⿸才子',
    etymology: {
      type: 'pictophonetic',
      phonetic: '才',
      semantic: '子',
      hint: 'seed',
    },
    radical: '子',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '孙',
    definition: 'grandchild, descendent; surname',
    pinyin: ['sūn'],
    decomposition: '⿰子小',
    etymology: {
      type: 'ideographic',
      hint: 'Simplified form of 孫; a chain 系 of descent 子',
    },
    radical: '子',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '孚',
    definition: 'to brood over eggs; to have confidence',
    pinyin: ['fú'],
    decomposition: '⿱爫子',
    etymology: { type: 'ideographic', hint: 'A bird clutching 爫 its eggs 子' },
    radical: '子',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '孛',
    definition: 'comet',
    pinyin: ['bèi'],
    decomposition: '⿱十⿱冖子',
    radical: '子',
    matches: [[0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '孜',
    definition: 'diligent, hard-working',
    pinyin: ['zī'],
    decomposition: '⿰子攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '子',
      semantic: '攵',
      hint: 'script',
    },
    radical: '子',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '孝',
    definition: 'filial piety, obedience; mourning',
    pinyin: ['xiào'],
    decomposition: '⿸耂子',
    etymology: {
      type: 'ideographic',
      hint: 'A young man 子 carrying an older man 耂',
    },
    radical: '子',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '孟',
    definition: 'first in a series; great, eminent',
    pinyin: ['mèng'],
    decomposition: '⿱子皿',
    etymology: {
      type: 'ideographic',
      hint: 'A child 子 sitting on a throne 皿',
    },
    radical: '子',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '孢',
    definition: 'spore',
    pinyin: ['bāo'],
    decomposition: '⿰子包',
    etymology: {
      type: 'pictophonetic',
      phonetic: '包',
      semantic: '子',
      hint: 'seed',
    },
    radical: '子',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '季',
    definition: 'a quarter-year, a season; surname',
    pinyin: ['jì'],
    decomposition: '⿱禾子',
    etymology: {
      type: 'ideographic',
      hint: 'The time for planting seeds 子 of grain 禾',
    },
    radical: '子',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '孤',
    definition: 'orphaned; alone, lonely, solidary',
    pinyin: ['gū'],
    decomposition: '⿰子瓜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '瓜',
      semantic: '子',
      hint: 'child',
    },
    radical: '子',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '孥',
    definition: "one's children",
    pinyin: ['nú'],
    decomposition: '⿱奴子',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奴',
      semantic: '子',
      hint: 'son',
    },
    radical: '子',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '学',
    definition:
      'learning, knowledge, science; to study, to go to school; -ology',
    pinyin: ['xué'],
    decomposition: '⿱⿱⺍冖子',
    etymology: {
      type: 'ideographic',
      hint: 'A building 冖 where children 子 study; ⺍ provides the pronunciation',
    },
    radical: '子',
    matches: [[0, 0], [0, 0], [0, 0], [0, 1], [0, 1], [1], [1], [1]],
  },
  {
    character: '孨',
    definition: 'cautious, cowardly, weak; an orphan',
    pinyin: ['zhuǎn'],
    decomposition: '⿱子⿰子子',
    etymology: {
      type: 'ideographic',
      hint: 'Many abandoned children 子 representing an orphanage',
    },
    radical: '子',
    matches: [[0], [0], [0], [1, 0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '孩',
    definition: 'baby, child; children',
    pinyin: ['hái'],
    decomposition: '⿰子亥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亥',
      semantic: '子',
      hint: 'child',
    },
    radical: '子',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '孪',
    definition: 'twins',
    pinyin: ['luán'],
    decomposition: '⿱亦子',
    etymology: {
      type: 'ideographic',
      hint: 'Giving birth to a second 亦 child 子',
    },
    radical: '子',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '孫',
    definition: 'grandchild, descendent; surname',
    pinyin: ['sūn'],
    decomposition: '⿰子系',
    etymology: { type: 'ideographic', hint: 'A chain 系 of descent 子' },
    radical: '子',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '孬',
    definition: 'bad, cowardly, useless; rogue, scoundrel',
    pinyin: ['nāo'],
    decomposition: '⿱不好',
    etymology: { type: 'ideographic', hint: 'Not 不 good 好' },
    radical: '子',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '孰',
    definition: 'who? which? what? which one?',
    pinyin: ['shú'],
    decomposition: '⿰享丸',
    radical: '子',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '孱',
    definition: 'feeble, frail, weak; unfit',
    pinyin: ['càn'],
    decomposition: '⿸尸孨',
    etymology: { type: 'ideographic', hint: 'Weak 孨 in body 尸' },
    radical: '子',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '孳',
    definition: 'to breed; to produce, to bear; to grow recklessly',
    pinyin: ['zī'],
    decomposition: '⿱兹子',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兹',
      semantic: '子',
      hint: 'child',
    },
    radical: '子',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '孵',
    definition: 'to brood over eggs, to incubate, to hatch',
    pinyin: ['fū'],
    decomposition: '⿰卵孚',
    etymology: { type: 'ideographic', hint: 'To brood 孚 over eggs 卵' },
    radical: '子',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '學',
    definition:
      'learning, knowledge, science; to study, to go to school; -ology',
    pinyin: ['xué'],
    decomposition: '⿳？冖子',
    etymology: {
      type: 'ideographic',
      hint: 'A building 冖 where children 子 study',
    },
    radical: '子',
    matches: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [1],
      [1],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '孺',
    definition: 'child; blood relation; affection',
    pinyin: ['rú'],
    decomposition: '⿰子需',
    etymology: {
      type: 'pictophonetic',
      phonetic: '需',
      semantic: '子',
      hint: 'child',
    },
    radical: '子',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '孽',
    definition: 'bastard child; the consequence of a sin; evil',
    pinyin: ['niè'],
    decomposition: '⿱薛子',
    etymology: {
      type: 'pictophonetic',
      phonetic: '薛',
      semantic: '子',
      hint: 'child',
    },
    radical: '子',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '孿',
    definition: 'twins',
    pinyin: ['luán'],
    decomposition: '⿱䜌子',
    etymology: {
      type: 'pictophonetic',
      phonetic: '䜌',
      semantic: '子',
      hint: 'child',
    },
    radical: '子',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '宀',
    definition: 'roof; house',
    pinyin: ['gài', 'mián'],
    decomposition: '⿱丶冖',
    radical: '宀',
    matches: [[0], [1], [1]],
  },
  {
    character: '宁',
    definition: 'calm, peaceful; healthy; rather; to prefer',
    pinyin: ['níng'],
    decomposition: '⿱宀丁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丁',
      semantic: '宀',
      hint: 'roof',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '它',
    definition: 'it; other',
    pinyin: ['tā'],
    decomposition: '⿱宀匕',
    radical: '宀',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '宄',
    definition: 'traitor; villain',
    pinyin: ['guǐ'],
    decomposition: '⿱宀九',
    etymology: {
      type: 'pictophonetic',
      phonetic: '九',
      semantic: '宀',
      hint: 'house',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '宅',
    definition: 'residence, dwelling, home; grave',
    pinyin: ['zhái'],
    decomposition: '⿱宀乇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乇',
      semantic: '宀',
      hint: 'roof',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '宇',
    definition: 'building, house, room, structure; space, the universe',
    pinyin: ['yǔ'],
    decomposition: '⿱宀于',
    etymology: {
      type: 'pictophonetic',
      phonetic: '于',
      semantic: '宀',
      hint: 'building',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '守',
    definition: 'to defend, to guard, to protect; to conserve; to wait',
    pinyin: ['shǒu'],
    decomposition: '⿱宀寸',
    etymology: {
      type: 'ideographic',
      hint: "Keeping something 寸 within one's walls 宀",
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '安',
    definition: 'peaceful, tranquil, quiet',
    pinyin: ['ān'],
    decomposition: '⿱宀女',
    etymology: { type: 'ideographic', hint: 'A woman 女 safe in a house 宀' },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '宋',
    definition: 'the Song dynasty; surname',
    pinyin: ['sòng'],
    decomposition: '⿱宀木',
    etymology: {
      type: 'ideographic',
      hint: 'A building 宀 made out of wood 木',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '完',
    definition: 'to complete, to finish, to settle; whole',
    pinyin: ['wán'],
    decomposition: '⿱宀元',
    etymology: {
      type: 'pictophonetic',
      phonetic: '元',
      semantic: '宀',
      hint: 'roof',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '宏',
    definition: 'great, spacious, vast, wide',
    pinyin: ['hóng'],
    decomposition: '⿱宀厷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厷',
      semantic: '宀',
      hint: 'building',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '宓',
    definition: 'quiet, silent, still; in good health',
    pinyin: ['mì'],
    decomposition: '⿱宀必',
    etymology: {
      type: 'pictophonetic',
      phonetic: '必',
      semantic: '宀',
      hint: 'roof',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '宕',
    definition: 'quarry; cave dwelling; to put someone off',
    pinyin: ['dàng'],
    decomposition: '⿱宀石',
    etymology: { type: 'ideographic', hint: 'A tunnel 宀 made in stone 石' },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '宗',
    definition: 'ancestry, clan, family, lineage; religion, sect',
    pinyin: ['zōng'],
    decomposition: '⿱宀示',
    etymology: {
      type: 'ideographic',
      hint: "An altar 示 to the ancestor spirits found in one's home 宀",
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '官',
    definition: 'official, public servant',
    pinyin: ['guān'],
    decomposition: '⿱宀㠯',
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '宙',
    definition: 'space, time, space-time',
    pinyin: ['zhòu'],
    decomposition: '⿱宀由',
    etymology: {
      type: 'pictophonetic',
      phonetic: '由',
      semantic: '宀',
      hint: 'roof - the sky',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '定',
    definition: 'to decide, to fix, to settle; to order; definite, fixed, sure',
    pinyin: ['dìng'],
    decomposition: '⿱宀疋',
    etymology: {
      type: 'ideographic',
      hint: 'A person 疋 settling under a roof 宀',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '宛',
    definition: 'to seem; as if; crooked',
    pinyin: ['wǎn'],
    decomposition: '⿱宀夗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夗',
      semantic: '宀',
      hint: 'roof',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '宜',
    definition: 'fitting, proper, right; what one should do',
    pinyin: ['yí'],
    decomposition: '⿱宀且',
    etymology: {
      type: 'ideographic',
      hint: 'A memorial service 且 held in a house 宀',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '宝',
    definition: 'treasure, jewel; rare, precious',
    pinyin: ['bǎo'],
    decomposition: '⿱宀玉',
    etymology: { type: 'ideographic', hint: "Jade 玉 kept in one's house 宀" },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '实',
    definition: 'real, true; honest, sincere',
    pinyin: ['shí'],
    decomposition: '⿱宀头',
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '宠',
    definition: 'to love; to favor, to pamper, to spoil; concubine',
    pinyin: ['chǒng'],
    decomposition: '⿱宀龙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龙',
      semantic: '宀',
      hint: 'roof',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '审',
    definition: 'to examine, to investigate; to judge; to try',
    pinyin: ['shěn'],
    decomposition: '⿱宀申',
    etymology: {
      type: 'pictophonetic',
      phonetic: '申',
      semantic: '宀',
      hint: 'courtroom',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '客',
    definition: 'guest, traveller; customer',
    pinyin: ['kè'],
    decomposition: '⿱宀各',
    etymology: {
      type: 'ideographic',
      hint: "A person 各 welcomed under one's roof 宀; 各 also provides the pronunciation",
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '宣',
    definition: 'to proclaim, to declare, to announce; surname',
    pinyin: ['xuān'],
    decomposition: '⿱宀亘',
    etymology: {
      type: 'pictographic',
      hint: 'A palace, where proclamations are made',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '室',
    definition: 'house, home; room, chamber',
    pinyin: ['shì'],
    decomposition: '⿱宀至',
    etymology: {
      type: 'pictophonetic',
      phonetic: '至',
      semantic: '宀',
      hint: 'roof',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '宥',
    definition: 'to forgive, to pardon, to indulge',
    pinyin: ['yòu'],
    decomposition: '⿱宀有',
    etymology: {
      type: 'pictophonetic',
      phonetic: '有',
      semantic: '宀',
      hint: 'roof',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '宦',
    definition: 'government official',
    pinyin: ['huàn'],
    decomposition: '⿱宀臣',
    etymology: {
      type: 'ideographic',
      hint: 'A minister 臣 in a statehouse 宀',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '宪',
    definition: 'constitution, statute, law',
    pinyin: ['xiàn'],
    decomposition: '⿱宀先',
    etymology: {
      type: 'pictophonetic',
      phonetic: '先',
      semantic: '宀',
      hint: 'roof',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '宫',
    definition: 'palace; surname',
    pinyin: ['gōng'],
    decomposition: '⿱宀吕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吕',
      semantic: '宀',
      hint: 'roof',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '宮',
    definition: 'palace; surname',
    pinyin: ['gōng'],
    decomposition: '⿱宀呂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '呂',
      semantic: '宀',
      hint: 'roof',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '宰',
    definition: 'to slaughter, to butcher; to govern, to rule',
    pinyin: ['zǎi'],
    decomposition: '⿱宀辛',
    etymology: {
      type: 'ideographic',
      hint: 'A barracks 宀 where slaves 辛 live',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '害',
    definition: 'to injure, to harm; to destroy, to kill',
    pinyin: ['hài'],
    decomposition: '⿱宀⿱丰口',
    radical: '宀',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '宴',
    definition: 'banquet, feast; to entertain',
    pinyin: ['yàn'],
    decomposition: '⿱宀妟',
    etymology: {
      type: 'ideographic',
      hint: 'A woman 女 cooking food 日 for a house 宀 banquet',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '宵',
    definition: 'night, evening, darkness',
    pinyin: ['xiāo'],
    decomposition: '⿱宀肖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肖',
      semantic: '宀',
      hint: 'roof',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '家',
    definition: 'house, home, residence; family',
    pinyin: ['jiā'],
    decomposition: '⿱宀豕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豕',
      semantic: '宀',
      hint: 'roof',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '宸',
    definition: 'imperial palace',
    pinyin: ['chén'],
    decomposition: '⿱宀辰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辰',
      semantic: '宀',
      hint: 'roof',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '容',
    definition: 'appearance, looks; form, figure; to contain, to hold',
    pinyin: ['róng'],
    decomposition: '⿱宀谷',
    etymology: { type: 'pictophonetic', semantic: '宀', hint: 'roof' },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '宽',
    definition: 'broad, spacious, vast, wide',
    pinyin: ['kuān'],
    decomposition: '⿱宀苋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '苋',
      semantic: '宀',
      hint: 'roof',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '宾',
    definition: 'guest, visitor; surname; submit',
    pinyin: ['bīn'],
    decomposition: '⿱宀兵',
    etymology: {
      type: 'ideographic',
      hint: "A solider 兵 quartered under one's roof 宀",
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '宿',
    definition: 'to stop, to rest, to lodge; constellation',
    pinyin: ['sù', 'xiù'],
    decomposition: '⿱宀佰',
    etymology: {
      type: 'ideographic',
      hint: 'A person 亻 sleeping in a bed 百 under a roof 宀',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '寂',
    definition: 'still, silent, quiet, desolate',
    pinyin: ['jì'],
    decomposition: '⿱宀叔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叔',
      semantic: '宀',
      hint: 'roof',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '寄',
    definition:
      'to mail, to send, to transit; to deposit, to entrust; to rely on',
    pinyin: ['jì'],
    decomposition: '⿱宀奇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奇',
      semantic: '宀',
      hint: 'roof',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '寅',
    definition: 'to respect, to revere; respectfully; 3rd terrestrial branch',
    pinyin: ['yín'],
    decomposition: '⿱宀⿱⿱一由八',
    radical: '宀',
    matches: [
      [0],
      [0],
      [0],
      [1, 0, 0],
      [1, 0, 1],
      [1, 0, 1],
      [1, 0, 1],
      [1, 0, 1],
      [1, 0, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '密',
    definition: 'secret, confidential; intimate, close; dense, thick',
    pinyin: ['mì'],
    decomposition: '⿱宓山',
    etymology: {
      type: 'ideographic',
      hint: 'A silent 宓 mountain 山; 宓 also provides the pronunciation',
    },
    radical: '宀',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '寇',
    definition: 'bandit, thief; enemy; to invade',
    pinyin: ['kòu'],
    decomposition: '⿱宀⿺元攴',
    etymology: {
      type: 'ideographic',
      hint: 'Bandits mugging 攴 a person 元 in his home 宀',
    },
    radical: '宀',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '富',
    definition: 'abundant, ample; rich, wealthy',
    pinyin: ['fù'],
    decomposition: '⿱宀畐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畐',
      semantic: '宀',
      hint: 'roof',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '寐',
    definition: 'sleep; asleep',
    pinyin: ['mèi'],
    decomposition: '⿱宀⿰爿未',
    etymology: {
      type: 'ideographic',
      hint: 'A bed 爿 in a house 宀; 未 provides the pronunciation',
    },
    radical: '宀',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '寒',
    definition: 'chilly, cold; poor; to shiver, to tremble',
    pinyin: ['hán'],
    decomposition: '⿱宀⿱？？',
    radical: '宀',
    matches: [
      [0],
      [0],
      [0],
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    ],
  },
  {
    character: '寓',
    definition: 'residence, lodge, dwelling',
    pinyin: ['yù'],
    decomposition: '⿱宀禺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '禺',
      semantic: '宀',
      hint: 'roof',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '寝',
    definition: 'to sleep, to rest; bedroom',
    pinyin: ['qǐn'],
    decomposition: '⿱宀⿰丬⿳彐冖又',
    etymology: {
      type: 'ideographic',
      hint: 'A person 彐冖又 lying down on a bed 丬 in their home 宀',
    },
    radical: '宀',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 2],
      [1, 1, 2],
    ],
  },
  {
    character: '寞',
    definition: 'silent, still; lonely, solitary',
    pinyin: ['mò'],
    decomposition: '⿱宀莫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '莫',
      semantic: '宀',
      hint: 'roof',
    },
    radical: '宀',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '察',
    definition: 'to examine, to investigate, to observe',
    pinyin: ['chá'],
    decomposition: '⿱宀祭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '祭',
      semantic: '宀',
      hint: 'roof',
    },
    radical: '宀',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '寡',
    definition: 'widowed; friendless, alone',
    pinyin: ['guǎ'],
    decomposition: '⿱宀⿱頁刀',
    radical: '宀',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '寢',
    definition: 'to sleep, to rest; bedroom',
    pinyin: ['qǐn'],
    decomposition: '⿱宀⿰爿⿳彐冖又',
    etymology: {
      type: 'ideographic',
      hint: 'A person 彐冖又 lying down on a bed 爿 in their home 宀',
    },
    radical: '宀',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 2],
      [1, 1, 2],
    ],
  },
  {
    character: '寤',
    definition: 'few, scarce; empty, deserted',
    pinyin: ['wù'],
    decomposition: '⿱宀⿰爿吾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吾',
      semantic: '宀',
      hint: 'roof',
    },
    radical: '宀',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '寥',
    definition: 'few, scarce; empty, deserted',
    pinyin: ['liáo'],
    decomposition: '⿱宀翏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '翏',
      semantic: '宀',
      hint: 'roof',
    },
    radical: '宀',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '實',
    definition: 'real, true; honest, sincere',
    pinyin: ['shí'],
    decomposition: '⿱宀貫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宀',
      semantic: '貫',
      hint: 'pierce',
    },
    radical: '宀',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '寧',
    definition: 'calm, peaceful; healthy; rather; to prefer',
    pinyin: ['níng'],
    decomposition: '⿱宀⿱心⿱皿丁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丁',
      semantic: '心',
      hint: 'heart',
    },
    radical: '宀',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 1],
      [1, 1, 1],
    ],
  },
  {
    character: '寨',
    definition: 'stockade, stronghold, outpost; brothel',
    pinyin: ['zhài'],
    decomposition: '⿳宀？木',
    etymology: {
      type: 'ideographic',
      hint: 'A fortress 宀 with walls made of wood 木',
    },
    radical: '宀',
    matches: [
      [0],
      [0],
      [0],
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '審',
    definition: 'to examine, to investigate; to judge; to try',
    pinyin: ['shěn'],
    decomposition: '⿱宀番',
    etymology: {
      type: 'pictophonetic',
      phonetic: '番',
      semantic: '宀',
      hint: 'courtroom',
    },
    radical: '宀',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '寫',
    definition: 'to write; to draw, to sketch; to compose',
    pinyin: ['xiě'],
    decomposition: '⿱宀舄',
    radical: '宀',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '寬',
    definition: 'broad, spacious, vast, wide',
    pinyin: ['kuān'],
    decomposition: '⿳宀艹⿻見丶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '苋',
      semantic: '宀',
      hint: 'roof',
    },
    radical: '宀',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [2, 0],
      [2, 0],
      [2, 0],
      [2, 0],
      [2, 0],
      [2, 0],
      [2, 0],
      [2, 1],
    ],
  },
  {
    character: '寮',
    definition: 'shanty, hut, shack',
    pinyin: ['liáo'],
    decomposition: '⿱宀尞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尞',
      semantic: '宀',
      hint: 'roof',
    },
    radical: '宀',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '寰',
    definition: 'country, domain, world',
    pinyin: ['huán'],
    decomposition: '⿱宀睘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '睘',
      semantic: '宀',
      hint: 'roof',
    },
    radical: '宀',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '寵',
    definition: 'to love; to favor, to pamper, to spoil; concubine',
    pinyin: ['chǒng'],
    decomposition: '⿱宀龍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龍',
      semantic: '宀',
      hint: 'roof',
    },
    radical: '宀',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '寶',
    definition: 'treasure, jewel; rare, precious',
    pinyin: ['bǎo'],
    decomposition: '⿳宀珤貝',
    etymology: {
      type: 'ideographic',
      hint: "Valuables 貝 kept in one's house 宀; 珤 also provides the pronunciation",
    },
    radical: '宀',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '寸',
    definition: 'inch; small, tiny',
    pinyin: ['cùn'],
    decomposition: '？',
    etymology: {
      type: 'ideographic',
      hint: 'A hand with a dot indicating where the pulse can be felt, about an inch up the wrist',
    },
    radical: '寸',
    matches: [null, null, null],
  },
  {
    character: '对',
    definition: 'correct, right; facing, opposed',
    pinyin: ['duì'],
    decomposition: '⿰又寸',
    etymology: { type: 'ideographic', hint: 'A pair 又 of hands 寸' },
    radical: '寸',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '寺',
    definition: 'court, office; temple, monastery',
    pinyin: ['sì'],
    decomposition: '⿱土寸',
    etymology: { type: 'ideographic', hint: 'An offering 土 in your hand 寸' },
    radical: '寸',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '寻',
    definition: 'to seek; to search for, to look for; ancient',
    pinyin: ['xún'],
    decomposition: '⿱彐寸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寸',
      semantic: '彐',
      hint: 'snout',
    },
    radical: '彐',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '导',
    definition: 'to direct, to guide, to lead, to conduct',
    pinyin: ['dǎo'],
    decomposition: '⿱巳寸',
    etymology: {
      type: 'ideographic',
      hint: 'A hand 寸 pointing the way to someplace 巳',
    },
    radical: '寸',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '寽',
    definition: 'a handful; a pinch',
    pinyin: ['lǜ'],
    decomposition: '⿱爫寸',
    etymology: {
      type: 'ideographic',
      hint: "A small object 寸 clutched in one's hand 爫",
    },
    radical: '寸',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '寿',
    definition: 'old age, longevity; lifespan',
    pinyin: ['shòu'],
    decomposition: '⿸丰寸',
    etymology: { type: 'ideographic', hint: 'Altered form of 老' },
    radical: '寸',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '封',
    definition: 'envelope, letter; to confer, to grant; feudal',
    pinyin: ['fēng'],
    decomposition: '⿰圭寸',
    etymology: {
      type: 'ideographic',
      hint: 'To seal 寸 something with a handful of mortar 土',
    },
    radical: '寸',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '尃',
    definition: 'to announce, to state',
    pinyin: ['fū'],
    decomposition: '⿱甫寸',
    etymology: { type: 'pictophonetic', phonetic: '甫' },
    radical: '寸',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '射',
    definition: 'to shoot, to eject, to emit',
    pinyin: ['shè'],
    decomposition: '⿰身寸',
    etymology: {
      type: 'pictographic',
      hint: 'A bow 身 being drawn by a hand 寸',
    },
    radical: '寸',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '将',
    definition: 'the future, what will be; ready, prepared; a general',
    pinyin: ['jiāng'],
    decomposition: '⿰丬⿱夕寸',
    etymology: {
      type: 'ideographic',
      hint: 'Going to bed 丬 at night 夕, a predictable future',
    },
    radical: '丬',
    matches: [[0], [0], [0], [1, 0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '將',
    definition: 'the future, what will be; ready, prepared; a general',
    pinyin: ['jiāng'],
    decomposition: '⿰爿⿱夕寸',
    etymology: {
      type: 'ideographic',
      hint: 'Going to bed 爿 at night 夕, a predictable future',
    },
    radical: '寸',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '專',
    definition: 'concentrated, specialized; to monopolize',
    pinyin: ['zhuān'],
    decomposition: '⿱叀寸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叀',
      semantic: '寸',
      hint: 'small',
    },
    radical: '寸',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '尉',
    definition: 'officer, military rank',
    pinyin: ['wèi'],
    decomposition: '⿰⿸尸示寸',
    radical: '寸',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '尊',
    definition: 'to honor, to respect, to venerate',
    pinyin: ['zūn'],
    decomposition: '⿱酋寸',
    etymology: {
      type: 'ideographic',
      hint: 'A hand 寸 making an offering of wine 酋',
    },
    radical: '寸',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '尋',
    definition: 'to seek; to search for, to look for; ancient',
    pinyin: ['xún'],
    decomposition: '⿳彐⿰工口寸',
    etymology: {
      type: 'ideographic',
      hint: 'A hand 彐 looking 工 for an item 口; 寸 provides the pronunciation',
    },
    radical: '寸',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '尌',
    definition: 'to prop up; to stand something up',
    pinyin: ['shù'],
    decomposition: '⿰壴寸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '壴',
      semantic: '寸',
      hint: 'inch',
    },
    radical: '寸',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '對',
    definition: 'correct, right; facing, opposed',
    pinyin: ['duì'],
    decomposition: '⿰⿱业羊寸',
    etymology: {
      type: 'ideographic',
      hint: 'A hand 寸 holding a lit 业 candelabrum 羊',
    },
    radical: '寸',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '導',
    definition: 'to direct, to guide, to lead, to conduct',
    pinyin: ['dǎo'],
    decomposition: '⿱道寸',
    etymology: {
      type: 'ideographic',
      hint: 'A hand 寸 pointing the way to someplace 道',
    },
    radical: '寸',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '小',
    definition: 'small, tiny, insignificant',
    pinyin: ['xiǎo'],
    decomposition: '⿻亅八',
    etymology: { type: 'ideographic', hint: 'Dividing 八 by a line 亅' },
    radical: '小',
    matches: [[0], [1], [1]],
  },
  {
    character: '少',
    definition: 'few, little; less; inadequate',
    pinyin: ['shǎo'],
    decomposition: '⿱小丿',
    etymology: {
      type: 'pictographic',
      hint: 'Grains of sand; 小 provides the pronunciation and meaning',
    },
    radical: '小',
    matches: [[0], [0], [0], [1]],
  },
  {
    character: '尔',
    definition: 'you; that, those; final particle',
    pinyin: ['ěr'],
    decomposition: '⿱⺈小',
    radical: '小',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '尕',
    definition: 'small (used in place names)',
    pinyin: ['gǎ'],
    decomposition: '⿱乃小',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乃',
      semantic: '小',
      hint: 'small',
    },
    radical: '小',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '尖',
    definition: 'sharp, pointed, acute; keen, shrewd',
    pinyin: ['jiān'],
    decomposition: '⿱小大',
    etymology: { type: 'ideographic', hint: 'A point, small 小 over big 大' },
    radical: '小',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '尗',
    definition: "younger brother; father's younger brother",
    pinyin: ['shū'],
    decomposition: '⿱上小',
    etymology: { type: 'ideographic', hint: 'The smaller 小 of two brothers' },
    radical: '小',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '尘',
    definition: 'cinders, ashes, dust, dirt',
    pinyin: ['chén'],
    decomposition: '⿱小土',
    etymology: { type: 'ideographic', hint: 'Small 小 flakes of earth 土' },
    radical: '小',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '尙',
    definition: 'still, yet; even; fairly, rather',
    pinyin: ['shàng'],
    decomposition: '⿱小冋',
    radical: '小',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '尚',
    definition: 'still, yet; even; fairly, rather',
    pinyin: ['shàng'],
    decomposition: '⿵⿱⺌冂口',
    radical: '⺌',
    matches: [[0, 0], [0, 0], [0, 0], [0, 1], [0, 1], [1], [1], [1]],
  },
  {
    character: '尜',
    definition: "a child's toy",
    pinyin: ['gá'],
    decomposition: '⿳小大小',
    etymology: {
      type: 'ideographic',
      hint: 'A diamond: small 小 to big 大 to small 小',
    },
    radical: '小',
    matches: [[0], [0], [0], [1], [1], [1], [2], [2], [2]],
  },
  {
    character: '尝',
    definition: 'to taste; to experience, to experiment with',
    pinyin: ['cháng'],
    decomposition: '⿱尚云',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尚',
      semantic: '云',
      hint: 'speak',
    },
    radical: '⺌',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '尞',
    definition: 'fuel used for sacrifices',
    pinyin: ['liào'],
    decomposition: '⿱？小',
    radical: '小',
    matches: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '尢',
    definition: 'weak, lame',
    pinyin: ['yóu'],
    decomposition: '⿸？乚',
    etymology: {
      type: 'ideographic',
      hint: 'Cutting 一 off the feet 儿; compare 兀',
    },
    radical: '尢',
    matches: [null, null, [1]],
  },
  {
    character: '尣',
    definition: 'weak, lame',
    pinyin: ['wāng'],
    decomposition: '⿱八儿',
    etymology: {
      type: 'ideographic',
      hint: 'A person with damaged 八 feet 儿',
    },
    radical: '尣',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '尤',
    definition: 'especially, particularly',
    pinyin: ['yóu'],
    decomposition: '⿻尢丶',
    etymology: { type: 'pictophonetic', phonetic: '尢' },
    radical: '尢',
    matches: [[0], [0], [0], [1]],
  },
  {
    character: '尥',
    pinyin: ['liào'],
    decomposition: '⿺尢勺',
    radical: '尢',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '尧',
    definition: 'a legendary ancient emperor-sage',
    pinyin: ['yáo'],
    decomposition: '⿱戈兀',
    radical: '儿',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '尨',
    definition: 'shaggy dog; striped, variegated',
    pinyin: ['máng'],
    decomposition: '⿺犬彡',
    etymology: { type: 'ideographic', hint: 'A hairy 彡 dog 犬' },
    radical: '犬',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '尬',
    definition: 'awkward, embarrassed; to limp, to stagger',
    pinyin: ['gà'],
    decomposition: '⿺尢介',
    etymology: {
      type: 'pictophonetic',
      phonetic: '介',
      semantic: '尢',
      hint: 'lame',
    },
    radical: '尢',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '就',
    definition: 'just, simply; to go to; to approach, near',
    pinyin: ['jiù'],
    decomposition: '⿰京尤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '京',
      semantic: '尤',
      hint: 'specialty',
    },
    radical: '尢',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '尴',
    definition: 'embarrassed; ill-at-ease',
    pinyin: ['gān'],
    decomposition: '⿺尢监',
    etymology: {
      type: 'pictophonetic',
      phonetic: '监',
      semantic: '尢',
      hint: 'lame',
    },
    radical: '尢',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '尷',
    definition: 'embarrassed; ill-at-ease',
    pinyin: ['gān'],
    decomposition: '⿺尢監',
    etymology: {
      type: 'pictophonetic',
      phonetic: '監',
      semantic: '尢',
      hint: 'lame',
    },
    radical: '尢',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '尸',
    definition: 'body, corpse',
    pinyin: ['shī'],
    decomposition: '⿰丿？',
    etymology: { type: 'pictographic', hint: 'A man keeled over' },
    radical: '尸',
    matches: [null, null, [0]],
  },
  {
    character: '尹',
    definition: 'to govern, to oversee; director',
    pinyin: ['yǐn'],
    decomposition: '⿻一尸',
    etymology: { type: 'pictographic', hint: 'A scepter' },
    radical: '尸',
    matches: [[1], [0], [1], [1]],
  },
  {
    character: '尺',
    definition: 'ruler, tape-measure; unit of length, about 1 ft.',
    pinyin: ['chǐ'],
    decomposition: '⿸尸乚',
    etymology: {
      type: 'ideographic',
      hint: 'Picture of a man measuring by pacing',
    },
    radical: '尸',
    matches: [[0], [0], [0], [1]],
  },
  {
    character: '尻',
    definition: 'end of spine; buttocks, sacrum',
    pinyin: ['kāo'],
    decomposition: '⿸尸九',
    etymology: { type: 'pictophonetic', semantic: '尸', hint: 'body' },
    radical: '尸',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '尼',
    definition: 'Buddhist nun; used in transliterations',
    pinyin: ['ní'],
    decomposition: '⿸尸匕',
    radical: '尸',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '尽',
    definition: 'to exhaust, to use up, to deplete',
    pinyin: ['jǐn'],
    decomposition: '⿵尺⺀',
    radical: '尸',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '尾',
    definition: 'tail; extremity, end; back, rear',
    pinyin: ['wěi'],
    decomposition: '⿸尸毛',
    etymology: {
      type: 'ideographic',
      hint: 'A furry 毛 tail behind a body 尸',
    },
    radical: '尸',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '尿',
    definition: 'urine; to urinate',
    pinyin: ['niào'],
    decomposition: '⿸尸水',
    etymology: {
      type: 'ideographic',
      hint: 'A person, crouched 尸 passing water 水',
    },
    radical: '尸',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '局',
    definition: 'bureau, office; circumstance, game, situation',
    pinyin: ['jú'],
    decomposition: '⿵尺口',
    etymology: {
      type: 'ideographic',
      hint: 'A place where measures 尺 are discussed 口',
    },
    radical: '尸',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '屁',
    definition: 'to break wind, to fart; the buttocks',
    pinyin: ['pì'],
    decomposition: '⿸尸比',
    etymology: {
      type: 'pictophonetic',
      phonetic: '比',
      semantic: '尸',
      hint: 'body',
    },
    radical: '尸',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '层',
    definition: 'layer, floor, story, stratum',
    pinyin: ['céng'],
    decomposition: '⿸尸云',
    etymology: {
      type: 'ideographic',
      hint: 'Simplified form of 層; 曾 provides the pronunciation',
    },
    radical: '尸',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '屃',
    definition: 'legendary hero; Herculean strength',
    pinyin: ['xì'],
    decomposition: '⿸尸贝',
    etymology: {
      type: 'ideographic',
      hint: 'Simplified form of 屭; a strong 贔 body 尸',
    },
    radical: '尸',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '屄',
    definition: 'vagina; to press up to; to force',
    pinyin: ['bī'],
    decomposition: '⿸尸穴',
    etymology: { type: 'ideographic', hint: "A hole 穴 in a woman's body 尸" },
    radical: '尸',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '居',
    definition: 'to live, to reside; to dwell; to sit',
    pinyin: ['jū'],
    decomposition: '⿸户古',
    etymology: {
      type: 'pictophonetic',
      phonetic: '古',
      semantic: '户',
      hint: 'door',
    },
    radical: '户',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '屆',
    definition:
      'deadline; period; measure word for elections, meetings, and other events',
    pinyin: ['jiè'],
    decomposition: '⿸尸⿶凵士',
    radical: '尸',
    matches: [[0], [0], [0], [1, 1], [1, 1], [1, 1], [1, 0], [1, 0]],
  },
  {
    character: '屈',
    definition: 'to bend, to flex; bent, crooked, crouched',
    pinyin: ['qū'],
    decomposition: '⿸尸出',
    etymology: {
      type: 'pictophonetic',
      phonetic: '出',
      semantic: '尸',
      hint: 'corpse',
    },
    radical: '尸',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '屉',
    definition: 'drawer, tier; pad, screen, tray',
    pinyin: ['tì'],
    decomposition: '⿸尸世',
    radical: '尸',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '届',
    definition:
      'deadline; period; measure word for elections, meetings, and other events',
    pinyin: ['jiè'],
    decomposition: '⿸尸由',
    radical: '尸',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '屋',
    definition: 'building, house, shelter; room',
    pinyin: ['wū'],
    decomposition: '⿸尸至',
    etymology: {
      type: 'ideographic',
      hint: 'To stop 至 under a roof 尸 (variant of 厂)',
    },
    radical: '尸',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '屌',
    definition: 'penis; to fuck',
    pinyin: ['diǎo'],
    decomposition: '⿸尸吊',
    etymology: {
      type: 'ideographic',
      hint: 'Something hanging 吊 from the body 尸; 吊 also provides the pronunciation',
    },
    radical: '尸',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '屍',
    definition: 'body, corpse',
    pinyin: ['shī'],
    decomposition: '⿸尸死',
    etymology: {
      type: 'ideographic',
      hint: 'A dead 死 body 尸; 尸 also provides the pronunciation',
    },
    radical: '尸',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '屎',
    definition: 'stool, feces, dung',
    pinyin: ['shǐ'],
    decomposition: '⿸尸米',
    etymology: {
      type: 'ideographic',
      hint: 'A person, crouched 尸 defecating 米; 米 also provides the pronunciation',
    },
    radical: '尸',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '屏',
    definition: 'screen, shield; to put aside, to reject; to hold',
    pinyin: ['píng'],
    decomposition: '⿸户并',
    etymology: {
      type: 'pictophonetic',
      phonetic: '并',
      semantic: '户',
      hint: 'door',
    },
    radical: '户',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '屐',
    definition: 'wooden clogs',
    pinyin: ['jī'],
    decomposition: '⿸尸⿰彳支',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尸',
      semantic: '彳',
      hint: 'step',
    },
    radical: '尸',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '屑',
    definition: 'bits, crumbs, scraps; fragments; not worthwhile',
    pinyin: ['xiè'],
    decomposition: '⿸尸肖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肖',
      semantic: '尸',
      hint: 'body',
    },
    radical: '尸',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '展',
    definition: 'to open, to unfold; to extend, to stretch',
    pinyin: ['zhǎn'],
    decomposition: '⿸尸⿻？衣',
    etymology: {
      type: 'ideographic',
      hint: 'Laying out clothes 㠭 for sale in a market 尸; compare 㠭',
    },
    radical: '尸',
    matches: [[0], [0], [0], null, null, null, [1, 1], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '屙',
    definition: 'to defecate',
    pinyin: ['ē'],
    decomposition: '⿸尸阿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '阿',
      semantic: '尸',
      hint: 'body',
    },
    radical: '尸',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '屚',
    pinyin: ['lòu'],
    decomposition: '⿸尸雨',
    radical: '尸',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '屜',
    definition: 'drawer, tier; pad, screen, tray',
    pinyin: ['tì'],
    decomposition: '⿸尸⿰彳世',
    radical: '尸',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '属',
    definition: 'class, category, type; family; affiliated, belonging to',
    pinyin: ['shǔ'],
    decomposition: '⿸尸禹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '禹',
      semantic: '尸',
      hint: 'body',
    },
    radical: '尸',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '屠',
    definition: 'to butcher, to slaughter; massacre',
    pinyin: ['tú'],
    decomposition: '⿸尸者',
    etymology: {
      type: 'pictophonetic',
      phonetic: '者',
      semantic: '尸',
      hint: 'corpse',
    },
    radical: '尸',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '屡',
    definition: 'frequently, often, again and again',
    pinyin: ['lǚ'],
    decomposition: '⿸尸娄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '娄',
      semantic: '尸',
      hint: 'body',
    },
    radical: '尸',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '屢',
    definition: 'frequently, often, again and again',
    pinyin: ['lǚ'],
    decomposition: '⿸尸婁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '婁',
      semantic: '尸',
      hint: 'body',
    },
    radical: '尸',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '屣',
    definition: 'sandals, slippers',
    pinyin: ['xǐ'],
    decomposition: '⿸尸徙',
    etymology: {
      type: 'ideographic',
      hint: 'A person 尸 walking 彳; 徙 also provides the pronunciation',
    },
    radical: '尸',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '層',
    definition: 'layer, floor, story, stratum',
    pinyin: ['céng'],
    decomposition: '⿸尸曾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曾',
      semantic: '尸',
      hint: 'body',
    },
    radical: '尸',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '履',
    definition: 'shoes; to walk, to tread',
    pinyin: ['lǚ'],
    decomposition: '⿸尸復',
    etymology: {
      type: 'ideographic',
      hint: 'A person 尸 walking 彳; 復 also provides the pronunciation',
    },
    radical: '尸',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '屦',
    definition: 'straw sandals; to tread on',
    pinyin: ['jù'],
    decomposition: '⿸尸⿰彳娄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '娄',
      semantic: '彳',
      hint: 'step',
    },
    radical: '尸',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '屬',
    definition: 'class, category, type; family; affiliated, belonging to',
    pinyin: ['shǔ'],
    decomposition: '⿸尸⿱氺蜀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '禹',
      semantic: '尸',
      hint: 'body',
    },
    radical: '尸',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '屭',
    definition: 'legendary hero; Herculean strength',
    pinyin: ['xì'],
    decomposition: '⿸尸贔',
    etymology: { type: 'ideographic', hint: 'A strong 贔 body 尸' },
    radical: '尸',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '屮',
    definition: 'sprout',
    pinyin: ['chè'],
    decomposition: '⿻凵丨',
    etymology: { type: 'pictographic', hint: 'A sprout' },
    radical: '屮',
    matches: [[0], [0], [1]],
  },
  {
    character: '屯',
    definition: 'village, hamlet; camp; station',
    pinyin: ['tún'],
    decomposition: '⿻一屮',
    radical: '屮',
    matches: [[0], [1], [1], [1]],
  },
  {
    character: '屰',
    definition: 'disobedient',
    pinyin: ['nì'],
    decomposition: '⿱？屮',
    radical: '屮',
    matches: [null, null, null, [1], [1], [1]],
  },
  {
    character: '山',
    definition: 'mountain, hill, peak',
    pinyin: ['shān'],
    decomposition: '⿶凵丨',
    etymology: { type: 'pictographic', hint: 'Three mountain peaks' },
    radical: '山',
    matches: [[1], [0], [0]],
  },
  {
    character: '屹',
    definition: 'to rise, to stand tall',
    pinyin: ['yì'],
    decomposition: '⿰山乞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乞',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '屺',
    definition: 'a grassy knoll; a barren knoll',
    pinyin: ['qǐ'],
    decomposition: '⿰山己',
    etymology: {
      type: 'pictophonetic',
      phonetic: '己',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '屾',
    definition: 'mountain range',
    pinyin: ['shēn'],
    decomposition: '⿰山山',
    etymology: {
      type: 'ideographic',
      hint: 'Two mountains 山; 山 also provides the pronunciation',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '屿',
    definition: 'island',
    pinyin: ['yǔ'],
    decomposition: '⿰山与',
    etymology: {
      type: 'pictophonetic',
      phonetic: '与',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '岁',
    definition: 'year; years old, age; harvest',
    pinyin: ['suì'],
    decomposition: '⿱山夕',
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '岂',
    definition: 'what; how',
    pinyin: ['qǐ'],
    decomposition: '⿱山己',
    etymology: { type: 'pictophonetic', phonetic: '己' },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '岈',
    definition: 'the name of a mountain',
    pinyin: ['yá'],
    decomposition: '⿰山牙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '牙',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '岌',
    definition: 'perilous, hazardous; steep, high',
    pinyin: ['jí'],
    decomposition: '⿱山及',
    etymology: {
      type: 'pictophonetic',
      phonetic: '及',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '岍',
    definition: 'the name of a mountain',
    pinyin: ['qiān'],
    decomposition: '⿰山开',
    etymology: {
      type: 'pictophonetic',
      phonetic: '开',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '岐',
    definition: 'to diverge, to branch; the name of a mountain',
    pinyin: ['qí'],
    decomposition: '⿰山支',
    etymology: {
      type: 'pictophonetic',
      phonetic: '支',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '岑',
    definition: 'steep, precipitous; peak',
    pinyin: ['cén'],
    decomposition: '⿱山今',
    etymology: {
      type: 'pictophonetic',
      phonetic: '今',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '岔',
    definition: 'to diverge, to branch; junction, fork in the road',
    pinyin: ['chà'],
    decomposition: '⿱分山',
    etymology: {
      type: 'ideographic',
      hint: 'A road being split 分 by a mountain 山',
    },
    radical: '山',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '岖',
    definition: 'steep, sheer; rugged, rough',
    pinyin: ['qū'],
    decomposition: '⿰山区',
    etymology: {
      type: 'pictophonetic',
      phonetic: '区',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '岗',
    definition: 'post; position',
    pinyin: ['gǎng'],
    decomposition: '⿱山冈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冈',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '岘',
    definition: 'steep hill; a mountain in Hubei',
    pinyin: ['xiàn'],
    decomposition: '⿰山见',
    etymology: {
      type: 'ideographic',
      hint: 'A mountain 山 that affords a good view 见; 见 also provides the pronunciation',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '岙',
    definition: 'island',
    pinyin: ['ào'],
    decomposition: '⿱夭山',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夭',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '岚',
    definition: 'mountain mist, mountain haze',
    pinyin: ['lán'],
    decomposition: '⿱山风',
    etymology: {
      type: 'ideographic',
      hint: 'Wind 风 blowing off the mountain 山',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '岛',
    definition: 'island',
    pinyin: ['dǎo'],
    decomposition: '⿹鸟山',
    etymology: {
      type: 'ideographic',
      hint: 'A bird 鸟 perched atop a mountain 山',
    },
    radical: '山',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '岜',
    definition: 'rocky mountain',
    pinyin: ['bā'],
    decomposition: '⿱山巴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巴',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '岡',
    definition: 'ridge or crest of hill',
    pinyin: ['gāng'],
    decomposition: '⿵冂⿱？山',
    etymology: {
      type: 'pictographic',
      hint: 'Clouds 网 forming over a mountain 山',
    },
    radical: '山',
    matches: [[0], [0], null, null, null, [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '岢',
    definition: 'the name of a mountain',
    pinyin: ['kě'],
    decomposition: '⿱山可',
    etymology: {
      type: 'pictophonetic',
      phonetic: '可',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '岣',
    definition: 'a hill in Hunan',
    pinyin: ['gǒu'],
    decomposition: '⿰山句',
    etymology: {
      type: 'pictophonetic',
      phonetic: '句',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '岩',
    definition: 'cliff; rocks; mountain',
    pinyin: ['yán'],
    decomposition: '⿱山石',
    etymology: {
      type: 'ideographic',
      hint: 'The rocks 石 that make up a mountain 山',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '岫',
    definition: 'mountain peak; cave, cavern',
    pinyin: ['xiù'],
    decomposition: '⿰山由',
    etymology: {
      type: 'pictophonetic',
      phonetic: '由',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '岬',
    definition: 'cape; promontory, headland',
    pinyin: ['jiǎ'],
    decomposition: '⿰山甲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甲',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '岭',
    definition: 'mountain ridge, mountain peak',
    pinyin: ['lǐng'],
    decomposition: '⿰山令',
    etymology: {
      type: 'pictophonetic',
      phonetic: '令',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '岱',
    definition: 'the Daishan mountain in Shandong',
    pinyin: ['dài'],
    decomposition: '⿱代山',
    etymology: {
      type: 'pictophonetic',
      phonetic: '代',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '岳',
    definition: 'mountain peak; surname',
    pinyin: ['yuè'],
    decomposition: '⿱丘山',
    etymology: {
      type: 'ideographic',
      hint: 'A mountain 山 range surrounded by hills 丘',
    },
    radical: '山',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '岵',
    definition: 'a wooded hill',
    pinyin: ['hù'],
    decomposition: '⿰山古',
    etymology: {
      type: 'pictophonetic',
      phonetic: '古',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '岷',
    definition: 'the Min mountains; the Min river',
    pinyin: ['mín'],
    decomposition: '⿰山民',
    etymology: {
      type: 'pictophonetic',
      phonetic: '民',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '岸',
    definition: 'beach, coast, shore',
    pinyin: ['àn'],
    decomposition: '⿱山⿸厂干',
    etymology: {
      type: 'ideographic',
      hint: 'A mountain 山 cliff 厂; 干 provides the pronunciation',
    },
    radical: '山',
    matches: [[0], [0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '岽',
    definition: 'a mountain in Guangxi province',
    pinyin: ['dōng'],
    decomposition: '⿱山东',
    etymology: {
      type: 'pictophonetic',
      phonetic: '东',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '岿',
    definition: 'grand, stately; secure, lasting',
    pinyin: ['kuī'],
    decomposition: '⿱山归',
    etymology: {
      type: 'pictophonetic',
      phonetic: '归',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '峁',
    definition: 'yellow dirt mount',
    pinyin: ['mǎo'],
    decomposition: '⿱山卯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卯',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '峄',
    definition: 'a range of peaks in Shandong and Jiangsu',
    pinyin: ['yì'],
    decomposition: '⿰山？',
    etymology: {
      type: 'pictophonetic',
      phonetic: '睪',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], null, null, null, null, null],
  },
  {
    character: '峇',
    definition: 'cave, cavern',
    pinyin: ['bā'],
    decomposition: '⿱山合',
    etymology: {
      type: 'pictophonetic',
      phonetic: '合',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '峋',
    definition: 'foothill, mountain range',
    pinyin: ['xún'],
    decomposition: '⿰山旬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旬',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '峒',
    definition: 'a mountain in Gansu province',
    pinyin: ['dòng'],
    decomposition: '⿰山同',
    etymology: {
      type: 'pictophonetic',
      phonetic: '同',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '峙',
    definition: 'to pile, to stack; to stand tall',
    pinyin: ['zhì'],
    decomposition: '⿰山寺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寺',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '峡',
    definition: 'gorge, ravine, strait; isthmus',
    pinyin: ['xiá'],
    decomposition: '⿰山夹',
    etymology: {
      type: 'ideographic',
      hint: 'The space between 夹 two mountains 山; 夹 also provides the pronunciation',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '峤',
    definition: 'tall pointed mountain',
    pinyin: ['jiào'],
    decomposition: '⿰山乔',
    etymology: {
      type: 'ideographic',
      hint: 'A tall 乔 mountain 山; 乔 also provides the pronunciation',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '峥',
    definition: 'high, lofty, noble; perilous, steep',
    pinyin: ['zhēng'],
    decomposition: '⿰山争',
    etymology: {
      type: 'pictophonetic',
      phonetic: '争',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '峦',
    definition: 'mountain range; tall pointed mountain',
    pinyin: ['luán'],
    decomposition: '⿱亦山',
    etymology: {
      type: 'pictophonetic',
      phonetic: '䜌',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '峨',
    definition: 'lofty; the name of a mountain',
    pinyin: ['é'],
    decomposition: '⿰山我',
    etymology: {
      type: 'pictophonetic',
      phonetic: '我',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '峪',
    definition: 'valley, ravine',
    pinyin: ['yù'],
    decomposition: '⿰山谷',
    etymology: {
      type: 'ideographic',
      hint: 'A mountain 山 by a valley 谷; 谷 also provides the pronunciation',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '峭',
    definition: 'steep, precipitous, rugged',
    pinyin: ['qiào'],
    decomposition: '⿰山肖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肖',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '峰',
    definition: "peak, summit; a camel's hump",
    pinyin: ['fēng'],
    decomposition: '⿰山夆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夆',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '峴',
    definition: 'steep hill; a mountain in Hubei',
    pinyin: ['xiàn'],
    decomposition: '⿰山見',
    etymology: {
      type: 'ideographic',
      hint: 'A mountain 山 that affords a good view 見; 見 also provides the pronunciation',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '島',
    definition: 'island',
    pinyin: ['dǎo'],
    decomposition: '⿹烏山',
    etymology: {
      type: 'ideographic',
      hint: 'A bird 烏 perched atop a mountain 山',
    },
    radical: '山',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '峻',
    definition: 'high, steep, towering; stern',
    pinyin: ['jùn'],
    decomposition: '⿰山夋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夋',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '峽',
    definition: 'gorge, ravine, strait; isthmus',
    pinyin: ['xiá'],
    decomposition: '⿰山夾',
    etymology: {
      type: 'ideographic',
      hint: 'The space between 夾 two mountains 山; 夾 also provides the pronunciation',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '崂',
    definition: 'Laoshan, a mountain in Shandong',
    pinyin: ['láo'],
    decomposition: '⿰山劳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '劳',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '崃',
    definition: 'a mountain in Sichuan province',
    pinyin: ['lái'],
    decomposition: '⿰山来',
    etymology: {
      type: 'pictophonetic',
      phonetic: '来',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '崆',
    definition: 'the Kongtong mountain',
    pinyin: ['kōng'],
    decomposition: '⿰山空',
    etymology: {
      type: 'pictophonetic',
      phonetic: '空',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '崇',
    definition: 'high, dignified; to esteem, to honor',
    pinyin: ['chóng'],
    decomposition: '⿱山宗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宗',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '崎',
    definition: 'rough, uneven; jagged, rugged',
    pinyin: ['qí'],
    decomposition: '⿰山奇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奇',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '崑',
    definition: 'the Kunlun mountains in Jiang Su province',
    pinyin: ['kūn'],
    decomposition: '⿱山昆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昆',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '崒',
    definition: 'rocky peaks; lofty; dangerous',
    pinyin: ['zú'],
    decomposition: '⿱山卒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卒',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '崔',
    definition: 'high, lofty, towering; surname',
    pinyin: ['cuī'],
    decomposition: '⿱山隹',
    etymology: {
      type: 'ideographic',
      hint: 'A bird 隹 faced with a mountain 山',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '崖',
    definition: 'cliff, precipice; precipitous',
    pinyin: ['yá'],
    decomposition: '⿱山厓',
    etymology: {
      type: 'ideographic',
      hint: 'A mountain 山 precipice 厓; 厓 also provides the pronunciation',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '崗',
    definition: 'post; position',
    pinyin: ['gǎng'],
    decomposition: '⿱山岡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '岡',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '崙',
    definition: 'the Kunlun mountains in Jiangsu',
    pinyin: ['lún'],
    decomposition: '⿱山侖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '侖',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '崛',
    definition: 'towering; eminent; a sudden rise',
    pinyin: ['jué'],
    decomposition: '⿰山屈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屈',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '崞',
    definition: 'a mountain in Shanxi',
    pinyin: ['guō'],
    decomposition: '⿰山享',
    etymology: {
      type: 'pictophonetic',
      phonetic: '享',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '崢',
    definition: 'high, lofty, noble; perilous, steep',
    pinyin: ['zhēng'],
    decomposition: '⿰山爭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爭',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '崤',
    definition: 'a mountain in Henan',
    pinyin: ['xiáo'],
    decomposition: '⿰山肴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肴',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '崦',
    definition: 'a mountain in Kansu where the sun is supposed to set at night',
    pinyin: ['yān'],
    decomposition: '⿰山奄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奄',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '崧',
    definition: 'tall mountain; lofty, eminent',
    pinyin: ['sōng'],
    decomposition: '⿱山松',
    etymology: {
      type: 'pictophonetic',
      phonetic: '松',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '崩',
    definition: 'to rupture, to split apart; to collapse; death, demise',
    pinyin: ['bēng'],
    decomposition: '⿱山朋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朋',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '崭',
    definition: 'new, bold; steep, high',
    pinyin: ['zhǎn'],
    decomposition: '⿱山斩',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斩',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '崮',
    definition: 'mesa, plateau',
    pinyin: ['gù'],
    decomposition: '⿱山固',
    etymology: {
      type: 'pictophonetic',
      phonetic: '固',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '崴',
    definition: 'high, lofty, precipitous; to sprain',
    pinyin: ['wǎi'],
    decomposition: '⿱山威',
    etymology: {
      type: 'pictophonetic',
      phonetic: '威',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '崽',
    definition: 'child, servant; a diminutive',
    pinyin: ['zǎi'],
    decomposition: '⿱山思',
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '崾',
    definition: 'a place name in Shanxi province',
    pinyin: ['yǎo'],
    decomposition: '⿰山要',
    etymology: {
      type: 'pictophonetic',
      phonetic: '要',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嵇',
    definition: 'a mountain in Henan; surname',
    pinyin: ['jī'],
    decomposition: '⿰禾⿱尤山',
    etymology: {
      type: 'pictophonetic',
      phonetic: '禾',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '嵊',
    definition: 'a district in Zhejiang',
    pinyin: ['shèng'],
    decomposition: '⿰山乘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乘',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嵋',
    definition: 'the Omei mountain in Sichuan',
    pinyin: ['méi'],
    decomposition: '⿰山眉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '眉',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嵌',
    definition: 'valley, ravine; to fall into; to inlay, to set in',
    pinyin: ['qiàn'],
    decomposition: '⿱山⿰甘欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '欠',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '嵒',
    definition: 'cliff, rocks, mountain',
    pinyin: ['yán'],
    decomposition: '⿱品山',
    etymology: {
      type: 'pictophonetic',
      phonetic: '品',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '嵘',
    definition: 'high, lofty, steep, towering',
    pinyin: ['róng'],
    decomposition: '⿰山荣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '荣',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嵛',
    definition: 'a county in the Shandong province',
    pinyin: ['yú'],
    decomposition: '⿱山俞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '俞',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嵝',
    definition: 'the Goulou mountain in Hunan',
    pinyin: ['lǒu'],
    decomposition: '⿰山娄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '娄',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嵞',
    definition: 'a mountain in Zhejiang',
    pinyin: ['tú'],
    decomposition: '⿱余屾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '余',
      semantic: '屾',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嵩',
    definition: 'high, lofty; one of the five peaks in Hunan',
    pinyin: ['sōng'],
    decomposition: '⿱山高',
    etymology: { type: 'ideographic', hint: 'A tall 高 mountain 山' },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嵫',
    definition: 'a hill in Shantung',
    pinyin: ['zī'],
    decomposition: '⿰山兹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兹',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嵬',
    definition: 'rugged, rocky, precipitous',
    pinyin: ['wéi'],
    decomposition: '⿱山鬼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鬼',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嵯',
    definition: 'high, towering; rugged, irregular',
    pinyin: ['cuó'],
    decomposition: '⿰山差',
    etymology: {
      type: 'pictophonetic',
      phonetic: '差',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嵴',
    definition: 'ridge, crest, apex',
    pinyin: ['jǐ'],
    decomposition: '⿰山脊',
    etymology: {
      type: 'ideographic',
      hint: 'The spine 脊 of a mountain 山 range; 脊 also provides the pronunciation',
    },
    radical: '山',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '嶂',
    definition: 'cliff; the barrier formed by a mountain range',
    pinyin: ['zhàng'],
    decomposition: '⿰山章',
    etymology: {
      type: 'pictophonetic',
      phonetic: '章',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嶄',
    definition: 'new, bold; steep, high',
    pinyin: ['zhǎn'],
    decomposition: '⿱山斬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斬',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嶇',
    definition: 'steep, sheer; rugged, rough',
    pinyin: ['qū'],
    decomposition: '⿰山區',
    etymology: {
      type: 'pictophonetic',
      phonetic: '區',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嶗',
    definition: 'Laoshan, a mountain in Shandong',
    pinyin: ['láo'],
    decomposition: '⿰山勞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '勞',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嶙',
    definition: 'precipitous, steep, tall',
    pinyin: ['lín'],
    decomposition: '⿰山粦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '粦',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嶝',
    definition: 'mountain path',
    pinyin: ['dèng'],
    decomposition: '⿰山登',
    etymology: {
      type: 'ideographic',
      hint: 'A road that climbs 登 a mountain 山; 登 also provides the pronunciation',
    },
    radical: '山',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嶡',
    definition: 'mountainous, precipitous; a sacrificial offering',
    pinyin: ['guì'],
    decomposition: '⿱山厥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厥',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嶧',
    definition: 'a range of peaks in Shandong and Jiangsu',
    pinyin: ['yì'],
    decomposition: '⿰山睪',
    etymology: {
      type: 'pictophonetic',
      phonetic: '睪',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嶪',
    definition: 'high, steep; perilous',
    pinyin: ['yè'],
    decomposition: '⿱山業',
    etymology: {
      type: 'pictophonetic',
      phonetic: '業',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嶷',
    definition: 'a mountain range in Hunan province',
    pinyin: ['yí'],
    decomposition: '⿱山疑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '疑',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嶸',
    definition: 'high, lofty, steep, towering',
    pinyin: ['róng'],
    decomposition: '⿰山榮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '榮',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嶺',
    definition: 'mountain ridge, mountain peak',
    pinyin: ['lǐng'],
    decomposition: '⿱山領',
    etymology: {
      type: 'pictophonetic',
      phonetic: '令',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嶼',
    definition: 'island',
    pinyin: ['yǔ'],
    decomposition: '⿰山與',
    etymology: {
      type: 'pictophonetic',
      phonetic: '與',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '嶽',
    definition: 'mountain peak, summit',
    pinyin: ['yuè'],
    decomposition: '⿱山獄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '獄',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '巂',
    definition: 'a place name',
    pinyin: ['guī'],
    decomposition: '⿱崔冏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '崔',
      semantic: '冏',
      hint: 'hot',
    },
    radical: '山',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '巅',
    definition: 'mountain peak, mountain top',
    pinyin: ['diān'],
    decomposition: '⿱山颠',
    etymology: {
      type: 'ideographic',
      hint: 'The top 颠 of a mountain 山; 颠 also provides the pronunciation',
    },
    radical: '山',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '巆',
    definition: 'deep; lofty',
    pinyin: ['róng'],
    decomposition: '⿰山營',
    etymology: {
      type: 'pictophonetic',
      phonetic: '營',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '巍',
    definition: 'high, lofty; eminent, majestic',
    pinyin: ['wēi'],
    decomposition: '⿱山魏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '魏',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '巒',
    definition: 'mountain range; tall pointed mountain',
    pinyin: ['luán'],
    decomposition: '⿱䜌山',
    etymology: {
      type: 'pictophonetic',
      phonetic: '䜌',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '巔',
    definition: 'mountain peak, mountain top',
    pinyin: ['diān'],
    decomposition: '⿱山顛',
    etymology: {
      type: 'ideographic',
      hint: 'The top 顛 of a mountain 山; 顛 also provides the pronunciation',
    },
    radical: '山',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '巖',
    definition: 'cliff, precipice; cave, grotto',
    pinyin: ['yán'],
    decomposition: '⿱山嚴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '嚴',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '山',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '巛',
    definition: 'stream, river',
    pinyin: ['chuān'],
    decomposition: '⿲？？？',
    etymology: { type: 'pictographic', hint: 'A river flowing' },
    radical: '巛',
    matches: [null, null, null],
  },
  {
    character: '川',
    definition: 'stream, river',
    pinyin: ['chuān'],
    decomposition: '⿲丿丨丨',
    etymology: { type: 'ideographic', hint: "A river's flow; compare 巛" },
    radical: '川',
    matches: [[0], [1], [2]],
  },
  {
    character: '州',
    definition: 'state, province, prefecture',
    pinyin: ['zhōu'],
    decomposition: '⿻川？',
    etymology: { type: 'ideographic', hint: 'Islands within a river 川' },
    radical: '川',
    matches: [null, [0], null, [0], null, [0]],
  },
  {
    character: '巠',
    definition: 'underground river; flowing water',
    pinyin: ['jīng'],
    decomposition: '⿱⿱一巛工',
    etymology: {
      type: 'pictophonetic',
      phonetic: '工',
      semantic: '巛',
      hint: 'river',
    },
    radical: '巛',
    matches: [[0, 0], [0, 1], [0, 1], [0, 1], [1], [1], [1]],
  },
  {
    character: '巡',
    definition: 'to cruise, to inspect, to patrol',
    pinyin: ['xún'],
    decomposition: '⿺辶巛',
    etymology: {
      type: 'ideographic',
      hint: 'To walk 辶 by the river 巛; 巛 also provides the pronunciation',
    },
    radical: '巛',
    matches: [[1], [1], [1], [0], [0], [0]],
  },
  {
    character: '巢',
    definition: 'nest, living quarters in tree',
    pinyin: ['cháo'],
    decomposition: '⿱巛果',
    etymology: { type: 'ideographic', hint: 'A nest 巛田 built in a tree 木' },
    radical: '巛',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '巤',
    definition: "a mouse's whiskers; a horse's mane; a fish's dorsal fin",
    pinyin: ['liè'],
    decomposition: '⿱巛鼠',
    etymology: { type: 'ideographic', hint: "A mouse's 鼠 whiskers 巛" },
    radical: '巛',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '工',
    definition: 'labor, work; laborer, worker',
    pinyin: ['gōng'],
    decomposition: '⿱一丄',
    etymology: {
      type: 'pictographic',
      hint: "A spade or other workman's tool",
    },
    radical: '工',
    matches: [[0], [1], [1]],
  },
  {
    character: '左',
    definition: 'left; unorthodox, improper',
    pinyin: ['zuǒ'],
    decomposition: '⿸？工',
    etymology: { type: 'pictographic', hint: 'A left hand; compare 又' },
    radical: '工',
    matches: [null, null, [1], [1], [1]],
  },
  {
    character: '巧',
    definition: 'skillful, ingenious, clever',
    pinyin: ['qiǎo'],
    decomposition: '⿰工丂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丂',
      semantic: '工',
      hint: 'work',
    },
    radical: '工',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '巨',
    definition: 'large, huge, gigantic; chief',
    pinyin: ['jù'],
    decomposition: '⿷匚？',
    etymology: {
      type: 'ideographic',
      hint: "A hand holding a large carpenter's square 工",
    },
    radical: '匚',
    matches: [[0], null, null, [0]],
  },
  {
    character: '巩',
    definition: 'to bind, to guard, to strengthen; firm, secure, strong',
    pinyin: ['gǒng'],
    decomposition: '⿰工凡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '工',
      semantic: '凡',
      hint: 'all',
    },
    radical: '工',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '巫',
    definition: 'wizard, sorcerer, witch, shaman',
    pinyin: ['wū'],
    decomposition: '⿻工从',
    etymology: { type: 'pictographic', hint: 'A cross-shaped divining rod' },
    radical: '工',
    matches: [[0], [0], [1], [1], [1], [1], [0]],
  },
  {
    character: '差',
    definition: 'difference, gap; almost, nearly; in error; an officer',
    pinyin: ['chà'],
    decomposition: '⿸羊工',
    etymology: {
      type: 'ideographic',
      hint: 'Work 工 done by a sheep 羊; incompetence',
    },
    radical: '工',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '巯',
    definition: 'an atom group',
    pinyin: ['qiú'],
    decomposition: '⿰⿱？工㐬',
    etymology: { type: 'pictophonetic', phonetic: '㐬' },
    radical: '工',
    matches: [
      null,
      null,
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '己',
    definition: 'self, oneself; personal, private; 6th heavenly stem',
    pinyin: ['jǐ'],
    decomposition: '⿱？乚',
    etymology: { type: 'pictographic', hint: 'A loom woven with thread' },
    radical: '己',
    matches: [null, null, [1]],
  },
  {
    character: '已',
    definition: 'already; finished; to stop; then, afterwards',
    pinyin: ['yǐ'],
    decomposition: '？',
    radical: '己',
    matches: [null, null, null],
  },
  {
    character: '巳',
    definition: 'the hours from 9 to 11; 6th terrestrial branch',
    pinyin: ['sì'],
    decomposition: '⿻乚？',
    radical: '巳',
    matches: [null, null, [0]],
  },
  {
    character: '巴',
    definition: 'to desire, to wish for',
    pinyin: ['bā'],
    decomposition: '⿻巳？',
    radical: '巳',
    matches: [[0], null, [0], [0]],
  },
  {
    character: '巵',
    definition: 'measuring cup; wine flask',
    pinyin: ['zhī'],
    decomposition: '⿸⿸厂一巴',
    radical: '巳',
    matches: [[0, 0], [0, 0], [0, 1], [1], [1], [1], [1]],
  },
  {
    character: '巷',
    definition: 'alley, lane',
    pinyin: ['xiàng'],
    decomposition: '⿱共巳',
    radical: '巳',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '巸',
    pinyin: ['yí'],
    decomposition: '⿰？巳',
    radical: '巳',
    matches: [null, null, null, null, null, null, null, [1], [1], [1]],
  },
  {
    character: '巹',
    definition: 'nuptial wine cup',
    pinyin: ['jǐn'],
    decomposition: '⿱丞己',
    etymology: {
      type: 'pictophonetic',
      phonetic: '己',
      semantic: '丞',
      hint: 'water',
    },
    radical: '己',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '巽',
    definition: 'mild, modest, obedient; southeast; 5th of the 8 trigrams',
    pinyin: ['xùn'],
    decomposition: '⿱⿰巳巳共',
    radical: '巳',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '巾',
    definition: 'cloth, curtain, handkerchief, towel',
    pinyin: ['jīn'],
    decomposition: '⿻冂丨',
    etymology: {
      type: 'pictographic',
      hint: 'A curtain or towel hanging from a rack',
    },
    radical: '巾',
    matches: [[0], [0], [1]],
  },
  {
    character: '巿',
    definition: 'to revolve, to turn, to make a circuit',
    pinyin: ['fú'],
    decomposition: '⿻一巾',
    etymology: { type: 'ideographic', hint: 'A belt 一 made of cloth 巾' },
    radical: '巾',
    matches: [[0], [1], [1], [1]],
  },
  {
    character: '帀',
    definition: 'to rotate, to revolve, to make a circuit',
    pinyin: ['zā'],
    decomposition: '⿱一巾',
    radical: '巾',
    matches: [[0], [1], [1], [1]],
  },
  {
    character: '币',
    definition: 'currency, coins, legal tender',
    pinyin: ['bì'],
    decomposition: '⿻丿巾',
    etymology: { type: 'ideographic', hint: 'Bills written on silk 巾' },
    radical: '巾',
    matches: [[0], [1], [1], [1]],
  },
  {
    character: '市',
    definition: 'city, town; market, fair; to trade',
    pinyin: ['shì'],
    decomposition: '⿱亠巾',
    radical: '巾',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '布',
    definition: 'cotton, linen, textiles; to announce, to declare; to spread',
    pinyin: ['bù'],
    decomposition: '⿸？巾',
    etymology: { type: 'ideographic', hint: 'Cloth 巾 held in a hand' },
    radical: '巾',
    matches: [null, null, [1], [1], [1]],
  },
  {
    character: '帅',
    definition: 'commander; commander-in-chief; handsome, smart',
    pinyin: ['shuài'],
    decomposition: '⿰刂巾',
    etymology: {
      type: 'ideographic',
      hint: 'An army officer carrying a weapon 刂 and a flag 巾',
    },
    radical: '巾',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '帆',
    definition: 'boat; to sail',
    pinyin: ['fān'],
    decomposition: '⿰巾凡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '凡',
      semantic: '巾',
      hint: 'cloth',
    },
    radical: '巾',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '师',
    definition: 'teacher, professional, master',
    pinyin: ['shī'],
    decomposition: '⿰刂帀',
    etymology: {
      type: 'ideographic',
      hint: 'To skillfully wield 帀 a knife 刂',
    },
    radical: '巾',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '希',
    definition: 'rare; to hope for, to strive for; to expect',
    pinyin: ['xī'],
    decomposition: '⿱乂布',
    radical: '巾',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '帏',
    definition: 'a curtain that forms a wall',
    pinyin: ['wéi'],
    decomposition: '⿰巾韦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韦',
      semantic: '巾',
      hint: 'curtain',
    },
    radical: '巾',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '帐',
    definition: 'tent, screen, mosquito net; debt, credit, account',
    pinyin: ['zhàng'],
    decomposition: '⿰巾长',
    etymology: {
      type: 'pictophonetic',
      phonetic: '长',
      semantic: '巾',
      hint: 'curtain',
    },
    radical: '巾',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '帑',
    definition: 'treasury; public funds',
    pinyin: ['tǎng'],
    decomposition: '⿱奴巾',
    etymology: {
      type: 'ideographic',
      hint: 'Records kept on cloth 巾 by servants 奴',
    },
    radical: '巾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '帔',
    definition: 'cape, robe, skirt',
    pinyin: ['pèi'],
    decomposition: '⿰巾皮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皮',
      semantic: '巾',
      hint: 'cloth',
    },
    radical: '巾',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '帕',
    definition: 'scarf, turban, veil, wrap',
    pinyin: ['pà'],
    decomposition: '⿰巾白',
    etymology: {
      type: 'ideographic',
      hint: "A scarf 巾 used to maintain a girl's purity 巾",
    },
    radical: '巾',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '帖',
    definition: 'card, invite, notice; to fit snugly',
    pinyin: ['tiē'],
    decomposition: '⿰巾占',
    etymology: { type: 'ideographic', hint: 'Writing on a cloth 巾' },
    radical: '巾',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '帘',
    definition: 'the flag-sign of a tavern',
    pinyin: ['lián'],
    decomposition: '⿱穴巾',
    etymology: {
      type: 'ideographic',
      hint: 'A curtain 巾 at the entrance to a cave 穴',
    },
    radical: '巾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '帙',
    definition: 'book jacket; satchel, bag',
    pinyin: ['zhì'],
    decomposition: '⿰巾失',
    etymology: {
      type: 'pictophonetic',
      phonetic: '失',
      semantic: '巾',
      hint: 'curtain',
    },
    radical: '巾',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '帚',
    definition: 'broom, broomstick',
    pinyin: ['zhǒu'],
    decomposition: '⿱彐⿱冖巾',
    etymology: {
      type: 'pictographic',
      hint: 'A hand 巾 holding a broom with the head 彐 held up',
    },
    radical: '巾',
    matches: [[0], [0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '帛',
    definition: 'silk, fabric; wealth, property',
    pinyin: ['bó'],
    decomposition: '⿱白巾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '白',
      semantic: '巾',
      hint: 'cloth',
    },
    radical: '巾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '帜',
    definition: 'flag, pennant, sign; to fasten',
    pinyin: ['zhì'],
    decomposition: '⿰巾只',
    etymology: {
      type: 'pictophonetic',
      phonetic: '只',
      semantic: '巾',
      hint: 'curtain',
    },
    radical: '巾',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '帝',
    definition: 'supreme ruler, emperor; god',
    pinyin: ['dì'],
    decomposition: '⿱立巾',
    etymology: {
      type: 'pictographic',
      hint: 'An altar on which a sacrifice is being made',
    },
    radical: '巾',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '帥',
    definition: 'commander; commander-in-chief; handsome, smart',
    pinyin: ['shuài'],
    decomposition: '⿰⿱丿㠯巾',
    etymology: {
      type: 'ideographic',
      hint: 'An army officer carrying a weapon 㠯 and a flag 巾',
    },
    radical: '巾',
    matches: [[0, 0], [0, 1], [0, 1], [0, 1], [0, 1], [0, 1], [1], [1], [1]],
  },
  {
    character: '带',
    definition:
      'belt, strap; band, ribbon; area, zone; to carry, to raise, to wear',
    pinyin: ['dài'],
    decomposition: '⿱卅⿱冖巾',
    etymology: {
      type: 'ideographic',
      hint: "A belt, creasing one's robe above 卅 but not below 巾",
    },
    radical: '巾',
    matches: [[0], [0], [0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '帧',
    definition: 'picture, scroll; one of a pair',
    pinyin: ['zhèng'],
    decomposition: '⿰巾贞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贞',
      semantic: '巾',
      hint: 'cloth',
    },
    radical: '巾',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '師',
    definition: 'teacher, professional, master',
    pinyin: ['shī'],
    decomposition: '⿰⿱丿㠯帀',
    etymology: {
      type: 'ideographic',
      hint: 'To skillfully wield 帀 a knife 㠯',
    },
    radical: '巾',
    matches: [
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '席',
    definition: 'seat, place; mat; banquet; to take a seat',
    pinyin: ['xí'],
    decomposition: '⿸广⿱廿巾',
    etymology: {
      type: 'ideographic',
      hint: 'A cloth 巾 or straw 艹 mat in the house 广',
    },
    radical: '巾',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '帮',
    definition: 'to help, to assist; to support, to defend; party; gang',
    pinyin: ['bāng'],
    decomposition: '⿱邦巾',
    etymology: {
      type: 'ideographic',
      hint: "A nation's 邦 flag 巾; 邦 also provides the pronunciation",
    },
    radical: '巾',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '帱',
    definition: 'to cover up; curtain',
    pinyin: ['chóu'],
    decomposition: '⿰巾寿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寿',
      semantic: '巾',
      hint: 'cloth',
    },
    radical: '巾',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '帳',
    definition: 'tent, screen, mosquito net; debt, credit, account',
    pinyin: ['zhàng'],
    decomposition: '⿰巾長',
    etymology: {
      type: 'pictophonetic',
      phonetic: '長',
      semantic: '巾',
      hint: 'curtain',
    },
    radical: '巾',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '帶',
    definition:
      'belt, strap; band, ribbon; area, zone; to carry, to raise, to wear',
    pinyin: ['dài'],
    decomposition: '⿱卌⿱冖巾',
    etymology: {
      type: 'ideographic',
      hint: "A belt, creasing one's robe above 卌 but not below 巾",
    },
    radical: '巾',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '帷',
    definition: 'curtain, screen, tent',
    pinyin: ['wéi'],
    decomposition: '⿰巾隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隹',
      semantic: '巾',
      hint: 'curtain',
    },
    radical: '巾',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '常',
    definition: 'common, general, normal; always, frequently, regularly',
    pinyin: ['cháng'],
    decomposition: '⿱尚巾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尚',
      semantic: '巾',
      hint: 'cloth',
    },
    radical: '巾',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '帻',
    definition: 'turban; conical cap',
    pinyin: ['zé'],
    decomposition: '⿰巾责',
    etymology: {
      type: 'pictophonetic',
      phonetic: '责',
      semantic: '巾',
      hint: 'towel',
    },
    radical: '巾',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '帼',
    definition: "women's headgear; mourning cap",
    pinyin: ['guó'],
    decomposition: '⿰巾国',
    etymology: {
      type: 'pictophonetic',
      phonetic: '国',
      semantic: '巾',
      hint: 'cloth',
    },
    radical: '巾',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '帽',
    definition: 'hat, cap',
    pinyin: ['mào'],
    decomposition: '⿰巾冒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冒',
      semantic: '巾',
      hint: 'towel',
    },
    radical: '巾',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '幀',
    definition: 'picture, scroll; one of a pair',
    pinyin: ['zhèng'],
    decomposition: '⿰巾貞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '貞',
      semantic: '巾',
      hint: 'cloth',
    },
    radical: '巾',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '幂',
    definition: 'cover-cloth; exponent, power',
    pinyin: ['mì'],
    decomposition: '⿱冖⿱旲巾',
    etymology: {
      type: 'ideographic',
      hint: 'A cover 冖 cloth 巾; 冖 also provides the pronunciation',
    },
    radical: '冖',
    matches: [
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '幃',
    definition: 'a curtain that forms a wall',
    pinyin: ['wéi'],
    decomposition: '⿰巾韋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韋',
      semantic: '巾',
      hint: 'curtain',
    },
    radical: '巾',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '幄',
    definition: 'tent; mosquito net',
    pinyin: ['wò'],
    decomposition: '⿰巾屋',
    etymology: {
      type: 'ideographic',
      hint: 'A room 屋 made of cloth 巾; 屋 also provides the pronunciation',
    },
    radical: '巾',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '幅',
    definition: 'piece, roll, strip; breadth, width; measure word for textiles',
    pinyin: ['fú'],
    decomposition: '⿰巾畐',
    etymology: {
      type: 'ideographic',
      hint: 'A roll 畐 of cloth 巾; 畐 also provides the pronunciation',
    },
    radical: '巾',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '幌',
    definition: 'curtain, cloth screen, signboard',
    pinyin: ['huǎng'],
    decomposition: '⿰巾晃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '晃',
      semantic: '巾',
      hint: 'curtain',
    },
    radical: '巾',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '幔',
    definition: 'curtain, screen, tent',
    pinyin: ['màn'],
    decomposition: '⿰巾曼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曼',
      semantic: '巾',
      hint: 'cloth',
    },
    radical: '巾',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '幕',
    definition: 'curtain, screen, tent; measure word for plays and shows',
    pinyin: ['mù'],
    decomposition: '⿱莫巾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '莫',
      semantic: '巾',
      hint: 'curtain',
    },
    radical: '巾',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '幗',
    definition: "women's headgear; mourning cap",
    pinyin: ['guó'],
    decomposition: '⿰巾國',
    etymology: {
      type: 'pictophonetic',
      phonetic: '國',
      semantic: '巾',
      hint: 'cloth',
    },
    radical: '巾',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '幛',
    definition: 'a cloth or silken hanging scroll',
    pinyin: ['zhàng'],
    decomposition: '⿰巾章',
    etymology: {
      type: 'ideographic',
      hint: 'Writing 章 on cloth 巾; 章 also provides the pronunciation',
    },
    radical: '巾',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '幞',
    definition: 'turban',
    pinyin: ['fú'],
    decomposition: '⿰巾菐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '菐',
      semantic: '巾',
      hint: 'towel',
    },
    radical: '巾',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '幟',
    definition: 'flag, pennant, sign; to fasten',
    pinyin: ['zhì'],
    decomposition: '⿰巾戠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戠',
      semantic: '巾',
      hint: 'curtain',
    },
    radical: '巾',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '幡',
    definition: 'pennant, banner, streamer, flag',
    pinyin: ['fān'],
    decomposition: '⿰巾番',
    etymology: {
      type: 'pictophonetic',
      phonetic: '番',
      semantic: '巾',
      hint: 'cloth',
    },
    radical: '巾',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '幢',
    definition:
      'carriage curtain; sun screen; tent; measure word for buildings',
    pinyin: ['chuáng'],
    decomposition: '⿰巾童',
    etymology: {
      type: 'pictophonetic',
      phonetic: '童',
      semantic: '巾',
      hint: 'curtain',
    },
    radical: '巾',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '幣',
    definition: 'currency, coins, legal tender',
    pinyin: ['bì'],
    decomposition: '⿱敝巾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敝',
      semantic: '巾',
      hint: 'cloth',
    },
    radical: '巾',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '幫',
    definition: 'to help, to assist; to support, to defend; party; gang',
    pinyin: ['bāng'],
    decomposition: '⿱封帛',
    etymology: {
      type: 'ideographic',
      hint: 'A feudal 封 flag 帛; 封 also provides the pronunciation',
    },
    radical: '巾',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '幬',
    definition: 'to cover up; curtain',
    pinyin: ['chóu'],
    decomposition: '⿰巾壽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '壽',
      semantic: '巾',
      hint: 'cloth',
    },
    radical: '巾',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '干',
    definition: 'arid, dry; to oppose; to offend; to invade',
    pinyin: ['gàn'],
    decomposition: '⿱一十',
    etymology: { type: 'pictographic', hint: 'A club or axe' },
    radical: '十',
    matches: [[0], [1], [1]],
  },
  {
    character: '平',
    definition: 'flat, level, even; peaceful',
    pinyin: ['píng'],
    decomposition: '⿻干丷',
    etymology: { type: 'pictographic', hint: 'A leveling scale' },
    radical: '广',
    matches: [[0], [1], [1], [0], [0]],
  },
  {
    character: '年',
    definition: "year; anniversary; a person's age",
    pinyin: ['nián'],
    decomposition: '⿻干？',
    etymology: {
      type: 'ideographic',
      hint: 'A man 干 carrying grain, representing the annual harvest',
    },
    radical: '干',
    matches: [null, [0], null, null, [0], [0]],
  },
  {
    character: '并',
    definition: "to combine, to annex; also, what's more",
    pinyin: ['bìng'],
    decomposition: '⿱丷开',
    etymology: {
      type: 'ideographic',
      hint: 'Simplified form of 並; two men standing side-by-side',
    },
    radical: '干',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '幸',
    definition: 'favor, fortune, luck; surname',
    pinyin: ['xìng'],
    decomposition: '⿱土⿱丷干',
    etymology: {
      type: 'ideographic',
      hint: 'Two men, one alive 土 and one dead 干; the living one is lucky',
    },
    radical: '干',
    matches: [[0], [0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '幹',
    definition: 'arid, dry; to oppose; to offend; to invade',
    pinyin: ['gàn'],
    decomposition: '⿰龺⿱人干',
    etymology: {
      type: 'pictographic',
      hint: 'Sunlight 龺 suggests "dry"; a club 人干 suggests "invade"',
    },
    radical: '干',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '幺',
    definition: 'one; tiny, small',
    pinyin: ['yāo'],
    decomposition: '？',
    radical: '幺',
    matches: [null, null, null],
  },
  {
    character: '幻',
    definition: 'fantasy, illusion, mirage; imaginary',
    pinyin: ['huàn'],
    decomposition: '⿰幺？',
    etymology: { type: 'ideographic', hint: 'An inversion of 予, "to give"' },
    radical: '幺',
    matches: [[0], [0], [0], null],
  },
  {
    character: '幼',
    definition: 'infant, young child; immature',
    pinyin: ['yòu'],
    decomposition: '⿰幺力',
    etymology: {
      type: 'ideographic',
      hint: 'One with little 幺 strength 力; 幺 also provides the pronunciation',
    },
    radical: '幺',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '幽',
    definition: 'quiet, secluded, tranquil; dark',
    pinyin: ['yōu'],
    decomposition: '⿻山⿰幺幺',
    etymology: {
      type: 'ideographic',
      hint: 'Small niches 幺 in the mountainside 山; 幺 also provides the pronunciation',
    },
    radical: '幺',
    matches: [[0], [1, 0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1], [0], [0]],
  },
  {
    character: '幾',
    definition: 'small table; how many; a few, some',
    pinyin: ['jǐ'],
    decomposition: '⿻⿰幺幺戍',
    etymology: { type: 'pictographic', hint: 'A very small 幺 table 戍' },
    radical: '幺',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '广',
    definition: 'broad, vast, wide; building, house',
    pinyin: ['guǎng'],
    decomposition: '⿱丶厂',
    etymology: {
      type: 'ideographic',
      hint: 'A lean-to 厂, suggesting a building',
    },
    radical: '广',
    matches: [[0], [1], [1]],
  },
  {
    character: '庀',
    definition: 'to prepare; to regulate',
    pinyin: ['pǐ'],
    decomposition: '⿸广匕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匕',
      semantic: '广',
      hint: 'house',
    },
    radical: '广',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '庄',
    definition: 'village, hamlet; villa, manor',
    pinyin: ['zhuāng'],
    decomposition: '⿸广土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '壯',
      semantic: '广',
      hint: 'house',
    },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '庆',
    definition: 'to congratulate, to celebrate',
    pinyin: ['qìng'],
    decomposition: '⿸广大',
    etymology: {
      type: 'ideographic',
      hint: 'A great 大 celebration in a house 广',
    },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '庇',
    definition: 'cover, shield; to protect, to shelter; to harbor',
    pinyin: ['bì'],
    decomposition: '⿸广比',
    etymology: {
      type: 'pictophonetic',
      phonetic: '比',
      semantic: '广',
      hint: 'house',
    },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '床',
    definition: 'bed, couch; framework, chassis',
    pinyin: ['chuáng'],
    decomposition: '⿸广木',
    etymology: {
      type: 'ideographic',
      hint: 'A house 广 made out of wood 木; 广 also provides the pronunciation',
    },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '庋',
    definition: 'cupboard, pantry',
    pinyin: ['guǐ'],
    decomposition: '⿸广支',
    etymology: {
      type: 'pictophonetic',
      phonetic: '支',
      semantic: '广',
      hint: 'house',
    },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '序',
    definition: 'order, sequence, series; preface',
    pinyin: ['xù'],
    decomposition: '⿸广予',
    etymology: {
      type: 'pictophonetic',
      phonetic: '予',
      semantic: '广',
      hint: 'wide',
    },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '庐',
    definition: 'hut, cottage; the name of a mountain',
    pinyin: ['lú'],
    decomposition: '⿸广户',
    etymology: {
      type: 'ideographic',
      hint: 'A house 广 with an open door 户; 户 also provides the pronunciation',
    },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '庑',
    definition: 'corridor, hallway; luxuriant',
    pinyin: ['wǔ'],
    decomposition: '⿸广无',
    etymology: {
      type: 'pictophonetic',
      phonetic: '无',
      semantic: '广',
      hint: 'house',
    },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '库',
    definition: 'armory, treasury, warehouse',
    pinyin: ['kù'],
    decomposition: '⿸广车',
    etymology: {
      type: 'ideographic',
      hint: 'A stable 广 where carriages 车 are parked',
    },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '应',
    definition: 'should, must; to respond, to handle; to deal with, to cope',
    pinyin: ['yīng'],
    decomposition: '⿸广⿱⺍一',
    radical: '广',
    matches: [[0], [0], [0], [1, 0], [1, 0], [1, 0], [1, 1]],
  },
  {
    character: '底',
    definition: 'bottom, underside; below, underneath',
    pinyin: ['dǐ'],
    decomposition: '⿸广氐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '氐',
      semantic: '广',
      hint: 'building',
    },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '庖',
    definition: 'kitchen; cooking, cuisine',
    pinyin: ['páo'],
    decomposition: '⿸广包',
    etymology: {
      type: 'pictophonetic',
      phonetic: '包',
      semantic: '广',
      hint: 'house',
    },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '店',
    definition: 'shop, store; inn, hotel',
    pinyin: ['diàn'],
    decomposition: '⿸广占',
    etymology: {
      type: 'pictophonetic',
      phonetic: '占',
      semantic: '广',
      hint: 'building',
    },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '庙',
    definition: 'temple, shrine; imperial court',
    pinyin: ['miào'],
    decomposition: '⿸广由',
    etymology: {
      type: 'ideographic',
      hint: 'A building 广 containing an altar 由',
    },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '庚',
    definition: 'age; 7th heavenly stem',
    pinyin: ['gēng'],
    decomposition: '⿸广？',
    radical: '广',
    matches: [[0], [0], [0], null, null, null, null, null],
  },
  {
    character: '府',
    definition: 'prefect; prefecture, government',
    pinyin: ['fǔ'],
    decomposition: '⿸广付',
    etymology: {
      type: 'pictophonetic',
      phonetic: '付',
      semantic: '广',
      hint: 'wide',
    },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '庞',
    definition: 'disorderly, messy; huge, big',
    pinyin: ['páng'],
    decomposition: '⿸广龙',
    etymology: { type: 'ideographic', hint: 'A dragon 龙 inside a house 广' },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '废',
    definition: 'to terminate; to discard; to abgrogate',
    pinyin: ['fèi'],
    decomposition: '⿸广发',
    etymology: { type: 'pictophonetic', phonetic: '发' },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '庠',
    definition: 'village school; teach',
    pinyin: ['xiáng'],
    decomposition: '⿸广羊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羊',
      semantic: '广',
      hint: 'building',
    },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '庥',
    definition: 'shade; shelter, protection',
    pinyin: ['xiū'],
    decomposition: '⿸广休',
    etymology: {
      type: 'pictophonetic',
      phonetic: '休',
      semantic: '广',
      hint: 'building',
    },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '度',
    definition: 'degree, system; manner; to consider',
    pinyin: ['dù'],
    decomposition: '⿸广⿱廿又',
    etymology: {
      type: 'ideographic',
      hint: 'Twenty 廿 people 又 meeting inside a building 广 to deliberate',
    },
    radical: '广',
    matches: [[0], [0], [0], [1, 0], [1, 0], [1, 0], [1, 0], [1, 1], [1, 1]],
  },
  {
    character: '座',
    definition: 'seat; stand, base',
    pinyin: ['zuò'],
    decomposition: '⿸广坐',
    etymology: {
      type: 'ideographic',
      hint: 'A wide 广 seat 坐; 坐 also provides the pronunciation',
    },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '庫',
    definition: 'armory, treasury, warehouse',
    pinyin: ['kù'],
    decomposition: '⿸广車',
    etymology: {
      type: 'ideographic',
      hint: 'A stable 广 where carriages 車 are parked',
    },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '庭',
    definition: 'court; courtyard; spacious hall or yard',
    pinyin: ['tíng'],
    decomposition: '⿸广廷',
    etymology: {
      type: 'ideographic',
      hint: 'A wide 广 couryard 廷; 廷 also provides the pronunciation',
    },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '庳',
    definition: 'a low-built house',
    pinyin: ['bì'],
    decomposition: '⿸广卑',
    etymology: { type: 'ideographic', hint: 'A low 卑 house 广' },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '庵',
    definition: 'Buddhist monastery or nunnery',
    pinyin: ['ān'],
    decomposition: '⿸广奄',
    etymology: {
      type: 'ideographic',
      hint: 'A building 广 where people remain 奄; 奄 also provides the pronunciation',
    },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '庶',
    definition: 'numerous, various; multitude',
    pinyin: ['shù'],
    decomposition: '⿸广⿱廿灬',
    etymology: {
      type: 'ideographic',
      hint: 'Many people 灬 (twenty or more 廿) in a house 广',
    },
    radical: '广',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '康',
    definition: 'health; peace, quiet',
    pinyin: ['kāng'],
    decomposition: '⿸广隶',
    etymology: { type: 'ideographic', hint: 'A home 广 with a servant 隶' },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '庸',
    definition: 'usual, common, ordinary, mediocre',
    pinyin: ['yōng'],
    decomposition: '⿸广⿱彐用',
    etymology: { type: 'pictophonetic', phonetic: '用' },
    radical: '广',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '庹',
    definition: "the length of one's two outstretched arms",
    pinyin: ['tuǒ'],
    decomposition: '⿸广⿱廿尺',
    etymology: { type: 'pictophonetic', semantic: '广', hint: 'wide' },
    radical: '广',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '庾',
    definition: 'granary; storehouse',
    pinyin: ['yǔ'],
    decomposition: '⿸广臾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臾',
      semantic: '广',
      hint: 'building',
    },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '廁',
    definition: 'toilet, washroom; to mingle',
    pinyin: ['cè'],
    decomposition: '⿸广則',
    etymology: {
      type: 'pictophonetic',
      phonetic: '則',
      semantic: '广',
      hint: 'building',
    },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '廂',
    definition: 'side-room, wing; theatre box',
    pinyin: ['xiāng'],
    decomposition: '⿸广相',
    etymology: {
      type: 'pictophonetic',
      phonetic: '相',
      semantic: '广',
      hint: 'building',
    },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '廄',
    definition: 'stable; barnyard',
    pinyin: ['jiù'],
    decomposition: '⿸广既',
    etymology: {
      type: 'pictophonetic',
      phonetic: '既',
      semantic: '厂',
      hint: 'building',
    },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '廈',
    definition: 'large building; mansion',
    pinyin: ['shà'],
    decomposition: '⿸广夏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夏',
      semantic: '广',
      hint: 'building',
    },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '廉',
    definition: 'upright, honorable, honest',
    pinyin: ['lián'],
    decomposition: '⿸广兼',
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '廊',
    definition: 'corridor, porch, veranda',
    pinyin: ['láng'],
    decomposition: '⿸广郎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '郎',
      semantic: '广',
      hint: 'wide',
    },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '廌',
    definition: 'unicorn',
    pinyin: ['zhì'],
    decomposition: '⿸鹿豸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豸',
      semantic: '鹿',
      hint: 'deer',
    },
    radical: '鹿',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '廑',
    definition: 'hut; careful',
    pinyin: ['jǐn'],
    decomposition: '⿸广堇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堇',
      semantic: '广',
      hint: 'house',
    },
    radical: '广',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '廒',
    definition: 'granary',
    pinyin: ['áo'],
    decomposition: '⿸广敖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敖',
      semantic: '广',
      hint: 'building',
    },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '廓',
    definition: 'broad, wide; open; empty; outline',
    pinyin: ['kuò'],
    decomposition: '⿸广郭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '郭',
      semantic: '广',
      hint: 'wide',
    },
    radical: '广',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '廖',
    definition: 'deserted, empty, few; surname',
    pinyin: ['liào'],
    decomposition: '⿸广翏',
    etymology: {
      type: 'ideographic',
      hint: 'The wind 翏 blowing over a vast, empty plain 广',
    },
    radical: '广',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '廚',
    definition: 'kitchen; closet, cupboard',
    pinyin: ['chú'],
    decomposition: '⿸广尌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豆',
      semantic: '厂',
      hint: 'building',
    },
    radical: '广',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '廛',
    definition: 'store, shop',
    pinyin: ['chán'],
    decomposition: '⿸广⿱⿱里八土',
    etymology: { type: 'pictophonetic', semantic: '广', hint: 'building' },
    radical: '广',
    matches: [
      [0],
      [0],
      [0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 1],
      [1, 0, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '廟',
    definition: 'temple, shrine; imperial court',
    pinyin: ['miào'],
    decomposition: '⿸广朝',
    etymology: {
      type: 'ideographic',
      hint: 'A building 广 containing an altar 朝',
    },
    radical: '广',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '廠',
    definition: 'cliff; factory, workshop; building',
    pinyin: ['chǎng'],
    decomposition: '⿸广敞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敞',
      semantic: '广',
      hint: 'building',
    },
    radical: '广',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '廡',
    definition: 'corridor, hallway; luxuriant',
    pinyin: ['wǔ'],
    decomposition: '⿸广無',
    etymology: {
      type: 'pictophonetic',
      phonetic: '無',
      semantic: '广',
      hint: 'house',
    },
    radical: '广',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '廢',
    definition: 'to terminate; to discard; to abgrogate',
    pinyin: ['fèi'],
    decomposition: '⿸广發',
    etymology: { type: 'pictophonetic', phonetic: '發' },
    radical: '广',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '廣',
    definition: 'broad, vast, wide; building, house',
    pinyin: ['guǎng'],
    decomposition: '⿸广黄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '黄',
      semantic: '广',
      hint: 'building',
    },
    radical: '广',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '廥',
    definition: 'granary, barn',
    pinyin: ['kuài'],
    decomposition: '⿸广會',
    etymology: {
      type: 'ideographic',
      hint: 'A building 广 where food is stored 會; 會 also provides the pronunciation',
    },
    radical: '广',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '廨',
    definition: 'office',
    pinyin: ['xiè'],
    decomposition: '⿸广解',
    etymology: {
      type: 'pictophonetic',
      phonetic: '解',
      semantic: '广',
      hint: 'building',
    },
    radical: '广',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '廪',
    definition: 'granary; to stockpile',
    pinyin: ['lǐn'],
    decomposition: '⿸广禀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '禀',
      semantic: '广',
      hint: 'building',
    },
    radical: '广',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '廬',
    definition: 'hut, cottage; the name of a mountain',
    pinyin: ['lú'],
    decomposition: '⿸广盧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '盧',
      semantic: '广',
      hint: 'house',
    },
    radical: '广',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '廳',
    definition: 'hall, central room',
    pinyin: ['tīng'],
    decomposition: '⿸广聽',
    etymology: {
      type: 'pictophonetic',
      hint: 'spacious',
      semantic: '广',
      phonetic: '聽',
    },
    radical: '广',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '廴',
    definition: 'to walk, to go; a place',
    pinyin: ['yǐn'],
    decomposition: '？',
    etymology: { type: 'pictographic', hint: 'A man walking to the left' },
    radical: '廴',
    matches: [null, null],
  },
  {
    character: '延',
    definition:
      'to defer, to delay, to postpone; to extend, to prolong; surname',
    pinyin: ['yán'],
    decomposition: '⿱丿㢟',
    etymology: {
      type: 'ideographic',
      hint: 'A foot on the road 㢟 stopped in its tracks 丿',
    },
    radical: '廴',
    matches: [[0], [1], [1], [1], [1], [1]],
  },
  {
    character: '廷',
    definition: 'courtyard',
    pinyin: ['tíng'],
    decomposition: '⿺廴壬',
    etymology: { type: 'pictophonetic', semantic: '廴', hint: 'place' },
    radical: '廴',
    matches: [[1], [1], [1], [1], [0], [0]],
  },
  {
    character: '建',
    definition: 'to build, to erect; to establish, to found',
    pinyin: ['jiàn'],
    decomposition: '⿺廴聿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '聿',
      semantic: '廴',
      hint: 'action',
    },
    radical: '廴',
    matches: [[1], [1], [1], [1], [1], [1], [0], [0]],
  },
  {
    character: '廾',
    definition: 'two hands',
    pinyin: ['gǒng'],
    decomposition: '？',
    etymology: { type: 'ideographic', hint: 'Two hands 十 side by side' },
    radical: '廾',
    matches: [null, null, null],
  },
  {
    character: '廿',
    definition: 'twenty, twentieth',
    pinyin: ['niàn'],
    decomposition: '⿻廾一',
    etymology: { type: 'ideographic', hint: 'Two tens 十 side by side' },
    radical: '廾',
    matches: [[0], [0], [0], [1]],
  },
  {
    character: '开',
    definition: 'to open; to start, to initiate, to begin',
    pinyin: ['kāi'],
    decomposition: '⿱一廾',
    etymology: {
      type: 'ideographic',
      hint: 'Simplified form of 開; hands 廾 lifting the latch 一 of a door',
    },
    radical: '廾',
    matches: [[0], [1], [1], [1]],
  },
  {
    character: '弁',
    definition: 'conical cap worn during the Zhou dynasty',
    pinyin: ['biàn'],
    decomposition: '⿱厶廾',
    etymology: {
      type: 'pictographic',
      hint: "Two hands 廾 putting the cap 厶 on someone's head",
    },
    radical: '廾',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '异',
    definition: 'different, strange, unusual; foreign; surprising',
    pinyin: ['yì'],
    decomposition: '⿱巳廾',
    etymology: {
      type: 'ideographic',
      hint: 'Simplified form of 異; a person 共 with a scary face田',
    },
    radical: '廾',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '弃',
    definition: 'to abandon, to discard, to reject; to desert; to forget',
    pinyin: ['qì'],
    decomposition: '⿳亠厶廾',
    etymology: {
      type: 'ideographic',
      hint: 'Two hands 廾 discarding a dead, swaddled baby 亠厶',
    },
    radical: '廾',
    matches: [[0], [0], [1], [1], [2], [2], [2]],
  },
  {
    character: '弄',
    definition: 'to do; to mock, to tease; to play with',
    pinyin: ['nòng'],
    decomposition: '⿱玉廾',
    etymology: {
      type: 'ideographic',
      hint: 'Two hands 廾 playing with a piece of jade 玉; 廾 also provides the pronunciation',
    },
    radical: '廾',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '弇',
    definition: 'to trap; to hide, to cover; narrow-necked',
    pinyin: ['yǎn'],
    decomposition: '⿱合廾',
    radical: '廾',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '弈',
    definition: 'Chinese chess',
    pinyin: ['yì'],
    decomposition: '⿱亦廾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亦',
      semantic: '廾',
      hint: 'hands',
    },
    radical: '廾',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '弊',
    definition: 'evil, bad, wrong; fraud, harm',
    pinyin: ['bì'],
    decomposition: '⿱敝廾',
    etymology: {
      type: 'ideographic',
      hint: 'Two hands 廾 breaking something 敝; 敝 also provides the pronunciation',
    },
    radical: '廾',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '弋',
    definition: 'to catch, to arrest; to shoot with a bow',
    pinyin: ['yì'],
    decomposition: '？',
    etymology: {
      type: 'pictographic',
      hint: 'Picture of an arrow shot from a bow',
    },
    radical: '弋',
    matches: [null, null, null],
  },
  {
    character: '式',
    definition: 'formula, pattern, rule, style, system',
    pinyin: ['shì'],
    decomposition: '⿹弋工',
    etymology: {
      type: 'ideographic',
      hint: 'A craftsman using an awl 弋 and a measuring square 工',
    },
    radical: '弋',
    matches: [[0], [1], [1], [1], [0], [0]],
  },
  {
    character: '弑',
    definition: 'patricide, matricide',
    pinyin: ['shì'],
    decomposition: '⿰杀式',
    etymology: {
      type: 'pictophonetic',
      phonetic: '式',
      semantic: '杀',
      hint: 'murder',
    },
    radical: '弋',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '弒',
    definition: 'patricide, matricide',
    pinyin: ['shì'],
    decomposition: '⿰杀式',
    etymology: {
      type: 'pictophonetic',
      phonetic: '式',
      semantic: '杀',
      hint: 'murder',
    },
    radical: '弋',
    matches: [[0], [0], [0], [0], [0], [0], null, [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '弓',
    definition: 'bow; curved, arched',
    pinyin: ['gōng'],
    decomposition: '？',
    etymology: { type: 'pictographic', hint: 'A bow aimed to the left' },
    radical: '弓',
    matches: [null, null, null],
  },
  {
    character: '弔',
    definition: 'to suspend, to hang; to pity, to condole',
    pinyin: ['diào'],
    decomposition: '⿻弓丨',
    etymology: { type: 'ideographic', hint: 'A corpse 弓 hanged on a rope 丨' },
    radical: '弓',
    matches: [[0], [0], [0], [1]],
  },
  {
    character: '引',
    definition: 'to pull, to stretch; to draw; to attract',
    pinyin: ['yǐn'],
    decomposition: '⿰弓丨',
    etymology: {
      type: 'ideographic',
      hint: "To pull back a bow's 弓 drawstring 丨",
    },
    radical: '弓',
    matches: [[0], [0], [0], [1]],
  },
  {
    character: '弗',
    definition: 'not, negative',
    pinyin: ['fú'],
    decomposition: '⿻弓⿰丨丨',
    etymology: {
      type: 'ideographic',
      hint: 'Two arrows 丨 pulled across a bow',
    },
    radical: '弓',
    matches: [[0], [0], [0], [1, 0], [1, 1]],
  },
  {
    character: '弘',
    definition: 'to enlarge, to expand; liberal, great',
    pinyin: ['hóng'],
    decomposition: '⿰弓厶',
    radical: '弓',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '弛',
    definition: 'to loosen, to relax; to unstring a bow',
    pinyin: ['chí'],
    decomposition: '⿰弓也',
    etymology: {
      type: 'pictophonetic',
      phonetic: '也',
      semantic: '弓',
      hint: 'bow',
    },
    radical: '弓',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '弟',
    definition: 'young brother, junior',
    pinyin: ['dì'],
    decomposition: '⿱丷⿻弓？',
    radical: '弓',
    matches: [[0], [0], [1, 0], [1, 0], [1, 0], null, null],
  },
  {
    character: '张',
    definition: 'to display; to expand, to open; to stretch; a sheet of paper',
    pinyin: ['zhāng'],
    decomposition: '⿰弓长',
    etymology: {
      type: 'pictophonetic',
      phonetic: '长',
      semantic: '弓',
      hint: 'bow',
    },
    radical: '弓',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '弥',
    definition: 'complete, extensive, full; to fill',
    pinyin: ['mí'],
    decomposition: '⿰弓尔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尔',
      semantic: '弓',
      hint: 'bow',
    },
    radical: '弓',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '弦',
    definition: 'bow string; string instrument; hypotenuse',
    pinyin: ['xián'],
    decomposition: '⿰弓玄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '玄',
      semantic: '弓',
      hint: 'bow',
    },
    radical: '弓',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '弧',
    definition: 'arc, crescent; wooden bow',
    pinyin: ['hú'],
    decomposition: '⿰弓瓜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '瓜',
      semantic: '弓',
      hint: 'bow',
    },
    radical: '弓',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '弩',
    definition: 'crossbow; an arrow falling, a downward stroke',
    pinyin: ['nǔ'],
    decomposition: '⿱奴弓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奴',
      semantic: '弓',
      hint: 'bow',
    },
    radical: '弓',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '弪',
    definition: 'radian (mathematics)',
    pinyin: ['jìng'],
    decomposition: '⿰弓？',
    etymology: { type: 'pictophonetic', semantic: '弓', hint: 'bow' },
    radical: '弓',
    matches: [[0], [0], [0], null, null, null, null, null],
  },
  {
    character: '弭',
    definition: 'to stop, to repress, to quell',
    pinyin: ['mǐ'],
    decomposition: '⿰弓耳',
    radical: '弓',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '弮',
    definition: 'a repeating crossbow',
    pinyin: ['quān'],
    decomposition: '⿱龹弓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龹',
      semantic: '弓',
      hint: 'bow',
    },
    radical: '弓',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '弯',
    definition: 'bend, curve, turn',
    pinyin: ['wān'],
    decomposition: '⿱亦弓',
    etymology: { type: 'ideographic', hint: 'Like 亦 a bow 弓' },
    radical: '弓',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '弱',
    definition: 'weak, fragile, delicate',
    pinyin: ['ruò'],
    decomposition: '⿰⿹弓冫⿹弓冫',
    etymology: { type: 'ideographic', hint: 'Two shoots 弓 dying to frost 冫' },
    radical: '弓',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '弳',
    definition: 'radian (mathematics)',
    pinyin: ['jìng'],
    decomposition: '⿰弓巠',
    etymology: { type: 'pictophonetic', semantic: '弓', hint: 'bow' },
    radical: '弓',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '張',
    definition: 'to display; to expand, to open; to stretch; a sheet of paper',
    pinyin: ['zhāng'],
    decomposition: '⿰弓長',
    etymology: {
      type: 'pictophonetic',
      phonetic: '長',
      semantic: '弓',
      hint: 'bow',
    },
    radical: '弓',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '強',
    definition: 'strong, powerful, energetic',
    pinyin: ['qiáng'],
    decomposition: '⿰弓⿱厶虫',
    etymology: {
      type: 'pictophonetic',
      semantic: '弓',
      hint: 'bow',
      phonetic: '虫',
    },
    radical: '弓',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '弹',
    definition: 'bullet, pellet, shell; elastic, springy',
    pinyin: ['dàn'],
    decomposition: '⿰弓单',
    etymology: {
      type: 'pictophonetic',
      phonetic: '单',
      semantic: '弓',
      hint: 'bow',
    },
    radical: '弓',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '强',
    definition: 'strong, powerful, energetic',
    pinyin: ['qiáng'],
    decomposition: '⿰弓虽',
    etymology: {
      type: 'pictophonetic',
      semantic: '弓',
      hint: 'bow',
      phonetic: '虫',
    },
    radical: '弓',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '弼',
    definition: 'to aid, to help; to correct',
    pinyin: ['bì'],
    decomposition: '⿲弓百弓',
    radical: '弓',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [2], [2], [2]],
  },
  {
    character: '彀',
    definition: 'enough; quite',
    pinyin: ['gòu'],
    decomposition: '⿰⿱⿳士冖一弓殳',
    radical: '弓',
    matches: [
      [0, 0, 0],
      [0, 0, 0],
      [0, 0, 0],
      [0, 0, 1],
      [0, 0, 1],
      [0, 0, 2],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '彆',
    definition: 'awkward',
    pinyin: ['biè'],
    decomposition: '⿱敝弓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敝',
      semantic: '弓',
      hint: 'curved',
    },
    radical: '弓',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '彈',
    definition: 'bullet, pellet, shell; elastic, springy',
    pinyin: ['dàn'],
    decomposition: '⿰弓單',
    etymology: {
      type: 'pictophonetic',
      phonetic: '單',
      semantic: '弓',
      hint: 'bow',
    },
    radical: '弓',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '彊',
    definition: 'stubborn, uncompromising',
    pinyin: ['jiàng'],
    decomposition: '⿰弓畺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畺',
      semantic: '弓',
      hint: 'bow',
    },
    radical: '弓',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '彌',
    definition: 'complete, extensive, full; to fill',
    pinyin: ['mí'],
    decomposition: '⿰弓爾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爾',
      semantic: '弓',
      hint: 'bow',
    },
    radical: '弓',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '彎',
    definition: 'bend, curve, turn',
    pinyin: ['wān'],
    decomposition: '⿱䜌弓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '䜌',
      semantic: '弓',
      hint: 'bow',
    },
    radical: '弓',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '彐',
    definition: 'snout',
    pinyin: ['jì'],
    decomposition: '⿹？二',
    radical: '彐',
    matches: [null, [1], [1]],
  },
  {
    character: '彑',
    definition: 'snout',
    pinyin: ['jì'],
    decomposition: '⿱？一',
    etymology: { type: 'pictographic', hint: 'A head-on view of a snout' },
    radical: '彑',
    matches: [null, null, [1]],
  },
  {
    character: '归',
    definition: 'to return, to go back; to return to, to revert',
    pinyin: ['guī'],
    decomposition: '⿰？彐',
    etymology: {
      type: 'ideographic',
      hint: 'Simplified form of 歸; a wife 帚 returning home; 追 provides the pronunciation',
    },
    radical: '彐',
    matches: [null, null, [1], [1], [1]],
  },
  {
    character: '当',
    definition: 'appropriate, timely; to act, to serve; the sound of bells',
    pinyin: ['dāng'],
    decomposition: '⿱⺌彐',
    radical: '⺌',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '彔',
    definition: 'to carve wood',
    pinyin: ['lù'],
    decomposition: '⿱彑氺',
    radical: '彑',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '录',
    definition: 'to copy, to record, to write down',
    pinyin: ['lù'],
    decomposition: '⿱彐氺',
    etymology: { type: 'pictographic', hint: 'A brush used to record stories' },
    radical: '彐',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '彖',
    definition: 'hog, hedgehog, porcupine',
    pinyin: ['tuàn'],
    decomposition: '⿱彑豕',
    etymology: { type: 'ideographic', hint: 'A pig 豕 with a long snout 彑' },
    radical: '彑',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '彗',
    definition: 'comet; broomstick',
    pinyin: ['huì'],
    decomposition: '⿱⿰丰丰彐',
    etymology: {
      type: 'ideographic',
      hint: 'A hand 彐 holding a bamboo broom 丰',
    },
    radical: '彐',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '彘',
    definition: 'swine',
    pinyin: ['zhì'],
    decomposition: '⿱彑⿻比矢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '矢',
      semantic: '彑',
      hint: 'snout',
    },
    radical: '彑',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 0],
      [1, 0],
    ],
  },
  {
    character: '彙',
    definition: 'to gather, to collect; confluence',
    pinyin: ['huì'],
    decomposition: '⿱彑⿱冖果',
    etymology: { type: 'ideographic', hint: 'To gather 彑 fruit 果' },
    radical: '彑',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '彝',
    definition: 'the Yi tribe; tripod; rule, nature',
    pinyin: ['yí'],
    decomposition: '⿱彑⿱⿰米糸廾',
    radical: '彑',
    matches: [
      [0],
      [0],
      [0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 1],
      [1, 0, 1],
      [1, 0, 1],
      [1, 0, 1],
      [1, 0, 1],
      [1, 0, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '彞',
    definition: 'the Yi tribe; tripod; rule, nature',
    pinyin: ['yí'],
    decomposition: '⿱彐⿱⿰米糸廾',
    radical: '彐',
    matches: [
      [0],
      [0],
      [0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 1],
      [1, 0, 1],
      [1, 0, 1],
      [1, 0, 1],
      [1, 0, 1],
      [1, 0, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '彟',
    definition: 'to measure; to calculate',
    pinyin: ['yuē'],
    decomposition: '⿰寻蒦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寻',
      semantic: '蒦',
      hint: 'measure',
    },
    radical: '彐',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '彡',
    definition: 'hair; sunlight',
    pinyin: ['shān'],
    decomposition: '⿳丿丿丿',
    etymology: { type: 'pictographic', hint: 'Tufts of hair' },
    radical: '彡',
    matches: [[0], [1], [2]],
  },
  {
    character: '形',
    definition: 'form, shape; to appear; to describe; to look',
    pinyin: ['xíng'],
    decomposition: '⿰开彡',
    etymology: {
      type: 'ideographic',
      hint: 'Sunlight 彡 streaming through a window 开',
    },
    radical: '彡',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '彤',
    definition: 'red, vermillion',
    pinyin: ['tóng'],
    decomposition: '⿰丹彡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彡',
      semantic: '丹',
      hint: 'red',
    },
    radical: '彡',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '彥',
    definition: 'elegant',
    pinyin: ['yàn'],
    decomposition: '⿱文⿸厂彡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '文',
      semantic: '彡',
      hint: 'hair',
    },
    radical: '彡',
    matches: [[0], [0], [0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '彦',
    definition: 'elegant',
    pinyin: ['yàn'],
    decomposition: '⿱产彡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '产',
      semantic: '彡',
      hint: 'hair',
    },
    radical: '彡',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '彧',
    definition: 'cultured, refined; polished',
    pinyin: ['yù'],
    decomposition: '⿻或彡',
    radical: '彡',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [0]],
  },
  {
    character: '彩',
    definition: 'color, hue; prize; brilliant; variegated',
    pinyin: ['cǎi'],
    decomposition: '⿰采彡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '采',
      semantic: '彡',
      hint: 'hair',
    },
    radical: '彡',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '彪',
    definition: "tiger; a tiger's stripes; like a tiger",
    pinyin: ['biāo'],
    decomposition: '⿺虎彡',
    etymology: { type: 'ideographic', hint: "A tiger's 虎 stripes 彡" },
    radical: '彡',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '彬',
    definition: 'ornamental; cultivated, refined, well-bred',
    pinyin: ['bīn'],
    decomposition: '⿰林彡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '林',
      semantic: '彡',
      hint: 'hair',
    },
    radical: '彡',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '彭',
    definition: 'name of an ancient country; surname',
    pinyin: ['péng'],
    decomposition: '⿰壴彡',
    etymology: { type: 'ideographic', hint: 'The sound 彡 of drums 壴' },
    radical: '彡',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '彰',
    definition: 'clear, manifest, obvious',
    pinyin: ['zhāng'],
    decomposition: '⿰章彡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '章',
      semantic: '彡',
      hint: 'sunlight',
    },
    radical: '彡',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '影',
    definition: 'shadow; image, reflection; photograph',
    pinyin: ['yǐng'],
    decomposition: '⿰景彡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '景',
      semantic: '彡',
      hint: 'sunlight',
    },
    radical: '彡',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '彳',
    definition: 'to step with the left foot',
    pinyin: ['chì'],
    decomposition: '⿱？丨',
    radical: '彳',
    matches: [null, null, [1]],
  },
  {
    character: '彷',
    definition: 'similar, alike; to resemble',
    pinyin: ['fǎng'],
    decomposition: '⿰彳方',
    etymology: {
      type: 'pictophonetic',
      phonetic: '方',
      semantic: '彳',
      hint: 'step',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '彸',
    definition: 'agitated, restless',
    pinyin: ['zhōng'],
    decomposition: '⿰彳公',
    etymology: {
      type: 'pictophonetic',
      phonetic: '公',
      semantic: '彳',
      hint: 'step',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '役',
    definition: 'servant, laborer; service; to serve',
    pinyin: ['yì'],
    decomposition: '⿰彳殳',
    etymology: {
      type: 'ideographic',
      hint: 'A person walking over 彳 with food in hand 殳',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '彻',
    definition: 'penetrating, pervasive; to penetrate, to pass through',
    pinyin: ['chè'],
    decomposition: '⿰彳切',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彳',
      semantic: '切',
      hint: 'cut',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '彼',
    definition: 'that, those, the other',
    pinyin: ['bǐ'],
    decomposition: '⿰彳皮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皮',
      semantic: '彳',
      hint: 'step',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '彿',
    definition: 'similar, alike; Buddhist',
    pinyin: ['fú'],
    decomposition: '⿰彳弗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弗',
      semantic: '彳',
      hint: 'step',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '往',
    definition: 'to go, to depart; past, former',
    pinyin: ['wǎng'],
    decomposition: '⿰彳⿱？王',
    etymology: {
      type: 'pictophonetic',
      phonetic: '王',
      semantic: '彳',
      hint: 'step',
    },
    radical: '彳',
    matches: [[0], [0], [0], null, [1, 1], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '征',
    definition: 'to summon, to recruit; levy, tax; journey; invasion',
    pinyin: ['zhēng'],
    decomposition: '⿰彳正',
    etymology: {
      type: 'pictophonetic',
      phonetic: '正',
      semantic: '彳',
      hint: 'step',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '徂',
    definition: 'to advance, to go; to; die',
    pinyin: ['cú'],
    decomposition: '⿰彳且',
    etymology: {
      type: 'pictophonetic',
      phonetic: '且',
      semantic: '彳',
      hint: 'step',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '径',
    definition: 'path, diameter; straight, direct',
    pinyin: ['jìng'],
    decomposition: '⿰彳⿱又工',
    etymology: {
      type: 'pictophonetic',
      phonetic: '工',
      semantic: '彳',
      hint: 'step',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '待',
    definition: 'to entertain, to receive, to treat; to delay, to wait',
    pinyin: ['dài'],
    decomposition: '⿰彳寺',
    etymology: {
      type: 'ideographic',
      hint: 'To welcome someone arriving 彳 at the royal court 寺',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '徇',
    definition: 'to follow, to comply with; to display',
    pinyin: ['xùn'],
    decomposition: '⿰彳旬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旬',
      semantic: '彳',
      hint: 'step',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '很',
    definition: 'very, quite, much',
    pinyin: ['hěn'],
    decomposition: '⿰彳艮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '艮',
      semantic: '彳',
      hint: 'step',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '徉',
    definition: 'to wander, to stray, to roam; to hesitate',
    pinyin: ['yáng'],
    decomposition: '⿰彳羊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羊',
      semantic: '彳',
      hint: 'step',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '徊',
    definition: 'to linger, to pace; irresolute',
    pinyin: ['huái'],
    decomposition: '⿰彳回',
    etymology: {
      type: 'ideographic',
      hint: 'To pace 彳 back and forth 回; 回 also provides the pronunciation',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '律',
    definition: 'statute, principle, regulation',
    pinyin: ['lǜ'],
    decomposition: '⿰彳聿',
    etymology: {
      type: 'ideographic',
      hint: 'To walk 彳 as required by law 聿',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '後',
    definition: 'after; behind, rear; descendants',
    pinyin: ['hòu'],
    decomposition: '⿰彳⿱幺夂',
    etymology: {
      type: 'ideographic',
      hint: 'One step 彳 coming behind another 夂; 幺 provides the pronunciation',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1, 0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '徐',
    definition: 'slowly, quietly, calmly; dignified, composed',
    pinyin: ['xú'],
    decomposition: '⿰彳余',
    etymology: {
      type: 'pictophonetic',
      phonetic: '余',
      semantic: '彳',
      hint: 'step',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '徑',
    definition: 'path, diameter; straight, direct',
    pinyin: ['jìng'],
    decomposition: '⿰彳巠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巠',
      semantic: '彳',
      hint: 'step',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '徒',
    definition: 'disciple, follower; only, merely; in vain',
    pinyin: ['tú'],
    decomposition: '⿰彳走',
    etymology: {
      type: 'ideographic',
      hint: "To walk 走 in someone's footsteps 彳",
    },
    radical: '彳',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '徕',
    definition: 'to entice, to solicit; to encourage customers to come',
    pinyin: ['lái'],
    decomposition: '⿰彳来',
    etymology: {
      type: 'pictophonetic',
      phonetic: '来',
      semantic: '彳',
      hint: 'step',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '得',
    definition: 'to obtain, to get, to acquire; suitable, proper; ready',
    pinyin: ['dé'],
    decomposition: '⿰彳⿱旦寸',
    etymology: { type: 'ideographic', hint: 'A hand 寸 grabbing a shell 旦' },
    radical: '彳',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '徘',
    definition: 'to dither, to pace; hesitant',
    pinyin: ['pái'],
    decomposition: '⿰彳非',
    etymology: {
      type: 'pictophonetic',
      phonetic: '非',
      semantic: '彳',
      hint: 'step',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '徙',
    definition: 'to move, to shift; to migrate',
    pinyin: ['xǐ'],
    decomposition: '⿰彳歨',
    etymology: {
      type: 'ideographic',
      hint: 'To step 彳 out on a long journey 歨',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '徜',
    definition: 'to linger, to walk back and forth',
    pinyin: ['cháng'],
    decomposition: '⿰彳尚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尚',
      semantic: '彳',
      hint: 'step',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '從',
    definition: 'from, by, since, whence, through',
    pinyin: ['cóng'],
    decomposition: '⿰彳⿱从足',
    etymology: {
      type: 'pictophonetic',
      phonetic: '从',
      semantic: '彳',
      hint: 'step',
    },
    radical: '彳',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '徠',
    definition: 'to entice, to solicit; to encourage customers to come',
    pinyin: ['lái'],
    decomposition: '⿰彳來',
    etymology: {
      type: 'pictophonetic',
      phonetic: '來',
      semantic: '彳',
      hint: 'step',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '御',
    definition: 'chariot; to drive, to ride; to manage',
    pinyin: ['yù'],
    decomposition: '⿰彳卸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卸',
      semantic: '彳',
      hint: 'step',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '徨',
    definition: 'doubtful, irresolute, vacillating',
    pinyin: ['huáng'],
    decomposition: '⿰彳皇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皇',
      semantic: '彳',
      hint: 'step',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '復',
    definition: 'again, repeatedly; copy, duplicate; to restore, to return',
    pinyin: ['fù'],
    decomposition: '⿰彳复',
    etymology: {
      type: 'ideographic',
      hint: 'Older form of 复; see that character for the etymology',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '循',
    definition: 'to obey, to follow, to comply with',
    pinyin: ['xún'],
    decomposition: '⿰彳盾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '盾',
      semantic: '彳',
      hint: 'step',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '徭',
    definition: 'conscripted labor',
    pinyin: ['yáo'],
    decomposition: '⿰彳䍃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '䍃',
      semantic: '彳',
      hint: 'step',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '微',
    definition: 'small, tiny, trifling; micro-',
    pinyin: ['wēi'],
    decomposition: '⿲彳⿱山兀攵',
    radical: '彳',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '徯',
    definition: 'to await, to expect, to hope',
    pinyin: ['xī'],
    decomposition: '⿰彳奚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奚',
      semantic: '彳',
      hint: 'step',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '徴',
    definition: 'to summon',
    pinyin: ['zhēng'],
    decomposition: '⿲彳⿱山王攵',
    etymology: {
      type: 'ideographic',
      hint: "To march 彳 on the king's 王 orders 攵",
    },
    radical: '彳',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '徵',
    definition: 'to summon, to recruit; levy, tax; journey; invasion',
    pinyin: ['zhēng'],
    decomposition: '⿲彳⿱山⿱一王攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '正',
      semantic: '彳',
      hint: 'step',
    },
    radical: '彳',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1, 0],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '德',
    definition: 'ethics, morality; compassion, kindness',
    pinyin: ['dé'],
    decomposition: '⿰彳⿱⿱十罒⿱一心',
    etymology: { type: 'pictophonetic', semantic: '心', hint: 'heart' },
    radical: '彳',
    matches: [
      [0],
      [0],
      [0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 1],
      [1, 0, 1],
      [1, 0, 1],
      [1, 0, 1],
      [1, 0, 1],
      [1, 1, 0],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
    ],
  },
  {
    character: '徹',
    definition: 'penetrating, pervasive; to penetrate, to pass through',
    pinyin: ['chè'],
    decomposition: '⿲彳育攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彳',
      semantic: '切',
      hint: 'cut',
    },
    radical: '彳',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '徼',
    definition: 'border, frontier; to inspect, to patrol',
    pinyin: ['jiǎo'],
    decomposition: '⿰彳敫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敫',
      semantic: '彳',
      hint: 'step',
    },
    radical: '彳',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '徽',
    definition: 'badge, crest, logo, insignia',
    pinyin: ['huī'],
    decomposition: '⿲彳⿱山系攵',
    radical: '彳',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '心',
    definition: 'heart; mind; soul',
    pinyin: ['xīn'],
    decomposition: '？',
    etymology: { type: 'pictographic', hint: 'A heart' },
    radical: '心',
    matches: [null, null, null, null],
  },
  {
    character: '忄',
    definition: 'heart; mind; soul',
    pinyin: ['xīn'],
    decomposition: '⿻八丨',
    radical: '忄',
    matches: [[0], [0], [1]],
  },
  {
    character: '必',
    definition: 'surely, certainly; must; will',
    pinyin: ['bì'],
    decomposition: '⿻心丿',
    radical: '心',
    matches: [[0], [0], [0], [1], [0]],
  },
  {
    character: '忆',
    definition: 'to remember, to reflect upon; memory',
    pinyin: ['yì'],
    decomposition: '⿰忄乙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乙',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1]],
  },
  {
    character: '忉',
    definition: 'grieving; distressed',
    pinyin: ['dāo'],
    decomposition: '⿰忄刀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '刀',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '忌',
    definition: 'jealous, envious; to fear; to shun',
    pinyin: ['jì'],
    decomposition: '⿱己心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '己',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '忍',
    definition: 'to endure, to bear, to suffer, to tolerate',
    pinyin: ['rěn'],
    decomposition: '⿱刃心',
    etymology: {
      type: 'ideographic',
      hint: 'A knife 刃 piercing the heart 心; 刃 also provides the pronunciation',
    },
    radical: '心',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '忏',
    definition: 'to regret, to repent; confession, penitence',
    pinyin: ['chàn'],
    decomposition: '⿰忄千',
    etymology: {
      type: 'pictophonetic',
      phonetic: '千',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '忐',
    definition: 'nervous, timorous',
    pinyin: ['tǎn'],
    decomposition: '⿱上心',
    etymology: { type: 'ideographic', hint: 'A weight on 上 the heart 心' },
    radical: '心',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '忑',
    definition: 'fearful, nervous, timid',
    pinyin: ['tè'],
    decomposition: '⿱下心',
    etymology: { type: 'ideographic', hint: 'A weight under 下 the heart 心' },
    radical: '心',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '忒',
    definition: 'excessive (in a bad way); to err, to make a mistake',
    pinyin: ['tè'],
    decomposition: '⿹弋心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弋',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [1], [1], [1], [1], [0], [0]],
  },
  {
    character: '忕',
    definition: 'habit; accustomed to',
    pinyin: ['shì'],
    decomposition: '⿰忄大',
    etymology: { type: 'pictophonetic', semantic: '忄', hint: 'mind' },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '忖',
    definition: 'to guess, to ponder, to suppose',
    pinyin: ['cǔn'],
    decomposition: '⿰忄寸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寸',
      semantic: '忄',
      hint: 'mind',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '志',
    definition: 'determination, will; mark, sign; to record, to write',
    pinyin: ['zhì'],
    decomposition: '⿱士心',
    etymology: {
      type: 'ideographic',
      hint: 'The mind 心 of a scholar 士; 士 also provides the pronunciation',
    },
    radical: '心',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '忘',
    definition: 'to forget, to miss, to neglect, to overlook',
    pinyin: ['wàng'],
    decomposition: '⿱亡心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亡',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '忙',
    definition: 'busy, hurried, pressed for time',
    pinyin: ['máng'],
    decomposition: '⿰忄亡',
    etymology: {
      type: 'ideographic',
      hint: 'A heart 忄 faced with death 亡; 亡 also provides the pronunciation',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '忝',
    definition: 'shame, disgrace; self-depreciation',
    pinyin: ['tiǎn'],
    decomposition: '⿱天⺗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '天',
      semantic: '⺗',
      hint: 'heart',
    },
    radical: '⺗',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '忞',
    definition: "to psych up; to steel one's nerves",
    pinyin: ['mín'],
    decomposition: '⿱文心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '文',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '忠',
    definition: 'loyalty, devotion, fidelity',
    pinyin: ['zhōng'],
    decomposition: '⿱中心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '中',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '忡',
    definition: 'sad, grieving; distressed, uneasy',
    pinyin: ['chōng'],
    decomposition: '⿰忄中',
    etymology: {
      type: 'pictophonetic',
      phonetic: '中',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '忤',
    definition: 'disobedient; stubborn; wrong',
    pinyin: ['wǔ'],
    decomposition: '⿰忄午',
    etymology: {
      type: 'pictophonetic',
      phonetic: '午',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '忧',
    definition: 'sad, grieving; melancholy, grief',
    pinyin: ['yōu'],
    decomposition: '⿰忄尤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尤',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '忪',
    definition: 'calm, peaceful; quiet, tranquil',
    pinyin: ['sōng'],
    decomposition: '⿰忄公',
    etymology: {
      type: 'pictophonetic',
      phonetic: '公',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '快',
    definition: 'speedy, rapid, quick; soon',
    pinyin: ['kuài'],
    decomposition: '⿰忄夬',
    etymology: {
      type: 'ideographic',
      hint: 'A decisive 夬 will 忄; 夬 also provides the pronunciation',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '忭',
    definition: 'pleased, delighted',
    pinyin: ['biàn'],
    decomposition: '⿰忄卞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卞',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '忮',
    definition: 'stubborn; perverse; aggressive',
    pinyin: ['zhì'],
    decomposition: '⿰忄支',
    etymology: {
      type: 'pictophonetic',
      phonetic: '支',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '忱',
    definition: 'honesty, sincerity, zeal',
    pinyin: ['chén'],
    decomposition: '⿰忄冘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冘',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '念',
    definition: 'to think of, to recall; to study',
    pinyin: ['niàn'],
    decomposition: '⿱今心',
    etymology: {
      type: 'ideographic',
      hint: 'To keep the present 今 in mind 心',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '忸',
    definition: 'blushing, bashful, ashamed',
    pinyin: ['niǔ'],
    decomposition: '⿰忄丑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丑',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '忻',
    definition: 'pleasant, joyful, delightful',
    pinyin: ['xīn'],
    decomposition: '⿰忄斤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斤',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '忽',
    definition: 'suddenly, abruptly; to neglect',
    pinyin: ['hū'],
    decomposition: '⿱勿心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '勿',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '忾',
    definition: 'anger, wrath, hatred, enmity',
    pinyin: ['kài'],
    decomposition: '⿰忄气',
    etymology: {
      type: 'ideographic',
      hint: 'A heart 忄 full of anger 气; 气 also provides the pronunciation',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '忿',
    definition: 'anger, fury; exasperation',
    pinyin: ['fèn'],
    decomposition: '⿱分心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '分',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '怀',
    definition: "bosom, breast; to carry in one's bosom",
    pinyin: ['huái'],
    decomposition: '⿰忄不',
    etymology: {
      type: 'pictophonetic',
      phonetic: '不',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '态',
    definition: 'manner, bearing, attitude',
    pinyin: ['tài'],
    decomposition: '⿱太心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '太',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '怂',
    definition: 'to arouse, to incite, to instigate',
    pinyin: ['sǒng'],
    decomposition: '⿱从心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '从',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '怃',
    definition: 'disappointed, regretful',
    pinyin: ['wǔ'],
    decomposition: '⿰忄无',
    etymology: {
      type: 'pictophonetic',
      phonetic: '无',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '怄',
    definition: 'annoyed',
    pinyin: ['òu'],
    decomposition: '⿰忄区',
    etymology: {
      type: 'pictophonetic',
      phonetic: '区',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '怅',
    definition: 'disappointed; regretful; upset',
    pinyin: ['chàng'],
    decomposition: '⿰忄长',
    etymology: {
      type: 'pictophonetic',
      phonetic: '长',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '怆',
    definition: 'sad, disconsolate, broken-hearted',
    pinyin: ['chuàng'],
    decomposition: '⿰忄仓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '仓',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '怊',
    definition: 'grieving',
    pinyin: ['chāo'],
    decomposition: '⿰忄召',
    etymology: {
      type: 'pictophonetic',
      phonetic: '召',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '怍',
    definition: 'ashamed',
    pinyin: ['zuò'],
    decomposition: '⿰忄乍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乍',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '怎',
    definition: 'what? why? how?',
    pinyin: ['zěn'],
    decomposition: '⿱乍心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乍',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '怏',
    definition: 'discontented, dispirited, sad',
    pinyin: ['yàng'],
    decomposition: '⿰忄央',
    etymology: {
      type: 'pictophonetic',
      phonetic: '央',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '怒',
    definition: 'anger, passion, rage',
    pinyin: ['nù'],
    decomposition: '⿱奴心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奴',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '怔',
    definition: 'frightened, startled, terrified',
    pinyin: ['zhēng'],
    decomposition: '⿰忄正',
    etymology: {
      type: 'pictophonetic',
      phonetic: '正',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '怕',
    definition: 'to fear, to be afraid of; apprehensive',
    pinyin: ['pà'],
    decomposition: '⿰忄白',
    etymology: {
      type: 'pictophonetic',
      phonetic: '白',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '怖',
    definition: 'frightened, terrified',
    pinyin: ['bù'],
    decomposition: '⿰忄布',
    etymology: {
      type: 'pictophonetic',
      phonetic: '布',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '怙',
    definition: 'to rely on; to presume; father (formal)',
    pinyin: ['hù'],
    decomposition: '⿰忄古',
    etymology: {
      type: 'pictophonetic',
      phonetic: '古',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '怛',
    definition: 'grieving; worried',
    pinyin: ['dá'],
    decomposition: '⿰忄旦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旦',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '怜',
    definition: 'to pity, to sympathize with',
    pinyin: ['lián'],
    decomposition: '⿰忄令',
    etymology: {
      type: 'pictophonetic',
      phonetic: '令',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '思',
    definition: 'to think, to ponder, to consider; final particle',
    pinyin: ['sī'],
    decomposition: '⿱田心',
    etymology: {
      type: 'ideographic',
      hint: 'Weighing something with your mind 囟 (altered) and heart 心',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '怠',
    definition: 'idle; negligent, remiss; to neglect',
    pinyin: ['dài'],
    decomposition: '⿱台心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '台',
      semantic: '心',
      hint: 'mind',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '怡',
    definition: 'gladness, joy, pleasure; harmony',
    pinyin: ['yí'],
    decomposition: '⿰忄台',
    etymology: {
      type: 'pictophonetic',
      phonetic: '台',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '急',
    definition: 'anxious, worried; hasty, quick; pressing, urgent',
    pinyin: ['jí'],
    decomposition: '⿱刍心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '刍',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '怦',
    definition: 'ardent, eager; impulsive, bold',
    pinyin: ['pēng'],
    decomposition: '⿰忄平',
    etymology: {
      type: 'pictophonetic',
      phonetic: '平',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '性',
    definition:
      'sex, nature, character; suffix converting a verb to an adjective',
    pinyin: ['xìng'],
    decomposition: '⿰忄生',
    etymology: {
      type: 'pictophonetic',
      phonetic: '生',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '怨',
    definition: 'to blame, to complain, to hate; enmity, resentment',
    pinyin: ['yuàn'],
    decomposition: '⿱夗心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夗',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '怩',
    definition: 'timid, shy; bashful, ashamed',
    pinyin: ['ní'],
    decomposition: '⿰忄尼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尼',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '怪',
    definition: 'unusual, strange, peculiar',
    pinyin: ['guài'],
    decomposition: '⿰忄圣',
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '怫',
    definition: 'anxious; depressed; sorry',
    pinyin: ['fú'],
    decomposition: '⿰忄弗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弗',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '怯',
    definition: 'afraid, lacking in courage',
    pinyin: ['qiè'],
    decomposition: '⿰忄去',
    etymology: {
      type: 'pictophonetic',
      phonetic: '去',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '怱',
    definition: 'hastily, hurriedly, in a rush',
    pinyin: ['cōng'],
    decomposition: '⿱匆心',
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '怵',
    definition: 'fearful, apprehensive; timid, shy',
    pinyin: ['chù'],
    decomposition: '⿰忄术',
    etymology: {
      type: 'pictophonetic',
      phonetic: '术',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '总',
    definition: 'to gather, to collect; overall, altogether',
    pinyin: ['zǒng'],
    decomposition: '⿳丷口心',
    etymology: {
      type: 'ideographic',
      hint: 'Many mouths 口 speaking with one mind 心',
    },
    radical: '心',
    matches: [[0], [0], [1], [1], [1], [2], [2], [2], [2]],
  },
  {
    character: '怼',
    definition: 'hatred, resentment; to dislike, to hate',
    pinyin: ['duì'],
    decomposition: '⿱对心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '对',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '怿',
    definition: 'glad, pleased; to enjoy',
    pinyin: ['yì'],
    decomposition: '⿰忄？',
    etymology: { type: 'pictophonetic', semantic: '忄', hint: 'heart' },
    radical: '忄',
    matches: [[0], [0], [0], null, null, null, null, null],
  },
  {
    character: '恁',
    definition: 'that, thus; such, like so',
    pinyin: ['nèn'],
    decomposition: '⿱任心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '任',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '恂',
    definition: 'careful; honest, sincere; to trust',
    pinyin: ['xún'],
    decomposition: '⿰忄旬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旬',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '恃',
    definition: 'to trust, to rely on; to presume',
    pinyin: ['shì'],
    decomposition: '⿰忄寺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寺',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '恆',
    definition: 'constant, persistent, regular',
    pinyin: ['héng'],
    decomposition: '⿰忄亙',
    etymology: {
      type: 'ideographic',
      hint: 'A constant 亙 heart 忄; 亙 also provides the pronunciation',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '恋',
    definition: 'love; to yearn for, to long for',
    pinyin: ['liàn'],
    decomposition: '⿱亦心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亦',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '恍',
    definition: 'absent-minded; distracted; indistinct; seemingly',
    pinyin: ['huǎng'],
    decomposition: '⿰忄光',
    etymology: {
      type: 'pictophonetic',
      phonetic: '光',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '恐',
    definition: 'fearful, apprehensive; to fear, to dread',
    pinyin: ['kǒng'],
    decomposition: '⿱巩心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巩',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '恒',
    definition: 'constant, persistent, regular',
    pinyin: ['héng'],
    decomposition: '⿰忄亘',
    etymology: {
      type: 'ideographic',
      hint: 'A constant 亘 heart 忄; 亘 also provides the pronunciation',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '恕',
    definition: 'to excuse, to forgive, to show mercy',
    pinyin: ['shù'],
    decomposition: '⿱如心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '如',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '恙',
    definition: 'illness, sickness; indisposition',
    pinyin: ['yàng'],
    decomposition: '⿱羊心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羊',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '恚',
    definition: 'anger, rage',
    pinyin: ['huì'],
    decomposition: '⿱圭心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '圭',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '恝',
    definition: 'carefree; indifferent',
    pinyin: ['jiá'],
    decomposition: '⿱㓞心',
    etymology: {
      type: 'pictophonetic',
      semantic: '心',
      hint: 'heart',
      phonetic: '㓞',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '恢',
    definition: 'to restore, to recover; great, immense, vast',
    pinyin: ['huī'],
    decomposition: '⿰忄灰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '灰',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '恣',
    definition: 'indulgent; unrestrained',
    pinyin: ['zì'],
    decomposition: '⿱次心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '次',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '恤',
    definition: 'to help, to relieve, to take pity on',
    pinyin: ['xù'],
    decomposition: '⿰忄血',
    etymology: {
      type: 'pictophonetic',
      phonetic: '血',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '恥',
    definition: 'shame, humiliation; ashamed',
    pinyin: ['chǐ'],
    decomposition: '⿰耳心',
    etymology: { type: 'pictophonetic', semantic: '心', hint: 'heart' },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '恧',
    definition: 'ashamed',
    pinyin: ['nǜ'],
    decomposition: '⿱而心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '而',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '恨',
    definition: 'to dislike, to hate, to resent',
    pinyin: ['hèn'],
    decomposition: '⿰忄艮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '艮',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '恩',
    definition: 'kindness, mercy, charity',
    pinyin: ['ēn'],
    decomposition: '⿱因心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '因',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '恪',
    definition: 'respectful, reverent',
    pinyin: ['kè'],
    decomposition: '⿰忄各',
    etymology: {
      type: 'pictophonetic',
      phonetic: '各',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '恫',
    definition: 'fearful, pained, sorrowful',
    pinyin: ['dòng'],
    decomposition: '⿰忄同',
    etymology: {
      type: 'pictophonetic',
      phonetic: '同',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '恬',
    definition: 'calm, peaceful; quiet, tranquil',
    pinyin: ['tián'],
    decomposition: '⿰忄舌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '舌',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '恭',
    definition: 'polite, respectful, reverent',
    pinyin: ['gōng'],
    decomposition: '⿱共⺗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '共',
      semantic: '⺗',
      hint: 'heart',
    },
    radical: '⺗',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '息',
    definition: 'to end, to cease, to put a stop to; pause, breath, rest; news',
    pinyin: ['xī'],
    decomposition: '⿱自心',
    etymology: {
      type: 'ideographic',
      hint: "To breathe (life, 心) through one's nose 自; 心 also provides the pronunciation",
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '恰',
    definition: 'just, exactly, precisely; proper',
    pinyin: ['qià'],
    decomposition: '⿰忄合',
    etymology: {
      type: 'pictophonetic',
      phonetic: '合',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '恳',
    definition: 'sincere, earnest, cordial',
    pinyin: ['kěn'],
    decomposition: '⿱艮心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '艮',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '恶',
    definition: 'bad, evil, wicked; to hate, to loathe; foul, nauseating',
    pinyin: ['è'],
    decomposition: '⿱亚心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亚',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '恸',
    definition: 'sadness, grief; to mourn, to be moved',
    pinyin: ['tòng'],
    decomposition: '⿰忄动',
    etymology: {
      type: 'ideographic',
      hint: 'Moving 动 and sad 忄; 动 also provides the pronunciation',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '恹',
    definition: 'feeble, sickly, weak; tranquil',
    pinyin: ['yān'],
    decomposition: '⿰忄厌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厌',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '恺',
    definition: 'to enjoy; kind; joyful, content',
    pinyin: ['kǎi'],
    decomposition: '⿰忄岂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '岂',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '恻',
    definition: 'anguished; sympathetic',
    pinyin: ['cè'],
    decomposition: '⿰忄则',
    etymology: {
      type: 'pictophonetic',
      phonetic: '则',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '恼',
    definition: 'angry, wrathful',
    pinyin: ['nǎo'],
    decomposition: '⿰忄⿱亠凶',
    etymology: { type: 'pictophonetic', semantic: '忄', hint: 'heart' },
    radical: '忄',
    matches: [[0], [0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '恽',
    definition: 'to devise, to plan; to deliberate, to consult',
    pinyin: ['yùn'],
    decomposition: '⿰忄军',
    etymology: {
      type: 'ideographic',
      hint: 'To plan 忄 for a battle 军; 军 also provides the pronunciation',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '恿',
    definition: 'to instigate, to incite, to alarm',
    pinyin: ['yǒng'],
    decomposition: '⿱甬心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甬',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '悃',
    definition: 'honest, sincere; loyal, true',
    pinyin: ['kǔn'],
    decomposition: '⿰忄困',
    etymology: {
      type: 'pictophonetic',
      phonetic: '困',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '悄',
    definition: 'quiet, silent, still; anxious',
    pinyin: ['qiāo'],
    decomposition: '⿰忄肖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肖',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '悅',
    definition: 'contented, gratified, pleased',
    pinyin: ['yuè'],
    decomposition: '⿰忄兌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兌',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '悉',
    definition: 'to know, to learn about, to comprehend',
    pinyin: ['xī'],
    decomposition: '⿱釆心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '釆',
      semantic: '心',
      hint: 'mind',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '悌',
    definition: 'respectful, brotherly',
    pinyin: ['tì'],
    decomposition: '⿰忄弟',
    etymology: {
      type: 'ideographic',
      hint: 'Fraternal 弟 respect 忄; 弟 also provides the pronunciation',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '悍',
    definition: 'courageous, brave; violent',
    pinyin: ['hàn'],
    decomposition: '⿰忄旱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旱',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '悒',
    definition: 'sorrowful, depressed',
    pinyin: ['yì'],
    decomposition: '⿰忄邑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '邑',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '悔',
    definition: 'to regret, to repent, to show remorse',
    pinyin: ['huǐ'],
    decomposition: '⿰忄每',
    etymology: {
      type: 'pictophonetic',
      phonetic: '每',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '悖',
    definition: 'contradictory; counter to',
    pinyin: ['bèi'],
    decomposition: '⿰忄孛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孛',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '悚',
    definition: 'scared, frightened',
    pinyin: ['sǒng'],
    decomposition: '⿰忄束',
    etymology: {
      type: 'pictophonetic',
      phonetic: '束',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '悛',
    definition: 'to repent; to reform',
    pinyin: ['quān'],
    decomposition: '⿰忄夋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夋',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '悝',
    definition: 'to laugh at; to pity; sad; afflicted',
    pinyin: ['kuī'],
    decomposition: '⿰忄里',
    etymology: {
      type: 'pictophonetic',
      phonetic: '里',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '悟',
    definition: 'to apprehend, to realize, to become aware',
    pinyin: ['wù'],
    decomposition: '⿰忄吾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吾',
      semantic: '忄',
      hint: 'mind',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '悠',
    definition: 'distant, remote; long, far; carefree',
    pinyin: ['yōu'],
    decomposition: '⿱攸心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '攸',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '患',
    definition: 'suffering; misfortune; trouble; to suffer',
    pinyin: ['huàn'],
    decomposition: '⿱串心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '串',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '悤',
    definition: 'agitated, hurried, restless',
    pinyin: ['cōng'],
    decomposition: '⿱囱心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '囱',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '悦',
    definition: 'contented, gratified, pleased',
    pinyin: ['yuè'],
    decomposition: '⿰忄兑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兑',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '悧',
    definition: 'active; clever, sharp; smooth',
    pinyin: ['lì'],
    decomposition: '⿰忄利',
    etymology: {
      type: 'ideographic',
      hint: 'One with a sharp 刂 wit 忄; 利 also provides the pronunciation',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '您',
    definition: "honorific for 'you'",
    pinyin: ['nín'],
    decomposition: '⿱你心',
    etymology: { type: 'ideographic', hint: 'You 你 said with affection 心' },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '悫',
    definition: 'modest; sincere',
    pinyin: ['què'],
    decomposition: '⿳士冗心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '士',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [1], [1], [1], [1], [2], [2], [2], [2]],
  },
  {
    character: '悬',
    definition: 'to hang, to hoist, to suspend; hung',
    pinyin: ['xuán'],
    decomposition: '⿱县心',
    etymology: {
      type: 'ideographic',
      hint: "Pride 心  in one's country 县, expressed by a flag; 县 also provides the pronunciation",
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '悭',
    definition: 'miserly, stingy, thrifty',
    pinyin: ['qiān'],
    decomposition: '⿰忄坚',
    etymology: {
      type: 'ideographic',
      hint: 'Having a hard 坚 heart 忄; 坚 also provides the pronunciation',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '悯',
    definition: 'to pity, to sympathize with; to grieve for',
    pinyin: ['mǐn'],
    decomposition: '⿰忄闵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '闵',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '悱',
    definition: 'overcome with emotion; at a loss for words',
    pinyin: ['fěi'],
    decomposition: '⿰忄非',
    etymology: {
      type: 'pictophonetic',
      phonetic: '非',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '悲',
    definition: 'sorrow, sadness, grief; to be sorry',
    pinyin: ['bēi'],
    decomposition: '⿱非心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '非',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '悴',
    definition: 'to suffer; haggard, emaciated',
    pinyin: ['cuì'],
    decomposition: '⿰忄卒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卒',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '悵',
    definition: 'disappointed; regretful; upset',
    pinyin: ['chàng'],
    decomposition: '⿰忄長',
    etymology: {
      type: 'pictophonetic',
      phonetic: '長',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '悶',
    definition: 'gloomy, depressed, melancholy',
    pinyin: ['mèn'],
    decomposition: '⿵門心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '門',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '悸',
    definition: 'apprehensive, fearful; perturbed',
    pinyin: ['jì'],
    decomposition: '⿰忄季',
    etymology: {
      type: 'pictophonetic',
      phonetic: '季',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '悻',
    definition: 'anger, frustration',
    pinyin: ['xìng'],
    decomposition: '⿰忄幸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '幸',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '悼',
    definition: 'to grieve, to lament, to mourn',
    pinyin: ['dào'],
    decomposition: '⿰忄卓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卓',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '悽',
    definition: 'sorrowful, grieving; melancholy',
    pinyin: ['qī'],
    decomposition: '⿰忄妻',
    etymology: {
      type: 'pictophonetic',
      phonetic: '妻',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '情',
    definition: 'emotion, feeling, sentiment',
    pinyin: ['qíng'],
    decomposition: '⿰忄青',
    etymology: {
      type: 'pictophonetic',
      phonetic: '青',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '惆',
    definition: 'distressed, regretful, sad',
    pinyin: ['chóu'],
    decomposition: '⿰忄周',
    etymology: {
      type: 'pictophonetic',
      phonetic: '周',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '惊',
    definition: 'to frighten, to startle; surprise, alarm',
    pinyin: ['jīng'],
    decomposition: '⿰忄京',
    etymology: {
      type: 'pictophonetic',
      phonetic: '京',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '惋',
    definition: 'to regret, to be sorry',
    pinyin: ['wǎn'],
    decomposition: '⿰忄宛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宛',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '惑',
    definition: 'to confuse, to mislead; to doubt',
    pinyin: ['huò'],
    decomposition: '⿱或心',
    etymology: {
      type: 'ideographic',
      hint: 'An uncertain 或 heart 心; 或 also provides the pronunciation',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '惓',
    definition: 'candid, sincere; careful, earnest',
    pinyin: ['quán'],
    decomposition: '⿰忄卷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卷',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '惕',
    definition: 'cautious, careful, alert',
    pinyin: ['tì'],
    decomposition: '⿰忄易',
    etymology: {
      type: 'pictophonetic',
      phonetic: '易',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '惘',
    definition: 'dejected, discouraged',
    pinyin: ['wǎng'],
    decomposition: '⿰忄罔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '罔',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '惙',
    definition: 'sad, melancholy; mournful, grieving',
    pinyin: ['chuò'],
    decomposition: '⿰忄叕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叕',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '惚',
    definition: 'confused, absent-minded',
    pinyin: ['hū'],
    decomposition: '⿰忄忽',
    etymology: {
      type: 'ideographic',
      hint: 'To neglect 忽 the mind 忄; 忽 also provides the pronunciation',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '惛',
    definition: 'confused, forgetful; senile; stupid',
    pinyin: ['hūn'],
    decomposition: '⿰忄昏',
    etymology: {
      type: 'ideographic',
      hint: 'Night falling 昏 on the mind 忄; 昏 also provides the pronunciation',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '惜',
    definition: 'pity, regret; to rue; to begrudge',
    pinyin: ['xī'],
    decomposition: '⿰忄昔',
    etymology: {
      type: 'ideographic',
      hint: 'To feel 忄 for the past 昔; 昔 also provides the pronunciation',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '惝',
    definition: 'alarmed, agitated',
    pinyin: ['chǎng'],
    decomposition: '⿰忄尚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尚',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '惟',
    definition: 'but, however, nevertheless; only',
    pinyin: ['wéi'],
    decomposition: '⿰忄隹',
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '惠',
    definition: 'favor, benefit, blessing, kindness',
    pinyin: ['huì'],
    decomposition: '⿱？心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叀',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '惡',
    definition: 'bad, evil, wicked; to hate, to loathe; foul, nauseating',
    pinyin: ['è'],
    decomposition: '⿱亞心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亞',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '惢',
    pinyin: ['suǒ'],
    decomposition: '⿱心⿰心心',
    radical: '心',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '惦',
    definition: 'to think of, to remember, to miss',
    pinyin: ['diàn'],
    decomposition: '⿰忄店',
    etymology: {
      type: 'pictophonetic',
      phonetic: '店',
      semantic: '忄',
      hint: 'mind',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '惧',
    definition: 'to fear, to dread',
    pinyin: ['jù'],
    decomposition: '⿰忄具',
    etymology: {
      type: 'pictophonetic',
      phonetic: '具',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '惨',
    definition: 'miserable, wretched; cruel, inhuman',
    pinyin: ['cǎn'],
    decomposition: '⿰忄参',
    etymology: {
      type: 'pictophonetic',
      phonetic: '参',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '惩',
    definition: 'to discipline, to punish, to reprimand, to warn',
    pinyin: ['chéng'],
    decomposition: '⿱征心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '征',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '惫',
    definition: 'tired, weary, fatigued',
    pinyin: ['bèi'],
    decomposition: '⿱夂思',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夂',
      semantic: '思',
      hint: 'ponder',
    },
    radical: '夂',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '惬',
    definition: 'satisfied, comfortable, cheerful',
    pinyin: ['qiè'],
    decomposition: '⿰忄⿷匚夹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夹',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 0],
    ],
  },
  {
    character: '惭',
    definition: 'ashamed, humiliated; shameful',
    pinyin: ['cán'],
    decomposition: '⿰忄斩',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斩',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '惮',
    definition: 'to fear, to dread; to dislike, to avoid',
    pinyin: ['dàn'],
    decomposition: '⿰忄单',
    etymology: {
      type: 'pictophonetic',
      phonetic: '单',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '惯',
    definition: 'habit, custom; habitual, usual',
    pinyin: ['guàn'],
    decomposition: '⿰忄贯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贯',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '惰',
    definition: 'lazy, idle, indolent; careless',
    pinyin: ['duò'],
    decomposition: '⿰忄⿱左⺼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '左',
      semantic: '忄',
      hint: 'mind',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '惱',
    definition: 'angry, wrathful',
    pinyin: ['nǎo'],
    decomposition: '⿰忄⿱巛囟',
    etymology: { type: 'pictophonetic', semantic: '忄', hint: 'heart' },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '想',
    definition: 'to believe, to wish for; to consider, to plan, to think',
    pinyin: ['xiǎng'],
    decomposition: '⿱相心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '相',
      semantic: '心',
      hint: 'mind',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '惴',
    definition: 'nervous, apprehensive',
    pinyin: ['zhuì'],
    decomposition: '⿰忄耑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '耑',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '惶',
    definition: 'anxious, nervous, uneasy',
    pinyin: ['huáng'],
    decomposition: '⿰忄皇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皇',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '惹',
    definition: 'to incite, to irritate, to offend, to vex',
    pinyin: ['rě'],
    decomposition: '⿱若心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '若',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '惺',
    definition: 'intelligent, clever, astute',
    pinyin: ['xīng'],
    decomposition: '⿰忄星',
    etymology: {
      type: 'ideographic',
      hint: 'A brilliant 星 mind 忄; 星 also provides the pronunciation',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '惻',
    definition: 'anguished; sympathetic',
    pinyin: ['cè'],
    decomposition: '⿰忄則',
    etymology: {
      type: 'pictophonetic',
      phonetic: '則',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '愀',
    definition: "anxious; blushing; to change one's countenance",
    pinyin: ['qiǎo'],
    decomposition: '⿰忄秋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '秋',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '愁',
    definition: 'anxious, worried',
    pinyin: ['chóu'],
    decomposition: '⿱秋心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '秋',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '愆',
    definition: 'error, fault, mistake, transgression',
    pinyin: ['qiān'],
    decomposition: '⿱衍心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '衍',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '愈',
    definition: 'to recover, to heal; more and more',
    pinyin: ['yù'],
    decomposition: '⿱俞心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '俞',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '愉',
    definition: 'pleasant, delightful; to please',
    pinyin: ['yú'],
    decomposition: '⿰忄俞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '俞',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '愍',
    definition: 'to pity, to sympathize with',
    pinyin: ['mǐn'],
    decomposition: '⿱敃心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敃',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '愎',
    definition: 'stubborn, obstinate, headstrong',
    pinyin: ['bì'],
    decomposition: '⿰忄复',
    etymology: {
      type: 'ideographic',
      hint: 'To persist 复 in error 忄; 复 also provides the pronunciation',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '意',
    definition: 'thought, idea, opinion; desire, wish; meaning, intention',
    pinyin: ['yì'],
    decomposition: '⿱音心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '音',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '愕',
    definition: 'startled, alarmed, astonished',
    pinyin: ['è'],
    decomposition: '⿰忄咢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咢',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '愚',
    definition: 'stupid, foolish',
    pinyin: ['yú'],
    decomposition: '⿱禺心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '禺',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '愛',
    definition: 'to love, to like, to be fond of; love, affection',
    pinyin: ['ài'],
    decomposition: '⿱⿱爫⿱冖心夂',
    etymology: {
      type: 'ideographic',
      hint: "To bring a lover 心 into one's house 冖",
    },
    radical: '心',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1, 0],
      [0, 1, 0],
      [0, 1, 1],
      [0, 1, 1],
      [0, 1, 1],
      [0, 1, 1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '愜',
    definition: 'satisfied, comfortable, cheerful',
    pinyin: ['qiè'],
    decomposition: '⿰忄匧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匧',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '感',
    definition: 'to affect, to move, to touch; to perceive, to sense',
    pinyin: ['gǎn'],
    decomposition: '⿱咸心',
    etymology: {
      type: 'ideographic',
      hint: 'Two hearts 心 beating together 咸',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '愠',
    definition: 'angry, indignant; resentful, sulking',
    pinyin: ['yùn'],
    decomposition: '⿰忄昷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昷',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '愣',
    definition: 'dazed, stupefied',
    pinyin: ['lèng'],
    decomposition: '⿰忄⿱罒方',
    etymology: {
      type: 'pictophonetic',
      phonetic: '罒',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '愤',
    definition: 'anger, indignation; to hate, to resent',
    pinyin: ['fèn'],
    decomposition: '⿰忄贲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贲',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '愦',
    definition: 'confused, muddle-headed; troubled',
    pinyin: ['kuì'],
    decomposition: '⿰忄贵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贵',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '愧',
    definition: 'ashamed, regretful; the pangs of conscience',
    pinyin: ['kuì'],
    decomposition: '⿰忄鬼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鬼',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '愫',
    definition: 'sincere, honest, guileless',
    pinyin: ['sù'],
    decomposition: '⿰忄素',
    etymology: {
      type: 'ideographic',
      hint: 'With a pure 素 heart 忄; 素 also provides the pronunciation',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '愴',
    definition: 'sad, disconsolate, broken-hearted',
    pinyin: ['chuàng'],
    decomposition: '⿰忄倉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '倉',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '愷',
    definition: 'to enjoy; kind; joyful, content',
    pinyin: ['kǎi'],
    decomposition: '⿰忄豈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豈',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '愾',
    definition: 'anger, wrath, hatred, enmity',
    pinyin: ['kài'],
    decomposition: '⿰忄氣',
    etymology: {
      type: 'ideographic',
      hint: 'A heart 忄 full of anger 氣; 氣 also provides the pronunciation',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '愿',
    definition: 'desire, wish; honest, virtuous; ready, willing',
    pinyin: ['yuàn'],
    decomposition: '⿸原心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '原',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '慄',
    definition: 'chestnut tree; chestnuts; surname',
    pinyin: ['lì'],
    decomposition: '⿰忄栗',
    etymology: {
      type: 'ideographic',
      hint: 'A tree 木 bearing nuts 覀; compare 果',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '慈',
    definition: 'gentle, humane, kind, merciful',
    pinyin: ['cí'],
    decomposition: '⿱兹心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兹',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '慊',
    definition: 'satisfied, content',
    pinyin: ['qiàn'],
    decomposition: '⿰忄兼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兼',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '態',
    definition: 'manner, bearing, attitude',
    pinyin: ['tài'],
    decomposition: '⿱能心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '能',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '慌',
    definition: 'frantic, nervous, panicked',
    pinyin: ['huāng'],
    decomposition: '⿰忄荒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '荒',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '慎',
    definition: 'cautious, prudent',
    pinyin: ['shèn'],
    decomposition: '⿰忄真',
    etymology: {
      type: 'pictophonetic',
      phonetic: '真',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '慑',
    definition: 'afraid, scared; to frighten, to intimidate',
    pinyin: ['shè'],
    decomposition: '⿰忄聂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '聂',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '慕',
    definition: 'to admire, to desire, to long for',
    pinyin: ['mù'],
    decomposition: '⿱莫⺗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '莫',
      semantic: '⺗',
      hint: 'heart',
    },
    radical: '⺗',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '慘',
    definition: 'miserable, wretched; cruel, inhuman',
    pinyin: ['cǎn'],
    decomposition: '⿰忄參',
    etymology: {
      type: 'pictophonetic',
      phonetic: '參',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '慚',
    definition: 'ashamed, humiliated; shameful',
    pinyin: ['cán'],
    decomposition: '⿰忄斬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斬',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '慝',
    definition: 'an evil thought; sin, vice',
    pinyin: ['tè'],
    decomposition: '⿱匿心',
    etymology: {
      type: 'ideographic',
      hint: "To hide 匿 evil in one's heart 心",
    },
    radical: '心',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '慟',
    definition: 'sadness, grief; to mourn, to be moved',
    pinyin: ['tòng'],
    decomposition: '⿰忄動',
    etymology: {
      type: 'ideographic',
      hint: 'Moving 動 and sad 忄; 動 also provides the pronunciation',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '慢',
    definition: 'slowly, leisurely; sluggish',
    pinyin: ['màn'],
    decomposition: '⿰忄曼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曼',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '慣',
    definition: 'habit, custom; habitual, usual',
    pinyin: ['guàn'],
    decomposition: '⿰忄貫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '貫',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '慧',
    definition: 'bright, intelligent; intelligence',
    pinyin: ['huì'],
    decomposition: '⿱彗心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彗',
      semantic: '心',
      hint: 'mind',
    },
    radical: '心',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '慨',
    definition: 'sigh, regret, lament; generosity',
    pinyin: ['kǎi'],
    decomposition: '⿰忄既',
    etymology: {
      type: 'pictophonetic',
      phonetic: '既',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '慪',
    definition: 'annoyed',
    pinyin: ['òu'],
    decomposition: '⿰忄區',
    etymology: {
      type: 'pictophonetic',
      phonetic: '區',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '慫',
    definition: 'to arouse, to incite, to instigate',
    pinyin: ['sǒng'],
    decomposition: '⿱從心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '從',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '慮',
    definition: 'anxious, concerned, worried',
    pinyin: ['lǜ'],
    decomposition: '⿸虍思',
    etymology: {
      type: 'ideographic',
      hint: 'A tiger 虍 striking fear into the heart 思',
    },
    radical: '心',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '慰',
    definition: 'to calm, to comfort, to reassure',
    pinyin: ['wèi'],
    decomposition: '⿱尉心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尉',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '慳',
    definition: 'miserly, stingy, thrifty',
    pinyin: ['qiān'],
    decomposition: '⿰忄堅',
    etymology: {
      type: 'ideographic',
      hint: 'Having a hard 堅 heart 忄; 堅 also provides the pronunciation',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '慵',
    definition: 'lazy, indolent; easy-going',
    pinyin: ['yōng'],
    decomposition: '⿰忄庸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '庸',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '慶',
    definition: 'to congratulate, to celebrate',
    pinyin: ['qìng'],
    decomposition: '⿸⿸鹿心夂',
    etymology: {
      type: 'ideographic',
      hint: 'To go to 夂 a celebration 心 in a house 广',
    },
    radical: '心',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '慷',
    definition: 'ardent, fervent; generous, magnanimous',
    pinyin: ['kāng'],
    decomposition: '⿰忄康',
    etymology: {
      type: 'pictophonetic',
      phonetic: '康',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '慼',
    definition: 'grief, mourning; relative; related to',
    pinyin: ['qī'],
    decomposition: '⿱戚心',
    etymology: {
      type: 'ideographic',
      hint: 'Grieving 心 for a dead brother 戚; 戚 also provides the pronunciation',
    },
    radical: '心',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '慾',
    definition: 'passion, desire, lust; appetite',
    pinyin: ['yù'],
    decomposition: '⿱欲心',
    etymology: {
      type: 'ideographic',
      hint: "The heart's 心 desire 欲; 欲 also provides the pronunciation",
    },
    radical: '心',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '憂',
    definition: 'sad, grieving; melancholy, grief',
    pinyin: ['yōu'],
    decomposition: '⿱⿱頁心夂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '頁',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '心',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '憊',
    definition: 'tired, weary, fatigued',
    pinyin: ['bèi'],
    decomposition: '⿱備心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '備',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '憋',
    definition:
      "to stifle, to restrain, to choke; to suppress one's inner feelings",
    pinyin: ['biē'],
    decomposition: '⿱敝心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敝',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '憎',
    definition: 'to abhor, to detest, to hate',
    pinyin: ['zēng'],
    decomposition: '⿰忄曾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曾',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '憐',
    definition: 'to pity, to sympathize with',
    pinyin: ['lián'],
    decomposition: '⿰忄粦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '粦',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '憑',
    definition: 'to lean on; to rely on',
    pinyin: ['píng'],
    decomposition: '⿱馮心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '馮',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '憔',
    definition: 'worn-out, haggard, emaciated',
    pinyin: ['qiáo'],
    decomposition: '⿰忄焦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '焦',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '憚',
    definition: 'to fear, to dread; to dislike, to avoid',
    pinyin: ['dàn'],
    decomposition: '⿰忄單',
    etymology: {
      type: 'pictophonetic',
      phonetic: '單',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '憝',
    definition: 'to dislike; to abhor, to hate',
    pinyin: ['duì'],
    decomposition: '⿱敦心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敦',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '憤',
    definition: 'anger, indignation; to hate, to resent',
    pinyin: ['fèn'],
    decomposition: '⿰忄賁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '賁',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '憧',
    definition: 'indecisive, irresolute; to yearn for',
    pinyin: ['chōng'],
    decomposition: '⿰忄童',
    etymology: {
      type: 'pictophonetic',
      phonetic: '童',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '憨',
    definition: 'silly, foolish; coquettish',
    pinyin: ['hān'],
    decomposition: '⿱敢心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敢',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '憩',
    definition: 'to rest',
    pinyin: ['qì'],
    decomposition: '⿱⿰舌自心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '自',
      semantic: '心',
      hint: 'mind',
    },
    radical: '心',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '憫',
    definition: 'to pity, to sympathize with; to grieve for',
    pinyin: ['mǐn'],
    decomposition: '⿰忄閔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '閔',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '憬',
    definition: 'to rouse, to awaken; to become conscious',
    pinyin: ['jǐng'],
    decomposition: '⿰忄景',
    etymology: {
      type: 'pictophonetic',
      phonetic: '景',
      semantic: '忄',
      hint: 'mind',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '憲',
    definition: 'constitution, statute, law',
    pinyin: ['xiàn'],
    decomposition: '⿱宀⿱龶⿱罒心',
    etymology: {
      type: 'ideographic',
      hint: 'Rules 宀 for living 龶; 心 provides the pronunciation',
    },
    radical: '心',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
    ],
  },
  {
    character: '憶',
    definition: 'to remember, to reflect upon; memory',
    pinyin: ['yì'],
    decomposition: '⿰忄意',
    etymology: {
      type: 'pictophonetic',
      phonetic: '意',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '憷',
    definition: 'painful; privation, suffering',
    pinyin: ['chù'],
    decomposition: '⿰忄楚',
    etymology: {
      type: 'ideographic',
      hint: 'A pained 楚 heart 忄; 楚 also provides the pronunciation',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '憹',
    definition: 'anxious, brooding',
    pinyin: ['náo'],
    decomposition: '⿰忄農',
    etymology: {
      type: 'pictophonetic',
      phonetic: '農',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '憾',
    definition: 'regret, remorse',
    pinyin: ['hàn'],
    decomposition: '⿰忄感',
    etymology: {
      type: 'pictophonetic',
      phonetic: '感',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '懂',
    definition: 'to understand, to know',
    pinyin: ['dǒng'],
    decomposition: '⿰忄董',
    etymology: {
      type: 'pictophonetic',
      phonetic: '董',
      semantic: '忄',
      hint: 'mind',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '懇',
    definition: 'sincere, earnest, cordial',
    pinyin: ['kěn'],
    decomposition: '⿱貇心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '貇',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '懈',
    definition: 'idle, relaxed; negligent, remiss',
    pinyin: ['xiè'],
    decomposition: '⿰忄解',
    etymology: {
      type: 'pictophonetic',
      phonetic: '解',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '應',
    definition: 'should, must; to respond, to handle; to deal with, to cope',
    pinyin: ['yīng'],
    decomposition: '⿸⿸广倠心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '倠',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '懊',
    definition: 'vexed; regretful; nervous',
    pinyin: ['ào'],
    decomposition: '⿰忄奥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奥',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '懋',
    definition: 'grand, majestic, splendid',
    pinyin: ['mào'],
    decomposition: '⿱楙心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '楙',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '懑',
    definition: 'sad, sorrowful, sick at heart',
    pinyin: ['mèn'],
    decomposition: '⿱满心',
    etymology: {
      type: 'ideographic',
      hint: 'With a heavy 满 heart 心; 满 also provides the pronunciation',
    },
    radical: '心',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '懒',
    definition: 'lazy, languid, listless',
    pinyin: ['lǎn'],
    decomposition: '⿰忄赖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '赖',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '懔',
    definition: 'afraid of; in awe of',
    pinyin: ['lǐn'],
    decomposition: '⿰忄禀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '禀',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '懞',
    definition: 'to cover; to deceive; Mongolia',
    pinyin: ['méng'],
    decomposition: '⿰忄蒙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蒙',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '懟',
    definition: 'hatred, resentment; to dislike, to hate',
    pinyin: ['duì'],
    decomposition: '⿱對心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '對',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '懣',
    definition: 'sad, sorrowful, sick at heart',
    pinyin: ['mèn'],
    decomposition: '⿱滿心',
    etymology: {
      type: 'ideographic',
      hint: 'With a heavy 滿 heart 心; 滿 also provides the pronunciation',
    },
    radical: '心',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '懦',
    definition: 'weak, timid, cowardly',
    pinyin: ['nuò'],
    decomposition: '⿰忄需',
    etymology: {
      type: 'pictophonetic',
      phonetic: '需',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '懨',
    definition: 'feeble, sickly, weak; tranquil',
    pinyin: ['yān'],
    decomposition: '⿰忄厭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厭',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '懮',
    definition: 'calm, liesurely; to procrastinate',
    pinyin: ['yǒu'],
    decomposition: '⿰忄憂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '憂',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '懲',
    definition: 'to discipline, to punish, to reprimand, to warn',
    pinyin: ['chéng'],
    decomposition: '⿱徴心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '徴',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '懵',
    definition: 'stupid, ignorant, dull',
    pinyin: ['měng'],
    decomposition: '⿰忄瞢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '瞢',
      semantic: '忄',
      hint: 'mind',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '懶',
    definition: 'lazy, languid, listless',
    pinyin: ['lǎn'],
    decomposition: '⿰忄賴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '賴',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '懷',
    definition: "bosom, breast; to carry in one's bosom",
    pinyin: ['huái'],
    decomposition: '⿰忄褱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '褱',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '懸',
    definition: 'to hang, to hoist, to suspend; hung',
    pinyin: ['xuán'],
    decomposition: '⿱縣心',
    etymology: {
      type: 'ideographic',
      hint: "Pride 心  in one's country 縣, expressed by a flag; 縣 also provides the pronunciation",
    },
    radical: '心',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '懺',
    definition: 'to regret, to repent; confession, penitence',
    pinyin: ['chàn'],
    decomposition: '⿰忄韱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韱',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '懼',
    definition: 'to fear, to dread',
    pinyin: ['jù'],
    decomposition: '⿰忄瞿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '瞿',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '懾',
    definition: 'afraid, scared; to frighten, to intimidate',
    pinyin: ['shè'],
    decomposition: '⿰忄聶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '聶',
      semantic: '忄',
      hint: 'heart',
    },
    radical: '忄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '懿',
    definition: 'admirable, esteemed, virtuous',
    pinyin: ['yì'],
    decomposition: '⿰壹恣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '壹',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '戀',
    definition: 'love; to yearn for, to long for',
    pinyin: ['liàn'],
    decomposition: '⿱䜌心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '䜌',
      semantic: '心',
      hint: 'heart',
    },
    radical: '心',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '戆',
    definition: 'stupid, simple, simple-minded',
    pinyin: ['gàng'],
    decomposition: '⿱赣心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '赣',
      semantic: '心',
      hint: 'mind',
    },
    radical: '心',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '戇',
    definition: 'stupid, simple, simple-minded',
    pinyin: ['gàng'],
    decomposition: '⿱贛心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贛',
      semantic: '心',
      hint: 'mind',
    },
    radical: '心',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '戈',
    definition: 'spear, lance, halberd',
    pinyin: ['gē'],
    decomposition: '？',
    etymology: {
      type: 'pictographic',
      hint: 'A spear pointing to the bottom-right',
    },
    radical: '戈',
    matches: [null, null, null, null],
  },
  {
    character: '戉',
    definition: 'halberd, battle-axe',
    pinyin: ['yuè'],
    decomposition: '⿰？戈',
    etymology: { type: 'pictographic', hint: 'An axe swinging to the left' },
    radical: '戈',
    matches: [[1], null, [1], [1], [1]],
  },
  {
    character: '戊',
    definition: '5th heavenly stem',
    pinyin: ['wù'],
    decomposition: '⿰丿戈',
    radical: '戈',
    matches: [[1], [0], [1], [1], [1]],
  },
  {
    character: '戋',
    definition: 'small, narrow; tiny, little',
    pinyin: ['jiān'],
    decomposition: '⿻戈一',
    radical: '戈',
    matches: [[0], [1], [0], [0], [0]],
  },
  {
    character: '戌',
    definition: '11th terrestrial branch',
    pinyin: ['xū'],
    decomposition: '⿵戊一',
    radical: '戈',
    matches: [[0], [0], [1], [0], [0], [0]],
  },
  {
    character: '戍',
    definition: 'to garrison, to defend the border',
    pinyin: ['shù'],
    decomposition: '⿵戊丶',
    etymology: {
      type: 'ideographic',
      hint: 'Arms 戈 surrounding the country 丶',
    },
    radical: '戈',
    matches: [[0], [0], [1], [0], [0], [0]],
  },
  {
    character: '戎',
    definition: 'arms, armaments; military affairs',
    pinyin: ['róng'],
    decomposition: '⿹戈？',
    etymology: { type: 'ideographic', hint: 'A hand holding a lance 戈' },
    radical: '戈',
    matches: [[0], null, null, [0], [0], [0]],
  },
  {
    character: '戏',
    definition: 'play, show, theater',
    pinyin: ['xì'],
    decomposition: '⿰又戈',
    etymology: {
      type: 'ideographic',
      hint: 'A hand 又 doing tricks with a spear 戈',
    },
    radical: '戈',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '成',
    definition: 'to accomplish; to become; to complete, to finish; to succeed',
    pinyin: ['chéng'],
    decomposition: '⿰丁戈',
    radical: '戈',
    matches: [[1], [0], [0], [1], [1], [1]],
  },
  {
    character: '我',
    definition: 'I, me, my; our, us',
    pinyin: ['wǒ'],
    decomposition: '⿰扌戈',
    etymology: { type: 'ideographic', hint: 'A hand 扌 holding a weapon 戈' },
    radical: '戈',
    matches: [[0], [1], [0], [0], [1], [1], [1]],
  },
  {
    character: '戒',
    definition: 'to warn, to admonish; to swear off, to avoid',
    pinyin: ['jiè'],
    decomposition: '⿹戈廾',
    etymology: {
      type: 'ideographic',
      hint: 'Two hands 廾 brandishing a spear 戈',
    },
    radical: '戈',
    matches: [[0], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '戔',
    definition: 'small, narrow; tiny, little',
    pinyin: ['jiān'],
    decomposition: '⿱戈戈',
    etymology: {
      type: 'ideographic',
      hint: 'The narrow space between two blades 戈',
    },
    radical: '戈',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '戕',
    definition: 'to kill, to slay; to wound, to injure',
    pinyin: ['qiāng'],
    decomposition: '⿰爿戈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爿',
      semantic: '戈',
      hint: 'spear',
    },
    radical: '戈',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '或',
    definition: 'or, either, else; maybe, perhaps, possibly',
    pinyin: ['huò'],
    decomposition: '⿹戈⿱口一',
    etymology: {
      type: 'ideographic',
      hint: 'To defend yourself 口 with a spear 戈; "or else"',
    },
    radical: '戈',
    matches: [[0], [1, 0], [1, 0], [1, 0], [1, 1], [0], [0], [0]],
  },
  {
    character: '戗',
    definition: 'to support',
    pinyin: ['qiāng'],
    decomposition: '⿰仓戈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '仓',
      semantic: '戈',
      hint: 'spear',
    },
    radical: '戈',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '战',
    definition: 'war, fighting, battle',
    pinyin: ['zhàn'],
    decomposition: '⿰占戈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '占',
      semantic: '戈',
      hint: 'spear',
    },
    radical: '戈',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '戚',
    definition: 'ashamed, grieving; related to; relative',
    pinyin: ['qī'],
    decomposition: '⿵戊尗',
    etymology: {
      type: 'ideographic',
      hint: 'A younger brother 尗 killed in a war 戈',
    },
    radical: '戈',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '戛',
    definition: 'lance; to lightly tap or strike',
    pinyin: ['jiá'],
    decomposition: '⿳一自戈',
    etymology: {
      type: 'ideographic',
      hint: 'To strike 戈 someone on the nose 自',
    },
    radical: '戈',
    matches: [[0], [1], [1], [1], [1], [1], [1], [2], [2], [2], [2]],
  },
  {
    character: '戜',
    definition: 'to scrape; advantageous',
    pinyin: ['dié'],
    decomposition: '⿹戈呈',
    radical: '戈',
    matches: [[0], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '戟',
    definition: 'a double-bladed axe',
    pinyin: ['jǐ'],
    decomposition: '⿰龺戈',
    etymology: {
      type: 'ideographic',
      hint: 'An axe 戈 with blades on both sides 龺',
    },
    radical: '戈',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '戠',
    definition: "sword; potter's clay; to gather",
    pinyin: ['zhī'],
    decomposition: '⿰音戈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '音',
      semantic: '戈',
      hint: 'spear',
    },
    radical: '戈',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '戡',
    definition: 'to subjugate, to subdue, to quell, to kill',
    pinyin: ['kān'],
    decomposition: '⿰甚戈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甚',
      semantic: '戈',
      hint: 'spear',
    },
    radical: '戈',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '戢',
    definition: 'to collect oneself; to put away, to store',
    pinyin: ['jí'],
    decomposition: '⿰咠戈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咠',
      semantic: '戈',
      hint: 'spear',
    },
    radical: '戈',
    matches: [[0], [0], [0], [1], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '戤',
    definition: 'to infringe upon a trademark',
    pinyin: ['gài'],
    decomposition: '⿰盈戈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戈',
      semantic: '盈',
      hint: 'overflow',
    },
    radical: '戈',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '戥',
    definition: 'a steelyard balance for weighing money',
    pinyin: ['děng'],
    decomposition: '⿰星戈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '星',
      semantic: '戈',
      hint: 'spear',
    },
    radical: '戈',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '戧',
    definition: 'to support',
    pinyin: ['qiāng'],
    decomposition: '⿰倉戈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '倉',
      semantic: '戈',
      hint: 'spear',
    },
    radical: '戈',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '截',
    definition: 'to cut off, to obstruct, to stop; segment; intersection',
    pinyin: ['jié'],
    decomposition: '⿻⿱十隹戈',
    etymology: {
      type: 'ideographic',
      hint: 'A bird 隹 cut off from its nest 十 by a weapon 戈',
    },
    radical: '戈',
    matches: [
      [0, 0],
      [0, 0],
      [1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '戬',
    definition: 'to exterminate, to destroy; blessing',
    pinyin: ['jiǎn'],
    decomposition: '⿰晋戈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '晋',
      semantic: '戈',
      hint: 'spear',
    },
    radical: '戈',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '戮',
    definition: 'to kill, to massacre; to oppress',
    pinyin: ['lù'],
    decomposition: '⿰翏戈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '翏',
      semantic: '戈',
      hint: 'spear',
    },
    radical: '戈',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '戰',
    definition: 'war, fighting, battle',
    pinyin: ['zhàn'],
    decomposition: '⿰單戈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '單',
      semantic: '戈',
      hint: 'spear',
    },
    radical: '戈',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '戲',
    definition: 'play, show, theater',
    pinyin: ['xì'],
    decomposition: '⿰⿸虍豆戈',
    radical: '戈',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '戳',
    definition: 'to pierce, to prick, to stab; stamp, seal',
    pinyin: ['chuō'],
    decomposition: '⿰翟戈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '翟',
      semantic: '戈',
      hint: 'spear',
    },
    radical: '戈',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '戴',
    definition: 'to support; to respect; to put on, to wear; surname',
    pinyin: ['dài'],
    decomposition: '⿻⿱十異戈',
    radical: '戈',
    matches: [
      [0, 0],
      [0, 0],
      [1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '戶',
    definition: 'door; family',
    pinyin: ['hù'],
    decomposition: '⿻？尸',
    etymology: { type: 'pictographic', hint: 'A door swinging on its hinge' },
    radical: '户',
    matches: [null, [1], [1], [1]],
  },
  {
    character: '户',
    definition: 'door; family',
    pinyin: ['hù'],
    decomposition: '⿱丶尸',
    etymology: {
      type: 'pictographic',
      hint: 'Simplified form of 戶; a door swinging on its hinge',
    },
    radical: '户',
    matches: [[0], [1], [1], [1]],
  },
  {
    character: '戽',
    definition: 'to bale out; to irrigate',
    pinyin: ['hù'],
    decomposition: '⿸户斗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '户',
      semantic: '斗',
      hint: 'bucket',
    },
    radical: '户',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '戾',
    definition: 'perverse, rebellious, recalcitrant',
    pinyin: ['lì'],
    decomposition: '⿸户犬',
    etymology: {
      type: 'ideographic',
      hint: "A dog 犬 that won't come indoors 户",
    },
    radical: '户',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '房',
    definition: 'building, house, room',
    pinyin: ['fáng'],
    decomposition: '⿸户方',
    etymology: {
      type: 'pictophonetic',
      phonetic: '方',
      semantic: '户',
      hint: 'door',
    },
    radical: '户',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '所',
    definition:
      'place, location; "that which", a particle introducing a passive clause',
    pinyin: ['suǒ'],
    decomposition: '⿰户斤',
    etymology: { type: 'ideographic', hint: 'An axe 斤 swung at a door 户' },
    radical: '户',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '扁',
    definition: 'flat; board, sign, tablet',
    pinyin: ['biǎn'],
    decomposition: '⿸户？',
    radical: '户',
    matches: [[0], [0], [0], [0], null, null, null, null, null],
  },
  {
    character: '扂',
    definition: 'door latch',
    pinyin: ['diàn'],
    decomposition: '⿸户占',
    etymology: {
      type: 'pictophonetic',
      phonetic: '占',
      semantic: '户',
      hint: 'door',
    },
    radical: '户',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '扃',
    definition: 'door latch, crossbar',
    pinyin: ['jiōng'],
    decomposition: '⿸户冋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冋',
      semantic: '户',
      hint: 'door',
    },
    radical: '户',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '扆',
    definition: 'screen door',
    pinyin: ['yǐ'],
    decomposition: '⿸户衣',
    etymology: {
      type: 'ideographic',
      hint: 'A cloth 衣 door 户; 衣 also provides the pronunciation',
    },
    radical: '户',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '扇',
    definition: 'fan; panel; to flap',
    pinyin: ['shàn'],
    decomposition: '⿸户羽',
    etymology: {
      type: 'ideographic',
      hint: 'A feathered 羽 fan in the shape of a folding door 户',
    },
    radical: '户',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '扈',
    definition: 'escort, retinue; insolent',
    pinyin: ['hù'],
    decomposition: '⿸户邑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '户',
      semantic: '邑',
      hint: 'city',
    },
    radical: '户',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '扉',
    definition: 'door panel',
    pinyin: ['fēi'],
    decomposition: '⿸户非',
    etymology: {
      type: 'pictophonetic',
      phonetic: '非',
      semantic: '户',
      hint: 'door',
    },
    radical: '户',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '手',
    definition: 'hand',
    pinyin: ['shǒu'],
    decomposition: '？',
    etymology: {
      type: 'pictographic',
      hint: 'A hand with the fingers splayed',
    },
    radical: '手',
    matches: [null, null, null, null],
  },
  {
    character: '扌',
    definition: 'hand',
    pinyin: ['shǒu'],
    decomposition: '⿻二亅',
    etymology: {
      type: 'pictographic',
      hint: 'A hand with the fingers splayed; compare 手',
    },
    radical: '扌',
    matches: [[0], [1], [0]],
  },
  {
    character: '才',
    definition: 'ability, talent, gift; just, only',
    pinyin: ['cái'],
    decomposition: '⿻扌？',
    etymology: {
      type: 'ideographic',
      hint: 'A sprout growing in the ground, representing a budding talent',
    },
    radical: '扌',
    matches: [[0], [0], [0]],
  },
  {
    character: '扎',
    definition: 'to bind, to wrap; to pierce; to stop',
    pinyin: ['zhā'],
    decomposition: '⿰扌乚',
    etymology: {
      type: 'ideographic',
      hint: 'A hand 扌 tying a bundle with string 乚',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1]],
  },
  {
    character: '扑',
    definition: 'to attack, to beat, to hit, to strike',
    pinyin: ['pū'],
    decomposition: '⿰扌卜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卜',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '扒',
    definition: 'to scratch, to dig up; to crouch, to crawl',
    pinyin: ['bā'],
    decomposition: '⿰扌八',
    etymology: {
      type: 'pictophonetic',
      phonetic: '八',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '打',
    definition: 'to attack, to beat, to hit, to strike',
    pinyin: ['dǎ'],
    decomposition: '⿰扌丁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丁',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '扔',
    definition: 'to throw, to hurl, to cast away',
    pinyin: ['rēng'],
    decomposition: '⿰扌乃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乃',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '払',
    definition: 'shake off, brush away; dust',
    pinyin: ['fǎn'],
    decomposition: '⿰扌厶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厶',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '托',
    definition: 'to raise, to support; to entrust, to rely on',
    pinyin: ['tuō'],
    decomposition: '⿰扌乇',
    etymology: {
      type: 'ideographic',
      hint: "Using one's hands 扌 for support 乇; 乇 also provides the pronunciation",
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '扛',
    definition: "to lift; to carry on one's shoulders",
    pinyin: ['káng'],
    decomposition: '⿰扌工',
    etymology: {
      type: 'ideographic',
      hint: 'Labor 工 done by hand 扌; 工 also provides the pronunciation',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '扢',
    definition: 'to clean, to rub',
    pinyin: ['gǔ'],
    decomposition: '⿰扌乞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乞',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '扣',
    definition: 'to detain; to knock, to tap; button',
    pinyin: ['kòu'],
    decomposition: '⿰扌口',
    etymology: {
      type: 'pictophonetic',
      phonetic: '口',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '扦',
    definition: 'to probe, to poke, to pierce, to pick at',
    pinyin: ['qiān'],
    decomposition: '⿰扌千',
    etymology: {
      type: 'pictophonetic',
      phonetic: '千',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '执',
    definition: 'to execute; to grasp, to hold; to keep; to sieze, to detain',
    pinyin: ['zhí'],
    decomposition: '⿰扌丸',
    etymology: { type: 'ideographic', hint: 'A hand 扌 clutching a pebble 丸' },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '扩',
    definition: 'to expand, to stretch, to magnify',
    pinyin: ['kuò'],
    decomposition: '⿰扌广',
    etymology: {
      type: 'pictophonetic',
      phonetic: '扌',
      semantic: '广',
      hint: 'wide',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '扪',
    definition: 'to stoke, to pat; to grope, to feel',
    pinyin: ['mén'],
    decomposition: '⿰扌门',
    etymology: {
      type: 'pictophonetic',
      phonetic: '门',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '扫',
    definition: 'to clean, to sweep, to wipe away; to weed out; to wipe out',
    pinyin: ['sǎo'],
    decomposition: '⿰扌彐',
    etymology: {
      type: 'ideographic',
      hint: 'Simplified form of 掃; to use 扌 a broom 帚; 帚 also provides the pronunciation',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '扬',
    definition: 'to flutter, to wave; to hoist, to raise; to praise',
    pinyin: ['yáng'],
    decomposition: '⿰扌昜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昜',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '扭',
    definition: 'to turn, to twist, to wrench; to grasp, to seize',
    pinyin: ['niǔ'],
    decomposition: '⿰扌丑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丑',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '扮',
    definition: 'costume, disguise; to dress up',
    pinyin: ['bàn'],
    decomposition: '⿰扌分',
    etymology: {
      type: 'pictophonetic',
      phonetic: '分',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '扯',
    definition: 'to rip, to tear; to haul; casual talk',
    pinyin: ['chě'],
    decomposition: '⿰扌止',
    etymology: {
      type: 'pictophonetic',
      phonetic: '止',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '扰',
    definition: 'to poke, to disturb, to annoy, to agitate',
    pinyin: ['rǎo'],
    decomposition: '⿰扌尤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尤',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '扳',
    definition: 'to drag, to pull; to twist',
    pinyin: ['bān'],
    decomposition: '⿰扌反',
    etymology: {
      type: 'pictophonetic',
      phonetic: '反',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '扶',
    definition: 'to support, to protect, to help',
    pinyin: ['fú'],
    decomposition: '⿰扌夫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夫',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '批',
    definition: 'comment, criticism; batch, lot; wholesale',
    pinyin: ['pī'],
    decomposition: '⿰扌比',
    etymology: {
      type: 'pictophonetic',
      phonetic: '比',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '扼',
    definition: 'to clutch, to grasp; to choke, to strangle',
    pinyin: ['è'],
    decomposition: '⿰扌厄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厄',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '找',
    definition: 'to search for, to look for, to find; change (as in money)',
    pinyin: ['zhǎo'],
    decomposition: '⿰扌戈',
    etymology: {
      type: 'ideographic',
      hint: 'To go searching with a spear 戈 in hand 扌',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '承',
    definition: 'to undertake, to bear, to accept a duty; inheritance',
    pinyin: ['chéng'],
    decomposition: '⿻⿻了三？',
    etymology: {
      type: 'ideographic',
      hint: 'Three hands 手 lifting a dead body 了',
    },
    radical: '手',
    matches: [[0, 0], [0, 0], [0, 1], [0, 1], [0, 1], null, null, null],
  },
  {
    character: '技',
    definition: 'ability, talent; skill, technique',
    pinyin: ['jì'],
    decomposition: '⿰扌支',
    etymology: {
      type: 'pictophonetic',
      phonetic: '支',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '抃',
    definition: 'to cheer, to clap',
    pinyin: ['biàn'],
    decomposition: '⿰扌卞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卞',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '抄',
    definition: 'copy, plagiarism; to confiscate, to seize',
    pinyin: ['chāo'],
    decomposition: '⿰扌少',
    etymology: {
      type: 'pictophonetic',
      phonetic: '少',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '抉',
    definition: 'to select, to choose; to pluck, to gouge',
    pinyin: ['jué'],
    decomposition: '⿰扌夬',
    etymology: {
      type: 'ideographic',
      hint: 'To choose 夬 by hand 扌; 夬 also provides the pronunciation',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '把',
    definition: 'to grasp, to hold; to guard, to take; handle',
    pinyin: ['bǎ'],
    decomposition: '⿰扌巴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巴',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '抑',
    definition: 'to curb, to hinder; to keep down, to repress',
    pinyin: ['yì'],
    decomposition: '⿰扌卬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卬',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '抒',
    definition: 'to express; to pour out',
    pinyin: ['shū'],
    decomposition: '⿰扌予',
    etymology: {
      type: 'pictophonetic',
      phonetic: '扌',
      semantic: '予',
      hint: 'give',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '抓',
    definition: 'to clutch, to grab, to seize',
    pinyin: ['zhuā'],
    decomposition: '⿰扌爪',
    etymology: {
      type: 'ideographic',
      hint: 'A hand 扌 with claws 爪; 爪 also provides the pronunciation',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '投',
    definition: 'to pitch, to throw; to bid, to invest',
    pinyin: ['tóu'],
    decomposition: '⿰扌殳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '殳',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '抖',
    definition: 'to tremble, to shake, to rouse',
    pinyin: ['dǒu'],
    decomposition: '⿰扌斗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斗',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '抗',
    definition: 'to defy, to fight, to resist',
    pinyin: ['kàng'],
    decomposition: '⿰扌亢',
    etymology: {
      type: 'ideographic',
      hint: 'Fighting 亢 with bare hands 扌; 亢 also provides the pronunciation',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '折',
    definition: 'to break, to snap; to fold, to bend; to bow; humble',
    pinyin: ['zhé'],
    decomposition: '⿰扌斤',
    etymology: { type: 'ideographic', hint: 'A hand 扌 wielding an axe 斤' },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '抚',
    definition: 'to pat, to console; to stroke, to caress',
    pinyin: ['fǔ'],
    decomposition: '⿰扌无',
    etymology: {
      type: 'pictophonetic',
      phonetic: '无',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '抛',
    definition: 'to abandon, to throw away; to fling, to toss',
    pinyin: ['pāo'],
    decomposition: '⿰扌⿺九力',
    etymology: { type: 'pictophonetic', semantic: '扌', hint: 'hand' },
    radical: '扌',
    matches: [[0], [0], [0], [1, 0], [1, 0], [1, 1], [1, 1]],
  },
  {
    character: '抟',
    definition: "to roll around in one's hand; to model",
    pinyin: ['tuán'],
    decomposition: '⿰扌专',
    etymology: {
      type: 'pictophonetic',
      phonetic: '专',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '抠',
    definition: 'to lift, to raise; tight-fisted',
    pinyin: ['kōu'],
    decomposition: '⿰扌区',
    etymology: {
      type: 'pictophonetic',
      phonetic: '区',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '抡',
    definition: 'to swing, to flourish, to brandish',
    pinyin: ['lūn'],
    decomposition: '⿰扌仑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '仑',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '抢',
    definition: 'urgent, rushed; to rob, to plunder',
    pinyin: ['qiǎng'],
    decomposition: '⿰扌仓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '仓',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '护',
    definition: 'to defend, to guard, to protect; shelter; endorse',
    pinyin: ['hù'],
    decomposition: '⿰扌户',
    etymology: {
      type: 'ideographic',
      hint: 'Guarding 扌 a home 户; 户 also provides the pronunciation',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '报',
    definition: 'to announce, to report; newspaper; payback, revenge',
    pinyin: ['bào'],
    decomposition: '⿰扌⿸卩又',
    etymology: {
      type: 'ideographic',
      hint: 'A hand 扌 cuffing 又 a criminal 卩, representing sentencing',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1, 0], [1, 0], [1, 1], [1, 1]],
  },
  {
    character: '抨',
    definition: 'to impeach; to criticize',
    pinyin: ['pēng'],
    decomposition: '⿰扌平',
    etymology: {
      type: 'pictophonetic',
      phonetic: '平',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '披',
    definition: 'to wear; to split, to crack',
    pinyin: ['pī'],
    decomposition: '⿰扌皮',
    etymology: {
      type: 'ideographic',
      hint: 'To put on 扌 fur 皮; 皮 also provides the pronunciation',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '抬',
    definition: 'to carry, to lift, to raise',
    pinyin: ['tái'],
    decomposition: '⿰扌台',
    etymology: {
      type: 'pictophonetic',
      phonetic: '台',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '抱',
    definition: "to embrace, to hold in one's arms; to enfold",
    pinyin: ['bào'],
    decomposition: '⿰扌包',
    etymology: {
      type: 'ideographic',
      hint: "To wrap 包 in one's arms 扌; 包 also provides the pronunciation",
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '抵',
    definition: 'to resist; to arrive; mortgage',
    pinyin: ['dǐ'],
    decomposition: '⿰扌氐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '氐',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '抹',
    definition: 'to apply; to erase, to smear, to wipe off',
    pinyin: ['mǒ'],
    decomposition: '⿰扌末',
    etymology: {
      type: 'pictophonetic',
      phonetic: '末',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '抻',
    definition: 'to pull',
    pinyin: ['chēn'],
    decomposition: '⿰扌申',
    etymology: {
      type: 'pictophonetic',
      phonetic: '申',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '押',
    definition: 'to arrest, to detain; to deposit, to pledge; mortgage',
    pinyin: ['yā'],
    decomposition: '⿰扌甲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甲',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '抽',
    definition: 'to draw out, to pull out; to sprout',
    pinyin: ['chōu'],
    decomposition: '⿰扌由',
    etymology: {
      type: 'pictophonetic',
      phonetic: '由',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '抿',
    definition: 'to press, to smooth; to purse the lips',
    pinyin: ['mǐn'],
    decomposition: '⿰扌民',
    etymology: {
      type: 'pictophonetic',
      phonetic: '民',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '拂',
    definition: 'to shake off, to brush away; dust',
    pinyin: ['fú'],
    decomposition: '⿰扌弗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弗',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '拄',
    definition: 'post; to lean on; to prod, to ridicule',
    pinyin: ['zhǔ'],
    decomposition: '⿰扌主',
    etymology: {
      type: 'pictophonetic',
      phonetic: '主',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '担',
    definition: 'to bear, to carry; burden, responsibility',
    pinyin: ['dān'],
    decomposition: '⿰扌旦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旦',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '拆',
    definition: 'to break open, to split up, to tear apart',
    pinyin: ['chāi'],
    decomposition: '⿰扌斥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斥',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '拇',
    definition: 'thumb; big toe',
    pinyin: ['mǔ'],
    decomposition: '⿰扌母',
    etymology: {
      type: 'pictophonetic',
      phonetic: '母',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '拈',
    definition: 'to pick up with the fingers; to draw lots',
    pinyin: ['niān'],
    decomposition: '⿰扌占',
    etymology: {
      type: 'ideographic',
      hint: 'To divine 占 by hand 扌; 占 also provides the pronunciation',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '拉',
    definition:
      'to pull, to drag; to seize, to hold; to lengthen; to play (a violin)',
    pinyin: ['lā'],
    decomposition: '⿰扌立',
    etymology: {
      type: 'pictophonetic',
      phonetic: '立',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '拊',
    definition: 'to pat, to slap, to tap; the handle of a vessel',
    pinyin: ['fǔ'],
    decomposition: '⿰扌付',
    etymology: {
      type: 'pictophonetic',
      phonetic: '付',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '拋',
    definition: 'to abandon, to throw away; to fling, to toss',
    pinyin: ['pāo'],
    decomposition: '⿰扌⿺尢力',
    etymology: { type: 'pictophonetic', semantic: '扌', hint: 'hand' },
    radical: '扌',
    matches: [[0], [0], [0], [1, 0], [1, 0], [1, 0], [1, 1], [1, 1]],
  },
  {
    character: '拌',
    definition: 'to mix',
    pinyin: ['bàn'],
    decomposition: '⿰扌半',
    etymology: {
      type: 'pictophonetic',
      phonetic: '半',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '拍',
    definition: 'to clap, to tap; to hit, to beat, to slap; beat, rhythm',
    pinyin: ['pāi'],
    decomposition: '⿰扌白',
    etymology: {
      type: 'pictophonetic',
      phonetic: '白',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '拎',
    definition: 'to lift, to haul, to take',
    pinyin: ['līn'],
    decomposition: '⿰扌令',
    etymology: {
      type: 'pictophonetic',
      phonetic: '令',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '拐',
    definition: 'to kidnap, to abduct; to turn; crutch',
    pinyin: ['guǎi'],
    decomposition: '⿰扌另',
    etymology: { type: 'ideographic', hint: 'To take another 另 by force 扌' },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '拑',
    definition: 'to clamp, to pin down, to tie down',
    pinyin: ['qián'],
    decomposition: '⿰扌甘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甘',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '拒',
    definition: 'to defend, to ward off; to refuse',
    pinyin: ['jù'],
    decomposition: '⿰扌巨',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巨',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '拓',
    definition: 'to develop, to expand, to open up',
    pinyin: ['tà'],
    decomposition: '⿰扌石',
    etymology: {
      type: 'pictophonetic',
      phonetic: '石',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '拔',
    definition: 'to uproot, to pull out; to select, to promote',
    pinyin: ['bá'],
    decomposition: '⿰扌犮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '犮',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '拖',
    definition: 'to drag, to haul, to tow; to delay',
    pinyin: ['tuō'],
    decomposition: '⿰扌⿱亻也',
    etymology: { type: 'pictophonetic', semantic: '扌', hint: 'hand' },
    radical: '扌',
    matches: [[0], [0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '拗',
    definition: 'to pull, to drag; perverse, obstinate; bent, warped',
    pinyin: ['ǎo'],
    decomposition: '⿰扌幼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '幼',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '拘',
    definition: 'to detain, to restrain, to seize',
    pinyin: ['jū'],
    decomposition: '⿰扌句',
    etymology: {
      type: 'pictophonetic',
      phonetic: '句',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '拙',
    definition: 'awkward, clumsy; dull, stupid',
    pinyin: ['zhuō'],
    decomposition: '⿰扌出',
    etymology: {
      type: 'pictophonetic',
      phonetic: '出',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '拚',
    definition: 'to reject, to disregard, to go all out',
    pinyin: ['pàn'],
    decomposition: '⿰扌弁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弁',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '招',
    definition: 'to summon; to recruit; to levy',
    pinyin: ['zhāo'],
    decomposition: '⿰扌召',
    etymology: {
      type: 'ideographic',
      hint: 'A call 召 to arms 扌; 召 also provides the pronunciation',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '拜',
    definition: 'to bow, to salute; to worship, to pay respects',
    pinyin: ['bài'],
    decomposition: '⿰手手',
    etymology: {
      type: 'ideographic',
      hint: 'Two hands 手 put together in respect',
    },
    radical: '手',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '拟',
    definition: 'to draft, to plan; to intend',
    pinyin: ['nǐ'],
    decomposition: '⿰扌以',
    etymology: {
      type: 'pictophonetic',
      phonetic: '以',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '拢',
    definition: 'to collect, to bring together',
    pinyin: ['lǒng'],
    decomposition: '⿰扌龙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龙',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '拣',
    definition: 'to choose, to select; to gather, to pick up',
    pinyin: ['jiǎn'],
    decomposition: '⿰扌柬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '柬',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '拥',
    definition: 'to have, to hold; to embrace, to hug; to flock, to throng',
    pinyin: ['yōng'],
    decomposition: '⿰扌用',
    etymology: {
      type: 'pictophonetic',
      phonetic: '用',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '拦',
    definition: 'to block, to hinder, to obstruct',
    pinyin: ['lán'],
    decomposition: '⿰扌兰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兰',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '拧',
    definition: 'screw, wrench; to pinch, to twist, to wring',
    pinyin: ['níng'],
    decomposition: '⿰扌宁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宁',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '拨',
    definition: 'to stir, to move, to distribute, to allocate',
    pinyin: ['bō'],
    decomposition: '⿰扌发',
    etymology: { type: 'ideographic', hint: 'To dispatch 发 goods by hand 扌' },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '择',
    definition: 'to select, to choose',
    pinyin: ['zé'],
    decomposition: '⿰扌？',
    radical: '扌',
    matches: [[0], [0], [0], null, null, null, null, null],
  },
  {
    character: '括',
    definition: 'to embrace, to enclose, to include',
    pinyin: ['kuò'],
    decomposition: '⿰扌舌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '舌',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '拭',
    definition: 'to wipe away stains with a cloth',
    pinyin: ['shì'],
    decomposition: '⿰扌式',
    etymology: {
      type: 'pictophonetic',
      phonetic: '式',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '拮',
    definition: 'busy, occupied; to pursue',
    pinyin: ['jié'],
    decomposition: '⿰扌吉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吉',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '拯',
    definition: 'to aid, to help; to lift, to raise',
    pinyin: ['zhěng'],
    decomposition: '⿰扌丞',
    etymology: {
      type: 'ideographic',
      hint: 'To give 丞 a hand 扌; 丞 also provides the pronunciation',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '拱',
    definition: 'to salute, to bow; arched; arch',
    pinyin: ['gǒng'],
    decomposition: '⿰扌共',
    etymology: {
      type: 'pictophonetic',
      phonetic: '共',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '拳',
    definition: 'fist; various forms of boxing',
    pinyin: ['quán'],
    decomposition: '⿱龹手',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龹',
      semantic: '手',
      hint: 'hand',
    },
    radical: '手',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '拴',
    definition: 'to fasten, to bind',
    pinyin: ['shuān'],
    decomposition: '⿰扌全',
    etymology: {
      type: 'pictophonetic',
      phonetic: '全',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '拶',
    definition: 'to squeeze, to press hard, to force',
    pinyin: ['zā'],
    decomposition: '⿰扌⿱巛夕',
    etymology: { type: 'pictophonetic', semantic: '扌', hint: 'hand' },
    radical: '扌',
    matches: [[0], [0], [0], [1, 0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '拷',
    definition: 'to torture, to interrogate; to beat, to flog',
    pinyin: ['kǎo'],
    decomposition: '⿰扌考',
    etymology: {
      type: 'ideographic',
      hint: 'To question 考 by hand 扌; 考 also provides the pronunciation',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '拼',
    definition: 'to link, to join together; to incorporate',
    pinyin: ['pīn'],
    decomposition: '⿰扌并',
    etymology: {
      type: 'pictophonetic',
      phonetic: '并',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '拽',
    definition: 'to drag, to tow; to throw; to twist',
    pinyin: ['zhuāi'],
    decomposition: '⿰扌曳',
    etymology: {
      type: 'ideographic',
      hint: 'To pull 曳 by hand 扌; 曳 also provides the pronunciation',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '拾',
    definition:
      "to collect, to pick up, to tidy up; ten (bankers' anti-fraud numeral)",
    pinyin: ['shí'],
    decomposition: '⿰扌合',
    etymology: {
      type: 'ideographic',
      hint: "To gather 合 things in one's hands 扌",
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '拿',
    definition: 'to bring, to grasp, to hold, to take',
    pinyin: ['ná'],
    decomposition: '⿱合手',
    etymology: {
      type: 'pictophonetic',
      phonetic: '合',
      semantic: '手',
      hint: 'hand',
    },
    radical: '手',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '持',
    definition: 'to hold, to support, to sustain',
    pinyin: ['chí'],
    decomposition: '⿰扌寺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寺',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '挂',
    definition: 'to suspend, to put up, to hang; suspense',
    pinyin: ['guà'],
    decomposition: '⿰扌圭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '圭',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '指',
    definition: 'finger, toe; to point, to indicate',
    pinyin: ['zhǐ'],
    decomposition: '⿰扌旨',
    etymology: {
      type: 'ideographic',
      hint: 'To point 旨 by hand 扌; 旨 also provides the pronunciation',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '挈',
    definition: 'to assist, to help; to lead by hand',
    pinyin: ['qiè'],
    decomposition: '⿱㓞手',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㓞',
      semantic: '手',
      hint: 'hand',
    },
    radical: '手',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '按',
    definition: 'to check, to control, to push, to restrain',
    pinyin: ['àn'],
    decomposition: '⿰扌安',
    etymology: {
      type: 'pictophonetic',
      phonetic: '安',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '挎',
    definition: 'to carry',
    pinyin: ['kuà'],
    decomposition: '⿰扌夸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夸',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '挑',
    definition: 'to select, to choose; picky, choosy; a load',
    pinyin: ['tiāo'],
    decomposition: '⿰扌兆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兆',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '挖',
    definition: 'to dig, to excavate',
    pinyin: ['wā'],
    decomposition: '⿰扌穵',
    etymology: {
      type: 'ideographic',
      hint: 'To dig out 扌 a hollow 穵; 穵 also provides the pronunciation',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '挚',
    definition: 'sincere, warm, cordial; surname',
    pinyin: ['zhì'],
    decomposition: '⿱执手',
    etymology: {
      type: 'ideographic',
      hint: 'To shake 执 hands 手; 执 also provides the pronunciation',
    },
    radical: '手',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '挛',
    definition: 'tangled, entwined; crooked',
    pinyin: ['luán'],
    decomposition: '⿱亦手',
    etymology: { type: 'pictophonetic', semantic: '手', hint: 'hand' },
    radical: '手',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '挝',
    definition: 'to beat; to strike',
    pinyin: ['wō'],
    decomposition: '⿰扌过',
    etymology: {
      type: 'pictophonetic',
      phonetic: '过',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '挞',
    definition: 'to whip, to flog, to chastise',
    pinyin: ['tà'],
    decomposition: '⿰扌达',
    etymology: {
      type: 'pictophonetic',
      phonetic: '达',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '挟',
    definition: "to seize; to hold to one's bosom",
    pinyin: ['xié'],
    decomposition: '⿰扌夹',
    etymology: {
      type: 'ideographic',
      hint: "Wedged 夹 in one's arms 扌; 夹 also provides the pronunciation",
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '挠',
    definition: 'to yield; to scratch, to disturb',
    pinyin: ['náo'],
    decomposition: '⿰扌尧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尧',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '挡',
    definition: 'to block, to obstruct; to get in the way; cover, guard',
    pinyin: ['dǎng'],
    decomposition: '⿰扌当',
    etymology: {
      type: 'ideographic',
      hint: 'A hand 扌 raised at the right time 当; 当 also provides the pronunciation',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '挢',
    definition: 'to correct',
    pinyin: ['jiǎo'],
    decomposition: '⿰扌乔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乔',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '挣',
    definition: 'to struggle, to strive, to endeavor',
    pinyin: ['zhēng'],
    decomposition: '⿰扌争',
    etymology: {
      type: 'ideographic',
      hint: 'To fight 争 by hand 扌; 争 also provides the pronunciation',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '挤',
    definition: 'to squeeze, to push against; crowded',
    pinyin: ['jǐ'],
    decomposition: '⿰扌齐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '齐',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '挥',
    definition: 'to direct; to squander; to wave; to wipe away',
    pinyin: ['huī'],
    decomposition: '⿰扌军',
    etymology: { type: 'ideographic', hint: 'To direct an army 军 by hand 扌' },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '挨',
    definition:
      'close by, near, next to, towards, against; to lean on; to wait',
    pinyin: ['āi'],
    decomposition: '⿰扌矣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '矣',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '挪',
    definition: 'to shift, to move',
    pinyin: ['nuó'],
    decomposition: '⿰扌那',
    etymology: {
      type: 'pictophonetic',
      phonetic: '那',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '挫',
    definition: 'to check, to obstruct, to push down',
    pinyin: ['cuò'],
    decomposition: '⿰扌坐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '坐',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '振',
    definition: 'to arouse, to excite; to rouse, to shake',
    pinyin: ['zhèn'],
    decomposition: '⿰扌辰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辰',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '挲',
    definition: 'to feel or fondle with the fingers',
    pinyin: ['sā'],
    decomposition: '⿱沙手',
    etymology: {
      type: 'pictophonetic',
      phonetic: '沙',
      semantic: '手',
      hint: 'hand',
    },
    radical: '手',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '挹',
    definition: 'to bale out; to pour',
    pinyin: ['yì'],
    decomposition: '⿰扌邑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '邑',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '挺',
    definition: 'to straighten, to stand upright; rigid, stiff',
    pinyin: ['tǐng'],
    decomposition: '⿰扌廷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '廷',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '挽',
    definition: 'to pull, to lead; to pull back, to draw a bow',
    pinyin: ['wǎn'],
    decomposition: '⿰扌免',
    etymology: {
      type: 'pictophonetic',
      phonetic: '免',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '挾',
    definition: "to seize; to hold to one's bosom",
    pinyin: ['xié'],
    decomposition: '⿰扌夾',
    etymology: {
      type: 'ideographic',
      hint: "Wedged 夾 in one's arms 扌; 夾 also provides the pronunciation",
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '捂',
    definition: 'to resist',
    pinyin: ['wǔ'],
    decomposition: '⿰扌吾',
    etymology: {
      type: 'ideographic',
      hint: 'To resist 吾 by hand 扌; 吾 also provides the pronunciation',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '捃',
    definition: 'to gather, to sort',
    pinyin: ['jùn'],
    decomposition: '⿰扌君',
    etymology: {
      type: 'pictophonetic',
      phonetic: '君',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '捅',
    definition: 'to jab, to poke',
    pinyin: ['tǒng'],
    decomposition: '⿰扌甬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甬',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '捆',
    definition: 'to bind, to tie, to truss up; a bundle',
    pinyin: ['kǔn'],
    decomposition: '⿰扌困',
    etymology: {
      type: 'pictophonetic',
      phonetic: '困',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '捉',
    definition: 'to clutch, to grasp, to seize',
    pinyin: ['zhuō'],
    decomposition: '⿰扌足',
    etymology: {
      type: 'pictophonetic',
      phonetic: '足',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '捋',
    definition: 'to gather, to pluck; to rub off, to scrape',
    pinyin: ['lǚ'],
    decomposition: '⿰扌寽',
    etymology: {
      type: 'ideographic',
      hint: 'To take 扌 a handful 寽; 寽 also provides the pronunciation',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '捌',
    definition: "to split, to break open; eight (bankers' anti-fraud numeral)",
    pinyin: ['bā'],
    decomposition: '⿰扌别',
    etymology: {
      type: 'ideographic',
      hint: 'To separate 别 by hand 扌; 别 also provides the pronunciation',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '捍',
    definition: 'to defend, to guard; to ward off',
    pinyin: ['hàn'],
    decomposition: '⿰扌旱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旱',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '捎',
    definition: 'to carry, to take; to select',
    pinyin: ['shāo'],
    decomposition: '⿰扌肖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肖',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '捏',
    definition: 'to knead, to mold, to pinch',
    pinyin: ['niē'],
    decomposition: '⿰扌圼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '圼',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '捐',
    definition: 'to give, to donate; to give up, to renounce',
    pinyin: ['juān'],
    decomposition: '⿰扌肙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肙',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '捕',
    definition: 'to arrest, to catch, to seize',
    pinyin: ['bǔ'],
    decomposition: '⿰扌甫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甫',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '捞',
    definition: 'to dredge up; to fish for; to scoop out of the water',
    pinyin: ['lāo'],
    decomposition: '⿰扌劳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '劳',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '损',
    definition: 'to damage, to harm',
    pinyin: ['sǔn'],
    decomposition: '⿰扌员',
    etymology: {
      type: 'pictophonetic',
      phonetic: '员',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '捡',
    definition: 'to pick up, to gather, to collect',
    pinyin: ['jiǎn'],
    decomposition: '⿰扌佥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '佥',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '换',
    definition: 'to change; to exchange, to swap, to trade',
    pinyin: ['huàn'],
    decomposition: '⿰扌奂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奂',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '捣',
    definition: 'to thresh, to pound; to stir, to disturb; to attack',
    pinyin: ['dǎo'],
    decomposition: '⿰扌岛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '岛',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '捧',
    definition: 'to hold or offer with both hands',
    pinyin: ['pěng'],
    decomposition: '⿰扌奉',
    etymology: {
      type: 'ideographic',
      hint: 'An offering 奉 made with two hands 扌; 奉 also provides the pronunciation',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '捨',
    definition: 'house, dwelling; to reside, to dwell; to abandon, to give up',
    pinyin: ['shě'],
    decomposition: '⿰扌舍',
    etymology: {
      type: 'pictophonetic',
      semantic: '舍',
      hint: 'house',
      phonetic: '扌',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '捩',
    definition: 'to twist, to tear, to snap',
    pinyin: ['liè'],
    decomposition: '⿰扌戾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戾',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '捭',
    definition: 'to open up, to spread out',
    pinyin: ['bǎi'],
    decomposition: '⿰扌卑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卑',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '据',
    definition: 'to possess, to occupy; position; base',
    pinyin: ['jù'],
    decomposition: '⿰扌居',
    etymology: {
      type: 'pictophonetic',
      phonetic: '居',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '捱',
    definition: 'to put off, to procrastinate; to endure',
    pinyin: ['ái'],
    decomposition: '⿰扌厓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厓',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '捶',
    definition: 'to beat, to lash, to strike with a cane',
    pinyin: ['chuí'],
    decomposition: '⿰扌垂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '垂',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '捷',
    definition: 'nimble, quick; triumph, victory',
    pinyin: ['jié'],
    decomposition: '⿰扌疌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '疌',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '捺',
    definition: 'to press down firmly with the fingers',
    pinyin: ['nà'],
    decomposition: '⿰扌奈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奈',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '捻',
    definition: 'to twist or nip with the fingers',
    pinyin: ['niǎn'],
    decomposition: '⿰扌念',
    etymology: {
      type: 'pictophonetic',
      phonetic: '念',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '掀',
    definition: 'to stir up; to turn over',
    pinyin: ['xiān'],
    decomposition: '⿰扌欣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '欣',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '掂',
    definition: 'to heft, to weigh; to hold in the palm',
    pinyin: ['diān'],
    decomposition: '⿰扌店',
    etymology: {
      type: 'pictophonetic',
      phonetic: '店',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '掃',
    definition: 'to clean, to sweep, to wipe away; to weed out; to wipe out',
    pinyin: ['sǎo'],
    decomposition: '⿰扌帚',
    etymology: {
      type: 'ideographic',
      hint: 'To use 扌 a broom 帚; 帚 also provides the pronunciation',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '掄',
    definition: 'to swing, to flourish, to brandish',
    pinyin: ['lūn'],
    decomposition: '⿰扌侖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '侖',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '掇',
    definition: 'to pick up, to gather, to collect',
    pinyin: ['duō'],
    decomposition: '⿰扌叕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叕',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '授',
    definition: 'to award, to confer, to instruct, to teach',
    pinyin: ['shòu'],
    decomposition: '⿰扌受',
    etymology: {
      type: 'pictophonetic',
      phonetic: '受',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '掉',
    definition: 'to drop, to fall, to remove',
    pinyin: ['diào'],
    decomposition: '⿰扌卓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卓',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '掊',
    definition: 'to extract; to injure',
    pinyin: ['póu'],
    decomposition: '⿰扌咅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咅',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '掌',
    definition: 'in charge; the palm of the hand, the sole of the foot',
    pinyin: ['zhǎng'],
    decomposition: '⿱尚手',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尚',
      semantic: '手',
      hint: 'hand',
    },
    radical: '手',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '掎',
    definition: "to pull, to drag; to drag one's feet",
    pinyin: ['jǐ'],
    decomposition: '⿰扌奇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奇',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '掏',
    definition: 'to take out; to pull out; to clean out',
    pinyin: ['tāo'],
    decomposition: '⿰扌匋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匋',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '掐',
    definition: 'to hold, to choke; to gather in one hand',
    pinyin: ['qiā'],
    decomposition: '⿰扌臽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臽',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '排',
    definition: 'row, rank, file; to eliminate, to remove',
    pinyin: ['pái'],
    decomposition: '⿰扌非',
    etymology: {
      type: 'pictophonetic',
      phonetic: '非',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '掖',
    definition: 'to tuck, to fold; to support',
    pinyin: ['yē'],
    decomposition: '⿰扌夜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夜',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '掘',
    definition: 'to dig, to excavate',
    pinyin: ['jué'],
    decomposition: '⿰扌屈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屈',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '掙',
    definition: 'to struggle, to strive, to endeavor',
    pinyin: ['zhēng'],
    decomposition: '⿰扌爭',
    etymology: {
      type: 'ideographic',
      hint: 'To fight 爭 by hand 扌; 爭 also provides the pronunciation',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '掛',
    definition: 'to suspend, to put up, to hang; suspense',
    pinyin: ['guà'],
    decomposition: '⿰扌卦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卦',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '掠',
    definition: 'to pillage, to ransack',
    pinyin: ['lüè'],
    decomposition: '⿰扌京',
    etymology: {
      type: 'pictophonetic',
      phonetic: '京',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '採',
    definition: 'to collect, to gather; to pick, to pluck',
    pinyin: ['cǎi'],
    decomposition: '⿰扌采',
    etymology: {
      type: 'pictophonetic',
      phonetic: '采',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '探',
    definition: 'to find, to locate; to grope for, to search for',
    pinyin: ['tàn'],
    decomposition: '⿰扌⿱？木',
    etymology: { type: 'pictophonetic', semantic: '扌', hint: 'hand' },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      null,
      null,
      null,
      null,
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '掣',
    definition: 'to pull, to drag; to hinder, to pull back',
    pinyin: ['chè'],
    decomposition: '⿱制手',
    etymology: {
      type: 'pictophonetic',
      phonetic: '制',
      semantic: '手',
      hint: 'hand',
    },
    radical: '手',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '接',
    definition: 'to connect, to join; to receive, to meet, to answer the phone',
    pinyin: ['jiē'],
    decomposition: '⿰扌妾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '妾',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '控',
    definition: 'to accuse, to charge; to control; to sue',
    pinyin: ['kòng'],
    decomposition: '⿰扌空',
    etymology: {
      type: 'pictophonetic',
      phonetic: '空',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '推',
    definition: 'to push; to expel; to drive; to decline',
    pinyin: ['tuī'],
    decomposition: '⿰扌隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隹',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '掩',
    definition: 'to cover up (with a hand); to ambush, to conceal; to shut',
    pinyin: ['yǎn'],
    decomposition: '⿰扌奄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奄',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '措',
    definition: 'to arrange; to execute on; to manage',
    pinyin: ['cuò'],
    decomposition: '⿰扌昔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昔',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '掬',
    definition: 'to grasp or hold with both hands',
    pinyin: ['jū'],
    decomposition: '⿰扌匊',
    etymology: {
      type: 'ideographic',
      hint: 'To take 扌a handful 匊; 匊 also provides the pronunciation',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '掭',
    definition: 'to manipulate',
    pinyin: ['tiàn'],
    decomposition: '⿰扌忝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '忝',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '掮',
    definition: 'to bear on the shoulders',
    pinyin: ['qián'],
    decomposition: '⿰扌肩',
    etymology: {
      type: 'ideographic',
      hint: 'To bear 扌 on the shoulders 肩; 肩 also provides the pronunciation',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '掰',
    definition: 'to rip, to tear',
    pinyin: ['bāi'],
    decomposition: '⿲手分手',
    etymology: {
      type: 'ideographic',
      hint: 'To tear something 分 with both hands 手',
    },
    radical: '手',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [2], [2], [2], [2]],
  },
  {
    character: '掱',
    definition: 'to pickpocket',
    pinyin: ['pá'],
    decomposition: '⿱手⿰手手',
    etymology: {
      type: 'ideographic',
      hint: 'Someone with three hands 手, representing sleight-of-hand',
    },
    radical: '手',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '掳',
    definition: 'to capture, to seize',
    pinyin: ['lǔ'],
    decomposition: '⿰扌虏',
    etymology: {
      type: 'ideographic',
      hint: 'To catch 虏 someone by the hand 扌; 虏 also provides the pronunciation',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '掴',
    definition: "to slap, to box one's ears",
    pinyin: ['guāi'],
    decomposition: '⿰扌国',
    etymology: {
      type: 'pictophonetic',
      phonetic: '国',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '掷',
    definition: 'to throw, to hurl, to fling, to cast',
    pinyin: ['zhì'],
    decomposition: '⿰扌郑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '郑',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '掸',
    definition: 'to dust; a duster',
    pinyin: ['dǎn'],
    decomposition: '⿰扌单',
    etymology: {
      type: 'pictophonetic',
      phonetic: '单',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '掺',
    definition: 'to mix, to blend, to adulterate',
    pinyin: ['càn'],
    decomposition: '⿰扌参',
    etymology: {
      type: 'pictophonetic',
      phonetic: '参',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '掼',
    definition: 'to fling, to smash; to know, to be familiar',
    pinyin: ['guàn'],
    decomposition: '⿰扌贯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贯',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '掾',
    definition: 'a general designation of officials',
    pinyin: ['yuàn'],
    decomposition: '⿰扌彖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彖',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '揀',
    definition: 'to choose, to select; to gather, to pick up',
    pinyin: ['jiǎn'],
    decomposition: '⿰扌柬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '柬',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '揄',
    definition: 'to lift, to raise; to praise; to hang, to flap',
    pinyin: ['yú'],
    decomposition: '⿰扌俞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '俞',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '揆',
    definition: 'to consider, to estimate',
    pinyin: ['kuí'],
    decomposition: '⿰扌癸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '癸',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '揉',
    definition: 'to massage, to knead; to crush by hand',
    pinyin: ['róu'],
    decomposition: '⿰扌柔',
    etymology: {
      type: 'ideographic',
      hint: 'A gentle 柔 hand 扌; 柔 also provides the pronunciation',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '揍',
    definition: 'to hit, to beat; to smash, to break',
    pinyin: ['zòu'],
    decomposition: '⿰扌奏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奏',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '揎',
    definition: "to pull up one's sleeves; to prepare to fight",
    pinyin: ['xuān'],
    decomposition: '⿰扌宣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宣',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '描',
    definition: 'to copy, to depict, to sketch, to trace',
    pinyin: ['miáo'],
    decomposition: '⿰扌苗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '苗',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '提',
    definition: 'to hold in the hand; to lift, to raise',
    pinyin: ['tí'],
    decomposition: '⿰扌是',
    etymology: {
      type: 'pictophonetic',
      phonetic: '是',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '插',
    definition: 'to insert, to stick in; to pierce; to plant',
    pinyin: ['chā'],
    decomposition: '⿰扌臿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臿',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '揖',
    definition: 'to bow, to salute; to defer, to yield',
    pinyin: ['yī'],
    decomposition: '⿰扌咠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咠',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '揚',
    definition: 'to flutter, to wave; to hoist, to raise; to praise',
    pinyin: ['yáng'],
    decomposition: '⿰扌昜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昜',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '換',
    definition: 'to change; to exchange, to swap, to trade',
    pinyin: ['huàn'],
    decomposition: '⿰扌奐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奐',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '揞',
    definition: 'to cover, to conceal; to apply medicine or make-up',
    pinyin: ['ǎn'],
    decomposition: '⿰扌音',
    etymology: {
      type: 'pictophonetic',
      phonetic: '音',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '揠',
    definition: 'to weed out, to pull up, to eradicate',
    pinyin: ['yà'],
    decomposition: '⿰扌匽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匽',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '握',
    definition: 'to grasp, to hold, to take by the hand',
    pinyin: ['wò'],
    decomposition: '⿰扌屋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屋',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '揣',
    definition: "to stow in one's clothes; to estimate, to guess, to figure",
    pinyin: ['chuāi'],
    decomposition: '⿰扌耑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '耑',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '揩',
    definition: 'to wipe, to rub, to dust, to clean',
    pinyin: ['kāi'],
    decomposition: '⿰扌皆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皆',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '揪',
    definition: 'to pinch, to grasp',
    pinyin: ['jiū'],
    decomposition: '⿰扌秋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '秋',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '揭',
    definition: 'to lift off a cover; to reveal, to divulge; surname',
    pinyin: ['jiē'],
    decomposition: '⿰扌曷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曷',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '揮',
    definition: 'to direct; to squander; to wave; to wipe away',
    pinyin: ['huī'],
    decomposition: '⿰扌軍',
    etymology: { type: 'ideographic', hint: 'To direct an army 軍 by hand 扌' },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '揲',
    definition: 'to sort out divining stalks',
    pinyin: ['dié'],
    decomposition: '⿰扌枼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '枼',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '援',
    definition: 'to assist; to lead; to quote, to cite',
    pinyin: ['yuán'],
    decomposition: '⿰扌爰',
    etymology: {
      type: 'ideographic',
      hint: 'To lead 爰 by hand 扌; 爰 also provides the pronunciation',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '揶',
    definition: 'to ridicule, to poke fun at',
    pinyin: ['yé'],
    decomposition: '⿰扌耶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '耶',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '揸',
    definition: 'handful; to grasp, to seize',
    pinyin: ['zhā'],
    decomposition: '⿰扌查',
    etymology: {
      type: 'pictophonetic',
      phonetic: '查',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '揽',
    definition: 'to grasp; to monopolize; to seize',
    pinyin: ['lǎn'],
    decomposition: '⿰扌览',
    etymology: {
      type: 'pictophonetic',
      phonetic: '览',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '揿',
    definition: 'to press',
    pinyin: ['qìn'],
    decomposition: '⿰扌钦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '钦',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '搀',
    definition: 'to mix; to support, to sustain, to lend a hand',
    pinyin: ['chān'],
    decomposition: '⿰扌⿱免⺀',
    etymology: { type: 'pictophonetic', semantic: '扌', hint: 'hand' },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '搁',
    definition: 'to place, to lay down; to delay',
    pinyin: ['gē'],
    decomposition: '⿰扌阁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '阁',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '搂',
    definition: 'to embrace, to hug; to drag, to pull',
    pinyin: ['lǒu'],
    decomposition: '⿰扌娄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '娄',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '搅',
    definition: 'to annoy, to disturb, to stir up',
    pinyin: ['jiǎo'],
    decomposition: '⿰扌觉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '觉',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '搋',
    definition: 'to thump',
    pinyin: ['chuāi'],
    decomposition: '⿰扌虒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '虒',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '搌',
    definition: 'to dab, to sop up, to wipe away tears',
    pinyin: ['zhǎn'],
    decomposition: '⿰扌展',
    etymology: {
      type: 'pictophonetic',
      phonetic: '展',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '損',
    definition: 'to damage, to harm',
    pinyin: ['sǔn'],
    decomposition: '⿰扌員',
    etymology: {
      type: 'pictophonetic',
      phonetic: '員',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '搏',
    definition: 'combat; to fight; to strike',
    pinyin: ['bó'],
    decomposition: '⿰扌尃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尃',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '搐',
    definition: 'cramp, spasm; to convulse, to twitch',
    pinyin: ['chù'],
    decomposition: '⿰扌畜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畜',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '搓',
    definition: 'to rub or roll between the hands',
    pinyin: ['cuō'],
    decomposition: '⿰扌差',
    etymology: {
      type: 'pictophonetic',
      phonetic: '差',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '搔',
    definition: 'to scratch',
    pinyin: ['sāo'],
    decomposition: '⿰扌蚤',
    etymology: {
      type: 'ideographic',
      hint: 'To scratch 扌 a flea bite 蚤; 蚤 also provides the pronunciation',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '搖',
    definition: 'to rock, to shake; to swing, to wave',
    pinyin: ['yáo'],
    decomposition: '⿰扌䍃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '䍃',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '搗',
    definition: 'to thresh, to pound; to stir, to disturb; to attack',
    pinyin: ['dǎo'],
    decomposition: '⿰扌島',
    etymology: {
      type: 'pictophonetic',
      phonetic: '島',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '搛',
    definition: 'to pick up with chopsticks',
    pinyin: ['jiān'],
    decomposition: '⿰扌兼',
    etymology: {
      type: 'ideographic',
      hint: 'To grip 扌with chopsticks 兼; 兼 also provides the pronunciation',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '搜',
    definition: 'to seek, to search, to investigate',
    pinyin: ['sōu'],
    decomposition: '⿰扌叟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叟',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '搞',
    definition: 'to do, to fix, to make, to settle',
    pinyin: ['gǎo'],
    decomposition: '⿰扌高',
    etymology: {
      type: 'pictophonetic',
      phonetic: '高',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '搠',
    definition: 'to daub; to thrust',
    pinyin: ['shuò'],
    decomposition: '⿰扌朔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朔',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '搡',
    definition: 'to push over; to push back',
    pinyin: ['sǎng'],
    decomposition: '⿰扌桑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '桑',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '搦',
    definition: 'to grasp, to seize; to challenge, to provoke',
    pinyin: ['nuò'],
    decomposition: '⿰扌弱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弱',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '搪',
    definition: 'to parry, to block; to ward off, to evade',
    pinyin: ['táng'],
    decomposition: '⿰扌唐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '唐',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '搬',
    definition: 'to move, to remove, to shift, to transfer',
    pinyin: ['bān'],
    decomposition: '⿰扌般',
    etymology: {
      type: 'pictophonetic',
      phonetic: '般',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '搭',
    definition: 'to attach, to build, to join',
    pinyin: ['dā'],
    decomposition: '⿰扌荅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '荅',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '搴',
    definition: 'to extract; to pluck; to seize',
    pinyin: ['qiān'],
    decomposition: '⿱？手',
    etymology: { type: 'pictophonetic', semantic: '手', hint: 'hand' },
    radical: '手',
    matches: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '搶',
    definition: 'urgent, rushed; to rob, to plunder',
    pinyin: ['qiǎng'],
    decomposition: '⿰扌倉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '倉',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '携',
    definition: 'to carry, to lead, to take by the hand',
    pinyin: ['xié'],
    decomposition: '⿰扌隽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隽',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '搽',
    definition: 'to wipe, to smear, to rub, to anoint',
    pinyin: ['chá'],
    decomposition: '⿰扌茶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '茶',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '搿',
    definition: 'to hug',
    pinyin: ['gé'],
    decomposition: '⿲手合手',
    etymology: { type: 'ideographic', hint: 'To clasp 合 with both hands 手' },
    radical: '手',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '摀',
    definition: 'to conceal, to hide; to cover with a hand',
    pinyin: ['wǔ'],
    decomposition: '⿰扌烏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '烏',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '摁',
    definition: 'to press with a finger',
    pinyin: ['èn'],
    decomposition: '⿰扌恩',
    etymology: {
      type: 'pictophonetic',
      phonetic: '恩',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '摄',
    definition: 'to absorb, to take in; to photograph; to act on behalf of',
    pinyin: ['shè'],
    decomposition: '⿰扌聂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '聂',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '摅',
    definition: 'to disperse, to spread, to vent; to send forth',
    pinyin: ['shū'],
    decomposition: '⿰扌虑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '虑',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '摆',
    definition: 'to arrange, to display; pendulum, swing',
    pinyin: ['bǎi'],
    decomposition: '⿰扌罢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '罢',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '摇',
    definition: 'to rock, to shake; to swing, to wave',
    pinyin: ['yáo'],
    decomposition: '⿰扌䍃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '䍃',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '摈',
    definition: 'to exclude, to expel, to reject; to usher',
    pinyin: ['bìn'],
    decomposition: '⿰扌宾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宾',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '摊',
    definition: "to spread out, to open, to allot; a merchant's stand",
    pinyin: ['tān'],
    decomposition: '⿰扌难',
    etymology: {
      type: 'pictophonetic',
      phonetic: '难',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '摑',
    definition: "to slap, to box one's ears",
    pinyin: ['guāi'],
    decomposition: '⿰扌國',
    etymology: {
      type: 'pictophonetic',
      phonetic: '國',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '摒',
    definition: 'to expel, to cast off; to arrange',
    pinyin: ['bǐng'],
    decomposition: '⿰扌屏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屏',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '摔',
    definition: 'to fall, to stumble, to trip',
    pinyin: ['shuāi'],
    decomposition: '⿰扌率',
    etymology: {
      type: 'pictophonetic',
      phonetic: '率',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '摘',
    definition: 'to pick, to pluck, to select, to take',
    pinyin: ['zhāi'],
    decomposition: '⿰扌啇',
    etymology: {
      type: 'ideographic',
      hint: 'To pick 扌 a fruit off a branch 啇',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '摞',
    definition: 'to pile up',
    pinyin: ['luò'],
    decomposition: '⿰扌累',
    etymology: {
      type: 'ideographic',
      hint: 'To pile up 累 by hand 扌; 累 also provides the pronunciation',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '摟',
    definition: 'to embrace, to hug; to drag, to pull',
    pinyin: ['lǒu'],
    decomposition: '⿰扌婁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '婁',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '摧',
    definition: 'to destroy, to wreck',
    pinyin: ['cuī'],
    decomposition: '⿰扌崔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '崔',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '摩',
    definition: 'to scour, to rub, to grind; friction',
    pinyin: ['mó'],
    decomposition: '⿸麻手',
    etymology: {
      type: 'pictophonetic',
      phonetic: '麻',
      semantic: '手',
      hint: 'hand',
    },
    radical: '手',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '摭',
    definition: 'to gather, to pick up',
    pinyin: ['zhí'],
    decomposition: '⿰扌庶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '庶',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '摯',
    definition: 'sincere, warm, cordial; surname',
    pinyin: ['zhì'],
    decomposition: '⿱執手',
    etymology: {
      type: 'ideographic',
      hint: 'To shake 執 hands 手; 執 also provides the pronunciation',
    },
    radical: '手',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '摳',
    definition: 'to lift, to raise; tight-fisted',
    pinyin: ['kōu'],
    decomposition: '⿰扌區',
    etymology: {
      type: 'pictophonetic',
      phonetic: '區',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '摶',
    definition: "to roll around in one's hand; to model",
    pinyin: ['tuán'],
    decomposition: '⿰扌專',
    etymology: {
      type: 'pictophonetic',
      phonetic: '專',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '摸',
    definition: 'to caress, to stroke, to gently touch',
    pinyin: ['mō'],
    decomposition: '⿰扌莫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '莫',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '摹',
    definition: 'to trace; to imitate, to copy; pattern',
    pinyin: ['mó'],
    decomposition: '⿱莫手',
    etymology: {
      type: 'pictophonetic',
      phonetic: '莫',
      semantic: '手',
      hint: 'hand',
    },
    radical: '手',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '摺',
    definition: 'to bend, to fold; curved, twisted',
    pinyin: ['zhé'],
    decomposition: '⿰扌習',
    etymology: {
      type: 'ideographic',
      hint: 'Skill 習 in paper-folding扌 ; 習 also provides the pronunciation',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '摻',
    definition: 'to mix, to blend, to adulterate',
    pinyin: ['càn'],
    decomposition: '⿰扌參',
    etymology: {
      type: 'pictophonetic',
      phonetic: '參',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '摽',
    definition: 'to sign, to signal; to throw',
    pinyin: ['biāo'],
    decomposition: '⿰扌票',
    etymology: {
      type: 'pictophonetic',
      phonetic: '票',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '撂',
    definition: 'to put down, to put aside, to drop',
    pinyin: ['liào'],
    decomposition: '⿰扌畧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畧',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '撄',
    definition: 'to offend, to oppose, to run counter to',
    pinyin: ['yīng'],
    decomposition: '⿰扌婴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '婴',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '撅',
    definition: 'to snap, to break; to protrude; to pout',
    pinyin: ['juē'],
    decomposition: '⿰扌厥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厥',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '撇',
    definition: 'to abandon, to discard',
    pinyin: ['piē'],
    decomposition: '⿰扌敝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敝',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '撈',
    definition: 'to dredge up; to fish for; to scoop out of the water',
    pinyin: ['lāo'],
    decomposition: '⿰扌勞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '勞',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '撐',
    definition: 'to support, to prop up, to brace; overflowing',
    pinyin: ['chēng'],
    decomposition: '⿰扌牚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '牚',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '撑',
    definition: 'to support, to prop up, to brace; overflowing',
    pinyin: ['chēng'],
    decomposition: '⿰扌掌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '掌',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '撒',
    definition: 'to disperse, to let go, to relax',
    pinyin: ['sā'],
    decomposition: '⿰扌散',
    etymology: {
      type: 'ideographic',
      hint: 'To scatter 散 seeds by hand 扌; 散 also provides the pronunciation',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '撓',
    definition: 'to yield; to scratch, to disturb',
    pinyin: ['náo'],
    decomposition: '⿰扌堯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堯',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '撕',
    definition: 'to rip, to tear; to buy cloth',
    pinyin: ['sī'],
    decomposition: '⿰扌斯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斯',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '撖',
    pinyin: ['hàn'],
    decomposition: '⿰扌敢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敢',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '撙',
    definition: 'to cut down, to reduce, to regulate; to rein in spending',
    pinyin: ['zǔn'],
    decomposition: '⿰扌尊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尊',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '撞',
    definition: 'to bump into, to collide, to hit, to knock against',
    pinyin: ['zhuàng'],
    decomposition: '⿰扌童',
    etymology: {
      type: 'pictophonetic',
      phonetic: '童',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '撣',
    definition: 'to dust; a duster',
    pinyin: ['dǎn'],
    decomposition: '⿰扌單',
    etymology: {
      type: 'pictophonetic',
      phonetic: '單',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '撤',
    definition: 'to omit; to remove; to withdraw',
    pinyin: ['chè'],
    decomposition: '⿲扌育攵',
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '撥',
    definition: 'to stir, to move, to distribute, to allocate',
    pinyin: ['bō'],
    decomposition: '⿰扌發',
    etymology: { type: 'ideographic', hint: 'To dispatch 發 goods by hand 扌' },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '撩',
    definition:
      'to lift, to raise; to provoke, to tease; to push aside clothing',
    pinyin: ['liāo'],
    decomposition: '⿰扌尞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尞',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '撫',
    definition: 'to pat, to console; to stroke, to caress',
    pinyin: ['fǔ'],
    decomposition: '⿰扌無',
    etymology: {
      type: 'pictophonetic',
      phonetic: '無',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '撬',
    definition: 'to lift, to raise, to pry off a lid',
    pinyin: ['qiào'],
    decomposition: '⿰扌毳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '毳',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '播',
    definition: 'to sow seeds, to scatter; to broadcast, to spread',
    pinyin: ['bō'],
    decomposition: '⿰扌番',
    etymology: {
      type: 'ideographic',
      hint: 'To sow seeds 番 by hand 扌; 番 also provides the pronunciation',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '撮',
    definition: 'dash, pinch, small amount',
    pinyin: ['cuō'],
    decomposition: '⿰扌最',
    etymology: {
      type: 'pictophonetic',
      phonetic: '最',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '撰',
    definition: 'to compose, to write',
    pinyin: ['zhuàn'],
    decomposition: '⿰扌巽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巽',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '撲',
    definition: 'to attack, to beat, to hit, to strike',
    pinyin: ['pū'],
    decomposition: '⿰扌菐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '菐',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '撵',
    definition: 'to drive away, to expel, to oust',
    pinyin: ['niǎn'],
    decomposition: '⿰扌辇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辇',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '撷',
    definition: "to pick up, to gather, to acquire; to hold in one's lap",
    pinyin: ['xié'],
    decomposition: '⿰扌颉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '颉',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '撸',
    definition: 'to reprimand; to fire an employee',
    pinyin: ['lū'],
    decomposition: '⿰扌鲁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鲁',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '撺',
    definition: 'rush, hurry; to stir up, to urge; to fling, to throw',
    pinyin: ['cuān'],
    decomposition: '⿰扌窜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '窜',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '撻',
    definition: 'to whip, to flog, to chastise',
    pinyin: ['tà'],
    decomposition: '⿰扌達',
    etymology: {
      type: 'pictophonetic',
      phonetic: '達',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '撼',
    definition: 'to incite, to move, to shake',
    pinyin: ['hàn'],
    decomposition: '⿰扌感',
    etymology: {
      type: 'pictophonetic',
      phonetic: '感',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '撾',
    definition: 'to beat; to strike',
    pinyin: ['wō'],
    decomposition: '⿰扌過',
    etymology: {
      type: 'pictophonetic',
      phonetic: '過',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '撿',
    definition: 'to pick up, to gather, to collect',
    pinyin: ['jiǎn'],
    decomposition: '⿰扌僉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '僉',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擀',
    definition: 'to roll or knead dough',
    pinyin: ['gǎn'],
    decomposition: '⿰扌幹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '幹',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擁',
    definition: 'to have, to hold; to embrace, to hug; to flock, to throng',
    pinyin: ['yōng'],
    decomposition: '⿰扌雍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '雍',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擂',
    definition: 'to rub, to grind; to use a mortar and pestle',
    pinyin: ['léi'],
    decomposition: '⿰扌雷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '雷',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擄',
    definition: 'to capture, to seize',
    pinyin: ['lǔ'],
    decomposition: '⿰扌虜',
    etymology: {
      type: 'ideographic',
      hint: 'To catch 虜 someone by the hand 扌; 虜 also provides the pronunciation',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擅',
    definition: 'to claim, to monopolize; arbitrary',
    pinyin: ['shàn'],
    decomposition: '⿰扌亶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亶',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擇',
    definition: 'to select, to choose',
    pinyin: ['zé'],
    decomposition: '⿰扌睪',
    etymology: {
      type: 'pictophonetic',
      phonetic: '睪',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擊',
    definition: 'to strike, to hit, to beat; to attack, to fight',
    pinyin: ['jī'],
    decomposition: '⿱毄手',
    etymology: {
      type: 'ideographic',
      hint: 'To strike 毄 with a hand 手; 毄 also provides the pronunciation',
    },
    radical: '手',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擋',
    definition: 'to block, to obstruct; to get in the way; cover, guard',
    pinyin: ['dǎng'],
    decomposition: '⿰扌當',
    etymology: {
      type: 'ideographic',
      hint: 'A hand 扌 raised at the right time 當; 當 also provides the pronunciation',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '操',
    definition: 'to conduct, to manage, to run',
    pinyin: ['cāo'],
    decomposition: '⿰扌喿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '喿',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擎',
    definition: 'to lift; to support, to hold up',
    pinyin: ['qíng'],
    decomposition: '⿱敬手',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敬',
      semantic: '手',
      hint: 'hand',
    },
    radical: '手',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擐',
    definition: 'to wear, to put on armor',
    pinyin: ['huàn'],
    decomposition: '⿰扌睘',
    etymology: {
      type: 'ideographic',
      hint: 'To don 扌 clothes 衣; 睘 also provides the pronunciation',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擒',
    definition: 'to arrest, to capture, to seize',
    pinyin: ['qín'],
    decomposition: '⿰扌禽',
    etymology: {
      type: 'ideographic',
      hint: 'To catch 禽 by hand 扌; 禽 also provides the pronunciation',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擔',
    definition: 'to bear, to carry; burden, responsibility',
    pinyin: ['dān'],
    decomposition: '⿰扌詹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '詹',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擗',
    definition: 'to beat the breast',
    pinyin: ['pǐ'],
    decomposition: '⿰扌辟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辟',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擘',
    definition: 'thumb; to rip, to tear; to split, to analyze',
    pinyin: ['bāi'],
    decomposition: '⿱辟手',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辟',
      semantic: '手',
      hint: 'hand',
    },
    radical: '手',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '據',
    definition: 'to possess, to occupy; position; base',
    pinyin: ['jù'],
    decomposition: '⿰扌豦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豦',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擞',
    definition: 'to tremble, to shake, to quake, to flutter',
    pinyin: ['sǒu'],
    decomposition: '⿰扌数',
    etymology: {
      type: 'pictophonetic',
      phonetic: '数',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擠',
    definition: 'to squeeze, to push against; crowded',
    pinyin: ['jǐ'],
    decomposition: '⿰扌齊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '齊',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擡',
    definition: 'to raise, to lift, to carry',
    pinyin: ['tái'],
    decomposition: '⿰扌臺',
    etymology: {
      type: 'ideographic',
      hint: 'To lift 扌 up high 臺; 臺 also provides the pronunciation',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擢',
    definition: 'to pull up, to raise; to select',
    pinyin: ['zhuó'],
    decomposition: '⿰扌翟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隹',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擤',
    definition: 'to blow the nose with fingers',
    pinyin: ['xǐng'],
    decomposition: '⿰扌鼻',
    etymology: {
      type: 'ideographic',
      hint: 'To use a hand 扌 to blow the nose 鼻',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擦',
    definition: 'to clean, to erase, to polish; a brush',
    pinyin: ['cā'],
    decomposition: '⿰扌察',
    etymology: {
      type: 'pictophonetic',
      phonetic: '察',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擬',
    definition: 'to draft, to plan; to intend',
    pinyin: ['nǐ'],
    decomposition: '⿰扌疑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '疑',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擯',
    definition: 'to exclude, to expel, to reject; to usher',
    pinyin: ['bìn'],
    decomposition: '⿰扌賓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '賓',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擰',
    definition: 'screw, wrench; to pinch, to twist, to wring',
    pinyin: ['níng'],
    decomposition: '⿰扌寧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寧',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擱',
    definition: 'to place, to lay down; to delay',
    pinyin: ['gē'],
    decomposition: '⿰扌閣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '閣',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擲',
    definition: 'to throw, to hurl, to fling, to cast',
    pinyin: ['zhì'],
    decomposition: '⿰扌鄭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鄭',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擴',
    definition: 'to expand, to stretch, to magnify',
    pinyin: ['kuò'],
    decomposition: '⿰扌廣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '扌',
      semantic: '廣',
      hint: 'wide',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擷',
    definition: "to pick up, to gather, to acquire; to hold in one's lap",
    pinyin: ['xié'],
    decomposition: '⿰扌頡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '頡',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擺',
    definition: 'to arrange, to display; pendulum, swing',
    pinyin: ['bǎi'],
    decomposition: '⿰扌罷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '罷',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擻',
    definition: 'to tremble, to shake, to quake, to flutter',
    pinyin: ['sǒu'],
    decomposition: '⿰扌數',
    etymology: {
      type: 'pictophonetic',
      phonetic: '數',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擼',
    definition: 'to reprimand; to fire an employee',
    pinyin: ['lū'],
    decomposition: '⿰扌魯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '魯',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擾',
    definition: 'to poke, to disturb, to annoy, to agitate',
    pinyin: ['rǎo'],
    decomposition: '⿰扌憂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '憂',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '擿',
    definition: 'to select, to pick out; to discard',
    pinyin: ['tī'],
    decomposition: '⿰扌適',
    etymology: {
      type: 'ideographic',
      hint: 'To select 扌 a match 適; 適 also provides the pronunciation',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '攀',
    definition: 'to climb, to hang on, to pull up',
    pinyin: ['pān'],
    decomposition: '⿱樊手',
    etymology: {
      type: 'pictophonetic',
      phonetic: '樊',
      semantic: '手',
      hint: 'hand',
    },
    radical: '手',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '攆',
    definition: 'to drive away, to expel, to oust',
    pinyin: ['niǎn'],
    decomposition: '⿰扌輦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '輦',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '攉',
    definition: 'to urge, to beckon',
    pinyin: ['huō'],
    decomposition: '⿰扌霍',
    etymology: {
      type: 'ideographic',
      hint: 'To motion 霍 with the hand 扌; 霍 also provides the pronunciation',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '攏',
    definition: 'to collect, to bring together',
    pinyin: ['lǒng'],
    decomposition: '⿰扌龍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龍',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '攒',
    definition: 'to save, to hoard',
    pinyin: ['zǎn'],
    decomposition: '⿰扌赞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '赞',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '攔',
    definition: 'to block, to hinder, to obstruct',
    pinyin: ['lán'],
    decomposition: '⿰扌闌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '闌',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '攘',
    definition: 'to usurp, to seize; to repel',
    pinyin: ['rǎng'],
    decomposition: '⿰扌襄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '襄',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '攙',
    definition: 'to mix; to support, to sustain, to lend a hand',
    pinyin: ['chān'],
    decomposition: '⿰扌毚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '毚',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '攛',
    definition: 'rush, hurry; to stir up, to urge; to fling, to throw',
    pinyin: ['cuān'],
    decomposition: '⿰扌竄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '竄',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '攜',
    definition: 'to carry, to lead, to take by the hand',
    pinyin: ['xié'],
    decomposition: '⿰扌巂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巂',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '攝',
    definition: 'to absorb, to take in; to photograph; to act on behalf of',
    pinyin: ['shè'],
    decomposition: '⿰扌聶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '聶',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '攢',
    definition: 'to save, to hoard',
    pinyin: ['zǎn'],
    decomposition: '⿰扌贊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贊',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '攣',
    definition: 'tangled, entwined; crooked',
    pinyin: ['luán'],
    decomposition: '⿱䜌手',
    etymology: {
      type: 'pictophonetic',
      semantic: '手',
      hint: 'hand',
      phonetic: '䜌',
    },
    radical: '手',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '攤',
    definition: "to spread out, to open, to allot; a merchant's stand",
    pinyin: ['tān'],
    decomposition: '⿰扌難',
    etymology: {
      type: 'pictophonetic',
      phonetic: '難',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '攥',
    definition: 'to hold, to grip, to grasp',
    pinyin: ['zuàn'],
    decomposition: '⿰扌纂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '纂',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '攪',
    definition: 'to annoy, to disturb, to stir up',
    pinyin: ['jiǎo'],
    decomposition: '⿰扌覺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '覺',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '攫',
    definition: 'to snatch, to sieze, to rob',
    pinyin: ['jué'],
    decomposition: '⿰扌矍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '矍',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '攬',
    definition: 'to grasp; to monopolize; to seize',
    pinyin: ['lǎn'],
    decomposition: '⿰扌覽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '覽',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '攮',
    definition: 'to fend off; to stab',
    pinyin: ['nǎng'],
    decomposition: '⿰扌囊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '囊',
      semantic: '扌',
      hint: 'hand',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '支',
    definition:
      'to support, to sustain; to withdraw, to pay; a branch (of a bank)',
    pinyin: ['zhī'],
    decomposition: '⿱十又',
    etymology: {
      type: 'ideographic',
      hint: 'A hand 又 holding a branch 十 for support',
    },
    radical: '支',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '攴',
    definition: 'to rap, to tap',
    pinyin: ['pū'],
    decomposition: '⿱⺊又',
    etymology: { type: 'pictographic', hint: 'A hand 又 wielding a stick ⺊' },
    radical: '攴',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '攵',
    definition: 'to rap, to tap; script; to let go',
    pinyin: ['pū'],
    decomposition: '⿱？乂',
    etymology: {
      type: 'pictographic',
      hint: "A fist made with one's right hand",
    },
    radical: '攵',
    matches: [null, null, [1], [1]],
  },
  {
    character: '收',
    definition: 'to collect, to gather, to harvest',
    pinyin: ['shōu'],
    decomposition: '⿰丩攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丩',
      semantic: '攵',
      hint: 'hand',
    },
    radical: '攵',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '攸',
    definition: 'distant, far; adverbial prefix',
    pinyin: ['yōu'],
    decomposition: '⿲亻丨攵',
    radical: '攵',
    matches: [[0], [0], [1], [2], [2], [2], [2]],
  },
  {
    character: '改',
    definition: 'to alter, to change, to improve, to remodel',
    pinyin: ['gǎi'],
    decomposition: '⿰己攵',
    etymology: {
      type: 'ideographic',
      hint: 'A hand with a stick 攵 disciplining a kneeling child 己',
    },
    radical: '攵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '攻',
    definition: 'to accuse; to assault; to criticize',
    pinyin: ['gōng'],
    decomposition: '⿰工攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '工',
      semantic: '攵',
      hint: 'rap',
    },
    radical: '攵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '放',
    definition: 'to release, to liberate, to free',
    pinyin: ['fàng'],
    decomposition: '⿰方攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '方',
      semantic: '攵',
      hint: 'let go',
    },
    radical: '攵',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '政',
    definition: 'government, politics',
    pinyin: ['zhèng'],
    decomposition: '⿰正攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '正',
      semantic: '攵',
      hint: 'script',
    },
    radical: '攵',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '敃',
    definition: 'robust, strong, vigorous',
    pinyin: ['mǐn'],
    decomposition: '⿰民攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '民',
      semantic: '攵',
      hint: 'rap',
    },
    radical: '攵',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '敄',
    definition: 'to put forth effort',
    pinyin: ['wù'],
    decomposition: '⿰矛攵',
    etymology: {
      type: 'ideographic',
      hint: 'To strike 攵 someone with a spear 矛',
    },
    radical: '攵',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '故',
    definition: 'reason, cause; happening, instance',
    pinyin: ['gù'],
    decomposition: '⿰古攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '古',
      semantic: '攵',
      hint: 'tap',
    },
    radical: '攵',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '效',
    definition: 'result, effect; effective',
    pinyin: ['xiào'],
    decomposition: '⿰交攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '交',
      semantic: '攵',
      hint: 'strike',
    },
    radical: '攵',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '敉',
    definition: 'to pacify, to soothe; to stabilize',
    pinyin: ['mǐ'],
    decomposition: '⿰米攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '米',
      semantic: '攵',
      hint: 'script',
    },
    radical: '攵',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '敌',
    definition: 'enemy, foe, rival; to match; to resist',
    pinyin: ['dí'],
    decomposition: '⿰舌攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '啇',
      semantic: '攵',
      hint: 'strike',
    },
    radical: '舌',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '敏',
    definition: 'fast, quick; clever, smart',
    pinyin: ['mǐn'],
    decomposition: '⿰每攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '每',
      semantic: '攵',
      hint: 'strike',
    },
    radical: '攵',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '救',
    definition: 'aid, help; to rescue, to save',
    pinyin: ['jiù'],
    decomposition: '⿰求攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '求',
      semantic: '攵',
      hint: 'hand',
    },
    radical: '攵',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '敕',
    definition: 'an imperial order or decree',
    pinyin: ['chì'],
    decomposition: '⿰束攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '束',
      semantic: '攵',
      hint: 'script',
    },
    radical: '攵',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '敖',
    definition: 'to ramble, to play about; leisurely; surname',
    pinyin: ['áo'],
    decomposition: '⿰？攵',
    radical: '攵',
    matches: [null, null, null, null, null, null, [1], [1], [1], [1]],
  },
  {
    character: '敗',
    definition: 'failure; to decline, to fail, to suffer defeat',
    pinyin: ['bài'],
    decomposition: '⿰貝攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '貝',
      semantic: '攵',
      hint: 'rap',
    },
    radical: '攵',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '敘',
    definition: 'to express, to state; to relate, to narrate',
    pinyin: ['xù'],
    decomposition: '⿰余攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '余',
      semantic: '攵',
      hint: 'again',
    },
    radical: '攵',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '教',
    definition: 'school, education',
    pinyin: ['jiào'],
    decomposition: '⿰孝攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孝',
      semantic: '攵',
      hint: 'script',
    },
    radical: '攵',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '敛',
    definition: 'to collect, to extort',
    pinyin: ['liǎn'],
    decomposition: '⿰佥攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '佥',
      semantic: '攵',
      hint: 'strike',
    },
    radical: '攵',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '敝',
    definition: 'to break, to destroy; ruined, tattered',
    pinyin: ['bì'],
    decomposition: '⿰？攵',
    etymology: { type: 'pictophonetic', semantic: '攵', hint: 'strike' },
    radical: '攵',
    matches: [null, null, null, null, null, null, null, [1], [1], [1], [1]],
  },
  {
    character: '敞',
    definition: 'wide, open, spacious',
    pinyin: ['chǎng'],
    decomposition: '⿰尚攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尚',
      semantic: '攵',
      hint: 'let go',
    },
    radical: '攵',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '敢',
    definition: 'bold, brave; to dare, to venture',
    pinyin: ['gǎn'],
    decomposition: '⿰⿱？耳攵',
    etymology: {
      type: 'ideographic',
      hint: 'A hand with a stick 攵 striking a beast 耳',
    },
    radical: '攵',
    matches: [
      null,
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '散',
    definition: 'to scatter, to disperse, to break up',
    pinyin: ['sàn'],
    decomposition: '⿰⿱？⺼攵',
    etymology: {
      type: 'ideographic',
      hint: 'A hand 攵 tossing seeds from a basket',
    },
    radical: '攵',
    matches: [
      null,
      null,
      null,
      null,
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '敦',
    definition: 'honest, candid, sincere; kind-hearted; to esteem',
    pinyin: ['dūn'],
    decomposition: '⿰享攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '攵',
      semantic: '享',
      hint: 'share',
    },
    radical: '攵',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '敪',
    definition: 'to weigh; to cut; to enter without being invited',
    pinyin: ['duó'],
    decomposition: '⿰叕攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叕',
      semantic: '攵',
      hint: 'rap',
    },
    radical: '攵',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '敫',
    definition: 'ancient musical instrument',
    pinyin: ['jiǎo'],
    decomposition: '⿰⿱白方攵',
    radical: '攵',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '敬',
    definition: 'to respect, to honor; respectfully',
    pinyin: ['jìng'],
    decomposition: '⿰苟攵',
    radical: '攵',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '数',
    definition: 'count, number, several',
    pinyin: ['shù'],
    decomposition: '⿰娄攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '娄',
      semantic: '攵',
      hint: 'script',
    },
    radical: '攵',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '敲',
    definition: 'to hammer, to pound, to strike',
    pinyin: ['qiāo'],
    decomposition: '⿰高攴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '高',
      semantic: '攴',
      hint: 'strike',
    },
    radical: '攴',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '整',
    definition: 'neat, orderly, whole; to repair, to mend',
    pinyin: ['zhěng'],
    decomposition: '⿱敕正',
    etymology: {
      type: 'pictophonetic',
      phonetic: '正',
      semantic: '敕',
      hint: 'order',
    },
    radical: '攵',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '敵',
    definition: 'enemy, foe, rival; to match; to resist',
    pinyin: ['dí'],
    decomposition: '⿰啇攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '啇',
      semantic: '攵',
      hint: 'strike',
    },
    radical: '攵',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '敷',
    definition: 'to apply, to paint, to spread',
    pinyin: ['fū'],
    decomposition: '⿰旉攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旉',
      semantic: '攵',
      hint: 'tap',
    },
    radical: '攵',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '數',
    definition: 'count, number, several',
    pinyin: ['shù'],
    decomposition: '⿰婁攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '婁',
      semantic: '攵',
      hint: 'script',
    },
    radical: '攵',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '敻',
    definition: 'remote, far away; preeminent',
    pinyin: ['xiòng'],
    decomposition: '⿱？夂',
    etymology: { type: 'pictophonetic', semantic: '夂', hint: 'go' },
    radical: '攵',
    matches: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '斂',
    definition: 'to collect, to extort',
    pinyin: ['liǎn'],
    decomposition: '⿰僉攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '僉',
      semantic: '攵',
      hint: 'strike',
    },
    radical: '攵',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '斃',
    definition: 'to kill; to die a violent death',
    pinyin: ['bì'],
    decomposition: '⿱敝死',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敝',
      semantic: '死',
      hint: 'death',
    },
    radical: '攵',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '文',
    definition: 'culture, literature, writing',
    pinyin: ['wén'],
    decomposition: '⿱亠乂',
    etymology: {
      type: 'pictographic',
      hint: 'A tattooed chest, representing writing',
    },
    radical: '文',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '斋',
    definition: 'to fast, to abstain; a vegetarian diet',
    pinyin: ['zhāi'],
    decomposition: '⿱文而',
    etymology: { type: 'pictophonetic', semantic: '文', hint: 'culture' },
    radical: '文',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '斌',
    definition: 'ornamental, refined',
    pinyin: ['bīn'],
    decomposition: '⿰文武',
    etymology: { type: 'pictophonetic', semantic: '文', hint: 'culture' },
    radical: '文',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '斐',
    definition: 'graceful, elegant, beautiful',
    pinyin: ['fěi'],
    decomposition: '⿱非文',
    etymology: {
      type: 'pictophonetic',
      phonetic: '非',
      semantic: '文',
      hint: 'culture',
    },
    radical: '文',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '斑',
    definition: 'freckled, mottled, spotted, striped',
    pinyin: ['bān'],
    decomposition: '⿲王文王',
    etymology: { type: 'ideographic', hint: 'Markings 文 in jade 王' },
    radical: '文',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [2], [2], [2], [2]],
  },
  {
    character: '斓',
    definition: 'multicolored',
    pinyin: ['lán'],
    decomposition: '⿰文阑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '阑',
      semantic: '文',
      hint: 'script',
    },
    radical: '文',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '斕',
    definition: 'multicolored',
    pinyin: ['lán'],
    decomposition: '⿰文闌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '闌',
      semantic: '文',
      hint: 'script',
    },
    radical: '文',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '斗',
    definition: 'to struggle, to fight, to contend; measuring cup',
    pinyin: ['dòu'],
    decomposition: '⿻十？',
    etymology: {
      type: 'ideographic',
      hint: 'A hand holding a measuring dipper',
    },
    radical: '斗',
    matches: [null, null, [0], [0]],
  },
  {
    character: '料',
    definition: 'ingredients, materials; to conjecture, to guess',
    pinyin: ['liào'],
    decomposition: '⿰米斗',
    etymology: {
      type: 'ideographic',
      hint: 'A hand measuring 斗 a cup of rice 米',
    },
    radical: '斗',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '斛',
    definition: 'ancient measuring vessel; unit of volume, about 50 liters',
    pinyin: ['hú'],
    decomposition: '⿰角斗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '角',
      semantic: '斗',
      hint: 'measuring cup',
    },
    radical: '斗',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '斜',
    definition: 'slanting, sloping, inclined',
    pinyin: ['xié'],
    decomposition: '⿰余斗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '余',
      semantic: '斗',
      hint: 'measuring cup',
    },
    radical: '斗',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '斟',
    definition: 'to deliberate, to gauge; to pour wine or tea',
    pinyin: ['zhēn'],
    decomposition: '⿰甚斗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甚',
      semantic: '斗',
      hint: 'measuring cup',
    },
    radical: '斗',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '斡',
    definition: 'to turn, to rotate, to revolve',
    pinyin: ['wò'],
    decomposition: '⿸倝斗',
    radical: '斗',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '斤',
    definition: 'a catty (about 500 grams); an axe; keen, shrewd',
    pinyin: ['jīn'],
    decomposition: '⿸厂下',
    radical: '斤',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '斥',
    definition: 'to scold, to upbraid; to accuse, to blame; to reproach',
    pinyin: ['chì'],
    decomposition: '⿸斤丶',
    etymology: {
      type: 'ideographic',
      hint: 'Someone scolded for cutting themselves 丶 with an axe 斤',
    },
    radical: '斤',
    matches: [[0], [0], [0], [0], [1]],
  },
  {
    character: '斦',
    pinyin: ['yín'],
    decomposition: '⿰斤斤',
    etymology: { type: 'pictophonetic', phonetic: '斤', semantic: '斤' },
    radical: '斤',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '斧',
    definition: 'axe, hatchet; to chop, to hew',
    pinyin: ['fǔ'],
    decomposition: '⿱父斤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '父',
      semantic: '斤',
      hint: 'axe',
    },
    radical: '斤',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '斩',
    definition: 'to chop, to cut, to sever; to behead',
    pinyin: ['zhǎn'],
    decomposition: '⿰车斤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '车',
      semantic: '斤',
      hint: 'axe',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '斫',
    definition: 'to chop, to cut, to lop off',
    pinyin: ['zhuó'],
    decomposition: '⿰石斤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '石',
      semantic: '斤',
      hint: 'axe',
    },
    radical: '斤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '斬',
    definition: 'to chop, to cut, to sever; to behead',
    pinyin: ['zhǎn'],
    decomposition: '⿰車斤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '車',
      semantic: '斤',
      hint: 'axe',
    },
    radical: '斤',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '断',
    definition: 'to sever, to cut off, to interrupt',
    pinyin: ['duàn'],
    decomposition: '⿰⿺？米斤',
    etymology: {
      type: 'ideographic',
      hint: 'Using an axe 斤 to harvest grain 米',
    },
    radical: '斤',
    matches: [
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      null,
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '斯',
    definition: 'this, thus, such; emphatic particle; used in transliterations',
    pinyin: ['sī'],
    decomposition: '⿰其斤',
    radical: '斤',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '新',
    definition: 'new, recent, fresh, modern',
    pinyin: ['xīn'],
    decomposition: '⿰亲斤',
    etymology: { type: 'ideographic', hint: 'A freshly chopped 斤 tree 亲' },
    radical: '斤',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '斲',
    definition: 'to chop, to hack; to cut wood',
    pinyin: ['zhuó'],
    decomposition: '⿰？斤',
    etymology: { type: 'ideographic', hint: 'To chop 斤 a tree trunk' },
    radical: '斤',
    matches: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '斷',
    definition: 'to sever, to cut off, to interrupt',
    pinyin: ['duàn'],
    decomposition: '⿰⿺？⿳⿰幺幺一⿰幺幺斤',
    etymology: {
      type: 'ideographic',
      hint: 'Threads 幺 severed 一 by an axe 斤',
    },
    radical: '斤',
    matches: [
      [0, 1, 0, 0],
      [0, 1, 0, 0],
      [0, 1, 0, 0],
      [0, 1, 0, 1],
      [0, 1, 0, 1],
      [0, 1, 0, 1],
      [0, 1, 1],
      [0, 1, 2, 0],
      [0, 1, 2, 0],
      [0, 1, 2, 0],
      [0, 1, 2, 1],
      [0, 1, 2, 1],
      [0, 1, 2, 1],
      null,
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '方',
    definition: 'square, rectangle; side; region; flag',
    pinyin: ['fāng'],
    decomposition: '⿱亠？',
    radical: '方',
    matches: [[0], [0], null, null],
  },
  {
    character: '於',
    definition: 'at, in, on; to, from; alas!',
    pinyin: ['yú'],
    decomposition: '⿰方？',
    radical: '方',
    matches: [[0], [0], [0], [0], null, null, null, null],
  },
  {
    character: '施',
    definition: 'to grant, to bestow; to act; surname',
    pinyin: ['shī'],
    decomposition: '⿰方㐌',
    radical: '方',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '斿',
    definition: 'to swim; to move freely',
    pinyin: ['yóu'],
    decomposition: '⿰方⿱？子',
    radical: '方',
    matches: [[0], [0], [0], [0], null, null, [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '旁',
    definition: 'side; beside, close, nearby',
    pinyin: ['páng'],
    decomposition: '⿱立方',
    etymology: {
      type: 'pictophonetic',
      phonetic: '方',
      semantic: '立',
      hint: 'stand',
    },
    radical: '方',
    matches: [[0], [0], [0], [0], null, [0], [1], [1], [1], [1]],
  },
  {
    character: '旃',
    definition: 'felt; a silk banner on a bent pole',
    pinyin: ['zhān'],
    decomposition: '⿰方⿱？丹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丹',
      semantic: '方',
      hint: 'flag',
    },
    radical: '方',
    matches: [[0], [0], [0], [0], null, null, [1, 1], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '旄',
    definition: 'old; an ancient pelt flag',
    pinyin: ['máo'],
    decomposition: '⿰方⿱？毛',
    etymology: {
      type: 'ideographic',
      hint: 'A flag 方 made of fur 毛; 毛 also provides the pronunciation',
    },
    radical: '方',
    matches: [[0], [0], [0], [0], null, null, [1, 1], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '旅',
    definition: 'journey, trip; to travel',
    pinyin: ['lǚ'],
    decomposition: '⿰方⿱？氏',
    etymology: {
      type: 'ideographic',
      hint: 'A man 方 traveling with a pack 氏 on his back',
    },
    radical: '方',
    matches: [[0], [0], [0], [0], null, null, [1, 1], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '旆',
    definition: 'banner, flag; ornament',
    pinyin: ['pèi'],
    decomposition: '⿰方⿱？巿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巿',
      semantic: '方',
      hint: 'flag',
    },
    radical: '方',
    matches: [[0], [0], [0], [0], null, null, [1, 1], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '旉',
    definition: 'to announce, to state',
    pinyin: ['fū'],
    decomposition: '⿱甫方',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甫',
      semantic: '方',
      hint: 'square',
    },
    radical: '方',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '旋',
    definition: 'to revolve, to orbit, to return',
    pinyin: ['xuán'],
    decomposition: '⿰方⿱？疋',
    etymology: {
      type: 'ideographic',
      hint: 'An army 方 marching under a flag 疋',
    },
    radical: '方',
    matches: [
      [0],
      [0],
      [0],
      [0],
      null,
      null,
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '旌',
    definition: 'to signal; a flag adorned with feathers',
    pinyin: ['jīng'],
    decomposition: '⿰方⿱？生',
    etymology: {
      type: 'pictophonetic',
      phonetic: '生',
      semantic: '方',
      hint: 'flag',
    },
    radical: '方',
    matches: [
      [0],
      [0],
      [0],
      [0],
      null,
      null,
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '旎',
    definition: 'romantic; the fluttering of a flag',
    pinyin: ['nǐ'],
    decomposition: '⿰方⿱？尼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尼',
      semantic: '方',
      hint: 'flag',
    },
    radical: '方',
    matches: [
      [0],
      [0],
      [0],
      [0],
      null,
      null,
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '族',
    definition: 'race, nationality, ethnicity; tribe, clan',
    pinyin: ['zú'],
    decomposition: '⿰方⿱？矢',
    etymology: {
      type: 'ideographic',
      hint: 'A group of people that swear by 矢 a single flag 方',
    },
    radical: '方',
    matches: [
      [0],
      [0],
      [0],
      [0],
      null,
      null,
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '旒',
    definition: 'tassels, fringes; pearls studding a crown',
    pinyin: ['liú'],
    decomposition: '⿰方⿱？㐬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㐬',
      semantic: '方',
      hint: 'flag',
    },
    radical: '方',
    matches: [
      [0],
      [0],
      [0],
      [0],
      null,
      null,
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '旖',
    definition: 'romantic; tender, charming',
    pinyin: ['yǐ'],
    decomposition: '⿰方⿱？奇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奇',
      semantic: '方',
      hint: 'flag',
    },
    radical: '方',
    matches: [
      [0],
      [0],
      [0],
      [0],
      null,
      null,
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '旗',
    definition: 'banner, flag, streamer',
    pinyin: ['qí'],
    decomposition: '⿰方⿱？其',
    etymology: {
      type: 'pictophonetic',
      phonetic: '其',
      semantic: '方',
      hint: 'square',
    },
    radical: '方',
    matches: [
      [0],
      [0],
      [0],
      [0],
      null,
      null,
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '无',
    definition: 'no, not; lacking, -less',
    pinyin: ['wú'],
    decomposition: '⿱一尢',
    radical: '无',
    matches: [[0], [1], [1], [1]],
  },
  {
    character: '旡',
    definition: 'to choke on something',
    pinyin: ['jì'],
    decomposition: '？',
    radical: '旡',
    matches: [null, null, null, null],
  },
  {
    character: '既',
    definition: 'already, since, then; both; de facto',
    pinyin: ['jì'],
    decomposition: '⿰？旡',
    etymology: {
      type: 'ideographic',
      hint: 'A person 旡 turning away from food 皀; compare 即',
    },
    radical: '旡',
    matches: [null, null, null, null, null, [1], [1], [1], [1]],
  },
  {
    character: '日',
    definition: 'sun; day; daytime',
    pinyin: ['rì'],
    decomposition: '⿴口一',
    etymology: { type: 'pictographic', hint: 'The sun' },
    radical: '日',
    matches: [[0], [0], [1], [0]],
  },
  {
    character: '旦',
    definition: 'dawn; morning; day',
    pinyin: ['dàn'],
    decomposition: '⿱日一',
    etymology: {
      type: 'ideographic',
      hint: 'The sun 日 rising over the horizon 一',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1]],
  },
  {
    character: '旧',
    definition: 'old, ancient; former, past',
    pinyin: ['jiù'],
    decomposition: '⿰丨日',
    etymology: { type: 'ideographic', hint: 'Older than 丨 the sun 日' },
    radical: '日',
    matches: [[0], [1], [1], [1], [1]],
  },
  {
    character: '旨',
    definition: 'aim, intention, purpose, will',
    pinyin: ['zhǐ'],
    decomposition: '⿱匕日',
    etymology: {
      type: 'ideographic',
      hint: 'A spoon 匕 aimed for the mouth 日',
    },
    radical: '日',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '早',
    definition: 'early; soon; morning',
    pinyin: ['zǎo'],
    decomposition: '⿱日十',
    etymology: { type: 'ideographic', hint: 'The first rays 十 of the sun 日' },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '旬',
    definition: 'ten-day period; period of time',
    pinyin: ['xún'],
    decomposition: '⿹勹日',
    etymology: {
      type: 'ideographic',
      hint: 'A cycle 勹 of ten days 日; a traditional week',
    },
    radical: '日',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '旭',
    definition: 'the rising sun; brilliant, radiant',
    pinyin: ['xù'],
    decomposition: '⿺九日',
    etymology: {
      type: 'pictophonetic',
      phonetic: '九',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '旮',
    definition: 'corner, nook, recess',
    pinyin: ['gā'],
    decomposition: '⿱九日',
    radical: '日',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '旯',
    definition: 'corner, nook, recess',
    pinyin: ['lá'],
    decomposition: '⿱日九',
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '旰',
    definition: 'sunset, dusk; evening',
    pinyin: ['gàn'],
    decomposition: '⿰日干',
    etymology: {
      type: 'pictophonetic',
      phonetic: '干',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '旱',
    definition: 'dry; drought; desert',
    pinyin: ['hàn'],
    decomposition: '⿱日干',
    etymology: {
      type: 'ideographic',
      hint: 'The sun 日 baking a desert 干; 干 also provides the pronunciation',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '旲',
    definition: 'daylight, sunlight',
    pinyin: ['tái'],
    decomposition: '⿱日大',
    etymology: {
      type: 'pictophonetic',
      phonetic: '大',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '时',
    definition: 'time, season; period, era, age',
    pinyin: ['shí'],
    decomposition: '⿰日寸',
    etymology: { type: 'pictophonetic', semantic: '日', hint: 'day' },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '旷',
    definition: 'broad, vast, wide; empty',
    pinyin: ['kuàng'],
    decomposition: '⿰日广',
    etymology: {
      type: 'ideographic',
      hint: 'A wide 广 plain under the sun 日; 广 also provides the pronunciation',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '旺',
    definition: 'to flourish, to prosper; prosperous',
    pinyin: ['wàng'],
    decomposition: '⿰日王',
    etymology: {
      type: 'pictophonetic',
      phonetic: '王',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '昀',
    definition: 'sunlight; surname',
    pinyin: ['yún'],
    decomposition: '⿰日匀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匀',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '昂',
    definition: 'to rise; proud, bold, upright',
    pinyin: ['áng'],
    decomposition: '⿱日卬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卬',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '昃',
    definition: 'afternoon; in decline',
    pinyin: ['zè'],
    decomposition: '⿱日仄',
    etymology: {
      type: 'ideographic',
      hint: 'The sun 日 at a slant 仄; 仄 also provides the pronunciation',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '昆',
    definition: 'elder brother; descendants',
    pinyin: ['kūn'],
    decomposition: '⿱日比',
    etymology: {
      type: 'ideographic',
      hint: 'Two brothers 比 under the son 日',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '昇',
    definition: 'rise, ascent; to raise, to exalt',
    pinyin: ['shēng'],
    decomposition: '⿱日升',
    etymology: {
      type: 'ideographic',
      hint: 'The rising 升 sun 日; 升 also provides the pronunciation',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '昉',
    definition: 'dawn, daybreak; to appear',
    pinyin: ['fǎng'],
    decomposition: '⿰日方',
    etymology: {
      type: 'pictophonetic',
      phonetic: '方',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '昊',
    definition: 'summertime; sky, heaven',
    pinyin: ['hào'],
    decomposition: '⿱日天',
    etymology: { type: 'ideographic', hint: 'The sun 日 high in the sky 天' },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '昌',
    definition: 'sunlight; good, proper; prosperous',
    pinyin: ['chāng'],
    decomposition: '⿱日曰',
    etymology: { type: 'ideographic', hint: 'Speaking 曰 in the daytime 日' },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '明',
    definition: 'bright, clear; to explain, to understand, to shed light',
    pinyin: ['míng'],
    decomposition: '⿰日月',
    etymology: {
      type: 'ideographic',
      hint: 'The light of the sun 日 and moon 月',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '昏',
    definition:
      'dusk, nightfall, twilight, dark; to faint, to lose consciousness',
    pinyin: ['hūn'],
    decomposition: '⿱氏日',
    etymology: {
      type: 'ideographic',
      hint: 'Th sun 日 setting behind a village 氏',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '易',
    definition: 'to change; to exchange, to trade; simple, easy',
    pinyin: ['yì'],
    decomposition: '⿱日勿',
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '昔',
    definition: 'past, former; ancient',
    pinyin: ['xī'],
    decomposition: '⿱廿日',
    etymology: { type: 'ideographic', hint: 'Twenty 廿 days ago 日' },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '昕',
    definition: 'day, dawn, early morning',
    pinyin: ['xīn'],
    decomposition: '⿰日斤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斤',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '昙',
    definition: 'cloudy, overcast',
    pinyin: ['tán'],
    decomposition: '⿱日云',
    etymology: {
      type: 'ideographic',
      hint: 'The sun 日 hidden behind a cloud 云',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '昜',
    definition: 'bright, glorious; to expand, to open up',
    pinyin: ['yáng'],
    decomposition: '⿱旦勿',
    etymology: {
      type: 'ideographic',
      hint: 'Bright and open, like the dawn 旦',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '昝',
    definition: 'dual pronoun: "you and I", "we two"; surname',
    pinyin: ['zǎn'],
    decomposition: '⿱处日',
    radical: '日',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '星',
    definition: 'star, planet; a point of light',
    pinyin: ['xīng'],
    decomposition: '⿱日生',
    etymology: {
      type: 'pictophonetic',
      phonetic: '生',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '映',
    definition: 'to project; to reflect; to shine',
    pinyin: ['yìng'],
    decomposition: '⿰日央',
    etymology: {
      type: 'pictophonetic',
      phonetic: '央',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '春',
    definition: 'springtime; joyful, lustful, wanton',
    pinyin: ['chūn'],
    decomposition: '⿱？日',
    etymology: { type: 'pictophonetic', semantic: '日', hint: 'sun' },
    radical: '日',
    matches: [null, null, null, null, null, [1], [1], [1], [1]],
  },
  {
    character: '昧',
    definition: 'dark, hidden, obscure',
    pinyin: ['mèi'],
    decomposition: '⿰日未',
    etymology: {
      type: 'pictophonetic',
      phonetic: '未',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '昨',
    definition: 'yesterday; formerly, in the past',
    pinyin: ['zuó'],
    decomposition: '⿰日乍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乍',
      semantic: '日',
      hint: 'day',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '昫',
    definition: 'warm',
    pinyin: ['xù'],
    decomposition: '⿰日句',
    etymology: {
      type: 'pictophonetic',
      phonetic: '句',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '昬',
    definition: 'dusk; dark, confused; stupid',
    pinyin: ['hūn'],
    decomposition: '⿱民日',
    etymology: {
      type: 'pictophonetic',
      phonetic: '民',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '昭',
    definition: 'bright, luminous; clear, manifest',
    pinyin: ['zhāo'],
    decomposition: '⿰日召',
    etymology: {
      type: 'pictophonetic',
      phonetic: '召',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '是',
    definition: 'to be; indeed, right, yes; okay',
    pinyin: ['shì'],
    decomposition: '⿱日疋',
    etymology: { type: 'ideographic', hint: 'To speak 日 directly 疋' },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '昱',
    definition: 'bright, dazzling; sunlight',
    pinyin: ['yù'],
    decomposition: '⿱日立',
    etymology: {
      type: 'pictophonetic',
      phonetic: '立',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '昴',
    definition: 'one of the 28 constellations',
    pinyin: ['mǎo'],
    decomposition: '⿱日卯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卯',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '昵',
    definition: 'close, intimate; to approach',
    pinyin: ['nì'],
    decomposition: '⿰日尼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尼',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '昶',
    definition: 'bright, clear; extended',
    pinyin: ['chǎng'],
    decomposition: '⿺永日',
    etymology: {
      type: 'ideographic',
      hint: 'A long 永 day 日; 永 also provides the pronunciation',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '昷',
    definition: 'warm, a warm meal',
    pinyin: ['wēn'],
    decomposition: '⿱日皿',
    etymology: { type: 'ideographic', hint: 'A warm 日 meal 皿' },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '昼',
    definition: 'daytime, daylight',
    pinyin: ['zhòu'],
    decomposition: '⿵尺旦',
    etymology: {
      type: 'ideographic',
      hint: 'When the sun is a foot 尺 above the horizon 旦',
    },
    radical: '尸',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '显',
    definition: 'clear, evident; prominent; to show',
    pinyin: ['xiǎn'],
    decomposition: '⿱日业',
    etymology: {
      type: 'pictophonetic',
      phonetic: '业',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '晁',
    definition: 'morning, dawn; surname',
    pinyin: ['cháo'],
    decomposition: '⿱日兆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兆',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '時',
    definition: 'time, season; period, era, age',
    pinyin: ['shí'],
    decomposition: '⿰日寺',
    etymology: {
      type: 'pictophonetic',
      semantic: '日',
      hint: 'day',
      phonetic: '寺',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '晃',
    definition: 'bright, dazzling; to shake, to sway',
    pinyin: ['huǎng'],
    decomposition: '⿱日光',
    etymology: {
      type: 'pictophonetic',
      phonetic: '光',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '晉',
    definition: 'to advance; to increase; to promote',
    pinyin: ['jìn'],
    decomposition: '⿱⿳一⿰厶厶一日',
    etymology: {
      type: 'ideographic',
      hint: 'A platform 一 raised on stilts 厶',
    },
    radical: '日',
    matches: [
      [0, 0],
      [0, 1, 0],
      [0, 1, 0],
      [0, 1, 1],
      [0, 1, 1],
      [0, 2],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '晋',
    definition: 'to advance; to increase; to promote',
    pinyin: ['jìn'],
    decomposition: '⿱亚日',
    etymology: {
      type: 'ideographic',
      hint: 'An advance to the second 亚 day 日',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '晌',
    definition: 'noon, midday; moment',
    pinyin: ['shǎng'],
    decomposition: '⿰日向',
    etymology: {
      type: 'pictophonetic',
      phonetic: '向',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '晏',
    definition: 'peaceful, tranquil, quiet; clear; late in the day',
    pinyin: ['yàn'],
    decomposition: '⿱日安',
    etymology: {
      type: 'ideographic',
      hint: 'A woman safe in a house 安 at sunset 日',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '晒',
    definition: 'to dry in the sun; to expose to the sun',
    pinyin: ['shài'],
    decomposition: '⿰日西',
    etymology: {
      type: 'pictophonetic',
      phonetic: '西',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '晓',
    definition: 'dawn; clear, explicit, known',
    pinyin: ['xiǎo'],
    decomposition: '⿰日尧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尧',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '晔',
    definition: 'bright, radiant; thriving',
    pinyin: ['yè'],
    decomposition: '⿰日华',
    etymology: {
      type: 'ideographic',
      hint: 'A flower 华 blooming in the sun 日',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '晕',
    definition: 'dizzy, faint, foggy; to see stars',
    pinyin: ['yūn'],
    decomposition: '⿱日军',
    etymology: {
      type: 'pictophonetic',
      phonetic: '军',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '晖',
    definition: 'sunshine; light; bright, radiant',
    pinyin: ['huī'],
    decomposition: '⿰日军',
    etymology: {
      type: 'pictophonetic',
      phonetic: '军',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '晗',
    definition: 'twilight before dawn',
    pinyin: ['hán'],
    decomposition: '⿰日含',
    etymology: {
      type: 'pictophonetic',
      phonetic: '含',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '晚',
    definition: 'night, evening; late',
    pinyin: ['wǎn'],
    decomposition: '⿰日免',
    etymology: {
      type: 'ideographic',
      hint: 'Avoiding 免 the sun 日; 免 also provides the pronunciation',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '晝',
    definition: 'daytime, daylight',
    pinyin: ['zhòu'],
    decomposition: '⿱聿旦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '聿',
      semantic: '旦',
      hint: 'day',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '晟',
    definition: 'bright, clear, splendid',
    pinyin: ['chéng'],
    decomposition: '⿱日成',
    etymology: {
      type: 'pictophonetic',
      phonetic: '成',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '晡',
    definition: 'late afternoon',
    pinyin: ['bū'],
    decomposition: '⿰日甫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甫',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '晤',
    definition: 'to meet; to interview with',
    pinyin: ['wù'],
    decomposition: '⿰日吾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吾',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '晦',
    definition: 'dark, obscure, unclear; night',
    pinyin: ['huì'],
    decomposition: '⿰日每',
    etymology: {
      type: 'pictophonetic',
      phonetic: '每',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '晨',
    definition: 'dawn, early morning',
    pinyin: ['chén'],
    decomposition: '⿱日辰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辰',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '晬',
    definition: "a child's first birthday",
    pinyin: ['zuì'],
    decomposition: '⿰日卒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卒',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '普',
    definition: 'widespread, universal, general',
    pinyin: ['pǔ'],
    decomposition: '⿱並日',
    etymology: { type: 'ideographic', hint: 'Everyone 並 under the sun 日' },
    radical: '日',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '景',
    definition: 'scenery, view; conditions, circumstances',
    pinyin: ['jǐng'],
    decomposition: '⿱日京',
    etymology: {
      type: 'ideographic',
      hint: 'The sun 日 rising over a city 京; 京 also provides the pronunciation',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '晰',
    definition: 'clear, evident',
    pinyin: ['xī'],
    decomposition: '⿰日析',
    etymology: {
      type: 'pictophonetic',
      phonetic: '析',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '晴',
    definition: 'clear weather, fine weather',
    pinyin: ['qíng'],
    decomposition: '⿰日青',
    etymology: {
      type: 'pictophonetic',
      phonetic: '青',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '晶',
    definition: 'crystal; bright, clear, radiant',
    pinyin: ['jīng'],
    decomposition: '⿱日⿰日日',
    etymology: {
      type: 'ideographic',
      hint: 'Many suns 日, suggesting a bright and glittering gem',
    },
    radical: '日',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '晷',
    definition: "the sun's shadow; sundial; time",
    pinyin: ['guǐ'],
    decomposition: '⿱日咎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咎',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '智',
    definition: 'wisdom, knowledge, intelligence',
    pinyin: ['zhì'],
    decomposition: '⿱知日',
    etymology: {
      type: 'ideographic',
      hint: 'Known 知 clearly 日; 知 also provides the pronunciation',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '晾',
    definition: 'to air-dry; to sun-dry',
    pinyin: ['liàng'],
    decomposition: '⿰日京',
    etymology: {
      type: 'pictophonetic',
      phonetic: '京',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '暂',
    definition: 'temporary',
    pinyin: ['zàn'],
    decomposition: '⿱斩日',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斩',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '暄',
    definition: 'warm, genial; comfortable',
    pinyin: ['xuān'],
    decomposition: '⿰日宣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宣',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '暆',
    definition: 'declining (as of the sun)',
    pinyin: ['yí'],
    decomposition: '⿰日施',
    etymology: {
      type: 'pictophonetic',
      phonetic: '施',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '暇',
    definition: 'leisure, relaxation, spare time',
    pinyin: ['xiá'],
    decomposition: '⿰日叚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叚',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '暈',
    definition: 'dizzy, faint, foggy; to see stars',
    pinyin: ['yūn'],
    decomposition: '⿱日軍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '軍',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '暉',
    definition: 'sunshine; light; bright, radiant',
    pinyin: ['huī'],
    decomposition: '⿰日軍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '軍',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '暋',
    definition: 'tough, strong, robust',
    pinyin: ['mǐn'],
    decomposition: '⿱敃日',
    etymology: {
      type: 'ideographic',
      hint: 'Strong 敃 sunlight 日; 敃 also provides the pronunciation',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '暌',
    definition: 'opposed to; separated, remote',
    pinyin: ['kuí'],
    decomposition: '⿰日癸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '癸',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '暑',
    definition: 'hot; heat; summer',
    pinyin: ['shǔ'],
    decomposition: '⿱日者',
    etymology: {
      type: 'pictophonetic',
      phonetic: '者',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '暖',
    definition: 'warm, genial',
    pinyin: ['nuǎn'],
    decomposition: '⿰日爰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爰',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '暗',
    definition: 'dark, gloomy; obscure; secret, covert',
    pinyin: ['àn'],
    decomposition: '⿰日音',
    etymology: {
      type: 'pictophonetic',
      phonetic: '音',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '暝',
    definition: 'dark, obscure',
    pinyin: ['míng'],
    decomposition: '⿰日冥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冥',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '暠',
    definition: 'daybreak; brilliant, bright',
    pinyin: ['gǎo'],
    decomposition: '⿱日高',
    etymology: {
      type: 'pictophonetic',
      phonetic: '高',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '暡',
    definition: 'twilight before dawn',
    pinyin: ['wěng'],
    decomposition: '⿰日翁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '翁',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '暢',
    definition: 'freely, smoothly; unrestrained',
    pinyin: ['chàng'],
    decomposition: '⿰申昜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昜',
      semantic: '申',
      hint: 'open',
    },
    radical: '日',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '暧',
    definition: 'obscure, dim; ambiguous, vague',
    pinyin: ['ài'],
    decomposition: '⿰日爱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爱',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '暨',
    definition: 'and; to reach, to attain; limits, confines',
    pinyin: ['jì'],
    decomposition: '⿱既旦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '既',
      semantic: '旦',
      hint: 'dawn',
    },
    radical: '日',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '暫',
    definition: 'temporary',
    pinyin: ['zàn'],
    decomposition: '⿱斬日',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斬',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '暮',
    definition: 'dusk, evening, sunset; ending',
    pinyin: ['mù'],
    decomposition: '⿱莫日',
    etymology: {
      type: 'pictophonetic',
      phonetic: '莫',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '暱',
    definition: 'close, intimate; to approach',
    pinyin: ['nì'],
    decomposition: '⿰日匿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匿',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '暴',
    definition: 'violent, brutal, tyrannical',
    pinyin: ['bào'],
    decomposition: '⿱日⿱共水',
    etymology: {
      type: 'ideographic',
      hint: 'A man with head 日 and hands 共 tormenting a deer 水',
    },
    radical: '日',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '暹',
    definition: 'sunrise; to advance, to rise, to go forward',
    pinyin: ['xiān'],
    decomposition: '⿺辶⿱日隹',
    etymology: {
      type: 'ideographic',
      hint: 'The sun 日 moving 辶; 隹 provides the pronunciation',
    },
    radical: '日',
    matches: [
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '暾',
    definition: 'sunrise, the morning sun',
    pinyin: ['tūn'],
    decomposition: '⿰日敦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敦',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '曄',
    definition: 'bright, radiant; thriving',
    pinyin: ['yè'],
    decomposition: '⿰日華',
    etymology: {
      type: 'ideographic',
      hint: 'A flower 華 blooming in the sun 日',
    },
    radical: '日',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '曆',
    definition: 'history; calendar',
    pinyin: ['lì'],
    decomposition: '⿸厤日',
    etymology: {
      type: 'pictophonetic',
      phonetic: '日',
      semantic: '厤',
      hint: 'calendar',
    },
    radical: '日',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '曇',
    definition: 'cloudy, overcast',
    pinyin: ['tán'],
    decomposition: '⿱日雲',
    etymology: {
      type: 'ideographic',
      hint: 'The sun 日 hidden behind a cloud 雲',
    },
    radical: '日',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '曉',
    definition: 'dawn; clear, explicit, known',
    pinyin: ['xiǎo'],
    decomposition: '⿰日堯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堯',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '曖',
    definition: 'obscure, dim; ambiguous, vague',
    pinyin: ['ài'],
    decomposition: '⿰日愛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '愛',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '曙',
    definition: 'dawn, daybreak; the dawn of an era',
    pinyin: ['shǔ'],
    decomposition: '⿰日署',
    etymology: {
      type: 'pictophonetic',
      phonetic: '署',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '曚',
    definition: 'twilight before dawn',
    pinyin: ['méng'],
    decomposition: '⿰日蒙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蒙',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '曛',
    definition: 'twilight; sunset',
    pinyin: ['xūn'],
    decomposition: '⿰日熏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '熏',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '曜',
    definition: 'bright, glorious; Venus',
    pinyin: ['yào'],
    decomposition: '⿰日翟',
    etymology: {
      type: 'ideographic',
      hint: 'A spectacular 翟 star 日; 翟 also provides the pronunciation',
    },
    radical: '日',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '曝',
    definition: 'to air out, to expose to sunlight; to reveal',
    pinyin: ['pù'],
    decomposition: '⿰日暴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '暴',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '曠',
    definition: 'broad, vast, wide; empty',
    pinyin: ['kuàng'],
    decomposition: '⿰日廣',
    etymology: {
      type: 'ideographic',
      hint: 'A wide 廣 plain under the sun 日; 廣 also provides the pronunciation',
    },
    radical: '日',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '曦',
    definition: 'sunshine; early dawn',
    pinyin: ['xī'],
    decomposition: '⿰日羲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羲',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '曩',
    definition: 'ancient times; former; old',
    pinyin: ['nǎng'],
    decomposition: '⿱日襄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '襄',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '曬',
    definition: 'to dry in the sun; to expose to the sun',
    pinyin: ['shài'],
    decomposition: '⿰日麗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '麗',
      semantic: '日',
      hint: 'sun',
    },
    radical: '日',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '曰',
    definition: 'to speak; to say',
    pinyin: ['yuē'],
    decomposition: '⿴口一',
    etymology: { type: 'ideographic', hint: 'Picture of an open 一 mouth 口' },
    radical: '曰',
    matches: [[0], [0], [1], [0]],
  },
  {
    character: '曱',
    definition: 'cockroach',
    pinyin: ['yuē'],
    decomposition: '⿻曰？',
    etymology: { type: 'pictophonetic', phonetic: '曰' },
    radical: '曰',
    matches: [[0], [0], [0], [0], null],
  },
  {
    character: '曲',
    definition: 'crooked, bent; wrong, false',
    pinyin: ['qū'],
    decomposition: '⿻曰⿰丨丨',
    etymology: { type: 'pictographic', hint: 'A folded object 曰' },
    radical: '曰',
    matches: [[0], [0], [0], [1, 0], [1, 1], [0]],
  },
  {
    character: '曳',
    definition: 'to tow, to pull, to drag',
    pinyin: ['yè'],
    decomposition: '⿻？曰',
    radical: '曰',
    matches: [[1], [1], [1], [1], null, null],
  },
  {
    character: '更',
    definition: 'more, further; to shift, to alternate; to modify',
    pinyin: ['gèng'],
    decomposition: '⿱一⿻曰乂',
    radical: '曰',
    matches: [[0], [1, 0], [1, 0], [1, 0], [1, 0], [1, 1], [1, 1]],
  },
  {
    character: '曷',
    definition: 'what, why, where, which, how',
    pinyin: ['hé'],
    decomposition: '⿱日？',
    etymology: { type: 'ideographic', hint: 'Variant of 何' },
    radical: '曰',
    matches: [[0], [0], [0], [0], null, null, null, null, null],
  },
  {
    character: '書',
    definition: 'book, letter, document; writing',
    pinyin: ['shū'],
    decomposition: '⿱聿曰',
    etymology: {
      type: 'ideographic',
      hint: 'A brush 聿 used to write words 曰',
    },
    radical: '曰',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '曹',
    definition: 'ministers, officials; a company; surname',
    pinyin: ['cáo'],
    decomposition: '⿱？日',
    radical: '曰',
    matches: [null, null, null, null, null, null, null, [1], [1], [1], [1]],
  },
  {
    character: '曼',
    definition: 'long, extended, vast; beautiful',
    pinyin: ['màn'],
    decomposition: '⿱日⿱罒又',
    etymology: {
      type: 'ideographic',
      hint: 'Two hands 日, 又 pulling an eye open 罒',
    },
    radical: '日',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '曾',
    definition: 'already, formerly, once; the past',
    pinyin: ['céng'],
    decomposition: '⿳丷？日',
    etymology: {
      type: 'ideographic',
      hint: 'A rice cooker on heat 日, building up steam 丷 and letting it off',
    },
    radical: '曰',
    matches: [[0], [0], null, null, null, null, null, null, [2], [2], [2], [2]],
  },
  {
    character: '替',
    definition: 'to change, to replace, to substitute for',
    pinyin: ['tì'],
    decomposition: '⿱⿰夫夫日',
    etymology: {
      type: 'ideographic',
      hint: 'One man 夫 replacing another; 日 provides the pronunciation',
    },
    radical: '曰',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '最',
    definition: 'most, extremely, exceedingly; superlative',
    pinyin: ['zuì'],
    decomposition: '⿱日取',
    etymology: {
      type: 'ideographic',
      hint: 'To take place 取 under the sun 日 (that is, everywhere)',
    },
    radical: '曰',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '朁',
    definition: 'if, supposing, nevertheless',
    pinyin: ['cǎn'],
    decomposition: '⿱？日',
    radical: '曰',
    matches: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '會',
    definition: 'to assemble, to meet; meeting; association, group',
    pinyin: ['huì'],
    decomposition: '⿱⿱亼？日',
    etymology: { type: 'ideographic', hint: 'People 人 speaking 日' },
    radical: '曰',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      null,
      null,
      null,
      null,
      null,
      null,
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '月',
    definition: 'moon; month',
    pinyin: ['yuè'],
    decomposition: '⿵冂二',
    etymology: { type: 'pictographic', hint: 'A crescent moon' },
    radical: '月',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '有',
    definition: 'to have, to own, to possess; to exist',
    pinyin: ['yǒu'],
    decomposition: '⿸？月',
    etymology: { type: 'pictophonetic', phonetic: '月' },
    radical: '月',
    matches: [null, null, [1], [1], [1], [1]],
  },
  {
    character: '朊',
    definition: 'protein',
    pinyin: ['ruǎn'],
    decomposition: '⿰⺼元',
    etymology: {
      type: 'pictophonetic',
      phonetic: '元',
      semantic: '⺼',
      hint: 'meat',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '朋',
    definition: 'friend, pal, acquaintance',
    pinyin: ['péng'],
    decomposition: '⿰月月',
    etymology: { type: 'ideographic', hint: 'Two people 月 walking together' },
    radical: '月',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '服',
    definition: 'clothes; to dress, to wear; to take medicine',
    pinyin: ['fú'],
    decomposition: '⿰月⿸卩又',
    etymology: {
      type: 'ideographic',
      hint: 'A person 卩 putting on 又 a coat 月',
    },
    radical: '月',
    matches: [[0], [0], [0], [0], [1, 0], [1, 0], [1, 1], [1, 1]],
  },
  {
    character: '朐',
    definition: 'warm',
    pinyin: ['qú'],
    decomposition: '⿰月句',
    etymology: {
      type: 'pictophonetic',
      phonetic: '句',
      semantic: '月',
      hint: 'moon',
    },
    radical: '月',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '朔',
    definition: 'beginning; the first day of the lunar month',
    pinyin: ['shuò'],
    decomposition: '⿰屰月',
    etymology: {
      type: 'pictophonetic',
      phonetic: '月',
      semantic: '月',
      hint: 'moon',
    },
    radical: '月',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '朕',
    definition: 'the royal "we", for imperial use',
    pinyin: ['zhèn'],
    decomposition: '⿰月关',
    radical: '月',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '朗',
    definition: 'bright, clear, distinct',
    pinyin: ['lǎng'],
    decomposition: '⿰良月',
    etymology: {
      type: 'pictophonetic',
      phonetic: '良',
      semantic: '月',
      hint: 'moon',
    },
    radical: '月',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '望',
    definition: 'to expect, to hope, to look forward to',
    pinyin: ['wàng'],
    decomposition: '⿱⿰亡月王',
    etymology: {
      type: 'ideographic',
      hint: 'A king 王 gazing at the moon 月; 亡 provides the pronunciation',
    },
    radical: '月',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '朝',
    definition: 'to face; direct, facing; dynasty; morning',
    pinyin: ['cháo'],
    decomposition: '⿰龺月',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龺',
      semantic: '月',
      hint: 'moon',
    },
    radical: '月',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '期',
    definition: 'a period of time; date, time; phase',
    pinyin: ['qī'],
    decomposition: '⿰其月',
    etymology: {
      type: 'pictophonetic',
      phonetic: '其',
      semantic: '月',
      hint: 'moon',
    },
    radical: '月',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '朦',
    definition: 'dim, obscure; the condition of the moon',
    pinyin: ['méng'],
    decomposition: '⿰月蒙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蒙',
      semantic: '月',
      hint: 'moon',
    },
    radical: '月',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '朧',
    definition: 'blurry, obscured; the condition or appearance of the moon',
    pinyin: ['lóng'],
    decomposition: '⿰月龍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龍',
      semantic: '月',
      hint: 'moon',
    },
    radical: '月',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '木',
    definition: 'tree; wood, lumber; wooden',
    pinyin: ['mù'],
    decomposition: '⿻十八',
    etymology: { type: 'pictographic', hint: 'A tree' },
    radical: '木',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '未',
    definition: 'not yet; 8th terrestrial branch',
    pinyin: ['wèi'],
    decomposition: '⿻一木',
    etymology: {
      type: 'ideographic',
      hint: 'A wheat plant that has not yet borne fruit; compare 來',
    },
    radical: '木',
    matches: [[0], [1], [1], [1], [1]],
  },
  {
    character: '末',
    definition: 'end, final, last; insignificant',
    pinyin: ['mò'],
    decomposition: '⿻木一',
    etymology: { type: 'ideographic', hint: 'The top 一 of a tree 木' },
    radical: '木',
    matches: [[1], [0], [0], [0], [0]],
  },
  {
    character: '本',
    definition: 'root, origin, source; basis',
    pinyin: ['běn'],
    decomposition: '⿻木一',
    etymology: {
      type: 'ideographic',
      hint: 'A tree 木 with its roots highlighted',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1]],
  },
  {
    character: '札',
    definition: 'letter, note; correspondence',
    pinyin: ['zhá'],
    decomposition: '⿰木乚',
    radical: '木',
    matches: [[0], [0], [0], [0], [1]],
  },
  {
    character: '朮',
    definition: 'skill, art; method, technique; trick',
    pinyin: ['shù'],
    decomposition: '⿻木？',
    etymology: { type: 'ideographic', hint: 'Variant of 术' },
    radical: '木',
    matches: [[0], [0], [0], [0], null],
  },
  {
    character: '术',
    definition: 'skill, art; method, technique; trick',
    pinyin: ['shù'],
    decomposition: '⿺木丶',
    radical: '木',
    matches: [[0], [0], [0], [0], [1]],
  },
  {
    character: '朱',
    definition: 'cinnabar, vermilion; surname',
    pinyin: ['zhū'],
    decomposition: '⿻一木',
    etymology: {
      type: 'ideographic',
      hint: 'The color of the sap 一 of some trees 木',
    },
    radical: '木',
    matches: [null, [0], [1], [1], [1], [1]],
  },
  {
    character: '朴',
    definition: 'plain, simple; sincere; surname',
    pinyin: ['pǔ'],
    decomposition: '⿰木卜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卜',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '朵',
    definition: 'cluster of flowers; earlobe; an item on both sides',
    pinyin: ['duǒ'],
    decomposition: '⿱几木',
    etymology: {
      type: 'ideographic',
      hint: 'Flowers 几 blooming on a tree 木',
    },
    radical: '木',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '机',
    definition: 'desk; machine; moment, opportunity',
    pinyin: ['jī'],
    decomposition: '⿰木几',
    etymology: {
      type: 'ideographic',
      hint: 'A table 几 made of wood 木; 几 also provides the pronunciation',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '朽',
    definition: 'decayed, rotten',
    pinyin: ['xiǔ'],
    decomposition: '⿰木丂',
    etymology: { type: 'ideographic', hint: 'The wood of a dying 丂 tree 木' },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '朿',
    definition: 'thorn, sting, prickle; to stab; to assassinate',
    pinyin: ['cì'],
    decomposition: '⿻木冂',
    radical: '木',
    matches: [[0], [1], [1], [0], [0], [0]],
  },
  {
    character: '杀',
    definition: 'to kill, to murder, to slaughter; to hurt',
    pinyin: ['shā'],
    decomposition: '⿱乂木',
    etymology: {
      type: 'ideographic',
      hint: 'To kill 乂 someone and bury them in a coffin 木',
    },
    radical: '木',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '杂',
    definition: 'mix, blend; various, miscellaneous',
    pinyin: ['zá'],
    decomposition: '⿱九木',
    radical: '木',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '权',
    definition: 'authority, power, right',
    pinyin: ['quán'],
    decomposition: '⿰木又',
    etymology: {
      type: 'pictophonetic',
      phonetic: '雚',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '杆',
    definition: 'cane, pole, stick',
    pinyin: ['gān'],
    decomposition: '⿰木干',
    etymology: {
      type: 'pictophonetic',
      phonetic: '干',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '杈',
    definition: 'pitchfork; tree fork',
    pinyin: ['chā'],
    decomposition: '⿰木叉',
    etymology: {
      type: 'ideographic',
      hint: 'Where two branches 木 fork 叉; 叉 also provides the pronunciation',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '杉',
    definition: 'various species of pine and fir',
    pinyin: ['shān'],
    decomposition: '⿰木彡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彡',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '杌',
    definition: 'tree stump; square stool; sterility',
    pinyin: ['wù'],
    decomposition: '⿰木兀',
    etymology: {
      type: 'ideographic',
      hint: 'A tree 木 stump 兀; 兀 also provides the pronunciation',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '李',
    definition: 'plum; luggage; surname',
    pinyin: ['lǐ'],
    decomposition: '⿱木子',
    etymology: {
      type: 'pictophonetic',
      phonetic: '子',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '杏',
    definition: 'apricot; almond',
    pinyin: ['xìng'],
    decomposition: '⿱木口',
    etymology: {
      type: 'ideographic',
      hint: 'A open mouth 口, waiting for fruit to fall from the tree 木',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '材',
    definition: 'timber; material, stuff; talent',
    pinyin: ['cái'],
    decomposition: '⿰木才',
    etymology: {
      type: 'pictophonetic',
      phonetic: '才',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '村',
    definition: 'village, hamlet; vulgar, uncouth',
    pinyin: ['cūn'],
    decomposition: '⿰木寸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寸',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '杓',
    definition: 'wooden cup, ladle, or spoon',
    pinyin: ['biāo'],
    decomposition: '⿰木勺',
    etymology: { type: 'ideographic', hint: 'A wooden 木 spoon 勺' },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '杖',
    definition: 'cane, walking stick',
    pinyin: ['zhàng'],
    decomposition: '⿰木丈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丈',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '杜',
    definition: 'to prevent, to restrict, to stop; surname',
    pinyin: ['dù'],
    decomposition: '⿰木土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '土',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '杞',
    definition: 'willow, medlar tree; a small feudal state',
    pinyin: ['qǐ'],
    decomposition: '⿰木己',
    etymology: {
      type: 'pictophonetic',
      phonetic: '己',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '束',
    definition: 'to bind, to control, to restrain; bale',
    pinyin: ['shù'],
    decomposition: '⿻木口',
    etymology: { type: 'ideographic', hint: 'Lumber 木 bound by rope 口' },
    radical: '木',
    matches: [[0], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '杠',
    definition: 'pole, bar; lever, crowbar',
    pinyin: ['gāng'],
    decomposition: '⿰木工',
    etymology: {
      type: 'ideographic',
      hint: 'A wooden 木 lever 工; 工 also provides the pronunciation',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '条',
    definition: 'clause, condition; string, stripe',
    pinyin: ['tiáo'],
    decomposition: '⿱夂木',
    radical: '木',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '来',
    definition: 'to arrive, to come, to return; in the future, later on',
    pinyin: ['lái'],
    decomposition: '⿻未丷',
    etymology: {
      type: 'ideographic',
      hint: 'A wheat plant that has not yet borne fruit; compare 來',
    },
    radical: '木',
    matches: [[0], [1], [1], [0], [0], [0], [0]],
  },
  {
    character: '杨',
    definition: 'willow, poplar, aspen; surname',
    pinyin: ['yáng'],
    decomposition: '⿰木昜',
    etymology: { type: 'pictophonetic', semantic: '木', hint: 'tree' },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '杩',
    definition: 'headboard',
    pinyin: ['mà'],
    decomposition: '⿰木马',
    etymology: {
      type: 'pictophonetic',
      phonetic: '马',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '杪',
    definition: 'twig, branch tip; the top of a tree',
    pinyin: ['miǎo'],
    decomposition: '⿰木少',
    etymology: {
      type: 'ideographic',
      hint: 'The tip 少 of a branch 木; 少 also provides the pronunciation',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '杭',
    definition: 'ford; surname',
    pinyin: ['háng'],
    decomposition: '⿰木亢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亢',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '杯',
    definition: 'cup, glass; measure word for liquids',
    pinyin: ['bēi'],
    decomposition: '⿰木不',
    etymology: {
      type: 'pictophonetic',
      phonetic: '不',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '杰',
    definition: 'hero; heroic, outstanding',
    pinyin: ['jié'],
    decomposition: '⿱木灬',
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '東',
    definition: 'east, eastern, eastward',
    pinyin: ['dōng'],
    decomposition: '⿻木日',
    etymology: {
      type: 'ideographic',
      hint: 'The sun 日 rising behind a tree 木; compare 西',
    },
    radical: '木',
    matches: [[0], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '杲',
    definition: 'brilliant, shining; high',
    pinyin: ['gǎo'],
    decomposition: '⿱日木',
    etymology: {
      type: 'ideographic',
      hint: 'The sun 日 rising over the woods 木',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '杳',
    definition: 'dark, mysterious, obscure; deep',
    pinyin: ['yǎo'],
    decomposition: '⿱木日',
    etymology: {
      type: 'ideographic',
      hint: 'The sun 日 setting below the woods 木',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '杵',
    definition: 'pestle; to grind',
    pinyin: ['chǔ'],
    decomposition: '⿰木午',
    etymology: {
      type: 'pictophonetic',
      phonetic: '午',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '杷',
    definition: 'loquat tree; axe handle',
    pinyin: ['pá'],
    decomposition: '⿰木巴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巴',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '杼',
    definition: 'scrub oak; long, narrow, thin; sewing shuttle',
    pinyin: ['zhù'],
    decomposition: '⿰木予',
    etymology: {
      type: 'pictophonetic',
      phonetic: '予',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '松',
    definition: 'pine tree; fir tree',
    pinyin: ['sōng'],
    decomposition: '⿰木公',
    etymology: {
      type: 'pictophonetic',
      semantic: '木',
      hint: 'tree',
      phonetic: '公',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '板',
    definition: 'board, plank; plate, slab; unnatural, stiff',
    pinyin: ['bǎn'],
    decomposition: '⿰木反',
    etymology: {
      type: 'pictophonetic',
      phonetic: '反',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '极',
    definition: 'extreme, top; final, furthest, utmost; pole',
    pinyin: ['jí'],
    decomposition: '⿰木及',
    etymology: {
      type: 'pictophonetic',
      phonetic: '及',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '构',
    definition: 'to compose, to make; building, frame, structure',
    pinyin: ['gòu'],
    decomposition: '⿰木勾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '勾',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '枇',
    definition: 'loquat tree',
    pinyin: ['pí'],
    decomposition: '⿰木比',
    etymology: {
      type: 'pictophonetic',
      phonetic: '比',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '枉',
    definition: 'useless, in vain; crooked, bent',
    pinyin: ['wǎng'],
    decomposition: '⿰木王',
    etymology: {
      type: 'pictophonetic',
      phonetic: '王',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '枋',
    definition: 'sandalwood; lumber',
    pinyin: ['fāng'],
    decomposition: '⿰木方',
    etymology: {
      type: 'ideographic',
      hint: 'A square 方 log 木; 方 also provides the pronunciation',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '析',
    definition: 'to split wood; to divide, to break apart',
    pinyin: ['xī'],
    decomposition: '⿰木斤',
    etymology: {
      type: 'ideographic',
      hint: 'Chopping 斤 wood 木; 斤 also provides the pronunciation',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '枒',
    definition: 'coconut tree; edge, rim',
    pinyin: ['yā'],
    decomposition: '⿰木牙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '牙',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '枓',
    definition: 'capital, base; a pedestal for a flag',
    pinyin: ['dǒu'],
    decomposition: '⿰木斗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斗',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '枕',
    definition: 'pillow',
    pinyin: ['zhěn'],
    decomposition: '⿰木冘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冘',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '林',
    definition: 'forest, grove; surname',
    pinyin: ['lín'],
    decomposition: '⿰木木',
    etymology: {
      type: 'ideographic',
      hint: 'Two trees 木 representing a forest',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '枘',
    definition: 'a handle for a tool',
    pinyin: ['ruì'],
    decomposition: '⿰木内',
    etymology: {
      type: 'pictophonetic',
      phonetic: '内',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '枚',
    definition: 'the stalk of a shrub, the trunk of a tree',
    pinyin: ['méi'],
    decomposition: '⿰木攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '攵',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '果',
    definition: 'fruit, nut; result',
    pinyin: ['guǒ'],
    decomposition: '⿱田木',
    etymology: { type: 'ideographic', hint: 'Fruit 田 growing on a tree 木' },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '枝',
    definition: 'branches, limbs; to branch off',
    pinyin: ['zhī'],
    decomposition: '⿰木支',
    etymology: {
      type: 'pictophonetic',
      phonetic: '支',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '枞',
    definition: 'fir tree',
    pinyin: ['cōng'],
    decomposition: '⿰木从',
    etymology: {
      type: 'pictophonetic',
      phonetic: '从',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '枢',
    definition: 'door hinge; pivot; center of power',
    pinyin: ['shū'],
    decomposition: '⿰木区',
    etymology: {
      type: 'pictophonetic',
      phonetic: '区',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '枣',
    definition: 'date tree; dates, jujubes; surname',
    pinyin: ['zǎo'],
    decomposition: '⿱朿⺀',
    etymology: { type: 'ideographic', hint: 'Dates ⺀ falling off a tree 朿' },
    radical: '木',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '枥',
    definition: 'oak tree; a stable',
    pinyin: ['lì'],
    decomposition: '⿰木历',
    etymology: {
      type: 'pictophonetic',
      phonetic: '历',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '枧',
    definition: 'spout, bamboo tube; wooden peg',
    pinyin: ['jiǎn'],
    decomposition: '⿰木见',
    etymology: {
      type: 'pictophonetic',
      phonetic: '见',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '枨',
    definition: 'jamb, door stop; to touch',
    pinyin: ['chéng'],
    decomposition: '⿰木长',
    etymology: {
      type: 'pictophonetic',
      phonetic: '长',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '枪',
    definition: 'gun, rife; lance, spear',
    pinyin: ['qiāng'],
    decomposition: '⿰木仓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '仓',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '枫',
    definition: 'maple tree',
    pinyin: ['fēng'],
    decomposition: '⿰木风',
    etymology: {
      type: 'pictophonetic',
      phonetic: '风',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '枭',
    definition: 'owl; evil; brave',
    pinyin: ['xiāo'],
    decomposition: '⿱鸟木',
    etymology: { type: 'ideographic', hint: 'A bird 鸟 roosting in a tree 木' },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '枯',
    definition: 'dried out, withered, decayed',
    pinyin: ['kū'],
    decomposition: '⿰木古',
    etymology: {
      type: 'ideographic',
      hint: 'An old 古 tree 木; 古 also provides the pronunciation',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '枰',
    definition: 'smooth board; chessboard; chess',
    pinyin: ['píng'],
    decomposition: '⿰木平',
    etymology: {
      type: 'ideographic',
      hint: 'A flat 平 piece of wood 木; 平 also provides the pronunciation',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '枳',
    definition: 'trifoliate orange; hedge thorn',
    pinyin: ['zhǐ'],
    decomposition: '⿰木只',
    etymology: {
      type: 'pictophonetic',
      phonetic: '只',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '枵',
    definition: 'empty; a hollow tree stump',
    pinyin: ['xiāo'],
    decomposition: '⿰木号',
    etymology: {
      type: 'pictophonetic',
      phonetic: '号',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '架',
    definition: 'frame, rack, stand; to prop up',
    pinyin: ['jià'],
    decomposition: '⿱加木',
    etymology: {
      type: 'pictophonetic',
      phonetic: '加',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '枷',
    definition: 'the stocks, a cangue scaffold',
    pinyin: ['jiā'],
    decomposition: '⿰木加',
    etymology: {
      type: 'pictophonetic',
      phonetic: '加',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '枸',
    definition: 'a kind of aspen found in Sichuan',
    pinyin: ['gǒu'],
    decomposition: '⿰木句',
    etymology: {
      type: 'pictophonetic',
      phonetic: '句',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '枼',
    definition: 'table; flat pieces of wood; a slip, a leaf',
    pinyin: ['yè'],
    decomposition: '⿱世木',
    etymology: {
      type: 'pictophonetic',
      phonetic: '世',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '柁',
    definition: 'the main beam of a house',
    pinyin: ['duò'],
    decomposition: '⿰木它',
    etymology: {
      type: 'pictophonetic',
      phonetic: '它',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '柃',
    definition: 'Eurya japonica',
    pinyin: ['líng'],
    decomposition: '⿰木令',
    etymology: {
      type: 'pictophonetic',
      phonetic: '令',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '柄',
    definition: 'handle, lever, knob; authority',
    pinyin: ['bǐng'],
    decomposition: '⿰木丙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丙',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '柊',
    definition: 'holly',
    pinyin: ['zhōng'],
    decomposition: '⿰木冬',
    etymology: {
      type: 'ideographic',
      hint: 'A winter 冬 tree 木; 冬 also provides the pronunciation',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '柏',
    definition: 'cypress, cedar',
    pinyin: ['bǎi'],
    decomposition: '⿰木白',
    etymology: {
      type: 'pictophonetic',
      phonetic: '白',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '某',
    definition: 'some, someone; a certain thing or person',
    pinyin: ['mǒu'],
    decomposition: '⿱甘木',
    etymology: {
      type: 'ideographic',
      hint: 'The sweet 甘 fruit of a certain tree 木',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '柑',
    definition: 'tangerine, loose-skinned orange',
    pinyin: ['gān'],
    decomposition: '⿰木甘',
    etymology: {
      type: 'ideographic',
      hint: 'A tree 木 bearing sweet fruit 甘; 甘 also provides the pronunciation',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '柒',
    definition: "seven (bankers' anti-fraud numeral)",
    pinyin: ['qī'],
    decomposition: '⿱⿰氵七木',
    etymology: {
      type: 'ideographic',
      hint: 'Seven 七 with accents to prevent forgery ',
    },
    radical: '木',
    matches: [[0, 0], [0, 0], [0, 0], [0, 1], [0, 1], [1], [1], [1], [1]],
  },
  {
    character: '染',
    definition: 'dye; to catch; to infect; to be contagious',
    pinyin: ['rǎn'],
    decomposition: '⿱氿木',
    etymology: {
      type: 'ideographic',
      hint: 'Water 氵 and wine 九 mixed in a wooden 木 bowl',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '柔',
    definition: 'soft, supple; gentle; flexible',
    pinyin: ['róu'],
    decomposition: '⿱矛木',
    etymology: {
      type: 'ideographic',
      hint: 'Wood 木 so soft it can be cut 矛',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '柘',
    definition: 'cudrania, mulberry; sugarcane',
    pinyin: ['zhè'],
    decomposition: '⿰木石',
    etymology: {
      type: 'pictophonetic',
      phonetic: '石',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '柙',
    definition: 'a cage or pen for wild animals',
    pinyin: ['xiá'],
    decomposition: '⿰木甲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甲',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '柚',
    definition: 'grapefruit, pomelo',
    pinyin: ['yòu'],
    decomposition: '⿰木由',
    etymology: {
      type: 'pictophonetic',
      phonetic: '由',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '柜',
    definition: 'cabinet, cupboard, wardrobe; shop counter',
    pinyin: ['guì'],
    decomposition: '⿰木巨',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巨',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '柝',
    definition: "a watchman's rattle",
    pinyin: ['tuò'],
    decomposition: '⿰木斥',
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '柞',
    definition: 'beech, oak; evergreen; to clear away trees',
    pinyin: ['zhà'],
    decomposition: '⿰木乍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乍',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '柠',
    definition: 'lemon',
    pinyin: ['níng'],
    decomposition: '⿰木宁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宁',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '柢',
    definition: 'root, base',
    pinyin: ['dǐ'],
    decomposition: '⿰木氐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '氐',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '查',
    definition: 'to investigate, to examine, to look into',
    pinyin: ['chá'],
    decomposition: '⿱木旦',
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '柩',
    definition: 'bier, coffin',
    pinyin: ['jiù'],
    decomposition: '⿰木匛',
    etymology: {
      type: 'ideographic',
      hint: 'A wooden 木 coffin 匛; 匛 also provides the pronunciation',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '柬',
    definition: 'card, letter, invitation, note',
    pinyin: ['jiǎn'],
    decomposition: '⿻束八',
    etymology: { type: 'ideographic', hint: 'A bound 束 package' },
    radical: '木',
    matches: [[0], [0], [0], [1], [1], [0], [0], [0], [0]],
  },
  {
    character: '柯',
    definition: 'axe-handle, bough, stalk; surname',
    pinyin: ['kē'],
    decomposition: '⿰木可',
    etymology: {
      type: 'pictophonetic',
      phonetic: '可',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '柰',
    definition: 'crab-apple tree; to endure, to bear',
    pinyin: ['nài'],
    decomposition: '⿱木示',
    etymology: {
      type: 'pictophonetic',
      phonetic: '示',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '柱',
    definition: 'to lean on; pillar, post, support',
    pinyin: ['zhù'],
    decomposition: '⿰木主',
    etymology: {
      type: 'pictophonetic',
      phonetic: '主',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '柳',
    definition: 'willow tree; pleasure; surname',
    pinyin: ['liǔ'],
    decomposition: '⿰木卯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卯',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '柴',
    definition: 'firewood, faggots, fuel; surname',
    pinyin: ['chái'],
    decomposition: '⿱此木',
    etymology: {
      type: 'pictophonetic',
      phonetic: '此',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '柵',
    definition: 'fence, grid, palisade',
    pinyin: ['zhà'],
    decomposition: '⿰木冊',
    etymology: {
      type: 'ideographic',
      hint: 'A fence 冊 made of wood 木; 冊 also provides the pronunciation',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '柽',
    definition: 'willow, tamarisk',
    pinyin: ['chēng'],
    decomposition: '⿰木圣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '圣',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '柿',
    definition: 'persimmon',
    pinyin: ['shì'],
    decomposition: '⿰木市',
    etymology: {
      type: 'pictophonetic',
      phonetic: '市',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '栀',
    definition: 'jasmine; Gardenia',
    pinyin: ['zhī'],
    decomposition: '⿰木卮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卮',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '栅',
    definition: 'fence, grid, palisade',
    pinyin: ['zhà'],
    decomposition: '⿰木册',
    etymology: {
      type: 'ideographic',
      hint: 'A fence 册 made of wood 木; 册 also provides the pronunciation',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '标',
    definition: 'mark, sign, symbol; bid, prize',
    pinyin: ['biāo'],
    decomposition: '⿰木示',
    etymology: {
      type: 'pictophonetic',
      phonetic: '票',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '栈',
    definition: 'warehouse; tavern, inn',
    pinyin: ['zhàn'],
    decomposition: '⿰木戋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戋',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '栉',
    definition: 'comb; to comb out, to eliminate, to weed out',
    pinyin: ['zhì'],
    decomposition: '⿰木节',
    etymology: {
      type: 'ideographic',
      hint: 'A wooden 木 comb 节; 节 also provides the pronunciation',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '栊',
    definition: 'cage, pen; grating',
    pinyin: ['lóng'],
    decomposition: '⿰木龙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龙',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '栋',
    definition: 'ridge-beam; the main support of a house',
    pinyin: ['dòng'],
    decomposition: '⿰木东',
    etymology: {
      type: 'pictophonetic',
      phonetic: '东',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '栌',
    definition: 'sumac; loquat; the capital of a column',
    pinyin: ['lú'],
    decomposition: '⿰木卢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卢',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '栎',
    definition: 'chestnut-leaved oak',
    pinyin: ['lì'],
    decomposition: '⿰木乐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乐',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '栏',
    definition: 'fence, railing, balustrade',
    pinyin: ['lán'],
    decomposition: '⿰木兰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兰',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '树',
    definition: 'tree; to plant; to set up, to establish',
    pinyin: ['shù'],
    decomposition: '⿰木对',
    etymology: {
      type: 'pictophonetic',
      phonetic: '对',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '栓',
    definition: 'cork, peg, stopper',
    pinyin: ['shuān'],
    decomposition: '⿰木全',
    etymology: {
      type: 'pictophonetic',
      phonetic: '全',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '栖',
    definition: 'perch, roost, to stay',
    pinyin: ['qī'],
    decomposition: '⿰木西',
    etymology: {
      type: 'pictophonetic',
      phonetic: '西',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '栗',
    definition: 'chestnut tree; chestnuts; surname',
    pinyin: ['lì'],
    decomposition: '⿱覀木',
    etymology: {
      type: 'ideographic',
      hint: 'A tree 木 bearing nuts 覀; compare 果',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '栝',
    definition: "a builder's frame for measuring",
    pinyin: ['guā'],
    decomposition: '⿰木舌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '舌',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '校',
    definition: 'school; military field officer',
    pinyin: ['xiào'],
    decomposition: '⿰木交',
    etymology: {
      type: 'pictophonetic',
      phonetic: '交',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '栩',
    definition: 'oak tree; pleased, glad',
    pinyin: ['xǔ'],
    decomposition: '⿰木羽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羽',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '株',
    definition: 'root, stump; measure word for trees',
    pinyin: ['zhū'],
    decomposition: '⿰木朱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朱',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '栱',
    definition: 'stake, post; pillar; peg',
    pinyin: ['gǒng'],
    decomposition: '⿰木共',
    etymology: {
      type: 'pictophonetic',
      phonetic: '共',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '栲',
    definition: 'mangrove',
    pinyin: ['kǎo'],
    decomposition: '⿰木考',
    etymology: {
      type: 'pictophonetic',
      phonetic: '考',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '栳',
    definition: 'basket',
    pinyin: ['lǎo'],
    decomposition: '⿰木老',
    etymology: {
      type: 'pictophonetic',
      phonetic: '老',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '栴',
    definition: 'sandalwood',
    pinyin: ['zhān'],
    decomposition: '⿰木⿱？丹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丹',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], null, null, [1, 1], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '样',
    definition: 'form, pattern, shape, style',
    pinyin: ['yàng'],
    decomposition: '⿰木羊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羊',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '核',
    definition: 'core, kernel; nut, seed; atom',
    pinyin: ['hé'],
    decomposition: '⿰木亥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亥',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '根',
    definition: 'root, basis, foundation',
    pinyin: ['gēn'],
    decomposition: '⿰木艮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '艮',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '格',
    definition: 'form, pattern, standard',
    pinyin: ['gé'],
    decomposition: '⿰木各',
    etymology: {
      type: 'pictophonetic',
      phonetic: '各',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '栽',
    definition: 'to cultivate, to plant, to tend',
    pinyin: ['zāi'],
    decomposition: '⿹戈木',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戈',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [null, null, [0], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '栾',
    definition: 'varnish tree; surname',
    pinyin: ['luán'],
    decomposition: '⿱亦木',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亦',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '桀',
    definition: 'chicken roost; ancient emperor',
    pinyin: ['jié'],
    decomposition: '⿱舛木',
    etymology: { type: 'pictophonetic', semantic: '木', hint: 'tree' },
    radical: '木',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '桁',
    definition: 'the cross-beams of a roof',
    pinyin: ['héng'],
    decomposition: '⿰木行',
    etymology: {
      type: 'pictophonetic',
      phonetic: '行',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '桂',
    definition: 'cassia, cinnamon',
    pinyin: ['guì'],
    decomposition: '⿰木圭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '圭',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '桃',
    definition: 'peach; marriage; surname',
    pinyin: ['táo'],
    decomposition: '⿰木兆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兆',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '桄',
    definition: 'coir-palm; ladder rung',
    pinyin: ['guāng'],
    decomposition: '⿰木光',
    etymology: {
      type: 'pictophonetic',
      phonetic: '光',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '桅',
    definition: "a ship's mast",
    pinyin: ['wéi'],
    decomposition: '⿰木危',
    etymology: {
      type: 'pictophonetic',
      phonetic: '危',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '框',
    definition: 'door; frame',
    pinyin: ['kuāng'],
    decomposition: '⿰木匡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匡',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '案',
    definition: 'file, legal case; bench, table',
    pinyin: ['àn'],
    decomposition: '⿱安木',
    etymology: {
      type: 'pictophonetic',
      phonetic: '安',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '桉',
    definition: 'eucalyptus',
    pinyin: ['ān'],
    decomposition: '⿰木安',
    etymology: {
      type: 'pictophonetic',
      phonetic: '安',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '桊',
    definition: 'ash tree',
    pinyin: ['juàn'],
    decomposition: '⿱龹木',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龹',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '桌',
    definition: 'table, stand, desk, counter',
    pinyin: ['zhuō'],
    decomposition: '⿱卓木',
    radical: '木',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '桎',
    definition: 'shackles, fetters, handcuffs',
    pinyin: ['zhì'],
    decomposition: '⿰木至',
    etymology: {
      type: 'pictophonetic',
      phonetic: '至',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '桐',
    definition: 'Chinese wood-oil tree, Vernicia fordii',
    pinyin: ['tóng'],
    decomposition: '⿰木同',
    etymology: {
      type: 'pictophonetic',
      phonetic: '同',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '桑',
    definition: 'mulberry tree; surname',
    pinyin: ['sāng'],
    decomposition: '⿱叒木',
    etymology: { type: 'ideographic', hint: 'A tree 木 bearing berries 叒' },
    radical: '木',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '桓',
    definition: 'variety of tree; surname',
    pinyin: ['huán'],
    decomposition: '⿰木亘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亘',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '桔',
    definition: 'orange, tangerine',
    pinyin: ['jú'],
    decomposition: '⿰木吉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吉',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '桕',
    definition: 'tallow tree',
    pinyin: ['jiù'],
    decomposition: '⿰木臼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臼',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '桠',
    definition: 'tree fork',
    pinyin: ['yā'],
    decomposition: '⿰木亚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亚',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '桡',
    definition: 'radius, forearm; a bent or twisted piece of wood',
    pinyin: ['ráo'],
    decomposition: '⿰木尧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尧',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '桢',
    definition: 'hardwood; posts, supports',
    pinyin: ['zhēn'],
    decomposition: '⿰木贞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贞',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '档',
    definition: 'shelve, frame; files, records; grade, level',
    pinyin: ['dàng'],
    decomposition: '⿰木当',
    etymology: {
      type: 'pictophonetic',
      phonetic: '当',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '桤',
    definition: 'alder',
    pinyin: ['qī'],
    decomposition: '⿰木岂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '岂',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '桥',
    definition: 'bridge; beam, crosspiece',
    pinyin: ['qiáo'],
    decomposition: '⿰木乔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乔',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '桦',
    definition: 'a type of birch tree',
    pinyin: ['huà'],
    decomposition: '⿰木华',
    etymology: {
      type: 'pictophonetic',
      phonetic: '华',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '桧',
    definition: 'Chinese cypress, Chinese juniper',
    pinyin: ['guì'],
    decomposition: '⿰木会',
    etymology: {
      type: 'pictophonetic',
      phonetic: '会',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '桨',
    definition: 'paddle, oar',
    pinyin: ['jiǎng'],
    decomposition: '⿱⿰丬夕木',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丬',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '桩',
    definition: 'stake, post; matter, affair',
    pinyin: ['zhuāng'],
    decomposition: '⿰木庄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '庄',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '桫',
    definition: 'horse chestnut',
    pinyin: ['suō'],
    decomposition: '⿰木沙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '沙',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '桲',
    definition: 'quince',
    pinyin: ['po'],
    decomposition: '⿰木孛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孛',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '桴',
    definition: 'beam, rafter',
    pinyin: ['fú'],
    decomposition: '⿰木孚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孚',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '桶',
    definition: 'bucket, pail, tub; can, cask, keg',
    pinyin: ['tǒng'],
    decomposition: '⿰木甬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甬',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '桷',
    definition: 'rafter; Malus toringo',
    pinyin: ['jué'],
    decomposition: '⿰木角',
    etymology: {
      type: 'pictophonetic',
      phonetic: '角',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '桼',
    definition: 'the varnish tree; varnish, lacquer; paint',
    pinyin: ['qī'],
    decomposition: '⿱木⿱人氺',
    etymology: {
      type: 'ideographic',
      hint: 'A tree 木 whose sap 氺 is used as varnish',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '桿',
    definition: 'cane, pole, stick',
    pinyin: ['gān'],
    decomposition: '⿰木旱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旱',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '梁',
    definition: 'bridge; beam, rafter; surname',
    pinyin: ['liáng'],
    decomposition: '⿱⿰氵刅木',
    etymology: {
      type: 'ideographic',
      hint: 'A wooden 木 bridge built 刅 over a river 氵',
    },
    radical: '木',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '梃',
    definition: 'stalk, wooden club; straight',
    pinyin: ['tǐng'],
    decomposition: '⿰木廷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '廷',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '梅',
    definition: 'plum; prune; surname',
    pinyin: ['méi'],
    decomposition: '⿰木每',
    etymology: {
      type: 'pictophonetic',
      phonetic: '每',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '梆',
    definition: "a watchman's rattle",
    pinyin: ['bāng'],
    decomposition: '⿰木邦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '邦',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '梏',
    definition: 'handcuffs, manacles; fetters',
    pinyin: ['gù'],
    decomposition: '⿰木告',
    etymology: {
      type: 'pictophonetic',
      phonetic: '告',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '梓',
    definition: 'Catalpa ovata',
    pinyin: ['zǐ'],
    decomposition: '⿰木辛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辛',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '梔',
    definition: 'jasmine; Gardenia',
    pinyin: ['zhī'],
    decomposition: '⿰木巵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巵',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '梗',
    definition: 'stem, branch; to hinder, to block',
    pinyin: ['gěng'],
    decomposition: '⿰木更',
    etymology: {
      type: 'pictophonetic',
      phonetic: '更',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '條',
    definition: 'clause, condition; string, stripe',
    pinyin: ['tiáo'],
    decomposition: '⿲亻丨条',
    etymology: {
      type: 'ideographic',
      hint: 'A person 亻 counting 丨; 条 provides the pronunciation',
    },
    radical: '木',
    matches: [[0], [0], [1], [2], [2], [2], [2], [2], [2], [2], [2]],
  },
  {
    character: '梟',
    definition: 'owl; evil; brave',
    pinyin: ['xiāo'],
    decomposition: '⿱鳥木',
    etymology: { type: 'ideographic', hint: 'A bird 鳥 roosting in a tree 木' },
    radical: '木',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '梢',
    definition: 'the tip of a branch; rudder',
    pinyin: ['shāo'],
    decomposition: '⿰木肖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肖',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '梣',
    definition: 'Chinese ash',
    pinyin: ['cén'],
    decomposition: '⿰木岑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '岑',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '梦',
    definition: 'dream',
    pinyin: ['mèng'],
    decomposition: '⿱林夕',
    etymology: { type: 'ideographic', hint: 'Two eyes shut 林 at night 夕' },
    radical: '木',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '梧',
    definition: 'Chinese parasol tree, Sterculia platanifolia',
    pinyin: ['wú'],
    decomposition: '⿰木吾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吾',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '梨',
    definition: 'pear; opera',
    pinyin: ['lí'],
    decomposition: '⿱利木',
    etymology: {
      type: 'pictophonetic',
      phonetic: '利',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '梭',
    definition: "a weaver's shuttle; to go back and forth",
    pinyin: ['suō'],
    decomposition: '⿰木夋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夋',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '梯',
    definition: 'ladder, steps, stairs',
    pinyin: ['tī'],
    decomposition: '⿰木弟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弟',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '械',
    definition: 'weapons; tools; instruments',
    pinyin: ['xiè'],
    decomposition: '⿰木戒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戒',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '梳',
    definition: 'brush, comb',
    pinyin: ['shū'],
    decomposition: '⿰木㐬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㐬',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '梵',
    definition: 'Buddhist, Sanskrit',
    pinyin: ['fàn'],
    decomposition: '⿱林凡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '凡',
      semantic: '林',
      hint: 'forest',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '梼',
    definition: 'wood block; idiot, blockhead',
    pinyin: ['táo'],
    decomposition: '⿰木寿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寿',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '梾',
    definition: 'dogwood; Cornus macrophylla',
    pinyin: ['lái'],
    decomposition: '⿰木来',
    etymology: {
      type: 'pictophonetic',
      phonetic: '来',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '梿',
    definition: 'flail; to thresh',
    pinyin: ['lián'],
    decomposition: '⿰木连',
    etymology: {
      type: 'pictophonetic',
      phonetic: '连',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '检',
    definition: 'to check, to examine, to inspect',
    pinyin: ['jiǎn'],
    decomposition: '⿰木佥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '佥',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '棂',
    definition: 'carved or patterned window sills',
    pinyin: ['líng'],
    decomposition: '⿰木灵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '灵',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '棄',
    definition: 'to abandon, to discard, to reject; to desert; to forget',
    pinyin: ['qì'],
    decomposition: '⿳⿱亠厶廾木',
    radical: '木',
    matches: [
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '棉',
    definition: 'cotton; cotton-padded',
    pinyin: ['mián'],
    decomposition: '⿰木帛',
    etymology: { type: 'ideographic', hint: 'Silk 帛 picked off a tree 木' },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '棋',
    definition: 'chess; any strategy game',
    pinyin: ['qí'],
    decomposition: '⿰木其',
    etymology: {
      type: 'pictophonetic',
      phonetic: '其',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '棍',
    definition: 'stick, cudgel; scoundrel',
    pinyin: ['gùn'],
    decomposition: '⿰木昆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昆',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '棒',
    definition: 'stick, club; strong, smart; to hit',
    pinyin: ['bàng'],
    decomposition: '⿰木奉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奉',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '棕',
    definition: 'hemp palm; palm tree',
    pinyin: ['zōng'],
    decomposition: '⿰木宗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宗',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '棗',
    definition: 'date tree; dates, jujubes; surname',
    pinyin: ['zǎo'],
    decomposition: '⿱朿朿',
    etymology: { type: 'ideographic', hint: 'A tree 朿 with many thorns 朿' },
    radical: '木',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '棘',
    definition: 'jujube tree; thorns, brambles',
    pinyin: ['jí'],
    decomposition: '⿰朿朿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朿',
      semantic: '朿',
      hint: 'thorn',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '棚',
    definition: 'shack, shed; tent, awning',
    pinyin: ['péng'],
    decomposition: '⿰木朋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朋',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '棟',
    definition: 'ridge-beam; the main support of a house',
    pinyin: ['dòng'],
    decomposition: '⿰木東',
    etymology: {
      type: 'pictophonetic',
      phonetic: '東',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '棠',
    definition: 'crabapple tree; wild plum',
    pinyin: ['táng'],
    decomposition: '⿱尚木',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尚',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '棣',
    definition: 'cherry; Kerria japonica',
    pinyin: ['dì'],
    decomposition: '⿰木隶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隶',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '棥',
    definition: 'railing, fence, enclosed place',
    pinyin: ['fán'],
    decomposition: '⿲木爻木',
    etymology: {
      type: 'ideographic',
      hint: 'Forests 木 separated by a fence 爻',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [2], [2], [2], [2]],
  },
  {
    character: '棧',
    definition: 'warehouse; tavern, inn',
    pinyin: ['zhàn'],
    decomposition: '⿰木戔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戔',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '森',
    definition: 'forest; luxuriant vegetation',
    pinyin: ['sēn'],
    decomposition: '⿱木⿰木木',
    etymology: { type: 'ideographic', hint: 'Many trees 木 forming a forest' },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '棰',
    definition: 'to whip, to flog',
    pinyin: ['chuí'],
    decomposition: '⿰木垂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '垂',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '棱',
    definition: 'squared timber; angle, corner, edge',
    pinyin: ['léng'],
    decomposition: '⿰木夌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夌',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '棲',
    definition: 'perch, roost, to stay',
    pinyin: ['qī'],
    decomposition: '⿰木妻',
    etymology: {
      type: 'pictophonetic',
      phonetic: '妻',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '棵',
    definition: 'measure word for trees',
    pinyin: ['kē'],
    decomposition: '⿰木果',
    etymology: {
      type: 'pictophonetic',
      phonetic: '果',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '棶',
    definition: 'dogwood; Cornus macrophylla',
    pinyin: ['lái'],
    decomposition: '⿰木來',
    etymology: {
      type: 'pictophonetic',
      phonetic: '來',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '棹',
    definition: 'oar; boat',
    pinyin: ['zhào'],
    decomposition: '⿰木卓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卓',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '棺',
    definition: 'coffin',
    pinyin: ['guān'],
    decomposition: '⿰木官',
    etymology: {
      type: 'pictophonetic',
      phonetic: '官',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '棻',
    definition: 'sandalwood',
    pinyin: ['fēn'],
    decomposition: '⿱艹⿱分木',
    etymology: {
      type: 'pictophonetic',
      phonetic: '分',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '棼',
    definition: 'rafters; disordered, confused',
    pinyin: ['fén'],
    decomposition: '⿱林分',
    etymology: {
      type: 'pictophonetic',
      phonetic: '分',
      semantic: '林',
      hint: 'forest',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '椁',
    definition: 'outer-coffin; vault',
    pinyin: ['guǒ'],
    decomposition: '⿰木享',
    etymology: { type: 'pictophonetic', semantic: '木', hint: 'wood' },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '椅',
    definition: 'chair, seat',
    pinyin: ['yǐ'],
    decomposition: '⿰木奇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奇',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '椆',
    definition: 'a species of tree resistant to cold weather',
    pinyin: ['chóu'],
    decomposition: '⿰木周',
    etymology: {
      type: 'pictophonetic',
      phonetic: '周',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '椋',
    definition: 'fruit',
    pinyin: ['liáng'],
    decomposition: '⿰木京',
    etymology: {
      type: 'pictophonetic',
      phonetic: '京',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '植',
    definition: 'tree, plant; to grow',
    pinyin: ['zhí'],
    decomposition: '⿰木直',
    etymology: {
      type: 'pictophonetic',
      phonetic: '直',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '椎',
    definition: 'spine, vertebra; hammer, mallet',
    pinyin: ['chuí'],
    decomposition: '⿰木隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隹',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '椐',
    definition: 'Zelkowa acuminata',
    pinyin: ['jū'],
    decomposition: '⿰木居',
    etymology: {
      type: 'pictophonetic',
      phonetic: '居',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '椒',
    definition: 'pepper, spice',
    pinyin: ['jiāo'],
    decomposition: '⿰木叔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叔',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '椟',
    definition: 'cabinet, closet, wardrobe',
    pinyin: ['dú'],
    decomposition: '⿰木卖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卖',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '椠',
    definition: 'wooden tablet; edition',
    pinyin: ['qiàn'],
    decomposition: '⿱斩木',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斩',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '椤',
    definition: 'tree; tree fern',
    pinyin: ['luó'],
    decomposition: '⿰木罗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '罗',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '椥',
    pinyin: ['zhī'],
    decomposition: '⿰木知',
    etymology: {
      type: 'pictophonetic',
      phonetic: '知',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '椪',
    definition: 'Machilus nanmu, a variety of evergreen',
    pinyin: ['pèng'],
    decomposition: '⿰木並',
    etymology: {
      type: 'pictophonetic',
      phonetic: '並',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '椭',
    definition: 'elliptical, oval-shaped; tubular',
    pinyin: ['tuǒ'],
    decomposition: '⿰木陏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '陏',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '椰',
    definition: 'palm tree, coconut tree',
    pinyin: ['yē'],
    decomposition: '⿰木耶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '耶',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '椴',
    definition: 'aspen, poplar',
    pinyin: ['duàn'],
    decomposition: '⿰木段',
    etymology: {
      type: 'pictophonetic',
      phonetic: '段',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '椹',
    definition: 'chopping board',
    pinyin: ['shèn'],
    decomposition: '⿰木甚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甚',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '椽',
    definition: 'beams, rafters, supports',
    pinyin: ['chuán'],
    decomposition: '⿰木彖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彖',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '椿',
    definition: 'Chinese toon tree; father (poetic)',
    pinyin: ['chūn'],
    decomposition: '⿰木春',
    etymology: {
      type: 'pictophonetic',
      phonetic: '春',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '楂',
    definition: 'raft; to hew, to fell trees',
    pinyin: ['zhā'],
    decomposition: '⿰木查',
    etymology: {
      type: 'pictophonetic',
      phonetic: '查',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '楊',
    definition: 'willow, poplar, aspen; surname',
    pinyin: ['yáng'],
    decomposition: '⿰木昜',
    etymology: {
      type: 'pictophonetic',
      semantic: '木',
      hint: 'tree',
      phonetic: '昜',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '楓',
    definition: 'maple tree',
    pinyin: ['fēng'],
    decomposition: '⿰木風',
    etymology: {
      type: 'pictophonetic',
      phonetic: '風',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '楔',
    definition: 'to wedge; wedge, gatepost; forward',
    pinyin: ['xiē'],
    decomposition: '⿰木契',
    etymology: {
      type: 'pictophonetic',
      phonetic: '契',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '楗',
    definition: 'latch, crossbar',
    pinyin: ['jiàn'],
    decomposition: '⿰木建',
    etymology: {
      type: 'pictophonetic',
      phonetic: '建',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '楙',
    definition: 'Cydonia japonica; lush',
    pinyin: ['mào'],
    decomposition: '⿲木矛木',
    etymology: {
      type: 'pictophonetic',
      phonetic: '矛',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [2], [2], [2], [2]],
  },
  {
    character: '楚',
    definition: 'clear, distinct; pain, suffering; surname',
    pinyin: ['chǔ'],
    decomposition: '⿱林疋',
    radical: '木',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '楛',
    definition: 'coarse, crude; a kind of plant',
    pinyin: ['hù'],
    decomposition: '⿰木苦',
    etymology: {
      type: 'ideographic',
      hint: 'A bitter 苦 plant 木; 苦 also provides the pronunciation',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '楝',
    definition: 'Melia japonica',
    pinyin: ['liàn'],
    decomposition: '⿰木柬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '柬',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '楞',
    definition: 'used for Ceylon in Buddhist texts',
    pinyin: ['léng'],
    decomposition: '⿰木⿱罒方',
    etymology: {
      type: 'pictophonetic',
      phonetic: '罒',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '楠',
    definition: 'Machilus nanmu',
    pinyin: ['nán'],
    decomposition: '⿰木南',
    etymology: {
      type: 'pictophonetic',
      phonetic: '南',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '楣',
    definition: 'crossbar; lintel',
    pinyin: ['méi'],
    decomposition: '⿰木眉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '眉',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '楦',
    definition: 'shoe last; to stretch a shoe; to turn a lathe',
    pinyin: ['xuàn'],
    decomposition: '⿰木宣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宣',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '楨',
    definition: 'hardwood; posts, supports',
    pinyin: ['zhēn'],
    decomposition: '⿰木貞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '貞',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '楫',
    definition: 'paddle, oar',
    pinyin: ['jí'],
    decomposition: '⿰木咠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咠',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '業',
    definition: 'business, profession; to study, to work',
    pinyin: ['yè'],
    decomposition: '⿱业⿱？未',
    etymology: {
      type: 'ideographic',
      hint: 'A musical instrument 业 made of wood 木',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      null,
      null,
      null,
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '楮',
    definition: 'mulberry; paper',
    pinyin: ['chǔ'],
    decomposition: '⿰木者',
    etymology: {
      type: 'pictophonetic',
      phonetic: '者',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '楱',
    pinyin: ['zòu'],
    decomposition: '⿰木奏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奏',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '極',
    definition: 'extreme, top; final, furthest, utmost; pole',
    pinyin: ['jí'],
    decomposition: '⿰木亟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亟',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '楷',
    definition: 'the normal style of Chinese handwriting',
    pinyin: ['kǎi'],
    decomposition: '⿰木皆',
    etymology: {
      type: 'ideographic',
      hint: 'The script 木 used by commoners 皆',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '楸',
    definition: 'Mallotus japonicus',
    pinyin: ['qiū'],
    decomposition: '⿰木秋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '秋',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '楹',
    definition: 'pillar, column',
    pinyin: ['yíng'],
    decomposition: '⿰木盈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '盈',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '楼',
    definition: 'multi-story building; floor',
    pinyin: ['lóu'],
    decomposition: '⿰木娄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '娄',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '榀',
    pinyin: ['pǐn'],
    decomposition: '⿰木品',
    etymology: {
      type: 'pictophonetic',
      phonetic: '品',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '概',
    definition: 'generally, probably, approximately',
    pinyin: ['gài'],
    decomposition: '⿰木既',
    etymology: {
      type: 'pictophonetic',
      phonetic: '既',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '榄',
    definition: 'olive',
    pinyin: ['lǎn'],
    decomposition: '⿰木览',
    etymology: {
      type: 'pictophonetic',
      phonetic: '览',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '榅',
    definition: 'pillar; conifer; Cryptomeria',
    pinyin: ['wēn'],
    decomposition: '⿰木昷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昷',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '榆',
    definition: 'elm tree',
    pinyin: ['yú'],
    decomposition: '⿰木俞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '俞',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '榇',
    definition: 'coffin; tung tree',
    pinyin: ['chèn'],
    decomposition: '⿰木亲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亲',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '榈',
    definition: 'palm tree',
    pinyin: ['lǘ'],
    decomposition: '⿰木闾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '闾',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '榉',
    definition: 'a type of elm tree',
    pinyin: ['jǔ'],
    decomposition: '⿰木举',
    etymology: {
      type: 'pictophonetic',
      phonetic: '举',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '榍',
    pinyin: ['xiè'],
    decomposition: '⿰木屑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屑',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '榔',
    definition: 'betel-nut tree',
    pinyin: ['láng'],
    decomposition: '⿰木郎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '郎',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '榕',
    definition: 'banyan tree',
    pinyin: ['róng'],
    decomposition: '⿰木容',
    etymology: {
      type: 'pictophonetic',
      phonetic: '容',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '榘',
    definition: 'rule, regulation; pattern; to carve',
    pinyin: ['jǔ'],
    decomposition: '⿱矩木',
    etymology: {
      type: 'ideographic',
      hint: "A wooden 木 carpenter's square 矩; 矩 also provides the pronunciation",
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '榛',
    definition: 'hazelnut; thicket, underbrush',
    pinyin: ['zhēn'],
    decomposition: '⿰木秦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '秦',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '榜',
    definition: 'placard, notice, announcement; a list of names',
    pinyin: ['bǎng'],
    decomposition: '⿰木旁',
    etymology: {
      type: 'ideographic',
      hint: 'A sign posted 旁 on a tree 木; 旁 also provides the pronunciation',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '榧',
    definition: 'a type of yew tree',
    pinyin: ['fěi'],
    decomposition: '⿰木匪',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匪',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '榨',
    definition: 'to press for juice; a juicer; a vegetable',
    pinyin: ['zhà'],
    decomposition: '⿰木窄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '窄',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '榫',
    definition: 'mortise and tenon; to fit into',
    pinyin: ['sǔn'],
    decomposition: '⿰木隼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隼',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '榭',
    definition: 'pavilion, kiosk',
    pinyin: ['xiè'],
    decomposition: '⿰木射',
    etymology: {
      type: 'pictophonetic',
      phonetic: '射',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '榮',
    definition: 'glory, honor; to flourish, to prosper',
    pinyin: ['róng'],
    decomposition: '⿳炏冖木',
    etymology: {
      type: 'ideographic',
      hint: 'Grass 炏 and trees 木 flourishing in a garden 冖',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '榱',
    definition: 'rafter',
    pinyin: ['cuī'],
    decomposition: '⿰木衰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '衰',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '榲',
    definition: 'pillar; conifer; Cryptomeria',
    pinyin: ['wēn'],
    decomposition: '⿰木⿱囚皿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皿',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '榴',
    definition: 'pomegranate',
    pinyin: ['liú'],
    decomposition: '⿰木留',
    etymology: {
      type: 'pictophonetic',
      phonetic: '留',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '榷',
    definition: 'footbridge; levy, toll; monopoly',
    pinyin: ['què'],
    decomposition: '⿰木隺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隺',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '榻',
    definition: 'bed, cot, couch',
    pinyin: ['tà'],
    decomposition: '⿰木⿱日羽',
    etymology: {
      type: 'ideographic',
      hint: 'A bed of wood 木 and feathers 羽 to sleep in at night 日',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '榿',
    definition: 'alder',
    pinyin: ['qī'],
    decomposition: '⿰木豈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豈',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '槀',
    definition: 'draft, manuscript',
    pinyin: ['gǎo'],
    decomposition: '⿱高木',
    etymology: {
      type: 'pictophonetic',
      phonetic: '高',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '槁',
    definition: 'to wither; withered, rotten, dead',
    pinyin: ['gǎo'],
    decomposition: '⿰木高',
    etymology: {
      type: 'pictophonetic',
      phonetic: '高',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '槃',
    definition: 'tray; to rotate, to turn; to search',
    pinyin: ['pán'],
    decomposition: '⿱般木',
    etymology: {
      type: 'pictophonetic',
      phonetic: '般',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '槊',
    definition: 'spear, lance',
    pinyin: ['shuò'],
    decomposition: '⿱朔木',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朔',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '構',
    definition: 'to compose, to make; building, frame, structure',
    pinyin: ['gòu'],
    decomposition: '⿰木冓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冓',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '槌',
    definition: 'hammer, mallet; to beat, to strike',
    pinyin: ['chuí'],
    decomposition: '⿰木追',
    etymology: {
      type: 'pictophonetic',
      phonetic: '追',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '槍',
    definition: 'gun, rife; lance, spear',
    pinyin: ['qiāng'],
    decomposition: '⿰木倉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '倉',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '槎',
    definition: 'raft; time, occasion; to hew',
    pinyin: ['chá'],
    decomposition: '⿰木差',
    etymology: {
      type: 'pictophonetic',
      phonetic: '差',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '槐',
    definition: 'locust tree',
    pinyin: ['huái'],
    decomposition: '⿰木鬼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鬼',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '槓',
    definition: 'pole, bar; lever, crowbar',
    pinyin: ['gàng'],
    decomposition: '⿰木貢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '貢',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '槔',
    definition: 'pulley',
    pinyin: ['gāo'],
    decomposition: '⿰木皋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皋',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '槛',
    definition: 'threshold, door frame',
    pinyin: ['kǎn'],
    decomposition: '⿰木监',
    etymology: {
      type: 'pictophonetic',
      phonetic: '监',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '槜',
    definition: 'white plum',
    pinyin: ['zuì'],
    decomposition: '⿰木隽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隹',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '槟',
    definition: 'betel-nut, areca nut',
    pinyin: ['bīn'],
    decomposition: '⿰木宾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宾',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '槠',
    definition: 'oak tree',
    pinyin: ['zhū'],
    decomposition: '⿰木诸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '诸',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '槤',
    definition: 'flail; to thresh',
    pinyin: ['lián'],
    decomposition: '⿰木連',
    etymology: {
      type: 'pictophonetic',
      phonetic: '連',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '槨',
    definition: 'outer-coffin; vault',
    pinyin: ['guǒ'],
    decomposition: '⿰木郭',
    etymology: {
      type: 'pictophonetic',
      semantic: '木',
      hint: 'wood',
      phonetic: '郭',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '槭',
    definition: 'maple tree',
    pinyin: ['qī'],
    decomposition: '⿰木戚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戚',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '槲',
    definition: 'a type of oak tree',
    pinyin: ['hú'],
    decomposition: '⿰木斛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斛',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '槳',
    definition: 'paddle, oar',
    pinyin: ['jiǎng'],
    decomposition: '⿱將木',
    etymology: {
      type: 'pictophonetic',
      phonetic: '將',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '槺',
    definition: 'warehouse, large room',
    pinyin: ['kāng'],
    decomposition: '⿰木康',
    etymology: {
      type: 'pictophonetic',
      phonetic: '康',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '槽',
    definition: 'trough, manger; vat, tank; distillery',
    pinyin: ['cáo'],
    decomposition: '⿰木曹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曹',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '槿',
    definition: 'hibiscus',
    pinyin: ['jǐn'],
    decomposition: '⿰木堇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堇',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '樂',
    definition: 'cheerful, happy, laughing; music',
    pinyin: ['lè'],
    decomposition: '⿱⿲幺白幺木',
    etymology: {
      type: 'ideographic',
      hint: 'A musical instrument with wood 木, strings 幺, and a pick 白',
    },
    radical: '木',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 2],
      [0, 2],
      [0, 2],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '樅',
    definition: 'fir tree',
    pinyin: ['cōng'],
    decomposition: '⿰木從',
    etymology: {
      type: 'pictophonetic',
      phonetic: '從',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '樆',
    definition: 'rowan, mountain ash',
    pinyin: ['lí'],
    decomposition: '⿰木离',
    etymology: {
      type: 'pictophonetic',
      phonetic: '离',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '樊',
    definition: 'railing, fence, enclosed place',
    pinyin: ['fán'],
    decomposition: '⿱棥大',
    etymology: {
      type: 'pictophonetic',
      phonetic: '棥',
      semantic: '大',
      hint: 'big',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '樑',
    definition: 'bridge; beam',
    pinyin: ['liáng'],
    decomposition: '⿰木梁',
    etymology: {
      type: 'ideographic',
      hint: 'A wooden 木 beam 梁; 梁 also provides the pronunciation',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '樓',
    definition: 'multi-story building; floor',
    pinyin: ['lóu'],
    decomposition: '⿰木婁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '婁',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '樗',
    definition: 'Ailanthus tree; a kind of small tree, useless for timber',
    pinyin: ['chū'],
    decomposition: '⿰木雩',
    etymology: {
      type: 'pictophonetic',
      phonetic: '雩',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '樘',
    definition: 'pillar, post, door frame',
    pinyin: ['táng'],
    decomposition: '⿰木堂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堂',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '標',
    definition: 'mark, sign, symbol; bid, prize',
    pinyin: ['biāo'],
    decomposition: '⿰木票',
    etymology: {
      type: 'pictophonetic',
      phonetic: '票',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '樛',
    definition: 'bent limbs or branches; to hang down',
    pinyin: ['jiū'],
    decomposition: '⿰木翏',
    etymology: {
      type: 'ideographic',
      hint: 'Branches 木 bowing in the wind 翏; 翏 also provides the pronunciation',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '樞',
    definition: 'door hinge; pivot; center of power',
    pinyin: ['shū'],
    decomposition: '⿰木區',
    etymology: {
      type: 'pictophonetic',
      phonetic: '區',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '樟',
    definition: 'camphor tree',
    pinyin: ['zhāng'],
    decomposition: '⿰木章',
    etymology: {
      type: 'pictophonetic',
      phonetic: '章',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '模',
    definition: 'model, pattern, standard; to copy, to imitate',
    pinyin: ['mó'],
    decomposition: '⿰木莫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '莫',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '樣',
    definition: 'form, pattern, shape, style',
    pinyin: ['yàng'],
    decomposition: '⿰木羕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羕',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '樨',
    definition: 'sweet olive; scrambled eggs',
    pinyin: ['xī'],
    decomposition: '⿰木犀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '犀',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '横',
    definition: 'horizontal, across; unreasonable, harsh',
    pinyin: ['héng'],
    decomposition: '⿰木黄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '黄',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '樯',
    definition: 'mast, boom, yard-arm',
    pinyin: ['qiáng'],
    decomposition: '⿰木啬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '啬',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '樱',
    definition: 'cherry, cherry blossom',
    pinyin: ['yīng'],
    decomposition: '⿰木婴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '婴',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '樵',
    definition: 'firewood; lumberjack; to gather wood',
    pinyin: ['qiáo'],
    decomposition: '⿰木焦',
    etymology: {
      type: 'ideographic',
      hint: 'Wood 木 for burning 焦; 焦 also provides the pronunciation',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '樸',
    definition: 'plain, simple; sincere; surname',
    pinyin: ['pǔ'],
    decomposition: '⿰木菐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '菐',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '樹',
    definition: 'tree; to plant; to set up, to establish',
    pinyin: ['shù'],
    decomposition: '⿰木尌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尌',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '樺',
    definition: 'a type of birch tree',
    pinyin: ['huà'],
    decomposition: '⿰木華',
    etymology: {
      type: 'pictophonetic',
      phonetic: '華',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '樽',
    definition: 'goblet, jar, jug; lush, drunk',
    pinyin: ['zūn'],
    decomposition: '⿰木尊',
    etymology: {
      type: 'ideographic',
      hint: 'A hand 寸 raising a wooden 木 wine jar 酉; 尊 also provides the pronunciation',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '樾',
    definition: 'the shade of a tree',
    pinyin: ['yuè'],
    decomposition: '⿰木越',
    etymology: {
      type: 'pictophonetic',
      phonetic: '越',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '橄',
    definition: 'olive',
    pinyin: ['gǎn'],
    decomposition: '⿰木敢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敢',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '橇',
    definition: 'a sledge for transportation',
    pinyin: ['qiāo'],
    decomposition: '⿰木毳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '毳',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '橈',
    definition: 'radius, forearm; a bent or twisted piece of wood',
    pinyin: ['ráo'],
    decomposition: '⿰木堯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堯',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '橋',
    definition: 'bridge; beam, crosspiece',
    pinyin: ['qiáo'],
    decomposition: '⿰木喬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '喬',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '橐',
    definition: 'bag, sack; a hollow tub open at both ends',
    pinyin: ['tuó'],
    decomposition: '⿱？⿱冖⿱石木',
    radical: '木',
    matches: [
      null,
      null,
      null,
      null,
      null,
      [1, 0],
      [1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
    ],
  },
  {
    character: '橘',
    definition: 'orange, tangerine',
    pinyin: ['jú'],
    decomposition: '⿰木矞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '矞',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '橙',
    definition: 'orange',
    pinyin: ['chéng'],
    decomposition: '⿰木登',
    etymology: {
      type: 'pictophonetic',
      phonetic: '登',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '橛',
    definition: 'stake, post; axle',
    pinyin: ['jué'],
    decomposition: '⿰木厥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厥',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '機',
    definition: 'desk; machine; moment, opportunity',
    pinyin: ['jī'],
    decomposition: '⿰木幾',
    etymology: {
      type: 'ideographic',
      hint: 'A table 幾 made of wood 木; 幾 also provides the pronunciation',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '橡',
    definition: 'chestnut oak; rubber tree; rubber',
    pinyin: ['xiàng'],
    decomposition: '⿰木象',
    etymology: {
      type: 'pictophonetic',
      phonetic: '象',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '橢',
    definition: 'elliptical, oval-shaped; tubular',
    pinyin: ['tuǒ'],
    decomposition: '⿰木隋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隋',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '橥',
    definition: 'a wooden peg, post, or stick',
    pinyin: ['zhū'],
    decomposition: '⿱猪木',
    etymology: {
      type: 'pictophonetic',
      phonetic: '猪',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '橫',
    definition: 'horizontal, across; unreasonable, harsh',
    pinyin: ['héng'],
    decomposition: '⿰木黃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '黃',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '橱',
    definition: 'cabinet, cupboard, wardrobe',
    pinyin: ['chú'],
    decomposition: '⿰木厨',
    etymology: {
      type: 'ideographic',
      hint: 'A wooden 木 cabinet 厨; 厨 also provides the pronunciation',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '橹',
    definition: 'oar, scull; to row, to scull',
    pinyin: ['lǔ'],
    decomposition: '⿰木鲁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鲁',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '橼',
    definition: 'citrus',
    pinyin: ['yuán'],
    decomposition: '⿰木缘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '缘',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '橾',
    definition: 'the axle hole in the center of a wheel (archaic)',
    pinyin: ['shū'],
    decomposition: '⿰木喿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '喿',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '檀',
    definition: 'ssandalwood, hardwood; surname',
    pinyin: ['tán'],
    decomposition: '⿰木亶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亶',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '檃',
    definition: 'a tool used to sharpen wood',
    pinyin: ['yǐn'],
    decomposition: '⿱⿰阝⿱爫⿱工彐木',
    etymology: { type: 'pictophonetic', semantic: '木', hint: 'wood' },
    radical: '木',
    matches: [
      [0, 0],
      [0, 0],
      [0, 1, 0],
      [0, 1, 0],
      [0, 1, 0],
      [0, 1, 0],
      [0, 1, 1, 0],
      [0, 1, 1, 0],
      [0, 1, 1, 0],
      [0, 1, 1, 1],
      [0, 1, 1, 1],
      [0, 1, 1, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '檄',
    definition: 'to order, to dispatch; urgency, a call to arms',
    pinyin: ['xí'],
    decomposition: '⿰木敫',
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '檎',
    definition: 'a small red apple',
    pinyin: ['qín'],
    decomposition: '⿰木禽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '禽',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '檐',
    definition: 'the eaves of a house; edge, brim',
    pinyin: ['yán'],
    decomposition: '⿰木詹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '詹',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '檑',
    definition: 'a log trap used to defend a city',
    pinyin: ['léi'],
    decomposition: '⿰木雷',
    etymology: {
      type: 'ideographic',
      hint: 'A thundering 雷 log 木 trap ; 雷 also provides the pronunciation',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '檔',
    definition: 'shelve, frame; files, records; grade, level',
    pinyin: ['dàng'],
    decomposition: '⿰木當',
    etymology: {
      type: 'pictophonetic',
      phonetic: '當',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '檗',
    definition: 'tree',
    pinyin: ['bò'],
    decomposition: '⿱辟木',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辟',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '檜',
    definition: 'Chinese cypress, Chinese juniper',
    pinyin: ['guì'],
    decomposition: '⿰木會',
    etymology: {
      type: 'pictophonetic',
      phonetic: '會',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '檠',
    definition: 'lamp stand; bow frame',
    pinyin: ['qíng'],
    decomposition: '⿱敬木',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敬',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '檢',
    definition: 'to check, to examine, to inspect',
    pinyin: ['jiǎn'],
    decomposition: '⿰木僉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '僉',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '檩',
    definition: "cross-beam, ridge-pole; ship's hatch",
    pinyin: ['lǐn'],
    decomposition: '⿰木禀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '禀',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '檫',
    definition: 'Sassafras tzumu',
    pinyin: ['chá'],
    decomposition: '⿰木察',
    etymology: {
      type: 'pictophonetic',
      phonetic: '察',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '檬',
    definition: 'a type of locust tree',
    pinyin: ['méng'],
    decomposition: '⿰木蒙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蒙',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '檮',
    definition: 'wood block; idiot, blockhead',
    pinyin: ['táo'],
    decomposition: '⿰木壽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '壽',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '檯',
    definition: 'platform; unit; term of address',
    pinyin: ['tái'],
    decomposition: '⿰木臺',
    etymology: {
      type: 'ideographic',
      hint: 'A wooden 木 platform 臺; 臺 also provides the pronunciation',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '檳',
    definition: 'betel-nut, areca nut',
    pinyin: ['bīn'],
    decomposition: '⿰木賓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '賓',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '檵',
    definition: 'fringe flower; wolfberry shrub',
    pinyin: ['jì'],
    decomposition: '⿰木㡭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㡭',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '檸',
    definition: 'lemon',
    pinyin: ['níng'],
    decomposition: '⿰木寧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寧',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '檻',
    definition: 'threshold, door frame',
    pinyin: ['kǎn'],
    decomposition: '⿰木監',
    etymology: {
      type: 'pictophonetic',
      phonetic: '監',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '櫃',
    definition: 'cabinet, cupboard, wardrobe; shop counter',
    pinyin: ['guì'],
    decomposition: '⿰木⿷匚貴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '貴',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 0],
    ],
  },
  {
    character: '櫆',
    definition: 'Polaris, the north star',
    pinyin: ['kuí'],
    decomposition: '⿰木魁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '魁',
      semantic: '木',
      hint: 'star',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '櫓',
    definition: 'oar, scull; to row, to scull',
    pinyin: ['lǔ'],
    decomposition: '⿰木魯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '魯',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '櫚',
    definition: 'palm tree',
    pinyin: ['lǘ'],
    decomposition: '⿰木閭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '閭',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '櫛',
    definition: 'comb; to comb out, to eliminate, to weed out',
    pinyin: ['zhì'],
    decomposition: '⿰木節',
    etymology: {
      type: 'ideographic',
      hint: 'A wooden 木 comb 節; 節 also provides the pronunciation',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '櫞',
    definition: 'citrus',
    pinyin: ['yuán'],
    decomposition: '⿰木緣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '緣',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '櫟',
    definition: 'chestnut-leaved oak',
    pinyin: ['lì'],
    decomposition: '⿰木樂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '樂',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '櫥',
    definition: 'cabinet, cupboard, wardrobe',
    pinyin: ['chú'],
    decomposition: '⿰木廚',
    etymology: {
      type: 'ideographic',
      hint: 'A wooden 木 cabinet 廚; 廚 also provides the pronunciation',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '櫪',
    definition: 'oak tree; a stable',
    pinyin: ['lì'],
    decomposition: '⿰木歷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '歷',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '櫫',
    definition: 'a wooden peg, post, or stick',
    pinyin: ['zhū'],
    decomposition: '⿱豬木',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豬',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '櫱',
    definition: 'stump, sprout',
    pinyin: ['niè'],
    decomposition: '⿱辥木',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辥',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '櫸',
    definition: 'a type of elm tree',
    pinyin: ['jǔ'],
    decomposition: '⿰木舉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '舉',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '櫻',
    definition: 'cherry, cherry blossom',
    pinyin: ['yīng'],
    decomposition: '⿰木嬰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '嬰',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '欄',
    definition: 'fence, railing, balustrade',
    pinyin: ['lán'],
    decomposition: '⿰木闌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '闌',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '權',
    definition: 'authority, power, right',
    pinyin: ['quán'],
    decomposition: '⿰木雚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '雚',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '欒',
    definition: 'varnish tree; surname',
    pinyin: ['luán'],
    decomposition: '⿱䜌木',
    etymology: {
      type: 'pictophonetic',
      phonetic: '䜌',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '欖',
    definition: 'olive',
    pinyin: ['lǎn'],
    decomposition: '⿰木覽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '覽',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '欞',
    definition: 'carved or patterned window sills',
    pinyin: ['líng'],
    decomposition: '⿰木靈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '靈',
      semantic: '木',
      hint: 'wood',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '欠',
    definition: 'to lack, to owe; to breathe, to yawn',
    pinyin: ['qiàn'],
    decomposition: '⿱⺈人',
    etymology: { type: 'ideographic', hint: 'A man 人 yawning ⺈' },
    radical: '欠',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '次',
    definition: 'order, sequence; second, next; one after the other',
    pinyin: ['cì'],
    decomposition: '⿰冫欠',
    etymology: {
      type: 'ideographic',
      hint: 'A person 欠 yawning multiple times 冫',
    },
    radical: '欠',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '欢',
    definition: 'happy, glad, joyful',
    pinyin: ['huān'],
    decomposition: '⿰又欠',
    radical: '欠',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '欣',
    definition: 'delighted, happy, joyous',
    pinyin: ['xīn'],
    decomposition: '⿰斤欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斤',
      semantic: '欠',
      hint: 'lack',
    },
    radical: '欠',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '欤',
    definition: 'final particle indicating doubt, surprise, or a question',
    pinyin: ['yú'],
    decomposition: '⿰与欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '与',
      semantic: '欠',
      hint: 'lack',
    },
    radical: '欠',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '欧',
    definition: 'Europe, ohm; surname',
    pinyin: ['ōu'],
    decomposition: '⿰区欠',
    radical: '欠',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '欮',
    definition: 'to hiccup; to dig out, to expand',
    pinyin: ['jué'],
    decomposition: '⿰屰欠',
    etymology: {
      type: 'ideographic',
      hint: 'A hiccup is a "disobedient 屰 yawn 欠"',
    },
    radical: '欠',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '欲',
    definition: 'desire, want, longing, intent',
    pinyin: ['yù'],
    decomposition: '⿰谷欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '谷',
      semantic: '欠',
      hint: 'lack',
    },
    radical: '欠',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '欶',
    definition: 'to suck, to drink',
    pinyin: ['shuò'],
    decomposition: '⿰束欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '束',
      semantic: '欠',
      hint: 'yawn',
    },
    radical: '欠',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '欷',
    definition: 'to sigh; to sob',
    pinyin: ['xī'],
    decomposition: '⿰希欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '希',
      semantic: '欠',
      hint: 'yawn',
    },
    radical: '欠',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '欹',
    definition: 'pleading interjection',
    pinyin: ['yī'],
    decomposition: '⿰奇欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奇',
      semantic: '欠',
      hint: 'lack',
    },
    radical: '欠',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '欺',
    definition: 'to cheat, to double-cross, to deceive',
    pinyin: ['qī'],
    decomposition: '⿰其欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '其',
      semantic: '欠',
      hint: 'lack',
    },
    radical: '欠',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '欻',
    definition: 'sudden, abrupt',
    pinyin: ['chuā'],
    decomposition: '⿰炎欠',
    etymology: {
      type: 'ideographic',
      hint: 'To fan 欠 flames 炎; 欠 also provides the pronunciation',
    },
    radical: '欠',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '欽',
    definition: 'to respect, to admire; royal',
    pinyin: ['qīn'],
    decomposition: '⿰釒欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '欠',
      semantic: '釒',
      hint: 'gold',
    },
    radical: '欠',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '款',
    definition: 'funds, payment; item, article',
    pinyin: ['kuǎn'],
    decomposition: '⿰⿱士示欠',
    etymology: { type: 'pictophonetic', semantic: '欠', hint: 'owe' },
    radical: '欠',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '欿',
    definition: 'sad, gloomy, discontent',
    pinyin: ['kǎn'],
    decomposition: '⿰臽欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '欠',
      semantic: '臽',
      hint: 'pit',
    },
    radical: '欠',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '歃',
    definition: 'to drink to an oath',
    pinyin: ['shà'],
    decomposition: '⿰臿欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臿',
      semantic: '欠',
      hint: 'breathe',
    },
    radical: '欠',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '歆',
    definition: 'to like, to admire; willingly, gladly',
    pinyin: ['xīn'],
    decomposition: '⿰音欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '音',
      semantic: '欠',
      hint: 'lack',
    },
    radical: '欠',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '歇',
    definition: 'to stop, to rest, to lodge',
    pinyin: ['xiē'],
    decomposition: '⿰曷欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曷',
      semantic: '欠',
      hint: 'yawn',
    },
    radical: '欠',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '歉',
    definition: 'deficient, lacking; to apologize, to regret, to be sorry',
    pinyin: ['qiàn'],
    decomposition: '⿰兼欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兼',
      semantic: '欠',
      hint: 'lack',
    },
    radical: '欠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '歌',
    definition: 'song, lyrics; to sing, to chant',
    pinyin: ['gē'],
    decomposition: '⿰哥欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '哥',
      semantic: '欠',
      hint: 'breath',
    },
    radical: '欠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '歎',
    definition: 'to sigh; to admire',
    pinyin: ['tàn'],
    decomposition: '⿰堇欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堇',
      semantic: '欠',
      hint: 'yawn',
    },
    radical: '欠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '歐',
    definition: 'Europe, ohm; surname',
    pinyin: ['ōu'],
    decomposition: '⿰區欠',
    radical: '欠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '歔',
    definition: 'to snort, to blow through the nose',
    pinyin: ['xū'],
    decomposition: '⿰虚欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '虚',
      semantic: '欠',
      hint: 'breathe',
    },
    radical: '欠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '歙',
    definition: 'to suck; the name of a district in Anhui',
    pinyin: ['shè'],
    decomposition: '⿰翕欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '翕',
      semantic: '欠',
      hint: 'breathe',
    },
    radical: '欠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '歛',
    definition: 'to fold back, to draw back; to collect',
    pinyin: ['hān'],
    decomposition: '⿰僉欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '僉',
      semantic: '欠',
      hint: 'lack',
    },
    radical: '欠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '歡',
    definition: 'happy, glad, joyful',
    pinyin: ['huān'],
    decomposition: '⿰雚欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '雚',
      semantic: '欠',
      hint: 'breathe',
    },
    radical: '欠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '止',
    definition: 'to stop, to halt; to detain; to desist',
    pinyin: ['zhǐ'],
    decomposition: '⿻上丨',
    etymology: { type: 'pictographic', hint: 'A foot' },
    radical: '止',
    matches: [[0], [0], [1], [0]],
  },
  {
    character: '正',
    definition: 'straight, right, proper, correct, just, true',
    pinyin: ['zhèng'],
    decomposition: '⿱一止',
    etymology: {
      type: 'ideographic',
      hint: 'A foot 止 stopping in the right place 一',
    },
    radical: '止',
    matches: [[0], [1], [1], [1], [1]],
  },
  {
    character: '此',
    definition: 'this, these; in this case, then',
    pinyin: ['cǐ'],
    decomposition: '⿰止匕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '止',
      semantic: '匕',
      hint: 'sitting man',
    },
    radical: '止',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '步',
    definition: 'walk, stroll, pace, march; to make progress',
    pinyin: ['bù'],
    decomposition: '⿱止？',
    etymology: {
      type: 'ideographic',
      hint: 'Modern form of 歨; putting one foot 止 in front of the other',
    },
    radical: '止',
    matches: [[0], [0], [0], [0], null, null, null],
  },
  {
    character: '武',
    definition: 'military; martial, warlike',
    pinyin: ['wǔ'],
    decomposition: '⿸一⿹弋止',
    etymology: {
      type: 'ideographic',
      hint: 'To stop someone 止 with an arrow 弋',
    },
    radical: '止',
    matches: [[0], [1, 0], [1, 1], [1, 1], [1, 1], [1, 1], [1, 0], [1, 0]],
  },
  {
    character: '歧',
    definition: 'to diverge, to fork; a branch; a side road',
    pinyin: ['qí'],
    decomposition: '⿰止支',
    etymology: {
      type: 'pictophonetic',
      phonetic: '支',
      semantic: '止',
      hint: 'stop',
    },
    radical: '止',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '歨',
    definition: 'Old variant of 步',
    pinyin: ['bù'],
    decomposition: '⿱止止',
    etymology: {
      type: 'ideographic',
      hint: 'Putting one foot 止 in front of the other',
    },
    radical: '止',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '歪',
    definition: 'slanted, askew, awry',
    pinyin: ['wāi'],
    decomposition: '⿱不正',
    etymology: { type: 'ideographic', hint: 'Not 不 straight 正' },
    radical: '止',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '歰',
    definition: 'to argue, to disagree, to wrangle',
    pinyin: ['sè'],
    decomposition: '⿱⿰刃刃⿰止止',
    etymology: {
      type: 'ideographic',
      hint: 'Two people 止 exchanging sharp words 刃',
    },
    radical: '止',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '歲',
    definition: 'year; years old, age; harvest',
    pinyin: ['suì'],
    decomposition: '⿱止⿵戊？',
    radical: '止',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      null,
      null,
      null,
      null,
      [1, 0],
      [1, 0],
      [1, 0],
    ],
  },
  {
    character: '歷',
    definition: 'history; calendar',
    pinyin: ['lì'],
    decomposition: '⿸厤止',
    etymology: {
      type: 'pictophonetic',
      phonetic: '止',
      semantic: '厤',
      hint: 'calendar',
    },
    radical: '止',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '歸',
    definition: 'to return, to go back; to return to, to revert',
    pinyin: ['guī'],
    decomposition: '⿰⿱⿱丿㠯止帚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㠯',
      semantic: '止',
      hint: 'foot',
    },
    radical: '止',
    matches: [
      [0, 0, 0],
      [0, 0, 1],
      [0, 0, 1],
      [0, 0, 1],
      [0, 0, 1],
      [0, 0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '歹',
    definition: 'corpse; death; evil, depraved, wicked',
    pinyin: ['dǎi'],
    decomposition: '⿱一夕',
    etymology: { type: 'pictographic', hint: 'A corpse' },
    radical: '歹',
    matches: [[0], [1], [1], [1]],
  },
  {
    character: '歺',
    definition: 'evil, depraved, wicked',
    pinyin: ['è'],
    decomposition: '⿱⺊夕',
    etymology: { type: 'ideographic', hint: 'A corpse; compare 歹' },
    radical: '歺',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '死',
    definition: 'dead; death; impassable, inflexible',
    pinyin: ['sǐ'],
    decomposition: '⿸歹匕',
    etymology: {
      type: 'ideographic',
      hint: 'A person kneeling 匕 before a corpse 歹',
    },
    radical: '歹',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '歼',
    definition: 'to annihilate, to kill off, to wipe out',
    pinyin: ['jiān'],
    decomposition: '⿰歹千',
    etymology: {
      type: 'ideographic',
      hint: 'A thousand 千 corpses 歹; 千 also provides the pronunciation',
    },
    radical: '歹',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '殁',
    definition: 'dead; to die',
    pinyin: ['mò'],
    decomposition: '⿰歹殳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '殳',
      semantic: '歹',
      hint: 'death',
    },
    radical: '歹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '殂',
    definition: 'dead; to die',
    pinyin: ['cú'],
    decomposition: '⿰歹且',
    etymology: {
      type: 'pictophonetic',
      phonetic: '且',
      semantic: '歹',
      hint: 'death',
    },
    radical: '歹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '殃',
    definition: 'misfortune, disaster, calamity',
    pinyin: ['yāng'],
    decomposition: '⿰歹央',
    etymology: {
      type: 'pictophonetic',
      phonetic: '央',
      semantic: '歹',
      hint: 'death',
    },
    radical: '歹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '殄',
    definition: 'to end; to exterminate',
    pinyin: ['tiǎn'],
    decomposition: '⿰歹㐱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㐱',
      semantic: '歹',
      hint: 'death',
    },
    radical: '歹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '殆',
    definition: 'almost, probably; danger, peril; to endanger',
    pinyin: ['dài'],
    decomposition: '⿰歹台',
    etymology: {
      type: 'pictophonetic',
      phonetic: '台',
      semantic: '歹',
      hint: 'death',
    },
    radical: '歹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '殇',
    definition: 'to die young; national mourning',
    pinyin: ['shāng'],
    decomposition: '⿰歹⿱？昜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昜',
      semantic: '歹',
      hint: 'death',
    },
    radical: '歹',
    matches: [[0], [0], [0], [0], null, null, [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '殉',
    definition: 'martyr; to die for a cause',
    pinyin: ['xùn'],
    decomposition: '⿰歹旬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旬',
      semantic: '歹',
      hint: 'death',
    },
    radical: '歹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '殊',
    definition: 'different, special, unusual',
    pinyin: ['shū'],
    decomposition: '⿰歹朱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朱',
      semantic: '歹',
      hint: 'depraved',
    },
    radical: '歹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '残',
    definition:
      'to injure, to ruin, to spoil; cruel, oppressive, savage; disabled, incomplete',
    pinyin: ['cán'],
    decomposition: '⿰歹戋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戋',
      semantic: '歹',
      hint: 'death',
    },
    radical: '歹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '殍',
    definition: 'to starve to death',
    pinyin: ['piǎo'],
    decomposition: '⿰歹孚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孚',
      semantic: '歹',
      hint: 'death',
    },
    radical: '歹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '殒',
    definition: 'to die, to fall, to perish, to vanish',
    pinyin: ['yǔn'],
    decomposition: '⿰歹员',
    etymology: {
      type: 'pictophonetic',
      phonetic: '员',
      semantic: '歹',
      hint: 'death',
    },
    radical: '歹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '殓',
    definition: 'to dress a corpse for burial',
    pinyin: ['liàn'],
    decomposition: '⿰歹佥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '佥',
      semantic: '歹',
      hint: 'corpse',
    },
    radical: '歹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '殖',
    definition: 'to breed, to spawn; to grow, to prosper',
    pinyin: ['zhí'],
    decomposition: '⿰歹直',
    etymology: {
      type: 'pictophonetic',
      phonetic: '直',
      semantic: '歹',
      hint: 'corpse',
    },
    radical: '歹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '殗',
    definition: 'sickness; repeated',
    pinyin: ['yè'],
    decomposition: '⿰歹奄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奄',
      semantic: '歹',
      hint: 'death',
    },
    radical: '歹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '殘',
    definition:
      'to injure, to ruin, to spoil; cruel, oppressive, savage; disabled, incomplete',
    pinyin: ['cán'],
    decomposition: '⿰歹戔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戔',
      semantic: '歹',
      hint: 'death',
    },
    radical: '歹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '殚',
    definition: 'utmost, entirely, quite; to use up',
    pinyin: ['dān'],
    decomposition: '⿰歹单',
    etymology: {
      type: 'pictophonetic',
      phonetic: '单',
      semantic: '歹',
      hint: 'death',
    },
    radical: '歹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '殛',
    definition: 'to put to death; to imprison for life',
    pinyin: ['jí'],
    decomposition: '⿰歹亟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亟',
      semantic: '歹',
      hint: 'death',
    },
    radical: '歹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '殞',
    definition: 'to die, to fall, to perish, to vanish',
    pinyin: ['yǔn'],
    decomposition: '⿰歹員',
    etymology: {
      type: 'pictophonetic',
      phonetic: '員',
      semantic: '歹',
      hint: 'death',
    },
    radical: '歹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '殡',
    definition: 'funeral; to enbalm, to inter',
    pinyin: ['bìn'],
    decomposition: '⿰歹宾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宾',
      semantic: '歹',
      hint: 'corpse',
    },
    radical: '歹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '殤',
    definition: 'to die young; national mourning',
    pinyin: ['shāng'],
    decomposition: '⿰歹⿱？昜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昜',
      semantic: '歹',
      hint: 'death',
    },
    radical: '歹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      null,
      null,
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '殪',
    definition: 'to die, to kill, to exterminate',
    pinyin: ['yì'],
    decomposition: '⿰歹壹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '壹',
      semantic: '歹',
      hint: 'death',
    },
    radical: '歹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '殫',
    definition: 'utmost, entirely, quite; to use up',
    pinyin: ['dān'],
    decomposition: '⿰歹單',
    etymology: {
      type: 'pictophonetic',
      phonetic: '單',
      semantic: '歹',
      hint: 'death',
    },
    radical: '歹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '殭',
    definition: 'a stiff corpse',
    pinyin: ['jiāng'],
    decomposition: '⿰歹畺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畺',
      semantic: '歹',
      hint: 'corpse',
    },
    radical: '歹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '殮',
    definition: 'to dress a corpse for burial',
    pinyin: ['liàn'],
    decomposition: '⿰歹僉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '僉',
      semantic: '歹',
      hint: 'corpse',
    },
    radical: '歹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '殯',
    definition: 'funeral; to enbalm, to inter',
    pinyin: ['bìn'],
    decomposition: '⿰歹賓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '賓',
      semantic: '歹',
      hint: 'corpse',
    },
    radical: '歹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '殲',
    definition: 'to annihilate, to kill off, to wipe out',
    pinyin: ['jiān'],
    decomposition: '⿰歹韱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韱',
      semantic: '歹',
      hint: 'death',
    },
    radical: '歹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '殳',
    definition: 'tool, weapon',
    pinyin: ['shū'],
    decomposition: '⿱几又',
    etymology: { type: 'ideographic', hint: 'A hand 又 holding a weapon 几' },
    radical: '殳',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '殴',
    definition: 'to hit, to beat, to fight with fists',
    pinyin: ['ōu'],
    decomposition: '⿰区殳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '区',
      semantic: '殳',
      hint: 'weapon',
    },
    radical: '殳',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '段',
    definition: 'section, piece, division',
    pinyin: ['duàn'],
    decomposition: '⿰？殳',
    etymology: {
      type: 'ideographic',
      hint: 'A hand using a chisel 殳 to cut stone',
    },
    radical: '殳',
    matches: [null, null, null, null, null, [1], [1], [1], [1]],
  },
  {
    character: '殷',
    definition: 'many, great; abundant, flourishing',
    pinyin: ['yīn'],
    decomposition: '⿰㐆殳',
    etymology: {
      type: 'ideographic',
      hint: 'A midwife 殳 to helping a pregnant woman 㐆; 㐆 also provides the pronunciation',
    },
    radical: '殳',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '殸',
    definition: 'stone chimes',
    pinyin: ['qìng'],
    decomposition: '⿰声殳',
    etymology: {
      type: 'ideographic',
      hint: 'A musical 声 instrument 殳; 声 also provides the pronunciation',
    },
    radical: '殳',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '殹',
    definition: 'an echo',
    pinyin: ['yì'],
    decomposition: '⿰医殳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '医',
      semantic: '殳',
      hint: 'tool',
    },
    radical: '殳',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '殺',
    definition: 'to kill, to murder, to slaughter; to hurt',
    pinyin: ['shā'],
    decomposition: '⿰杀殳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '杀',
      semantic: '殳',
      hint: 'weapon',
    },
    radical: '殳',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '殼',
    definition: 'casing, husk, shell',
    pinyin: ['ké'],
    decomposition: '⿰壳殳',
    etymology: { type: 'ideographic', hint: 'A hand 殳 striking a shell 壳' },
    radical: '殳',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '殽',
    definition: 'cooked meat; confused, mixed up',
    pinyin: ['xiáo'],
    decomposition: '⿰肴殳',
    radical: '殳',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '殿',
    definition: 'hall; palace; temple',
    pinyin: ['diàn'],
    decomposition: '⿰⿸尸共殳',
    radical: '殳',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '毀',
    definition: 'to damage, to ruin; to defame, to slander',
    pinyin: ['huǐ'],
    decomposition: '⿰⿱臼土殳',
    etymology: {
      type: 'ideographic',
      hint: 'A man using a tool 殳 to strike a clay 土 vessel 臼',
    },
    radical: '殳',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '毁',
    definition: 'to damage, to ruin; to defame, to slander',
    pinyin: ['huǐ'],
    decomposition: '⿰⿱臼工殳',
    etymology: {
      type: 'ideographic',
      hint: 'A man using a tool 殳 to strike 工 a clay vessel 臼',
    },
    radical: '殳',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '毂',
    definition: 'the hub of a wheel',
    pinyin: ['gǔ'],
    decomposition: '⿰⿱士军车',
    etymology: { type: 'pictophonetic', semantic: '车', hint: 'wheel' },
    radical: '殳',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '毄',
    definition: 'to hit, to strike',
    pinyin: ['jī'],
    decomposition: '⿰軎殳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '軎',
      semantic: '殳',
      hint: 'weapon',
    },
    radical: '殳',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '毅',
    definition: 'decisive, firm, resolute',
    pinyin: ['yì'],
    decomposition: '⿰豙殳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豙',
      semantic: '殳',
      hint: 'tool',
    },
    radical: '殳',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '毆',
    definition: 'to hit, to beat, to fight with fists',
    pinyin: ['ōu'],
    decomposition: '⿰區殳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '區',
      semantic: '殳',
      hint: 'weapon',
    },
    radical: '殳',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '毋',
    definition: 'not; do not; surname',
    pinyin: ['wú'],
    decomposition: '？',
    radical: '毋',
    matches: [null, null, null, null],
  },
  {
    character: '毌',
    definition: 'old form of 貫',
    pinyin: ['guàn'],
    decomposition: '⿻？十',
    radical: '毋',
    matches: [null, null, [1], [1]],
  },
  {
    character: '母',
    definition: 'mother; female elders; female',
    pinyin: ['mǔ'],
    decomposition: '？',
    etymology: { type: 'ideographic', hint: "A mother's breasts" },
    radical: '母',
    matches: [null, null, null, null, null],
  },
  {
    character: '每',
    definition: 'each, every',
    pinyin: ['měi'],
    decomposition: '⿱？母',
    etymology: { type: 'pictophonetic', phonetic: '母' },
    radical: '母',
    matches: [null, null, [1], [1], [1], [1], [1]],
  },
  {
    character: '毒',
    definition: 'poison, venom; drug, narcotic',
    pinyin: ['dú'],
    decomposition: '⿱龶母',
    etymology: {
      type: 'pictophonetic',
      phonetic: '母',
      semantic: '龶',
      hint: 'a poisonous plant',
    },
    radical: '母',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '毓',
    definition: 'to give birth to; to raise; to educate',
    pinyin: ['yù'],
    decomposition: '⿰每㐬',
    etymology: { type: 'pictophonetic', semantic: '母', hint: 'mother' },
    radical: '母',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '比',
    definition: 'to compare, liken; comparison; than',
    pinyin: ['bǐ'],
    decomposition: '⿰匕匕',
    etymology: {
      type: 'ideographic',
      hint: 'Two spoons 匕 side-by-side; 匕 also provides the pronunciation',
    },
    radical: '比',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '毕',
    definition: 'to finish, to conclude, to end; completed',
    pinyin: ['bì'],
    decomposition: '⿱比十',
    etymology: {
      type: 'pictophonetic',
      phonetic: '比',
      semantic: '十',
      hint: 'complete',
    },
    radical: '比',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '毖',
    definition: 'caution; to guard against, to take care',
    pinyin: ['bì'],
    decomposition: '⿱比必',
    etymology: {
      type: 'pictophonetic',
      phonetic: '必',
      semantic: '比',
      hint: 'compare',
    },
    radical: '比',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '毗',
    definition: 'to aid, to help; to adjoin, to connect',
    pinyin: ['pí'],
    decomposition: '⿰田比',
    etymology: {
      type: 'pictophonetic',
      phonetic: '比',
      semantic: '田',
      hint: 'field',
    },
    radical: '田',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '毙',
    definition: 'to kill; to die a violent death',
    pinyin: ['bì'],
    decomposition: '⿱比死',
    etymology: {
      type: 'pictophonetic',
      phonetic: '比',
      semantic: '死',
      hint: 'death',
    },
    radical: '比',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '毚',
    definition: 'greedy; cunning',
    pinyin: ['chán'],
    decomposition: '⿱㲋兔',
    etymology: {
      type: 'ideographic',
      hint: 'Eating two whole rabbits 㲋 and 兔',
    },
    radical: '比',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '毛',
    definition: 'hair, fur, feathers; coarse',
    pinyin: ['máo'],
    decomposition: '⿻乇一',
    radical: '毛',
    matches: [[0], [0], [1], [0]],
  },
  {
    character: '毡',
    definition: 'felt; rug, carpet',
    pinyin: ['zhān'],
    decomposition: '⿺毛占',
    etymology: {
      type: 'pictophonetic',
      phonetic: '占',
      semantic: '毛',
      hint: 'fur',
    },
    radical: '毛',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '毪',
    definition: 'serge (fabric) from Tibet',
    pinyin: ['mú'],
    decomposition: '⿺毛牟',
    etymology: {
      type: 'pictophonetic',
      semantic: '毛',
      hint: 'fur',
      phonetic: '牟',
    },
    radical: '毛',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '毫',
    definition: 'fine hair; measure of length; one-thousandth',
    pinyin: ['háo'],
    decomposition: '⿱⿳亠口冖毛',
    etymology: { type: 'pictophonetic', semantic: '毛', hint: 'hair' },
    radical: '毛',
    matches: [
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 2],
      [0, 2],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '毯',
    definition: 'rug, carpet, blanket',
    pinyin: ['tǎn'],
    decomposition: '⿺毛炎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '炎',
      semantic: '毛',
      hint: 'fur',
    },
    radical: '毛',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '毳',
    definition: 'fine hair or fur on animals',
    pinyin: ['cuì'],
    decomposition: '⿱毛⿰毛毛',
    etymology: {
      type: 'ideographic',
      hint: 'Many fine hairs 毛 forming a pelt',
    },
    radical: '毛',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '毵',
    definition: 'long feathers; scraggy',
    pinyin: ['sān'],
    decomposition: '⿰参毛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '参',
      semantic: '毛',
      hint: 'feathers',
    },
    radical: '毛',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '毹',
    definition: 'blanket, rug',
    pinyin: ['shū'],
    decomposition: '⿰俞毛',
    etymology: {
      type: 'pictophonetic',
      semantic: '毛',
      hint: 'fur',
      phonetic: '俞',
    },
    radical: '毛',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '毽',
    definition: 'a shuttlecock',
    pinyin: ['jiàn'],
    decomposition: '⿺毛建',
    etymology: {
      type: 'pictophonetic',
      phonetic: '建',
      semantic: '毛',
      hint: 'feathers',
    },
    radical: '毛',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '氂',
    definition: 'tail, hair; yak',
    pinyin: ['máo'],
    decomposition: '⿱⿰未攵⿸厂毛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '毛',
      semantic: '毛',
      hint: 'fur',
    },
    radical: '毛',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '氅',
    definition: 'overcoat; down feathers',
    pinyin: ['chǎng'],
    decomposition: '⿱敞毛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敞',
      semantic: '毛',
      hint: 'fur',
    },
    radical: '毛',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '氆',
    definition: 'thick rough serge from Tibet',
    pinyin: ['pǔ'],
    decomposition: '⿺毛普',
    etymology: {
      type: 'pictophonetic',
      phonetic: '普',
      semantic: '毛',
      hint: 'fur',
    },
    radical: '毛',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '氇',
    definition: 'thick rough serge from Tibet',
    pinyin: ['lu'],
    decomposition: '⿺毛鲁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鲁',
      semantic: '毛',
      hint: 'fur',
    },
    radical: '毛',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '氈',
    definition: 'felt; rug, carpet',
    pinyin: ['zhān'],
    decomposition: '⿰亶毛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亶',
      semantic: '毛',
      hint: 'fur',
    },
    radical: '毛',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '氍',
    definition: 'fine woolen cloth; prayer mat',
    pinyin: ['qú'],
    decomposition: '⿰瞿毛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '瞿',
      semantic: '毛',
      hint: 'fur',
    },
    radical: '毛',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '氏',
    definition: 'clan, family; maiden name',
    pinyin: ['shì'],
    decomposition: '？',
    etymology: { type: 'ideographic', hint: 'A person bowing down' },
    radical: '氏',
    matches: [null, null, null, null],
  },
  {
    character: '氐',
    definition: 'the name of an ancient tribe',
    pinyin: ['dī'],
    decomposition: '⿱氏丶',
    etymology: { type: 'pictophonetic', semantic: '氏', hint: 'clan' },
    radical: '氏',
    matches: [[0], [0], [0], [0], [1]],
  },
  {
    character: '民',
    definition: "citizens, subjects; a nation's people",
    pinyin: ['mín'],
    decomposition: '⿻巳戈',
    etymology: {
      type: 'ideographic',
      hint: 'An eye 巳 pierced by a dagger 戈, an old mark of slavery',
    },
    radical: '民',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '氓',
    definition: 'people, subjects, vassals',
    pinyin: ['máng'],
    decomposition: '⿰亡民',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亡',
      semantic: '民',
      hint: 'citizens',
    },
    radical: '民',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '气',
    definition: 'air, gas; steam, vapor; anger',
    pinyin: ['qì'],
    decomposition: '⿱亻？',
    etymology: { type: 'ideographic', hint: 'A person 亻 breathing air' },
    radical: '气',
    matches: [[0], [0], null, null],
  },
  {
    character: '氕',
    definition: 'protium',
    pinyin: ['piē'],
    decomposition: '⿹气丿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丿',
      semantic: '气',
      hint: 'gas',
    },
    radical: '气',
    matches: [[0], [0], [0], [0], [1]],
  },
  {
    character: '氖',
    definition: 'neon',
    pinyin: ['nǎi'],
    decomposition: '⿹气乃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乃',
      semantic: '气',
      hint: 'gas',
    },
    radical: '气',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '氘',
    definition: 'deuterium',
    pinyin: ['dāo'],
    decomposition: '⿹气刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '刂',
      semantic: '气',
      hint: 'gas',
    },
    radical: '气',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '氙',
    definition: 'xenon',
    pinyin: ['xiān'],
    decomposition: '⿹气山',
    etymology: {
      type: 'pictophonetic',
      phonetic: '山',
      semantic: '气',
      hint: 'gas',
    },
    radical: '气',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '氚',
    definition: 'tritium',
    pinyin: ['chuān'],
    decomposition: '⿹气川',
    etymology: {
      type: 'pictophonetic',
      phonetic: '川',
      semantic: '气',
      hint: 'gas',
    },
    radical: '气',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '氛',
    definition: 'air; atmosphere',
    pinyin: ['fēn'],
    decomposition: '⿹气分',
    etymology: {
      type: 'pictophonetic',
      phonetic: '分',
      semantic: '气',
      hint: 'air',
    },
    radical: '气',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '氜',
    definition: 'helium',
    pinyin: ['yáng'],
    decomposition: '⿹气日',
    etymology: {
      type: 'ideographic',
      hint: 'The gas 气 that comprises the sun 日',
    },
    radical: '气',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '氟',
    definition: 'fluorine',
    pinyin: ['fú'],
    decomposition: '⿹气弗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弗',
      semantic: '气',
      hint: 'gas',
    },
    radical: '气',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '氡',
    definition: 'radon',
    pinyin: ['dōng'],
    decomposition: '⿹气冬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冬',
      semantic: '气',
      hint: 'gas',
    },
    radical: '气',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '氢',
    definition: 'ammonia',
    pinyin: ['qīng'],
    decomposition: '⿹气⿱又工',
    etymology: {
      type: 'pictophonetic',
      phonetic: '工',
      semantic: '气',
      hint: 'gas',
    },
    radical: '气',
    matches: [[0], [0], [0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '氣',
    definition: 'air, gas; steam, vapor; anger',
    pinyin: ['qì'],
    decomposition: '⿹气米',
    etymology: { type: 'ideographic', hint: 'A person 亻 breathing air 米' },
    radical: '气',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '氤',
    definition: 'fog, mist',
    pinyin: ['yīn'],
    decomposition: '⿹气因',
    etymology: {
      type: 'pictophonetic',
      phonetic: '因',
      semantic: '气',
      hint: 'gas',
    },
    radical: '气',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '氦',
    definition: 'helium',
    pinyin: ['hài'],
    decomposition: '⿹气亥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亥',
      semantic: '气',
      hint: 'gas',
    },
    radical: '气',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '氧',
    definition: 'oxygen',
    pinyin: ['yǎng'],
    decomposition: '⿹气羊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羊',
      semantic: '气',
      hint: 'gas',
    },
    radical: '气',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '氨',
    definition: 'ammonia',
    pinyin: ['ān'],
    decomposition: '⿹气安',
    etymology: {
      type: 'pictophonetic',
      phonetic: '安',
      semantic: '气',
      hint: 'gas',
    },
    radical: '气',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '氩',
    definition: 'argon',
    pinyin: ['yà'],
    decomposition: '⿹气亚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亚',
      semantic: '气',
      hint: 'gas',
    },
    radical: '气',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '氪',
    definition: 'krypton',
    pinyin: ['kè'],
    decomposition: '⿹气克',
    etymology: {
      type: 'pictophonetic',
      phonetic: '克',
      semantic: '气',
      hint: 'gas',
    },
    radical: '气',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '氫',
    definition: 'ammonia',
    pinyin: ['qīng'],
    decomposition: '⿹气巠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巠',
      semantic: '气',
      hint: 'gas',
    },
    radical: '气',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '氮',
    definition: 'nitrogen',
    pinyin: ['dàn'],
    decomposition: '⿹气炎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '炎',
      semantic: '气',
      hint: 'gas',
    },
    radical: '气',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '氯',
    definition: 'chlorine',
    pinyin: ['lǜ'],
    decomposition: '⿹气录',
    etymology: {
      type: 'pictophonetic',
      phonetic: '录',
      semantic: '气',
      hint: 'gas',
    },
    radical: '气',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '氰',
    definition: 'cyanogen; ethane dinitrile',
    pinyin: ['qíng'],
    decomposition: '⿹气青',
    etymology: {
      type: 'pictophonetic',
      phonetic: '青',
      semantic: '气',
      hint: 'gas',
    },
    radical: '气',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '氲',
    definition: 'prosperity; the breath of life; the spirit of harmony',
    pinyin: ['yūn'],
    decomposition: '⿹气昷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昷',
      semantic: '气',
      hint: 'air',
    },
    radical: '气',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '氳',
    definition: 'prosperity; the breath of life; the spirit of harmony',
    pinyin: ['yūn'],
    decomposition: '⿹气⿱囚皿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皿',
      semantic: '气',
      hint: 'air',
    },
    radical: '气',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '水',
    definition: 'water, liquid, lotion, juice',
    pinyin: ['shuǐ'],
    decomposition: '⿻亅？',
    etymology: {
      type: 'pictographic',
      hint: 'A river running between two banks; compare 川',
    },
    radical: '水',
    matches: [[0], null, null, null],
  },
  {
    character: '氵',
    definition: 'water',
    pinyin: ['shuǐ'],
    decomposition: '⿱？？',
    radical: '氵',
    matches: [null, null, null],
  },
  {
    character: '氶',
    definition: 'name of a river in Shandong',
    pinyin: ['zhěng'],
    decomposition: '⿱？水',
    etymology: { type: 'pictophonetic', semantic: '水', hint: 'water' },
    radical: '水',
    matches: [null, [1], [1], [1], [1]],
  },
  {
    character: '永',
    definition: 'long; perpetual, eternal; forever',
    pinyin: ['yǒng'],
    decomposition: '⿱？水',
    radical: '水',
    matches: [null, [1], [1], [1], [1]],
  },
  {
    character: '氹',
    definition: 'ditch; pool',
    pinyin: ['dàng'],
    decomposition: '⿺乙水',
    etymology: {
      type: 'ideographic',
      hint: 'A furrow 乙 filled with water 水',
    },
    radical: '乙',
    matches: [[0], [1], [1], [1], [1]],
  },
  {
    character: '氺',
    pinyin: ['shui'],
    decomposition: '⿻亅？',
    etymology: {
      type: 'ideographic',
      hint: 'A river running between two banks; compare 川 and 水',
    },
    radical: '氺',
    matches: [[0], null, null, null, null],
  },
  {
    character: '氽',
    definition: 'to float; to deep-fry',
    pinyin: ['tǔn'],
    decomposition: '⿱人水',
    etymology: {
      type: 'pictophonetic',
      phonetic: '人',
      semantic: '水',
      hint: 'water',
    },
    radical: '人',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '氾',
    definition: 'to flood, to inundate, to overflow',
    pinyin: ['fàn'],
    decomposition: '⿰氵㔾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㔾',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '氿',
    definition: 'spring',
    pinyin: ['guǐ'],
    decomposition: '⿰氵九',
    etymology: {
      type: 'pictophonetic',
      phonetic: '九',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '汀',
    definition: 'bank, sandbar; beach, shore',
    pinyin: ['tīng'],
    decomposition: '⿰氵丁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丁',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '汁',
    definition: 'juice, liquor, fluid; sap; gravy, sauce',
    pinyin: ['zhī'],
    decomposition: '⿰氵十',
    etymology: {
      type: 'pictophonetic',
      phonetic: '十',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '求',
    definition: 'to seek; to request, to demand; to beseech, to beg for',
    pinyin: ['qiú'],
    decomposition: '⿻一氺',
    radical: '氺',
    matches: [[0], [1], [1], [1], [1], [1], null],
  },
  {
    character: '汆',
    definition: 'to parboil; to boil; a kettle of hot water',
    pinyin: ['cuān'],
    decomposition: '⿱入水',
    etymology: {
      type: 'pictophonetic',
      phonetic: '入',
      semantic: '水',
      hint: 'water',
    },
    radical: '水',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '汇',
    definition: 'to gather, to collect; confluence',
    pinyin: ['huì'],
    decomposition: '⿰氵匚',
    etymology: {
      type: 'ideographic',
      hint: 'Water 氵 collected in a container 匚',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '汉',
    definition: 'Chinese people; Chinese language',
    pinyin: ['hàn'],
    decomposition: '⿰氵又',
    etymology: {
      type: 'ideographic',
      hint: 'Simplified form of 漢; the Han 𦰩 river 氵',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '汊',
    definition: 'a branching stream',
    pinyin: ['chà'],
    decomposition: '⿰氵叉',
    etymology: {
      type: 'ideographic',
      hint: 'A stream 氵 that forks 叉; 叉 also provides the pronunciation',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '汐',
    definition: 'night tide, evening ebb tide',
    pinyin: ['xī'],
    decomposition: '⿰氵夕',
    etymology: {
      type: 'ideographic',
      hint: 'The evening 夕 tide 氵; 夕 also provides the pronunciation',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '汒',
    pinyin: ['máng'],
    decomposition: '⿰氵亡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亡',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '汔',
    definition: 'nearby',
    pinyin: ['qì'],
    decomposition: '⿰氵乞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乞',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '汕',
    definition: 'bamboo; basket for catching fish; Shantou',
    pinyin: ['shàn'],
    decomposition: '⿰氵山',
    etymology: {
      type: 'pictophonetic',
      phonetic: '山',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '汗',
    definition: 'perspiration, sweat',
    pinyin: ['hàn'],
    decomposition: '⿰氵干',
    etymology: {
      type: 'pictophonetic',
      phonetic: '干',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '汛',
    definition: 'high water, flood tides',
    pinyin: ['xùn'],
    decomposition: '⿰氵卂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卂',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '汜',
    definition: 'a stream which forks and then rejoins the main branch',
    pinyin: ['sì'],
    decomposition: '⿰氵巳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巳',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '汝',
    definition: 'you',
    pinyin: ['rǔ'],
    decomposition: '⿰氵女',
    etymology: {
      type: 'pictophonetic',
      phonetic: '女',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '汞',
    definition: 'mercury (element)',
    pinyin: ['gǒng'],
    decomposition: '⿱工水',
    etymology: {
      type: 'pictophonetic',
      phonetic: '工',
      semantic: '水',
      hint: 'water',
    },
    radical: '水',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '江',
    definition: 'large river; the Yangtze; surname',
    pinyin: ['jiāng'],
    decomposition: '⿰氵工',
    etymology: {
      type: 'pictophonetic',
      phonetic: '工',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '池',
    definition: 'pool, pond; moat; cistern',
    pinyin: ['chí'],
    decomposition: '⿰氵也',
    etymology: {
      type: 'pictophonetic',
      phonetic: '也',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '污',
    definition: 'filthy, dirty; polluted, impure',
    pinyin: ['wū'],
    decomposition: '⿰氵亏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亏',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '汤',
    definition: 'soup, gravy, broth; hot water',
    pinyin: ['tāng'],
    decomposition: '⿰氵昜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昜',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '汧',
    definition: 'marsh; to float; the name of a river in Shangdong',
    pinyin: ['qiān'],
    decomposition: '⿰氵开',
    etymology: {
      type: 'pictophonetic',
      phonetic: '开',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '汨',
    definition: 'to sink; a river in Hunan where Qu Yuan drowned himself',
    pinyin: ['mì'],
    decomposition: '⿰氵日',
    etymology: {
      type: 'pictophonetic',
      phonetic: '日',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '汩',
    definition: 'the sound of running water; to gurgle; confused, disorderly',
    pinyin: ['gǔ'],
    decomposition: '⿰氵曰',
    etymology: { type: 'ideographic', hint: 'The sound 曰 of a stream 氵' },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '汪',
    definition: 'vast, extensive, deep; surname',
    pinyin: ['wāng'],
    decomposition: '⿰氵王',
    etymology: {
      type: 'pictophonetic',
      phonetic: '王',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '汰',
    definition: 'to eliminate, to scour, to wash out; excessive',
    pinyin: ['tài'],
    decomposition: '⿰氵太',
    etymology: {
      type: 'pictophonetic',
      phonetic: '太',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '汲',
    definition: 'to draw water at a well; to imbibe',
    pinyin: ['jí'],
    decomposition: '⿰氵及',
    etymology: {
      type: 'pictophonetic',
      phonetic: '及',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '汴',
    definition: 'a river in Henan; Henan province',
    pinyin: ['biàn'],
    decomposition: '⿰氵卞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卞',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '汶',
    definition: 'a river in Shandong province',
    pinyin: ['wèn'],
    decomposition: '⿰氵文',
    etymology: {
      type: 'pictophonetic',
      phonetic: '文',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '汹',
    definition: 'turbulent, torrential, restless',
    pinyin: ['xiōng'],
    decomposition: '⿰氵凶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '凶',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '決',
    definition: 'to decide, to determine, to judge',
    pinyin: ['jué'],
    decomposition: '⿰氵夬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '氵',
      semantic: '夬',
      hint: 'decisive',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '汽',
    definition: 'gasoline; steam, vapor',
    pinyin: ['qì'],
    decomposition: '⿰氵气',
    etymology: {
      type: 'ideographic',
      hint: 'Liquid 氵 gas 气; 气 also provides the pronunciation',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '汾',
    definition: 'a river in Shanxi province',
    pinyin: ['fén'],
    decomposition: '⿰氵分',
    etymology: {
      type: 'pictophonetic',
      phonetic: '分',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '沁',
    definition: 'to soak, to seep in, to percolate',
    pinyin: ['qìn'],
    decomposition: '⿰氵心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '心',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '沂',
    definition: 'a river in southeast Shandong',
    pinyin: ['yí'],
    decomposition: '⿰氵斤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斤',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '沃',
    definition: 'to water, to irrigate; fertile, rich',
    pinyin: ['wò'],
    decomposition: '⿰氵夭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夭',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '沅',
    definition: 'a river in western Hunan',
    pinyin: ['yuán'],
    decomposition: '⿰氵元',
    etymology: {
      type: 'pictophonetic',
      phonetic: '元',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '沆',
    definition: 'ferry; fog; to go with the flow',
    pinyin: ['hàng'],
    decomposition: '⿰氵亢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亢',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '沇',
    definition: 'flowing, engulfing, brimming',
    pinyin: ['yǎn'],
    decomposition: '⿰氵允',
    etymology: {
      type: 'pictophonetic',
      phonetic: '允',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '沈',
    definition: 'to sink, to submerge; addicted; surname',
    pinyin: ['chén'],
    decomposition: '⿰氵冘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冘',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '沉',
    definition: 'to sink, to submerge; profound, deep',
    pinyin: ['chén'],
    decomposition: '⿰氵冗',
    etymology: {
      type: 'ideographic',
      hint: 'An excessive 冗 amount of water 氵',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '沌',
    definition: 'chaotic, confused; murky, turbid',
    pinyin: ['dùn'],
    decomposition: '⿰氵屯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屯',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '沏',
    definition: 'to infuse',
    pinyin: ['qī'],
    decomposition: '⿰氵切',
    etymology: {
      type: 'pictophonetic',
      phonetic: '切',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '沐',
    definition: 'to bathe, to cleanse, to shampoo, to wash',
    pinyin: ['mù'],
    decomposition: '⿰氵木',
    etymology: {
      type: 'pictophonetic',
      phonetic: '木',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '沒',
    definition: 'not, none, gone; to bury; to sink, to drown',
    pinyin: ['méi'],
    decomposition: '⿰氵⿱？又',
    etymology: { type: 'pictophonetic', semantic: '氵', hint: 'water' },
    radical: '氵',
    matches: [[0], [0], [0], null, null, [1, 1], [1, 1]],
  },
  {
    character: '沓',
    definition: 'connected, joined; repeated',
    pinyin: ['tà'],
    decomposition: '⿱水日',
    radical: '水',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '沔',
    definition: 'flood; overflowing',
    pinyin: ['miǎn'],
    decomposition: '⿰氵丏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丏',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '沖',
    definition: 'wash, rinse, flush; dash; soar',
    pinyin: ['chōng'],
    decomposition: '⿰氵中',
    etymology: {
      type: 'pictophonetic',
      phonetic: '中',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '沙',
    definition: 'sand, gravel, pebbles; granulated',
    pinyin: ['shā'],
    decomposition: '⿰氵少',
    etymology: {
      type: 'pictophonetic',
      phonetic: '少',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '沛',
    definition: 'abundant, copious, full',
    pinyin: ['pèi'],
    decomposition: '⿰氵巿',
    etymology: {
      type: 'ideographic',
      hint: 'Circulating 巿 water 氵, representing a flood',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '沟',
    definition: 'ditch, drain, gutter, narrow waterway',
    pinyin: ['gōu'],
    decomposition: '⿰氵勾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '勾',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '没',
    definition: 'not, none, gone; to bury; to sink, to drown',
    pinyin: ['méi'],
    decomposition: '⿰氵殳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '殳',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '沣',
    definition: 'a river in Shanxi province',
    pinyin: ['fēng'],
    decomposition: '⿰氵丰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丰',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '沤',
    definition: 'to soak, to steep; sodden, soaked',
    pinyin: ['ōu'],
    decomposition: '⿰氵区',
    etymology: {
      type: 'pictophonetic',
      phonetic: '区',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '沥',
    definition: 'trickle, drip, dregs; to strain',
    pinyin: ['lì'],
    decomposition: '⿰氵历',
    etymology: {
      type: 'pictophonetic',
      phonetic: '历',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '沦',
    definition: 'sunk, submerged; to perish, to be lost',
    pinyin: ['lún'],
    decomposition: '⿰氵仑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '仑',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '沧',
    definition: 'azure, cold, vast (all as of the sea)',
    pinyin: ['cāng'],
    decomposition: '⿰氵仓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '仓',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '沩',
    definition: 'a river in Shanxi province',
    pinyin: ['wéi'],
    decomposition: '⿰氵为',
    etymology: {
      type: 'pictophonetic',
      phonetic: '为',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '沪',
    definition: 'Shanghai; the Shanghai river',
    pinyin: ['hù'],
    decomposition: '⿰氵户',
    etymology: {
      type: 'pictophonetic',
      phonetic: '户',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '沫',
    definition: 'bubbles, foam, froth, suds',
    pinyin: ['mò'],
    decomposition: '⿰氵末',
    etymology: {
      type: 'pictophonetic',
      phonetic: '末',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '沭',
    definition: 'a river in Shantung province',
    pinyin: ['shù'],
    decomposition: '⿰氵术',
    etymology: {
      type: 'pictophonetic',
      phonetic: '术',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '沮',
    definition: 'to stop, to prevent; dejected, defeated',
    pinyin: ['jǔ'],
    decomposition: '⿰氵且',
    etymology: {
      type: 'pictophonetic',
      phonetic: '且',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '沱',
    definition: 'river, stream, waterway; to flow',
    pinyin: ['tuó'],
    decomposition: '⿰氵它',
    etymology: {
      type: 'pictophonetic',
      phonetic: '它',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '沲',
    definition: 'to float',
    pinyin: ['tuó'],
    decomposition: '⿰氵⿱？也',
    etymology: { type: 'pictophonetic', phonetic: '也', semantic: '氵' },
    radical: '氵',
    matches: [[0], [0], [0], null, null, [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '河',
    definition: 'river, stream; the Yellow river',
    pinyin: ['hé'],
    decomposition: '⿰氵可',
    etymology: {
      type: 'pictophonetic',
      phonetic: '可',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '沸',
    definition: 'to boil, to bubble up, to gush',
    pinyin: ['fèi'],
    decomposition: '⿰氵弗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弗',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '油',
    definition: 'oil, fat, grease, lard; oil paints',
    pinyin: ['yóu'],
    decomposition: '⿰氵由',
    etymology: {
      type: 'pictophonetic',
      phonetic: '由',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '治',
    definition: 'to administer, to govern, to regulate',
    pinyin: ['zhì'],
    decomposition: '⿰氵台',
    etymology: {
      type: 'ideographic',
      hint: 'A structure 台 that directs the flow of water 氵',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '沼',
    definition: 'lake, pond, swamp',
    pinyin: ['zhǎo'],
    decomposition: '⿰氵召',
    etymology: {
      type: 'pictophonetic',
      phonetic: '召',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '沽',
    definition: 'to buy and sell; of inferior quality',
    pinyin: ['gū'],
    decomposition: '⿰氵古',
    etymology: {
      type: 'pictophonetic',
      phonetic: '古',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '沾',
    definition: 'to moisten, to soak, to wet; to touch',
    pinyin: ['zhān'],
    decomposition: '⿰氵占',
    etymology: {
      type: 'pictophonetic',
      phonetic: '占',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '沿',
    definition: 'to follow a course, to go along',
    pinyin: ['yán'],
    decomposition: '⿰氵⿱几口',
    etymology: { type: 'pictophonetic', semantic: '氵', hint: 'water' },
    radical: '氵',
    matches: [[0], [0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '況',
    definition: 'condition, situation; furthermore',
    pinyin: ['kuàng'],
    decomposition: '⿰氵兄',
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '泄',
    definition: 'drip, leak, vent; to disperse; to reduce',
    pinyin: ['xiè'],
    decomposition: '⿰氵世',
    etymology: {
      type: 'pictophonetic',
      phonetic: '世',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '泅',
    definition: 'to float, to swim, to wade',
    pinyin: ['qiú'],
    decomposition: '⿰氵囚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '囚',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '泆',
    definition: 'to overflow; licentious, libertine, dissipated',
    pinyin: ['yì'],
    decomposition: '⿰氵失',
    etymology: {
      type: 'pictophonetic',
      phonetic: '失',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '泉',
    definition: 'spring, fountain; wealth, money',
    pinyin: ['quán'],
    decomposition: '⿱白水',
    etymology: {
      type: 'ideographic',
      hint: 'Water 水 flowing from a spring 白',
    },
    radical: '水',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '泊',
    definition: 'to anchor; to moor',
    pinyin: ['pō'],
    decomposition: '⿰氵白',
    etymology: {
      type: 'pictophonetic',
      phonetic: '白',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '泌',
    definition: 'to seep out, to secrete',
    pinyin: ['mì'],
    decomposition: '⿰氵必',
    etymology: {
      type: 'pictophonetic',
      phonetic: '必',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '泐',
    definition: 'to write; mineral vein',
    pinyin: ['lè'],
    decomposition: '⿰氵阞',
    etymology: {
      type: 'ideographic',
      hint: 'To deposit 氵 a new silt layer 阞; 阞 also provides the pronunciation',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '泓',
    definition: 'a clear deep pool of water',
    pinyin: ['hóng'],
    decomposition: '⿰氵弘',
    etymology: {
      type: 'ideographic',
      hint: 'Expansive 弘 water 氵; 弘 also provides the pronunciation',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '泔',
    definition: 'water from washing rice; thick gruel',
    pinyin: ['gān'],
    decomposition: '⿰氵甘',
    etymology: {
      type: 'ideographic',
      hint: 'Sweet 甘 water 氵; 甘 also provides the pronunciation',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '法',
    definition: 'law, rule, statute; method, way; French',
    pinyin: ['fǎ'],
    decomposition: '⿰氵去',
    etymology: {
      type: 'ideographic',
      hint: 'The course 去 followed by a stream 氵',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '泖',
    definition: 'still water; a river in Jiangsu province',
    pinyin: ['mǎo'],
    decomposition: '⿰氵卯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卯',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '泗',
    definition: 'mucus; to sniffle; a river in Shandong province',
    pinyin: ['sì'],
    decomposition: '⿰氵四',
    etymology: {
      type: 'pictophonetic',
      phonetic: '四',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '泙',
    definition: 'to roar',
    pinyin: ['píng'],
    decomposition: '⿰氵平',
    etymology: {
      type: 'pictophonetic',
      phonetic: '平',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '泛',
    definition: 'to drift, to float; broad, vast; careless, reckless',
    pinyin: ['fàn'],
    decomposition: '⿰氵乏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乏',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '泞',
    definition: 'mud, mire; muddy, stagnant',
    pinyin: ['nìng'],
    decomposition: '⿰氵宁',
    etymology: {
      type: 'ideographic',
      hint: 'Still 宁 water 氵; 宁 also provides the pronunciation',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '泠',
    definition: 'nice and cool, mild and comfortable',
    pinyin: ['líng'],
    decomposition: '⿰氵令',
    etymology: {
      type: 'pictophonetic',
      phonetic: '令',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '泡',
    definition: 'bubble, blister; swollen, puffed up',
    pinyin: ['pào'],
    decomposition: '⿰氵包',
    etymology: {
      type: 'pictophonetic',
      phonetic: '包',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '波',
    definition: 'waves, ripples, breakers; undulations',
    pinyin: ['bō'],
    decomposition: '⿰氵皮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皮',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '泣',
    definition: 'to cry, to sob, to weep',
    pinyin: ['qì'],
    decomposition: '⿰氵立',
    etymology: {
      type: 'pictophonetic',
      phonetic: '立',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '泥',
    definition: 'mud, earth, clay; plaster, paste',
    pinyin: ['ní'],
    decomposition: '⿰氵尼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尼',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '注',
    definition: 'to concentrate, to focus',
    pinyin: ['zhù'],
    decomposition: '⿰氵主',
    etymology: {
      type: 'pictophonetic',
      phonetic: '主',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '泪',
    definition: 'tears; to cry, to weep',
    pinyin: ['lèi'],
    decomposition: '⿰氵目',
    etymology: { type: 'ideographic', hint: 'Water 氵 from the eyes 目' },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '泫',
    definition: 'to weep, to cry; to shine, to glisten',
    pinyin: ['xuàn'],
    decomposition: '⿰氵玄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '玄',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '泮',
    definition: 'Zhou dynasty school; to disperse, to fall apart',
    pinyin: ['pàn'],
    decomposition: '⿰氵半',
    etymology: {
      type: 'pictophonetic',
      phonetic: '半',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '泯',
    definition: 'to destroy, to eliminate; to perish',
    pinyin: ['mǐn'],
    decomposition: '⿰氵民',
    etymology: {
      type: 'pictophonetic',
      phonetic: '民',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '泰',
    definition: 'great, exalted, superior; calm; big',
    pinyin: ['tài'],
    decomposition: '⿱？氺',
    etymology: { type: 'ideographic', hint: 'Water 氺 contained by a dam' },
    radical: '氺',
    matches: [null, null, null, null, null, [1], [1], [1], [1], [1]],
  },
  {
    character: '泱',
    definition: 'great, expansive; agitated',
    pinyin: ['yāng'],
    decomposition: '⿰氵央',
    etymology: {
      type: 'pictophonetic',
      phonetic: '央',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '泳',
    definition: 'to swim, to dive',
    pinyin: ['yǒng'],
    decomposition: '⿰氵永',
    etymology: {
      type: 'pictophonetic',
      phonetic: '永',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '泵',
    definition: 'to pump',
    pinyin: ['bèng'],
    decomposition: '⿱石水',
    etymology: {
      type: 'ideographic',
      hint: 'To pull water 水 out of stone 石',
    },
    radical: '水',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '泶',
    pinyin: ['xué'],
    decomposition: '⿱⿱⺍冖水',
    radical: '水',
    matches: [[0, 0], [0, 0], [0, 0], [0, 1], [0, 1], [1], [1], [1], [1]],
  },
  {
    character: '泷',
    definition: 'raining; wet, soaked; rapids; a river in Guangdong',
    pinyin: ['lóng'],
    decomposition: '⿰氵龙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龙',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '泸',
    definition: 'a river in Jiangxi province',
    pinyin: ['lú'],
    decomposition: '⿰氵卢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卢',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '泺',
    definition: 'a river in Shandong province',
    pinyin: ['luò'],
    decomposition: '⿰氵乐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乐',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '泻',
    definition: 'to leak; diarrhea',
    pinyin: ['xiè'],
    decomposition: '⿰氵写',
    etymology: {
      type: 'pictophonetic',
      phonetic: '写',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '泼',
    definition: 'to pour, to splash, to sprinkle, to water',
    pinyin: ['pō'],
    decomposition: '⿰氵发',
    etymology: { type: 'ideographic', hint: 'To send forth 发 water 氵' },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '泽',
    definition: 'marsh, swamp; brilliance, grace',
    pinyin: ['zé'],
    decomposition: '⿰氵？',
    etymology: { type: 'pictophonetic', semantic: '氵', hint: 'water' },
    radical: '氵',
    matches: [[0], [0], [0], null, null, null, null, null],
  },
  {
    character: '泾',
    definition: 'a river in Gansu and Shaanxi',
    pinyin: ['jīng'],
    decomposition: '⿰氵？',
    etymology: { type: 'pictophonetic', semantic: '氵', hint: 'water' },
    radical: '氵',
    matches: [[0], [0], [0], null, null, null, null, null],
  },
  {
    character: '洁',
    definition: 'clean, pure; to purify, to cleanse',
    pinyin: ['jié'],
    decomposition: '⿰氵吉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吉',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '洄',
    definition: 'backwater; an eddy a whirlpool',
    pinyin: ['huí'],
    decomposition: '⿰氵回',
    etymology: {
      type: 'ideographic',
      hint: 'Swirling 回 water 氵; 回 also provides the pronunciation',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '洇',
    definition: 'to soak; to blot, to splotch',
    pinyin: ['yīn'],
    decomposition: '⿰氵因',
    etymology: {
      type: 'pictophonetic',
      phonetic: '因',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '洋',
    definition: 'sea, ocean; western, foreign',
    pinyin: ['yáng'],
    decomposition: '⿰氵羊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羊',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '洌',
    definition: 'clear, pure; to cleanse',
    pinyin: ['liè'],
    decomposition: '⿰氵列',
    etymology: {
      type: 'pictophonetic',
      phonetic: '列',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '洎',
    definition: 'when, until; to soak; soup',
    pinyin: ['jì'],
    decomposition: '⿰氵自',
    etymology: {
      type: 'pictophonetic',
      phonetic: '自',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '洒',
    definition: 'to pour, to spill; to scatter, to shed; to wipe away',
    pinyin: ['sǎ'],
    decomposition: '⿰氵西',
    etymology: {
      type: 'pictophonetic',
      phonetic: '西',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '洗',
    definition: 'to bathe, to rinse, to wash',
    pinyin: ['xǐ'],
    decomposition: '⿰氵先',
    etymology: {
      type: 'pictophonetic',
      phonetic: '先',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '洙',
    definition: 'a river in Shandong province',
    pinyin: ['zhū'],
    decomposition: '⿰氵朱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朱',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '洚',
    definition: 'flood',
    pinyin: ['jiàng'],
    decomposition: '⿰氵夅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夅',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '洛',
    definition: 'a river in the Shanxi province; a city',
    pinyin: ['luò'],
    decomposition: '⿰氵各',
    etymology: {
      type: 'pictophonetic',
      phonetic: '各',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '洞',
    definition: 'cave, grotto, hole, ravine',
    pinyin: ['dòng'],
    decomposition: '⿰氵同',
    etymology: {
      type: 'pictophonetic',
      phonetic: '同',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '洣',
    definition: 'a river in Hunan province',
    pinyin: ['mǐ'],
    decomposition: '⿰氵米',
    etymology: {
      type: 'pictophonetic',
      phonetic: '米',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '津',
    definition: 'saliva, sweat; ferry, ford',
    pinyin: ['jīn'],
    decomposition: '⿰氵聿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '聿',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '洧',
    definition: 'a river in Henan province',
    pinyin: ['wěi'],
    decomposition: '⿰氵有',
    etymology: {
      type: 'pictophonetic',
      phonetic: '有',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '洨',
    definition: 'a river in Hebei province',
    pinyin: ['xiáo'],
    decomposition: '⿰氵交',
    etymology: {
      type: 'pictophonetic',
      phonetic: '交',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '洩',
    definition: 'to leak, to drip; to vent, to release',
    pinyin: ['xiè'],
    decomposition: '⿰氵曳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曳',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '洪',
    definition: 'deluge, flood; immense, vast',
    pinyin: ['hóng'],
    decomposition: '⿰氵共',
    etymology: {
      type: 'ideographic',
      hint: 'All 共 the water 氵; 共 also provides the pronunciation',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '洫',
    definition: 'moat, ditch',
    pinyin: ['xù'],
    decomposition: '⿰氵血',
    etymology: {
      type: 'pictophonetic',
      phonetic: '血',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '洮',
    definition: 'to cleanse; a river in Gansu province',
    pinyin: ['táo'],
    decomposition: '⿰氵兆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兆',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '洰',
    definition: 'ditch, gutter; canal, channel',
    pinyin: ['jù'],
    decomposition: '⿰氵巨',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巨',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '洱',
    definition: 'a lake in Yunnan province',
    pinyin: ['ěr'],
    decomposition: '⿰氵耳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '耳',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '洲',
    definition: 'continent; island',
    pinyin: ['zhōu'],
    decomposition: '⿰氵州',
    etymology: {
      type: 'ideographic',
      hint: 'A state 州 surrounded by water 氵; 州 also provides the pronunciation',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '洳',
    definition: 'sdamp, boggy, marshy',
    pinyin: ['rù'],
    decomposition: '⿰氵如',
    etymology: {
      type: 'pictophonetic',
      phonetic: '如',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '洵',
    definition: 'true, real; truly, really',
    pinyin: ['xún'],
    decomposition: '⿰氵旬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旬',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '洶',
    definition: 'turbulent, torrential, restless',
    pinyin: ['xiōng'],
    decomposition: '⿰氵匈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匈',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '洹',
    definition: 'a river in Henan province',
    pinyin: ['huán'],
    decomposition: '⿰氵亘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亘',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '活',
    definition: 'to exist, to live, to survive; living, working',
    pinyin: ['huó'],
    decomposition: '⿰氵舌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '舌',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '洼',
    definition: 'pit, hollow, depression; swamp',
    pinyin: ['wā'],
    decomposition: '⿰氵圭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '圭',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '洽',
    definition: 'to mix, to blend, to harmonize',
    pinyin: ['qià'],
    decomposition: '⿰氵合',
    etymology: { type: 'ideographic', hint: 'To combine 合 two solutions 氵' },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '派',
    definition: 'clique, faction, group, sect',
    pinyin: ['pài'],
    decomposition: '⿰氵⿸？氏',
    radical: '氵',
    matches: [[0], [0], [0], null, null, [1, 1], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '流',
    definition: 'to flow, to drift, to circulate; class',
    pinyin: ['liú'],
    decomposition: '⿰氵㐬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㐬',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '浃',
    definition: 'to saturate, to drench; wet, damp',
    pinyin: ['jiā'],
    decomposition: '⿰氵夹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夹',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '浅',
    definition: 'shallow, superficial',
    pinyin: ['qiǎn'],
    decomposition: '⿰氵戋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戋',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '浆',
    definition: 'pulp, starch, syrup; a thick fluid',
    pinyin: ['jiāng'],
    decomposition: '⿱⿰丬夕水',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丬',
      semantic: '水',
      hint: 'water',
    },
    radical: '水',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '浇',
    definition: 'to spray, to sprinkle, to water',
    pinyin: ['jiāo'],
    decomposition: '⿰氵尧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尧',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '浈',
    definition: 'a river in Guangdong province',
    pinyin: ['zhēn'],
    decomposition: '⿰氵贞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贞',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '浉',
    definition: 'a river in Henan province',
    pinyin: ['shī'],
    decomposition: '⿰氵师',
    etymology: {
      type: 'pictophonetic',
      phonetic: '师',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '浊',
    definition: 'dirty, filthy, muddy, turbid',
    pinyin: ['zhuó'],
    decomposition: '⿰氵虫',
    etymology: { type: 'ideographic', hint: 'A pond 氵 growing scum 虫' },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '测',
    definition: 'to survey, to measure; to estimate, to conjecture',
    pinyin: ['cè'],
    decomposition: '⿰氵则',
    etymology: {
      type: 'pictophonetic',
      phonetic: '则',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '浍',
    definition: 'ditch, trench, irrigation canal; river',
    pinyin: ['huì'],
    decomposition: '⿰氵会',
    etymology: {
      type: 'pictophonetic',
      phonetic: '会',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '济',
    definition: 'to aid, to help, to relieve; to ferry across',
    pinyin: ['jì'],
    decomposition: '⿰氵齐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '齐',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '浏',
    definition: 'bright; clear; deep; swift',
    pinyin: ['liú'],
    decomposition: '⿰氵刘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '刘',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '浐',
    definition: 'a river in Shaanxi province',
    pinyin: ['chǎn'],
    decomposition: '⿰氵产',
    etymology: {
      type: 'pictophonetic',
      phonetic: '产',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '浑',
    definition: 'blended, mixed; muddy, turbid',
    pinyin: ['hún'],
    decomposition: '⿰氵军',
    etymology: {
      type: 'pictophonetic',
      phonetic: '军',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '浒',
    definition: 'shore, river bank',
    pinyin: ['hǔ'],
    decomposition: '⿰氵许',
    etymology: {
      type: 'pictophonetic',
      phonetic: '许',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '浓',
    definition: 'concentrated, dense, strong, thick',
    pinyin: ['nóng'],
    decomposition: '⿰氵农',
    etymology: {
      type: 'pictophonetic',
      phonetic: '农',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '浔',
    definition: 'steep river bank',
    pinyin: ['xún'],
    decomposition: '⿰氵寻',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寻',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '浙',
    definition: 'the Zhejiang province; a river',
    pinyin: ['zhè'],
    decomposition: '⿰氵折',
    etymology: {
      type: 'pictophonetic',
      phonetic: '折',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '浚',
    definition: 'to dredge',
    pinyin: ['jùn'],
    decomposition: '⿰氵夋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夋',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '浜',
    definition: 'creek, stream; beach, coast',
    pinyin: ['bāng'],
    decomposition: '⿰氵兵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兵',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '浞',
    definition: 'to soak, to steep in water',
    pinyin: ['zhuó'],
    decomposition: '⿰氵足',
    etymology: {
      type: 'pictophonetic',
      phonetic: '足',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '浠',
    definition: 'a river in Hubei province',
    pinyin: ['xī'],
    decomposition: '⿰氵希',
    etymology: {
      type: 'pictophonetic',
      phonetic: '希',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '浣',
    definition: 'to wash, to rinse',
    pinyin: ['huàn'],
    decomposition: '⿰氵完',
    etymology: {
      type: 'pictophonetic',
      phonetic: '完',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '浦',
    definition: 'beach, shore, river bank; surname',
    pinyin: ['pǔ'],
    decomposition: '⿰氵甫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甫',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '浩',
    definition: 'great, grand, vast',
    pinyin: ['hào'],
    decomposition: '⿰氵告',
    etymology: {
      type: 'pictophonetic',
      phonetic: '告',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '浪',
    definition: 'breaker, wave; reckless, wasteful',
    pinyin: ['làng'],
    decomposition: '⿰氵良',
    etymology: {
      type: 'pictophonetic',
      phonetic: '良',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '浮',
    definition: 'to drift, to float; mobile, temporary, unstable; reckless',
    pinyin: ['fú'],
    decomposition: '⿰氵孚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孚',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '浯',
    definition: 'a river in Shandong province',
    pinyin: ['wú'],
    decomposition: '⿰氵吾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吾',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '浴',
    definition: 'to bathe, to shower, to wash',
    pinyin: ['yù'],
    decomposition: '⿰氵谷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '谷',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '海',
    definition: 'sea, ocean; maritime',
    pinyin: ['hǎi'],
    decomposition: '⿰氵每',
    etymology: {
      type: 'pictophonetic',
      phonetic: '每',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '浸',
    definition: 'to dip, to immerse, to soak; to percolate, to steep',
    pinyin: ['jìn'],
    decomposition: '⿰氵⿳彐冖又',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彐',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 2],
      [1, 2],
    ],
  },
  {
    character: '浹',
    definition: 'to saturate, to drench; wet, damp',
    pinyin: ['jiā'],
    decomposition: '⿰氵夾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夾',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '浼',
    definition: 'to request, to ask a favor; to pollute, to contaminate',
    pinyin: ['měi'],
    decomposition: '⿰氵免',
    etymology: {
      type: 'pictophonetic',
      phonetic: '免',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '浽',
    definition: 'drizzle, light rain',
    pinyin: ['suī'],
    decomposition: '⿰氵妥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '妥',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '涂',
    definition: 'to smear, to scribble, to daub; surname',
    pinyin: ['tú'],
    decomposition: '⿰氵余',
    etymology: {
      type: 'pictophonetic',
      phonetic: '余',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '涅',
    definition: 'to blacken; slime, black mud',
    pinyin: ['niè'],
    decomposition: '⿰氵圼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '圼',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '涇',
    definition: 'a river in Gansu and Shaanxi',
    pinyin: ['jīng'],
    decomposition: '⿰氵巠',
    etymology: { type: 'pictophonetic', semantic: '氵', hint: 'water' },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '消',
    definition: 'news, rumors; to die out, to melt away, to vanish',
    pinyin: ['xiāo'],
    decomposition: '⿰氵肖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肖',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '涉',
    definition: 'sconcerned, involved; to experience; to wade through a stream',
    pinyin: ['shè'],
    decomposition: '⿰氵步',
    etymology: { type: 'ideographic', hint: 'To wade 步 through a stream 氵' },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '涌',
    definition: 'to surge up, to bubble up, to gush forth',
    pinyin: ['yǒng'],
    decomposition: '⿰氵甬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甬',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '涎',
    definition: 'saliva',
    pinyin: ['xián'],
    decomposition: '⿰氵延',
    etymology: {
      type: 'pictophonetic',
      phonetic: '延',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '涑',
    definition: 'a river in Shansi province',
    pinyin: ['sù'],
    decomposition: '⿰氵束',
    etymology: {
      type: 'pictophonetic',
      phonetic: '束',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '涓',
    definition: 'brook, stream; pure; to select',
    pinyin: ['juān'],
    decomposition: '⿰氵肙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肙',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '涔',
    definition: 'to overflow; rainwater; a river in Shaanxi province',
    pinyin: ['cén'],
    decomposition: '⿰氵岑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '岑',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '涕',
    definition: 'tears; mucus',
    pinyin: ['tì'],
    decomposition: '⿰氵弟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弟',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '涖',
    definition: 'creek; a river in Hebei province',
    pinyin: ['lì'],
    decomposition: '⿰氵位',
    etymology: {
      type: 'pictophonetic',
      phonetic: '位',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '涛',
    definition: 'large waves',
    pinyin: ['tāo'],
    decomposition: '⿰氵寿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寿',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '涝',
    definition: 'to inundate, to flood; torrent',
    pinyin: ['lào'],
    decomposition: '⿰氵劳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '劳',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '涞',
    definition: 'ripple; brook; a river in Hebei province',
    pinyin: ['lái'],
    decomposition: '⿰氵来',
    etymology: {
      type: 'pictophonetic',
      phonetic: '来',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '涟',
    definition: 'flowing water; ripples; weeping',
    pinyin: ['lián'],
    decomposition: '⿰氵连',
    etymology: {
      type: 'pictophonetic',
      phonetic: '连',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '涠',
    definition: 'still water',
    pinyin: ['wéi'],
    decomposition: '⿰氵围',
    etymology: {
      type: 'pictophonetic',
      phonetic: '围',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '涡',
    definition: 'eddy, swirl, whirlpool',
    pinyin: ['wō'],
    decomposition: '⿰氵呙',
    etymology: { type: 'ideographic', hint: 'A mouth 呙 made of water 氵' },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '涣',
    definition: 'scattered; to scatter',
    pinyin: ['huàn'],
    decomposition: '⿰氵奂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奂',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '涤',
    definition: 'to wash, to sweep; to purify, to cleanse',
    pinyin: ['dí'],
    decomposition: '⿰氵条',
    etymology: {
      type: 'pictophonetic',
      phonetic: '条',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '润',
    definition: 'fresh, moist; soft, sleek',
    pinyin: ['rùn'],
    decomposition: '⿰氵闰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '闰',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '涧',
    definition: 'brook, mountain stream',
    pinyin: ['jiàn'],
    decomposition: '⿰氵间',
    etymology: {
      type: 'ideographic',
      hint: 'A stream 氵 flowing through a valley 间; 间 also provides the pronunciation',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '涨',
    definition: 'flood tide; to rise in price',
    pinyin: ['zhǎng'],
    decomposition: '⿰氵张',
    etymology: {
      type: 'pictophonetic',
      phonetic: '张',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '涩',
    definition: 'astringent, harsh, rough, uneven',
    pinyin: ['sè'],
    decomposition: '⿰氵⿱刃止',
    etymology: {
      type: 'ideographic',
      hint: 'Water 氵 that cuts like a knife 刃; 止 provides the pronunciation',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '涪',
    definition: 'a river in Sichuan province',
    pinyin: ['fú'],
    decomposition: '⿰氵咅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咅',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '涫',
    definition: 'to boil',
    pinyin: ['guàn'],
    decomposition: '⿰氵官',
    etymology: {
      type: 'pictophonetic',
      phonetic: '官',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '涮',
    definition: 'to rinse; to boil or cook in juice',
    pinyin: ['shuàn'],
    decomposition: '⿰氵刷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '刷',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '涯',
    definition: 'border, horizon; river bank, shore',
    pinyin: ['yá'],
    decomposition: '⿰氵厓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厓',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '液',
    definition: 'fluid, liquid; juice, sap',
    pinyin: ['yè'],
    decomposition: '⿰氵夜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夜',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '涵',
    definition: 'to wet, to soak; to tolerate, to include lenient',
    pinyin: ['hán'],
    decomposition: '⿰氵函',
    etymology: {
      type: 'pictophonetic',
      phonetic: '函',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '涸',
    definition: 'tired, exhausted; dried up',
    pinyin: ['hé'],
    decomposition: '⿰氵固',
    etymology: {
      type: 'ideographic',
      hint: 'To run out 氵 of strength 固; 固 also provides the pronunciation',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '涼',
    definition: 'cool, cold; disheartened',
    pinyin: ['liáng'],
    decomposition: '⿰氵京',
    etymology: {
      type: 'pictophonetic',
      semantic: '氵',
      hint: 'water',
      phonetic: '京',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '涿',
    definition: 'to trickle, to dribble, to drip',
    pinyin: ['zhuō'],
    decomposition: '⿰氵豖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豖',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淀',
    definition: 'marsh, swamp; sediment; to precipitate',
    pinyin: ['diàn'],
    decomposition: '⿰氵定',
    etymology: {
      type: 'pictophonetic',
      phonetic: '定',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淄',
    definition: 'a river in Shandong province',
    pinyin: ['zī'],
    decomposition: '⿰氵甾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甾',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淅',
    definition: 'water used wash rice',
    pinyin: ['xī'],
    decomposition: '⿰氵析',
    etymology: {
      type: 'pictophonetic',
      phonetic: '析',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淆',
    definition: 'confused, mixed up, in disarray',
    pinyin: ['xiáo'],
    decomposition: '⿰氵肴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肴',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淇',
    definition: 'a river in Henan province',
    pinyin: ['qí'],
    decomposition: '⿰氵其',
    etymology: {
      type: 'pictophonetic',
      phonetic: '其',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淋',
    definition: 'to drench, to drip, to soak; perfectly',
    pinyin: ['lín'],
    decomposition: '⿰氵林',
    etymology: {
      type: 'pictophonetic',
      phonetic: '林',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淌',
    definition: 'to trickle down, to flow, to drip; to shed tears',
    pinyin: ['tǎng'],
    decomposition: '⿰氵尚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尚',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淑',
    definition: 'good, pure, virtuous; charming',
    pinyin: ['shū'],
    decomposition: '⿰氵叔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叔',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淒',
    definition: 'bitter, cold, dreary, miserable',
    pinyin: ['qī'],
    decomposition: '⿰氵妻',
    etymology: {
      type: 'pictophonetic',
      phonetic: '妻',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淖',
    definition: 'mud, slush',
    pinyin: ['nào'],
    decomposition: '⿰氵卓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卓',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淘',
    definition: 'to dredge, to sieve; to cleanse, to weed out',
    pinyin: ['táo'],
    decomposition: '⿰氵匋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匋',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淙',
    definition: 'the sound of water gurgling',
    pinyin: ['cóng'],
    decomposition: '⿰氵宗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宗',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淚',
    definition: 'tears; to cry, to weep',
    pinyin: ['lèi'],
    decomposition: '⿰氵戾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戾',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淝',
    definition: 'an affluent of the Poyang Lake',
    pinyin: ['féi'],
    decomposition: '⿰氵肥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肥',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淞',
    definition: 'a river in Jiangsu province',
    pinyin: ['sōng'],
    decomposition: '⿰氵松',
    etymology: {
      type: 'pictophonetic',
      phonetic: '松',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淠',
    definition: 'luxuriant; water lily',
    pinyin: ['pì'],
    decomposition: '⿰氵畀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畀',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淡',
    definition: 'watery, dilute; insipid, tasteless',
    pinyin: ['dàn'],
    decomposition: '⿰氵炎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '炎',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淤',
    definition: 'mud, sediment; to clog up, to silt up',
    pinyin: ['yū'],
    decomposition: '⿰氵於',
    etymology: {
      type: 'pictophonetic',
      phonetic: '於',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淥',
    definition: 'to strain',
    pinyin: ['lù'],
    decomposition: '⿰氵彔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彔',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淦',
    definition: 'a river in Jiangxi province; water leaking into a boat',
    pinyin: ['gàn'],
    decomposition: '⿰氵金',
    etymology: {
      type: 'pictophonetic',
      phonetic: '金',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淨',
    definition: 'clean, pure, unspoiled',
    pinyin: ['jìng'],
    decomposition: '⿰氵爭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爭',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淩',
    definition: 'to cross, to traverse, to pass through',
    pinyin: ['líng'],
    decomposition: '⿰氵夌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夌',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淪',
    definition: 'sunk, submerged; to perish, to be lost',
    pinyin: ['lún'],
    decomposition: '⿰氵侖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '侖',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淫',
    definition: 'obscene, licentious, lewd, kinky',
    pinyin: ['yín'],
    decomposition: '⿰氵⿱爫壬',
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '淬',
    definition: 'to soak, to dye; to temper, to change',
    pinyin: ['cuì'],
    decomposition: '⿰氵卒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卒',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淮',
    definition: 'a river in Anhui province',
    pinyin: ['huái'],
    decomposition: '⿰氵隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隹',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淯',
    definition: 'a river in Henan province',
    pinyin: ['yù'],
    decomposition: '⿰氵育',
    etymology: {
      type: 'pictophonetic',
      phonetic: '育',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '深',
    definition: 'deep, profound; depth',
    pinyin: ['shēn'],
    decomposition: '⿰氵罙',
    etymology: { type: 'ideographic', hint: 'Deep 罙 water 氵' },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淳',
    definition: 'simple, honest, genuine',
    pinyin: ['chún'],
    decomposition: '⿰氵享',
    etymology: {
      type: 'pictophonetic',
      phonetic: '享',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淵',
    definition: 'abyss, depth; to surge up, to bubble up',
    pinyin: ['yuān'],
    decomposition: '⿰氵⿻⿰片爿一',
    etymology: {
      type: 'pictophonetic',
      phonetic: '片',
      hint: 'water',
      semantic: '氵',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1, 0, 0],
      [1, 0, 1],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 1],
      [1, 1],
      [1, 0, 0],
      [1, 0, 1],
      [1, 0, 1],
    ],
  },
  {
    character: '淶',
    definition: 'ripple; brook; a river in Hebei province',
    pinyin: ['lái'],
    decomposition: '⿰氵來',
    etymology: {
      type: 'pictophonetic',
      phonetic: '來',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '混',
    definition: 'muddy, confused; to mix, to blend; to mingle',
    pinyin: ['hùn'],
    decomposition: '⿰氵昆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昆',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淹',
    definition: 'to drown, to immerse, to steep',
    pinyin: ['yān'],
    decomposition: '⿰氵奄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奄',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淺',
    definition: 'shallow, superficial',
    pinyin: ['qiǎn'],
    decomposition: '⿰氵戔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戔',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '添',
    definition: 'to add, to append, to increase, to replenish',
    pinyin: ['tiān'],
    decomposition: '⿰氵忝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '忝',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '淼',
    definition: 'infinity; flooding; a wide expanse of water',
    pinyin: ['miǎo'],
    decomposition: '⿱水⿰水水',
    etymology: { type: 'ideographic', hint: 'Water 水 everywhere' },
    radical: '水',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '清',
    definition: 'clean, pure; clear, distinct; peaceful',
    pinyin: ['qīng'],
    decomposition: '⿰氵青',
    etymology: {
      type: 'pictophonetic',
      phonetic: '青',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '渊',
    definition: 'abyss, depth; to surge up, to bubble up',
    pinyin: ['yuān'],
    decomposition: '⿰氵⿻？米',
    etymology: { type: 'pictophonetic', semantic: '氵', hint: 'water' },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      null,
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      null,
    ],
  },
  {
    character: '渌',
    definition: 'to strain',
    pinyin: ['lù'],
    decomposition: '⿰氵录',
    etymology: {
      type: 'pictophonetic',
      phonetic: '录',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '渍',
    definition: 'to soak, to steep; dye, stains; sodden',
    pinyin: ['zì'],
    decomposition: '⿰氵责',
    etymology: {
      type: 'pictophonetic',
      phonetic: '责',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '渎',
    definition: 'ditch, sluice, gutter, drain',
    pinyin: ['dú'],
    decomposition: '⿰氵卖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卖',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '渐',
    definition: 'gradually',
    pinyin: ['jiàn'],
    decomposition: '⿰氵斩',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斩',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '渑',
    definition: 'the name of a river in Shandong',
    pinyin: ['miǎn'],
    decomposition: '⿰氵黾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '黾',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '渔',
    definition: 'fisherman; to fish; to pursue; to sieze',
    pinyin: ['yú'],
    decomposition: '⿰氵鱼',
    etymology: {
      type: 'ideographic',
      hint: 'To fish 鱼 in a river氵; 鱼 also provides the pronunciation',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '渖',
    definition: 'water, liquid, juice; to pour',
    pinyin: ['shěn'],
    decomposition: '⿰氵审',
    etymology: {
      type: 'pictophonetic',
      phonetic: '审',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '渗',
    definition: 'to seep, to permeate, to infiltrate',
    pinyin: ['shèn'],
    decomposition: '⿰氵参',
    etymology: {
      type: 'pictophonetic',
      phonetic: '参',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '渙',
    definition: 'scattered; to scatter',
    pinyin: ['huàn'],
    decomposition: '⿰氵奐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奐',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '渚',
    definition: 'islet, sandbar',
    pinyin: ['zhǔ'],
    decomposition: '⿰氵者',
    etymology: {
      type: 'pictophonetic',
      phonetic: '者',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '減',
    definition: 'to decrease, to subtract, to diminish',
    pinyin: ['jiǎn'],
    decomposition: '⿰氵咸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咸',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '渝',
    definition: 'to change; Chongqing',
    pinyin: ['yú'],
    decomposition: '⿰氵俞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '俞',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '渠',
    definition: 'ditch, gutter; canal, channel',
    pinyin: ['qú'],
    decomposition: '⿱洰木',
    etymology: {
      type: 'ideographic',
      hint: 'A ditch 洰 made of wood 木; 洰 also provides the pronunciation',
    },
    radical: '氵',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '渡',
    definition: 'to cross, to ferry over, to pass through',
    pinyin: ['dù'],
    decomposition: '⿰氵度',
    etymology: {
      type: 'pictophonetic',
      phonetic: '度',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '渣',
    definition: 'dregs, sediment; refuse, slag',
    pinyin: ['zhā'],
    decomposition: '⿰氵查',
    etymology: {
      type: 'pictophonetic',
      phonetic: '查',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '渤',
    definition: 'swelling; the Bohai sea',
    pinyin: ['bó'],
    decomposition: '⿰氵勃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '勃',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '渥',
    definition: 'to enrich, to dye; to moisten, to soak',
    pinyin: ['wò'],
    decomposition: '⿰氵屋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屋',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '渦',
    definition: 'eddy, swirl, whirlpool',
    pinyin: ['wō'],
    decomposition: '⿰氵咼',
    etymology: { type: 'ideographic', hint: 'A mouth 咼 made of water 氵' },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '温',
    definition: 'warm, lukewarm',
    pinyin: ['wēn'],
    decomposition: '⿰氵昷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昷',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '渫',
    definition: 'to scatter, to disperse; high tide',
    pinyin: ['xiè'],
    decomposition: '⿰氵枼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '枼',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '測',
    definition: 'to survey, to measure; to estimate, to conjecture',
    pinyin: ['cè'],
    decomposition: '⿰氵則',
    etymology: {
      type: 'pictophonetic',
      phonetic: '則',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '渭',
    definition: 'a river in Shanxi province',
    pinyin: ['wèi'],
    decomposition: '⿰氵胃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '胃',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '港',
    definition: 'port, harbor, bay; Hong Kong',
    pinyin: ['gǎng'],
    decomposition: '⿰氵巷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巷',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '渲',
    definition:
      'to render; to exaggerate, to embellish, to add layers of color',
    pinyin: ['xuàn'],
    decomposition: '⿰氵宣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宣',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '渴',
    definition: 'thirsty, parched; to yearn, to pine for',
    pinyin: ['kě'],
    decomposition: '⿰氵曷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曷',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '游',
    definition: 'to wander, to travel, to tour, to roam',
    pinyin: ['yóu'],
    decomposition: '⿰氵斿',
    etymology: {
      type: 'ideographic',
      hint: 'To swim freely 斿 through the seas 氵',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '渺',
    definition: 'vast, boundless',
    pinyin: ['miǎo'],
    decomposition: '⿰氵眇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '眇',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '渾',
    definition: 'blended, mixed; muddy, turbid',
    pinyin: ['hún'],
    decomposition: '⿰氵軍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '軍',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '湃',
    definition: 'turbulent, surging; the sound of waves crashing',
    pinyin: ['pài'],
    decomposition: '⿰氵拜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '拜',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '湄',
    definition: 'bank, coast, shore',
    pinyin: ['méi'],
    decomposition: '⿰氵眉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '眉',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '湉',
    definition: 'flowing smoothly; calm water',
    pinyin: ['tián'],
    decomposition: '⿰氵恬',
    etymology: {
      type: 'ideographic',
      hint: 'Calm 恬 water 氵; 恬 also provides the pronunciation',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '湊',
    definition: 'to piece together, to assemble',
    pinyin: ['còu'],
    decomposition: '⿰氵奏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奏',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '湍',
    definition: 'current, rapids',
    pinyin: ['tuān'],
    decomposition: '⿰氵耑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '耑',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '湎',
    definition: 'drunk, flushed',
    pinyin: ['miǎn'],
    decomposition: '⿰氵面',
    etymology: {
      type: 'ideographic',
      hint: "A man's face 面 after drinking 氵; 面 also provides the pronunciation",
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '湓',
    definition: 'an affluent of the Yangtze river',
    pinyin: ['pén'],
    decomposition: '⿰氵盆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '盆',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '湔',
    definition: 'to wash, to cleanse; to purge',
    pinyin: ['jiān'],
    decomposition: '⿰氵前',
    etymology: {
      type: 'pictophonetic',
      phonetic: '前',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '湖',
    definition: 'lake; Hubei, Hunan; bluish-green',
    pinyin: ['hú'],
    decomposition: '⿰氵胡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '胡',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '湘',
    definition: 'Hunan province; the Xiangjiang river',
    pinyin: ['xiāng'],
    decomposition: '⿰氵相',
    etymology: {
      type: 'pictophonetic',
      phonetic: '相',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '湛',
    definition: 'calm, clear, deep (as of a lake)',
    pinyin: ['zhàn'],
    decomposition: '⿰氵甚',
    etymology: {
      type: 'ideographic',
      hint: 'A deep 甚 lake 氵; 甚 also provides the pronunciation',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '湞',
    definition: 'a river in Guangdong province',
    pinyin: ['zhēn'],
    decomposition: '⿰氵貞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '貞',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '湟',
    definition: 'river in Qinghai province',
    pinyin: ['huáng'],
    decomposition: '⿰氵皇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皇',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '湣',
    definition: 'confused, mixed; to pity',
    pinyin: ['mǐn'],
    decomposition: '⿰氵昬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '民',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '湧',
    definition: 'to gush, to well up, to bubble up',
    pinyin: ['yǒng'],
    decomposition: '⿰氵勈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '勈',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '湫',
    definition: 'marsh, swamp, small pond',
    pinyin: ['jiǎo'],
    decomposition: '⿰氵秋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '秋',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '湮',
    definition: 'to block up; to sink; to stain',
    pinyin: ['yān'],
    decomposition: '⿰氵垔',
    etymology: {
      type: 'ideographic',
      hint: 'A dammed 垔 stream 氵; 垔 also provides the pronunciation',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '湯',
    definition: 'soup, gravy, broth; hot water',
    pinyin: ['tāng'],
    decomposition: '⿰氵昜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昜',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '湴',
    definition: 'mud, mire',
    pinyin: ['bàn'],
    decomposition: '⿰氵並',
    etymology: {
      type: 'pictophonetic',
      phonetic: '並',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '湼',
    definition: 'mud, slime',
    pinyin: ['niè'],
    decomposition: '⿰氵⿱臼工',
    etymology: { type: 'pictophonetic', phonetic: '臼', semantic: '氵' },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '湾',
    definition: 'bay, cove, gulf, inlet',
    pinyin: ['wān'],
    decomposition: '⿰氵弯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弯',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '湿',
    definition: 'wet, moist, humid, damp; illness',
    pinyin: ['shī'],
    decomposition: '⿰氵显',
    etymology: {
      type: 'pictophonetic',
      phonetic: '显',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '溃',
    definition:
      'a flooding river; a military defeat; to break down, to disperse',
    pinyin: ['kuì'],
    decomposition: '⿰氵贵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贵',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '溅',
    definition: 'to sprinkle, to spray, to splash, to spill',
    pinyin: ['jiàn'],
    decomposition: '⿰氵贱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贱',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '溆',
    definition: 'a river in Hunan',
    pinyin: ['xù'],
    decomposition: '⿰氵叙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叙',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '溉',
    definition: 'to water, to irrigate, to flood; to wash',
    pinyin: ['gài'],
    decomposition: '⿰氵既',
    etymology: {
      type: 'pictophonetic',
      phonetic: '既',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '溏',
    definition: 'pool, pond; not hardened, semi-soft',
    pinyin: ['táng'],
    decomposition: '⿰氵唐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '唐',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '源',
    definition: 'spring; source, root, head; surname',
    pinyin: ['yuán'],
    decomposition: '⿰氵原',
    etymology: {
      type: 'pictophonetic',
      phonetic: '原',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '準',
    definition: 'standard, accurate; to permit, to approve, to allow',
    pinyin: ['zhǔn'],
    decomposition: '⿱淮十',
    etymology: {
      type: 'ideographic',
      hint: 'To balance 十 water 氵 in a spirit level; 隹 provides the pronunciation',
    },
    radical: '氵',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '溘',
    definition: 'sudden, abrupt, unexpected',
    pinyin: ['kè'],
    decomposition: '⿰氵盍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '盍',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '溜',
    definition: 'to slip, to slide, to glide; slippery',
    pinyin: ['liū'],
    decomposition: '⿰氵留',
    etymology: {
      type: 'pictophonetic',
      phonetic: '留',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '溝',
    definition: 'ditch, drain, gutter, narrow waterway',
    pinyin: ['gōu'],
    decomposition: '⿰氵冓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冓',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '溟',
    definition: 'drizzling rain; dark, obscure',
    pinyin: ['míng'],
    decomposition: '⿰氵冥',
    etymology: { type: 'ideographic', hint: 'A gloomy 冥 rainy 氵 day' },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '溢',
    definition: 'full; overflowing',
    pinyin: ['yì'],
    decomposition: '⿰氵益',
    etymology: {
      type: 'pictophonetic',
      phonetic: '益',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '溥',
    definition: 'big, great, vast; extensive, pervading, widespread',
    pinyin: ['pǔ'],
    decomposition: '⿰氵尃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尃',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '溦',
    definition: 'to drizzle',
    pinyin: ['wēi'],
    decomposition: '⿲氵⿳山一几攵',
    etymology: { type: 'pictophonetic', semantic: '氵', hint: 'water' },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 2],
      [1, 2],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '溧',
    definition: 'a river in Anhui and Jiangsu provinces',
    pinyin: ['lì'],
    decomposition: '⿰氵⿱西木',
    etymology: {
      type: 'pictophonetic',
      phonetic: '西',
      hint: 'water',
      semantic: '氵',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '溪',
    definition: 'brook, creek, stream',
    pinyin: ['xī'],
    decomposition: '⿰氵奚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奚',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '溫',
    definition: 'warm, lukewarm',
    pinyin: ['wēn'],
    decomposition: '⿰氵⿱囚皿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皿',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '溯',
    definition:
      'to paddle upstream, to go against the current; to trace the source; formerly',
    pinyin: ['sù'],
    decomposition: '⿰氵朔',
    etymology: {
      type: 'ideographic',
      hint: 'To seek the source 朔 of a river 氵',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '溱',
    definition: 'a river in Henan province',
    pinyin: ['qín'],
    decomposition: '⿰氵秦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '秦',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '溲',
    definition: 'to urinate; to soak, to drench',
    pinyin: ['sōu'],
    decomposition: '⿰氵叟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叟',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '溴',
    definition: 'bromine',
    pinyin: ['xiù'],
    decomposition: '⿰氵臭',
    etymology: {
      type: 'ideographic',
      hint: 'A noxious 臭 liquid 氵; 臭 also provides the pronunciation',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '溶',
    definition: 'to melt, to dissolve',
    pinyin: ['róng'],
    decomposition: '⿰氵容',
    etymology: {
      type: 'pictophonetic',
      phonetic: '容',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '溷',
    definition: 'privy, latrine; turbid, dirty',
    pinyin: ['hùn'],
    decomposition: '⿰氵圂',
    etymology: {
      type: 'ideographic',
      hint: 'Water 氵 flowing through a pig-sty 圂; 圂 also provides the pronunciation',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '溺',
    definition: 'to spoil, to pamper, to indulge; to drown',
    pinyin: ['nì'],
    decomposition: '⿰氵弱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弱',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '溻',
    definition: 'wet',
    pinyin: ['tā'],
    decomposition: '⿰氵⿱日羽',
    etymology: { type: 'pictophonetic', semantic: '氵', hint: 'water' },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '溽',
    definition: 'moist; humid, muggy',
    pinyin: ['rù'],
    decomposition: '⿰氵辱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辱',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '滁',
    definition: 'a district in Anhui province',
    pinyin: ['chú'],
    decomposition: '⿰氵除',
    etymology: {
      type: 'pictophonetic',
      phonetic: '除',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '滂',
    definition: 'torrential; voluminous',
    pinyin: ['pāng'],
    decomposition: '⿰氵旁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旁',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '滄',
    definition: 'azure, cold, vast (all as of the sea)',
    pinyin: ['cāng'],
    decomposition: '⿰氵倉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '倉',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '滅',
    definition: 'to extinguish; to wipe out',
    pinyin: ['miè'],
    decomposition: '⿰氵烕',
    etymology: {
      type: 'ideographic',
      hint: 'To extinguish a flame 烕 with water 氵; 烕 also provides the pronunciation',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '滇',
    definition: 'Yunnan province',
    pinyin: ['diān'],
    decomposition: '⿰氵真',
    etymology: {
      type: 'pictophonetic',
      phonetic: '真',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '滊',
    definition: 'saline pond; the name of a river',
    pinyin: ['xì'],
    decomposition: '⿰氵氣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '氣',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '滋',
    definition: 'to grow, to nourish; to multiply, to thrive',
    pinyin: ['zī'],
    decomposition: '⿰氵兹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兹',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '滌',
    definition: 'to wash, to sweep; to purify, to cleanse',
    pinyin: ['dí'],
    decomposition: '⿰氵條',
    etymology: {
      type: 'pictophonetic',
      phonetic: '條',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '滎',
    definition: 'a county in Henan; the sound of waves crashing',
    pinyin: ['xíng'],
    decomposition: '⿳炏冖水',
    etymology: { type: 'pictophonetic', semantic: '水', hint: 'water' },
    radical: '水',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '滏',
    definition: 'a river in Hebei province',
    pinyin: ['fǔ'],
    decomposition: '⿰氵釜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '釜',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '滑',
    definition: 'to slip, to slide; slippery, polished',
    pinyin: ['huá'],
    decomposition: '⿰氵骨',
    etymology: {
      type: 'pictophonetic',
      phonetic: '骨',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '滓',
    definition: 'sediment, lees, dregs',
    pinyin: ['zǐ'],
    decomposition: '⿰氵宰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宰',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '滔',
    definition: 'torrential, rushing, overflowing',
    pinyin: ['tāo'],
    decomposition: '⿰氵舀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '舀',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '滕',
    definition: 'an ancient state in Shandong province',
    pinyin: ['téng'],
    decomposition: '⿰月⿱龹氺',
    radical: '氺',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '滗',
    definition: 'to drain',
    pinyin: ['bì'],
    decomposition: '⿰氵笔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '笔',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '滚',
    definition: 'to boil, to roll, to turn',
    pinyin: ['gǔn'],
    decomposition: '⿰氵衮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '衮',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '滞',
    definition: 'to block, to obstruct; sluggish, stagnant',
    pinyin: ['zhì'],
    decomposition: '⿰氵带',
    etymology: {
      type: 'pictophonetic',
      phonetic: '带',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '滟',
    definition: 'billowing, overflowing; wavy',
    pinyin: ['yàn'],
    decomposition: '⿰氵艳',
    etymology: {
      type: 'ideographic',
      hint: 'Curves 艳 in the water 氵; 艳 also provides the pronunciation',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '滠',
    definition: 'a river in Hubei province',
    pinyin: ['shè'],
    decomposition: '⿰氵聂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '聂',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '满',
    definition: 'to fill; full, packed; satisfied',
    pinyin: ['mǎn'],
    decomposition: '⿰氵⿱艹两',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㒼',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '滢',
    definition: 'clear, pure; glossy; lucid',
    pinyin: ['yíng'],
    decomposition: '⿰氵莹',
    etymology: {
      type: 'ideographic',
      hint: 'A sparkling 莹 lake 氵; 莹 also provides the pronunciation',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '滤',
    definition: 'to filter, to strain',
    pinyin: ['lǜ'],
    decomposition: '⿰氵虑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '虑',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '滥',
    definition: 'to flood, to overflow; excessive',
    pinyin: ['làn'],
    decomposition: '⿰氵监',
    etymology: {
      type: 'pictophonetic',
      phonetic: '监',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '滦',
    definition: 'a county and river in Hebei province',
    pinyin: ['luán'],
    decomposition: '⿰氵栾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '栾',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '滨',
    definition: 'beach, coast, river bank',
    pinyin: ['bīn'],
    decomposition: '⿰氵宾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宾',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '滩',
    definition: 'rapids; sandbar, shoal',
    pinyin: ['tān'],
    decomposition: '⿰氵难',
    etymology: {
      type: 'ideographic',
      hint: 'Difficult 难 waters 氵 to navigate; 难 also provides the pronunciation',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '滬',
    definition: 'Shanghai; the Shanghai river',
    pinyin: ['hù'],
    decomposition: '⿰氵扈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '扈',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '滯',
    definition: 'to block, to obstruct; sluggish, stagnant',
    pinyin: ['zhì'],
    decomposition: '⿰氵帶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '帶',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '滲',
    definition: 'to seep, to permeate, to infiltrate',
    pinyin: ['shèn'],
    decomposition: '⿰氵參',
    etymology: {
      type: 'pictophonetic',
      phonetic: '參',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '滴',
    definition: 'to drip; a drop of water',
    pinyin: ['dī'],
    decomposition: '⿰氵啇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '啇',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '滷',
    definition: 'sauce, gravy, broth; brine',
    pinyin: ['lǔ'],
    decomposition: '⿰氵鹵',
    etymology: {
      type: 'ideographic',
      hint: 'Salt 鹵 water 氵; 鹵 also provides the pronunciation',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '滸',
    definition: 'shore, river bank',
    pinyin: ['hǔ'],
    decomposition: '⿰氵許',
    etymology: {
      type: 'pictophonetic',
      phonetic: '許',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '滹',
    definition: 'the bank of a stream',
    pinyin: ['hū'],
    decomposition: '⿰氵虖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '虖',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '滻',
    definition: 'a river in Shaanxi province',
    pinyin: ['chǎn'],
    decomposition: '⿰氵産',
    etymology: {
      type: 'pictophonetic',
      phonetic: '産',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '滾',
    definition: 'to boil, to roll, to turn',
    pinyin: ['gǔn'],
    decomposition: '⿰氵袞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '袞',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '滿',
    definition: 'to fill; full, packed; satisfied',
    pinyin: ['mǎn'],
    decomposition: '⿰氵㒼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㒼',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '漁',
    definition: 'fisherman; to fish; to pursue; to sieze',
    pinyin: ['yú'],
    decomposition: '⿰氵魚',
    etymology: {
      type: 'ideographic',
      hint: 'To fish 魚 in a river氵; 魚 also provides the pronunciation',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '漂',
    definition: 'to drift, to float; to be tossed about; bleach',
    pinyin: ['piào'],
    decomposition: '⿰氵票',
    etymology: {
      type: 'pictophonetic',
      phonetic: '票',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '漆',
    definition: 'varnish, lacquer; paint',
    pinyin: ['qī'],
    decomposition: '⿰氵桼',
    etymology: {
      type: 'ideographic',
      hint: 'The sap 氵 of the varnish tree 桼; 桼 also provides the pronunciation',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '漉',
    definition: 'to filter, to strain; dripping, wet',
    pinyin: ['lù'],
    decomposition: '⿰氵鹿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鹿',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '漏',
    definition: 'to leak, to drip; hour glass; funnel',
    pinyin: ['lòu'],
    decomposition: '⿰氵屚',
    etymology: {
      type: 'ideographic',
      hint: 'Water 氵 falling like raindrops 雨; 屚 provides the pronunciation',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '漓',
    definition: 'dripping water; a river in Guangxi province',
    pinyin: ['lí'],
    decomposition: '⿰氵离',
    etymology: {
      type: 'pictophonetic',
      phonetic: '离',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '演',
    definition: 'to perform, to act, to put on a play',
    pinyin: ['yǎn'],
    decomposition: '⿰氵寅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寅',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '漕',
    definition: 'canal, watercourse; to transport by sea',
    pinyin: ['cáo'],
    decomposition: '⿰氵曹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曹',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '漚',
    definition: 'to soak, to steep; sodden, soaked',
    pinyin: ['ōu'],
    decomposition: '⿰氵區',
    etymology: {
      type: 'pictophonetic',
      phonetic: '區',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '漠',
    definition: 'desert; aloof, cool, indifferent',
    pinyin: ['mò'],
    decomposition: '⿰氵莫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '莫',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '漢',
    definition: 'Chinese people; Chinese language',
    pinyin: ['hàn'],
    decomposition: '⿰氵堇',
    etymology: { type: 'ideographic', hint: 'The Han 𦰩 river 氵' },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '漣',
    definition: 'flowing water; ripples; weeping',
    pinyin: ['lián'],
    decomposition: '⿰氵連',
    etymology: {
      type: 'pictophonetic',
      phonetic: '連',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '漤',
    definition: 'to marinate in salt',
    pinyin: ['lǎn'],
    decomposition: '⿰氵婪',
    etymology: {
      type: 'pictophonetic',
      phonetic: '婪',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '漩',
    definition: 'eddy, whirlpool',
    pinyin: ['xuán'],
    decomposition: '⿰氵旋',
    etymology: {
      type: 'ideographic',
      hint: 'Swirling 旋 water 氵; 旋 also provides the pronunciation',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '漪',
    definition: 'ripples; swirling water',
    pinyin: ['yī'],
    decomposition: '⿰氵猗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '猗',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '漫',
    definition: 'inundating; exaggerated',
    pinyin: ['màn'],
    decomposition: '⿰氵曼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曼',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '漬',
    definition: 'to soak, to steep; dye, stains; sodden',
    pinyin: ['zì'],
    decomposition: '⿰氵責',
    etymology: {
      type: 'pictophonetic',
      phonetic: '責',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '漭',
    definition: 'vast, expansive',
    pinyin: ['mǎng'],
    decomposition: '⿰氵莽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '莽',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '漯',
    definition: 'a river in northern Shandong',
    pinyin: ['luò'],
    decomposition: '⿰氵累',
    etymology: {
      type: 'pictophonetic',
      phonetic: '累',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '漱',
    definition: 'to gargle, to rinse; to wash, to scour',
    pinyin: ['shù'],
    decomposition: '⿰氵欶',
    etymology: {
      type: 'ideographic',
      hint: 'To gargle 欶 water 氵; 欶 also provides the pronunciation',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '漲',
    definition: 'flood tide; to rise in price',
    pinyin: ['zhǎng'],
    decomposition: '⿰氵張',
    etymology: {
      type: 'pictophonetic',
      phonetic: '张',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '漳',
    definition: 'a river in Henan province',
    pinyin: ['zhāng'],
    decomposition: '⿰氵章',
    etymology: {
      type: 'pictophonetic',
      phonetic: '章',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '漵',
    definition: 'a river in Hunan',
    pinyin: ['xù'],
    decomposition: '⿰氵敘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敘',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '漶',
    definition: 'indecipherable',
    pinyin: ['huàn'],
    decomposition: '⿰氵患',
    etymology: {
      type: 'pictophonetic',
      phonetic: '患',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '漸',
    definition: 'gradually',
    pinyin: ['jiàn'],
    decomposition: '⿰氵斬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斬',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '漼',
    definition: 'to appear deep',
    pinyin: ['cuǐ'],
    decomposition: '⿰氵崔',
    etymology: {
      type: 'ideographic',
      hint: 'A deep 崔 pool 氵; 崔 also provides the pronunciation',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '漾',
    definition: 'to ripple, to undulate; to bob on the waves',
    pinyin: ['yàng'],
    decomposition: '⿰氵羕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羕',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '漿',
    definition: 'pulp, starch, syrup; a thick fluid',
    pinyin: ['jiāng'],
    decomposition: '⿱將水',
    etymology: {
      type: 'pictophonetic',
      phonetic: '將',
      semantic: '水',
      hint: 'water',
    },
    radical: '水',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '潆',
    definition: 'eddy; small river',
    pinyin: ['yíng'],
    decomposition: '⿰氵萦',
    etymology: {
      type: 'ideographic',
      hint: 'Water 氵 coiling 萦 on itself; 萦 also provides the pronunciation',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '潇',
    definition: 'the sound of beating wind and rain',
    pinyin: ['xiāo'],
    decomposition: '⿰氵萧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '萧',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '潋',
    definition: 'ripples, waves; to overflow',
    pinyin: ['liàn'],
    decomposition: '⿰氵敛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敛',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '潍',
    definition: 'a river in Shandong province',
    pinyin: ['wéi'],
    decomposition: '⿰氵维',
    etymology: {
      type: 'pictophonetic',
      phonetic: '维',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '潑',
    definition: 'to pour, to splash, to sprinkle, to water',
    pinyin: ['pō'],
    decomposition: '⿰氵發',
    etymology: { type: 'ideographic', hint: 'To send forth 發 water 氵' },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '潔',
    definition: 'clean, pure; to purify, to cleanse',
    pinyin: ['jié'],
    decomposition: '⿰氵絜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '絜',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '潘',
    definition: 'a river that flows into the Han; surname',
    pinyin: ['pān'],
    decomposition: '⿰氵番',
    etymology: {
      type: 'pictophonetic',
      phonetic: '番',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '潛',
    definition: 'to hide; secret, latent, hidden',
    pinyin: ['qián'],
    decomposition: '⿰氵朁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朁',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '潜',
    definition: 'to hide; secret, latent, hidden',
    pinyin: ['qián'],
    decomposition: '⿰氵替',
    etymology: {
      type: 'pictophonetic',
      phonetic: '替',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '潞',
    definition: 'a river in northern China',
    pinyin: ['lù'],
    decomposition: '⿰氵路',
    etymology: {
      type: 'pictophonetic',
      phonetic: '路',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '潟',
    definition: 'salt marsh, scrubland',
    pinyin: ['xì'],
    decomposition: '⿰氵舄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '舄',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '潢',
    definition: 'pond, lake',
    pinyin: ['huáng'],
    decomposition: '⿰氵黄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '黄',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '潤',
    definition: 'fresh, moist; soft, sleek',
    pinyin: ['rùn'],
    decomposition: '⿰氵閏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '閏',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '潦',
    definition: 'to flood; puddle; dejected, careless',
    pinyin: ['lǎo'],
    decomposition: '⿰氵尞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尞',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '潭',
    definition: 'deep pool, lake; deep, profound',
    pinyin: ['tán'],
    decomposition: '⿰氵覃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '覃',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '潮',
    definition: 'tide, current; damp, moist, wet',
    pinyin: ['cháo'],
    decomposition: '⿰氵朝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朝',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '潯',
    definition: 'steep river bank',
    pinyin: ['xún'],
    decomposition: '⿰氵尋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尋',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '潰',
    definition:
      'a flooding river; a military defeat; to break down, to disperse',
    pinyin: ['kuì'],
    decomposition: '⿰氵貴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '貴',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '潲',
    definition: 'to sprinkle; driving rain',
    pinyin: ['shào'],
    decomposition: '⿰氵稍',
    etymology: {
      type: 'ideographic',
      hint: 'A little 稍 water 氵; 稍 also provides the pronunciation',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '潴',
    definition: 'pond, pool',
    pinyin: ['zhū'],
    decomposition: '⿰氵猪',
    etymology: {
      type: 'pictophonetic',
      phonetic: '猪',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '潸',
    definition: 'tearful; to weep',
    pinyin: ['shān'],
    decomposition: '⿰氵⿱林月',
    etymology: {
      type: 'ideographic',
      hint: 'Water 氵 falling from closed eyes 林',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '潺',
    definition: 'the sound of flowing water',
    pinyin: ['chán'],
    decomposition: '⿰氵孱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孱',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '潼',
    definition: 'high, lofty; a mountain pass',
    pinyin: ['tóng'],
    decomposition: '⿰氵童',
    etymology: {
      type: 'pictophonetic',
      phonetic: '童',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '潽',
    definition: 'to boil over',
    pinyin: ['pū'],
    decomposition: '⿰氵普',
    etymology: {
      type: 'pictophonetic',
      phonetic: '普',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '澀',
    definition: 'astringent, harsh, rough, uneven',
    pinyin: ['sè'],
    decomposition: '⿰氵歰',
    etymology: {
      type: 'ideographic',
      hint: 'Water 氵 that cuts like a knife 歰; 歰 also provides the pronunciation',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '澄',
    definition: 'clear, limpid, pure',
    pinyin: ['chéng'],
    decomposition: '⿰氵登',
    etymology: {
      type: 'pictophonetic',
      phonetic: '登',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '澆',
    definition: 'to spray, to sprinkle, to water',
    pinyin: ['jiāo'],
    decomposition: '⿰氵堯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堯',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '澇',
    definition: 'to inundate, to flood; torrent',
    pinyin: ['lào'],
    decomposition: '⿰氵勞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '勞',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '澈',
    definition: 'limpid, clear; thoroughly, completely',
    pinyin: ['chè'],
    decomposition: '⿰氵⿰育攵',
    etymology: { type: 'pictophonetic', semantic: '氵', hint: 'water' },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '澉',
    definition: 'to wash; a place name',
    pinyin: ['gǎn'],
    decomposition: '⿰氵敢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敢',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '澌',
    definition: 'to vanish, to disappear; to exhaust, to dry up',
    pinyin: ['sī'],
    decomposition: '⿰氵斯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斯',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '澍',
    definition: 'timely and life-giving rain',
    pinyin: ['shù'],
    decomposition: '⿰氵尌',
    etymology: {
      type: 'ideographic',
      hint: 'Rain 氵 that saves 尌 the farm; 尌 also provides the pronunciation',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '澎',
    definition: 'to splatter',
    pinyin: ['pēng'],
    decomposition: '⿰氵彭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彭',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '澗',
    definition: 'brook, mountain stream',
    pinyin: ['jiàn'],
    decomposition: '⿰氵間',
    etymology: {
      type: 'ideographic',
      hint: 'A stream 氵 flowing through a valley 間; 間 also provides the pronunciation',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '澜',
    definition: 'overflowing; ripples, waves',
    pinyin: ['lán'],
    decomposition: '⿰氵阑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '阑',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '澠',
    definition: 'the name of a river in Shandong',
    pinyin: ['miǎn'],
    decomposition: '⿰氵黽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '黽',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '澡',
    definition: 'to wash, to bathe',
    pinyin: ['zǎo'],
    decomposition: '⿰氵喿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '喿',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '澤',
    definition: 'marsh, swamp; brilliance, grace',
    pinyin: ['zé'],
    decomposition: '⿰氵睪',
    etymology: {
      type: 'pictophonetic',
      semantic: '氵',
      hint: 'water',
      phonetic: '睪',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '澥',
    definition: 'gulf; a blocked stream',
    pinyin: ['xiè'],
    decomposition: '⿰氵解',
    etymology: {
      type: 'pictophonetic',
      phonetic: '解',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '澧',
    definition: 'a river in northern Hunan',
    pinyin: ['lǐ'],
    decomposition: '⿰氵豊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豊',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '澱',
    definition: 'marsh, swamp; sediment; to precipitate',
    pinyin: ['diàn'],
    decomposition: '⿰氵殿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '殿',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '澳',
    definition: 'bay, cove, dock, inlet',
    pinyin: ['ào'],
    decomposition: '⿰氵奥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奥',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '澶',
    definition: 'still water; tranquil, placid',
    pinyin: ['chán'],
    decomposition: '⿰氵亶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亶',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '澹',
    definition: 'calm, quiet, tranquil',
    pinyin: ['dàn'],
    decomposition: '⿰氵詹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '詹',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '激',
    definition: 'to arouse, to incite; acute, sharp; fierce, violent',
    pinyin: ['jī'],
    decomposition: '⿰氵敫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敫',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '濁',
    definition: 'dirty, filthy, muddy, turbid',
    pinyin: ['zhuó'],
    decomposition: '⿰氵蜀',
    etymology: { type: 'ideographic', hint: 'A pond 氵 growing scum 蜀' },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '濂',
    definition: 'a waterfall; a river in Hunan',
    pinyin: ['lián'],
    decomposition: '⿰氵廉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '廉',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '濃',
    definition: 'concentrated, dense, strong, thick',
    pinyin: ['nóng'],
    decomposition: '⿰氵農',
    etymology: {
      type: 'pictophonetic',
      phonetic: '農',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '濉',
    definition: 'the name of a river',
    pinyin: ['suī'],
    decomposition: '⿰氵睢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '睢',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '濊',
    definition: 'vast, expansive, deep; dirty',
    pinyin: ['huì'],
    decomposition: '⿰氵歲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '歲',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '濑',
    definition: 'current, rapids',
    pinyin: ['lài'],
    decomposition: '⿰氵赖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '赖',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '濒',
    definition: 'to approach; near, on the verge of',
    pinyin: ['bīn'],
    decomposition: '⿰氵频',
    etymology: {
      type: 'pictophonetic',
      phonetic: '频',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '濕',
    definition: 'wet, moist, humid, damp; illness',
    pinyin: ['shī'],
    decomposition: '⿰氵㬎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㬎',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '濘',
    definition: 'mud, mire; muddy, stagnant',
    pinyin: ['nìng'],
    decomposition: '⿰氵寧',
    etymology: {
      type: 'ideographic',
      hint: 'Still 寧 water 氵; 寧 also provides the pronunciation',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '濛',
    definition: 'drizzling, misty, raining',
    pinyin: ['méng'],
    decomposition: '⿰氵蒙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蒙',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '濞',
    definition: 'a county in Yunnan province',
    pinyin: ['bì'],
    decomposition: '⿰氵鼻',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鼻',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '濟',
    definition: 'to aid, to help, to relieve; to ferry across',
    pinyin: ['jì'],
    decomposition: '⿰氵齊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '齊',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '濠',
    definition: 'ditch, trench, moat',
    pinyin: ['háo'],
    decomposition: '⿰氵豪',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豪',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '濡',
    definition: 'to moisten, to immerse; wet, damp',
    pinyin: ['rú'],
    decomposition: '⿰氵需',
    etymology: {
      type: 'pictophonetic',
      phonetic: '需',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '濤',
    definition: 'large waves',
    pinyin: ['tāo'],
    decomposition: '⿰氵壽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '壽',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '濫',
    definition: 'to flood, to overflow; excessive',
    pinyin: ['làn'],
    decomposition: '⿰氵監',
    etymology: {
      type: 'pictophonetic',
      phonetic: '監',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '濮',
    definition: 'a county in Henan province',
    pinyin: ['pú'],
    decomposition: '⿰氵僕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '僕',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '濯',
    definition: 'to cleanse, to rinse, to wash out',
    pinyin: ['zhuó'],
    decomposition: '⿰氵翟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隹',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '濰',
    definition: 'a river in Shandong province',
    pinyin: ['wéi'],
    decomposition: '⿰氵維',
    etymology: {
      type: 'pictophonetic',
      phonetic: '維',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '濱',
    definition: 'beach, coast, river bank',
    pinyin: ['bīn'],
    decomposition: '⿰氵賓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '賓',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '濺',
    definition: 'to sprinkle, to spray, to splash, to spill',
    pinyin: ['jiàn'],
    decomposition: '⿰氵賤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '賤',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '濾',
    definition: 'to filter, to strain',
    pinyin: ['lǜ'],
    decomposition: '⿰氵慮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '慮',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瀆',
    definition: 'ditch, sluice, gutter, drain',
    pinyin: ['dú'],
    decomposition: '⿰氵賣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '賣',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瀉',
    definition: 'to leak; diarrhea',
    pinyin: ['xiè'],
    decomposition: '⿰氵寫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寫',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瀋',
    definition: 'to sink, to submerge; addicted; surname',
    pinyin: ['chén'],
    decomposition: '⿰氵審',
    etymology: {
      type: 'pictophonetic',
      phonetic: '審',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瀏',
    definition: 'bright; clear; deep; swift',
    pinyin: ['liú'],
    decomposition: '⿰氵劉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '劉',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瀑',
    definition: 'waterfall, cascade; heavy rain',
    pinyin: ['pù'],
    decomposition: '⿰氵暴',
    etymology: {
      type: 'ideographic',
      hint: 'Violent 暴 water 氵; 暴 also provides the pronunciation',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瀕',
    definition: 'to approach; near, on the verge of',
    pinyin: ['bīn'],
    decomposition: '⿰氵頻',
    etymology: {
      type: 'pictophonetic',
      phonetic: '頻',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瀘',
    definition: 'a river in Jiangxi province',
    pinyin: ['lú'],
    decomposition: '⿰氵盧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '盧',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瀚',
    definition: 'wide, vast, extensive',
    pinyin: ['hàn'],
    decomposition: '⿰氵翰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '翰',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瀛',
    definition: 'ocean, sea',
    pinyin: ['yíng'],
    decomposition: '⿰氵嬴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '嬴',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瀟',
    definition: 'the sound of beating wind and rain',
    pinyin: ['xiāo'],
    decomposition: '⿰氵蕭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蕭',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瀣',
    definition: 'vapor, sea mist',
    pinyin: ['xiè'],
    decomposition: '⿰氵韰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韰',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瀧',
    definition: 'raining; wet, soaked; rapids; a river in Guangdong',
    pinyin: ['lóng'],
    decomposition: '⿰氵龍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龍',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瀰',
    definition: 'to overflow, to flood; to disseminate',
    pinyin: ['mǐ'],
    decomposition: '⿰氵彌',
    etymology: {
      type: 'ideographic',
      hint: 'Water 氵 everywhere 彌; 彌 also provides the pronunciation',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瀵',
    definition: 'the name of a river',
    pinyin: ['fèn'],
    decomposition: '⿰氵糞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '糞',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瀹',
    definition: 'to boil, to soak; to cleanse, to wash',
    pinyin: ['yuè'],
    decomposition: '⿰氵龠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龠',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瀾',
    definition: 'overflowing; ripples, waves',
    pinyin: ['lán'],
    decomposition: '⿰氵闌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '闌',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '灌',
    definition: 'to water, to irrigate; to pour; to flood',
    pinyin: ['guàn'],
    decomposition: '⿰氵雚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '雚',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '灏',
    definition: 'vast, large, grand, expansive',
    pinyin: ['hào'],
    decomposition: '⿰氵颢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '颢',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '灑',
    definition: 'to pour, to spill; to scatter, to shed; to wipe away',
    pinyin: ['sǎ'],
    decomposition: '⿰氵麗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '麗',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '灘',
    definition: 'rapids; sandbar, shoal',
    pinyin: ['tān'],
    decomposition: '⿰氵難',
    etymology: {
      type: 'ideographic',
      hint: 'Difficult 難 waters 氵 to navigate; 難 also provides the pronunciation',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '灞',
    definition: 'a river in Shanxi province',
    pinyin: ['bà'],
    decomposition: '⿰氵霸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '霸',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '灣',
    definition: 'bay, cove, gulf, inlet',
    pinyin: ['wān'],
    decomposition: '⿰氵彎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彎',
      semantic: '氵',
      hint: 'water',
    },
    radical: '氵',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '火',
    definition: 'fire, flame; to burn; anger, rage',
    pinyin: ['huǒ'],
    decomposition: '⿻丷人',
    etymology: { type: 'pictographic', hint: 'Flames' },
    radical: '火',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '灬',
    definition: 'fire',
    pinyin: ['huǒ'],
    decomposition: '？',
    radical: '灬',
    matches: [null, null, null, null],
  },
  {
    character: '灭',
    definition: 'to extinguish; to wipe out',
    pinyin: ['miè'],
    decomposition: '⿱一火',
    etymology: { type: 'ideographic', hint: 'To cover 一 a flame 火' },
    radical: '火',
    matches: [[0], [1], [1], [1], [1]],
  },
  {
    character: '灯',
    definition: 'lamp, lantern, light',
    pinyin: ['dēng'],
    decomposition: '⿰火丁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丁',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '灰',
    definition: 'ashes; dust; lime, mortar',
    pinyin: ['huī'],
    decomposition: '⿸？火',
    etymology: {
      type: 'ideographic',
      hint: 'The remains of a fire 火; 火 also provides the pronunciation',
    },
    radical: '火',
    matches: [null, null, [1], [1], [1], [1]],
  },
  {
    character: '灵',
    definition: 'spirit, soul; spiritual world',
    pinyin: ['líng'],
    decomposition: '⿱彐火',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彐',
      semantic: '火',
      hint: 'fire',
    },
    radical: '彐',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '灶',
    definition: 'kitchen, oven, stove',
    pinyin: ['zào'],
    decomposition: '⿰火土',
    etymology: { type: 'ideographic', hint: 'A clay 土 oven 火' },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '灸',
    definition: 'to cauterize; moxibustion',
    pinyin: ['jiǔ'],
    decomposition: '⿱久火',
    etymology: {
      type: 'pictophonetic',
      phonetic: '久',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '灼',
    definition: 'to burn, to cauterize; bright',
    pinyin: ['zhuó'],
    decomposition: '⿰火勺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '勺',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '災',
    definition: 'disaster, catastrophe, calamity',
    pinyin: ['zāi'],
    decomposition: '⿱巛火',
    etymology: { type: 'ideographic', hint: 'A river 巛 on fire 火' },
    radical: '火',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '灾',
    definition: 'disaster, catastrophe, calamity',
    pinyin: ['zāi'],
    decomposition: '⿱宀火',
    etymology: { type: 'ideographic', hint: 'A house 宀 on fire 火' },
    radical: '火',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '灿',
    definition: 'vivid, illuminating, brilliant',
    pinyin: ['càn'],
    decomposition: '⿰火山',
    etymology: {
      type: 'pictophonetic',
      phonetic: '山',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '炀',
    definition: 'to scorch, to roast, to melt',
    pinyin: ['yáng'],
    decomposition: '⿰火昜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昜',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '炅',
    definition: 'brilliant, shining',
    pinyin: ['jiǒng'],
    decomposition: '⿱日火',
    etymology: {
      type: 'ideographic',
      hint: 'A flame 火 as bright as the sun 日',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '炆',
    definition: 'to simmer, to cook over a slow fire',
    pinyin: ['wén'],
    decomposition: '⿰火文',
    etymology: {
      type: 'pictophonetic',
      phonetic: '文',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '炉',
    definition: 'fireplace, furnace, oven, stove',
    pinyin: ['lú'],
    decomposition: '⿰火户',
    etymology: { type: 'ideographic', hint: "A fire 火 in one's home 户" },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '炊',
    definition: 'meal; to cook, to steam',
    pinyin: ['chuī'],
    decomposition: '⿰火欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '欠',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '炎',
    definition: 'flame, blaze; hot',
    pinyin: ['yán'],
    decomposition: '⿱火火',
    etymology: { type: 'ideographic', hint: 'Two fires 火 burning' },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '炏',
    definition: 'grass',
    pinyin: ['kài'],
    decomposition: '⿰火火',
    etymology: {
      type: 'pictographic',
      hint: 'Two blades of grass; compare 艸',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '炒',
    definition: 'to boil, to fry, to roast, to sauté; to trade stock',
    pinyin: ['chǎo'],
    decomposition: '⿰火少',
    etymology: {
      type: 'pictophonetic',
      phonetic: '少',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '炔',
    definition: 'acetylene',
    pinyin: ['guì'],
    decomposition: '⿰火夬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夬',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '炕',
    definition: 'the brick-bed in northern China',
    pinyin: ['kàng'],
    decomposition: '⿰火亢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亢',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '炖',
    definition: 'stew; to cook stew',
    pinyin: ['dùn'],
    decomposition: '⿰火屯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屯',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '炙',
    definition: 'to roast, to broil; to cauterize',
    pinyin: ['zhì'],
    decomposition: '⿱月火',
    etymology: {
      type: 'pictophonetic',
      phonetic: '月',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '炜',
    definition: 'brilliant, glowing, red',
    pinyin: ['wěi'],
    decomposition: '⿰火韦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韦',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '炝',
    definition: 'to stir-fry; to cook in sauce',
    pinyin: ['qiàng'],
    decomposition: '⿰火仓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '仓',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '炤',
    definition: 'to illuminate, to light up; to reflect',
    pinyin: ['zhào'],
    decomposition: '⿰火召',
    etymology: {
      type: 'pictophonetic',
      phonetic: '召',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '炫',
    definition: 'to glitter, to shine; to show off, to flaunt',
    pinyin: ['xuàn'],
    decomposition: '⿰火玄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '玄',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '炬',
    definition: 'torch',
    pinyin: ['jù'],
    decomposition: '⿰火巨',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巨',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '炭',
    definition: 'carbon, charcoal, coal',
    pinyin: ['tàn'],
    decomposition: '⿱山灰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '山',
      semantic: '灰',
      hint: 'ashes',
    },
    radical: '火',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '炮',
    definition: 'cannon, artillery',
    pinyin: ['pào'],
    decomposition: '⿰火包',
    etymology: {
      type: 'pictophonetic',
      phonetic: '包',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '炯',
    definition: 'bright, brilliant; clear; hot',
    pinyin: ['jiǒng'],
    decomposition: '⿰火冋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冋',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '炱',
    definition: 'soot',
    pinyin: ['tái'],
    decomposition: '⿱台火',
    etymology: {
      type: 'pictophonetic',
      phonetic: '台',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '炳',
    definition: 'bright, luminous; glorious',
    pinyin: ['bǐng'],
    decomposition: '⿰火丙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丙',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '炷',
    definition: 'candle wick; incense',
    pinyin: ['zhù'],
    decomposition: '⿰火主',
    etymology: {
      type: 'ideographic',
      hint: 'A lit 火 candle 主; 主 also provides the pronunciation',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '炸',
    definition: 'to explode; to fry in oil; to scald',
    pinyin: ['zhà'],
    decomposition: '⿰火乍',
    etymology: {
      type: 'ideographic',
      hint: 'A sudden 乍 flame 火; 乍 also provides the pronunciation',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '点',
    definition: 'dot, point, speck',
    pinyin: ['diǎn'],
    decomposition: '⿱占灬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '占',
      semantic: '灬',
      hint: 'fire',
    },
    radical: '灬',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '為',
    definition: 'to do, to act; to handle, to govern; to be',
    pinyin: ['wèi'],
    decomposition: '⿱爫⿵？灬',
    etymology: { type: 'ideographic', hint: 'A hand 爫 leading an elephant' },
    radical: '灬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      null,
      null,
      null,
      null,
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '炻',
    definition: 'china, stoneware',
    pinyin: ['shí'],
    decomposition: '⿰火石',
    etymology: {
      type: 'ideographic',
      hint: 'Fired 火 clay 石; 石 also provides the pronunciation',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '炼',
    definition: 'to smelt, to refine; to distill, to condense',
    pinyin: ['liàn'],
    decomposition: '⿰火柬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '柬',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '炽',
    definition: 'to burn, to blaze; splendid; intense',
    pinyin: ['chì'],
    decomposition: '⿰火只',
    etymology: {
      type: 'pictophonetic',
      phonetic: '只',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '烀',
    definition: 'to simmer, to cook over a slow fire',
    pinyin: ['hū'],
    decomposition: '⿰火乎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乎',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '烁',
    definition: 'to sparkle, to shine, to glitter',
    pinyin: ['shuò'],
    decomposition: '⿰火乐',
    etymology: {
      type: 'ideographic',
      hint: 'The happy 乐 light of a flame 火',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '烂',
    definition: 'overcooked, overripe; rotten, spoiled',
    pinyin: ['làn'],
    decomposition: '⿰火兰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兰',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '烃',
    definition: 'hydrocarbon',
    pinyin: ['tīng'],
    decomposition: '⿰火？',
    etymology: { type: 'pictophonetic', semantic: '火', hint: 'fire' },
    radical: '火',
    matches: [[0], [0], [0], [0], null, null, null, null, null],
  },
  {
    character: '烈',
    definition: 'fiery, violent; ardent, vehement',
    pinyin: ['liè'],
    decomposition: '⿱列灬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '列',
      semantic: '灬',
      hint: 'fire',
    },
    radical: '灬',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '烊',
    definition: 'to smelt; to close for the night',
    pinyin: ['yáng'],
    decomposition: '⿰火羊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羊',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '烏',
    definition: 'crow, rook, raven; black, dark',
    pinyin: ['wū'],
    decomposition: '⿹？灬',
    etymology: { type: 'pictographic', hint: 'A crow; compare 鸟' },
    radical: '灬',
    matches: [null, null, null, null, null, null, [1], [1], [1], [1]],
  },
  {
    character: '烕',
    definition: 'to destroy, to exterminate, to extinguish',
    pinyin: ['miè'],
    decomposition: '⿵戊灭',
    etymology: {
      type: 'ideographic',
      hint: 'To smother 戊 a flame 灭; 灭 also provides the pronunciation',
    },
    radical: '火',
    matches: [[0], [0], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '烘',
    definition: 'to bake, to roast; to dry by the fire',
    pinyin: ['hōng'],
    decomposition: '⿰火共',
    etymology: {
      type: 'pictophonetic',
      phonetic: '共',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '烙',
    definition: 'to burn, to brand; hot iron',
    pinyin: ['lào'],
    decomposition: '⿰火各',
    etymology: {
      type: 'pictophonetic',
      phonetic: '各',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '烛',
    definition: 'candle, taper; to illuminate, to shine',
    pinyin: ['zhú'],
    decomposition: '⿰火虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '虫',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '烜',
    definition: 'sunlight; to dry in the sun',
    pinyin: ['xuǎn'],
    decomposition: '⿰火亘',
    etymology: {
      type: 'ideographic',
      hint: 'To bake 火 in the sun 亘; 亘 also provides the pronunciation',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '烝',
    definition: 'to rise; steam; many, numerous',
    pinyin: ['zhēng'],
    decomposition: '⿱丞灬',
    etymology: { type: 'ideographic', hint: 'Boiling 灬 water 氶' },
    radical: '灬',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '烟',
    definition: 'smoke, soot; opium; tobacco, cigarettes',
    pinyin: ['yān'],
    decomposition: '⿰火因',
    etymology: {
      type: 'pictophonetic',
      phonetic: '因',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '烤',
    definition: 'to bake, to cook, to roast, to toast',
    pinyin: ['kǎo'],
    decomposition: '⿰火考',
    etymology: {
      type: 'pictophonetic',
      phonetic: '考',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '烦',
    definition: 'to bother, to trouble, to vex',
    pinyin: ['fán'],
    decomposition: '⿰火页',
    etymology: {
      type: 'pictophonetic',
      semantic: '火',
      hint: 'fire',
      phonetic: '页',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '烧',
    definition: 'to burn, to bake; to heat, to roast',
    pinyin: ['shāo'],
    decomposition: '⿰火尧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尧',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '烨',
    definition: 'glorious, splendid; a blaze of fire',
    pinyin: ['yè'],
    decomposition: '⿰火华',
    etymology: {
      type: 'ideographic',
      hint: 'A glorious 华 blaze 火; 华 also provides the pronunciation',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '烩',
    definition: 'ragout; to braise, to cook',
    pinyin: ['huì'],
    decomposition: '⿰火会',
    etymology: {
      type: 'pictophonetic',
      phonetic: '会',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '烫',
    definition: 'to scald; to iron clothes or hair',
    pinyin: ['tàng'],
    decomposition: '⿱汤火',
    etymology: {
      type: 'pictophonetic',
      phonetic: '汤',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '烬',
    definition: 'ashes, cinders, embers; remnants',
    pinyin: ['jìn'],
    decomposition: '⿰火尽',
    etymology: {
      type: 'ideographic',
      hint: 'A used up 尽 fire 火; 尽 also provides the pronunciation',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '热',
    definition: 'heat, fever, zeal',
    pinyin: ['rè'],
    decomposition: '⿱执灬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '执',
      semantic: '灬',
      hint: 'fire',
    },
    radical: '灬',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '烯',
    definition: 'alkene',
    pinyin: ['xī'],
    decomposition: '⿰火希',
    etymology: {
      type: 'pictophonetic',
      phonetic: '希',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '烴',
    definition: 'hydrocarbon',
    pinyin: ['tīng'],
    decomposition: '⿰火巠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巠',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '烷',
    definition: 'alkane',
    pinyin: ['wán'],
    decomposition: '⿰火完',
    etymology: {
      type: 'pictophonetic',
      phonetic: '完',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '烹',
    definition: 'cooking, cuisine; stir-fry',
    pinyin: ['pēng'],
    decomposition: '⿱亨灬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亨',
      semantic: '灬',
      hint: 'fire',
    },
    radical: '灬',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '烽',
    definition: 'beacon, signal fire',
    pinyin: ['fēng'],
    decomposition: '⿰火夆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夆',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '焉',
    definition: 'why? where? how?; strange; thereupon, then',
    pinyin: ['yān'],
    decomposition: '⿳正？灬',
    etymology: { type: 'ideographic', hint: 'A bird 鳥 with a strange head' },
    radical: '灬',
    matches: [[0], [0], [0], [0], [0], null, null, [2], [2], [2], [2]],
  },
  {
    character: '焊',
    definition: 'to solder, to weld',
    pinyin: ['hàn'],
    decomposition: '⿰火旱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旱',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '焌',
    definition: 'to ignite, to light',
    pinyin: ['jùn'],
    decomposition: '⿰火夋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夋',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '焐',
    definition: 'to warm up',
    pinyin: ['wù'],
    decomposition: '⿰火吾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吾',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '焓',
    definition: 'onomatopoetic, a fire sizzling',
    pinyin: ['hán'],
    decomposition: '⿰火含',
    etymology: {
      type: 'pictophonetic',
      phonetic: '含',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '焕',
    definition: 'shining, lustrous',
    pinyin: ['huàn'],
    decomposition: '⿰火奂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奂',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '焖',
    definition: 'to simmer, to cook over a slow fire',
    pinyin: ['mèn'],
    decomposition: '⿰火闷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '闷',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '焗',
    definition: 'to bake, to roast; to suffocate; stuffy',
    pinyin: ['jú'],
    decomposition: '⿰火局',
    etymology: {
      type: 'pictophonetic',
      phonetic: '局',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '焘',
    definition: 'to shine, to illuminate; to cover, to envelop',
    pinyin: ['dào'],
    decomposition: '⿱寿灬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寿',
      semantic: '灬',
      hint: 'fire',
    },
    radical: '灬',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '焙',
    definition: 'to bake, to roast; to dry by the fire',
    pinyin: ['bèi'],
    decomposition: '⿰火咅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咅',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '焚',
    definition: 'to burn',
    pinyin: ['fén'],
    decomposition: '⿱林火',
    etymology: { type: 'ideographic', hint: 'Setting fire 火 to a forest 林' },
    radical: '火',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '無',
    definition: 'no, not; lacking, -less',
    pinyin: ['wú'],
    decomposition: '⿱？灬',
    radical: '灬',
    matches: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '焢',
    definition: 'anger, rage; slow-braised pork belly',
    pinyin: ['hōng'],
    decomposition: '⿰火空',
    etymology: {
      type: 'pictophonetic',
      phonetic: '空',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '焦',
    definition: 'burned, scorched; anxious, vexed',
    pinyin: ['jiāo'],
    decomposition: '⿱隹灬',
    etymology: {
      type: 'ideographic',
      hint: 'A bird 隹 getting its tail singed 灬',
    },
    radical: '灬',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '焯',
    definition: 'to scald; to flash-boil vegetables',
    pinyin: ['chāo'],
    decomposition: '⿰火卓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卓',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '焰',
    definition: 'flame, blaze; glowing, blazing',
    pinyin: ['yàn'],
    decomposition: '⿰火臽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臽',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '焱',
    definition: 'fierce flames; conflagration',
    pinyin: ['yàn'],
    decomposition: '⿱火⿰火火',
    etymology: { type: 'ideographic', hint: 'Many fires 火 burning' },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '然',
    definition: 'certainly; naturally; suddenly',
    pinyin: ['rán'],
    decomposition: '⿱肰灬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肰',
      semantic: '灬',
      hint: 'fire',
    },
    radical: '灬',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '煅',
    definition: 'discipline; to forge metal; to hone a skill',
    pinyin: ['duàn'],
    decomposition: '⿰火段',
    etymology: {
      type: 'pictophonetic',
      phonetic: '段',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '煆',
    definition: 'a raging fire; to forge; to work',
    pinyin: ['xiā'],
    decomposition: '⿰火叚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叚',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '煉',
    definition: 'to smelt, to refine; to distill, to condense',
    pinyin: ['liàn'],
    decomposition: '⿰火柬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '柬',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '煊',
    definition: 'warm',
    pinyin: ['xuān'],
    decomposition: '⿰火宣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宣',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '煌',
    definition: 'bright, shining, luminous',
    pinyin: ['huáng'],
    decomposition: '⿰火皇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皇',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '煎',
    definition: 'to fry in fat or oil; to boil in water',
    pinyin: ['jiān'],
    decomposition: '⿱前灬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '前',
      semantic: '灬',
      hint: 'fire',
    },
    radical: '灬',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '煙',
    definition: 'smoke, soot; opium; tobacco, cigarettes',
    pinyin: ['yān'],
    decomposition: '⿰火垔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '垔',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '煜',
    definition: 'brilliant, shining',
    pinyin: ['yù'],
    decomposition: '⿰火昱',
    etymology: {
      type: 'ideographic',
      hint: 'A dazzling 昱 flame 火; 昱 also provides the pronunciation',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '煞',
    definition: 'demon, fiend; baleful, noxious',
    pinyin: ['shā'],
    decomposition: '⿱⿰刍攵灬',
    radical: '灬',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '煢',
    definition: 'alone, desolate; without friends or family',
    pinyin: ['qióng'],
    decomposition: '⿳炏冖卂',
    radical: '炏',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [2], [2], [2]],
  },
  {
    character: '煤',
    definition: 'carbon, charcoal, coal, coke',
    pinyin: ['méi'],
    decomposition: '⿰火某',
    etymology: {
      type: 'pictophonetic',
      phonetic: '某',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '煥',
    definition: 'shining, lustrous',
    pinyin: ['huàn'],
    decomposition: '⿰火奐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奐',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '煦',
    definition: 'kind, gentle, gracious',
    pinyin: ['xù'],
    decomposition: '⿱昫灬',
    etymology: {
      type: 'ideographic',
      hint: 'A warm 昫 fire 灬; 昫 also provides the pronunciation',
    },
    radical: '灬',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '照',
    definition: 'to shine, to reflect, to illuminate',
    pinyin: ['zhào'],
    decomposition: '⿱昭灬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昭',
      semantic: '灬',
      hint: 'fire',
    },
    radical: '灬',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '煨',
    definition: 'to simmer, to stew',
    pinyin: ['wēi'],
    decomposition: '⿰火畏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畏',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '煩',
    definition: 'to bother, to trouble, to vex',
    pinyin: ['fán'],
    decomposition: '⿰火頁',
    etymology: {
      type: 'pictophonetic',
      semantic: '火',
      hint: 'fire',
      phonetic: '頁',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '煬',
    definition: 'to scorch, to roast, to melt',
    pinyin: ['yáng'],
    decomposition: '⿰火昜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昜',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '煮',
    definition: 'to boil, to cook',
    pinyin: ['zhǔ'],
    decomposition: '⿱者灬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '者',
      semantic: '灬',
      hint: 'fire',
    },
    radical: '灬',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '煲',
    definition: 'to heat, to boil; saucepan',
    pinyin: ['bāo'],
    decomposition: '⿱保火',
    etymology: {
      type: 'pictophonetic',
      phonetic: '保',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '煳',
    definition: 'burnt; to char (in cooking)',
    pinyin: ['hú'],
    decomposition: '⿰火胡',
    etymology: {
      type: 'ideographic',
      hint: 'A reckless 胡 flame 火; 胡 also provides the pronunciation',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '煸',
    definition: 'to stir-fry before broiling or stewing',
    pinyin: ['biān'],
    decomposition: '⿰火扁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '扁',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '煺',
    definition: 'to pluck poultry; to skin meat',
    pinyin: ['tuì'],
    decomposition: '⿰火退',
    etymology: {
      type: 'ideographic',
      hint: 'To prepare 退 to cook 火; 退 also provides the pronunciation',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '煽',
    definition: 'to stir up, to incite; to agitate, to provoke',
    pinyin: ['shān'],
    decomposition: '⿰火扇',
    etymology: {
      type: 'ideographic',
      hint: 'To fan 扇 the flames 火; 扇 also provides the pronunciation',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '熄',
    definition: 'to extinguish, to put out, to quench',
    pinyin: ['xī'],
    decomposition: '⿰火息',
    etymology: {
      type: 'ideographic',
      hint: 'To end 息 a flame 火; 息 also provides the pronunciation',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '熊',
    definition: 'a bear; brilliant; surname',
    pinyin: ['xióng'],
    decomposition: '⿱能灬',
    etymology: { type: 'ideographic', hint: "A bear's 能 footprints 灬" },
    radical: '灬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '熏',
    definition: 'to smoke, to cure meat; vapor, smoke, fog',
    pinyin: ['xūn'],
    decomposition: '⿱？灬',
    etymology: { type: 'pictophonetic', semantic: '灬', hint: 'fire' },
    radical: '灬',
    matches: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '熒',
    definition: 'to shine, to shimmer; shining, dazzling',
    pinyin: ['yíng'],
    decomposition: '⿱⿱炏冖火',
    etymology: { type: 'pictophonetic', semantic: '火', hint: 'fire' },
    radical: '火',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '熔',
    definition: 'mold; to fuse, to melt, to smelt',
    pinyin: ['róng'],
    decomposition: '⿰火容',
    etymology: {
      type: 'ideographic',
      hint: 'To form 容 hot metal 火; 容 also provides the pronunciation',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '熘',
    definition: 'to steam, to stir-fry',
    pinyin: ['liū'],
    decomposition: '⿰火留',
    etymology: {
      type: 'pictophonetic',
      phonetic: '留',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '熙',
    definition: 'bright, prosperous; splendid, glorious',
    pinyin: ['xī'],
    decomposition: '⿱巸灬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巸',
      semantic: '灬',
      hint: 'fire',
    },
    radical: '灬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '熜',
    definition: 'chimney; torch',
    pinyin: ['cōng'],
    decomposition: '⿰火悤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '悤',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '熟',
    definition: 'well-cooked; ripe, mature; familiar with',
    pinyin: ['shú'],
    decomposition: '⿱孰灬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孰',
      semantic: '灬',
      hint: 'fire',
    },
    radical: '灬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '熠',
    definition: 'bright, sparkling',
    pinyin: ['yì'],
    decomposition: '⿰火習',
    etymology: {
      type: 'pictophonetic',
      phonetic: '習',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '熨',
    definition: 'to press, to iron; an iron',
    pinyin: ['yùn'],
    decomposition: '⿱尉火',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尉',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '熬',
    definition: 'to boil, to simmer; to endure pain',
    pinyin: ['áo'],
    decomposition: '⿱敖灬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敖',
      semantic: '灬',
      hint: 'fire',
    },
    radical: '灬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '熰',
    definition: 'severe drought',
    pinyin: ['ōu'],
    decomposition: '⿰火區',
    etymology: {
      type: 'pictophonetic',
      phonetic: '區',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '熱',
    definition: 'heat, fever, zeal',
    pinyin: ['rè'],
    decomposition: '⿱埶灬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '埶',
      semantic: '灬',
      hint: 'fire',
    },
    radical: '灬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '熳',
    definition: 'to spread',
    pinyin: ['màn'],
    decomposition: '⿰火曼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曼',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '熵',
    definition: 'entropy',
    pinyin: ['shāng'],
    decomposition: '⿰火商',
    etymology: {
      type: 'pictophonetic',
      phonetic: '商',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '熹',
    definition: 'dim light, a glimmer; warm; bright',
    pinyin: ['xī'],
    decomposition: '⿱喜灬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '喜',
      semantic: '灬',
      hint: 'fire',
    },
    radical: '灬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '熾',
    definition: 'to burn, to blaze; splendid; intense',
    pinyin: ['chì'],
    decomposition: '⿰火戠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戠',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '燃',
    definition: 'to ignite, to burn; combustion',
    pinyin: ['rán'],
    decomposition: '⿰火然',
    etymology: {
      type: 'pictophonetic',
      phonetic: '然',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '燅',
    definition: 'to reheat food',
    pinyin: ['xián'],
    decomposition: '⿰坴炎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '坴',
      semantic: '炎',
      hint: 'hot',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '燈',
    definition: 'lamp, lantern, light',
    pinyin: ['dēng'],
    decomposition: '⿰火登',
    etymology: {
      type: 'pictophonetic',
      phonetic: '登',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '燉',
    definition: 'to simmer; to stew',
    pinyin: ['dùn'],
    decomposition: '⿰火敦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敦',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '燎',
    definition: 'to burn, to light; street lamp; signal fire',
    pinyin: ['liáo'],
    decomposition: '⿰火尞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尞',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '燒',
    definition: 'to burn, to bake; to heat, to roast',
    pinyin: ['shāo'],
    decomposition: '⿰火堯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堯',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '燔',
    definition: 'to roast meat for a sacrifice',
    pinyin: ['fán'],
    decomposition: '⿰火番',
    etymology: {
      type: 'ideographic',
      hint: 'To roast 火 meat on a spit 番; 番 also provides the pronunciation',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '燕',
    definition: 'lovebird, swallow',
    pinyin: ['yàn'],
    decomposition: '⿱⿱廿⿻口北灬',
    etymology: {
      type: 'ideographic',
      hint: 'A swallow, with its head 廿, wings 北, and tail 灬',
    },
    radical: '灬',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1, 0],
      [0, 1, 0],
      [0, 1, 0],
      [0, 1, 1],
      [0, 1, 1],
      [0, 1, 1],
      [0, 1, 1],
      [0, 1, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '燙',
    definition: 'to scald; to iron clothes or hair',
    pinyin: ['tàng'],
    decomposition: '⿱湯火',
    etymology: {
      type: 'pictophonetic',
      phonetic: '湯',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '燜',
    definition: 'to simmer, to cook over a slow fire',
    pinyin: ['mèn'],
    decomposition: '⿰火悶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '悶',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '營',
    definition: 'camp, barracks, army; to run, to manage',
    pinyin: ['yíng'],
    decomposition: '⿳炏冖吕',
    radical: '炏',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '燠',
    definition: 'warm; warmth',
    pinyin: ['yù'],
    decomposition: '⿰火奥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奥',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '燥',
    definition: 'arid, dry, parched; quick-tempered',
    pinyin: ['zào'],
    decomposition: '⿰火喿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '喿',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '燦',
    definition: 'vivid, illuminating, brilliant',
    pinyin: ['càn'],
    decomposition: '⿰火粲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '粲',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '燧',
    definition: 'torch; flintstone; beacon, signal fire',
    pinyin: ['suì'],
    decomposition: '⿰火遂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '遂',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '燬',
    definition: 'to burn down; flame, blaze',
    pinyin: ['huǐ'],
    decomposition: '⿰火毁',
    etymology: {
      type: 'ideographic',
      hint: 'Damage 毁 from fire 火; 毁 also provides the pronunciation',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '燭',
    definition: 'candle, taper; to illuminate, to shine',
    pinyin: ['zhú'],
    decomposition: '⿰火蜀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蜀',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '燮',
    definition: 'to harmonize, to blend; to adjust',
    pinyin: ['xiè'],
    decomposition: '⿱⿲火言火又',
    radical: '火',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 2],
      [0, 2],
      [0, 2],
      [0, 2],
      [1],
      [1],
    ],
  },
  {
    character: '燴',
    definition: 'ragout; to braise, to cook',
    pinyin: ['huì'],
    decomposition: '⿰火會',
    etymology: {
      type: 'pictophonetic',
      phonetic: '會',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '燹',
    definition: 'fire; wildfire',
    pinyin: ['xiǎn'],
    decomposition: '⿱豩火',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豩',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '燻',
    definition: 'smoke, scent; to smoke, to cure',
    pinyin: ['xūn'],
    decomposition: '⿰火熏',
    etymology: {
      type: 'ideographic',
      hint: 'Smoke 熏 from a fire 火; 熏 also provides the pronunciation',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '燼',
    definition: 'ashes, cinders, embers; remnants',
    pinyin: ['jìn'],
    decomposition: '⿰火盡',
    etymology: {
      type: 'ideographic',
      hint: 'A used up 盡 fire 火; 盡 also provides the pronunciation',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '燾',
    definition: 'to shine, to illuminate; to cover, to envelop',
    pinyin: ['dào'],
    decomposition: '⿱壽灬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '壽',
      semantic: '灬',
      hint: 'fire',
    },
    radical: '灬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '爆',
    definition: 'crackle, pop; burst, explode',
    pinyin: ['bào'],
    decomposition: '⿰火暴',
    etymology: {
      type: 'ideographic',
      hint: 'A violent 暴 flame 火; 暴 also provides the pronunciation',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '爇',
    definition: 'to burn',
    pinyin: ['ruò'],
    decomposition: '⿱艹熱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '艹',
      semantic: '熱',
      hint: 'heat',
    },
    radical: '灬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '爌',
    definition: 'bright',
    pinyin: ['kuàng'],
    decomposition: '⿰火廣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '廣',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '爍',
    definition: 'to sparkle, to shine, to glitter',
    pinyin: ['shuò'],
    decomposition: '⿰火樂',
    etymology: {
      type: 'ideographic',
      hint: 'The happy 樂 light of a flame 火',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '爐',
    definition: 'fireplace, furnace, oven, stove',
    pinyin: ['lú'],
    decomposition: '⿰火盧',
    etymology: { type: 'ideographic', hint: "A fire 火 in one's home 盧" },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '爛',
    definition: 'overcooked, overripe; rotten, spoiled',
    pinyin: ['làn'],
    decomposition: '⿰火闌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '闌',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '爝',
    definition: 'torch',
    pinyin: ['jué'],
    decomposition: '⿰火爵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爵',
      semantic: '火',
      hint: 'fire',
    },
    radical: '火',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '爨',
    definition: 'oven, stove; to cook',
    pinyin: ['cuàn'],
    decomposition: '⿱⿳？林大火',
    etymology: { type: 'pictophonetic', semantic: '火', hint: 'fire' },
    radical: '火',
    matches: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 2],
      [0, 2],
      [0, 2],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '爪',
    definition: 'claws, nails, talons',
    pinyin: ['zhǎo'],
    decomposition: '⿵？丨',
    etymology: { type: 'pictographic', hint: "A bird's talons" },
    radical: '爪',
    matches: [null, null, [1], null],
  },
  {
    character: '爫',
    definition: 'claws, nails, talons',
    pinyin: ['zhǎo'],
    decomposition: '？',
    etymology: { type: 'pictographic', hint: "A bird's talons; compare 爪" },
    radical: '爫',
    matches: [null, null, null, null],
  },
  {
    character: '爬',
    definition: 'to climb, to scramble; to crawl, to creep',
    pinyin: ['pá'],
    decomposition: '⿺爪巴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巴',
      semantic: '爪',
      hint: 'claw',
    },
    radical: '爪',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '爭',
    definition: 'to dispute, to fight, to contend, to strive',
    pinyin: ['zhēng'],
    decomposition: '⿱爫⿻彐亅',
    etymology: {
      type: 'ideographic',
      hint: 'Two hands 爪 and 彐 fighting over 亅',
    },
    radical: '爫',
    matches: [[0], [0], [0], [0], [1, 0], [1, 0], [1, 0], [1, 1]],
  },
  {
    character: '爯',
    definition: 'to balance, to fit; balanced, suitable',
    pinyin: ['chēng'],
    decomposition: '⿱爫冉',
    etymology: {
      type: 'ideographic',
      hint: 'A hand 爫 balancing items on a scale 冉',
    },
    radical: '爫',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '爰',
    definition: 'to lead on to; then, therefore, as a consequence',
    pinyin: ['yuán'],
    decomposition: '⿱爫⿱一友',
    radical: '爫',
    matches: [[0], [0], [0], [0], [1, 0], [1, 1], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '爱',
    definition: 'to love, to like, to be fond of; love, affection',
    pinyin: ['ài'],
    decomposition: '⿱⿱爫冖友',
    etymology: {
      type: 'ideographic',
      hint: "To bring a friend 友 into one's house 冖",
    },
    radical: '爫',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '爵',
    definition: 'noble; a feudal rank or title',
    pinyin: ['jué'],
    decomposition: '⿱爫⿱罒⿰良寸',
    etymology: {
      type: 'ideographic',
      hint: 'A hand 寸 holding a goblet 良 of wine 罒',
    },
    radical: '爫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
    ],
  },
  {
    character: '父',
    definition: 'father, dad',
    pinyin: ['fù'],
    decomposition: '⿱八乂',
    etymology: { type: 'ideographic', hint: 'A hand 乂 holding an axe 八' },
    radical: '父',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '爷',
    definition: 'grandfather, old man',
    pinyin: ['yé'],
    decomposition: '⿱父卩',
    etymology: {
      type: 'pictophonetic',
      phonetic: '耶',
      semantic: '父',
      hint: 'father',
    },
    radical: '父',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '爸',
    definition: 'father, papa',
    pinyin: ['bà'],
    decomposition: '⿱父巴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巴',
      semantic: '父',
      hint: 'father',
    },
    radical: '父',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '爹',
    definition: 'father, dad, daddy',
    pinyin: ['diē'],
    decomposition: '⿱父多',
    etymology: {
      type: 'pictophonetic',
      phonetic: '多',
      semantic: '父',
      hint: 'father',
    },
    radical: '父',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '爺',
    definition: 'grandfather, old man',
    pinyin: ['yé'],
    decomposition: '⿱父耶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '耶',
      semantic: '父',
      hint: 'father',
    },
    radical: '父',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '爻',
    definition: 'diagrams for divination',
    pinyin: ['yáo'],
    decomposition: '⿱乂乂',
    etymology: { type: 'ideographic', hint: 'Two marks 乂 on an oracle bone' },
    radical: '爻',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '爽',
    definition: 'crisp, refreshing; candid, frank; pleased, happy',
    pinyin: ['shuǎng'],
    decomposition: '⿻大⿰爻爻',
    etymology: {
      type: 'ideographic',
      hint: 'A person 大 breathing lots of fresh air 爻',
    },
    radical: '爻',
    matches: [
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [0],
      [0],
    ],
  },
  {
    character: '爾',
    definition: 'you; that, those; final particle',
    pinyin: ['ěr'],
    decomposition: '⿻？⿰爻爻',
    radical: '爻',
    matches: [
      null,
      null,
      null,
      null,
      null,
      null,
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '爿',
    definition: 'half of a tree trunk',
    pinyin: ['qiáng'],
    decomposition: '⿹丩厂',
    etymology: {
      type: 'pictographic',
      hint: 'Half of a tree trunk; compare 片',
    },
    radical: '爿',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '牆',
    definition: 'wall',
    pinyin: ['qiáng'],
    decomposition: '⿰爿嗇',
    etymology: {
      type: 'pictophonetic',
      semantic: '爿',
      hint: 'earth',
      phonetic: '嗇',
    },
    radical: '爿',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '片',
    definition: 'slice, splinter; page, strip',
    pinyin: ['piàn'],
    decomposition: '⿸？？',
    etymology: {
      type: 'pictographic',
      hint: 'Half of a tree trunk; compare 爿',
    },
    radical: '片',
    matches: [null, null, null, null],
  },
  {
    character: '版',
    definition: 'printing block, edition; register; volume, version',
    pinyin: ['bǎn'],
    decomposition: '⿰片反',
    etymology: {
      type: 'pictophonetic',
      phonetic: '反',
      semantic: '片',
      hint: 'page',
    },
    radical: '片',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '牌',
    definition: 'card, game piece; placard, signboard, tablet',
    pinyin: ['pái'],
    decomposition: '⿰片卑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卑',
      semantic: '片',
      hint: 'page',
    },
    radical: '片',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '牍',
    definition: 'writing tablet; documents, books',
    pinyin: ['dú'],
    decomposition: '⿰片卖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卖',
      semantic: '片',
      hint: 'page',
    },
    radical: '片',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '牒',
    definition: 'documents, records; to dispatch',
    pinyin: ['dié'],
    decomposition: '⿰片枼',
    etymology: { type: 'ideographic', hint: 'Flat 片 pages 片 of wood' },
    radical: '片',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '牖',
    definition: 'window; to enlighten',
    pinyin: ['yǒu'],
    decomposition: '⿰片⿸户甫',
    etymology: { type: 'pictophonetic', hint: 'door', semantic: '户' },
    radical: '片',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '牘',
    definition: 'writing tablet; documents, books',
    pinyin: ['dú'],
    decomposition: '⿰片賣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '賣',
      semantic: '片',
      hint: 'page',
    },
    radical: '片',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '牙',
    definition: 'tooth, molar; fang, tusk; serrated',
    pinyin: ['yá'],
    decomposition: '？',
    radical: '牙',
    matches: [null, null, null, null],
  },
  {
    character: '牚',
    pinyin: ['chēng'],
    decomposition: '⿱尚牙',
    etymology: { type: 'pictophonetic', phonetic: '尚' },
    radical: '牙',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '牛',
    definition: 'ox, cow, bull',
    pinyin: ['niú'],
    decomposition: '？',
    etymology: { type: 'pictographic', hint: "An ox's horned head" },
    radical: '牛',
    matches: [null, null, null, null],
  },
  {
    character: '牝',
    definition: 'female animal; keyhole; valley',
    pinyin: ['pìn'],
    decomposition: '⿰牛匕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匕',
      semantic: '牛',
      hint: 'cow',
    },
    radical: '牛',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '牟',
    definition: 'to profit, to usurp; moo',
    pinyin: ['móu'],
    decomposition: '⿱厶牛',
    etymology: { type: 'pictophonetic', semantic: '牛', hint: 'ox' },
    radical: '牛',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '牡',
    definition: 'male animal; key, door bolt',
    pinyin: ['mǔ'],
    decomposition: '⿰牛土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '土',
      semantic: '牛',
      hint: 'ox',
    },
    radical: '牛',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '牢',
    definition: 'pen, prison, stable; fast, firm, secure',
    pinyin: ['láo'],
    decomposition: '⿱宀牛',
    etymology: {
      type: 'ideographic',
      hint: 'A stable 宀 where cattle are kept 牛',
    },
    radical: '牛',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '牦',
    definition: 'tail, hair; yak',
    pinyin: ['máo'],
    decomposition: '⿰牛毛',
    etymology: {
      type: 'ideographic',
      hint: 'The fur 毛 of an ox 牛; 毛 also provides the pronunciation',
    },
    radical: '牛',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '牧',
    definition: 'shepherd; to tend cattle',
    pinyin: ['mù'],
    decomposition: '⿰牛攵',
    etymology: { type: 'ideographic', hint: 'A hand 攵 leading an ox 牛' },
    radical: '牛',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '物',
    definition: 'thing, substance, matter; creature',
    pinyin: ['wù'],
    decomposition: '⿰牛勿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '勿',
      semantic: '牛',
      hint: 'ox',
    },
    radical: '牛',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '牮',
    definition: 'to prop up',
    pinyin: ['jiàn'],
    decomposition: '⿱代牛',
    radical: '牛',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '牯',
    definition: 'cow, steer',
    pinyin: ['gǔ'],
    decomposition: '⿰牛古',
    etymology: {
      type: 'pictophonetic',
      phonetic: '古',
      semantic: '牛',
      hint: 'ox',
    },
    radical: '牛',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '牲',
    definition: 'sacrificial animal; domestic animal',
    pinyin: ['shēng'],
    decomposition: '⿰牛生',
    etymology: {
      type: 'pictophonetic',
      phonetic: '生',
      semantic: '牛',
      hint: 'ox',
    },
    radical: '牛',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '牴',
    definition: 'to butt, to gore; to resist',
    pinyin: ['dǐ'],
    decomposition: '⿰牛氐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '氐',
      semantic: '牛',
      hint: 'ox',
    },
    radical: '牛',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '牵',
    definition: 'to drag, to pull, to lead by the hand',
    pinyin: ['qiān'],
    decomposition: '⿱大⿱冖牛',
    etymology: {
      type: 'ideographic',
      hint: 'A person 大 pulling an ox 牛 by a rope 冖',
    },
    radical: '大',
    matches: [[0], [0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '牸',
    definition: 'female animal; to give birth',
    pinyin: ['zì'],
    decomposition: '⿰牛字',
    etymology: {
      type: 'pictophonetic',
      phonetic: '字',
      semantic: '牛',
      hint: 'cow',
    },
    radical: '牛',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '特',
    definition: 'special, unique, distinguished',
    pinyin: ['tè'],
    decomposition: '⿰牛寺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寺',
      semantic: '牛',
      hint: 'ox',
    },
    radical: '牛',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '牺',
    definition: 'to sacrifice, to give up, to die for a cause',
    pinyin: ['xī'],
    decomposition: '⿰牛西',
    etymology: {
      type: 'pictophonetic',
      phonetic: '西',
      semantic: '牛',
      hint: 'ox',
    },
    radical: '牛',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '牽',
    definition: 'to drag, to pull, to lead by the hand',
    pinyin: ['qiān'],
    decomposition: '⿱⿻玄冖牛',
    etymology: {
      type: 'ideographic',
      hint: 'A person pulling 冖 an ox 牛 by a rope 玄',
    },
    radical: '牛',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '牾',
    definition: 'to gore; to oppose',
    pinyin: ['wǔ'],
    decomposition: '⿰牛吾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吾',
      semantic: '牛',
      hint: 'ox',
    },
    radical: '牛',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '牿',
    definition: 'cattle shed',
    pinyin: ['gù'],
    decomposition: '⿰牛告',
    etymology: {
      type: 'pictophonetic',
      phonetic: '告',
      semantic: '牛',
      hint: 'ox',
    },
    radical: '牛',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '犀',
    definition: 'rhinoceros; sharp, tempered',
    pinyin: ['xī'],
    decomposition: '⿸尾牛',
    etymology: { type: 'ideographic', hint: 'An ox 牛 with a tail 尾' },
    radical: '牛',
    matches: [[0], [0], [0], [0], [0], [0], [0], null, [1], [1], [1], [1]],
  },
  {
    character: '犁',
    definition: 'to plow',
    pinyin: ['lí'],
    decomposition: '⿱利牛',
    etymology: {
      type: 'ideographic',
      hint: 'To use an ox 牛 to harvest 刂 grain 禾; 利 also provides the pronunciation',
    },
    radical: '牛',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '犂',
    definition: 'plow',
    pinyin: ['lí'],
    decomposition: '⿱⿰禾？牛',
    etymology: {
      type: 'ideographic',
      hint: 'To use an ox 牛 to harvest  grain 禾; compare 犁',
    },
    radical: '牛',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      null,
      null,
      null,
      null,
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '犄',
    definition: 'animal horns',
    pinyin: ['jī'],
    decomposition: '⿰牛奇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奇',
      semantic: '牛',
      hint: 'ox',
    },
    radical: '牛',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '犊',
    definition: 'calf; sacrificial lamb',
    pinyin: ['dú'],
    decomposition: '⿰牛卖',
    etymology: { type: 'ideographic', hint: 'To sacrifice 卖 a calf 牛' },
    radical: '牛',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '犋',
    pinyin: ['jù'],
    decomposition: '⿰牛具',
    etymology: {
      type: 'pictophonetic',
      phonetic: '具',
      semantic: '牛',
      hint: 'ox',
    },
    radical: '牛',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '犍',
    definition: 'bullock; to castrate',
    pinyin: ['jiān'],
    decomposition: '⿰牛建',
    etymology: {
      type: 'pictophonetic',
      phonetic: '建',
      semantic: '牛',
      hint: 'ox',
    },
    radical: '牛',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '犎',
    definition: 'zebu; humped-ox',
    pinyin: ['fēng'],
    decomposition: '⿱封牛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '封',
      semantic: '牛',
      hint: 'ox',
    },
    radical: '牛',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '犏',
    definition: 'yak-ox',
    pinyin: ['piān'],
    decomposition: '⿰牛扁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '扁',
      semantic: '牛',
      hint: 'ox',
    },
    radical: '牛',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '犒',
    definition: 'victory feast; to throw a banquet',
    pinyin: ['kào'],
    decomposition: '⿰牛高',
    etymology: {
      type: 'pictophonetic',
      phonetic: '高',
      semantic: '牛',
      hint: 'ox',
    },
    radical: '牛',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '犟',
    definition: 'stubborn',
    pinyin: ['jiàng'],
    decomposition: '⿱强牛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '强',
      semantic: '牛',
      hint: 'ox',
    },
    radical: '牛',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '犢',
    definition: 'calf; sacrificial lamb',
    pinyin: ['dú'],
    decomposition: '⿰牛賣',
    etymology: { type: 'ideographic', hint: 'To sacrifice 賣 a calf 牛' },
    radical: '牛',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '犧',
    definition: 'to sacrifice, to give up, to die for a cause',
    pinyin: ['xī'],
    decomposition: '⿰牛羲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羲',
      semantic: '牛',
      hint: 'ox',
    },
    radical: '牛',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '犪',
    definition: 'yak',
    pinyin: ['kuí'],
    decomposition: '⿰牛夔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夔',
      semantic: '牛',
      hint: 'ox',
    },
    radical: '牛',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '犬',
    definition: 'dog',
    pinyin: ['quǎn'],
    decomposition: '⿻大丶',
    etymology: { type: 'pictographic', hint: 'A dog turned to the side' },
    radical: '犬',
    matches: [[0], [0], [0], [1]],
  },
  {
    character: '犭',
    definition: 'dog',
    pinyin: ['quǎn'],
    decomposition: '⿻？？',
    etymology: { type: 'pictographic', hint: 'A dog turned to the side' },
    radical: '犭',
    matches: [null, null, null],
  },
  {
    character: '犮',
    definition: 'to pull up',
    pinyin: ['bá'],
    decomposition: '⿻犬？',
    radical: '犬',
    matches: [[0], [0], null, [0], [0]],
  },
  {
    character: '犯',
    definition: 'criminal; to violate, to commit a crime',
    pinyin: ['fàn'],
    decomposition: '⿰犭㔾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㔾',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '犰',
    definition: 'armadillo',
    pinyin: ['qiú'],
    decomposition: '⿰犭九',
    etymology: {
      type: 'pictophonetic',
      phonetic: '九',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '犴',
    definition: 'wild dog; jail, lock-up',
    pinyin: ['àn'],
    decomposition: '⿰犭干',
    etymology: {
      type: 'pictophonetic',
      phonetic: '干',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '状',
    definition: 'state, condition; shape, appearance, form; certificate',
    pinyin: ['zhuàng'],
    decomposition: '⿰丬犬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丬',
      semantic: '犬',
      hint: 'dog',
    },
    radical: '犬',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '犷',
    definition: 'fierce, rude, uncivilized',
    pinyin: ['guǎng'],
    decomposition: '⿰犭广',
    etymology: {
      type: 'pictophonetic',
      phonetic: '广',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '犸',
    definition: 'mammoth',
    pinyin: ['mà'],
    decomposition: '⿰犭马',
    etymology: {
      type: 'pictophonetic',
      phonetic: '马',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '犹',
    definition: 'similar to, just like, as',
    pinyin: ['yóu'],
    decomposition: '⿰犭尤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尤',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '犾',
    pinyin: ['yín'],
    decomposition: '⿰犭犬',
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '狀',
    definition: 'state, condition; shape, appearance, form; certificate',
    pinyin: ['zhuàng'],
    decomposition: '⿰爿犬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爿',
      semantic: '犬',
      hint: 'dog',
    },
    radical: '犬',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '狁',
    definition: 'barbarians; a tribe of Scythian nomads',
    pinyin: ['yǔn'],
    decomposition: '⿰犭允',
    etymology: {
      type: 'pictophonetic',
      phonetic: '允',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '狂',
    definition: 'insane, mad; violent; wild',
    pinyin: ['kuáng'],
    decomposition: '⿰犭王',
    etymology: {
      type: 'pictophonetic',
      phonetic: '王',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '狃',
    definition: 'greedy, covetous; accustomed to',
    pinyin: ['niǔ'],
    decomposition: '⿰犭丑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丑',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '狄',
    definition: 'barbarians; a tribe from northern China; surname',
    pinyin: ['dí'],
    decomposition: '⿰犭火',
    etymology: {
      type: 'pictophonetic',
      phonetic: '火',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '狈',
    definition: 'a legendary wolf; distressed, wretched',
    pinyin: ['bèi'],
    decomposition: '⿰犭贝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贝',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '狉',
    definition: 'fox cub',
    pinyin: ['pī'],
    decomposition: '⿰犭丕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丕',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '狊',
    pinyin: ['jú'],
    decomposition: '⿱目犬',
    radical: '犬',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '狍',
    definition: 'a species of deer found in northern China',
    pinyin: ['páo'],
    decomposition: '⿰犭包',
    etymology: {
      type: 'pictophonetic',
      phonetic: '包',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '狎',
    definition: 'to be familiar with; to disrespect',
    pinyin: ['xiá'],
    decomposition: '⿰犭甲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甲',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '狐',
    definition: 'fox',
    pinyin: ['hú'],
    decomposition: '⿰犭瓜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '瓜',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '狒',
    definition: 'baboon',
    pinyin: ['fèi'],
    decomposition: '⿰犭弗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弗',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '狗',
    definition: 'dog',
    pinyin: ['gǒu'],
    decomposition: '⿰犭句',
    etymology: {
      type: 'pictophonetic',
      phonetic: '句',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '狙',
    definition: 'monkey, ape; to spy, to watch for; to lie in ambush',
    pinyin: ['jū'],
    decomposition: '⿰犭且',
    etymology: {
      type: 'pictophonetic',
      phonetic: '且',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '狞',
    definition: 'fierce; hideous',
    pinyin: ['níng'],
    decomposition: '⿰犭宁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宁',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '狠',
    definition: 'vicious, fierce, cruel',
    pinyin: ['hěn'],
    decomposition: '⿰犭艮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '艮',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '狡',
    definition: 'cunning, deceitful, treacherous',
    pinyin: ['jiǎo'],
    decomposition: '⿰犭交',
    etymology: {
      type: 'pictophonetic',
      phonetic: '交',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '狨',
    definition: 'the common marmoset',
    pinyin: ['róng'],
    decomposition: '⿰犭戎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戎',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '狩',
    definition: 'winter hunting; a hunting dog; an imperial tour',
    pinyin: ['shòu'],
    decomposition: '⿰犭守',
    etymology: {
      type: 'pictophonetic',
      phonetic: '守',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '独',
    definition: 'alone, independent, only, single, solitary',
    pinyin: ['dú'],
    decomposition: '⿰犭虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '虫',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '狭',
    definition: 'narrow, limited; narrow-minded',
    pinyin: ['xiá'],
    decomposition: '⿰犭夹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夹',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '狮',
    definition: 'lion',
    pinyin: ['shī'],
    decomposition: '⿰犭师',
    etymology: {
      type: 'pictophonetic',
      phonetic: '师',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '狯',
    definition: 'sly, cunning, crafty',
    pinyin: ['kuài'],
    decomposition: '⿰犭会',
    etymology: {
      type: 'pictophonetic',
      phonetic: '会',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '狰',
    definition: 'fierce-looking, ferocious',
    pinyin: ['zhēng'],
    decomposition: '⿰犭争',
    etymology: {
      type: 'pictophonetic',
      phonetic: '争',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '狱',
    definition: 'prison, jail; case; lawsuit',
    pinyin: ['yù'],
    decomposition: '⿰犭⿰讠犬',
    etymology: {
      type: 'ideographic',
      hint: 'A guard dog 犭 talking 讠 to a prisoner 犬',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '狲',
    definition: 'monkey',
    pinyin: ['sūn'],
    decomposition: '⿰犭孙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孙',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '狳',
    definition: 'armadillo',
    pinyin: ['yú'],
    decomposition: '⿰犭余',
    etymology: {
      type: 'pictophonetic',
      phonetic: '余',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '狴',
    definition: 'tapir; a fierce beast depicted on prison doors',
    pinyin: ['bì'],
    decomposition: '⿰犭坒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '坒',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '狷',
    definition: 'rash, irritable, impulsive, impetuous',
    pinyin: ['juàn'],
    decomposition: '⿰犭肙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肙',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '狸',
    definition: 'fox',
    pinyin: ['lí'],
    decomposition: '⿰犭里',
    etymology: {
      type: 'pictophonetic',
      phonetic: '里',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '狹',
    definition: 'narrow, limited; narrow-minded',
    pinyin: ['xiá'],
    decomposition: '⿰犭夾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夾',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '狺',
    definition: 'the snarling of dogs',
    pinyin: ['yín'],
    decomposition: '⿰犭言',
    etymology: {
      type: 'pictophonetic',
      phonetic: '言',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '狻',
    definition: 'a fabulous beast',
    pinyin: ['suān'],
    decomposition: '⿰犭夋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夋',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '狼',
    definition: 'wolf',
    pinyin: ['láng'],
    decomposition: '⿰犭良',
    etymology: {
      type: 'pictophonetic',
      phonetic: '良',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '狽',
    definition: 'a legendary wolf; distressed, wretched',
    pinyin: ['bèi'],
    decomposition: '⿰犭貝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '貝',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猁',
    definition: 'a kind of monkey',
    pinyin: ['lì'],
    decomposition: '⿰犭利',
    etymology: {
      type: 'pictophonetic',
      phonetic: '利',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猃',
    definition: 'long-snouted dog',
    pinyin: ['xiǎn'],
    decomposition: '⿰犭佥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '佥',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猇',
    definition: "a tiger's roar; to intimidate; to scare",
    pinyin: ['xiāo'],
    decomposition: '⿰犭虎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '犭',
      semantic: '虎',
      hint: 'tiger',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猊',
    definition: 'lion, wild beast; wild horse',
    pinyin: ['ní'],
    decomposition: '⿰犭兒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兒',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猋',
    definition: 'wind, storm, gale; a dog running',
    pinyin: ['biāo'],
    decomposition: '⿱犬⿰犬犬',
    etymology: {
      type: 'ideographic',
      hint: 'A pack of ferocious dogs 犬; a storm',
    },
    radical: '犬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '猎',
    definition: 'hunting; field sports',
    pinyin: ['liè'],
    decomposition: '⿰犭昔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昔',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猒',
    pinyin: ['yān'],
    decomposition: '⿰明犬',
    radical: '犬',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '猓',
    definition: 'monkey',
    pinyin: ['guǒ'],
    decomposition: '⿰犭果',
    etymology: {
      type: 'pictophonetic',
      phonetic: '果',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猕',
    definition: 'macacus monkey',
    pinyin: ['mí'],
    decomposition: '⿰犭弥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弥',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猖',
    definition: 'mad, wild; reckless, unruly',
    pinyin: ['chāng'],
    decomposition: '⿰犭昌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昌',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猗',
    definition: 'exclamation of admiration',
    pinyin: ['yī'],
    decomposition: '⿰犭奇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奇',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猙',
    definition: 'fierce-looking, ferocious',
    pinyin: ['zhēng'],
    decomposition: '⿰犭爭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爭',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猛',
    definition: 'violent, savage, cruel, bold',
    pinyin: ['měng'],
    decomposition: '⿰犭孟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孟',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猜',
    definition: 'to guess, to conjecture, to suppose; to feel',
    pinyin: ['cāi'],
    decomposition: '⿰犭青',
    etymology: {
      type: 'pictophonetic',
      phonetic: '青',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猝',
    definition: 'sudden, abrupt',
    pinyin: ['cù'],
    decomposition: '⿰犭卒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卒',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猞',
    definition: 'lynx, wild cat',
    pinyin: ['shē'],
    decomposition: '⿰犭舍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '舍',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猡',
    definition: 'pig; the Lolo aboriginal tribe',
    pinyin: ['luó'],
    decomposition: '⿰犭罗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '罗',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猢',
    definition: 'a kind of monkey found in western China',
    pinyin: ['hú'],
    decomposition: '⿰犭胡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '胡',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猥',
    definition: 'vulgar, low; wanton, obscene',
    pinyin: ['wěi'],
    decomposition: '⿰犭畏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畏',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猩',
    definition: 'ape, orangutan',
    pinyin: ['xīng'],
    decomposition: '⿰犭星',
    etymology: {
      type: 'pictophonetic',
      phonetic: '星',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猪',
    definition: 'pig, hog, wild boar',
    pinyin: ['zhū'],
    decomposition: '⿰犭者',
    etymology: {
      type: 'pictophonetic',
      phonetic: '者',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猫',
    definition: 'cat',
    pinyin: ['māo'],
    decomposition: '⿰犭苗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '苗',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猬',
    definition: 'porcupine, hedgehog; many, varied; vulgar, low',
    pinyin: ['wèi'],
    decomposition: '⿰犭胃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '胃',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '献',
    definition: 'to offer, to present; to show, to display',
    pinyin: ['xiàn'],
    decomposition: '⿰南犬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '南',
      semantic: '犬',
      hint: 'dog',
    },
    radical: '犬',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '猱',
    definition: 'a monkey with yellow hair',
    pinyin: ['náo'],
    decomposition: '⿰犭柔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '柔',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猲',
    definition: 'frightened, terrified; snub-nosed dog',
    pinyin: ['xiē'],
    decomposition: '⿰犭曷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曷',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猳',
    definition: 'boar; legendary ape',
    pinyin: ['jiā'],
    decomposition: '⿰犭叚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叚',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猴',
    definition: 'monkey, ape; like a monkey',
    pinyin: ['hóu'],
    decomposition: '⿰犭侯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '侯',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猵',
    definition: 'otter',
    pinyin: ['biān'],
    decomposition: '⿰犭扁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '扁',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猶',
    definition: 'similar to, just like, as',
    pinyin: ['yóu'],
    decomposition: '⿰犭酋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '酋',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猷',
    definition: 'to plan, to plot, to scheme',
    pinyin: ['yóu'],
    decomposition: '⿰酋犬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '酋',
      semantic: '犬',
      hint: 'dog',
    },
    radical: '犬',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '猸',
    definition: 'badger, ferret, mongoose',
    pinyin: ['méi'],
    decomposition: '⿰犭眉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '眉',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猹',
    definition: 'badger; a wild animal mentioned in a story by Lu Xun',
    pinyin: ['chá'],
    decomposition: '⿰犭查',
    etymology: {
      type: 'pictophonetic',
      phonetic: '查',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猻',
    definition: 'monkey',
    pinyin: ['sūn'],
    decomposition: '⿰犭孫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孫',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猾',
    definition: 'crafty, cunning, shrewd; deceitful',
    pinyin: ['huá'],
    decomposition: '⿰犭骨',
    etymology: {
      type: 'pictophonetic',
      phonetic: '骨',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '猿',
    definition: 'ape',
    pinyin: ['yuán'],
    decomposition: '⿰犭袁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '袁',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '獄',
    definition: 'prison, jail; case; lawsuit',
    pinyin: ['yù'],
    decomposition: '⿰犭⿰言犬',
    etymology: {
      type: 'ideographic',
      hint: 'A guard dog 犭 talking 言 to a prisoner 犬',
    },
    radical: '犭',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '獅',
    definition: 'lion',
    pinyin: ['shī'],
    decomposition: '⿰犭師',
    etymology: {
      type: 'pictophonetic',
      phonetic: '師',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '獍',
    definition: 'the Manchurian tiger',
    pinyin: ['jìng'],
    decomposition: '⿰犭竟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '竟',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '獎',
    definition: 'prize, reward; to award',
    pinyin: ['jiǎng'],
    decomposition: '⿱將犬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '將',
      semantic: '犬',
      hint: 'dog',
    },
    radical: '犬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '獐',
    definition: 'roebuck, hornless river deer',
    pinyin: ['zhāng'],
    decomposition: '⿰犭章',
    etymology: {
      type: 'pictophonetic',
      phonetic: '章',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '獒',
    definition: 'smastiff, large fierce dog',
    pinyin: ['áo'],
    decomposition: '⿱敖犬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敖',
      semantic: '犬',
      hint: 'dog',
    },
    radical: '犬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '獗',
    definition: 'wild, violent; unruly, lawless',
    pinyin: ['jué'],
    decomposition: '⿰犭厥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厥',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '獠',
    definition: 'to hunt at night with torches',
    pinyin: ['liáo'],
    decomposition: '⿰犭尞',
    etymology: {
      type: 'ideographic',
      hint: 'Hunting with dogs 犭 and torches 尞; 尞 also provides the pronunciation',
    },
    radical: '犭',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '獨',
    definition: 'alone, independent, only, single, solitary',
    pinyin: ['dú'],
    decomposition: '⿰犭蜀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蜀',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '獬',
    definition: 'mythical unicorn',
    pinyin: ['xiè'],
    decomposition: '⿰犭解',
    etymology: {
      type: 'pictophonetic',
      phonetic: '解',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '獭',
    definition: 'otter',
    pinyin: ['tǎ'],
    decomposition: '⿰犭赖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '赖',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '獯',
    definition: 'barbarians; a tribe of Scythian nomads',
    pinyin: ['xūn'],
    decomposition: '⿰犭熏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '熏',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '獲',
    definition: 'to get, to obtain, to receive, to sieze',
    pinyin: ['huò'],
    decomposition: '⿰犭蒦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蒦',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '獵',
    definition: 'hunting; field sports',
    pinyin: ['liè'],
    decomposition: '⿰犭巤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巤',
      semantic: '犭',
      hint: 'dog',
    },
    radical: '犭',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '獸',
    definition: 'beast, animal; bestial',
    pinyin: ['shòu'],
    decomposition: '⿰嘼犬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '嘼',
      semantic: '犬',
      hint: 'animal',
    },
    radical: '犬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '獻',
    definition: 'to offer, to present; to show, to display',
    pinyin: ['xiàn'],
    decomposition: '⿰鬳犬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鬳',
      semantic: '犬',
      hint: 'dog',
    },
    radical: '犬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '獾',
    definition: 'badger',
    pinyin: ['huān'],
    decomposition: '⿰犭雚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '雚',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '玃',
    definition: 'a large ape found in western China',
    pinyin: ['jué'],
    decomposition: '⿰犭矍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '矍',
      semantic: '犭',
      hint: 'animal',
    },
    radical: '犭',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '玄',
    definition: 'deep, profound, abstruse',
    pinyin: ['xuán'],
    decomposition: '⿱亠幺',
    radical: '玄',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '率',
    definition: 'to command, to lead; rate, ratio, proportion',
    pinyin: ['lǜ'],
    decomposition: '⿱亠⿱⿻幺？十',
    etymology: {
      type: 'ideographic',
      hint: 'A string 幺 vibrating in an instrument 亠十',
    },
    radical: '玄',
    matches: [
      [0],
      [0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 0],
      null,
      null,
      null,
      null,
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '玉',
    definition: 'jade, gem, precious stone',
    pinyin: ['yù'],
    decomposition: '⿻王丶',
    etymology: {
      type: 'ideographic',
      hint: 'A necklace 丨 adorned with three pieces of jade',
    },
    radical: '玉',
    matches: [[0], [0], [0], [0], [1]],
  },
  {
    character: '王',
    definition: 'king, ruler; royal; surname',
    pinyin: ['wáng'],
    decomposition: '⿱一土',
    etymology: {
      type: 'ideographic',
      hint: 'A man 十 bridging heaven and earth (both 一)',
    },
    radical: '王',
    matches: [[0], [1], [1], [1]],
  },
  {
    character: '玎',
    definition: 'jingling, tinkling',
    pinyin: ['dīng'],
    decomposition: '⿰王丁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丁',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '玑',
    definition: 'an oblong pearl',
    pinyin: ['jī'],
    decomposition: '⿰王几',
    etymology: {
      type: 'pictophonetic',
      phonetic: '几',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '玓',
    definition: 'pearl',
    pinyin: ['dì'],
    decomposition: '⿰王勺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '勺',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '玖',
    definition: "black jade; nine (bankers' anti-fraud numeral)",
    pinyin: ['jiǔ'],
    decomposition: '⿰王久',
    etymology: {
      type: 'pictophonetic',
      phonetic: '久',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '玗',
    definition: 'semi-precious stone',
    pinyin: ['yú'],
    decomposition: '⿰王于',
    etymology: {
      type: 'pictophonetic',
      phonetic: '于',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '玛',
    definition: 'agate, cornelian',
    pinyin: ['mǎ'],
    decomposition: '⿰王马',
    etymology: {
      type: 'pictophonetic',
      phonetic: '马',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '玟',
    definition: 'gem, jade-like stone',
    pinyin: ['wén'],
    decomposition: '⿰王文',
    etymology: {
      type: 'pictophonetic',
      phonetic: '文',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '玡',
    definition: 'used in place names',
    pinyin: ['yá'],
    decomposition: '⿰王牙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '牙',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '玢',
    definition: '(archaic) a kind of jade, porphyrite',
    pinyin: ['bīn'],
    decomposition: '⿰王分',
    etymology: {
      type: 'pictophonetic',
      phonetic: '分',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '玨',
    definition: 'guitar strings; variant of 珏',
    pinyin: ['jué'],
    decomposition: '⿰王王',
    etymology: {
      type: 'pictographic',
      hint: 'Two guitar strings bound across frets',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '玩',
    definition: 'to play with, to joke, to entertain',
    pinyin: ['wán'],
    decomposition: '⿰王元',
    etymology: {
      type: 'pictophonetic',
      phonetic: '元',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '玫',
    definition: 'rose',
    pinyin: ['méi'],
    decomposition: '⿰王攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '攵',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '玮',
    definition: 'a type of red jade; rare, valuable',
    pinyin: ['wěi'],
    decomposition: '⿰王韦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韦',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '环',
    definition: 'bracelet, ring; to surround, to loop',
    pinyin: ['huán'],
    decomposition: '⿰王不',
    etymology: {
      type: 'pictophonetic',
      phonetic: '不',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '现',
    definition: 'to appear, to manifest; current, now',
    pinyin: ['xiàn'],
    decomposition: '⿰王见',
    etymology: {
      type: 'ideographic',
      hint: 'To see 见 jade 王; 见 also provides the pronunciation',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '玲',
    definition: 'the tinkling of jewelry',
    pinyin: ['líng'],
    decomposition: '⿰王令',
    etymology: {
      type: 'pictophonetic',
      phonetic: '令',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '玳',
    definition: 'tortoise shell',
    pinyin: ['dài'],
    decomposition: '⿰王代',
    etymology: {
      type: 'pictophonetic',
      phonetic: '代',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '玷',
    definition: 'character flaw; a flaw in a gem',
    pinyin: ['diàn'],
    decomposition: '⿰王占',
    etymology: {
      type: 'pictophonetic',
      phonetic: '占',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '玺',
    definition: 'imperial signet, royal signet',
    pinyin: ['xǐ'],
    decomposition: '⿱尔玉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尔',
      semantic: '玉',
      hint: 'jade',
    },
    radical: '玉',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '玻',
    definition: 'glass',
    pinyin: ['bō'],
    decomposition: '⿰王皮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皮',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '珀',
    definition: 'amber',
    pinyin: ['pò'],
    decomposition: '⿰王白',
    etymology: {
      type: 'ideographic',
      hint: 'Clear 白 jade 王; 白 also provides the pronunciation',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '珂',
    definition: 'an inferior kind of jade',
    pinyin: ['kē'],
    decomposition: '⿰王可',
    etymology: {
      type: 'ideographic',
      hint: 'Possibly 可 jade 王; 可 also provides the pronunciation',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '珈',
    definition: "an ornament attached to a woman's hairpin",
    pinyin: ['jiā'],
    decomposition: '⿰王加',
    etymology: {
      type: 'ideographic',
      hint: 'Jade 王 added 加 to jewelry; 加 also provides the pronunciation',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '珉',
    definition: 'alabaster; a jade-like stone',
    pinyin: ['mín'],
    decomposition: '⿰王民',
    etymology: {
      type: 'pictophonetic',
      phonetic: '民',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '珊',
    definition: 'coral',
    pinyin: ['shān'],
    decomposition: '⿰王册',
    etymology: {
      type: 'pictophonetic',
      phonetic: '册',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '珍',
    definition: 'a treasure, a precious thing; rare, valuable',
    pinyin: ['zhēn'],
    decomposition: '⿰王⿱人彡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彡',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '珏',
    definition: 'two gems mounted together',
    pinyin: ['jué'],
    decomposition: '⿰王玉',
    etymology: {
      type: 'ideographic',
      hint: 'Two pieces of jade 王 side by side',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '珐',
    definition: 'enamel, cloissoné',
    pinyin: ['fà'],
    decomposition: '⿰王去',
    etymology: {
      type: 'pictophonetic',
      phonetic: '去',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '珑',
    definition: 'the tinkling of jewelry',
    pinyin: ['lóng'],
    decomposition: '⿰王龙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龙',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '珙',
    definition: 'precious stone; a county in Sichuan',
    pinyin: ['gǒng'],
    decomposition: '⿰王共',
    etymology: {
      type: 'pictophonetic',
      phonetic: '共',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '珞',
    definition: 'a kind of necklace',
    pinyin: ['luò'],
    decomposition: '⿰王各',
    etymology: {
      type: 'pictophonetic',
      phonetic: '各',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '珠',
    definition: 'gem, jewel, pearl, precious stone',
    pinyin: ['zhū'],
    decomposition: '⿰王朱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朱',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '珤',
    definition: 'treasure, jewel; rare, precious',
    pinyin: ['bǎo'],
    decomposition: '⿰王缶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '缶',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '珥',
    definition: 'pearl or jade earring; to insert, to stick',
    pinyin: ['ěr'],
    decomposition: '⿰王耳',
    etymology: {
      type: 'ideographic',
      hint: 'An ear 耳 ring 王; 耳 also provides the pronunciation',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '珧',
    definition: 'mother-of-pearl',
    pinyin: ['yáo'],
    decomposition: '⿰王兆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兆',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '珩',
    definition: 'central gem; crown jewel',
    pinyin: ['háng'],
    decomposition: '⿰王行',
    etymology: {
      type: 'pictophonetic',
      phonetic: '行',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '班',
    definition: 'class, squad, team, work shift',
    pinyin: ['bān'],
    decomposition: '⿲王刂王',
    etymology: {
      type: 'ideographic',
      hint: 'Cutting 刂 a piece of jade 王 in two, symbolizing two classes',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [2], [2], [2], [2]],
  },
  {
    character: '珲',
    definition: 'bright, glorious, splendid',
    pinyin: ['huī'],
    decomposition: '⿰王军',
    etymology: {
      type: 'pictophonetic',
      phonetic: '军',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '現',
    definition: 'to appear, to manifest; current, now',
    pinyin: ['xiàn'],
    decomposition: '⿰王見',
    etymology: {
      type: 'ideographic',
      hint: 'To see 見 jade 王; 見 also provides the pronunciation',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '球',
    definition: 'ball, globe, sphere; round',
    pinyin: ['qiú'],
    decomposition: '⿰王求',
    etymology: {
      type: 'pictophonetic',
      phonetic: '求',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '琅',
    definition: 'pure, white; carnelian',
    pinyin: ['láng'],
    decomposition: '⿰王良',
    etymology: {
      type: 'pictophonetic',
      phonetic: '良',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '理',
    definition: 'science, reason, logic; to manage',
    pinyin: ['lǐ'],
    decomposition: '⿰王里',
    etymology: {
      type: 'pictophonetic',
      phonetic: '里',
      semantic: '王',
      hint: 'king',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '琉',
    definition: 'sparkling stone; opaque, glazed',
    pinyin: ['liú'],
    decomposition: '⿰王㐬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㐬',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '琊',
    definition: 'a place in eastern Shandong',
    pinyin: ['yá'],
    decomposition: '⿰王邪',
    etymology: {
      type: 'pictophonetic',
      phonetic: '邪',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '琏',
    definition: 'a vessel used to hold grain offerings',
    pinyin: ['liǎn'],
    decomposition: '⿰王连',
    etymology: {
      type: 'pictophonetic',
      phonetic: '连',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '琐',
    definition: 'petty; trifling; troublesome',
    pinyin: ['suǒ'],
    decomposition: '⿰王⿱⺌贝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '⺌',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '琚',
    definition: 'girdle ornaments',
    pinyin: ['jū'],
    decomposition: '⿰王居',
    etymology: {
      type: 'pictophonetic',
      phonetic: '居',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '琛',
    definition: 'treasure, valuables',
    pinyin: ['chēn'],
    decomposition: '⿰王罙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '罙',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '琢',
    definition: 'to polish jade; to cut jade',
    pinyin: ['zuó'],
    decomposition: '⿰王豖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豖',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '琥',
    definition: 'amber, tigers-eye',
    pinyin: ['hǔ'],
    decomposition: '⿰王虎',
    etymology: {
      type: 'ideographic',
      hint: "A tiger's eye 虎 stone 王; 虎 also provides the pronunciation",
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '琦',
    definition: 'jade, gem, precious stone',
    pinyin: ['qí'],
    decomposition: '⿰王奇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奇',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '琨',
    definition: 'beautiful jade, precious stones',
    pinyin: ['kūn'],
    decomposition: '⿰王昆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昆',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '琪',
    definition: 'fine jade',
    pinyin: ['qí'],
    decomposition: '⿰王其',
    etymology: {
      type: 'pictophonetic',
      phonetic: '其',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '琬',
    definition: 'fine jade; nobility',
    pinyin: ['wǎn'],
    decomposition: '⿰王宛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宛',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '琮',
    definition: 'an octagonal jade ornament',
    pinyin: ['cóng'],
    decomposition: '⿰王宗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宗',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '琰',
    definition: 'gemstone fire; scintillation',
    pinyin: ['yǎn'],
    decomposition: '⿰王炎',
    etymology: {
      type: 'ideographic',
      hint: 'The fire 炎 in a gem 王; 炎 also provides the pronunciation',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '琳',
    definition: 'a beautiful gemstone',
    pinyin: ['lín'],
    decomposition: '⿰王林',
    etymology: {
      type: 'pictophonetic',
      phonetic: '林',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '琴',
    definition: 'Chinese lute or guitar, string instrument',
    pinyin: ['qín'],
    decomposition: '⿱玨今',
    etymology: {
      type: 'ideographic',
      hint: 'Two guitar strings 玨 suggest the meaning; 今 provides the pronunciation',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '琵',
    definition: 'a guitar-like instrument',
    pinyin: ['pí'],
    decomposition: '⿱玨比',
    etymology: {
      type: 'pictophonetic',
      phonetic: '比',
      semantic: '玨',
      hint: 'guitar strings',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '琶',
    definition: 'a guitar-like instrument',
    pinyin: ['pá'],
    decomposition: '⿱玨巴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巴',
      semantic: '玨',
      hint: 'guitar strings',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '琼',
    definition: 'jade; rare, precious; elegant',
    pinyin: ['qióng'],
    decomposition: '⿰王京',
    etymology: {
      type: 'pictophonetic',
      phonetic: '京',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '瑁',
    definition: 'fine jade',
    pinyin: ['mào'],
    decomposition: '⿰王冒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冒',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '瑄',
    definition: 'ornamental jade',
    pinyin: ['xuān'],
    decomposition: '⿰王宣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宣',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '瑋',
    definition: 'a type of red jade; rare, valuable',
    pinyin: ['wěi'],
    decomposition: '⿰王韋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韋',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '瑕',
    definition: 'fault, default; a flaw in a gem',
    pinyin: ['xiá'],
    decomposition: '⿰王叚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叚',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '瑗',
    definition: 'a large jade ring',
    pinyin: ['yuàn'],
    decomposition: '⿰王爰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爰',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '瑙',
    definition: 'agate, cornelian',
    pinyin: ['nǎo'],
    decomposition: '⿰王⿱巛囟',
    etymology: { type: 'pictophonetic', hint: 'jade', semantic: '王' },
    radical: '王',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '瑚',
    definition: 'coral',
    pinyin: ['hú'],
    decomposition: '⿰王胡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '胡',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '瑛',
    definition: "a gem's luster; crystal",
    pinyin: ['yīng'],
    decomposition: '⿰王英',
    etymology: {
      type: 'pictophonetic',
      phonetic: '英',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '瑜',
    definition: 'flawless gem or jewel',
    pinyin: ['yú'],
    decomposition: '⿰王俞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '俞',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '瑞',
    definition: 'auspicious; a good omen',
    pinyin: ['ruì'],
    decomposition: '⿰王耑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '耑',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '瑟',
    definition: 'a large string instrument; to tremble, to vibrate',
    pinyin: ['sè'],
    decomposition: '⿱玨必',
    etymology: {
      type: 'pictophonetic',
      phonetic: '必',
      semantic: '玨',
      hint: 'guitar strings',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '瑣',
    definition: 'petty; trifling; troublesome',
    pinyin: ['suǒ'],
    decomposition: '⿰王⿱⺌貝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '⺌',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '瑤',
    definition: 'precious jade',
    pinyin: ['yáo'],
    decomposition: '⿰王䍃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '䍃',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瑩',
    definition: 'bright, lustrous, sparkling like a gem',
    pinyin: ['yíng'],
    decomposition: '⿳炏冖玉',
    etymology: { type: 'ideographic', hint: 'Fiery 火 like a gem 玉' },
    radical: '玉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '瑪',
    definition: 'agate, cornelian',
    pinyin: ['mǎ'],
    decomposition: '⿰王馬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '馬',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瑭',
    definition: 'a kind of jade',
    pinyin: ['táng'],
    decomposition: '⿰王唐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '唐',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瑯',
    definition: 'pure, white; cornelian',
    pinyin: ['láng'],
    decomposition: '⿰王郎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '郎',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '瑰',
    definition: 'extraordinary, fabulous; rose; semi-precious stone',
    pinyin: ['guī'],
    decomposition: '⿰王鬼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鬼',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '瑱',
    definition: 'a jade earring',
    pinyin: ['zhèn'],
    decomposition: '⿰王真',
    etymology: {
      type: 'pictophonetic',
      phonetic: '真',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瑶',
    definition: 'precious jade',
    pinyin: ['yáo'],
    decomposition: '⿰王䍃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '䍃',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瑷',
    definition: 'fine jade',
    pinyin: ['ài'],
    decomposition: '⿰王爱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爱',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瑾',
    definition: 'the brilliance or luster of a gem',
    pinyin: ['jǐn'],
    decomposition: '⿰王堇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堇',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '璀',
    definition: 'brillance; luster; to shine',
    pinyin: ['cuǐ'],
    decomposition: '⿰王崔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '崔',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '璁',
    definition: 'turquoise',
    pinyin: ['cōng'],
    decomposition: '⿰王悤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '悤',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '璃',
    definition: 'glass; colored glaze',
    pinyin: ['lí'],
    decomposition: '⿰王离',
    etymology: {
      type: 'pictophonetic',
      phonetic: '离',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '璇',
    definition: 'beautiful jade; star',
    pinyin: ['xuán'],
    decomposition: '⿰王旋',
    etymology: {
      type: 'ideographic',
      hint: 'An orbiting 旋 gem 王; 旋 also provides the pronunciation',
    },
    radical: '王',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '璋',
    definition: 'jade plaything; jade ornament',
    pinyin: ['zhāng'],
    decomposition: '⿰王章',
    etymology: {
      type: 'pictophonetic',
      phonetic: '章',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '璎',
    definition: 'a necklace made of precious stones',
    pinyin: ['yīng'],
    decomposition: '⿰王婴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '婴',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '璐',
    definition: 'a beautiful variety of jade',
    pinyin: ['lù'],
    decomposition: '⿰王路',
    etymology: {
      type: 'pictophonetic',
      phonetic: '路',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '璚',
    definition: 'splendid; a jade ring',
    pinyin: ['qióng'],
    decomposition: '⿰王矞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '矞',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '璜',
    definition: 'a jade pendant',
    pinyin: ['huáng'],
    decomposition: '⿰王黄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '黄',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '璞',
    definition: 'unpolished gem',
    pinyin: ['pú'],
    decomposition: '⿰王菐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '菐',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '璣',
    definition: 'an oblong pearl',
    pinyin: ['jī'],
    decomposition: '⿰王幾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '幾',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '璦',
    definition: 'fine jade',
    pinyin: ['ài'],
    decomposition: '⿰王愛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '愛',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '璧',
    definition: 'a jade annulus',
    pinyin: ['bì'],
    decomposition: '⿱辟玉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辟',
      semantic: '玉',
      hint: 'jade',
    },
    radical: '玉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '璨',
    definition: 'gem; the luster of a gem',
    pinyin: ['càn'],
    decomposition: '⿰王粲',
    etymology: {
      type: 'ideographic',
      hint: 'The luster 粲 of a gem 王; 粲 also provides the pronunciation',
    },
    radical: '王',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '璩',
    definition: 'jade ring; jade earring; surname',
    pinyin: ['qú'],
    decomposition: '⿰王豦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豦',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '環',
    definition: 'bracelet, ring; to surround, to loop',
    pinyin: ['huán'],
    decomposition: '⿰王睘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '睘',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '璺',
    definition: 'a crack in porcelain',
    pinyin: ['wèn'],
    decomposition: '⿱？玉',
    etymology: { type: 'pictophonetic', semantic: '玉', hint: 'jade' },
    radical: '玉',
    matches: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '璽',
    definition: 'imperial signet, royal signet',
    pinyin: ['xǐ'],
    decomposition: '⿱爾玉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爾',
      semantic: '玉',
      hint: 'jade',
    },
    radical: '玉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瓅',
    definition: 'brilliant',
    pinyin: ['lì'],
    decomposition: '⿰王樂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '樂',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瓊',
    definition: 'jade; rare, precious; elegant',
    pinyin: ['qióng'],
    decomposition: '⿰王敻',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敻',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瓒',
    definition: 'ceremonial libation cup',
    pinyin: ['zàn'],
    decomposition: '⿰王赞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '赞',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瓔',
    definition: 'a necklace made of precious stones',
    pinyin: ['yīng'],
    decomposition: '⿰王嬰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '嬰',
      semantic: '王',
      hint: 'jade',
    },
    radical: '王',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瓜',
    definition: 'melon, gourd, squash, cucumber',
    pinyin: ['guā'],
    decomposition: '⿵？厶',
    etymology: {
      type: 'pictographic',
      hint: 'Vines growing with a melon at their base',
    },
    radical: '瓜',
    matches: [null, null, [1], [1], null],
  },
  {
    character: '瓞',
    definition: 'young melon',
    pinyin: ['dié'],
    decomposition: '⿺瓜失',
    etymology: {
      type: 'pictophonetic',
      phonetic: '失',
      semantic: '瓜',
      hint: 'melon',
    },
    radical: '瓜',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '瓠',
    definition: 'bottle gourd, calabash',
    pinyin: ['hù'],
    decomposition: '⿰夸瓜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夸',
      semantic: '瓜',
      hint: 'gourd',
    },
    radical: '瓜',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '瓢',
    definition: 'a ladle made from a dried gourd',
    pinyin: ['piáo'],
    decomposition: '⿰票瓜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '票',
      semantic: '瓜',
      hint: 'gourd',
    },
    radical: '瓜',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瓣',
    definition: 'petal; segment; valve',
    pinyin: ['bàn'],
    decomposition: '⿲辛瓜辛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '\n\n\n\n\n\n\n\n辡',
      semantic: '瓜',
      hint: 'melon',
    },
    radical: '瓜',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '瓤',
    definition: 'flesh, core, pith, pulp',
    pinyin: ['ráng'],
    decomposition: '⿰襄瓜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '襄',
      semantic: '瓜',
      hint: 'melon',
    },
    radical: '瓜',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瓦',
    definition: 'tile; pottery, earthenware',
    pinyin: ['wǎ'],
    decomposition: '？',
    etymology: { type: 'pictographic', hint: 'An interlocking roof tile' },
    radical: '瓦',
    matches: [null, null, null, null],
  },
  {
    character: '瓮',
    definition: 'urn, earthen jar',
    pinyin: ['wèng'],
    decomposition: '⿱公瓦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '公',
      semantic: '瓦',
      hint: 'pottery',
    },
    radical: '瓦',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '瓯',
    definition: 'bowl, cup; small tray',
    pinyin: ['ōu'],
    decomposition: '⿰区瓦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '区',
      semantic: '瓦',
      hint: 'pottery',
    },
    radical: '瓦',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '瓴',
    definition: 'Roman roof tiles; a long-necked jar',
    pinyin: ['líng'],
    decomposition: '⿰令瓦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '令',
      semantic: '瓦',
      hint: 'pottery',
    },
    radical: '瓦',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '瓶',
    definition: 'bottle, jug, pitcher, vase',
    pinyin: ['píng'],
    decomposition: '⿰并瓦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '并',
      semantic: '瓦',
      hint: 'pottery',
    },
    radical: '瓦',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '瓷',
    definition: 'china, crockery, porcelain',
    pinyin: ['cí'],
    decomposition: '⿱次瓦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '次',
      semantic: '瓦',
      hint: 'pottery',
    },
    radical: '瓦',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '瓿',
    definition: 'vase, pot, jar',
    pinyin: ['bù'],
    decomposition: '⿰咅瓦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咅',
      semantic: '瓦',
      hint: 'pottery',
    },
    radical: '瓦',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '甄',
    definition: 'to grade, to examine, to discern; surname',
    pinyin: ['zhēn'],
    decomposition: '⿰垔瓦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '垔',
      semantic: '瓦',
      hint: 'pottery',
    },
    radical: '瓦',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '甌',
    definition: 'bowl, cup; small tray',
    pinyin: ['ōu'],
    decomposition: '⿰區瓦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '區',
      semantic: '瓦',
      hint: 'pottery',
    },
    radical: '瓦',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '甍',
    definition: 'rafters supporting roof tiles',
    pinyin: ['méng'],
    decomposition: '⿱⿱艹罒⿱冖瓦',
    etymology: {
      type: 'ideographic',
      hint: 'Beams 罒 supporting roof 冖 tiles 瓦',
    },
    radical: '瓦',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '甏',
    definition: 'a squat jar for holding wine, sauces, etc',
    pinyin: ['bèng'],
    decomposition: '⿱彭瓦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彭',
      semantic: '瓦',
      hint: 'pottery',
    },
    radical: '瓦',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '甑',
    definition: 'a boiler for steaming rice',
    pinyin: ['zèng'],
    decomposition: '⿰曾瓦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曾',
      semantic: '瓦',
      hint: 'pottery',
    },
    radical: '瓦',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '甓',
    definition: 'bricks, glazed tiles',
    pinyin: ['pì'],
    decomposition: '⿱辟瓦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辟',
      semantic: '瓦',
      hint: 'pottery',
    },
    radical: '瓦',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '甕',
    definition: 'urn',
    pinyin: ['wèng'],
    decomposition: '⿱雍瓦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '雍',
      semantic: '瓦',
      hint: 'pottery',
    },
    radical: '瓦',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '甘',
    definition: 'sweet, tasty; willing',
    pinyin: ['gān'],
    decomposition: '⿵卄二',
    etymology: {
      type: 'ideographic',
      hint: 'Picture of a tongue with 一 marking the sweet spot',
    },
    radical: '甘',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '甙',
    definition: 'glucoside',
    pinyin: ['dài'],
    decomposition: '⿹弋甘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弋',
      semantic: '甘',
      hint: 'sweet',
    },
    radical: '弋',
    matches: [[0], [1], [1], [1], [1], [1], [0], [0]],
  },
  {
    character: '甚',
    definition: 'considerably; very, extremely; a great extent',
    pinyin: ['shén'],
    decomposition: '⿱甘匹',
    radical: '甘',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '甜',
    definition: 'sweet, sweetness',
    pinyin: ['tián'],
    decomposition: '⿰舌甘',
    etymology: {
      type: 'ideographic',
      hint: 'Something tasty 甘 to the tongue 舌',
    },
    radical: '甘',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '生',
    definition: 'life, lifetime; birth; growth',
    pinyin: ['shēng'],
    decomposition: '⿻一土',
    etymology: {
      type: 'ideographic',
      hint: ' A shoot 屮 growing in the soil 土',
    },
    radical: '生',
    matches: [null, [0], [1], [1], [1]],
  },
  {
    character: '產',
    definition: 'to give birth, to bring forth, to produce',
    pinyin: ['chǎn'],
    decomposition: '⿱文⿸厂生',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厂',
      semantic: '生',
      hint: 'birth',
    },
    radical: '生',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '産',
    definition: 'to give birth',
    pinyin: ['chǎn'],
    decomposition: '⿸产生',
    etymology: {
      type: 'pictophonetic',
      phonetic: '产',
      semantic: '生',
      hint: 'birth',
    },
    radical: '生',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '甤',
    definition: 'soft, delicate; overgrowth, drooping leaves',
    pinyin: ['ruí'],
    decomposition: '⿰豕生',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豕',
      semantic: '生',
      hint: 'growth',
    },
    radical: '生',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '甥',
    definition: "niece, nephew; sister's child",
    pinyin: ['shēng'],
    decomposition: '⿰生男',
    etymology: {
      type: 'pictophonetic',
      phonetic: '生',
      semantic: '男',
      hint: 'boy',
    },
    radical: '生',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '甦',
    definition: 'reborn; to resuscitate, to revive',
    pinyin: ['sū'],
    decomposition: '⿺更生',
    etymology: {
      type: 'ideographic',
      hint: 'To grant an additional 更 life 生',
    },
    radical: '生',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '用',
    definition: 'to use, to employ, to apply; use',
    pinyin: ['yòng'],
    decomposition: '⿵冂？',
    radical: '用',
    matches: [[0], [0], null, null, null],
  },
  {
    character: '甩',
    definition: 'to throw away, to fling, to discard',
    pinyin: ['shuǎi'],
    decomposition: '⿻月乚',
    etymology: { type: 'ideographic', hint: 'The opposite of "to use" 用' },
    radical: '用',
    matches: [[0], [0], [0], [0], [1]],
  },
  {
    character: '甪',
    definition: 'surname',
    pinyin: ['lù'],
    decomposition: '⿱丿用',
    radical: '用',
    matches: [[0], [1], [1], [1], [1], [1]],
  },
  {
    character: '甫',
    definition: 'to begin; man, father; great; a distance of ten li',
    pinyin: ['fǔ'],
    decomposition: '⿻十用',
    radical: '用',
    matches: [[0], [1], [1], [1], [1], [1], null],
  },
  {
    character: '甬',
    definition: 'path; river in Ningbo; Ningbo',
    pinyin: ['yǒng'],
    decomposition: '⿱？用',
    etymology: { type: 'pictophonetic', phonetic: '用' },
    radical: '用',
    matches: [null, null, [1], [1], [1], [1], [1]],
  },
  {
    character: '甭',
    definition: '"there is no need"',
    pinyin: ['béng'],
    decomposition: '⿱不用',
    etymology: {
      type: 'ideographic',
      hint: 'Not 不 needed 用; 用 also provides the pronunciation',
    },
    radical: '用',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '甯',
    definition: 'peaceful',
    pinyin: ['níng'],
    decomposition: '⿱宀⿱心用',
    etymology: {
      type: 'pictophonetic',
      phonetic: '用',
      semantic: '心',
      hint: 'heart',
    },
    radical: '用',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '田',
    definition: 'field, farm, arable land; cultivated',
    pinyin: ['tián'],
    decomposition: '⿵冂土',
    etymology: { type: 'pictographic', hint: 'The plots of a rice paddy' },
    radical: '田',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '由',
    definition: 'cause, reason; from',
    pinyin: ['yóu'],
    decomposition: '田',
    etymology: { type: 'ideographic', hint: 'Road 丨 leading to the farm 田' },
    radical: '田',
    matches: [[], [], [], [], []],
  },
  {
    character: '甲',
    definition: 'armor, shell; fingernails; 1st heavenly stem',
    pinyin: ['jiǎ'],
    decomposition: '⿻冂？',
    radical: '田',
    matches: [[0], [0], null, null, null],
  },
  {
    character: '申',
    definition: 'to report; to extend; to explain; to declare',
    pinyin: ['shēn'],
    decomposition: '⿻日丨',
    etymology: { type: 'pictographic', hint: 'A bolt of lightning' },
    radical: '田',
    matches: [[0], [0], [0], [0], [1]],
  },
  {
    character: '甴',
    definition: 'cockroach',
    pinyin: ['zhá'],
    decomposition: '⿻囗？',
    radical: '田',
    matches: [[0], [0], null, null, [0]],
  },
  {
    character: '电',
    definition: 'electricity; electric; lightning',
    pinyin: ['diàn'],
    decomposition: '⿻曰乚',
    etymology: {
      type: 'ideographic',
      hint: 'Simplified form of 電; lightning 申 from a storm cloud 雨',
    },
    radical: '曰',
    matches: [[0], [0], [0], [0], [1]],
  },
  {
    character: '男',
    definition: 'man, boy; male; baron; surname',
    pinyin: ['nán'],
    decomposition: '⿱田力',
    etymology: {
      type: 'ideographic',
      hint: 'Someone who can work 力 the farm 田',
    },
    radical: '田',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '甸',
    definition: 'suburbs of the capital; to govern; crops',
    pinyin: ['diān'],
    decomposition: '⿹勹田',
    etymology: {
      type: 'pictophonetic',
      phonetic: '田',
      semantic: '勹',
      hint: 'wrap',
    },
    radical: '田',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '甹',
    definition: 'chivalrous knight',
    pinyin: ['pīng'],
    decomposition: '⿱由丂',
    radical: '田',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '町',
    definition: 'a raised path between fields',
    pinyin: ['tīng'],
    decomposition: '⿰田丁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丁',
      semantic: '田',
      hint: 'field',
    },
    radical: '田',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '画',
    definition: 'picture, painting, drawing; to draw',
    pinyin: ['huà'],
    decomposition: '⿱一⿶凵田',
    etymology: {
      type: 'ideographic',
      hint: 'A painting on an easel; compare 畫, which includes the brush',
    },
    radical: '田',
    matches: [[0], [1, 1], [1, 1], [1, 1], [1, 1], [1, 1], [1, 0], [1, 0]],
  },
  {
    character: '甾',
    definition: 'evil; a calamity',
    pinyin: ['zāi'],
    decomposition: '⿱巛田',
    etymology: {
      type: 'ideographic',
      hint: 'A farm 田 wiped out by a flood 巛',
    },
    radical: '田',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '畀',
    definition: 'to give',
    pinyin: ['bì'],
    decomposition: '⿱田丌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丌',
      semantic: '田',
      hint: 'farm',
    },
    radical: '田',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '畅',
    definition: 'freely, smoothly; unrestrained',
    pinyin: ['chàng'],
    decomposition: '⿰申昜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昜',
      semantic: '申',
      hint: 'open',
    },
    radical: '日',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '畈',
    definition: 'field; farm',
    pinyin: ['fàn'],
    decomposition: '⿰田反',
    etymology: {
      type: 'pictophonetic',
      phonetic: '反',
      semantic: '田',
      hint: 'field',
    },
    radical: '田',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '畋',
    definition: 'to till, to cultivate; to hunt',
    pinyin: ['tián'],
    decomposition: '⿰田攵',
    etymology: {
      type: 'ideographic',
      hint: 'A man 攵 working on a farm 田; 田 also provides the pronunciation',
    },
    radical: '田',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '界',
    definition: 'boundary, limit; domain; society, the world',
    pinyin: ['jiè'],
    decomposition: '⿱田介',
    etymology: {
      type: 'pictophonetic',
      phonetic: '介',
      semantic: '田',
      hint: 'farm',
    },
    radical: '田',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '畎',
    definition: 'a drain between fields, irrigation; to flow',
    pinyin: ['quǎn'],
    decomposition: '⿰田犬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '犬',
      semantic: '田',
      hint: 'field',
    },
    radical: '田',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '畏',
    definition: 'fear, dread, awe, reverence',
    pinyin: ['wèi'],
    decomposition: '⿳田一？',
    etymology: { type: 'pictographic', hint: 'A monster with a scary head 田' },
    radical: '田',
    matches: [[0], [0], [0], [0], [0], [1], null, null, null],
  },
  {
    character: '畐',
    definition: 'to fill; a roll of cloth',
    pinyin: ['fú'],
    decomposition: '⿳一口田',
    radical: '田',
    matches: [[0], [1], [1], [1], [2], [2], [2], [2], [2]],
  },
  {
    character: '畑',
    definition: 'dry field (as opposed to a paddy); used in Japanese names',
    pinyin: ['tián'],
    decomposition: '⿰火田',
    etymology: {
      type: 'ideographic',
      hint: 'A dry 火 field 田; 田 also provides the pronunciation',
    },
    radical: '火',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '畔',
    definition: 'river bank; a boundary path that divides fields',
    pinyin: ['pàn'],
    decomposition: '⿰田半',
    etymology: {
      type: 'ideographic',
      hint: 'A farm 田 divided in half 半; 半 also provides the pronunciation',
    },
    radical: '田',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '留',
    definition:
      'to stay, to remain; to preserve, to keep; to leave a message; ',
    pinyin: ['liú'],
    decomposition: '⿱卯田',
    radical: '田',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '畚',
    definition: 'hamper, straw basket',
    pinyin: ['běn'],
    decomposition: '⿱⿱厶大田',
    radical: '田',
    matches: [[0, 0], [0, 0], [0, 1], [0, 1], [0, 1], [1], [1], [1], [1], [1]],
  },
  {
    character: '畛',
    definition: 'border, boundary; raised path',
    pinyin: ['zhěn'],
    decomposition: '⿰田㐱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㐱',
      semantic: '田',
      hint: 'field',
    },
    radical: '田',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '畜',
    definition: 'livestock, domestic animals',
    pinyin: ['chù'],
    decomposition: '⿱玄田',
    etymology: {
      type: 'pictophonetic',
      phonetic: '玄',
      semantic: '田',
      hint: 'farm',
    },
    radical: '田',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '畝',
    definition: 'fields; unit of area equal to 660 sq. m.',
    pinyin: ['mǔ'],
    decomposition: '⿰亩久',
    etymology: {
      type: 'ideographic',
      hint: 'A man 久 pacing out a plot of land 亩',
    },
    radical: '田',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '畟',
    definition: 'to plow',
    pinyin: ['cè'],
    decomposition: '⿱⿱田八夂',
    etymology: {
      type: 'ideographic',
      hint: 'A man 夂 making a furrow 八 in a field 田',
    },
    radical: '田',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '畢',
    definition: 'to finish, to conclude, to end; completed',
    pinyin: ['bì'],
    decomposition: '⿻⿱田卄十',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卄',
      semantic: '十',
      hint: 'complete',
    },
    radical: '田',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [1],
      [0, 1],
      [0, 1],
      [0, 1],
      null,
      [1],
    ],
  },
  {
    character: '略',
    definition: 'approximate, rough; outline, summary; plan, plot',
    pinyin: ['lüè'],
    decomposition: '⿰田各',
    etymology: {
      type: 'pictophonetic',
      phonetic: '各',
      semantic: '田',
      hint: 'farm',
    },
    radical: '田',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '畦',
    definition: 'sections in a vegetable farm',
    pinyin: ['qí'],
    decomposition: '⿰田圭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '圭',
      semantic: '田',
      hint: 'field',
    },
    radical: '田',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '畧',
    definition: 'approximately, roughly; outline',
    pinyin: ['lüè'],
    decomposition: '⿱田各',
    radical: '田',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '番',
    definition: 'to take turns, to repeat; to sow; a turn',
    pinyin: ['fān'],
    decomposition: '⿱⿱？米田',
    etymology: { type: 'ideographic', hint: 'Sowing seeds 米 on the farm 田' },
    radical: '田',
    matches: [
      null,
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '畫',
    definition: 'picture, painting, drawing; to draw',
    pinyin: ['huà'],
    decomposition: '⿱聿⿱田一',
    etymology: {
      type: 'ideographic',
      hint: 'To paint 聿 a canvas 田 on an easel 一',
    },
    radical: '田',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
    ],
  },
  {
    character: '畬',
    definition: 'a field reclaimed by burning the forest',
    pinyin: ['shē'],
    decomposition: '⿱余田',
    etymology: {
      type: 'ideographic',
      hint: 'An extra 余 field 田; 佘 provides the pronunciation; compare 畲',
    },
    radical: '田',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '異',
    definition: 'different, strange, unusual; foreign; surprising',
    pinyin: ['yì'],
    decomposition: '⿱田共',
    etymology: { type: 'pictographic', hint: 'A person with a scary face 田' },
    radical: '田',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '畲',
    definition: 'a field reclaimed by burning the forest',
    pinyin: ['shē'],
    decomposition: '⿱佘田',
    etymology: {
      type: 'ideographic',
      hint: 'An extra 余 field 田; 佘 provides the pronunciation; compare 畬',
    },
    radical: '田',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '畴',
    definition: 'field, farmland; class, category',
    pinyin: ['chóu'],
    decomposition: '⿰田寿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寿',
      semantic: '田',
      hint: 'farm',
    },
    radical: '田',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '當',
    definition: 'appropriate, timely; to act, to serve; the sound of bells',
    pinyin: ['dāng'],
    decomposition: '⿱尚田',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尚',
      semantic: '田',
      hint: 'field',
    },
    radical: '田',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '畸',
    definition: 'odd, unusual; fraction, remainder',
    pinyin: ['jī'],
    decomposition: '⿰田奇',
    etymology: {
      type: 'ideographic',
      hint: 'Leftover 奇 farmland 田; 奇 also provides the pronunciation',
    },
    radical: '田',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '畹',
    definition: 'a field of 20-30 mu',
    pinyin: ['wǎn'],
    decomposition: '⿰田宛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宛',
      semantic: '田',
      hint: 'field',
    },
    radical: '田',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '畺',
    definition: 'boundary, border',
    pinyin: ['jiāng'],
    decomposition: '⿳⿳一田一田一',
    etymology: {
      type: 'ideographic',
      hint: 'Lines 一 drawn between two plots of land 田',
    },
    radical: '田',
    matches: [
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 2],
      [1],
      [1],
      [1],
      [1],
      [1],
      [2],
    ],
  },
  {
    character: '畾',
    definition: 'fields divided by dikes',
    pinyin: ['léi'],
    decomposition: '⿱田⿰田田',
    etymology: {
      type: 'ideographic',
      hint: 'Three fields 田 divided by dikes',
    },
    radical: '田',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '畿',
    definition: 'imperial domain; area near the capital',
    pinyin: ['jī'],
    decomposition: '⿹⿱？戈田',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戈',
      semantic: '田',
      hint: 'land',
    },
    radical: '田',
    matches: [
      null,
      null,
      null,
      null,
      null,
      null,
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0, 1],
      [0, 1],
      [0, 1],
    ],
  },
  {
    character: '疃',
    definition: 'hamlet; area near a city',
    pinyin: ['tuǎn'],
    decomposition: '⿰田童',
    etymology: {
      type: 'pictophonetic',
      phonetic: '童',
      semantic: '田',
      hint: 'land',
    },
    radical: '田',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '疆',
    definition: 'boundary, border, frontier',
    pinyin: ['jiāng'],
    decomposition: '⿰⿹弓土畺',
    etymology: {
      type: 'ideographic',
      hint: 'A bow 弓 and arrow 土 used to defend a border 畺; 畺 also provides the pronunciation',
    },
    radical: '田',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '疇',
    definition: 'field, farmland; class, category',
    pinyin: ['chóu'],
    decomposition: '⿰田壽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '壽',
      semantic: '田',
      hint: 'farm',
    },
    radical: '田',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '疊',
    definition: 'pile; layer; to fold up; to repeat, to duplicate',
    pinyin: ['dié'],
    decomposition: '⿱畾冝',
    etymology: {
      type: 'ideographic',
      hint: 'Clothes 畾 stacked on top of a drawer 冝',
    },
    radical: '田',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '疋',
    definition: 'roll, bolt of cloth; foot',
    pinyin: ['pǐ'],
    decomposition: '？',
    etymology: { type: 'pictographic', hint: 'A foot 止 with a leg on top' },
    radical: '疋',
    matches: [null, null, null, null, null],
  },
  {
    character: '疌',
    definition: 'nimble, quick',
    pinyin: ['jié'],
    decomposition: '⿱彐疋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彐',
      semantic: '疋',
      hint: 'foot',
    },
    radical: '疋',
    matches: [[1], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '疏',
    definition: 'to neglect; to dredge, to clear away; lax, careless',
    pinyin: ['shū'],
    decomposition: '⿰疋㐬',
    etymology: {
      type: 'ideographic',
      hint: 'Walking 疋 through uncultivated land 㐬',
    },
    radical: '疋',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '疐',
    definition: 'to fall, to stumble, to falter; hindered',
    pinyin: ['zhì'],
    decomposition: '⿱⿱⿱十冖田疋',
    etymology: { type: 'ideographic', hint: 'A foot 疋 stuck in a field 田' },
    radical: '疋',
    matches: [
      [0, 0, 0],
      [0, 0, 0],
      [0, 0, 1],
      [0, 0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '疑',
    definition: 'to doubt, to question, to suspect',
    pinyin: ['yí'],
    decomposition: '⿰⿱匕矢⿱？疋',
    etymology: {
      type: 'ideographic',
      hint: 'An old man walking 疋 while holding 匕 a cane 矢',
    },
    radical: '疋',
    matches: [
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      null,
      null,
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '疒',
    definition: 'sickness, disease',
    pinyin: ['nè'],
    decomposition: '⿻广冫',
    radical: '疒',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '疔',
    definition: 'boil, carbuncle, ulcer',
    pinyin: ['dīng'],
    decomposition: '⿸疒丁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丁',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '疖',
    definition: 'boil, pimple, sore',
    pinyin: ['jiē'],
    decomposition: '⿸疒卩',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卩',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '疗',
    definition: 'cured, healed; to recover',
    pinyin: ['liáo'],
    decomposition: '⿸疒了',
    etymology: {
      type: 'ideographic',
      hint: 'To clear 了 an illness 疒; 了 also provides the pronunciation',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '疙',
    definition: 'pimple, sore; wart, pustule',
    pinyin: ['gē'],
    decomposition: '⿸疒乞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乞',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '疚',
    definition: 'chronic disease; guilt, remorse; sorrow',
    pinyin: ['jiù'],
    decomposition: '⿸疒久',
    etymology: {
      type: 'pictophonetic',
      phonetic: '久',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '疝',
    definition: 'hernia; to rupture',
    pinyin: ['shàn'],
    decomposition: '⿸疒山',
    etymology: {
      type: 'pictophonetic',
      phonetic: '山',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '疟',
    definition: 'malaria; intermittent fever',
    pinyin: ['nüè'],
    decomposition: '⿸疒？',
    etymology: { type: 'pictophonetic', semantic: '疒', hint: 'sickness' },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], null, null, null],
  },
  {
    character: '疠',
    definition: 'sore, ulcer; plague, pestilence',
    pinyin: ['lì'],
    decomposition: '⿸疒万',
    etymology: { type: 'ideographic', hint: 'Ten thousand 万 sick people 疒' },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '疡',
    definition: 'sore, ulcer; infection',
    pinyin: ['yáng'],
    decomposition: '⿸疒昜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昜',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '疣',
    definition: 'wart, tumor, papule, goiter',
    pinyin: ['yóu'],
    decomposition: '⿸疒尤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尤',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '疤',
    definition: 'scar, cicatrix; birthmark',
    pinyin: ['bā'],
    decomposition: '⿸疒巴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巴',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '疥',
    definition: 'scabies; to itch',
    pinyin: ['jiè'],
    decomposition: '⿸疒介',
    etymology: {
      type: 'pictophonetic',
      phonetic: '介',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '疫',
    definition: 'epidemic, plague, pestilence',
    pinyin: ['yì'],
    decomposition: '⿸疒殳',
    etymology: { type: 'pictophonetic', semantic: '疒', hint: 'sickness' },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '疬',
    definition: 'scrofulous swellings or lumps',
    pinyin: ['lì'],
    decomposition: '⿸疒历',
    etymology: {
      type: 'pictophonetic',
      phonetic: '历',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '疭',
    definition: 'clonic convulsions',
    pinyin: ['zòng'],
    decomposition: '⿸疒从',
    etymology: {
      type: 'pictophonetic',
      phonetic: '从',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '疮',
    definition: 'boil, tumor; wound, sore',
    pinyin: ['chuāng'],
    decomposition: '⿸疒仓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '仓',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '疯',
    definition: 'crazy, insane, mentally ill',
    pinyin: ['fēng'],
    decomposition: '⿸疒风',
    etymology: {
      type: 'pictophonetic',
      phonetic: '风',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '疰',
    pinyin: ['zhù'],
    decomposition: '⿸疒主',
    etymology: {
      type: 'pictophonetic',
      phonetic: '主',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '疱',
    definition: 'acne',
    pinyin: ['pào'],
    decomposition: '⿸疒包',
    etymology: {
      type: 'pictophonetic',
      phonetic: '包',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '疲',
    definition: 'weak, tired, exhausted',
    pinyin: ['pí'],
    decomposition: '⿸疒皮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皮',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '疳',
    definition: 'rickets, chickenpox; childhood disease',
    pinyin: ['gān'],
    decomposition: '⿸疒甘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甘',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '疴',
    definition: 'sickness, illness; pain',
    pinyin: ['kē'],
    decomposition: '⿸疒可',
    etymology: {
      type: 'pictophonetic',
      phonetic: '可',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '疵',
    definition: 'flaw, fault, defect; disease',
    pinyin: ['cī'],
    decomposition: '⿸疒此',
    etymology: {
      type: 'pictophonetic',
      phonetic: '此',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '疸',
    definition: 'jaundice; stomach disorder',
    pinyin: ['dǎn'],
    decomposition: '⿸疒旦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旦',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '疹',
    definition: 'rash, measles; fever',
    pinyin: ['zhěn'],
    decomposition: '⿸疒㐱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㐱',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '疼',
    definition: 'ache, pain; to love dearly',
    pinyin: ['téng'],
    decomposition: '⿸疒冬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冬',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '疽',
    definition: 'ulcer, carbuncle, abscess',
    pinyin: ['jū'],
    decomposition: '⿸疒且',
    etymology: {
      type: 'pictophonetic',
      phonetic: '且',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '疾',
    definition: 'sickness, illness, disease; to envy, to hate',
    pinyin: ['jí'],
    decomposition: '⿸疒矢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '矢',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '痂',
    definition: 'scab',
    pinyin: ['jiā'],
    decomposition: '⿸疒加',
    etymology: {
      type: 'pictophonetic',
      phonetic: '加',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '痃',
    definition: 'indigestion; buboes, lymphatic inflammation',
    pinyin: ['xuán'],
    decomposition: '⿸疒玄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '玄',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '痄',
    definition: 'scrofulous swellings or lumps',
    pinyin: ['zhà'],
    decomposition: '⿸疒乍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乍',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '病',
    definition: 'sickness, illness, disease',
    pinyin: ['bìng'],
    decomposition: '⿸疒丙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丙',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '症',
    definition: 'ailment, disease, illness',
    pinyin: ['zhèng'],
    decomposition: '⿸疒正',
    etymology: {
      type: 'pictophonetic',
      phonetic: '正',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '痈',
    definition: 'ulcer, sore, carbuncle, abcess',
    pinyin: ['yōng'],
    decomposition: '⿸疒用',
    etymology: {
      type: 'pictophonetic',
      phonetic: '用',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '痉',
    definition: 'convulsions, fits',
    pinyin: ['jìng'],
    decomposition: '⿸疒？',
    etymology: { type: 'pictophonetic', hint: 'sickness', semantic: '疒' },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], null, null, null, null, null],
  },
  {
    character: '痊',
    definition: 'cured, healed; to recover',
    pinyin: ['quán'],
    decomposition: '⿸疒全',
    etymology: {
      type: 'ideographic',
      hint: 'Made whole 全 after an illness 疒; 全 also provides the pronunciation',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '痍',
    definition: 'wound, sore, bruise',
    pinyin: ['yí'],
    decomposition: '⿸疒夷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夷',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '痒',
    definition: 'to itch; to tickle',
    pinyin: ['yǎng'],
    decomposition: '⿸疒羊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羊',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '痔',
    definition: 'piles, hemorrhoids',
    pinyin: ['zhì'],
    decomposition: '⿸疒寺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寺',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '痕',
    definition: 'scar, mark; vestige, trace',
    pinyin: ['hén'],
    decomposition: '⿸疒艮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '艮',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '痖',
    definition: 'dumb, mute',
    pinyin: ['yǎ'],
    decomposition: '⿸疒亚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亚',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '痘',
    definition: 'smallpox',
    pinyin: ['dòu'],
    decomposition: '⿸疒豆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豆',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '痙',
    definition: 'convulsions, fits',
    pinyin: ['jìng'],
    decomposition: '⿸疒巠',
    etymology: {
      type: 'pictophonetic',
      hint: 'sickness',
      semantic: '疒',
      phonetic: '巠',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '痛',
    definition: 'ache, pain; bitterness, sorrow; deeply, thoroughly',
    pinyin: ['tòng'],
    decomposition: '⿸疒甬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甬',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '痞',
    definition: 'dyspepsia; spleen infection',
    pinyin: ['pǐ'],
    decomposition: '⿸疒否',
    etymology: {
      type: 'pictophonetic',
      phonetic: '否',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '痢',
    definition: 'dysentery',
    pinyin: ['lì'],
    decomposition: '⿸疒利',
    etymology: {
      type: 'pictophonetic',
      phonetic: '利',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '痣',
    definition: 'spot, mole, birthmark',
    pinyin: ['zhì'],
    decomposition: '⿸疒志',
    etymology: {
      type: 'ideographic',
      hint: 'The mark 志 of an illness 疒; 志 also provides the pronunciation',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '痤',
    definition: 'a swelling of the lymph nodes',
    pinyin: ['cuó'],
    decomposition: '⿸疒坐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '坐',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '痦',
    definition: 'spot, mole, birthmark',
    pinyin: ['wù'],
    decomposition: '⿸疒吾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吾',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '痧',
    definition: 'cholera; colic',
    pinyin: ['shā'],
    decomposition: '⿸疒沙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '沙',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '痨',
    definition: 'tuberculosis',
    pinyin: ['láo'],
    decomposition: '⿸疒劳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '劳',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '痪',
    definition: 'numbness, paralysis',
    pinyin: ['huàn'],
    decomposition: '⿸疒奂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奂',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '痫',
    definition: 'epilepsy, convulsions',
    pinyin: ['xián'],
    decomposition: '⿸疒闲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '闲',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '痰',
    definition: 'mucus, phlegm, spit',
    pinyin: ['tán'],
    decomposition: '⿸疒炎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '炎',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '痱',
    definition: 'heat rash; prickly heat; ulcers',
    pinyin: ['fèi'],
    decomposition: '⿸疒非',
    etymology: {
      type: 'pictophonetic',
      phonetic: '非',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '痲',
    definition: 'pock-marked; measles; leprosy',
    pinyin: ['má'],
    decomposition: '⿸疒林',
    etymology: {
      type: 'pictophonetic',
      phonetic: '林',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '痴',
    definition: 'foolish, stupid, dumb, silly',
    pinyin: ['chī'],
    decomposition: '⿸疒知',
    etymology: {
      type: 'pictophonetic',
      phonetic: '知',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '痹',
    definition: 'numbess, paralysis',
    pinyin: ['bì'],
    decomposition: '⿸疒畀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畀',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '痺',
    definition: 'numbness, paralysis',
    pinyin: ['bì'],
    decomposition: '⿸疒卑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卑',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '痼',
    definition: 'chronic disease; long-term passion',
    pinyin: ['gù'],
    decomposition: '⿸疒固',
    etymology: {
      type: 'pictophonetic',
      phonetic: '固',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '痾',
    definition: 'sickness, illness; pain',
    pinyin: ['kē'],
    decomposition: '⿸疒阿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '阿',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '痿',
    definition: 'paralysis; impotence',
    pinyin: ['wěi'],
    decomposition: '⿸疒委',
    etymology: {
      type: 'pictophonetic',
      phonetic: '委',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '瘀',
    definition: 'hematoma, contusion',
    pinyin: ['yū'],
    decomposition: '⿸疒於',
    etymology: {
      type: 'pictophonetic',
      phonetic: '於',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '瘁',
    definition: 'tired, worn-out; sick; overworked',
    pinyin: ['cuì'],
    decomposition: '⿸疒卒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卒',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '瘃',
    definition: 'cold sores',
    pinyin: ['zhú'],
    decomposition: '⿸疒豖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豖',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '瘅',
    definition: 'bitter hatred; drought',
    pinyin: ['dān'],
    decomposition: '⿸疒单',
    etymology: {
      type: 'pictophonetic',
      phonetic: '单',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '瘊',
    definition: 'pimple, wart',
    pinyin: ['hóu'],
    decomposition: '⿸疒侯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '侯',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瘋',
    definition: 'crazy, insane, mentally ill',
    pinyin: ['fēng'],
    decomposition: '⿸疒風',
    etymology: {
      type: 'pictophonetic',
      phonetic: '風',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瘌',
    definition: 'scabies, itching, scald-head',
    pinyin: ['là'],
    decomposition: '⿸疒剌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '剌',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瘐',
    definition: 'cold, hungry; to mistreat a prisoner',
    pinyin: ['yǔ'],
    decomposition: '⿸疒臾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臾',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '瘓',
    definition: 'numbness, paralysis',
    pinyin: ['huàn'],
    decomposition: '⿸疒奐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奐',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瘕',
    definition: 'asthma; bowel disease',
    pinyin: ['jiǎ'],
    decomposition: '⿸疒叚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叚',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瘗',
    definition: 'to bury, to inter',
    pinyin: ['yì'],
    decomposition: '⿸疒⿱夹土',
    etymology: { type: 'pictophonetic', semantic: '土', hint: 'earth' },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '瘘',
    definition: 'fistula; goiter, sore, ulcer',
    pinyin: ['lòu'],
    decomposition: '⿸疒娄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '娄',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瘙',
    definition: 'scabies; to itch',
    pinyin: ['sào'],
    decomposition: '⿸疒蚤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蚤',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瘛',
    definition: 'clonic convulsions',
    pinyin: ['chì'],
    decomposition: '⿸疒恝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '恝',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瘜',
    definition: 'polypus',
    pinyin: ['xī'],
    decomposition: '⿸疒息',
    etymology: {
      type: 'pictophonetic',
      phonetic: '息',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瘟',
    definition: 'epidemic, plague, pestilence',
    pinyin: ['wēn'],
    decomposition: '⿸疒昷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昷',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瘠',
    definition: 'thin, emaciated; barren',
    pinyin: ['jí'],
    decomposition: '⿸疒脊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '脊',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瘡',
    definition: 'boil, tumor; wound, sore',
    pinyin: ['chuāng'],
    decomposition: '⿸疒倉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '倉',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瘢',
    definition: 'scar, mole',
    pinyin: ['bān'],
    decomposition: '⿸疒般',
    etymology: {
      type: 'pictophonetic',
      phonetic: '般',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瘤',
    definition: 'tumor, lump, goiter',
    pinyin: ['liú'],
    decomposition: '⿸疒留',
    etymology: {
      type: 'pictophonetic',
      phonetic: '留',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瘥',
    definition: 'to recover from disease; an epidemic',
    pinyin: ['chài'],
    decomposition: '⿸疒差',
    etymology: {
      type: 'pictophonetic',
      phonetic: '差',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瘦',
    definition: 'thin, lean, emaciated; meager',
    pinyin: ['shòu'],
    decomposition: '⿸疒叟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叟',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瘧',
    definition: 'malaria; intermittent fever',
    pinyin: ['nüè'],
    decomposition: '⿸疒虐',
    etymology: {
      type: 'pictophonetic',
      semantic: '疒',
      hint: 'sickness',
      phonetic: '虐',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瘩',
    definition: 'pimples',
    pinyin: ['da'],
    decomposition: '⿸疒荅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '荅',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瘪',
    definition: 'shriveled, dried up; vexed',
    pinyin: ['biě'],
    decomposition: '⿸疒⿱自仑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '自',
      hint: 'sickness',
      semantic: '疒',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '瘫',
    definition: 'paralysis, palsy, numbness',
    pinyin: ['tān'],
    decomposition: '⿸疒难',
    etymology: {
      type: 'pictophonetic',
      phonetic: '难',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瘭',
    definition: 'whitlow',
    pinyin: ['biāo'],
    decomposition: '⿸疒票',
    etymology: {
      type: 'pictophonetic',
      phonetic: '票',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瘰',
    definition: 'scrofula, swellings',
    pinyin: ['luǒ'],
    decomposition: '⿸疒累',
    etymology: {
      type: 'pictophonetic',
      phonetic: '累',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瘲',
    definition: 'clonic convulsions',
    pinyin: ['zòng'],
    decomposition: '⿸疒從',
    etymology: {
      type: 'pictophonetic',
      phonetic: '從',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瘳',
    definition: 'healed; reformed',
    pinyin: ['chōu'],
    decomposition: '⿸疒翏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '翏',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瘴',
    definition: 'malaria; miasma, pestilential vapor',
    pinyin: ['zhàng'],
    decomposition: '⿸疒章',
    etymology: {
      type: 'pictophonetic',
      phonetic: '章',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瘵',
    definition: 'a wasting disease',
    pinyin: ['zhài'],
    decomposition: '⿸疒祭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '祭',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瘸',
    definition: 'lameness; paralysis of the hands or legs',
    pinyin: ['qué'],
    decomposition: '⿸疒⿱加肉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '加',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '瘼',
    definition: 'sickness; distress',
    pinyin: ['mò'],
    decomposition: '⿸疒莫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '莫',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瘾',
    definition: 'rash; addiction, craving, habit',
    pinyin: ['yǐn'],
    decomposition: '⿸疒隐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隐',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瘿',
    definition: 'swelling, goiter',
    pinyin: ['yǐng'],
    decomposition: '⿸疒婴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '婴',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '癀',
    definition: 'jaundice',
    pinyin: ['huáng'],
    decomposition: '⿸疒黄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '黄',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '療',
    definition: 'cured, healed; to recover',
    pinyin: ['liáo'],
    decomposition: '⿸疒尞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尞',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '癃',
    definition: 'weakness, infirmity; urine retention',
    pinyin: ['lóng'],
    decomposition: '⿸疒隆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隆',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '癆',
    definition: 'tuberculosis',
    pinyin: ['láo'],
    decomposition: '⿸疒勞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '勞',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '癇',
    definition: 'epilepsy, convulsions',
    pinyin: ['xián'],
    decomposition: '⿸疒閒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '閒',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '癉',
    definition: 'bitter hatred; drought',
    pinyin: ['dān'],
    decomposition: '⿸疒單',
    etymology: {
      type: 'pictophonetic',
      phonetic: '單',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '癌',
    definition: 'cancer, carcinoma',
    pinyin: ['ái'],
    decomposition: '⿸疒嵒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '嵒',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '癍',
    definition: 'pockmarks on the skin',
    pinyin: ['bān'],
    decomposition: '⿸疒斑',
    etymology: {
      type: 'ideographic',
      hint: 'A sickness 疒 that causes freckling 斑; 斑 also provides the pronunciation',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '癒',
    definition: 'to recover, to get well',
    pinyin: ['yù'],
    decomposition: '⿸疒愈',
    etymology: {
      type: 'ideographic',
      hint: 'To recover 愈 from an illness 疒; 愈 also provides the pronunciation',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '癔',
    definition: 'hysteria',
    pinyin: ['yì'],
    decomposition: '⿸疒意',
    etymology: {
      type: 'pictophonetic',
      phonetic: '意',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '癖',
    definition: 'craving, addiction; habit, hobby; indigestion',
    pinyin: ['pǐ'],
    decomposition: '⿸疒辟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辟',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '癘',
    definition: 'sore, ulcer; plague, pestilence',
    pinyin: ['lì'],
    decomposition: '⿸疒萬',
    etymology: { type: 'ideographic', hint: 'Ten thousand 萬 sick people 疒' },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '癜',
    definition: 'erythema',
    pinyin: ['diàn'],
    decomposition: '⿸疒殿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '殿',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '癞',
    definition: 'leprosy; scabies, mange; shoddy',
    pinyin: ['lài'],
    decomposition: '⿸疒赖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '赖',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '癟',
    definition: 'shriveled, dried up; vexed',
    pinyin: ['biě'],
    decomposition: '⿸疒⿱自侖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '自',
      hint: 'sickness',
      semantic: '疒',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '癡',
    definition: 'silly, foolish, idiotic',
    pinyin: ['chī'],
    decomposition: '⿸疒疑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '疑',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '癢',
    definition: 'to itch; to tickle',
    pinyin: ['yǎng'],
    decomposition: '⿸疒養',
    etymology: {
      type: 'pictophonetic',
      phonetic: '養',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '癣',
    definition: 'ringworms',
    pinyin: ['xuǎn'],
    decomposition: '⿸疒鲜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鲜',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '癥',
    definition: 'ailment, disease, illness',
    pinyin: ['zhèng'],
    decomposition: '⿸疒徵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '徵',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '癧',
    definition: 'scrofulous swellings or lumps',
    pinyin: ['lì'],
    decomposition: '⿸疒歷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '歷',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '癩',
    definition: 'leprosy; scabies, mange; shoddy',
    pinyin: ['lài'],
    decomposition: '⿸疒賴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '賴',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '癫',
    definition: 'crazy, insane; madness, mania',
    pinyin: ['diān'],
    decomposition: '⿸疒颠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '颠',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '癬',
    definition: 'ringworms',
    pinyin: ['xuǎn'],
    decomposition: '⿸疒鮮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鮮',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '癮',
    definition: 'rash; addiction, craving, habit',
    pinyin: ['yǐn'],
    decomposition: '⿸疒隱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隱',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '癯',
    definition: 'sthin, emaciated; tired, worn',
    pinyin: ['qú'],
    decomposition: '⿸疒瞿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '瞿',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '癰',
    definition: 'ulcer, sore, carbuncle, abcess',
    pinyin: ['yōng'],
    decomposition: '⿸疒雝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '雝',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '癱',
    definition: 'paralysis, palsy, numbness',
    pinyin: ['tān'],
    decomposition: '⿸疒難',
    etymology: {
      type: 'pictophonetic',
      phonetic: '難',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '癲',
    definition: 'crazy, insane; madness, mania',
    pinyin: ['diān'],
    decomposition: '⿸疒顛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '顛',
      semantic: '疒',
      hint: 'sickness',
    },
    radical: '疒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '癶',
    definition: 'legs',
    pinyin: ['bō'],
    decomposition: '⿰？？',
    etymology: { type: 'pictographic', hint: 'Two feet' },
    radical: '癶',
    matches: [null, null, null, null, null],
  },
  {
    character: '癸',
    definition: '10th heavenly stem',
    pinyin: ['guǐ'],
    decomposition: '⿱癶天',
    radical: '癶',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '登',
    definition: 'to rise, to mount, to board, to climb',
    pinyin: ['dēng'],
    decomposition: '⿱癶豆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豆',
      semantic: '癶',
      hint: 'legs',
    },
    radical: '癶',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '發',
    definition: 'to issue, to dispatch, to send out; hair',
    pinyin: ['fā'],
    decomposition: '⿱癶⿰弓殳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '癶',
      semantic: '弓',
      hint: 'bow',
    },
    radical: '癶',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '白',
    definition: 'white; clear, pure, unblemished; bright',
    pinyin: ['bái'],
    decomposition: '⿻？日',
    etymology: {
      type: 'ideographic',
      hint: 'A burning candle; the rays of the sun',
    },
    radical: '白',
    matches: [null, [1], [1], [1], [1]],
  },
  {
    character: '百',
    definition: 'one hundred; numerous, many',
    pinyin: ['bǎi'],
    decomposition: '⿱一白',
    etymology: {
      type: 'pictophonetic',
      phonetic: '白',
      semantic: '一',
      hint: 'one',
    },
    radical: '白',
    matches: [[0], [1], [1], [1], [1], [1]],
  },
  {
    character: '皂',
    definition: 'soap; black; menial servant',
    pinyin: ['zào'],
    decomposition: '⿱白七',
    radical: '白',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '皃',
    definition: 'countenance, appearance',
    pinyin: ['mào'],
    decomposition: '⿱白儿',
    radical: '白',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '的',
    definition: 'aim, goal; of; possessive particle; -self suffix',
    pinyin: ['de'],
    decomposition: '⿰白勺',
    radical: '白',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '皅',
    definition: 'white flowers',
    pinyin: ['pā'],
    decomposition: '⿰白巴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巴',
      semantic: '白',
      hint: 'white',
    },
    radical: '白',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '皆',
    definition: 'all, every, everybody',
    pinyin: ['jiē'],
    decomposition: '⿱比白',
    radical: '白',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '皇',
    definition: 'royal, imperial; ruler, superior',
    pinyin: ['huáng'],
    decomposition: '⿱白王',
    etymology: {
      type: 'ideographic',
      hint: 'A crown 白 on the head of the emperor 王',
    },
    radical: '白',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '皈',
    definition: 'to follow, to comply with',
    pinyin: ['guī'],
    decomposition: '⿰白反',
    radical: '白',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '皋',
    definition: 'the high land along a river',
    pinyin: ['gāo'],
    decomposition: '⿱白夲',
    etymology: { type: 'pictophonetic', phonetic: '夲' },
    radical: '白',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '皎',
    definition: 'white; bright, brilliant; clear',
    pinyin: ['jiǎo'],
    decomposition: '⿰白交',
    etymology: {
      type: 'pictophonetic',
      phonetic: '交',
      semantic: '白',
      hint: 'white',
    },
    radical: '白',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '皑',
    definition: 'brilliant white; as white as snow',
    pinyin: ['ái'],
    decomposition: '⿰白岂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '岂',
      semantic: '白',
      hint: 'white',
    },
    radical: '白',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '皒',
    definition: 'white',
    pinyin: ['é'],
    decomposition: '⿰白我',
    etymology: {
      type: 'pictophonetic',
      phonetic: '我',
      semantic: '白',
      hint: 'white',
    },
    radical: '白',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '皓',
    definition: 'bright, luminous; clear; hoary',
    pinyin: ['hào'],
    decomposition: '⿰白告',
    etymology: {
      type: 'pictophonetic',
      phonetic: '告',
      semantic: '白',
      hint: 'white',
    },
    radical: '白',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '皕',
    definition: 'two hundred',
    pinyin: ['bì'],
    decomposition: '⿰百百',
    etymology: { type: 'ideographic', hint: 'Two hundreds 百' },
    radical: '白',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '皖',
    definition: 'Anhui province',
    pinyin: ['wǎn'],
    decomposition: '⿰白完',
    etymology: {
      type: 'pictophonetic',
      phonetic: '完',
      semantic: '白',
      hint: 'bright',
    },
    radical: '白',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '皙',
    definition: 'white; a kind of date',
    pinyin: ['xī'],
    decomposition: '⿱析白',
    etymology: {
      type: 'pictophonetic',
      phonetic: '析',
      semantic: '白',
      hint: 'white',
    },
    radical: '白',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '皚',
    definition: 'brilliant white; as white as snow',
    pinyin: ['ái'],
    decomposition: '⿰白豈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豈',
      semantic: '白',
      hint: 'white',
    },
    radical: '白',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '皤',
    definition: 'white, grey; corpulent',
    pinyin: ['pó'],
    decomposition: '⿰白番',
    etymology: {
      type: 'pictophonetic',
      phonetic: '番',
      semantic: '白',
      hint: 'white',
    },
    radical: '白',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '皦',
    definition: 'white; bright, brilliant; clear',
    pinyin: ['jiǎo'],
    decomposition: '⿰白敫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敫',
      semantic: '白',
      hint: 'white',
    },
    radical: '白',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '皮',
    definition: 'skin, hide, fur, feathers',
    pinyin: ['pí'],
    decomposition: '⿸？攴',
    etymology: {
      type: 'pictographic',
      hint: 'A hand using a tool 攴 to strip the hide from a carcass',
    },
    radical: '皮',
    matches: [null, null, [1], [1], [1]],
  },
  {
    character: '皰',
    definition: 'acne',
    pinyin: ['pào'],
    decomposition: '⿰皮包',
    etymology: {
      type: 'pictophonetic',
      phonetic: '包',
      semantic: '皮',
      hint: 'skin',
    },
    radical: '皮',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '皱',
    definition: 'wrinkles, creases, folds',
    pinyin: ['zhòu'],
    decomposition: '⿰刍皮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '刍',
      semantic: '皮',
      hint: 'skin',
    },
    radical: '皮',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '皲',
    definition: 'chapped, cracked',
    pinyin: ['jūn'],
    decomposition: '⿰军皮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '军',
      semantic: '皮',
      hint: 'hide',
    },
    radical: '皮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '皴',
    definition: 'chapped, cracked',
    pinyin: ['cūn'],
    decomposition: '⿰夋皮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夋',
      semantic: '皮',
      hint: 'hide',
    },
    radical: '皮',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '皺',
    definition: 'wrinkles, creases, folds',
    pinyin: ['zhòu'],
    decomposition: '⿰芻皮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '芻',
      semantic: '皮',
      hint: 'skin',
    },
    radical: '皮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '皻',
    definition: 'pimples, blotches',
    pinyin: ['zhā'],
    decomposition: '⿰虘皮',
    etymology: {
      type: 'ideographic',
      hint: 'Spots 虘 on the skin 皮; 虘 also provides the pronunciation',
    },
    radical: '皮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '皿',
    definition: 'dish, vessel; shallow container',
    pinyin: ['mǐn'],
    decomposition: '⿱？一',
    radical: '皿',
    matches: [null, null, null, null, [1]],
  },
  {
    character: '盂',
    definition: 'basin; cup',
    pinyin: ['yú'],
    decomposition: '⿱于皿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '于',
      semantic: '皿',
      hint: 'dish',
    },
    radical: '皿',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '盃',
    definition: 'glass, cup',
    pinyin: ['bēi'],
    decomposition: '⿱不皿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '不',
      semantic: '皿',
      hint: 'dish',
    },
    radical: '皿',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '盅',
    definition: 'small cup or bowl',
    pinyin: ['zhōng'],
    decomposition: '⿱中皿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '中',
      semantic: '皿',
      hint: 'dish',
    },
    radical: '皿',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '盆',
    definition: 'basin, bowl, pot, tub',
    pinyin: ['pén'],
    decomposition: '⿱分皿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '分',
      semantic: '皿',
      hint: 'dish',
    },
    radical: '皿',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '盈',
    definition: 'full, overflowing; surplus; to fill',
    pinyin: ['yíng'],
    decomposition: '⿱夃皿',
    etymology: { type: 'pictophonetic', semantic: '皿', hint: 'dish' },
    radical: '皿',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '益',
    definition: 'to profit, to benefit; advantage',
    pinyin: ['yì'],
    decomposition: '⿱水皿',
    etymology: {
      type: 'ideographic',
      hint: 'A container 皿 overflowing with water 水',
    },
    radical: '皿',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '盍',
    definition: 'what? why not?',
    pinyin: ['hé'],
    decomposition: '⿱去皿',
    radical: '皿',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '盎',
    definition: 'pot, cup, bowl; abundant',
    pinyin: ['àng'],
    decomposition: '⿱央皿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '央',
      semantic: '皿',
      hint: 'dish',
    },
    radical: '皿',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '盏',
    definition: 'small cup or container',
    pinyin: ['zhǎn'],
    decomposition: '⿱戋皿',
    etymology: {
      type: 'ideographic',
      hint: 'A small 戋 dish 皿; 戋 also provides the pronunciation',
    },
    radical: '皿',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '盐',
    definition: 'salt',
    pinyin: ['yán'],
    decomposition: '⿱圤皿',
    radical: '皿',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '监',
    definition: 'to supervise, to direct, to control; to inspect; prison, jail',
    pinyin: ['jiān'],
    decomposition: '⿱？皿',
    radical: '皿',
    matches: [null, null, null, null, null, [1], [1], [1], [1], [1]],
  },
  {
    character: '盒',
    definition: 'small box or case; casket',
    pinyin: ['hé'],
    decomposition: '⿱合皿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '合',
      semantic: '皿',
      hint: 'container',
    },
    radical: '皿',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '盔',
    definition: 'helmet; bowl, basin',
    pinyin: ['kuī'],
    decomposition: '⿱灰皿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '灰',
      semantic: '皿',
      hint: 'dish',
    },
    radical: '皿',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '盖',
    definition: 'to cover, to hide, to protect',
    pinyin: ['gài'],
    decomposition: '⿱羊皿',
    etymology: { type: 'ideographic', hint: 'A dish 皿 with a lid 羊' },
    radical: '皿',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '盗',
    definition: 'to rob, to steal; thief, bandit',
    pinyin: ['dào'],
    decomposition: '⿱次皿',
    radical: '皿',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '盘',
    definition: 'tray, plate, dish; to examine',
    pinyin: ['pán'],
    decomposition: '⿱舟皿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '般',
      semantic: '皿',
      hint: 'dish',
    },
    radical: '皿',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '盛',
    definition: 'abundant, flourishing; to contain; to fill',
    pinyin: ['shèng'],
    decomposition: '⿱成皿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '成',
      semantic: '皿',
      hint: 'dish',
    },
    radical: '皿',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '盜',
    definition: 'to rob, to steal; thief, bandit',
    pinyin: ['dào'],
    decomposition: '⿱⿰氵欠皿',
    radical: '皿',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '盞',
    definition: 'small cup or container',
    pinyin: ['zhǎn'],
    decomposition: '⿱戔皿',
    etymology: {
      type: 'ideographic',
      hint: 'A small 戔 dish 皿; 戔 also provides the pronunciation',
    },
    radical: '皿',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '盟',
    definition: 'alliance, covenant; oath; to swear',
    pinyin: ['méng'],
    decomposition: '⿱明皿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '明',
      semantic: '皿',
      hint: 'offering dish',
    },
    radical: '皿',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '盡',
    definition: 'to exhaust, to use up, to deplete',
    pinyin: ['jǐn'],
    decomposition: '⿱⿱聿灬皿',
    etymology: {
      type: 'ideographic',
      hint: 'A brush 聿 using the last drops 灬 of ink 皿',
    },
    radical: '皿',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '監',
    definition: 'to supervise, to direct, to control; to inspect; prison, jail',
    pinyin: ['jiān'],
    decomposition: '⿱⿰臣？皿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皿',
      semantic: '臣',
      hint: 'minister',
    },
    radical: '皿',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      null,
      null,
      null,
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '盤',
    definition: 'tray, plate, dish; to examine',
    pinyin: ['pán'],
    decomposition: '⿱般皿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '般',
      semantic: '皿',
      hint: 'dish',
    },
    radical: '皿',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '盥',
    definition: 'to wash',
    pinyin: ['guàn'],
    decomposition: '⿱⿲？水彐皿',
    etymology: {
      type: 'ideographic',
      hint: "Washing 水 one's hands 彐 in a basin 皿",
    },
    radical: '皿',
    matches: [
      null,
      null,
      null,
      null,
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 2],
      [0, 2],
      [0, 2],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '盧',
    definition: 'cottage, hut; black; surname',
    pinyin: ['lú'],
    decomposition: '⿸虍⿱田皿',
    etymology: { type: 'pictophonetic', phonetic: '虍' },
    radical: '皿',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '盪',
    definition: 'pond, pool; ripple, shake; to wash away, to wipe out',
    pinyin: ['dàng'],
    decomposition: '⿱湯皿',
    etymology: {
      type: 'ideographic',
      hint: 'Hot soup 湯 in a bowl 皿; 湯 also provides the pronunciation',
    },
    radical: '皿',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '目',
    definition: 'eye; to look, to see; division, topic',
    pinyin: ['mù'],
    decomposition: '⿴口二',
    etymology: { type: 'pictographic', hint: 'An eye drawn on its side' },
    radical: '目',
    matches: [[0], [0], [1], [1], [0]],
  },
  {
    character: '盯',
    definition: "to rivet one's gaze upon; to keep eyes on",
    pinyin: ['dīng'],
    decomposition: '⿰目丁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丁',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '盱',
    definition: 'eyes wide open; to gaze in astonishment',
    pinyin: ['xū'],
    decomposition: '⿰目于',
    etymology: {
      type: 'pictophonetic',
      phonetic: '于',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '盲',
    definition: 'blind; shortsighted; unperceptive',
    pinyin: ['máng'],
    decomposition: '⿱亡目',
    etymology: {
      type: 'ideographic',
      hint: "Losing 亡 one's sight 目; 亡 also provides the pronunciation",
    },
    radical: '目',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '直',
    definition: 'straight, vertical; candid, direct, frank',
    pinyin: ['zhí'],
    decomposition: '⿳十目一',
    etymology: { type: 'ideographic', hint: 'To look someone in the eye 目' },
    radical: '目',
    matches: [[0], [0], [1], [1], [1], [1], [1], [2]],
  },
  {
    character: '相',
    definition: 'mutual, reciprocal; equal; each other',
    pinyin: ['xiāng'],
    decomposition: '⿰木目',
    etymology: {
      type: 'ideographic',
      hint: 'To stare 目 at a tree 木, meaning to observe',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '盹',
    definition: 'to doze, to nap, to nod off',
    pinyin: ['dǔn'],
    decomposition: '⿰目屯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屯',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '盼',
    definition: 'to look, to gaze; to expect, to hope for',
    pinyin: ['pàn'],
    decomposition: '⿰目分',
    etymology: {
      type: 'pictophonetic',
      phonetic: '分',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '盾',
    definition: 'shield; Dutch guilder',
    pinyin: ['dùn'],
    decomposition: '⿸厂⿱十目',
    etymology: {
      type: 'ideographic',
      hint: 'An eye 目 peering from behind a shield 厂',
    },
    radical: '目',
    matches: [[0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '省',
    definition: 'province; frugal; to save, to leave out',
    pinyin: ['shěng'],
    decomposition: '⿱少目',
    etymology: {
      type: 'pictophonetic',
      phonetic: '少',
      semantic: '目',
      hint: 'division',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '眄',
    definition: 'to ogle, to squint at, to look askance',
    pinyin: ['miǎn'],
    decomposition: '⿰目丏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丏',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '眇',
    definition: 'blind in one eye; subtle, minute, minuscule',
    pinyin: ['miǎo'],
    decomposition: '⿰目少',
    etymology: {
      type: 'ideographic',
      hint: 'Too small 少 to be seen by the naked eye 目',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '眈',
    definition: 'to stare at, to gaze intently; to delay, to hinder',
    pinyin: ['dān'],
    decomposition: '⿰目冘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冘',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '眉',
    definition: 'eyebrows; upper margin of book',
    pinyin: ['méi'],
    decomposition: '⿸尸目',
    etymology: {
      type: 'ideographic',
      hint: 'Picture of hair 尸 above an eye 目',
    },
    radical: '目',
    matches: [[0], null, [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '看',
    definition: 'to look, to see; to examine, to scrutinize',
    pinyin: ['kàn'],
    decomposition: '⿱手目',
    etymology: {
      type: 'ideographic',
      hint: "Shielding one's eyes 目 with a hand 手 to look to the distance",
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '県',
    definition: 'county, district, subdivision',
    pinyin: ['xiàn'],
    decomposition: '⿱⿺目？小',
    etymology: {
      type: 'pictophonetic',
      phonetic: '小',
      semantic: '目',
      hint: 'head',
    },
    radical: '目',
    matches: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], null, [1], [1], [1]],
  },
  {
    character: '眍',
    definition: 'sunken eyes',
    pinyin: ['kōu'],
    decomposition: '⿰目区',
    etymology: {
      type: 'pictophonetic',
      phonetic: '区',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '眔',
    definition: 'to glance; to wink',
    pinyin: ['dà'],
    decomposition: '⿱目？',
    etymology: { type: 'pictophonetic', semantic: '目', hint: 'eye' },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], null, null, null, null, null],
  },
  {
    character: '眙',
    definition: 'to gaze at; a place name',
    pinyin: ['yí'],
    decomposition: '⿰目台',
    etymology: {
      type: 'pictophonetic',
      phonetic: '台',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '眚',
    definition: 'cataract; fault, error, crime',
    pinyin: ['shěng'],
    decomposition: '⿱生目',
    etymology: {
      type: 'pictophonetic',
      phonetic: '生',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '真',
    definition: 'real, actual, true, genuine',
    pinyin: ['zhēn'],
    decomposition: '⿱直几',
    etymology: {
      type: 'ideographic',
      hint: 'A straight 直 (that is, level) table 几',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '眠',
    definition: 'sleep, shut-eye, hibernatation',
    pinyin: ['mián'],
    decomposition: '⿰目民',
    etymology: {
      type: 'pictophonetic',
      phonetic: '民',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '眢',
    definition: 'dull, parched, or inflamed eyes',
    pinyin: ['yuān'],
    decomposition: '⿱夗目',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夗',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '眥',
    definition: 'eye socket; the corner of the eye',
    pinyin: ['zì'],
    decomposition: '⿱此目',
    etymology: {
      type: 'pictophonetic',
      phonetic: '此',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '眦',
    definition: 'eye socket; the corner of the eye',
    pinyin: ['zì'],
    decomposition: '⿰目此',
    etymology: {
      type: 'pictophonetic',
      phonetic: '此',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '眨',
    definition: 'to wink',
    pinyin: ['zhǎ'],
    decomposition: '⿰目乏',
    etymology: {
      type: 'ideographic',
      hint: 'Two eyes, one open 目 and one shut 乏',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '眩',
    definition: 'to confuse; dazed, disoriented',
    pinyin: ['xuàn'],
    decomposition: '⿰目玄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '玄',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '眬',
    definition: 'faint, fuzzy, blurry',
    pinyin: ['lóng'],
    decomposition: '⿰目龙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龙',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '眭',
    definition: 'a piercing gaze; the evil eye',
    pinyin: ['suī'],
    decomposition: '⿰目圭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '圭',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '眯',
    definition: 'to squint, to narrow the eyes; blindness',
    pinyin: ['mī'],
    decomposition: '⿰目米',
    etymology: {
      type: 'pictophonetic',
      phonetic: '米',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '眳',
    definition: 'eye ridge',
    pinyin: ['míng'],
    decomposition: '⿰目名',
    etymology: {
      type: 'pictophonetic',
      phonetic: '名',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '眵',
    definition: 'rheum from the eyes',
    pinyin: ['chī'],
    decomposition: '⿰目多',
    etymology: {
      type: 'pictophonetic',
      phonetic: '多',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '眶',
    definition: 'eye socket; the corner of the eye',
    pinyin: ['kuàng'],
    decomposition: '⿰目匡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匡',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '眷',
    definition: 'to take an interest in; to care for',
    pinyin: ['juàn'],
    decomposition: '⿱龹目',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龹',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '眸',
    definition: 'eye; pupil',
    pinyin: ['móu'],
    decomposition: '⿰目牟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '牟',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '眺',
    definition: 'to gaze, to look at; to scan, to survey',
    pinyin: ['tiào'],
    decomposition: '⿰目兆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兆',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '眼',
    definition: 'eyelet, hole, opening',
    pinyin: ['yǎn'],
    decomposition: '⿰目艮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '艮',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '眽',
    definition: 'to gaze; to look at, to ogle',
    pinyin: ['mò'],
    decomposition: '⿰目？',
    etymology: { type: 'pictophonetic', semantic: '目', hint: 'eye' },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], null, null, null, null, null, null],
  },
  {
    character: '眾',
    definition: 'multitude, crowd; masses, public',
    pinyin: ['zhòng'],
    decomposition: '⿱罒众',
    etymology: {
      type: 'pictophonetic',
      phonetic: '罒',
      semantic: '众',
      hint: 'crowd',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '着',
    definition: 'to make a move, to take action',
    pinyin: ['zhe'],
    decomposition: '⿸羊目',
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '睁',
    definition: "to open one's eyes; to stare",
    pinyin: ['zhēng'],
    decomposition: '⿰目争',
    etymology: {
      type: 'pictophonetic',
      phonetic: '争',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '睃',
    definition: 'to squint at',
    pinyin: ['suō'],
    decomposition: '⿰目夋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夋',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '睇',
    definition: 'to glance, to look, to stare',
    pinyin: ['dì'],
    decomposition: '⿰目弟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弟',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '睐',
    definition: 'to squint at; a sidelong glance',
    pinyin: ['lài'],
    decomposition: '⿰目来',
    etymology: {
      type: 'pictophonetic',
      phonetic: '来',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '睑',
    definition: 'eyelid',
    pinyin: ['jiǎn'],
    decomposition: '⿰目佥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '佥',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '睘',
    definition: 'round; to stare',
    pinyin: ['qióng'],
    decomposition: '⿳罒一？',
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    ],
  },
  {
    character: '睚',
    definition: 'to stare',
    pinyin: ['yá'],
    decomposition: '⿰目厓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厓',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '睛',
    definition: 'eyeball; pupil',
    pinyin: ['jīng'],
    decomposition: '⿰目青',
    etymology: {
      type: 'pictophonetic',
      phonetic: '青',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '睜',
    definition: "to open one's eyes; to stare",
    pinyin: ['zhēng'],
    decomposition: '⿰目爭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爭',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '睡',
    definition: 'to sleep, to doze',
    pinyin: ['shuì'],
    decomposition: '⿰目垂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '垂',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '睢',
    definition: 'to gaze at, to stare at; uninhibited',
    pinyin: ['suī'],
    decomposition: '⿰目隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隹',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '督',
    definition: 'to supervise, to oversee, to direct',
    pinyin: ['dū'],
    decomposition: '⿱叔目',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叔',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '睥',
    definition: 'to glare at; to look askance',
    pinyin: ['pì'],
    decomposition: '⿰目卑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卑',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '睦',
    definition: 'amiable, friendly, peaceful',
    pinyin: ['mù'],
    decomposition: '⿰目坴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '坴',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '睨',
    definition: 'to glare at, to look askance, to squint',
    pinyin: ['nì'],
    decomposition: '⿰目兒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兒',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '睪',
    definition: 'to spy on',
    pinyin: ['yì'],
    decomposition: '⿱罒幸',
    etymology: { type: 'ideographic', hint: 'An eye 目 on top of a tower 幸' },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '睫',
    definition: 'eyelashes',
    pinyin: ['jié'],
    decomposition: '⿰目疌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '疌',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '睬',
    definition: 'to notice, to pay attention to',
    pinyin: ['cǎi'],
    decomposition: '⿰目采',
    etymology: {
      type: 'pictophonetic',
      phonetic: '采',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '睹',
    definition: 'to look at, to gaze at; to observe',
    pinyin: ['dǔ'],
    decomposition: '⿰目者',
    etymology: {
      type: 'pictophonetic',
      phonetic: '者',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '睽',
    definition: 'to stare',
    pinyin: ['kuí'],
    decomposition: '⿰目癸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '癸',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '睾',
    definition: 'testicle',
    pinyin: ['gāo'],
    decomposition: '⿱血幸',
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '睿',
    definition: 'keen, clever, astute',
    pinyin: ['ruì'],
    decomposition: '⿱⿳⺊冖一⿳八人目',
    radical: '目',
    matches: [
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 2],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 2],
      [1, 2],
      [1, 2],
      [1, 2],
      [1, 2],
    ],
  },
  {
    character: '瞀',
    definition: 'to take a close look; nearsighted, dim',
    pinyin: ['mào'],
    decomposition: '⿱敄目',
    etymology: {
      type: 'ideographic',
      hint: 'To make an effort 敄 to see 目 something',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瞄',
    definition: 'to take aim at; to look at',
    pinyin: ['miáo'],
    decomposition: '⿰目苗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '苗',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '瞅',
    definition: 'to see, to look at, to gaze at',
    pinyin: ['chǒu'],
    decomposition: '⿰目秋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '秋',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瞇',
    definition: 'to squint, to narrow the eyes',
    pinyin: ['mī'],
    decomposition: '⿰目迷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '迷',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瞈',
    definition: 'blurred vision',
    pinyin: ['wěng'],
    decomposition: '⿰目翁',
    etymology: {
      type: 'ideographic',
      hint: "An old man's 翁 eyes 目; 翁 also provides the pronunciation",
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瞋',
    definition: 'to glare',
    pinyin: ['chēn'],
    decomposition: '⿰目真',
    etymology: {
      type: 'pictophonetic',
      phonetic: '真',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瞌',
    definition: 'sleepy; to doze off',
    pinyin: ['kē'],
    decomposition: '⿰目盍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '盍',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瞍',
    definition: 'blind',
    pinyin: ['sǒu'],
    decomposition: '⿰目叟',
    etymology: {
      type: 'ideographic',
      hint: "An old man's 叟 eyes 目; 叟 also provides the pronunciation",
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瞎',
    definition: 'blind, reckless; rash',
    pinyin: ['xiā'],
    decomposition: '⿰目害',
    etymology: {
      type: 'ideographic',
      hint: "To damage 害 one's eyes 目; 害 also provides the pronunciation",
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瞑',
    definition: "to close one's eyes",
    pinyin: ['míng'],
    decomposition: '⿰目冥',
    etymology: {
      type: 'ideographic',
      hint: "One's eyes 目at night 冥; 冥 also provides the pronunciation",
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瞒',
    definition: 'to deceive, to lie; to regard with suspicion',
    pinyin: ['mán'],
    decomposition: '⿰目⿱艹两',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㒼',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '瞓',
    definition: 'to sleep',
    pinyin: ['shuì'],
    decomposition: '⿰目訓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '訓',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瞘',
    definition: 'sunken eyes',
    pinyin: ['kōu'],
    decomposition: '⿰目區',
    etymology: {
      type: 'pictophonetic',
      phonetic: '區',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瞜',
    definition: 'to see; to look at; to observe',
    pinyin: ['lōu'],
    decomposition: '⿰目婁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '婁',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瞞',
    definition: 'to deceive, to lie; to regard with suspicion',
    pinyin: ['mán'],
    decomposition: '⿰目㒼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㒼',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瞟',
    definition: 'to squint, to glare, to look askance',
    pinyin: ['piǎo'],
    decomposition: '⿰目票',
    etymology: {
      type: 'pictophonetic',
      phonetic: '票',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瞠',
    definition: 'to gaze, to look, to stare',
    pinyin: ['chēng'],
    decomposition: '⿰目堂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堂',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瞢',
    definition: "to hide one's eyes; to feel ashamed",
    pinyin: ['méng'],
    decomposition: '⿱⿳艹罒冖目',
    etymology: {
      type: 'ideographic',
      hint: "To cover 冖 one's eyes 目; 罒 provides the pronunciation",
    },
    radical: '目',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 2],
      [0, 2],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瞥',
    definition: 'to take a fleeting glance at',
    pinyin: ['piē'],
    decomposition: '⿱敝目',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敝',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瞧',
    definition: 'to glance at, to look at, to see',
    pinyin: ['qiáo'],
    decomposition: '⿰目焦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '焦',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瞩',
    definition: 'to focus on, to stare at, to watch carefully',
    pinyin: ['zhǔ'],
    decomposition: '⿰目属',
    etymology: {
      type: 'pictophonetic',
      phonetic: '属',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瞪',
    definition: 'to stare at',
    pinyin: ['dèng'],
    decomposition: '⿰目登',
    etymology: {
      type: 'pictophonetic',
      phonetic: '登',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瞬',
    definition: 'to wink, to blink; an instant, the blink of an eye',
    pinyin: ['shùn'],
    decomposition: '⿰目舜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '舜',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瞭',
    definition: 'bright; clear-sighted; to understand',
    pinyin: ['liǎo'],
    decomposition: '⿰目尞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尞',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瞰',
    definition: 'to watch, to spy on; to overlook, to look down on',
    pinyin: ['kàn'],
    decomposition: '⿰目敢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敢',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瞳',
    definition: 'the pupil of the eye',
    pinyin: ['tóng'],
    decomposition: '⿰目童',
    etymology: {
      type: 'pictophonetic',
      phonetic: '童',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瞵',
    definition: 'to stare at',
    pinyin: ['lín'],
    decomposition: '⿰目粦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '粦',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瞻',
    definition: 'to look; to look out for; to respect',
    pinyin: ['zhān'],
    decomposition: '⿰目詹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '詹',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瞼',
    definition: 'eyelid',
    pinyin: ['jiǎn'],
    decomposition: '⿰目僉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '僉',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瞽',
    definition: 'blind, stupid; a blind musician',
    pinyin: ['gǔ'],
    decomposition: '⿱鼓目',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鼓',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '瞿',
    definition: 'startled; surname',
    pinyin: ['jù'],
    decomposition: '⿱⿰目目隹',
    etymology: { type: 'ideographic', hint: 'A bird 隹 with two wide eyes 目' },
    radical: '目',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '矇',
    definition: 'stupid, ignorant; blind',
    pinyin: ['méng'],
    decomposition: '⿰目蒙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蒙',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '矍',
    definition: 'to look about in alarm or fright',
    pinyin: ['jué'],
    decomposition: '⿱瞿又',
    etymology: {
      type: 'ideographic',
      hint: 'To startle 瞿 again 又; 瞿 also provides the pronunciation',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '矓',
    definition: 'faint, fuzzy, blurry',
    pinyin: ['lóng'],
    decomposition: '⿰目龍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龍',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '矗',
    definition: 'straight, upright; erect, lofty',
    pinyin: ['chù'],
    decomposition: '⿱直⿰直直',
    etymology: {
      type: 'ideographic',
      hint: 'Three people standing up straight 直',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '矚',
    definition: 'to focus on, to stare at, to watch carefully',
    pinyin: ['zhǔ'],
    decomposition: '⿰目屬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屬',
      semantic: '目',
      hint: 'eye',
    },
    radical: '目',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '矛',
    definition: 'spear, lance',
    pinyin: ['máo'],
    decomposition: '？',
    etymology: {
      type: 'pictographic',
      hint: 'A spear pointed up and to the right',
    },
    radical: '矛',
    matches: [null, null, null, null, null],
  },
  {
    character: '矜',
    definition: 'to pity, to sympathize, to feel sorry for',
    pinyin: ['jīn'],
    decomposition: '⿰矛今',
    etymology: {
      type: 'pictophonetic',
      phonetic: '今',
      semantic: '矛',
      hint: 'spear',
    },
    radical: '矛',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '矞',
    definition: 'to bore with an awl; bright, charming',
    pinyin: ['yù'],
    decomposition: '⿱矛冏',
    etymology: { type: 'ideographic', hint: 'To bore a hole with an awl 矛' },
    radical: '矛',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '矢',
    definition: 'arrow, dart; to vow, to swear',
    pinyin: ['shǐ'],
    decomposition: '⿻丿天',
    etymology: { type: 'pictographic', hint: 'An arrow pointing upwards' },
    radical: '矢',
    matches: [[0], [1], [1], [1], [1]],
  },
  {
    character: '矣',
    definition: 'particle of completed action',
    pinyin: ['yǐ'],
    decomposition: '⿱厶矢',
    radical: '矢',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '知',
    definition: 'to know, to perceive, to comprehend',
    pinyin: ['zhī'],
    decomposition: '⿰矢口',
    etymology: {
      type: 'pictophonetic',
      phonetic: '矢',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '矢',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '矦',
    definition: 'target in archery',
    pinyin: ['hóu'],
    decomposition: '⿸厃矢',
    etymology: {
      type: 'pictographic',
      hint: 'An arrow 矢 hitting a target 厃',
    },
    radical: '矢',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '矧',
    definition: 'interrogative particle; much more, still more',
    pinyin: ['shěn'],
    decomposition: '⿰矢引',
    etymology: {
      type: 'pictophonetic',
      phonetic: '矢',
      semantic: '引',
      hint: 'pull',
    },
    radical: '矢',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '矩',
    definition: "carpenter's square, ruler, rule",
    pinyin: ['jǔ'],
    decomposition: '⿰矢巨',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巨',
      semantic: '矢',
      hint: 'arrow',
    },
    radical: '矢',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '矫',
    definition: 'to correct, to rectify, to straighten out',
    pinyin: ['jiǎo'],
    decomposition: '⿰矢乔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乔',
      semantic: '矢',
      hint: 'arrow',
    },
    radical: '矢',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '矬',
    definition: 'short; a dwarf',
    pinyin: ['cuó'],
    decomposition: '⿰矢坐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '坐',
      semantic: '矢',
      hint: 'arrow',
    },
    radical: '矢',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '短',
    definition: 'brief, short; deficient, lacking',
    pinyin: ['duǎn'],
    decomposition: '⿰矢豆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豆',
      semantic: '矢',
      hint: 'dart',
    },
    radical: '矢',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '矮',
    definition: 'short, low; dwarf',
    pinyin: ['ǎi'],
    decomposition: '⿰矢委',
    etymology: {
      type: 'pictophonetic',
      phonetic: '委',
      semantic: '矢',
      hint: 'dart',
    },
    radical: '矢',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '矯',
    definition: 'to correct, to rectify, to straighten out',
    pinyin: ['jiǎo'],
    decomposition: '⿰矢喬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '喬',
      semantic: '矢',
      hint: 'arrow',
    },
    radical: '矢',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '石',
    definition: 'stone, rock, mineral',
    pinyin: ['shí'],
    decomposition: '⿸厂口',
    etymology: {
      type: 'ideographic',
      hint: 'A rock 口 at the base of a cliff 厂',
    },
    radical: '石',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '矶',
    definition: 'jetty, reef; breakwater, eddy',
    pinyin: ['jī'],
    decomposition: '⿰石几',
    etymology: {
      type: 'pictophonetic',
      phonetic: '几',
      semantic: '石',
      hint: 'rock',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '矸',
    definition: 'cliff; rock',
    pinyin: ['gān'],
    decomposition: '⿰石干',
    etymology: {
      type: 'pictophonetic',
      phonetic: '干',
      semantic: '石',
      hint: 'rock',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '矻',
    definition: 'busy; to toil, to slave away',
    pinyin: ['kū'],
    decomposition: '⿰石乞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乞',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '矽',
    definition: 'silicon',
    pinyin: ['xì'],
    decomposition: '⿰石夕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夕',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '矾',
    definition: 'alum',
    pinyin: ['fán'],
    decomposition: '⿰石凡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '凡',
      semantic: '石',
      hint: 'mineral',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '矿',
    definition: 'mine; mineral, ore',
    pinyin: ['kuàng'],
    decomposition: '⿰石广',
    etymology: {
      type: 'pictophonetic',
      phonetic: '广',
      semantic: '石',
      hint: 'mineral',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '砀',
    definition: 'a stone veined with brilliant colors',
    pinyin: ['dàng'],
    decomposition: '⿰石昜',
    etymology: {
      type: 'ideographic',
      hint: 'A bright 昜 stone 石; 昜 also provides the pronunciation',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '码',
    definition: 'number, numeral, symbol; yard',
    pinyin: ['mǎ'],
    decomposition: '⿰石马',
    etymology: {
      type: 'pictophonetic',
      phonetic: '马',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '砂',
    definition: 'sand, pebbles, gravel; gritty',
    pinyin: ['shā'],
    decomposition: '⿰石少',
    etymology: {
      type: 'ideographic',
      hint: 'Many small 少 stones 石; 少 also provides the pronunciation',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '砉',
    definition: 'the sound of a whip cracking',
    pinyin: ['huò'],
    decomposition: '⿱丰石',
    radical: '石',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '砌',
    definition: 'to pile up, to build; stone steps; rock wall',
    pinyin: ['qì'],
    decomposition: '⿰石切',
    etymology: {
      type: 'ideographic',
      hint: 'To cut 切 stone 石; 切 also provides the pronunciation',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '砍',
    definition: 'to hack, to chop, to cut, to fell',
    pinyin: ['kǎn'],
    decomposition: '⿰石欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '欠',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '砑',
    definition: 'to polish, to grind; to roll with a stone roller',
    pinyin: ['yà'],
    decomposition: '⿰石牙',
    etymology: {
      type: 'ideographic',
      hint: 'Stone 石 used as teeth 牙; 牙 also provides the pronunciation',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '砒',
    definition: 'arsenic',
    pinyin: ['pī'],
    decomposition: '⿰石比',
    etymology: {
      type: 'pictophonetic',
      phonetic: '比',
      semantic: '石',
      hint: 'mineral',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '研',
    definition: 'to grind, to rub; to study, to research',
    pinyin: ['yán'],
    decomposition: '⿰石开',
    etymology: {
      type: 'pictophonetic',
      phonetic: '开',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '砖',
    definition: 'tile, brick',
    pinyin: ['zhuān'],
    decomposition: '⿰石专',
    etymology: {
      type: 'pictophonetic',
      phonetic: '专',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '砗',
    definition: 'giant clam, Tridacna gigas',
    pinyin: ['chē'],
    decomposition: '⿰石车',
    etymology: {
      type: 'pictophonetic',
      phonetic: '车',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '砘',
    definition: 'a kind of farm tool',
    pinyin: ['dùn'],
    decomposition: '⿰石屯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屯',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '砚',
    definition: 'inkstone',
    pinyin: ['yàn'],
    decomposition: '⿰石见',
    etymology: {
      type: 'pictophonetic',
      phonetic: '见',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '砜',
    definition: 'sulfone',
    pinyin: ['fēng'],
    decomposition: '⿰石风',
    etymology: {
      type: 'pictophonetic',
      phonetic: '风',
      semantic: '石',
      hint: 'mineral',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '砝',
    definition: 'a standard weight (as for a balance)',
    pinyin: ['fá'],
    decomposition: '⿰石去',
    etymology: {
      type: 'pictophonetic',
      phonetic: '去',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '砟',
    definition: 'stone tablet; monument',
    pinyin: ['zhǎ'],
    decomposition: '⿰石乍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乍',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '砣',
    definition: 'a stone roller; plumb, weight',
    pinyin: ['tuó'],
    decomposition: '⿰石它',
    etymology: {
      type: 'pictophonetic',
      phonetic: '它',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '砥',
    definition: 'whetstone; to polish',
    pinyin: ['dǐ'],
    decomposition: '⿰石氐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '氐',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '砦',
    definition: 'stockade, fort, military outpost; brothel',
    pinyin: ['zhài'],
    decomposition: '⿱此石',
    etymology: {
      type: 'pictophonetic',
      phonetic: '此',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '砧',
    definition: 'anvil, flat stone',
    pinyin: ['zhēn'],
    decomposition: '⿰石占',
    etymology: {
      type: 'pictophonetic',
      phonetic: '占',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '砩',
    definition: 'to build a dam with rocks',
    pinyin: ['fú'],
    decomposition: '⿰石弗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弗',
      semantic: '石',
      hint: 'rock',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '砬',
    definition: 'boulder; obelisk',
    pinyin: ['lá'],
    decomposition: '⿰石立',
    etymology: {
      type: 'ideographic',
      hint: 'A large standing 立 stone 石; 立 also provides the pronunciation',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '砭',
    definition: 'stone probe; to pierce; to counsel',
    pinyin: ['biān'],
    decomposition: '⿰石乏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乏',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '砰',
    definition: 'bang! the sound of crashing rock',
    pinyin: ['pēng'],
    decomposition: '⿰石平',
    etymology: {
      type: 'pictophonetic',
      phonetic: '平',
      semantic: '石',
      hint: 'rock',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '砲',
    definition: 'gun, cannon',
    pinyin: ['pào'],
    decomposition: '⿰石包',
    etymology: {
      type: 'pictophonetic',
      phonetic: '包',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '破',
    definition: 'to break, to rout; to ruin, to destroy',
    pinyin: ['pò'],
    decomposition: '⿰石皮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皮',
      semantic: '石',
      hint: 'rock',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '砷',
    definition: 'arsenic',
    pinyin: ['shēn'],
    decomposition: '⿰石申',
    etymology: {
      type: 'pictophonetic',
      phonetic: '申',
      semantic: '石',
      hint: 'mineral',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '砸',
    definition: 'to smash, to pound, to crush, to break',
    pinyin: ['zá'],
    decomposition: '⿰石匝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匝',
      semantic: '石',
      hint: 'rock',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '砹',
    definition: 'astatine',
    pinyin: ['ài'],
    decomposition: '⿰石艾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '艾',
      semantic: '石',
      hint: 'mineral',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '砺',
    definition: 'whetstone; to sharpen',
    pinyin: ['lì'],
    decomposition: '⿰石厉',
    etymology: {
      type: 'ideographic',
      hint: 'A stone 石 used to hone 厉 blades; 厉 also provides the pronunciation',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '砻',
    definition: 'millstone; to grind, to mill',
    pinyin: ['lóng'],
    decomposition: '⿱龙石',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龙',
      semantic: '石',
      hint: 'stone',
    },
    radical: '龙',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '砼',
    definition: 'concrete',
    pinyin: ['tóng'],
    decomposition: '⿰石仝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '仝',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '砾',
    definition: 'gravel, pebbles',
    pinyin: ['lì'],
    decomposition: '⿰石乐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乐',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '础',
    definition: 'foundation stone, plinth; basis',
    pinyin: ['chǔ'],
    decomposition: '⿰石出',
    etymology: {
      type: 'pictophonetic',
      phonetic: '出',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '硃',
    definition: 'cinnabar; a red mole',
    pinyin: ['zhū'],
    decomposition: '⿰石朱',
    etymology: {
      type: 'ideographic',
      hint: 'Cinnabar 朱 ore 石; 朱 also provides the pronunciation',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '硅',
    definition: 'silicon',
    pinyin: ['guī'],
    decomposition: '⿰石圭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '圭',
      semantic: '石',
      hint: 'mineral',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '硇',
    definition: 'sal ammoniac',
    pinyin: ['náo'],
    decomposition: '⿰石囟',
    etymology: { type: 'ideographic', hint: 'A kind of mineral 石 salt 卤' },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '硌',
    definition: 'hard, bulging',
    pinyin: ['gè'],
    decomposition: '⿰石各',
    etymology: {
      type: 'pictophonetic',
      phonetic: '各',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '硎',
    definition: 'whetstone',
    pinyin: ['xíng'],
    decomposition: '⿰石刑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '刑',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '硐',
    definition: 'cave; chamber; pit',
    pinyin: ['dòng'],
    decomposition: '⿰石同',
    etymology: {
      type: 'pictophonetic',
      phonetic: '同',
      semantic: '石',
      hint: 'rock',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '硒',
    definition: 'selenium',
    pinyin: ['xī'],
    decomposition: '⿰石西',
    etymology: {
      type: 'pictophonetic',
      phonetic: '西',
      semantic: '石',
      hint: 'mineral',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '硕',
    definition: 'great, eminent; large, big',
    pinyin: ['shuò'],
    decomposition: '⿰石页',
    etymology: { type: 'ideographic', hint: 'Like a sheet 页 of stone 石' },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '硖',
    definition: 'a town in Hebei province',
    pinyin: ['xiá'],
    decomposition: '⿰石夹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夹',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '硗',
    definition: 'barren land; sandy soil',
    pinyin: ['qiāo'],
    decomposition: '⿰石尧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尧',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '硙',
    definition: 'millstone; to grind, to mill',
    pinyin: ['wéi'],
    decomposition: '⿰石岂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '岂',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '硝',
    definition: 'saltpeter; to tan leather',
    pinyin: ['xiāo'],
    decomposition: '⿰石肖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肖',
      semantic: '石',
      hint: 'mineral',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '硪',
    definition: 'a flat stone used as a mortar',
    pinyin: ['wò'],
    decomposition: '⿰石我',
    etymology: {
      type: 'pictophonetic',
      phonetic: '我',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '硫',
    definition: 'sulfur',
    pinyin: ['liú'],
    decomposition: '⿰石㐬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㐬',
      semantic: '石',
      hint: 'mineral',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '硬',
    definition: 'firm, hard, strong; obstinate',
    pinyin: ['yìng'],
    decomposition: '⿰石更',
    etymology: {
      type: 'pictophonetic',
      phonetic: '更',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '硭',
    definition: 'a crude saltpeter',
    pinyin: ['máng'],
    decomposition: '⿰石芒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '芒',
      semantic: '石',
      hint: 'mineral',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '确',
    definition: 'certain, sure; definite, exact; real, true',
    pinyin: ['què'],
    decomposition: '⿰石角',
    etymology: {
      type: 'pictophonetic',
      phonetic: '角',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '硷',
    definition: 'alkaline, alkali, lye, salt',
    pinyin: ['jiǎn'],
    decomposition: '⿰石佥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '佥',
      semantic: '石',
      hint: 'mineral',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '硼',
    definition: 'borax, boron',
    pinyin: ['péng'],
    decomposition: '⿰石朋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朋',
      semantic: '石',
      hint: 'mineral',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '碇',
    definition: 'anchor',
    pinyin: ['dìng'],
    decomposition: '⿰石定',
    etymology: {
      type: 'pictophonetic',
      phonetic: '定',
      semantic: '石',
      hint: 'rock',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '碉',
    definition: 'watchtower',
    pinyin: ['diāo'],
    decomposition: '⿰石周',
    etymology: {
      type: 'pictophonetic',
      phonetic: '周',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '碌',
    definition: 'rocky, rough, uneven; mediocre',
    pinyin: ['lù'],
    decomposition: '⿰石录',
    etymology: {
      type: 'pictophonetic',
      phonetic: '录',
      semantic: '石',
      hint: 'rock',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '碍',
    definition: 'to block, to deter, to hinder, to obstruct',
    pinyin: ['ài'],
    decomposition: '⿰石㝵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㝵',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '碎',
    definition: 'to break, to smash; broken, busted',
    pinyin: ['suì'],
    decomposition: '⿰石卒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卒',
      semantic: '石',
      hint: 'rock',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '碑',
    definition: 'stone tablet; gravestone',
    pinyin: ['bēi'],
    decomposition: '⿰石卑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卑',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '碓',
    definition: 'pestle',
    pinyin: ['duì'],
    decomposition: '⿰石隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隹',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '碗',
    definition: 'bowl, small dish',
    pinyin: ['wǎn'],
    decomposition: '⿰石宛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宛',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '碘',
    definition: 'iodine',
    pinyin: ['diǎn'],
    decomposition: '⿰石典',
    etymology: {
      type: 'pictophonetic',
      phonetic: '典',
      semantic: '石',
      hint: 'mineral',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '碚',
    definition: 'suburb',
    pinyin: ['bèi'],
    decomposition: '⿰石咅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咅',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '碛',
    definition: 'gravel, sand',
    pinyin: ['qì'],
    decomposition: '⿰石责',
    etymology: {
      type: 'pictophonetic',
      phonetic: '责',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '碜',
    definition: 'gritty',
    pinyin: ['chěn'],
    decomposition: '⿰石参',
    etymology: {
      type: 'pictophonetic',
      phonetic: '参',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '碟',
    definition: 'plate, small dish',
    pinyin: ['dié'],
    decomposition: '⿰石枼',
    etymology: { type: 'ideographic', hint: 'A flat 枼 stone 石' },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '碡',
    definition: 'stone roller',
    pinyin: ['dú'],
    decomposition: '⿰石毒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '毒',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '碣',
    definition: 'stone tablet',
    pinyin: ['jié'],
    decomposition: '⿰石曷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曷',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '碥',
    pinyin: ['biǎn'],
    decomposition: '⿰石扁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '扁',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '碧',
    definition: 'jade; green, blue',
    pinyin: ['bì'],
    decomposition: '⿱珀石',
    etymology: {
      type: 'ideographic',
      hint: 'A stone 石 like amber 珀; 珀 also provides the pronunciation',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '碩',
    definition: 'great, eminent; large, big',
    pinyin: ['shuò'],
    decomposition: '⿰石頁',
    etymology: { type: 'ideographic', hint: 'Like a sheet 頁 of stone 石' },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '碰',
    definition: 'to touch; to meet with; to collide, to bump into',
    pinyin: ['pèng'],
    decomposition: '⿰石並',
    etymology: {
      type: 'pictophonetic',
      phonetic: '並',
      semantic: '石',
      hint: 'rock',
    },
    radical: '石',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '碱',
    definition: 'alkaline, alkali, lye, salt',
    pinyin: ['jiǎn'],
    decomposition: '⿰石咸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咸',
      semantic: '石',
      hint: 'mineral',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '碲',
    definition: 'tellurium',
    pinyin: ['dì'],
    decomposition: '⿰石帝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '帝',
      semantic: '石',
      hint: 'mineral',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '碳',
    definition: 'carbon',
    pinyin: ['tàn'],
    decomposition: '⿰石炭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '炭',
      semantic: '石',
      hint: 'mineral',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '碴',
    definition: 'quarrel; fault; a shard of glass',
    pinyin: ['chá'],
    decomposition: '⿰石查',
    etymology: {
      type: 'pictophonetic',
      phonetic: '查',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '碹',
    pinyin: ['xuàn'],
    decomposition: '⿰石宣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宣',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '確',
    definition: 'certain, sure; definite, exact; real, true',
    pinyin: ['què'],
    decomposition: '⿰石隺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隺',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '碼',
    definition: 'number, numeral, symbol; yard',
    pinyin: ['mǎ'],
    decomposition: '⿰石馬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '馬',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '碾',
    definition: 'stone roller; to crush, to roll',
    pinyin: ['niǎn'],
    decomposition: '⿰石展',
    etymology: {
      type: 'pictophonetic',
      phonetic: '展',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '磁',
    definition: 'magnetic; porcelain',
    pinyin: ['cí'],
    decomposition: '⿰石兹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兹',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '磅',
    definition: 'pound; to weigh',
    pinyin: ['bàng'],
    decomposition: '⿰石旁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旁',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '磉',
    definition: 'plinth, stone base',
    pinyin: ['sǎng'],
    decomposition: '⿰石桑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '桑',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '磊',
    definition: 'a pile of rocks; candid, open; great',
    pinyin: ['lěi'],
    decomposition: '⿱石⿰石石',
    etymology: { type: 'ideographic', hint: 'Many rocks 石 piled up' },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '磋',
    definition: 'to polish, to buff; to examine, to deliberate',
    pinyin: ['cuō'],
    decomposition: '⿰石差',
    etymology: {
      type: 'pictophonetic',
      phonetic: '差',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '磐',
    definition: 'boulder, large rock; firm, stable',
    pinyin: ['pán'],
    decomposition: '⿱般石',
    etymology: {
      type: 'pictophonetic',
      phonetic: '般',
      semantic: '石',
      hint: 'rock',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '磔',
    definition: 'to dismember, to tear apart',
    pinyin: ['zhé'],
    decomposition: '⿰石桀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '桀',
      semantic: '石',
      hint: 'rock',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '磕',
    definition: 'to collide, to hit, to knock, to tap',
    pinyin: ['kē'],
    decomposition: '⿰石盍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '盍',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '磙',
    definition: 'stone roller',
    pinyin: ['gǔn'],
    decomposition: '⿰石衮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '衮',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '磚',
    definition: 'tile, brick',
    pinyin: ['zhuān'],
    decomposition: '⿰石專',
    etymology: {
      type: 'pictophonetic',
      phonetic: '專',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '磨',
    definition: 'millstone; to grind, to polish, to rub, to wear out',
    pinyin: ['mó'],
    decomposition: '⿸麻石',
    etymology: {
      type: 'pictophonetic',
      phonetic: '麻',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '磬',
    definition: 'musical instrument; a kind of xylophone',
    pinyin: ['qìng'],
    decomposition: '⿱殸石',
    etymology: {
      type: 'ideographic',
      hint: 'Stone 石 chimes 殸; 殸 also provides the pronunciation',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '磲',
    definition: 'giant clam, Tridacna gigas',
    pinyin: ['qú'],
    decomposition: '⿰石渠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '渠',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '磴',
    definition: 'stone steps on a cliff or hill',
    pinyin: ['dèng'],
    decomposition: '⿰石登',
    etymology: {
      type: 'ideographic',
      hint: 'Stone 石 steps for climbing 登; 登 also provides the pronunciation',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '磷',
    definition: 'phosphorus',
    pinyin: ['lín'],
    decomposition: '⿰石粦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '粦',
      semantic: '石',
      hint: 'mineral',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '磺',
    definition: 'sulphur; brimstone',
    pinyin: ['huáng'],
    decomposition: '⿰石黄',
    etymology: {
      type: 'ideographic',
      hint: 'A yellow 黄 mineral 石; 黄 also provides the pronunciation',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '礁',
    definition: 'jetty, reef',
    pinyin: ['jiāo'],
    decomposition: '⿰石焦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '焦',
      semantic: '石',
      hint: 'rock',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '礅',
    definition: 'stone block',
    pinyin: ['dūn'],
    decomposition: '⿰石敦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敦',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '礎',
    definition: 'foundation stone, plinth; basis',
    pinyin: ['chǔ'],
    decomposition: '⿰石楚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '楚',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '礓',
    definition: 'pebble, small stone',
    pinyin: ['jiāng'],
    decomposition: '⿰石畺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畺',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '礙',
    definition: 'to block, to deter, to hinder, to obstruct',
    pinyin: ['ài'],
    decomposition: '⿰石疑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '疑',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '礞',
    definition: 'a kind of mineral',
    pinyin: ['méng'],
    decomposition: '⿰石蒙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蒙',
      semantic: '石',
      hint: 'mineral',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '礤',
    definition: 'shredder, grater; grindstone',
    pinyin: ['cǎ'],
    decomposition: '⿰石蔡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蔡',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '礦',
    definition: 'mine; mineral, ore',
    pinyin: ['kuàng'],
    decomposition: '⿰石廣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '廣',
      semantic: '石',
      hint: 'mineral',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '礬',
    definition: 'alum',
    pinyin: ['fán'],
    decomposition: '⿱樊石',
    etymology: {
      type: 'pictophonetic',
      phonetic: '樊',
      semantic: '石',
      hint: 'mineral',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '礴',
    definition: 'to extend, to fill',
    pinyin: ['bó'],
    decomposition: '⿰石薄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '薄',
      semantic: '石',
      hint: 'stone',
    },
    radical: '石',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '示',
    definition: 'altar; ceremony; to show, to demonstrate',
    pinyin: ['shì'],
    decomposition: '⿱二小',
    etymology: { type: 'pictographic', hint: 'An altar' },
    radical: '示',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '礻',
    definition: 'spirit',
    pinyin: ['shì'],
    decomposition: '⿱？卜',
    radical: '礻',
    matches: [null, null, [1], [1]],
  },
  {
    character: '礼',
    definition: 'courtesy, manners, social customs',
    pinyin: ['lǐ'],
    decomposition: '⿰礻乚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乚',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1]],
  },
  {
    character: '社',
    definition: 'group, organization, society; a god of the soil',
    pinyin: ['shè'],
    decomposition: '⿰礻土',
    etymology: {
      type: 'ideographic',
      hint: 'An earth 土 spirit 礻; 礻 also provides the pronunciation',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '祀',
    definition: 'to sacrifice, to worship',
    pinyin: ['sì'],
    decomposition: '⿰礻巳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巳',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '祁',
    definition: 'to pray; numerous, ample, abundant',
    pinyin: ['qí'],
    decomposition: '⿰礻阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '阝',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '祆',
    definition: 'Ormazda, the Zoroastrian sun god',
    pinyin: ['xiān'],
    decomposition: '⿰礻天',
    etymology: {
      type: 'ideographic',
      hint: 'A spirit 礻 in the sky 天; 天 also provides the pronunciation',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '祇',
    definition: 'only, just, simply; one of a pair; an earth god',
    pinyin: ['qí'],
    decomposition: '⿰礻氏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '氏',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '祈',
    definition: 'to pray, to entreat, to beseech',
    pinyin: ['qí'],
    decomposition: '⿰礻斤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斤',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '祉',
    definition: 'blessings, happiness, good luck',
    pinyin: ['zhǐ'],
    decomposition: '⿰礻止',
    etymology: {
      type: 'pictophonetic',
      phonetic: '止',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '祎',
    definition: 'excellent, rare; beautiful, fine',
    pinyin: ['yī'],
    decomposition: '⿰礻韦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韦',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '祓',
    definition: 'to exorcise; to cleanse',
    pinyin: ['fú'],
    decomposition: '⿰礻犮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '犮',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '祕',
    definition: 'secret, mysterious, abstruse',
    pinyin: ['mì'],
    decomposition: '⿰礻必',
    etymology: {
      type: 'pictophonetic',
      phonetic: '必',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '祖',
    definition: 'ancestor, forefather; grandfather; surname',
    pinyin: ['zǔ'],
    decomposition: '⿰礻且',
    etymology: {
      type: 'pictophonetic',
      phonetic: '且',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '祗',
    definition: 'to revere, to respect, to look up to',
    pinyin: ['zhī'],
    decomposition: '⿰礻氐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '氐',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '祘',
    definition: 'to calculate',
    pinyin: ['suàn'],
    decomposition: '⿰示示',
    radical: '示',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '祚',
    definition: 'throne; happiness, blessings',
    pinyin: ['zuò'],
    decomposition: '⿰礻乍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乍',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '祛',
    definition: 'to expel, to disperse; to exorcise',
    pinyin: ['qū'],
    decomposition: '⿰礻去',
    etymology: {
      type: 'ideographic',
      hint: 'To banish 去 a spirit 礻; 去 also provides the pronunciation',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '祜',
    definition: 'blessings, happiness, prosperity',
    pinyin: ['hù'],
    decomposition: '⿰礻古',
    etymology: {
      type: 'pictophonetic',
      phonetic: '古',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '祝',
    definition: 'to pray; to wish well; surname',
    pinyin: ['zhù'],
    decomposition: '⿰礻兄',
    etymology: {
      type: 'ideographic',
      hint: 'A person 兄 praying before an altar 礻',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '神',
    definition: 'god, spirit; divine, mysterious, supernatural',
    pinyin: ['shén'],
    decomposition: '⿰礻申',
    etymology: {
      type: 'pictophonetic',
      phonetic: '申',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '祟',
    definition: 'evil spirit; evil influence',
    pinyin: ['suì'],
    decomposition: '⿱出示',
    etymology: { type: 'pictophonetic', semantic: '示', hint: 'spirit' },
    radical: '示',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '祠',
    definition: 'ancestral temple; to sacrifice',
    pinyin: ['cí'],
    decomposition: '⿰礻司',
    etymology: {
      type: 'pictophonetic',
      phonetic: '司',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '祢',
    definition: "one's deceased father",
    pinyin: ['mí'],
    decomposition: '⿰礻尔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尔',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '祥',
    definition: 'happiness, good fortune; auspicious',
    pinyin: ['xiáng'],
    decomposition: '⿰礻羊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羊',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '祧',
    definition: 'ancestral hall',
    pinyin: ['tiāo'],
    decomposition: '⿰礻兆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兆',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '票',
    definition: 'bank note; ticket; vote; a slip of paper',
    pinyin: ['piào'],
    decomposition: '⿱覀示',
    etymology: {
      type: 'ideographic',
      hint: 'Flames 覀 over an altar 示, referring to a Chinese tradition of burning fake money as an offering',
    },
    radical: '示',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '祭',
    definition: 'to sacrifice to, to worship',
    pinyin: ['jì'],
    decomposition: '⿱⿰⺼寸示',
    etymology: {
      type: 'ideographic',
      hint: 'Hand 寸 holding meat ⺼ over an altar 示',
    },
    radical: '示',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '祯',
    definition: 'lucky, auspicious; a good omen',
    pinyin: ['zhēn'],
    decomposition: '⿰礻贞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贞',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '祷',
    definition: 'to pray, to entreat, to beg; prayer',
    pinyin: ['dǎo'],
    decomposition: '⿰礻寿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寿',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '祸',
    definition: 'misfortune, disaster, calamity',
    pinyin: ['huò'],
    decomposition: '⿰礻呙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '呙',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '祺',
    definition: 'good luck, good fortune',
    pinyin: ['qí'],
    decomposition: '⿰礻其',
    etymology: {
      type: 'pictophonetic',
      phonetic: '其',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '祿',
    definition: 'blessing, happiness, prosperity',
    pinyin: ['lù'],
    decomposition: '⿰礻彔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彔',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '禀',
    definition: 'to report to, to petition',
    pinyin: ['bǐng'],
    decomposition: '⿳亠回示',
    etymology: {
      type: 'ideographic',
      hint: 'To show 示 something to an official 亠回',
    },
    radical: '示',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [2], [2], [2], [2], [2]],
  },
  {
    character: '禁',
    definition: 'to restrict, to prohibit, to forbid; to endure',
    pinyin: ['jìn'],
    decomposition: '⿱林示',
    etymology: {
      type: 'pictophonetic',
      phonetic: '林',
      semantic: '示',
      hint: 'altar',
    },
    radical: '示',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '禄',
    definition: 'blessing, happiness, prosperity',
    pinyin: ['lù'],
    decomposition: '⿰礻录',
    etymology: {
      type: 'pictophonetic',
      phonetic: '录',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '禅',
    definition: 'meditation, contemplation',
    pinyin: ['chán'],
    decomposition: '⿰礻单',
    etymology: {
      type: 'ideographic',
      hint: 'To pray 礻 alone 单; 单 also provides the pronunciation',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '禊',
    definition: 'a semi-annual ceremony of purification',
    pinyin: ['xì'],
    decomposition: '⿰礻契',
    etymology: {
      type: 'pictophonetic',
      phonetic: '契',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '禍',
    definition: 'misfortune, disaster, calamity',
    pinyin: ['huò'],
    decomposition: '⿰礻咼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咼',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '禎',
    definition: 'lucky, auspicious; a good omen',
    pinyin: ['zhēn'],
    decomposition: '⿰礻貞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '貞',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '福',
    definition: 'happiness, good fortune, blessings',
    pinyin: ['fú'],
    decomposition: '⿰礻畐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畐',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '禕',
    definition: 'excellent, rare; beautiful, fine',
    pinyin: ['yī'],
    decomposition: '⿰礻韋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韋',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '禚',
    definition: 'a place name',
    pinyin: ['zhuó'],
    decomposition: '⿰礻羔',
    radical: '礻',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '禛',
    definition: 'to receive blessings',
    pinyin: ['zhēn'],
    decomposition: '⿰礻真',
    etymology: {
      type: 'pictophonetic',
      phonetic: '真',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '禦',
    definition: 'chariot; to drive, to ride; to manage',
    pinyin: ['yù'],
    decomposition: '⿱御示',
    etymology: {
      type: 'pictophonetic',
      phonetic: '御',
      semantic: '示',
      hint: 'spirit',
    },
    radical: '示',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '禧',
    definition: 'happiness; congratulations',
    pinyin: ['xǐ'],
    decomposition: '⿰礻喜',
    etymology: {
      type: 'ideographic',
      hint: 'Celebrating 喜 good fortune 礻; 壴 also provides the pronunciation',
    },
    radical: '礻',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '禪',
    definition: 'meditation, contemplation',
    pinyin: ['chán'],
    decomposition: '⿰礻單',
    etymology: {
      type: 'ideographic',
      hint: 'To pray 礻 alone 單; 單 also provides the pronunciation',
    },
    radical: '礻',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '禮',
    definition: 'courtesy, manners, social customs',
    pinyin: ['lǐ'],
    decomposition: '⿰礻豊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豊',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '禰',
    definition: "one's deceased father",
    pinyin: ['mí'],
    decomposition: '⿰礻爾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爾',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '禱',
    definition: 'to pray, to entreat, to beg; prayer',
    pinyin: ['dǎo'],
    decomposition: '⿰礻壽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '壽',
      semantic: '礻',
      hint: 'spirit',
    },
    radical: '礻',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '禳',
    definition: 'to sacrifice; to pray; to exorcise',
    pinyin: ['ráng'],
    decomposition: '⿰礻襄',
    etymology: {
      type: 'ideographic',
      hint: 'To pray 礻for help 襄; 襄 also provides the pronunciation',
    },
    radical: '礻',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '禸',
    definition: 'rump',
    pinyin: ['róu'],
    decomposition: '⿻冂厶',
    radical: '禸',
    matches: [[0], [0], null, [1], [1]],
  },
  {
    character: '禹',
    definition: 'legendary Hsia dynasty founder',
    pinyin: ['yǔ'],
    decomposition: '⿻？禸',
    radical: '禸',
    matches: [null, null, null, null, [1], [1], [1], [1], [1]],
  },
  {
    character: '禺',
    definition: 'district; mountain in Zhejiang',
    pinyin: ['yú'],
    decomposition: '⿱日禸',
    radical: '禸',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '离',
    definition: 'rare beast; strange; elegant',
    pinyin: ['lí'],
    decomposition: '⿱⿱亠凶禸',
    etymology: {
      type: 'pictographic',
      hint: 'An animal standing straight; 亠 is the head',
    },
    radical: '禸',
    matches: [
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '禼',
    definition: 'termite',
    pinyin: ['xiè'],
    decomposition: '⿱卤禸',
    radical: '禸',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '禽',
    definition: 'birds, fowl; to capture; surname',
    pinyin: ['qín'],
    decomposition: '⿱人离',
    etymology: {
      type: 'ideographic',
      hint: 'A legendary beast 离 captured by a man 人',
    },
    radical: '禸',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '禾',
    definition: 'cereal, grain, rice; plant, stalk',
    pinyin: ['hé'],
    decomposition: '⿱丿木',
    etymology: {
      type: 'pictographic',
      hint: 'A plant stalk with a sagging head',
    },
    radical: '禾',
    matches: [[0], [1], [1], [1], [1]],
  },
  {
    character: '禿',
    definition: 'bald',
    pinyin: ['tū'],
    decomposition: '⿱禾儿',
    etymology: {
      type: 'ideographic',
      hint: "Grains of hair 禾 on a person's head 儿",
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '秀',
    definition: 'elegant, graceful, refined; flowing, luxuriant',
    pinyin: ['xiù'],
    decomposition: '⿱禾乃',
    etymology: { type: 'pictophonetic', semantic: '禾', hint: 'flower' },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '私',
    definition: 'personal, private, secret; selfish',
    pinyin: ['sī'],
    decomposition: '⿰禾厶',
    etymology: {
      type: 'ideographic',
      hint: '厶 provides the meaning and pronunciation',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '秃',
    definition: 'bald',
    pinyin: ['tū'],
    decomposition: '⿱禾几',
    etymology: {
      type: 'ideographic',
      hint: "Grains of hair 禾 on a person's head 几",
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '秆',
    definition: 'straw, hay',
    pinyin: ['gǎn'],
    decomposition: '⿰禾干',
    etymology: {
      type: 'ideographic',
      hint: 'Dried 干 grain stalks 禾; 干 also provides the pronunciation',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '秉',
    definition: 'to grasp, to hold; to maintain, to preside over',
    pinyin: ['bǐng'],
    decomposition: '⿻禾彐',
    etymology: {
      type: 'ideographic',
      hint: 'A hand 彐 grasping a bundle of grain 禾',
    },
    radical: '禾',
    matches: [[0], [0], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '秋',
    definition: 'autumn, fall; year',
    pinyin: ['qiū'],
    decomposition: '⿰禾火',
    etymology: {
      type: 'ideographic',
      hint: 'The time of year when farmers would burn 禾 crops 火',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '种',
    definition: 'race, kind, breed; seed; to plant',
    pinyin: ['zhǒng'],
    decomposition: '⿰禾中',
    etymology: {
      type: 'pictophonetic',
      phonetic: '中',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '科',
    definition: 'section, department; field, branch; science',
    pinyin: ['kē'],
    decomposition: '⿰禾斗',
    etymology: { type: 'ideographic', hint: 'A hand measuring 斗 grain 禾' },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '秒',
    definition: 'a second; a corn kernel; measure word for time',
    pinyin: ['miǎo'],
    decomposition: '⿰禾少',
    etymology: {
      type: 'pictophonetic',
      phonetic: '少',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '秕',
    definition: 'chaff, husk',
    pinyin: ['bǐ'],
    decomposition: '⿰禾比',
    etymology: {
      type: 'pictophonetic',
      phonetic: '比',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '秘',
    definition: 'secret, mysterious, abstruse',
    pinyin: ['mì'],
    decomposition: '⿰禾必',
    etymology: {
      type: 'pictophonetic',
      phonetic: '必',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '秝',
    definition: '(Cant.) excessively thin',
    pinyin: ['lì'],
    decomposition: '⿰禾禾',
    etymology: { type: 'ideographic', hint: 'As thin as a stalk of grain 禾' },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '租',
    definition: 'to rent, to lease; tax, rent',
    pinyin: ['zū'],
    decomposition: '⿰禾且',
    etymology: {
      type: 'ideographic',
      hint: 'Regularly paid 且 tribute in grain 禾',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '秣',
    definition: 'fodder, horse feed; to feed a horse',
    pinyin: ['mò'],
    decomposition: '⿰禾末',
    etymology: {
      type: 'pictophonetic',
      phonetic: '末',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '秤',
    definition: 'balance, scale; steelyard',
    pinyin: ['chèng'],
    decomposition: '⿰禾平',
    etymology: {
      type: 'ideographic',
      hint: 'A balance 平 used to measure grain 禾',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '秦',
    definition: 'the Qin dynasty (eponymous for China)',
    pinyin: ['qín'],
    decomposition: '⿱？禾',
    radical: '禾',
    matches: [null, null, null, null, null, [1], [1], [1], [1], [1]],
  },
  {
    character: '秧',
    definition: 'shoots, sprouts; young rice plants',
    pinyin: ['yāng'],
    decomposition: '⿰禾央',
    etymology: {
      type: 'pictophonetic',
      phonetic: '央',
      semantic: '禾',
      hint: 'rice',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '秩',
    definition: 'order; ordered',
    pinyin: ['zhì'],
    decomposition: '⿰禾失',
    etymology: {
      type: 'pictophonetic',
      phonetic: '失',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '秫',
    definition: 'a glutinous variety of millet',
    pinyin: ['shú'],
    decomposition: '⿰禾术',
    etymology: {
      type: 'pictophonetic',
      phonetic: '术',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '秭',
    definition: 'billion',
    pinyin: ['zǐ'],
    decomposition: '⿰禾？',
    etymology: { type: 'pictophonetic', semantic: '禾', hint: 'grain' },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], null, null, null, null],
  },
  {
    character: '积',
    definition: 'to store up, to amass, to accumulate',
    pinyin: ['jī'],
    decomposition: '⿰禾只',
    etymology: {
      type: 'pictophonetic',
      phonetic: '只',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '称',
    definition: 'balanced; name, brand; to say, to call',
    pinyin: ['chēng'],
    decomposition: '⿰禾尔',
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '秸',
    definition: 'stalks of millet or corn',
    pinyin: ['jiē'],
    decomposition: '⿰禾吉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吉',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '移',
    definition: 'to shift, to move about, to drift',
    pinyin: ['yí'],
    decomposition: '⿰禾多',
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '秽',
    definition: 'dirty, unclean; immoral, obscene',
    pinyin: ['huì'],
    decomposition: '⿰禾岁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '岁',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '稀',
    definition: 'rare, unusual; scarce, sparse',
    pinyin: ['xī'],
    decomposition: '⿰禾希',
    etymology: {
      type: 'pictophonetic',
      phonetic: '希',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '稂',
    definition: 'grass; weeds',
    pinyin: ['láng'],
    decomposition: '⿰禾良',
    etymology: {
      type: 'pictophonetic',
      phonetic: '良',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '稃',
    definition: 'chaff, husk',
    pinyin: ['fū'],
    decomposition: '⿰禾孚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孚',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '稅',
    definition: 'taxes',
    pinyin: ['shuì'],
    decomposition: '⿰禾兌',
    etymology: {
      type: 'ideographic',
      hint: 'Grain 禾 paid as tribute 兌; 兌 also provides the pronunciation',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '稆',
    definition: 'wild grain',
    pinyin: ['lǚ'],
    decomposition: '⿰禾吕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吕',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '稈',
    definition: 'straw, hay',
    pinyin: ['gǎn'],
    decomposition: '⿰禾旱',
    etymology: {
      type: 'ideographic',
      hint: 'Dried 旱 grain stalks 禾; 旱 also provides the pronunciation',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '程',
    definition: 'process, rules; journey, trip; agenda, schedule',
    pinyin: ['chéng'],
    decomposition: '⿰禾呈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '呈',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '稍',
    definition: 'somewhat, slightly, a little; rather',
    pinyin: ['shāo'],
    decomposition: '⿰禾肖',
    etymology: {
      type: 'ideographic',
      hint: 'Resembling 肖 grain 禾; 肖 also provides the pronunciation',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '税',
    definition: 'taxes',
    pinyin: ['shuì'],
    decomposition: '⿰禾兑',
    etymology: {
      type: 'ideographic',
      hint: 'Grain 禾 paid as tribute 兑; 兑 also provides the pronunciation',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '稔',
    definition: 'ripe grain; to harvest; to know well',
    pinyin: ['rěn'],
    decomposition: '⿰禾念',
    etymology: {
      type: 'pictophonetic',
      phonetic: '念',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '稗',
    definition: 'darnels, weeds; small, insignificant',
    pinyin: ['bài'],
    decomposition: '⿰禾卑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卑',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '稙',
    definition: 'grain ready for grinding',
    pinyin: ['zhī'],
    decomposition: '⿰禾直',
    etymology: {
      type: 'pictophonetic',
      phonetic: '直',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '稚',
    definition: 'young, immature; childhood',
    pinyin: ['zhì'],
    decomposition: '⿰禾隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隹',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '稜',
    definition: 'edge, corner, angle; protrusion; square beam',
    pinyin: ['léng'],
    decomposition: '⿰禾夌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夌',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '稞',
    definition: 'grain ready for grinding',
    pinyin: ['kē'],
    decomposition: '⿰禾果',
    etymology: {
      type: 'ideographic',
      hint: 'Grain 禾 bearing fruit 果; 果 also provides the pronunciation',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '稟',
    definition: 'to report to, to petition',
    pinyin: ['bǐng'],
    decomposition: '⿳亠回禾',
    etymology: {
      type: 'ideographic',
      hint: 'To show 禾 something to an official 亠回',
    },
    radical: '禾',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [2], [2], [2], [2], [2]],
  },
  {
    character: '稠',
    definition: 'crowded, dense; viscous, thick',
    pinyin: ['chóu'],
    decomposition: '⿰禾周',
    etymology: {
      type: 'pictophonetic',
      phonetic: '周',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '稣',
    definition: 'to revive; to rise again',
    pinyin: ['sū'],
    decomposition: '⿰鱼禾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鱼',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '鱼',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '稨',
    definition: 'hyacinth bean, haricot',
    pinyin: ['biǎn'],
    decomposition: '⿰禾扁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '扁',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '種',
    definition: 'race, kind, breed; seed; to plant',
    pinyin: ['zhǒng'],
    decomposition: '⿰禾重',
    etymology: {
      type: 'pictophonetic',
      phonetic: '重',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '稱',
    definition: 'balanced; name, brand; to say, to call',
    pinyin: ['chēng'],
    decomposition: '⿰禾爯',
    etymology: {
      type: 'ideographic',
      hint: 'Grain 禾 measured on a scale 爯; 爯 also provides the pronunciation',
    },
    radical: '禾',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '稳',
    definition: 'steady, stable; solid, firm',
    pinyin: ['wěn'],
    decomposition: '⿰禾急',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㥯',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '稷',
    definition: 'god of cereals; minister of agriculture',
    pinyin: ['jì'],
    decomposition: '⿰禾畟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畟',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '稹',
    definition: 'to accumulate',
    pinyin: ['zhěn'],
    decomposition: '⿰禾真',
    etymology: {
      type: 'pictophonetic',
      phonetic: '真',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '稻',
    definition: 'rice plant; rice growing in the field',
    pinyin: ['dào'],
    decomposition: '⿰禾舀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '舀',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '稼',
    definition: 'crops; to sow grain',
    pinyin: ['jià'],
    decomposition: '⿰禾家',
    etymology: {
      type: 'pictophonetic',
      phonetic: '家',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '稽',
    definition: 'to examine, to investigate',
    pinyin: ['jī'],
    decomposition: '⿰禾⿱尤旨',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旨',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '稿',
    definition: 'draft, manuscript, rough copy',
    pinyin: ['gǎo'],
    decomposition: '⿰禾高',
    etymology: {
      type: 'pictophonetic',
      phonetic: '高',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '穀',
    definition: 'valley, gorge, ravine',
    pinyin: ['gǔ'],
    decomposition: '⿰⿱⿳士冖一禾殳',
    radical: '禾',
    matches: [
      [0, 0, 0],
      [0, 0, 0],
      [0, 0, 0],
      [0, 0, 1],
      [0, 0, 1],
      [0, 0, 2],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '穆',
    definition: 'majestic; reverent, solemn',
    pinyin: ['mù'],
    decomposition: '⿰禾㣎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㣎',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '穌',
    definition: 'to revive; to rise again',
    pinyin: ['sū'],
    decomposition: '⿰魚禾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '魚',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '積',
    definition: 'to store up, to amass, to accumulate',
    pinyin: ['jī'],
    decomposition: '⿰禾責',
    etymology: {
      type: 'pictophonetic',
      phonetic: '責',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '穎',
    definition: 'rice tassel; sharp; clever',
    pinyin: ['yǐng'],
    decomposition: '⿰⿱匕禾頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匕',
      semantic: '禾',
      hint: 'rice',
    },
    radical: '禾',
    matches: [
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '穑',
    definition: 'to farm, to harvest grain',
    pinyin: ['sè'],
    decomposition: '⿰禾啬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '啬',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '穗',
    definition: 'ear of grain; fringe, tassel; Guangzhou',
    pinyin: ['suì'],
    decomposition: '⿰禾惠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '惠',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '穡',
    definition: 'to farm, to harvest grain',
    pinyin: ['sè'],
    decomposition: '⿰禾嗇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '嗇',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '穢',
    definition: 'dirty, unclean; immoral, obscene',
    pinyin: ['huì'],
    decomposition: '⿰禾歲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '歲',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '穩',
    definition: 'steady, stable; solid, firm',
    pinyin: ['wěn'],
    decomposition: '⿰禾㥯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㥯',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '穫',
    definition: 'to get, to obtain, to receive, to sieze',
    pinyin: ['huò'],
    decomposition: '⿰禾蒦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蒦',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '穰',
    definition: 'stalks of grain; lush, abundant',
    pinyin: ['ráng'],
    decomposition: '⿰禾襄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '襄',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '禾',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '穴',
    definition: 'cave, den, hole',
    pinyin: ['xué'],
    decomposition: '⿱宀八',
    etymology: { type: 'pictographic', hint: 'The mouth of a cave' },
    radical: '穴',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '穵',
    definition: 'a deep hollow; to dig out, to gouge',
    pinyin: ['wā'],
    decomposition: '⿱穴乙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乙',
      semantic: '穴',
      hint: 'cave',
    },
    radical: '穴',
    matches: [[0], [0], [0], [0], [0], [1]],
  },
  {
    character: '究',
    definition: 'to dig into, to investigate; actually, after all',
    pinyin: ['jiū'],
    decomposition: '⿱穴九',
    etymology: {
      type: 'pictophonetic',
      phonetic: '九',
      semantic: '穴',
      hint: 'cave',
    },
    radical: '穴',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '穷',
    definition: 'poor, destitute; to exhaust',
    pinyin: ['qióng'],
    decomposition: '⿱穴力',
    radical: '穴',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '穸',
    definition: 'the gloom of the grave; tomb, grave; death',
    pinyin: ['xī'],
    decomposition: '⿱穴夕',
    etymology: {
      type: 'ideographic',
      hint: 'A dark 夕 cave 穴; 夕 also provides the pronunciation',
    },
    radical: '穴',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '穹',
    definition: 'vast, lofty, high; vault, dome, arch',
    pinyin: ['qióng'],
    decomposition: '⿱穴弓',
    etymology: {
      type: 'ideographic',
      hint: 'An arched 弓 vault 穴; 弓 also provides the pronunciation',
    },
    radical: '穴',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '空',
    definition: 'hollow, empty, deserted, bare',
    pinyin: ['kōng'],
    decomposition: '⿱穴工',
    etymology: {
      type: 'pictophonetic',
      phonetic: '工',
      semantic: '穴',
      hint: 'cave',
    },
    radical: '穴',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '穿',
    definition: 'to drill, to pierce; to dress, to wear',
    pinyin: ['chuān'],
    decomposition: '⿱穴牙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '穴',
      semantic: '牙',
      hint: 'tooth',
    },
    radical: '穴',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '窀',
    definition: 'to bury',
    pinyin: ['zhūn'],
    decomposition: '⿱穴屯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屯',
      semantic: '穴',
      hint: 'hole',
    },
    radical: '穴',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '突',
    definition: 'sudden, abrupt, unexpected',
    pinyin: ['tū'],
    decomposition: '⿱穴犬',
    etymology: {
      type: 'ideographic',
      hint: 'A dog 犬 rushing out of a cave 穴',
    },
    radical: '穴',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '窃',
    definition: 'to steal; thief; secret, stealthy',
    pinyin: ['qiè'],
    decomposition: '⿱穴切',
    etymology: {
      type: 'pictophonetic',
      phonetic: '切',
      semantic: '穴',
      hint: 'hole',
    },
    radical: '穴',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '窄',
    definition: 'narrow, tight; narrow-minded',
    pinyin: ['zhǎi'],
    decomposition: '⿱穴乍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乍',
      semantic: '穴',
      hint: 'cave',
    },
    radical: '穴',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '窅',
    definition: 'deep, far, hollow; sad; sunken eyes',
    pinyin: ['yǎo'],
    decomposition: '⿱穴目',
    etymology: { type: 'ideographic', hint: 'Sunken 穴 eyes 目' },
    radical: '穴',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '窆',
    definition: 'to lower a coffin into a grave',
    pinyin: ['biǎn'],
    decomposition: '⿱穴乏',
    etymology: { type: 'pictophonetic', semantic: '穴', hint: 'hole' },
    radical: '穴',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '窈',
    definition: 'obscure, secluded; quiet, refined',
    pinyin: ['yǎo'],
    decomposition: '⿱穴幼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '幼',
      semantic: '穴',
      hint: 'cave',
    },
    radical: '穴',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '窍',
    definition: 'hole, opening, aperture',
    pinyin: ['qiào'],
    decomposition: '⿱穴巧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巧',
      semantic: '穴',
      hint: 'hole',
    },
    radical: '穴',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '窑',
    definition: 'kiln, oven; pit, coal mine',
    pinyin: ['yáo'],
    decomposition: '⿱穴缶',
    etymology: {
      type: 'ideographic',
      hint: 'An oven 穴 where pots 缶 are fired; 缶 also provides the pronunciation',
    },
    radical: '穴',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '窒',
    definition: 'to obstruct, to stop',
    pinyin: ['zhì'],
    decomposition: '⿱穴至',
    etymology: {
      type: 'pictophonetic',
      phonetic: '至',
      semantic: '穴',
      hint: 'cave',
    },
    radical: '穴',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '窕',
    definition: 'slender; quiet, modest; charming',
    pinyin: ['tiǎo'],
    decomposition: '⿱穴兆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兆',
      semantic: '穴',
      hint: 'cave',
    },
    radical: '穴',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '窖',
    definition: 'cellar, storeroom',
    pinyin: ['jiào'],
    decomposition: '⿱穴告',
    etymology: {
      type: 'pictophonetic',
      phonetic: '告',
      semantic: '穴',
      hint: 'cave',
    },
    radical: '穴',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '窗',
    definition: 'window',
    pinyin: ['chuāng'],
    decomposition: '⿱穴囱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '囱',
      semantic: '穴',
      hint: 'hole',
    },
    radical: '穴',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '窘',
    definition: 'distressed; embarrassed; hard-pressed',
    pinyin: ['jiǒng'],
    decomposition: '⿱穴君',
    etymology: {
      type: 'pictophonetic',
      phonetic: '君',
      semantic: '穴',
      hint: 'cave',
    },
    radical: '穴',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '窜',
    definition: 'to run away; to expel; to revise, to edit',
    pinyin: ['cuàn'],
    decomposition: '⿱穴串',
    etymology: {
      type: 'ideographic',
      hint: 'Simplified form of 竄; a mouse 鼠 running out of its hole 穴',
    },
    radical: '穴',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '窝',
    definition: 'cave, den, nest; hiding place; measure word for small animals',
    pinyin: ['wō'],
    decomposition: '⿱穴呙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '呙',
      semantic: '穴',
      hint: 'cave',
    },
    radical: '穴',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '窟',
    definition: 'hole, cave; cellar; underground',
    pinyin: ['kū'],
    decomposition: '⿱穴屈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屈',
      semantic: '穴',
      hint: 'cave',
    },
    radical: '穴',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '窠',
    definition: 'den, nest; hole, indentation',
    pinyin: ['kē'],
    decomposition: '⿱穴果',
    etymology: {
      type: 'pictophonetic',
      phonetic: '果',
      semantic: '穴',
      hint: 'hole',
    },
    radical: '穴',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '窣',
    definition: 'to emerge from a hole; rustling, whispering',
    pinyin: ['sū'],
    decomposition: '⿱穴卒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卒',
      semantic: '穴',
      hint: 'hole',
    },
    radical: '穴',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '窥',
    definition: 'to peep, to spy on, to watch',
    pinyin: ['kuī'],
    decomposition: '⿱穴规',
    etymology: {
      type: 'pictophonetic',
      phonetic: '规',
      semantic: '穴',
      hint: 'hole',
    },
    radical: '穴',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '窦',
    definition: 'sinuses; corrupt; surname',
    pinyin: ['dòu'],
    decomposition: '⿱穴卖',
    etymology: {
      type: 'ideographic',
      hint: 'To buy someone off 卖; a nose-hole 穴',
    },
    radical: '穴',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '窨',
    definition: 'cellar, storeroom',
    pinyin: ['xūn'],
    decomposition: '⿱穴音',
    etymology: {
      type: 'pictophonetic',
      phonetic: '音',
      semantic: '穴',
      hint: 'cave',
    },
    radical: '穴',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '窩',
    definition: 'cave, den, nest; hiding place; measure word for small animals',
    pinyin: ['wō'],
    decomposition: '⿱穴咼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咼',
      semantic: '穴',
      hint: 'cave',
    },
    radical: '穴',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '窪',
    definition: 'pit, hollow, depression; swamp',
    pinyin: ['wā'],
    decomposition: '⿱穴洼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '洼',
      semantic: '穴',
      hint: 'cave',
    },
    radical: '穴',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '窬',
    definition: 'door, window; a hole in a wall',
    pinyin: ['yú'],
    decomposition: '⿱穴俞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '俞',
      semantic: '穴',
      hint: 'hole',
    },
    radical: '穴',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '窭',
    definition: 'poor; rustic',
    pinyin: ['jù'],
    decomposition: '⿱穴娄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '娄',
      semantic: '穴',
      hint: 'hole',
    },
    radical: '穴',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '窮',
    definition: 'poor, destitute; to exhaust',
    pinyin: ['qióng'],
    decomposition: '⿱穴躬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '躬',
      semantic: '穴',
      hint: 'cave',
    },
    radical: '穴',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '窯',
    definition: 'kiln, oven; pit, coal mine',
    pinyin: ['yáo'],
    decomposition: '⿱穴羔',
    etymology: {
      type: 'ideographic',
      hint: 'An oven 穴 where lamb 羔 is cooked; 羔 also provides the pronunciation',
    },
    radical: '穴',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '窳',
    definition: 'dirty; weak, useless; cracked, flawed',
    pinyin: ['yǔ'],
    decomposition: '⿱穴㼌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㼌',
      semantic: '穴',
      hint: 'cave',
    },
    radical: '穴',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '窸',
    definition: 'whisper, faint noise',
    pinyin: ['xī'],
    decomposition: '⿱穴悉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '悉',
      semantic: '穴',
      hint: 'cave',
    },
    radical: '穴',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '窺',
    definition: 'to peep, to spy on, to watch',
    pinyin: ['kuī'],
    decomposition: '⿱穴規',
    etymology: {
      type: 'pictophonetic',
      phonetic: '規',
      semantic: '穴',
      hint: 'hole',
    },
    radical: '穴',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '窾',
    definition: 'hole; hallow; empty',
    pinyin: ['kuǎn'],
    decomposition: '⿱穴款',
    etymology: {
      type: 'pictophonetic',
      phonetic: '款',
      semantic: '穴',
      hint: 'cave',
    },
    radical: '穴',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '窿',
    definition: 'mine shaft; cavity, hole',
    pinyin: ['lóng'],
    decomposition: '⿱穴隆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隆',
      semantic: '穴',
      hint: 'hole',
    },
    radical: '穴',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '竄',
    definition: 'to run away; to expel; to revise, to edit',
    pinyin: ['cuàn'],
    decomposition: '⿱穴鼠',
    etymology: {
      type: 'ideographic',
      hint: 'A mouse 鼠 running out of its hole 穴',
    },
    radical: '穴',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '竅',
    definition: 'hole, opening, aperture',
    pinyin: ['qiào'],
    decomposition: '⿱穴敫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敫',
      semantic: '穴',
      hint: 'hole',
    },
    radical: '穴',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '竇',
    definition: 'sinuses; corrupt; surname',
    pinyin: ['dòu'],
    decomposition: '⿱穴賣',
    etymology: {
      type: 'ideographic',
      hint: 'To buy someone off 賣; a nose-hole 穴',
    },
    radical: '穴',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '竈',
    definition: 'furnace; kitchen stove',
    pinyin: ['zào'],
    decomposition: '⿱穴⿱土黽',
    etymology: { type: 'pictophonetic', semantic: '穴', hint: 'hole' },
    radical: '穴',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '竊',
    definition: 'to steal; thief; secret, stealthy',
    pinyin: ['qiè'],
    decomposition: '⿱穴⿰米禼',
    etymology: {
      type: 'ideographic',
      hint: 'Termites 禼 taking grain 米 to their nest 穴',
    },
    radical: '穴',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '立',
    definition: 'to stand; to establish, to set up',
    pinyin: ['lì'],
    decomposition: '⿳亠丷一',
    etymology: {
      type: 'pictographic',
      hint: 'A man standing on the ground 一',
    },
    radical: '立',
    matches: [[0], [0], [1], [1], [2]],
  },
  {
    character: '竖',
    definition: 'perpendicular, vertical; to erect',
    pinyin: ['shù'],
    decomposition: '⿱⿰刂又立',
    etymology: {
      type: 'ideographic',
      hint: 'A person 又 standing 立 as straight as a knife 刂',
    },
    radical: '立',
    matches: [[0, 0], [0, 0], [0, 1], [0, 1], [1], [1], [1], [1], [1]],
  },
  {
    character: '竘',
    pinyin: ['qǔ'],
    decomposition: '⿰立句',
    etymology: { type: 'pictophonetic', phonetic: '句', semantic: '立' },
    radical: '立',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '站',
    definition:
      'stand, station; to halt, to stand; website; measure word for stands and stations',
    pinyin: ['zhàn'],
    decomposition: '⿰立占',
    etymology: {
      type: 'pictophonetic',
      phonetic: '占',
      semantic: '立',
      hint: 'stand',
    },
    radical: '立',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '竞',
    definition: 'to compete, to contend, to vie',
    pinyin: ['jìng'],
    decomposition: '⿱立兄',
    etymology: { type: 'ideographic', hint: 'To stand up 立 to a foe 兄' },
    radical: '立',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '竟',
    definition: 'finally, after all, at last; indeed; unexpected',
    pinyin: ['jìng'],
    decomposition: '⿱音儿',
    etymology: {
      type: 'ideographic',
      hint: 'A person 儿 finishing a musical piece 音',
    },
    radical: '立',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '章',
    definition: 'chapter, section, writing; seal',
    pinyin: ['zhāng'],
    decomposition: '⿱音十',
    etymology: {
      type: 'ideographic',
      hint: 'The ten 十 movements of a piece of music 音',
    },
    radical: '立',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '竣',
    definition: 'to terminate, to finish, to end; to quit',
    pinyin: ['jùn'],
    decomposition: '⿰立夋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夋',
      semantic: '立',
      hint: 'stand',
    },
    radical: '立',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '童',
    definition: 'child, boy; servant boy; virgin',
    pinyin: ['tóng'],
    decomposition: '⿱立里',
    etymology: {
      type: 'ideographic',
      hint: 'A child standing 立 in the village 里',
    },
    radical: '立',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '竦',
    definition: 'to revere, to respect; to be in awe of',
    pinyin: ['sǒng'],
    decomposition: '⿰立束',
    radical: '立',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '竭',
    definition: 'to exhaust; to put forth great effort',
    pinyin: ['jié'],
    decomposition: '⿰立曷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曷',
      semantic: '立',
      hint: 'stand',
    },
    radical: '立',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '端',
    definition: 'end, extreme; head; beginning',
    pinyin: ['duān'],
    decomposition: '⿰立耑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '耑',
      semantic: '立',
      hint: 'stand',
    },
    radical: '立',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '競',
    definition: 'to compete, to contend, to vie',
    pinyin: ['jìng'],
    decomposition: '⿰竞竞',
    etymology: {
      type: 'ideographic',
      hint: 'Two people 竞 locked in a struggle',
    },
    radical: '立',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '竹',
    definition: 'bamboo; flute',
    pinyin: ['zhú'],
    decomposition: '⿰？？',
    etymology: { type: 'pictographic', hint: 'Two stalks of bamboo' },
    radical: '竹',
    matches: [null, null, null, null, null, null],
  },
  {
    character: '竺',
    definition: 'India; bamboo; surname',
    pinyin: ['zhú'],
    decomposition: '⿱⺮二',
    etymology: {
      type: 'ideographic',
      hint: 'A kind 二 of bamboo ⺮; ⺮ also provides the pronunciation',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '竽',
    definition: 'free reed mouth organ',
    pinyin: ['yú'],
    decomposition: '⿱⺮于',
    etymology: {
      type: 'pictophonetic',
      phonetic: '于',
      semantic: '⺮',
      hint: 'flute',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '竿',
    definition: 'bamboo pole; penis',
    pinyin: ['gān'],
    decomposition: '⿱⺮干',
    etymology: {
      type: 'pictophonetic',
      phonetic: '干',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '笃',
    definition: 'deep, serious; genuine, sincere, true',
    pinyin: ['dǔ'],
    decomposition: '⿱⺮马',
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '笄',
    definition: 'hairpin; fifteen-year-old girl',
    pinyin: ['jī'],
    decomposition: '⿱⺮开',
    etymology: {
      type: 'pictophonetic',
      phonetic: '开',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '笆',
    definition: 'bamboo fence',
    pinyin: ['bā'],
    decomposition: '⿱⺮巴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巴',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '笈',
    definition: 'bamboo box used carry books',
    pinyin: ['jí'],
    decomposition: '⿱⺮及',
    etymology: {
      type: 'pictophonetic',
      phonetic: '及',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '笊',
    definition: 'bamboo ladle, bamboo skimmer',
    pinyin: ['zhào'],
    decomposition: '⿱⺮爪',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爪',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '笋',
    definition: 'bamboo shoots',
    pinyin: ['sǔn'],
    decomposition: '⿱⺮尹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尹',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '笏',
    definition: 'a tablet held by an overseer',
    pinyin: ['hù'],
    decomposition: '⿱⺮勿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '勿',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '笑',
    definition: 'to smile, to laugh; to giggle; to snicker',
    pinyin: ['xiào'],
    decomposition: '⿱⺮夭',
    etymology: { type: 'ideographic', hint: 'A person 夭 with a big grin ⺮' },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '笔',
    definition:
      'pen, pencil, writing brush; to compose, to write; Hanzi stroke',
    pinyin: ['bǐ'],
    decomposition: '⿱⺮毛',
    etymology: {
      type: 'ideographic',
      hint: 'A bamboo rod ⺮ tipped with hair 毛',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '笕',
    definition: 'bamboo water pipe',
    pinyin: ['jiǎn'],
    decomposition: '⿱⺮见',
    etymology: {
      type: 'pictophonetic',
      phonetic: '见',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '笙',
    definition: 'free reed mouth organ',
    pinyin: ['shēng'],
    decomposition: '⿱⺮生',
    etymology: {
      type: 'pictophonetic',
      phonetic: '生',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '笛',
    definition: 'bamboo flute; whistle',
    pinyin: ['dí'],
    decomposition: '⿱⺮由',
    etymology: { type: 'ideographic', hint: 'A bamboo ⺮ flute 由' },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '笞',
    definition: 'bamboo rod used for beatings',
    pinyin: ['chī'],
    decomposition: '⿱⺮台',
    etymology: {
      type: 'pictophonetic',
      phonetic: '台',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '笠',
    definition: 'bamboo hat; bamboo covering',
    pinyin: ['lì'],
    decomposition: '⿱⺮立',
    etymology: {
      type: 'pictophonetic',
      phonetic: '立',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '笤',
    definition: 'broom, besom',
    pinyin: ['tiáo'],
    decomposition: '⿱⺮召',
    etymology: {
      type: 'pictophonetic',
      phonetic: '召',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '笥',
    definition: 'hamper, wicker basket',
    pinyin: ['sì'],
    decomposition: '⿱⺮司',
    etymology: {
      type: 'pictophonetic',
      phonetic: '司',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '符',
    definition: 'amulet, charm; mark, tag; to correspond to',
    pinyin: ['fú'],
    decomposition: '⿱⺮付',
    etymology: {
      type: 'pictophonetic',
      phonetic: '付',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '笨',
    definition: 'stupid, foolish, dull, awkward',
    pinyin: ['bèn'],
    decomposition: '⿱⺮本',
    etymology: {
      type: 'pictophonetic',
      phonetic: '本',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '笪',
    definition: 'a coarse mat of rushes or bamboo',
    pinyin: ['dá'],
    decomposition: '⿱⺮旦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旦',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '笫',
    definition: 'bed boards, sleeping mat',
    pinyin: ['zǐ'],
    decomposition: '⿱⺮？',
    etymology: { type: 'pictophonetic', hint: 'bamboo', semantic: '⺮' },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], null, null, null, null],
  },
  {
    character: '第',
    definition:
      'sequence, number; grade, degree; particle prefacing an ordinal',
    pinyin: ['dì'],
    decomposition: '⿱⺮弟',
    etymology: {
      type: 'ideographic',
      hint: 'Bamboo strips ⺮ arrayed in sequence; 弟 provides the pronunciation',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '笮',
    definition: 'boards that support roof tiles',
    pinyin: ['zé'],
    decomposition: '⿱⺮乍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乍',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '笱',
    definition: 'a basket trap for fish',
    pinyin: ['gǒu'],
    decomposition: '⿱⺮句',
    etymology: {
      type: 'pictophonetic',
      phonetic: '句',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '笳',
    definition: 'reed whistle',
    pinyin: ['jiā'],
    decomposition: '⿱⺮加',
    etymology: {
      type: 'pictophonetic',
      phonetic: '加',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '笸',
    definition: 'a flat grain basket',
    pinyin: ['pǒ'],
    decomposition: '⿱⺮叵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叵',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '笺',
    definition: 'note, memo, letter; stationery; comments',
    pinyin: ['jiān'],
    decomposition: '⿱⺮戋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戋',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '笼',
    definition: 'basket; cage; bamboo basket used to serve dimsum',
    pinyin: ['lóng'],
    decomposition: '⿱⺮龙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龙',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '笾',
    definition: 'bamboo container for food',
    pinyin: ['biān'],
    decomposition: '⿱⺮边',
    etymology: {
      type: 'pictophonetic',
      phonetic: '边',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '筀',
    definition: 'bamboo (archaic)',
    pinyin: ['guì'],
    decomposition: '⿱⺮圭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '圭',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '筅',
    definition: 'bamboo brush',
    pinyin: ['xiǎn'],
    decomposition: '⿱⺮先',
    etymology: {
      type: 'pictophonetic',
      phonetic: '先',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '筆',
    definition:
      'pen, pencil, writing brush; to compose, to write; Hanzi stroke',
    pinyin: ['bǐ'],
    decomposition: '⿱⺮聿',
    etymology: {
      type: 'ideographic',
      hint: 'A bamboo rod ⺮ used as a pencil 聿',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '筇',
    definition: 'bamboo staff',
    pinyin: ['qióng'],
    decomposition: '⿱⺮邛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '邛',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '等',
    definition: 'rank, grade; same, equal; to wait',
    pinyin: ['děng'],
    decomposition: '⿱⺮寺',
    etymology: {
      type: 'ideographic',
      hint: 'Bamboo strips ⺮ laid before a court 寺',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '筊',
    definition: 'bamboo rope',
    pinyin: ['xiáo'],
    decomposition: '⿱⺮交',
    etymology: {
      type: 'ideographic',
      hint: 'Bamboo ⺮ used to tie 交 things; 交 also provides the pronunciation',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '筋',
    definition: 'muscles; tendons',
    pinyin: ['jīn'],
    decomposition: '⿱⺮肋',
    etymology: {
      type: 'ideographic',
      hint: 'Bamboo-like ⺮ tendons in the chest 肋',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '筌',
    definition: 'bamboo fish trap',
    pinyin: ['quán'],
    decomposition: '⿱⺮全',
    etymology: {
      type: 'pictophonetic',
      phonetic: '全',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '筏',
    definition: 'raft',
    pinyin: ['fá'],
    decomposition: '⿱⺮伐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '伐',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '筐',
    definition: 'bamboo basket or chest',
    pinyin: ['kuāng'],
    decomposition: '⿱⺮匡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匡',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '筑',
    definition: 'building; a five-string lute',
    pinyin: ['zhù'],
    decomposition: '⿱⺮巩',
    etymology: {
      type: 'ideographic',
      hint: 'A strong  巩 bamboo ⺮ building; ⺮ also provides the pronunciation',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '筒',
    definition: 'tube, pipe, cylinder; a thick piece of bamboo',
    pinyin: ['tǒng'],
    decomposition: '⿱⺮同',
    etymology: {
      type: 'pictophonetic',
      phonetic: '同',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '答',
    definition: 'answer, reply; to return; to assent to',
    pinyin: ['dá'],
    decomposition: '⿱⺮合',
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '筕',
    definition: 'woven bamboo mat',
    pinyin: ['háng'],
    decomposition: '⿱⺮行',
    etymology: {
      type: 'pictophonetic',
      phonetic: '行',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '策',
    definition: 'to urge, to whip; method, plan, policy',
    pinyin: ['cè'],
    decomposition: '⿱⺮朿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朿',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '筘',
    definition: 'a roll of cloth',
    pinyin: ['kòu'],
    decomposition: '⿱⺮扣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '扣',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '筚',
    definition: 'wicker, bamboo',
    pinyin: ['bì'],
    decomposition: '⿱⺮毕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '毕',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '筛',
    definition: 'screen, sieve; to filter, to sift',
    pinyin: ['shāi'],
    decomposition: '⿱⺮师',
    etymology: {
      type: 'pictophonetic',
      phonetic: '师',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '筜',
    definition: 'tall bamboo',
    pinyin: ['dāng'],
    decomposition: '⿱⺮当',
    etymology: {
      type: 'pictophonetic',
      phonetic: '当',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '筝',
    definition: 'guzheng, zither, string instrument',
    pinyin: ['zhēng'],
    decomposition: '⿱⺮争',
    etymology: {
      type: 'pictophonetic',
      phonetic: '争',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '筠',
    definition: 'bamboo skin',
    pinyin: ['yún'],
    decomposition: '⿱⺮均',
    etymology: {
      type: 'pictophonetic',
      phonetic: '均',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '筢',
    definition: 'rake',
    pinyin: ['pá'],
    decomposition: '⿱⺮把',
    etymology: {
      type: 'pictophonetic',
      phonetic: '把',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '筦',
    definition: 'key; pipe; to be in charge',
    pinyin: ['guǎn'],
    decomposition: '⿱⺮完',
    etymology: {
      type: 'pictophonetic',
      phonetic: '完',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '筮',
    definition: 'divination using the stalks of plants; divining rod',
    pinyin: ['shì'],
    decomposition: '⿱⺮巫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '⺮',
      semantic: '巫',
      hint: 'divining rod',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '筱',
    definition: 'dwarf bamboo; a diminutive in a nickname',
    pinyin: ['xiǎo'],
    decomposition: '⿱⺮攸',
    etymology: {
      type: 'ideographic',
      hint: 'Distant 攸 bamboo ⺮; 小 provides the pronunciation',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '筲',
    definition: 'basket, bucket',
    pinyin: ['shāo'],
    decomposition: '⿱⺮肖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肖',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '筵',
    definition: 'bamboo mat; banquet, feast',
    pinyin: ['yán'],
    decomposition: '⿱⺮延',
    etymology: {
      type: 'pictophonetic',
      phonetic: '延',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '筷',
    definition: 'chopsticks',
    pinyin: ['kuài'],
    decomposition: '⿱⺮快',
    etymology: {
      type: 'pictophonetic',
      phonetic: '快',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '筹',
    definition: 'chip, tally, token; to plan; to raise money',
    pinyin: ['chóu'],
    decomposition: '⿱⺮寿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寿',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '筻',
    definition: 'a place in Hunan province',
    pinyin: ['gàng'],
    decomposition: '⿱⺮更',
    etymology: {
      type: 'pictophonetic',
      phonetic: '更',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '筼',
    definition: 'tall bamboo',
    pinyin: ['yún'],
    decomposition: '⿱⺮员',
    etymology: {
      type: 'pictophonetic',
      phonetic: '员',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '签',
    definition: 'to sign, to endorse; a note, a slip of paper',
    pinyin: ['qiān'],
    decomposition: '⿱⺮佥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '佥',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '简',
    definition: 'simple, succinct, terse; a letter',
    pinyin: ['jiǎn'],
    decomposition: '⿱⺮间',
    etymology: {
      type: 'pictophonetic',
      phonetic: '间',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '箅',
    pinyin: ['bì'],
    decomposition: '⿱⺮畀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畀',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '箋',
    definition: 'note, memo, letter; stationery; comments',
    pinyin: ['jiān'],
    decomposition: '⿱⺮戔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戔',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '箍',
    definition: 'hoop; to surround, to bind',
    pinyin: ['gū'],
    decomposition: '⿱⺮㧜',
    etymology: {
      type: 'ideographic',
      hint: 'Bamboo ⺮ bindings 㧜; 㧜 also provides the pronunciation',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '箐',
    definition: 'to draw a bamboo bow',
    pinyin: ['qìng'],
    decomposition: '⿱⺮青',
    etymology: {
      type: 'pictophonetic',
      phonetic: '青',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '箓',
    definition: 'book, record; book of prophecy',
    pinyin: ['lù'],
    decomposition: '⿱⺮录',
    etymology: {
      type: 'ideographic',
      hint: 'A bamboo ⺮ record 录; 录 also provides the pronunciation',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '箔',
    definition: 'screen, foil, plaited matting; silkworm basket',
    pinyin: ['bó'],
    decomposition: '⿱⺮泊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '泊',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '箕',
    definition: 'sieve; dust pan; garbage bag',
    pinyin: ['jī'],
    decomposition: '⿱⺮其',
    etymology: {
      type: 'pictophonetic',
      phonetic: '其',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '算',
    definition: 'to calculate, to count; to figure, to plan',
    pinyin: ['suàn'],
    decomposition: '⿱⺮具',
    etymology: { type: 'ideographic', hint: 'A bamboo ⺮ abacus 具' },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '箜',
    definition: 'ancient Chinese harp',
    pinyin: ['kōng'],
    decomposition: '⿱⺮空',
    etymology: {
      type: 'pictophonetic',
      phonetic: '空',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '箝',
    definition: 'tweezers, pincers; pliers, tongs',
    pinyin: ['qián'],
    decomposition: '⿱⺮拑',
    etymology: {
      type: 'ideographic',
      hint: 'Bamboo ⺮ used to grasp 拑 things; 拑 also provides the pronunciation',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '管',
    definition: 'tube, pipe, duct; to manage, to control',
    pinyin: ['guǎn'],
    decomposition: '⿱⺮官',
    etymology: {
      type: 'pictophonetic',
      phonetic: '官',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '箢',
    pinyin: ['yuān'],
    decomposition: '⿱⺮宛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宛',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '箦',
    definition: 'reed mat; bedding',
    pinyin: ['zé'],
    decomposition: '⿱⺮责',
    etymology: {
      type: 'pictophonetic',
      phonetic: '责',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '箧',
    definition: 'trunk, chest, box; portfolio',
    pinyin: ['qiè'],
    decomposition: '⿱⺮⿷匚夹',
    etymology: {
      type: 'ideographic',
      hint: 'A bamboo ⺮ box 匚; 夹 provides the pronunciation',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 0],
    ],
  },
  {
    character: '箨',
    definition: 'bamboo sheath, bamboo shoots',
    pinyin: ['tuò'],
    decomposition: '⿱⺮择',
    etymology: {
      type: 'pictophonetic',
      phonetic: '择',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '箩',
    definition: 'bamboo basket',
    pinyin: ['luó'],
    decomposition: '⿱⺮罗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '罗',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '箪',
    definition: 'a small bamboo basket for rice',
    pinyin: ['dān'],
    decomposition: '⿱⺮单',
    etymology: {
      type: 'pictophonetic',
      phonetic: '单',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '箫',
    definition: 'bamboo flute',
    pinyin: ['xiāo'],
    decomposition: '⿱⺮肃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肃',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '箬',
    definition: 'bamboo skin; broad-leaved bamboo',
    pinyin: ['ruò'],
    decomposition: '⿱⺮若',
    etymology: {
      type: 'pictophonetic',
      phonetic: '若',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '箭',
    definition: 'arrow; a type of bamboo',
    pinyin: ['jiàn'],
    decomposition: '⿱⺮前',
    etymology: {
      type: 'pictophonetic',
      phonetic: '前',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '箱',
    definition: 'box, case; chest, trunk',
    pinyin: ['xiāng'],
    decomposition: '⿱⺮相',
    etymology: {
      type: 'pictophonetic',
      phonetic: '相',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '箴',
    definition: 'needle, probe; to admonish, to warn',
    pinyin: ['zhēn'],
    decomposition: '⿱⺮咸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咸',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '箸',
    definition: 'chopsticks',
    pinyin: ['zhù'],
    decomposition: '⿱⺮者',
    etymology: {
      type: 'pictophonetic',
      phonetic: '者',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '節',
    definition: 'festival; knot, joint; segment; to economize, to save',
    pinyin: ['jié'],
    decomposition: '⿱⺮即',
    etymology: {
      type: 'pictophonetic',
      phonetic: '即',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '篁',
    definition: 'bamboo grove',
    pinyin: ['huáng'],
    decomposition: '⿱⺮皇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皇',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '範',
    definition: 'pattern, model, example; surname',
    pinyin: ['fàn'],
    decomposition: '⿱⺮⿰車㔾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㔾',
      hint: 'bamboo',
      semantic: '⺮',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '篆',
    definition: 'seal script; seal, stamp',
    pinyin: ['zhuàn'],
    decomposition: '⿱⺮彖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彖',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '篇',
    definition: 'chapter, section; article, essay',
    pinyin: ['piān'],
    decomposition: '⿱⺮扁',
    etymology: {
      type: 'ideographic',
      hint: 'A bamboo ⺮ tablet 扁; 扁 also provides the pronunciation',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '築',
    definition: 'building; a five-string lute',
    pinyin: ['zhù'],
    decomposition: '⿱⺮⿱巩木',
    etymology: {
      type: 'ideographic',
      hint: 'A building 巩 of bamboo ⺮ and wood 木; ⺮also provides the pronunciation',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '篋',
    definition: 'trunk, chest, box; portfolio',
    pinyin: ['qiè'],
    decomposition: '⿱⺮匧',
    etymology: {
      type: 'ideographic',
      hint: 'A bamboo ⺮ chest 匧; 匧 also provides the pronunciation',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '篌',
    definition: 'ancient Chinese harp',
    pinyin: ['hóu'],
    decomposition: '⿱⺮侯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '侯',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '篑',
    definition: 'a bamboo basket for carrying soil',
    pinyin: ['kuì'],
    decomposition: '⿱⺮贵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贵',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '篓',
    definition: 'bamboo basket',
    pinyin: ['lǒu'],
    decomposition: '⿱⺮娄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '娄',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '篔',
    definition: 'tall bamboo',
    pinyin: ['yún'],
    decomposition: '⿱⺮員',
    etymology: {
      type: 'pictophonetic',
      phonetic: '員',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '篙',
    definition: 'a pole used to punt a boat',
    pinyin: ['gāo'],
    decomposition: '⿱⺮高',
    etymology: {
      type: 'pictophonetic',
      phonetic: '高',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '篚',
    definition: 'round covered-basket',
    pinyin: ['fěi'],
    decomposition: '⿱⺮匪',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匪',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '篝',
    definition: 'bamboo basket; bamboo frame',
    pinyin: ['gōu'],
    decomposition: '⿱⺮冓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冓',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '篡',
    definition: 'to sieze, to usurp',
    pinyin: ['cuàn'],
    decomposition: '⿱算厶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '算',
      semantic: '厶',
      hint: 'private',
    },
    radical: '厶',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '篤',
    definition: 'deep, serious; genuine, sincere, true',
    pinyin: ['dǔ'],
    decomposition: '⿱⺮馬',
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '篥',
    definition: 'bugle, Tartar horn',
    pinyin: ['lì'],
    decomposition: '⿱⺮栗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '栗',
      semantic: '⺮',
      hint: 'flute',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '篦',
    definition: "fine-toothed comb; to comb one's hair",
    pinyin: ['bì'],
    decomposition: '⿳⺮囟比',
    etymology: {
      type: 'ideographic',
      hint: 'A bamboo ⺮ hair 囟 comb; 比 provides the pronunciation',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '篩',
    definition: 'screen, sieve; to filter, to sift',
    pinyin: ['shāi'],
    decomposition: '⿱⺮師',
    etymology: {
      type: 'pictophonetic',
      phonetic: '師',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '篪',
    definition: 'bamboo flute',
    pinyin: ['chí'],
    decomposition: '⿱⺮虒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '虒',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '篮',
    definition: 'basket; goal',
    pinyin: ['lán'],
    decomposition: '⿱⺮监',
    etymology: {
      type: 'pictophonetic',
      phonetic: '监',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '篱',
    definition: 'bamboo fence; fence, hedge',
    pinyin: ['lí'],
    decomposition: '⿱⺮离',
    etymology: {
      type: 'pictophonetic',
      phonetic: '离',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '篳',
    definition: 'wicker, bamboo',
    pinyin: ['bì'],
    decomposition: '⿱⺮畢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畢',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '篷',
    definition: 'awning, covering; sail, tarp; boat',
    pinyin: ['péng'],
    decomposition: '⿱⺮逢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '逢',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '篹',
    definition: 'to edit; to collect; a bamboo basket',
    pinyin: ['zhuàn'],
    decomposition: '⿱算㔾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '算',
      semantic: '㔾',
      hint: 'seal',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '篼',
    definition: 'wicker basket; sedan chair',
    pinyin: ['dōu'],
    decomposition: '⿱⺮兜',
    etymology: {
      type: 'ideographic',
      hint: 'A bamboo ⺮ pouch 兜; 兜 also provides the pronunciation',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '篾',
    definition: 'bamboo splints or slats',
    pinyin: ['miè'],
    decomposition: '⿱⺮⿱罒戍',
    etymology: {
      type: 'ideographic',
      hint: 'A framework 罒 made of bamboo ⺮',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '簇',
    definition: 'bunch, cluster; crowd, swarm',
    pinyin: ['cù'],
    decomposition: '⿱⺮族',
    etymology: {
      type: 'pictophonetic',
      phonetic: '族',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '簉',
    definition: 'subordinate; deputy; concubine',
    pinyin: ['zào'],
    decomposition: '⿱⺮造',
    etymology: {
      type: 'pictophonetic',
      phonetic: '造',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '簋',
    definition: 'bamboo basket for grain',
    pinyin: ['guǐ'],
    decomposition: '⿱⺮⿱艮皿',
    etymology: {
      type: 'ideographic',
      hint: 'A bamboo ⺮ basket 皿 used to store food 艮',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '簌',
    definition: 'to rustle; falling flower petals',
    pinyin: ['sù'],
    decomposition: '⿱⺮欶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '欶',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '簏',
    definition: 'box, basket',
    pinyin: ['lù'],
    decomposition: '⿱⺮鹿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鹿',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '簖',
    definition: 'a bamboo trap for catching fish',
    pinyin: ['duàn'],
    decomposition: '⿱⺮断',
    etymology: {
      type: 'pictophonetic',
      phonetic: '断',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '簞',
    definition: 'a small bamboo basket for rice',
    pinyin: ['dān'],
    decomposition: '⿱⺮單',
    etymology: {
      type: 'pictophonetic',
      phonetic: '單',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '簟',
    definition: 'bamboo mat',
    pinyin: ['diàn'],
    decomposition: '⿱⺮覃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '覃',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '簡',
    definition: 'simple, succinct, terse; a letter',
    pinyin: ['jiǎn'],
    decomposition: '⿱⺮間',
    etymology: {
      type: 'pictophonetic',
      phonetic: '間',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '簣',
    definition: 'a bamboo basket for carrying soil',
    pinyin: ['kuì'],
    decomposition: '⿱⺮貴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '貴',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '簦',
    definition: "bamboo or straw hat; street-vendor's umbrella",
    pinyin: ['dēng'],
    decomposition: '⿱⺮登',
    etymology: {
      type: 'pictophonetic',
      phonetic: '登',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '簧',
    definition: 'reed; lock, metal spring',
    pinyin: ['huáng'],
    decomposition: '⿱⺮黄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '黄',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '簪',
    definition: 'hairpin, clasp; to wear in the hair',
    pinyin: ['zān'],
    decomposition: '⿱⺮朁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朁',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '簫',
    definition: 'bamboo flute',
    pinyin: ['xiāo'],
    decomposition: '⿱⺮肅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肅',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '簷',
    definition: 'edge, brim; the eaves of a house',
    pinyin: ['yán'],
    decomposition: '⿱⺮詹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '詹',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '簸',
    definition: 'dustpan; to winnow, to toss',
    pinyin: ['bǒ'],
    decomposition: '⿱⺮⿰其皮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皮',
      hint: 'bamboo',
      semantic: '⺮',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '簹',
    definition: 'tall bamboo',
    pinyin: ['dāng'],
    decomposition: '⿱⺮當',
    etymology: {
      type: 'pictophonetic',
      phonetic: '當',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '簽',
    definition: 'to sign, to endorse; a note, a slip of paper',
    pinyin: ['qiān'],
    decomposition: '⿱⺮僉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '僉',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '簾',
    definition: 'the flag-sign of a tavern',
    pinyin: ['lián'],
    decomposition: '⿱⺮廉',
    etymology: { type: 'ideographic', hint: 'An upright 廉 bamboo ⺮ sign' },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '簿',
    definition: 'register, notebook, account book',
    pinyin: ['bù'],
    decomposition: '⿱⺮溥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '溥',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '籀',
    definition: 'to read, to recite; a style of calligraphy',
    pinyin: ['zhòu'],
    decomposition: '⿱⺮⿰扌留',
    etymology: {
      type: 'ideographic',
      hint: 'A hand 扌 writing 留 with a bamboo ⺮ brush',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '籁',
    definition: 'bamboo flute; flute, pipe; a musical note',
    pinyin: ['lài'],
    decomposition: '⿱⺮赖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '赖',
      semantic: '⺮',
      hint: 'flute',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '籃',
    definition: 'basket; goal',
    pinyin: ['lán'],
    decomposition: '⿱⺮監',
    etymology: {
      type: 'pictophonetic',
      phonetic: '監',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '籌',
    definition: 'chip, tally, token; to plan; to raise money',
    pinyin: ['chóu'],
    decomposition: '⿱⺮壽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '壽',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '籍',
    definition: 'register, record, list, census',
    pinyin: ['jí'],
    decomposition: '⿱⺮耤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '耤',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '籑',
    definition: 'to feed, to provide for; danties, delicacies',
    pinyin: ['zhuàn'],
    decomposition: '⿱算良',
    etymology: {
      type: 'pictophonetic',
      phonetic: '算',
      semantic: '食',
      hint: 'food',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '籙',
    definition: 'book, record; book of prophecy',
    pinyin: ['lù'],
    decomposition: '⿱⺮録',
    etymology: {
      type: 'ideographic',
      hint: 'A bamboo ⺮ record 録; 録 also provides the pronunciation',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '籟',
    definition: 'bamboo flute; flute, pipe; a musical note',
    pinyin: ['lài'],
    decomposition: '⿱⺮賴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '賴',
      semantic: '⺮',
      hint: 'flute',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '籠',
    definition: 'basket; cage; bamboo basket used to serve dimsum',
    pinyin: ['lóng'],
    decomposition: '⿱⺮龍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龍',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '籤',
    definition: 'label, marker, tag; signature; visa',
    pinyin: ['qiān'],
    decomposition: '⿱⺮韱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韱',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '籬',
    definition: 'bamboo fence; fence, hedge',
    pinyin: ['lí'],
    decomposition: '⿱⺮離',
    etymology: {
      type: 'pictophonetic',
      phonetic: '離',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '籮',
    definition: 'bamboo basket',
    pinyin: ['luó'],
    decomposition: '⿱⺮羅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羅',
      semantic: '⺮',
      hint: 'bamboo',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '籲',
    definition: 'to appeal, to request; to beg, to implore',
    pinyin: ['yù'],
    decomposition: '⿱⺮龥',
    etymology: {
      type: 'ideographic',
      hint: 'To beg 龥 by playing a bamboo flute 录; 龥 also provides the pronunciation',
    },
    radical: '⺮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '米',
    definition: 'rice, millet, grain',
    pinyin: ['mǐ'],
    decomposition: '⿻丷木',
    etymology: { type: 'pictographic', hint: 'Grains of rice' },
    radical: '米',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '籴',
    definition: 'to purchase grain; to store grain',
    pinyin: ['dí'],
    decomposition: '⿱入米',
    etymology: {
      type: 'ideographic',
      hint: 'A house 入 where grain 米 is stored',
    },
    radical: '米',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '类',
    definition: 'category, class, group, kind; similar to; to resemble',
    pinyin: ['lèi'],
    decomposition: '⿱米大',
    radical: '大',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '籼',
    definition: 'non-glutinous long-grain rice',
    pinyin: ['xiān'],
    decomposition: '⿰米山',
    etymology: {
      type: 'pictophonetic',
      phonetic: '山',
      semantic: '米',
      hint: 'rice',
    },
    radical: '米',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '籽',
    definition: 'seed, pit, pip',
    pinyin: ['zǐ'],
    decomposition: '⿰米子',
    etymology: {
      type: 'ideographic',
      hint: 'A grain 米 seed 子; 子 also provides the pronunciation',
    },
    radical: '米',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '粉',
    definition: 'powder, flour, cosmetic powder; plaster',
    pinyin: ['fěn'],
    decomposition: '⿰米分',
    etymology: {
      type: 'pictophonetic',
      phonetic: '分',
      semantic: '米',
      hint: 'grain',
    },
    radical: '米',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '粑',
    definition: 'tsamba, flat rice cake',
    pinyin: ['bā'],
    decomposition: '⿰米巴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巴',
      semantic: '米',
      hint: 'rice',
    },
    radical: '米',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '粒',
    definition: 'grain, granule; bullet, pellet',
    pinyin: ['lì'],
    decomposition: '⿰米立',
    etymology: {
      type: 'pictophonetic',
      phonetic: '立',
      semantic: '米',
      hint: 'grain',
    },
    radical: '米',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '粕',
    definition: 'sediment, lees, dregs',
    pinyin: ['pò'],
    decomposition: '⿰米白',
    etymology: {
      type: 'pictophonetic',
      phonetic: '白',
      semantic: '米',
      hint: 'grain',
    },
    radical: '米',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '粗',
    definition: 'rough, think; coarse, rude',
    pinyin: ['cū'],
    decomposition: '⿰米且',
    etymology: {
      type: 'pictophonetic',
      phonetic: '且',
      semantic: '米',
      hint: 'grain',
    },
    radical: '米',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '粘',
    definition: 'viscous, sticky, mucous, glutinous',
    pinyin: ['zhān'],
    decomposition: '⿰米占',
    etymology: {
      type: 'pictophonetic',
      phonetic: '占',
      semantic: '米',
      hint: 'grain',
    },
    radical: '米',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '粜',
    definition: 'to sell grain',
    pinyin: ['tiào'],
    decomposition: '⿱出米',
    etymology: {
      type: 'ideographic',
      hint: 'A stand 出 where grain 米 is sold',
    },
    radical: '米',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '粝',
    definition: 'coarse rice; brown rice',
    pinyin: ['lì'],
    decomposition: '⿰米厉',
    etymology: {
      type: 'ideographic',
      hint: 'Rice 米 that must be ground 厉; 厉 also provides the pronunciation',
    },
    radical: '米',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '粞',
    definition: 'ground rice; to thresh rice',
    pinyin: ['xī'],
    decomposition: '⿰米西',
    etymology: {
      type: 'pictophonetic',
      phonetic: '西',
      semantic: '米',
      hint: 'rice',
    },
    radical: '米',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '粟',
    definition: 'oats, millet, barley',
    pinyin: ['sù'],
    decomposition: '⿱覀米',
    etymology: {
      type: 'ideographic',
      hint: 'A millet plant 米 bearing grain 覀',
    },
    radical: '米',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '粢',
    definition: 'common millet; grain offered as a sacrifice',
    pinyin: ['zī'],
    decomposition: '⿱次米',
    etymology: {
      type: 'pictophonetic',
      phonetic: '次',
      semantic: '米',
      hint: 'millet',
    },
    radical: '米',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '粤',
    definition: 'Cantonese; Guandong province',
    pinyin: ['yuè'],
    decomposition: '⿱⿴囗米丂',
    radical: '米',
    matches: [
      null,
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 0],
      [1],
      [1],
    ],
  },
  {
    character: '粥',
    definition: 'porridge, gruel, congee',
    pinyin: ['zhōu'],
    decomposition: '⿲弓米弓',
    etymology: { type: 'ideographic', hint: 'Steaming 弓 rice 米' },
    radical: '米',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [2], [2], [2]],
  },
  {
    character: '粦',
    definition: 'phosphorus',
    pinyin: ['lín'],
    decomposition: '⿱米舛',
    radical: '米',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '粪',
    definition: 'manure, dung; shit, excrement',
    pinyin: ['fèn'],
    decomposition: '⿱米共',
    etymology: {
      type: 'pictophonetic',
      phonetic: '共',
      semantic: '米',
      hint: 'grain',
    },
    radical: '米',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '粮',
    definition: 'food, grain, provisions',
    pinyin: ['liáng'],
    decomposition: '⿰米良',
    etymology: {
      type: 'pictophonetic',
      phonetic: '良',
      semantic: '米',
      hint: 'grain',
    },
    radical: '米',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '粱',
    definition: 'sorghum, millet',
    pinyin: ['liáng'],
    decomposition: '⿱⿰氵刅米',
    etymology: {
      type: 'pictophonetic',
      phonetic: '刅',
      semantic: '米',
      hint: 'millet',
    },
    radical: '米',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '粲',
    definition: 'bright, radiant; smiling; to polish',
    pinyin: ['càn'],
    decomposition: '⿱⿰歺又米',
    radical: '米',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '粳',
    definition: 'non-glutinous rice',
    pinyin: ['jīng'],
    decomposition: '⿰米更',
    etymology: {
      type: 'pictophonetic',
      phonetic: '更',
      semantic: '米',
      hint: 'rice',
    },
    radical: '米',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '粵',
    definition: 'Cantonese; Guandong province',
    pinyin: ['yuè'],
    decomposition: '⿱⿴囗釆丂',
    radical: '米',
    matches: [
      null,
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 0],
      [1],
      [1],
    ],
  },
  {
    character: '粹',
    definition: 'pure, unadulterated; essence',
    pinyin: ['cuì'],
    decomposition: '⿰米卒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卒',
      semantic: '米',
      hint: 'grain',
    },
    radical: '米',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '粼',
    definition: 'clear, limpid (as of water)',
    pinyin: ['lín'],
    decomposition: '⿰粦巛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '粦',
      semantic: '巛',
      hint: 'river',
    },
    radical: '米',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '粽',
    definition: 'a dumpling made of glutinous rice',
    pinyin: ['zòng'],
    decomposition: '⿰米宗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宗',
      semantic: '米',
      hint: 'rice',
    },
    radical: '米',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '精',
    definition: 'essence, germ, spirit',
    pinyin: ['jīng'],
    decomposition: '⿰米青',
    etymology: {
      type: 'pictophonetic',
      phonetic: '青',
      semantic: '米',
      hint: 'grain',
    },
    radical: '米',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '糁',
    definition: 'to mix; a grain of rice',
    pinyin: ['sǎn'],
    decomposition: '⿰米参',
    etymology: {
      type: 'pictophonetic',
      phonetic: '参',
      semantic: '米',
      hint: 'rice',
    },
    radical: '米',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '糅',
    definition: 'to mix, to blend; mixed',
    pinyin: ['róu'],
    decomposition: '⿰米柔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '柔',
      semantic: '米',
      hint: 'grain',
    },
    radical: '米',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '糇',
    definition: 'dried rice; dry rations',
    pinyin: ['hóu'],
    decomposition: '⿰米侯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '侯',
      semantic: '米',
      hint: 'rice',
    },
    radical: '米',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '糈',
    definition: 'pay, rations; sacrificial rice',
    pinyin: ['xǔ'],
    decomposition: '⿰米胥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '胥',
      semantic: '米',
      hint: 'rice',
    },
    radical: '米',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '糊',
    definition: 'muddled; paste; to stick on with paste',
    pinyin: ['hú'],
    decomposition: '⿰米胡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '胡',
      semantic: '米',
      hint: 'grain',
    },
    radical: '米',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '糌',
    definition: 'zanba, barley bread',
    pinyin: ['zān'],
    decomposition: '⿰米昝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昝',
      semantic: '米',
      hint: 'grain',
    },
    radical: '米',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '糍',
    definition: 'sticky rice; mochi',
    pinyin: ['cí'],
    decomposition: '⿰米兹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兹',
      semantic: '米',
      hint: 'rice',
    },
    radical: '米',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '糕',
    definition: 'cake, pastry',
    pinyin: ['gāo'],
    decomposition: '⿰米羔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羔',
      semantic: '米',
      hint: 'rice',
    },
    radical: '米',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '糖',
    definition: 'candy, sugar, sweets',
    pinyin: ['táng'],
    decomposition: '⿰米唐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '唐',
      semantic: '米',
      hint: 'rice',
    },
    radical: '米',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '糗',
    definition: 'dry rations; mushy, overcooked; embarrassing',
    pinyin: ['qiǔ'],
    decomposition: '⿰米臭',
    etymology: {
      type: 'ideographic',
      hint: 'Rice 米 that stinks 臭; 臭 also provides the pronunciation',
    },
    radical: '米',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '糙',
    definition: 'coarse, harsh, rough; coarse rice',
    pinyin: ['cāo'],
    decomposition: '⿰米造',
    etymology: {
      type: 'pictophonetic',
      phonetic: '造',
      semantic: '米',
      hint: 'rice',
    },
    radical: '米',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '糜',
    definition: 'rice gruel, congee; mashed',
    pinyin: ['mí'],
    decomposition: '⿸麻米',
    etymology: {
      type: 'pictophonetic',
      phonetic: '麻',
      semantic: '米',
      hint: 'rice',
    },
    radical: '米',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '糞',
    definition: 'manure, dung; shit, excrement',
    pinyin: ['fèn'],
    decomposition: '⿱米異',
    etymology: {
      type: 'pictophonetic',
      phonetic: '異',
      semantic: '米',
      hint: 'grain',
    },
    radical: '米',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '糟',
    definition: 'sediment, dregs; to waste, to spoil',
    pinyin: ['zāo'],
    decomposition: '⿰米曹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曹',
      semantic: '米',
      hint: 'grain',
    },
    radical: '米',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '糠',
    definition: 'chaff, bran, husk; poor',
    pinyin: ['kāng'],
    decomposition: '⿰米康',
    etymology: {
      type: 'pictophonetic',
      phonetic: '康',
      semantic: '米',
      hint: 'rice',
    },
    radical: '米',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '糢',
    definition: 'rice snacks',
    pinyin: ['mó'],
    decomposition: '⿰米莫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '莫',
      semantic: '米',
      hint: 'rice',
    },
    radical: '米',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '糧',
    definition: 'food, grain, provisions',
    pinyin: ['liáng'],
    decomposition: '⿰米量',
    etymology: {
      type: 'pictophonetic',
      phonetic: '量',
      semantic: '米',
      hint: 'grain',
    },
    radical: '米',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '糨',
    definition: 'starch, paste; to starch',
    pinyin: ['jiàng'],
    decomposition: '⿰米强',
    etymology: {
      type: 'pictophonetic',
      phonetic: '强',
      semantic: '米',
      hint: 'rice',
    },
    radical: '米',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '糬',
    definition: 'sticky rice; mochi',
    pinyin: ['shu'],
    decomposition: '⿰米署',
    etymology: {
      type: 'pictophonetic',
      phonetic: '署',
      semantic: '米',
      hint: 'rice',
    },
    radical: '米',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '糯',
    definition: 'glutinous rice; sticky, viscous',
    pinyin: ['nuò'],
    decomposition: '⿰米需',
    etymology: {
      type: 'pictophonetic',
      phonetic: '需',
      semantic: '米',
      hint: 'rice',
    },
    radical: '米',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '糰',
    definition: 'rice ball',
    pinyin: ['tuán'],
    decomposition: '⿰米團',
    etymology: {
      type: 'ideographic',
      hint: 'A rice 米 ball 團; 團 also provides the pronunciation',
    },
    radical: '米',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '糲',
    definition: 'coarse rice; brown rice',
    pinyin: ['lì'],
    decomposition: '⿰米厲',
    etymology: {
      type: 'ideographic',
      hint: 'Rice 米 that must be ground 厲; 厲 also provides the pronunciation',
    },
    radical: '米',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '糸',
    definition: 'silk; thread',
    pinyin: ['mì'],
    decomposition: '⿱幺小',
    etymology: { type: 'pictographic', hint: 'A twisted strand of silk' },
    radical: '糸',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '糹',
    definition: 'silk; thread',
    pinyin: ['sī'],
    decomposition: '⿱幺？',
    etymology: { type: 'pictographic', hint: 'A twisted strand of silk' },
    radical: '糹',
    matches: [[0], [0], [0], null, null, null],
  },
  {
    character: '系',
    definition: 'system; line, link, connection',
    pinyin: ['xì'],
    decomposition: '⿱丿糸',
    etymology: { type: 'pictophonetic', semantic: '糸', hint: 'thread' },
    radical: '糸',
    matches: [[0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '糾',
    definition: 'tangled; to investigate, to unravel',
    pinyin: ['jiū'],
    decomposition: '⿰糹丩',
    etymology: {
      type: 'ideographic',
      hint: 'To connect 丩 threads 糹; 丩 also provides the pronunciation',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '紀',
    definition: 'discipline, age; period, era; record, annal',
    pinyin: ['jì'],
    decomposition: '⿰糹己',
    etymology: {
      type: 'pictophonetic',
      phonetic: '己',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '紂',
    definition: 'saddle strap, harness; an emperor',
    pinyin: ['zhòu'],
    decomposition: '⿰糹寸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寸',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '約',
    definition: 'treaty, covenant, agreement',
    pinyin: ['yuē'],
    decomposition: '⿰糹勺',
    etymology: { type: 'pictophonetic', semantic: '糹', hint: 'thread' },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '紅',
    definition: 'red, vermillion; to blush, to flush; popular',
    pinyin: ['hóng'],
    decomposition: '⿰糹工',
    etymology: {
      type: 'pictophonetic',
      phonetic: '工',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '紆',
    definition: 'to twist, to turn, to bend; to distort',
    pinyin: ['yū'],
    decomposition: '⿰糹于',
    etymology: {
      type: 'pictophonetic',
      phonetic: '于',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '紇',
    definition: 'inferior silk; tassel, knot, fringe',
    pinyin: ['gē'],
    decomposition: '⿰糹乞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '糹',
      semantic: '乞',
      hint: 'silk',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '紈',
    definition: 'gauze; fine white silk',
    pinyin: ['wán'],
    decomposition: '⿰糹丸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丸',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '紉',
    definition: 'to sew, to stitch; to thread a needle',
    pinyin: ['rèn'],
    decomposition: '⿰糹刃',
    etymology: {
      type: 'ideographic',
      hint: 'To thread 糹 a needle 刃; 刃 also provides the pronunciation',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '紊',
    definition: 'tangled; confused, disordered',
    pinyin: ['wěn'],
    decomposition: '⿱文糸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '文',
      semantic: '糸',
      hint: 'thread',
    },
    radical: '糸',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '紋',
    definition: 'line, stripe; pattern, decoration; wrinkle',
    pinyin: ['wén'],
    decomposition: '⿰糹文',
    etymology: {
      type: 'pictophonetic',
      phonetic: '文',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '納',
    definition: 'to adopt, to accept; to receive, to take',
    pinyin: ['nà'],
    decomposition: '⿰糹内',
    etymology: {
      type: 'pictophonetic',
      phonetic: '内',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '紐',
    definition: 'knot; button, handle; tie',
    pinyin: ['niǔ'],
    decomposition: '⿰糹丑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丑',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '紓',
    definition: 'to relieve; to relax, to loosen; to extricate',
    pinyin: ['shū'],
    decomposition: '⿰糹予',
    etymology: {
      type: 'ideographic',
      hint: 'A thread 糹 with some give 予; 予 also provides the pronunciation',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '純',
    definition: 'pure, clean; simple, genuine',
    pinyin: ['chún'],
    decomposition: '⿰糹屯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屯',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '紕',
    definition: 'carelessness; error, mistake; spoiled silk',
    pinyin: ['pī'],
    decomposition: '⿰糹比',
    etymology: {
      type: 'pictophonetic',
      phonetic: '比',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '紗',
    definition: 'gauze, muslin, yarn',
    pinyin: ['shā'],
    decomposition: '⿰糹少',
    etymology: {
      type: 'pictophonetic',
      phonetic: '少',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '紙',
    definition: 'paper',
    pinyin: ['zhǐ'],
    decomposition: '⿰糹氏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '氏',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '級',
    definition: 'level, rank; class, grade',
    pinyin: ['jí'],
    decomposition: '⿰糹及',
    etymology: {
      type: 'pictophonetic',
      phonetic: '及',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '紛',
    definition: 'tangled, scattered; numerous, confused',
    pinyin: ['fēn'],
    decomposition: '⿰糹分',
    etymology: {
      type: 'pictophonetic',
      phonetic: '分',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '紜',
    definition: 'confused; numerous',
    pinyin: ['yún'],
    decomposition: '⿰糹云',
    etymology: {
      type: 'pictophonetic',
      phonetic: '云',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '素',
    definition: 'plain; white; vegetarian; formerly; normally',
    pinyin: ['sù'],
    decomposition: '⿱龶糸',
    etymology: {
      type: 'ideographic',
      hint: 'A silken thread 糸 hanging off a tree 龶',
    },
    radical: '糸',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '紡',
    definition: 'to spin, to weave, to reel',
    pinyin: ['fǎng'],
    decomposition: '⿰糹方',
    etymology: {
      type: 'pictophonetic',
      phonetic: '方',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '索',
    definition:
      'cable, rope; rules, laws; to demand, to exact; to search, to inquire',
    pinyin: ['suǒ'],
    decomposition: '⿱⿱十冖糸',
    etymology: {
      type: 'ideographic',
      hint: 'A rope 糸 hanging from the ceiling 冖',
    },
    radical: '糸',
    matches: [[0, 0], [0, 0], [0, 1], [0, 1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '紥',
    definition: 'to tie, to fasten, to bind',
    pinyin: ['zā'],
    decomposition: '⿱扎糸',
    etymology: { type: 'ideographic', hint: 'To bind 扎 with thread 糸' },
    radical: '糸',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '紧',
    definition: 'tense, tight, taut; firm, secure',
    pinyin: ['jǐn'],
    decomposition: '⿱⿰？又糸',
    etymology: { type: 'pictophonetic', semantic: '糸', hint: 'silk' },
    radical: '糸',
    matches: [null, null, [0, 1], [0, 1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '紫',
    definition: 'purple, violet; amethyst; surname',
    pinyin: ['zǐ'],
    decomposition: '⿱此糸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '此',
      semantic: '糸',
      hint: 'silk',
    },
    radical: '糸',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '紮',
    definition: 'to tie, to fasten, to bind',
    pinyin: ['zā'],
    decomposition: '⿱札糸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '札',
      semantic: '糸',
      hint: 'thread',
    },
    radical: '糸',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '累',
    definition: 'tired; to accumulate; to involve; bother, nuisance',
    pinyin: ['lèi'],
    decomposition: '⿱田糸',
    etymology: {
      type: 'ideographic',
      hint: 'Simplified form of 纍; growing silk 糸 in the fields 畾; 畾 also provides the pronunciation',
    },
    radical: '糸',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '細',
    definition: 'fine, detailed; slender, thin',
    pinyin: ['xì'],
    decomposition: '⿰糹田',
    etymology: {
      type: 'pictophonetic',
      phonetic: '田',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '紳',
    definition: 'girdle, tie; gentry; to bend',
    pinyin: ['shēn'],
    decomposition: '⿰糹申',
    etymology: {
      type: 'pictophonetic',
      phonetic: '申',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '紹',
    definition: 'to connect; to introduce',
    pinyin: ['shào'],
    decomposition: '⿰糹召',
    etymology: {
      type: 'pictophonetic',
      phonetic: '召',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '紺',
    definition: 'purple, violet',
    pinyin: ['gàn'],
    decomposition: '⿰糹甘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甘',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '紼',
    definition: 'thick rope; the rope around a bier',
    pinyin: ['fú'],
    decomposition: '⿰糹弗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弗',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '絀',
    definition: 'to stitch, to sew; insufficient',
    pinyin: ['chù'],
    decomposition: '⿰糹出',
    etymology: {
      type: 'pictophonetic',
      phonetic: '出',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '終',
    definition: 'end; finally, in the end',
    pinyin: ['zhōng'],
    decomposition: '⿰糹冬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冬',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '組',
    definition: 'to form, to assemble; section, department',
    pinyin: ['zǔ'],
    decomposition: '⿰糹且',
    etymology: {
      type: 'pictophonetic',
      phonetic: '且',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '絆',
    definition: 'a loop of thread; shackles, fetters; to stumble, to trip',
    pinyin: ['bàn'],
    decomposition: '⿰糹半',
    etymology: {
      type: 'pictophonetic',
      phonetic: '半',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '絎',
    definition: 'to quilt',
    pinyin: ['háng'],
    decomposition: '⿰糹行',
    etymology: {
      type: 'pictophonetic',
      phonetic: '行',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '結',
    definition: 'knot, tie; to connect, to join',
    pinyin: ['jié'],
    decomposition: '⿰糹吉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吉',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '絓',
    definition: 'to hinder, to obstruct',
    pinyin: ['guà'],
    decomposition: '⿰糹圭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '圭',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '絕',
    definition: 'to cut, to sever; to break off, to terminate',
    pinyin: ['jué'],
    decomposition: '⿰糹⿱刀巴',
    etymology: {
      type: 'ideographic',
      hint: 'To cut 刀 thread 糹; 巴 provides the pronunciation',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '絘',
    definition: 'a tax on rolls of cloth',
    pinyin: ['cì'],
    decomposition: '⿰糹次',
    etymology: {
      type: 'pictophonetic',
      phonetic: '次',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '絛',
    definition: 'silk cord; sash, ribbon, cord',
    pinyin: ['tāo'],
    decomposition: '⿰亻⿱夂糸',
    etymology: { type: 'pictophonetic', semantic: '糸', hint: 'silk' },
    radical: '糸',
    matches: [
      [0],
      [0],
      null,
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '絜',
    definition: 'line, marking; to assess, to measure',
    pinyin: ['jié'],
    decomposition: '⿱㓞糸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㓞',
      semantic: '糸',
      hint: 'thread',
    },
    radical: '糸',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '絞',
    definition: 'intertwined; to twist, to wring; to hang a criminal',
    pinyin: ['jiǎo'],
    decomposition: '⿰糹交',
    etymology: {
      type: 'pictophonetic',
      phonetic: '交',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '絡',
    definition: 'web, net; to entangle',
    pinyin: ['luò'],
    decomposition: '⿰糹各',
    etymology: {
      type: 'pictophonetic',
      phonetic: '各',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '絢',
    definition: 'variegated, adorned; brilliant',
    pinyin: ['xuàn'],
    decomposition: '⿰糹旬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旬',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '給',
    definition: 'to give, to lend; for, by',
    pinyin: ['gěi'],
    decomposition: '⿰糹合',
    etymology: {
      type: 'pictophonetic',
      phonetic: '合',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '絨',
    definition: 'cotton, silk, velvet, wool',
    pinyin: ['róng'],
    decomposition: '⿰糹戎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戎',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '絮',
    definition: 'cotton padding; fluff, padding, waste; long-winded',
    pinyin: ['xù'],
    decomposition: '⿱如糸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '如',
      semantic: '糸',
      hint: 'silk',
    },
    radical: '糸',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '統',
    definition: 'to govern, to command; to gather, to unite',
    pinyin: ['tǒng'],
    decomposition: '⿰糹充',
    etymology: {
      type: 'pictophonetic',
      phonetic: '充',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '絲',
    definition: 'silk, fine thread; wire; strings',
    pinyin: ['sī'],
    decomposition: '⿰糹糸',
    etymology: {
      type: 'ideographic',
      hint: 'Finely-layered 糹silk 糸;  糹 also provides the pronunciation',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '絳',
    definition: 'deep red; a river in Shanxi province',
    pinyin: ['jiàng'],
    decomposition: '⿰糹夅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夅',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '絷',
    definition: 'to tie up, to shackle; to imprison, to confine',
    pinyin: ['zhí'],
    decomposition: '⿱执糸',
    etymology: {
      type: 'ideographic',
      hint: 'To capture 执 and bind 糸 someone; 执 also provides the pronunciation',
    },
    radical: '糸',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '絹',
    definition: 'a kind of thick stiff silk',
    pinyin: ['juàn'],
    decomposition: '⿰糹肙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肙',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '絻',
    definition: 'mourning veil',
    pinyin: ['miǎn'],
    decomposition: '⿰糹免',
    etymology: {
      type: 'pictophonetic',
      phonetic: '免',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '綁',
    definition: 'to tie, to fasten, to bind',
    pinyin: ['bǎng'],
    decomposition: '⿰糹邦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '邦',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '經',
    definition: 'the classics; to experience, to undergo',
    pinyin: ['jīng'],
    decomposition: '⿰糹巠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巠',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '綜',
    definition: 'to sum up; to arrange threads for weaving',
    pinyin: ['zōng'],
    decomposition: '⿰糹宗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宗',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '綠',
    definition: 'green; chlorine',
    pinyin: ['lǜ'],
    decomposition: '⿰糹彔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彔',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '綢',
    definition: 'silk cloth, satin damask',
    pinyin: ['chóu'],
    decomposition: '⿰糹周',
    etymology: {
      type: 'pictophonetic',
      phonetic: '周',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '綣',
    definition: 'attached, inseparable, in love',
    pinyin: ['quǎn'],
    decomposition: '⿰糹卷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卷',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '綦',
    definition: 'dark gray; variegated; superlative',
    pinyin: ['qí'],
    decomposition: '⿱其糸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '其',
      semantic: '糸',
      hint: 'silk',
    },
    radical: '糸',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '綬',
    definition: 'a silk ribbon used as a seal',
    pinyin: ['shòu'],
    decomposition: '⿰糹受',
    etymology: {
      type: 'pictophonetic',
      phonetic: '受',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '維',
    definition: 'to preserve, to maintain, to hold together',
    pinyin: ['wéi'],
    decomposition: '⿰糹隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隹',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '綮',
    definition: 'embroidered banner',
    pinyin: ['qǐ'],
    decomposition: '⿱⿰户攵糸',
    etymology: { type: 'ideographic', hint: 'A silk 糸 banner over a door 户' },
    radical: '糸',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '綱',
    definition: 'program, outline; principle, guiding thread',
    pinyin: ['gāng'],
    decomposition: '⿰糹岡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '岡',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '網',
    definition: 'net; network',
    pinyin: ['wǎng'],
    decomposition: '⿰糹罔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '罔',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '綴',
    definition: 'to connect, to join; to patch up, to stitch together',
    pinyin: ['zhuì'],
    decomposition: '⿰糹叕',
    etymology: {
      type: 'ideographic',
      hint: 'To bind 叕 by thread 糹; 叕 also provides the pronunciation',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '綵',
    definition: 'motley, variegated',
    pinyin: ['cǎi'],
    decomposition: '⿰糹采',
    etymology: {
      type: 'pictophonetic',
      phonetic: '采',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '綷',
    definition: 'five-color silk',
    pinyin: ['cuì'],
    decomposition: '⿰糹卒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卒',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '綸',
    definition: 'silk thread; to twist together; to classify',
    pinyin: ['lún'],
    decomposition: '⿰糹侖',
    etymology: {
      type: 'ideographic',
      hint: 'To spin thread 糹 into order 侖; 侖 also provides the pronunciation',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '綹',
    definition: 'skein; tuft, lock; wrinkle',
    pinyin: ['liǔ'],
    decomposition: '⿰糹咎',
    etymology: {
      type: 'ideographic',
      hint: 'A wrinkle 咎 in a silk 糹 garment; 糹 also provides the pronunciation',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '綺',
    definition: 'fine silk; elegant, beautiful',
    pinyin: ['qǐ'],
    decomposition: '⿰糹奇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奇',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '綻',
    definition: 'to crack; to burst open; to split at the seams',
    pinyin: ['zhàn'],
    decomposition: '⿰糹定',
    etymology: {
      type: 'pictophonetic',
      phonetic: '定',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '綽',
    definition: 'graceful, delicate; spacious',
    pinyin: ['chuò'],
    decomposition: '⿰糹卓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卓',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '綿',
    definition: 'continuous, unbroken; cotten, silk; soft, downy',
    pinyin: ['mián'],
    decomposition: '⿰糹帛',
    etymology: {
      type: 'ideographic',
      hint: 'A continuous thread 糹 of silk 帛',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '緄',
    definition: 'belt, cord, sash; hemming; to sew',
    pinyin: ['gǔn'],
    decomposition: '⿰糹昆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昆',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '緊',
    definition: 'tense, tight, taut; firm, secure',
    pinyin: ['jǐn'],
    decomposition: '⿱臤糸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臤',
      semantic: '糸',
      hint: 'thread',
    },
    radical: '糸',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '緋',
    definition: 'crimson, scarlet; purple',
    pinyin: ['fēi'],
    decomposition: '⿰糹非',
    etymology: {
      type: 'pictophonetic',
      phonetic: '非',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '緒',
    definition: 'mental state; thread, clue',
    pinyin: ['xù'],
    decomposition: '⿰糹者',
    etymology: {
      type: 'pictophonetic',
      phonetic: '者',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '緘',
    definition: 'to seal, to close, to bind; a letter',
    pinyin: ['jiān'],
    decomposition: '⿰糹咸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咸',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '線',
    definition: 'line, thread, wire; clue, trail',
    pinyin: ['xiàn'],
    decomposition: '⿰糹泉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '泉',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '緝',
    definition: 'to sieze, to arrest; to stich closely',
    pinyin: ['jī'],
    decomposition: '⿰糹咠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咠',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '緞',
    definition: 'satin',
    pinyin: ['duàn'],
    decomposition: '⿰糹段',
    etymology: {
      type: 'pictophonetic',
      phonetic: '段',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '締',
    definition: 'to tie, to join; knot, connection',
    pinyin: ['dì'],
    decomposition: '⿰糹帝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '帝',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '緣',
    definition: 'reason, cause; fate; margin, hem',
    pinyin: ['yuán'],
    decomposition: '⿰糹彖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彖',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '編',
    definition: 'to knit, to weave; to arrange, to compile',
    pinyin: ['biān'],
    decomposition: '⿰糹扁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '扁',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '緩',
    definition: 'slow, gradual; to postpone, to delay',
    pinyin: ['huǎn'],
    decomposition: '⿰糹爰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爰',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '緬',
    definition: 'distant, remote; to think of',
    pinyin: ['miǎn'],
    decomposition: '⿰糹面',
    etymology: {
      type: 'pictophonetic',
      phonetic: '面',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '緯',
    definition: 'warp and woof; lines of latitude',
    pinyin: ['wěi'],
    decomposition: '⿰糹韋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韋',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '緲',
    definition: 'dim, indistinct; distant; minute',
    pinyin: ['miǎo'],
    decomposition: '⿰糹眇',
    etymology: {
      type: 'ideographic',
      hint: 'A veil 糹 over the eyes 眇; 眇 also provides the pronunciation',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '練',
    definition: 'to drill, to exercise; to practice, to train',
    pinyin: ['liàn'],
    decomposition: '⿰糹柬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '柬',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '緻',
    definition: 'to send; to present, to deliver; to cause; consequence',
    pinyin: ['zhì'],
    decomposition: '⿰糹致',
    etymology: {
      type: 'ideographic',
      hint: 'A silken 糹present 致; 致 also provides the pronunciation',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '縈',
    definition: 'to coil, to entangle, to entwine',
    pinyin: ['yíng'],
    decomposition: '⿱⿱炏冖糸',
    etymology: { type: 'pictophonetic', semantic: '糸', hint: 'thread' },
    radical: '糸',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '縉',
    definition: 'red silk',
    pinyin: ['jìn'],
    decomposition: '⿰糹晋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '晋',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '縊',
    definition: 'to hang; to strangle',
    pinyin: ['yì'],
    decomposition: '⿰糹益',
    etymology: {
      type: 'pictophonetic',
      phonetic: '益',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '縕',
    definition: 'tangled hemp, raveled silk; vague, confused',
    pinyin: ['yūn'],
    decomposition: '⿰糹⿱囚皿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皿',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '縛',
    definition: 'to tie, to bind',
    pinyin: ['fù'],
    decomposition: '⿰糹尃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尃',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '縞',
    definition: 'plain white silk',
    pinyin: ['gǎo'],
    decomposition: '⿰糹高',
    etymology: {
      type: 'pictophonetic',
      phonetic: '高',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '縟',
    definition: 'elegant, decorative, adorned',
    pinyin: ['rù'],
    decomposition: '⿰糹辱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辱',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '縣',
    definition: 'county, district, subdivision',
    pinyin: ['xiàn'],
    decomposition: '⿰県系',
    etymology: {
      type: 'ideographic',
      hint: 'District 県 borders 系; 県 also provides the pronunciation',
    },
    radical: '糸',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '縧',
    definition: 'cord, ribbon, sash',
    pinyin: ['tāo'],
    decomposition: '⿰糹條',
    etymology: {
      type: 'pictophonetic',
      phonetic: '條',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '縩',
    definition: 'the sound of fabric rustling',
    pinyin: ['cài'],
    decomposition: '⿰糹祭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '祭',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '縫',
    definition: 'to sew, to mend',
    pinyin: ['fèng'],
    decomposition: '⿰糹逢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '逢',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '縭',
    definition: 'bridal veil; to tie, to bind',
    pinyin: ['lí'],
    decomposition: '⿰糹离',
    etymology: {
      type: 'pictophonetic',
      phonetic: '离',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '縮',
    definition: 'to withdraw, to shrink, to pull back; abbreviation',
    pinyin: ['suō'],
    decomposition: '⿰糹宿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宿',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '縱',
    definition: 'to indulge in, to give free reign to',
    pinyin: ['zòng'],
    decomposition: '⿰糹從',
    etymology: {
      type: 'pictophonetic',
      phonetic: '從',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '縴',
    definition: 'tow rope',
    pinyin: ['qiàn'],
    decomposition: '⿰糹牽',
    etymology: {
      type: 'ideographic',
      hint: 'A thread 糹 used to pull 牽 boats; 牽 also provides the pronunciation',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '縵',
    definition: 'plain silk; simple, plain',
    pinyin: ['màn'],
    decomposition: '⿰糹曼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曼',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '縷',
    definition: 'strand, thread; detailed, precise',
    pinyin: ['lǚ'],
    decomposition: '⿰糹婁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '婁',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '縹',
    definition: 'dim, misty, indistinct; a silk veil',
    pinyin: ['piāo'],
    decomposition: '⿰糹票',
    etymology: {
      type: 'pictophonetic',
      phonetic: '票',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '縻',
    definition: 'harness, halter; to tie up',
    pinyin: ['mí'],
    decomposition: '⿸麻糸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '麻',
      semantic: '糸',
      hint: 'thread',
    },
    radical: '糸',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '總',
    definition: 'to gather, to collect; overall, altogether',
    pinyin: ['zǒng'],
    decomposition: '⿰糹悤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '悤',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '績',
    definition: 'achievements, merit',
    pinyin: ['jī'],
    decomposition: '⿰糹責',
    etymology: {
      type: 'ideographic',
      hint: "To complete 糹 one's duties 責; 責 also provides the pronunciation",
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '繁',
    definition: 'complex, difficult; many, diverse',
    pinyin: ['fán'],
    decomposition: '⿱敏糸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敏',
      semantic: '糸',
      hint: 'silk',
    },
    radical: '糸',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '繃',
    definition: 'to bind, to strap, to draw firm',
    pinyin: ['běng'],
    decomposition: '⿰糹崩',
    etymology: {
      type: 'pictophonetic',
      phonetic: '崩',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '繆',
    definition: 'to prepare; error, mistake; attached',
    pinyin: ['móu'],
    decomposition: '⿰糹翏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '翏',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '繇',
    definition: 'cause, means, reason',
    pinyin: ['yáo'],
    decomposition: '⿰䍃系',
    etymology: {
      type: 'pictophonetic',
      phonetic: '䍃',
      semantic: '系',
      hint: 'link',
    },
    radical: '糸',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '繒',
    definition: 'silk; to tie, to bind; surname',
    pinyin: ['zēng'],
    decomposition: '⿰糹曾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曾',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '織',
    definition: 'to knit, to weave; to organize, to unite',
    pinyin: ['zhī'],
    decomposition: '⿰糹戠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戠',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '繕',
    definition: 'to repair, to mend; to transcribe, to rewrite',
    pinyin: ['shàn'],
    decomposition: '⿰糹善',
    etymology: {
      type: 'pictophonetic',
      phonetic: '善',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '繚',
    definition: 'confused; to bind; to wind around',
    pinyin: ['liáo'],
    decomposition: '⿰糹尞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尞',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '繞',
    definition: 'to entwine, to wind around; to orbit, to revolve',
    pinyin: ['rào'],
    decomposition: '⿰糹堯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堯',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '繡',
    definition: 'to embroider; embroidery; ornament',
    pinyin: ['xiù'],
    decomposition: '⿰糹肅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肅',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '繩',
    definition: 'string, rope, cord; to control',
    pinyin: ['shéng'],
    decomposition: '⿰糹黽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '黽',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '繪',
    definition: 'to sketch, to paint, to draw',
    pinyin: ['huì'],
    decomposition: '⿰糹會',
    etymology: {
      type: 'pictophonetic',
      phonetic: '會',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '繫',
    definition: 'system; line, link, connection',
    pinyin: ['xì'],
    decomposition: '⿱毄糸',
    etymology: {
      type: 'pictophonetic',
      semantic: '糸',
      hint: 'thread',
      phonetic: '毄',
    },
    radical: '糸',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '繭',
    definition: 'cocoon; callus, blister',
    pinyin: ['jiǎn'],
    decomposition: '⿱艹⿻冂⿰糹虫',
    etymology: {
      type: 'ideographic',
      hint: 'A silk 糹 cocoon 冂 spun by a worm 虫',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      null,
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
    ],
  },
  {
    character: '繯',
    definition: 'noose; to hang; to tie, to bind',
    pinyin: ['huán'],
    decomposition: '⿰糹睘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '睘',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '繰',
    definition: 'to spool, to reel',
    pinyin: ['qiāo'],
    decomposition: '⿰糹喿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '喿',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '繳',
    definition: 'to deliver, to submit, to hand over',
    pinyin: ['jiǎo'],
    decomposition: '⿰糹敫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敫',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '繹',
    definition: 'to unravel; to interpret',
    pinyin: ['yì'],
    decomposition: '⿰糹睪',
    etymology: {
      type: 'pictophonetic',
      semantic: '糹',
      hint: 'thread',
      phonetic: '睪',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '繼',
    definition: 'to continue, to carry on; to succeed, to inherit',
    pinyin: ['jì'],
    decomposition: '⿰糹㡭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㡭',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '繽',
    definition: 'abundant, diverse, variegated',
    pinyin: ['bīn'],
    decomposition: '⿰糹賓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '賓',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '繾',
    definition: 'attached, inseparable, in love; entangled',
    pinyin: ['qiǎn'],
    decomposition: '⿰糹遣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '遣',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '纂',
    definition: 'to edit, to compile; to tie a knot',
    pinyin: ['zuǎn'],
    decomposition: '⿱算糸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '算',
      semantic: '糸',
      hint: 'thread',
    },
    radical: '糸',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '纈',
    definition: 'knot; to tie a knot',
    pinyin: ['xié'],
    decomposition: '⿰糹頡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '頡',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '續',
    definition: 'continuous, serial',
    pinyin: ['xù'],
    decomposition: '⿰糹賣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '賣',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '纏',
    definition: 'to wrap, to entangle; to involve; to bother, to annoy',
    pinyin: ['chán'],
    decomposition: '⿰糹廛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '廛',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '纓',
    definition: 'tassel, ribbon; to bother, to annoy',
    pinyin: ['yīng'],
    decomposition: '⿰糹嬰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '嬰',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '纔',
    definition: 'talent, ability; only, just',
    pinyin: ['cái'],
    decomposition: '⿰糹毚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '毚',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '纖',
    definition: 'fine, delicate; tiny, minute',
    pinyin: ['xiān'],
    decomposition: '⿰糹韱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韱',
      semantic: '糹',
      hint: 'silk',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '纛',
    definition: 'banner, streamer',
    pinyin: ['dào'],
    decomposition: '⿱毒縣',
    etymology: {
      type: 'ideographic',
      hint: 'A silk 系 banner 県; 毒 provides the pronunciation',
    },
    radical: '糸',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '纜',
    definition: 'cable, hawser, heavy-duty rope',
    pinyin: ['lǎn'],
    decomposition: '⿰糹覽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '覽',
      semantic: '糹',
      hint: 'thread',
    },
    radical: '糹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '纟',
    definition: 'silk; thread',
    pinyin: ['sī'],
    decomposition: '⿱？一',
    etymology: {
      type: 'pictographic',
      hint: 'A twisted strand of silk; see 糸',
    },
    radical: '纟',
    matches: [null, null, [1]],
  },
  {
    character: '纠',
    definition: 'tangled; to investigate, to unravel',
    pinyin: ['jiū'],
    decomposition: '⿰纟丩',
    etymology: {
      type: 'ideographic',
      hint: 'To connect 丩 threads 纟; 丩 also provides the pronunciation',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '纡',
    definition: 'to twist, to turn, to bend; to distort',
    pinyin: ['yū'],
    decomposition: '⿰纟于',
    etymology: {
      type: 'pictophonetic',
      phonetic: '于',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '红',
    definition: 'red, vermillion; to blush, to flush; popular',
    pinyin: ['hóng'],
    decomposition: '⿰纟工',
    etymology: {
      type: 'pictophonetic',
      phonetic: '工',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '纣',
    definition: 'saddle strap, harness; an emperor',
    pinyin: ['zhòu'],
    decomposition: '⿰纟寸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寸',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '纤',
    definition: 'fine, delicate; tiny, minute',
    pinyin: ['xiān'],
    decomposition: '⿰纟千',
    etymology: {
      type: 'pictophonetic',
      phonetic: '千',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '纥',
    definition: 'inferior silk; tassel, knot, fringe',
    pinyin: ['gē'],
    decomposition: '⿰纟乞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '纟',
      semantic: '乞',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '约',
    definition: 'treaty, covenant, agreement',
    pinyin: ['yuē'],
    decomposition: '⿰纟勺',
    etymology: { type: 'pictophonetic', semantic: '纟', hint: 'thread' },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '级',
    definition: 'level, rank; class, grade',
    pinyin: ['jí'],
    decomposition: '⿰纟及',
    etymology: {
      type: 'pictophonetic',
      phonetic: '及',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '纨',
    definition: 'gauze; fine white silk',
    pinyin: ['wán'],
    decomposition: '⿰纟丸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丸',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '纩',
    definition: 'cotton, silk',
    pinyin: ['kuàng'],
    decomposition: '⿰纟广',
    etymology: {
      type: 'pictophonetic',
      phonetic: '广',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '纪',
    definition: 'discipline, age; period, era; record, annal',
    pinyin: ['jì'],
    decomposition: '⿰纟己',
    etymology: {
      type: 'pictophonetic',
      phonetic: '己',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '纫',
    definition: 'to sew, to stitch; to thread a needle',
    pinyin: ['rèn'],
    decomposition: '⿰纟刃',
    etymology: {
      type: 'ideographic',
      hint: 'To thread 纟 a needle 刃; 刃 also provides the pronunciation',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '纬',
    definition: 'warp and woof; lines of latitude',
    pinyin: ['wěi'],
    decomposition: '⿰纟韦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韦',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '纭',
    definition: 'confused; numerous',
    pinyin: ['yún'],
    decomposition: '⿰纟云',
    etymology: {
      type: 'pictophonetic',
      phonetic: '云',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '纯',
    definition: 'pure, clean; simple, genuine',
    pinyin: ['chún'],
    decomposition: '⿰纟屯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屯',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '纰',
    definition: 'carelessness; error, mistake; spoiled silk',
    pinyin: ['pī'],
    decomposition: '⿰纟比',
    etymology: {
      type: 'pictophonetic',
      phonetic: '比',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '纱',
    definition: 'gauze, muslin, yarn',
    pinyin: ['shā'],
    decomposition: '⿰纟少',
    etymology: {
      type: 'pictophonetic',
      phonetic: '少',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '纲',
    definition: 'program, outline; principle, guiding thread',
    pinyin: ['gāng'],
    decomposition: '⿰纟冈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冈',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '纳',
    definition: 'to adopt, to accept; to receive, to take',
    pinyin: ['nà'],
    decomposition: '⿰纟内',
    etymology: {
      type: 'pictophonetic',
      phonetic: '内',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '纴',
    definition: 'to lay warp, to weave; to stitch, to sew',
    pinyin: ['rèn'],
    decomposition: '⿰纟壬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '壬',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '纵',
    definition: 'to indulge in, to give free reign to',
    pinyin: ['zòng'],
    decomposition: '⿰纟从',
    etymology: {
      type: 'pictophonetic',
      phonetic: '从',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '纶',
    definition: 'silk thread; to twist together; to classify',
    pinyin: ['lún'],
    decomposition: '⿰纟仑',
    etymology: {
      type: 'ideographic',
      hint: 'To spin thread 纟 into order 仑; 仑 also provides the pronunciation',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '纷',
    definition: 'tangled, scattered; numerous, confused',
    pinyin: ['fēn'],
    decomposition: '⿰纟分',
    etymology: {
      type: 'pictophonetic',
      phonetic: '分',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '纸',
    definition: 'paper',
    pinyin: ['zhǐ'],
    decomposition: '⿰纟氏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '氏',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '纹',
    definition: 'line, stripe; pattern, decoration; wrinkle',
    pinyin: ['wén'],
    decomposition: '⿰纟文',
    etymology: {
      type: 'pictophonetic',
      phonetic: '文',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '纺',
    definition: 'to spin, to weave, to reel',
    pinyin: ['fǎng'],
    decomposition: '⿰纟方',
    etymology: {
      type: 'pictophonetic',
      phonetic: '方',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '纽',
    definition: 'knot; button, handle; tie',
    pinyin: ['niǔ'],
    decomposition: '⿰纟丑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丑',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '纾',
    definition: 'to relieve; to relax, to loosen; to extricate',
    pinyin: ['shū'],
    decomposition: '⿰纟予',
    etymology: {
      type: 'ideographic',
      hint: 'A thread 纟 with some give 予; 予 also provides the pronunciation',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '线',
    definition: 'line, thread, wire; clue, trail',
    pinyin: ['xiàn'],
    decomposition: '⿰纟戋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戋',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '绀',
    definition: 'purple, violet',
    pinyin: ['gàn'],
    decomposition: '⿰纟甘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甘',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '绁',
    definition: 'to shorten, to contract; tie, leash',
    pinyin: ['xiè'],
    decomposition: '⿰纟世',
    etymology: {
      type: 'pictophonetic',
      phonetic: '世',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '绂',
    definition: 'a cord or ribbon used to hang ornaments',
    pinyin: ['fú'],
    decomposition: '⿰纟犮',
    etymology: {
      type: 'ideographic',
      hint: 'A thread 纟 on which ornaments are hung 犮',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '练',
    definition: 'to drill, to exercise; to practice, to train',
    pinyin: ['liàn'],
    decomposition: '⿰纟柬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '柬',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '组',
    definition: 'to form, to assemble; section, department',
    pinyin: ['zǔ'],
    decomposition: '⿰纟且',
    etymology: {
      type: 'pictophonetic',
      phonetic: '且',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '绅',
    definition: 'girdle, tie; gentry; to bend',
    pinyin: ['shēn'],
    decomposition: '⿰纟申',
    etymology: {
      type: 'pictophonetic',
      phonetic: '申',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '细',
    definition: 'fine, detailed; slender, thin',
    pinyin: ['xì'],
    decomposition: '⿰纟田',
    etymology: {
      type: 'pictophonetic',
      phonetic: '田',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '织',
    definition: 'to knit, to weave; to organize, to unite',
    pinyin: ['zhī'],
    decomposition: '⿰纟只',
    etymology: {
      type: 'pictophonetic',
      phonetic: '只',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '终',
    definition: 'end; finally, in the end',
    pinyin: ['zhōng'],
    decomposition: '⿰纟冬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冬',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '绉',
    definition: 'crepe, imitation silk; wrinkles, creases',
    pinyin: ['zhòu'],
    decomposition: '⿰纟刍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '刍',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '绊',
    definition: 'a loop of thread; shackles, fetters; to stumble, to trip',
    pinyin: ['bàn'],
    decomposition: '⿰纟半',
    etymology: {
      type: 'pictophonetic',
      phonetic: '半',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '绋',
    definition: 'thick rope; the rope around a bier',
    pinyin: ['fú'],
    decomposition: '⿰纟弗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弗',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '绌',
    definition: 'to stitch, to sew; insufficient',
    pinyin: ['chù'],
    decomposition: '⿰纟出',
    etymology: {
      type: 'pictophonetic',
      phonetic: '出',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '绍',
    definition: 'to connect; to introduce',
    pinyin: ['shào'],
    decomposition: '⿰纟召',
    etymology: {
      type: 'pictophonetic',
      phonetic: '召',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '绎',
    definition: 'to unravel; to interpret',
    pinyin: ['yì'],
    decomposition: '⿰纟？',
    etymology: { type: 'pictophonetic', semantic: '纟', hint: 'thread' },
    radical: '纟',
    matches: [[0], [0], [0], null, null, null, null, null],
  },
  {
    character: '经',
    definition: 'the classics; to experience, to undergo',
    pinyin: ['jīng'],
    decomposition: '⿰纟⿱？工',
    etymology: {
      type: 'pictophonetic',
      phonetic: '工',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], null, null, [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '绐',
    definition: 'to pretend, to fool, to cheat',
    pinyin: ['dài'],
    decomposition: '⿰纟台',
    etymology: {
      type: 'pictophonetic',
      phonetic: '台',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '绑',
    definition: 'to tie, to fasten, to bind',
    pinyin: ['bǎng'],
    decomposition: '⿰纟邦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '邦',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绒',
    definition: 'cotton, silk, velvet, wool',
    pinyin: ['róng'],
    decomposition: '⿰纟戎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戎',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '结',
    definition: 'knot, tie; to connect, to join',
    pinyin: ['jié'],
    decomposition: '⿰纟吉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吉',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绔',
    definition: 'pants, trousers, underwear',
    pinyin: ['kù'],
    decomposition: '⿰纟夸',
    etymology: {
      type: 'ideographic',
      hint: 'Extravagant 夸 silk 纟 clothes; 夸 also provides the pronunciation',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绕',
    definition: 'to entwine, to wind around; to orbit, to revolve',
    pinyin: ['rào'],
    decomposition: '⿰纟尧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尧',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绗',
    definition: 'to quilt',
    pinyin: ['háng'],
    decomposition: '⿰纟行',
    etymology: {
      type: 'pictophonetic',
      phonetic: '行',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绘',
    definition: 'to sketch, to paint, to draw',
    pinyin: ['huì'],
    decomposition: '⿰纟会',
    etymology: {
      type: 'pictophonetic',
      phonetic: '会',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '给',
    definition: 'to give, to lend; for, by',
    pinyin: ['gěi'],
    decomposition: '⿰纟合',
    etymology: {
      type: 'pictophonetic',
      phonetic: '合',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绚',
    definition: 'variegated, adorned; brilliant',
    pinyin: ['xuàn'],
    decomposition: '⿰纟旬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旬',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绛',
    definition: 'deep red; a river in Shanxi province',
    pinyin: ['jiàng'],
    decomposition: '⿰纟夅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夅',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '络',
    definition: 'web, net; to entangle',
    pinyin: ['luò'],
    decomposition: '⿰纟各',
    etymology: {
      type: 'pictophonetic',
      phonetic: '各',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绝',
    definition: 'to cut, to sever; to break off, to terminate',
    pinyin: ['jué'],
    decomposition: '⿰纟色',
    etymology: {
      type: 'pictophonetic',
      phonetic: '色',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绞',
    definition: 'intertwined; to twist, to wring; to hang a criminal',
    pinyin: ['jiǎo'],
    decomposition: '⿰纟交',
    etymology: {
      type: 'pictophonetic',
      phonetic: '交',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '统',
    definition: 'to govern, to command; to gather, to unite',
    pinyin: ['tǒng'],
    decomposition: '⿰纟充',
    etymology: {
      type: 'pictophonetic',
      phonetic: '充',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绠',
    definition: 'thick rope; well-rope',
    pinyin: ['gěng'],
    decomposition: '⿰纟更',
    etymology: {
      type: 'pictophonetic',
      phonetic: '更',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绡',
    definition: 'raw silk',
    pinyin: ['xiāo'],
    decomposition: '⿰纟肖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肖',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绢',
    definition: 'a kind of thick stiff silk',
    pinyin: ['juàn'],
    decomposition: '⿰纟肙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肙',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绣',
    definition: 'to embroider; embroidery; ornament',
    pinyin: ['xiù'],
    decomposition: '⿰纟秀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '秀',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绥',
    definition: 'to soothe, to pacify, to appease',
    pinyin: ['suí'],
    decomposition: '⿰纟妥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '妥',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绦',
    definition: 'silk cord; sash, ribbon, cord',
    pinyin: ['tāo'],
    decomposition: '⿰纟条',
    etymology: {
      type: 'pictophonetic',
      phonetic: '条',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '继',
    definition: 'to continue, to carry on; to succeed, to inherit',
    pinyin: ['jì'],
    decomposition: '⿰纟⿺？米',
    etymology: {
      type: 'pictophonetic',
      phonetic: '米',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [
      [0],
      [0],
      [0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      null,
    ],
  },
  {
    character: '绨',
    definition: 'coarse pongee, heavy silk',
    pinyin: ['tí'],
    decomposition: '⿰纟弟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弟',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绩',
    definition: 'achievements, merit',
    pinyin: ['jī'],
    decomposition: '⿰纟责',
    etymology: {
      type: 'ideographic',
      hint: "To complete 纟 one's duties 责; 责 also provides the pronunciation",
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绪',
    definition: 'mental state; thread, clue',
    pinyin: ['xù'],
    decomposition: '⿰纟者',
    etymology: {
      type: 'pictophonetic',
      phonetic: '者',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绫',
    definition: 'thin silk, damask silk',
    pinyin: ['líng'],
    decomposition: '⿰纟夌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夌',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '续',
    definition: 'continuous, serial',
    pinyin: ['xù'],
    decomposition: '⿰纟卖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卖',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绮',
    definition: 'fine silk; elegant, beautiful',
    pinyin: ['qǐ'],
    decomposition: '⿰纟奇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奇',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绯',
    definition: 'crimson, scarlet; purple',
    pinyin: ['fēi'],
    decomposition: '⿰纟非',
    etymology: {
      type: 'pictophonetic',
      phonetic: '非',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绰',
    definition: 'graceful, delicate; spacious',
    pinyin: ['chuò'],
    decomposition: '⿰纟卓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卓',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绱',
    definition: 'the sole of a shoe; to patch, to sole',
    pinyin: ['shàng'],
    decomposition: '⿰纟尚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尚',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绲',
    definition: 'belt, cord, sash; hemming; to sew',
    pinyin: ['gǔn'],
    decomposition: '⿰纟昆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昆',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绳',
    definition: 'string, rope, cord; to control',
    pinyin: ['shéng'],
    decomposition: '⿰纟黾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '黾',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '维',
    definition: 'to preserve, to maintain, to hold together',
    pinyin: ['wéi'],
    decomposition: '⿰纟隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隹',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绵',
    definition: 'continuous, unbroken; cotten, silk; soft, downy',
    pinyin: ['mián'],
    decomposition: '⿰纟帛',
    etymology: {
      type: 'ideographic',
      hint: 'A continuous thread 纟 of silk 帛',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绶',
    definition: 'a silk ribbon used as a seal',
    pinyin: ['shòu'],
    decomposition: '⿰纟受',
    etymology: {
      type: 'pictophonetic',
      phonetic: '受',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绷',
    definition: 'to bind, to strap, to draw firm',
    pinyin: ['běng'],
    decomposition: '⿰纟朋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朋',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绸',
    definition: 'silk cloth, satin damask',
    pinyin: ['chóu'],
    decomposition: '⿰纟周',
    etymology: {
      type: 'pictophonetic',
      phonetic: '周',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绺',
    definition: 'skein; tuft, lock; wrinkle',
    pinyin: ['liǔ'],
    decomposition: '⿰纟咎',
    etymology: {
      type: 'ideographic',
      hint: 'A wrinkle 咎 in a silk 纟 garment; 纟 also provides the pronunciation',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绻',
    definition: 'attached, inseparable, in love',
    pinyin: ['quǎn'],
    decomposition: '⿰纟卷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卷',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '综',
    definition: 'to sum up; to arrange threads for weaving',
    pinyin: ['zōng'],
    decomposition: '⿰纟宗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宗',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绽',
    definition: 'to crack; to burst open; to split at the seams',
    pinyin: ['zhàn'],
    decomposition: '⿰纟定',
    etymology: {
      type: 'pictophonetic',
      phonetic: '定',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绾',
    definition: 'to string together, to bind up',
    pinyin: ['wǎn'],
    decomposition: '⿰纟官',
    etymology: {
      type: 'pictophonetic',
      phonetic: '官',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '绿',
    definition: 'green; chlorine',
    pinyin: ['lǜ'],
    decomposition: '⿰纟录',
    etymology: {
      type: 'pictophonetic',
      phonetic: '录',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缀',
    definition: 'to connect, to join; to patch up, to stitch together',
    pinyin: ['zhuì'],
    decomposition: '⿰纟叕',
    etymology: {
      type: 'ideographic',
      hint: 'To bind 叕 by thread 纟; 叕 also provides the pronunciation',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缁',
    definition: 'black silk',
    pinyin: ['zī'],
    decomposition: '⿰纟甾',
    etymology: {
      type: 'ideographic',
      hint: 'Black 甾 silk 纟; 甾 also provides the pronunciation',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缂',
    definition: 'the woof of a woven item',
    pinyin: ['kè'],
    decomposition: '⿰纟革',
    etymology: {
      type: 'pictophonetic',
      phonetic: '革',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缃',
    definition: 'light-yellow color',
    pinyin: ['xiāng'],
    decomposition: '⿰纟相',
    etymology: {
      type: 'pictophonetic',
      phonetic: '相',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缄',
    definition: 'to seal, to close, to bind; a letter',
    pinyin: ['jiān'],
    decomposition: '⿰纟咸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咸',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缅',
    definition: 'distant, remote; to think of',
    pinyin: ['miǎn'],
    decomposition: '⿰纟面',
    etymology: {
      type: 'pictophonetic',
      phonetic: '面',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缆',
    definition: 'cable, hawser, heavy-duty rope',
    pinyin: ['lǎn'],
    decomposition: '⿰纟览',
    etymology: {
      type: 'pictophonetic',
      phonetic: '览',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缇',
    definition: 'orange-red silk; red, brown',
    pinyin: ['tí'],
    decomposition: '⿰纟是',
    etymology: {
      type: 'pictophonetic',
      phonetic: '是',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缈',
    definition: 'dim, indistinct; distant; minute',
    pinyin: ['miǎo'],
    decomposition: '⿰纟眇',
    etymology: {
      type: 'ideographic',
      hint: 'A veil 纟 over the eyes 眇; 眇 also provides the pronunciation',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缉',
    definition: 'to sieze, to arrest; to stich closely',
    pinyin: ['jī'],
    decomposition: '⿰纟咠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咠',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缊',
    definition: 'tangled hemp, raveled silk; vague, confused',
    pinyin: ['yūn'],
    decomposition: '⿰纟昷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昷',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缋',
    definition: 'to sketch, to paint, to draw; multicolored',
    pinyin: ['huì'],
    decomposition: '⿰纟贵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贵',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缌',
    definition: 'fine linen',
    pinyin: ['sī'],
    decomposition: '⿰纟思',
    etymology: {
      type: 'pictophonetic',
      phonetic: '思',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缍',
    pinyin: ['duǒ'],
    decomposition: '⿰纟垂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '垂',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缎',
    definition: 'satin',
    pinyin: ['duàn'],
    decomposition: '⿰纟段',
    etymology: {
      type: 'pictophonetic',
      phonetic: '段',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缏',
    definition: 'hem; to braid, to plait',
    pinyin: ['biàn'],
    decomposition: '⿰纟便',
    etymology: {
      type: 'pictophonetic',
      phonetic: '便',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缑',
    definition: 'a tassel on a sword hilt; surname',
    pinyin: ['gōu'],
    decomposition: '⿰纟侯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '侯',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缒',
    definition: 'to climb a rope; to hang, to rappel',
    pinyin: ['zhuì'],
    decomposition: '⿰纟追',
    etymology: {
      type: 'pictophonetic',
      phonetic: '追',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缓',
    definition: 'slow, gradual; to postpone, to delay',
    pinyin: ['huǎn'],
    decomposition: '⿰纟爰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爰',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缔',
    definition: 'to tie, to join; knot, connection',
    pinyin: ['dì'],
    decomposition: '⿰纟帝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '帝',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缕',
    definition: 'strand, thread; detailed, precise',
    pinyin: ['lǚ'],
    decomposition: '⿰纟娄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '娄',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '编',
    definition: 'to knit, to weave; to arrange, to compile',
    pinyin: ['biān'],
    decomposition: '⿰纟扁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '扁',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缗',
    definition: 'fishing line; cord; a string of coins',
    pinyin: ['mín'],
    decomposition: '⿰纟昬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昬',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缘',
    definition: 'reason, cause; fate; margin, hem',
    pinyin: ['yuán'],
    decomposition: '⿰纟彖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彖',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缙',
    definition: 'red silk',
    pinyin: ['jìn'],
    decomposition: '⿰纟晋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '晋',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缚',
    definition: 'to tie, to bind',
    pinyin: ['fù'],
    decomposition: '⿰纟尃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尃',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缛',
    definition: 'elegant, decorative, adorned',
    pinyin: ['rù'],
    decomposition: '⿰纟辱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辱',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缜',
    definition: 'fine, detailed; closely woven',
    pinyin: ['zhěn'],
    decomposition: '⿰纟真',
    etymology: {
      type: 'pictophonetic',
      phonetic: '真',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缝',
    definition: 'to sew, to mend',
    pinyin: ['fèng'],
    decomposition: '⿰纟逢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '逢',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缟',
    definition: 'plain white silk',
    pinyin: ['gǎo'],
    decomposition: '⿰纟高',
    etymology: {
      type: 'pictophonetic',
      phonetic: '高',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缠',
    definition: 'to wrap, to entangle; to involve; to bother, to annoy',
    pinyin: ['chán'],
    decomposition: '⿰纟㢆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㢆',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缡',
    definition: 'bridal veil; to tie, to bind',
    pinyin: ['lí'],
    decomposition: '⿰纟离',
    etymology: {
      type: 'pictophonetic',
      phonetic: '离',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缢',
    definition: 'to hang; to strangle',
    pinyin: ['yì'],
    decomposition: '⿰纟益',
    etymology: {
      type: 'pictophonetic',
      phonetic: '益',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缣',
    definition: 'fine silk',
    pinyin: ['jiān'],
    decomposition: '⿰纟兼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兼',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缤',
    definition: 'abundant, diverse, variegated',
    pinyin: ['bīn'],
    decomposition: '⿰纟宾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宾',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '缥',
    definition: 'dim, misty, indistinct; a silk veil',
    pinyin: ['piāo'],
    decomposition: '⿰纟票',
    etymology: {
      type: 'pictophonetic',
      phonetic: '票',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '缦',
    definition: 'plain silk; simple, plain',
    pinyin: ['màn'],
    decomposition: '⿰纟曼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曼',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '缧',
    definition: 'chains, bonds',
    pinyin: ['léi'],
    decomposition: '⿰纟累',
    etymology: {
      type: 'pictophonetic',
      phonetic: '累',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '缨',
    definition: 'tassel, ribbon; to bother, to annoy',
    pinyin: ['yīng'],
    decomposition: '⿰纟婴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '婴',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '缩',
    definition: 'to withdraw, to shrink, to pull back; abbreviation',
    pinyin: ['suō'],
    decomposition: '⿰纟宿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宿',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '缪',
    definition: 'to prepare; error, mistake; attached',
    pinyin: ['móu'],
    decomposition: '⿰纟翏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '翏',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '缫',
    definition: 'to draw, to reel in',
    pinyin: ['sāo'],
    decomposition: '⿰纟巢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巢',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '缬',
    definition: 'knot; to tie a knot',
    pinyin: ['xié'],
    decomposition: '⿰纟颉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '颉',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '缭',
    definition: 'confused; to bind; to wind around',
    pinyin: ['liáo'],
    decomposition: '⿰纟尞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尞',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '缮',
    definition: 'to repair, to mend; to transcribe, to rewrite',
    pinyin: ['shàn'],
    decomposition: '⿰纟善',
    etymology: {
      type: 'pictophonetic',
      phonetic: '善',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '缯',
    definition: 'silk; to tie, to bind; surname',
    pinyin: ['zēng'],
    decomposition: '⿰纟曾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曾',
      semantic: '纟',
      hint: 'silk',
    },
    radical: '纟',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '缰',
    definition: 'bridle, reins',
    pinyin: ['jiāng'],
    decomposition: '⿰纟畺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畺',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '缱',
    definition: 'attached, inseparable, in love; entangled',
    pinyin: ['qiǎn'],
    decomposition: '⿰纟遣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '遣',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '缲',
    definition: 'to spool, to reel',
    pinyin: ['qiāo'],
    decomposition: '⿰纟喿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '喿',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '缳',
    definition: 'noose; to hang; to tie, to bind',
    pinyin: ['huán'],
    decomposition: '⿰纟睘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '睘',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '缴',
    definition: 'to deliver, to submit, to hand over',
    pinyin: ['jiǎo'],
    decomposition: '⿰纟敫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敫',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '缵',
    definition: 'to continue, to carry on; to succeed',
    pinyin: ['zuǎn'],
    decomposition: '⿰纟赞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '赞',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '纟',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '缶',
    definition: 'earthen crock or jar; pottery',
    pinyin: ['fǒu'],
    decomposition: '⿱？山',
    etymology: { type: 'pictographic', hint: 'An earthen jar' },
    radical: '缶',
    matches: [null, null, null, [1], [1], [1]],
  },
  {
    character: '缸',
    definition: 'earthen jug, crock, cistern',
    pinyin: ['gāng'],
    decomposition: '⿰缶工',
    etymology: {
      type: 'pictophonetic',
      phonetic: '工',
      semantic: '缶',
      hint: 'pottery',
    },
    radical: '缶',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '缺',
    definition: 'to lack, to be short; vacancy, gap, deficit',
    pinyin: ['quē'],
    decomposition: '⿰缶夬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夬',
      semantic: '缶',
      hint: 'jar',
    },
    radical: '缶',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '缽',
    definition: 'earthen basin; alms bowl',
    pinyin: ['bō'],
    decomposition: '⿰缶本',
    etymology: {
      type: 'pictophonetic',
      phonetic: '本',
      semantic: '缶',
      hint: 'pottery',
    },
    radical: '缶',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '罂',
    definition: 'long-necked bottle or jar',
    pinyin: ['yīng'],
    decomposition: '⿱⿰贝贝缶',
    etymology: { type: 'pictophonetic', semantic: '缶', hint: 'pottery' },
    radical: '缶',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '罄',
    definition: 'empty; to exhaust, to run out, to use up',
    pinyin: ['qìng'],
    decomposition: '⿱殸缶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '殸',
      semantic: '缶',
      hint: 'pottery',
    },
    radical: '缶',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '罅',
    definition: 'crack, fissure, split',
    pinyin: ['xià'],
    decomposition: '⿰缶虖',
    etymology: {
      type: 'ideographic',
      hint: 'The sound 虖 of pottery 缶 breaking',
    },
    radical: '缶',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '罈',
    definition: 'altar; arena; examination hall',
    pinyin: ['tán'],
    decomposition: '⿰缶覃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '覃',
      semantic: '缶',
      hint: 'earth',
    },
    radical: '缶',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '罌',
    definition: 'long-necked bottle or jar',
    pinyin: ['yīng'],
    decomposition: '⿱賏缶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '賏',
      semantic: '缶',
      hint: 'pottery',
    },
    radical: '缶',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '罐',
    definition: 'jar, jug, pitcher, pot',
    pinyin: ['guàn'],
    decomposition: '⿰缶雚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '雚',
      semantic: '缶',
      hint: 'jar',
    },
    radical: '缶',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '网',
    definition: 'net; network',
    pinyin: ['wǎng'],
    decomposition: '⿵冂⿰乂乂',
    etymology: { type: 'pictographic', hint: 'A net for catching fish' },
    radical: '网',
    matches: [[0], [0], [1, 0], [1, 0], [1, 1], [1, 1]],
  },
  {
    character: '罒',
    definition: 'net, network',
    pinyin: ['wǎng'],
    decomposition: '⿻口？',
    radical: '罒',
    matches: [[0], [0], null, null, [0]],
  },
  {
    character: '罓',
    definition: 'net, network',
    pinyin: ['gāng'],
    decomposition: '？',
    etymology: {
      type: 'pictographic',
      hint: 'A net for catching fish; compare 网',
    },
    radical: '罓',
    matches: [null, null, null, null],
  },
  {
    character: '罔',
    definition: 'none; to deceive; to slander',
    pinyin: ['wǎng'],
    decomposition: '⿵⺳⿱一亡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亡',
      semantic: '⺳',
      hint: 'net',
    },
    radical: '⺳',
    matches: [[0], [0], [0], [0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '罕',
    definition: 'rare, scarce; surname',
    pinyin: ['hǎn'],
    decomposition: '⿱⺳干',
    etymology: {
      type: 'ideographic',
      hint: 'An empty 干 fishing net ⺳; 干 also provides the pronunciation',
    },
    radical: '⺳',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '罗',
    definition: 'gauze, net; to collect, to display',
    pinyin: ['luō'],
    decomposition: '⿱罒夕',
    etymology: { type: 'pictophonetic', semantic: '罒', hint: 'net' },
    radical: '罒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '罘',
    definition: 'a screen used in ancient times',
    pinyin: ['fú'],
    decomposition: '⿱罒不',
    etymology: {
      type: 'pictophonetic',
      phonetic: '不',
      semantic: '罒',
      hint: 'net',
    },
    radical: '罒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '罙',
    definition: 'deep',
    pinyin: ['mí'],
    decomposition: '⿱⺳木',
    etymology: { type: 'pictophonetic', phonetic: '木' },
    radical: '⺳',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '罚',
    definition: 'penalty, fine; to punish, to penalize',
    pinyin: ['fá'],
    decomposition: '⿱罒⿰讠刂',
    etymology: {
      type: 'ideographic',
      hint: 'Simplified form of 罰; to punish 刂 the accused 詈',
    },
    radical: '罒',
    matches: [[0], [0], [0], [0], [0], [1, 0], [1, 0], [1, 1], [1, 1]],
  },
  {
    character: '罟',
    definition: 'net, snare; to implicate',
    pinyin: ['gǔ'],
    decomposition: '⿱罒古',
    etymology: {
      type: 'pictophonetic',
      phonetic: '古',
      semantic: '罒',
      hint: 'net',
    },
    radical: '罒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '罡',
    definition: 'the stars at the end of the Big Dipper',
    pinyin: ['gāng'],
    decomposition: '⿱罒正',
    etymology: {
      type: 'pictophonetic',
      phonetic: '正',
      semantic: '罒',
      hint: 'net',
    },
    radical: '罒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '罢',
    definition: 'to cease, to finish, to stop, to quit',
    pinyin: ['bà'],
    decomposition: '⿱罒去',
    etymology: {
      type: 'ideographic',
      hint: 'Stuck in a net 罒, unable to leave 去',
    },
    radical: '罒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '罨',
    definition: 'medical compress; fishing net',
    pinyin: ['yǎn'],
    decomposition: '⿱罒奄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奄',
      semantic: '罒',
      hint: 'net',
    },
    radical: '罒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '罩',
    definition: 'cover, shroud; basket for catching fish',
    pinyin: ['zhào'],
    decomposition: '⿱罒卓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卓',
      semantic: '罒',
      hint: 'net',
    },
    radical: '罒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '罪',
    definition: 'sin, vice; fault, guilt; crime',
    pinyin: ['zuì'],
    decomposition: '⿱罒非',
    etymology: { type: 'ideographic', hint: 'A net 罒 of wrongdoing 非' },
    radical: '罒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '置',
    definition: 'to lay out, to place, to set aside',
    pinyin: ['zhì'],
    decomposition: '⿱罒直',
    etymology: {
      type: 'pictophonetic',
      phonetic: '直',
      semantic: '罒',
      hint: 'net',
    },
    radical: '罒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '罰',
    definition: 'penalty, fine; to punish, to penalize',
    pinyin: ['fá'],
    decomposition: '⿱罒⿰言刂',
    etymology: { type: 'ideographic', hint: 'To punish 刂 the accused 詈' },
    radical: '罒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '罱',
    definition: 'fishing net',
    pinyin: ['lǎn'],
    decomposition: '⿱罒南',
    etymology: {
      type: 'pictophonetic',
      phonetic: '南',
      semantic: '罒',
      hint: 'net',
    },
    radical: '罒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '署',
    definition: 'bureau, public office; to sign',
    pinyin: ['shǔ'],
    decomposition: '⿱罒者',
    etymology: {
      type: 'pictophonetic',
      phonetic: '者',
      semantic: '罒',
      hint: 'network',
    },
    radical: '罒',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '罴',
    definition: 'brown bear, Ursus arctos',
    pinyin: ['pí'],
    decomposition: '⿱罢灬',
    radical: '罒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '罵',
    definition: 'to accuse, to blame, to curse, to scold',
    pinyin: ['mà'],
    decomposition: '⿱罒馬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '馬',
      semantic: '罒',
      hint: 'net',
    },
    radical: '罒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '罷',
    definition: 'to cease, to finish, to stop, to quit',
    pinyin: ['bà'],
    decomposition: '⿱罒能',
    etymology: {
      type: 'ideographic',
      hint: 'Stuck in a net 罒, unable 能 to leave',
    },
    radical: '罒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '罹',
    definition: 'sorrow, grief; to incur, to meet with',
    pinyin: ['lí'],
    decomposition: '⿱罒惟',
    etymology: { type: 'pictophonetic', semantic: '忄', hint: 'heart' },
    radical: '罒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '罾',
    definition: 'a large square net for catching fish',
    pinyin: ['zēng'],
    decomposition: '⿱罒曾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曾',
      semantic: '罒',
      hint: 'net',
    },
    radical: '罒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '羁',
    definition: 'halter; to restrain, to hold, to control',
    pinyin: ['jī'],
    decomposition: '⿱罒⿰革马',
    etymology: {
      type: 'ideographic',
      hint: 'A leather 革 halter used to control 罒a horse  马',
    },
    radical: '罒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '羅',
    definition: 'gauze, net; to collect, to display',
    pinyin: ['luō'],
    decomposition: '⿱罒維',
    etymology: {
      type: 'ideographic',
      hint: 'A silk 糹 net 罒 for catching birds 隹',
    },
    radical: '罒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '羆',
    definition: 'brown bear, Ursus arctos',
    pinyin: ['pí'],
    decomposition: '⿱罒熊',
    etymology: { type: 'pictophonetic', semantic: '熊', hint: 'bear' },
    radical: '罒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '羈',
    definition: 'halter; to restrain, to hold, to control',
    pinyin: ['jī'],
    decomposition: '⿱罒⿰革馬',
    etymology: {
      type: 'ideographic',
      hint: 'A leather 革 halter used to control 罒a horse  馬',
    },
    radical: '罒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '羊',
    definition: 'sheep, goat',
    pinyin: ['yáng'],
    decomposition: '⿱丷？',
    etymology: { type: 'pictographic', hint: "A sheep's head with horns" },
    radical: '羊',
    matches: [[0], [0], null, null, null, null],
  },
  {
    character: '羋',
    definition: 'the bleating of sheep; surname',
    pinyin: ['mǐ'],
    decomposition: '⿱？？',
    radical: '羋',
    matches: [null, null, null, null, null, null, null, null],
  },
  {
    character: '羌',
    definition: 'Qiang nationality; surname',
    pinyin: ['qiāng'],
    decomposition: '⿸羊乚',
    etymology: { type: 'pictophonetic', phonetic: '羊' },
    radical: '羊',
    matches: [[0], [0], [0], [0], [0], [0], [1]],
  },
  {
    character: '羍',
    pinyin: ['dá'],
    decomposition: '⿱大羊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '大',
      semantic: '羊',
      hint: 'sheep',
    },
    radical: '羊',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '美',
    definition: 'beautiful, pretty; pleasing',
    pinyin: ['měi'],
    decomposition: '⿱羊大',
    etymology: {
      type: 'ideographic',
      hint: 'A person 大 wearing an elegant crown 羊',
    },
    radical: '羊',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '羔',
    definition: 'lamb',
    pinyin: ['gāo'],
    decomposition: '⿱羊灬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '灬',
      semantic: '羊',
      hint: 'sheep',
    },
    radical: '羊',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '羕',
    definition: 'river, flowing water',
    pinyin: ['yàng'],
    decomposition: '⿱羊永',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羊',
      semantic: '永',
      hint: 'long',
    },
    radical: '羊',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '羚',
    definition: 'a species of antelope',
    pinyin: ['líng'],
    decomposition: '⿰羊令',
    etymology: {
      type: 'pictophonetic',
      phonetic: '令',
      semantic: '羊',
      hint: 'sheep',
    },
    radical: '羊',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '羝',
    definition: 'ram, he-goat',
    pinyin: ['dī'],
    decomposition: '⿰羊氐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '氐',
      semantic: '羊',
      hint: 'sheep',
    },
    radical: '羊',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '羞',
    definition: 'shame, disgrace; shy, ashamed',
    pinyin: ['xiū'],
    decomposition: '⿸羊丑',
    etymology: { type: 'ideographic', hint: 'An ugly 丑 sheep 羊' },
    radical: '羊',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '羟',
    definition: 'hydroxide',
    pinyin: ['qiǎng'],
    decomposition: '⿰羊？',
    etymology: { type: 'pictophonetic', phonetic: '羊' },
    radical: '羊',
    matches: [[0], [0], [0], [0], [0], [0], null, null, null, null, null],
  },
  {
    character: '羡',
    definition: 'to envy, to covet; to admire, to praise',
    pinyin: ['xiàn'],
    decomposition: '⿱羊次',
    etymology: {
      type: 'ideographic',
      hint: 'Someone who has a whole row 次 of sheep 羊',
    },
    radical: '羊',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '群',
    definition: 'group, crowd; multitude, mob',
    pinyin: ['qún'],
    decomposition: '⿰君羊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '君',
      semantic: '羊',
      hint: 'sheep',
    },
    radical: '羊',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '羥',
    definition: 'hydroxide',
    pinyin: ['qiǎng'],
    decomposition: '⿰羊巠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羊',
      semantic: '巠',
      hint: 'water',
    },
    radical: '羊',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '羧',
    definition: 'carboxyl group',
    pinyin: ['suō'],
    decomposition: '⿰羊夋',
    radical: '羊',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '羨',
    definition: 'to covet, to envy; to admire, to praise',
    pinyin: ['xiàn'],
    decomposition: '⿱羊㳄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㳄',
      semantic: '羊',
      hint: 'sheep',
    },
    radical: '羊',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '義',
    definition: 'right conduct, propriety; justice',
    pinyin: ['yì'],
    decomposition: '⿱羊我',
    etymology: {
      type: 'pictophonetic',
      phonetic: '我',
      semantic: '羊',
      hint: 'sheep',
    },
    radical: '羊',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '羯',
    definition: 'wether, castrated ram; deer skin',
    pinyin: ['jié'],
    decomposition: '⿰羊曷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曷',
      semantic: '羊',
      hint: 'sheep',
    },
    radical: '羊',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '羰',
    definition: 'carbonyl group',
    pinyin: ['tāng'],
    decomposition: '⿰羊炭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羊',
      semantic: '炭',
      hint: 'carbon',
    },
    radical: '羊',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '羲',
    definition: 'an ancient emperor; breath, vapor',
    pinyin: ['xī'],
    decomposition: '⿱羊⿱⿻禾戈丂',
    radical: '羊',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 1],
      [1, 1],
      [1, 0, 1],
      [1, 0, 1],
      [1, 0, 1],
    ],
  },
  {
    character: '羴',
    definition: 'the rank odor of sheep or goats',
    pinyin: ['shān'],
    decomposition: '⿱羊⿰羊羊',
    etymology: {
      type: 'ideographic',
      hint: 'The smell of a large flock of sheep 羊',
    },
    radical: '羊',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '羸',
    definition: 'exhausted, weak; emaciated, lean',
    pinyin: ['léi'],
    decomposition: '⿱吂⿲月羊凡',
    radical: '羊',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 2],
      [1, 2],
      [1, 2],
    ],
  },
  {
    character: '羹',
    definition: 'soup, broth',
    pinyin: ['gēng'],
    decomposition: '⿱羔美',
    etymology: { type: 'ideographic', hint: 'A pleasing 美 lamb 羔 soup' },
    radical: '羊',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '羼',
    definition: 'to confuse, to mix; to interpolate',
    pinyin: ['chàn'],
    decomposition: '⿸尸羴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羴',
      semantic: '尸',
      hint: 'body',
    },
    radical: '羊',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '羽',
    definition: 'feather, plume; wings',
    pinyin: ['yǔ'],
    decomposition: '⿰习习',
    etymology: { type: 'pictographic', hint: 'Two feathers or wings' },
    radical: '羽',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '羿',
    definition: 'a legendary archer',
    pinyin: ['yì'],
    decomposition: '⿱羽廾',
    etymology: { type: 'ideographic', hint: 'A man drawing 廾 an arrow 羽' },
    radical: '羽',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '翁',
    definition: 'old man; father, father-in-law',
    pinyin: ['wēng'],
    decomposition: '⿱公羽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '公',
      semantic: '羽',
      hint: 'feather',
    },
    radical: '羽',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '翅',
    definition: 'wings; fins',
    pinyin: ['chì'],
    decomposition: '⿺支羽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '支',
      semantic: '羽',
      hint: 'wings',
    },
    radical: '羽',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '翊',
    definition: 'flying; to assist, to help; to respect',
    pinyin: ['yì'],
    decomposition: '⿰立羽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '立',
      semantic: '羽',
      hint: 'wings',
    },
    radical: '羽',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '翌',
    definition: 'bright; dawn, daybreak; tomorrow',
    pinyin: ['yì'],
    decomposition: '⿱羽立',
    radical: '羽',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '翎',
    definition: 'plume, tail feathers',
    pinyin: ['líng'],
    decomposition: '⿰令羽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '令',
      semantic: '羽',
      hint: 'plume',
    },
    radical: '羽',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '翏',
    definition: 'the sound of the wind; to soar',
    pinyin: ['liù'],
    decomposition: '⿱羽⿱人彡',
    etymology: {
      type: 'ideographic',
      hint: "To feel the wind 羽 in one's 人 hair 彡",
    },
    radical: '羽',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '習',
    definition: 'to study, to practice; habit',
    pinyin: ['xí'],
    decomposition: '⿱羽白',
    etymology: {
      type: 'ideographic',
      hint: 'Birds flying 羽 in the daytime 白',
    },
    radical: '羽',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '翔',
    definition: 'to soar, to hover, to glide',
    pinyin: ['xiáng'],
    decomposition: '⿰羊羽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羊',
      semantic: '羽',
      hint: 'wings',
    },
    radical: '羽',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '翕',
    definition: 'to agree; to open and close the mouth',
    pinyin: ['xī'],
    decomposition: '⿱合羽',
    etymology: { type: 'ideographic', hint: 'Birds 羽 flocking together 合' },
    radical: '羽',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '翘',
    definition: 'outstanding; to elevate, to lift, to raise',
    pinyin: ['qiào'],
    decomposition: '⿺尧羽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尧',
      semantic: '羽',
      hint: 'wings',
    },
    radical: '羽',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '翟',
    definition: 'long-tailed pheasant; plume; surname',
    pinyin: ['dí'],
    decomposition: '⿱羽隹',
    etymology: { type: 'ideographic', hint: 'A bird 隹 with a plumed 羽 tail' },
    radical: '羽',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '翠',
    definition: 'kingfisher; jade, emerald',
    pinyin: ['cuì'],
    decomposition: '⿱羽卒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卒',
      semantic: '羽',
      hint: 'wings',
    },
    radical: '羽',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '翡',
    definition: 'kingfisher; jade, emerald',
    pinyin: ['fěi'],
    decomposition: '⿱非羽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '非',
      semantic: '羽',
      hint: 'plume',
    },
    radical: '羽',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '翥',
    definition: 'to soar; to take off',
    pinyin: ['zhù'],
    decomposition: '⿱者羽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '者',
      semantic: '羽',
      hint: 'wings',
    },
    radical: '羽',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '翦',
    definition: 'scissors; to cut, to clip; to annihilate',
    pinyin: ['jiǎn'],
    decomposition: '⿱前羽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '前',
      semantic: '羽',
      hint: 'feather',
    },
    radical: '羽',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '翩',
    definition: 'to fly, to flutter',
    pinyin: ['piān'],
    decomposition: '⿰扁羽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '扁',
      semantic: '羽',
      hint: 'wings',
    },
    radical: '羽',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '翮',
    definition: 'quill, feather stem',
    pinyin: ['hé'],
    decomposition: '⿰鬲羽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鬲',
      semantic: '羽',
      hint: 'feather',
    },
    radical: '羽',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '翰',
    definition: 'pen, pencil, writing brush',
    pinyin: ['hàn'],
    decomposition: '⿰倝羽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '倝',
      semantic: '羽',
      hint: 'plume',
    },
    radical: '羽',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '翱',
    definition: 'to soar; to roam',
    pinyin: ['áo'],
    decomposition: '⿰皋羽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皋',
      semantic: '羽',
      hint: 'wings',
    },
    radical: '羽',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '翳',
    definition: 'shade, screen; to hide, to screen',
    pinyin: ['yì'],
    decomposition: '⿱殹羽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '殹',
      semantic: '羽',
      hint: 'feather',
    },
    radical: '羽',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '翹',
    definition: 'outstanding; to elevate, to lift, to raise',
    pinyin: ['qiào'],
    decomposition: '⿺堯羽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堯',
      semantic: '羽',
      hint: 'wings',
    },
    radical: '羽',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '翻',
    definition: 'to upset, to capsize, to flip over',
    pinyin: ['fān'],
    decomposition: '⿰番羽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '番',
      semantic: '羽',
      hint: 'wings',
    },
    radical: '羽',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '翼',
    definition: 'wings, fins; shelter',
    pinyin: ['yì'],
    decomposition: '⿱羽異',
    etymology: {
      type: 'pictophonetic',
      phonetic: '異',
      semantic: '羽',
      hint: 'wings',
    },
    radical: '羽',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '耀',
    definition: 'to sparkle, to shine, to dazzle; glory',
    pinyin: ['yào'],
    decomposition: '⿰光翟',
    etymology: {
      type: 'ideographic',
      hint: 'A peacock 翟 with a brilliant 光 tail',
    },
    radical: '羽',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '老',
    definition: 'old, aged; experienced',
    pinyin: ['lǎo'],
    decomposition: '⿱耂匕',
    etymology: {
      type: 'pictographic',
      hint: 'A person bent over with long hair 匕 and a crutch; compare 耂',
    },
    radical: '老',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '耂',
    definition: 'old, aged; experienced',
    pinyin: ['lǎo'],
    decomposition: '⿻土丿',
    etymology: {
      type: 'ideographic',
      hint: 'A person bent over with long hair',
    },
    radical: '耂',
    matches: [[0], [0], [0], [1]],
  },
  {
    character: '考',
    definition: 'to test, to investigate, to examine',
    pinyin: ['kǎo'],
    decomposition: '⿸耂丂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丂',
      semantic: '耂',
      hint: 'old',
    },
    radical: '耂',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '耄',
    definition: 'selderly person; old, senile',
    pinyin: ['mào'],
    decomposition: '⿱老毛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '毛',
      semantic: '老',
      hint: 'old',
    },
    radical: '老',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '者',
    definition: 'that which; they who; those who',
    pinyin: ['zhě'],
    decomposition: '⿸耂日',
    radical: '耂',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '耆',
    definition: 'man of sixty; aged, old',
    pinyin: ['qí'],
    decomposition: '⿱老日',
    etymology: {
      type: 'pictophonetic',
      phonetic: '日',
      semantic: '老',
      hint: 'old',
    },
    radical: '老',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '耋',
    definition: "aged; in one's eighties",
    pinyin: ['dié'],
    decomposition: '⿱老至',
    etymology: {
      type: 'pictophonetic',
      phonetic: '至',
      semantic: '老',
      hint: 'old',
    },
    radical: '老',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '而',
    definition: 'and, and then, and yet; but',
    pinyin: ['ér'],
    decomposition: '？',
    radical: '而',
    matches: [null, null, null, null, null, null],
  },
  {
    character: '耍',
    definition: 'to play, to frolic, to amuse',
    pinyin: ['shuǎ'],
    decomposition: '⿱而女',
    etymology: {
      type: 'ideographic',
      hint: 'A woman 女 wearing a beard 而 for disguise',
    },
    radical: '而',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '耐',
    definition: 'to resist, to bear; patient, enduring',
    pinyin: ['nài'],
    decomposition: '⿰而寸',
    radical: '而',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '耑',
    definition: 'specialized; concentrated',
    pinyin: ['duān'],
    decomposition: '⿱山而',
    radical: '而',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '耒',
    definition: 'plow',
    pinyin: ['lěi'],
    decomposition: '⿻丰八',
    etymology: { type: 'pictographic', hint: 'The handle of a plow' },
    radical: '耒',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '耔',
    definition: "to hoe the soil around one's plants",
    pinyin: ['zǐ'],
    decomposition: '⿰耒子',
    etymology: {
      type: 'pictophonetic',
      phonetic: '子',
      semantic: '耒',
      hint: 'plow',
    },
    radical: '耒',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '耕',
    definition: 'to plow, to cultivate',
    pinyin: ['gēng'],
    decomposition: '⿰耒井',
    etymology: {
      type: 'pictophonetic',
      phonetic: '井',
      semantic: '耒',
      hint: 'plow',
    },
    radical: '耒',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '耖',
    pinyin: ['chào'],
    decomposition: '⿰耒少',
    etymology: {
      type: 'pictophonetic',
      phonetic: '少',
      semantic: '耒',
      hint: 'plow',
    },
    radical: '耒',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '耗',
    definition: 'to consume, to use up; to squander, to waste',
    pinyin: ['hào'],
    decomposition: '⿰耒毛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '毛',
      semantic: '耒',
      hint: 'plow',
    },
    radical: '耒',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '耘',
    definition: 'to weed',
    pinyin: ['yún'],
    decomposition: '⿰耒云',
    etymology: {
      type: 'pictophonetic',
      phonetic: '云',
      semantic: '耒',
      hint: 'plow',
    },
    radical: '耒',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '耙',
    definition: 'to rake',
    pinyin: ['bà'],
    decomposition: '⿰耒巴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巴',
      semantic: '耒',
      hint: 'plow',
    },
    radical: '耒',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '耜',
    definition: 'plow, spade',
    pinyin: ['sì'],
    decomposition: '⿰耒㠯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㠯',
      semantic: '耒',
      hint: 'plow',
    },
    radical: '耒',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '耠',
    definition: 'to dig, to till',
    pinyin: ['huō'],
    decomposition: '⿰耒合',
    etymology: {
      type: 'pictophonetic',
      phonetic: '合',
      semantic: '耒',
      hint: 'plow',
    },
    radical: '耒',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '耢',
    definition: 'a kind of farm tool',
    pinyin: ['lào'],
    decomposition: '⿰耒劳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '劳',
      semantic: '耒',
      hint: 'plow',
    },
    radical: '耒',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '耤',
    definition: 'to plow; to rely on',
    pinyin: ['jí'],
    decomposition: '⿰耒昔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昔',
      semantic: '耒',
      hint: 'plow',
    },
    radical: '耒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '耥',
    definition: 'a kind of farm tool',
    pinyin: ['tāng'],
    decomposition: '⿰耒尚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尚',
      semantic: '耒',
      hint: 'plow',
    },
    radical: '耒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '耦',
    definition: 'to plow side-by-side; pair, couple; a team of two',
    pinyin: ['ǒu'],
    decomposition: '⿰耒禺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '禺',
      semantic: '耒',
      hint: 'plow',
    },
    radical: '耒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '耧',
    definition: 'a drill for sowing grain',
    pinyin: ['lóu'],
    decomposition: '⿰耒娄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '娄',
      semantic: '耒',
      hint: 'plow',
    },
    radical: '耒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '耨',
    definition: 'to hoe, to rake; to weed',
    pinyin: ['nòu'],
    decomposition: '⿰耒辱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辱',
      semantic: '耒',
      hint: 'plow',
    },
    radical: '耒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '耩',
    definition: 'to plow; to sow',
    pinyin: ['jiǎng'],
    decomposition: '⿰耒冓',
    etymology: { type: 'ideographic', hint: 'To dig a hole 冓 with a plow 耒' },
    radical: '耒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '耪',
    definition: 'to cultivate, to plow',
    pinyin: ['pǎng'],
    decomposition: '⿰耒旁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旁',
      semantic: '耒',
      hint: 'plow',
    },
    radical: '耒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '耱',
    definition: 'a kind of farm tool',
    pinyin: ['mò'],
    decomposition: '⿰耒磨',
    etymology: {
      type: 'pictophonetic',
      phonetic: '磨',
      semantic: '耒',
      hint: 'plow',
    },
    radical: '耒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '耳',
    definition: 'ear; to hear, to hear of; handle',
    pinyin: ['ěr'],
    decomposition: '⿻？二',
    etymology: { type: 'pictographic', hint: 'An ear' },
    radical: '耳',
    matches: [[1], null, null, null, null, [1]],
  },
  {
    character: '耴',
    pinyin: ['yì'],
    decomposition: '⿰耳乚',
    radical: '耳',
    matches: [[0], [0], [0], [0], [0], [0], [1]],
  },
  {
    character: '耵',
    definition: 'earwax',
    pinyin: ['dīng'],
    decomposition: '⿰耳丁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丁',
      semantic: '耳',
      hint: 'ear',
    },
    radical: '耳',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '耶',
    definition: 'used in transliterations',
    pinyin: ['yé'],
    decomposition: '⿰耳阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '阝',
      semantic: '耳',
      hint: 'ear',
    },
    radical: '耳',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '耷',
    definition: 'drooping ears',
    pinyin: ['dā'],
    decomposition: '⿱大耳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '大',
      semantic: '耳',
      hint: 'ear',
    },
    radical: '耳',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '耸',
    definition: 'to excite, to urge; to raise; to shrug; lofty, towering',
    pinyin: ['sǒng'],
    decomposition: '⿱从耳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '从',
      semantic: '耳',
      hint: 'ear',
    },
    radical: '耳',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '耻',
    definition: 'shame, humiliation; ashamed',
    pinyin: ['chǐ'],
    decomposition: '⿰耳止',
    etymology: {
      type: 'pictophonetic',
      phonetic: '止',
      semantic: '耳',
      hint: 'ear',
    },
    radical: '耳',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '耽',
    definition: 'to indulge; to delay',
    pinyin: ['dān'],
    decomposition: '⿰耳冘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冘',
      semantic: '耳',
      hint: 'ear',
    },
    radical: '耳',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '耿',
    definition: 'bright, shining; brave, loyal',
    pinyin: ['gěng'],
    decomposition: '⿰耳火',
    etymology: { type: 'pictophonetic', semantic: '火', hint: 'fire' },
    radical: '耳',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '聂',
    definition: 'to whisper; surname',
    pinyin: ['niè'],
    decomposition: '⿱耳双',
    etymology: { type: 'ideographic', hint: 'A pair 双 of ears 耳' },
    radical: '耳',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '聃',
    definition: 'ears without rims; a nickname',
    pinyin: ['dān'],
    decomposition: '⿰耳冉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冉',
      semantic: '耳',
      hint: 'ear',
    },
    radical: '耳',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '聆',
    definition: 'to hear, to listen',
    pinyin: ['líng'],
    decomposition: '⿰耳令',
    etymology: {
      type: 'pictophonetic',
      phonetic: '令',
      semantic: '耳',
      hint: 'ear',
    },
    radical: '耳',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '聊',
    definition: 'somewhat, slightly, at least',
    pinyin: ['liáo'],
    decomposition: '⿰耳卯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卯',
      semantic: '耳',
      hint: 'ear',
    },
    radical: '耳',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '聋',
    definition: 'deaf',
    pinyin: ['lóng'],
    decomposition: '⿱龙耳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龙',
      semantic: '耳',
      hint: 'ear',
    },
    radical: '耳',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '职',
    definition: 'duty, profession; office, post',
    pinyin: ['zhí'],
    decomposition: '⿰耳只',
    etymology: {
      type: 'pictophonetic',
      phonetic: '只',
      semantic: '耳',
      hint: 'ear',
    },
    radical: '耳',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '聍',
    definition: 'earwax',
    pinyin: ['níng'],
    decomposition: '⿰耳宁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宁',
      semantic: '耳',
      hint: 'ear',
    },
    radical: '耳',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '聒',
    definition: 'clamor, din, hubbub',
    pinyin: ['guā'],
    decomposition: '⿰耳舌',
    etymology: { type: 'ideographic', hint: 'The sound 耳 of a bell 舌' },
    radical: '耳',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '联',
    definition: 'ally, associate; to connect, to join',
    pinyin: ['lián'],
    decomposition: '⿰耳关',
    etymology: {
      type: 'pictophonetic',
      phonetic: '关',
      semantic: '耳',
      hint: 'ear',
    },
    radical: '耳',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '聖',
    definition: 'holy, sacred; sage, saint',
    pinyin: ['shèng'],
    decomposition: '⿱⿰耳口王',
    etymology: {
      type: 'ideographic',
      hint: 'A ruler 王 who speaks 口 and listens 耳',
    },
    radical: '耳',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '聘',
    definition: 'to employ, to engage; betrothed',
    pinyin: ['pìn'],
    decomposition: '⿰耳甹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甹',
      semantic: '耳',
      hint: 'ear',
    },
    radical: '耳',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '聚',
    definition: 'to assemble, to collect, to meet',
    pinyin: ['jù'],
    decomposition: '⿱取乑',
    etymology: {
      type: 'ideographic',
      hint: 'People standing side-by-side 乑, hand-to-ear 取',
    },
    radical: '耳',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '聞',
    definition: 'news; to hear, to smell; to make known',
    pinyin: ['wén'],
    decomposition: '⿵門耳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '門',
      semantic: '耳',
      hint: 'ear',
    },
    radical: '耳',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '聩',
    definition: 'deaf',
    pinyin: ['kuì'],
    decomposition: '⿰耳贵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贵',
      semantic: '耳',
      hint: 'ear',
    },
    radical: '耳',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '聪',
    definition: 'sharp (of sight and hearing); intelligent, clever, bright',
    pinyin: ['cōng'],
    decomposition: '⿰耳总',
    etymology: {
      type: 'pictophonetic',
      phonetic: '总',
      semantic: '耳',
      hint: 'ear',
    },
    radical: '耳',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '聯',
    definition: 'ally, associate; to connect, to join',
    pinyin: ['lián'],
    decomposition: '⿰耳絲',
    etymology: { type: 'pictophonetic', semantic: '絲', hint: 'silk' },
    radical: '耳',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '聰',
    definition: 'sharp (of sight and hearing); intelligent, clever, bright',
    pinyin: ['cōng'],
    decomposition: '⿰耳悤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '悤',
      semantic: '耳',
      hint: 'ear',
    },
    radical: '耳',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '聱',
    definition: 'bent, twisted; overcomplicated',
    pinyin: ['áo'],
    decomposition: '⿱敖耳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敖',
      semantic: '耳',
      hint: 'ear',
    },
    radical: '耳',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '聲',
    definition: 'sound, noise; voice, tone, music',
    pinyin: ['shēng'],
    decomposition: '⿱殸耳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '殸',
      semantic: '耳',
      hint: 'ear',
    },
    radical: '耳',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '聳',
    definition: 'to excite, to urge; to raise; to shrug; lofty, towering',
    pinyin: ['sǒng'],
    decomposition: '⿱從耳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '從',
      semantic: '耳',
      hint: 'ear',
    },
    radical: '耳',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '聶',
    definition: 'to whisper; surname',
    pinyin: ['niè'],
    decomposition: '⿱耳⿰耳耳',
    etymology: { type: 'ideographic', hint: 'A rumor passing by many ears 耳' },
    radical: '耳',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '職',
    definition: 'duty, profession; office, post',
    pinyin: ['zhí'],
    decomposition: '⿰耳戠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戠',
      semantic: '耳',
      hint: 'ear',
    },
    radical: '耳',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '聽',
    definition: 'to hear, to listen; to understand; to obey',
    pinyin: ['tīng'],
    decomposition: '⿰⿹耳王⿱⿱十罒⿱一心',
    etymology: {
      type: 'ideographic',
      hint: 'Someone listening 耳 attentively 心',
    },
    radical: '耳',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 1],
      [1, 0, 1],
      [1, 0, 1],
      [1, 0, 1],
      [1, 0, 1],
      [1, 1, 0],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
    ],
  },
  {
    character: '聾',
    definition: 'deaf',
    pinyin: ['lóng'],
    decomposition: '⿱龍耳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龍',
      semantic: '耳',
      hint: 'ear',
    },
    radical: '耳',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '聿',
    definition: 'writing brush, pencil; thereupon',
    pinyin: ['yù'],
    decomposition: '⿱肀？',
    etymology: {
      type: 'pictographic',
      hint: 'A hand 彐 holding a brush; compare 肀',
    },
    radical: '聿',
    matches: [[0], [0], [0], null, null, [0]],
  },
  {
    character: '肀',
    definition: 'pen',
    pinyin: ['yù'],
    decomposition: '⿻彐丨',
    etymology: {
      type: 'pictographic',
      hint: 'A hand 彐 holding a pen; compare 聿',
    },
    radical: '肀',
    matches: [[0], [0], [0], [1]],
  },
  {
    character: '肃',
    definition: 'to pay respects; solemn, reverent',
    pinyin: ['sù'],
    decomposition: '⿱肀？',
    radical: '肀',
    matches: [[0], [0], [0], [0], null, null, null, null],
  },
  {
    character: '肄',
    definition: 'to learn, to practice, to study, to toil',
    pinyin: ['yì'],
    decomposition: '⿰⿱匕矢聿',
    radical: '聿',
    matches: [
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '肅',
    definition: 'to pay respects; solemn, reverent',
    pinyin: ['sù'],
    decomposition: '⿻肀⿰片爿',
    radical: '肀',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 1],
      [1, 0],
      [1, 0],
      [1, 1],
      null,
      [1, 0],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '肆',
    definition: "to indulge; excess; four (bankers' anti-fraud numeral)",
    pinyin: ['sì'],
    decomposition: '⿰镸聿',
    etymology: { type: 'ideographic', hint: 'Having long 镸 hair 聿' },
    radical: '聿',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '肇',
    definition: 'to begin, to start; to originate',
    pinyin: ['zhào'],
    decomposition: '⿱⿰户攵聿',
    radical: '聿',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '肉',
    definition: 'meat; flesh',
    pinyin: ['ròu'],
    decomposition: '⿻冂仌',
    etymology: { type: 'pictographic', hint: 'Meat on the ribs of an animal' },
    radical: '肉',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '肋',
    definition: 'ribs; chest',
    pinyin: ['lē'],
    decomposition: '⿰⺼力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '力',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '肌',
    definition: 'flesh, skin; muscle, tissue; meat on bones',
    pinyin: ['jī'],
    decomposition: '⿰⺼几',
    etymology: {
      type: 'pictophonetic',
      phonetic: '几',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '肓',
    definition: 'abdominal cavity; the area between the heart and diaphragm',
    pinyin: ['huāng'],
    decomposition: '⿱亡⺼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亡',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '肖',
    definition: 'to resemble, to look like; to be like',
    pinyin: ['xiào'],
    decomposition: '⿱⺌⺼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '⺌',
      semantic: '⺼',
      hint: 'flesh - "in the flesh"',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '肘',
    definition: 'elbow, shoulder; to help someone carry a load',
    pinyin: ['zhǒu'],
    decomposition: '⿰⺼寸',
    etymology: {
      type: 'pictographic',
      hint: 'A arm carrying an object 寸 at the side of the body ⺼',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '肙',
    definition: 'a small worm; to twist; to surround; empty',
    pinyin: ['yuàn'],
    decomposition: '⿱口⺼',
    etymology: { type: 'ideographic', hint: 'A head 口 on a long body ⺼' },
    radical: '⺼',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '肚',
    definition: 'belly; abdomen, bowels',
    pinyin: ['dù'],
    decomposition: '⿰⺼土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '土',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '肛',
    definition: 'anus',
    pinyin: ['gāng'],
    decomposition: '⿰⺼工',
    etymology: {
      type: 'pictophonetic',
      phonetic: '工',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '肜',
    definition: 'to sacrifice on two successive days',
    pinyin: ['róng'],
    decomposition: '⿰⺼彡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彡',
      semantic: '⺼',
      hint: 'meat',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '肝',
    definition: 'liver',
    pinyin: ['gān'],
    decomposition: '⿰⺼干',
    etymology: {
      type: 'pictophonetic',
      phonetic: '干',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '肟',
    definition: 'oxime, oximide, -oxil',
    pinyin: ['wò'],
    decomposition: '⿰⺼亏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亏',
      semantic: '⺼',
      hint: 'organic compound',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '肠',
    definition: 'intestines; emotions; sausage',
    pinyin: ['cháng'],
    decomposition: '⿰⺼昜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昜',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '股',
    definition: 'share, portion; thighs, haunches, rump',
    pinyin: ['gǔ'],
    decomposition: '⿰⺼殳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '殳',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '肢',
    definition: 'limbs',
    pinyin: ['zhī'],
    decomposition: '⿰⺼支',
    etymology: {
      type: 'pictophonetic',
      phonetic: '支',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '肤',
    definition: 'skin; shallow, superficial',
    pinyin: ['fū'],
    decomposition: '⿰⺼夫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夫',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '肥',
    definition: 'fat, plump, obese; fertile',
    pinyin: ['féi'],
    decomposition: '⿰⺼巴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巴',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '肩',
    definition: 'shoulders; to shoulder, to bear',
    pinyin: ['jiān'],
    decomposition: '⿸户⺼',
    etymology: {
      type: 'ideographic',
      hint: 'A man bringing home meat ⺼ for the family 户',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '肪',
    definition: 'animal fat',
    pinyin: ['fáng'],
    decomposition: '⿰⺼方',
    etymology: {
      type: 'pictophonetic',
      phonetic: '方',
      semantic: '⺼',
      hint: 'meat',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '肫',
    definition: 'gizzard; honest, sincere',
    pinyin: ['zhūn'],
    decomposition: '⿰⺼屯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屯',
      semantic: '⺼',
      hint: 'meat',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '肭',
    definition: 'fat, blubber; a seal',
    pinyin: ['nà'],
    decomposition: '⿰⺼内',
    etymology: {
      type: 'pictophonetic',
      phonetic: '内',
      semantic: '⺼',
      hint: 'meat',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '肮',
    definition: 'dirty, filthy',
    pinyin: ['āng'],
    decomposition: '⿰⺼亢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亢',
      semantic: '⺼',
      hint: 'meat',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '肯',
    definition: 'to agree to, to consent, to permit; ready, willing',
    pinyin: ['kěn'],
    decomposition: '⿱止⺼',
    etymology: {
      type: 'ideographic',
      hint: "To stop 止 flexing one's muscles ⺼",
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '肰',
    definition: 'dog meat',
    pinyin: ['rán'],
    decomposition: '⿰⺼犬',
    etymology: { type: 'ideographic', hint: 'Dog 犬 meat ⺼' },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '肱',
    definition: 'forearm',
    pinyin: ['gōng'],
    decomposition: '⿰⺼厷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厷',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '育',
    definition: 'to produce, to give birth to; to educate',
    pinyin: ['yù'],
    decomposition: '⿱⿱亠厶⺼',
    etymology: {
      type: 'ideographic',
      hint: 'A pregnant woman with a baby ⺼ in her womb',
    },
    radical: '⺼',
    matches: [[0, 0], [0, 0], [0, 1], [0, 1], [1], [1], [1], [1]],
  },
  {
    character: '肴',
    definition: 'cooked or prepared meat',
    pinyin: ['yáo'],
    decomposition: '⿱乂有',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乂',
      semantic: '⺼',
      hint: 'meat',
    },
    radical: '⺼',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '肷',
    definition: 'the area between the waist and hips',
    pinyin: ['qiǎn'],
    decomposition: '⿰⺼欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '欠',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '肺',
    definition: 'lungs',
    pinyin: ['fèi'],
    decomposition: '⿰⺼巿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巿',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '肼',
    definition: 'hydrazine',
    pinyin: ['jǐng'],
    decomposition: '⿰⺼井',
    etymology: {
      type: 'pictophonetic',
      phonetic: '井',
      semantic: '⺼',
      hint: 'organic compound',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '肽',
    definition: 'peptide',
    pinyin: ['tài'],
    decomposition: '⿰⺼太',
    etymology: {
      type: 'pictophonetic',
      phonetic: '太',
      semantic: '⺼',
      hint: 'organic compound',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '肾',
    definition: 'kidney',
    pinyin: ['shèn'],
    decomposition: '⿱⿰？又⺼',
    etymology: { type: 'pictophonetic', semantic: '⺼', hint: 'flesh' },
    radical: '⺼',
    matches: [null, null, [0, 1], [0, 1], [1], [1], [1], [1]],
  },
  {
    character: '肿',
    definition: 'swelling; swollen; to swell',
    pinyin: ['zhǒng'],
    decomposition: '⿰⺼中',
    etymology: {
      type: 'pictophonetic',
      phonetic: '中',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '胀',
    definition: 'swelling, inflation',
    pinyin: ['zhàng'],
    decomposition: '⿰⺼长',
    etymology: {
      type: 'pictophonetic',
      phonetic: '长',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '胁',
    definition: 'to threaten, to coerce; ribs, flank',
    pinyin: ['xié'],
    decomposition: '⿰⺼办',
    etymology: { type: 'ideographic', hint: "To control 办 another's body ⺼" },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '胂',
    definition: 'arsine',
    pinyin: ['shèn'],
    decomposition: '⿰⺼申',
    etymology: {
      type: 'pictophonetic',
      phonetic: '申',
      semantic: '⺼',
      hint: 'organic compound',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '胃',
    definition: 'stomach',
    pinyin: ['wèi'],
    decomposition: '⿱田⺼',
    etymology: {
      type: 'ideographic',
      hint: 'The stomach ⺼ behind the abdominal muscles 田',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '胄',
    definition: 'helmet; descendant',
    pinyin: ['zhòu'],
    decomposition: '⿱由⺼',
    etymology: { type: 'pictographic', hint: 'A man ⺼ wearing a helmet 由' },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '胆',
    definition: 'gallbladder; gall, guts, courage',
    pinyin: ['dǎn'],
    decomposition: '⿰⺼旦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旦',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '背',
    definition: 'back, backside; to betray, to violate',
    pinyin: ['bèi'],
    decomposition: '⿱北⺼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '北',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '胍',
    definition: 'guanidine',
    pinyin: ['guā'],
    decomposition: '⿰⺼瓜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '瓜',
      semantic: '⺼',
      hint: 'organic compound',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '胎',
    definition: 'embryo, fetus; car tire',
    pinyin: ['tāi'],
    decomposition: '⿰⺼台',
    etymology: {
      type: 'pictophonetic',
      phonetic: '台',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '胖',
    definition: 'fat, plump, obese; a fat person',
    pinyin: ['pàng'],
    decomposition: '⿰⺼半',
    etymology: {
      type: 'pictophonetic',
      phonetic: '半',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '胗',
    definition: 'measles, pustules, rash',
    pinyin: ['zhēn'],
    decomposition: '⿰⺼㐱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㐱',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '胙',
    definition: "meat offered in sacrifice to one's ancestors",
    pinyin: ['zuò'],
    decomposition: '⿰⺼乍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乍',
      semantic: '⺼',
      hint: 'meat',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '胚',
    definition: 'embryo; an unfinished thing',
    pinyin: ['pēi'],
    decomposition: '⿰⺼丕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丕',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '胛',
    definition: 'shoulder; shoulder blade',
    pinyin: ['jiǎ'],
    decomposition: '⿰⺼甲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甲',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '胜',
    definition: 'victory; to excel, to truimph',
    pinyin: ['shèng'],
    decomposition: '⿰⺼生',
    etymology: {
      type: 'pictophonetic',
      phonetic: '生',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '胝',
    definition: 'corn, callus',
    pinyin: ['zhī'],
    decomposition: '⿰⺼氐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '氐',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '胞',
    definition: 'womb, placenta, fetal membrane',
    pinyin: ['bāo'],
    decomposition: '⿰⺼包',
    etymology: {
      type: 'pictophonetic',
      phonetic: '包',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '胠',
    definition: 'to open; to throw away',
    pinyin: ['qū'],
    decomposition: '⿰⺼去',
    etymology: {
      type: 'ideographic',
      hint: 'To leave 去 in the flesh ⺼; 去 also provides the pronunciation',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '胡',
    definition: 'recklessly, foolishly; wildly',
    pinyin: ['hú'],
    decomposition: '⿰古⺼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '古',
      semantic: '⺼',
      hint: 'meat',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '胤',
    definition: 'heir, successor; progeny, posterity',
    pinyin: ['yìn'],
    decomposition: '⿻儿⿱幺⺼',
    etymology: {
      type: 'ideographic',
      hint: 'A small 幺 child ⺼ leaving the womb 儿',
    },
    radical: '⺼',
    matches: [[0], [1, 0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1], [1, 1], [0]],
  },
  {
    character: '胥',
    definition: 'all, together, mutually',
    pinyin: ['xū'],
    decomposition: '⿱疋⺼',
    etymology: { type: 'ideographic', hint: 'A body ⺼ wrapped in cloth 疋' },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '胧',
    definition: 'blurry, obscured; the condition or appearance of the moon',
    pinyin: ['lóng'],
    decomposition: '⿰月龙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龙',
      semantic: '月',
      hint: 'moon',
    },
    radical: '月',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '胨',
    definition: 'peptone',
    pinyin: ['dòng'],
    decomposition: '⿰⺼东',
    etymology: {
      type: 'pictophonetic',
      phonetic: '东',
      semantic: '⺼',
      hint: 'organic compound',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '胩',
    definition: 'carbylamine; isocyanide',
    pinyin: ['kǎ'],
    decomposition: '⿰⺼卡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卡',
      semantic: '⺼',
      hint: 'organic compound',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '胪',
    definition: 'to arrange, to display',
    pinyin: ['lú'],
    decomposition: '⿰⺼卢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卢',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '胫',
    definition: 'calf, shinbone',
    pinyin: ['jìng'],
    decomposition: '⿰⺼？',
    etymology: { type: 'pictophonetic', semantic: '⺼', hint: 'flesh' },
    radical: '⺼',
    matches: [[0], [0], [0], [0], null, null, null, null, null],
  },
  {
    character: '胬',
    definition: "pterygium, surfer's eye",
    pinyin: ['nǔ'],
    decomposition: '⿱奴肉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奴',
      semantic: '肉',
      hint: 'flesh',
    },
    radical: '肉',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '胭',
    definition: 'cosmetics, rouge',
    pinyin: ['yān'],
    decomposition: '⿰⺼因',
    etymology: {
      type: 'pictophonetic',
      phonetic: '因',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '胯',
    definition: 'pelvis, groin; thighs',
    pinyin: ['kuà'],
    decomposition: '⿰⺼夸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夸',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '胰',
    definition: 'pancreas; soap',
    pinyin: ['yí'],
    decomposition: '⿰⺼夷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夷',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '胱',
    definition: 'bladder',
    pinyin: ['guāng'],
    decomposition: '⿰⺼光',
    etymology: {
      type: 'pictophonetic',
      phonetic: '光',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '胲',
    definition: 'hydroxylamine',
    pinyin: ['hǎi'],
    decomposition: '⿰⺼亥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亥',
      semantic: '⺼',
      hint: 'organic compound',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '胳',
    definition: 'arms; armpit',
    pinyin: ['gē'],
    decomposition: '⿰⺼各',
    etymology: {
      type: 'pictophonetic',
      phonetic: '各',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '胴',
    definition: 'the large intestine; the body',
    pinyin: ['dòng'],
    decomposition: '⿰⺼同',
    etymology: {
      type: 'pictophonetic',
      phonetic: '同',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '胶',
    definition: 'glue, gum, resin, rubber; sticky; to glue',
    pinyin: ['jiāo'],
    decomposition: '⿰⺼交',
    etymology: {
      type: 'ideographic',
      hint: 'Tendons that connect 交 muscles ⺼; 交 also provides the pronunciation',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '胸',
    definition: 'breast, bosom; heart, mind',
    pinyin: ['xiōng'],
    decomposition: '⿰⺼匈',
    etymology: {
      type: 'ideographic',
      hint: 'A heart ⺼ in the chest 匈; 匈 also provides the pronunciation',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '胺',
    definition: 'amine',
    pinyin: ['àn'],
    decomposition: '⿰⺼安',
    etymology: {
      type: 'pictophonetic',
      phonetic: '安',
      semantic: '⺼',
      hint: 'organic compound',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '胼',
    definition: 'corn, callus',
    pinyin: ['pián'],
    decomposition: '⿰⺼并',
    etymology: {
      type: 'pictophonetic',
      phonetic: '并',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '能',
    definition: 'can, may; capable, full of energy',
    pinyin: ['néng'],
    decomposition: '⿰⿱厶⺼⿱匕匕',
    etymology: {
      type: 'pictographic',
      hint: "A bear's head 厶, body ⺼, and claws 匕",
    },
    radical: '⺼',
    matches: [
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '脂',
    definition: 'fat, grease, lard, oil',
    pinyin: ['zhī'],
    decomposition: '⿰⺼旨',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旨',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '脅',
    definition: 'to threaten, to coerce; ribs, flank',
    pinyin: ['xié'],
    decomposition: '⿱劦⺼',
    etymology: { type: 'ideographic', hint: "To control 劦 another's body ⺼" },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '脆',
    definition: 'fragile, frail; brittle, crisp',
    pinyin: ['cuì'],
    decomposition: '⿰⺼危',
    etymology: {
      type: 'ideographic',
      hint: "Something dangerous 危 to one's flesh ⺼",
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '脈',
    definition: 'a pulse; arteries, veins; blood vessels',
    pinyin: ['mài'],
    decomposition: '⿰⺼永',
    etymology: {
      type: 'ideographic',
      hint: "Long 永 vessels through one's body ⺼",
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '脉',
    definition: 'a pulse; arteries, veins; blood vessels',
    pinyin: ['mài'],
    decomposition: '⿰⺼永',
    etymology: {
      type: 'ideographic',
      hint: "Long 永 vessels through one's body ⺼",
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '脊',
    definition: 'spine, backbone; ridge',
    pinyin: ['jí'],
    decomposition: '⿱⿻人？⺼',
    etymology: {
      type: 'ideographic',
      hint: 'A vertebra 人 protruding from the flesh ⺼',
    },
    radical: '⺼',
    matches: [null, null, null, null, [0, 0], [0, 0], [1], [1], [1], [1]],
  },
  {
    character: '脍',
    definition: 'minced meat, minced fish',
    pinyin: ['kuài'],
    decomposition: '⿰⺼会',
    etymology: {
      type: 'pictophonetic',
      phonetic: '会',
      semantic: '⺼',
      hint: 'meat',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '脎',
    definition: 'an organic compound',
    pinyin: ['sà'],
    decomposition: '⿰⺼杀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '杀',
      semantic: '⺼',
      hint: 'organic compound',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '脏',
    definition: 'organs, viscera; dirty, filthy',
    pinyin: ['zàng'],
    decomposition: '⿰⺼庄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '庄',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '脐',
    definition: 'navel; belly, underside',
    pinyin: ['qí'],
    decomposition: '⿰⺼齐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '齐',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '脑',
    definition: 'brain',
    pinyin: ['nǎo'],
    decomposition: '⿰⺼⿱亠凶',
    etymology: { type: 'pictophonetic', semantic: '⺼', hint: 'flesh' },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '脒',
    definition: 'to open; to throw away',
    pinyin: ['mǐ'],
    decomposition: '⿰⺼米',
    etymology: {
      type: 'pictophonetic',
      phonetic: '米',
      semantic: '⺼',
      hint: 'meat',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '脓',
    definition: 'pus',
    pinyin: ['nóng'],
    decomposition: '⿰⺼农',
    etymology: {
      type: 'pictophonetic',
      phonetic: '农',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '脔',
    definition: 'thinly sliced meat',
    pinyin: ['luán'],
    decomposition: '⿱亦肉',
    etymology: { type: 'pictophonetic', semantic: '肉', hint: 'meat' },
    radical: '肉',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '脖',
    definition: 'neck',
    pinyin: ['bó'],
    decomposition: '⿰⺼孛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孛',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '脘',
    definition: 'abdominal cavity',
    pinyin: ['wǎn'],
    decomposition: '⿰⺼完',
    etymology: {
      type: 'pictophonetic',
      phonetic: '完',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '脚',
    definition: 'leg, foot; foundation, base',
    pinyin: ['jiǎo'],
    decomposition: '⿰⺼却',
    etymology: {
      type: 'pictophonetic',
      phonetic: '却',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '脛',
    definition: 'calf, shinbone',
    pinyin: ['jìng'],
    decomposition: '⿰⺼巠',
    etymology: {
      type: 'pictophonetic',
      semantic: '⺼',
      hint: 'flesh',
      phonetic: '巠',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '脞',
    definition: 'minced meat; trifles',
    pinyin: ['cuǒ'],
    decomposition: '⿰⺼坐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '坐',
      semantic: '⺼',
      hint: 'meat',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '脢',
    definition: 'flesh',
    pinyin: ['méi'],
    decomposition: '⿰⺼每',
    etymology: {
      type: 'pictophonetic',
      phonetic: '每',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '脣',
    definition: 'lips',
    pinyin: ['chún'],
    decomposition: '⿸辰⺼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辰',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '脩',
    definition: 'dried meat',
    pinyin: ['xiū'],
    decomposition: '⿸攸⺼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '攸',
      semantic: '⺼',
      hint: 'meat',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '脫',
    definition: 'to take off, to shed; to escape from',
    pinyin: ['tuō'],
    decomposition: '⿰⺼兌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兌',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '脬',
    definition: 'bladder',
    pinyin: ['pāo'],
    decomposition: '⿰⺼孚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孚',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '脯',
    definition: 'dried meat; preserved fruits',
    pinyin: ['pú'],
    decomposition: '⿰⺼甫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甫',
      semantic: '⺼',
      hint: 'meat',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '脱',
    definition: 'to take off, to shed; to escape from',
    pinyin: ['tuō'],
    decomposition: '⿰⺼兑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兑',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '脲',
    definition: 'urea',
    pinyin: ['niào'],
    decomposition: '⿰⺼尿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尿',
      semantic: '⺼',
      hint: 'organic compound',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '脶',
    definition: 'fingerprint',
    pinyin: ['luó'],
    decomposition: '⿰⺼呙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '呙',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '脷',
    definition: 'beef tongue',
    pinyin: ['lì'],
    decomposition: '⿰⺼利',
    etymology: {
      type: 'pictophonetic',
      phonetic: '利',
      semantic: '⺼',
      hint: 'meat',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '脸',
    definition: 'face, cheek; reputation',
    pinyin: ['liǎn'],
    decomposition: '⿰⺼佥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '佥',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '脹',
    definition: 'swelling, inflation',
    pinyin: ['zhàng'],
    decomposition: '⿰⺼長',
    etymology: {
      type: 'pictophonetic',
      phonetic: '長',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '脾',
    definition: 'spleen, pancreas; temper, disposition',
    pinyin: ['pí'],
    decomposition: '⿰⺼卑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卑',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腆',
    definition: 'good, strong; prosperous; protruding',
    pinyin: ['tiǎn'],
    decomposition: '⿰⺼典',
    etymology: {
      type: 'pictophonetic',
      phonetic: '典',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腈',
    definition: 'acrylic',
    pinyin: ['jīng'],
    decomposition: '⿰⺼青',
    etymology: {
      type: 'pictophonetic',
      phonetic: '青',
      semantic: '⺼',
      hint: 'organic compound',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腊',
    definition: "December; year's end sacrifice; dried meat",
    pinyin: ['là'],
    decomposition: '⿰⺼昔',
    etymology: {
      type: 'ideographic',
      hint: 'A sacrifice of meat ⺼ for the past year 昔',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腋',
    definition: 'armpit',
    pinyin: ['yè'],
    decomposition: '⿰⺼夜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夜',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腌',
    definition: 'to salt, to cure; to pickle, to marinate',
    pinyin: ['yān'],
    decomposition: '⿰⺼奄',
    etymology: {
      type: 'ideographic',
      hint: 'Meat ⺼ left 奄 in salt; 奄 also provides the pronunciation',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腎',
    definition: 'kidney',
    pinyin: ['shèn'],
    decomposition: '⿱臤⺼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臤',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '腐',
    definition: 'to spoil, to rot, to decay; rotten',
    pinyin: ['fǔ'],
    decomposition: '⿸广⿱付肉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '付',
      semantic: '肉',
      hint: 'meat',
    },
    radical: '肉',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '腑',
    definition: 'bowels, entrails, viscera',
    pinyin: ['fǔ'],
    decomposition: '⿰⺼府',
    etymology: {
      type: 'pictophonetic',
      phonetic: '府',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腓',
    definition: 'leg, calf; to wither, to decay',
    pinyin: ['féi'],
    decomposition: '⿰⺼非',
    etymology: {
      type: 'pictophonetic',
      phonetic: '非',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腔',
    definition: 'chest cavity; a hollow in the body',
    pinyin: ['qiāng'],
    decomposition: '⿰⺼空',
    etymology: {
      type: 'pictophonetic',
      phonetic: '空',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腕',
    definition: 'wrist',
    pinyin: ['wàn'],
    decomposition: '⿰⺼宛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宛',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腖',
    definition: 'peptone',
    pinyin: ['dòng'],
    decomposition: '⿰⺼東',
    etymology: {
      type: 'pictophonetic',
      phonetic: '東',
      semantic: '⺼',
      hint: 'organic compound',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腙',
    definition: 'an organic compound',
    pinyin: ['zōng'],
    decomposition: '⿰⺼宗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宗',
      semantic: '⺼',
      hint: 'organic compound',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腚',
    definition: 'buttocks',
    pinyin: ['dìng'],
    decomposition: '⿰⺼定',
    etymology: {
      type: 'pictophonetic',
      phonetic: '定',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腠',
    definition: 'subcutaneous tissue',
    pinyin: ['còu'],
    decomposition: '⿰⺼奏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奏',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腥',
    definition: 'fishy, rank; raw meat',
    pinyin: ['xīng'],
    decomposition: '⿰⺼星',
    etymology: {
      type: 'pictophonetic',
      phonetic: '星',
      semantic: '⺼',
      hint: 'meat',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腦',
    definition: 'brain',
    pinyin: ['nǎo'],
    decomposition: '⿰⺼⿱巛囟',
    etymology: { type: 'ideographic', hint: 'An organ ⺼ in the skull 囟' },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '腧',
    definition: 'acupoint',
    pinyin: ['shù'],
    decomposition: '⿰⺼俞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '俞',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腩',
    definition: 'brisket, ribs; belly meat',
    pinyin: ['nǎn'],
    decomposition: '⿰⺼南',
    etymology: {
      type: 'pictophonetic',
      phonetic: '南',
      semantic: '⺼',
      hint: 'meat',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腫',
    definition: 'swelling; swollen; to swell',
    pinyin: ['zhǒng'],
    decomposition: '⿰⺼重',
    etymology: {
      type: 'ideographic',
      hint: 'Swollen 重 flesh ⺼; 重 also provides the pronunciation',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腭',
    definition: 'palate, the roof of the mouth',
    pinyin: ['è'],
    decomposition: '⿰⺼咢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咢',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腮',
    definition: 'jaw; gills',
    pinyin: ['sāi'],
    decomposition: '⿰⺼思',
    etymology: {
      type: 'pictophonetic',
      phonetic: '思',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腰',
    definition: 'waist, lower back; middle; pocket',
    pinyin: ['yāo'],
    decomposition: '⿰⺼要',
    etymology: {
      type: 'pictophonetic',
      phonetic: '要',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腱',
    definition: 'tendon, sinew',
    pinyin: ['jiàn'],
    decomposition: '⿰⺼建',
    etymology: {
      type: 'pictophonetic',
      phonetic: '建',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腳',
    definition: 'leg, foot; foundation, base',
    pinyin: ['jiǎo'],
    decomposition: '⿰⺼卻',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卻',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腴',
    definition: 'fat; rich, fertile; soft, plump',
    pinyin: ['yú'],
    decomposition: '⿰⺼臾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臾',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腸',
    definition: 'intestines; emotions; sausage',
    pinyin: ['cháng'],
    decomposition: '⿰⺼昜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昜',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腹',
    definition: 'stomach, belly, abdomen; inside',
    pinyin: ['fù'],
    decomposition: '⿰⺼复',
    etymology: {
      type: 'pictophonetic',
      phonetic: '复',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腺',
    definition: 'gland',
    pinyin: ['xiàn'],
    decomposition: '⿰⺼泉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '泉',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腻',
    definition: 'greasy, oily, smooth; bored, tired',
    pinyin: ['nì'],
    decomposition: '⿰⺼贰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贰',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腼',
    definition: 'modest, bashful',
    pinyin: ['miǎn'],
    decomposition: '⿰⺼面',
    etymology: {
      type: 'pictophonetic',
      phonetic: '面',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腽',
    definition: 'fat, blubber',
    pinyin: ['wà'],
    decomposition: '⿰⺼昷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昷',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '腾',
    definition: 'to fly, to soar; to gallop, to prance; rising, steaming',
    pinyin: ['téng'],
    decomposition: '⿸朕马',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朕',
      semantic: '马',
      hint: 'horse',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '腿',
    definition: 'legs, thighs',
    pinyin: ['tuǐ'],
    decomposition: '⿰⺼退',
    etymology: {
      type: 'ideographic',
      hint: 'Flesh ⺼ used to walk 退; 退 also provides the pronunciation',
    },
    radical: '⺼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '膀',
    definition: 'shoulder, upper arm, wing',
    pinyin: ['bǎng'],
    decomposition: '⿰⺼旁',
    etymology: {
      type: 'ideographic',
      hint: 'Flesh ⺼ beside 旁 the body; 旁 also provides the pronunciation',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '膂',
    definition: 'backbone, spinal column',
    pinyin: ['lǚ'],
    decomposition: '⿱旅⺼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旅',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '膃',
    definition: 'fat, blubber',
    pinyin: ['wà'],
    decomposition: '⿰⺼⿱囚皿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '？',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '膈',
    definition: 'diaphragm',
    pinyin: ['gé'],
    decomposition: '⿰⺼鬲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鬲',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '膊',
    definition: 'shoulder, upper arm',
    pinyin: ['bó'],
    decomposition: '⿰⺼尃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尃',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '膏',
    definition: 'grease, fat; ointment, paste',
    pinyin: ['gāo'],
    decomposition: '⿱高⺼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '高',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '膑',
    definition: 'kneecap',
    pinyin: ['bìn'],
    decomposition: '⿰⺼宾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宾',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '膕',
    definition: 'hollow, cavity',
    pinyin: ['guó'],
    decomposition: '⿰⺼國',
    etymology: {
      type: 'pictophonetic',
      phonetic: '國',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '膘',
    definition: 'sfat; rump',
    pinyin: ['biāo'],
    decomposition: '⿰⺼票',
    etymology: {
      type: 'pictophonetic',
      phonetic: '票',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '膚',
    definition: 'skin; shallow, superficial',
    pinyin: ['fū'],
    decomposition: '⿸虍胃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '虍',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '膛',
    definition: 'chest cavity; hollow space',
    pinyin: ['táng'],
    decomposition: '⿰⺼堂',
    etymology: {
      type: 'ideographic',
      hint: "A hall 堂 in one's chest ⺼; 堂 also provides the pronunciation",
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '膜',
    definition: 'membrane, film; to kneel and worship',
    pinyin: ['mó'],
    decomposition: '⿰⺼莫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '莫',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '膝',
    definition: 'knee',
    pinyin: ['xī'],
    decomposition: '⿰⺼桼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '桼',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '膠',
    definition: 'glue, gum, resin, rubber; sticky; to glue',
    pinyin: ['jiāo'],
    decomposition: '⿰⺼翏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '翏',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '膣',
    definition: 'vagina',
    pinyin: ['zhì'],
    decomposition: '⿰⺼窒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '窒',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '膦',
    definition: 'phosphine',
    pinyin: ['lìn'],
    decomposition: '⿰⺼粦',
    etymology: {
      type: 'pictographic',
      hint: 'An organic compound ⺼ containing phosphorous 粦; 粦 also provides the pronunciation',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '膨',
    definition: 'bloated, inflated, swollen; to swell',
    pinyin: ['péng'],
    decomposition: '⿰⺼彭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彭',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '膩',
    definition: 'greasy, oily, smooth; bored, tired',
    pinyin: ['nì'],
    decomposition: '⿰⺼貳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '貳',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '膪',
    definition: 'pork',
    pinyin: ['chuài'],
    decomposition: '⿰⺼啻',
    etymology: {
      type: 'pictophonetic',
      phonetic: '啻',
      semantic: '⺼',
      hint: 'meat',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '膫',
    definition: 'omentum; the fat covering the intestines',
    pinyin: ['liáo'],
    decomposition: '⿰⺼尞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尞',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '膲',
    definition: 'the triple foci, the three visceral cavities',
    pinyin: ['jiāo'],
    decomposition: '⿰⺼焦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '焦',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '膳',
    definition: 'meals, provisions',
    pinyin: ['shàn'],
    decomposition: '⿰⺼善',
    etymology: {
      type: 'pictophonetic',
      phonetic: '善',
      semantic: '⺼',
      hint: 'meat',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '膺',
    definition: 'breast, chest; to bear, to undertake',
    pinyin: ['yīng'],
    decomposition: '⿸䧹⺼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '䧹',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '膻',
    definition: 'a flock of sheep; a rank odor',
    pinyin: ['shān'],
    decomposition: '⿰⺼亶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亶',
      semantic: '⺼',
      hint: 'meat',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '膽',
    definition: 'gallbladder; gall, guts, courage',
    pinyin: ['dǎn'],
    decomposition: '⿰⺼詹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '詹',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '膾',
    definition: 'minced meat, minced fish',
    pinyin: ['kuài'],
    decomposition: '⿰⺼會',
    etymology: {
      type: 'pictophonetic',
      phonetic: '會',
      semantic: '⺼',
      hint: 'meat',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '膿',
    definition: 'pus',
    pinyin: ['nóng'],
    decomposition: '⿰⺼農',
    etymology: {
      type: 'pictophonetic',
      phonetic: '農',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '臀',
    definition: 'buttocks',
    pinyin: ['tún'],
    decomposition: '⿱殿⺼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '殿',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '臁',
    definition: 'leg, calf',
    pinyin: ['lián'],
    decomposition: '⿰⺼廉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '廉',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '臂',
    definition: 'arm',
    pinyin: ['bì'],
    decomposition: '⿱辟⺼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辟',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '臃',
    definition: 'to swell up; swollen, fat',
    pinyin: ['yōng'],
    decomposition: '⿰⺼雍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '雍',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '臆',
    definition: 'chest, breast; thoughts, feelings',
    pinyin: ['yì'],
    decomposition: '⿰⺼意',
    etymology: {
      type: 'ideographic',
      hint: 'The part of the body ⺼ that feels 意; 意 also provides the pronunciation',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '臉',
    definition: 'face, cheek; reputation',
    pinyin: ['liǎn'],
    decomposition: '⿰⺼僉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '僉',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '臊',
    definition: 'shy, bashful; rank, fetid; the smell of urine',
    pinyin: ['sāo'],
    decomposition: '⿰⺼喿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '喿',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '臌',
    definition: 'swelling, edema; puffy, bloated',
    pinyin: ['gǔ'],
    decomposition: '⿰⺼鼓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鼓',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '臘',
    definition: "December; year's end sacrifice; dried meat",
    pinyin: ['là'],
    decomposition: '⿰⺼巤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巤',
      semantic: '⺼',
      hint: 'meat',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '臚',
    definition: 'to arrange, to display',
    pinyin: ['lú'],
    decomposition: '⿰⺼盧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '盧',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '臜',
    definition: 'dirty, filthy',
    pinyin: ['zā'],
    decomposition: '⿰⺼赞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '赞',
      semantic: '⺼',
      hint: 'meat',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '臟',
    definition: 'organs, viscera; dirty, filthy',
    pinyin: ['zàng'],
    decomposition: '⿰⺼藏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '藏',
      semantic: '⺼',
      hint: 'flesh',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '臠',
    definition: 'thinly sliced meat',
    pinyin: ['luán'],
    decomposition: '⿱䜌肉',
    etymology: {
      type: 'pictophonetic',
      semantic: '肉',
      hint: 'meat',
      phonetic: '䜌',
    },
    radical: '肉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '臢',
    definition: 'dirty, filthy',
    pinyin: ['zā'],
    decomposition: '⿰⺼贊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贊',
      semantic: '⺼',
      hint: 'meat',
    },
    radical: '⺼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '臣',
    definition: 'minister, statesman, official, vassal',
    pinyin: ['chén'],
    decomposition: '⿷匚⿻⿱丨丨？',
    radical: '臣',
    matches: [[0], [1, 0, 0], null, null, [1, 0, 1], [0]],
  },
  {
    character: '臤',
    definition: 'stern; wise',
    pinyin: ['qiān'],
    decomposition: '⿰臣又',
    etymology: {
      type: 'ideographic',
      hint: 'Like 又 a minister 臣; 臣 also provides the pronunciation',
    },
    radical: '臣',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '臥',
    definition: 'to crouch, to lie down',
    pinyin: ['wò'],
    decomposition: '⿰臣人',
    etymology: { type: 'ideographic', hint: 'A person 人 laying on a bed 臣' },
    radical: '臣',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '臧',
    definition: 'good, right; generous; to command',
    pinyin: ['zāng'],
    decomposition: '⿵戕臣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戕',
      semantic: '臣',
      hint: 'minister',
    },
    radical: '臣',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '臨',
    definition: 'to draw near, to approach; to descend',
    pinyin: ['lín'],
    decomposition: '⿰臣⿱？品',
    radical: '臣',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      null,
      null,
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '自',
    definition: 'self; private, personal; from',
    pinyin: ['zì'],
    decomposition: '⿻目？',
    etymology: {
      type: 'pictographic',
      hint: 'A nose; in China, people refer to themselves by pointing to their noses',
    },
    radical: '自',
    matches: [null, [0], [0], [0], [0], [0]],
  },
  {
    character: '臬',
    definition: 'provincial judge; law, rule; door post',
    pinyin: ['niè'],
    decomposition: '⿱自木',
    etymology: { type: 'ideographic', hint: 'A notice 自 posted on a tree 木' },
    radical: '自',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '臭',
    definition: 'to reek, to smell, to stink',
    pinyin: ['chòu'],
    decomposition: '⿱自犬',
    etymology: { type: 'ideographic', hint: 'The smell 自 of a dirty dog 犬' },
    radical: '自',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '臱',
    pinyin: ['mián'],
    decomposition: '⿱自⿱穴方',
    radical: '自',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '臲',
    definition: 'tottering, unsteady; jumpy, jittery',
    pinyin: ['niè'],
    decomposition: '⿰臬危',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臬',
      semantic: '危',
      hint: 'precarious',
    },
    radical: '自',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '至',
    definition: 'reach, arrive; very, extremely',
    pinyin: ['zhì'],
    decomposition: '⿱⿱一厶土',
    etymology: {
      type: 'ideographic',
      hint: 'A bird alighting on the ground 土',
    },
    radical: '至',
    matches: [[0, 0], [0, 1], [0, 1], [1], [1], [1]],
  },
  {
    character: '致',
    definition: 'to send; to present, to deliver; to cause; consequence',
    pinyin: ['zhì'],
    decomposition: '⿰至攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '至',
      semantic: '攵',
      hint: 'rap',
    },
    radical: '至',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '臺',
    definition: 'platform; unit; term of address',
    pinyin: ['tái'],
    decomposition: '⿳吉冖至',
    etymology: {
      type: 'ideographic',
      hint: 'A man 吉 standing on a raised 至 dais 冖',
    },
    radical: '至',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '臻',
    definition: 'to reach, to arrive; utmost, superior',
    pinyin: ['zhēn'],
    decomposition: '⿰至秦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '秦',
      semantic: '至',
      hint: 'reach',
    },
    radical: '至',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '臼',
    definition: 'mortar; bone joint socket',
    pinyin: ['jiù'],
    decomposition: '？',
    etymology: {
      type: 'pictographic',
      hint: 'A mortar used to grind out powders',
    },
    radical: '臼',
    matches: [null, null, null, null, null, null],
  },
  {
    character: '臽',
    definition: 'pit, hole',
    pinyin: ['xiàn'],
    decomposition: '⿱⺈臼',
    etymology: { type: 'ideographic', hint: 'A person ⺈ falling in a pit 臼' },
    radical: '臼',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '臾',
    definition: 'moment, instant, short while',
    pinyin: ['yú'],
    decomposition: '⿻臼人',
    radical: '臼',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '臿',
    definition: 'to separate the grain from the husk',
    pinyin: ['chā'],
    decomposition: '⿻千臼',
    etymology: { type: 'ideographic', hint: 'A mortar 臼 and pestle 千' },
    radical: '臼',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '舀',
    definition: 'to ladle out; to scoop',
    pinyin: ['yǎo'],
    decomposition: '⿱爫臼',
    etymology: {
      type: 'ideographic',
      hint: 'A hand 爫 fetching food from a container 臼',
    },
    radical: '臼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '舁',
    definition: "to lift, to raise, to carry on one's shoulder",
    pinyin: ['yú'],
    decomposition: '⿱臼廾',
    etymology: {
      type: 'ideographic',
      hint: 'Two hands 廾 lifting a mortar 臼',
    },
    radical: '臼',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '舂',
    definition: 'to grind in a mortar',
    pinyin: ['chōng'],
    decomposition: '⿱？臼',
    etymology: { type: 'pictophonetic', semantic: '臼', hint: 'mortar' },
    radical: '臼',
    matches: [null, null, null, null, null, [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '舄',
    definition: 'shoe, the sole of a shoe; magpie',
    pinyin: ['xì'],
    decomposition: '⿱臼⿹勹灬',
    etymology: { type: 'pictographic', hint: 'A magpie; compare 鳥' },
    radical: '臼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '舅',
    definition: "mother's brother, uncle",
    pinyin: ['jiù'],
    decomposition: '⿱臼男',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臼',
      semantic: '男',
      hint: 'man',
    },
    radical: '臼',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '舆',
    definition: 'cart, palanquin, sedan chair',
    pinyin: ['yú'],
    decomposition: '⿶舁车',
    etymology: {
      type: 'ideographic',
      hint: "A cart 车 carried on one's shoulder 舁",
    },
    radical: '车',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '與',
    definition: 'and; with; to; for; to give, to grant',
    pinyin: ['yǔ'],
    decomposition: '⿱⿻臼？八',
    radical: '臼',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      null,
      null,
      null,
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [1],
      [1],
    ],
  },
  {
    character: '興',
    definition: 'to thrive, to prosper, to flourish',
    pinyin: ['xìng'],
    decomposition: '⿱⿻臼？八',
    radical: '臼',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      null,
      null,
      null,
      null,
      null,
      null,
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [1],
      [1],
    ],
  },
  {
    character: '舉',
    definition: 'to raise; to recommend; to praise',
    pinyin: ['jǔ'],
    decomposition: '⿱與扌',
    etymology: {
      type: 'pictophonetic',
      semantic: '扌',
      hint: 'hand',
      phonetic: '舉',
    },
    radical: '扌',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '舊',
    definition: 'old, ancient; former, past',
    pinyin: ['jiù'],
    decomposition: '⿱雈臼',
    etymology: { type: 'pictophonetic', phonetic: '臼' },
    radical: '臼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '舋',
    definition: 'split, quarrel, dispute; blood sacrifice',
    pinyin: ['xìn'],
    decomposition: '⿱興且',
    etymology: { type: 'ideographic', hint: 'A sacrifice made on an altar 且' },
    radical: '臼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '舌',
    definition: 'tongue; bell clapper',
    pinyin: ['shé'],
    decomposition: '⿱千口',
    etymology: {
      type: 'pictographic',
      hint: 'A tongue 千 sticking out of a mouth 口',
    },
    radical: '舌',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '舍',
    definition: 'house, dwelling; to reside, to dwell; to abandon, to give up',
    pinyin: ['shě'],
    decomposition: '⿱人舌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '舌',
      semantic: '人',
      hint: 'the shape of a roof',
    },
    radical: '舌',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '舐',
    definition: 'to lick, to lap up',
    pinyin: ['shì'],
    decomposition: '⿰舌氏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '氏',
      semantic: '舌',
      hint: 'tongue',
    },
    radical: '舌',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '舒',
    definition: 'relaxed, comfortable; to unfold, to stretch out',
    pinyin: ['shū'],
    decomposition: '⿰舍予',
    etymology: {
      type: 'pictophonetic',
      phonetic: '予',
      semantic: '舍',
      hint: 'home',
    },
    radical: '舌',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '舔',
    definition: 'to lick, to taste',
    pinyin: ['tiǎn'],
    decomposition: '⿰舌忝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '忝',
      semantic: '舌',
      hint: 'tongue',
    },
    radical: '舌',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '舖',
    definition: 'store, shop; bunk, bed',
    pinyin: ['pù'],
    decomposition: '⿰舍甫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甫',
      semantic: '舍',
      hint: 'house',
    },
    radical: '舌',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '舛',
    definition: 'mistaken; to be contrary; to deviate',
    pinyin: ['chuǎn'],
    decomposition: '⿰夕？',
    radical: '舛',
    matches: [[0], [0], [0], null, null, null],
  },
  {
    character: '舜',
    definition: 'legendary ruler',
    pinyin: ['shùn'],
    decomposition: '⿱⿱爫冖舛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '舛',
      semantic: '爫',
      hint: 'claw',
    },
    radical: '舛',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '舞',
    definition: 'to dance; to brandish',
    pinyin: ['wǔ'],
    decomposition: '⿱無舛',
    etymology: { type: 'ideographic', hint: 'A hand 舛 holding a fan' },
    radical: '舛',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '舟',
    definition: 'boat, ship',
    pinyin: ['zhōu'],
    decomposition: '⿻？？',
    etymology: { type: 'pictographic', hint: 'A boat' },
    radical: '舟',
    matches: [null, null, null, null, null, null],
  },
  {
    character: '舡',
    definition: 'boat, ship',
    pinyin: ['chuán'],
    decomposition: '⿰舟工',
    etymology: {
      type: 'pictophonetic',
      phonetic: '工',
      semantic: '舟',
      hint: 'boat',
    },
    radical: '舟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '舢',
    definition: 'sampan, wooden boat',
    pinyin: ['shān'],
    decomposition: '⿰舟山',
    etymology: {
      type: 'pictophonetic',
      phonetic: '山',
      semantic: '舟',
      hint: 'boat',
    },
    radical: '舟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '舣',
    definition: 'to moor a boat',
    pinyin: ['yǐ'],
    decomposition: '⿰舟义',
    etymology: {
      type: 'pictophonetic',
      phonetic: '义',
      semantic: '舟',
      hint: 'boat',
    },
    radical: '舟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '舨',
    definition: 'sampan, wooden boat',
    pinyin: ['bǎn'],
    decomposition: '⿰舟反',
    etymology: {
      type: 'pictophonetic',
      phonetic: '反',
      semantic: '舟',
      hint: 'boat',
    },
    radical: '舟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '航',
    definition: 'vessel, craft; to sail, to navigate',
    pinyin: ['háng'],
    decomposition: '⿰舟亢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亢',
      semantic: '舟',
      hint: 'ship',
    },
    radical: '舟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '舫',
    definition: 'yacht, fancy boat',
    pinyin: ['fǎng'],
    decomposition: '⿰舟方',
    etymology: {
      type: 'pictophonetic',
      phonetic: '方',
      semantic: '舟',
      hint: 'boat',
    },
    radical: '舟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '般',
    definition: 'sort, manner, kind, class',
    pinyin: ['bān'],
    decomposition: '⿰舟殳',
    etymology: {
      type: 'ideographic',
      hint: 'Using a tool 殳 to sort items on a tray 舟',
    },
    radical: '舟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '舭',
    definition: 'bilge',
    pinyin: ['bǐ'],
    decomposition: '⿰舟比',
    etymology: {
      type: 'pictophonetic',
      phonetic: '比',
      semantic: '舟',
      hint: 'boat',
    },
    radical: '舟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '舯',
    pinyin: ['zhōng'],
    decomposition: '⿰舟中',
    etymology: {
      type: 'pictophonetic',
      phonetic: '中',
      semantic: '舟',
      hint: 'boat',
    },
    radical: '舟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '舰',
    definition: 'warship',
    pinyin: ['jiàn'],
    decomposition: '⿰舟见',
    etymology: {
      type: 'pictophonetic',
      phonetic: '见',
      semantic: '舟',
      hint: 'ship',
    },
    radical: '舟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '舱',
    definition: "cabin, ship's hold",
    pinyin: ['cāng'],
    decomposition: '⿰舟仓',
    etymology: {
      type: 'ideographic',
      hint: "A ship's 舟 cabin 仓; 仓 also provides the pronunciation",
    },
    radical: '舟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '舲',
    definition: 'houseboat; a small boat with windows',
    pinyin: ['líng'],
    decomposition: '⿰舟令',
    etymology: {
      type: 'pictophonetic',
      phonetic: '令',
      semantic: '舟',
      hint: 'boat',
    },
    radical: '舟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '舳',
    definition: 'the stern of a ship',
    pinyin: ['zhú'],
    decomposition: '⿰舟由',
    etymology: {
      type: 'pictophonetic',
      phonetic: '由',
      semantic: '舟',
      hint: 'ship',
    },
    radical: '舟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '舴',
    definition: 'dinghy, small boat',
    pinyin: ['zé'],
    decomposition: '⿰舟乍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乍',
      semantic: '舟',
      hint: 'boat',
    },
    radical: '舟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '舵',
    definition: 'helm, rudder',
    pinyin: ['duò'],
    decomposition: '⿰舟它',
    etymology: {
      type: 'pictophonetic',
      phonetic: '它',
      semantic: '舟',
      hint: 'boat',
    },
    radical: '舟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '舶',
    definition: 'large ship, ocean-going vessel',
    pinyin: ['bó'],
    decomposition: '⿰舟白',
    etymology: {
      type: 'pictophonetic',
      phonetic: '白',
      semantic: '舟',
      hint: 'ship',
    },
    radical: '舟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '舷',
    definition: 'bulwarks, gunwhale',
    pinyin: ['xián'],
    decomposition: '⿰舟玄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '玄',
      semantic: '舟',
      hint: 'ship',
    },
    radical: '舟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '舸',
    definition: 'barge, large boat',
    pinyin: ['gě'],
    decomposition: '⿰舟可',
    etymology: {
      type: 'pictophonetic',
      phonetic: '可',
      semantic: '舟',
      hint: 'boat',
    },
    radical: '舟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '船',
    definition: 'ship, boat, vessel',
    pinyin: ['chuán'],
    decomposition: '⿰舟⿱几口',
    etymology: { type: 'pictophonetic', semantic: '舟', hint: 'ship' },
    radical: '舟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '舻',
    definition: 'the prow of a ship',
    pinyin: ['lú'],
    decomposition: '⿰舟卢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卢',
      semantic: '舟',
      hint: 'ship',
    },
    radical: '舟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '舾',
    definition: 'equipment onboard a ship',
    pinyin: ['xī'],
    decomposition: '⿰舟西',
    etymology: {
      type: 'pictophonetic',
      phonetic: '西',
      semantic: '舟',
      hint: 'ship',
    },
    radical: '舟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '艄',
    definition: 'the stern of a ship',
    pinyin: ['shāo'],
    decomposition: '⿰舟肖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肖',
      semantic: '舟',
      hint: 'ship',
    },
    radical: '舟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '艅',
    definition: 'dispatch boat',
    pinyin: ['yú'],
    decomposition: '⿰舟余',
    etymology: {
      type: 'ideographic',
      hint: 'An extra 余 boat 舟; 余 also provides the pronunciation',
    },
    radical: '舟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '艇',
    definition: 'dugout, punt, small boat',
    pinyin: ['tǐng'],
    decomposition: '⿰舟廷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '廷',
      semantic: '舟',
      hint: 'boat',
    },
    radical: '舟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '艉',
    definition: 'the aft of a ship',
    pinyin: ['wěi'],
    decomposition: '⿰舟尾',
    etymology: {
      type: 'ideographic',
      hint: 'The back 尾 of a ship 舟; 尾 also provides the pronunciation',
    },
    radical: '舟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '艋',
    definition: 'small boat',
    pinyin: ['měng'],
    decomposition: '⿰舟孟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孟',
      semantic: '舟',
      hint: 'boat',
    },
    radical: '舟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '艎',
    definition: 'fast boat',
    pinyin: ['huáng'],
    decomposition: '⿰舟皇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皇',
      semantic: '舟',
      hint: 'boat',
    },
    radical: '舟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '艏',
    definition: 'the prow of a ship',
    pinyin: ['shǒu'],
    decomposition: '⿰舟首',
    etymology: {
      type: 'ideographic',
      hint: 'The head 首 of a ship 舟; 首 also provides the pronunciation',
    },
    radical: '舟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '艘',
    definition: 'measure word for ships or vessels',
    pinyin: ['sōu'],
    decomposition: '⿰舟叟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叟',
      semantic: '舟',
      hint: 'ship',
    },
    radical: '舟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '艙',
    definition: "cabin, ship's hold",
    pinyin: ['cāng'],
    decomposition: '⿰舟倉',
    etymology: {
      type: 'ideographic',
      hint: "A ship's 舟 cabin 倉; 倉 also provides the pronunciation",
    },
    radical: '舟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '艚',
    definition: 'ship, junk',
    pinyin: ['cáo'],
    decomposition: '⿰舟曹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曹',
      semantic: '舟',
      hint: 'ship',
    },
    radical: '舟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '艟',
    definition: 'ancient warship',
    pinyin: ['chōng'],
    decomposition: '⿰舟童',
    etymology: {
      type: 'pictophonetic',
      phonetic: '童',
      semantic: '舟',
      hint: 'ship',
    },
    radical: '舟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '艦',
    definition: 'warship',
    pinyin: ['jiàn'],
    decomposition: '⿰舟監',
    etymology: {
      type: 'pictophonetic',
      phonetic: '監',
      semantic: '舟',
      hint: 'ship',
    },
    radical: '舟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '艨',
    definition: 'a long narrow war-boat',
    pinyin: ['méng'],
    decomposition: '⿰舟蒙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蒙',
      semantic: '舟',
      hint: 'boat',
    },
    radical: '舟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '艮',
    definition: 'blunt; tough, chewy',
    pinyin: ['gěn'],
    decomposition: '⿸？？',
    radical: '艮',
    matches: [null, null, null, null, null, null],
  },
  {
    character: '良',
    definition: 'good, virtuous, respectable',
    pinyin: ['liáng'],
    decomposition: '⿱丶艮',
    radical: '艮',
    matches: [[0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '艰',
    definition: 'difficult, hard; hardship',
    pinyin: ['jiān'],
    decomposition: '⿰又艮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堇',
      semantic: '艮',
      hint: 'tough',
    },
    radical: '又',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '艱',
    definition: 'difficult, hard; hardship',
    pinyin: ['jiān'],
    decomposition: '⿰堇艮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堇',
      semantic: '艮',
      hint: 'tough',
    },
    radical: '艮',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '色',
    definition: 'color, tint, hue, shade; beauty, form; sex',
    pinyin: ['sè'],
    decomposition: '⿱⺈巴',
    etymology: { type: 'ideographic', hint: 'What a person ⺈ desires 巴' },
    radical: '色',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '艳',
    definition: 'beautiful, glamorous, sexy, voluptuous',
    pinyin: ['yàn'],
    decomposition: '⿰丰色',
    etymology: { type: 'ideographic', hint: 'Lush 丰 and sexy 色' },
    radical: '色',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '艴',
    definition: "angry, showing emotion on one's face",
    pinyin: ['fú'],
    decomposition: '⿰弗色',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弗',
      semantic: '色',
      hint: 'color',
    },
    radical: '色',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '艷',
    definition: 'beautiful, glamorous, sexy, voluptuous',
    pinyin: ['yàn'],
    decomposition: '⿰豐色',
    etymology: { type: 'ideographic', hint: 'Lush 豐 and sexy 色' },
    radical: '色',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '艸',
    definition: 'grass',
    pinyin: ['cǎo'],
    decomposition: '⿰屮屮',
    etymology: { type: 'pictographic', hint: 'Grass sprouting' },
    radical: '艸',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '艹',
    definition: 'grass, weed, plant, herb',
    pinyin: ['cǎo'],
    decomposition: '？',
    etymology: {
      type: 'pictographic',
      hint: 'Simplified form of 艸; grass sprouting',
    },
    radical: '艹',
    matches: [null, null, null],
  },
  {
    character: '艺',
    definition: 'art; talent, ability; craft',
    pinyin: ['yì'],
    decomposition: '⿱艹乙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乙',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1]],
  },
  {
    character: '艻',
    definition: 'sweet basil',
    pinyin: ['lè'],
    decomposition: '⿱艹力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '力',
      semantic: '艹',
      hint: 'herb',
    },
    radical: '艹',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '艽',
    definition: 'large-leaf gentian',
    pinyin: ['jiāo'],
    decomposition: '⿱艹九',
    etymology: {
      type: 'pictophonetic',
      phonetic: '九',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '艾',
    definition: 'mugwort, Artemisia vulgaris; used in transliterations',
    pinyin: ['ài', 'yì'],
    decomposition: '⿱艹乂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乂',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '艿',
    definition: 'taro',
    pinyin: ['nǎi'],
    decomposition: '⿱艹乃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乃',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '节',
    definition: 'festival; knot, joint; segment; to economize, to save',
    pinyin: ['jié'],
    decomposition: '⿱艹？',
    etymology: {
      type: 'ideographic',
      hint: 'Simplified form of 節; sections of bamboo ⺮',
    },
    radical: '艹',
    matches: [[0], [0], [0], null, null],
  },
  {
    character: '芄',
    definition: 'leaf-blade vine; Metaplexis',
    pinyin: ['wán'],
    decomposition: '⿱艹丸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丸',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '芈',
    definition: 'the bleating of sheep; surname',
    pinyin: ['mǐ'],
    decomposition: '⿻羋？',
    radical: '羋',
    matches: [[0], [0], [0], [0], [0], [0], [0]],
  },
  {
    character: '芊',
    definition: 'luxuriant foliage',
    pinyin: ['qiān'],
    decomposition: '⿱艹千',
    etymology: {
      type: 'ideographic',
      hint: 'A thousand 千 plants 艹; 千 also provides the pronunciation',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '芋',
    definition: 'taro',
    pinyin: ['yù'],
    decomposition: '⿱艹于',
    etymology: {
      type: 'pictophonetic',
      phonetic: '于',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '芍',
    definition: 'peony; water chestnuts',
    pinyin: ['sháo'],
    decomposition: '⿱艹勺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '勺',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '芎',
    definition: 'Szechuan lovage rhizome',
    pinyin: ['qiōng'],
    decomposition: '⿱艹弓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弓',
      semantic: '艹',
      hint: 'herb',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '芏',
    definition: 'Shichito matgrass',
    pinyin: ['dù'],
    decomposition: '⿱艹土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '土',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '芑',
    definition: 'white millet',
    pinyin: ['qǐ'],
    decomposition: '⿱艹己',
    etymology: {
      type: 'pictophonetic',
      phonetic: '己',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '芒',
    definition: 'blade; ray; silvergrass, Miscanthus sinensis',
    pinyin: ['máng'],
    decomposition: '⿱艹亡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亡',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '芗',
    definition: 'fragrant, aromatic; the smell of herbs',
    pinyin: ['xiāng'],
    decomposition: '⿱艹乡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乡',
      semantic: '艹',
      hint: 'herb',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '芘',
    definition: 'common mallow; Malva sylvestris',
    pinyin: ['pí'],
    decomposition: '⿱艹比',
    etymology: {
      type: 'pictophonetic',
      phonetic: '比',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '芙',
    definition: 'lotus; hibiscus',
    pinyin: ['fú'],
    decomposition: '⿱艹夫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夫',
      semantic: '艹',
      hint: 'flower',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '芜',
    definition: 'weeds; overgrowth',
    pinyin: ['wú'],
    decomposition: '⿱艹无',
    etymology: {
      type: 'pictophonetic',
      phonetic: '无',
      semantic: '艹',
      hint: 'weed',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '芝',
    definition: 'sesame; a magical mushroom',
    pinyin: ['zhī'],
    decomposition: '⿱艹之',
    etymology: {
      type: 'pictophonetic',
      phonetic: '之',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '芟',
    definition: 'to weed, to mow, to scythe',
    pinyin: ['shān'],
    decomposition: '⿱艹殳',
    etymology: {
      type: 'ideographic',
      hint: 'To cut grass 艹 with a scythe 殳; 殳 also provides the pronunciation',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '芡',
    definition: 'Gorgon plant, fox nut',
    pinyin: ['qiàn'],
    decomposition: '⿱艹欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '欠',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '芤',
    definition: 'China grass, ramie',
    pinyin: ['kōu'],
    decomposition: '⿱艹孔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孔',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '芥',
    definition: 'mustard, broccoli',
    pinyin: ['jiè'],
    decomposition: '⿱艹介',
    etymology: {
      type: 'pictophonetic',
      phonetic: '介',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '芦',
    definition: 'rushes, reeds',
    pinyin: ['lú'],
    decomposition: '⿱艹户',
    etymology: {
      type: 'pictophonetic',
      phonetic: '户',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '芨',
    definition: 'Chinese elder tree',
    pinyin: ['jī'],
    decomposition: '⿱艹及',
    etymology: {
      type: 'pictophonetic',
      phonetic: '及',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '芩',
    definition: 'salt-marsh plant',
    pinyin: ['qín'],
    decomposition: '⿱艹今',
    etymology: {
      type: 'pictophonetic',
      phonetic: '今',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '芪',
    definition: 'celery',
    pinyin: ['qí'],
    decomposition: '⿱艹氏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '氏',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '芫',
    definition: 'a poisonous plant; Daphne genkwa',
    pinyin: ['yán'],
    decomposition: '⿱艹元',
    etymology: {
      type: 'pictophonetic',
      phonetic: '元',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '芬',
    definition: 'aroma, fragrance, perfume',
    pinyin: ['fēn'],
    decomposition: '⿱艹分',
    etymology: {
      type: 'pictophonetic',
      phonetic: '分',
      semantic: '艹',
      hint: 'flower',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '芭',
    definition: 'a plantain or banana palm',
    pinyin: ['bā'],
    decomposition: '⿱艹巴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巴',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '芮',
    definition: "tiny, small; the water's edge",
    pinyin: ['ruì'],
    decomposition: '⿱艹内',
    etymology: {
      type: 'pictophonetic',
      phonetic: '内',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '芯',
    definition: 'core, pith; the pith of a rush (Juncus effusus)',
    pinyin: ['xīn'],
    decomposition: '⿱艹心',
    etymology: {
      type: 'ideographic',
      hint: 'The heart 心 of a plant 艹; 心 also provides the pronunciation',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '芰',
    definition: 'water caltrop',
    pinyin: ['jì'],
    decomposition: '⿱艹支',
    etymology: {
      type: 'pictophonetic',
      phonetic: '支',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '花',
    definition: 'flower, blossom; to spend (time or money)',
    pinyin: ['huā'],
    decomposition: '⿱艹化',
    etymology: {
      type: 'ideographic',
      hint: 'A flower 艹 in bloom 化; 化 also provides the pronunciation',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '芳',
    definition: 'fragrant; beautiful, virtuous',
    pinyin: ['fāng'],
    decomposition: '⿱艹方',
    etymology: {
      type: 'pictophonetic',
      phonetic: '方',
      semantic: '艹',
      hint: 'flower',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '芴',
    definition: 'an edible wild plant',
    pinyin: ['wù'],
    decomposition: '⿱艹勿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '勿',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '芷',
    definition: 'an angelica herb',
    pinyin: ['zhǐ'],
    decomposition: '⿱艹止',
    etymology: {
      type: 'pictophonetic',
      phonetic: '止',
      semantic: '艹',
      hint: 'herb',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '芸',
    definition: 'common rue; diverse, varied',
    pinyin: ['yún'],
    decomposition: '⿱艹云',
    etymology: {
      type: 'pictophonetic',
      phonetic: '云',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '芹',
    definition: 'celery',
    pinyin: ['qín'],
    decomposition: '⿱艹斤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斤',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '芻',
    definition: 'to mow, to cut grass; hay, fodder',
    pinyin: ['chú'],
    decomposition: '⿱⿹勹屮⿹勹屮',
    etymology: { type: 'ideographic', hint: 'To trim 勹 grass shoots 屮' },
    radical: '艸',
    matches: [
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '芽',
    definition: 'bud, shoot, sprout',
    pinyin: ['yá'],
    decomposition: '⿱艹牙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '牙',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '芾',
    definition: 'flower; lush, luxuriant',
    pinyin: ['fèi'],
    decomposition: '⿱艹巿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巿',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '苁',
    definition: 'a medicinal herb; Boschniakia glabra',
    pinyin: ['cōng'],
    decomposition: '⿱艹从',
    etymology: {
      type: 'pictophonetic',
      phonetic: '从',
      semantic: '艹',
      hint: 'herb',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '苄',
    definition: 'benzyl',
    pinyin: ['biàn'],
    decomposition: '⿱艹卞',
    etymology: { type: 'pictophonetic', phonetic: '卞', semantic: '艹' },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '苇',
    definition: 'reed',
    pinyin: ['wěi'],
    decomposition: '⿱艹韦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韦',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '苈',
    definition: 'magnolia; Drabanemerosa hebecarpa',
    pinyin: ['lì'],
    decomposition: '⿱艹历',
    etymology: {
      type: 'pictophonetic',
      phonetic: '历',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '苊',
    definition: 'acenaphthene',
    pinyin: ['è'],
    decomposition: '⿱艹厄',
    etymology: { type: 'pictophonetic', phonetic: '厄', semantic: '艹' },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '苋',
    definition: 'amaranth',
    pinyin: ['xiàn'],
    decomposition: '⿱艹见',
    etymology: {
      type: 'pictophonetic',
      phonetic: '见',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '苌',
    definition: 'Averrhora carambola; surname',
    pinyin: ['cháng'],
    decomposition: '⿱艹长',
    etymology: {
      type: 'pictophonetic',
      phonetic: '长',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '苍',
    definition: 'dark blue; deep green; old, hoary',
    pinyin: ['cāng'],
    decomposition: '⿱艹仓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '仓',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '苎',
    definition: 'China grass, ramie',
    pinyin: ['zhù'],
    decomposition: '⿱艹⿱宀一',
    etymology: { type: 'pictophonetic', semantic: '艹', hint: 'grass' },
    radical: '艹',
    matches: [[0], [0], [0], [1, 0], [1, 0], [1, 0], [1, 1]],
  },
  {
    character: '苏',
    definition: 'to awaken, to revive, to resurrect; used in transliterations',
    pinyin: ['sū'],
    decomposition: '⿱艹办',
    etymology: {
      type: 'pictophonetic',
      phonetic: '稣',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '苑',
    definition: 'pasture, park, garden; mansion',
    pinyin: ['yuàn'],
    decomposition: '⿱艹夗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夗',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '苒',
    definition: 'lush, luxuriant; ordered, sequential; the passage of time',
    pinyin: ['rǎn'],
    decomposition: '⿱艹冉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冉',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '苓',
    definition: 'fungus, tuber; licorice',
    pinyin: ['líng'],
    decomposition: '⿱艹令',
    etymology: {
      type: 'pictophonetic',
      phonetic: '令',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '苔',
    definition: 'moss, lichen',
    pinyin: ['tái'],
    decomposition: '⿱艹台',
    etymology: {
      type: 'pictophonetic',
      phonetic: '台',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '苕',
    definition: 'rush, reed; trumpet vine',
    pinyin: ['sháo'],
    decomposition: '⿱艹召',
    etymology: {
      type: 'pictophonetic',
      phonetic: '召',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '苗',
    definition: 'sprouts; Miao nationality',
    pinyin: ['miáo'],
    decomposition: '⿱艹田',
    etymology: { type: 'ideographic', hint: 'Grass 艹 growing in a field 田' },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '苘',
    definition: 'Indian mallow',
    pinyin: ['qǐng'],
    decomposition: '⿱艹冋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冋',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '苛',
    definition: 'severe, harsh; rigorous, exacting',
    pinyin: ['kē'],
    decomposition: '⿱艹可',
    etymology: {
      type: 'pictophonetic',
      phonetic: '可',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '苜',
    definition: 'clover',
    pinyin: ['mù'],
    decomposition: '⿱艹目',
    etymology: {
      type: 'pictophonetic',
      phonetic: '目',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '苞',
    definition: 'bud, flower; rush, reed; to bloom',
    pinyin: ['bāo'],
    decomposition: '⿱艹包',
    etymology: {
      type: 'ideographic',
      hint: 'A flower 艹 unfolding 包; 包 also provides the pronunciation',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '苟',
    definition: 'careless, frivolous, illicit; but, if only',
    pinyin: ['gǒu'],
    decomposition: '⿱艹句',
    etymology: {
      type: 'pictophonetic',
      phonetic: '句',
      semantic: '艹',
      hint: 'wild grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '苠',
    definition: 'number, multitude; bamboo skin',
    pinyin: ['mín'],
    decomposition: '⿱艹民',
    etymology: {
      type: 'pictophonetic',
      phonetic: '民',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '苡',
    definition: 'barley',
    pinyin: ['yǐ'],
    decomposition: '⿱艹以',
    etymology: {
      type: 'pictophonetic',
      phonetic: '以',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '苣',
    definition: 'a kind of lettuce',
    pinyin: ['jù'],
    decomposition: '⿱艹巨',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巨',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '苤',
    definition: 'kohlrabi',
    pinyin: ['piě'],
    decomposition: '⿱艹丕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丕',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '若',
    definition: 'if, supposing, assuming; similar',
    pinyin: ['ruò'],
    decomposition: '⿱艹右',
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '苦',
    definition: 'bitter; hardship, suffering',
    pinyin: ['kǔ'],
    decomposition: '⿱艹古',
    etymology: {
      type: 'pictophonetic',
      phonetic: '古',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '苧',
    definition: 'China grass, ramie',
    pinyin: ['zhù'],
    decomposition: '⿱艹宁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宁',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '苫',
    definition: 'rush or straw matting',
    pinyin: ['shān'],
    decomposition: '⿱艹占',
    etymology: {
      type: 'pictophonetic',
      phonetic: '占',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '苯',
    definition: 'benzene, benzol',
    pinyin: ['běn'],
    decomposition: '⿱艹本',
    etymology: { type: 'pictophonetic', phonetic: '本', semantic: '艹' },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '英',
    definition: 'petal, flower, leaf; brave, heroic; English',
    pinyin: ['yīng'],
    decomposition: '⿱艹央',
    etymology: {
      type: 'pictophonetic',
      phonetic: '央',
      semantic: '艹',
      hint: 'flower',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '苲',
    definition: 'hornwort',
    pinyin: ['zhǎ'],
    decomposition: '⿱艹乍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乍',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '苴',
    definition: 'hemp; sack-cloth',
    pinyin: ['jū'],
    decomposition: '⿱艹且',
    etymology: {
      type: 'pictophonetic',
      phonetic: '且',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '苷',
    definition: 'licorice',
    pinyin: ['gān'],
    decomposition: '⿱艹甘',
    etymology: {
      type: 'ideographic',
      hint: 'A sweet 甘 plant 艹; 甘 also provides the pronunciation',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '苹',
    definition: 'apple; duckweed, Artemisia',
    pinyin: ['píng'],
    decomposition: '⿱艹平',
    etymology: {
      type: 'pictophonetic',
      phonetic: '平',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '苻',
    definition: 'a kind of herb; Angelica anomala',
    pinyin: ['fú'],
    decomposition: '⿱艹付',
    etymology: {
      type: 'pictophonetic',
      phonetic: '付',
      semantic: '艹',
      hint: 'herb',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '茀',
    definition: 'weeds; overgrowth',
    pinyin: ['fú'],
    decomposition: '⿱艹弗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弗',
      semantic: '艹',
      hint: 'weed',
    },
    radical: '艹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '茁',
    definition: 'to sprout, to flourish; vigorous, healthy',
    pinyin: ['zhuó'],
    decomposition: '⿱艹出',
    etymology: {
      type: 'ideographic',
      hint: 'Sprouting 出 grass 艹; 出 also provides the pronunciation',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '茂',
    definition: 'thick, lush, dense; talented',
    pinyin: ['mào'],
    decomposition: '⿱艹戊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戊',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '范',
    definition: 'pattern, model, example; surname',
    pinyin: ['fàn'],
    decomposition: '⿱艹氾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '氾',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '茄',
    definition: 'eggplant',
    pinyin: ['jiā'],
    decomposition: '⿱艹加',
    etymology: {
      type: 'pictophonetic',
      phonetic: '加',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '茅',
    definition: 'rushes, reeds, grass; surname',
    pinyin: ['máo'],
    decomposition: '⿱艹矛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '矛',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '茆',
    definition: 'water mallow',
    pinyin: ['máo'],
    decomposition: '⿱艹卯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卯',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '茇',
    definition: 'straw, thatch',
    pinyin: ['bá'],
    decomposition: '⿱艹犮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '犮',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '茈',
    definition: 'a plant yielding a red dye',
    pinyin: ['cí'],
    decomposition: '⿱艹此',
    etymology: {
      type: 'pictophonetic',
      phonetic: '此',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '茉',
    definition: 'white jasmine',
    pinyin: ['mò'],
    decomposition: '⿱艹末',
    etymology: {
      type: 'pictophonetic',
      phonetic: '末',
      semantic: '艹',
      hint: 'herb',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '茌',
    definition: 'a district in Shandong',
    pinyin: ['chí'],
    decomposition: '⿱艹仕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '仕',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '茎',
    definition: 'stem, stalk',
    pinyin: ['jīng'],
    decomposition: '⿱艹？',
    etymology: { type: 'pictophonetic', semantic: '艹', hint: 'grass' },
    radical: '艹',
    matches: [[0], [0], [0], null, null, null, null, null],
  },
  {
    character: '茏',
    definition: 'tall grass; water-weeds',
    pinyin: ['lóng'],
    decomposition: '⿱艹龙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龙',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '茑',
    definition: 'mistletoe; parasitic plants',
    pinyin: ['niǎo'],
    decomposition: '⿱艹鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鸟',
      semantic: '艹',
      hint: 'weed',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '茔',
    definition: 'grave, tomb, cemetary',
    pinyin: ['yíng'],
    decomposition: '⿳艹冖土',
    etymology: {
      type: 'ideographic',
      hint: 'Grass 艹 covering a buried 土 casket 冖',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [2], [2], [2]],
  },
  {
    character: '茕',
    definition: 'alone, desolate; without friends or family',
    pinyin: ['qióng'],
    decomposition: '⿱艹⿱冖卂',
    radical: '艹',
    matches: [[0], [0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '茗',
    definition: 'tea; tea leaves; tea plant',
    pinyin: ['míng'],
    decomposition: '⿱艹名',
    etymology: {
      type: 'pictophonetic',
      phonetic: '名',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '茚',
    definition: 'indene',
    pinyin: ['yìn'],
    decomposition: '⿱艹印',
    etymology: { type: 'pictophonetic', phonetic: '印', semantic: '艹' },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '茛',
    definition: 'ranunculus',
    pinyin: ['gèn'],
    decomposition: '⿱艹艮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '艮',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '茜',
    definition: 'reed, madder; Rubia cordifolia',
    pinyin: ['qiàn'],
    decomposition: '⿱艹西',
    etymology: {
      type: 'pictophonetic',
      phonetic: '西',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '茧',
    definition: 'cocoon; callus, blister',
    pinyin: ['jiǎn'],
    decomposition: '⿱艹虫',
    etymology: {
      type: 'ideographic',
      hint: 'A silk cocoon 艹 spun by a worm 虫',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '茨',
    definition: 'thatching; caltrop, Tribulus terrestris',
    pinyin: ['cí'],
    decomposition: '⿱艹次',
    etymology: {
      type: 'pictophonetic',
      phonetic: '次',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '茫',
    definition: 'vague, boundless; vast, widespread',
    pinyin: ['máng'],
    decomposition: '⿱艹汒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '汒',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '茬',
    definition: 'opportunity; farmland after the harvest',
    pinyin: ['chá'],
    decomposition: '⿱艹在',
    etymology: {
      type: 'pictophonetic',
      phonetic: '在',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '茭',
    definition: 'an edible aquatic grass; Zizania aquatica',
    pinyin: ['jiāo'],
    decomposition: '⿱艹交',
    etymology: {
      type: 'pictophonetic',
      phonetic: '交',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '茯',
    definition: 'China root; medicinal fungus',
    pinyin: ['fú'],
    decomposition: '⿱艹伏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '伏',
      semantic: '艹',
      hint: 'herb',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '茱',
    definition: 'dogwood',
    pinyin: ['zhū'],
    decomposition: '⿱艹朱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朱',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '茲',
    definition: 'now, here; this; time, year',
    pinyin: ['zī'],
    decomposition: '⿱艹⿰幺幺',
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '茳',
    definition: 'Shichito matgrass',
    pinyin: ['jiāng'],
    decomposition: '⿱艹江',
    etymology: {
      type: 'pictophonetic',
      phonetic: '江',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '茴',
    definition: 'fennel, aniseed',
    pinyin: ['huí'],
    decomposition: '⿱艹回',
    etymology: {
      type: 'pictophonetic',
      phonetic: '回',
      semantic: '艹',
      hint: 'herb',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '茵',
    definition: 'mattress, cushion; wormwood, Skimmia japon',
    pinyin: ['yīn'],
    decomposition: '⿱艹因',
    etymology: {
      type: 'pictophonetic',
      phonetic: '因',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '茶',
    definition: 'tea; tea leaves; tea plant',
    pinyin: ['chá'],
    decomposition: '⿱艹⿱人木',
    etymology: { type: 'pictophonetic', semantic: '艹', hint: 'plant' },
    radical: '艹',
    matches: [[0], [0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '茸',
    definition: 'soft, downy; buds, sprouts',
    pinyin: ['rōng'],
    decomposition: '⿱艹耳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '耳',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '茹',
    definition: 'roots, vegetables',
    pinyin: ['rú'],
    decomposition: '⿱艹如',
    etymology: {
      type: 'pictophonetic',
      phonetic: '如',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '茺',
    pinyin: ['chōng'],
    decomposition: '⿱艹充',
    etymology: {
      type: 'pictophonetic',
      phonetic: '充',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '茼',
    definition: 'chrysanthemum; Glebionis coronarium',
    pinyin: ['tóng'],
    decomposition: '⿱艹同',
    etymology: {
      type: 'pictophonetic',
      phonetic: '同',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '荀',
    definition: 'plant, herb; surname',
    pinyin: ['xún'],
    decomposition: '⿱艹旬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旬',
      semantic: '艹',
      hint: 'herb',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '荃',
    definition: 'aromatic herb; fine cloth',
    pinyin: ['quán'],
    decomposition: '⿱艹全',
    etymology: {
      type: 'pictophonetic',
      phonetic: '全',
      semantic: '艹',
      hint: 'herb',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '荅',
    definition: 'to answer; small bean; thick, heavy',
    pinyin: ['dā'],
    decomposition: '⿱艹合',
    etymology: {
      type: 'pictophonetic',
      phonetic: '合',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '荆',
    definition: 'thorns, brambles; surname',
    pinyin: ['jīng'],
    decomposition: '⿰⿱艹开刂',
    etymology: { type: 'ideographic', hint: 'A plant 艹 armed with thorns 刂' },
    radical: '刂',
    matches: [[0, 0], [0, 0], [0, 0], [0, 1], [0, 1], [0, 1], [0, 1], [1], [1]],
  },
  {
    character: '荇',
    definition: 'a water plant, Nymphoides peltalum',
    pinyin: ['xìng'],
    decomposition: '⿱艹行',
    etymology: {
      type: 'pictophonetic',
      phonetic: '行',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '草',
    definition: 'grass, herbs; straw, thatch',
    pinyin: ['cǎo'],
    decomposition: '⿱艹早',
    etymology: {
      type: 'pictophonetic',
      phonetic: '早',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '荏',
    definition: 'herb, mint; soft, pliable',
    pinyin: ['rěn'],
    decomposition: '⿱艹任',
    etymology: {
      type: 'pictophonetic',
      phonetic: '任',
      semantic: '艹',
      hint: 'herb',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '荐',
    definition: 'to recommend; to recur, to repeat',
    pinyin: ['jiàn'],
    decomposition: '⿱艹存',
    etymology: {
      type: 'ideographic',
      hint: 'A perennial; grass 艹 that survives 存 year-after-year',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '荑',
    definition: 'sprout; to weed',
    pinyin: ['tí'],
    decomposition: '⿱艹夷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夷',
      semantic: '艹',
      hint: 'weed',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '荒',
    definition: 'wasteland, desert; uncultivated',
    pinyin: ['huāng'],
    decomposition: '⿱芒川',
    etymology: {
      type: 'pictophonetic',
      phonetic: '川',
      semantic: '芒',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '荔',
    definition: 'lychee',
    pinyin: ['lì'],
    decomposition: '⿱艹劦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '劦',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '荚',
    definition: 'seed-pod',
    pinyin: ['jiá'],
    decomposition: '⿱艹夹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夹',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '荛',
    definition: 'fuel, firewood; grass, shrub; Wikstroemia japonica',
    pinyin: ['ráo'],
    decomposition: '⿱艹尧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尧',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '荜',
    definition: 'a kind of bean; Piper longtum',
    pinyin: ['bì'],
    decomposition: '⿱艹毕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '毕',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '荞',
    definition: 'buckwheat',
    pinyin: ['qiáo'],
    decomposition: '⿱艹乔',
    etymology: {
      type: 'ideographic',
      hint: 'A tall 乔 grass 艹; 乔 also provides the pronunciation',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '荟',
    definition: 'abundant, flourishing',
    pinyin: ['huì'],
    decomposition: '⿱艹会',
    etymology: {
      type: 'pictophonetic',
      phonetic: '会',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '荠',
    definition: 'water chestnut; water caltrop',
    pinyin: ['jì'],
    decomposition: '⿱艹齐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '齐',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '荡',
    definition: 'pond, pool; ripple, shake; to wash away, to wipe out',
    pinyin: ['dàng'],
    decomposition: '⿱艹汤',
    etymology: {
      type: 'ideographic',
      hint: 'Hot water 汤 wiping out plant life 艹; 汤 also provides the pronunciation',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '荣',
    definition: 'glory, honor; to flourish, to prosper',
    pinyin: ['róng'],
    decomposition: '⿱艹⿱冖木',
    etymology: {
      type: 'ideographic',
      hint: 'Grass 艹 and trees 木 flourishing in a garden 冖',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '荤',
    definition: 'non-vegetarian food; garlic; a foul smell',
    pinyin: ['hūn'],
    decomposition: '⿱艹军',
    etymology: {
      type: 'pictophonetic',
      phonetic: '军',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '荥',
    definition: 'a county in Henan; the sound of waves crashing',
    pinyin: ['xíng'],
    decomposition: '⿳艹冖水',
    etymology: { type: 'pictophonetic', semantic: '水', hint: 'water' },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [2], [2], [2], [2]],
  },
  {
    character: '荦',
    definition: 'brindled ox; tawny, variegated',
    pinyin: ['luò'],
    decomposition: '⿱艹⿱冖牛',
    etymology: { type: 'pictophonetic', semantic: '牛', hint: 'ox' },
    radical: '牛',
    matches: [[0], [0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '荧',
    definition: 'to shine, to shimmer; shining, dazzling',
    pinyin: ['yíng'],
    decomposition: '⿱艹⿱冖火',
    etymology: { type: 'pictophonetic', semantic: '火', hint: 'fire' },
    radical: '艹',
    matches: [[0], [0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '荨',
    definition: 'nettle',
    pinyin: ['xún'],
    decomposition: '⿱艹寻',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寻',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '荩',
    definition: 'loyal, faithful; a perennial weed',
    pinyin: ['jìn'],
    decomposition: '⿱艹尽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尽',
      semantic: '艹',
      hint: 'weed',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '荪',
    definition: 'aromatic grass; flower, iris',
    pinyin: ['sūn'],
    decomposition: '⿱艹孙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孙',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '荫',
    definition: 'shade, shelter; to protect',
    pinyin: ['yīn'],
    decomposition: '⿱艹阴',
    etymology: {
      type: 'ideographic',
      hint: 'Shade 阴 provided by a tree 艹; 阴 also provides the pronunciation',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '荬',
    definition: 'endive; sow-thistle',
    pinyin: ['mǎi'],
    decomposition: '⿱艹买',
    etymology: {
      type: 'pictophonetic',
      phonetic: '买',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '荭',
    definition: 'herb',
    pinyin: ['hóng'],
    decomposition: '⿱艹红',
    etymology: {
      type: 'pictophonetic',
      phonetic: '红',
      semantic: '艹',
      hint: 'herb',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '荮',
    definition: 'grass',
    pinyin: ['zhòu'],
    decomposition: '⿱艹纣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '纣',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '药',
    definition: 'drugs, medicine; the leaf of the Dahurian angelica plant',
    pinyin: ['yào'],
    decomposition: '⿱艹约',
    etymology: {
      type: 'pictophonetic',
      phonetic: '约',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '荷',
    definition: 'lotus, water lily; burden, responsibility; Holland',
    pinyin: ['hé'],
    decomposition: '⿱艹何',
    etymology: {
      type: 'pictophonetic',
      phonetic: '何',
      semantic: '艹',
      hint: 'flower',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '荸',
    definition: 'water chestnut',
    pinyin: ['bí'],
    decomposition: '⿱艹孛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孛',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '荻',
    definition: 'rush, reed; Miscanthus saccariflorus',
    pinyin: ['dí'],
    decomposition: '⿱艹狄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '狄',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '荼',
    definition: 'a bitter vegetable',
    pinyin: ['tú'],
    decomposition: '⿱艹余',
    etymology: {
      type: 'pictophonetic',
      phonetic: '余',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '荽',
    definition: 'coriander',
    pinyin: ['suī'],
    decomposition: '⿱艹妥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '妥',
      semantic: '艹',
      hint: 'herb',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '莅',
    definition: 'attend, be present; arrive at',
    pinyin: ['lì'],
    decomposition: '⿱艹位',
    etymology: {
      type: 'ideographic',
      hint: 'A place 位 where grass 艹 grows; 立 also provides the pronunciation',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '莆',
    definition: 'a kind of legendary tree',
    pinyin: ['pú'],
    decomposition: '⿱艹甫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甫',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '莉',
    definition: 'jasmine',
    pinyin: ['lì'],
    decomposition: '⿱艹利',
    etymology: {
      type: 'pictophonetic',
      phonetic: '利',
      semantic: '艹',
      hint: 'flower',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '莊',
    definition: 'village, hamlet; villa, manor',
    pinyin: ['zhuāng'],
    decomposition: '⿱艹壯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '壯',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '莎',
    definition: 'a kind of sedge grass that used to be woven into raincoats',
    pinyin: ['shā'],
    decomposition: '⿱艹沙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '沙',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '莒',
    definition: 'taro, hemp; herb;',
    pinyin: ['jǔ'],
    decomposition: '⿱艹吕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吕',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '莓',
    definition: 'moss; edible berries',
    pinyin: ['méi'],
    decomposition: '⿱艹每',
    etymology: {
      type: 'pictophonetic',
      phonetic: '每',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '莖',
    definition: 'stem, stalk',
    pinyin: ['jīng'],
    decomposition: '⿱艹巠',
    etymology: {
      type: 'pictophonetic',
      semantic: '艹',
      hint: 'grass',
      phonetic: '巠',
    },
    radical: '艹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '莘',
    definition: 'numerous, long; a marsh plant with a medicinal root',
    pinyin: ['shēn'],
    decomposition: '⿱艹辛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辛',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '莛',
    definition: 'blades of grass',
    pinyin: ['tíng'],
    decomposition: '⿱艹廷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '廷',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '莜',
    definition: 'Avena nuda; a bamboo basket',
    pinyin: ['yóu'],
    decomposition: '⿱艹攸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '攸',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '莞',
    definition: 'to smile; club-rush, Scirpus lacustris',
    pinyin: ['guǎn'],
    decomposition: '⿱艹完',
    etymology: {
      type: 'pictophonetic',
      phonetic: '完',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '莠',
    definition: 'weeds, tares; evil, undesirable',
    pinyin: ['yǒu'],
    decomposition: '⿱艹秀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '秀',
      semantic: '艹',
      hint: 'weed',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '莢',
    definition: 'seed-pod',
    pinyin: ['jiá'],
    decomposition: '⿱艹夾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夾',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '莧',
    definition: 'amaranth',
    pinyin: ['xiàn'],
    decomposition: '⿱艹見',
    etymology: {
      type: 'pictophonetic',
      phonetic: '見',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '莨',
    definition: 'Japanese belladonna; Scopolia japonica',
    pinyin: ['làng'],
    decomposition: '⿱艹良',
    etymology: {
      type: 'pictophonetic',
      phonetic: '良',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '莩',
    definition: 'culm, stem; the membrane lining a stem',
    pinyin: ['fú'],
    decomposition: '⿱艹孚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孚',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '莪',
    definition: 'mugwort, Artemisia',
    pinyin: ['é'],
    decomposition: '⿱艹我',
    etymology: {
      type: 'pictophonetic',
      phonetic: '我',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '莫',
    definition: 'cannot; do not; is not; negative',
    pinyin: ['mò'],
    decomposition: '⿱艹旲',
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '莰',
    definition: 'camphane',
    pinyin: ['kǎn'],
    decomposition: '⿱艹坎',
    etymology: { type: 'pictophonetic', phonetic: '坎', semantic: '艹' },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '莱',
    definition: 'weed, goosefoot; fallow field; used in transliterations',
    pinyin: ['lái'],
    decomposition: '⿱艹来',
    etymology: {
      type: 'pictophonetic',
      phonetic: '来',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '莲',
    definition: 'lotus, water lily; paradise',
    pinyin: ['lián'],
    decomposition: '⿱艹连',
    etymology: {
      type: 'pictophonetic',
      phonetic: '连',
      semantic: '艹',
      hint: 'flower',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '莳',
    definition: 'to transplant, to grow; dill, Anethum graveolens',
    pinyin: ['shí'],
    decomposition: '⿱艹时',
    etymology: {
      type: 'pictophonetic',
      phonetic: '时',
      semantic: '艹',
      hint: 'herb',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '莴',
    definition: 'lettuce',
    pinyin: ['wō'],
    decomposition: '⿱艹呙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '呙',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '莶',
    definition: 'vine',
    pinyin: ['xiān'],
    decomposition: '⿱艹佥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '佥',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '获',
    definition: 'to get, to obtain, to receive, to sieze',
    pinyin: ['huò'],
    decomposition: '⿱艹犾',
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '莸',
    definition: 'Caryopteris divaricata',
    pinyin: ['yóu'],
    decomposition: '⿱艹犹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '犹',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '莹',
    definition: 'bright, lustrous, sparkling like a gem',
    pinyin: ['yíng'],
    decomposition: '⿱艹⿱冖玉',
    etymology: {
      type: 'ideographic',
      hint: 'Simplified form of 瑩; fiery 火 like a gem 玉',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '莺',
    definition: 'oriole, green finch; Sylvia species (various)',
    pinyin: ['yīng'],
    decomposition: '⿱艹⿱冖鸟',
    etymology: {
      type: 'ideographic',
      hint: 'A bird 鸟 covered in 冖 green 艹 feathers',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '莼',
    definition: 'an edible water plant; Brasenia',
    pinyin: ['chún'],
    decomposition: '⿱艹纯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '纯',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '莽',
    definition: 'thicket, underbrush; rude, impertinent',
    pinyin: ['mǎng'],
    decomposition: '⿱艹⿱犬廾',
    etymology: {
      type: 'ideographic',
      hint: 'A dog 犬 surrounded by weeds 艹, 廾',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '莿',
    definition: 'thorn',
    pinyin: ['cì'],
    decomposition: '⿱艹刺',
    etymology: {
      type: 'ideographic',
      hint: 'A plant 艹 that pricks 刺; 刺 also provides the pronunciation',
    },
    radical: '艹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '菀',
    definition: 'luxuriant foliage',
    pinyin: ['wǎn'],
    decomposition: '⿱艹宛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宛',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '菁',
    definition: 'turnip; a flower of the leek family',
    pinyin: ['jīng'],
    decomposition: '⿱艹青',
    etymology: {
      type: 'pictophonetic',
      phonetic: '青',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '菅',
    definition: 'coarse grass; Themedia forskali',
    pinyin: ['jiān'],
    decomposition: '⿱艹官',
    etymology: {
      type: 'pictophonetic',
      phonetic: '官',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '菇',
    definition: 'mushroom',
    pinyin: ['gū'],
    decomposition: '⿱艹姑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '姑',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '菊',
    definition: 'chrysanthemum',
    pinyin: ['jú'],
    decomposition: '⿱艹匊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匊',
      semantic: '艹',
      hint: 'flower',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '菌',
    definition: 'mushroom; bacteria, germ, microbe',
    pinyin: ['jūn'],
    decomposition: '⿱艹囷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '囷',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '菏',
    definition: 'a river in Shandong province',
    pinyin: ['hé'],
    decomposition: '⿱艹河',
    etymology: {
      type: 'ideographic',
      hint: 'A green 艹 river 河; 河 also provides the pronunciation',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '菐',
    definition: 'thicket',
    pinyin: ['pú'],
    decomposition: '⿳业艹？',
    radical: '艹',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], null, null, null, null],
  },
  {
    character: '菔',
    definition: 'turnip',
    pinyin: ['fú'],
    decomposition: '⿱艹服',
    etymology: {
      type: 'pictophonetic',
      phonetic: '服',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '菖',
    definition: 'iris, sweet flag, Calamus',
    pinyin: ['chāng'],
    decomposition: '⿱艹昌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昌',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '菘',
    definition: 'celery, cabbage',
    pinyin: ['sōng'],
    decomposition: '⿱艹松',
    etymology: {
      type: 'pictophonetic',
      phonetic: '松',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '菜',
    definition: 'vegetables; order, dish; food',
    pinyin: ['cài'],
    decomposition: '⿱艹采',
    etymology: {
      type: 'pictophonetic',
      phonetic: '采',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '菝',
    definition: 'Smilax china',
    pinyin: ['bá'],
    decomposition: '⿱艹拔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '拔',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '菟',
    definition: 'creeper, parasitic vine; Cuscuta sinensis ',
    pinyin: ['tú'],
    decomposition: '⿱艹兔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兔',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '菠',
    definition: 'spinach',
    pinyin: ['bō'],
    decomposition: '⿱艹波',
    etymology: {
      type: 'pictophonetic',
      phonetic: '波',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '菡',
    definition: 'lotus blossom',
    pinyin: ['hàn'],
    decomposition: '⿱艹函',
    etymology: {
      type: 'pictophonetic',
      phonetic: '函',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '菥',
    definition: 'pennycress',
    pinyin: ['xī'],
    decomposition: '⿱艹析',
    etymology: {
      type: 'pictophonetic',
      phonetic: '析',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '菩',
    definition: 'herb, aromatic plant',
    pinyin: ['pú'],
    decomposition: '⿱艹咅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咅',
      semantic: '艹',
      hint: 'herb',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '菪',
    definition: 'henbane, nightshade',
    pinyin: ['dàng'],
    decomposition: '⿱艹宕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宕',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '華',
    definition: 'flowery; illustrious; Chinese',
    pinyin: ['huá'],
    decomposition: '⿱艹⿻十？',
    etymology: {
      type: 'pictophonetic',
      phonetic: '艹',
      semantic: '十',
      hint: 'ten',
    },
    radical: '艹',
    matches: [[0], [0], [0], [0], null, [1, 0], null, null, null, null, [1, 0]],
  },
  {
    character: '菰',
    definition: 'wild rice; Zizania latifolia',
    pinyin: ['gū'],
    decomposition: '⿱艹孤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孤',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '菱',
    definition: 'water chestnut, water caltrop',
    pinyin: ['líng'],
    decomposition: '⿱艹夌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夌',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '菲',
    definition: 'fragrant; rich, luxuriant; the Philippines',
    pinyin: ['fēi'],
    decomposition: '⿱艹非',
    etymology: {
      type: 'pictophonetic',
      phonetic: '非',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '菸',
    definition: 'tobacco, dried leaves; to fade',
    pinyin: ['yān'],
    decomposition: '⿱艹於',
    etymology: {
      type: 'pictophonetic',
      phonetic: '於',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '菹',
    definition: 'salted or pickled vegetables',
    pinyin: ['jū'],
    decomposition: '⿱艹沮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '沮',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '菽',
    definition: 'legumes',
    pinyin: ['shū'],
    decomposition: '⿱艹叔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叔',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '萁',
    definition: 'pulses, legumes',
    pinyin: ['qí'],
    decomposition: '⿱艹其',
    etymology: {
      type: 'pictophonetic',
      phonetic: '其',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '萃',
    definition: 'grassy; thick, dense, close; to gather, to assemble',
    pinyin: ['cuì'],
    decomposition: '⿱艹卒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卒',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '萄',
    definition: 'grapes',
    pinyin: ['táo'],
    decomposition: '⿱艹匋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匋',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '萆',
    definition: 'castor oil; the castor-oil plant',
    pinyin: ['bì'],
    decomposition: '⿱艹卑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卑',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '萋',
    definition: 'luxuriant foliage',
    pinyin: ['qī'],
    decomposition: '⿱艹妻',
    etymology: {
      type: 'pictophonetic',
      phonetic: '妻',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '萌',
    definition: 'bud, germ, sprout; to bud',
    pinyin: ['méng'],
    decomposition: '⿱艹明',
    etymology: {
      type: 'pictophonetic',
      phonetic: '明',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '萍',
    definition: 'duckweed; to travel, to wander',
    pinyin: ['píng'],
    decomposition: '⿱艹泙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '泙',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '萎',
    definition: 'to wither, to wilt',
    pinyin: ['wēi'],
    decomposition: '⿱艹委',
    etymology: {
      type: 'pictophonetic',
      phonetic: '委',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '萏',
    definition: 'lotus',
    pinyin: ['dàn'],
    decomposition: '⿱艹臽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臽',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '萑',
    definition: 'grass, hay, straw',
    pinyin: ['huán'],
    decomposition: '⿱艹隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隹',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '萘',
    definition: 'naphthalene',
    pinyin: ['nài'],
    decomposition: '⿱艹奈',
    etymology: { type: 'pictophonetic', phonetic: '奈', semantic: '艹' },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '萜',
    definition: 'terpene',
    pinyin: ['tiē'],
    decomposition: '⿱艹帖',
    etymology: { type: 'pictophonetic', phonetic: '帖', semantic: '艹' },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '萝',
    definition: 'carrot, radish, turnip',
    pinyin: ['luó'],
    decomposition: '⿱艹罗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '罗',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '萠',
    definition: 'bud, sprout',
    pinyin: ['méng'],
    decomposition: '⿱艹朋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朋',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '萤',
    definition: 'firefly, glow-worm',
    pinyin: ['yíng'],
    decomposition: '⿱艹⿱冖虫',
    etymology: { type: 'pictophonetic', semantic: '虫', hint: 'insect' },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '营',
    definition: 'camp, barracks, army; to run, to manage',
    pinyin: ['yíng'],
    decomposition: '⿱艹⿱冖吕',
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '萦',
    definition: 'to coil, to entangle, to entwine',
    pinyin: ['yíng'],
    decomposition: '⿳艹冖糸',
    etymology: { type: 'pictophonetic', semantic: '糸', hint: 'thread' },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [2], [2], [2], [2], [2], [2]],
  },
  {
    character: '萧',
    definition: 'mournful, desolate; common Artemisa',
    pinyin: ['xiāo'],
    decomposition: '⿱艹肃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '艹',
      semantic: '肃',
      hint: 'solemn',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '萨',
    definition: 'Buddhist diety; used in transliterations',
    pinyin: ['sà'],
    decomposition: '⿱艹⿰阝产',
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '萬',
    definition: 'ten thousand; innumerable',
    pinyin: ['wàn'],
    decomposition: '⿱艹禺',
    radical: '艹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '萱',
    definition: 'day-lily, Hemerocallis fulva',
    pinyin: ['xuān'],
    decomposition: '⿱艹宣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宣',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '萸',
    definition: 'dogwood',
    pinyin: ['yú'],
    decomposition: '⿱艹臾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臾',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '萼',
    definition: 'the stem and calyx of a flower',
    pinyin: ['è'],
    decomposition: '⿱艹咢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咢',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '落',
    definition: 'to fall, to drop; surplus, net income',
    pinyin: ['luò'],
    decomposition: '⿱艹洛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '洛',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '葄',
    definition: 'straw mat; straw cushion or pillow',
    pinyin: ['zuò'],
    decomposition: '⿱艹胙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '胙',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '葆',
    definition: 'dense foliage; to cover, to conceal; to preserve',
    pinyin: ['bǎo'],
    decomposition: '⿱艹保',
    etymology: {
      type: 'pictophonetic',
      phonetic: '保',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '葉',
    definition: 'leaf, page; surname',
    pinyin: ['yè'],
    decomposition: '⿱艹枼',
    etymology: {
      type: 'ideographic',
      hint: 'A flat 枼 leaf 艹; 枼 also provides the pronunciation',
    },
    radical: '艹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '葑',
    definition: 'the rape-turnip',
    pinyin: ['fēng'],
    decomposition: '⿱艹封',
    etymology: {
      type: 'pictophonetic',
      phonetic: '封',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '著',
    definition: 'to show, to prove, to make known',
    pinyin: ['zhe'],
    decomposition: '⿱艹者',
    etymology: {
      type: 'pictophonetic',
      phonetic: '者',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '葙',
    definition: 'feather cockscomb; Celosia argentea',
    pinyin: ['xiāng'],
    decomposition: '⿱艹相',
    etymology: {
      type: 'pictophonetic',
      phonetic: '相',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '葚',
    definition: 'mulberry fruit',
    pinyin: ['rèn'],
    decomposition: '⿱艹甚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甚',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '葛',
    definition: 'an edible bean; vine; surname',
    pinyin: ['gé'],
    decomposition: '⿱艹曷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曷',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '葜',
    definition: 'Smilax china',
    pinyin: ['qiā'],
    decomposition: '⿱艹契',
    etymology: {
      type: 'pictophonetic',
      phonetic: '契',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '葡',
    definition: 'grapes; Portugal, Portuguese',
    pinyin: ['pú'],
    decomposition: '⿱艹匍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匍',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '董',
    definition: 'to direct, to supervise; surname',
    pinyin: ['dǒng'],
    decomposition: '⿱艹重',
    etymology: {
      type: 'pictophonetic',
      phonetic: '重',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '葦',
    definition: 'reed',
    pinyin: ['wěi'],
    decomposition: '⿱艹韋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韋',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '葩',
    definition: 'petal, corolla; flower',
    pinyin: ['pā'],
    decomposition: '⿱艹皅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皅',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '葫',
    definition: 'bottle-gourd',
    pinyin: ['hú'],
    decomposition: '⿱艹胡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '胡',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '葬',
    definition: 'to bury, to inter',
    pinyin: ['zàng'],
    decomposition: '⿱艹⿱死廾',
    etymology: {
      type: 'ideographic',
      hint: 'A corpse 死 laid 廾 to rest under the grass 艹',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '葭',
    definition: 'bulrush, reed; flute, whistle',
    pinyin: ['jiā'],
    decomposition: '⿱艹叚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叚',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '葱',
    definition: 'scallions, leeks, green onions',
    pinyin: ['cōng'],
    decomposition: '⿱艹怱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '怱',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '葳',
    definition: 'flourishing; luxuriant',
    pinyin: ['wēi'],
    decomposition: '⿱艹威',
    etymology: {
      type: 'pictophonetic',
      phonetic: '威',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '葵',
    definition: 'sunflower; to measure',
    pinyin: ['kuí'],
    decomposition: '⿱艹癸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '癸',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '葶',
    definition: 'yellow whitlow-grass; Draba nemerosa',
    pinyin: ['tíng'],
    decomposition: '⿱艹亭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亭',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '葷',
    definition: 'non-vegetarian food; garlic; a foul smell',
    pinyin: ['hūn'],
    decomposition: '⿱艹軍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '軍',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '葸',
    definition: 'afraid, bashful, insecure',
    pinyin: ['xǐ'],
    decomposition: '⿱艹思',
    etymology: {
      type: 'pictophonetic',
      phonetic: '思',
      semantic: '心',
      hint: 'heart',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '葺',
    definition: 'thatch; to fix, to repair',
    pinyin: ['qì'],
    decomposition: '⿱艹咠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咠',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蒂',
    definition: 'root cause; the stem of a fruit; the peduncle of a flower',
    pinyin: ['dì'],
    decomposition: '⿱艹帝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '帝',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蒇',
    definition: 'to solve, to finish, to complete',
    pinyin: ['chǎn'],
    decomposition: '⿱艹⿵戊贝',
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 0],
      [1, 0],
      [1, 0],
    ],
  },
  {
    character: '蒈',
    definition: 'an organic compound',
    pinyin: ['kǎi'],
    decomposition: '⿱艹皆',
    etymology: { type: 'pictophonetic', phonetic: '皆', semantic: '艹' },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蒉',
    definition: 'edible amaranth; straw basket',
    pinyin: ['kuì'],
    decomposition: '⿱艹贵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贵',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蒋',
    definition: 'Hydropyrum latifalium; surname',
    pinyin: ['jiǎng'],
    decomposition: '⿱艹将',
    etymology: {
      type: 'pictophonetic',
      phonetic: '将',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蒌',
    definition: 'Artemisia stelleriana',
    pinyin: ['lóu'],
    decomposition: '⿱艹娄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '娄',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蒎',
    definition: 'pinane',
    pinyin: ['pài'],
    decomposition: '⿱艹派',
    etymology: { type: 'pictophonetic', phonetic: '派', semantic: '艹' },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蒓',
    definition: 'an edible water plant; Brasenia',
    pinyin: ['chún'],
    decomposition: '⿱艹純',
    etymology: {
      type: 'pictophonetic',
      phonetic: '純',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蒔',
    definition: 'to transplant, to grow; dill, Anethum graveolens',
    pinyin: ['shí'],
    decomposition: '⿱艹時',
    etymology: {
      type: 'pictophonetic',
      phonetic: '時',
      semantic: '艹',
      hint: 'herb',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蒗',
    definition: 'an herb; a place name',
    pinyin: ['làng'],
    decomposition: '⿱艹浪',
    etymology: {
      type: 'pictophonetic',
      phonetic: '浪',
      semantic: '艹',
      hint: 'herb',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蒙',
    definition: 'to cover; to deceive; Mongolia',
    pinyin: ['méng'],
    decomposition: '⿱艹冡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冡',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蒜',
    definition: 'garlic',
    pinyin: ['suàn'],
    decomposition: '⿱艹祘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '祘',
      semantic: '艹',
      hint: 'herb',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蒞',
    definition: 'attend, be present; arrive at',
    pinyin: ['lì'],
    decomposition: '⿱艹涖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '涖',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蒟',
    definition: 'betel pepper; Amorphophallus konjac',
    pinyin: ['jǔ'],
    decomposition: '⿱艹竘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '竘',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蒡',
    definition: 'great burdock; Arctium lappa',
    pinyin: ['bàng'],
    decomposition: '⿱艹旁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旁',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蒦',
    definition: 'to measure; to calculate',
    pinyin: ['huò'],
    decomposition: '⿱艹隻',
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蒭',
    definition: 'to mow, to cut grass; hay, fodder',
    pinyin: ['chú'],
    decomposition: '⿱艹芻',
    etymology: {
      type: 'ideographic',
      hint: 'To mow 芻 grass 艹; 芻 also provides the pronunciation',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蒯',
    definition: 'reed, rush; Scirpus cyperinus',
    pinyin: ['kuǎi'],
    decomposition: '⿰萠刂',
    etymology: {
      type: 'ideographic',
      hint: 'A shoot 萠 that is cut 刂 for building material',
    },
    radical: '艹',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '蒲',
    definition: 'vine, rush',
    pinyin: ['pú'],
    decomposition: '⿱艹浦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '浦',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蒴',
    definition: 'capsule, seed-pod',
    pinyin: ['shuò'],
    decomposition: '⿱艹朔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朔',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蒸',
    definition: 'steam, vapor; to evaporate',
    pinyin: ['zhēng'],
    decomposition: '⿱艹烝',
    etymology: {
      type: 'ideographic',
      hint: 'Steam 烝 provides the meaning and sound',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蒹',
    definition: 'common reed; Phragmites communis',
    pinyin: ['jiān'],
    decomposition: '⿱艹兼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兼',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蒺',
    definition: 'furze, gorse',
    pinyin: ['jí'],
    decomposition: '⿱艹疾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '疾',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蒻',
    definition: 'cattail; young rush',
    pinyin: ['ruò'],
    decomposition: '⿱艹弱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弱',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蒼',
    definition: 'dark blue; deep green; old, hoary',
    pinyin: ['cāng'],
    decomposition: '⿱艹倉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '倉',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蒽',
    definition: 'anthracene',
    pinyin: ['ēn'],
    decomposition: '⿱艹恩',
    etymology: { type: 'pictophonetic', phonetic: '恩', semantic: '艹' },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蒿',
    definition: 'mugwort, wormwood, Artemisia; to give off a scent',
    pinyin: ['hāo'],
    decomposition: '⿱艹高',
    etymology: {
      type: 'pictophonetic',
      phonetic: '高',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蓁',
    definition: 'abundant; luxuriant foliage',
    pinyin: ['zhēn'],
    decomposition: '⿱艹秦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '秦',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蓂',
    definition: 'a lucky place',
    pinyin: ['míng'],
    decomposition: '⿱艹冥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冥',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蓄',
    definition: 'to store, to save, to hoard, to gather',
    pinyin: ['xù'],
    decomposition: '⿱艹畜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畜',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蓉',
    definition: 'lotus, hibiscus; Chengdu, Sichuan',
    pinyin: ['róng'],
    decomposition: '⿱艹容',
    etymology: {
      type: 'pictophonetic',
      phonetic: '容',
      semantic: '艹',
      hint: 'flower',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蓊',
    definition: 'luxuriant foliage',
    pinyin: ['wěng'],
    decomposition: '⿱艹翁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '翁',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蓋',
    definition: 'to cover, to hide, to protect',
    pinyin: ['gài'],
    decomposition: '⿱艹盍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '盍',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蓍',
    definition: 'yarrow, milfoil; a plant used in divination',
    pinyin: ['shī'],
    decomposition: '⿱艹耆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '耆',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蓐',
    definition: 'straw mat; rushes, reeds',
    pinyin: ['rù'],
    decomposition: '⿱艹辱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辱',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蓑',
    definition: 'straw raincoat',
    pinyin: ['suō'],
    decomposition: '⿱艹衰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '衰',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蓓',
    definition: 'flower bud',
    pinyin: ['bèi'],
    decomposition: '⿱艹倍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '倍',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蓔',
    definition: 'a kind of grass',
    pinyin: ['yǎo'],
    decomposition: '⿱艹羔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羔',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蓖',
    definition: 'the castor-oil plant; Ricinus commumis',
    pinyin: ['bì'],
    decomposition: '⿳艹囟比',
    etymology: {
      type: 'pictophonetic',
      phonetic: '比',
      hint: 'plant',
      semantic: '艹',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [2], [2], [2], [2]],
  },
  {
    character: '蓝',
    definition: 'blue; indigo plant; surname',
    pinyin: ['lán'],
    decomposition: '⿱艹监',
    etymology: {
      type: 'pictophonetic',
      phonetic: '监',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蓟',
    definition: 'cirsium, thistle; surname',
    pinyin: ['jì'],
    decomposition: '⿱艹⿰鱼刂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鱼',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '蓠',
    definition: 'red algae; Gracilaria verrucosa',
    pinyin: ['lí'],
    decomposition: '⿱艹离',
    etymology: {
      type: 'pictophonetic',
      phonetic: '离',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蓣',
    definition: 'yam',
    pinyin: ['yù'],
    decomposition: '⿱艹预',
    etymology: {
      type: 'pictophonetic',
      phonetic: '预',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蓥',
    definition: 'to polish, to shine',
    pinyin: ['yíng'],
    decomposition: '⿳艹冖金',
    etymology: {
      type: 'ideographic',
      hint: 'To polish 艹 a metal 金 cover 冖',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [2], [2], [2], [2], [2], [2], [2], [2]],
  },
  {
    character: '蓦',
    definition: 'suddenly, quickly, abruptly',
    pinyin: ['mò'],
    decomposition: '⿱莫马',
    etymology: {
      type: 'pictophonetic',
      phonetic: '莫',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '蓬',
    definition: 'disheveled, unkempt; a type of raspberry',
    pinyin: ['péng'],
    decomposition: '⿱艹逢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '逢',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蓮',
    definition: 'lotus, water lily; paradise',
    pinyin: ['lián'],
    decomposition: '⿱艹連',
    etymology: {
      type: 'pictophonetic',
      phonetic: '連',
      semantic: '艹',
      hint: 'flower',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蓰',
    definition: 'to increase five-fold',
    pinyin: ['xǐ'],
    decomposition: '⿱艹徙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '徙',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蓴',
    definition: 'an edible water plant; Brasenia',
    pinyin: ['chún'],
    decomposition: '⿱艹專',
    etymology: {
      type: 'pictophonetic',
      phonetic: '專',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蓼',
    definition: 'knotweed, polygonum',
    pinyin: ['liǎo'],
    decomposition: '⿱艹翏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '翏',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蓽',
    definition: 'a kind of bean; Piper longtum',
    pinyin: ['bì'],
    decomposition: '⿱艹畢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畢',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蓿',
    definition: 'alfalfa, clover, lucerne',
    pinyin: ['xu'],
    decomposition: '⿱艹宿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宿',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蔌',
    definition: 'vegetables; surname',
    pinyin: ['sù'],
    decomposition: '⿱艹欶',
    etymology: {
      type: 'ideographic',
      hint: 'Plants 艹 that can be eaten 欶; 欶 also provides the pronunciation',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蔑',
    definition: 'to disdain, to disregard, to slight',
    pinyin: ['miè'],
    decomposition: '⿱艹⿱罒戍',
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '蔓',
    definition: 'vine, tendril, creeper',
    pinyin: ['màn'],
    decomposition: '⿱艹曼',
    etymology: {
      type: 'ideographic',
      hint: 'A long 曼 plant 艹 ; 曼 also provides the pronunciation',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蔔',
    definition: 'radish; root vegetables',
    pinyin: ['bó'],
    decomposition: '⿱艹匐',
    etymology: {
      type: 'ideographic',
      hint: 'Vegetables 艹 that are buried in the ground 匐; 匐 also provides the pronunciation',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蔗',
    definition: 'sugar cane',
    pinyin: ['zhè'],
    decomposition: '⿱艹庶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '庶',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蔚',
    definition: 'thick, luxuriant; resplendent, ornamental',
    pinyin: ['wèi'],
    decomposition: '⿱艹尉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尉',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蔟',
    definition: 'nest; silkworm frame; to collect',
    pinyin: ['cù'],
    decomposition: '⿱艹族',
    etymology: {
      type: 'pictophonetic',
      phonetic: '族',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蔡',
    definition: 'a species of tortoise; surname',
    pinyin: ['cài'],
    decomposition: '⿱艹祭',
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蔣',
    definition: 'Hydropyrum latifalium; surname',
    pinyin: ['jiǎng'],
    decomposition: '⿱艹將',
    etymology: {
      type: 'pictophonetic',
      phonetic: '將',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蔥',
    definition: 'scallions, leeks, green onions',
    pinyin: ['cōng'],
    decomposition: '⿱艹悤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '悤',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蔫',
    definition: 'withered, faded, decayed; calm',
    pinyin: ['niān'],
    decomposition: '⿱艹焉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '焉',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蔬',
    definition: 'vegetables, greens',
    pinyin: ['shū'],
    decomposition: '⿱艹疏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '疏',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蔭',
    definition: 'shade, shelter; to protect',
    pinyin: ['yīn'],
    decomposition: '⿱艹陰',
    etymology: {
      type: 'ideographic',
      hint: 'Shade 陰 provided by a tree 艹; 陰 also provides the pronunciation',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蔷',
    definition: 'rose',
    pinyin: ['qiáng'],
    decomposition: '⿱艹啬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '啬',
      semantic: '艹',
      hint: 'flower',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蔸',
    definition: 'measure word for plants',
    pinyin: ['dōu'],
    decomposition: '⿱艹兜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兜',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蔹',
    definition: 'wild vine; Vitis pentaphylla',
    pinyin: ['liǎn'],
    decomposition: '⿱艹敛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敛',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蔺',
    definition: 'hay, straw; surname',
    pinyin: ['lìn'],
    decomposition: '⿱艹⿵门隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '门',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '蔻',
    definition: 'nutmeg, cardamom',
    pinyin: ['kòu'],
    decomposition: '⿱艹寇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寇',
      semantic: '艹',
      hint: 'herb',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蔼',
    definition: 'lush; friendly, affable',
    pinyin: ['ǎi'],
    decomposition: '⿱艹谒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '谒',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蔽',
    definition: 'to cover, to hide, to shelter',
    pinyin: ['bì'],
    decomposition: '⿱艹敝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敝',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蕃',
    definition: 'abundant, flourishing; barbarians, foreigners',
    pinyin: ['fān'],
    decomposition: '⿱艹番',
    etymology: {
      type: 'pictophonetic',
      phonetic: '番',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蕈',
    definition: 'mushroom, fungus; mildew, mold',
    pinyin: ['xùn'],
    decomposition: '⿱艹覃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '覃',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蕉',
    definition: 'banana, plantain',
    pinyin: ['jiāo'],
    decomposition: '⿱艹焦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '焦',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蕊',
    definition: 'flower bud',
    pinyin: ['ruǐ'],
    decomposition: '⿱艹惢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '惢',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蕎',
    definition: 'buckwheat',
    pinyin: ['qiáo'],
    decomposition: '⿱艹喬',
    etymology: {
      type: 'ideographic',
      hint: 'A tall 喬 grass 艹; 喬 also provides the pronunciation',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蕑',
    definition: 'a climbing plant; Valeriana villosa',
    pinyin: ['jiān'],
    decomposition: '⿱艹閒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '閒',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蕒',
    definition: 'endive; sow-thistle',
    pinyin: ['mǎi'],
    decomposition: '⿱艹買',
    etymology: {
      type: 'pictophonetic',
      phonetic: '買',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蕓',
    definition: 'common rue; diverse, varied',
    pinyin: ['yún'],
    decomposition: '⿱艹雲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '雲',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蕕',
    definition: 'Caryopteris divaricata',
    pinyin: ['yóu'],
    decomposition: '⿱艹猶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '猶',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蕖',
    definition: 'lotus',
    pinyin: ['qú'],
    decomposition: '⿱艹渠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '渠',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蕘',
    definition: 'fuel, firewood; grass, shrub; Wikstroemia japonica',
    pinyin: ['ráo'],
    decomposition: '⿱艹堯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堯',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蕙',
    definition: 'a fragrant orchid; Coumarouna odorata',
    pinyin: ['huì'],
    decomposition: '⿱艹惠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '惠',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蕞',
    definition: 'small, petty; to assemble',
    pinyin: ['zuì'],
    decomposition: '⿱艹最',
    etymology: {
      type: 'pictophonetic',
      phonetic: '最',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蕠',
    definition: 'a plant with roots used for red dye; Rubia cordifolia',
    pinyin: ['rú'],
    decomposition: '⿱艹絮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '絮',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蕢',
    definition: 'edible amaranth; straw basket',
    pinyin: ['kuì'],
    decomposition: '⿱艹貴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '貴',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蕤',
    definition: 'soft, delicate; overgrowth, drooping leaves',
    pinyin: ['ruí'],
    decomposition: '⿱艹甤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甤',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蕨',
    definition: 'common bracken; Pteris aquilina',
    pinyin: ['jué'],
    decomposition: '⿱艹厥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厥',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蕩',
    definition: 'pond, pool; ripple, shake; to wash away, to wipe out',
    pinyin: ['dàng'],
    decomposition: '⿱艹湯',
    etymology: {
      type: 'ideographic',
      hint: 'Hot water 湯 wiping out plant life 艹; 湯 also provides the pronunciation',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蕪',
    definition: 'weeds; overgrowth',
    pinyin: ['wú'],
    decomposition: '⿱艹無',
    etymology: {
      type: 'pictophonetic',
      phonetic: '無',
      semantic: '艹',
      hint: 'weed',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蕭',
    definition: 'mournful, desolate; common Artemisa',
    pinyin: ['xiāo'],
    decomposition: '⿱艹肅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '艹',
      semantic: '肅',
      hint: 'solemn',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蕲',
    definition: 'to pray, to implore; herb; Artemesia',
    pinyin: ['qí'],
    decomposition: '⿱艹⿰单斤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斤',
      semantic: '艹',
      hint: 'herb',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '蕴',
    definition: 'to collect, to gather, to store; profound',
    pinyin: ['yùn'],
    decomposition: '⿱艹缊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '缊',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蕷',
    definition: 'yam',
    pinyin: ['yù'],
    decomposition: '⿱艹預',
    etymology: {
      type: 'pictophonetic',
      phonetic: '預',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蕹',
    definition: 'an edible water plant; Ipomoea aquatica',
    pinyin: ['wèng'],
    decomposition: '⿱艹雍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '雍',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蕺',
    definition: 'Houttuynia cordata',
    pinyin: ['jí'],
    decomposition: '⿱艹戢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戢',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蕻',
    definition: 'budding, flourishing',
    pinyin: ['hóng'],
    decomposition: '⿱艹⿰镸共',
    etymology: {
      type: 'pictophonetic',
      phonetic: '共',
      hint: 'grass',
      semantic: '艹',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '蕾',
    definition: 'flower bud',
    pinyin: ['lěi'],
    decomposition: '⿱艹雷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '雷',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '薄',
    definition: 'thin, slight; meager, weak; poor, stingy',
    pinyin: ['báo'],
    decomposition: '⿱艹溥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '溥',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '薅',
    definition: 'to weed; to eradicate',
    pinyin: ['hāo'],
    decomposition: '⿱艹媷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '媷',
      semantic: '艹',
      hint: 'weed',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '薇',
    definition: 'a kind of fern; Osmunda regalis',
    pinyin: ['wēi'],
    decomposition: '⿱艹微',
    etymology: {
      type: 'pictophonetic',
      phonetic: '微',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '薈',
    definition: 'abundant, flourishing',
    pinyin: ['huì'],
    decomposition: '⿱艹會',
    etymology: {
      type: 'pictophonetic',
      phonetic: '會',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '薊',
    definition: 'cirsium, thistle; surname',
    pinyin: ['jì'],
    decomposition: '⿱艹魝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '魝',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '薌',
    definition: 'fragrant, aromatic; the smell of herbs',
    pinyin: ['xiāng'],
    decomposition: '⿱艹鄉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鄉',
      semantic: '艹',
      hint: 'herb',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '薏',
    definition: "lotus seed; the seed of the Job's tear plant",
    pinyin: ['yì'],
    decomposition: '⿱艹意',
    etymology: {
      type: 'pictophonetic',
      phonetic: '意',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '薑',
    definition: 'ginger',
    pinyin: ['jiāng'],
    decomposition: '⿱艹畺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畺',
      semantic: '艹',
      hint: 'herb',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '薔',
    definition: 'rose',
    pinyin: ['qiáng'],
    decomposition: '⿱艹嗇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '嗇',
      semantic: '艹',
      hint: 'flower',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '薛',
    definition: 'wormwood, marsh grass; a feudal state',
    pinyin: ['xuē'],
    decomposition: '⿱艹⿰⿱丿㠯辛',
    etymology: { type: 'ideographic', hint: 'A kind of bitter 辛 grass 艹' },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1, 0, 0],
      [1, 0, 1],
      [1, 0, 1],
      [1, 0, 1],
      [1, 0, 1],
      [1, 0, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '薜',
    definition: 'evergreen shrub; Ligusticum',
    pinyin: ['bì'],
    decomposition: '⿱艹辟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辟',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '薤',
    definition: 'shallots, scallions; Allium bakeri',
    pinyin: ['xiè'],
    decomposition: '⿱艹⿰歹非',
    etymology: {
      type: 'pictophonetic',
      phonetic: '非',
      hint: 'grass',
      semantic: '艹',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '薦',
    definition: 'to recommend; to recur, to repeat',
    pinyin: ['jiàn'],
    decomposition: '⿱艹廌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '廌',
      semantic: '艹',
      hint: 'perennial grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '薨',
    definition: 'the death of a prince; to swarm',
    pinyin: ['hōng'],
    decomposition: '⿱艹⿱罒⿱冖死',
    etymology: {
      type: 'pictophonetic',
      phonetic: '罒',
      semantic: '死',
      hint: 'death',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
    ],
  },
  {
    character: '薩',
    definition: 'Buddhist diety; used in transliterations',
    pinyin: ['sà'],
    decomposition: '⿱艹隡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隡',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '薪',
    definition: 'fuel, firewood; salary',
    pinyin: ['xīn'],
    decomposition: '⿱艹新',
    etymology: {
      type: 'ideographic',
      hint: 'Freshly-cut 新 wood 艹; 新 also provides the pronunciation',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '薮',
    definition: 'swamp, marsh; wild country',
    pinyin: ['sǒu'],
    decomposition: '⿱艹数',
    etymology: {
      type: 'pictophonetic',
      phonetic: '数',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '薯',
    definition: 'yam, tuber, potato',
    pinyin: ['shǔ'],
    decomposition: '⿱艹署',
    etymology: {
      type: 'pictophonetic',
      phonetic: '署',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '薰',
    definition: 'a medicinal herb; to cauterize',
    pinyin: ['xūn'],
    decomposition: '⿱艹熏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '熏',
      semantic: '艹',
      hint: 'herb',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '薳',
    definition: 'milkwort, snakeroot; a medicinal herb',
    pinyin: ['tuǒ'],
    decomposition: '⿱艹遠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '遠',
      semantic: '艹',
      hint: 'herb',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '薶',
    definition: 'sto bury; to dirty, to soil',
    pinyin: ['mái'],
    decomposition: '⿱艹貍',
    etymology: {
      type: 'ideographic',
      hint: 'A fox 貍 burying something in the grass 艹',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '薷',
    definition: 'Elshotria paltrini',
    pinyin: ['rú'],
    decomposition: '⿱艹需',
    etymology: {
      type: 'pictophonetic',
      phonetic: '需',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '薹',
    definition: 'sedge, grass; Cyperus rotundus',
    pinyin: ['tái'],
    decomposition: '⿱艹臺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臺',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '薺',
    definition: 'water chestnut; water caltrop',
    pinyin: ['jì'],
    decomposition: '⿱艹齊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '齊',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '藁',
    definition: 'straw, hay; withered, dry',
    pinyin: ['gǎo'],
    decomposition: '⿱艹槀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '槀',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '藇',
    definition: 'fine, beautiful; surname',
    pinyin: ['xù'],
    decomposition: '⿱艹與',
    etymology: {
      type: 'pictophonetic',
      phonetic: '與',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '藉',
    definition: 'by means of; excuse, pretext; to rely on',
    pinyin: ['jí'],
    decomposition: '⿱艹耤',
    etymology: {
      type: 'ideographic',
      hint: 'A plow 耤 is the means used to grow crops 艹',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '藍',
    definition: 'blue; indigo plant; surname',
    pinyin: ['lán'],
    decomposition: '⿱艹監',
    etymology: {
      type: 'pictophonetic',
      phonetic: '監',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '藏',
    definition: 'to conceal, to hide; to hoard, to store',
    pinyin: ['cáng'],
    decomposition: '⿱艹臧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臧',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '藐',
    definition: 'to despise, to disdain; to disregard, to slight',
    pinyin: ['miǎo'],
    decomposition: '⿱艹貌',
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '藒',
    definition: 'an aromatic herb',
    pinyin: ['qiè'],
    decomposition: '⿱艹⿰禾曷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '禾',
      hint: 'herb',
      semantic: '艹',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '藓',
    definition: 'lichen, moss',
    pinyin: ['xiǎn'],
    decomposition: '⿱艹鲜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鲜',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '藕',
    definition: 'lotus root',
    pinyin: ['ǒu'],
    decomposition: '⿱艹耦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '耦',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '藘',
    definition: 'madder; Rubia',
    pinyin: ['lǘ'],
    decomposition: '⿱艹慮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '慮',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '藜',
    definition: 'pigweed; Chenopodium album',
    pinyin: ['lí'],
    decomposition: '⿱艹黎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '黎',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '藝',
    definition: 'art; talent, ability; craft',
    pinyin: ['yì'],
    decomposition: '⿱艹⿱埶云',
    etymology: {
      type: 'pictophonetic',
      phonetic: '埶',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '藤',
    definition: 'ivy, creeper',
    pinyin: ['téng'],
    decomposition: '⿱艹滕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '滕',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '藥',
    definition: 'drugs, medicine; the leaf of the Dahurian angelica plant',
    pinyin: ['yào'],
    decomposition: '⿱艹樂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '樂',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '藨',
    definition: 'a kind of raspberry',
    pinyin: ['biāo'],
    decomposition: '⿱艹麃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '麃',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '藩',
    definition: 'boundary, fence, outlying border',
    pinyin: ['fān'],
    decomposition: '⿱艹潘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '潘',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '藪',
    definition: 'swamp, marsh; wild country',
    pinyin: ['sǒu'],
    decomposition: '⿱艹數',
    etymology: {
      type: 'pictophonetic',
      phonetic: '數',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '藭',
    definition: 'Sichuan lovage rhizome',
    pinyin: ['qióng'],
    decomposition: '⿱艹窮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '窮',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '藹',
    definition: 'lush; friendly, affable',
    pinyin: ['ǎi'],
    decomposition: '⿱艹謁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '謁',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '藺',
    definition: 'hay, straw; surname',
    pinyin: ['lìn'],
    decomposition: '⿱艹閵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '閵',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '藻',
    definition: 'splendid, magnificent; algae',
    pinyin: ['zǎo'],
    decomposition: '⿱艹澡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '澡',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '藿',
    definition: "betony, bishop's wort; lophanthus rugosus",
    pinyin: ['huò'],
    decomposition: '⿱艹霍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '霍',
      semantic: '艹',
      hint: 'herb',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蘄',
    definition: 'to pray, to implore; herb; Artemesia',
    pinyin: ['qí'],
    decomposition: '⿱艹⿰單斤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斤',
      semantic: '艹',
      hint: 'herb',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '蘅',
    definition: 'wild ginger; Asarum blumei',
    pinyin: ['héng'],
    decomposition: '⿱艹衡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '衡',
      semantic: '艹',
      hint: 'herb',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蘆',
    definition: 'rushes, reeds',
    pinyin: ['lú'],
    decomposition: '⿱艹盧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '盧',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蘇',
    definition: 'to awaken, to revive, to resurrect; used in transliterations',
    pinyin: ['sū'],
    decomposition: '⿱艹穌',
    etymology: {
      type: 'ideographic',
      hint: 'A perennial 穌 grass 艹; 穌 also provides the pronunciation',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蘊',
    definition: 'to collect, to gather, to store; profound',
    pinyin: ['yùn'],
    decomposition: '⿱艹縕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '縕',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蘋',
    definition: 'apple; duckweed, Artemisia',
    pinyin: ['píng'],
    decomposition: '⿱艹頻',
    etymology: {
      type: 'pictophonetic',
      phonetic: '頻',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蘑',
    definition: 'mushroom',
    pinyin: ['mó'],
    decomposition: '⿱艹磨',
    etymology: {
      type: 'pictophonetic',
      phonetic: '磨',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蘖',
    definition: 'stump, sprout',
    pinyin: ['niè'],
    decomposition: '⿱薛木',
    etymology: {
      type: 'pictophonetic',
      phonetic: '薛',
      semantic: '木',
      hint: 'tree',
    },
    radical: '木',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蘘',
    definition: 'wild ginger',
    pinyin: ['ráng'],
    decomposition: '⿱艹襄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '襄',
      semantic: '艹',
      hint: 'herb',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蘚',
    definition: 'lichen, moss',
    pinyin: ['xiǎn'],
    decomposition: '⿱艹鮮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鮮',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蘞',
    definition: 'wild vine; Vitis pentaphylla',
    pinyin: ['liǎn'],
    decomposition: '⿱艹斂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斂',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蘢',
    definition: 'tall grass; water-weeds',
    pinyin: ['lóng'],
    decomposition: '⿱艹龍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龍',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蘧',
    definition: 'Dianthus superbus; surname',
    pinyin: ['qú'],
    decomposition: '⿱艹遽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '遽',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蘩',
    definition: 'Artemisia stellariana',
    pinyin: ['fán'],
    decomposition: '⿱艹繁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '繁',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蘭',
    definition: 'orchid; elegant, graceful',
    pinyin: ['lán'],
    decomposition: '⿱艹闌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '闌',
      semantic: '艹',
      hint: 'flower',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蘵',
    definition: 'Physalis angulata',
    pinyin: ['zhī'],
    decomposition: '⿱艹職',
    etymology: {
      type: 'pictophonetic',
      phonetic: '職',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蘸',
    definition: 'to dip (in ink, sauce, etc); to remarry',
    pinyin: ['zhàn'],
    decomposition: '⿱艹醮',
    etymology: {
      type: 'ideographic',
      hint: 'To perform a rite 醮 again (like a perennial 艹)',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蘺',
    definition: 'red algae; Gracilaria verrucosa',
    pinyin: ['lí'],
    decomposition: '⿱艹離',
    etymology: {
      type: 'pictophonetic',
      phonetic: '離',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蘼',
    definition: 'millet',
    pinyin: ['mí'],
    decomposition: '⿱艹靡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '靡',
      semantic: '艹',
      hint: 'grass',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蘿',
    definition: 'carrot, radish, turnip',
    pinyin: ['luó'],
    decomposition: '⿱艹羅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羅',
      semantic: '艹',
      hint: 'plant',
    },
    radical: '艹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '虍',
    definition: 'tiger',
    pinyin: ['hū'],
    decomposition: '⿸？七',
    radical: '虍',
    matches: [null, null, null, null, [1], [1]],
  },
  {
    character: '虎',
    definition: 'tiger; brave, fierce; surname',
    pinyin: ['hǔ'],
    decomposition: '⿸虍几',
    etymology: {
      type: 'ideographic',
      hint: 'A tiger 虍 standing on a rock 几; 虍 also provides the pronunciation',
    },
    radical: '虎',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '虏',
    definition: 'prisoner; to capture, to imprison, to sieze',
    pinyin: ['lǔ'],
    decomposition: '⿸虍力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '虍',
      semantic: '力',
      hint: 'strength',
    },
    radical: '虍',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '虐',
    definition: 'cruel, harsh, oppressive',
    pinyin: ['nüè'],
    decomposition: '⿸虍彐',
    etymology: { type: 'ideographic', hint: 'A tiger 虍 baring its claws 彐' },
    radical: '虍',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '虑',
    definition: 'anxious, concerned, worried',
    pinyin: ['lǜ'],
    decomposition: '⿸虍心',
    etymology: {
      type: 'ideographic',
      hint: 'A tiger 虍 striking fear into the heart 心',
    },
    radical: '心',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '虒',
    definition:
      'an amphibious beast resembling a tiger with one horn; place name',
    pinyin: ['sī'],
    decomposition: '⿸厂虎',
    etymology: { type: 'ideographic', hint: 'A tiger 虎 with one horn 厂' },
    radical: '虎',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '虔',
    definition: 'reverent, devout',
    pinyin: ['qián'],
    decomposition: '⿸虍文',
    radical: '虍',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '處',
    definition: 'to reside at, to live in; place, locale; department',
    pinyin: ['chù'],
    decomposition: '⿸虍処',
    etymology: {
      type: 'pictophonetic',
      phonetic: '虍',
      semantic: '処',
      hint: 'place',
    },
    radical: '虍',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '虖',
    definition: 'to cry, to howl, to roar',
    pinyin: ['hū'],
    decomposition: '⿸虍乎',
    etymology: {
      type: 'ideographic',
      hint: "A tiger's 虍 roar 乎; 乎 also provides the pronunciation",
    },
    radical: '虍',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '虘',
    definition: 'stripes, spots, blotches',
    pinyin: ['cuó'],
    decomposition: '⿸虍且',
    etymology: {
      type: 'pictophonetic',
      phonetic: '且',
      semantic: '虍',
      hint: 'tiger',
    },
    radical: '虍',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '虚',
    definition: 'false; worthless, hollow, empty; vain',
    pinyin: ['xū'],
    decomposition: '⿸虍业',
    etymology: {
      type: 'ideographic',
      hint: 'A tiger 虍 stalking in the bushes 业',
    },
    radical: '虍',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '虛',
    definition: 'false; worthless, hollow, empty; vain',
    pinyin: ['xū'],
    decomposition: '⿸虍⿱丱一',
    etymology: {
      type: 'ideographic',
      hint: 'A tiger 虍 stalking in the bushes 丱',
    },
    radical: '虍',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
    ],
  },
  {
    character: '虜',
    definition: 'prisoner; to capture, to imprison, to sieze',
    pinyin: ['lǔ'],
    decomposition: '⿸虍男',
    etymology: {
      type: 'pictophonetic',
      phonetic: '虍',
      semantic: '男',
      hint: 'strength',
    },
    radical: '虍',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '虞',
    definition: 'anxious, concerned, worried',
    pinyin: ['yú'],
    decomposition: '⿸虍吴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吴',
      semantic: '虍',
      hint: 'tiger',
    },
    radical: '虍',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '號',
    definition: 'mark, sign; symbol; number; to call, to cry, to roar',
    pinyin: ['hào'],
    decomposition: '⿰号虎',
    etymology: {
      type: 'ideographic',
      hint: 'The roar 口 of the tiger 虎; 丂 provides the pronunciation',
    },
    radical: '虎',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '虢',
    definition: 'an ancient feudal State in Shenxi and Hunan',
    pinyin: ['guó'],
    decomposition: '⿰寽虎',
    radical: '虎',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '虧',
    definition: 'to lose, to fail; loss, damages; deficient',
    pinyin: ['kuī'],
    decomposition: '⿰雐亏',
    etymology: {
      type: 'ideographic',
      hint: 'A tiger 虍 mauling a bird 隹; 亏 also provides the pronunciation',
    },
    radical: '虍',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '虫',
    definition: 'insect, worm; mollusk',
    pinyin: ['chóng'],
    decomposition: '⿱中？',
    etymology: { type: 'pictophonetic', phonetic: '中' },
    radical: '虫',
    matches: [[0], [0], [0], [0], null, null],
  },
  {
    character: '虬',
    definition: 'young dragon',
    pinyin: ['qiú'],
    decomposition: '⿰虫乚',
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1]],
  },
  {
    character: '虮',
    definition: 'nits, lice',
    pinyin: ['jǐ'],
    decomposition: '⿰虫几',
    etymology: {
      type: 'pictophonetic',
      phonetic: '几',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '虰',
    definition: 'dragonfly',
    pinyin: ['dīng'],
    decomposition: '⿰虫丁',
    etymology: {
      type: 'ideographic',
      hint: 'An adult male 丁 insect 虫; 丁 also provides the pronunciation',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '虱',
    definition: 'bug, louse, parasite',
    pinyin: ['shī'],
    decomposition: '⿹乙⿱？虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乙',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], null, [1, 1], [1, 1], [1, 1], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '虹',
    definition: 'rainbow',
    pinyin: ['hóng'],
    decomposition: '⿰虫工',
    etymology: {
      type: 'pictophonetic',
      phonetic: '工',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '虺',
    definition: 'a large venomous snake',
    pinyin: ['huī'],
    decomposition: '⿺兀虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兀',
      semantic: '虫',
      hint: 'worm',
    },
    radical: '虫',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '虻',
    definition: 'horsefly, gadfly',
    pinyin: ['méng'],
    decomposition: '⿰虫亡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亡',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '虼',
    definition: 'flea',
    pinyin: ['gè'],
    decomposition: '⿰虫乞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乞',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '虽',
    definition: 'although, even though',
    pinyin: ['suī'],
    decomposition: '⿱口虫',
    radical: '虫',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '虾',
    definition: 'shrimp, prawn',
    pinyin: ['xiā'],
    decomposition: '⿰虫下',
    etymology: {
      type: 'pictophonetic',
      phonetic: '下',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '虿',
    definition: 'scorpion',
    pinyin: ['chài'],
    decomposition: '⿱万虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '万',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蚀',
    definition: 'to nibble at, to erode; an eclipse',
    pinyin: ['shí'],
    decomposition: '⿰饣虫',
    etymology: {
      type: 'ideographic',
      hint: 'An insect 虫 bite 饣; 饣 also provides the pronunciation',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蚁',
    definition: 'ant',
    pinyin: ['yǐ'],
    decomposition: '⿰虫义',
    etymology: {
      type: 'pictophonetic',
      phonetic: '义',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '蚂',
    definition: 'ant; leech',
    pinyin: ['mǎ'],
    decomposition: '⿰虫马',
    etymology: {
      type: 'pictophonetic',
      phonetic: '马',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '蚊',
    definition: 'mosquito, gnat',
    pinyin: ['wén'],
    decomposition: '⿰虫文',
    etymology: {
      type: 'pictophonetic',
      phonetic: '文',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '蚋',
    definition: 'mosquito, gnat',
    pinyin: ['ruì'],
    decomposition: '⿰虫内',
    etymology: {
      type: 'pictophonetic',
      phonetic: '内',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '蚌',
    definition: 'oysters, mussels; mother-of-pearl',
    pinyin: ['bàng'],
    decomposition: '⿰虫丰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丰',
      semantic: '虫',
      hint: 'mollusk',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '蚍',
    definition: 'mussels, shellfish',
    pinyin: ['pí'],
    decomposition: '⿰虫比',
    etymology: {
      type: 'pictophonetic',
      phonetic: '比',
      semantic: '虫',
      hint: 'mollusk',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '蚓',
    definition: 'earthworm',
    pinyin: ['yǐn'],
    decomposition: '⿰虫引',
    etymology: {
      type: 'pictophonetic',
      phonetic: '引',
      semantic: '虫',
      hint: 'worm',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '蚕',
    definition: 'silkworm',
    pinyin: ['cán'],
    decomposition: '⿱天虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '天',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蚖',
    definition: 'salamander, newt',
    pinyin: ['yuán'],
    decomposition: '⿰虫元',
    etymology: {
      type: 'pictophonetic',
      phonetic: '元',
      semantic: '虫',
      hint: 'worm',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '蚜',
    definition: 'aphid, plant louse',
    pinyin: ['yá'],
    decomposition: '⿰虫牙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '牙',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '蚝',
    definition: 'a poisonous hairy caterpillar',
    pinyin: ['háo'],
    decomposition: '⿰虫毛',
    etymology: {
      type: 'ideographic',
      hint: 'A hairy 毛 worm 虫; 毛 also provides the pronunciation',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '蚣',
    definition: 'centipede',
    pinyin: ['gōng'],
    decomposition: '⿰虫公',
    etymology: {
      type: 'pictophonetic',
      phonetic: '公',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '蚤',
    definition: 'flea; louse',
    pinyin: ['zǎo'],
    decomposition: '⿱叉虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叉',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蚧',
    definition: 'horny toad; red-spotted lizard',
    pinyin: ['jiè'],
    decomposition: '⿰虫介',
    etymology: {
      type: 'pictophonetic',
      phonetic: '介',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '蚨',
    definition: 'a kind of water beetle; cash, dollars, money',
    pinyin: ['fú'],
    decomposition: '⿰虫夫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夫',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '蚩',
    definition: 'worm; ignorant, rustic; to laugh at',
    pinyin: ['chī'],
    decomposition: '⿱⿱屮一虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屮',
      semantic: '虫',
      hint: 'worm',
    },
    radical: '虫',
    matches: [[0, 0], [0, 0], [0, 0], [0, 1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蚪',
    definition: 'tadpole',
    pinyin: ['dǒu'],
    decomposition: '⿰虫斗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斗',
      semantic: '虫',
      hint: 'worm',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '蚬',
    definition: 'clam, bivalve; Cyclina orientalis',
    pinyin: ['xiǎn'],
    decomposition: '⿰虫见',
    etymology: {
      type: 'pictophonetic',
      phonetic: '见',
      semantic: '虫',
      hint: 'mollusk',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '蚯',
    definition: 'earthworm',
    pinyin: ['qiū'],
    decomposition: '⿰虫丘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丘',
      semantic: '虫',
      hint: 'worm',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '蚰',
    definition: 'millipede',
    pinyin: ['yóu'],
    decomposition: '⿰虫由',
    etymology: {
      type: 'pictophonetic',
      phonetic: '由',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '蚱',
    definition: 'grasshopper; locust, cicada',
    pinyin: ['zhà'],
    decomposition: '⿰虫乍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乍',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '蚴',
    definition: 'larva',
    pinyin: ['yòu'],
    decomposition: '⿰虫幼',
    etymology: {
      type: 'ideographic',
      hint: 'An immature 幼 insect 虫; 幼 also provides the pronunciation',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '蚵',
    definition: 'oyster',
    pinyin: ['hé'],
    decomposition: '⿰虫可',
    etymology: {
      type: 'pictophonetic',
      phonetic: '可',
      semantic: '虫',
      hint: 'mollusk',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '蚶',
    definition: 'clam, bivalve; Arca inflata',
    pinyin: ['hān'],
    decomposition: '⿰虫甘',
    etymology: {
      type: 'ideographic',
      hint: 'A sweet 甘 mollusk 虫; 甘 also provides the pronunciation',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '蚺',
    definition: 'boa constrictor',
    pinyin: ['rán'],
    decomposition: '⿰虫冉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冉',
      semantic: '虫',
      hint: 'worm',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛀',
    definition: 'termite, bookworm; to bore, to eat into',
    pinyin: ['zhù'],
    decomposition: '⿰虫主',
    etymology: {
      type: 'pictophonetic',
      phonetic: '主',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛄',
    definition: 'mole cricket',
    pinyin: ['gū'],
    decomposition: '⿰虫古',
    etymology: {
      type: 'pictophonetic',
      phonetic: '古',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛆',
    definition: 'maggot',
    pinyin: ['qū'],
    decomposition: '⿰虫且',
    etymology: {
      type: 'pictophonetic',
      phonetic: '且',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛇',
    definition: 'snake',
    pinyin: ['shé'],
    decomposition: '⿰虫它',
    etymology: {
      type: 'pictophonetic',
      phonetic: '它',
      semantic: '虫',
      hint: 'worm',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛉',
    definition: 'dragonfly, sandfly; Libellulidae',
    pinyin: ['líng'],
    decomposition: '⿰虫令',
    etymology: {
      type: 'pictophonetic',
      phonetic: '令',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛊',
    definition: 'poison, venom; to bewitch, to harm',
    pinyin: ['gǔ'],
    decomposition: '⿱虫皿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皿',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛋',
    definition: 'egg',
    pinyin: ['dàn'],
    decomposition: '⿱疋虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '延',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛎',
    definition: 'oyster',
    pinyin: ['lì'],
    decomposition: '⿰虫厉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厉',
      semantic: '虫',
      hint: 'mollusk',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛏',
    definition: 'razor clam',
    pinyin: ['chēng'],
    decomposition: '⿰虫圣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '圣',
      semantic: '虫',
      hint: 'mollusk',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛐',
    definition: 'cricket; worm',
    pinyin: ['qū'],
    decomposition: '⿰虫曲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曲',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛑',
    definition: 'a marine crab',
    pinyin: ['móu'],
    decomposition: '⿰虫牟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '牟',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛔',
    definition: 'tapeworm',
    pinyin: ['huí'],
    decomposition: '⿰虫回',
    etymology: {
      type: 'pictophonetic',
      phonetic: '回',
      semantic: '虫',
      hint: 'worm',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛘',
    definition: 'rice weevil',
    pinyin: ['yáng'],
    decomposition: '⿰虫羊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羊',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛙',
    definition: 'frog',
    pinyin: ['wā'],
    decomposition: '⿰虫圭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '圭',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛛',
    definition: 'spider',
    pinyin: ['zhū'],
    decomposition: '⿰虫朱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朱',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛜',
    definition: 'woodlouse',
    pinyin: ['yī'],
    decomposition: '⿰虫伊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '伊',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛞',
    definition: 'snail, slug; mole cricket',
    pinyin: ['kuò'],
    decomposition: '⿰虫舌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '舌',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛟',
    definition: 'a legendary scaled dragon',
    pinyin: ['jiāo'],
    decomposition: '⿰虫交',
    etymology: {
      type: 'pictophonetic',
      phonetic: '交',
      semantic: '虫',
      hint: 'worm',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛤',
    definition: 'clam',
    pinyin: ['há'],
    decomposition: '⿰虫合',
    etymology: {
      type: 'pictophonetic',
      phonetic: '合',
      semantic: '虫',
      hint: 'mollusk',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛩',
    definition: 'cricket, locust; anxious',
    pinyin: ['qióng'],
    decomposition: '⿱巩虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巩',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛭',
    definition: 'leech',
    pinyin: ['zhì'],
    decomposition: '⿰虫至',
    etymology: {
      type: 'pictophonetic',
      phonetic: '至',
      semantic: '虫',
      hint: 'worm',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛮',
    definition: 'barbarians; barbarous, rude, savage',
    pinyin: ['mán'],
    decomposition: '⿱亦虫',
    etymology: { type: 'ideographic', hint: 'Like 亦 insects 虫' },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛰',
    definition: 'to hibernate',
    pinyin: ['zhé'],
    decomposition: '⿱执虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '执',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛱',
    definition: 'butterfly, nymphalid',
    pinyin: ['jiá'],
    decomposition: '⿰虫夹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夹',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛲',
    definition: 'parasitic worm; human pinworm',
    pinyin: ['náo'],
    decomposition: '⿰虫尧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尧',
      semantic: '虫',
      hint: 'worm',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛳',
    definition: 'a snail with a spiral shell',
    pinyin: ['sī'],
    decomposition: '⿰虫师',
    etymology: {
      type: 'pictophonetic',
      phonetic: '师',
      semantic: '虫',
      hint: 'mollusk',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛴',
    definition: 'grubs, maggots',
    pinyin: ['qí'],
    decomposition: '⿰虫齐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '齐',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛵',
    definition: 'dragonfly',
    pinyin: ['xīng'],
    decomposition: '⿰虫巠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巠',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛸',
    definition: 'octopus; long-legged spider; mantis nest',
    pinyin: ['shāo'],
    decomposition: '⿰虫肖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肖',
      semantic: '虫',
      hint: 'mollusk',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛹',
    definition: 'pupa, chrysalis',
    pinyin: ['yǒng'],
    decomposition: '⿰虫甬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甬',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛺',
    definition: 'butterfly, nymphalid',
    pinyin: ['jiá'],
    decomposition: '⿰虫夾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夾',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛻',
    definition: 'to molt',
    pinyin: ['tuì'],
    decomposition: '⿰虫兌',
    etymology: {
      type: 'ideographic',
      hint: 'An insect 虫 changing 兌 its skin; 兌 also provides the pronunciation',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蛾',
    definition: 'moth',
    pinyin: ['é'],
    decomposition: '⿰虫我',
    etymology: {
      type: 'pictophonetic',
      phonetic: '我',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蜀',
    definition: 'the name of an ancient state',
    pinyin: ['shǔ'],
    decomposition: '⿱罒⿹勹虫',
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '蜂',
    definition: 'bee, wasp, hornet',
    pinyin: ['fēng'],
    decomposition: '⿰虫夆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夆',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蜃',
    definition: 'clam; sea serpent',
    pinyin: ['shèn'],
    decomposition: '⿸辰虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辰',
      semantic: '虫',
      hint: 'mollusk',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蜇',
    definition: 'jellyfish',
    pinyin: ['zhē'],
    decomposition: '⿱折虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '折',
      semantic: '虫',
      hint: 'mollusk',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蜈',
    definition: 'centipede',
    pinyin: ['wú'],
    decomposition: '⿰虫吴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吴',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蜉',
    definition: 'wasp; mayfly; large ant',
    pinyin: ['fú'],
    decomposition: '⿰虫孚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孚',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蜊',
    definition: 'clam',
    pinyin: ['lí'],
    decomposition: '⿰虫利',
    etymology: {
      type: 'pictophonetic',
      phonetic: '利',
      semantic: '虫',
      hint: 'mollusk',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蜍',
    definition: 'toad',
    pinyin: ['chú'],
    decomposition: '⿰虫余',
    etymology: {
      type: 'pictophonetic',
      phonetic: '余',
      semantic: '虫',
      hint: 'mollusk',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蜎',
    definition: 'mosquito larva',
    pinyin: ['yuān'],
    decomposition: '⿰虫肙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肙',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蜒',
    definition: 'millipede',
    pinyin: ['yán'],
    decomposition: '⿰虫延',
    etymology: {
      type: 'pictophonetic',
      phonetic: '延',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蜓',
    definition: 'dragonfly',
    pinyin: ['tíng'],
    decomposition: '⿰虫廷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '廷',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蜕',
    definition: 'to molt',
    pinyin: ['tuì'],
    decomposition: '⿰虫兑',
    etymology: {
      type: 'ideographic',
      hint: 'An insect 虫 changing 兑 its skin; 兑 also provides the pronunciation',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蜗',
    definition: 'snail; Eulota callizoma',
    pinyin: ['wō'],
    decomposition: '⿰虫呙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '呙',
      semantic: '虫',
      hint: 'mollusk',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蜘',
    definition: 'spider',
    pinyin: ['zhī'],
    decomposition: '⿰虫知',
    etymology: {
      type: 'pictophonetic',
      phonetic: '知',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蜚',
    definition: 'cockroach',
    pinyin: ['fēi'],
    decomposition: '⿱非虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '非',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蜜',
    definition: 'honey, nectar; sweet',
    pinyin: ['mì'],
    decomposition: '⿱宓虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宓',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蜞',
    definition: 'lightfoot crab; worm, leech',
    pinyin: ['qí'],
    decomposition: '⿰虫其',
    etymology: {
      type: 'pictophonetic',
      phonetic: '其',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蜡',
    definition: 'candle, wax; maggot',
    pinyin: ['là'],
    decomposition: '⿰虫昔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昔',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蜢',
    definition: 'grasshopper',
    pinyin: ['měng'],
    decomposition: '⿰虫孟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孟',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蜣',
    definition: 'dung beetle',
    pinyin: ['qiāng'],
    decomposition: '⿰虫羌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羌',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '蜥',
    definition: 'lizard',
    pinyin: ['xī'],
    decomposition: '⿰虫析',
    etymology: {
      type: 'pictophonetic',
      phonetic: '析',
      semantic: '虫',
      hint: 'worm',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蜩',
    definition: 'cicada, broad locust',
    pinyin: ['tiáo'],
    decomposition: '⿰虫周',
    etymology: {
      type: 'pictophonetic',
      phonetic: '周',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蜮',
    definition: 'toad; legendary turtle',
    pinyin: ['yù'],
    decomposition: '⿰虫或',
    etymology: {
      type: 'pictophonetic',
      phonetic: '或',
      semantic: '虫',
      hint: 'worm',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蜱',
    definition: 'tick, mite',
    pinyin: ['pí'],
    decomposition: '⿰虫卑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卑',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蜴',
    definition: 'lizard',
    pinyin: ['yì'],
    decomposition: '⿰虫易',
    etymology: {
      type: 'pictophonetic',
      phonetic: '易',
      semantic: '虫',
      hint: 'worm',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蜷',
    definition: "to curl one's body; to wriggle like a worm",
    pinyin: ['quán'],
    decomposition: '⿰虫卷',
    etymology: {
      type: 'ideographic',
      hint: 'To curl up 卷 like a worm 虫; 卷 also provides the pronunciation',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蜻',
    definition: 'dragonfly',
    pinyin: ['qīng'],
    decomposition: '⿰虫青',
    etymology: {
      type: 'pictophonetic',
      phonetic: '青',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蜾',
    definition: 'solitary wasp; potter wasp',
    pinyin: ['guǒ'],
    decomposition: '⿰虫果',
    etymology: {
      type: 'pictophonetic',
      phonetic: '果',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蜿',
    definition: 'to creep, to crawl',
    pinyin: ['wān'],
    decomposition: '⿰虫宛',
    etymology: {
      type: 'ideographic',
      hint: 'Crooked 宛 like an insect 虫; 宛 also provides the pronunciation',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蝇',
    definition: 'fly, musca',
    pinyin: ['yíng'],
    decomposition: '⿰虫黾',
    etymology: {
      type: 'ideographic',
      hint: 'Insects 虫 that toads 黾 feed on',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蝈',
    definition: 'cicada, grasshopper; small green frog',
    pinyin: ['guō'],
    decomposition: '⿰虫国',
    etymology: {
      type: 'pictophonetic',
      phonetic: '国',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蝉',
    definition: 'cicada; continuous',
    pinyin: ['chán'],
    decomposition: '⿰虫单',
    etymology: {
      type: 'pictophonetic',
      phonetic: '单',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蝌',
    definition: 'tadpole',
    pinyin: ['kē'],
    decomposition: '⿰虫科',
    etymology: {
      type: 'pictophonetic',
      phonetic: '科',
      semantic: '虫',
      hint: 'worm',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蝎',
    definition: 'scorpion',
    pinyin: ['xiē'],
    decomposition: '⿰虫曷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曷',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蝓',
    definition: 'snail',
    pinyin: ['yú'],
    decomposition: '⿰虫俞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '俞',
      semantic: '虫',
      hint: 'mollusk',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蝕',
    definition: 'to nibble at, to erode; an eclipse',
    pinyin: ['shí'],
    decomposition: '⿰飠虫',
    etymology: {
      type: 'ideographic',
      hint: 'An insect 虫 bite 飠; 飠 also provides the pronunciation',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蝗',
    definition: 'locust',
    pinyin: ['huáng'],
    decomposition: '⿰虫皇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皇',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蝙',
    definition: 'bat',
    pinyin: ['biān'],
    decomposition: '⿰虫扁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '扁',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蝠',
    definition: 'bat',
    pinyin: ['fú'],
    decomposition: '⿰虫畐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畐',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蝣',
    definition: 'mayfly; Ephemera strigata',
    pinyin: ['yóu'],
    decomposition: '⿰虫斿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斿',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蝤',
    definition: 'grub, larva',
    pinyin: ['qiú'],
    decomposition: '⿰虫酋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '酋',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蝥',
    definition: 'Spanish fly; grain-eating grub',
    pinyin: ['máo'],
    decomposition: '⿱敄虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敄',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蝮',
    definition: 'viper, venomous snake',
    pinyin: ['fù'],
    decomposition: '⿰虫复',
    etymology: {
      type: 'pictophonetic',
      phonetic: '复',
      semantic: '虫',
      hint: 'worm',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蝰',
    definition: 'forest viper; meadow viper',
    pinyin: ['kuí'],
    decomposition: '⿰虫奎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奎',
      semantic: '虫',
      hint: 'worm',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蝴',
    definition: 'butterfly',
    pinyin: ['hú'],
    decomposition: '⿰虫胡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '胡',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蝶',
    definition: 'butterfly',
    pinyin: ['dié'],
    decomposition: '⿰虫枼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '枼',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蝻',
    definition: 'immature locust',
    pinyin: ['nǎn'],
    decomposition: '⿰虫南',
    etymology: {
      type: 'pictophonetic',
      phonetic: '南',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蝼',
    definition: 'mole cricket; Gryllotalpa africana',
    pinyin: ['lóu'],
    decomposition: '⿰虫娄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '娄',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蝽',
    definition: 'bedbug',
    pinyin: ['chūn'],
    decomposition: '⿰虫春',
    etymology: {
      type: 'pictophonetic',
      phonetic: '春',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蝾',
    definition: 'lizard',
    pinyin: ['róng'],
    decomposition: '⿰虫荣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '荣',
      semantic: '虫',
      hint: 'worm',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '螂',
    definition: 'mantis, dung beetle',
    pinyin: ['láng'],
    decomposition: '⿰虫郎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '郎',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '螃',
    definition: 'crab',
    pinyin: ['páng'],
    decomposition: '⿰虫旁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旁',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '螄',
    definition: 'a snail with a spiral shell',
    pinyin: ['sī'],
    decomposition: '⿰虫師',
    etymology: {
      type: 'pictophonetic',
      phonetic: '師',
      semantic: '虫',
      hint: 'mollusk',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '螅',
    definition: 'intestinal worm',
    pinyin: ['xī'],
    decomposition: '⿰虫息',
    etymology: {
      type: 'pictophonetic',
      phonetic: '息',
      semantic: '虫',
      hint: 'worm',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '螈',
    definition: 'silkworm',
    pinyin: ['yuán'],
    decomposition: '⿰虫原',
    etymology: {
      type: 'pictophonetic',
      phonetic: '原',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '螉',
    definition: 'wasp',
    pinyin: ['wēng'],
    decomposition: '⿰虫翁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '翁',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '螋',
    definition: 'earwig, millipede, spider',
    pinyin: ['sōu'],
    decomposition: '⿰虫叟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叟',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '融',
    definition: 'to melt, to fuse; to blend, to harmonize',
    pinyin: ['róng'],
    decomposition: '⿰鬲虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '虫',
      semantic: '鬲',
      hint: 'cauldron',
    },
    radical: '鬲',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '螓',
    definition: 'a small cicada with a square head',
    pinyin: ['qín'],
    decomposition: '⿰虫秦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '秦',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '螗',
    definition: 'a kind of cicada',
    pinyin: ['táng'],
    decomposition: '⿰虫唐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '唐',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '螞',
    definition: 'ant; leech',
    pinyin: ['mǎ'],
    decomposition: '⿰虫馬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '馬',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '螟',
    definition: 'caterpillar, larva',
    pinyin: ['míng'],
    decomposition: '⿰虫冥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冥',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '螢',
    definition: 'firefly, glow-worm',
    pinyin: ['yíng'],
    decomposition: '⿳⿰火火冖虫',
    etymology: { type: 'ideographic', hint: 'A glowing 火 insect 虫' },
    radical: '虫',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '螨',
    definition: 'mite, insect',
    pinyin: ['mǎn'],
    decomposition: '⿰虫⿱艹两',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㒼',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '螫',
    definition: 'poison, sting; poisonous insect',
    pinyin: ['shì'],
    decomposition: '⿱赦虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '赦',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '螬',
    definition: 'grubs found in fruit',
    pinyin: ['cáo'],
    decomposition: '⿰虫曹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曹',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '螭',
    definition: 'cruel; a young dragon',
    pinyin: ['chī'],
    decomposition: '⿰虫离',
    etymology: {
      type: 'pictophonetic',
      phonetic: '离',
      semantic: '虫',
      hint: 'worm',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '螮',
    definition: 'rainbow',
    pinyin: ['dì'],
    decomposition: '⿰虫帶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '帶',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '螯',
    definition: 'claws, pincers',
    pinyin: ['áo'],
    decomposition: '⿱敖虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敖',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '螳',
    definition: 'praying mantis',
    pinyin: ['táng'],
    decomposition: '⿰虫堂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堂',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '螵',
    definition: 'chrysalis',
    pinyin: ['piāo'],
    decomposition: '⿰虫票',
    etymology: {
      type: 'pictophonetic',
      phonetic: '票',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '螺',
    definition: 'spiral shell, conch; spiral',
    pinyin: ['luó'],
    decomposition: '⿰虫累',
    etymology: {
      type: 'pictophonetic',
      phonetic: '累',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '螻',
    definition: 'mole cricket; Gryllotalpa africana',
    pinyin: ['lóu'],
    decomposition: '⿰虫婁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '婁',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '螽',
    definition: 'katydid',
    pinyin: ['zhōng'],
    decomposition: '⿱冬⿰虫虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冬',
      hint: 'insect',
      semantic: '虫',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '蟀',
    definition: 'cricket',
    pinyin: ['shuài'],
    decomposition: '⿰虫率',
    etymology: {
      type: 'pictophonetic',
      phonetic: '率',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蟄',
    definition: 'to hibernate',
    pinyin: ['zhé'],
    decomposition: '⿱執虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '執',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蟆',
    definition: 'frog, toad',
    pinyin: ['má'],
    decomposition: '⿰虫莫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '莫',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蟈',
    definition: 'cicada, grasshopper; small green frog',
    pinyin: ['guō'],
    decomposition: '⿰虫國',
    etymology: {
      type: 'pictophonetic',
      phonetic: '國',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蟊',
    definition: 'Spanish fly; grain-eating grub',
    pinyin: ['máo'],
    decomposition: '⿱矛⿰虫虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '矛',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '蟋',
    definition: 'cricket',
    pinyin: ['xī'],
    decomposition: '⿰虫悉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '悉',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蟎',
    definition: 'mite, insect',
    pinyin: ['mǎn'],
    decomposition: '⿰虫㒼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㒼',
      hint: 'insect',
      semantic: '虫',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蟏',
    definition: 'a long-legged spider',
    pinyin: ['xiāo'],
    decomposition: '⿰虫萧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '萧',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蟑',
    definition: 'cockroach',
    pinyin: ['zhāng'],
    decomposition: '⿰虫章',
    etymology: {
      type: 'pictophonetic',
      phonetic: '章',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蟒',
    definition: 'python, boa constrictor',
    pinyin: ['mǎng'],
    decomposition: '⿰虫莽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '莽',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蟓',
    definition: 'silkworm',
    pinyin: ['xiàng'],
    decomposition: '⿰虫象',
    etymology: {
      type: 'pictophonetic',
      phonetic: '象',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蟛',
    definition: 'land-crab; Grapsus',
    pinyin: ['péng'],
    decomposition: '⿰虫彭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彭',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蟜',
    definition: 'insect',
    pinyin: ['jiǎo'],
    decomposition: '⿰虫喬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '喬',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蟟',
    definition: 'cicada',
    pinyin: ['liáo'],
    decomposition: '⿰虫尞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尞',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蟠',
    definition: 'to occupy; to coil; curled up, coiled',
    pinyin: ['pán'],
    decomposition: '⿰虫番',
    etymology: {
      type: 'pictophonetic',
      phonetic: '番',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蟢',
    definition: 'spider; caulking',
    pinyin: ['xǐ'],
    decomposition: '⿰虫喜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '喜',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蟣',
    definition: 'nits, lice',
    pinyin: ['jǐ'],
    decomposition: '⿰虫幾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '幾',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蟥',
    definition: 'leech',
    pinyin: ['huáng'],
    decomposition: '⿰虫黄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '黄',
      semantic: '虫',
      hint: 'worm',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蟪',
    definition: 'a kind of cicada; Platypleura',
    pinyin: ['huì'],
    decomposition: '⿰虫惠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '惠',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蟬',
    definition: 'cicada; continuous',
    pinyin: ['chán'],
    decomposition: '⿰虫單',
    etymology: {
      type: 'pictophonetic',
      phonetic: '單',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蟭',
    definition: 'mite, larva; mantis egg',
    pinyin: ['jiāo'],
    decomposition: '⿰虫焦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '焦',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蟮',
    definition: 'earthworm',
    pinyin: ['shàn'],
    decomposition: '⿰虫善',
    etymology: {
      type: 'pictophonetic',
      phonetic: '善',
      semantic: '虫',
      hint: 'worm',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蟯',
    definition: 'parasitic worm; human pinworm',
    pinyin: ['náo'],
    decomposition: '⿰虫堯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堯',
      semantic: '虫',
      hint: 'worm',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蟲',
    definition: 'lower animals, such as insects, worms, mollusks; low-life',
    pinyin: ['chóng'],
    decomposition: '⿱虫⿰虫虫',
    etymology: { type: 'ideographic', hint: 'The class of insects 虫' },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '蟹',
    definition: 'crab, brachyura',
    pinyin: ['xiè'],
    decomposition: '⿱解虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '解',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蟻',
    definition: 'ant',
    pinyin: ['yǐ'],
    decomposition: '⿰虫義',
    etymology: {
      type: 'pictophonetic',
      phonetic: '義',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蟾',
    definition: 'toad',
    pinyin: ['chán'],
    decomposition: '⿰虫詹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '詹',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蠃',
    definition: 'solitary wasp; paper wasp',
    pinyin: ['luǒ'],
    decomposition: '⿱吂⿲⺼虫⺼',
    etymology: {
      type: 'ideographic',
      hint: 'A wasp 虫 building a nest in dead 吂 flesh ⺼',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 2],
      [1, 2],
      [1, 2],
    ],
  },
  {
    character: '蠅',
    definition: 'fly, musca',
    pinyin: ['yíng'],
    decomposition: '⿰虫黽',
    etymology: {
      type: 'ideographic',
      hint: 'Insects 虫 that toads 黽 feed on',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蠊',
    definition: 'cockroach',
    pinyin: ['lián'],
    decomposition: '⿰虫廉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '廉',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蠑',
    definition: 'lizard',
    pinyin: ['róng'],
    decomposition: '⿰虫榮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '榮',
      semantic: '虫',
      hint: 'worm',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蠓',
    definition: 'midge, sandfly',
    pinyin: ['měng'],
    decomposition: '⿰虫蒙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蒙',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蠔',
    definition: 'oyster',
    pinyin: ['háo'],
    decomposition: '⿰虫豪',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豪',
      semantic: '虫',
      hint: 'mollusk',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蠕',
    definition: 'wasp; to wriggle, to squirm',
    pinyin: ['rú'],
    decomposition: '⿰虫需',
    etymology: {
      type: 'pictophonetic',
      phonetic: '需',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蠖',
    definition: 'inch-worm; looper caterpiller',
    pinyin: ['huò'],
    decomposition: '⿰虫蒦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蒦',
      semantic: '虫',
      hint: 'worm',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蠛',
    definition: 'small fly',
    pinyin: ['miè'],
    decomposition: '⿰虫蔑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蔑',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蠟',
    definition: 'candle, wax; maggot',
    pinyin: ['là'],
    decomposition: '⿰虫巤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巤',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蠡',
    definition: 'termite; to bore',
    pinyin: ['lí'],
    decomposition: '⿱彖⿰虫虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彖',
      hint: 'insect',
      semantic: '虫',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '蠢',
    definition: 'to wriggle; stupid, silly, fat',
    pinyin: ['chǔn'],
    decomposition: '⿱春⿰虫虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '春',
      semantic: '虫',
      hint: 'worm',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '蠣',
    definition: 'oyster',
    pinyin: ['lì'],
    decomposition: '⿰虫厲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厲',
      semantic: '虫',
      hint: 'mollusk',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蠨',
    definition: 'a long-legged spider',
    pinyin: ['xiāo'],
    decomposition: '⿰虫蕭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蕭',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蠮',
    definition: 'bee',
    pinyin: ['yē'],
    decomposition: '⿰虫翳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '翳',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蠱',
    definition: 'poison, venom; to bewitch, to harm',
    pinyin: ['gǔ'],
    decomposition: '⿱蟲皿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皿',
      semantic: '蟲',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蠲',
    definition: 'millipede; glow-worm; bright, clear',
    pinyin: ['juān'],
    decomposition: '⿰益蜀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蜀',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蠵',
    definition: 'large turtle',
    pinyin: ['xī'],
    decomposition: '⿰虫巂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巂',
      semantic: '虫',
      hint: 'worm',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蠶',
    definition: 'silkworm',
    pinyin: ['cán'],
    decomposition: '⿱兓⿱日⿰虫虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兓',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
    ],
  },
  {
    character: '蠹',
    definition: 'moth, bookworm; moth-eaten, worm-eaten',
    pinyin: ['dù'],
    decomposition: '⿱橐⿰虫虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '橐',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '蠻',
    definition: 'barbarians; barbarous, rude, savage',
    pinyin: ['mán'],
    decomposition: '⿱䜌虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '䜌',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蠼',
    definition: 'earwig',
    pinyin: ['qú'],
    decomposition: '⿰虫矍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '矍',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '虫',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '血',
    definition: 'blood',
    pinyin: ['xuè'],
    decomposition: '⿱丿皿',
    etymology: {
      type: 'ideographic',
      hint: 'A chalice 皿 filled with blood 丿',
    },
    radical: '血',
    matches: [[0], [1], [1], [1], [1], [1]],
  },
  {
    character: '衄',
    definition: 'a bloody nose; to be defeated',
    pinyin: ['nǜ'],
    decomposition: '⿰血丑',
    etymology: {
      type: 'ideographic',
      hint: 'To be shamed 丑 by a bloody 血 nose',
    },
    radical: '血',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '衅',
    definition: 'to quarrel, to dispute; a blood sacrifice',
    pinyin: ['xìn'],
    decomposition: '⿰血半',
    etymology: {
      type: 'pictophonetic',
      phonetic: '半',
      semantic: '血',
      hint: 'blood',
    },
    radical: '血',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '衆',
    definition: 'multitude, crowd; the public',
    pinyin: ['zhòng'],
    decomposition: '⿱血乑',
    etymology: { type: 'pictophonetic', semantic: '乑', hint: 'side-by-side' },
    radical: '血',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '衊',
    definition: 'to smear, to slander; to defile',
    pinyin: ['miè'],
    decomposition: '⿰血蔑',
    etymology: {
      type: 'ideographic',
      hint: 'To slight 蔑 with smeared blood 血; 蔑 also provides the pronunciation',
    },
    radical: '血',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '行',
    definition: 'to go, to walk, to move; professional',
    pinyin: ['xíng'],
    decomposition: '⿰彳亍',
    etymology: {
      type: 'ideographic',
      hint: "To take small steps 亍 with one's feet 彳",
    },
    radical: '行',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '衍',
    definition: 'to overflow; to spread out',
    pinyin: ['yǎn'],
    decomposition: '⿻行氵',
    etymology: {
      type: 'ideographic',
      hint: 'Water 氵 going in all directions 行',
    },
    radical: '行',
    matches: [[0], [0], [0], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '術',
    definition: 'skill, art; method, technique; trick',
    pinyin: ['shù'],
    decomposition: '⿻行术',
    etymology: {
      type: 'ideographic',
      hint: 'Professional 行 skills 术; 术 also provides the pronunciation',
    },
    radical: '行',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '衔',
    definition: 'rank, title; to bite, to hold in the mouth',
    pinyin: ['xián'],
    decomposition: '⿻行钅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '行',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '彳',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '衕',
    definition: 'same, similar; together with, alike',
    pinyin: ['tóng'],
    decomposition: '⿻行同',
    etymology: {
      type: 'ideographic',
      hint: 'To walk 行 with 同 someone; 同 also provides the pronunciation',
    },
    radical: '行',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '衖',
    definition: 'alley, lane',
    pinyin: ['xiàng'],
    decomposition: '⿻行共',
    etymology: {
      type: 'pictophonetic',
      phonetic: '共',
      semantic: '行',
      hint: 'step',
    },
    radical: '行',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '街',
    definition: 'street, road, thoroughfare',
    pinyin: ['jiē'],
    decomposition: '⿻行圭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '圭',
      semantic: '行',
      hint: 'walk',
    },
    radical: '行',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '衙',
    definition: 'public office; official residence',
    pinyin: ['yá'],
    decomposition: '⿻行吾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吾',
      semantic: '行',
      hint: 'go',
    },
    radical: '行',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '衚',
    definition: 'recklessly, foolishly; wildly',
    pinyin: ['hú'],
    decomposition: '⿻行胡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '胡',
      semantic: '行',
      hint: 'walk',
    },
    radical: '行',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '衛',
    definition: 'to guard, to protect, to defend',
    pinyin: ['wèi'],
    decomposition: '⿻行韋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韋',
      semantic: '行',
      hint: 'step',
    },
    radical: '行',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '衝',
    definition: 'wash, rinse, flush; dash; soar',
    pinyin: ['chōng'],
    decomposition: '⿴行重',
    etymology: {
      type: 'pictophonetic',
      phonetic: '重',
      semantic: '行',
      hint: 'go',
    },
    radical: '行',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '衡',
    definition: 'to measure, to weigh; to consider, to judge',
    pinyin: ['héng'],
    decomposition: '⿻行⿱角大',
    etymology: {
      type: 'ideographic',
      hint: 'A big 大 horn 角; 行 provides the pronunciation',
    },
    radical: '行',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '衢',
    definition: 'highway; thoroughfare, intersection',
    pinyin: ['qú'],
    decomposition: '⿻行瞿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '瞿',
      semantic: '行',
      hint: 'step',
    },
    radical: '行',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '衣',
    definition: 'cloth; clothes, apparel; dress, coat',
    pinyin: ['yī'],
    decomposition: '⿱亠？',
    etymology: { type: 'pictographic', hint: "A woman's dress" },
    radical: '衣',
    matches: [[0], [0], null, null, null, null],
  },
  {
    character: '衤',
    definition: 'cloth',
    pinyin: ['yī'],
    decomposition: '？',
    radical: '衤',
    matches: [null, null, null, null, null],
  },
  {
    character: '补',
    definition: 'to fix, to mend, to patch, to restore',
    pinyin: ['bǔ'],
    decomposition: '⿰衤卜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卜',
      semantic: '衤',
      hint: 'cloth',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '表',
    definition: 'to show, to express, to display; outside, appearance; a watch',
    pinyin: ['biǎo'],
    decomposition: '⿱毛衣',
    etymology: {
      type: 'ideographic',
      hint: 'Fur 毛 clothing 衣; a shawl or wrap',
    },
    radical: '衣',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '衩',
    definition: 'shorts, panties; a slit in a robe',
    pinyin: ['chǎ'],
    decomposition: '⿰衤叉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叉',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '衫',
    definition: 'shirt, robe, jacket, gown',
    pinyin: ['shān'],
    decomposition: '⿰衤彡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彡',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '衬',
    definition: 'underwear, lining; in contrast',
    pinyin: ['chèn'],
    decomposition: '⿰衤寸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寸',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '衮',
    definition: 'imperial robe; ceremonial dress',
    pinyin: ['gǔn'],
    decomposition: '⿻衣公',
    etymology: { type: 'ideographic', hint: 'A duke 公 in his robes 衣' },
    radical: '衣',
    matches: [[0], [0], [1], [1], [1], [1], [0], [0], [0], [0]],
  },
  {
    character: '衰',
    definition: 'weak, feeble; to decline, to falter',
    pinyin: ['shuāi'],
    decomposition: '⿻衣⿻口一',
    etymology: {
      type: 'ideographic',
      hint: 'A person in a robe 衣 with an injury 一 to his head 口',
    },
    radical: '衣',
    matches: [[0], [0], [1, 0], [1, 0], [1, 1], [1, 0], [0], [0], [0], [0]],
  },
  {
    character: '衲',
    definition: 'to sew, to mend; quilt; patch; cassock',
    pinyin: ['nà'],
    decomposition: '⿰衤内',
    etymology: {
      type: 'pictophonetic',
      phonetic: '内',
      semantic: '衤',
      hint: 'cloth',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '衷',
    definition: 'sincere, heartfelt',
    pinyin: ['zhōng'],
    decomposition: '⿻衣中',
    etymology: {
      type: 'ideographic',
      hint: 'A person in a robe 衣 with his heart 中 marked; 中 also provides the pronunciation',
    },
    radical: '衣',
    matches: [[0], [0], [1], [1], [1], [1], [0], [0], [0], [0]],
  },
  {
    character: '衹',
    definition: 'only, merely, just',
    pinyin: ['zhǐ'],
    decomposition: '⿰衤氏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '氏',
      semantic: '衤',
      hint: 'cloth',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '衽',
    definition: 'collar, lapel',
    pinyin: ['rèn'],
    decomposition: '⿰衤壬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '壬',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '衾',
    definition: 'quilt, coverlet',
    pinyin: ['qīn'],
    decomposition: '⿱今衣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '今',
      semantic: '衣',
      hint: 'cloth',
    },
    radical: '衣',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '衿',
    definition: 'collar, lapel',
    pinyin: ['jīn'],
    decomposition: '⿰衤今',
    etymology: {
      type: 'pictophonetic',
      phonetic: '今',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '袁',
    definition: 'robe; surname',
    pinyin: ['yuán'],
    decomposition: '⿻衣口',
    etymology: { type: 'ideographic', hint: 'A person 口 wearing a robe 衣' },
    radical: '衣',
    matches: [[0], [0], [0], [1], [1], [1], [0], [0], [0], [0]],
  },
  {
    character: '袂',
    definition: 'sleeves',
    pinyin: ['mèi'],
    decomposition: '⿰衤夬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夬',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '袄',
    definition: 'coat, jacket, outerware',
    pinyin: ['ǎo'],
    decomposition: '⿰衤夭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夭',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '袅',
    definition: 'curling upwards; elegant, graceful',
    pinyin: ['niǎo'],
    decomposition: '⿱鸟衣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鸟',
      semantic: '衣',
      hint: 'cloth',
    },
    radical: '衣',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '袈',
    definition: 'Buddhist cassock',
    pinyin: ['jiā'],
    decomposition: '⿱加衣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '加',
      semantic: '衣',
      hint: 'clothes',
    },
    radical: '衣',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '袋',
    definition: 'bag, sack; pocket, pouch',
    pinyin: ['dài'],
    decomposition: '⿱代衣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '代',
      semantic: '衣',
      hint: 'clothes',
    },
    radical: '衣',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '袍',
    definition: 'robe, gown, cloak',
    pinyin: ['páo'],
    decomposition: '⿰衤包',
    etymology: {
      type: 'ideographic',
      hint: 'A cloth 衤 wrap 包; 包 also provides the pronunciation',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '袒',
    definition: 'to strip, to bare',
    pinyin: ['tǎn'],
    decomposition: '⿰衤旦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旦',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '袖',
    definition: 'sleeve',
    pinyin: ['xiù'],
    decomposition: '⿰衤由',
    etymology: {
      type: 'pictophonetic',
      phonetic: '由',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '袜',
    definition: 'socks, stockings',
    pinyin: ['wà'],
    decomposition: '⿰衤末',
    etymology: {
      type: 'pictophonetic',
      phonetic: '末',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '袞',
    definition: 'imperial robe; ceremonial dress',
    pinyin: ['gǔn'],
    decomposition: '⿻衣⿱八口',
    etymology: {
      type: 'ideographic',
      hint: 'The emperor 口 in 八 his robes 衣',
    },
    radical: '衣',
    matches: [
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [0],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '袟',
    definition: 'bag, satchel; book cover',
    pinyin: ['zhì'],
    decomposition: '⿰衤失',
    etymology: {
      type: 'pictophonetic',
      phonetic: '失',
      semantic: '衤',
      hint: 'cloth',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '袢',
    definition: 'robe',
    pinyin: ['pàn'],
    decomposition: '⿰衤半',
    etymology: {
      type: 'pictophonetic',
      phonetic: '半',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '袤',
    definition: 'longitude; lengthwise; length',
    pinyin: ['mào'],
    decomposition: '⿻衣矛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '矛',
      semantic: '衣',
      hint: 'cloth',
    },
    radical: '衣',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '被',
    definition: 'bedding; a passive particle meaning "by"',
    pinyin: ['bèi'],
    decomposition: '⿰衤皮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皮',
      semantic: '衤',
      hint: 'cloth',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '袭',
    definition: 'to attack, to raid; to inherit',
    pinyin: ['xí'],
    decomposition: '⿱龙衣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '衣',
      semantic: '龙',
      hint: 'dragon',
    },
    radical: '龙',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '袮',
    definition: 'thee, thou; "you" when referring to a diety',
    pinyin: ['ni'],
    decomposition: '⿰衤尔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '衤',
      semantic: '尔',
      hint: 'you',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '袯',
    definition: 'raincoat',
    pinyin: ['bó'],
    decomposition: '⿰衤发',
    etymology: {
      type: 'pictophonetic',
      phonetic: '发',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '袱',
    definition: 'apants; trousers; panties',
    pinyin: ['fú'],
    decomposition: '⿰衤伏',
    etymology: {
      type: 'ideographic',
      hint: 'Something wrapped 伏 in cloth 衤; 伏 also provides the pronunciation',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '袴',
    definition: 'pants, trousers; panties',
    pinyin: ['kù'],
    decomposition: '⿰衤夸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夸',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '袷',
    definition: 'lined garment',
    pinyin: ['jiá'],
    decomposition: '⿰衤合',
    etymology: {
      type: 'pictophonetic',
      phonetic: '合',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '袼',
    definition: 'gusset, cloth fitting-sleeve',
    pinyin: ['gē'],
    decomposition: '⿰衤各',
    etymology: {
      type: 'pictophonetic',
      phonetic: '各',
      semantic: '衤',
      hint: 'cloth',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '裁',
    definition: 'to trim, to reduce, to cut; judgment',
    pinyin: ['cái'],
    decomposition: '⿹⿱十戈衣',
    etymology: { type: 'ideographic', hint: 'To cut 戈 cloth 衣' },
    radical: '衣',
    matches: [
      [0, 0],
      [0, 0],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0, 1],
      [0, 1],
      [0, 1],
    ],
  },
  {
    character: '裂',
    definition: 'to split, to rend; crevice, crack',
    pinyin: ['liè'],
    decomposition: '⿱列衣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '列',
      semantic: '衣',
      hint: 'cloth',
    },
    radical: '衣',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '装',
    definition: 'dress, clothes, attire; to wear, to install',
    pinyin: ['zhuāng'],
    decomposition: '⿱壮衣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '壮',
      semantic: '衣',
      hint: 'clothes',
    },
    radical: '衣',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '裆',
    definition: 'the crotch or seat of a pair of pants',
    pinyin: ['dāng'],
    decomposition: '⿰衤当',
    etymology: {
      type: 'pictophonetic',
      phonetic: '当',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '裇',
    definition: 'shirt',
    pinyin: ['xū'],
    decomposition: '⿰衤血',
    etymology: {
      type: 'pictophonetic',
      phonetic: '血',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '裉',
    definition: 'a garment seam',
    pinyin: ['kèn'],
    decomposition: '⿰衤艮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '艮',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '裊',
    definition: 'curling upwards; elegant, graceful',
    pinyin: ['niǎo'],
    decomposition: '⿱鳥衣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鳥',
      semantic: '衣',
      hint: 'cloth',
    },
    radical: '衣',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '裎',
    definition: 'to take off clothes; to bare oneself',
    pinyin: ['chéng'],
    decomposition: '⿰衤呈',
    etymology: {
      type: 'ideographic',
      hint: 'Take take off clothes 衤; to show 呈 oneself',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '裏',
    definition: 'inside, interior, within',
    pinyin: ['lǐ'],
    decomposition: '⿻衣里',
    etymology: {
      type: 'pictophonetic',
      phonetic: '里',
      semantic: '衣',
      hint: 'clothes',
    },
    radical: '衣',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0], [0]],
  },
  {
    character: '裒',
    definition: 'to gather, to collect, to assemble; to praise',
    pinyin: ['póu'],
    decomposition: '⿻衣臼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臼',
      semantic: '衣',
      hint: 'cloth',
    },
    radical: '衣',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '裔',
    definition: 'progeny, descendants',
    pinyin: ['yì'],
    decomposition: '⿱衣冏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '衣',
      semantic: '冏',
      hint: 'bright',
    },
    radical: '衣',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '裕',
    definition: 'rich, plentiful, abundant',
    pinyin: ['yù'],
    decomposition: '⿰衤谷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '谷',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '裘',
    definition: 'fur coat; surname',
    pinyin: ['qiú'],
    decomposition: '⿱求衣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '求',
      semantic: '衣',
      hint: 'clothes',
    },
    radical: '衣',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '裙',
    definition: 'skirt, petticoat, apron',
    pinyin: ['qún'],
    decomposition: '⿰衤君',
    etymology: {
      type: 'pictophonetic',
      phonetic: '君',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '補',
    definition: 'to fix, to mend, to patch, to restore',
    pinyin: ['bǔ'],
    decomposition: '⿰衤甫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甫',
      semantic: '衤',
      hint: 'cloth',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '裝',
    definition: 'dress, clothes, attire; to wear, to install',
    pinyin: ['zhuāng'],
    decomposition: '⿱壯衣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '壯',
      semantic: '衣',
      hint: 'clothes',
    },
    radical: '衣',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '裟',
    definition: "cassock; monk's robe",
    pinyin: ['shā'],
    decomposition: '⿱沙衣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '沙',
      semantic: '衣',
      hint: 'cloth',
    },
    radical: '衣',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '裡',
    definition: 'unit of distance equal to 0.5km; village; lane',
    pinyin: ['lǐ'],
    decomposition: '⿰衤里',
    etymology: {
      type: 'ideographic',
      hint: 'Unit of measure for farm 田 land 土; 衤 provides the pronunciation',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '裢',
    definition: "a folding purse kept in one's belt",
    pinyin: ['lián'],
    decomposition: '⿰衤连',
    etymology: {
      type: 'pictophonetic',
      phonetic: '连',
      semantic: '衤',
      hint: 'cloth',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '裣',
    definition: "draw one's hands into sleeve",
    pinyin: ['liǎn'],
    decomposition: '⿰衤佥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '佥',
      semantic: '衤',
      hint: 'cloth',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '裤',
    definition: 'pants, trousers',
    pinyin: ['kù'],
    decomposition: '⿰衤库',
    etymology: {
      type: 'pictophonetic',
      phonetic: '库',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '裥',
    definition: 'pleats, folds',
    pinyin: ['jiǎn'],
    decomposition: '⿰衤间',
    etymology: {
      type: 'pictophonetic',
      phonetic: '间',
      semantic: '衤',
      hint: 'cloth',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '裨',
    definition: 'to aid, to benefit, to help, to supplement',
    pinyin: ['bì'],
    decomposition: '⿰衤卑',
    etymology: {
      type: 'pictographic',
      hint: 'Clothing 衤 for the poor 卑; 卑 also provides the pronunciation',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '裰',
    definition: 'to mend clothes',
    pinyin: ['duō'],
    decomposition: '⿰衤叕',
    etymology: {
      type: 'ideographic',
      hint: 'To patch up 叕 clothing 衤; 叕 also provides the pronunciation',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '裱',
    definition: 'to hang (a banner); to mount (a map or scroll)',
    pinyin: ['biǎo'],
    decomposition: '⿰衤表',
    etymology: {
      type: 'ideographic',
      hint: 'To display 表 a cloth 衤 map; 表 also provides the pronunciation',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '裳',
    definition: 'skirt, petticoat; beautiful',
    pinyin: ['shang'],
    decomposition: '⿱尚衣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尚',
      semantic: '衣',
      hint: 'clothes',
    },
    radical: '衣',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '裴',
    definition: 'flowing gown; surname',
    pinyin: ['péi'],
    decomposition: '⿱非衣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '非',
      semantic: '衣',
      hint: 'clothes',
    },
    radical: '衣',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '裸',
    definition: 'bare, nude; to strip, to undress',
    pinyin: ['luǒ'],
    decomposition: '⿰衤果',
    etymology: {
      type: 'pictophonetic',
      phonetic: '果',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '裹',
    definition: 'to wrap, to encircle; to confine, to bind',
    pinyin: ['guǒ'],
    decomposition: '⿻衣果',
    etymology: {
      type: 'pictophonetic',
      phonetic: '果',
      semantic: '衣',
      hint: 'clothes',
    },
    radical: '衣',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '裼',
    definition: 'to take off a top; to divest',
    pinyin: ['tì'],
    decomposition: '⿰衤易',
    etymology: {
      type: 'ideographic',
      hint: "To change 易 one's top 衤; 易 also provides the pronunciation",
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '製',
    definition: 'system; to establish; to manufacture; to overpower',
    pinyin: ['zhì'],
    decomposition: '⿱制衣',
    etymology: {
      type: 'ideographic',
      hint: 'To manufacture 制 clothes 衣; 制 also provides the pronunciation',
    },
    radical: '衣',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '裾',
    definition: 'hem, lapel; skirt',
    pinyin: ['jū'],
    decomposition: '⿰衤居',
    etymology: {
      type: 'pictophonetic',
      phonetic: '居',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '褂',
    definition: 'coat, jacket; gown, robe',
    pinyin: ['guà'],
    decomposition: '⿰衤卦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卦',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '複',
    definition: 'again, repeatedly; copy, duplicate; to restore, to return',
    pinyin: ['fù'],
    decomposition: '⿰衤复',
    etymology: {
      type: 'ideographic',
      hint: 'A cloth 衤 pattern 复; 复 also provides the pronunciation',
    },
    radical: '衤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '褊',
    definition: '4cramped, narrow; crowded; urgent',
    pinyin: ['biǎn'],
    decomposition: '⿰衤扁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '扁',
      semantic: '衤',
      hint: 'cloth',
    },
    radical: '衤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '褐',
    definition: 'coarse wool; dull, brown',
    pinyin: ['hè'],
    decomposition: '⿰衤曷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曷',
      semantic: '衤',
      hint: 'cloth',
    },
    radical: '衤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '褒',
    definition: 'to cite; to honor, to praise; to recommend',
    pinyin: ['bāo'],
    decomposition: '⿻衣保',
    etymology: {
      type: 'pictophonetic',
      phonetic: '保',
      semantic: '衣',
      hint: 'clothes',
    },
    radical: '衣',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '褓',
    definition: 'swaddling cloth; infancy',
    pinyin: ['bǎo'],
    decomposition: '⿰衤保',
    etymology: {
      type: 'ideographic',
      hint: 'A cloth 衤 used to protect 保 an infant; 保 also provides the pronunciation',
    },
    radical: '衤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '褙',
    definition: 'paper or cloth pasted together',
    pinyin: ['bèi'],
    decomposition: '⿰衤背',
    etymology: {
      type: 'pictophonetic',
      phonetic: '背',
      semantic: '衤',
      hint: 'cloth',
    },
    radical: '衤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '褚',
    definition: 'bag, valise; to pad, to stuff; surname',
    pinyin: ['chǔ'],
    decomposition: '⿰衤者',
    etymology: {
      type: 'pictophonetic',
      phonetic: '者',
      semantic: '衤',
      hint: 'cloth',
    },
    radical: '衤',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '褛',
    definition: 'lapel, collar; tattered, threadbare',
    pinyin: ['lǚ'],
    decomposition: '⿰衤娄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '娄',
      semantic: '衤',
      hint: 'cloth',
    },
    radical: '衤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '褟',
    definition: 'singlet, inner shirt; to sew',
    pinyin: ['tā'],
    decomposition: '⿰衤⿱日羽',
    etymology: { type: 'pictophonetic', semantic: '衤', hint: 'clothes' },
    radical: '衤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '褡',
    definition: 'girdle, loincloth; bag, pouch',
    pinyin: ['dā'],
    decomposition: '⿰衤荅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '荅',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '褥',
    definition: 'mattress, cushion; bedding',
    pinyin: ['rù'],
    decomposition: '⿰衤辱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辱',
      semantic: '衤',
      hint: 'cloth',
    },
    radical: '衤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '褪',
    definition: 'to strip, to undress; to fade, to fall off',
    pinyin: ['tuì'],
    decomposition: '⿰衤退',
    etymology: {
      type: 'ideographic',
      hint: 'Th take off 退 clothing 衤; 退 also provides the pronunciation',
    },
    radical: '衤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '褫',
    definition: 'to strip, to tear off, to undress',
    pinyin: ['chǐ'],
    decomposition: '⿰衤虒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '虒',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '褰',
    definition: "4undergarment; to pick up one's skirt",
    pinyin: ['qiān'],
    decomposition: '⿱宀⿱？衣',
    etymology: { type: 'pictophonetic', semantic: '衣', hint: 'clothes' },
    radical: '衣',
    matches: [
      [0],
      [0],
      [0],
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '褱',
    definition:
      "to wrap, to conceal; to carry in one's bosom or up one's sleeve",
    pinyin: ['huái'],
    decomposition: '⿻衣⿱罒氺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '氺',
      hint: 'cloth',
      semantic: '衣',
    },
    radical: '衣',
    matches: [
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [0],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '褲',
    definition: 'pants, trousers',
    pinyin: ['kù'],
    decomposition: '⿰衤庫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '庫',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '褳',
    definition: "a folding purse kept in one's belt",
    pinyin: ['lián'],
    decomposition: '⿰衤連',
    etymology: {
      type: 'pictophonetic',
      phonetic: '連',
      semantic: '衤',
      hint: 'cloth',
    },
    radical: '衤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '褴',
    definition: 'ragged, tattered, threadbare',
    pinyin: ['lán'],
    decomposition: '⿰衤监',
    etymology: {
      type: 'pictophonetic',
      phonetic: '监',
      semantic: '衤',
      hint: 'cloth',
    },
    radical: '衤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '褵',
    definition: 'bridal veil',
    pinyin: ['lí'],
    decomposition: '⿰衤离',
    etymology: {
      type: 'pictophonetic',
      phonetic: '离',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '褶',
    definition: 'wrinkle, pleat, crease',
    pinyin: ['zhě'],
    decomposition: '⿰衤習',
    etymology: {
      type: 'pictophonetic',
      phonetic: '習',
      semantic: '衤',
      hint: 'cloth',
    },
    radical: '衤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '褸',
    definition: 'lapel, collar; tattered, threadbare',
    pinyin: ['lǚ'],
    decomposition: '⿰衤婁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '婁',
      semantic: '衤',
      hint: 'cloth',
    },
    radical: '衤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '褻',
    definition: 'dirty, ragged; slight, insult, disrespect',
    pinyin: ['xiè'],
    decomposition: '⿻衣埶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '埶',
      semantic: '衣',
      hint: 'cloth',
    },
    radical: '衣',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '襁',
    definition: 'swaddling cloth',
    pinyin: ['qiǎng'],
    decomposition: '⿰衤强',
    etymology: {
      type: 'pictophonetic',
      phonetic: '强',
      semantic: '衤',
      hint: 'cloth',
    },
    radical: '衤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '襄',
    definition: 'to aid, to help, to assist; to undress',
    pinyin: ['xiāng'],
    decomposition: '⿱⿱亠⿰口口⿱井衣',
    etymology: {
      type: 'ideographic',
      hint: 'Using two hands 口 to help someone remove their clothes 衣',
    },
    radical: '衣',
    matches: [
      [0, 0],
      [0, 0],
      [0, 1, 0],
      [0, 1, 0],
      [0, 1, 0],
      [0, 1, 1],
      [0, 1, 1],
      [0, 1, 1],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '襖',
    definition: 'coat, jacket, outerware',
    pinyin: ['ǎo'],
    decomposition: '⿰衤奥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奥',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '襞',
    definition: 'pleat, fold, crease',
    pinyin: ['bì'],
    decomposition: '⿱辟衣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辟',
      semantic: '衣',
      hint: 'cloth',
    },
    radical: '衣',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '襟',
    definition: 'lapel, collar',
    pinyin: ['jīn'],
    decomposition: '⿰衤禁',
    etymology: {
      type: 'ideographic',
      hint: 'Cloth 衤 that restricts 禁; 禁 also provides the pronunciation',
    },
    radical: '衤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '襠',
    definition: 'the crotch or seat of a pair of pants',
    pinyin: ['dāng'],
    decomposition: '⿰衤當',
    etymology: {
      type: 'pictophonetic',
      phonetic: '當',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '襢',
    definition: 'to strip, to lay bare; naked, bare',
    pinyin: ['tǎn'],
    decomposition: '⿰衤亶',
    etymology: {
      type: 'ideographic',
      hint: "The truth 亶 hidden under one's robes 衤; 亶 also provides the pronunciation",
    },
    radical: '衤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '襤',
    definition: 'ragged, tattered, threadbare',
    pinyin: ['lán'],
    decomposition: '⿰衤監',
    etymology: {
      type: 'pictophonetic',
      phonetic: '監',
      semantic: '衤',
      hint: 'cloth',
    },
    radical: '衤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '襦',
    definition: 'coat, jacket; fine silk fabric',
    pinyin: ['rú'],
    decomposition: '⿰衤需',
    etymology: {
      type: 'pictophonetic',
      phonetic: '需',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '襪',
    definition: 'socks, stockings',
    pinyin: ['wà'],
    decomposition: '⿰衤蔑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蔑',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '襫',
    definition: 'raincoat',
    pinyin: ['shì'],
    decomposition: '⿰衤奭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奭',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '襯',
    definition: 'underwear, lining; in contrast',
    pinyin: ['chèn'],
    decomposition: '⿰衤親',
    etymology: {
      type: 'pictophonetic',
      phonetic: '親',
      semantic: '衤',
      hint: 'clothes',
    },
    radical: '衤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '襲',
    definition: 'to attack, to raid; to inherit',
    pinyin: ['xí'],
    decomposition: '⿱龍衣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '衣',
      semantic: '龍',
      hint: 'dragon',
    },
    radical: '衣',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '襻',
    definition: 'loop, belt, band',
    pinyin: ['pàn'],
    decomposition: '⿰衤攀',
    etymology: {
      type: 'ideographic',
      hint: 'A belt that holds up 攀 clothes 衤; 攀 also provides the pronunciation',
    },
    radical: '衤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '襾',
    definition: 'cover',
    pinyin: ['yà'],
    decomposition: '？',
    radical: '襾',
    matches: [null, null, null, null, null, null],
  },
  {
    character: '西',
    definition: 'west, western, westward',
    pinyin: ['xī'],
    decomposition: '⿻兀囗',
    etymology: {
      type: 'pictographic',
      hint: 'A bird settling into its nest, representing sunset; compare 東',
    },
    radical: '西',
    matches: [[0], [1], [1], [0], [0], [1]],
  },
  {
    character: '覀',
    definition: 'west, western, westward',
    pinyin: ['xī'],
    decomposition: '？',
    etymology: {
      type: 'ideographic',
      hint: 'A bird settling into its nest, representing sunset; compare 東',
    },
    radical: '覀',
    matches: [null, null, null, null, null, null],
  },
  {
    character: '要',
    definition: 'essential, necessary; to ask for; to coerce; to demand',
    pinyin: ['yào'],
    decomposition: '⿱覀女',
    etymology: {
      type: 'ideographic',
      hint: 'A woman 女 with hands on her waist 覀',
    },
    radical: '覀',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '覃',
    definition: 'to reach, to spread to; deep, extensive',
    pinyin: ['tán'],
    decomposition: '⿱覀早',
    etymology: {
      type: 'ideographic',
      hint: 'From the east 早 to the west 覀 ',
    },
    radical: '覀',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '覆',
    definition: 'to cover; to overturn; to repeat; to reply',
    pinyin: ['fù'],
    decomposition: '⿱覀復',
    etymology: {
      type: 'pictophonetic',
      phonetic: '復',
      semantic: '覀',
      hint: 'cover',
    },
    radical: '覀',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '覈',
    definition: 'to investigate, to examine; to consider',
    pinyin: ['hé'],
    decomposition: '⿱覀敫',
    radical: '覀',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '見',
    definition: 'to see, to observe, to meet, to appear',
    pinyin: ['jiàn'],
    decomposition: '⿱目儿',
    etymology: {
      type: 'ideographic',
      hint: 'A man 儿 with the eye 目 emphasized',
    },
    radical: '見',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '規',
    definition: 'rules, regulations, customs, law',
    pinyin: ['guī'],
    decomposition: '⿰夫見',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夫',
      semantic: '見',
      hint: 'observe',
    },
    radical: '見',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '覓',
    definition: 'to seek; to search',
    pinyin: ['mì'],
    decomposition: '⿱爫見',
    etymology: {
      type: 'ideographic',
      hint: 'To search for something with eyes 見 and hands 爫',
    },
    radical: '見',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '視',
    definition: 'to look at, to inspect, to observe, to regard',
    pinyin: ['shì'],
    decomposition: '⿰礻見',
    etymology: {
      type: 'pictophonetic',
      phonetic: '礻',
      semantic: '見',
      hint: 'see',
    },
    radical: '見',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '覘',
    definition: 'to peek, to watch; to investigate, to spy on',
    pinyin: ['chān'],
    decomposition: '⿰占見',
    etymology: {
      type: 'ideographic',
      hint: 'To watch 見 and observe 占; 占 also provides the pronunciation',
    },
    radical: '見',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '覡',
    definition: 'wizard',
    pinyin: ['xí'],
    decomposition: '⿰巫見',
    etymology: { type: 'ideographic', hint: 'One who learns 見 magic 巫' },
    radical: '見',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '覦',
    definition: 'to covet, to desire, to long for',
    pinyin: ['yú'],
    decomposition: '⿰俞見',
    etymology: {
      type: 'pictophonetic',
      phonetic: '俞',
      semantic: '見',
      hint: 'eye',
    },
    radical: '見',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '親',
    definition: 'relatives, parents; intimate; the hazelnut tree',
    pinyin: ['qīn'],
    decomposition: '⿰亲見',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亲',
      semantic: '見',
      hint: 'see',
    },
    radical: '見',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '覬',
    definition: 'to covet, to desire, to long for',
    pinyin: ['jì'],
    decomposition: '⿰豈見',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豈',
      semantic: '見',
      hint: 'eye',
    },
    radical: '見',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '覲',
    definition: 'an audience with the emperor',
    pinyin: ['jìn'],
    decomposition: '⿰堇見',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堇',
      semantic: '見',
      hint: 'meet',
    },
    radical: '見',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '覷',
    definition: 'to peep, to watch, to spy on',
    pinyin: ['qù'],
    decomposition: '⿰虚見',
    etymology: {
      type: 'pictophonetic',
      phonetic: '虚',
      semantic: '見',
      hint: 'see',
    },
    radical: '見',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '覺',
    definition: 'conscious; to nap, to sleep; to wake up',
    pinyin: ['jué'],
    decomposition: '⿱？見',
    radical: '見',
    matches: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '覽',
    definition: 'to look over, to inspect, to view, to perceive',
    pinyin: ['lǎn'],
    decomposition: '⿱監見',
    etymology: {
      type: 'pictophonetic',
      phonetic: '監',
      semantic: '見',
      hint: 'see',
    },
    radical: '見',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '觀',
    definition: 'to observe, to spectate; appearance, view',
    pinyin: ['guān'],
    decomposition: '⿰雚見',
    etymology: {
      type: 'pictophonetic',
      phonetic: '雚',
      semantic: '見',
      hint: 'see',
    },
    radical: '見',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '见',
    definition: 'to see, to observe, to meet, to appear',
    pinyin: ['jiàn'],
    decomposition: '⿵冂儿',
    etymology: {
      type: 'ideographic',
      hint: 'Simplified form of 見; a man 儿 with the eye 目 emphasized',
    },
    radical: '见',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '观',
    definition: 'to observe, to spectate; appearance, view',
    pinyin: ['guān'],
    decomposition: '⿰又见',
    etymology: { type: 'ideographic', hint: 'To see 见 again 又' },
    radical: '见',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '规',
    definition: 'rules, regulations, customs, law',
    pinyin: ['guī'],
    decomposition: '⿰夫见',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夫',
      semantic: '见',
      hint: 'observe',
    },
    radical: '见',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '觅',
    definition: 'to seek; to search',
    pinyin: ['mì'],
    decomposition: '⿱爫见',
    etymology: {
      type: 'ideographic',
      hint: 'To search for something with eyes 见 and hands 爫',
    },
    radical: '爫',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '视',
    definition: 'to look at, to inspect, to observe, to regard',
    pinyin: ['shì'],
    decomposition: '⿰礻见',
    etymology: {
      type: 'pictophonetic',
      phonetic: '礻',
      semantic: '见',
      hint: 'see',
    },
    radical: '见',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '觇',
    definition: 'to peek, to watch; to investigate, to spy on',
    pinyin: ['chān'],
    decomposition: '⿰占见',
    etymology: {
      type: 'ideographic',
      hint: 'To watch 见 and observe 占; 占 also provides the pronunciation',
    },
    radical: '见',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '览',
    definition: 'to look over, to inspect, to view, to perceive',
    pinyin: ['lǎn'],
    decomposition: '⿱？见',
    etymology: { type: 'pictophonetic', semantic: '见', hint: 'see' },
    radical: '见',
    matches: [null, null, null, null, null, [1], [1], [1], [1]],
  },
  {
    character: '觉',
    definition: 'conscious; to nap, to sleep; to wake up',
    pinyin: ['jué'],
    decomposition: '⿳⺍冖见',
    etymology: {
      type: 'pictophonetic',
      phonetic: '⺍',
      semantic: '见',
      hint: 'see',
    },
    radical: '见',
    matches: [[0], [0], [0], [1], [1], [2], [2], [2], [2]],
  },
  {
    character: '觊',
    definition: 'to covet, to desire, to long for',
    pinyin: ['jì'],
    decomposition: '⿰岂见',
    etymology: {
      type: 'pictophonetic',
      phonetic: '岂',
      semantic: '见',
      hint: 'eye',
    },
    radical: '见',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '觋',
    definition: 'wizard',
    pinyin: ['xí'],
    decomposition: '⿰巫见',
    etymology: { type: 'ideographic', hint: 'One who learns 见 magic 巫' },
    radical: '见',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '觌',
    definition: 'audience, interview; face-to-face meeting',
    pinyin: ['dí'],
    decomposition: '⿰卖见',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卖',
      semantic: '见',
      hint: 'meet',
    },
    radical: '见',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '觎',
    definition: 'to covet, to desire, to long for',
    pinyin: ['yú'],
    decomposition: '⿰俞见',
    etymology: {
      type: 'pictophonetic',
      phonetic: '俞',
      semantic: '见',
      hint: 'eye',
    },
    radical: '见',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '觏',
    definition: 'to meet unexpectedly',
    pinyin: ['gòu'],
    decomposition: '⿰冓见',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冓',
      semantic: '见',
      hint: 'meet',
    },
    radical: '见',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '觐',
    definition: 'an audience with the emperor',
    pinyin: ['jìn'],
    decomposition: '⿰堇见',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堇',
      semantic: '见',
      hint: 'meet',
    },
    radical: '见',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '觑',
    definition: 'to peep, to watch, to spy on',
    pinyin: ['qù'],
    decomposition: '⿰虚见',
    etymology: {
      type: 'pictophonetic',
      phonetic: '虚',
      semantic: '见',
      hint: 'see',
    },
    radical: '见',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '角',
    definition: 'angle, corner; horn, horn-shaped',
    pinyin: ['jiǎo'],
    decomposition: '⿱⺈用',
    etymology: {
      type: 'pictographic',
      hint: 'A rhinoceros or other animal horn',
    },
    radical: '角',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '觖',
    definition: 'to long for; to criticize; dissatisfied',
    pinyin: ['jué'],
    decomposition: '⿰角夬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夬',
      semantic: '角',
      hint: 'horn',
    },
    radical: '角',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '觚',
    definition: 'jug, goblet; rule, law',
    pinyin: ['gū'],
    decomposition: '⿰角瓜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '瓜',
      semantic: '角',
      hint: 'horn',
    },
    radical: '角',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '觜',
    definition: 'beak',
    pinyin: ['zī'],
    decomposition: '⿱此角',
    etymology: {
      type: 'pictophonetic',
      phonetic: '此',
      semantic: '角',
      hint: 'horn',
    },
    radical: '角',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '觞',
    definition: 'wine cup; to propose a toast; feast',
    pinyin: ['shāng'],
    decomposition: '⿰角⿱？昜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昜',
      semantic: '角',
      hint: 'horn',
    },
    radical: '角',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      null,
      null,
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '解',
    definition: 'to explain; to loosen; to unfasten, to untie',
    pinyin: ['jiě'],
    decomposition: '⿰角⿱刀牛',
    etymology: {
      type: 'ideographic',
      hint: 'To cut 刀 the horns 角 off of an ox 牛; 角 also provides the pronunciation',
    },
    radical: '角',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '觥',
    definition: 'a horn of wine',
    pinyin: ['gōng'],
    decomposition: '⿰角光',
    etymology: {
      type: 'pictophonetic',
      phonetic: '光',
      semantic: '角',
      hint: 'horn',
    },
    radical: '角',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '触',
    definition: 'to butt, to gore, to ram; to touch',
    pinyin: ['chù'],
    decomposition: '⿰角虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '虫',
      semantic: '角',
      hint: 'horn',
    },
    radical: '角',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '觫',
    definition: 'to start, to tremble with fear',
    pinyin: ['sù'],
    decomposition: '⿰角束',
    etymology: {
      type: 'pictophonetic',
      phonetic: '束',
      semantic: '角',
      hint: 'horn',
    },
    radical: '角',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '觯',
    definition: 'a horn of wine',
    pinyin: ['zhì'],
    decomposition: '⿰角单',
    etymology: {
      type: 'pictophonetic',
      phonetic: '单',
      semantic: '角',
      hint: 'horn',
    },
    radical: '角',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '觱',
    definition: 'Tartar horn; chill wind',
    pinyin: ['bì'],
    decomposition: '⿱咸角',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咸',
      semantic: '角',
      hint: 'horn',
    },
    radical: '角',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '觳',
    definition: 'goblet, horn; frightened',
    pinyin: ['hú'],
    decomposition: '⿰⿱⿳士冖一角殳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '殳',
      semantic: '角',
      hint: 'horn',
    },
    radical: '角',
    matches: [
      [0, 0, 0],
      [0, 0, 0],
      [0, 0, 0],
      [0, 0, 1],
      [0, 0, 1],
      [0, 0, 2],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '觴',
    definition: 'wine cup; to propose a toast; feast',
    pinyin: ['shāng'],
    decomposition: '⿰角⿱？昜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昜',
      semantic: '角',
      hint: 'horn',
    },
    radical: '角',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      null,
      null,
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '觸',
    definition: 'to butt, to gore, to ram; to touch',
    pinyin: ['chù'],
    decomposition: '⿰角蜀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蜀',
      semantic: '角',
      hint: 'horn',
    },
    radical: '角',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '言',
    definition: 'words, speech; to speak, to say',
    pinyin: ['yán'],
    decomposition: '⿱亠⿱二口',
    etymology: {
      type: 'ideographic',
      hint: 'A tongue sticking out of a mouth 口',
    },
    radical: '言',
    matches: [[0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '訁',
    definition: 'words, speech; to speak, to say',
    pinyin: ['yán'],
    decomposition: '？',
    etymology: {
      type: 'ideographic',
      hint: 'A tongue sticking out of a mouth 口',
    },
    radical: '訁',
    matches: [null, null, null, null, null, null, null],
  },
  {
    character: '訂',
    definition: 'to make an order; to draw up an agreement',
    pinyin: ['dìng'],
    decomposition: '⿰言丁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丁',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '訃',
    definition: 'obituary, death notice',
    pinyin: ['fù'],
    decomposition: '⿰言卜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卜',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '訇',
    definition: 'a crashing sound',
    pinyin: ['hōng'],
    decomposition: '⿹勹言',
    etymology: { type: 'pictophonetic', semantic: '言', hint: 'speech' },
    radical: '言',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '計',
    definition: 'to calculate, to count; to plan, to reckon; plot, scheme',
    pinyin: ['jì'],
    decomposition: '⿰言十',
    etymology: {
      type: 'pictophonetic',
      phonetic: '十',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '訊',
    definition: 'news, information; to question, to interrogate',
    pinyin: ['xùn'],
    decomposition: '⿰言卂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卂',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '訌',
    definition: 'confusion; internal strife',
    pinyin: ['hòng'],
    decomposition: '⿰言工',
    etymology: {
      type: 'ideographic',
      hint: 'Dissent 言 among workers 工; 工 also provides the pronunciation',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '討',
    definition: 'to haggle, to discuss; to demand, to ask for',
    pinyin: ['tǎo'],
    decomposition: '⿰言寸',
    etymology: { type: 'ideographic', hint: 'To ask 言 for something 寸' },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '訓',
    definition: 'to teach, to instruct; pattern, example; exegesis',
    pinyin: ['xùn'],
    decomposition: '⿰言川',
    etymology: {
      type: 'pictophonetic',
      phonetic: '川',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '訕',
    definition: 'to abuse, to slander, to vilify; to ridicule',
    pinyin: ['shàn'],
    decomposition: '⿰言山',
    etymology: {
      type: 'pictophonetic',
      phonetic: '山',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '訖',
    definition: 'to finish, to conclude; to exhaust',
    pinyin: ['qì'],
    decomposition: '⿰言乞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乞',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '託',
    definition: 'to commission, to entrust, to rely on',
    pinyin: ['tuō'],
    decomposition: '⿰言乇',
    etymology: {
      type: 'ideographic',
      hint: "To depend on 乇 someone's word 言; 乇 also provides the pronunciation",
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '記',
    definition: 'mark, sign; to note, to record',
    pinyin: ['jì'],
    decomposition: '⿰言己',
    etymology: {
      type: 'ideographic',
      hint: 'A private 己 note 言; 己 also provides the pronunciation',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '訚',
    definition: 'respectful; to speak gently',
    pinyin: ['yín'],
    decomposition: '⿵门言',
    etymology: {
      type: 'pictophonetic',
      phonetic: '门',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '訛',
    definition: 'to swindle, to cheat; wrong, error; falsehood',
    pinyin: ['é'],
    decomposition: '⿰言化',
    etymology: {
      type: 'pictophonetic',
      phonetic: '化',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '訝',
    definition: 'amazed, surprised; to express surprise',
    pinyin: ['yà'],
    decomposition: '⿰言牙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '牙',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '訟',
    definition: 'to accuse, to argue; to dispute, to litigate',
    pinyin: ['sòng'],
    decomposition: '⿰言公',
    etymology: {
      type: 'pictophonetic',
      phonetic: '公',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '訢',
    definition: 'delighted, pleased; happy',
    pinyin: ['xīn'],
    decomposition: '⿰言斤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斤',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '訣',
    definition: 'to take leave of, to bid farewell; knack, trick',
    pinyin: ['jué'],
    decomposition: '⿰言夬',
    etymology: {
      type: 'ideographic',
      hint: 'Words 言 said at a parting 夬; 夬 also provides the pronunciation',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '訥',
    definition: 'inarticulate, slow; to mumble, to stammer',
    pinyin: ['nè'],
    decomposition: '⿰言内',
    etymology: {
      type: 'pictophonetic',
      phonetic: '内',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '訪',
    definition: 'to visit; to inquire, to ask',
    pinyin: ['fǎng'],
    decomposition: '⿰言方',
    etymology: {
      type: 'pictophonetic',
      phonetic: '方',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '設',
    definition: 'to build, to design; to establish; to offer',
    pinyin: ['shè'],
    decomposition: '⿰言殳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '殳',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '許',
    definition: 'to consent, to permit; to promise, to betroth',
    pinyin: ['xǔ'],
    decomposition: '⿰言午',
    etymology: {
      type: 'pictophonetic',
      phonetic: '午',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '訴',
    definition: 'to accuse, to sue; to inform; to narrate',
    pinyin: ['sù'],
    decomposition: '⿰言斥',
    etymology: {
      type: 'ideographic',
      hint: 'Words 言 of blame 斥; 斥 also provides the pronunciation',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '訶',
    definition: 'to scold loudly, to curse, to abuse',
    pinyin: ['hē'],
    decomposition: '⿰言可',
    etymology: {
      type: 'pictophonetic',
      phonetic: '可',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '診',
    definition: 'to diagnose; to examine a patient',
    pinyin: ['zhěn'],
    decomposition: '⿰言㐱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㐱',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '註',
    definition: 'to concentrate, to focus',
    pinyin: ['zhù'],
    decomposition: '⿰言主',
    etymology: {
      type: 'pictophonetic',
      phonetic: '主',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '訾',
    definition: 'to criticize, to bad-mouth; defect; betrayal',
    pinyin: ['zī'],
    decomposition: '⿱此言',
    etymology: {
      type: 'pictophonetic',
      phonetic: '此',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '詆',
    definition: 'to slander; to condem, to reproach',
    pinyin: ['dǐ'],
    decomposition: '⿰言氐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '氐',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '詈',
    definition: 'to curse, to scold; to accuse',
    pinyin: ['lì'],
    decomposition: '⿱罒言',
    etymology: {
      type: 'ideographic',
      hint: "To implicate 罒 someone by one's words 言",
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '詐',
    definition: 'to cheat, to defraud; sly, treacherous',
    pinyin: ['zhà'],
    decomposition: '⿰言乍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乍',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '詒',
    definition: 'to bequeath, to pass on',
    pinyin: ['yí'],
    decomposition: '⿰言台',
    etymology: {
      type: 'pictophonetic',
      phonetic: '台',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '詔',
    definition: 'to proclaim, to decree; imperial decree',
    pinyin: ['zhào'],
    decomposition: '⿰言召',
    etymology: {
      type: 'ideographic',
      hint: 'To issue 言 a decree 召; 召 also provides the pronunciation',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '評',
    definition: 'to appraise, to criticize, to evaluate',
    pinyin: ['píng'],
    decomposition: '⿰言平',
    etymology: {
      type: 'pictophonetic',
      phonetic: '平',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '詛',
    definition: 'to curse; to pledge, to swear',
    pinyin: ['zǔ'],
    decomposition: '⿰言且',
    etymology: {
      type: 'pictophonetic',
      phonetic: '且',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '詞',
    definition: 'phrase, expression; words, speech',
    pinyin: ['cí'],
    decomposition: '⿰言司',
    etymology: {
      type: 'pictophonetic',
      phonetic: '司',
      semantic: '言',
      hint: 'words',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '詠',
    definition: 'to sing, to hum, to chant',
    pinyin: ['yǒng'],
    decomposition: '⿰言永',
    etymology: {
      type: 'pictophonetic',
      phonetic: '永',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '詡',
    definition: 'to brag, to boast; popular, well-known',
    pinyin: ['xǔ'],
    decomposition: '⿰言羽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羽',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '詢',
    definition: 'to ask about, to inquire into; to consult',
    pinyin: ['xún'],
    decomposition: '⿰言旬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旬',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '詣',
    definition: 'to reach; achievement, accomplishment',
    pinyin: ['yì'],
    decomposition: '⿰言旨',
    etymology: {
      type: 'ideographic',
      hint: 'To meet 言 a goal 旨; 旨 also provides the pronunciation',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '試',
    definition: 'to try, to experiment; exam, test',
    pinyin: ['shì'],
    decomposition: '⿰言式',
    etymology: {
      type: 'pictophonetic',
      phonetic: '式',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '詩',
    definition: 'poetry; poem, verse, ode',
    pinyin: ['shī'],
    decomposition: '⿰言寺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寺',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '詫',
    definition: 'surprised, shocked',
    pinyin: ['chà'],
    decomposition: '⿰言宅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宅',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '詬',
    definition: 'to abuse, to scold; to berate, to insult',
    pinyin: ['gòu'],
    decomposition: '⿰言后',
    etymology: {
      type: 'pictophonetic',
      phonetic: '后',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '詭',
    definition: 'to cheat, to defraud; sly, treacherous',
    pinyin: ['guǐ'],
    decomposition: '⿰言危',
    etymology: {
      type: 'pictophonetic',
      phonetic: '危',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '詮',
    definition: 'to expound, to explain, to comment on',
    pinyin: ['quán'],
    decomposition: '⿰言全',
    etymology: {
      type: 'pictophonetic',
      phonetic: '全',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '詰',
    definition: 'to question, to interrogate',
    pinyin: ['jí'],
    decomposition: '⿰言吉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吉',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '話',
    definition: 'talk, speech; language, dialect',
    pinyin: ['huà'],
    decomposition: '⿰言舌',
    etymology: {
      type: 'ideographic',
      hint: 'A spoken 言 tongue 舌; 舌 also provides the pronunciation',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '該',
    definition: 'should, ought to, must',
    pinyin: ['gāi'],
    decomposition: '⿰言亥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亥',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '詳',
    definition: 'complete, detailed, thorough',
    pinyin: ['xiáng'],
    decomposition: '⿰言羊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羊',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '詹',
    definition: 'talkative, verbose; surname',
    pinyin: ['zhān'],
    decomposition: '⿸厂⿱八言',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厂',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      null,
      null,
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '詼',
    definition: 'to tease, to joke with; to ridicule, to mock',
    pinyin: ['huī'],
    decomposition: '⿰言灰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '灰',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '誅',
    definition: 'to execute, to kill; to punish',
    pinyin: ['zhū'],
    decomposition: '⿰言朱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朱',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '誆',
    definition: 'to swindle, to cheat; to lie',
    pinyin: ['kuāng'],
    decomposition: '⿰言匡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匡',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '誇',
    definition: 'to praise; to exaggerate, to boast',
    pinyin: ['kuā'],
    decomposition: '⿰言夸',
    etymology: {
      type: 'ideographic',
      hint: 'Extravagant 夸 words 言; 夸 also provides the pronunciation',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '誉',
    definition: 'fame, reputation; to praise',
    pinyin: ['yù'],
    decomposition: '⿱兴言',
    etymology: { type: 'ideographic', hint: "Word 言 of one's success 兴" },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '誊',
    definition: 'to copy, to transcribe',
    pinyin: ['téng'],
    decomposition: '⿱龹言',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龹',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '誌',
    definition: 'determination, will; mark, sign; to record, to write',
    pinyin: ['zhì'],
    decomposition: '⿰言志',
    etymology: {
      type: 'pictophonetic',
      phonetic: '志',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '認',
    definition: 'to know, to recognize, to understand',
    pinyin: ['rèn'],
    decomposition: '⿰言忍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '忍',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '誑',
    definition: 'to lie, to deceive; to delude, to cheat',
    pinyin: ['kuáng'],
    decomposition: '⿰言狂',
    etymology: {
      type: 'ideographic',
      hint: 'Mad 狂 speech 言; 狂 also provides the pronunciation',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '誒',
    definition:
      'oh, hey; surprise (tone 2), disagreement (tone 3), agreement (tone 4)',
    pinyin: ['éi'],
    decomposition: '⿰言矣',
    etymology: {
      type: 'ideographic',
      hint: 'To verbally 言 confirm 矣 ; 矣 also provides the pronunciation',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '誓',
    definition: 'to swear, to pledge; oath',
    pinyin: ['shì'],
    decomposition: '⿱折言',
    etymology: {
      type: 'ideographic',
      hint: 'Words 言 that must not be broken 折; 折 also provides the pronunciation',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '誕',
    definition: 'to give birth, to bear children; birth, birthday',
    pinyin: ['dàn'],
    decomposition: '⿰言延',
    etymology: {
      type: 'pictophonetic',
      phonetic: '延',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '誘',
    definition: 'to tempt, to persuade, to entice; guide',
    pinyin: ['yòu'],
    decomposition: '⿰言秀',
    etymology: {
      type: 'ideographic',
      hint: 'To use elegant 秀 words 言; 秀 also provides the pronunciation',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '誙',
    definition: 'definitely, sure!',
    pinyin: ['kēng'],
    decomposition: '⿰言巠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巠',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '誚',
    definition: 'to scold, to blame; to ridicule, to criticize',
    pinyin: ['qiào'],
    decomposition: '⿰言肖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肖',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '語',
    definition: 'words, language; saying, expression',
    pinyin: ['yǔ'],
    decomposition: '⿰言吾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吾',
      semantic: '言',
      hint: 'words',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '誠',
    definition: 'honest, sincere, true; actually, really',
    pinyin: ['chéng'],
    decomposition: '⿰言成',
    etymology: {
      type: 'pictophonetic',
      phonetic: '成',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '誡',
    definition: 'to warn, to admonish; warning',
    pinyin: ['jiè'],
    decomposition: '⿰言戒',
    etymology: {
      type: 'ideographic',
      hint: 'Words 言 of warning 戒; 戒 also provides the pronunciation',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '誣',
    definition: 'to slander, to defame; a false accusation',
    pinyin: ['wū'],
    decomposition: '⿰言巫',
    etymology: {
      type: 'ideographic',
      hint: 'To start 言 a witch-hunt 巫; 巫 also provides the pronunciation',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '誤',
    definition: 'error, fault, mistake; to delay',
    pinyin: ['wù'],
    decomposition: '⿰言吴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吴',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '誦',
    definition: 'to chant, to recite, to repeat, to read aloud',
    pinyin: ['sòng'],
    decomposition: '⿰言甬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甬',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '誨',
    definition: 'to teach, to instruct; to encourage, to urge',
    pinyin: ['huì'],
    decomposition: '⿰言每',
    etymology: {
      type: 'pictophonetic',
      phonetic: '每',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '說',
    definition: 'to speak, to say; to scold, to upbraid',
    pinyin: ['shuō'],
    decomposition: '⿰言兌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兌',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '誰',
    definition: 'who? whom? whose? anyone?',
    pinyin: ['shuí'],
    decomposition: '⿰言隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隹',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '課',
    definition: 'subject, lesson, course; classwork',
    pinyin: ['kè'],
    decomposition: '⿰言果',
    etymology: {
      type: 'pictophonetic',
      phonetic: '果',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '誹',
    definition: 'to condemn, to slander, to vilify',
    pinyin: ['fěi'],
    decomposition: '⿰言非',
    etymology: {
      type: 'pictophonetic',
      phonetic: '非',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '誼',
    definition: 'friendship; appropriate, suitable',
    pinyin: ['yì'],
    decomposition: '⿰言宜',
    etymology: {
      type: 'ideographic',
      hint: 'Fitting 宜 speech 言; 宜 also provides the pronunciation',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '誾',
    definition: 'respectful; to speak gently',
    pinyin: ['yín'],
    decomposition: '⿵門言',
    etymology: {
      type: 'pictophonetic',
      phonetic: '門',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '調',
    definition: 'tune, melody, key; to transfer, to exchange',
    pinyin: ['diào'],
    decomposition: '⿰言周',
    etymology: {
      type: 'pictophonetic',
      phonetic: '周',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '諂',
    definition: 'to flatter, to cajole; toady, yes-man',
    pinyin: ['chǎn'],
    decomposition: '⿰言臽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臽',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '諄',
    definition: 'earnest, patient, sincere',
    pinyin: ['zhūn'],
    decomposition: '⿰言享',
    etymology: {
      type: 'ideographic',
      hint: 'One who freely shares 享 advice 言; 享 also provides the pronunciation',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '談',
    definition: 'to talk, to chat; conversation; surname',
    pinyin: ['tán'],
    decomposition: '⿰言炎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '炎',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '諉',
    definition: 'to shirk, to pass the buck, to make excuses',
    pinyin: ['wěi'],
    decomposition: '⿰言委',
    etymology: {
      type: 'pictophonetic',
      phonetic: '委',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '請',
    definition: 'to ask, to request; to invite; please',
    pinyin: ['qǐng'],
    decomposition: '⿰言青',
    etymology: {
      type: 'pictophonetic',
      phonetic: '青',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '諒',
    definition: 'to excuse, to forgive; to guess, to presume',
    pinyin: ['liàng'],
    decomposition: '⿰言京',
    etymology: {
      type: 'pictophonetic',
      phonetic: '京',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '論',
    definition: 'debate; discussion',
    pinyin: ['lùn'],
    decomposition: '⿰言侖',
    etymology: {
      type: 'ideographic',
      hint: 'Speech 言 that explains the logic 侖; 侖 also provides the pronunciation',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '諛',
    definition: 'to flatter, to cajole',
    pinyin: ['yú'],
    decomposition: '⿰言臾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臾',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '諜',
    definition: 'to spy; an intelligence report',
    pinyin: ['dié'],
    decomposition: '⿰言枼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '枼',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '諠',
    definition: 'noisy, uproarious; to forget',
    pinyin: ['xuān'],
    decomposition: '⿰言宣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宣',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '諡',
    definition: 'posthumous name or title',
    pinyin: ['shì'],
    decomposition: '⿰言㿽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㿽',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '諢',
    definition: 'joke, jest; nickname; obscene joke',
    pinyin: ['hùn'],
    decomposition: '⿰言軍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '軍',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '諤',
    definition: 'candid, frank; honest speech',
    pinyin: ['è'],
    decomposition: '⿰言咢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咢',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '諦',
    definition: 'careful, attentive; to examine; the truth',
    pinyin: ['dì'],
    decomposition: '⿰言帝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '帝',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '諧',
    definition: 'to joke, to jest; to harmonize, to agree',
    pinyin: ['xié'],
    decomposition: '⿰言皆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皆',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '諫',
    definition: 'to admonish, to remonstrate',
    pinyin: ['jiàn'],
    decomposition: '⿰言柬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '柬',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '諭',
    definition: 'to proclaim; to instruct; edict',
    pinyin: ['yù'],
    decomposition: '⿰言俞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '俞',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '諮',
    definition: 'to consult, to confer with; recommendation, advice',
    pinyin: ['zī'],
    decomposition: '⿰言咨',
    etymology: {
      type: 'ideographic',
      hint: 'To discuss 言 a plan 咨; 咨 also provides the pronunciation',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '諱',
    definition: 'taboo; to shun, to conceal, to avoid mentioning',
    pinyin: ['huì'],
    decomposition: '⿰言韋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韋',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '諳',
    definition: 'well-versed in, fully acquainted with',
    pinyin: ['ān'],
    decomposition: '⿰言音',
    etymology: {
      type: 'pictophonetic',
      phonetic: '音',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '諶',
    definition: 'faithful, sincere; surname',
    pinyin: ['chén'],
    decomposition: '⿰言甚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甚',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '諷',
    definition: 'sarcastic; to chant, to mock, to ridicule',
    pinyin: ['fěng'],
    decomposition: '⿰言風',
    etymology: {
      type: 'pictophonetic',
      phonetic: '風',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '諸',
    definition: 'all, many, various; surname',
    pinyin: ['zhū'],
    decomposition: '⿰言者',
    etymology: {
      type: 'pictophonetic',
      phonetic: '者',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '諺',
    definition: 'proverb, maxim',
    pinyin: ['yàn'],
    decomposition: '⿰言彦',
    etymology: {
      type: 'ideographic',
      hint: 'Elegant 彦 words 言; 彦 also provides the pronunciation',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '諾',
    definition: 'to promise; to approve, to assent to',
    pinyin: ['nuò'],
    decomposition: '⿰言若',
    etymology: {
      type: 'pictophonetic',
      phonetic: '若',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '謀',
    definition: 'to plan, to scheme; strategem',
    pinyin: ['móu'],
    decomposition: '⿰言某',
    etymology: {
      type: 'pictophonetic',
      phonetic: '某',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '謁',
    definition: 'to visit, to pay respects',
    pinyin: ['yè'],
    decomposition: '⿰言曷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曷',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '謂',
    definition: 'to call, to say, to tell; name, title; meaning',
    pinyin: ['wèi'],
    decomposition: '⿰言胃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '胃',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '謄',
    definition: 'to copy, to transcribe',
    pinyin: ['téng'],
    decomposition: '⿰月誊',
    etymology: {
      type: 'ideographic',
      hint: 'To make 誊 a copy 月; 誊 also provides the pronunciation',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '謅',
    definition: 'to quip, to play with words, to talk nonsense',
    pinyin: ['zhōu'],
    decomposition: '⿰言芻',
    etymology: {
      type: 'pictophonetic',
      phonetic: '芻',
      semantic: '言',
      hint: 'words',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '謇',
    definition: 'to stutter; to speak boldly',
    pinyin: ['jiǎn'],
    decomposition: '⿳宀？言',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宀',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '謊',
    definition: 'to lie',
    pinyin: ['huǎng'],
    decomposition: '⿰言荒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '荒',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '謎',
    definition: 'riddle, puzzle, conundrum',
    pinyin: ['mí'],
    decomposition: '⿰言迷',
    etymology: {
      type: 'ideographic',
      hint: 'Bewitching 迷 words 言; 迷 also provides the pronunciation',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '謔',
    definition: 'to jeer',
    pinyin: ['xuè'],
    decomposition: '⿰言虐',
    etymology: {
      type: 'ideographic',
      hint: 'To use cruel 虐 words 言; 虐 also provides the pronunciation',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '謗',
    definition: 'to slander, to defame',
    pinyin: ['bàng'],
    decomposition: '⿰言旁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旁',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '謙',
    definition: 'humble, modest',
    pinyin: ['qiān'],
    decomposition: '⿰言兼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兼',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '謚',
    definition: 'posthumous name or title',
    pinyin: ['shì'],
    decomposition: '⿰言益',
    etymology: {
      type: 'pictophonetic',
      phonetic: '益',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '講',
    definition: 'talk, speech, lecture; to speak, to explain',
    pinyin: ['jiǎng'],
    decomposition: '⿰言冓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冓',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '謝',
    definition: 'to thank; to refuse politely',
    pinyin: ['xiè'],
    decomposition: '⿰言射',
    etymology: {
      type: 'pictophonetic',
      phonetic: '射',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '謠',
    definition: 'rumor; folksong, ballad',
    pinyin: ['yáo'],
    decomposition: '⿰言䍃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '言',
      semantic: '䍃',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '謦',
    definition: 'to speak softly',
    pinyin: ['qìng'],
    decomposition: '⿱殸言',
    etymology: {
      type: 'pictophonetic',
      phonetic: '殸',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '謨',
    definition: 'to scheme, to plan; to practice',
    pinyin: ['mó'],
    decomposition: '⿰言莫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '莫',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '謫',
    definition: 'to censure, to blame; to exile, to banish',
    pinyin: ['zhé'],
    decomposition: '⿰言啇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '啇',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '謬',
    definition: 'absurd; error, exaggeration',
    pinyin: ['miù'],
    decomposition: '⿰言翏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '翏',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '謳',
    definition: 'songs; to sing',
    pinyin: ['ōu'],
    decomposition: '⿰言區',
    etymology: {
      type: 'pictophonetic',
      phonetic: '區',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '謹',
    definition: 'prudent, cautious, attentive',
    pinyin: ['jǐn'],
    decomposition: '⿰言堇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堇',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '謾',
    definition: 'to slight, to insult; to deceive',
    pinyin: ['mán'],
    decomposition: '⿰言曼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曼',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '證',
    definition: 'to prove, to verify; certificate, proof',
    pinyin: ['zhèng'],
    decomposition: '⿰言登',
    etymology: {
      type: 'pictophonetic',
      phonetic: '登',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '譎',
    definition: 'cunning, crafty, sly',
    pinyin: ['jué'],
    decomposition: '⿰言矞',
    etymology: {
      type: 'ideographic',
      hint: 'A bright 矞 wit 言; 矞 also provides the pronunciation',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '譏',
    definition: 'to ridicule, to mock, to jeer',
    pinyin: ['jī'],
    decomposition: '⿰言幾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '幾',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '譖',
    definition: 'to slander',
    pinyin: ['zèn'],
    decomposition: '⿰言朁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朁',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '識',
    definition: 'knowledge; to understand, to recognize, to know',
    pinyin: ['shí'],
    decomposition: '⿰言戠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戠',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '譙',
    definition: 'tower; to ridicule, to blame; surname',
    pinyin: ['qiáo'],
    decomposition: '⿰言焦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '焦',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '譚',
    definition: 'surname',
    pinyin: ['tán'],
    decomposition: '⿰言覃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '覃',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '譜',
    definition: 'chart, list, table; spectrum; musical score',
    pinyin: ['pǔ'],
    decomposition: '⿰言普',
    etymology: {
      type: 'pictophonetic',
      phonetic: '普',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '警',
    definition: 'to guard, to watch; alarm, alert',
    pinyin: ['jǐng'],
    decomposition: '⿱敬言',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敬',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '譫',
    definition: 'talkative; incoherent, babbling',
    pinyin: ['zhān'],
    decomposition: '⿰言詹',
    etymology: {
      type: 'ideographic',
      hint: 'Verbose 詹 speech 言; 詹 also provides the pronunciation',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '譬',
    definition: 'example; metaphor, simile',
    pinyin: ['pì'],
    decomposition: '⿱辟言',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辟',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '譭',
    definition: 'to slander, to defame',
    pinyin: ['huǐ'],
    decomposition: '⿰言毁',
    etymology: {
      type: 'ideographic',
      hint: 'Slanderous 毁 words 言; 毁 also provides the pronunciation',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '譯',
    definition: 'to translate, to interpret; to encode, to decode',
    pinyin: ['yì'],
    decomposition: '⿰言睪',
    etymology: {
      type: 'ideographic',
      hint: "Spies' 睪 words 言; 睪 also provides the pronunciation",
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '議',
    definition: 'to consult, to talk over; to criticize, to discuss',
    pinyin: ['yì'],
    decomposition: '⿰言義',
    etymology: {
      type: 'pictophonetic',
      phonetic: '義',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '譴',
    definition: 'to scold, to reprimand, to abuse',
    pinyin: ['qiǎn'],
    decomposition: '⿰言遣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '遣',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '護',
    definition: 'to defend, to guard, to protect; shelter; endorse',
    pinyin: ['hù'],
    decomposition: '⿰言蒦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蒦',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '譽',
    definition: 'fame, reputation; to praise',
    pinyin: ['yù'],
    decomposition: '⿱與言',
    etymology: {
      type: 'pictophonetic',
      phonetic: '與',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '讀',
    definition: 'to study, to learn; to read, to pronounce',
    pinyin: ['dú'],
    decomposition: '⿰言賣',
    etymology: {
      type: 'ideographic',
      hint: "To show off 賣 one's literacy 言",
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '變',
    definition: 'to change, to transform, to alter; rebel',
    pinyin: ['biàn'],
    decomposition: '⿱䜌攵',
    etymology: { type: 'ideographic', hint: 'To foment 攵 rebellion 䜌' },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '讌',
    definition: 'banquet, feast; to entertain, to feast',
    pinyin: ['yàn'],
    decomposition: '⿰言燕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '燕',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '讒',
    definition: 'to slander, to defame; to misrepresent',
    pinyin: ['chán'],
    decomposition: '⿰言毚',
    etymology: { type: 'pictophonetic', phonetic: '毚', semantic: '言' },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '讓',
    definition: 'to allow, to permit, to yield',
    pinyin: ['ràng'],
    decomposition: '⿰言襄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '襄',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '讕',
    definition: 'to slander, to defame; a false accusation',
    pinyin: ['lán'],
    decomposition: '⿰言闌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '闌',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '讖',
    definition: 'prophecy; hint, omen',
    pinyin: ['chèn'],
    decomposition: '⿰言韱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韱',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '讚',
    definition: 'to praise, to eulogize; to commend',
    pinyin: ['zàn'],
    decomposition: '⿰言贊',
    etymology: {
      type: 'ideographic',
      hint: 'Words 言 of praise 贊; 贊 also provides the pronunciation',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '讞',
    definition: 'to decide, to judge; decision, verdict',
    pinyin: ['yàn'],
    decomposition: '⿰言獻',
    etymology: {
      type: 'pictophonetic',
      phonetic: '獻',
      semantic: '言',
      hint: 'speech',
    },
    radical: '言',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '讠',
    definition: 'words, speech; to speak, to say',
    pinyin: ['yán'],
    decomposition: '⿻？？',
    radical: '讠',
    matches: [null, null],
  },
  {
    character: '计',
    definition: 'to calculate, to count; to plan, to reckon; plot, scheme',
    pinyin: ['jì'],
    decomposition: '⿰讠十',
    etymology: {
      type: 'pictophonetic',
      phonetic: '十',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '订',
    definition: 'to make an order; to draw up an agreement',
    pinyin: ['dìng'],
    decomposition: '⿰讠丁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丁',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '讣',
    definition: 'obituary, death notice',
    pinyin: ['fù'],
    decomposition: '⿰讠卜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卜',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '认',
    definition: 'to know, to recognize, to understand',
    pinyin: ['rèn'],
    decomposition: '⿰讠人',
    etymology: {
      type: 'pictophonetic',
      phonetic: '人',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '讥',
    definition: 'to ridicule, to mock, to jeer',
    pinyin: ['jī'],
    decomposition: '⿰讠几',
    etymology: {
      type: 'pictophonetic',
      phonetic: '几',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '讦',
    definition: 'to accuse, to pry; to expose secrets',
    pinyin: ['jié'],
    decomposition: '⿰讠干',
    etymology: { type: 'ideographic', hint: 'Invasive 干 words 讠' },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '讧',
    definition: 'confusion; internal strife',
    pinyin: ['hòng'],
    decomposition: '⿰讠工',
    etymology: {
      type: 'ideographic',
      hint: 'Dissent 讠 among workers 工; 工 also provides the pronunciation',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '讨',
    definition: 'to haggle, to discuss; to demand, to ask for',
    pinyin: ['tǎo'],
    decomposition: '⿰讠寸',
    etymology: { type: 'ideographic', hint: 'To ask 讠 for something 寸' },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '让',
    definition: 'to allow, to permit, to yield',
    pinyin: ['ràng'],
    decomposition: '⿰讠上',
    etymology: {
      type: 'pictophonetic',
      phonetic: '上',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '讪',
    definition: 'to abuse, to slander, to vilify; to ridicule',
    pinyin: ['shàn'],
    decomposition: '⿰讠山',
    etymology: {
      type: 'pictophonetic',
      phonetic: '山',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '讫',
    definition: 'to finish, to conclude; to exhaust',
    pinyin: ['qì'],
    decomposition: '⿰讠乞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乞',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '讬',
    definition: 'to commission, to entrust, to rely on',
    pinyin: ['tuō'],
    decomposition: '⿰讠乇',
    etymology: {
      type: 'ideographic',
      hint: "To depend on 乇 someone's word 讠; 乇 also provides the pronunciation",
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '训',
    definition: 'to teach, to instruct; pattern, example; exegesis',
    pinyin: ['xùn'],
    decomposition: '⿰讠川',
    etymology: {
      type: 'pictophonetic',
      phonetic: '川',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '议',
    definition: 'to consult, to talk over; to criticize, to discuss',
    pinyin: ['yì'],
    decomposition: '⿰讠义',
    etymology: {
      type: 'pictophonetic',
      phonetic: '义',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '讯',
    definition: 'news, information; to question, to interrogate',
    pinyin: ['xùn'],
    decomposition: '⿰讠卂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卂',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '记',
    definition: 'mark, sign; to note, to record',
    pinyin: ['jì'],
    decomposition: '⿰讠己',
    etymology: {
      type: 'ideographic',
      hint: 'A private 己 note 讠; 己 also provides the pronunciation',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '讲',
    definition: 'talk, speech, lecture; to speak, to explain',
    pinyin: ['jiǎng'],
    decomposition: '⿰讠井',
    etymology: {
      type: 'pictophonetic',
      phonetic: '井',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '讳',
    definition: 'taboo; to shun, to conceal, to avoid mentioning',
    pinyin: ['huì'],
    decomposition: '⿰讠韦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韦',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '讴',
    definition: 'songs; to sing',
    pinyin: ['ōu'],
    decomposition: '⿰讠区',
    etymology: {
      type: 'pictophonetic',
      phonetic: '区',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '讵',
    definition: 'an interjection of surprise',
    pinyin: ['jù'],
    decomposition: '⿰讠巨',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巨',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '讶',
    definition: 'amazed, surprised; to express surprise',
    pinyin: ['yà'],
    decomposition: '⿰讠牙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '牙',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '讷',
    definition: 'inarticulate, slow; to mumble, to stammer',
    pinyin: ['nè'],
    decomposition: '⿰讠内',
    etymology: {
      type: 'pictophonetic',
      phonetic: '内',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '许',
    definition: 'to consent, to permit; to promise, to betroth',
    pinyin: ['xǔ'],
    decomposition: '⿰讠午',
    etymology: {
      type: 'pictophonetic',
      phonetic: '午',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '讹',
    definition: 'to swindle, to cheat; wrong, error; falsehood',
    pinyin: ['é'],
    decomposition: '⿰讠化',
    etymology: {
      type: 'pictophonetic',
      phonetic: '化',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '论',
    definition: 'debate; discussion',
    pinyin: ['lùn'],
    decomposition: '⿰讠仑',
    etymology: {
      type: 'ideographic',
      hint: 'Speech 讠 that explains the logic 仑; 仑 also provides the pronunciation',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '讼',
    definition: 'to accuse, to argue; to dispute, to litigate',
    pinyin: ['sòng'],
    decomposition: '⿰讠公',
    etymology: {
      type: 'pictophonetic',
      phonetic: '公',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '讽',
    definition: 'sarcastic; to chant, to mock, to ridicule',
    pinyin: ['fěng'],
    decomposition: '⿰讠风',
    etymology: {
      type: 'pictophonetic',
      phonetic: '风',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '设',
    definition: 'to build, to design; to establish; to offer',
    pinyin: ['shè'],
    decomposition: '⿰讠殳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '殳',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '访',
    definition: 'to visit; to inquire, to ask',
    pinyin: ['fǎng'],
    decomposition: '⿰讠方',
    etymology: {
      type: 'pictophonetic',
      phonetic: '方',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '诀',
    definition: 'to take leave of, to bid farewell; knack, trick',
    pinyin: ['jué'],
    decomposition: '⿰讠夬',
    etymology: {
      type: 'ideographic',
      hint: 'Words 讠 said at a parting 夬; 夬 also provides the pronunciation',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '证',
    definition: 'to prove, to verify; certificate, proof',
    pinyin: ['zhèng'],
    decomposition: '⿰讠正',
    etymology: {
      type: 'ideographic',
      hint: 'To speak 讠 the truth 正; 正 also provides the pronunciation',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '诂',
    definition: 'explanation; to comment, to explain',
    pinyin: ['gǔ'],
    decomposition: '⿰讠古',
    etymology: {
      type: 'pictophonetic',
      phonetic: '古',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '诃',
    definition: 'to scold loudly, to curse, to abuse',
    pinyin: ['hē'],
    decomposition: '⿰讠可',
    etymology: {
      type: 'pictophonetic',
      phonetic: '可',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '评',
    definition: 'to appraise, to criticize, to evaluate',
    pinyin: ['píng'],
    decomposition: '⿰讠平',
    etymology: {
      type: 'pictophonetic',
      phonetic: '平',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '诅',
    definition: 'to curse; to pledge, to swear',
    pinyin: ['zǔ'],
    decomposition: '⿰讠且',
    etymology: {
      type: 'pictophonetic',
      phonetic: '且',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '识',
    definition: 'knowledge; to understand, to recognize, to know',
    pinyin: ['shí'],
    decomposition: '⿰讠只',
    etymology: {
      type: 'pictophonetic',
      phonetic: '只',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '诈',
    definition: 'to cheat, to defraud; sly, treacherous',
    pinyin: ['zhà'],
    decomposition: '⿰讠乍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乍',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '诉',
    definition: 'to accuse, to sue; to inform; to narrate',
    pinyin: ['sù'],
    decomposition: '⿰讠斥',
    etymology: {
      type: 'ideographic',
      hint: 'Words 讠 of blame 斥; 斥 also provides the pronunciation',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '诊',
    definition: 'to diagnose; to examine a patient',
    pinyin: ['zhěn'],
    decomposition: '⿰讠㐱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㐱',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '诋',
    definition: 'to slander; to condem, to reproach',
    pinyin: ['dǐ'],
    decomposition: '⿰讠氐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '氐',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '诌',
    definition: 'to quip, to play with words, to talk nonsense',
    pinyin: ['zhōu'],
    decomposition: '⿰讠刍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '刍',
      semantic: '讠',
      hint: 'words',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '词',
    definition: 'phrase, expression; words, speech',
    pinyin: ['cí'],
    decomposition: '⿰讠司',
    etymology: {
      type: 'pictophonetic',
      phonetic: '司',
      semantic: '讠',
      hint: 'words',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '诎',
    definition: 'to stutter, to exhaust; to crouch, to bend',
    pinyin: ['qū'],
    decomposition: '⿰讠出',
    etymology: {
      type: 'pictophonetic',
      phonetic: '出',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '诏',
    definition: 'to proclaim, to decree; imperial decree',
    pinyin: ['zhào'],
    decomposition: '⿰讠召',
    etymology: {
      type: 'ideographic',
      hint: 'To issue 讠 a decree 召; 召 also provides the pronunciation',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '译',
    definition: 'to translate, to interpret; to encode, to decode',
    pinyin: ['yì'],
    decomposition: '⿰讠？',
    etymology: { type: 'pictophonetic', semantic: '讠', hint: 'speech' },
    radical: '讠',
    matches: [[0], [0], null, null, null, null, null],
  },
  {
    character: '诒',
    definition: 'to bequeath, to pass on',
    pinyin: ['yí'],
    decomposition: '⿰讠台',
    etymology: {
      type: 'pictophonetic',
      phonetic: '台',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '诓',
    definition: 'to swindle, to cheat; to lie',
    pinyin: ['kuāng'],
    decomposition: '⿰讠匡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匡',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诔',
    definition: 'to praise, to eulogize',
    pinyin: ['lěi'],
    decomposition: '⿰讠耒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '耒',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '试',
    definition: 'to try, to experiment; exam, test',
    pinyin: ['shì'],
    decomposition: '⿰讠式',
    etymology: {
      type: 'pictophonetic',
      phonetic: '式',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诖',
    definition: 'error, mistake; to deceive, to mislead',
    pinyin: ['guà'],
    decomposition: '⿰讠圭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '圭',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诗',
    definition: 'poetry; poem, verse, ode',
    pinyin: ['shī'],
    decomposition: '⿰讠寺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寺',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诘',
    definition: 'to question, to interrogate',
    pinyin: ['jí'],
    decomposition: '⿰讠吉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吉',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诙',
    definition: 'to tease, to joke with; to ridicule, to mock',
    pinyin: ['huī'],
    decomposition: '⿰讠灰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '灰',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诚',
    definition: 'honest, sincere, true; actually, really',
    pinyin: ['chéng'],
    decomposition: '⿰讠成',
    etymology: {
      type: 'pictophonetic',
      phonetic: '成',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诛',
    definition: 'to execute, to kill; to punish',
    pinyin: ['zhū'],
    decomposition: '⿰讠朱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朱',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诜',
    definition: 'to question; to inform',
    pinyin: ['shēn'],
    decomposition: '⿰讠先',
    etymology: {
      type: 'pictophonetic',
      phonetic: '先',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '话',
    definition: 'talk, speech; language, dialect',
    pinyin: ['huà'],
    decomposition: '⿰讠舌',
    etymology: {
      type: 'ideographic',
      hint: 'A spoken 讠 tongue 舌; 舌 also provides the pronunciation',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诞',
    definition: 'to give birth, to bear children; birth, birthday',
    pinyin: ['dàn'],
    decomposition: '⿰讠延',
    etymology: {
      type: 'pictophonetic',
      phonetic: '延',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诟',
    definition: 'to abuse, to scold; to berate, to insult',
    pinyin: ['gòu'],
    decomposition: '⿰讠后',
    etymology: {
      type: 'pictophonetic',
      phonetic: '后',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诠',
    definition: 'to expound, to explain, to comment on',
    pinyin: ['quán'],
    decomposition: '⿰讠全',
    etymology: {
      type: 'pictophonetic',
      phonetic: '全',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诡',
    definition: 'to cheat, to defraud; sly, treacherous',
    pinyin: ['guǐ'],
    decomposition: '⿰讠危',
    etymology: {
      type: 'pictophonetic',
      phonetic: '危',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '询',
    definition: 'to ask about, to inquire into; to consult',
    pinyin: ['xún'],
    decomposition: '⿰讠旬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旬',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诣',
    definition: 'to reach; achievement, accomplishment',
    pinyin: ['yì'],
    decomposition: '⿰讠旨',
    etymology: {
      type: 'ideographic',
      hint: 'To meet 讠 a goal 旨; 旨 also provides the pronunciation',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诤',
    definition: 'to admonish, to warn; to criticize',
    pinyin: ['zhēng'],
    decomposition: '⿰讠争',
    etymology: {
      type: 'ideographic',
      hint: 'Fighting 争 words 讠; 争 also provides the pronunciation',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '该',
    definition: 'should, ought to, must',
    pinyin: ['gāi'],
    decomposition: '⿰讠亥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亥',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '详',
    definition: 'complete, detailed, thorough',
    pinyin: ['xiáng'],
    decomposition: '⿰讠羊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羊',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诧',
    definition: 'surprised, shocked',
    pinyin: ['chà'],
    decomposition: '⿰讠宅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宅',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诨',
    definition: 'joke, jest; nickname; obscene joke',
    pinyin: ['hùn'],
    decomposition: '⿰讠军',
    etymology: {
      type: 'pictophonetic',
      phonetic: '军',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诩',
    definition: 'to brag, to boast; popular, well-known',
    pinyin: ['xǔ'],
    decomposition: '⿰讠羽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羽',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诫',
    definition: 'to warn, to admonish; warning',
    pinyin: ['jiè'],
    decomposition: '⿰讠戒',
    etymology: {
      type: 'ideographic',
      hint: 'Words 讠 of warning 戒; 戒 also provides the pronunciation',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诬',
    definition: 'to slander, to defame; a false accusation',
    pinyin: ['wū'],
    decomposition: '⿰讠巫',
    etymology: {
      type: 'ideographic',
      hint: 'To start 讠 a witch-hunt 巫; 巫 also provides the pronunciation',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '语',
    definition: 'words, language; saying, expression',
    pinyin: ['yǔ'],
    decomposition: '⿰讠吾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吾',
      semantic: '讠',
      hint: 'words',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诮',
    definition: 'to scold, to blame; to ridicule, to criticize',
    pinyin: ['qiào'],
    decomposition: '⿰讠肖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肖',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '误',
    definition: 'error, fault, mistake; to delay',
    pinyin: ['wù'],
    decomposition: '⿰讠吴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吴',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诰',
    definition: 'to grant; to notify, to inform; to order',
    pinyin: ['gào'],
    decomposition: '⿰讠告',
    etymology: {
      type: 'ideographic',
      hint: 'To verbally 讠 inform 告; 告 also provides the pronunciation',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诱',
    definition: 'to tempt, to persuade, to entice; guide',
    pinyin: ['yòu'],
    decomposition: '⿰讠秀',
    etymology: {
      type: 'ideographic',
      hint: 'To use elegant 秀 words 讠; 秀 also provides the pronunciation',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诲',
    definition: 'to teach, to instruct; to encourage, to urge',
    pinyin: ['huì'],
    decomposition: '⿰讠每',
    etymology: {
      type: 'pictophonetic',
      phonetic: '每',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诳',
    definition: 'to lie, to deceive; to delude, to cheat',
    pinyin: ['kuáng'],
    decomposition: '⿰讠狂',
    etymology: {
      type: 'ideographic',
      hint: 'Mad 狂 speech 讠; 狂 also provides the pronunciation',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '说',
    definition: 'to speak, to say; to scold, to upbraid',
    pinyin: ['shuō'],
    decomposition: '⿰讠兑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兑',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诵',
    definition: 'to chant, to recite, to repeat, to read aloud',
    pinyin: ['sòng'],
    decomposition: '⿰讠甬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甬',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诶',
    definition:
      'oh, hey; surprise (tone 2), disagreement (tone 3), agreement (tone 4)',
    pinyin: ['éi'],
    decomposition: '⿰讠矣',
    etymology: {
      type: 'ideographic',
      hint: 'To verbally 讠 confirm 矣 ; 矣 also provides the pronunciation',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '请',
    definition: 'to ask, to request; to invite; please',
    pinyin: ['qǐng'],
    decomposition: '⿰讠青',
    etymology: {
      type: 'pictophonetic',
      phonetic: '青',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诸',
    definition: 'all, many, various; surname',
    pinyin: ['zhū'],
    decomposition: '⿰讠者',
    etymology: {
      type: 'pictophonetic',
      phonetic: '者',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诹',
    definition: 'to consult, to confer with; to select, to choose',
    pinyin: ['zōu'],
    decomposition: '⿰讠取',
    etymology: {
      type: 'ideographic',
      hint: 'To receive 取 advice 讠; 取 also provides the pronunciation',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诺',
    definition: 'to promise; to approve, to assent to',
    pinyin: ['nuò'],
    decomposition: '⿰讠若',
    etymology: {
      type: 'pictophonetic',
      phonetic: '若',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '读',
    definition: 'to study, to learn; to read, to pronounce',
    pinyin: ['dú'],
    decomposition: '⿰讠卖',
    etymology: {
      type: 'ideographic',
      hint: "To show off 卖 one's literacy 讠",
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诼',
    definition: 'gossip, rumors; to slander',
    pinyin: ['zhuó'],
    decomposition: '⿰讠豖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豖',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诽',
    definition: 'to condemn, to slander, to vilify',
    pinyin: ['fěi'],
    decomposition: '⿰讠非',
    etymology: {
      type: 'pictophonetic',
      phonetic: '非',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '课',
    definition: 'subject, lesson, course; classwork',
    pinyin: ['kè'],
    decomposition: '⿰讠果',
    etymology: {
      type: 'pictophonetic',
      phonetic: '果',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '诿',
    definition: 'to shirk, to pass the buck, to make excuses',
    pinyin: ['wěi'],
    decomposition: '⿰讠委',
    etymology: {
      type: 'pictophonetic',
      phonetic: '委',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谀',
    definition: 'to flatter, to cajole',
    pinyin: ['yú'],
    decomposition: '⿰讠臾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臾',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谁',
    definition: 'who? whom? whose? anyone?',
    pinyin: ['shuí'],
    decomposition: '⿰讠隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隹',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谂',
    definition: 'to counsel, to consult for',
    pinyin: ['shěn'],
    decomposition: '⿰讠念',
    etymology: { type: 'ideographic', hint: 'To give thoughtful 念 advice 讠' },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '调',
    definition: 'tune, melody, key; to transfer, to exchange',
    pinyin: ['diào'],
    decomposition: '⿰讠周',
    etymology: {
      type: 'pictophonetic',
      phonetic: '周',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谄',
    definition: 'to flatter, to cajole; toady, yes-man',
    pinyin: ['chǎn'],
    decomposition: '⿰讠臽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臽',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谅',
    definition: 'to excuse, to forgive; to guess, to presume',
    pinyin: ['liàng'],
    decomposition: '⿰讠京',
    etymology: {
      type: 'pictophonetic',
      phonetic: '京',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谆',
    definition: 'earnest, patient, sincere',
    pinyin: ['zhūn'],
    decomposition: '⿰讠享',
    etymology: {
      type: 'ideographic',
      hint: 'One who freely shares 享 advice 讠; 享 also provides the pronunciation',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谇',
    definition: 'to slander, to defame; to berate',
    pinyin: ['suì'],
    decomposition: '⿰讠卒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卒',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谈',
    definition: 'to talk, to chat; conversation; surname',
    pinyin: ['tán'],
    decomposition: '⿰讠炎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '炎',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谊',
    definition: 'friendship; appropriate, suitable',
    pinyin: ['yì'],
    decomposition: '⿰讠宜',
    etymology: {
      type: 'ideographic',
      hint: 'Fitting 宜 speech 讠; 宜 also provides the pronunciation',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谋',
    definition: 'to plan, to scheme; strategem',
    pinyin: ['móu'],
    decomposition: '⿰讠某',
    etymology: {
      type: 'pictophonetic',
      phonetic: '某',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谌',
    definition: 'faithful, sincere; surname',
    pinyin: ['chén'],
    decomposition: '⿰讠甚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甚',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谍',
    definition: 'to spy; an intelligence report',
    pinyin: ['dié'],
    decomposition: '⿰讠枼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '枼',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谎',
    definition: 'to lie',
    pinyin: ['huǎng'],
    decomposition: '⿰讠荒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '荒',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谏',
    definition: 'to admonish, to remonstrate',
    pinyin: ['jiàn'],
    decomposition: '⿰讠柬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '柬',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谐',
    definition: 'to joke, to jest; to harmonize, to agree',
    pinyin: ['xié'],
    decomposition: '⿰讠皆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皆',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谑',
    definition: 'to jeer',
    pinyin: ['xuè'],
    decomposition: '⿰讠虐',
    etymology: {
      type: 'ideographic',
      hint: 'To use cruel 虐 words 讠; 虐 also provides the pronunciation',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谒',
    definition: 'to visit, to pay respects',
    pinyin: ['yè'],
    decomposition: '⿰讠曷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曷',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谓',
    definition: 'to call, to say, to tell; name, title; meaning',
    pinyin: ['wèi'],
    decomposition: '⿰讠胃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '胃',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谔',
    definition: 'candid, frank; honest speech',
    pinyin: ['è'],
    decomposition: '⿰讠咢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咢',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谕',
    definition: 'to proclaim; to instruct; edict',
    pinyin: ['yù'],
    decomposition: '⿰讠俞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '俞',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谖',
    definition: 'to forget; to cheat, to lie',
    pinyin: ['xuān'],
    decomposition: '⿰讠爰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爰',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谗',
    definition: 'to slander, to defame; to misrepresent',
    pinyin: ['chán'],
    decomposition: '⿰讠⿱免？',
    etymology: {
      type: 'pictophonetic',
      phonetic: '免',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      null,
      null,
    ],
  },
  {
    character: '谘',
    definition: 'to consult, to confer with; recommendation, advice',
    pinyin: ['zī'],
    decomposition: '⿰讠咨',
    etymology: {
      type: 'ideographic',
      hint: 'To discuss 讠 a plan 咨; 咨 also provides the pronunciation',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谙',
    definition: 'well-versed in, fully acquainted with',
    pinyin: ['ān'],
    decomposition: '⿰讠音',
    etymology: {
      type: 'pictophonetic',
      phonetic: '音',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谚',
    definition: 'proverb, maxim',
    pinyin: ['yàn'],
    decomposition: '⿰讠彦',
    etymology: {
      type: 'ideographic',
      hint: 'Elegant 彦 words 讠; 彦 also provides the pronunciation',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谛',
    definition: 'careful, attentive; to examine; the truth',
    pinyin: ['dì'],
    decomposition: '⿰讠帝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '帝',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谜',
    definition: 'riddle, puzzle, conundrum',
    pinyin: ['mí'],
    decomposition: '⿰讠迷',
    etymology: {
      type: 'ideographic',
      hint: 'Bewitching 迷 words 讠; 迷 also provides the pronunciation',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谝',
    definition: 'to brag, to boast; to quibble',
    pinyin: ['piǎn'],
    decomposition: '⿰讠扁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '扁',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谟',
    definition: 'to scheme, to plan; to practice',
    pinyin: ['mó'],
    decomposition: '⿰讠莫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '莫',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谠',
    definition: 'counsel, advice; to speak out',
    pinyin: ['dǎng'],
    decomposition: '⿰讠党',
    etymology: {
      type: 'pictophonetic',
      phonetic: '党',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谡',
    definition: 'to raise; to start, to prepare',
    pinyin: ['sù'],
    decomposition: '⿰讠畟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畟',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谢',
    definition: 'to thank; to refuse politely',
    pinyin: ['xiè'],
    decomposition: '⿰讠射',
    etymology: {
      type: 'pictophonetic',
      phonetic: '射',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谣',
    definition: 'rumor; folksong, ballad',
    pinyin: ['yáo'],
    decomposition: '⿰讠䍃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '䍃',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谤',
    definition: 'to slander, to defame',
    pinyin: ['bàng'],
    decomposition: '⿰讠旁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旁',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谥',
    definition: 'posthumous name or title',
    pinyin: ['shì'],
    decomposition: '⿰讠益',
    etymology: {
      type: 'pictophonetic',
      phonetic: '益',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谦',
    definition: 'humble, modest',
    pinyin: ['qiān'],
    decomposition: '⿰讠兼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兼',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谧',
    definition: 'calm, quiet, still; cautious',
    pinyin: ['mì'],
    decomposition: '⿰讠⿱必皿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '必',
      hint: 'speech',
      semantic: '讠',
    },
    radical: '讠',
    matches: [
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '谨',
    definition: 'prudent, cautious, attentive',
    pinyin: ['jǐn'],
    decomposition: '⿰讠堇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堇',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谩',
    definition: 'to slight, to insult; to deceive',
    pinyin: ['mán'],
    decomposition: '⿰讠曼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曼',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谪',
    definition: 'to censure, to blame; to exile, to banish',
    pinyin: ['zhé'],
    decomposition: '⿰讠啇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '啇',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谫',
    definition: 'shallow; stupid',
    pinyin: ['jiǎn'],
    decomposition: '⿰讠剪',
    etymology: {
      type: 'pictophonetic',
      phonetic: '剪',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谬',
    definition: 'absurd; error, exaggeration',
    pinyin: ['miù'],
    decomposition: '⿰讠翏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '翏',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '谭',
    definition: 'surname',
    pinyin: ['tán'],
    decomposition: '⿰讠覃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '覃',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '谮',
    definition: 'to slander',
    pinyin: ['zèn'],
    decomposition: '⿰讠朁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朁',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '谯',
    definition: 'tower; to ridicule, to blame; surname',
    pinyin: ['qiáo'],
    decomposition: '⿰讠焦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '焦',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '谰',
    definition: 'to slander, to defame; a false accusation',
    pinyin: ['lán'],
    decomposition: '⿰讠阑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '阑',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '谱',
    definition: 'chart, list, table; spectrum; musical score',
    pinyin: ['pǔ'],
    decomposition: '⿰讠普',
    etymology: {
      type: 'pictophonetic',
      phonetic: '普',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '谲',
    definition: 'cunning, crafty, sly',
    pinyin: ['jué'],
    decomposition: '⿰讠矞',
    etymology: {
      type: 'ideographic',
      hint: 'A bright 矞 wit 讠; 矞 also provides the pronunciation',
    },
    radical: '讠',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '谳',
    definition: 'to decide, to judge; decision, verdict',
    pinyin: ['yàn'],
    decomposition: '⿰讠献',
    etymology: {
      type: 'pictophonetic',
      phonetic: '献',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '谴',
    definition: 'to scold, to reprimand, to abuse',
    pinyin: ['qiǎn'],
    decomposition: '⿰讠遣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '遣',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '谵',
    definition: 'talkative; incoherent, babbling',
    pinyin: ['zhān'],
    decomposition: '⿰讠詹',
    etymology: {
      type: 'ideographic',
      hint: 'Verbose 詹 speech 讠; 詹 also provides the pronunciation',
    },
    radical: '讠',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '谶',
    definition: 'prophecy; hint, omen',
    pinyin: ['chèn'],
    decomposition: '⿰讠韱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韱',
      semantic: '讠',
      hint: 'speech',
    },
    radical: '讠',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '谷',
    definition: 'valley, gorge, ravine',
    pinyin: ['gǔ'],
    decomposition: '⿱八⿱人口',
    etymology: {
      type: 'ideographic',
      hint: 'Water flowing 人 from a spring 口 through a valley 八',
    },
    radical: '谷',
    matches: [[0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '谿',
    definition: 'valley, gorge; mountain stream',
    pinyin: ['xī'],
    decomposition: '⿰奚谷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奚',
      semantic: '谷',
      hint: 'valley',
    },
    radical: '谷',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '豁',
    definition: 'clear, open; exempt',
    pinyin: ['huō'],
    decomposition: '⿰害谷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '害',
      semantic: '谷',
      hint: 'valley',
    },
    radical: '谷',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '豆',
    definition: 'beans, peas; bean-shaped',
    pinyin: ['dòu'],
    decomposition: '⿳一口⿱丷一',
    etymology: {
      type: 'pictographic',
      hint: 'An old serving dish 口 on a stand with a lid 一',
    },
    radical: '豆',
    matches: [[0], [1], [1], [1], [2, 0], [2, 0], [2, 1]],
  },
  {
    character: '豇',
    definition: 'kidney bean; black-eyed pea',
    pinyin: ['jiāng'],
    decomposition: '⿰豆工',
    etymology: {
      type: 'pictophonetic',
      phonetic: '工',
      semantic: '豆',
      hint: 'beans',
    },
    radical: '豆',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '豈',
    definition: 'what; how',
    pinyin: ['qǐ'],
    decomposition: '⿱山豆',
    radical: '豆',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '豉',
    definition: 'fermented beans',
    pinyin: ['shì'],
    decomposition: '⿰豆支',
    etymology: {
      type: 'pictophonetic',
      phonetic: '支',
      semantic: '豆',
      hint: 'beans',
    },
    radical: '豆',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '豊',
    definition: 'abundant, lush, bountiful, plenty',
    pinyin: ['lǐ'],
    decomposition: '⿱曲豆',
    etymology: {
      type: 'ideographic',
      hint: 'A stalk bent crooked 曲 by the weight of its beans 豆',
    },
    radical: '豆',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '豌',
    definition: 'peas',
    pinyin: ['wān'],
    decomposition: '⿰豆宛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宛',
      semantic: '豆',
      hint: 'peas',
    },
    radical: '豆',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '豎',
    definition: 'perpendicular, vertical; to erect',
    pinyin: ['shù'],
    decomposition: '⿱臤豆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豆',
      semantic: '臤',
      hint: 'stern',
    },
    radical: '豆',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '豐',
    definition: 'abundant, lush, bountiful, plenty',
    pinyin: ['fēng'],
    decomposition: '⿱⿻山⿰丰丰豆',
    etymology: {
      type: 'ideographic',
      hint: 'A bean plant 豆 with much fruit 丰; 丰 also provides the pronunciation',
    },
    radical: '豆',
    matches: [
      [0, 0],
      [0, 1, 0],
      [0, 1, 0],
      [0, 1, 0],
      [0, 1, 0],
      [0, 1, 1],
      [0, 1, 1],
      [0, 1, 1],
      [0, 1, 1],
      [0, 0],
      [0, 0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '豔',
    definition: 'beautiful, plump, voluptuous',
    pinyin: ['yàn'],
    decomposition: '⿰豐盍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豐',
      semantic: '盍',
      hint: 'lush',
    },
    radical: '豆',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '豕',
    definition: 'pig, boar',
    pinyin: ['shǐ'],
    decomposition: '⿱一⿰勿？',
    etymology: { type: 'pictographic', hint: 'A pig drawn on its side' },
    radical: '豕',
    matches: [[0], [1, 0], [1, 0], [1, 0], [1, 0], null, null],
  },
  {
    character: '豖',
    definition: 'a shackled pig',
    pinyin: ['chù'],
    decomposition: '⿻豕丶',
    etymology: { type: 'pictographic', hint: 'A pig 豕 in shackles 丶' },
    radical: '豕',
    matches: [[0], [0], [0], [0], [0], [1], [0], [0]],
  },
  {
    character: '豙',
    pinyin: ['yì'],
    decomposition: '⿱立豕',
    radical: '豕',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '豚',
    definition: 'suckling pig; to suckle',
    pinyin: ['tún'],
    decomposition: '⿰⺼豕',
    etymology: {
      type: 'pictographic',
      hint: "A pig 豕 suckling at its mother's teat ⺼",
    },
    radical: '豕',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '象',
    definition: 'elephant; ivory; figure, image',
    pinyin: ['xiàng'],
    decomposition: '⿳⺈口豕',
    etymology: { type: 'pictophonetic', semantic: '豕', hint: 'boar' },
    radical: '豕',
    matches: [[0], [0], [1], [1], [1], [2], [2], [2], [2], [2], [2]],
  },
  {
    character: '豢',
    definition: 'domestic animal; to feed, to raise',
    pinyin: ['huàn'],
    decomposition: '⿱龹豕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龹',
      semantic: '豕',
      hint: 'pig',
    },
    radical: '豕',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '豦',
    definition: 'wild boar; to fight',
    pinyin: ['jù'],
    decomposition: '⿸虍豕',
    etymology: { type: 'ideographic', hint: 'A boar 豕 fighting a tiger 虍' },
    radical: '豕',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '豩',
    definition: 'a group of pigs',
    pinyin: ['bīn'],
    decomposition: '⿰豕豕',
    etymology: { type: 'ideographic', hint: 'Two pigs 豕 representing a herd' },
    radical: '豕',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '豪',
    definition: 'brave, heroic, chivalrous',
    pinyin: ['háo'],
    decomposition: '⿱高豕',
    etymology: {
      type: 'pictophonetic',
      semantic: '豕',
      hint: 'boar',
      phonetic: '高',
    },
    radical: '豕',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '豫',
    definition: 'relaxed; hesitant',
    pinyin: ['yù'],
    decomposition: '⿰予象',
    etymology: {
      type: 'pictophonetic',
      phonetic: '予',
      semantic: '象',
      hint: 'elephant',
    },
    radical: '豕',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '豬',
    definition: 'pig, hog, wild boar',
    pinyin: ['zhū'],
    decomposition: '⿰豕者',
    etymology: {
      type: 'pictophonetic',
      phonetic: '者',
      semantic: '豕',
      hint: 'animal',
    },
    radical: '豕',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '豱',
    definition: 'short-snouted pig',
    pinyin: ['wēn'],
    decomposition: '⿰豕昷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昷',
      semantic: '豕',
      hint: 'pig',
    },
    radical: '豕',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      null,
    ],
  },
  {
    character: '豳',
    definition: 'a Zhou-dynasty state',
    pinyin: ['bīn'],
    decomposition: '⿻山豩',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豩',
      semantic: '山',
      hint: 'mountain',
    },
    radical: '豕',
    matches: [
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
    ],
  },
  {
    character: '豸',
    definition: 'badger; legendary beast',
    pinyin: ['zhì'],
    decomposition: '⿱爫犭',
    radical: '豸',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '豹',
    definition: 'leopard, panther; surname',
    pinyin: ['bào'],
    decomposition: '⿰豸勺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '勺',
      semantic: '豸',
      hint: 'beast',
    },
    radical: '豸',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '豺',
    definition: 'wolf; cruel, mean, wicked',
    pinyin: ['chái'],
    decomposition: '⿰豸才',
    etymology: {
      type: 'pictophonetic',
      phonetic: '才',
      semantic: '豸',
      hint: 'beast',
    },
    radical: '豸',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '豻',
    definition: 'prison, jail; a wild dog',
    pinyin: ['àn'],
    decomposition: '⿰豸干',
    etymology: {
      type: 'pictophonetic',
      phonetic: '干',
      semantic: '豸',
      hint: 'beast',
    },
    radical: '豸',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '貂',
    definition: 'sable, mink, marten',
    pinyin: ['diāo'],
    decomposition: '⿰豸召',
    etymology: {
      type: 'pictophonetic',
      phonetic: '召',
      semantic: '豸',
      hint: 'beast',
    },
    radical: '豸',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '貅',
    definition: 'fierce; brave, courageous',
    pinyin: ['xiū'],
    decomposition: '⿰豸休',
    etymology: {
      type: 'pictophonetic',
      phonetic: '休',
      semantic: '豸',
      hint: 'badger',
    },
    radical: '豸',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '貇',
    definition: 'to bite, to gnaw',
    pinyin: ['kūn'],
    decomposition: '⿰豸艮',
    etymology: {
      type: 'ideographic',
      hint: "A badger's 豸 teeth 艮; 艮 also provides the pronunciation",
    },
    radical: '豸',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '貉',
    definition: 'raccoon dog',
    pinyin: ['háo'],
    decomposition: '⿰豸各',
    etymology: {
      type: 'pictophonetic',
      phonetic: '各',
      semantic: '豸',
      hint: 'beast',
    },
    radical: '豸',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '貊',
    definition: 'leopard; an ancient tribe in northeast China',
    pinyin: ['mò'],
    decomposition: '⿰豸百',
    etymology: {
      type: 'ideographic',
      hint: 'A tribe of a hundred 百 wild beasts 豸',
    },
    radical: '豸',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '貌',
    definition: 'countenance, appearance',
    pinyin: ['mào'],
    decomposition: '⿰豸皃',
    etymology: {
      type: 'ideographic',
      hint: "A beast's 豸 appearance 皃; 皃 also provides the pronunciation",
    },
    radical: '豸',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '貍',
    definition: 'fox, wildcat',
    pinyin: ['lí'],
    decomposition: '⿰豸里',
    etymology: {
      type: 'pictophonetic',
      phonetic: '里',
      semantic: '豸',
      hint: 'animal',
    },
    radical: '豸',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '貓',
    definition: 'cat',
    pinyin: ['māo'],
    decomposition: '⿰豸苗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '苗',
      semantic: '豸',
      hint: 'badger',
    },
    radical: '豸',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '貔',
    definition: 'fox, leopard, panther',
    pinyin: ['pí'],
    decomposition: '⿰豸⿱囟比',
    etymology: {
      type: 'pictophonetic',
      phonetic: '比',
      semantic: '豸',
      hint: 'beast',
    },
    radical: '豸',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '貘',
    definition: 'panther, tapir',
    pinyin: ['mò'],
    decomposition: '⿰豸莫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '莫',
      semantic: '豸',
      hint: 'beast',
    },
    radical: '豸',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '貝',
    definition: 'sea shell; money, currency',
    pinyin: ['bèi'],
    decomposition: '⿱目八',
    etymology: {
      type: 'ideographic',
      hint: 'A sea shell, once used as currency',
    },
    radical: '貝',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '貞',
    definition: 'virtuous, chaste, pure; loyal',
    pinyin: ['zhēn'],
    decomposition: '⿱⺊貝',
    radical: '貝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '負',
    definition: 'load, burden; to carry, to bear',
    pinyin: ['fù'],
    decomposition: '⿱⺈貝',
    etymology: {
      type: 'ideographic',
      hint: 'A person 人 carrying a lot of money 貝',
    },
    radical: '貝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '財',
    definition: 'riches, wealth, valuables',
    pinyin: ['cái'],
    decomposition: '⿰貝才',
    etymology: {
      type: 'pictophonetic',
      phonetic: '才',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '貢',
    definition: 'to offer, to contribute; tribute, gifts',
    pinyin: ['gòng'],
    decomposition: '⿱工貝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '工',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '貧',
    definition: 'poor, needy, impoverished; lacking',
    pinyin: ['pín'],
    decomposition: '⿱分貝',
    etymology: {
      type: 'ideographic',
      hint: 'Money 貝 that must be split 分; 分 also provides the pronunciation',
    },
    radical: '貝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '貨',
    definition: 'products, merchandise; goods, commodities',
    pinyin: ['huò'],
    decomposition: '⿱化貝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '化',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '販',
    definition: 'merchant, peddler; to deal in, to trade',
    pinyin: ['fàn'],
    decomposition: '⿰貝反',
    etymology: {
      type: 'pictophonetic',
      phonetic: '反',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '貪',
    definition: 'greedy, covetous; corrupt',
    pinyin: ['tān'],
    decomposition: '⿱今貝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '今',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '貫',
    definition: 'to pierce, to string up; a string of 1000 coins',
    pinyin: ['guàn'],
    decomposition: '⿱毌貝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '毌',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '責',
    definition: "one's responsibility, duty",
    pinyin: ['zé'],
    decomposition: '⿱龶貝',
    etymology: { type: 'ideographic', hint: 'Money 貝 that must be repaid' },
    radical: '貝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '貯',
    definition: 'to store, to stockpile, to hoard',
    pinyin: ['zhù'],
    decomposition: '⿰貝宁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宁',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '貲',
    definition: 'wealth, property; to estimate, to count',
    pinyin: ['zī'],
    decomposition: '⿱此貝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '此',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '貳',
    definition: "two (bankers' anti-fraud numeral)",
    pinyin: ['èr'],
    decomposition: '⿹弋⿱二貝',
    etymology: {
      type: 'ideographic',
      hint: "A banker's 貝 two 二 with accents to prevent forgery",
    },
    radical: '貝',
    matches: [
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [0],
      [0],
    ],
  },
  {
    character: '貴',
    definition: 'expensive, costly; valuable, precious',
    pinyin: ['guì'],
    decomposition: '⿱⿱中一貝',
    etymology: { type: 'pictophonetic', semantic: '貝', hint: 'money' },
    radical: '貝',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '貶',
    definition: 'to devalue, to demote; to criticize, to censure',
    pinyin: ['biǎn'],
    decomposition: '⿰貝乏',
    etymology: { type: 'ideographic', hint: 'To devalue 乏 currency 貝' },
    radical: '貝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '買',
    definition: 'to buy, to purchase; to bribe, to persuade',
    pinyin: ['mǎi'],
    decomposition: '⿱罒貝',
    etymology: { type: 'pictophonetic', semantic: '貝', hint: 'money' },
    radical: '貝',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '貸',
    definition: 'to borrow; to lend; to pardon',
    pinyin: ['dài'],
    decomposition: '⿱代貝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '代',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '費',
    definition: 'expenses, fees; to cost, to spend; wasteful',
    pinyin: ['fèi'],
    decomposition: '⿱弗貝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弗',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '貼',
    definition: 'to stick, to paste; attached; allowance, subsidy',
    pinyin: ['tiē'],
    decomposition: '⿰貝占',
    etymology: {
      type: 'pictophonetic',
      phonetic: '占',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '貽',
    definition: 'to hand down, to give to, to bequeath',
    pinyin: ['yí'],
    decomposition: '⿰貝台',
    etymology: {
      type: 'pictophonetic',
      phonetic: '台',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '貿',
    definition: 'commerce, trade',
    pinyin: ['mào'],
    decomposition: '⿱卯貝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卯',
      semantic: '贝',
      hint: 'money',
    },
    radical: '貝',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '賀',
    definition: 'to congratulate; to send a present',
    pinyin: ['hè'],
    decomposition: '⿱加貝',
    etymology: {
      type: 'ideographic',
      hint: "To add 加 to someone else's fortune 貝",
    },
    radical: '貝',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '賁',
    definition: 'to forge ahead; energetic; surname',
    pinyin: ['bì'],
    decomposition: '⿱卉貝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '貝',
      semantic: '卉',
      hint: 'myriads',
    },
    radical: '貝',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '賂',
    definition: 'bribery; to bribe; to present',
    pinyin: ['lù'],
    decomposition: '⿰貝各',
    etymology: {
      type: 'pictophonetic',
      phonetic: '各',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '賃',
    definition: 'to rent, to lease; to hire; employee',
    pinyin: ['lìn'],
    decomposition: '⿱任貝',
    etymology: { type: 'ideographic', hint: 'Someone 任 working for money 貝' },
    radical: '貝',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '賄',
    definition: 'to bribe; riches, wealth',
    pinyin: ['huì'],
    decomposition: '⿰貝有',
    etymology: { type: 'ideographic', hint: 'To possess 有 wealth 貝' },
    radical: '貝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '賅',
    definition: 'to include; to prepare for',
    pinyin: ['gāi'],
    decomposition: '⿰貝亥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亥',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '資',
    definition: 'wealth, property, capital',
    pinyin: ['zī'],
    decomposition: '⿱次貝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '次',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '賈',
    definition: 'merchant; to buy, to trade; surname',
    pinyin: ['jiǎ'],
    decomposition: '⿱覀貝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '覀',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '賊',
    definition: 'thief, traitor; cunning, sly',
    pinyin: ['zéi'],
    decomposition: '⿰貝戎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '貝',
      semantic: '戎',
      hint: 'weapons',
    },
    radical: '貝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '賏',
    definition: 'necklace; pearls or shells strung together',
    pinyin: ['yīng'],
    decomposition: '⿰貝貝',
    etymology: { type: 'ideographic', hint: 'Two shells 貝 strung together' },
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '賑',
    definition: 'to relieve, to aid; rich',
    pinyin: ['zhèn'],
    decomposition: '⿰貝辰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辰',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '賒',
    definition: 'to buy and sell on credit',
    pinyin: ['shē'],
    decomposition: '⿰貝佘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '佘',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '賓',
    definition: 'guest, visitor; surname; submit',
    pinyin: ['bīn'],
    decomposition: '⿳宀小貝',
    etymology: {
      type: 'ideographic',
      hint: "Someone 小 living under one's roof 宀; 貝 also provides the pronunciation",
    },
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      null,
      [1],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '賙',
    definition: 'to give to charity; to give alms',
    pinyin: ['zhōu'],
    decomposition: '⿰貝周',
    etymology: {
      type: 'pictophonetic',
      phonetic: '周',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '賚',
    definition: 'to bestow, to confer; surname',
    pinyin: ['lài'],
    decomposition: '⿱來貝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '來',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '賜',
    definition: 'to give; to bestow a favor; to appoint',
    pinyin: ['cì'],
    decomposition: '⿰貝易',
    etymology: {
      type: 'pictophonetic',
      phonetic: '易',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '賞',
    definition: 'reward; to appreciate; to bestow, to grant',
    pinyin: ['shǎng'],
    decomposition: '⿱尚貝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尚',
      semantic: '贝',
      hint: 'money',
    },
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '賠',
    definition: 'to compensate, to pay damages, to suffer a loss',
    pinyin: ['péi'],
    decomposition: '⿰貝咅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咅',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '賢',
    definition: 'virtuous, worthy; good, able',
    pinyin: ['xián'],
    decomposition: '⿱臤貝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臤',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '賣',
    definition: 'to sell; to betray; to show off',
    pinyin: ['mài'],
    decomposition: '⿳士罒貝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '买',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '賤',
    definition: 'cheap, low, mean, worthless',
    pinyin: ['jiàn'],
    decomposition: '⿰貝戔',
    etymology: {
      type: 'ideographic',
      hint: 'Costing little 戔 money 貝; 戔 also provides the pronunciation',
    },
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '賦',
    definition: 'tax; to give, to bestow',
    pinyin: ['fù'],
    decomposition: '⿰貝武',
    etymology: {
      type: 'ideographic',
      hint: 'Money 貝 used to raise an army 武; 武 also provides the pronunciation',
    },
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '質',
    definition: 'essence, nature; material, substance',
    pinyin: ['zhì'],
    decomposition: '⿱斦貝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斦',
      semantic: '貝',
      hint: 'shell',
    },
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '賬',
    definition: 'accounts, bills; credit, debt',
    pinyin: ['zhàng'],
    decomposition: '⿰貝長',
    etymology: {
      type: 'pictophonetic',
      phonetic: '長',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '賭',
    definition: 'to bet, to gamble, to wager',
    pinyin: ['dǔ'],
    decomposition: '⿰貝者',
    etymology: {
      type: 'pictophonetic',
      phonetic: '者',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '賴',
    definition: 'to depend on, to rely on; to bilk, to deny; poor',
    pinyin: ['lài'],
    decomposition: '⿰束負',
    etymology: {
      type: 'pictophonetic',
      phonetic: '束',
      semantic: '負',
      hint: 'money',
    },
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '賺',
    definition: 'to earn, to profit, to make money',
    pinyin: ['zhuàn'],
    decomposition: '⿰貝兼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兼',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '購',
    definition: 'to buy, to purchase',
    pinyin: ['gòu'],
    decomposition: '⿰貝冓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冓',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '賽',
    definition: 'to compete, to contend; contest, race',
    pinyin: ['sài'],
    decomposition: '⿱宀⿱？貝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宀',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '贄',
    definition: 'tribute; a gift given to a superior',
    pinyin: ['zhì'],
    decomposition: '⿱執貝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '執',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '贅',
    definition: 'unnecessary, superfluous',
    pinyin: ['zhuì'],
    decomposition: '⿱敖貝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '貝',
      semantic: '敖',
      hint: 'leisure',
    },
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '贈',
    definition: 'to bestow, to confer, to present a gift',
    pinyin: ['zèng'],
    decomposition: '⿰貝曾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曾',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '贊',
    definition: 'to help, to support; to laud, to praise',
    pinyin: ['zàn'],
    decomposition: '⿱兟貝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兟',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '贏',
    definition: 'to win, to gain; surplus, profit',
    pinyin: ['yíng'],
    decomposition: '⿵吂⿲⺼貝？',
    etymology: { type: 'pictophonetic', semantic: '貝', hint: 'money' },
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      null,
      null,
      null,
    ],
  },
  {
    character: '贓',
    definition: 'booty, loot; stolen goods; to bribe',
    pinyin: ['zāng'],
    decomposition: '⿰貝臧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臧',
      semantic: '貝',
      hint: 'money',
    },
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '贔',
    definition: 'strong',
    pinyin: ['bì'],
    decomposition: '⿱貝⿰貝貝',
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '贖',
    definition: 'ransom; to buy; to redeem',
    pinyin: ['shú'],
    decomposition: '⿰貝賣',
    etymology: {
      type: 'ideographic',
      hint: 'To sell 賣 a soul for money 貝; 賣 also provides the pronunciation',
    },
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '贗',
    definition: 'false, bogus; counterfeit; a sham',
    pinyin: ['yàn'],
    decomposition: '⿸鴈貝',
    etymology: {
      type: 'ideographic',
      hint: '"Wild goose" 鴈 money 貝; 鴈 also provides the pronunciation',
    },
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '贛',
    definition: 'Jiangxi province; places therein',
    pinyin: ['gàn'],
    decomposition: '⿰章⿱夂貢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '貢',
      semantic: '夂',
      hint: 'go',
    },
    radical: '貝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '贝',
    definition: 'sea shell; money, currency',
    pinyin: ['bèi'],
    decomposition: '⿵冂人',
    etymology: {
      type: 'pictographic',
      hint: 'A sea shell, once used as currency',
    },
    radical: '贝',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '贞',
    definition: 'virtuous, chaste, pure; loyal',
    pinyin: ['zhēn'],
    decomposition: '⿱⺊贝',
    radical: '⺊',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '负',
    definition: 'load, burden; to carry, to bear',
    pinyin: ['fù'],
    decomposition: '⿱⺈贝',
    etymology: {
      type: 'ideographic',
      hint: 'A person 人 carrying a lot of money 贝',
    },
    radical: '贝',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '贡',
    definition: 'to offer, to contribute; tribute, gifts',
    pinyin: ['gòng'],
    decomposition: '⿱工贝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '工',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '财',
    definition: 'riches, wealth, valuables',
    pinyin: ['cái'],
    decomposition: '⿰贝才',
    etymology: {
      type: 'pictophonetic',
      phonetic: '才',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '责',
    definition: "one's responsibility, duty",
    pinyin: ['zé'],
    decomposition: '⿱龶贝',
    etymology: { type: 'ideographic', hint: 'Money 贝 that must be repaid' },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '贤',
    definition: 'virtuous, worthy; good, able',
    pinyin: ['xián'],
    decomposition: '⿱⿰？又贝',
    etymology: { type: 'pictophonetic', semantic: '贝', hint: 'money' },
    radical: '贝',
    matches: [null, null, [0, 1], [0, 1], [1], [1], [1], [1]],
  },
  {
    character: '败',
    definition: 'failure; to decline, to fail, to suffer defeat',
    pinyin: ['bài'],
    decomposition: '⿰贝攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贝',
      semantic: '攵',
      hint: 'rap',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '账',
    definition: 'accounts, bills; credit, debt',
    pinyin: ['zhàng'],
    decomposition: '⿰贝长',
    etymology: {
      type: 'pictophonetic',
      phonetic: '长',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '货',
    definition: 'products, merchandise; goods, commodities',
    pinyin: ['huò'],
    decomposition: '⿱化贝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '化',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '质',
    definition: 'essence, nature; material, substance',
    pinyin: ['zhì'],
    decomposition: '⿸厂⿱十贝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '十',
      semantic: '贝',
      hint: 'shell',
    },
    radical: '厂',
    matches: [[0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '贩',
    definition: 'merchant, peddler; to deal in, to trade',
    pinyin: ['fàn'],
    decomposition: '⿰贝反',
    etymology: {
      type: 'pictophonetic',
      phonetic: '反',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '贪',
    definition: 'greedy, covetous; corrupt',
    pinyin: ['tān'],
    decomposition: '⿱今贝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '今',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '贫',
    definition: 'poor, needy, impoverished; lacking',
    pinyin: ['pín'],
    decomposition: '⿱分贝',
    etymology: {
      type: 'ideographic',
      hint: 'Money 贝 that must be split 分; 分 also provides the pronunciation',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '贬',
    definition: 'to devalue, to demote; to criticize, to censure',
    pinyin: ['biǎn'],
    decomposition: '⿰贝乏',
    etymology: { type: 'ideographic', hint: 'To devalue 乏 currency 贝' },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '购',
    definition: 'to buy, to purchase',
    pinyin: ['gòu'],
    decomposition: '⿰贝勾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '勾',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '贮',
    definition: 'to store, to stockpile, to hoard',
    pinyin: ['zhù'],
    decomposition: '⿰贝⿱宀一',
    etymology: {
      type: 'ideographic',
      hint: 'Money 贝 kept under one 一 roof 宀',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1, 0], [1, 0], [1, 0], [1, 1]],
  },
  {
    character: '贯',
    definition: 'to pierce, to string up; a string of 1000 coins',
    pinyin: ['guàn'],
    decomposition: '⿱毌贝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '毌',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '贰',
    definition: "two (bankers' anti-fraud numeral)",
    pinyin: ['èr'],
    decomposition: '⿹弋⿱二贝',
    etymology: {
      type: 'ideographic',
      hint: "A banker's 贝 two 二 with accents to prevent forgery",
    },
    radical: '弋',
    matches: [[0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1], [1, 1], [0], [0]],
  },
  {
    character: '贱',
    definition: 'cheap, low, mean, worthless',
    pinyin: ['jiàn'],
    decomposition: '⿰贝戋',
    etymology: {
      type: 'ideographic',
      hint: 'Costing little 戋 money 贝; 戋 also provides the pronunciation',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '贲',
    definition: 'to forge ahead; energetic; surname',
    pinyin: ['bì'],
    decomposition: '⿱卉贝',
    radical: '贝',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '贳',
    definition: 'to borrow; to pardon; loan',
    pinyin: ['shì'],
    decomposition: '⿱世贝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '世',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '贴',
    definition: 'to stick, to paste; attached; allowance, subsidy',
    pinyin: ['tiē'],
    decomposition: '⿰贝占',
    etymology: {
      type: 'pictophonetic',
      phonetic: '占',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '贵',
    definition: 'expensive, costly; valuable, precious',
    pinyin: ['guì'],
    decomposition: '⿱⿱中一贝',
    etymology: { type: 'pictophonetic', semantic: '贝', hint: 'money' },
    radical: '贝',
    matches: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 1], [1], [1], [1], [1]],
  },
  {
    character: '贶',
    definition: 'to bestow, to grant; surname',
    pinyin: ['kuàng'],
    decomposition: '⿰贝兄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兄',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '贷',
    definition: 'to borrow; to lend; to pardon',
    pinyin: ['dài'],
    decomposition: '⿱代贝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '代',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '贸',
    definition: 'commerce, trade',
    pinyin: ['mào'],
    decomposition: '⿱卯贝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卯',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '费',
    definition: 'expenses, fees; to cost, to spend; wasteful',
    pinyin: ['fèi'],
    decomposition: '⿱弗贝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弗',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '贺',
    definition: 'to congratulate; to send a present',
    pinyin: ['hè'],
    decomposition: '⿱加贝',
    etymology: {
      type: 'ideographic',
      hint: "To add 加 to someone else's fortune 贝",
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '贻',
    definition: 'to hand down, to give to, to bequeath',
    pinyin: ['yí'],
    decomposition: '⿰贝台',
    etymology: {
      type: 'pictophonetic',
      phonetic: '台',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '贼',
    definition: 'thief, traitor; cunning, sly',
    pinyin: ['zéi'],
    decomposition: '⿰贝戎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贝',
      semantic: '戎',
      hint: 'weapons',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '贽',
    definition: 'tribute; a gift given to a superior',
    pinyin: ['zhì'],
    decomposition: '⿱执贝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '执',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '贾',
    definition: 'merchant; to buy, to trade; surname',
    pinyin: ['jiǎ'],
    decomposition: '⿱覀贝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '覀',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '贿',
    definition: 'to bribe; riches, wealth',
    pinyin: ['huì'],
    decomposition: '⿰贝有',
    etymology: { type: 'ideographic', hint: 'To possess 有 wealth 贝' },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '赀',
    definition: 'wealth, property; to estimate, to count',
    pinyin: ['zī'],
    decomposition: '⿱此贝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '此',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '赁',
    definition: 'to rent, to lease; to hire; employee',
    pinyin: ['lìn'],
    decomposition: '⿱任贝',
    etymology: { type: 'ideographic', hint: 'Someone 任 working for money 贝' },
    radical: '贝',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '赂',
    definition: 'bribery; to bribe; to present',
    pinyin: ['lù'],
    decomposition: '⿰贝各',
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '赃',
    definition: 'booty, loot; stolen goods; to bribe',
    pinyin: ['zāng'],
    decomposition: '⿰贝庄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '庄',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '资',
    definition: 'wealth, property, capital',
    pinyin: ['zī'],
    decomposition: '⿱次贝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '次',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '赅',
    definition: 'to include; to prepare for',
    pinyin: ['gāi'],
    decomposition: '⿰贝亥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亥',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '赆',
    definition: 'farewell present',
    pinyin: ['jìn'],
    decomposition: '⿰贝尽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尽',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '赇',
    definition: 'to bribe',
    pinyin: ['qiú'],
    decomposition: '⿰贝求',
    etymology: {
      type: 'ideographic',
      hint: 'To beseech 求 with money 贝; 求 also provides the pronunciation',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '赈',
    definition: 'to relieve, to aid; rich',
    pinyin: ['zhèn'],
    decomposition: '⿰贝辰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辰',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '赉',
    definition: 'to bestow, to confer; surname',
    pinyin: ['lài'],
    decomposition: '⿱来贝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '来',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '赊',
    definition: 'to buy and sell on credit',
    pinyin: ['shē'],
    decomposition: '⿰贝佘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '佘',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '赋',
    definition: 'tax; to give, to bestow',
    pinyin: ['fù'],
    decomposition: '⿰贝武',
    etymology: {
      type: 'ideographic',
      hint: 'Money 贝 used to raise an army 武; 武 also provides the pronunciation',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '赌',
    definition: 'to bet, to gamble, to wager',
    pinyin: ['dǔ'],
    decomposition: '⿰贝者',
    etymology: {
      type: 'pictophonetic',
      phonetic: '者',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '赍',
    definition: 'gift, present; offering',
    pinyin: ['jī'],
    decomposition: '⿱⿱⿻十从冖贝',
    etymology: { type: 'ideographic', hint: 'Money 贝 from 从 someone' },
    radical: '贝',
    matches: [
      [0, 0, 0],
      [0, 0, 0],
      [0, 0, 1],
      [0, 0, 1],
      [0, 0, 1],
      [0, 0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '赎',
    definition: 'ransom; to buy; to redeem',
    pinyin: ['shú'],
    decomposition: '⿰贝卖',
    etymology: {
      type: 'ideographic',
      hint: 'To sell 卖 a soul for money 贝; 卖 also provides the pronunciation',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '赏',
    definition: 'reward; to appreciate; to bestow, to grant',
    pinyin: ['shǎng'],
    decomposition: '⿱尚贝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尚',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '赐',
    definition: 'to give; to bestow a favor; to appoint',
    pinyin: ['cì'],
    decomposition: '⿰贝易',
    etymology: {
      type: 'pictophonetic',
      phonetic: '易',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '赑',
    definition: 'strong',
    pinyin: ['bì'],
    decomposition: '⿱贝⿰贝贝',
    radical: '贝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '赒',
    definition: 'to give to charity; to give alms',
    pinyin: ['zhōu'],
    decomposition: '⿰贝周',
    etymology: {
      type: 'pictophonetic',
      phonetic: '周',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '赓',
    definition: 'to continue a song',
    pinyin: ['gēng'],
    decomposition: '⿸庚贝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '庚',
      semantic: '贝',
      hint: 'shell',
    },
    radical: '广',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '赔',
    definition: 'to compensate, to pay damages, to suffer a loss',
    pinyin: ['péi'],
    decomposition: '⿰贝咅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咅',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '赕',
    definition: 'fine, penalty',
    pinyin: ['dǎn'],
    decomposition: '⿰贝炎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '炎',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '赖',
    definition: 'to depend on, to rely on; to bilk, to deny; poor',
    pinyin: ['lài'],
    decomposition: '⿰剌贝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '剌',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '赘',
    definition: 'unnecessary, superfluous',
    pinyin: ['zhuì'],
    decomposition: '⿱敖贝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贝',
      semantic: '敖',
      hint: 'leisure',
    },
    radical: '贝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '赙',
    definition: 'to contribute to funeral expenses',
    pinyin: ['fù'],
    decomposition: '⿰贝尃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尃',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '赚',
    definition: 'to earn, to profit, to make money',
    pinyin: ['zhuàn'],
    decomposition: '⿰贝兼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兼',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '赛',
    definition: 'to compete, to contend; contest, race',
    pinyin: ['sài'],
    decomposition: '⿱宀⿱？贝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宀',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [
      [0],
      [0],
      [0],
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '赜',
    definition: 'abstruse, deep, profound',
    pinyin: ['zé'],
    decomposition: '⿰臣责',
    etymology: {
      type: 'pictophonetic',
      phonetic: '责',
      semantic: '臣',
      hint: 'minister',
    },
    radical: '臣',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '赝',
    definition: 'false, bogus; counterfeit; a sham',
    pinyin: ['yàn'],
    decomposition: '⿸雁贝',
    etymology: {
      type: 'ideographic',
      hint: '"Wild goose" 雁 money 贝; 雁 also provides the pronunciation',
    },
    radical: '贝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '赞',
    definition: 'to help, to support; to laud, to praise',
    pinyin: ['zàn'],
    decomposition: '⿱兟贝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兟',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '赠',
    definition: 'to bestow, to confer, to present a gift',
    pinyin: ['zèng'],
    decomposition: '⿰贝曾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曾',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '赡',
    definition: 'rich, elegant; to support, to provide for',
    pinyin: ['shàn'],
    decomposition: '⿰贝詹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '詹',
      semantic: '贝',
      hint: 'money',
    },
    radical: '贝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '赢',
    definition: 'to win, to gain; surplus, profit',
    pinyin: ['yíng'],
    decomposition: '⿱吂⿲⺼贝？',
    etymology: { type: 'pictophonetic', semantic: '贝', hint: 'money' },
    radical: '贝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      null,
      null,
      null,
    ],
  },
  {
    character: '赣',
    definition: 'Jiangxi province; places therein',
    pinyin: ['gàn'],
    decomposition: '⿰章⿱夂贡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贡',
      semantic: '夂',
      hint: 'go',
    },
    radical: '贝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '赤',
    definition: 'red, scarlet; blushing; bare, naked',
    pinyin: ['chì'],
    decomposition: '⿱土火',
    etymology: {
      type: 'ideographic',
      hint: 'A person 土 whose cheeks are burning 火',
    },
    radical: '赤',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '赦',
    definition: 'to forgive, to pardon, to remit',
    pinyin: ['shè'],
    decomposition: '⿰赤攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '赤',
      semantic: '攵',
      hint: 'let go',
    },
    radical: '赤',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '赧',
    definition: 'to blush, to turn red',
    pinyin: ['nǎn'],
    decomposition: '⿰赤？',
    etymology: { type: 'pictophonetic', semantic: '赤', hint: 'red' },
    radical: '赤',
    matches: [[0], [0], [0], [0], [0], [0], [0], null, null, null, null],
  },
  {
    character: '赫',
    definition: 'bright, radiant, glowing',
    pinyin: ['hè'],
    decomposition: '⿰赤赤',
    etymology: { type: 'ideographic', hint: 'Blushing 赤 bright red 赤' },
    radical: '赤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '赭',
    definition: 'hematite; ochre, reddish-brown',
    pinyin: ['zhě'],
    decomposition: '⿰赤者',
    etymology: {
      type: 'pictophonetic',
      phonetic: '者',
      semantic: '赤',
      hint: 'red',
    },
    radical: '赤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '走',
    definition: 'to walk, to run, to flee',
    pinyin: ['zǒu'],
    decomposition: '⿱土止',
    etymology: {
      type: 'ideographic',
      hint: 'Someone 土 stepping with their foot 止',
    },
    radical: '走',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '赳',
    definition: 'gallant, valiant',
    pinyin: ['jiū'],
    decomposition: '⿺走丩',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丩',
      semantic: '走',
      hint: 'walk',
    },
    radical: '走',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '赴',
    definition: 'to attend, to go to, to be present',
    pinyin: ['fù'],
    decomposition: '⿺走卜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卜',
      semantic: '走',
      hint: 'walk',
    },
    radical: '走',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '赵',
    definition: 'ancient state; surname',
    pinyin: ['zhào'],
    decomposition: '⿺走乂',
    radical: '走',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '赶',
    definition: 'to pursue, to overtake; to hurry; to expel',
    pinyin: ['gǎn'],
    decomposition: '⿺走干',
    etymology: {
      type: 'pictophonetic',
      phonetic: '干',
      semantic: '走',
      hint: 'run',
    },
    radical: '走',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '起',
    definition: 'to begin, to initiate; to rise, to stand up',
    pinyin: ['qǐ'],
    decomposition: '⿺走己',
    etymology: {
      type: 'pictophonetic',
      phonetic: '己',
      semantic: '走',
      hint: 'walk',
    },
    radical: '走',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '赸',
    definition: 'to jump; to leave',
    pinyin: ['shàn'],
    decomposition: '⿺走山',
    etymology: {
      type: 'pictophonetic',
      phonetic: '山',
      semantic: '走',
      hint: 'flee',
    },
    radical: '走',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '趁',
    definition: 'to take advantage of, to seize an opportunity',
    pinyin: ['chèn'],
    decomposition: '⿺走㐱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㐱',
      semantic: '走',
      hint: 'walk',
    },
    radical: '走',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '趄',
    definition: 'weak, lame',
    pinyin: ['jū'],
    decomposition: '⿺走且',
    etymology: {
      type: 'pictophonetic',
      phonetic: '且',
      semantic: '走',
      hint: 'walk',
    },
    radical: '走',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '超',
    definition: 'to jump over, to leap over; to overtake, to surpass',
    pinyin: ['chāo'],
    decomposition: '⿺走召',
    etymology: {
      type: 'pictophonetic',
      phonetic: '召',
      semantic: '走',
      hint: 'run',
    },
    radical: '走',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '越',
    definition: 'to exceed, to surpass, to transcend',
    pinyin: ['yuè'],
    decomposition: '⿺走戉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戉',
      semantic: '走',
      hint: 'run',
    },
    radical: '走',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '趋',
    definition: 'to hurry, to hasten; to approach, to be attracted to',
    pinyin: ['qū'],
    decomposition: '⿺走刍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '刍',
      semantic: '走',
      hint: 'run',
    },
    radical: '走',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '趑',
    definition: 'to falter; to be unable to move',
    pinyin: ['zī'],
    decomposition: '⿺走次',
    etymology: {
      type: 'ideographic',
      hint: 'Unable to put one foot 走 after the other 次; 次 also provides the pronunciation',
    },
    radical: '走',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '趔',
    definition: 'to stumble; to halt, to check',
    pinyin: ['liè'],
    decomposition: '⿺走列',
    etymology: {
      type: 'pictophonetic',
      phonetic: '列',
      semantic: '走',
      hint: 'walk',
    },
    radical: '走',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '趕',
    definition: 'to pursue, to overtake; to hurry; to expel',
    pinyin: ['gǎn'],
    decomposition: '⿺走旱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旱',
      semantic: '走',
      hint: 'run',
    },
    radical: '走',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '趙',
    definition: 'ancient state; surname',
    pinyin: ['zhào'],
    decomposition: '⿺走肖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肖',
      semantic: '走',
      hint: 'walk',
    },
    radical: '走',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '趟',
    definition: 'time, occasion; to make a journey',
    pinyin: ['tàng'],
    decomposition: '⿺走尚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尚',
      semantic: '走',
      hint: 'walk',
    },
    radical: '走',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '趣',
    definition: "interest; interesting; what attracts one's attention",
    pinyin: ['qù'],
    decomposition: '⿺走取',
    etymology: {
      type: 'pictophonetic',
      phonetic: '取',
      semantic: '走',
      hint: 'walk',
    },
    radical: '走',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '趦',
    definition: 'to falter; to be unable to move',
    pinyin: ['zī'],
    decomposition: '⿺走咨',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咨',
      semantic: '走',
      hint: 'walk',
    },
    radical: '走',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '趨',
    definition: 'to hurry, to hasten; to approach, to be attracted to',
    pinyin: ['qū'],
    decomposition: '⿺走芻',
    etymology: {
      type: 'pictophonetic',
      phonetic: '芻',
      semantic: '走',
      hint: 'run',
    },
    radical: '走',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '趯',
    definition: 'to jump',
    pinyin: ['tì'],
    decomposition: '⿺走翟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '翟',
      semantic: '走',
      hint: 'flee',
    },
    radical: '走',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '趱',
    definition: 'to urge, to hasten; to go in a hurry',
    pinyin: ['zǎn'],
    decomposition: '⿺走赞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '赞',
      semantic: '走',
      hint: 'run',
    },
    radical: '走',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '足',
    definition: 'foot; to attain, to satisfy; enough',
    pinyin: ['zú'],
    decomposition: '⿱口？',
    etymology: { type: 'pictographic', hint: 'The leg 口 above the foot' },
    radical: '足',
    matches: [[0], [0], [0], null, null, null, null],
  },
  {
    character: '趴',
    definition: 'prone, lying down, leaning over',
    pinyin: ['pā'],
    decomposition: '⿰足八',
    etymology: {
      type: 'pictophonetic',
      phonetic: '八',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '趵',
    definition: 'the noise of tramping feet',
    pinyin: ['bào'],
    decomposition: '⿰足勺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '勺',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '趸',
    definition: 'to buy or sell wholesale',
    pinyin: ['dǔn'],
    decomposition: '⿱万足',
    etymology: {
      type: 'ideographic',
      hint: 'A ten-thousand 万 square-foot 足 warehouse',
    },
    radical: '足',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '趺',
    definition: 'to sit cross-legged; tarsus, instep',
    pinyin: ['fū'],
    decomposition: '⿰足夫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夫',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '趼',
    definition: 'blister, callus',
    pinyin: ['jiǎn'],
    decomposition: '⿰足开',
    etymology: {
      type: 'pictophonetic',
      phonetic: '开',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '趾',
    definition: 'toe; tracks, footprints',
    pinyin: ['zhǐ'],
    decomposition: '⿰足止',
    etymology: {
      type: 'pictophonetic',
      phonetic: '止',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '趿',
    definition: 'to tread on; slipshod',
    pinyin: ['tā'],
    decomposition: '⿰足及',
    etymology: {
      type: 'pictophonetic',
      phonetic: '及',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '跂',
    definition: 'to creep, to crawl',
    pinyin: ['qí'],
    decomposition: '⿰足支',
    etymology: {
      type: 'pictophonetic',
      phonetic: '支',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '跃',
    definition: 'to skip, to jump, to frolic',
    pinyin: ['yuè'],
    decomposition: '⿰足夭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夭',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '跄',
    definition: 'to stagger, to stumble',
    pinyin: ['qiāng'],
    decomposition: '⿰足仓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '仓',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '跆',
    definition: 'to trample, to kick',
    pinyin: ['tái'],
    decomposition: '⿰足台',
    etymology: {
      type: 'pictophonetic',
      phonetic: '台',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '跋',
    definition: 'to walk, to travel; epilogue, colophon',
    pinyin: ['bá'],
    decomposition: '⿰足犮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '犮',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '跌',
    definition: 'to stumble, to slip, to fall',
    pinyin: ['diē'],
    decomposition: '⿰足失',
    etymology: { type: 'ideographic', hint: "To lose 失 one's footing 足" },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '跎',
    definition: 'to stumble, to falter, to vacillate',
    pinyin: ['tuó'],
    decomposition: '⿰足它',
    etymology: {
      type: 'pictophonetic',
      phonetic: '它',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '跏',
    definition: 'to squat, to sit cross-legged',
    pinyin: ['jiā'],
    decomposition: '⿰足加',
    etymology: {
      type: 'pictophonetic',
      phonetic: '加',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '跑',
    definition: 'to run, to flee, to escape',
    pinyin: ['pǎo'],
    decomposition: '⿰足包',
    etymology: {
      type: 'pictophonetic',
      phonetic: '包',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '跖',
    definition: 'the sole of the foot',
    pinyin: ['zhí'],
    decomposition: '⿰足石',
    etymology: {
      type: 'pictophonetic',
      phonetic: '石',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '跗',
    definition: 'arch, instep',
    pinyin: ['fū'],
    decomposition: '⿰足付',
    etymology: {
      type: 'pictophonetic',
      phonetic: '付',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '跚',
    definition: 'to stagger, to limp',
    pinyin: ['shān'],
    decomposition: '⿰足册',
    etymology: {
      type: 'pictophonetic',
      phonetic: '册',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '跛',
    definition: 'lame',
    pinyin: ['bǒ'],
    decomposition: '⿰足皮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皮',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '距',
    definition: 'distance, gap',
    pinyin: ['jù'],
    decomposition: '⿰足巨',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巨',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '跞',
    definition: 'to walk, to move',
    pinyin: ['lì'],
    decomposition: '⿰足乐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乐',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '跟',
    definition: 'heel; to accompany, to follow; with',
    pinyin: ['gēn'],
    decomposition: '⿰足艮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '艮',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '跡',
    definition: 'trace, sign, mark, footprint',
    pinyin: ['jī'],
    decomposition: '⿰足亦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亦',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '跣',
    definition: 'barefoot',
    pinyin: ['xiǎn'],
    decomposition: '⿰足先',
    etymology: {
      type: 'pictophonetic',
      phonetic: '先',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '跤',
    definition: 'to tumble, to fall; to wrestle',
    pinyin: ['jiāo'],
    decomposition: '⿰足交',
    etymology: {
      type: 'pictophonetic',
      phonetic: '交',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '跨',
    definition: 'to straddle, to ride; to span, to stretch across',
    pinyin: ['kuà'],
    decomposition: '⿰足夸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夸',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '跪',
    definition: 'to kneel',
    pinyin: ['guì'],
    decomposition: '⿰足危',
    etymology: {
      type: 'pictophonetic',
      phonetic: '危',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '跫',
    definition: 'the sound of footsteps',
    pinyin: ['qióng'],
    decomposition: '⿱巩足',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巩',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '跬',
    definition: 'short step, half-pace',
    pinyin: ['kuǐ'],
    decomposition: '⿰足圭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '圭',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '路',
    definition: 'road, path, street; journey',
    pinyin: ['lù'],
    decomposition: '⿰足各',
    etymology: {
      type: 'pictophonetic',
      phonetic: '各',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '跳',
    definition: 'to hop, to skip; to jump, to leap; to vault; to dance',
    pinyin: ['tiào'],
    decomposition: '⿰足兆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兆',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '践',
    definition: 'to trample, to tread on, to walk over',
    pinyin: ['jiàn'],
    decomposition: '⿰足戋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戋',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '跶',
    definition: 'to stumble, to slip',
    pinyin: ['tà'],
    decomposition: '⿰足达',
    etymology: {
      type: 'pictophonetic',
      phonetic: '达',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '跷',
    definition: 'to stand on tiptoe; stilts',
    pinyin: ['qiāo'],
    decomposition: '⿰足尧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尧',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '跸',
    definition: 'to clear the way; to make way for the emperor',
    pinyin: ['bì'],
    decomposition: '⿰足毕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '毕',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '跹',
    definition: 'to walk about; to revolve; to dance',
    pinyin: ['xiān'],
    decomposition: '⿰足迁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '迁',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '跺',
    definition: 'to stamp the feet',
    pinyin: ['duò'],
    decomposition: '⿰足朵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朵',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '跻',
    definition: 'to ascend, to rise',
    pinyin: ['jī'],
    decomposition: '⿰足齐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '齐',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '跽',
    definition: 'to kneel; to get on hands and knees',
    pinyin: ['jì'],
    decomposition: '⿰足忌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '忌',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '踅',
    definition: 'to pace; to turn around midway',
    pinyin: ['xué'],
    decomposition: '⿱折足',
    etymology: {
      type: 'pictophonetic',
      phonetic: '折',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '踉',
    definition: 'to hop, to jump; hurried, urgent',
    pinyin: ['liáng'],
    decomposition: '⿰足良',
    etymology: {
      type: 'pictophonetic',
      phonetic: '良',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '踊',
    definition: 'to leap',
    pinyin: ['yǒng'],
    decomposition: '⿰足甬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甬',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '踌',
    definition: 'to falter, to hesitate; smug, self-satisfied',
    pinyin: ['chóu'],
    decomposition: '⿰足寿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寿',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '踏',
    definition: 'to trample, to tread on, to walk over',
    pinyin: ['tà'],
    decomposition: '⿰足沓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '沓',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '踐',
    definition: 'to trample, to tread on, to walk over',
    pinyin: ['jiàn'],
    decomposition: '⿰足戔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戔',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '踔',
    definition: 'to stride, to excel, to get ahead',
    pinyin: ['chuō'],
    decomposition: '⿰足卓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卓',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '踘',
    definition: 'ball',
    pinyin: ['jū'],
    decomposition: '⿰足匊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匊',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '踝',
    definition: 'ankle',
    pinyin: ['huái'],
    decomposition: '⿰足果',
    etymology: {
      type: 'pictophonetic',
      phonetic: '果',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '踞',
    definition: 'to crouch, to squat; to occupy',
    pinyin: ['jù'],
    decomposition: '⿰足居',
    etymology: {
      type: 'ideographic',
      hint: "To sit 居 on one's feet 足; 居 also provides the pronunciation",
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '踟',
    definition: 'hesitant, undecided; embarrassed',
    pinyin: ['chí'],
    decomposition: '⿰足知',
    etymology: {
      type: 'pictophonetic',
      phonetic: '知',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '踢',
    definition: 'to kick',
    pinyin: ['tī'],
    decomposition: '⿰足易',
    etymology: {
      type: 'pictophonetic',
      phonetic: '易',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '踣',
    definition: 'stiff, corpse-like; rigor mortis',
    pinyin: ['bó'],
    decomposition: '⿰足咅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咅',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '踥',
    definition: 'to take small steps',
    pinyin: ['qiè'],
    decomposition: '⿰足妾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '妾',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '踩',
    definition: 'to step on; to stamp',
    pinyin: ['cǎi'],
    decomposition: '⿰足采',
    etymology: {
      type: 'pictophonetic',
      phonetic: '采',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '踪',
    definition: 'footprints, traces, tracks',
    pinyin: ['zōng'],
    decomposition: '⿰足宗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宗',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '踬',
    definition: 'to stumble, to totter; to fail, to be frustrated',
    pinyin: ['zhì'],
    decomposition: '⿰足质',
    etymology: {
      type: 'pictophonetic',
      phonetic: '质',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '踮',
    definition: 'to tip-toe',
    pinyin: ['diǎn'],
    decomposition: '⿰足店',
    etymology: {
      type: 'pictophonetic',
      phonetic: '店',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '踯',
    definition: 'to hesitate, to waver; irresolute',
    pinyin: ['zhí'],
    decomposition: '⿰足郑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '郑',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '踱',
    definition: 'to pace, to stroll, to walk slowly',
    pinyin: ['duó'],
    decomposition: '⿰足度',
    etymology: {
      type: 'pictophonetic',
      phonetic: '度',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '踴',
    definition: 'to leap',
    pinyin: ['yǒng'],
    decomposition: '⿰足勇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '勇',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '踵',
    definition: 'heel; to follow; to visit, to call on',
    pinyin: ['zhǒng'],
    decomposition: '⿰足重',
    etymology: {
      type: 'pictophonetic',
      phonetic: '重',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '踶',
    definition: 'paw',
    pinyin: ['dì'],
    decomposition: '⿰足是',
    etymology: {
      type: 'pictophonetic',
      phonetic: '是',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '踹',
    definition: 'to trample, to tread on; to kick; to crush',
    pinyin: ['chuài'],
    decomposition: '⿰足耑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '耑',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '踺',
    definition: 'to somersault',
    pinyin: ['jiàn'],
    decomposition: '⿰足建',
    etymology: {
      type: 'pictophonetic',
      phonetic: '建',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '踽',
    definition: 'to walk alone; self-reliant; hunch-backed',
    pinyin: ['jǔ'],
    decomposition: '⿰足禹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '禹',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蹀',
    definition: 'to skip, to dance; to put a foot down',
    pinyin: ['dié'],
    decomposition: '⿰足枼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '枼',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蹁',
    definition: 'to limp',
    pinyin: ['pián'],
    decomposition: '⿰足扁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '扁',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蹂',
    definition: 'to trample, to tread on',
    pinyin: ['róu'],
    decomposition: '⿰足柔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '柔',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蹄',
    definition: "hoof; pig's trotter",
    pinyin: ['tí'],
    decomposition: '⿰足帝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '帝',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蹇',
    definition: 'lame, crippled; nag, donkey; slow, difficult',
    pinyin: ['jiǎn'],
    decomposition: '⿱宀⿱？足',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宀',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '蹈',
    definition: 'to dance, to stamp the feet',
    pinyin: ['dǎo'],
    decomposition: '⿰足舀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '舀',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蹉',
    definition: 'slip, mistake, error',
    pinyin: ['cuō'],
    decomposition: '⿰足差',
    etymology: {
      type: 'ideographic',
      hint: 'A footstep 足 in error 差; 差 also provides the pronunciation',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蹊',
    definition: 'trail, footpath',
    pinyin: ['qī'],
    decomposition: '⿰足奚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奚',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蹋',
    definition: 'to step on, to tread on',
    pinyin: ['tà'],
    decomposition: '⿰足⿱日羽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '日',
      hint: 'foot',
      semantic: '足',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '蹌',
    definition: 'to stagger, to stumble',
    pinyin: ['qiāng'],
    decomposition: '⿰足倉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '倉',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蹑',
    definition: 'to tip-toe, to walk quietly',
    pinyin: ['niè'],
    decomposition: '⿰足聂',
    etymology: {
      type: 'ideographic',
      hint: 'To walk 足 quietly 聂; 聂 also provides the pronunciation',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蹒',
    definition: 'to stagger, to limp',
    pinyin: ['pán'],
    decomposition: '⿰足⿱艹两',
    etymology: {
      type: 'pictophonetic',
      hint: 'foot',
      semantic: '足',
      phonetic: '㒼',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '蹙',
    definition: 'to frown, to knit the brows; distressed',
    pinyin: ['cù'],
    decomposition: '⿱戚足',
    etymology: {
      type: 'pictophonetic',
      phonetic: '足',
      semantic: '戚',
      hint: 'grieving',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蹚',
    definition: 'to trample, to wade; muddy, wet',
    pinyin: ['tāng'],
    decomposition: '⿰足堂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堂',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蹟',
    definition: 'trace, tracks; footprints',
    pinyin: ['jī'],
    decomposition: '⿰足責',
    etymology: {
      type: 'pictophonetic',
      phonetic: '責',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蹡',
    definition: 'to limp; to lurch',
    pinyin: ['qiāng'],
    decomposition: '⿰足將',
    etymology: {
      type: 'pictophonetic',
      phonetic: '將',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蹣',
    definition: 'to stagger, to limp',
    pinyin: ['pán'],
    decomposition: '⿰足㒼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㒼',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蹤',
    definition: 'footprints, traces, tracks',
    pinyin: ['zōng'],
    decomposition: '⿰足從',
    etymology: {
      type: 'pictophonetic',
      phonetic: '從',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蹦',
    definition: 'to jump, to bounce on; bright',
    pinyin: ['bèng'],
    decomposition: '⿰足崩',
    etymology: {
      type: 'pictophonetic',
      phonetic: '崩',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蹧',
    definition: 'to spoil; to ruin',
    pinyin: ['zāo'],
    decomposition: '⿰足曹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曹',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蹩',
    definition: 'to limp',
    pinyin: ['bié'],
    decomposition: '⿱敝足',
    etymology: {
      type: 'ideographic',
      hint: 'A broken 敝 foot 足; 敝 also provides the pronunciation',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蹬',
    definition: 'to step on; to wear; to face bad luck',
    pinyin: ['dēng'],
    decomposition: '⿰足登',
    etymology: {
      type: 'pictophonetic',
      phonetic: '登',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蹭',
    definition: 'to shuffle; to procrastinate, to freeload, to dilly-dally',
    pinyin: ['cèng'],
    decomposition: '⿰足曾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曾',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蹯',
    definition: 'paw',
    pinyin: ['fán'],
    decomposition: '⿰足番',
    etymology: {
      type: 'pictophonetic',
      phonetic: '番',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蹰',
    definition: 'to falter, to waver, to hesitate',
    pinyin: ['chú'],
    decomposition: '⿰足厨',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厨',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蹲',
    definition: 'to squat, to crouch',
    pinyin: ['dūn'],
    decomposition: '⿰足尊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尊',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蹴',
    definition: 'to leap; to kick; solemn',
    pinyin: ['cù'],
    decomposition: '⿰足就',
    etymology: {
      type: 'ideographic',
      hint: 'To approach 就 in one leap 足; 足 also provides the pronunciation',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蹶',
    definition: 'to stumble, to fall; to trample',
    pinyin: ['jué'],
    decomposition: '⿰足厥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厥',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蹺',
    definition: 'to stand on tiptoe; stilts',
    pinyin: ['qiāo'],
    decomposition: '⿰足堯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堯',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蹼',
    definition: 'webbed feet',
    pinyin: ['pǔ'],
    decomposition: '⿰足菐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '菐',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '蹿',
    definition: 'to jump, to leap; to gush, to spurt',
    pinyin: ['cuān'],
    decomposition: '⿰足窜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '窜',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '躁',
    definition: 'tense, irritable; rash, hot-tempered',
    pinyin: ['zào'],
    decomposition: '⿰足喿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '喿',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '躂',
    definition: 'to stumble, to slip',
    pinyin: ['tà'],
    decomposition: '⿰足達',
    etymology: {
      type: 'pictophonetic',
      phonetic: '達',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '躅',
    definition: 'to walk carefully; to hesitate, to falter',
    pinyin: ['zhú'],
    decomposition: '⿰足蜀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '足',
      semantic: '蜀',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '躇',
    definition: 'to hesitate, to falter; undecided',
    pinyin: ['chú'],
    decomposition: '⿰足著',
    etymology: {
      type: 'pictophonetic',
      phonetic: '著',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '躉',
    definition: 'to buy or sell wholesale',
    pinyin: ['dǔn'],
    decomposition: '⿱萬足',
    etymology: {
      type: 'ideographic',
      hint: 'A ten-thousand 萬 square-foot 足 warehouse',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '躊',
    definition: 'to falter, to hesitate; smug, self-satisfied',
    pinyin: ['chóu'],
    decomposition: '⿰足壽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '壽',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '躋',
    definition: 'to ascend, to rise',
    pinyin: ['jī'],
    decomposition: '⿰足齊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '齊',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '躍',
    definition: 'to skip, to jump, to frolic',
    pinyin: ['yuè'],
    decomposition: '⿰足翟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '翟',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '躏',
    definition: 'to trample, to oppress; to overrun',
    pinyin: ['lìn'],
    decomposition: '⿰足蔺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蔺',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '躐',
    definition: 'to stride over; to step across',
    pinyin: ['liè'],
    decomposition: '⿰足巤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巤',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '躑',
    definition: 'to hesitate, to waver; irresolute',
    pinyin: ['zhí'],
    decomposition: '⿰足鄭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鄭',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '躓',
    definition: 'to stumble, to totter; to fail, to be frustrated',
    pinyin: ['zhì'],
    decomposition: '⿰足質',
    etymology: {
      type: 'pictophonetic',
      phonetic: '質',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '躔',
    definition: 'to follow, to imitate; path, rut',
    pinyin: ['chán'],
    decomposition: '⿰足廛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '廛',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '躕',
    definition: 'to falter, to waver, to hesitate',
    pinyin: ['chú'],
    decomposition: '⿰足廚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '廚',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '躚',
    definition: 'to walk about; to revolve; to dance',
    pinyin: ['xiān'],
    decomposition: '⿰足遷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '遷',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '躜',
    definition: 'to jump',
    pinyin: ['zuān'],
    decomposition: '⿰足赞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '赞',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '躞',
    definition: 'to walk',
    pinyin: ['xiè'],
    decomposition: '⿰足燮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '燮',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '躡',
    definition: 'to tip-toe, to walk quietly',
    pinyin: ['niè'],
    decomposition: '⿰足聶',
    etymology: {
      type: 'ideographic',
      hint: 'To walk 足 quietly 聶; 聶 also provides the pronunciation',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '躥',
    definition: 'to jump, to leap; to gush, to spurt',
    pinyin: ['cuān'],
    decomposition: '⿰足竄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '竄',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '躪',
    definition: 'to trample, to oppress; to overrun',
    pinyin: ['lìn'],
    decomposition: '⿰足藺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '藺',
      semantic: '足',
      hint: 'foot',
    },
    radical: '足',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '身',
    definition: 'body, torso; person; pregnancy',
    pinyin: ['shēn'],
    decomposition: '？',
    etymology: { type: 'pictographic', hint: 'A pregnant woman' },
    radical: '身',
    matches: [null, null, null, null, null, null, null],
  },
  {
    character: '躬',
    definition: 'to bow; personally, in person; oneself',
    pinyin: ['gōng'],
    decomposition: '⿰身弓',
    etymology: {
      type: 'ideographic',
      hint: "To bow 弓 one's body 身; 弓 also provides the pronunciation",
    },
    radical: '身',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '躯',
    definition: 'the human body',
    pinyin: ['qū'],
    decomposition: '⿰身区',
    etymology: {
      type: 'pictophonetic',
      phonetic: '区',
      semantic: '身',
      hint: 'body',
    },
    radical: '身',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '躲',
    definition: 'to evade, to escape; to hide, to take shelter',
    pinyin: ['duǒ'],
    decomposition: '⿰身朵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朵',
      semantic: '身',
      hint: 'body',
    },
    radical: '身',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '躺',
    definition: 'to recline, to lie down',
    pinyin: ['tǎng'],
    decomposition: '⿰身尚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尚',
      semantic: '身',
      hint: 'body',
    },
    radical: '身',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '軀',
    definition: 'the human body',
    pinyin: ['qū'],
    decomposition: '⿰身區',
    etymology: {
      type: 'pictophonetic',
      phonetic: '區',
      semantic: '身',
      hint: 'body',
    },
    radical: '身',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '軃',
    definition: 'to hang down',
    pinyin: ['duǒ'],
    decomposition: '⿰身單',
    radical: '身',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '車',
    definition: 'cart, vehicle; to move in a cart',
    pinyin: ['chē'],
    decomposition: '⿻？日',
    etymology: {
      type: 'pictographic',
      hint: 'A cart with two wheels, seen from above',
    },
    radical: '車',
    matches: [null, [1], [1], [1], [1], null, null],
  },
  {
    character: '軋',
    definition: 'to crush, to grind; mill, roller',
    pinyin: ['yà'],
    decomposition: '⿰車乚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乚',
      semantic: '車',
      hint: 'cart',
    },
    radical: '車',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1]],
  },
  {
    character: '軌',
    definition: 'track, rut, path',
    pinyin: ['guǐ'],
    decomposition: '⿰車九',
    etymology: {
      type: 'pictophonetic',
      phonetic: '九',
      semantic: '車',
      hint: 'cart',
    },
    radical: '車',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '軍',
    definition: 'army, military; soldiers, troops',
    pinyin: ['jūn'],
    decomposition: '⿱冖車',
    etymology: {
      type: 'ideographic',
      hint: 'Soldiers 冖 (distorted 力) in a cart 車',
    },
    radical: '車',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '軎',
    definition: 'a brass part for a cart in ancient China',
    pinyin: ['wèi'],
    decomposition: '⿱車口',
    etymology: { type: 'ideographic', hint: 'A cart 車 part 口' },
    radical: '車',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '軒',
    definition: 'pavilion; carriage; balcony',
    pinyin: ['xuān'],
    decomposition: '⿰車干',
    etymology: {
      type: 'pictophonetic',
      phonetic: '干',
      semantic: '車',
      hint: 'cart',
    },
    radical: '車',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '軔',
    definition: 'brake',
    pinyin: ['rèn'],
    decomposition: '⿰車刃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '刃',
      semantic: '車',
      hint: 'cart',
    },
    radical: '車',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '軛',
    definition: 'yoke, restraint, collar',
    pinyin: ['è'],
    decomposition: '⿰車厄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厄',
      semantic: '車',
      hint: 'cart',
    },
    radical: '車',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '軟',
    definition: 'soft, pliable, flexible; weak',
    pinyin: ['ruǎn'],
    decomposition: '⿰車欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '欠',
      semantic: '車',
      hint: 'cart',
    },
    radical: '車',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '軫',
    definition: 'a cross board at rear of a carriage',
    pinyin: ['zhěn'],
    decomposition: '⿰車㐱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㐱',
      semantic: '車',
      hint: 'cart',
    },
    radical: '車',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '軲',
    definition: 'wheel; to revolve, to turn',
    pinyin: ['gū'],
    decomposition: '⿰車古',
    etymology: {
      type: 'pictophonetic',
      phonetic: '古',
      semantic: '車',
      hint: 'wheel',
    },
    radical: '車',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '軸',
    definition: 'axle, pivot, shaft; axis',
    pinyin: ['zhóu'],
    decomposition: '⿰車由',
    etymology: {
      type: 'pictophonetic',
      phonetic: '由',
      semantic: '車',
      hint: 'wheel',
    },
    radical: '車',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '軻',
    definition: 'axle',
    pinyin: ['kē'],
    decomposition: '⿰車可',
    etymology: {
      type: 'pictophonetic',
      phonetic: '可',
      semantic: '車',
      hint: 'wheel',
    },
    radical: '車',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '軼',
    definition: 'to surpass, to overtake, to excel',
    pinyin: ['yì'],
    decomposition: '⿰車失',
    etymology: {
      type: 'pictophonetic',
      phonetic: '失',
      semantic: '車',
      hint: 'cart',
    },
    radical: '車',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '軾',
    definition: 'carriage crossbar',
    pinyin: ['shì'],
    decomposition: '⿰車式',
    etymology: {
      type: 'pictophonetic',
      phonetic: '式',
      semantic: '車',
      hint: 'cart',
    },
    radical: '車',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '輂',
    definition: 'horse-drawn carriage',
    pinyin: ['jú'],
    decomposition: '⿱共車',
    etymology: {
      type: 'pictophonetic',
      phonetic: '共',
      semantic: '車',
      hint: 'cart',
    },
    radical: '車',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '較',
    definition: 'to compare; relatively; more',
    pinyin: ['jiào'],
    decomposition: '⿰車交',
    etymology: {
      type: 'pictophonetic',
      phonetic: '交',
      semantic: '車',
      hint: 'cart',
    },
    radical: '車',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '載',
    definition: 'load; to carry, to convey, to transport',
    pinyin: ['zài'],
    decomposition: '⿹哉車',
    etymology: {
      type: 'pictophonetic',
      phonetic: '哉',
      semantic: '車',
      hint: 'cart',
    },
    radical: '車',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '輊',
    definition: 'the back of a cart',
    pinyin: ['zhì'],
    decomposition: '⿰車至',
    etymology: {
      type: 'pictophonetic',
      phonetic: '至',
      semantic: '車',
      hint: 'cart',
    },
    radical: '車',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '輒',
    definition: 'often, readily; scattered; the weapon-rack of a chariot',
    pinyin: ['zhé'],
    decomposition: '⿰車耴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '耴',
      semantic: '車',
      hint: 'cart',
    },
    radical: '車',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '輓',
    definition: 'to pull, to lead; to pull back, to draw a bow',
    pinyin: ['wǎn'],
    decomposition: '⿰車免',
    etymology: {
      type: 'pictophonetic',
      phonetic: '免',
      semantic: '車',
      hint: 'cart',
    },
    radical: '車',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '輔',
    definition: 'side road; to assist, to coach, to tutor',
    pinyin: ['fǔ'],
    decomposition: '⿰車甫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甫',
      semantic: '車',
      hint: 'cart',
    },
    radical: '車',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '輕',
    definition: 'light, gentle; simple, easy',
    pinyin: ['qīng'],
    decomposition: '⿰車巠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巠',
      semantic: '車',
      hint: 'cart',
    },
    radical: '車',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '輛',
    definition: 'measure word for vehicles',
    pinyin: ['liàng'],
    decomposition: '⿰車兩',
    etymology: {
      type: 'ideographic',
      hint: 'Two 兩 carts 車; 兩 also provides the pronunciation',
    },
    radical: '車',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '輝',
    definition: 'brightness, luster',
    pinyin: ['huī'],
    decomposition: '⿰光軍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '軍',
      semantic: '光',
      hint: 'light',
    },
    radical: '車',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '輟',
    definition: 'to suspend, to stop, to halt',
    pinyin: ['chuò'],
    decomposition: '⿰車叕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叕',
      semantic: '車',
      hint: 'cart',
    },
    radical: '車',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '輥',
    definition: 'to revolve, to turn; a stone roller',
    pinyin: ['gǔn'],
    decomposition: '⿰車昆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昆',
      semantic: '車',
      hint: 'wheel',
    },
    radical: '車',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '輦',
    definition: 'hand-cart; to transport by carriage',
    pinyin: ['niǎn'],
    decomposition: '⿱⿰夫夫車',
    etymology: {
      type: 'ideographic',
      hint: 'Two people 夫 riding in a cart 車',
    },
    radical: '車',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '輩',
    definition: 'generation, lifetime; contemporary',
    pinyin: ['bèi'],
    decomposition: '⿱非車',
    etymology: {
      type: 'pictophonetic',
      phonetic: '非',
      semantic: '車',
      hint: 'wheel',
    },
    radical: '車',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '輪',
    definition: 'wheel; to turn, to revolve; to recur',
    pinyin: ['lún'],
    decomposition: '⿰車侖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '侖',
      semantic: '車',
      hint: 'wheel',
    },
    radical: '車',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '輬',
    definition: 'carriage, hearse',
    pinyin: ['liáng'],
    decomposition: '⿰車京',
    etymology: {
      type: 'pictophonetic',
      phonetic: '京',
      semantic: '車',
      hint: 'cart',
    },
    radical: '車',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '輯',
    definition: 'to gather, to collect; to edit, to compile',
    pinyin: ['jí'],
    decomposition: '⿰車咠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咠',
      semantic: '車',
      hint: 'cart',
    },
    radical: '車',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '輸',
    definition: 'to carry, to haul, to transport',
    pinyin: ['shū'],
    decomposition: '⿰車俞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '俞',
      semantic: '車',
      hint: 'cart',
    },
    radical: '車',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '輻',
    definition: 'ray, spoke',
    pinyin: ['fú'],
    decomposition: '⿰車畐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畐',
      semantic: '車',
      hint: 'wheel',
    },
    radical: '車',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '輾',
    definition: 'to roll over; to turn on a side',
    pinyin: ['niǎn'],
    decomposition: '⿰車展',
    etymology: {
      type: 'pictophonetic',
      phonetic: '展',
      semantic: '車',
      hint: 'cart',
    },
    radical: '車',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '輿',
    definition: 'cart, palanquin, sedan chair',
    pinyin: ['yú'],
    decomposition: '⿶舁車',
    etymology: {
      type: 'ideographic',
      hint: "A cart 車 carried on one's shoulder 舁",
    },
    radical: '車',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '轀',
    definition: 'hearse',
    pinyin: ['wēn'],
    decomposition: '⿰車⿱囚皿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皿',
      hint: 'cart',
      semantic: '車',
    },
    radical: '車',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '轂',
    definition: 'the hub of a wheel',
    pinyin: ['gǔ'],
    decomposition: '⿰⿱⿳士冖一車殳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '殳',
      hint: 'wheel',
      semantic: '車',
    },
    radical: '車',
    matches: [
      [0, 0, 0],
      [0, 0, 0],
      [0, 0, 0],
      [0, 0, 1],
      [0, 0, 1],
      [0, 0, 2],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '轄',
    definition: 'to control, to have jurisdiction; the linchpin of a wheel',
    pinyin: ['xiá'],
    decomposition: '⿰車害',
    etymology: {
      type: 'pictophonetic',
      phonetic: '害',
      semantic: '車',
      hint: 'cart',
    },
    radical: '車',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '轅',
    definition: "axle; magistrate's office; surname",
    pinyin: ['yuán'],
    decomposition: '⿰車袁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '袁',
      semantic: '車',
      hint: 'wheel',
    },
    radical: '車',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '轆',
    definition: 'windlass, pulley, capstan',
    pinyin: ['lù'],
    decomposition: '⿰車鹿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鹿',
      semantic: '車',
      hint: 'wheel',
    },
    radical: '車',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '轉',
    definition:
      'to move, to convey; to turn, to revolve, to circle; to forward mail',
    pinyin: ['zhuǎn'],
    decomposition: '⿰車專',
    etymology: {
      type: 'pictophonetic',
      phonetic: '專',
      semantic: '車',
      hint: 'cart',
    },
    radical: '車',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '轍',
    definition: 'track, rut; stuck in a rut',
    pinyin: ['zhé'],
    decomposition: '⿲車育攵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '徹',
      semantic: '車',
      hint: 'cart',
    },
    radical: '車',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '轎',
    definition: 'sedan-chair, palanquin, litter',
    pinyin: ['jiào'],
    decomposition: '⿰車喬',
    etymology: {
      type: 'ideographic',
      hint: 'A lofty 喬 carriage 車; 喬 also provides the pronunciation',
    },
    radical: '車',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '轗',
    definition: 'to fail; to face misfortune',
    pinyin: ['kǎn'],
    decomposition: '⿰車感',
    etymology: {
      type: 'pictophonetic',
      phonetic: '感',
      semantic: '車',
      hint: 'cart',
    },
    radical: '車',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '轘',
    definition: 'punishment, torture; to tear asunder between two chariots',
    pinyin: ['huán'],
    decomposition: '⿰車睘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '睘',
      semantic: '車',
      hint: 'cart',
    },
    radical: '車',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '轟',
    definition: 'rumble, explosion, blast',
    pinyin: ['hōng'],
    decomposition: '⿱車⿰車車',
    etymology: {
      type: 'ideographic',
      hint: 'The thunderous sound of many chariots 車',
    },
    radical: '車',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '轡',
    definition: 'bridle, reins',
    pinyin: ['pèi'],
    decomposition: '⿱⿲糹車糹口',
    etymology: {
      type: 'ideographic',
      hint: 'Rope 糹 yoking a horse to a chariot 車 by its mouth 口',
    },
    radical: '車',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 2],
      [0, 2],
      [0, 2],
      [0, 2],
      [0, 2],
      [0, 2],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '轤',
    definition: 'pulley, windlass, capstan',
    pinyin: ['lú'],
    decomposition: '⿰車盧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '盧',
      semantic: '車',
      hint: 'wheel',
    },
    radical: '車',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '车',
    definition: 'cart, vehicle; to move in a cart',
    pinyin: ['chē'],
    decomposition: '⿻七十',
    etymology: {
      type: 'pictographic',
      hint: 'Simplified form of 車, a cart with two wheels, seen from above',
    },
    radical: '车',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '轧',
    definition: 'to crush, to grind; mill, roller',
    pinyin: ['yà'],
    decomposition: '⿰车乚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乚',
      semantic: '车',
      hint: 'cart',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1]],
  },
  {
    character: '轨',
    definition: 'track, rut, path',
    pinyin: ['guǐ'],
    decomposition: '⿰车九',
    etymology: {
      type: 'pictophonetic',
      phonetic: '九',
      semantic: '车',
      hint: 'cart',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '轩',
    definition: 'pavilion; carriage; balcony',
    pinyin: ['xuān'],
    decomposition: '⿰车干',
    etymology: {
      type: 'pictophonetic',
      phonetic: '干',
      semantic: '车',
      hint: 'cart',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '轫',
    definition: 'brake',
    pinyin: ['rèn'],
    decomposition: '⿰车刃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '刃',
      semantic: '车',
      hint: 'cart',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '转',
    definition:
      'to move, to convey; to turn, to revolve, to circle; to forward mail',
    pinyin: ['zhuǎn'],
    decomposition: '⿰车专',
    etymology: {
      type: 'pictophonetic',
      phonetic: '专',
      semantic: '车',
      hint: 'cart',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '轭',
    definition: 'yoke, restraint, collar',
    pinyin: ['è'],
    decomposition: '⿰车厄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厄',
      semantic: '车',
      hint: 'cart',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '轮',
    definition: 'wheel; to turn, to revolve; to recur',
    pinyin: ['lún'],
    decomposition: '⿰车仑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '仑',
      semantic: '车',
      hint: 'wheel',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '软',
    definition: 'soft, pliable, flexible; weak',
    pinyin: ['ruǎn'],
    decomposition: '⿰车欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '欠',
      semantic: '车',
      hint: 'cart',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '轰',
    definition: 'rumble, explosion, blast',
    pinyin: ['hōng'],
    decomposition: '⿱车双',
    etymology: {
      type: 'ideographic',
      hint: 'The thunderous sound of a pair 双 of carts 车',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '轱',
    definition: 'wheel; to revolve, to turn',
    pinyin: ['gū'],
    decomposition: '⿰车古',
    etymology: {
      type: 'pictophonetic',
      phonetic: '古',
      semantic: '车',
      hint: 'wheel',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '轲',
    definition: 'axle',
    pinyin: ['kē'],
    decomposition: '⿰车可',
    etymology: {
      type: 'pictophonetic',
      phonetic: '可',
      semantic: '车',
      hint: 'wheel',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '轳',
    definition: 'pulley, windlass, capstan',
    pinyin: ['lú'],
    decomposition: '⿰车卢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卢',
      semantic: '车',
      hint: 'wheel',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '轴',
    definition: 'axle, pivot, shaft; axis',
    pinyin: ['zhóu'],
    decomposition: '⿰车由',
    etymology: {
      type: 'pictophonetic',
      phonetic: '由',
      semantic: '车',
      hint: 'wheel',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '轵',
    definition: 'the end of an axle that extends beyond the hub',
    pinyin: ['zhǐ'],
    decomposition: '⿰车只',
    etymology: {
      type: 'pictophonetic',
      phonetic: '只',
      semantic: '车',
      hint: 'wheel',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '轶',
    definition: 'to surpass, to overtake, to excel',
    pinyin: ['yì'],
    decomposition: '⿰车失',
    etymology: {
      type: 'pictophonetic',
      phonetic: '失',
      semantic: '车',
      hint: 'cart',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '轷',
    definition: 'surname',
    pinyin: ['hū'],
    decomposition: '⿰车乎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乎',
      semantic: '车',
      hint: 'cart',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '轸',
    definition: 'a cross board at rear of a carriage',
    pinyin: ['zhěn'],
    decomposition: '⿰车㐱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㐱',
      semantic: '车',
      hint: 'cart',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '轹',
    definition: 'to run over something in a vehicle',
    pinyin: ['lì'],
    decomposition: '⿰车乐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乐',
      semantic: '车',
      hint: 'cart',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '轺',
    definition: 'light carriage',
    pinyin: ['yáo'],
    decomposition: '⿰车召',
    etymology: {
      type: 'pictophonetic',
      phonetic: '召',
      semantic: '车',
      hint: 'cart',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '轻',
    definition: 'light, gentle; simple, easy',
    pinyin: ['qīng'],
    decomposition: '⿰车⿱又工',
    etymology: {
      type: 'pictophonetic',
      phonetic: '工',
      hint: 'cart',
      semantic: '车',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '轼',
    definition: 'carriage crossbar',
    pinyin: ['shì'],
    decomposition: '⿰车式',
    etymology: {
      type: 'pictophonetic',
      phonetic: '式',
      semantic: '车',
      hint: 'cart',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '载',
    definition: 'load; to carry, to convey, to transport',
    pinyin: ['zài'],
    decomposition: '⿹哉车',
    etymology: {
      type: 'pictophonetic',
      phonetic: '哉',
      semantic: '车',
      hint: 'cart',
    },
    radical: '戈',
    matches: [[0], [0], [0], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '轾',
    definition: 'the back of a cart',
    pinyin: ['zhì'],
    decomposition: '⿰车至',
    etymology: {
      type: 'pictophonetic',
      phonetic: '至',
      semantic: '车',
      hint: 'cart',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '轿',
    definition: 'sedan-chair, palanquin, litter',
    pinyin: ['jiào'],
    decomposition: '⿰车乔',
    etymology: {
      type: 'ideographic',
      hint: 'A lofty 乔 carriage 车; 乔 also provides the pronunciation',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '辁',
    definition: 'limited (in talent or ability); a solid wheel without spokes',
    pinyin: ['quán'],
    decomposition: '⿰车全',
    etymology: {
      type: 'ideographic',
      hint: 'A complete 全 wheel 车; 全 also provides the pronunciation',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '辂',
    definition: 'chariot, carriage',
    pinyin: ['lù'],
    decomposition: '⿰车各',
    etymology: {
      type: 'pictophonetic',
      phonetic: '各',
      semantic: '车',
      hint: 'cart',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '较',
    definition: 'to compare; relatively; more',
    pinyin: ['jiào'],
    decomposition: '⿰车交',
    etymology: {
      type: 'pictophonetic',
      phonetic: '交',
      semantic: '车',
      hint: 'cart',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '辄',
    definition: 'often, readily; scattered; the weapon-rack of a chariot',
    pinyin: ['zhé'],
    decomposition: '⿰车耴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '耴',
      semantic: '车',
      hint: 'cart',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '辅',
    definition: 'side road; to assist, to coach, to tutor',
    pinyin: ['fǔ'],
    decomposition: '⿰车甫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甫',
      semantic: '车',
      hint: 'cart',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '辆',
    definition: 'measure word for vehicles',
    pinyin: ['liàng'],
    decomposition: '⿰车两',
    etymology: {
      type: 'ideographic',
      hint: 'Two 两 carts 车; 两 also provides the pronunciation',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '辇',
    definition: 'hand-cart; to transport by carriage',
    pinyin: ['niǎn'],
    decomposition: '⿱⿰夫夫车',
    etymology: {
      type: 'ideographic',
      hint: 'Two people 夫 riding in a cart 车',
    },
    radical: '车',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '辈',
    definition: 'generation, lifetime; contemporary',
    pinyin: ['bèi'],
    decomposition: '⿱非车',
    etymology: {
      type: 'pictophonetic',
      phonetic: '非',
      semantic: '车',
      hint: 'wheel',
    },
    radical: '非',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '辉',
    definition: 'brightness, luster',
    pinyin: ['huī'],
    decomposition: '⿰光军',
    etymology: {
      type: 'pictophonetic',
      phonetic: '军',
      semantic: '光',
      hint: 'light',
    },
    radical: '⺌',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '辊',
    definition: 'to revolve, to turn; a stone roller',
    pinyin: ['gǔn'],
    decomposition: '⿰车昆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昆',
      semantic: '车',
      hint: 'wheel',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '辋',
    definition: 'tire; wheel rim',
    pinyin: ['wǎng'],
    decomposition: '⿰车罔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '罔',
      semantic: '车',
      hint: 'wheel',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '辌',
    definition: 'carriage, hearse',
    pinyin: ['liáng'],
    decomposition: '⿰车京',
    etymology: {
      type: 'pictophonetic',
      phonetic: '京',
      semantic: '车',
      hint: 'cart',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '辍',
    definition: 'to suspend, to stop, to halt',
    pinyin: ['chuò'],
    decomposition: '⿰车叕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叕',
      semantic: '车',
      hint: 'cart',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '辎',
    definition: 'supply cart, covered wagon, dray',
    pinyin: ['zī'],
    decomposition: '⿰车甾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甾',
      semantic: '车',
      hint: 'cart',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '辏',
    definition: 'wheel hub; to converge',
    pinyin: ['còu'],
    decomposition: '⿰车奏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奏',
      hint: 'wheel',
      semantic: '车',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '辐',
    definition: 'ray, spoke',
    pinyin: ['fú'],
    decomposition: '⿰车畐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畐',
      semantic: '车',
      hint: 'cart',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '辑',
    definition: 'to gather, to collect; to edit, to compile',
    pinyin: ['jí'],
    decomposition: '⿰车咠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咠',
      semantic: '车',
      hint: 'cart',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '辒',
    definition: 'hearse',
    pinyin: ['wēn'],
    decomposition: '⿰车昷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昷',
      semantic: '车',
      hint: 'cart',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '输',
    definition: 'to carry, to haul, to transport',
    pinyin: ['shū'],
    decomposition: '⿰车俞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '俞',
      semantic: '车',
      hint: 'cart',
    },
    radical: '车',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '辔',
    definition: 'bridle, reins',
    pinyin: ['pèi'],
    decomposition: '⿱⿲纟车纟口',
    etymology: {
      type: 'ideographic',
      hint: 'Rope 纟 yoking a horse to a chariot 车 by its mouth 口',
    },
    radical: '口',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 2],
      [0, 2],
      [0, 2],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '辕',
    definition: "axle; magistrate's office; surname",
    pinyin: ['yuán'],
    decomposition: '⿰车袁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '袁',
      semantic: '车',
      hint: 'wheel',
    },
    radical: '车',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '辖',
    definition: 'to control, to have jurisdiction; the linchpin of a wheel',
    pinyin: ['xiá'],
    decomposition: '⿰车害',
    etymology: {
      type: 'pictophonetic',
      phonetic: '害',
      semantic: '车',
      hint: 'cart',
    },
    radical: '车',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '辗',
    definition: 'to roll over; to turn on a side',
    pinyin: ['niǎn'],
    decomposition: '⿰车展',
    etymology: {
      type: 'pictophonetic',
      phonetic: '展',
      semantic: '车',
      hint: 'cart',
    },
    radical: '车',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '辘',
    definition: 'windlass, pulley, capstan',
    pinyin: ['lù'],
    decomposition: '⿰车鹿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鹿',
      semantic: '车',
      hint: 'wheel',
    },
    radical: '车',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '辙',
    definition: 'track, rut; stuck in a rut',
    pinyin: ['zhé'],
    decomposition: '⿲车育攵',
    etymology: {
      type: 'ideographic',
      hint: 'Something left 育 by a cart 车 when it moves 攵',
    },
    radical: '车',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '辚',
    definition: 'the rumbling of wheels',
    pinyin: ['lín'],
    decomposition: '⿰车粦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '粦',
      semantic: '车',
      hint: 'cart',
    },
    radical: '车',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '辛',
    definition: 'bitter; toilsome, laborious; 8th heavenly stem',
    pinyin: ['xīn'],
    decomposition: '⿱立十',
    etymology: {
      type: 'pictographic',
      hint: 'A hot iron used to brand prisoners and slaves',
    },
    radical: '辛',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '辜',
    definition: 'crime, offense, sin',
    pinyin: ['gū'],
    decomposition: '⿱古辛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '古',
      semantic: '辛',
      hint: 'bitter',
    },
    radical: '辛',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '辞',
    definition: 'words, speech; to resign, to take leave',
    pinyin: ['cí'],
    decomposition: '⿰舌辛',
    etymology: { type: 'ideographic', hint: 'Bitter 辛 words 舌' },
    radical: '舌',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '辟',
    definition: 'law, rule; to open up, to develop',
    pinyin: ['pì'],
    decomposition: '⿰⿸尸口辛',
    etymology: {
      type: 'ideographic',
      hint: 'A body 尸 decapitated 口 by a sword 辛 , representing the law',
    },
    radical: '辛',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '辣',
    definition: 'pepper; hot, spicy; cruel',
    pinyin: ['là'],
    decomposition: '⿰辛束',
    etymology: {
      type: 'pictophonetic',
      phonetic: '束',
      semantic: '辛',
      hint: 'bitter',
    },
    radical: '辛',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '辥',
    definition: 'a variety of marsh grass',
    pinyin: ['xuē'],
    decomposition: '⿰⿱屮⿱丿㠯辛',
    radical: '辛',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1, 0],
      [0, 1, 1],
      [0, 1, 1],
      [0, 1, 1],
      [0, 1, 1],
      [0, 1, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '辦',
    definition: 'to set up; to manage, to run; to deal with, to handle',
    pinyin: ['bàn'],
    decomposition: '⿲辛力辛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辛',
      semantic: '力',
      hint: 'strength',
    },
    radical: '辛',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '辨',
    definition: 'to recognize, to distinguish, to discriminate',
    pinyin: ['biàn'],
    decomposition: '⿲辛刂辛',
    etymology: {
      type: 'ideographic',
      hint: 'To separate 刂 two alternatives 辛',
    },
    radical: '辛',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '辩',
    definition: 'to argue, to dispute; to discuss, to debate',
    pinyin: ['biàn'],
    decomposition: '⿲辛讠辛',
    etymology: {
      type: 'ideographic',
      hint: 'A bitter 辛 exchange of words 讠',
    },
    radical: '辛',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '辫',
    definition: 'braid, pigtail, plait; queue',
    pinyin: ['biàn'],
    decomposition: '⿲辛纟辛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辛',
      semantic: '纟',
      hint: 'thread',
    },
    radical: '辛',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '辭',
    definition: 'words, speech; to resign, to take leave',
    pinyin: ['cí'],
    decomposition: '⿰⿳爫？⿵冂⿱厶又辛',
    radical: '辛',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      null,
      null,
      [0, 2, 0],
      [0, 2, 0],
      [0, 2, 1, 0],
      [0, 2, 1, 0],
      [0, 2, 1, 1],
      [0, 2, 1, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '辮',
    definition: 'braid, pigtail, plait; queue',
    pinyin: ['biàn'],
    decomposition: '⿲辛糸辛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辛',
      semantic: '糸',
      hint: 'thread',
    },
    radical: '糸',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '辯',
    definition: 'to argue, to dispute; to discuss, to debate',
    pinyin: ['biàn'],
    decomposition: '⿲辛言辛',
    etymology: {
      type: 'ideographic',
      hint: 'A bitter 辛 exchange of words 言',
    },
    radical: '辛',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '辰',
    definition: 'early morning; fortune, good luck; 5th terrestrial branch',
    pinyin: ['chén'],
    decomposition: '⿸厂⿱二？',
    radical: '辰',
    matches: [[0], [0], [1, 0], [1, 0], null, null, null],
  },
  {
    character: '辱',
    definition: 'to insult, to humiliate, to abuse',
    pinyin: ['rǔ'],
    decomposition: '⿸辰寸',
    radical: '辰',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '農',
    definition: 'agriculture, farming; farmer',
    pinyin: ['nóng'],
    decomposition: '⿱曲辰',
    etymology: {
      type: 'pictographic',
      hint: 'Tilling the field 田 with a hoe 辰',
    },
    radical: '辰',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '辵',
    definition: 'to walk; walking',
    pinyin: ['chuò'],
    decomposition: '⿱彡止',
    etymology: { type: 'pictophonetic', semantic: '止', hint: 'foot' },
    radical: '辵',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '辶',
    definition: 'to walk; walking',
    pinyin: ['chuò'],
    decomposition: '？',
    etymology: { type: 'pictographic', hint: 'A foot stepping' },
    radical: '辶',
    matches: [null, null, null],
  },
  {
    character: '边',
    definition: 'border, edge, margin, side',
    pinyin: ['biān'],
    decomposition: '⿺辶力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臱',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [0], [0], [0]],
  },
  {
    character: '辽',
    definition: 'distant, far',
    pinyin: ['liáo'],
    decomposition: '⿺辶了',
    etymology: {
      type: 'pictophonetic',
      phonetic: '了',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [0], [0], [0]],
  },
  {
    character: '达',
    definition: 'to reach, to arrive at; intelligent',
    pinyin: ['dá'],
    decomposition: '⿺辶大',
    etymology: { type: 'pictophonetic', phonetic: '大', semantic: '辶' },
    radical: '辶',
    matches: [[1], [1], [1], [0], [0], [0]],
  },
  {
    character: '迁',
    definition: 'to shift, to move; to transfer, to change',
    pinyin: ['qiān'],
    decomposition: '⿺辶千',
    etymology: {
      type: 'pictophonetic',
      phonetic: '千',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [0], [0], [0]],
  },
  {
    character: '迂',
    definition: 'abstruse, pedantic, unrealistic',
    pinyin: ['yū'],
    decomposition: '⿺辶于',
    etymology: {
      type: 'pictophonetic',
      phonetic: '于',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [0], [0], [0]],
  },
  {
    character: '迄',
    definition: 'to extend, to reach; till, until',
    pinyin: ['qì'],
    decomposition: '⿺辶乞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乞',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [0], [0], [0]],
  },
  {
    character: '迅',
    definition: 'quick, hasty; sudden, rapid',
    pinyin: ['xùn'],
    decomposition: '⿺辶卂',
    etymology: {
      type: 'ideographic',
      hint: 'To walk 辶 quickly 卂; 卂 also provides the pronunciation',
    },
    radical: '辶',
    matches: [[1], [1], [1], [0], [0], [0]],
  },
  {
    character: '过',
    definition: 'pass; to go across, to pass through',
    pinyin: ['guò'],
    decomposition: '⿺辶寸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咼',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [0], [0], [0]],
  },
  {
    character: '迈',
    definition: 'old; to pass by, to take a stride',
    pinyin: ['mài'],
    decomposition: '⿺辶万',
    etymology: {
      type: 'ideographic',
      hint: 'To take ten thousand 万 steps 辶',
    },
    radical: '辶',
    matches: [[1], [1], [1], [0], [0], [0]],
  },
  {
    character: '迎',
    definition: 'to welcome, to receive, to greet',
    pinyin: ['yíng'],
    decomposition: '⿺辶卬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卬',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '运',
    definition: 'to run; ship, transport; fortune, luck',
    pinyin: ['yùn'],
    decomposition: '⿺辶云',
    etymology: {
      type: 'pictophonetic',
      phonetic: '云',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '近',
    definition: 'to approach; near, close; intimate',
    pinyin: ['jìn'],
    decomposition: '⿺辶斤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斤',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '迓',
    definition: 'to receive a guest',
    pinyin: ['yà'],
    decomposition: '⿺辶牙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '牙',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '返',
    definition: 'to restore, to return, to revert to',
    pinyin: ['fǎn'],
    decomposition: '⿺辶反',
    etymology: {
      type: 'ideographic',
      hint: 'To walk 辶 backwards 反; 反 also provides the pronunciation',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '迕',
    definition: 'obstinate, perverse',
    pinyin: ['wù'],
    decomposition: '⿺辶午',
    etymology: {
      type: 'pictophonetic',
      phonetic: '午',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '还',
    definition: 'also, besides; still, yet; to return',
    pinyin: ['hái'],
    decomposition: '⿺辶不',
    etymology: { type: 'ideographic', hint: 'Not 不 moving 辶' },
    radical: '辶',
    matches: [[1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '这',
    definition: 'this, these; such; here',
    pinyin: ['zhè'],
    decomposition: '⿺辶文',
    radical: '辶',
    matches: [[1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '进',
    definition: 'to advance, to make progress; to come in, to enter',
    pinyin: ['jìn'],
    decomposition: '⿺辶井',
    etymology: {
      type: 'pictophonetic',
      phonetic: '井',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '远',
    definition: 'distant, remote, far; profound',
    pinyin: ['yuǎn'],
    decomposition: '⿺辶元',
    etymology: {
      type: 'pictophonetic',
      phonetic: '元',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '违',
    definition: 'to violate, to disobey, to defy; to separate from',
    pinyin: ['wéi'],
    decomposition: '⿺辶韦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韦',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '连',
    definition: 'to join, to connect; continuous; even',
    pinyin: ['lián'],
    decomposition: '⿺辶车',
    etymology: {
      type: 'ideographic',
      hint: 'A cart 车 moving 辶 goods between cities',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '迟',
    definition: 'tardy, slow, late; to delay',
    pinyin: ['chí'],
    decomposition: '⿺辶尺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尺',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '迢',
    definition: 'distant, far',
    pinyin: ['tiáo'],
    decomposition: '⿺辶召',
    etymology: {
      type: 'pictophonetic',
      phonetic: '召',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '迤',
    definition: 'winding, meandering',
    pinyin: ['yí'],
    decomposition: '⿺辶⿱？也',
    etymology: {
      type: 'pictophonetic',
      phonetic: '也',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [null, null, [1, 1], [1, 1], [1, 1], [0], [0], [0]],
  },
  {
    character: '迥',
    definition: 'distant, far; separated; different',
    pinyin: ['jiǒng'],
    decomposition: '⿺辶冋',
    etymology: {
      type: 'ideographic',
      hint: 'Separated 辶 by a border 冋; 冋 also provides the pronunciation',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '迦',
    definition: 'used in transliterations',
    pinyin: ['jiā'],
    decomposition: '⿺辶加',
    etymology: {
      type: 'pictophonetic',
      phonetic: '加',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '迨',
    definition: 'while, until; to seize, to arrest',
    pinyin: ['dài'],
    decomposition: '⿺辶台',
    etymology: {
      type: 'pictophonetic',
      phonetic: '台',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '迩',
    definition: 'near, close; recent',
    pinyin: ['ěr'],
    decomposition: '⿺辶尔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尔',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '迪',
    definition: 'to advance, to enlighten, to make progress',
    pinyin: ['dí'],
    decomposition: '⿺辶由',
    etymology: { type: 'ideographic', hint: 'To walk 辶 with purpose 由' },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '迫',
    definition: 'to compel, to force; pressing, urgent',
    pinyin: ['pò'],
    decomposition: '⿺辶白',
    etymology: {
      type: 'pictophonetic',
      phonetic: '白',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '迭',
    definition: 'repeatedly, frequently',
    pinyin: ['dié'],
    decomposition: '⿺辶失',
    etymology: {
      type: 'pictophonetic',
      phonetic: '失',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '迮',
    definition: 'to press; hasty; cramped',
    pinyin: ['zé'],
    decomposition: '⿺辶乍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乍',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '述',
    definition: 'to express, to state; to narrate, to tell',
    pinyin: ['shù'],
    decomposition: '⿺辶术',
    etymology: {
      type: 'pictophonetic',
      phonetic: '术',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '迳',
    definition: 'way, path; straight, direct; to approach',
    pinyin: ['jìng'],
    decomposition: '⿺辶？',
    etymology: { type: 'pictophonetic', semantic: '辶', hint: 'walk' },
    radical: '辶',
    matches: [null, null, null, null, null, [0], [0], [0]],
  },
  {
    character: '迴',
    definition: 'to rotate, to revolve; curve, zig-zag',
    pinyin: ['huí'],
    decomposition: '⿺辶回',
    etymology: {
      type: 'ideographic',
      hint: 'To walk 辶 in circles 回; 回 also provides the pronunciation',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '迶',
    definition: 'to walk',
    pinyin: ['yòu'],
    decomposition: '⿺辶有',
    etymology: {
      type: 'pictophonetic',
      phonetic: '有',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '迷',
    definition: 'to bewitch, to charm; a fan of; infatuated',
    pinyin: ['mí'],
    decomposition: '⿺辶米',
    etymology: {
      type: 'pictophonetic',
      phonetic: '米',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '迸',
    definition: 'to gush, to burst; to crack, to split',
    pinyin: ['bèng'],
    decomposition: '⿺辶并',
    etymology: {
      type: 'pictophonetic',
      phonetic: '并',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '迹',
    definition: 'trace, sign, mark, footprint',
    pinyin: ['jī'],
    decomposition: '⿺辶亦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亦',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '追',
    definition: 'to pursue, to chase after; to expel',
    pinyin: ['zhuī'],
    decomposition: '⿺辶⿱丿㠯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㠯',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1, 0], [1, 1], [1, 1], [1, 1], [1, 1], [1, 1], [0], [0], [0]],
  },
  {
    character: '退',
    definition: 'to retreat, to step back, to withdraw',
    pinyin: ['tuì'],
    decomposition: '⿺辶艮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '艮',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '送',
    definition: 'to see off, to send off, to dispatch; to give',
    pinyin: ['sòng'],
    decomposition: '⿺辶关',
    etymology: {
      type: 'ideographic',
      hint: 'A person waving 关 to someone walking away 辶',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '适',
    definition: 'match, comfortable; just',
    pinyin: ['shì'],
    decomposition: '⿺辶舌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '舌',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '逃',
    definition: 'to abscond, to dodge, to escape, to flee',
    pinyin: ['táo'],
    decomposition: '⿺辶兆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兆',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '逄',
    definition: 'surname',
    pinyin: ['páng'],
    decomposition: '⿺辶夅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夅',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '逅',
    definition: 'to meet unexpectedly',
    pinyin: ['hòu'],
    decomposition: '⿺辶后',
    etymology: {
      type: 'pictophonetic',
      phonetic: '后',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '逆',
    definition: 'to disobey, to rebel; traitor, rebel',
    pinyin: ['nì'],
    decomposition: '⿺辶屰',
    etymology: {
      type: 'ideographic',
      hint: 'A disobedient 屰 person 辶; 屰 also provides the pronunciation',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '选',
    definition: 'to select, to elect, to choose; election',
    pinyin: ['xuǎn'],
    decomposition: '⿺辶先',
    etymology: {
      type: 'pictophonetic',
      phonetic: '先',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '逊',
    definition: 'humble, modest; to yield',
    pinyin: ['xùn'],
    decomposition: '⿺辶孙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孙',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '逋',
    definition: 'to flee, to run away; to leave a debt unsettled',
    pinyin: ['bū'],
    decomposition: '⿺辶甫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甫',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '逍',
    definition: 'to ramble, to stroll; to jaunt, to loiter',
    pinyin: ['xiāo'],
    decomposition: '⿺辶肖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肖',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '透',
    definition: 'to pierce, to penetrate, to pass through; thorough',
    pinyin: ['tòu'],
    decomposition: '⿺辶秀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '秀',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '逐',
    definition: 'to pursue; to expel; step by step',
    pinyin: ['zhú'],
    decomposition: '⿺辶豕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豕',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '逑',
    definition: 'to unite, to collect; pair, match',
    pinyin: ['qiú'],
    decomposition: '⿺辶求',
    etymology: {
      type: 'pictophonetic',
      phonetic: '求',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '递',
    definition: 'to deliver, to hand over; substitute',
    pinyin: ['dì'],
    decomposition: '⿺辶弟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弟',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '途',
    definition: 'way, road, path, journey, course',
    pinyin: ['tú'],
    decomposition: '⿺辶余',
    etymology: {
      type: 'pictophonetic',
      phonetic: '余',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '逕',
    definition: 'way, path; straight, direct; to approach',
    pinyin: ['jìng'],
    decomposition: '⿺辶巠',
    etymology: {
      type: 'pictophonetic',
      semantic: '辶',
      hint: 'walk',
      phonetic: '巠',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '逖',
    definition: 'distant, far; to keep at a distance',
    pinyin: ['tì'],
    decomposition: '⿺辶狄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '狄',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '逗',
    definition: 'to entice, to tempt; to arouse, to stir',
    pinyin: ['dòu'],
    decomposition: '⿺辶豆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豆',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '這',
    definition: 'this, these; such; here',
    pinyin: ['zhè'],
    decomposition: '⿺辶言',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辶',
      semantic: '言',
      hint: 'words',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '通',
    definition: 'to pass through, to open, to connect; to communicate; common',
    pinyin: ['tōng'],
    decomposition: '⿺辶甬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甬',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '逛',
    definition: 'to ramble, to stroll, to wander',
    pinyin: ['guàng'],
    decomposition: '⿺辶狂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '狂',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '逝',
    definition: 'to die, to pass away',
    pinyin: ['shì'],
    decomposition: '⿺辶折',
    etymology: {
      type: 'pictophonetic',
      phonetic: '折',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '逞',
    definition: 'indulge oneself; brag, show off',
    pinyin: ['chěng'],
    decomposition: '⿺辶呈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '呈',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '速',
    definition: 'prompt, quick, speedy',
    pinyin: ['sù'],
    decomposition: '⿺辶束',
    etymology: {
      type: 'pictophonetic',
      phonetic: '束',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '造',
    definition: 'to build, to construct, to invent, to manufacture',
    pinyin: ['zào'],
    decomposition: '⿺辶告',
    etymology: {
      type: 'pictophonetic',
      phonetic: '告',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '逡',
    definition: 'to withdraw, to retreat, to fall back',
    pinyin: ['qūn'],
    decomposition: '⿺辶夋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夋',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '逢',
    definition: 'to happen to meet; chance meeting, coincidence',
    pinyin: ['féng'],
    decomposition: '⿺辶夆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夆',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '連',
    definition: 'to join, to connect; continuous; even',
    pinyin: ['lián'],
    decomposition: '⿺辶車',
    etymology: {
      type: 'ideographic',
      hint: 'A cart 車 moving 辶 goods between cities',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '逦',
    definition: 'winding, meandering',
    pinyin: ['lǐ'],
    decomposition: '⿺辶丽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丽',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '逭',
    definition: 'to flee, to escape, to avoid',
    pinyin: ['huàn'],
    decomposition: '⿺辶官',
    etymology: {
      type: 'pictophonetic',
      phonetic: '官',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '逮',
    definition: 'to catch, to seize; to arrive, to reach',
    pinyin: ['dǎi'],
    decomposition: '⿺辶隶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隶',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '逯',
    definition: 'to leave without a reason; surname',
    pinyin: ['lù'],
    decomposition: '⿺辶录',
    etymology: {
      type: 'pictophonetic',
      phonetic: '录',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '週',
    definition: 'week; turn, cycle; anniversary',
    pinyin: ['zhōu'],
    decomposition: '⿺辶周',
    etymology: {
      type: 'ideographic',
      hint: 'To walk 辶 in a circle 周; 周 also provides the pronunciation',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '進',
    definition: 'to advance, to make progress; to come in, to enter',
    pinyin: ['jìn'],
    decomposition: '⿺辶隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隹',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '逵',
    definition: 'thoroughfare, crossroads',
    pinyin: ['kuí'],
    decomposition: '⿺辶坴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '坴',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '逶',
    definition: 'winding, curving; to swagger',
    pinyin: ['wēi'],
    decomposition: '⿺辶委',
    etymology: {
      type: 'pictophonetic',
      phonetic: '委',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '逸',
    definition: 'to flee, to escape, to break loose',
    pinyin: ['yì'],
    decomposition: '⿺辶兔',
    etymology: { type: 'ideographic', hint: 'To run 辶 like a rabbit 兔' },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '逻',
    definition: 'to patrol, to inspect; patrol, watch; logic',
    pinyin: ['luó'],
    decomposition: '⿺辶罗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '罗',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '逼',
    definition: 'to bother, to pressure; to compel, to force',
    pinyin: ['bī'],
    decomposition: '⿺辶畐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畐',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '逾',
    definition: 'to jump over; to exceed, to surpass',
    pinyin: ['yú'],
    decomposition: '⿺辶俞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '俞',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '遀',
    definition: 'to walk',
    pinyin: ['suí'],
    decomposition: '⿺辶？',
    radical: '辶',
    matches: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '遁',
    definition: 'to flee, to escape; to hide, to conceal oneself',
    pinyin: ['dùn'],
    decomposition: '⿺辶盾',
    etymology: {
      type: 'ideographic',
      hint: 'To escape 辶 to shelter 盾; 盾 also provides the pronunciation',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '遂',
    definition: 'to fail; to follow, to comply with',
    pinyin: ['suì'],
    decomposition: '⿺辶⿱丷豕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豕',
      hint: 'walk',
      semantic: '辶',
    },
    radical: '辶',
    matches: [
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '遄',
    definition: 'to hurry; to go to and fro',
    pinyin: ['chuán'],
    decomposition: '⿺辶耑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '耑',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '遇',
    definition: 'to meet, to encounter, to come across',
    pinyin: ['yù'],
    decomposition: '⿺辶禺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '禺',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '遊',
    definition: 'sto wander, to travel, to roam',
    pinyin: ['yóu'],
    decomposition: '⿺辶斿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斿',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '運',
    definition: 'to run; ship, transport; fortune, luck',
    pinyin: ['yùn'],
    decomposition: '⿺辶軍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '軍',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '遍',
    definition: 'everywhere, all over, throughout',
    pinyin: ['biàn'],
    decomposition: '⿺辶扁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '扁',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '過',
    definition: 'pass; to go across, to pass through',
    pinyin: ['guò'],
    decomposition: '⿺辶咼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咼',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '遏',
    definition: 'to curb, to check, to stop, to suppress',
    pinyin: ['è'],
    decomposition: '⿺辶曷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曷',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '遐',
    definition: 'distant, far; to abandon, to cast away',
    pinyin: ['xiá'],
    decomposition: '⿺辶叚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叚',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '遑',
    definition: 'leisurely; hurried, anxious',
    pinyin: ['huáng'],
    decomposition: '⿺辶皇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皇',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '遒',
    definition: 'robust, strong; unyielding',
    pinyin: ['qiú'],
    decomposition: '⿺辶酋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '酋',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '道',
    definition: 'method, way; path, road',
    pinyin: ['dào'],
    decomposition: '⿺辶首',
    etymology: {
      type: 'pictophonetic',
      phonetic: '首',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '達',
    definition: 'to reach, to arrive at; intelligent',
    pinyin: ['dá'],
    decomposition: '⿺辶羍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羍',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '違',
    definition: 'to violate, to disobey, to defy; to separate from',
    pinyin: ['wéi'],
    decomposition: '⿺辶韋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韋',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '遗',
    definition: 'to lose; a lost article',
    pinyin: ['yí'],
    decomposition: '⿺辶贵',
    etymology: {
      type: 'ideographic',
      hint: 'To leave 辶 something valuable 贵 behind',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '遘',
    definition: 'to meet; to come across',
    pinyin: ['gòu'],
    decomposition: '⿺辶冓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冓',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '遙',
    definition: 'distant, remote',
    pinyin: ['yáo'],
    decomposition: '⿺辶䍃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '䍃',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '遛',
    definition: 'to walk, to stroll',
    pinyin: ['liú'],
    decomposition: '⿺辶留',
    etymology: {
      type: 'pictophonetic',
      phonetic: '留',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '遜',
    definition: 'humble, modest; to yield',
    pinyin: ['xùn'],
    decomposition: '⿺辶孫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孫',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '遞',
    definition: 'to deliver, to hand over; substitute',
    pinyin: ['dì'],
    decomposition: '⿺辶虒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '虒',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '遠',
    definition: 'distant, remote, far; profound',
    pinyin: ['yuǎn'],
    decomposition: '⿺辶袁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '袁',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '遢',
    definition: 'careless, negligent, slipshod',
    pinyin: ['tà'],
    decomposition: '⿺辶⿱日羽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '日',
      hint: 'walk',
      semantic: '辶',
    },
    radical: '辶',
    matches: [
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '遣',
    definition: 'to send, to dispatch; to exile, to send off',
    pinyin: ['qiǎn'],
    decomposition: '⿺辶⿱⿱中一㠯',
    etymology: { type: 'pictophonetic', semantic: '辶', hint: 'walk' },
    radical: '辶',
    matches: [
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '遥',
    definition: 'distant, remote',
    pinyin: ['yáo'],
    decomposition: '⿺辶䍃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '䍃',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '遨',
    definition: 'to ramble, to roam; to travel for pleasure',
    pinyin: ['áo'],
    decomposition: '⿺辶敖',
    etymology: {
      type: 'ideographic',
      hint: 'To walk 辶 about 敖; 敖 also provides the pronunciation',
    },
    radical: '辶',
    matches: [[1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [0], [0], [0]],
  },
  {
    character: '適',
    definition: 'match, comfortable; just',
    pinyin: ['shì'],
    decomposition: '⿺辶啇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '啇',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '遭',
    definition: 'to meet, to encounter, to come across',
    pinyin: ['zāo'],
    decomposition: '⿺辶曹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曹',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '遮',
    definition: 'to cover, to protect, to shield',
    pinyin: ['zhē'],
    decomposition: '⿺辶庶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '庶',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '遲',
    definition: 'tardy, slow, late; to delay',
    pinyin: ['chí'],
    decomposition: '⿺辶犀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '犀',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '遴',
    definition: 'to select, to choose; surname',
    pinyin: ['lín'],
    decomposition: '⿺辶粦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '粦',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '遵',
    definition: 'to follow, to comply with; to honor',
    pinyin: ['zūn'],
    decomposition: '⿺辶尊',
    etymology: {
      type: 'ideographic',
      hint: 'To follow 辶 or honor 尊 someone; 尊 also provides the pronunciation',
    },
    radical: '辶',
    matches: [
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '遷',
    definition: 'to shift, to move; to transfer, to change',
    pinyin: ['qiān'],
    decomposition: '⿺辶䙴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '䙴',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '選',
    definition: 'to select, to elect, to choose; election',
    pinyin: ['xuǎn'],
    decomposition: '⿺辶巽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巽',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '遺',
    definition: 'to lose; a lost article',
    pinyin: ['yí'],
    decomposition: '⿺辶貴',
    etymology: {
      type: 'ideographic',
      hint: 'To leave 辶 something valuable 貴 behind',
    },
    radical: '辶',
    matches: [
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '遼',
    definition: 'distant, far',
    pinyin: ['liáo'],
    decomposition: '⿺辶尞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尞',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '遽',
    definition: 'rapid, sudden, unexpected',
    pinyin: ['jù'],
    decomposition: '⿺辶豦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豦',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '避',
    definition: 'to avoid, to turn away; to escape, to hide',
    pinyin: ['bì'],
    decomposition: '⿺辶辟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辟',
      semantic: '辶',
      hint: 'foot',
    },
    radical: '辶',
    matches: [
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '邀',
    definition: 'to invite, to welcome; to intercept, to meet',
    pinyin: ['yāo'],
    decomposition: '⿺辶敫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敫',
      semantic: '辶',
      hint: 'foot',
    },
    radical: '辶',
    matches: [
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '邁',
    definition: 'old; to pass by, to take a stride',
    pinyin: ['mài'],
    decomposition: '⿺辶萬',
    etymology: {
      type: 'ideographic',
      hint: 'To take ten thousand 萬 steps 辶',
    },
    radical: '辶',
    matches: [
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '邂',
    definition: 'an unexpected meeting',
    pinyin: ['xiè'],
    decomposition: '⿺辶解',
    etymology: {
      type: 'pictophonetic',
      phonetic: '解',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '邃',
    definition: 'profound, mysterious, deep',
    pinyin: ['suì'],
    decomposition: '⿺辶⿱穴㒸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㒸',
      hint: 'cave',
      semantic: '穴',
    },
    radical: '辶',
    matches: [
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '還',
    definition: 'also, besides; still, yet; to return',
    pinyin: ['hái'],
    decomposition: '⿺辶睘',
    radical: '辶',
    matches: [
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '邇',
    definition: 'near, close; recent',
    pinyin: ['ěr'],
    decomposition: '⿺辶爾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爾',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '邈',
    definition: 'distant, remote; profound',
    pinyin: ['miǎo'],
    decomposition: '⿺辶貌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '貌',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '邊',
    definition: 'border, edge, margin, side',
    pinyin: ['biān'],
    decomposition: '⿺辶臱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臱',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '邋',
    definition: 'sloppy; rags',
    pinyin: ['lā'],
    decomposition: '⿺辶巤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巤',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '邏',
    definition: 'to patrol, to inspect; patrol, watch; logic',
    pinyin: ['luó'],
    decomposition: '⿺辶羅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羅',
      semantic: '辶',
      hint: 'walk',
    },
    radical: '辶',
    matches: [
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '邑',
    definition: 'area, district, city, state',
    pinyin: ['yì'],
    decomposition: '⿱口巴',
    etymology: {
      type: 'ideographic',
      hint: 'A place 口 where people hope 巴 to settle',
    },
    radical: '邑',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '邓',
    definition: 'surname',
    pinyin: ['dèng'],
    decomposition: '⿰又阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '登',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '邕',
    definition: 'former or literary name for Nanning (in Guangxi)',
    pinyin: ['yōng'],
    decomposition: '⿱巛邑',
    etymology: { type: 'ideographic', hint: 'The area 邑 around a river 巛' },
    radical: '邑',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '邗',
    definition: 'an ancient place in the state of Wu',
    pinyin: ['hán'],
    decomposition: '⿰干阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '干',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '邘',
    definition: 'a state in Henan province',
    pinyin: ['yú'],
    decomposition: '⿰于阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '于',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '邙',
    definition: 'a mountain in Henan province',
    pinyin: ['máng'],
    decomposition: '⿰亡阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亡',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '邛',
    definition: 'mound; in distress',
    pinyin: ['qióng'],
    decomposition: '⿰工阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '工',
      semantic: '阝',
      hint: 'hill',
    },
    radical: '阝',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '邝',
    definition: 'surname',
    pinyin: ['kuàng'],
    decomposition: '⿰广阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '广',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '邠',
    definition: 'a county in Shaanxi province',
    pinyin: ['bīn'],
    decomposition: '⿰分阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '分',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '邡',
    definition: 'a district in Sichuan province',
    pinyin: ['fāng'],
    decomposition: '⿰方阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '方',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '邢',
    definition: 'a state in Hebei province; surname',
    pinyin: ['xíng'],
    decomposition: '⿰开阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '开',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '那',
    definition: 'that, that one, those',
    pinyin: ['nà'],
    decomposition: '⿰⿹？？阝',
    radical: '阝',
    matches: [null, null, null, null, [1], [1]],
  },
  {
    character: '邦',
    definition: 'country, nation, state',
    pinyin: ['bāng'],
    decomposition: '⿰丰阝',
    etymology: { type: 'ideographic', hint: 'A bountiful 丰 place 阝' },
    radical: '阝',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '邨',
    definition: 'village, hamlet; rustic',
    pinyin: ['cūn'],
    decomposition: '⿰屯阝',
    etymology: {
      type: 'ideographic',
      hint: 'A rustic 屯 town 阝; 阝 also provides the pronunciation',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '邪',
    definition: 'wrong, evil, demonic; perverse, depraved, heterodox',
    pinyin: ['xié'],
    decomposition: '⿰牙阝',
    radical: '阝',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '邬',
    definition: 'various place names; surname',
    pinyin: ['wū'],
    decomposition: '⿰乌阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乌',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [1], [1]],
  },
  {
    character: '邮',
    definition: 'mail; post office',
    pinyin: ['yóu'],
    decomposition: '⿰由阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '由',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '邯',
    definition: 'a district in Hebei province',
    pinyin: ['hán'],
    decomposition: '⿰甘阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甘',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '邰',
    definition: 'a state in Shanxi province; surname',
    pinyin: ['tái'],
    decomposition: '⿰台阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '台',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '邱',
    definition: 'mound, hill; grave; surname',
    pinyin: ['qiū'],
    decomposition: '⿰丘阝',
    etymology: {
      type: 'ideographic',
      hint: 'A place 阝 on a hill 丘; 丘 also provides the pronunciation',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '邳',
    definition: 'a department in the state of Lu',
    pinyin: ['pī'],
    decomposition: '⿰丕阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丕',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '邴',
    definition: 'an ancient city; pleased, happy; surname',
    pinyin: ['bǐng'],
    decomposition: '⿰丙阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丙',
      semantic: '阝',
      hint: 'city',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '邵',
    definition: 'various place names; surname',
    pinyin: ['shào'],
    decomposition: '⿰召阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '召',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '邶',
    definition: 'a place in Henan province',
    pinyin: ['bèi'],
    decomposition: '⿰北阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '北',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '邸',
    definition: 'official residence',
    pinyin: ['dǐ'],
    decomposition: '⿰氐阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '氐',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '邹',
    definition: 'an ancient state; surname',
    pinyin: ['zōu'],
    decomposition: '⿰刍阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '刍',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '邺',
    definition: 'a place in Henan province',
    pinyin: ['yè'],
    decomposition: '⿰业阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '业',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '邻',
    definition: 'neighbor; neighborhood',
    pinyin: ['lín'],
    decomposition: '⿰令阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '令',
      semantic: '阝',
      hint: 'town',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '邾',
    definition: 'an ancient feudal state in Shandong province',
    pinyin: ['zhū'],
    decomposition: '⿰朱阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朱',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '郁',
    definition: 'melancholy; dense growth',
    pinyin: ['yù'],
    decomposition: '⿰有阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '有',
      semantic: '阝',
      hint: 'city',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '郄',
    definition: 'surname',
    pinyin: ['qiè'],
    decomposition: '⿰⿱乂厷阝',
    radical: '阝',
    matches: [[0, 0], [0, 0], [0, 1], [0, 1], [0, 1], [0, 1], [1], [1]],
  },
  {
    character: '郅',
    definition: 'to grow, to flourish; superlative',
    pinyin: ['zhì'],
    decomposition: '⿰至阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '至',
      semantic: '阝',
      hint: 'city',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '郇',
    definition: 'an ancient feudal state in Shaanxi province',
    pinyin: ['huán'],
    decomposition: '⿰旬阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旬',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '郊',
    definition: 'suburbs, outskirts; wasteland, open space',
    pinyin: ['jiāo'],
    decomposition: '⿰交阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '交',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '郎',
    definition: 'gentleman, young man; husband',
    pinyin: ['láng'],
    decomposition: '⿰良阝',
    etymology: {
      type: 'ideographic',
      hint: 'A man from a good 良 place 阝;  良 also provides the pronunciation',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '郏',
    definition: 'a county in Henan province; surname',
    pinyin: ['jiá'],
    decomposition: '⿰夹阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夹',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '郐',
    definition: 'a state in Henan province',
    pinyin: ['kuài'],
    decomposition: '⿰会阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '会',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '郑',
    definition: "state in today's Henan; surname",
    pinyin: ['zhèng'],
    decomposition: '⿰关阝',
    etymology: { type: 'ideographic', hint: 'A city 阝 guarding a pass 关' },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '郓',
    definition: 'an ancient town; surname',
    pinyin: ['yùn'],
    decomposition: '⿰军阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '军',
      semantic: '阝',
      hint: 'town',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '郗',
    definition: 'an ancient city; surname',
    pinyin: ['xī'],
    decomposition: '⿰希阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '希',
      semantic: '阝',
      hint: 'city',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '郛',
    definition: 'suburbs; city walls',
    pinyin: ['fú'],
    decomposition: '⿰孚阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孚',
      semantic: '阝',
      hint: 'city',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '郜',
    definition: 'a feudal state in Shantong; surname',
    pinyin: ['gào'],
    decomposition: '⿰告阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '告',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '郝',
    definition: 'a place in Shanxi province; surname',
    pinyin: ['hǎo'],
    decomposition: '⿰赤阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '赤',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '郟',
    definition: 'a county in Henan province; surname',
    pinyin: ['jiá'],
    decomposition: '⿰夾阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夾',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '郡',
    definition: 'county, region, administrative division',
    pinyin: ['jùn'],
    decomposition: '⿰君阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '君',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '郢',
    definition: 'a state in Hubei province',
    pinyin: ['yǐng'],
    decomposition: '⿰呈阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '呈',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '郤',
    definition: 'crack, crevice; gap, interval; surname',
    pinyin: ['xì'],
    decomposition: '⿰谷阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '阝',
      semantic: '谷',
      hint: 'valley',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '郦',
    definition: 'a place in Henan province',
    pinyin: ['lì'],
    decomposition: '⿰丽阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丽',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '郧',
    definition: 'a county in Hubei province',
    pinyin: ['yún'],
    decomposition: '⿰员阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '员',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '部',
    definition: 'department, ministry; division, unit; part, section',
    pinyin: ['bù'],
    decomposition: '⿰咅阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咅',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '郫',
    pinyin: ['pí'],
    decomposition: '⿰卑阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卑',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '郭',
    definition: 'city limits; surname',
    pinyin: ['guō'],
    decomposition: '⿰享阝',
    etymology: {
      type: 'ideographic',
      hint: 'A tall building 享 at the edge of a city 阝',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '郯',
    definition: 'an ancient city; surname',
    pinyin: ['tán'],
    decomposition: '⿰炎阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '炎',
      semantic: '阝',
      hint: 'city',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '郴',
    definition: 'a county in Hunan province; surname',
    pinyin: ['chēn'],
    decomposition: '⿰林阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '林',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '郵',
    definition: 'mail; post office',
    pinyin: ['yóu'],
    decomposition: '⿰垂阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '垂',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '郸',
    definition: 'a county in Hebei province',
    pinyin: ['dān'],
    decomposition: '⿰单阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '单',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '都',
    definition: 'all, each, entirely, whole; metropolis; capital',
    pinyin: ['dōu'],
    decomposition: '⿰者阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '者',
      semantic: '阝',
      hint: 'city',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '郾',
    definition: 'a county in Henan province',
    pinyin: ['yǎn'],
    decomposition: '⿰匽阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匽',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '鄂',
    definition: 'Hubei province; startled',
    pinyin: ['è'],
    decomposition: '⿰咢阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咢',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '鄄',
    definition: 'a district in Shandong province',
    pinyin: ['juàn'],
    decomposition: '⿰垔阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '垔',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '鄆',
    definition: 'an ancient town; surname',
    pinyin: ['yùn'],
    decomposition: '⿰軍阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '軍',
      semantic: '阝',
      hint: 'town',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '鄉',
    definition: 'country, village; rural',
    pinyin: ['xiāng'],
    decomposition: '⿰乡郎',
    etymology: {
      type: 'ideographic',
      hint: 'Two people  乡 and ⻏ hunched over a meal 良',
    },
    radical: '阝',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '鄋',
    definition: 'a county in Shandong province',
    pinyin: ['sōu'],
    decomposition: '⿰叟阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叟',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '鄒',
    definition: 'an ancient state; surname',
    pinyin: ['zōu'],
    decomposition: '⿰芻阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '芻',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '鄖',
    definition: 'a county in Hubei province',
    pinyin: ['yún'],
    decomposition: '⿰員阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '員',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '鄙',
    definition: 'rustic, vulgar; to despise, to scorn',
    pinyin: ['bǐ'],
    decomposition: '⿰啚阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '啚',
      semantic: '阝',
      hint: 'village',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '鄞',
    definition: 'a county in Zhejiang province',
    pinyin: ['yín'],
    decomposition: '⿰堇阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堇',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '鄢',
    definition: 'a district in Henan province',
    pinyin: ['yān'],
    decomposition: '⿰焉阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '焉',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '鄣',
    definition: 'an ancient city in Jiangsu province',
    pinyin: ['zhāng'],
    decomposition: '⿰章阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '章',
      semantic: '阝',
      hint: 'city',
    },
    radical: '阝',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '鄦',
    definition: 'surname',
    pinyin: ['xǔ'],
    decomposition: '⿰無阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '無',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '鄧',
    definition: 'surname',
    pinyin: ['dèng'],
    decomposition: '⿰登阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '登',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '鄭',
    definition: "state in today's Henan; surname",
    pinyin: ['zhèng'],
    decomposition: '⿰奠阝',
    etymology: { type: 'ideographic', hint: 'A city 阝 guarding a pass 奠' },
    radical: '阝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '鄯',
    definition: 'an ancient district in Gansu province',
    pinyin: ['shàn'],
    decomposition: '⿰善阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '善',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '鄰',
    definition: 'neighbor; neighborhood',
    pinyin: ['lín'],
    decomposition: '⿰粦阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '粦',
      semantic: '阝',
      hint: 'town',
    },
    radical: '阝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '鄱',
    definition: 'a county and lake in Jiangxi province',
    pinyin: ['pó'],
    decomposition: '⿰番阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '番',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '鄲',
    definition: 'a county in Hebei province',
    pinyin: ['dān'],
    decomposition: '⿰單阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '單',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '鄴',
    definition: 'a place in Henan province',
    pinyin: ['yè'],
    decomposition: '⿰業阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '業',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '鄹',
    definition: 'the name of a state; surname',
    pinyin: ['zōu'],
    decomposition: '⿰聚阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '聚',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '酃',
    definition: 'a district in Hunan province',
    pinyin: ['líng'],
    decomposition: '⿰霝阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '霝',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '酆',
    definition: 'the name of a Zhou-period state',
    pinyin: ['fēng'],
    decomposition: '⿰豐阝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豐',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '酉',
    definition: 'wine; wine vessel; chemical',
    pinyin: ['yǒu'],
    decomposition: '⿻兀日',
    etymology: { type: 'pictographic', hint: 'A vessel half-filled with wine' },
    radical: '酉',
    matches: [[0], [1], [1], [0], [0], [1], [1]],
  },
  {
    character: '酊',
    definition: 'drunk, intoxicated',
    pinyin: ['dīng'],
    decomposition: '⿰酉丁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丁',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '酋',
    definition: 'chief of tribe, chieftain',
    pinyin: ['qiú'],
    decomposition: '⿱丷酉',
    etymology: { type: 'pictographic', hint: 'A feathered crown' },
    radical: '酉',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '酌',
    definition: 'to pour wine, to drink wine; to deliberate, to consider',
    pinyin: ['zhuó'],
    decomposition: '⿰酉勺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '勺',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '配',
    definition: 'to blend, to mix; to fit, to match',
    pinyin: ['pèi'],
    decomposition: '⿰酉己',
    etymology: {
      type: 'pictophonetic',
      phonetic: '己',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '酎',
    definition: 'double-fermented wine, vintage wine',
    pinyin: ['zhòu'],
    decomposition: '⿰酉寸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寸',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '酏',
    definition: 'millet wine',
    pinyin: ['yǐ'],
    decomposition: '⿰酉也',
    etymology: {
      type: 'pictophonetic',
      phonetic: '也',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '酐',
    definition: 'anhydride',
    pinyin: ['gān'],
    decomposition: '⿰酉干',
    etymology: {
      type: 'pictophonetic',
      phonetic: '干',
      semantic: '酉',
      hint: 'chemical',
    },
    radical: '酉',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '酒',
    definition: 'wine, spirits, liquor, alcohol',
    pinyin: ['jiǔ'],
    decomposition: '⿰氵酉',
    etymology: {
      type: 'ideographic',
      hint: 'A jar 酉 of wine 氵; 酉 also provides the pronunciation',
    },
    radical: '酉',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '酕',
    definition: 'drunk, blotto',
    pinyin: ['máo'],
    decomposition: '⿰酉毛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '毛',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '酖',
    definition: 'poison, bad wine; addicted',
    pinyin: ['zhèn'],
    decomposition: '⿰酉冘',
    etymology: { type: 'ideographic', hint: 'Suspect 冘 wine 酉' },
    radical: '酉',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '酗',
    definition: 'violent, raging drunk, blotto',
    pinyin: ['xù'],
    decomposition: '⿰酉凶',
    etymology: { type: 'ideographic', hint: 'A dangerous 凶 drunk 酉' },
    radical: '酉',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '酚',
    definition: 'carbolic acid; phenol',
    pinyin: ['fēn'],
    decomposition: '⿰酉分',
    etymology: {
      type: 'pictophonetic',
      phonetic: '分',
      semantic: '酉',
      hint: 'chemical',
    },
    radical: '酉',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '酝',
    definition: 'liquor, spirits, wine; to ferment',
    pinyin: ['yùn'],
    decomposition: '⿰酉云',
    etymology: {
      type: 'pictophonetic',
      phonetic: '云',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '酞',
    definition: 'phthalein',
    pinyin: ['tài'],
    decomposition: '⿰酉太',
    etymology: {
      type: 'pictophonetic',
      phonetic: '太',
      semantic: '酉',
      hint: 'chemical',
    },
    radical: '酉',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '酡',
    definition: 'ruddy, flushed',
    pinyin: ['tuó'],
    decomposition: '⿰酉它',
    etymology: {
      type: 'pictophonetic',
      phonetic: '它',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '酢',
    definition: 'a toast to the host',
    pinyin: ['cù'],
    decomposition: '⿰酉乍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乍',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '酣',
    definition: 'to enjoy liquor',
    pinyin: ['hān'],
    decomposition: '⿰酉甘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甘',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '酤',
    definition: 'to sell liquor',
    pinyin: ['gū'],
    decomposition: '⿰酉古',
    etymology: {
      type: 'pictophonetic',
      phonetic: '古',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '酥',
    definition: 'butter; crispy, flaky; fluffy, light',
    pinyin: ['sū'],
    decomposition: '⿰酉禾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '酉',
      semantic: '禾',
      hint: 'grain',
    },
    radical: '酉',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '酦',
    definition: 'to ferment, to brew',
    pinyin: ['fā'],
    decomposition: '⿰酉发',
    etymology: {
      type: 'pictophonetic',
      phonetic: '发',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '酩',
    definition: 'drunk, tipsy, intoxicated',
    pinyin: ['mǐng'],
    decomposition: '⿰酉名',
    etymology: {
      type: 'pictophonetic',
      phonetic: '名',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '酪',
    definition: 'cream, cheese; koumiss',
    pinyin: ['lào'],
    decomposition: '⿰酉各',
    etymology: {
      type: 'pictophonetic',
      phonetic: '各',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '酬',
    definition: 'to toast, to entertain; to reward, to compensate',
    pinyin: ['chóu'],
    decomposition: '⿰酉州',
    etymology: {
      type: 'pictophonetic',
      phonetic: '州',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '酮',
    definition: 'ketone',
    pinyin: ['tóng'],
    decomposition: '⿰酉同',
    etymology: {
      type: 'pictophonetic',
      phonetic: '同',
      semantic: '酉',
      hint: 'chemical',
    },
    radical: '酉',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '酯',
    definition: 'ester',
    pinyin: ['zhǐ'],
    decomposition: '⿰酉旨',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旨',
      semantic: '酉',
      hint: 'chemical',
    },
    radical: '酉',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '酰',
    definition: 'acylate',
    pinyin: ['xiān'],
    decomposition: '⿰酉先',
    etymology: {
      type: 'pictophonetic',
      phonetic: '先',
      semantic: '酉',
      hint: 'chemical',
    },
    radical: '酉',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '酱',
    definition: 'sauce, paste, jam',
    pinyin: ['jiàng'],
    decomposition: '⿱⿰丬夕酉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丬',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '酲',
    definition: 'hangover; uncomfortable',
    pinyin: ['chéng'],
    decomposition: '⿰酉呈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '呈',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '酴',
    definition: 'yeast; wine; to leaven, to ferment',
    pinyin: ['tú'],
    decomposition: '⿰酉余',
    etymology: {
      type: 'pictophonetic',
      phonetic: '余',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '酵',
    definition: 'yeast; to leaven',
    pinyin: ['jiào'],
    decomposition: '⿰酉孝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孝',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '酶',
    definition: 'enzyme; to ferment',
    pinyin: ['méi'],
    decomposition: '⿰酉每',
    etymology: {
      type: 'pictophonetic',
      phonetic: '每',
      semantic: '酉',
      hint: 'chemical',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '酷',
    definition: 'strong, stimulating; ruthless, intense',
    pinyin: ['kù'],
    decomposition: '⿰酉告',
    etymology: {
      type: 'pictophonetic',
      phonetic: '告',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '酸',
    definition: 'tart, sour; spoiled; acid',
    pinyin: ['suān'],
    decomposition: '⿰酉夋',
    etymology: {
      type: 'ideographic',
      hint: 'Wine 酉 aged too long 夋; 夋 also provides the pronunciation',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '酹',
    definition: 'to pour out a libation; to sprinkle',
    pinyin: ['lèi'],
    decomposition: '⿰酉寽',
    etymology: {
      type: 'ideographic',
      hint: 'A pinch 寽 of wine 酉; 寽 also provides the pronunciation',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '酽',
    definition: 'thick, strong (as a beverage)',
    pinyin: ['yàn'],
    decomposition: '⿰酉严',
    etymology: {
      type: 'ideographic',
      hint: 'Hard 严 liquor 酉; 严 also provides the pronunciation',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '酾',
    definition: 'to filter, to strain',
    pinyin: ['shāi'],
    decomposition: '⿰酉丽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丽',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '酿',
    definition: 'to ferment, to brew',
    pinyin: ['niàng'],
    decomposition: '⿰酉良',
    etymology: {
      type: 'pictophonetic',
      phonetic: '良',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '醃',
    definition: 'to pickle, to marinate; to salt, to cure',
    pinyin: ['yān'],
    decomposition: '⿰酉奄',
    etymology: {
      type: 'ideographic',
      hint: 'To leave 奄 meat in wine 酉; 奄 also provides the pronunciation',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '醄',
    definition: 'drunk, flushed, happy',
    pinyin: ['táo'],
    decomposition: '⿰酉匋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匋',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '醅',
    definition: 'unstrained spirits',
    pinyin: ['pēi'],
    decomposition: '⿰酉咅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咅',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '醇',
    definition: 'rich, pure, as good as wine',
    pinyin: ['chún'],
    decomposition: '⿰酉享',
    etymology: { type: 'ideographic', hint: 'Wine 酉 fit to be savored 享' },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '醉',
    definition: 'intoxicated, drunk; addicted',
    pinyin: ['zuì'],
    decomposition: '⿰酉卒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卒',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '醋',
    definition: 'vinegar; jealousy, envy',
    pinyin: ['cù'],
    decomposition: '⿰酉昔',
    etymology: { type: 'ideographic', hint: 'Aged 昔 wine 酉; wine gone sour' },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '醌',
    definition: 'quinone',
    pinyin: ['kūn'],
    decomposition: '⿰酉昆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昆',
      semantic: '酉',
      hint: 'chemical',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '醍',
    definition: 'essential oil of butter',
    pinyin: ['tí'],
    decomposition: '⿰酉是',
    etymology: {
      type: 'pictophonetic',
      phonetic: '是',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '醐',
    definition: 'the purest cream',
    pinyin: ['hú'],
    decomposition: '⿰酉胡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '胡',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '醑',
    definition: 'to filter, to strain',
    pinyin: ['xǔ'],
    decomposition: '⿰酉胥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '胥',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '醒',
    definition: 'to wake up, to startle; to sober up',
    pinyin: ['xǐng'],
    decomposition: '⿰酉星',
    etymology: {
      type: 'pictophonetic',
      phonetic: '星',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '醚',
    definition: 'ether',
    pinyin: ['mí'],
    decomposition: '⿰酉迷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '迷',
      semantic: '酉',
      hint: 'chemical',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '醛',
    definition: 'aldehyde',
    pinyin: ['quán'],
    decomposition: '⿰酉荃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '荃',
      semantic: '酉',
      hint: 'chemical',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '醜',
    definition: 'ugly; shameful; comedian, clown',
    pinyin: ['chǒu'],
    decomposition: '⿰酉鬼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '酉',
      semantic: '鬼',
      hint: 'demon',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '醞',
    definition: 'liquor, spirits, wine; to ferment',
    pinyin: ['yùn'],
    decomposition: '⿰酉⿱囚皿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皿',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '醢',
    definition: 'minced pickled meat; to mince',
    pinyin: ['hǎi'],
    decomposition: '⿰酉⿱右皿',
    etymology: {
      type: 'ideographic',
      hint: 'Meat 皿 left in wine 酉; 右 provides the pronunciation',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '醣',
    definition: 'carbohydrate',
    pinyin: ['táng'],
    decomposition: '⿰酉唐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '唐',
      semantic: '酉',
      hint: 'chemical',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '醪',
    definition: 'unfiltered wine; sediment, dregs',
    pinyin: ['láo'],
    decomposition: '⿰酉翏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '翏',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '醫',
    definition: 'to cure, to heal, to treat; doctor; medicine',
    pinyin: ['yī'],
    decomposition: '⿱殹酉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '殹',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '醬',
    definition: 'sauce, paste, jam',
    pinyin: ['jiàng'],
    decomposition: '⿱將酉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '將',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '醭',
    definition: 'mold, pond scum',
    pinyin: ['bú'],
    decomposition: '⿰酉菐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '菐',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '醮',
    definition: 'to anoint, to perform a rite; Daoist or Buddhist ceremony',
    pinyin: ['jiào'],
    decomposition: '⿰酉焦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '焦',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '醯',
    definition: 'vinegar, acid; to pickle',
    pinyin: ['xī'],
    decomposition: '⿰酉⿱㐬皿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㐬',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '醱',
    definition: 'to ferment, to brew',
    pinyin: ['fā'],
    decomposition: '⿰酉發',
    etymology: {
      type: 'pictophonetic',
      phonetic: '發',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '醴',
    definition: 'sweet wine; sweet spring water',
    pinyin: ['lǐ'],
    decomposition: '⿰酉豊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豊',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '醵',
    definition: 'to contribute for drinks; to pool money',
    pinyin: ['jù'],
    decomposition: '⿰酉豦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豦',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '醺',
    definition: 'drunk, intoxicated',
    pinyin: ['xūn'],
    decomposition: '⿰酉熏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '熏',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '釀',
    definition: 'to ferment, to brew',
    pinyin: ['niàng'],
    decomposition: '⿰酉襄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '襄',
      semantic: '酉',
      hint: 'wine',
    },
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '釁',
    definition: 'to quarrel, to dispute; a blood sacrifice',
    pinyin: ['xìn'],
    decomposition: '⿳興酉分',
    radical: '酉',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '釆',
    definition: 'to distinguish; to pick, to gather, to collect',
    pinyin: ['biàn'],
    decomposition: '⿱丿米',
    etymology: { type: 'ideographic', hint: 'Rice 米 ready to be picked' },
    radical: '釆',
    matches: [[0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '采',
    definition: 'to collect, to gather; to pick, to pluck',
    pinyin: ['cǎi'],
    decomposition: '⿱爫木',
    etymology: {
      type: 'ideographic',
      hint: 'A hand picking 爫 fruit from a tree 木',
    },
    radical: '釆',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '釉',
    definition: 'enamel, glaze',
    pinyin: ['yòu'],
    decomposition: '⿰釆由',
    etymology: {
      type: 'pictophonetic',
      phonetic: '由',
      semantic: '釆',
      hint: 'collect',
    },
    radical: '釆',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '释',
    definition: 'to explain, to interpret; to release',
    pinyin: ['shì'],
    decomposition: '⿰釆？',
    etymology: {
      type: 'pictophonetic',
      phonetic: '睪',
      semantic: '釆',
      hint: 'collect',
    },
    radical: '釆',
    matches: [[0], [0], [0], [0], [0], [0], [0], null, null, null, null, null],
  },
  {
    character: '釋',
    definition: 'to explain, to interpret; to release',
    pinyin: ['shì'],
    decomposition: '⿰釆睪',
    etymology: {
      type: 'pictophonetic',
      phonetic: '睪',
      semantic: '釆',
      hint: 'collect',
    },
    radical: '釆',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '里',
    definition: 'unit of distance equal to 0.5km; village; lane',
    pinyin: ['lǐ'],
    decomposition: '⿱田土',
    etymology: {
      type: 'ideographic',
      hint: 'Unit of measure for farm 田 land 土',
    },
    radical: '里',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '重',
    definition: 'heavy, weighty; to double, to repeat',
    pinyin: ['zhòng'],
    decomposition: '⿻千里',
    etymology: {
      type: 'ideographic',
      hint: 'A burden carried for a thousand 千 miles 里',
    },
    radical: '里',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '野',
    definition: 'field, open country; wilderness',
    pinyin: ['yě'],
    decomposition: '⿰里予',
    etymology: {
      type: 'pictophonetic',
      phonetic: '予',
      semantic: '里',
      hint: 'village',
    },
    radical: '里',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '量',
    definition: 'measure, volume; amount, quantity',
    pinyin: ['liàng'],
    decomposition: '⿱旦里',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旦',
      semantic: '里',
      hint: 'unit',
    },
    radical: '里',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '金',
    definition: 'gold, metal; money',
    pinyin: ['jīn'],
    decomposition: '⿱人⿻王丷',
    etymology: { type: 'pictographic', hint: 'A cast-iron bell' },
    radical: '金',
    matches: [[0], [0], [1, 0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 0]],
  },
  {
    character: '釒',
    definition: 'gold, metal; money',
    pinyin: ['jīn'],
    decomposition: '？',
    etymology: { type: 'ideographic', hint: 'A cast-iron bell; compare 金' },
    radical: '釒',
    matches: [null, null, null, null, null, null, null, null],
  },
  {
    character: '釗',
    definition: 'to endeavor, to strive; to encourage; to cut',
    pinyin: ['zhāo'],
    decomposition: '⿰釒刂',
    etymology: {
      type: 'ideographic',
      hint: 'A metal 釒 knife 刂; 刂 also provides the pronunciation',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '釘',
    definition: 'nail, spike',
    pinyin: ['dīng'],
    decomposition: '⿰釒丁',
    etymology: {
      type: 'ideographic',
      hint: 'A metal 釒 nail 丁; 丁 also provides the pronunciation',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '釜',
    definition: 'cauldron, kettle, pot',
    pinyin: ['fǔ'],
    decomposition: '⿻父金',
    etymology: {
      type: 'pictophonetic',
      phonetic: '父',
      semantic: '金',
      hint: 'metal',
    },
    radical: '金',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '針',
    definition: 'needle, pin, tack; acupuncture',
    pinyin: ['zhēn'],
    decomposition: '⿰釒十',
    etymology: { type: 'ideographic', hint: 'A metal 釒 pin 十' },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '釣',
    definition: 'fishhook; to fish, to lure',
    pinyin: ['diào'],
    decomposition: '⿰釒勺',
    etymology: {
      type: 'ideographic',
      hint: 'A metal 釒 hook 勺; 勺 also provides the pronunciation',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '釦',
    definition: 'button; buckle, clasp; to engrave',
    pinyin: ['kòu'],
    decomposition: '⿰釒口',
    etymology: {
      type: 'pictophonetic',
      phonetic: '口',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '釧',
    definition: 'bracelet, armlet',
    pinyin: ['chuàn'],
    decomposition: '⿰釒川',
    etymology: {
      type: 'pictophonetic',
      phonetic: '川',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '釩',
    definition: 'vanadium',
    pinyin: ['fán'],
    decomposition: '⿰釒凡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '凡',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '釵',
    definition: 'ornamental hairpin',
    pinyin: ['chāi'],
    decomposition: '⿰釒叉',
    etymology: {
      type: 'ideographic',
      hint: 'A metal 釒 fork 叉; 叉 also provides the pronunciation',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '釺',
    definition: 'awl; a tool for boring holes',
    pinyin: ['qiān'],
    decomposition: '⿰釒千',
    etymology: {
      type: 'ideographic',
      hint: 'A metal 釒 awl 千; 千 also provides the pronunciation',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '鈀',
    definition: 'palladium',
    pinyin: ['bǎ'],
    decomposition: '⿰釒巴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巴',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '鈄',
    definition: 'wine flagon',
    pinyin: ['tǒu'],
    decomposition: '⿰釒斗',
    etymology: {
      type: 'ideographic',
      hint: 'A metal 釒 flask 斗; 斗 also provides the pronunciation',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '鈆',
    definition: 'lead (element)',
    pinyin: ['qiān'],
    decomposition: '⿰釒公',
    etymology: {
      type: 'pictophonetic',
      phonetic: '公',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '鈉',
    definition: 'sodium, natrium; to sharpen wood',
    pinyin: ['nà'],
    decomposition: '⿰釒内',
    etymology: {
      type: 'pictophonetic',
      phonetic: '内',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '鈍',
    definition: 'blunt, obtuse; dull, flat; dim-witted',
    pinyin: ['dùn'],
    decomposition: '⿰釒屯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屯',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '鈎',
    definition: 'hook, barb; sickle; to stroke',
    pinyin: ['gōu'],
    decomposition: '⿰釒勾',
    etymology: {
      type: 'ideographic',
      hint: 'A metal 釒 hook 勾; 勾 also provides the pronunciation',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '鈔',
    definition: 'bank note, paper money; to counterfeit',
    pinyin: ['chāo'],
    decomposition: '⿰釒少',
    etymology: {
      type: 'pictophonetic',
      phonetic: '少',
      semantic: '釒',
      hint: 'money',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '鈕',
    definition: 'button, knob; surname',
    pinyin: ['niǔ'],
    decomposition: '⿰釒丑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丑',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '鈞',
    definition: 'unit of weight equal to thirty catties; your (formal)',
    pinyin: ['jūn'],
    decomposition: '⿰釒匀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匀',
      semantic: '釒',
      hint: 'gold',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '鈣',
    definition: 'calcium',
    pinyin: ['gài'],
    decomposition: '⿰釒丐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丐',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '鈦',
    definition: 'titanium',
    pinyin: ['tài'],
    decomposition: '⿰釒太',
    etymology: {
      type: 'pictophonetic',
      phonetic: '太',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '鈬',
    definition: 'bell; surname',
    pinyin: ['duó'],
    decomposition: '⿰釒尺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尺',
      semantic: '釒',
      hint: 'bell',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '鈴',
    definition: 'small bell',
    pinyin: ['líng'],
    decomposition: '⿰釒令',
    etymology: {
      type: 'pictophonetic',
      phonetic: '令',
      semantic: '釒',
      hint: 'bell',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鈷',
    definition: 'cobalt; clothes-iron',
    pinyin: ['gǔ'],
    decomposition: '⿰釒古',
    etymology: {
      type: 'pictophonetic',
      phonetic: '古',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鈺',
    definition: 'rare treasure',
    pinyin: ['yù'],
    decomposition: '⿰釒玉',
    etymology: {
      type: 'ideographic',
      hint: 'A treasure of gold 釒 and jade 玉; 玉 also provides the pronunciation',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鈽',
    definition: 'plutonium',
    pinyin: ['bù'],
    decomposition: '⿰釒布',
    etymology: {
      type: 'pictophonetic',
      phonetic: '布',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鈾',
    definition: 'uranium',
    pinyin: ['yóu'],
    decomposition: '⿰釒由',
    etymology: {
      type: 'pictophonetic',
      phonetic: '由',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鈿',
    definition: 'hairpin; gold-inlaid item; filigree',
    pinyin: ['diàn'],
    decomposition: '⿰釒田',
    etymology: {
      type: 'pictophonetic',
      phonetic: '田',
      semantic: '釒',
      hint: 'gold',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鉀',
    definition: 'potassium',
    pinyin: ['jiǎ'],
    decomposition: '⿰釒甲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甲',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鉄',
    definition: 'iron; strong, solid, firm',
    pinyin: ['zhí'],
    decomposition: '⿰釒失',
    etymology: {
      type: 'pictophonetic',
      phonetic: '失',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鉅',
    definition: 'steel, iron; great',
    pinyin: ['jù'],
    decomposition: '⿰釒巨',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巨',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '鉉',
    definition: 'a device for carrying a tripod',
    pinyin: ['xuàn'],
    decomposition: '⿰釒玄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '玄',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鉗',
    definition: 'pincers, pliers, tongs; to compress',
    pinyin: ['qián'],
    decomposition: '⿰釒甘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甘',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鉚',
    definition: 'rivet',
    pinyin: ['mǎo'],
    decomposition: '⿰釒卯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卯',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鉛',
    definition: 'lead',
    pinyin: ['qiān'],
    decomposition: '⿰釒⿱几口',
    etymology: {
      type: 'pictophonetic',
      phonetic: '几',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '鉞',
    definition: 'broad-axe; halberd, battle-axe',
    pinyin: ['yuè'],
    decomposition: '⿰釒戉',
    etymology: {
      type: 'ideographic',
      hint: 'A metal 釒 axe 戉; 戉 also provides the pronunciation',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鉤',
    definition: 'hook, barb, sickle; to hook, to link',
    pinyin: ['gōu'],
    decomposition: '⿰釒句',
    etymology: {
      type: 'ideographic',
      hint: 'A metal 釒 hook 句; 句 also provides the pronunciation',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鉧',
    definition: 'cauldron, kettle, pot',
    pinyin: ['mǔ'],
    decomposition: '⿰釒母',
    etymology: {
      type: 'pictophonetic',
      phonetic: '母',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鉴',
    definition: 'mirror, looking glass; to reflect',
    pinyin: ['jiàn'],
    decomposition: '⿱？金',
    etymology: { type: 'pictophonetic', semantic: '金', hint: 'metal' },
    radical: '金',
    matches: [
      null,
      null,
      null,
      null,
      null,
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鉸',
    definition: 'hinge; scissors, shears; to cut',
    pinyin: ['jiǎo'],
    decomposition: '⿰釒交',
    etymology: {
      type: 'ideographic',
      hint: 'Objects with a metal 釒 joint 交; 交 also provides the pronunciation',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鉻',
    definition: 'chromium',
    pinyin: ['gè'],
    decomposition: '⿰釒各',
    etymology: {
      type: 'pictophonetic',
      phonetic: '各',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鉾',
    definition: 'spear',
    pinyin: ['móu'],
    decomposition: '⿰釒牟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '牟',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '銀',
    definition: 'silver; cash, money, wealth',
    pinyin: ['yín'],
    decomposition: '⿰釒艮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '艮',
      semantic: '釒',
      hint: 'money',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '銃',
    definition: 'ancient weapon; blunderbuss',
    pinyin: ['chòng'],
    decomposition: '⿰釒充',
    etymology: {
      type: 'pictophonetic',
      phonetic: '充',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '銅',
    definition: 'copper, bronze',
    pinyin: ['tóng'],
    decomposition: '⿰釒同',
    etymology: {
      type: 'pictophonetic',
      phonetic: '同',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '銎',
    definition: "an axe's eyehole (for hanging it up)",
    pinyin: ['qióng'],
    decomposition: '⿱巩金',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巩',
      semantic: '金',
      hint: 'metal',
    },
    radical: '金',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '銑',
    definition: 'mill',
    pinyin: ['xǐ'],
    decomposition: '⿰釒先',
    etymology: {
      type: 'pictophonetic',
      phonetic: '先',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '銓',
    definition: 'to weigh, to measure; to select, to elect; to estimate',
    pinyin: ['quán'],
    decomposition: '⿰釒全',
    etymology: {
      type: 'pictophonetic',
      phonetic: '全',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '銖',
    definition: 'a unit of weight, about 1 gram',
    pinyin: ['zhū'],
    decomposition: '⿰釒朱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朱',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '銘',
    definition: 'to engrave, to inscribe',
    pinyin: ['míng'],
    decomposition: '⿰釒名',
    etymology: {
      type: 'ideographic',
      hint: "To carve 釒 one's name 名; 名 also provides the pronunciation",
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '銚',
    definition: 'hoe; spear; surname',
    pinyin: ['diào'],
    decomposition: '⿰釒兆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兆',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '銜',
    definition: 'rank, title; to bite, to hold in the mouth',
    pinyin: ['xián'],
    decomposition: '⿻行金',
    etymology: {
      type: 'pictophonetic',
      phonetic: '行',
      semantic: '金',
      hint: 'metal',
    },
    radical: '金',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '銨',
    definition: 'ammonium',
    pinyin: ['ǎn'],
    decomposition: '⿰釒安',
    etymology: {
      type: 'pictophonetic',
      phonetic: '安',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '銬',
    definition: 'shackles, manacles',
    pinyin: ['kào'],
    decomposition: '⿰釒考',
    etymology: {
      type: 'pictophonetic',
      phonetic: '考',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '銮',
    definition: 'bells hung on a horse; imperial',
    pinyin: ['luán'],
    decomposition: '⿱亦金',
    etymology: {
      type: 'ideographic',
      hint: 'A bell 金 dangling from a tassel 亦',
    },
    radical: '金',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '銲',
    definition: 'to solder, to weld; greaves',
    pinyin: ['hàn'],
    decomposition: '⿰釒旱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旱',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '銳',
    definition: 'sharp, pointed; keen, acute',
    pinyin: ['ruì'],
    decomposition: '⿰釒兌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兌',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '銷',
    definition: 'to fuse, to melt; to market, to sell',
    pinyin: ['xiāo'],
    decomposition: '⿰釒肖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肖',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '銹',
    definition: 'to rust, to corrode',
    pinyin: ['xiù'],
    decomposition: '⿰釒秀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '秀',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '銼',
    definition: "carpenter's file; to file smooth",
    pinyin: ['cuò'],
    decomposition: '⿰釒坐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '坐',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '銾',
    definition: 'mercury (element)',
    pinyin: ['hòng'],
    decomposition: '⿰釒汞',
    etymology: {
      type: 'ideographic',
      hint: 'Metal 釒 that flows like water 水; 工 provides the pronunciation',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鋁',
    definition: 'aluminum',
    pinyin: ['lǚ'],
    decomposition: '⿰釒吕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吕',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鋃',
    definition: 'chain, lock; ornament',
    pinyin: ['láng'],
    decomposition: '⿰釒良',
    etymology: {
      type: 'pictophonetic',
      phonetic: '良',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鋅',
    definition: 'zinc',
    pinyin: ['xīn'],
    decomposition: '⿰釒辛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辛',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鋇',
    definition: 'barium',
    pinyin: ['bèi'],
    decomposition: '⿰釒貝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '貝',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鋈',
    definition: 'gold- or silver-plated; to plate',
    pinyin: ['wù'],
    decomposition: '⿱沃金',
    etymology: {
      type: 'pictophonetic',
      phonetic: '沃',
      semantic: '金',
      hint: 'metal',
    },
    radical: '金',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鋌',
    definition: 'ingots, metal bars; to hurry',
    pinyin: ['dìng'],
    decomposition: '⿰釒廷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '廷',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鋒',
    definition: 'spear-point; edge, point, tip',
    pinyin: ['fēng'],
    decomposition: '⿰釒夆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夆',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鋤',
    definition: 'hoe; to eradicate, to weed out',
    pinyin: ['chú'],
    decomposition: '⿰釒助',
    etymology: {
      type: 'ideographic',
      hint: 'A metal 釒 tool 助; 助 also provides the pronunciation',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鋥',
    definition: 'to polish, to shine',
    pinyin: ['zèng'],
    decomposition: '⿰釒呈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '呈',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鋦',
    definition: 'curium',
    pinyin: ['jū'],
    decomposition: '⿰釒局',
    etymology: {
      type: 'pictophonetic',
      phonetic: '局',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鋩',
    definition: 'sword-point; sharp, pointed',
    pinyin: ['máng'],
    decomposition: '⿰釒芒',
    etymology: {
      type: 'ideographic',
      hint: 'A metal 釒 blade 芒; 芒 also provides the pronunciation',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      null,
    ],
  },
  {
    character: '鋪',
    definition: 'shop, store; bed, mattress',
    pinyin: ['pù'],
    decomposition: '⿰釒甫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甫',
      semantic: '釒',
      hint: 'money',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鋯',
    definition: 'zirconium',
    pinyin: ['gào'],
    decomposition: '⿰釒告',
    etymology: {
      type: 'pictophonetic',
      phonetic: '告',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鋰',
    definition: 'lithium',
    pinyin: ['lǐ'],
    decomposition: '⿰釒里',
    etymology: {
      type: 'pictophonetic',
      phonetic: '里',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鋸',
    definition: 'a saw; to saw, to amputate',
    pinyin: ['jù'],
    decomposition: '⿰釒居',
    etymology: {
      type: 'pictophonetic',
      phonetic: '居',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鋼',
    definition: 'steel; hard, strong, tough',
    pinyin: ['gāng'],
    decomposition: '⿰釒岡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '岡',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '錄',
    definition: 'to copy, to record, to write down',
    pinyin: ['lù'],
    decomposition: '⿰釒彔',
    etymology: {
      type: 'ideographic',
      hint: 'A metal 釒 brush 彔 used to record stories',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '錒',
    definition: 'actinium',
    pinyin: ['ā'],
    decomposition: '⿰釒阿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '阿',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '錕',
    definition: 'a legendary sword',
    pinyin: ['kūn'],
    decomposition: '⿰釒昆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昆',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '錘',
    definition: 'hammer',
    pinyin: ['chuí'],
    decomposition: '⿰釒垂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '垂',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '錙',
    definition: 'half-pound; an ancient unit of weight',
    pinyin: ['zī'],
    decomposition: '⿰釒甾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甾',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '錚',
    definition: 'clanging sound; a small gong',
    pinyin: ['zhēng'],
    decomposition: '⿰釒争',
    etymology: {
      type: 'pictophonetic',
      phonetic: '争',
      semantic: '釒',
      hint: 'bell',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '錠',
    definition: 'spindle, ingot; tablet, slab',
    pinyin: ['dìng'],
    decomposition: '⿰釒定',
    etymology: {
      type: 'pictophonetic',
      phonetic: '定',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '錢',
    definition: 'money, currency, coins',
    pinyin: ['qián'],
    decomposition: '⿰釒戔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戔',
      semantic: '釒',
      hint: 'money',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '錦',
    definition: 'brocade, tapestry; embroidered',
    pinyin: ['jǐn'],
    decomposition: '⿰釒帛',
    etymology: {
      type: 'ideographic',
      hint: 'Silk 帛 inlaid with gold 釒; 釒 also provides the pronunciation',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '錨',
    definition: 'anchor',
    pinyin: ['máo'],
    decomposition: '⿰釒苗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '苗',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '錫',
    definition: 'tin; to bestow, to confer',
    pinyin: ['xī'],
    decomposition: '⿰釒易',
    etymology: {
      type: 'pictophonetic',
      phonetic: '易',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '錮',
    definition:
      'to run hot metal through a mold; to confine, to restrain, to stop',
    pinyin: ['gù'],
    decomposition: '⿰釒固',
    etymology: {
      type: 'ideographic',
      hint: 'To forge 固 metal 釒; 固 also provides the pronunciation',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '錯',
    definition: 'error, mistake; incorrect, wrong',
    pinyin: ['cuò'],
    decomposition: '⿰釒昔',
    etymology: {
      type: 'ideographic',
      hint: 'Gold 釒 that once was 昔 but is lost',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '録',
    definition: 'to copy',
    pinyin: ['lù'],
    decomposition: '⿰釒录',
    etymology: {
      type: 'ideographic',
      hint: 'To carve 釒 a record 录; 录 also provides the pronunciation',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '錳',
    definition: 'manganese',
    pinyin: ['měng'],
    decomposition: '⿰釒孟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孟',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '錶',
    definition: 'to show, to express, to display; outside, appearance; a watch',
    pinyin: ['biǎo'],
    decomposition: '⿰釒表',
    etymology: {
      type: 'pictophonetic',
      phonetic: '表',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '錾',
    definition: 'chisel, engraving tool',
    pinyin: ['zàn'],
    decomposition: '⿱斩金',
    etymology: {
      type: 'ideographic',
      hint: 'A metal 金 cutting tool 斩; 斩 also provides the pronunciation',
    },
    radical: '金',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鍋',
    definition: 'cooking-pot, saucepan',
    pinyin: ['guō'],
    decomposition: '⿰釒咼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咼',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鍛',
    definition: 'to temper, to refine; to forge metal',
    pinyin: ['duàn'],
    decomposition: '⿰釒段',
    etymology: {
      type: 'pictophonetic',
      phonetic: '段',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鍥',
    definition: 'sickle; to cut, to carve, to engrave',
    pinyin: ['qiè'],
    decomposition: '⿰釒契',
    etymology: {
      type: 'ideographic',
      hint: 'Something engraved 契 in metal 釒; 契 also provides the pronunciation',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鍪',
    definition: 'iron pan; metal cap',
    pinyin: ['móu'],
    decomposition: '⿱敄金',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敄',
      semantic: '金',
      hint: 'metal',
    },
    radical: '金',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鍵',
    definition: 'lock, door bolt; key',
    pinyin: ['jiàn'],
    decomposition: '⿰釒建',
    etymology: {
      type: 'pictophonetic',
      phonetic: '建',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鎂',
    definition: 'magnesium',
    pinyin: ['měi'],
    decomposition: '⿰釒美',
    etymology: {
      type: 'pictophonetic',
      phonetic: '美',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鎊',
    definition: 'pound sterling',
    pinyin: ['bàng'],
    decomposition: '⿰釒旁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旁',
      semantic: '釒',
      hint: 'money',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鎏',
    definition: 'pure gold',
    pinyin: ['liú'],
    decomposition: '⿱流金',
    etymology: {
      type: 'pictophonetic',
      phonetic: '流',
      semantic: '金',
      hint: 'gold',
    },
    radical: '金',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鎔',
    definition: 'mold; to fuse, to melt, to smelt',
    pinyin: ['róng'],
    decomposition: '⿰釒容',
    etymology: {
      type: 'ideographic',
      hint: 'A mold that holds 容 hot metal 釒; 容 also provides the pronunciation',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鎖',
    definition: 'lock, padlock; chains, shackles',
    pinyin: ['suǒ'],
    decomposition: '⿰釒⿱⺌貝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '⺌',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '鎛',
    definition: 'large bell; hoe, spade',
    pinyin: ['bó'],
    decomposition: '⿰釒尃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尃',
      semantic: '釒',
      hint: 'bell',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鎢',
    definition: 'tungsten, wolfram',
    pinyin: ['wū'],
    decomposition: '⿰釒烏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '烏',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鎣',
    definition: 'to polish, to shine',
    pinyin: ['yíng'],
    decomposition: '⿳炏冖金',
    etymology: {
      type: 'ideographic',
      hint: 'To polish 炏 a metal 金 cover 冖',
    },
    radical: '金',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '鎦',
    definition: 'to distill; lutetium; surname',
    pinyin: ['liú'],
    decomposition: '⿰釒留',
    etymology: {
      type: 'ideographic',
      hint: 'A metal 釒 still 留; 留 also provides the pronunciation',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鎧',
    definition: 'armor, chain mail',
    pinyin: ['kǎi'],
    decomposition: '⿰釒豈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豈',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鎩',
    definition: 'spear; to injure',
    pinyin: ['shā'],
    decomposition: '⿰釒殺',
    etymology: { type: 'ideographic', hint: 'A metal 釒 weapon 殺' },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鎬',
    definition: 'stove; bright',
    pinyin: ['gǎo'],
    decomposition: '⿰釒高',
    etymology: {
      type: 'pictophonetic',
      phonetic: '高',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鎮',
    definition: 'calm, composed; to control, to suppress',
    pinyin: ['zhèn'],
    decomposition: '⿰釒真',
    etymology: {
      type: 'pictophonetic',
      phonetic: '真',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鎳',
    definition: 'nickel',
    pinyin: ['niè'],
    decomposition: '⿰釒臬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臬',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鏈',
    definition: 'chain, wire; chains, shackles',
    pinyin: ['liàn'],
    decomposition: '⿰釒連',
    etymology: {
      type: 'ideographic',
      hint: 'Metal 釒 that joins 連; 連 also provides the pronunciation',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鏊',
    definition: 'a flat iron cooking-plate for cakes',
    pinyin: ['ào'],
    decomposition: '⿱敖金',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敖',
      semantic: '金',
      hint: 'metal',
    },
    radical: '金',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鏖',
    definition: 'to fight to the death; to engage in a fierce battle',
    pinyin: ['áo'],
    decomposition: '⿸鹿金',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鹿',
      semantic: '金',
      hint: 'metal',
    },
    radical: '金',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鏡',
    definition: 'mirror, glass; lens, glasses',
    pinyin: ['jìng'],
    decomposition: '⿰釒竟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '竟',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鏢',
    definition: 'spear, harpoon, dart; to escort',
    pinyin: ['biāo'],
    decomposition: '⿰釒票',
    etymology: {
      type: 'pictophonetic',
      phonetic: '票',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鏽',
    definition: 'to rust, to corrode',
    pinyin: ['xiù'],
    decomposition: '⿰釒肅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肅',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鐘',
    definition: 'clock; bell',
    pinyin: ['zhōng'],
    decomposition: '⿰釒童',
    etymology: {
      type: 'pictophonetic',
      phonetic: '童',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鐵',
    definition: 'iron; strong, solid, firm',
    pinyin: ['tiě'],
    decomposition: '⿰釒⿸十戜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戜',
      hint: 'metal',
      semantic: '釒',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '鐾',
    definition: 'a flat iron cooking-plate for cakes',
    pinyin: ['bèi'],
    decomposition: '⿱辟金',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辟',
      semantic: '金',
      hint: 'metal',
    },
    radical: '金',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鑄',
    definition: 'to melt, to cast; to mint, to coin',
    pinyin: ['zhù'],
    decomposition: '⿰釒壽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '壽',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鑊',
    definition: 'cauldron, large iron pot',
    pinyin: ['huò'],
    decomposition: '⿰釒蒦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蒦',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鑑',
    definition: 'mirror, looking glass; to reflect',
    pinyin: ['jiàn'],
    decomposition: '⿰釒監',
    etymology: {
      type: 'pictophonetic',
      phonetic: '監',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鑒',
    definition: 'mirror, looking glass; to reflect',
    pinyin: ['jiàn'],
    decomposition: '⿱監金',
    etymology: {
      type: 'pictophonetic',
      phonetic: '監',
      semantic: '金',
      hint: 'metal',
    },
    radical: '金',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鑔',
    definition: 'cymbals',
    pinyin: ['chǎ'],
    decomposition: '⿰釒察',
    etymology: {
      type: 'pictophonetic',
      phonetic: '察',
      semantic: '釒',
      hint: 'bell',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鑞',
    definition: 'tin, solder',
    pinyin: ['là'],
    decomposition: '⿰釒巤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巤',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鑠',
    definition: 'to melt, to smelt; polish, shine',
    pinyin: ['shuò'],
    decomposition: '⿰釒樂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '樂',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鑢',
    definition: 'file, rasp; to file, to polish',
    pinyin: ['lǜ'],
    decomposition: '⿰釒慮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '慮',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鑣',
    definition: 'bit, bridle; to ride',
    pinyin: ['biāo'],
    decomposition: '⿰釒麃',
    etymology: {
      type: 'ideographic',
      hint: 'A metal bit 釒 used to saddle 麃 a horse',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鑪',
    definition: 'fireplace, stove; oven; furnace',
    pinyin: ['lú'],
    decomposition: '⿰釒盧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '盧',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鑫',
    definition: 'prosperity; used in names of people and shops',
    pinyin: ['xīn'],
    decomposition: '⿱金⿰金金',
    etymology: {
      type: 'ideographic',
      hint: 'Much gold 金, representing wealth',
    },
    radical: '金',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '鑭',
    definition: 'lanthanum',
    pinyin: ['lán'],
    decomposition: '⿰釒闌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '闌',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鑰',
    definition: 'lock, key',
    pinyin: ['yào'],
    decomposition: '⿰釒龠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龠',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鑲',
    definition: 'inset, inlay; to set, to mount; to fill',
    pinyin: ['xiāng'],
    decomposition: '⿰釒襄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '襄',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鑷',
    definition: 'tweezers, forceps, pliers; to nip, to pluck',
    pinyin: ['niè'],
    decomposition: '⿰釒聶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '聶',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鑼',
    definition: 'gong',
    pinyin: ['luó'],
    decomposition: '⿰釒羅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羅',
      semantic: '釒',
      hint: 'bell',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鑽',
    definition: 'diamond; to bore, to drill, to pierce',
    pinyin: ['zuān'],
    decomposition: '⿰釒贊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贊',
      semantic: '釒',
      hint: 'metal',
    },
    radical: '釒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鑾',
    definition: 'bells hung on a horse; imperial',
    pinyin: ['luán'],
    decomposition: '⿱䜌金',
    etymology: {
      type: 'pictophonetic',
      phonetic: '䜌',
      semantic: '金',
      hint: 'bell',
    },
    radical: '金',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鑿',
    definition: 'chisel; to bore, to pierce',
    pinyin: ['záo'],
    decomposition: '⿱⿰⿱丵臼殳金',
    etymology: {
      type: 'ideographic',
      hint: 'A metal 金 drill 丵 boring a hole 臼; 殳 provides the pronunciation',
    },
    radical: '金',
    matches: [
      [0, 0, 0],
      [0, 0, 0],
      [0, 0, 0],
      [0, 0, 0],
      [0, 0, 0],
      [0, 0, 0],
      [0, 0, 0],
      [0, 0, 0],
      [0, 0, 0],
      [0, 0, 0],
      [0, 0, 1],
      [0, 0, 1],
      [0, 0, 1],
      [0, 0, 1],
      [0, 0, 1],
      [0, 0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '钅',
    definition: 'gold, metal; money',
    pinyin: ['jīn'],
    decomposition: '⿱？？',
    etymology: { type: 'pictographic', hint: 'A cast-iron bell; compare 金' },
    radical: '钅',
    matches: [null, null, null, null, null],
  },
  {
    character: '钆',
    definition: 'gadolinium',
    pinyin: ['gá'],
    decomposition: '⿰钅乚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乚',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1]],
  },
  {
    character: '钇',
    definition: 'yttrium',
    pinyin: ['yǐ'],
    decomposition: '⿰钅乙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乙',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1]],
  },
  {
    character: '针',
    definition: 'needle, pin, tack; acupuncture',
    pinyin: ['zhēn'],
    decomposition: '⿰钅十',
    etymology: { type: 'ideographic', hint: 'A metal 钅 pin 十' },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '钉',
    definition: 'nail, spike',
    pinyin: ['dīng'],
    decomposition: '⿰钅丁',
    etymology: {
      type: 'ideographic',
      hint: 'A metal 钅 nail 丁; 丁 also provides the pronunciation',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '钊',
    definition: 'to endeavor, to strive; to encourage; to cut',
    pinyin: ['zhāo'],
    decomposition: '⿰钅刂',
    etymology: {
      type: 'ideographic',
      hint: 'A metal 钅 knife 刂; 刂 also provides the pronunciation',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '钋',
    definition: 'polonium',
    pinyin: ['pō'],
    decomposition: '⿰钅卜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卜',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '钌',
    definition: 'ruthenium',
    pinyin: ['liǎo'],
    decomposition: '⿰钅了',
    etymology: {
      type: 'pictophonetic',
      phonetic: '了',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '钍',
    definition: 'thorium',
    pinyin: ['tǔ'],
    decomposition: '⿰钅土',
    etymology: {
      type: 'pictophonetic',
      phonetic: '土',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '钎',
    definition: 'awl; a tool for boring holes',
    pinyin: ['qiān'],
    decomposition: '⿰钅千',
    etymology: {
      type: 'ideographic',
      hint: 'A metal 钅 awl 千; 千 also provides the pronunciation',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '钏',
    definition: 'bracelet, armlet',
    pinyin: ['chuàn'],
    decomposition: '⿰钅川',
    etymology: {
      type: 'pictophonetic',
      phonetic: '川',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '钐',
    definition: 'samarium',
    pinyin: ['shān'],
    decomposition: '⿰钅彡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彡',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '钒',
    definition: 'vanadium',
    pinyin: ['fán'],
    decomposition: '⿰钅凡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '凡',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '钓',
    definition: 'fishhook; to fish, to lure',
    pinyin: ['diào'],
    decomposition: '⿰钅勺',
    etymology: {
      type: 'ideographic',
      hint: 'A metal 钅 hook 勺; 勺 also provides the pronunciation',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '钔',
    definition: 'mendelevium',
    pinyin: ['mén'],
    decomposition: '⿰钅门',
    etymology: {
      type: 'pictophonetic',
      phonetic: '门',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '钕',
    definition: 'neodymium',
    pinyin: ['nǚ'],
    decomposition: '⿰钅女',
    etymology: {
      type: 'pictophonetic',
      phonetic: '女',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '钗',
    definition: 'ornamental hairpin',
    pinyin: ['chāi'],
    decomposition: '⿰钅叉',
    etymology: {
      type: 'ideographic',
      hint: 'A metal 钅 fork 叉; 叉 also provides the pronunciation',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '钙',
    definition: 'calcium',
    pinyin: ['gài'],
    decomposition: '⿰钅丐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丐',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '钚',
    definition: 'plutonium',
    pinyin: ['bù'],
    decomposition: '⿰钅不',
    etymology: {
      type: 'pictophonetic',
      phonetic: '不',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '钛',
    definition: 'titanium',
    pinyin: ['tài'],
    decomposition: '⿰钅太',
    etymology: {
      type: 'pictophonetic',
      phonetic: '太',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '钜',
    definition: 'steel, iron; great',
    pinyin: ['jù'],
    decomposition: '⿰钅巨',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巨',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '钝',
    definition: 'blunt, obtuse; dull, flat; dim-witted',
    pinyin: ['dùn'],
    decomposition: '⿰钅屯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屯',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '钞',
    definition: 'bank note, paper money; to counterfeit',
    pinyin: ['chāo'],
    decomposition: '⿰钅少',
    etymology: {
      type: 'pictophonetic',
      phonetic: '少',
      semantic: '钅',
      hint: 'money',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '钟',
    definition: 'clock; bell',
    pinyin: ['zhōng'],
    decomposition: '⿰钅中',
    etymology: {
      type: 'pictophonetic',
      phonetic: '中',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '钠',
    definition: 'sodium, natrium; to sharpen wood',
    pinyin: ['nà'],
    decomposition: '⿰钅内',
    etymology: {
      type: 'pictophonetic',
      phonetic: '内',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '钡',
    definition: 'barium',
    pinyin: ['bèi'],
    decomposition: '⿰钅贝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贝',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '钢',
    definition: 'steel; hard, strong, tough',
    pinyin: ['gāng'],
    decomposition: '⿰钅冈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冈',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '钣',
    definition: 'metal plate; sheet metal',
    pinyin: ['bǎn'],
    decomposition: '⿰钅反',
    etymology: {
      type: 'pictophonetic',
      phonetic: '反',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '钤',
    definition: 'lock, latch; to stamp, to seal',
    pinyin: ['qián'],
    decomposition: '⿰钅今',
    etymology: {
      type: 'pictophonetic',
      phonetic: '今',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '钥',
    definition: 'lock, key',
    pinyin: ['yào'],
    decomposition: '⿰钅月',
    etymology: {
      type: 'pictophonetic',
      phonetic: '月',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '钦',
    definition: 'to respect, to admire; royal',
    pinyin: ['qīn'],
    decomposition: '⿰钅欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '欠',
      semantic: '钅',
      hint: 'gold',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '钧',
    definition: 'unit of weight equal to thirty catties; your (formal)',
    pinyin: ['jūn'],
    decomposition: '⿰钅匀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匀',
      semantic: '钅',
      hint: 'gold',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '钨',
    definition: 'tungsten, wolfram',
    pinyin: ['wū'],
    decomposition: '⿰钅乌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乌',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '钩',
    definition: 'hook, barb, sickle; to hook, to link',
    pinyin: ['gōu'],
    decomposition: '⿰钅勾',
    etymology: {
      type: 'ideographic',
      hint: 'A metal 钅 hook 勾; 勾 also provides the pronunciation',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '钪',
    definition: 'scandium',
    pinyin: ['kàng'],
    decomposition: '⿰钅亢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亢',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '钫',
    definition: 'francium',
    pinyin: ['fāng'],
    decomposition: '⿰钅方',
    etymology: {
      type: 'pictophonetic',
      phonetic: '方',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '钬',
    definition: 'holmium',
    pinyin: ['huǒ'],
    decomposition: '⿰钅火',
    etymology: {
      type: 'pictophonetic',
      phonetic: '火',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '钭',
    definition: 'wine flagon',
    pinyin: ['tǒu'],
    decomposition: '⿰钅斗',
    etymology: {
      type: 'ideographic',
      hint: 'A metal 钅 flask 斗; 斗 also provides the pronunciation',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '钮',
    definition: 'button, knob; surname',
    pinyin: ['niǔ'],
    decomposition: '⿰钅丑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丑',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '钯',
    definition: 'palladium',
    pinyin: ['bǎ'],
    decomposition: '⿰钅巴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巴',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '钰',
    definition: 'rare treasure',
    pinyin: ['yù'],
    decomposition: '⿰钅玉',
    etymology: {
      type: 'ideographic',
      hint: 'A treasure of gold 钅 and jade 玉; 玉 also provides the pronunciation',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '钱',
    definition: 'money, currency, coins',
    pinyin: ['qián'],
    decomposition: '⿰钅戋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戋',
      semantic: '钅',
      hint: 'money',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '钲',
    definition: "an army's marching gong",
    pinyin: ['zhēng'],
    decomposition: '⿰钅正',
    etymology: {
      type: 'pictophonetic',
      phonetic: '正',
      semantic: '钅',
      hint: 'bell',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '钳',
    definition: 'pincers, pliers, tongs; to compress',
    pinyin: ['qián'],
    decomposition: '⿰钅甘',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甘',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '钴',
    definition: 'cobalt; clothes-iron',
    pinyin: ['gǔ'],
    decomposition: '⿰钅古',
    etymology: {
      type: 'pictophonetic',
      phonetic: '古',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '钵',
    definition: 'earthen basin; alms bowl',
    pinyin: ['bō'],
    decomposition: '⿰钅本',
    etymology: {
      type: 'pictophonetic',
      phonetic: '本',
      semantic: '钅',
      hint: 'gold',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '钶',
    definition: 'columbium',
    pinyin: ['ē'],
    decomposition: '⿰钅可',
    etymology: {
      type: 'pictophonetic',
      phonetic: '可',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '钷',
    definition: 'promethium',
    pinyin: ['pǒ'],
    decomposition: '⿰钅叵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叵',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '钸',
    definition: 'plutonium',
    pinyin: ['bù'],
    decomposition: '⿰钅布',
    etymology: {
      type: 'pictophonetic',
      phonetic: '布',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '钹',
    definition: 'cymbals',
    pinyin: ['bó'],
    decomposition: '⿰钅犮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '犮',
      semantic: '钅',
      hint: 'bell',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '钺',
    definition: 'broad-axe; halberd, battle-axe',
    pinyin: ['yuè'],
    decomposition: '⿰钅戉',
    etymology: {
      type: 'ideographic',
      hint: 'A metal 钅 axe 戉; 戉 also provides the pronunciation',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '钻',
    definition: 'diamond; to bore, to drill, to pierce',
    pinyin: ['zuān'],
    decomposition: '⿰钅占',
    etymology: {
      type: 'pictophonetic',
      phonetic: '占',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '钼',
    definition: 'molybdenum',
    pinyin: ['mù'],
    decomposition: '⿰钅目',
    etymology: {
      type: 'pictophonetic',
      phonetic: '目',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '钽',
    definition: 'tantalum',
    pinyin: ['tǎn'],
    decomposition: '⿰钅旦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旦',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '钾',
    definition: 'potassium',
    pinyin: ['jiǎ'],
    decomposition: '⿰钅甲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甲',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '钿',
    definition: 'hairpin; gold-inlaid item; filigree',
    pinyin: ['diàn'],
    decomposition: '⿰钅田',
    etymology: {
      type: 'pictophonetic',
      phonetic: '田',
      semantic: '钅',
      hint: 'gold',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '铀',
    definition: 'uranium',
    pinyin: ['yóu'],
    decomposition: '⿰钅由',
    etymology: {
      type: 'pictophonetic',
      phonetic: '由',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '铁',
    definition: 'iron; strong, solid, firm',
    pinyin: ['tiě'],
    decomposition: '⿰钅失',
    etymology: {
      type: 'pictophonetic',
      phonetic: '失',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '铂',
    definition: 'platinum; thin sheet metal',
    pinyin: ['bó'],
    decomposition: '⿰钅白',
    etymology: {
      type: 'pictophonetic',
      phonetic: '白',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '铃',
    definition: 'small bell',
    pinyin: ['líng'],
    decomposition: '⿰钅令',
    etymology: {
      type: 'pictophonetic',
      phonetic: '令',
      semantic: '钅',
      hint: 'bell',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '铄',
    definition: 'to melt, to smelt; polish, shine',
    pinyin: ['shuò'],
    decomposition: '⿰钅乐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乐',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '铅',
    definition: 'lead',
    pinyin: ['qiān'],
    decomposition: '⿰钅⿱几口',
    etymology: {
      type: 'pictophonetic',
      phonetic: '几',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '铆',
    definition: 'rivet',
    pinyin: ['mǎo'],
    decomposition: '⿰钅卯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卯',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '铈',
    definition: 'cerium',
    pinyin: ['shì'],
    decomposition: '⿰钅市',
    etymology: {
      type: 'pictophonetic',
      phonetic: '市',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '铉',
    definition: 'a device for carrying a tripod',
    pinyin: ['xuàn'],
    decomposition: '⿰钅玄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '玄',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '铊',
    definition: 'thallium',
    pinyin: ['tā'],
    decomposition: '⿰钅它',
    etymology: {
      type: 'pictophonetic',
      phonetic: '它',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '铋',
    definition: 'bismuth',
    pinyin: ['bì'],
    decomposition: '⿰钅必',
    etymology: {
      type: 'pictophonetic',
      phonetic: '必',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '铌',
    definition: 'niobium',
    pinyin: ['ní'],
    decomposition: '⿰钅尼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尼',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '铍',
    definition: 'beryllium',
    pinyin: ['pī'],
    decomposition: '⿰钅皮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皮',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '铎',
    definition: 'bell; surname',
    pinyin: ['duó'],
    decomposition: '⿰钅？',
    etymology: { type: 'pictophonetic', semantic: '钅', hint: 'bell' },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], null, null, null, null, null],
  },
  {
    character: '铐',
    definition: 'shackles, manacles',
    pinyin: ['kào'],
    decomposition: '⿰钅考',
    etymology: {
      type: 'pictophonetic',
      phonetic: '考',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铑',
    definition: 'rhodium',
    pinyin: ['lǎo'],
    decomposition: '⿰钅老',
    etymology: {
      type: 'pictophonetic',
      phonetic: '老',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铒',
    definition: 'erbium',
    pinyin: ['ěr'],
    decomposition: '⿰钅耳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '耳',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铓',
    definition: 'sword-point; sharp, pointed',
    pinyin: ['máng'],
    decomposition: '⿰钅芒',
    etymology: {
      type: 'ideographic',
      hint: 'A metal 钅 blade 芒; 芒 also provides the pronunciation',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铕',
    definition: 'europium',
    pinyin: ['yǒu'],
    decomposition: '⿰钅有',
    etymology: {
      type: 'pictophonetic',
      phonetic: '有',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铖',
    definition: 'surname',
    pinyin: ['chéng'],
    decomposition: '⿰钅成',
    etymology: {
      type: 'pictophonetic',
      phonetic: '成',
      semantic: '钅',
      hint: 'gold',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铗',
    definition: 'tongs, pincers; dagger, sword',
    pinyin: ['jiá'],
    decomposition: '⿰钅夹',
    etymology: {
      type: 'ideographic',
      hint: 'Metal 钅 used to grasp 夹 items; 夹 also provides the pronunciation',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铘',
    definition: 'sword',
    pinyin: ['yé'],
    decomposition: '⿰钅邪',
    etymology: {
      type: 'ideographic',
      hint: 'A metal 钅 weapon 邪; 邪 also provides the pronunciation',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铙',
    definition: 'cymbals, hand-bell; to disturb',
    pinyin: ['náo'],
    decomposition: '⿰钅尧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尧',
      semantic: '钅',
      hint: 'bell',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铛',
    definition: 'frying pan; warming vessel',
    pinyin: ['dāng'],
    decomposition: '⿰钅当',
    etymology: {
      type: 'pictophonetic',
      phonetic: '当',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铜',
    definition: 'copper, bronze',
    pinyin: ['tóng'],
    decomposition: '⿰钅同',
    etymology: {
      type: 'pictophonetic',
      phonetic: '同',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铝',
    definition: 'aluminum',
    pinyin: ['lǚ'],
    decomposition: '⿰钅吕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吕',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铞',
    definition: 'sword',
    pinyin: ['diào'],
    decomposition: '⿰钅吊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吊',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铟',
    definition: 'indium',
    pinyin: ['yīn'],
    decomposition: '⿰钅因',
    etymology: {
      type: 'pictophonetic',
      phonetic: '因',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铠',
    definition: 'armor, chain mail',
    pinyin: ['kǎi'],
    decomposition: '⿰钅岂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '岂',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铡',
    definition: 'a sickle used to cut grass or hay',
    pinyin: ['zhá'],
    decomposition: '⿰钅则',
    etymology: {
      type: 'ideographic',
      hint: 'A metal 钅 knife 刂; 则 also provides the pronunciation',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铢',
    definition: 'a unit of weight, about 1 gram',
    pinyin: ['zhū'],
    decomposition: '⿰钅朱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朱',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铣',
    definition: 'mill',
    pinyin: ['xǐ'],
    decomposition: '⿰钅先',
    etymology: {
      type: 'pictophonetic',
      phonetic: '先',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铤',
    definition: 'ingots, metal bars; to hurry',
    pinyin: ['dìng'],
    decomposition: '⿰钅廷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '廷',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铥',
    definition: 'thulium',
    pinyin: ['diū'],
    decomposition: '⿰钅丢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丢',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铧',
    definition: 'spade, shovel, plowshare',
    pinyin: ['huá'],
    decomposition: '⿰钅华',
    etymology: {
      type: 'pictophonetic',
      phonetic: '华',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铨',
    definition: 'to weigh, to measure; to select, to elect; to estimate',
    pinyin: ['quán'],
    decomposition: '⿰钅全',
    etymology: {
      type: 'pictophonetic',
      phonetic: '全',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铩',
    definition: 'spear; to injure',
    pinyin: ['shā'],
    decomposition: '⿰钅杀',
    etymology: { type: 'ideographic', hint: 'A metal 钅 weapon 杀' },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铪',
    definition: 'hafnium',
    pinyin: ['hā'],
    decomposition: '⿰钅合',
    etymology: {
      type: 'pictophonetic',
      phonetic: '合',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铫',
    definition: 'hoe; spear; surname',
    pinyin: ['diào'],
    decomposition: '⿰钅兆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兆',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铬',
    definition: 'chromium',
    pinyin: ['gè'],
    decomposition: '⿰钅各',
    etymology: {
      type: 'pictophonetic',
      phonetic: '各',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铭',
    definition: 'to engrave, to inscribe',
    pinyin: ['míng'],
    decomposition: '⿰钅名',
    etymology: {
      type: 'ideographic',
      hint: "To carve 钅 one's name 名; 名 also provides the pronunciation",
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铮',
    definition: 'clanging sound; a small gong',
    pinyin: ['zhēng'],
    decomposition: '⿰钅争',
    etymology: {
      type: 'pictophonetic',
      phonetic: '争',
      semantic: '钅',
      hint: 'bell',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铯',
    definition: 'cesium',
    pinyin: ['sè'],
    decomposition: '⿰钅色',
    etymology: {
      type: 'pictophonetic',
      phonetic: '色',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铰',
    definition: 'hinge; scissors, shears; to cut',
    pinyin: ['jiǎo'],
    decomposition: '⿰钅交',
    etymology: {
      type: 'ideographic',
      hint: 'Objects with a metal 钅 joint 交; 交 also provides the pronunciation',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铱',
    definition: 'iridium',
    pinyin: ['yī'],
    decomposition: '⿰钅衣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '衣',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铲',
    definition: 'spade, shovel; trowel, scoop',
    pinyin: ['chǎn'],
    decomposition: '⿰钅产',
    etymology: {
      type: 'pictophonetic',
      phonetic: '产',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铳',
    definition: 'ancient weapon; blunderbuss',
    pinyin: ['chòng'],
    decomposition: '⿰钅充',
    etymology: {
      type: 'pictophonetic',
      phonetic: '充',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铴',
    definition: 'gong',
    pinyin: ['tāng'],
    decomposition: '⿰钅汤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '汤',
      semantic: '钅',
      hint: 'bell',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铵',
    definition: 'ammonium',
    pinyin: ['ǎn'],
    decomposition: '⿰钅安',
    etymology: {
      type: 'pictophonetic',
      phonetic: '安',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '银',
    definition: 'silver; cash, money, wealth',
    pinyin: ['yín'],
    decomposition: '⿰钅艮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '艮',
      semantic: '钅',
      hint: 'money',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铷',
    definition: 'rubidium',
    pinyin: ['rú'],
    decomposition: '⿰钅如',
    etymology: {
      type: 'pictophonetic',
      phonetic: '如',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铸',
    definition: 'to melt, to cast; to mint, to coin',
    pinyin: ['zhù'],
    decomposition: '⿰钅寿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寿',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铹',
    definition: 'lawrencium',
    pinyin: ['láo'],
    decomposition: '⿰钅劳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '劳',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铺',
    definition: 'shop, store; bed, mattress',
    pinyin: ['pù'],
    decomposition: '⿰钅甫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甫',
      semantic: '钅',
      hint: 'money',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铼',
    definition: 'rhenium',
    pinyin: ['lái'],
    decomposition: '⿰钅来',
    etymology: {
      type: 'pictophonetic',
      phonetic: '来',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铽',
    definition: 'terbium',
    pinyin: ['tè'],
    decomposition: '⿰钅忒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '忒',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '链',
    definition: 'chain, wire; chains, shackles',
    pinyin: ['liàn'],
    decomposition: '⿰钅连',
    etymology: {
      type: 'ideographic',
      hint: 'Metal 钅 that joins 连; 连 also provides the pronunciation',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '铿',
    definition: 'to strike, to beat; gong, resounding noise',
    pinyin: ['kēng'],
    decomposition: '⿰钅坚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '坚',
      semantic: '钅',
      hint: 'bell',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '销',
    definition: 'to fuse, to melt; to market, to sell',
    pinyin: ['xiāo'],
    decomposition: '⿰钅肖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肖',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锁',
    definition: 'lock, padlock; chains, shackles',
    pinyin: ['suǒ'],
    decomposition: '⿰钅⿱⺌贝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '⺌',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '锂',
    definition: 'lithium',
    pinyin: ['lǐ'],
    decomposition: '⿰钅里',
    etymology: {
      type: 'pictophonetic',
      phonetic: '里',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锃',
    definition: 'to polish, to shine',
    pinyin: ['zèng'],
    decomposition: '⿰钅呈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '呈',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锄',
    definition: 'hoe; to eradicate, to weed out',
    pinyin: ['chú'],
    decomposition: '⿰钅助',
    etymology: {
      type: 'ideographic',
      hint: 'A metal 钅 tool 助; 助 also provides the pronunciation',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锅',
    definition: 'cooking-pot, saucepan',
    pinyin: ['guō'],
    decomposition: '⿰钅呙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '呙',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锆',
    definition: 'zirconium',
    pinyin: ['gào'],
    decomposition: '⿰钅告',
    etymology: {
      type: 'pictophonetic',
      phonetic: '告',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锇',
    definition: 'osmium',
    pinyin: ['é'],
    decomposition: '⿰钅我',
    etymology: {
      type: 'pictophonetic',
      phonetic: '我',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锈',
    definition: 'to rust, to corrode',
    pinyin: ['xiù'],
    decomposition: '⿰钅秀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '秀',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锉',
    definition: "carpenter's file; to file smooth",
    pinyin: ['cuò'],
    decomposition: '⿰钅坐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '坐',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锊',
    definition: 'a unit of weight, about 6 ounces',
    pinyin: ['lüè'],
    decomposition: '⿰钅寽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寽',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锋',
    definition: 'spear-point; edge, point, tip',
    pinyin: ['fēng'],
    decomposition: '⿰钅夆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夆',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锌',
    definition: 'zinc',
    pinyin: ['xīn'],
    decomposition: '⿰钅辛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辛',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锍',
    pinyin: ['liǔ'],
    decomposition: '⿰钅㐬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㐬',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锎',
    definition: 'caesium',
    pinyin: ['kāi'],
    decomposition: '⿰钅⿵门开',
    etymology: {
      type: 'pictophonetic',
      phonetic: '开',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '锏',
    definition: 'rapier; mace',
    pinyin: ['jiǎn'],
    decomposition: '⿰钅间',
    etymology: {
      type: 'pictophonetic',
      phonetic: '间',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锐',
    definition: 'sharp, pointed; keen, acute',
    pinyin: ['ruì'],
    decomposition: '⿰钅兑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兑',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锑',
    definition: 'antimony',
    pinyin: ['tī'],
    decomposition: '⿰钅弟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弟',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锒',
    definition: 'chain, lock; ornament',
    pinyin: ['láng'],
    decomposition: '⿰钅良',
    etymology: {
      type: 'pictophonetic',
      phonetic: '良',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锓',
    definition: 'to carve',
    pinyin: ['qǐn'],
    decomposition: '⿰钅⿳彐冖又',
    etymology: { type: 'pictophonetic', semantic: '钅', hint: 'metal' },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 2],
      [1, 2],
    ],
  },
  {
    character: '锔',
    definition: 'curium',
    pinyin: ['jū'],
    decomposition: '⿰钅局',
    etymology: {
      type: 'pictophonetic',
      phonetic: '局',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锕',
    definition: 'actinium',
    pinyin: ['ā'],
    decomposition: '⿰钅阿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '阿',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锖',
    definition: 'the color of a mineral',
    pinyin: ['qiāng'],
    decomposition: '⿰钅青',
    etymology: {
      type: 'ideographic',
      hint: 'A metallic 钅 color 青; 青 also provides the pronunciation',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锗',
    definition: 'germanium',
    pinyin: ['zhě'],
    decomposition: '⿰钅者',
    etymology: {
      type: 'pictophonetic',
      phonetic: '者',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锘',
    definition: 'nobelium',
    pinyin: ['nuò'],
    decomposition: '⿰钅若',
    etymology: {
      type: 'pictophonetic',
      phonetic: '若',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '错',
    definition: 'error, mistake; incorrect, wrong',
    pinyin: ['cuò'],
    decomposition: '⿰钅昔',
    etymology: {
      type: 'ideographic',
      hint: 'Gold 钅 that once was 昔 but is lost',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锚',
    definition: 'anchor',
    pinyin: ['máo'],
    decomposition: '⿰钅苗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '苗',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锛',
    definition: 'adze',
    pinyin: ['bēn'],
    decomposition: '⿰钅奔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奔',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锝',
    definition: 'technetium',
    pinyin: ['dé'],
    decomposition: '⿰钅㝵',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㝵',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锞',
    definition: 'ingot; acrobatic move',
    pinyin: ['kè'],
    decomposition: '⿰钅果',
    etymology: {
      type: 'pictophonetic',
      phonetic: '果',
      semantic: '钅',
      hint: 'gold',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锟',
    definition: 'a legendary sword',
    pinyin: ['kūn'],
    decomposition: '⿰钅昆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昆',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锡',
    definition: 'tin; to bestow, to confer',
    pinyin: ['xī'],
    decomposition: '⿰钅易',
    etymology: {
      type: 'pictophonetic',
      phonetic: '易',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锢',
    definition:
      'to run hot metal through a mold; to confine, to restrain, to stop',
    pinyin: ['gù'],
    decomposition: '⿰钅固',
    etymology: {
      type: 'ideographic',
      hint: 'To forge 固 metal 钅; 固 also provides the pronunciation',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锣',
    definition: 'gong',
    pinyin: ['luó'],
    decomposition: '⿰钅罗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '罗',
      semantic: '钅',
      hint: 'bell',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锤',
    definition: 'hammer',
    pinyin: ['chuí'],
    decomposition: '⿰钅垂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '垂',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锥',
    definition: 'gimlet, drill, awl; to drill, to bore',
    pinyin: ['zhuī'],
    decomposition: '⿰钅隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隹',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锦',
    definition: 'brocade, tapestry; embroidered',
    pinyin: ['jǐn'],
    decomposition: '⿰钅帛',
    etymology: {
      type: 'ideographic',
      hint: 'Silk 帛 inlaid with gold 钅; 钅 also provides the pronunciation',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锨',
    definition: 'shovel',
    pinyin: ['xiān'],
    decomposition: '⿰钅欣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '欣',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锩',
    definition: 'to bend iron',
    pinyin: ['juǎn'],
    decomposition: '⿰钅卷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卷',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锪',
    definition: 'a kind of tool',
    pinyin: ['huō'],
    decomposition: '⿰钅忽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '忽',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锫',
    definition: 'berkelium',
    pinyin: ['péi'],
    decomposition: '⿰钅咅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咅',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锬',
    definition: 'long spear',
    pinyin: ['tán'],
    decomposition: '⿰钅炎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '炎',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锭',
    definition: 'spindle, ingot; tablet, slab',
    pinyin: ['dìng'],
    decomposition: '⿰钅定',
    etymology: {
      type: 'pictophonetic',
      phonetic: '定',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '键',
    definition: 'lock, door bolt; key',
    pinyin: ['jiàn'],
    decomposition: '⿰钅建',
    etymology: {
      type: 'pictophonetic',
      phonetic: '建',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锯',
    definition: 'a saw; to saw, to amputate',
    pinyin: ['jù'],
    decomposition: '⿰钅居',
    etymology: {
      type: 'pictophonetic',
      phonetic: '居',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锰',
    definition: 'manganese',
    pinyin: ['měng'],
    decomposition: '⿰钅孟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孟',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锱',
    definition: 'half-pound; an ancient unit of weight',
    pinyin: ['zī'],
    decomposition: '⿰钅甾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甾',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '锲',
    definition: 'sickle; to cut, to carve, to engrave',
    pinyin: ['qiè'],
    decomposition: '⿰钅契',
    etymology: {
      type: 'ideographic',
      hint: 'Something engraved 契 in metal 钅; 契 also provides the pronunciation',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '锴',
    definition: 'high-quality iron',
    pinyin: ['kǎi'],
    decomposition: '⿰钅皆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皆',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '锵',
    definition: 'clang; jingle, tinkle',
    pinyin: ['qiāng'],
    decomposition: '⿰钅将',
    etymology: {
      type: 'pictophonetic',
      phonetic: '将',
      semantic: '钅',
      hint: 'bell',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '锶',
    definition: 'strontium',
    pinyin: ['sī'],
    decomposition: '⿰钅思',
    etymology: {
      type: 'pictophonetic',
      phonetic: '思',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '锷',
    definition: "high, lofty; sharp; a knife's edge",
    pinyin: ['è'],
    decomposition: '⿰钅咢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咢',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '锸',
    definition: 'spade, shovel; marking pin',
    pinyin: ['chā'],
    decomposition: '⿰钅臿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臿',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '锹',
    definition: 'shovel',
    pinyin: ['qiāo'],
    decomposition: '⿰钅秋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '秋',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '锺',
    definition: 'cup, glass, goblet; surname',
    pinyin: ['zhōng'],
    decomposition: '⿰钅重',
    etymology: {
      type: 'pictophonetic',
      phonetic: '重',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '锻',
    definition: 'to temper, to refine; to forge metal',
    pinyin: ['duàn'],
    decomposition: '⿰钅段',
    etymology: {
      type: 'pictophonetic',
      phonetic: '段',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '锼',
    definition: 'to carve',
    pinyin: ['sōu'],
    decomposition: '⿰钅叟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叟',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '锾',
    definition: 'to measure; money, coins',
    pinyin: ['huán'],
    decomposition: '⿰钅爰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爰',
      semantic: '钅',
      hint: 'money',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '锿',
    definition: 'einsteinium',
    pinyin: ['āi'],
    decomposition: '⿰钅哀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '哀',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镀',
    definition: 'to plate, to gild, to coat',
    pinyin: ['dù'],
    decomposition: '⿰钅度',
    etymology: {
      type: 'pictophonetic',
      phonetic: '度',
      semantic: '钅',
      hint: 'gold',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镁',
    definition: 'magnesium',
    pinyin: ['měi'],
    decomposition: '⿰钅美',
    etymology: {
      type: 'pictophonetic',
      phonetic: '美',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镂',
    definition: 'to inlay; to engrave, to carve; tattoo',
    pinyin: ['lòu'],
    decomposition: '⿰钅娄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '娄',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镄',
    definition: 'fermium',
    pinyin: ['fèi'],
    decomposition: '⿰钅费',
    etymology: {
      type: 'pictophonetic',
      phonetic: '费',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镅',
    definition: 'americium',
    pinyin: ['méi'],
    decomposition: '⿰钅眉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '眉',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镆',
    definition: 'sword',
    pinyin: ['mò'],
    decomposition: '⿰钅莫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '莫',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镇',
    definition: 'calm, composed; to control, to suppress',
    pinyin: ['zhèn'],
    decomposition: '⿰钅真',
    etymology: {
      type: 'pictophonetic',
      phonetic: '真',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镈',
    definition: 'large bell; hoe, spade',
    pinyin: ['bó'],
    decomposition: '⿰钅尃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尃',
      semantic: '钅',
      hint: 'bell',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镉',
    definition: 'cadmium',
    pinyin: ['gé'],
    decomposition: '⿰钅鬲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鬲',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镊',
    definition: 'tweezers, forceps, pliers; to nip, to pluck',
    pinyin: ['niè'],
    decomposition: '⿰钅聂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '聂',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镌',
    definition: 'engraving tool; to carve, to engrave',
    pinyin: ['juān'],
    decomposition: '⿰钅隽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隽',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镍',
    definition: 'nickel',
    pinyin: ['niè'],
    decomposition: '⿰钅臬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臬',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镎',
    definition: 'neptunium',
    pinyin: ['ná'],
    decomposition: '⿰钅拿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '拿',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镏',
    definition: 'to distill; lutetium; surname',
    pinyin: ['liú'],
    decomposition: '⿰钅留',
    etymology: {
      type: 'ideographic',
      hint: 'A metal 钅 still 留; 留 also provides the pronunciation',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镐',
    definition: 'stove; bright',
    pinyin: ['gǎo'],
    decomposition: '⿰钅高',
    etymology: {
      type: 'pictophonetic',
      phonetic: '高',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镑',
    definition: 'pound sterling',
    pinyin: ['bàng'],
    decomposition: '⿰钅旁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旁',
      semantic: '钅',
      hint: 'money',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镒',
    definition: 'a measure of weight used for gold',
    pinyin: ['yì'],
    decomposition: '⿰钅益',
    etymology: {
      type: 'pictophonetic',
      phonetic: '益',
      semantic: '钅',
      hint: 'gold',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镓',
    definition: 'gallium',
    pinyin: ['jiā'],
    decomposition: '⿰钅家',
    etymology: {
      type: 'pictophonetic',
      phonetic: '家',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镔',
    definition: 'high-quality iron',
    pinyin: ['bīn'],
    decomposition: '⿰钅宾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宾',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镕',
    definition: 'mold; to fuse, to melt, to smelt',
    pinyin: ['róng'],
    decomposition: '⿰钅容',
    etymology: {
      type: 'ideographic',
      hint: 'A mold that holds 容 hot metal 钅; 容 also provides the pronunciation',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镖',
    definition: 'spear, harpoon, dart; to escort',
    pinyin: ['biāo'],
    decomposition: '⿰钅票',
    etymology: {
      type: 'pictophonetic',
      phonetic: '票',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镗',
    definition: 'awl, boring tool',
    pinyin: ['tāng'],
    decomposition: '⿰钅堂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堂',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镘',
    definition: 'trowel',
    pinyin: ['màn'],
    decomposition: '⿰钅曼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曼',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镙',
    pinyin: ['luó'],
    decomposition: '⿰钅累',
    etymology: {
      type: 'pictophonetic',
      phonetic: '累',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镚',
    definition: 'dime, small coin',
    pinyin: ['bèng'],
    decomposition: '⿰钅崩',
    etymology: {
      type: 'pictophonetic',
      phonetic: '崩',
      semantic: '钅',
      hint: 'money',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镛',
    definition: 'a large bell used as musical instrument',
    pinyin: ['yōng'],
    decomposition: '⿰钅庸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '庸',
      semantic: '钅',
      hint: 'bell',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镜',
    definition: 'mirror, glass; lens, glasses',
    pinyin: ['jìng'],
    decomposition: '⿰钅竟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '竟',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镝',
    definition: 'dysprosium',
    pinyin: ['dī'],
    decomposition: '⿰钅啇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '啇',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镞',
    definition: 'arrowhead, barb; quick, swift',
    pinyin: ['zú'],
    decomposition: '⿰钅族',
    etymology: {
      type: 'pictophonetic',
      phonetic: '族',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镟',
    definition: 'lathe',
    pinyin: ['xuàn'],
    decomposition: '⿰钅旋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旋',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镡',
    definition: 'dagger, dirk, short-sword',
    pinyin: ['chán'],
    decomposition: '⿰钅覃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '覃',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镢',
    definition: 'hoe',
    pinyin: ['jué'],
    decomposition: '⿰钅厥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厥',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镣',
    definition: 'fetters, leg-irons',
    pinyin: ['liào'],
    decomposition: '⿰钅尞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尞',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镤',
    definition: 'protactinium',
    pinyin: ['pú'],
    decomposition: '⿰钅菐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '菐',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镥',
    definition: 'lutetium',
    pinyin: ['lǔ'],
    decomposition: '⿰钅鲁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鲁',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镦',
    definition: 'ferrule; to castrate',
    pinyin: ['duì'],
    decomposition: '⿰钅敦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敦',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镧',
    definition: 'lanthanum',
    pinyin: ['lán'],
    decomposition: '⿰钅阑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '阑',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镨',
    definition: 'praseodymium',
    pinyin: ['pǔ'],
    decomposition: '⿰钅普',
    etymology: {
      type: 'pictophonetic',
      phonetic: '普',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镩',
    definition: 'iron, pick, poker',
    pinyin: ['cuān'],
    decomposition: '⿰钅窜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '窜',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镪',
    definition: 'coins, money, wealth',
    pinyin: ['qiāng'],
    decomposition: '⿰钅强',
    etymology: {
      type: 'pictophonetic',
      phonetic: '强',
      semantic: '钅',
      hint: 'money',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镫',
    definition: 'lamp; a kind of cooking vessel',
    pinyin: ['dèng'],
    decomposition: '⿰钅登',
    etymology: {
      type: 'pictophonetic',
      phonetic: '登',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镬',
    definition: 'cauldron, large iron pot',
    pinyin: ['huò'],
    decomposition: '⿰钅蒦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蒦',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镭',
    definition: 'radium',
    pinyin: ['léi'],
    decomposition: '⿰钅雷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '雷',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镯',
    definition: 'bracelet, armband; small bell',
    pinyin: ['zhuó'],
    decomposition: '⿰钅蜀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蜀',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镰',
    definition: 'sickle',
    pinyin: ['lián'],
    decomposition: '⿰钅廉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '廉',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镱',
    definition: 'ytterbium',
    pinyin: ['yì'],
    decomposition: '⿰钅意',
    etymology: {
      type: 'pictophonetic',
      phonetic: '意',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镲',
    definition: 'cymbals',
    pinyin: ['chǎ'],
    decomposition: '⿰钅察',
    etymology: {
      type: 'pictophonetic',
      phonetic: '察',
      semantic: '钅',
      hint: 'bell',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镳',
    definition: 'bit, bridle; to ride',
    pinyin: ['biāo'],
    decomposition: '⿰钅麃',
    etymology: {
      type: 'ideographic',
      hint: 'A metal bit 钅 used to saddle 麃 a horse',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镴',
    definition: 'tin, solder',
    pinyin: ['là'],
    decomposition: '⿰钅巤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巤',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '镶',
    definition: 'inset, inlay; to set, to mount; to fill',
    pinyin: ['xiāng'],
    decomposition: '⿰钅襄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '襄',
      semantic: '钅',
      hint: 'metal',
    },
    radical: '钅',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '長',
    definition: 'long, lasting; to excel in',
    pinyin: ['zhǎng'],
    decomposition: '⿱？？',
    etymology: {
      type: 'pictographic',
      hint: 'An old man with long hair and a cane',
    },
    radical: '長',
    matches: [null, null, null, null, null, null, null, null],
  },
  {
    character: '镸',
    definition: 'long; lasting; to excel in',
    pinyin: ['cháng'],
    decomposition: '⿱？厶',
    radical: '镸',
    matches: [null, null, null, null, null, [1], [1]],
  },
  {
    character: '长',
    definition: 'long, lasting; to excel in',
    pinyin: ['zhǎng'],
    decomposition: '⿻？一',
    etymology: {
      type: 'ideographic',
      hint: 'Simplified form of 長; an old man with long hair and a cane',
    },
    radical: '长',
    matches: [null, [1], null, null],
  },
  {
    character: '門',
    definition: 'gate, door, entrance, opening',
    pinyin: ['mén'],
    decomposition: '⿰？？',
    etymology: { type: 'pictographic', hint: 'An open doorway or gate' },
    radical: '門',
    matches: [null, null, null, null, null, null, null, null],
  },
  {
    character: '閂',
    definition: 'bolt, latch, crossbar',
    pinyin: ['shuān'],
    decomposition: '⿵門一',
    etymology: { type: 'ideographic', hint: 'A bar 一 laid across a gate 門' },
    radical: '門',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1]],
  },
  {
    character: '閃',
    definition: 'flash, lightning; to dodge, to evade',
    pinyin: ['shǎn'],
    decomposition: '⿵門人',
    etymology: {
      type: 'ideographic',
      hint: 'A man 人 just glimpsed through a door 門',
    },
    radical: '門',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '閉',
    definition: 'to shut, to close; to obstruct, to block',
    pinyin: ['bì'],
    decomposition: '⿵門才',
    etymology: { type: 'ideographic', hint: 'A door 門 blocked by bars 才' },
    radical: '門',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '開',
    definition: 'to open; to start, to initiate, to begin',
    pinyin: ['kāi'],
    decomposition: '⿵門开',
    etymology: {
      type: 'pictophonetic',
      phonetic: '开',
      semantic: '門',
      hint: 'gate',
    },
    radical: '門',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '閎',
    definition: 'barrier, gate; vast, wide; to expand',
    pinyin: ['hóng'],
    decomposition: '⿵門厷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厷',
      semantic: '門',
      hint: 'gate',
    },
    radical: '門',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '閏',
    definition: 'intercalary; extra, surplus',
    pinyin: ['rùn'],
    decomposition: '⿵門王',
    etymology: {
      type: 'pictophonetic',
      phonetic: '門',
      semantic: '王',
      hint: 'royal decree',
    },
    radical: '門',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '閑',
    definition: 'fence, guard; to defend; idle time',
    pinyin: ['xián'],
    decomposition: '⿵門木',
    etymology: {
      type: 'ideographic',
      hint: 'A wooden fence 木 with a door 門',
    },
    radical: '門',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '閒',
    definition: 'leisure, idle time; tranquil, peaceful, calm',
    pinyin: ['xián'],
    decomposition: '⿵門月',
    etymology: {
      type: 'ideographic',
      hint: 'The moon 月 seen through a door 門; night-time',
    },
    radical: '門',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '間',
    definition: 'between, among; midpoint; space, place, locality',
    pinyin: ['jiān'],
    decomposition: '⿵門日',
    etymology: {
      type: 'ideographic',
      hint: 'The sun 日 shining through a doorway 門',
    },
    radical: '門',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '閔',
    definition: 'to mourn, to grieve; to incite, to urge on',
    pinyin: ['mǐn'],
    decomposition: '⿵門文',
    etymology: {
      type: 'pictophonetic',
      phonetic: '門',
      semantic: '文',
      hint: 'culture',
    },
    radical: '門',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '閘',
    definition: 'sluice, floodgate, canal lock',
    pinyin: ['zhá'],
    decomposition: '⿵門甲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甲',
      semantic: '門',
      hint: 'gate',
    },
    radical: '門',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '閡',
    definition: 'separated, blocked; to prevent, to block',
    pinyin: ['hé'],
    decomposition: '⿵門亥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亥',
      semantic: '門',
      hint: 'gate',
    },
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '閣',
    definition: 'cabinet, chamber, pavilion',
    pinyin: ['gé'],
    decomposition: '⿵門各',
    etymology: {
      type: 'pictophonetic',
      phonetic: '各',
      semantic: '門',
      hint: 'door',
    },
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '閤',
    definition: 'chamber; shelf; side-door',
    pinyin: ['gé'],
    decomposition: '⿵門合',
    etymology: {
      type: 'pictophonetic',
      phonetic: '合',
      semantic: '門',
      hint: 'door',
    },
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '閥',
    definition: 'clique, valve; a powerful and influential group',
    pinyin: ['fá'],
    decomposition: '⿵門伐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '伐',
      semantic: '門',
      hint: 'gate',
    },
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '閦',
    definition: 'busy, crowded; used in transliterations',
    pinyin: ['chù'],
    decomposition: '⿵門众',
    etymology: {
      type: 'ideographic',
      hint: 'A crowd 众 walking through a gate 門',
    },
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '閨',
    definition: "women's quarters; lady's apartment",
    pinyin: ['guī'],
    decomposition: '⿵門圭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '圭',
      semantic: '門',
      hint: 'gate',
    },
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '閩',
    definition: 'Fujian province; a river; a tribe',
    pinyin: ['mǐn'],
    decomposition: '⿵門虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '門',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '閫',
    definition: "threshold; women's quarters",
    pinyin: ['kǔn'],
    decomposition: '⿵門困',
    etymology: {
      type: 'pictophonetic',
      phonetic: '困',
      semantic: '門',
      hint: 'gate',
    },
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '閬',
    definition: 'high door, high gate; high, lofty',
    pinyin: ['láng'],
    decomposition: '⿵門良',
    etymology: {
      type: 'ideographic',
      hint: 'A lofty 良 gate 門; 良 also provides the pronunciation',
    },
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '閭',
    definition: 'a village of twenty-five families',
    pinyin: ['lǘ'],
    decomposition: '⿵門吕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吕',
      semantic: '門',
      hint: 'gate',
    },
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '閱',
    definition: 'to examine, to inspect; to read, to review',
    pinyin: ['yuè'],
    decomposition: '⿵門兌',
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '閵',
    pinyin: ['lìn'],
    decomposition: '⿵門隹',
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '閶',
    definition: 'the gates of heaven; the main gate of a palace',
    pinyin: ['chāng'],
    decomposition: '⿵門昌',
    etymology: {
      type: 'ideographic',
      hint: 'A heavenly 昌 gate 門; 昌 also provides the pronunciation',
    },
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '閹',
    definition: 'eunuch; to castrate',
    pinyin: ['yān'],
    decomposition: '⿵門奄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奄',
      semantic: '門',
      hint: 'gate',
    },
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '閻',
    definition: 'village gate; surname',
    pinyin: ['yán'],
    decomposition: '⿵門臽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臽',
      semantic: '門',
      hint: 'gate',
    },
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '閼',
    definition: 'to block, to obstruct, to stop up',
    pinyin: ['è'],
    decomposition: '⿵門於',
    etymology: {
      type: 'pictophonetic',
      phonetic: '於',
      semantic: '門',
      hint: 'gate',
    },
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '閾',
    definition: 'threshold; separated, confined',
    pinyin: ['yù'],
    decomposition: '⿵門或',
    etymology: { type: 'ideographic', hint: 'Separated 或 by a gate 門' },
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '闃',
    definition: 'alone; quiet, still',
    pinyin: ['qù'],
    decomposition: '⿵門狊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '狊',
      semantic: '門',
      hint: 'gate',
    },
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '闆',
    definition: 'board, plank; plate, slab; unnatural, stiff',
    pinyin: ['bǎn'],
    decomposition: '⿵門品',
    etymology: {
      type: 'ideographic',
      hint: 'Door 門 material 品; 品 also provides the pronunciation',
    },
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '闈',
    definition: 'gate, door; living quarters',
    pinyin: ['wéi'],
    decomposition: '⿵門韋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韋',
      semantic: '門',
      hint: 'gate',
    },
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '闉',
    definition: 'bent, curved; a curved wall',
    pinyin: ['yīn'],
    decomposition: '⿵門垔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '垔',
      semantic: '門',
      hint: 'gate',
    },
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '闊',
    definition: 'ample, broad, wide; separate; to be apart',
    pinyin: ['kuò'],
    decomposition: '⿵門活',
    etymology: {
      type: 'pictophonetic',
      phonetic: '活',
      semantic: '門',
      hint: 'gate',
    },
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '闌',
    definition: 'screen door, railing, fence',
    pinyin: ['lán'],
    decomposition: '⿵門柬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '柬',
      semantic: '門',
      hint: 'door',
    },
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '闔',
    definition: 'to close; whole, entire, all',
    pinyin: ['hé'],
    decomposition: '⿵門盍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '盍',
      semantic: '門',
      hint: 'gate',
    },
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '闕',
    definition: 'palace; watchtower',
    pinyin: ['quē'],
    decomposition: '⿵門欮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '欮',
      semantic: '門',
      hint: 'gate',
    },
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '闖',
    definition: 'to rush in, to charge in, to burst in',
    pinyin: ['chuǎng'],
    decomposition: '⿵門馬',
    etymology: {
      type: 'ideographic',
      hint: 'A horse 馬 charging through a gate 門',
    },
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '關',
    definition: 'frontier pass; to close, to shut; relation',
    pinyin: ['guān'],
    decomposition: '⿵門⿱⿰幺幺丱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丱',
      semantic: '門',
      hint: 'gate',
    },
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 0],
      [1, 0, 1],
      [1, 0, 1],
      [1, 0, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '闞',
    definition: 'to glance, to peep; to growl, to roar',
    pinyin: ['hǎn'],
    decomposition: '⿵門敢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敢',
      semantic: '門',
      hint: 'gate',
    },
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '闡',
    definition: 'to disclose; to explain; to open',
    pinyin: ['chǎn'],
    decomposition: '⿵門單',
    etymology: {
      type: 'pictophonetic',
      phonetic: '單',
      semantic: '門',
      hint: 'gate',
    },
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '闢',
    definition: 'open; to settle, to develop, to open up',
    pinyin: ['pì'],
    decomposition: '⿵門辟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辟',
      semantic: '門',
      hint: 'gate',
    },
    radical: '門',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '门',
    definition: 'gate, door, entrance, opening',
    pinyin: ['mén'],
    decomposition: '⿰⿱丶丨？',
    etymology: { type: 'pictographic', hint: 'An open doorway or gate' },
    radical: '门',
    matches: [[0, 0], [0, 1], null],
  },
  {
    character: '闩',
    definition: 'bolt, latch, crossbar',
    pinyin: ['shuān'],
    decomposition: '⿵门一',
    etymology: { type: 'ideographic', hint: 'A bar 一 laid across a gate 门' },
    radical: '门',
    matches: [[0], [0], [0], [1]],
  },
  {
    character: '闪',
    definition: 'flash, lightning; to dodge, to evade',
    pinyin: ['shǎn'],
    decomposition: '⿵门人',
    etymology: {
      type: 'ideographic',
      hint: 'A man 人 just glimpsed through a door 门',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '闫',
    definition: 'village gate',
    pinyin: ['yàn'],
    decomposition: '⿵门三',
    etymology: {
      type: 'pictophonetic',
      phonetic: '三',
      semantic: '门',
      hint: 'gate',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '闭',
    definition: 'to shut, to close; to obstruct, to block',
    pinyin: ['bì'],
    decomposition: '⿵门才',
    etymology: { type: 'ideographic', hint: 'A door 门 blocked by bars 才' },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '问',
    definition: 'to ask about, to inquire after',
    pinyin: ['wèn'],
    decomposition: '⿵门口',
    etymology: {
      type: 'pictophonetic',
      phonetic: '门',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '闯',
    definition: 'to rush in, to charge in, to burst in',
    pinyin: ['chuǎng'],
    decomposition: '⿵门马',
    etymology: {
      type: 'ideographic',
      hint: 'A horse 马 charging through a gate 门',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '闰',
    definition: 'intercalary; extra, surplus',
    pinyin: ['rùn'],
    decomposition: '⿵门王',
    etymology: {
      type: 'pictophonetic',
      phonetic: '门',
      semantic: '王',
      hint: 'royal decree',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '闱',
    definition: 'gate, door; living quarters',
    pinyin: ['wéi'],
    decomposition: '⿵门韦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韦',
      semantic: '门',
      hint: 'gate',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '闲',
    definition: 'fence, guard; to defend; idle time',
    pinyin: ['xián'],
    decomposition: '⿵门木',
    etymology: {
      type: 'ideographic',
      hint: 'A wooden fence 木 with a door 门',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '闳',
    definition: 'barrier, gate; vast, wide; to expand',
    pinyin: ['hóng'],
    decomposition: '⿵门厷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厷',
      semantic: '门',
      hint: 'gate',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '间',
    definition: 'between, among; midpoint; space, place, locality',
    pinyin: ['jiān'],
    decomposition: '⿵门日',
    etymology: {
      type: 'ideographic',
      hint: 'The sun 日 shining through a doorway 门',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '闵',
    definition: 'to mourn, to grieve; to incite, to urge on',
    pinyin: ['mǐn'],
    decomposition: '⿵门文',
    etymology: {
      type: 'pictophonetic',
      phonetic: '门',
      semantic: '文',
      hint: 'culture',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '闶',
    definition: 'door',
    pinyin: ['kāng'],
    decomposition: '⿵门亢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亢',
      semantic: '门',
      hint: 'door',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '闷',
    definition: 'gloomy, depressed, melancholy',
    pinyin: ['mèn'],
    decomposition: '⿵门心',
    etymology: {
      type: 'pictophonetic',
      phonetic: '门',
      semantic: '心',
      hint: 'heart',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '闸',
    definition: 'sluice, floodgate, canal lock',
    pinyin: ['zhá'],
    decomposition: '⿵门甲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甲',
      semantic: '门',
      hint: 'gate',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '闹',
    definition: 'busy, lively; to dispute, to quarrel',
    pinyin: ['nào'],
    decomposition: '⿵门市',
    etymology: {
      type: 'ideographic',
      hint: 'As busy as the market 市 gate 门',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '闺',
    definition: "women's quarters; lady's apartment",
    pinyin: ['guī'],
    decomposition: '⿵门圭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '圭',
      semantic: '门',
      hint: 'gate',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '闻',
    definition: 'news; to hear, to smell; to make known',
    pinyin: ['wén'],
    decomposition: '⿵门耳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '门',
      semantic: '耳',
      hint: 'ear',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '闼',
    definition: 'door, gate; the door to an inner room',
    pinyin: ['tà'],
    decomposition: '⿵门达',
    etymology: {
      type: 'pictophonetic',
      phonetic: '达',
      semantic: '门',
      hint: 'door',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '闽',
    definition: 'Fujian province; a river; a tribe',
    pinyin: ['mǐn'],
    decomposition: '⿵门虫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '门',
      semantic: '虫',
      hint: 'insect',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '闾',
    definition: 'a village of twenty-five families',
    pinyin: ['lǘ'],
    decomposition: '⿵门吕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吕',
      semantic: '门',
      hint: 'gate',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '阀',
    definition: 'clique, valve; a powerful and influential group',
    pinyin: ['fá'],
    decomposition: '⿵门伐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '伐',
      semantic: '门',
      hint: 'gate',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '阁',
    definition: 'cabinet, chamber, pavilion',
    pinyin: ['gé'],
    decomposition: '⿵门各',
    etymology: {
      type: 'pictophonetic',
      phonetic: '各',
      semantic: '门',
      hint: 'door',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '阂',
    definition: 'separated, blocked; to prevent, to block',
    pinyin: ['hé'],
    decomposition: '⿵门亥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亥',
      semantic: '门',
      hint: 'gate',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '阃',
    definition: "threshold; women's quarters",
    pinyin: ['kǔn'],
    decomposition: '⿵门困',
    etymology: {
      type: 'pictophonetic',
      phonetic: '困',
      semantic: '门',
      hint: 'gate',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '阄',
    definition: 'chance, risk; to draw lots',
    pinyin: ['jiū'],
    decomposition: '⿵门龟',
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '阅',
    definition: 'to examine, to inspect; to read, to review',
    pinyin: ['yuè'],
    decomposition: '⿵门兑',
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '阆',
    definition: 'high door, high gate; high, lofty',
    pinyin: ['láng'],
    decomposition: '⿵门良',
    etymology: {
      type: 'ideographic',
      hint: 'A lofty 良 gate 门; 良 also provides the pronunciation',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '阇',
    definition: 'a Buddhist high priest',
    pinyin: ['dū'],
    decomposition: '⿵门者',
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '阈',
    definition: 'threshold; separated, confined',
    pinyin: ['yù'],
    decomposition: '⿵门或',
    etymology: { type: 'ideographic', hint: 'Separated 或 by a gate 门' },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '阉',
    definition: 'eunuch; to castrate',
    pinyin: ['yān'],
    decomposition: '⿵门奄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奄',
      semantic: '门',
      hint: 'gate',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '阊',
    definition: 'the gates of heaven; the main gate of a palace',
    pinyin: ['chāng'],
    decomposition: '⿵门昌',
    etymology: {
      type: 'ideographic',
      hint: 'A heavenly 昌 gate 门; 昌 also provides the pronunciation',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '阋',
    definition: 'feud; to fight, to quarrel',
    pinyin: ['xì'],
    decomposition: '⿵门兒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兒',
      semantic: '门',
      hint: 'fight',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '阌',
    definition: 'a place in the Henan province',
    pinyin: ['wén'],
    decomposition: '⿵门受',
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '阍',
    definition: 'gatekeeper; gate, door',
    pinyin: ['hūn'],
    decomposition: '⿵门昏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昏',
      semantic: '门',
      hint: 'gate',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '阎',
    definition: 'village gate; surname',
    pinyin: ['yán'],
    decomposition: '⿵门臽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臽',
      semantic: '门',
      hint: 'gate',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '阏',
    definition: 'to block, to obstruct, to stop up',
    pinyin: ['è'],
    decomposition: '⿵门於',
    etymology: {
      type: 'pictophonetic',
      phonetic: '於',
      semantic: '门',
      hint: 'gate',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '阐',
    definition: 'to disclose; to explain; to open',
    pinyin: ['chǎn'],
    decomposition: '⿵门单',
    etymology: {
      type: 'pictophonetic',
      phonetic: '单',
      semantic: '门',
      hint: 'gate',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '阑',
    definition: 'screen door, railing, fence',
    pinyin: ['lán'],
    decomposition: '⿵门柬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '柬',
      semantic: '门',
      hint: 'door',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '阒',
    definition: 'alone; quiet, still',
    pinyin: ['qù'],
    decomposition: '⿵门狊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '狊',
      semantic: '门',
      hint: 'gate',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '阔',
    definition: 'ample, broad, wide; separate; to be apart',
    pinyin: ['kuò'],
    decomposition: '⿵门活',
    etymology: {
      type: 'pictophonetic',
      phonetic: '活',
      semantic: '门',
      hint: 'gate',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '阕',
    definition: 'to close, to shut; watchtower',
    pinyin: ['què'],
    decomposition: '⿵门癸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '癸',
      semantic: '门',
      hint: 'gate',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '阖',
    definition: 'to close; whole, entire, all',
    pinyin: ['hé'],
    decomposition: '⿵门盍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '盍',
      semantic: '门',
      hint: 'gate',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '阗',
    definition: 'a place in Xinjiang province',
    pinyin: ['tián'],
    decomposition: '⿵门真',
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '阙',
    definition: 'palace; watchtower',
    pinyin: ['quē'],
    decomposition: '⿵门欮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '欮',
      semantic: '门',
      hint: 'gate',
    },
    radical: '门',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '阚',
    definition: 'to glance, to peep; to growl, to roar',
    pinyin: ['hǎn'],
    decomposition: '⿵门敢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敢',
      semantic: '门',
      hint: 'gate',
    },
    radical: '门',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '阜',
    definition: 'mound; abundant, ample, numerous',
    pinyin: ['fù'],
    decomposition: '⿳丿㠯十',
    radical: '阜',
    matches: [[0], [1], [1], [1], [1], [1], [2], [2]],
  },
  {
    character: '阝',
    definition: 'place, town, city',
    pinyin: ['yì'],
    decomposition: '⿻丨？',
    radical: '阝',
    matches: [null, [0]],
  },
  {
    character: '阞',
    definition: 'sedimentary layer; mineral vein',
    pinyin: ['lè'],
    decomposition: '⿰阝力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '力',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '队',
    definition:
      'team, group, band, army unit; measure word for groups of people',
    pinyin: ['duì'],
    decomposition: '⿰阝人',
    etymology: {
      type: 'ideographic',
      hint: 'A group of people 人 gathered in one place 阝',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '阡',
    definition: 'path; a foot-path between fields',
    pinyin: ['qiān'],
    decomposition: '⿰阝千',
    etymology: {
      type: 'pictophonetic',
      phonetic: '千',
      semantic: '阝',
      hint: 'hill',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '阢',
    definition: 'worried, apprehensive',
    pinyin: ['wù'],
    decomposition: '⿰阝兀',
    etymology: { type: 'pictophonetic', phonetic: '兀' },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1]],
  },
  {
    character: '阪',
    definition: 'hillside, slope',
    pinyin: ['bǎn'],
    decomposition: '⿰阝反',
    etymology: {
      type: 'pictophonetic',
      phonetic: '反',
      semantic: '阝',
      hint: 'hill',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '阮',
    definition: 'ancient musical instrument; surname',
    pinyin: ['ruǎn'],
    decomposition: '⿰阝元',
    etymology: { type: 'pictophonetic', phonetic: '元' },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '阱',
    definition: 'trap, snare, pitfall',
    pinyin: ['jǐng'],
    decomposition: '⿰阝井',
    etymology: {
      type: 'ideographic',
      hint: 'A farm 阝 with a well 井; 井 also provides the pronunciation',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '防',
    definition: 'to protect, to defend, to guard against',
    pinyin: ['fáng'],
    decomposition: '⿰阝方',
    etymology: {
      type: 'pictophonetic',
      phonetic: '方',
      semantic: '阝',
      hint: 'wall',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '阳',
    definition: 'the male principle; bright, sunny; clear, lit, open',
    pinyin: ['yáng'],
    decomposition: '⿰阝日',
    etymology: {
      type: 'ideographic',
      hint: 'The place 阝 of the sun 日; compare 阴',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '阴',
    definition: 'the female principle; dark, shaded; hidden, implicit, secret',
    pinyin: ['yīn'],
    decomposition: '⿰阝月',
    etymology: {
      type: 'ideographic',
      hint: 'The place 阝 of the moon 月; compare 阳',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '阵',
    definition: 'row, column; ranks, troop formation',
    pinyin: ['zhèn'],
    decomposition: '⿰阝车',
    etymology: { type: 'ideographic', hint: 'A formation 阝of soldiers 车' },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '阶',
    definition: 'stairs, steps; degree, rank',
    pinyin: ['jiē'],
    decomposition: '⿰阝介',
    etymology: {
      type: 'pictophonetic',
      phonetic: '介',
      semantic: '阝',
      hint: 'hill',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1]],
  },
  {
    character: '阻',
    definition: 'to hinder, to impede; to obstruct, to oppose',
    pinyin: ['zǔ'],
    decomposition: '⿰阝且',
    etymology: {
      type: 'pictophonetic',
      phonetic: '且',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '阼',
    definition: 'the steps leading to the eastern door',
    pinyin: ['zuò'],
    decomposition: '⿰阝乍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乍',
      semantic: '阝',
      hint: 'hill',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '阽',
    pinyin: ['diàn'],
    decomposition: '⿰阝占',
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '阿',
    definition:
      'an initial particle, a prefix used for names; used in transliterations',
    pinyin: ['ā'],
    decomposition: '⿰阝可',
    etymology: {
      type: 'pictophonetic',
      phonetic: '可',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '陀',
    definition: 'steep bank, rough terrain',
    pinyin: ['tuó'],
    decomposition: '⿰阝它',
    etymology: {
      type: 'pictophonetic',
      phonetic: '阝',
      semantic: '它',
      hint: 'hill',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '陂',
    definition: 'dam, embankment; reservoir',
    pinyin: ['bēi'],
    decomposition: '⿰阝皮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皮',
      semantic: '阝',
      hint: 'hill',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '附',
    definition: 'nearby; to adhere to, to attach; to rely on',
    pinyin: ['fù'],
    decomposition: '⿰阝付',
    etymology: {
      type: 'pictophonetic',
      phonetic: '付',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '际',
    definition: 'border, boundary, juncture',
    pinyin: ['jì'],
    decomposition: '⿰阝示',
    etymology: {
      type: 'pictophonetic',
      phonetic: '示',
      semantic: '阝',
      hint: 'hill',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '陆',
    definition: "land, continent; six (bankers' anti-fraud numeral)",
    pinyin: ['lù'],
    decomposition: '⿰阝击',
    etymology: {
      type: 'pictophonetic',
      phonetic: '击',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '陇',
    definition: 'a mountain located in the Shanxi provice',
    pinyin: ['lǒng'],
    decomposition: '⿰阝龙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龙',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '陈',
    definition: 'to display, to exhibit; to plead; surname',
    pinyin: ['chén'],
    decomposition: '⿰阝东',
    etymology: { type: 'ideographic', hint: 'To place 阝 facing east 东' },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '陉',
    definition: 'defile, gorge, mountain pass',
    pinyin: ['xíng'],
    decomposition: '⿰阝？',
    etymology: { type: 'pictophonetic', semantic: '阝', hint: 'hill' },
    radical: '阝',
    matches: [[0], [0], null, null, null, null, null],
  },
  {
    character: '陋',
    definition: 'coarse, crude; narrow; ugly',
    pinyin: ['lòu'],
    decomposition: '⿰阝⿺乚丙',
    etymology: { type: 'pictophonetic', semantic: '阝', hint: 'village' },
    radical: '阝',
    matches: [[0], [0], [1, 1], [1, 1], [1, 1], [1, 1], [1, 1], [1, 0]],
  },
  {
    character: '陌',
    definition: 'strange, unfamiliar; a foot path between rice fields',
    pinyin: ['mò'],
    decomposition: '⿰阝百',
    etymology: {
      type: 'ideographic',
      hint: 'A large 百 city 阝, representing an unfamiliar place',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '降',
    definition: 'to descend, to fall; to drop, to lower',
    pinyin: ['jiàng'],
    decomposition: '⿰阝夅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夅',
      semantic: '阝',
      hint: 'hill',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '陏',
    definition: 'to accompany, to follow; to listen to; to submit to',
    pinyin: ['duò'],
    decomposition: '⿰阝有',
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '限',
    definition: 'boundary, limit, line',
    pinyin: ['xiàn'],
    decomposition: '⿰阝艮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '艮',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '陔',
    definition: 'ledge, step, terrace; slope',
    pinyin: ['gāi'],
    decomposition: '⿰阝亥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亥',
      semantic: '阝',
      hint: 'hill',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '陕',
    definition: 'mountain pass; the Shanxi province',
    pinyin: ['shǎn'],
    decomposition: '⿰阝夹',
    etymology: {
      type: 'ideographic',
      hint: 'A place 阝 wedged in a valley 夹',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '陘',
    definition: 'defile, gorge, mountain pass',
    pinyin: ['xíng'],
    decomposition: '⿰阝巠',
    etymology: {
      type: 'pictophonetic',
      semantic: '阝',
      hint: 'hill',
      phonetic: '巠',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '陛',
    definition: 'throne; steps leading to the throne',
    pinyin: ['bì'],
    decomposition: '⿰阝坒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '坒',
      semantic: '阝',
      hint: 'hill',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '陜',
    definition: 'narrow; mountain pass',
    pinyin: ['xiá'],
    decomposition: '⿰阝夾',
    etymology: {
      type: 'ideographic',
      hint: 'The space between 夾 two hills 阝; 夾 also provides the pronunciation',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '陞',
    definition: 'to ascend, to rise; to promote',
    pinyin: ['shēng'],
    decomposition: '⿰阝⿱升土',
    etymology: {
      type: 'ideographic',
      hint: 'To pile up 升 earth 土 to form a mound 阝; 升 also provides the pronunciation',
    },
    radical: '阝',
    matches: [[0], [0], [1, 0], [1, 0], [1, 0], [1, 0], [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '陟',
    definition: 'to climb; to advance; progress',
    pinyin: ['zhì'],
    decomposition: '⿰阝步',
    etymology: {
      type: 'pictophonetic',
      phonetic: '阝',
      semantic: '步',
      hint: 'walk',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '陡',
    definition: 'steep, sloping; sudden, abrupt',
    pinyin: ['dǒu'],
    decomposition: '⿰阝走',
    etymology: {
      type: 'pictophonetic',
      phonetic: '走',
      semantic: '阝',
      hint: 'hill',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '院',
    definition: 'court, yard, courtyard; school',
    pinyin: ['yuàn'],
    decomposition: '⿰阝完',
    etymology: {
      type: 'pictophonetic',
      phonetic: '完',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '陣',
    definition: 'row, column; ranks, troop formation',
    pinyin: ['zhèn'],
    decomposition: '⿰阝車',
    etymology: { type: 'ideographic', hint: 'A formation 阝of soldiers 車' },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '除',
    definition: 'to eliminate, to remove, to wipe out',
    pinyin: ['chú'],
    decomposition: '⿰阝余',
    etymology: {
      type: 'ideographic',
      hint: 'The waste 余 produced by a city 阝',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '陧',
    definition: 'chaos, disorder',
    pinyin: ['niè'],
    decomposition: '⿰阝里',
    etymology: {
      type: 'pictophonetic',
      phonetic: '里',
      semantic: '阝',
      hint: 'city',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '陨',
    definition: 'to slip, to fall; to drop; to die',
    pinyin: ['yǔn'],
    decomposition: '⿰阝员',
    etymology: {
      type: 'pictophonetic',
      phonetic: '员',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '险',
    definition: 'narrow pass, strategic point',
    pinyin: ['xiǎn'],
    decomposition: '⿰阝佥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '佥',
      semantic: '阝',
      hint: 'hill',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '陪',
    definition: 'to accompany, to be with, to keep company',
    pinyin: ['péi'],
    decomposition: '⿰阝咅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咅',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '陬',
    definition: 'corner, cranny, niche',
    pinyin: ['zōu'],
    decomposition: '⿰阝取',
    etymology: {
      type: 'pictophonetic',
      phonetic: '取',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '陰',
    definition: 'the female principle; dark, shaded; hidden, implicit, secret',
    pinyin: ['yīn'],
    decomposition: '⿰阝侌',
    etymology: {
      type: 'ideographic',
      hint: 'The shaded side of a hill 阝; 侌 provides the pronunciation',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '陲',
    definition: 'frontier, border',
    pinyin: ['chuí'],
    decomposition: '⿰阝垂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '垂',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '陳',
    definition: 'to display, to exhibit; to plead; surname',
    pinyin: ['chén'],
    decomposition: '⿰阝東',
    etymology: { type: 'ideographic', hint: 'To place 阝 facing east 東' },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '陴',
    definition: 'parapet; city wall',
    pinyin: ['pí'],
    decomposition: '⿰阝卑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卑',
      semantic: '阝',
      hint: 'city',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '陵',
    definition: 'hill, mound; mausoleum',
    pinyin: ['líng'],
    decomposition: '⿰阝夌',
    etymology: {
      type: 'ideographic',
      hint: 'A hill 阝 where people are laid to rest 夌; 夌 also provides the pronunciation',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '陶',
    definition: 'pottery, ceramics',
    pinyin: ['táo'],
    decomposition: '⿰阝匋',
    etymology: {
      type: 'ideographic',
      hint: 'A mound 阝 of clay 匋; 匋 also provides the pronunciation',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '陷',
    definition: 'to sink, to plunge; trap, pitfall',
    pinyin: ['xiàn'],
    decomposition: '⿰阝臽',
    etymology: {
      type: 'ideographic',
      hint: 'A place 阝 with a pit 臽; 臽 also provides the pronunciation',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '陸',
    definition: "land, continent; six (bankers' anti-fraud numeral)",
    pinyin: ['lù'],
    decomposition: '⿰阝坴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '坴',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '陽',
    definition: 'the male principle; bright, sunny; clear, lit, open',
    pinyin: ['yáng'],
    decomposition: '⿰阝昜',
    etymology: {
      type: 'ideographic',
      hint: 'The place 阝 of the sun 昜; compare 阴',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '隄',
    definition: 'dike, embankment',
    pinyin: ['dī'],
    decomposition: '⿰阝是',
    etymology: {
      type: 'pictophonetic',
      phonetic: '是',
      semantic: '阝',
      hint: 'hill',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '隅',
    definition: 'corner, cranny, niche',
    pinyin: ['yú'],
    decomposition: '⿰阝禺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '禺',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '隆',
    definition: 'prosperous, plentiful, abundant',
    pinyin: ['lóng'],
    decomposition: '⿰阝⿳夂一生',
    radical: '阝',
    matches: [
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 2],
      [1, 2],
      [1, 2],
      [1, 2],
      [1, 2],
    ],
  },
  {
    character: '隈',
    definition: 'bay, cove, inlet',
    pinyin: ['wēi'],
    decomposition: '⿰阝畏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畏',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '隉',
    definition: 'chaos, disorder',
    pinyin: ['niè'],
    decomposition: '⿰阝⿱臼工',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臼',
      semantic: '阝',
      hint: 'city',
    },
    radical: '阝',
    matches: [
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '隊',
    definition:
      'team, group, band, army unit; measure word for groups of people',
    pinyin: ['duì'],
    decomposition: '⿰阝㒸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㒸',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '隋',
    definition: 'the Sui dynasty; surname',
    pinyin: ['suí'],
    decomposition: '⿰阝⿱左⺼',
    radical: '阝',
    matches: [
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '隍',
    definition: 'dry ditch, dry moat',
    pinyin: ['huáng'],
    decomposition: '⿰阝皇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皇',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '階',
    definition: 'stairs, steps; degree, rank',
    pinyin: ['jiē'],
    decomposition: '⿰阝皆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皆',
      semantic: '阝',
      hint: 'hill',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '随',
    definition: 'to follow, to listen to, to submit to',
    pinyin: ['suí'],
    decomposition: '⿰阝迶',
    etymology: {
      type: 'ideographic',
      hint: 'To walk 迶 to the city 阝; to follow a path',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '隐',
    definition: 'to hide, to conceal; secret, hidden',
    pinyin: ['yǐn'],
    decomposition: '⿰阝急',
    etymology: {
      type: 'ideographic',
      hint: 'A place 阝 to hide when worried 急',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '隔',
    definition: 'to separate, to partition, to divide',
    pinyin: ['gé'],
    decomposition: '⿰阝鬲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鬲',
      semantic: '阝',
      hint: 'wall',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '隕',
    definition: 'to slip, to fall; to drop; to die',
    pinyin: ['yǔn'],
    decomposition: '⿰阝員',
    etymology: {
      type: 'pictophonetic',
      phonetic: '員',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '隗',
    definition: 'high, lofty; surname',
    pinyin: ['kuí'],
    decomposition: '⿰阝鬼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鬼',
      semantic: '阝',
      hint: 'hill',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '隘',
    definition: 'narrow, confined; a strategic pass',
    pinyin: ['ài'],
    decomposition: '⿰阝益',
    etymology: {
      type: 'pictophonetic',
      phonetic: '益',
      semantic: '阝',
      hint: 'hill',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '隙',
    definition: 'crack, fissure, split; grudge',
    pinyin: ['xì'],
    decomposition: '⿰阝⿱小⿱日小',
    etymology: {
      type: 'ideographic',
      hint: 'A crack 日 dividing two things 小; 阝 provides the pronunciation',
    },
    radical: '阝',
    matches: [
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
    ],
  },
  {
    character: '際',
    definition: 'border, boundary, juncture',
    pinyin: ['jì'],
    decomposition: '⿰阝祭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '祭',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '障',
    definition: 'to separate; shield, barricade',
    pinyin: ['zhàng'],
    decomposition: '⿰阝章',
    etymology: {
      type: 'pictophonetic',
      phonetic: '章',
      semantic: '阝',
      hint: 'wall',
    },
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '隡',
    pinyin: ['sa'],
    decomposition: '⿰阝産',
    radical: '阝',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '隧',
    definition: 'tunnel, underground passage; a path to a tomb',
    pinyin: ['suì'],
    decomposition: '⿰阝遂',
    etymology: {
      type: 'pictophonetic',
      phonetic: '遂',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '隨',
    definition: 'to follow, to listen to, to submit to',
    pinyin: ['suí'],
    decomposition: '⿰阝遀',
    etymology: {
      type: 'ideographic',
      hint: 'To walk 遀 to the city 阝; to follow a path',
    },
    radical: '阝',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '險',
    definition: 'narrow pass, strategic point',
    pinyin: ['xiǎn'],
    decomposition: '⿰阝僉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '僉',
      semantic: '阝',
      hint: 'hill',
    },
    radical: '阝',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '隰',
    definition: 'swamp, marsh, damp lowland',
    pinyin: ['xí'],
    decomposition: '⿰阝㬎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㬎',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '隱',
    definition: 'to hide, to conceal; secret, hidden',
    pinyin: ['yǐn'],
    decomposition: '⿰阝㥯',
    etymology: {
      type: 'ideographic',
      hint: 'A place 阝 to hide when worried 㥯',
    },
    radical: '阝',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '隳',
    definition: 'to destroy; to overthrow',
    pinyin: ['huī'],
    decomposition: '⿱隋⿱人⺗',
    etymology: { type: 'pictophonetic', phonetic: '隋' },
    radical: '阝',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '隴',
    definition: 'a mountain located in the Shanxi provice',
    pinyin: ['lǒng'],
    decomposition: '⿰阝龍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龍',
      semantic: '阝',
      hint: 'place',
    },
    radical: '阝',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '隶',
    definition: 'subservient; servant',
    pinyin: ['lì'],
    decomposition: '⿱彐氺',
    etymology: { type: 'ideographic', hint: 'A hand 彐 threshing rice' },
    radical: '隶',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '隸',
    definition: 'subservient; servant',
    pinyin: ['lì'],
    decomposition: '⿰柰隶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隶',
      semantic: '柰',
      hint: 'bear',
    },
    radical: '隶',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '隹',
    definition: 'short-tailed bird; sparrow',
    pinyin: ['zhuī'],
    decomposition: '⿰亻？',
    etymology: { type: 'pictographic', hint: 'A bird facing left; compare 鳥' },
    radical: '隹',
    matches: [[0], [0], null, null, null, null, null, null],
  },
  {
    character: '隺',
    definition: 'flying high; ambition',
    pinyin: ['hú'],
    decomposition: '⿱冖隹',
    etymology: {
      type: 'ideographic',
      hint: 'A bird 隹 flying close to the ceiling 冖',
    },
    radical: '隹',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '隻',
    definition: 'only, merely, just',
    pinyin: ['zhī'],
    decomposition: '⿱隹又',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隹',
      semantic: '又',
      hint: 'again',
    },
    radical: '隹',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '隼',
    definition: 'falcon, eagle; an aquiline nose',
    pinyin: ['sǔn'],
    decomposition: '⿱隹十',
    etymology: {
      type: 'pictophonetic',
      phonetic: '十',
      semantic: '隹',
      hint: 'bird',
    },
    radical: '隹',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '隽',
    definition: 'superior, outstanding, talented',
    pinyin: ['juàn'],
    decomposition: '⿱隹乃',
    etymology: {
      type: 'ideographic',
      hint: 'Someone aiming a bow 乃 at a small bird 隹',
    },
    radical: '隹',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '难',
    definition: 'hard, difficult, arduous; unable',
    pinyin: ['nán'],
    decomposition: '⿰又隹',
    etymology: {
      type: 'ideographic',
      hint: 'A hand 又 trying to grasp at a bird 隹',
    },
    radical: '又',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '雀',
    definition: 'sparrow',
    pinyin: ['què'],
    decomposition: '⿱小隹',
    etymology: { type: 'ideographic', hint: 'A small 小 bird 隹' },
    radical: '隹',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '雁',
    definition: 'wild goose',
    pinyin: ['yàn'],
    decomposition: '⿸厂倠',
    etymology: { type: 'pictophonetic', semantic: '隹', hint: 'bird' },
    radical: '隹',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '雄',
    definition: 'alpha male, hero; manly',
    pinyin: ['xióng'],
    decomposition: '⿰厷隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厷',
      semantic: '隹',
      hint: 'bird',
    },
    radical: '隹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '雅',
    definition: 'elegant, graceful, refined',
    pinyin: ['yǎ'],
    decomposition: '⿰牙隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '牙',
      semantic: '隹',
      hint: 'bird',
    },
    radical: '隹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '集',
    definition: 'to gather, to collect; set, collection',
    pinyin: ['jí'],
    decomposition: '⿱隹木',
    etymology: { type: 'ideographic', hint: 'Birds 隹 flocking on a tree 木' },
    radical: '隹',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '雇',
    definition: 'employment; to hire, to employ',
    pinyin: ['gù'],
    decomposition: '⿸户隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '户',
      semantic: '隹',
      hint: 'bird',
    },
    radical: '隹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '雈',
    definition: 'owl',
    pinyin: ['huán'],
    decomposition: '⿱艹隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '艹',
      semantic: '隹',
      hint: 'bird',
    },
    radical: '隹',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '雉',
    definition: 'pheasant; crenellated wall',
    pinyin: ['zhì'],
    decomposition: '⿰矢隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '矢',
      semantic: '隹',
      hint: 'bird',
    },
    radical: '隹',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '雋',
    definition: 'superior, outstanding, talented',
    pinyin: ['juàn'],
    decomposition: '⿱隹弓',
    etymology: {
      type: 'ideographic',
      hint: 'Someone aiming a bow 弓 at a small bird 隹',
    },
    radical: '隹',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '雌',
    definition: 'female; feminine; gentle, soft',
    pinyin: ['cí'],
    decomposition: '⿰此隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '此',
      semantic: '隹',
      hint: 'bird',
    },
    radical: '隹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '雍',
    definition: 'harmony, union; harmonious',
    pinyin: ['yōng'],
    decomposition: '⿱亠⿰乡隹',
    etymology: {
      type: 'ideographic',
      hint: 'Birds 乡 living together in a village 乡',
    },
    radical: '隹',
    matches: [
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '雎',
    definition: 'osprey, fish hawk; to hold back',
    pinyin: ['jū'],
    decomposition: '⿰且隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '且',
      semantic: '隹',
      hint: 'bird',
    },
    radical: '隹',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '雏',
    definition: 'chick, fledging; infant, toddler',
    pinyin: ['chú'],
    decomposition: '⿰刍隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '刍',
      semantic: '隹',
      hint: 'bird',
    },
    radical: '隹',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '雐',
    definition: 'a kind of bird',
    pinyin: ['hū'],
    decomposition: '⿸虍隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '虍',
      semantic: '隹',
      hint: 'bird',
    },
    radical: '虍',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '雒',
    definition: 'fearful; a black horse with a white mane',
    pinyin: ['luò'],
    decomposition: '⿰各隹',
    radical: '隹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '雔',
    definition: 'companion; couple; to match',
    pinyin: ['chóu'],
    decomposition: '⿰隹隹',
    etymology: { type: 'ideographic', hint: 'A pair 隹 of lovebirds' },
    radical: '隹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '雕',
    definition: 'to carve, to engrave; eagle, vulture',
    pinyin: ['diāo'],
    decomposition: '⿰周隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '周',
      semantic: '隹',
      hint: 'bird',
    },
    radical: '隹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '雖',
    definition: 'although, even though',
    pinyin: ['suī'],
    decomposition: '⿰虽隹',
    etymology: { type: 'pictophonetic', phonetic: '隹' },
    radical: '隹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '雙',
    definition:
      'pair, couple; both; measure word for things that come in pairs',
    pinyin: ['shuāng'],
    decomposition: '⿱雔又',
    etymology: {
      type: 'ideographic',
      hint: 'A pair of lovebirds 雔 perched on a branch 又',
    },
    radical: '隹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '雚',
    definition: 'heron; small cup',
    pinyin: ['guàn'],
    decomposition: '⿳艹？隹',
    etymology: { type: 'pictophonetic', semantic: '隹', hint: 'bird' },
    radical: '隹',
    matches: [
      [0],
      [0],
      [0],
      null,
      null,
      null,
      null,
      null,
      null,
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '雛',
    definition: 'chick, fledging; infant, toddler',
    pinyin: ['chú'],
    decomposition: '⿰芻隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '芻',
      semantic: '隹',
      hint: 'bird',
    },
    radical: '隹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '雜',
    definition: 'mix, blend; various, miscellaneous',
    pinyin: ['zá'],
    decomposition: '⿰⿳亠从木隹',
    etymology: { type: 'pictophonetic', phonetic: '隹' },
    radical: '隹',
    matches: [
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 2],
      [0, 2],
      [0, 2],
      [0, 2],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '雝',
    definition: 'pool, marsh; harmony',
    pinyin: ['yōng'],
    decomposition: '⿰邕隹',
    etymology: { type: 'pictophonetic', phonetic: '邕' },
    radical: '隹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '雞',
    definition: 'chicken',
    pinyin: ['jī'],
    decomposition: '⿰奚隹',
    etymology: { type: 'ideographic', hint: 'Another 奚 kind of bird 隹' },
    radical: '隹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '雠',
    definition: 'enemy, rival, opponent',
    pinyin: ['chóu'],
    decomposition: '⿻雔讠',
    etymology: {
      type: 'ideographic',
      hint: 'Two birds 隹 exchanging angry words 讠; 雔 provides the pronunciation',
    },
    radical: '隹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '離',
    definition: 'rare beast; strange; elegant',
    pinyin: ['lí'],
    decomposition: '⿰离隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '离',
      semantic: '隹',
      hint: 'bird',
    },
    radical: '隹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '難',
    definition: 'hard, difficult, arduous; unable',
    pinyin: ['nán'],
    decomposition: '⿰堇隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堇',
      semantic: '隹',
      hint: 'bird',
    },
    radical: '隹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '雨',
    definition: 'rain',
    pinyin: ['yǔ'],
    decomposition: '⿻帀？',
    etymology: {
      type: 'pictographic',
      hint: 'Rain drops falling from a cloud 帀',
    },
    radical: '雨',
    matches: [[0], [0], [0], [0], null, null, null, null],
  },
  {
    character: '雩',
    definition: 'to offer a sacrifice for rain',
    pinyin: ['yú'],
    decomposition: '⿱雨亏',
    etymology: {
      type: 'ideographic',
      hint: 'To sacrifice 亏 for rain 雨; 雨 also provides the pronunciation',
    },
    radical: '雨',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '雪',
    definition: 'snow; wipe away shame, avenge',
    pinyin: ['xuě'],
    decomposition: '⿱雨彐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彐',
      semantic: '雨',
      hint: 'rain',
    },
    radical: '雨',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '雯',
    definition: 'cloud patterns; storm clouds',
    pinyin: ['wén'],
    decomposition: '⿱雨文',
    etymology: {
      type: 'pictophonetic',
      phonetic: '文',
      semantic: '雨',
      hint: 'rain',
    },
    radical: '雨',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '雲',
    definition: 'cloud; to say, to speak',
    pinyin: ['yún'],
    decomposition: '⿱雨云',
    etymology: { type: 'ideographic', hint: 'Rain 雨 falling from a cloud 云' },
    radical: '雨',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '雳',
    definition: 'thunderclap, crashing thunder',
    pinyin: ['lì'],
    decomposition: '⿱雨历',
    etymology: {
      type: 'pictophonetic',
      phonetic: '历',
      semantic: '雨',
      hint: 'rain',
    },
    radical: '雨',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '零',
    definition: 'zero; fragment, fraction',
    pinyin: ['líng'],
    decomposition: '⿱雨令',
    etymology: {
      type: 'pictophonetic',
      phonetic: '令',
      semantic: '雨',
      hint: 'raindrop',
    },
    radical: '雨',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '雷',
    definition: 'thunder; surname',
    pinyin: ['léi'],
    decomposition: '⿱雨田',
    etymology: { type: 'ideographic', hint: 'A storm 雨 over the fields 田' },
    radical: '雨',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '雹',
    definition: 'hail',
    pinyin: ['báo'],
    decomposition: '⿱雨包',
    etymology: {
      type: 'pictophonetic',
      phonetic: '包',
      semantic: '雨',
      hint: 'rain',
    },
    radical: '雨',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '電',
    definition: 'electricity; electric; lightning',
    pinyin: ['diàn'],
    decomposition: '⿱雨电',
    etymology: {
      type: 'ideographic',
      hint: 'A thunderbolt 电 cast by a storm cloud 雨',
    },
    radical: '雨',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '雾',
    definition: 'fog, mist, vapor, fine spray',
    pinyin: ['wù'],
    decomposition: '⿱雨务',
    etymology: {
      type: 'pictophonetic',
      phonetic: '务',
      semantic: '雨',
      hint: 'rain',
    },
    radical: '雨',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '需',
    definition: 'to need, to require; must',
    pinyin: ['xū'],
    decomposition: '⿱雨而',
    etymology: {
      type: 'ideographic',
      hint: 'Rain 雨 needed for crops to grow',
    },
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '霁',
    definition: 'to subside; to clear up after a storm; to stop being angry',
    pinyin: ['jì'],
    decomposition: '⿱雨齐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '齐',
      semantic: '雨',
      hint: 'rain',
    },
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '霂',
    definition: 'drizzle, shower, light rain',
    pinyin: ['mù'],
    decomposition: '⿱雨沐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '沐',
      semantic: '雨',
      hint: 'rain',
    },
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '霄',
    definition: 'clouds, mist; sky',
    pinyin: ['xiāo'],
    decomposition: '⿱雨肖',
    etymology: {
      type: 'ideographic',
      hint: 'To look like 肖 rain 雨; 肖 also provides the pronunciation',
    },
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '霅',
    definition: 'thunder',
    pinyin: ['zhà'],
    decomposition: '⿱雨言',
    etymology: { type: 'ideographic', hint: 'The sound 言 of a storm 雨' },
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '霆',
    definition: 'a sudden peal of thunder',
    pinyin: ['tíng'],
    decomposition: '⿱雨廷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '廷',
      semantic: '雨',
      hint: 'rain',
    },
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '震',
    definition: 'shake, quake, tremor; to excite',
    pinyin: ['zhèn'],
    decomposition: '⿱雨辰',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辰',
      semantic: '雨',
      hint: 'rain',
    },
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '霈',
    definition: 'torrential rains; the flow of water',
    pinyin: ['pèi'],
    decomposition: '⿱雨沛',
    etymology: {
      type: 'ideographic',
      hint: 'Rain 雨 causing a flood 沛; 沛 also provides the pronunciation',
    },
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '霉',
    definition: 'mildew, mold, rot',
    pinyin: ['méi'],
    decomposition: '⿱雨每',
    etymology: {
      type: 'pictophonetic',
      phonetic: '每',
      semantic: '雨',
      hint: 'rain',
    },
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '霍',
    definition: 'quickly, suddenly; surname',
    pinyin: ['huò'],
    decomposition: '⿱雨隹',
    etymology: {
      type: 'ideographic',
      hint: 'Birds 隹 caught in a sudden storm 雨',
    },
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '霎',
    definition: 'drizzle, light rain; fleeting, passing',
    pinyin: ['shà'],
    decomposition: '⿱雨妾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '妾',
      semantic: '雨',
      hint: 'rain',
    },
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '霏',
    definition: 'rainfall, snowfall',
    pinyin: ['fēi'],
    decomposition: '⿱雨非',
    etymology: {
      type: 'pictophonetic',
      phonetic: '非',
      semantic: '雨',
      hint: 'rain',
    },
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '霑',
    definition: 'moist, soaked; to moisten',
    pinyin: ['zhān'],
    decomposition: '⿱雨沾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '沾',
      semantic: '雨',
      hint: 'rain',
    },
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '霓',
    definition: 'rainbow; colorful, variegated',
    pinyin: ['ní'],
    decomposition: '⿱雨兒',
    etymology: { type: 'ideographic', hint: 'The child 兒 of a rain cloud 雨' },
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '霖',
    definition: 'monsoon; a long spell of rain',
    pinyin: ['lín'],
    decomposition: '⿱雨林',
    etymology: {
      type: 'pictophonetic',
      phonetic: '林',
      semantic: '雨',
      hint: 'rain',
    },
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '霜',
    definition: 'frost; frozen, crystallized, candied',
    pinyin: ['shuāng'],
    decomposition: '⿱雨相',
    etymology: {
      type: 'pictophonetic',
      phonetic: '相',
      semantic: '雨',
      hint: 'rain',
    },
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '霝',
    definition: 'raindrops',
    pinyin: ['líng'],
    decomposition: '⿱雨⿲口口口',
    etymology: { type: 'ideographic', hint: 'Falling rain 雨 drops 口' },
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 2],
      [1, 2],
      [1, 2],
    ],
  },
  {
    character: '霞',
    definition: 'rosy clouds',
    pinyin: ['xiá'],
    decomposition: '⿱雨叚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叚',
      semantic: '雨',
      hint: 'rain',
    },
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '霡',
    definition: 'drizzle, light rain; favors, gifts',
    pinyin: ['mài'],
    decomposition: '⿱雨脉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '脉',
      semantic: '雨',
      hint: 'rain',
    },
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '霢',
    definition: 'drizzle, light rain; favors, gifts',
    pinyin: ['mài'],
    decomposition: '⿱雨脈',
    etymology: {
      type: 'pictophonetic',
      phonetic: '脈',
      semantic: '雨',
      hint: 'rain',
    },
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '霧',
    definition: 'fog, mist, vapor, fine spray',
    pinyin: ['wù'],
    decomposition: '⿱雨務',
    etymology: {
      type: 'pictophonetic',
      phonetic: '務',
      semantic: '雨',
      hint: 'rain',
    },
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '霪',
    definition: 'monsoon; a long and heavy rain',
    pinyin: ['yín'],
    decomposition: '⿱雨淫',
    etymology: {
      type: 'ideographic',
      hint: 'An obscene 淫 amount of rain 雨; 淫 also provides the pronunciation',
    },
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '霭',
    definition: 'fog, haze; calm, peaceful',
    pinyin: ['ǎi'],
    decomposition: '⿱雨谒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '谒',
      semantic: '雨',
      hint: 'rain',
    },
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '霰',
    definition: 'hail, sleet',
    pinyin: ['sǎn'],
    decomposition: '⿱雨散',
    etymology: {
      type: 'pictophonetic',
      phonetic: '散',
      semantic: '雨',
      hint: 'rain',
    },
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '露',
    definition: 'dew; leak; bare, exposed; to reveal, to show',
    pinyin: ['lù'],
    decomposition: '⿱雨路',
    etymology: {
      type: 'pictophonetic',
      phonetic: '路',
      semantic: '雨',
      hint: 'rain',
    },
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '霸',
    definition: 'tyrant; to usurp, to rule by might',
    pinyin: ['bà'],
    decomposition: '⿱雨⿰革月',
    etymology: { type: 'pictophonetic', semantic: '雨', hint: 'rain' },
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '霹',
    definition: 'thunderclap, crashing thunder',
    pinyin: ['pī'],
    decomposition: '⿱雨辟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辟',
      semantic: '雨',
      hint: 'rain',
    },
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '霽',
    definition: 'to subside; to clear up after a storm; to stop being angry',
    pinyin: ['jì'],
    decomposition: '⿱雨齊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '齊',
      semantic: '雨',
      hint: 'rain',
    },
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '霾',
    definition: 'fog, mist; smoke, smog; dust storm',
    pinyin: ['mái'],
    decomposition: '⿱雨貍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '貍',
      semantic: '雨',
      hint: 'rain',
    },
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '靈',
    definition: 'spirit, soul; spiritual world',
    pinyin: ['líng'],
    decomposition: '⿳雨⿲口口口巫',
    radical: '雨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 2],
      [1, 2],
      [1, 2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '靑',
    definition: 'blue',
    pinyin: ['qīng'],
    decomposition: '⿱龶円',
    radical: '靑',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '青',
    definition: "nature's color; blue, green, black; young",
    pinyin: ['qīng'],
    decomposition: '⿱龶月',
    radical: '青',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '靓',
    definition: 'ornament; pretty; to apply make-up',
    pinyin: ['jìng'],
    decomposition: '⿰青见',
    etymology: {
      type: 'pictophonetic',
      phonetic: '青',
      semantic: '见',
      hint: 'appear',
    },
    radical: '青',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '靖',
    definition: 'to pacify, to appease; calm, peaceful',
    pinyin: ['jìng'],
    decomposition: '⿰立青',
    etymology: {
      type: 'ideographic',
      hint: 'As peaceful 立 as nature 青; 青 also provides the pronunciation',
    },
    radical: '青',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '静',
    definition: 'still, quiet, motionless, gentle',
    pinyin: ['jìng'],
    decomposition: '⿰青争',
    etymology: {
      type: 'pictophonetic',
      phonetic: '争',
      semantic: '青',
      hint: 'nature',
    },
    radical: '青',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '靛',
    definition: 'indigo, blue dye',
    pinyin: ['diàn'],
    decomposition: '⿰青定',
    etymology: {
      type: 'pictophonetic',
      phonetic: '定',
      semantic: '青',
      hint: 'blue',
    },
    radical: '青',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '靜',
    definition: 'still, quiet, motionless, gentle',
    pinyin: ['jìng'],
    decomposition: '⿰青爭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爭',
      semantic: '青',
      hint: 'nature',
    },
    radical: '青',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '非',
    definition: 'not, negative, non-; to oppose',
    pinyin: ['fēi'],
    decomposition: '⿰？？',
    etymology: {
      type: 'ideographic',
      hint: "Two bird's wings opposed; two people back-to-back",
    },
    radical: '非',
    matches: [null, null, null, null, null, null, null, null],
  },
  {
    character: '靠',
    definition: 'nearby; to depend on, to lean on, to trust',
    pinyin: ['kào'],
    decomposition: '⿱告非',
    etymology: {
      type: 'pictophonetic',
      phonetic: '告',
      semantic: '非',
      hint: 'people back-to-back',
    },
    radical: '非',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '靡',
    definition: 'to scatter, to disperse; to divide',
    pinyin: ['mí'],
    decomposition: '⿸麻非',
    etymology: {
      type: 'pictophonetic',
      phonetic: '麻',
      semantic: '非',
      hint: 'wrong',
    },
    radical: '非',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '面',
    definition: 'face; surface, side; plane, dimension',
    pinyin: ['miàn'],
    decomposition: '⿱？？',
    etymology: { type: 'pictographic', hint: "A person's face" },
    radical: '面',
    matches: [null, null, null, null, null, null, null, null, null],
  },
  {
    character: '靥',
    definition: 'dimples',
    pinyin: ['yè'],
    decomposition: '⿸厌面',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厌',
      semantic: '面',
      hint: 'face',
    },
    radical: '厂',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '革',
    definition: 'leather, animal hide; to reform; to remove',
    pinyin: ['gé'],
    decomposition: '⿱廿？',
    etymology: { type: 'pictographic', hint: 'An animal being skinned' },
    radical: '革',
    matches: [[0], [0], [0], [0], null, null, null, null, null],
  },
  {
    character: '靳',
    definition: "a strap on a horse's breast",
    pinyin: ['jìn'],
    decomposition: '⿰革斤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斤',
      semantic: '革',
      hint: 'leather',
    },
    radical: '革',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '靴',
    definition: 'boots',
    pinyin: ['xuē'],
    decomposition: '⿰革化',
    etymology: {
      type: 'pictophonetic',
      phonetic: '化',
      semantic: '革',
      hint: 'leather',
    },
    radical: '革',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '靶',
    definition: 'target, mark',
    pinyin: ['bǎ'],
    decomposition: '⿰革巴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巴',
      semantic: '革',
      hint: 'leather',
    },
    radical: '革',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '靼',
    definition: 'the Tartars',
    pinyin: ['dá'],
    decomposition: '⿰革旦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旦',
      semantic: '革',
      hint: 'leather',
    },
    radical: '革',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鞅',
    definition: "the strap over a horse's neck",
    pinyin: ['yāng'],
    decomposition: '⿰革央',
    etymology: {
      type: 'pictophonetic',
      phonetic: '央',
      semantic: '革',
      hint: 'leather',
    },
    radical: '革',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鞋',
    definition: 'shoes, footwear in general',
    pinyin: ['xié'],
    decomposition: '⿰革圭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '圭',
      semantic: '革',
      hint: 'leather',
    },
    radical: '革',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鞍',
    definition: 'saddle',
    pinyin: ['ān'],
    decomposition: '⿰革安',
    etymology: {
      type: 'pictophonetic',
      phonetic: '安',
      semantic: '革',
      hint: 'leather',
    },
    radical: '革',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鞏',
    definition: 'to bind, to guard, to strengthen; firm, secure, strong',
    pinyin: ['gǒng'],
    decomposition: '⿱巩革',
    etymology: {
      type: 'ideographic',
      hint: 'Leather 革 bindings 巩; 巩 also provides the pronunciation',
    },
    radical: '革',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鞑',
    definition: 'the Tartars',
    pinyin: ['dá'],
    decomposition: '⿰革达',
    etymology: {
      type: 'pictophonetic',
      phonetic: '达',
      semantic: '革',
      hint: 'leather',
    },
    radical: '革',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鞒',
    definition: 'boot, mud shoe, snowshoe',
    pinyin: ['qiáo'],
    decomposition: '⿰革乔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乔',
      semantic: '革',
      hint: 'leather',
    },
    radical: '革',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鞔',
    definition: 'to cover; leather stretched over a drum',
    pinyin: ['mán'],
    decomposition: '⿰革免',
    etymology: {
      type: 'pictophonetic',
      phonetic: '免',
      semantic: '革',
      hint: 'leather',
    },
    radical: '革',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鞘',
    definition: 'scabbard, sheath',
    pinyin: ['qiào'],
    decomposition: '⿰革肖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肖',
      semantic: '革',
      hint: 'leather',
    },
    radical: '革',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鞠',
    definition: 'to bow, to bend; to nourish, to rear',
    pinyin: ['jū'],
    decomposition: '⿰革匊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匊',
      semantic: '革',
      hint: 'leather',
    },
    radical: '革',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鞣',
    definition: 'to tan, to soften',
    pinyin: ['róu'],
    decomposition: '⿰革柔',
    etymology: {
      type: 'ideographic',
      hint: 'To soften 柔 leather 革; 柔 also provides the pronunciation',
    },
    radical: '革',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鞦',
    definition: 'leather strap; to swing',
    pinyin: ['qiū'],
    decomposition: '⿰革秋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '秋',
      semantic: '革',
      hint: 'leather',
    },
    radical: '革',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鞫',
    definition: 'to question, to interrogate',
    pinyin: ['jū'],
    decomposition: '⿰革訇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '革',
      semantic: '訇',
      hint: 'crash',
    },
    radical: '革',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鞭',
    definition: 'whip; to lash, to flog',
    pinyin: ['biān'],
    decomposition: '⿰革便',
    etymology: { type: 'pictophonetic', phonetic: '便', semantic: '革' },
    radical: '革',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鞮',
    definition: 'leather shoes',
    pinyin: ['dī'],
    decomposition: '⿰革是',
    etymology: {
      type: 'pictophonetic',
      phonetic: '是',
      semantic: '革',
      hint: 'leather',
    },
    radical: '革',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鞯',
    definition: 'saddle blanket',
    pinyin: ['jiān'],
    decomposition: '⿰革荐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '荐',
      semantic: '革',
      hint: 'leather',
    },
    radical: '革',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鞲',
    definition: 'leather bracer',
    pinyin: ['gōu'],
    decomposition: '⿰革冓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冓',
      semantic: '革',
      hint: 'leather',
    },
    radical: '革',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鞴',
    definition: 'to saddle up, to ride',
    pinyin: ['bèi'],
    decomposition: '⿰革？',
    radical: '革',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    ],
  },
  {
    character: '韃',
    definition: 'the Tartars',
    pinyin: ['dá'],
    decomposition: '⿰革達',
    etymology: {
      type: 'pictophonetic',
      phonetic: '達',
      semantic: '革',
      hint: 'leather',
    },
    radical: '革',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '韆',
    definition: 'thousand, many, numerous; swing, seesaw',
    pinyin: ['qiān'],
    decomposition: '⿰革遷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '遷',
      semantic: '革',
      hint: 'leather',
    },
    radical: '革',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      null,
    ],
  },
  {
    character: '韋',
    definition: 'tanned leather; surname',
    pinyin: ['wéi'],
    decomposition: '⿻？口',
    radical: '韋',
    matches: [null, null, null, [1], [1], [1], null, null, null],
  },
  {
    character: '韌',
    definition: 'tough, strong; pliable',
    pinyin: ['rèn'],
    decomposition: '⿰韋刃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '刃',
      semantic: '韋',
      hint: 'leather',
    },
    radical: '韋',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '韓',
    definition: 'Korea, especially South Korea; surname',
    pinyin: ['hán'],
    decomposition: '⿰龺韋',
    radical: '韋',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '韙',
    definition: 'right; proper; perpriety',
    pinyin: ['wěi'],
    decomposition: '⿺是韋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韋',
      semantic: '是',
      hint: 'right',
    },
    radical: '韋',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '韜',
    definition: 'sheath, scabbard, bow case',
    pinyin: ['tāo'],
    decomposition: '⿰韋舀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '舀',
      semantic: '韋',
      hint: 'leather',
    },
    radical: '韋',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '韦',
    definition: 'tanned leather; surname',
    pinyin: ['wéi'],
    decomposition: '⿻三丨',
    radical: '韦',
    matches: [[0], [0], [0], [1]],
  },
  {
    character: '韧',
    definition: 'tough, strong; pliable',
    pinyin: ['rèn'],
    decomposition: '⿰韦刃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '刃',
      semantic: '韦',
      hint: 'leather',
    },
    radical: '韦',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '韩',
    definition: 'Korea, especially South Korea; surname',
    pinyin: ['hán'],
    decomposition: '⿰龺韦',
    radical: '韦',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '韪',
    definition: 'right; proper; perpriety',
    pinyin: ['wěi'],
    decomposition: '⿺是韦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '韦',
      semantic: '是',
      hint: 'right',
    },
    radical: '韦',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '韫',
    definition: 'to contain; to hide, to conceal',
    pinyin: ['yùn'],
    decomposition: '⿰韦昷',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昷',
      semantic: '韦',
      hint: 'leather',
    },
    radical: '韦',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '韬',
    definition: 'sheath, scabbard, bow case',
    pinyin: ['tāo'],
    decomposition: '⿰韦舀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '舀',
      semantic: '韦',
      hint: 'leather',
    },
    radical: '韦',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '韭',
    definition: 'scallion, leek, chive',
    pinyin: ['jiǔ'],
    decomposition: '⿱非一',
    etymology: {
      type: 'pictographic',
      hint: 'Chives 非 growing in the ground 一',
    },
    radical: '韭',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1]],
  },
  {
    character: '韰',
    pinyin: ['xiè'],
    decomposition: '⿱⿰歺又韭',
    etymology: { type: 'pictophonetic', phonetic: '韭' },
    radical: '韭',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '韱',
    definition: 'wild onions or leeks',
    pinyin: ['xiān'],
    decomposition: '⿱从⿹戈韭',
    etymology: { type: 'ideographic', hint: 'Harvesting 戈 scallions 韭' },
    radical: '韭',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 0],
      [1, 0],
      [1, 0],
    ],
  },
  {
    character: '音',
    definition: 'sound, tone, pitch, pronunciation',
    pinyin: ['yīn'],
    decomposition: '⿱立日',
    etymology: {
      type: 'ideographic',
      hint: 'A tongue 立 forming a sound in the mouth 日',
    },
    radical: '音',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '韵',
    definition: 'rhyme; vowel',
    pinyin: ['yùn'],
    decomposition: '⿰音匀',
    etymology: {
      type: 'ideographic',
      hint: 'Of equal 匀 tone 音; 匀 also provides the pronunciation',
    },
    radical: '音',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '韶',
    definition: 'beautiful, excellent, harmonious; music from the Shun dynasty',
    pinyin: ['sháo'],
    decomposition: '⿰音召',
    etymology: {
      type: 'ideographic',
      hint: 'Imperial 召 music 音; 召 also provides the pronunciation',
    },
    radical: '音',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '韻',
    definition: 'rhyme; vowel',
    pinyin: ['yùn'],
    decomposition: '⿰音員',
    etymology: {
      type: 'ideographic',
      hint: 'Of equal 員 tone 音; 員 also provides the pronunciation',
    },
    radical: '音',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '響',
    definition: 'to make noise, to make sound; sound',
    pinyin: ['xiǎng'],
    decomposition: '⿱鄉音',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鄉',
      semantic: '音',
      hint: 'sound',
    },
    radical: '音',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '頁',
    definition: 'page, sheet, leaf',
    pinyin: ['yè'],
    decomposition: '⿱？貝',
    etymology: { type: 'pictographic', hint: "A person's head" },
    radical: '頁',
    matches: [null, null, [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '頂',
    definition: 'top, summit, peak; to carry on the head',
    pinyin: ['dǐng'],
    decomposition: '⿰丁頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丁',
      semantic: '頁',
      hint: 'head',
    },
    radical: '頁',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '頃',
    definition: 'a moment; a unit of area equal to 100 mu',
    pinyin: ['qǐng'],
    decomposition: '⿰匕頁',
    radical: '頁',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '項',
    definition: 'neck, nape; item; a term in an equation',
    pinyin: ['xiàng'],
    decomposition: '⿰工頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '工',
      semantic: '頁',
      hint: 'head',
    },
    radical: '頁',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '順',
    definition: 'to submit to, to obey, to go along with',
    pinyin: ['shùn'],
    decomposition: '⿰川頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '川',
      semantic: '頁',
      hint: 'head',
    },
    radical: '頁',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '須',
    definition: 'beard; must; necessary',
    pinyin: ['xū'],
    decomposition: '⿰彡頁',
    etymology: { type: 'ideographic', hint: 'Hair 彡 growing on the face 頁' },
    radical: '頁',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '頊',
    definition: 'anxious, grieving',
    pinyin: ['xū'],
    decomposition: '⿰王頁',
    radical: '頁',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '頌',
    definition: 'to laud, to acclaim; ode, hymn',
    pinyin: ['sòng'],
    decomposition: '⿰公頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '公',
      semantic: '頁',
      hint: 'page',
    },
    radical: '頁',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '預',
    definition: 'to prepare, to arrange; in advance',
    pinyin: ['yù'],
    decomposition: '⿰予頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '予',
      semantic: '頁',
      hint: 'page',
    },
    radical: '頁',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '頑',
    definition: 'stubborn, recalcitrant, obstinate',
    pinyin: ['wán'],
    decomposition: '⿰元頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '元',
      semantic: '頁',
      hint: 'head',
    },
    radical: '頁',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '頒',
    definition: 'to bestow, to confer; to publish',
    pinyin: ['bān'],
    decomposition: '⿰分頁',
    etymology: {
      type: 'ideographic',
      hint: 'To pass out 分 a booklet 頁; 分 also provides the pronunciation',
    },
    radical: '頁',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '頓',
    definition: 'to pause; to bow; to arrange',
    pinyin: ['dùn'],
    decomposition: '⿰屯頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屯',
      semantic: '頁',
      hint: 'head',
    },
    radical: '頁',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '頗',
    definition: 'rather, quite; partial, biased',
    pinyin: ['pō'],
    decomposition: '⿰皮頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皮',
      semantic: '頁',
      hint: 'leaf',
    },
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '領',
    definition: 'neck, collar; lead, guide',
    pinyin: ['lǐng'],
    decomposition: '⿰令頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '令',
      semantic: '頁',
      hint: 'head',
    },
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '頜',
    definition: 'mouth; jaw',
    pinyin: ['hé'],
    decomposition: '⿰合頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '合',
      semantic: '頁',
      hint: 'head',
    },
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '頡',
    definition: 'contest; to fly, to soar',
    pinyin: ['jié'],
    decomposition: '⿰吉頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吉',
      semantic: '頁',
      hint: 'leaf',
    },
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '頤',
    definition: 'cheeks, jaw; chin; rear; to nourish',
    pinyin: ['yí'],
    decomposition: '⿰臣頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臣',
      semantic: '頁',
      hint: 'head',
    },
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '頦',
    definition: 'chin',
    pinyin: ['kē'],
    decomposition: '⿰亥頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亥',
      semantic: '頁',
      hint: 'head',
    },
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '頭',
    definition: 'head; chief, boss; first, top',
    pinyin: ['tóu'],
    decomposition: '⿰豆頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豆',
      semantic: '頁',
      hint: 'head',
    },
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '頰',
    definition: 'cheeks, jaw',
    pinyin: ['jiá'],
    decomposition: '⿰夾頁',
    etymology: {
      type: 'ideographic',
      hint: 'The jaw in 夾 the head 頁; 夾 also provides the pronunciation',
    },
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '頷',
    definition: 'chin, jowl; to nod',
    pinyin: ['hàn'],
    decomposition: '⿰含頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '含',
      semantic: '頁',
      hint: 'head',
    },
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '頸',
    definition: 'neck, throat',
    pinyin: ['jǐng'],
    decomposition: '⿰巠頁',
    etymology: {
      type: 'pictophonetic',
      semantic: '頁',
      hint: 'head',
      phonetic: '巠',
    },
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '頹',
    definition: 'ruined, decayed; depressed; decadent',
    pinyin: ['tuí'],
    decomposition: '⿰禿頁',
    etymology: {
      type: 'ideographic',
      hint: 'A bald 禿 head 頁; 禿 also provides the pronunciation',
    },
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '頻',
    definition: 'frequency; repeatedly, again and again',
    pinyin: ['pín'],
    decomposition: '⿰步頁',
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '顆',
    definition: 'grain, kernel',
    pinyin: ['kē'],
    decomposition: '⿰果頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '頁',
      semantic: '果',
      hint: 'grain',
    },
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '題',
    definition: 'forehead; headline, title; theme',
    pinyin: ['tí'],
    decomposition: '⿺是頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '是',
      semantic: '頁',
      hint: 'head',
    },
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '額',
    definition: 'forehead; quota, amount',
    pinyin: ['é'],
    decomposition: '⿰客頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '客',
      semantic: '頁',
      hint: 'head',
    },
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '顎',
    definition: 'jaw',
    pinyin: ['è'],
    decomposition: '⿰咢頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咢',
      semantic: '頁',
      hint: 'head',
    },
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '顏',
    definition: 'face, facial appearance',
    pinyin: ['yán'],
    decomposition: '⿰彥頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彥',
      semantic: '頁',
      hint: 'head',
    },
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '顓',
    definition: 'good, honest, simple; respectful',
    pinyin: ['zhuān'],
    decomposition: '⿰耑頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '耑',
      semantic: '頁',
      hint: 'head',
    },
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '顗',
    definition: 'quiet',
    pinyin: ['yǐ'],
    decomposition: '⿰豈頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豈',
      semantic: '頁',
      hint: 'leaf',
    },
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '願',
    definition: 'desire, wish; honest, virtuous; ready, willing',
    pinyin: ['yuàn'],
    decomposition: '⿰原頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '原',
      semantic: '頁',
      hint: 'head',
    },
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '顙',
    definition: 'forehead; to kowtow',
    pinyin: ['sǎng'],
    decomposition: '⿰桑頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '桑',
      semantic: '頁',
      hint: 'head',
    },
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '顛',
    definition: 'peak, summit, top; to upset',
    pinyin: ['diān'],
    decomposition: '⿰真頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '真',
      semantic: '頁',
      hint: 'head',
    },
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '類',
    definition: 'category, class, group, kind; similar to; to resemble',
    pinyin: ['lèi'],
    decomposition: '⿰⿱米犬頁',
    radical: '頁',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '顥',
    definition: 'bright, luminous; white, hoary',
    pinyin: ['hào'],
    decomposition: '⿰景頁',
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '顧',
    definition: 'to look back; to look at; to look after',
    pinyin: ['gù'],
    decomposition: '⿰雇頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '雇',
      semantic: '頁',
      hint: 'head',
    },
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '顫',
    definition: 'to shiver, to tremble; trembling',
    pinyin: ['chàn'],
    decomposition: '⿰亶頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亶',
      semantic: '頁',
      hint: 'leaf',
    },
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '顬',
    definition: 'the temporal bone',
    pinyin: ['rú'],
    decomposition: '⿰需頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '需',
      semantic: '頁',
      hint: 'head',
    },
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '顯',
    definition: 'clear, evident; prominent; to show',
    pinyin: ['xiǎn'],
    decomposition: '⿰㬎頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㬎',
      semantic: '頁',
      hint: 'head',
    },
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '顰',
    definition: 'to frown; to knit the brows',
    pinyin: ['pín'],
    decomposition: '⿱頻卑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '頻',
      semantic: '卑',
      hint: 'despise',
    },
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '顱',
    definition: 'skull',
    pinyin: ['lú'],
    decomposition: '⿰盧頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '盧',
      semantic: '頁',
      hint: 'head',
    },
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '顳',
    definition: 'the temporal bone',
    pinyin: ['niè'],
    decomposition: '⿰聶頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '聶',
      semantic: '頁',
      hint: 'head',
    },
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '顴',
    definition: 'cheekbones',
    pinyin: ['quán'],
    decomposition: '⿰雚頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '雚',
      semantic: '頁',
      hint: 'head',
    },
    radical: '頁',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '页',
    definition: 'page, sheet, leaf',
    pinyin: ['yè'],
    decomposition: '⿱？贝',
    etymology: { type: 'pictographic', hint: "A person's head" },
    radical: '页',
    matches: [null, null, [1], [1], [1], [1]],
  },
  {
    character: '顶',
    definition: 'top, summit, peak; to carry on the head',
    pinyin: ['dǐng'],
    decomposition: '⿰丁页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丁',
      semantic: '页',
      hint: 'head',
    },
    radical: '页',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '顷',
    definition: 'a moment; a unit of area equal to 100 mu',
    pinyin: ['qǐng'],
    decomposition: '⿰匕页',
    radical: '页',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '顸',
    definition: 'stupid; having a large, flat face',
    pinyin: ['hān'],
    decomposition: '⿰干页',
    etymology: {
      type: 'ideographic',
      hint: 'One with a dry 干 face 页; 干 also provides the pronunciation',
    },
    radical: '干',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '项',
    definition: 'neck, nape; item; a term in an equation',
    pinyin: ['xiàng'],
    decomposition: '⿰工页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '工',
      semantic: '页',
      hint: 'head',
    },
    radical: '页',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '顺',
    definition: 'to submit to, to obey, to go along with',
    pinyin: ['shùn'],
    decomposition: '⿰川页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '川',
      semantic: '页',
      hint: 'head',
    },
    radical: '页',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '须',
    definition: 'beard; must; necessary',
    pinyin: ['xū'],
    decomposition: '⿰彡页',
    etymology: { type: 'ideographic', hint: 'Hair 彡 growing on the face 页' },
    radical: '彡',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '顼',
    definition: 'anxious, grieving',
    pinyin: ['xū'],
    decomposition: '⿰王页',
    radical: '王',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '顽',
    definition: 'stubborn, recalcitrant, obstinate',
    pinyin: ['wán'],
    decomposition: '⿰元页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '元',
      semantic: '页',
      hint: 'head',
    },
    radical: '页',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '顾',
    definition: 'to look back; to look at; to look after',
    pinyin: ['gù'],
    decomposition: '⿰厄页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厄',
      semantic: '页',
      hint: 'head',
    },
    radical: '页',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '顿',
    definition: 'to pause; to bow; to arrange',
    pinyin: ['dùn'],
    decomposition: '⿰屯页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屯',
      semantic: '页',
      hint: 'head',
    },
    radical: '页',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '颀',
    definition: 'tall and slim; slender',
    pinyin: ['qí'],
    decomposition: '⿰斤页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '斤',
      semantic: '页',
      hint: 'leaf',
    },
    radical: '斤',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '颁',
    definition: 'to bestow, to confer; to publish',
    pinyin: ['bān'],
    decomposition: '⿰分页',
    etymology: {
      type: 'ideographic',
      hint: 'To pass out 分 a booklet 页; 分 also provides the pronunciation',
    },
    radical: '页',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '颂',
    definition: 'to laud, to acclaim; ode, hymn',
    pinyin: ['sòng'],
    decomposition: '⿰公页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '公',
      semantic: '页',
      hint: 'page',
    },
    radical: '页',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '颃',
    definition: 'to dive, to fly downward',
    pinyin: ['háng'],
    decomposition: '⿰亢页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亢',
      semantic: '页',
      hint: 'leaf',
    },
    radical: '页',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '预',
    definition: 'to prepare, to arrange; in advance',
    pinyin: ['yù'],
    decomposition: '⿰予页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '予',
      semantic: '页',
      hint: 'page',
    },
    radical: '页',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '颅',
    definition: 'skull',
    pinyin: ['lú'],
    decomposition: '⿰卢页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卢',
      semantic: '页',
      hint: 'head',
    },
    radical: '页',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '领',
    definition: 'neck, collar; lead, guide',
    pinyin: ['lǐng'],
    decomposition: '⿰令页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '令',
      semantic: '页',
      hint: 'head',
    },
    radical: '页',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '颇',
    definition: 'rather, quite; partial, biased',
    pinyin: ['pō'],
    decomposition: '⿰皮页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皮',
      semantic: '页',
      hint: 'leaf',
    },
    radical: '页',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '颈',
    definition: 'neck, throat',
    pinyin: ['jǐng'],
    decomposition: '⿰？页',
    etymology: { type: 'pictophonetic', semantic: '页', hint: 'head' },
    radical: '页',
    matches: [null, null, null, null, null, [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '颉',
    definition: 'contest; to fly, to soar',
    pinyin: ['jié'],
    decomposition: '⿰吉页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吉',
      semantic: '页',
      hint: 'leaf',
    },
    radical: '页',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '颊',
    definition: 'cheeks, jaw',
    pinyin: ['jiá'],
    decomposition: '⿰夹页',
    etymology: {
      type: 'ideographic',
      hint: 'The jaw in 夹 the head 页; 夹 also provides the pronunciation',
    },
    radical: '页',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '颌',
    definition: 'mouth; jaw',
    pinyin: ['hé'],
    decomposition: '⿰合页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '合',
      semantic: '页',
      hint: 'head',
    },
    radical: '页',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '颍',
    definition: 'a river in Anhui',
    pinyin: ['yǐng'],
    decomposition: '⿰⿱匕水页',
    etymology: { type: 'pictophonetic', semantic: '水', hint: 'water' },
    radical: '水',
    matches: [
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '颏',
    definition: 'chin',
    pinyin: ['kē'],
    decomposition: '⿰亥页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亥',
      semantic: '页',
      hint: 'head',
    },
    radical: '页',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '颐',
    definition: 'cheeks, jaw; chin; rear; to nourish',
    pinyin: ['yí'],
    decomposition: '⿰臣页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '臣',
      semantic: '页',
      hint: 'head',
    },
    radical: '页',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '频',
    definition: 'frequency; repeatedly, again and again',
    pinyin: ['pín'],
    decomposition: '⿰步页',
    radical: '页',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '颓',
    definition: 'ruined, decayed; depressed; decadent',
    pinyin: ['tuí'],
    decomposition: '⿰秃页',
    etymology: {
      type: 'ideographic',
      hint: 'A bald 秃 head 页; 秃 also provides the pronunciation',
    },
    radical: '页',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '颔',
    definition: 'chin, jowl; to nod',
    pinyin: ['hàn'],
    decomposition: '⿰含页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '含',
      semantic: '页',
      hint: 'head',
    },
    radical: '页',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '颖',
    definition: 'rice tassel; sharp; clever',
    pinyin: ['yǐng'],
    decomposition: '⿰⿱匕禾页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匕',
      semantic: '禾',
      hint: 'rice',
    },
    radical: '页',
    matches: [
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '颗',
    definition: 'grain, kernel',
    pinyin: ['kē'],
    decomposition: '⿰果页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '页',
      semantic: '果',
      hint: 'grain',
    },
    radical: '页',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '题',
    definition: 'forehead; headline, title; theme',
    pinyin: ['tí'],
    decomposition: '⿺是页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '是',
      semantic: '页',
      hint: 'head',
    },
    radical: '页',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '颚',
    definition: 'jaw',
    pinyin: ['è'],
    decomposition: '⿰咢页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咢',
      semantic: '页',
      hint: 'head',
    },
    radical: '页',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '颛',
    definition: 'good, honest, simple; respectful',
    pinyin: ['zhuān'],
    decomposition: '⿰耑页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '耑',
      semantic: '页',
      hint: 'head',
    },
    radical: '页',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '颜',
    definition: 'face, facial appearance',
    pinyin: ['yán'],
    decomposition: '⿰彦页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '彦',
      semantic: '页',
      hint: 'head',
    },
    radical: '页',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '额',
    definition: 'forehead; quota, amount',
    pinyin: ['é'],
    decomposition: '⿰客页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '客',
      semantic: '页',
      hint: 'head',
    },
    radical: '页',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '颞',
    definition: 'the temporal bone',
    pinyin: ['niè'],
    decomposition: '⿰聂页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '聂',
      semantic: '页',
      hint: 'head',
    },
    radical: '页',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '颟',
    definition: 'to idle, to dawdle; thoughtless, careless',
    pinyin: ['mān'],
    decomposition: '⿰⿱艹两页',
    radical: '页',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '颠',
    definition: 'peak, summit, top; to upset',
    pinyin: ['diān'],
    decomposition: '⿰真页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '真',
      semantic: '页',
      hint: 'head',
    },
    radical: '页',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '颡',
    definition: 'forehead; to kowtow',
    pinyin: ['sǎng'],
    decomposition: '⿰桑页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '桑',
      semantic: '页',
      hint: 'head',
    },
    radical: '页',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '颢',
    definition: 'bright, luminous; white, hoary',
    pinyin: ['hào'],
    decomposition: '⿰景页',
    radical: '页',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '颤',
    definition: 'to shiver, to tremble; trembling',
    pinyin: ['chàn'],
    decomposition: '⿰亶页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亶',
      semantic: '页',
      hint: 'leaf',
    },
    radical: '页',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '颥',
    definition: 'the temporal bone',
    pinyin: ['rú'],
    decomposition: '⿰需页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '需',
      semantic: '页',
      hint: 'head',
    },
    radical: '页',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '颦',
    definition: 'to frown; to knit the brows',
    pinyin: ['pín'],
    decomposition: '⿱频卑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '频',
      semantic: '卑',
      hint: 'despise',
    },
    radical: '十',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '颧',
    definition: 'cheekbones',
    pinyin: ['quán'],
    decomposition: '⿰雚页',
    etymology: {
      type: 'pictophonetic',
      phonetic: '雚',
      semantic: '页',
      hint: 'head',
    },
    radical: '页',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '風',
    definition: 'wind; air; customs, manners; news',
    pinyin: ['fēng'],
    decomposition: '⿵几虫',
    radical: '風',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '颭',
    definition: 'to sway in the wind',
    pinyin: ['zhǎn'],
    decomposition: '⿺風占',
    etymology: {
      type: 'pictophonetic',
      phonetic: '占',
      semantic: '風',
      hint: 'wind',
    },
    radical: '風',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '颯',
    definition: 'bleak; melancholy; the howl of the wind',
    pinyin: ['sà'],
    decomposition: '⿰立風',
    etymology: {
      type: 'pictophonetic',
      phonetic: '立',
      semantic: '風',
      hint: 'wind',
    },
    radical: '風',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '颱',
    definition: 'platform; unit; term of address',
    pinyin: ['tái'],
    decomposition: '⿺風台',
    etymology: {
      type: 'ideographic',
      hint: 'News 風 delivered from a platform 台',
    },
    radical: '風',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '颳',
    definition: 'to shave; to scrape; to blow',
    pinyin: ['guā'],
    decomposition: '⿺風舌',
    etymology: {
      type: 'ideographic',
      hint: 'The biting tongue 舌 of the wind 風',
    },
    radical: '風',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '颶',
    definition: 'cyclone, gale, typhoon',
    pinyin: ['jù'],
    decomposition: '⿺風具',
    etymology: {
      type: 'pictophonetic',
      phonetic: '具',
      semantic: '風',
      hint: 'wind',
    },
    radical: '風',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '颻',
    definition: 'floating in the air; drifting on the wind',
    pinyin: ['yáo'],
    decomposition: '⿰䍃風',
    etymology: {
      type: 'pictophonetic',
      phonetic: '䍃',
      semantic: '風',
      hint: 'wind',
    },
    radical: '風',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '颼',
    definition: 'a chill breeze; to blow; the sound of the wind',
    pinyin: ['sōu'],
    decomposition: '⿺風叟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叟',
      semantic: '風',
      hint: 'wind',
    },
    radical: '風',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '飄',
    definition: 'to drift, to float, to flutter',
    pinyin: ['piāo'],
    decomposition: '⿰票風',
    etymology: {
      type: 'pictophonetic',
      phonetic: '票',
      semantic: '風',
      hint: 'wind',
    },
    radical: '風',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '飆',
    definition: 'whirlwind, storm gale',
    pinyin: ['biāo'],
    decomposition: '⿰猋風',
    etymology: {
      type: 'ideographic',
      hint: 'Storm 猋 winds 風; 猋 also provides the pronunciation',
    },
    radical: '風',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '风',
    definition: 'wind; air; customs, manners; news',
    pinyin: ['fēng'],
    decomposition: '⿵几乂',
    radical: '风',
    matches: [[0], [0], [1], [1]],
  },
  {
    character: '飐',
    definition: 'to sway in the wind',
    pinyin: ['zhǎn'],
    decomposition: '⿺风占',
    etymology: {
      type: 'pictophonetic',
      phonetic: '占',
      semantic: '风',
      hint: 'wind',
    },
    radical: '风',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '飑',
    definition: 'storm, whirlwind',
    pinyin: ['biāo'],
    decomposition: '⿺风包',
    etymology: {
      type: 'ideographic',
      hint: 'Wind 风 that wraps 包 on itself; 包 also provides the pronunciation',
    },
    radical: '风',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '飒',
    definition: 'bleak; melancholy; the howl of the wind',
    pinyin: ['sà'],
    decomposition: '⿰立风',
    etymology: {
      type: 'pictophonetic',
      phonetic: '立',
      semantic: '风',
      hint: 'wind',
    },
    radical: '风',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '飓',
    definition: 'cyclone, gale, typhoon',
    pinyin: ['jù'],
    decomposition: '⿺风具',
    etymology: {
      type: 'pictophonetic',
      phonetic: '具',
      semantic: '风',
      hint: 'wind',
    },
    radical: '风',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '飕',
    definition: 'a chill breeze; to blow; the sound of the wind',
    pinyin: ['sōu'],
    decomposition: '⿺风叟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '叟',
      semantic: '风',
      hint: 'wind',
    },
    radical: '风',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '飖',
    definition: 'floating in the air; drifting on the wind',
    pinyin: ['yáo'],
    decomposition: '⿰䍃风',
    etymology: {
      type: 'pictophonetic',
      phonetic: '䍃',
      semantic: '风',
      hint: 'wind',
    },
    radical: '风',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '飘',
    definition: 'to drift, to float, to flutter',
    pinyin: ['piāo'],
    decomposition: '⿰票风',
    etymology: {
      type: 'pictophonetic',
      phonetic: '票',
      semantic: '风',
      hint: 'wind',
    },
    radical: '风',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '飙',
    definition: 'whirlwind, storm gale',
    pinyin: ['biāo'],
    decomposition: '⿰猋风',
    etymology: {
      type: 'ideographic',
      hint: 'Storm 猋 winds 风; 猋 also provides the pronunciation',
    },
    radical: '风',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '飚',
    definition: 'whirlwind',
    pinyin: ['biāo'],
    decomposition: '⿺风焱',
    etymology: {
      type: 'ideographic',
      hint: 'A particularly fierce 焱 storm 风',
    },
    radical: '风',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '飛',
    definition: 'to fly, to dart; high',
    pinyin: ['fēi'],
    decomposition: '⿹飞⿻？飞',
    etymology: { type: 'ideographic', hint: 'Two birds 飞 flying' },
    radical: '飛',
    matches: [[0], [0], [0], null, null, [1, 1], [1, 1], [1, 1], null],
  },
  {
    character: '飞',
    definition: 'to fly, to dart; high',
    pinyin: ['fēi'],
    decomposition: '⿻？？',
    etymology: { type: 'pictographic', hint: 'A bird flapping its wings' },
    radical: '飞',
    matches: [null, null, null],
  },
  {
    character: '食',
    definition: 'food; to eat',
    pinyin: ['shí'],
    decomposition: '⿱人良',
    etymology: {
      type: 'pictographic',
      hint: 'A dish of food 良 with a lid on top 人',
    },
    radical: '食',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '飠',
    definition: 'food; to eat',
    pinyin: ['shí'],
    decomposition: '⿱人？',
    etymology: {
      type: 'pictographic',
      hint: 'A dish of food 良 with a lid on top 人',
    },
    radical: '飠',
    matches: [[0], [0], null, null, null, null, null, null],
  },
  {
    character: '飢',
    definition: 'hungry, starving; hunger, famine',
    pinyin: ['jī'],
    decomposition: '⿰飠几',
    etymology: {
      type: 'pictophonetic',
      phonetic: '几',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '飧',
    definition: 'dinner, supper; cooked food',
    pinyin: ['sūn'],
    decomposition: '⿰夕食',
    etymology: { type: 'ideographic', hint: 'An evening 夕 meal 食' },
    radical: '食',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '飨',
    definition: 'banquet; to host a banquet',
    pinyin: ['xiǎng'],
    decomposition: '⿰乡食',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乡',
      semantic: '食',
      hint: 'food',
    },
    radical: '食',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '飩',
    definition: 'stuffed dumplings',
    pinyin: ['tún'],
    decomposition: '⿰飠屯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屯',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '飪',
    definition: 'cooked food; to cook until well-done',
    pinyin: ['rèn'],
    decomposition: '⿰飠壬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '壬',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '飫',
    definition: 'full, satiated; to confer',
    pinyin: ['yù'],
    decomposition: '⿰飠夭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夭',
      semantic: '飠',
      hint: 'eat',
    },
    radical: '飠',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '飬',
    definition: 'to offer a sacrifice',
    pinyin: ['juàn'],
    decomposition: '⿱龹食',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龹',
      semantic: '食',
      hint: 'food',
    },
    radical: '食',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '飭',
    definition: 'order; command; give command',
    pinyin: ['chì'],
    decomposition: '⿰飠⿱？力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '飠',
      semantic: '力',
      hint: 'strength',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      null,
      null,
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '飯',
    definition: 'meal, food; cooked rice',
    pinyin: ['fàn'],
    decomposition: '⿰飠反',
    etymology: {
      type: 'pictophonetic',
      phonetic: '反',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '飲',
    definition: 'to swallow, to drink; a kind of drink',
    pinyin: ['yǐn'],
    decomposition: '⿰飠欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '欠',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '飴',
    definition: 'syrup; sweet-meat, sweet-cake',
    pinyin: ['yí'],
    decomposition: '⿰飠台',
    etymology: {
      type: 'pictophonetic',
      phonetic: '台',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '飼',
    definition: 'to raise animals; to nourish, to feed',
    pinyin: ['sì'],
    decomposition: '⿰飠司',
    etymology: {
      type: 'pictophonetic',
      phonetic: '司',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '飽',
    definition: "satisfied; to eat one's fill",
    pinyin: ['bǎo'],
    decomposition: '⿰飠包',
    etymology: {
      type: 'pictophonetic',
      phonetic: '包',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '飾',
    definition: 'to decorate, to adorn; ornament',
    pinyin: ['shì'],
    decomposition: '⿰飠⿱？巾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '飠',
      semantic: '巾',
      hint: 'cloth',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      null,
      null,
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '餃',
    definition: 'stuffed dumplings',
    pinyin: ['jiǎo'],
    decomposition: '⿰飠交',
    etymology: {
      type: 'pictophonetic',
      phonetic: '交',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '餄',
    definition: 'buckwheat or sorghum noodles',
    pinyin: ['hé'],
    decomposition: '⿰飠合',
    etymology: {
      type: 'pictophonetic',
      phonetic: '合',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '餅',
    definition: 'rice-cake, pastry, biscuit',
    pinyin: ['bǐng'],
    decomposition: '⿰飠并',
    etymology: {
      type: 'pictophonetic',
      phonetic: '并',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '餉',
    definition: 'rations and pay for soldiers',
    pinyin: ['xiǎng'],
    decomposition: '⿰飠向',
    etymology: {
      type: 'pictophonetic',
      phonetic: '向',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '養',
    definition: 'to raise, to rear, to bring up; to support',
    pinyin: ['yǎng'],
    decomposition: '⿱羊食',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羊',
      semantic: '食',
      hint: 'food',
    },
    radical: '食',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '餌',
    definition: 'bait; cake; dumplings; to bait, to entice',
    pinyin: ['ěr'],
    decomposition: '⿰飠耳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '耳',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '餍',
    definition: "full, satiated; to eat one's fill",
    pinyin: ['yàn'],
    decomposition: '⿸厌食',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厌',
      semantic: '食',
      hint: 'eat',
    },
    radical: '食',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '餎',
    definition: 'buckwheat or sorghum noodles',
    pinyin: ['le'],
    decomposition: '⿰飠各',
    etymology: {
      type: 'pictophonetic',
      phonetic: '各',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '餐',
    definition: 'to eat, to dine; meal, food',
    pinyin: ['cān'],
    decomposition: '⿱⿰歺又食',
    etymology: { type: 'pictophonetic', semantic: '食', hint: 'food' },
    radical: '食',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '餑',
    definition: 'cake, biscuit',
    pinyin: ['bō'],
    decomposition: '⿰飠孛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孛',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '餒',
    definition: 'famished, hungry, starving',
    pinyin: ['něi'],
    decomposition: '⿰飠妥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '妥',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '餓',
    definition: 'hungry; greedy',
    pinyin: ['è'],
    decomposition: '⿰飠我',
    etymology: {
      type: 'ideographic',
      hint: 'To want 我 food 飠; 我 also provides the pronunciation',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '餕',
    definition: 'leftovers',
    pinyin: ['jùn'],
    decomposition: '⿰飠夋',
    etymology: {
      type: 'ideographic',
      hint: 'Food 飠 left over 夋; 夋 also provides the pronunciation',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '餘',
    definition: 'surplus, remainder, excess',
    pinyin: ['yú'],
    decomposition: '⿰飠余',
    etymology: {
      type: 'ideographic',
      hint: 'Extra 余 food 飠; 余 also provides the pronunciation',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '餚',
    definition: 'cooked or prepared meat',
    pinyin: ['yáo'],
    decomposition: '⿰飠肴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肴',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '餛',
    definition: 'dumpling soup; wonton',
    pinyin: ['hún'],
    decomposition: '⿰飠昆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昆',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '餞',
    definition: 'to send off; farewell dinner; preserves',
    pinyin: ['jiàn'],
    decomposition: '⿰飠戔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戔',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '餡',
    definition: 'filling, stuffing; secret',
    pinyin: ['xiàn'],
    decomposition: '⿰飠臽',
    etymology: {
      type: 'ideographic',
      hint: 'Food 飠 stuffed in a hole 臽; 臽 also provides the pronunciation',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '館',
    definition: 'public building; shop, house, establishment',
    pinyin: ['guǎn'],
    decomposition: '⿰飠官',
    etymology: {
      type: 'ideographic',
      hint: 'A public 官 building where food 飠 is served; 官 also provides the pronunciation',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '餬',
    definition: 'porridge, gruel, congee; paste',
    pinyin: ['hú'],
    decomposition: '⿰飠胡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '胡',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '餮',
    definition: 'glutton, greedy person; insatiable dragon',
    pinyin: ['tiè'],
    decomposition: '⿱殄食',
    etymology: {
      type: 'pictophonetic',
      phonetic: '殄',
      semantic: '食',
      hint: 'eat',
    },
    radical: '食',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '餵',
    definition: 'to feed, to raise',
    pinyin: ['wèi'],
    decomposition: '⿰飠畏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畏',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '餼',
    definition: 'sacrficial victim; gift; grain',
    pinyin: ['xì'],
    decomposition: '⿰飠氣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '氣',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '餾',
    definition: 'distill, distillation',
    pinyin: ['liú'],
    decomposition: '⿰飠留',
    etymology: {
      type: 'ideographic',
      hint: 'Distilled 留 wine 飠; 留 also provides the pronunciation',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '餿',
    definition: 'spoiled, rotten; stale, rancid',
    pinyin: ['sōu'],
    decomposition: '⿰飠叟',
    etymology: {
      type: 'ideographic',
      hint: 'Old 叟 food 飠; 叟 also provides the pronunciation',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '饃',
    definition: 'bread',
    pinyin: ['mó'],
    decomposition: '⿰飠莫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '莫',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '饅',
    definition: 'steamed buns; steamed dumplings',
    pinyin: ['mán'],
    decomposition: '⿰飠曼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曼',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '饈',
    definition: 'food, meal; to eat; to offer',
    pinyin: ['xiū'],
    decomposition: '⿰飠羞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羞',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '饉',
    definition: 'a time of famine or crop failure',
    pinyin: ['jǐn'],
    decomposition: '⿰飠堇',
    etymology: {
      type: 'ideographic',
      hint: 'A time of little 堇 food 飠; 堇 also provides the pronunciation',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '饊',
    definition: 'fried round cakes of wheat flour',
    pinyin: ['sǎn'],
    decomposition: '⿰飠散',
    etymology: {
      type: 'pictophonetic',
      phonetic: '散',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '饋',
    definition: 'gift, present',
    pinyin: ['kuì'],
    decomposition: '⿰飠貴',
    etymology: {
      type: 'ideographic',
      hint: 'Expensive 貴 food 飠; 貴 also provides the pronunciation',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '饌',
    definition: 'to feed, support, provide for; food',
    pinyin: ['zhuàn'],
    decomposition: '⿰飠巽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巽',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '饑',
    definition: 'famine; to starve, to go hungry',
    pinyin: ['jī'],
    decomposition: '⿰飠幾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '幾',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '饒',
    definition: 'abundant, bountiful',
    pinyin: ['ráo'],
    decomposition: '⿰飠堯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堯',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '饔',
    definition: 'breakfast; to eat prepared food',
    pinyin: ['yōng'],
    decomposition: '⿱雍食',
    etymology: {
      type: 'pictophonetic',
      phonetic: '雍',
      semantic: '食',
      hint: 'food',
    },
    radical: '食',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '饕',
    definition: 'gluttonous; greedy, covetous',
    pinyin: ['tāo'],
    decomposition: '⿱號食',
    etymology: {
      type: 'pictophonetic',
      phonetic: '號',
      semantic: '食',
      hint: 'eat',
    },
    radical: '食',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '饗',
    definition: 'banquet; to host a banquet',
    pinyin: ['xiǎng'],
    decomposition: '⿱鄉食',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鄉',
      semantic: '食',
      hint: 'food',
    },
    radical: '食',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '饜',
    definition: "full, satiated; to eat one's fill",
    pinyin: ['yàn'],
    decomposition: '⿸厭食',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厭',
      semantic: '食',
      hint: 'eat',
    },
    radical: '食',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '饞',
    definition: 'greedy, gluttonous; lewd, lecherous',
    pinyin: ['chán'],
    decomposition: '⿰飠毚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '毚',
      semantic: '飠',
      hint: 'eat',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '饢',
    definition: 'naan',
    pinyin: ['náng'],
    decomposition: '⿰飠囊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '囊',
      semantic: '飠',
      hint: 'food',
    },
    radical: '飠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '饣',
    definition: 'food; to eat',
    pinyin: ['shí'],
    decomposition: '⿱？乚',
    radical: '饣',
    matches: [null, null, [1]],
  },
  {
    character: '饥',
    definition: 'hungry, starving; hunger, famine',
    pinyin: ['jī'],
    decomposition: '⿰饣几',
    etymology: {
      type: 'pictophonetic',
      phonetic: '几',
      semantic: '饣',
      hint: 'food',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '饧',
    definition: 'syrup, molasses, malt sugar; sticky',
    pinyin: ['táng'],
    decomposition: '⿰饣昜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昜',
      semantic: '饣',
      hint: 'food',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '饨',
    definition: 'stuffed dumplings',
    pinyin: ['tún'],
    decomposition: '⿰饣屯',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屯',
      semantic: '饣',
      hint: 'food',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '饩',
    definition: 'sacrficial victim; gift; grain',
    pinyin: ['xì'],
    decomposition: '⿰饣气',
    etymology: {
      type: 'pictophonetic',
      phonetic: '气',
      semantic: '饣',
      hint: 'food',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '饪',
    definition: 'cooked food; to cook until well-done',
    pinyin: ['rèn'],
    decomposition: '⿰饣壬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '壬',
      semantic: '饣',
      hint: 'food',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '饫',
    definition: 'full, satiated; to confer',
    pinyin: ['yù'],
    decomposition: '⿰饣夭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夭',
      semantic: '饣',
      hint: 'eat',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '饬',
    definition: 'order; command; give command',
    pinyin: ['chì'],
    decomposition: '⿰饣⿱？力',
    etymology: {
      type: 'pictophonetic',
      phonetic: '饣',
      semantic: '力',
      hint: 'strength',
    },
    radical: '饣',
    matches: [[0], [0], [0], null, null, [1, 1], [1, 1]],
  },
  {
    character: '饭',
    definition: 'meal, food; cooked rice',
    pinyin: ['fàn'],
    decomposition: '⿰饣反',
    etymology: {
      type: 'pictophonetic',
      phonetic: '反',
      semantic: '饣',
      hint: 'food',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '饮',
    definition: 'to swallow, to drink; a kind of drink',
    pinyin: ['yǐn'],
    decomposition: '⿰饣欠',
    etymology: {
      type: 'pictophonetic',
      phonetic: '欠',
      semantic: '饣',
      hint: 'food',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '饯',
    definition: 'to send off; farewell dinner; preserves',
    pinyin: ['jiàn'],
    decomposition: '⿰饣戋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戋',
      semantic: '饣',
      hint: 'food',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '饰',
    definition: 'to decorate, to adorn; ornament',
    pinyin: ['shì'],
    decomposition: '⿰饣⿱？巾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '饣',
      semantic: '巾',
      hint: 'cloth',
    },
    radical: '饣',
    matches: [[0], [0], [0], null, null, [1, 1], [1, 1], [1, 1]],
  },
  {
    character: '饱',
    definition: "satisfied; to eat one's fill",
    pinyin: ['bǎo'],
    decomposition: '⿰饣包',
    etymology: {
      type: 'pictophonetic',
      phonetic: '包',
      semantic: '饣',
      hint: 'food',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '饲',
    definition: 'to raise animals; to nourish, to feed',
    pinyin: ['sì'],
    decomposition: '⿰饣司',
    etymology: {
      type: 'pictophonetic',
      phonetic: '司',
      semantic: '饣',
      hint: 'food',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '饴',
    definition: 'syrup; sweet-meat, sweet-cake',
    pinyin: ['yí'],
    decomposition: '⿰饣台',
    etymology: {
      type: 'pictophonetic',
      phonetic: '台',
      semantic: '饣',
      hint: 'food',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '饵',
    definition: 'bait; cake; dumplings; to bait, to entice',
    pinyin: ['ěr'],
    decomposition: '⿰饣耳',
    etymology: {
      type: 'pictophonetic',
      phonetic: '耳',
      semantic: '饣',
      hint: 'food',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '饶',
    definition: 'abundant, bountiful',
    pinyin: ['ráo'],
    decomposition: '⿰饣尧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尧',
      semantic: '饣',
      hint: 'food',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '饷',
    definition: 'rations and pay for soldiers',
    pinyin: ['xiǎng'],
    decomposition: '⿰饣向',
    etymology: {
      type: 'pictophonetic',
      phonetic: '向',
      semantic: '饣',
      hint: 'food',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '饸',
    definition: 'buckwheat or sorghum noodles',
    pinyin: ['hé'],
    decomposition: '⿰饣合',
    etymology: {
      type: 'pictophonetic',
      phonetic: '合',
      semantic: '饣',
      hint: 'food',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '饹',
    definition: 'buckwheat or sorghum noodles',
    pinyin: ['le'],
    decomposition: '⿰饣各',
    etymology: {
      type: 'pictophonetic',
      phonetic: '各',
      semantic: '饣',
      hint: 'food',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '饺',
    definition: 'stuffed dumplings',
    pinyin: ['jiǎo'],
    decomposition: '⿰饣交',
    etymology: {
      type: 'pictophonetic',
      phonetic: '交',
      semantic: '饣',
      hint: 'food',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '饼',
    definition: 'rice-cake, pastry, biscuit',
    pinyin: ['bǐng'],
    decomposition: '⿰饣并',
    etymology: {
      type: 'pictophonetic',
      phonetic: '并',
      semantic: '饣',
      hint: 'food',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '饽',
    definition: 'cake, biscuit',
    pinyin: ['bō'],
    decomposition: '⿰饣孛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孛',
      semantic: '饣',
      hint: 'food',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '饿',
    definition: 'hungry; greedy',
    pinyin: ['è'],
    decomposition: '⿰饣我',
    etymology: {
      type: 'ideographic',
      hint: 'To want 我 food 饣; 我 also provides the pronunciation',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '馀',
    definition: 'surplus, remainder, excess',
    pinyin: ['yú'],
    decomposition: '⿰饣余',
    etymology: {
      type: 'ideographic',
      hint: 'Extra 余 food 饣; 余 also provides the pronunciation',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '馁',
    definition: 'famished, hungry, starving',
    pinyin: ['něi'],
    decomposition: '⿰饣妥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '妥',
      semantic: '饣',
      hint: 'food',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '馂',
    definition: 'leftovers',
    pinyin: ['jùn'],
    decomposition: '⿰饣夋',
    etymology: {
      type: 'ideographic',
      hint: 'Food 饣 left over 夋; 夋 also provides the pronunciation',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '馄',
    definition: 'dumpling soup; wonton',
    pinyin: ['hún'],
    decomposition: '⿰饣昆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昆',
      semantic: '饣',
      hint: 'food',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '馅',
    definition: 'filling, stuffing; secret',
    pinyin: ['xiàn'],
    decomposition: '⿰饣臽',
    etymology: {
      type: 'ideographic',
      hint: 'Food 饣 stuffed in a hole 臽; 臽 also provides the pronunciation',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '馆',
    definition: 'public building; shop, house, establishment',
    pinyin: ['guǎn'],
    decomposition: '⿰饣官',
    etymology: {
      type: 'ideographic',
      hint: 'A public 官 building where food 饣 is served; 官 also provides the pronunciation',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '馇',
    definition: 'to stir, to cook, to boil; porridge',
    pinyin: ['chā'],
    decomposition: '⿰饣查',
    etymology: {
      type: 'pictophonetic',
      phonetic: '查',
      semantic: '饣',
      hint: 'food',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '馈',
    definition: 'gift, present',
    pinyin: ['kuì'],
    decomposition: '⿰饣贵',
    etymology: {
      type: 'ideographic',
      hint: 'Expensive 贵 food 饣; 贵 also provides the pronunciation',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '馊',
    definition: 'spoiled, rotten; stale, rancid',
    pinyin: ['sōu'],
    decomposition: '⿰饣叟',
    etymology: {
      type: 'ideographic',
      hint: 'Old 叟 food 饣; 叟 also provides the pronunciation',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '馋',
    definition: 'greedy, gluttonous; lewd, lecherous',
    pinyin: ['chán'],
    decomposition: '⿰饣⿱兔？',
    etymology: {
      type: 'pictophonetic',
      phonetic: '饣',
      semantic: '饣',
      hint: 'eat',
    },
    radical: '饣',
    matches: [
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      null,
      null,
    ],
  },
  {
    character: '馍',
    definition: 'bread',
    pinyin: ['mó'],
    decomposition: '⿰饣莫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '莫',
      semantic: '饣',
      hint: 'food',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '馏',
    definition: 'distill, distillation',
    pinyin: ['liú'],
    decomposition: '⿰饣留',
    etymology: {
      type: 'ideographic',
      hint: 'Distilled 留 wine 饣; 留 also provides the pronunciation',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '馐',
    definition: 'food, meal; to eat; to offer',
    pinyin: ['xiū'],
    decomposition: '⿰饣羞',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羞',
      semantic: '饣',
      hint: 'food',
    },
    radical: '饣',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '馑',
    definition: 'a time of famine or crop failure',
    pinyin: ['jǐn'],
    decomposition: '⿰饣堇',
    etymology: {
      type: 'ideographic',
      hint: 'A time of little 堇 food 饣; 堇 also provides the pronunciation',
    },
    radical: '饣',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '馒',
    definition: 'steamed buns; steamed dumplings',
    pinyin: ['mán'],
    decomposition: '⿰饣曼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曼',
      semantic: '饣',
      hint: 'food',
    },
    radical: '饣',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '馓',
    definition: 'fried round cakes of wheat flour',
    pinyin: ['sǎn'],
    decomposition: '⿰饣散',
    etymology: {
      type: 'pictophonetic',
      phonetic: '散',
      semantic: '饣',
      hint: 'food',
    },
    radical: '饣',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '馔',
    definition: 'to feed, support, provide for; food',
    pinyin: ['zhuàn'],
    decomposition: '⿰饣巽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巽',
      semantic: '饣',
      hint: 'food',
    },
    radical: '饣',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '馕',
    definition: 'naan',
    pinyin: ['náng'],
    decomposition: '⿰饣囊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '囊',
      semantic: '饣',
      hint: 'food',
    },
    radical: '饣',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '首',
    definition: 'chief, head, leader',
    pinyin: ['shǒu'],
    decomposition: '⿱丷自',
    etymology: {
      type: 'ideographic',
      hint: "A deer's head 自 adorned with antlers 丷",
    },
    radical: '首',
    matches: [[0], [0], null, [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '馗',
    definition: 'cheekbone; path, road, intersection',
    pinyin: ['kuí'],
    decomposition: '⿺九首',
    etymology: {
      type: 'pictophonetic',
      phonetic: '九',
      semantic: '首',
      hint: 'head',
    },
    radical: '首',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '馘',
    definition: "to cut off the left ear; to tally the enemy's dead",
    pinyin: ['guó'],
    decomposition: '⿰首或',
    etymology: {
      type: 'ideographic',
      hint: "To cut off 或 the enemy's ears 首; 或 also provides the pronunciation",
    },
    radical: '首',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '香',
    definition: 'incense; fragrant, aromatic',
    pinyin: ['xiāng'],
    decomposition: '⿱禾日',
    etymology: { type: 'ideographic', hint: 'A herb 禾 with a sweet 甘 smell' },
    radical: '香',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '馥',
    definition: 'scent, fragrance, aroma',
    pinyin: ['fù'],
    decomposition: '⿰香复',
    etymology: {
      type: 'pictophonetic',
      phonetic: '复',
      semantic: '香',
      hint: 'fragrant',
    },
    radical: '香',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '馨',
    definition: 'fragrant, aromatic',
    pinyin: ['xīn'],
    decomposition: '⿱殸香',
    etymology: {
      type: 'pictophonetic',
      phonetic: '殸',
      semantic: '香',
      hint: 'incense',
    },
    radical: '香',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '馬',
    definition: 'horse; surname',
    pinyin: ['mǎ'],
    decomposition: '⿹？灬',
    etymology: { type: 'pictographic', hint: 'A horse galloping to the left' },
    radical: '馬',
    matches: [null, null, null, null, null, null, [1], [1], [1], [1]],
  },
  {
    character: '馭',
    definition: 'to drive, to ride; to manage, to control',
    pinyin: ['yù'],
    decomposition: '⿰馬又',
    etymology: {
      type: 'pictophonetic',
      phonetic: '又',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '馮',
    definition: 'to gallop; by dint of; surname',
    pinyin: ['féng'],
    decomposition: '⿰冫馬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冫',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '馱',
    definition: "to carry on one's back",
    pinyin: ['tuó'],
    decomposition: '⿰馬大',
    etymology: {
      type: 'pictophonetic',
      phonetic: '大',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '馳',
    definition: 'speed, haste; to run, to gallop',
    pinyin: ['chí'],
    decomposition: '⿰馬也',
    etymology: {
      type: 'pictophonetic',
      phonetic: '也',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '馴',
    definition: 'tame, obedient, docile',
    pinyin: ['xún'],
    decomposition: '⿰馬川',
    etymology: {
      type: 'pictophonetic',
      phonetic: '川',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '駁',
    definition: 'variegated, motley; to refuse, to dispute',
    pinyin: ['bó'],
    decomposition: '⿰馬爻',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爻',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '駐',
    definition: 'stable; station, garrison',
    pinyin: ['zhù'],
    decomposition: '⿰馬主',
    etymology: {
      type: 'pictophonetic',
      phonetic: '主',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '駑',
    definition: 'tired old horse; old, weak',
    pinyin: ['nú'],
    decomposition: '⿱奴馬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奴',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '駒',
    definition: 'colt; fleet, swift; surname',
    pinyin: ['jū'],
    decomposition: '⿰馬句',
    etymology: {
      type: 'pictophonetic',
      phonetic: '句',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '駕',
    definition: 'to drive, to ride, to sail; carriage, cart',
    pinyin: ['jià'],
    decomposition: '⿱加馬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '加',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '駙',
    definition: 'extra horse; imperial son-in-law',
    pinyin: ['fù'],
    decomposition: '⿰馬付',
    etymology: {
      type: 'pictophonetic',
      phonetic: '付',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '駛',
    definition: 'to drive, to pilot, to ride; fast, quick',
    pinyin: ['shǐ'],
    decomposition: '⿰馬史',
    etymology: {
      type: 'pictophonetic',
      phonetic: '史',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '駟',
    definition: 'a team of four horses',
    pinyin: ['sì'],
    decomposition: '⿰馬四',
    etymology: {
      type: 'ideographic',
      hint: 'Four 四 horses 馬; 四 also provides the pronunciation',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '駢',
    definition: 'a team of horses; to associate; to join',
    pinyin: ['pián'],
    decomposition: '⿰馬并',
    etymology: {
      type: 'ideographic',
      hint: 'A team of horses 馬 working together 并',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '駭',
    definition: 'to terrify, to shock, to frighten',
    pinyin: ['hài'],
    decomposition: '⿰馬亥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亥',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '駮',
    definition: 'fierce animal; piebald horse; to argue; to join, to transfer',
    pinyin: ['bó'],
    decomposition: '⿰馬交',
    etymology: { type: 'pictophonetic', semantic: '馬', hint: 'horse' },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '駱',
    definition: 'camel',
    pinyin: ['luò'],
    decomposition: '⿰馬各',
    etymology: {
      type: 'pictophonetic',
      phonetic: '各',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '駿',
    definition: 'an excellent horse; a noble steed',
    pinyin: ['jùn'],
    decomposition: '⿰馬夋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夋',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '騅',
    definition: 'piebald horse',
    pinyin: ['zhuī'],
    decomposition: '⿰馬隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隹',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '騎',
    definition: 'to ride, to mount; cavalry',
    pinyin: ['qí'],
    decomposition: '⿰馬奇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奇',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '騖',
    definition: 'to gallop, to pursue, to run',
    pinyin: ['wù'],
    decomposition: '⿱敄馬',
    etymology: {
      type: 'ideographic',
      hint: 'A horse 馬 working hard 敄; 敄 also provides the pronunciation',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '騙',
    definition: 'to cheat, to defraud, to swindle',
    pinyin: ['piàn'],
    decomposition: '⿰馬扁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '扁',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '騫',
    definition: 'to lift, to raise; to fly, to soar',
    pinyin: ['qiān'],
    decomposition: '⿱宀⿱？馬',
    etymology: {
      type: 'ideographic',
      hint: 'A soldier 宀 mounting a horse 马',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '騭',
    definition: 'stallion; to determine; to promote',
    pinyin: ['zhì'],
    decomposition: '⿱陟馬',
    etymology: {
      type: 'ideographic',
      hint: 'To climb 陟 on a horse 馬; 陟 also provides the pronunciation',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '騮',
    definition: 'a legendary horse',
    pinyin: ['liú'],
    decomposition: '⿰馬留',
    etymology: {
      type: 'pictophonetic',
      phonetic: '留',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '騰',
    definition: 'to fly, to soar; to gallop, to prance; rising, steaming',
    pinyin: ['téng'],
    decomposition: '⿸朕馬',
    etymology: { type: 'ideographic', hint: 'A person 朕 riding a horse 馬' },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '騶',
    definition: 'mounted escort; groom',
    pinyin: ['zōu'],
    decomposition: '⿰馬芻',
    etymology: {
      type: 'pictophonetic',
      phonetic: '芻',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '騷',
    definition: 'to annoy, to bother; to disturb, to harrass',
    pinyin: ['sāo'],
    decomposition: '⿰馬蚤',
    etymology: {
      type: 'ideographic',
      hint: 'A flea 蚤 biting a horse 馬; 蚤 also provides the pronunciation',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '騾',
    definition: 'mule',
    pinyin: ['luó'],
    decomposition: '⿰馬累',
    etymology: {
      type: 'pictophonetic',
      phonetic: '累',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '驀',
    definition: 'suddenly, quickly, abruptly',
    pinyin: ['mò'],
    decomposition: '⿱莫馬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '莫',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '驅',
    definition: 'to spur a horse on; to expel, to drive away',
    pinyin: ['qū'],
    decomposition: '⿰馬區',
    etymology: {
      type: 'pictophonetic',
      phonetic: '區',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '驊',
    definition: 'an excellent horse',
    pinyin: ['huá'],
    decomposition: '⿰馬華',
    etymology: {
      type: 'pictophonetic',
      phonetic: '華',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '驌',
    definition: 'a famous horse',
    pinyin: ['sù'],
    decomposition: '⿰馬肅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肅',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '驎',
    definition: 'female unicorn',
    pinyin: ['lín'],
    decomposition: '⿰馬粦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '粦',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '驕',
    definition: 'haughty, spirited; a wild stallion',
    pinyin: ['jiāo'],
    decomposition: '⿰馬喬',
    etymology: {
      type: 'ideographic',
      hint: 'A proud 喬 horse 馬; 喬 also provides the pronunciation',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '驗',
    definition: 'to examine, to inspect, to test, to verify',
    pinyin: ['yàn'],
    decomposition: '⿰馬僉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '僉',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '驚',
    definition: 'to frighten, to startle; surprise, alarm',
    pinyin: ['jīng'],
    decomposition: '⿱敬馬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敬',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '驛',
    definition: 'relay station',
    pinyin: ['yì'],
    decomposition: '⿰馬睪',
    etymology: {
      type: 'pictophonetic',
      semantic: '馬',
      hint: 'horse',
      phonetic: '睪',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '驟',
    definition: 'procedure; sudden, abrupt; to gallop',
    pinyin: ['zhòu'],
    decomposition: '⿰馬聚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '聚',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '驢',
    definition: 'donkey, ass',
    pinyin: ['lǘ'],
    decomposition: '⿰馬盧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '盧',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '驤',
    definition: 'to gallop about with the head uplifted',
    pinyin: ['xiāng'],
    decomposition: '⿰馬襄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '襄',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '驥',
    definition: 'a thoroughbred horse; refined, virtuous',
    pinyin: ['jì'],
    decomposition: '⿰馬冀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冀',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '驦',
    definition: 'horse',
    pinyin: ['shuāng'],
    decomposition: '⿰馬霜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '霜',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '驪',
    definition: 'a pure-black horse; a pair of horses',
    pinyin: ['lí'],
    decomposition: '⿰馬麗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '麗',
      semantic: '馬',
      hint: 'horse',
    },
    radical: '馬',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '马',
    definition: 'horse; surname',
    pinyin: ['mǎ'],
    decomposition: '⿹？一',
    etymology: {
      type: 'pictographic',
      hint: 'Simplified form of 馬, a horse galloping to the left',
    },
    radical: '马',
    matches: [null, null, [1]],
  },
  {
    character: '驭',
    definition: 'to drive, to ride; to manage, to control',
    pinyin: ['yù'],
    decomposition: '⿰马又',
    etymology: {
      type: 'pictophonetic',
      phonetic: '又',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1]],
  },
  {
    character: '驮',
    definition: "to carry on one's back",
    pinyin: ['tuó'],
    decomposition: '⿰马大',
    etymology: {
      type: 'pictophonetic',
      phonetic: '大',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '驯',
    definition: 'tame, obedient, docile',
    pinyin: ['xún'],
    decomposition: '⿰马川',
    etymology: {
      type: 'pictophonetic',
      phonetic: '川',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '驰',
    definition: 'speed, haste; to run, to gallop',
    pinyin: ['chí'],
    decomposition: '⿰马也',
    etymology: {
      type: 'pictophonetic',
      phonetic: '也',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1]],
  },
  {
    character: '驱',
    definition: 'to spur a horse on; to expel, to drive away',
    pinyin: ['qū'],
    decomposition: '⿰马区',
    etymology: {
      type: 'pictophonetic',
      phonetic: '区',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '驳',
    definition: 'variegated, motley; to refuse, to dispute',
    pinyin: ['bó'],
    decomposition: '⿰马爻',
    etymology: {
      type: 'pictophonetic',
      phonetic: '爻',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '驴',
    definition: 'donkey, ass',
    pinyin: ['lǘ'],
    decomposition: '⿰马户',
    etymology: {
      type: 'pictophonetic',
      phonetic: '户',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '驵',
    definition: 'excellent horse, noble steed',
    pinyin: ['zǎng'],
    decomposition: '⿰马且',
    etymology: {
      type: 'pictophonetic',
      phonetic: '且',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '驶',
    definition: 'to drive, to pilot, to ride; fast, quick',
    pinyin: ['shǐ'],
    decomposition: '⿰马史',
    etymology: {
      type: 'pictophonetic',
      phonetic: '史',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '驷',
    definition: 'a team of four horses',
    pinyin: ['sì'],
    decomposition: '⿰马四',
    etymology: {
      type: 'ideographic',
      hint: 'Four 四 horses 马; 四 also provides the pronunciation',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '驸',
    definition: 'extra horse; imperial son-in-law',
    pinyin: ['fù'],
    decomposition: '⿰马付',
    etymology: {
      type: 'pictophonetic',
      phonetic: '付',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '驹',
    definition: 'colt; fleet, swift; surname',
    pinyin: ['jū'],
    decomposition: '⿰马句',
    etymology: {
      type: 'pictophonetic',
      phonetic: '句',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '驺',
    definition: 'mounted escort; groom',
    pinyin: ['zōu'],
    decomposition: '⿰马刍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '刍',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '驻',
    definition: 'stable; station, garrison',
    pinyin: ['zhù'],
    decomposition: '⿰马主',
    etymology: {
      type: 'pictophonetic',
      phonetic: '主',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '驼',
    definition: "camel; humpback; to carry on one's back",
    pinyin: ['tuó'],
    decomposition: '⿰马它',
    etymology: {
      type: 'pictophonetic',
      phonetic: '它',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '驽',
    definition: 'tired old horse; old, weak',
    pinyin: ['nú'],
    decomposition: '⿱奴马',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奴',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '驾',
    definition: 'to drive, to ride, to sail; carriage, cart',
    pinyin: ['jià'],
    decomposition: '⿱加马',
    etymology: {
      type: 'pictophonetic',
      phonetic: '加',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '驿',
    definition: 'relay station',
    pinyin: ['yì'],
    decomposition: '⿰马？',
    etymology: { type: 'pictophonetic', semantic: '马', hint: 'horse' },
    radical: '马',
    matches: [[0], [0], [0], null, null, null, null, null],
  },
  {
    character: '骀',
    definition: 'tired old horse; tired, exhaused',
    pinyin: ['dài'],
    decomposition: '⿰马台',
    etymology: {
      type: 'pictophonetic',
      phonetic: '台',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '骁',
    definition: 'valiant, brave; skilled; a noble steed',
    pinyin: ['xiāo'],
    decomposition: '⿰马尧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尧',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '骂',
    definition: 'to accuse, to blame, to curse, to scold',
    pinyin: ['mà'],
    decomposition: '⿱⿰口口马',
    etymology: {
      type: 'pictophonetic',
      phonetic: '马',
      semantic: '口',
      hint: 'mouth',
    },
    radical: '口',
    matches: [[0, 0], [0, 0], [0, 0], [0, 1], [0, 1], [0, 1], [1], [1], [1]],
  },
  {
    character: '骄',
    definition: 'haughty, spirited; a wild stallion',
    pinyin: ['jiāo'],
    decomposition: '⿰马乔',
    etymology: {
      type: 'ideographic',
      hint: 'A proud 乔 horse 马; 乔 also provides the pronunciation',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '骅',
    definition: 'an excellent horse',
    pinyin: ['huá'],
    decomposition: '⿰马华',
    etymology: {
      type: 'pictophonetic',
      phonetic: '华',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '骆',
    definition: 'camel',
    pinyin: ['luò'],
    decomposition: '⿰马各',
    etymology: {
      type: 'pictophonetic',
      phonetic: '各',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '骇',
    definition: 'to terrify, to shock, to frighten',
    pinyin: ['hài'],
    decomposition: '⿰马亥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亥',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '骈',
    definition: 'a team of horses; to associate; to join',
    pinyin: ['pián'],
    decomposition: '⿰马并',
    etymology: {
      type: 'ideographic',
      hint: 'A team of horses 马 working together 并',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '骊',
    definition: 'a pure-black horse; a pair of horses',
    pinyin: ['lí'],
    decomposition: '⿰马丽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丽',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '骋',
    definition: 'to gallop, to hasten, to hurry',
    pinyin: ['chěng'],
    decomposition: '⿰马甹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甹',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '验',
    definition: 'to examine, to inspect, to test, to verify',
    pinyin: ['yàn'],
    decomposition: '⿰马佥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '佥',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '骏',
    definition: 'an excellent horse; a noble steed',
    pinyin: ['jùn'],
    decomposition: '⿰马夋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夋',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '骐',
    definition: 'piebald horse; excellent horse',
    pinyin: ['qí'],
    decomposition: '⿰马其',
    etymology: {
      type: 'pictophonetic',
      phonetic: '其',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '骑',
    definition: 'to ride, to mount; cavalry',
    pinyin: ['qí'],
    decomposition: '⿰马奇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奇',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '骒',
    definition: 'mare, jenny',
    pinyin: ['kè'],
    decomposition: '⿰马果',
    etymology: {
      type: 'pictophonetic',
      phonetic: '果',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '骓',
    definition: 'piebald horse',
    pinyin: ['zhuī'],
    decomposition: '⿰马隹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隹',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '骕',
    definition: 'a famous horse',
    pinyin: ['sù'],
    decomposition: '⿰马肃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肃',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '骖',
    definition: 'the two outside horses in a team of four',
    pinyin: ['cān'],
    decomposition: '⿰马参',
    etymology: {
      type: 'pictophonetic',
      phonetic: '参',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '骗',
    definition: 'to cheat, to defraud, to swindle',
    pinyin: ['piàn'],
    decomposition: '⿰马扁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '扁',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '骘',
    definition: 'stallion; to determine; to promote',
    pinyin: ['zhì'],
    decomposition: '⿱陟马',
    etymology: {
      type: 'ideographic',
      hint: 'To climb 陟 on a horse 马; 陟 also provides the pronunciation',
    },
    radical: '马',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '骚',
    definition: 'to annoy, to bother; to disturb, to harrass',
    pinyin: ['sāo'],
    decomposition: '⿰马蚤',
    etymology: {
      type: 'ideographic',
      hint: 'A flea 蚤 biting a horse 马; 蚤 also provides the pronunciation',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '骛',
    definition: 'to gallop, to pursue, to run',
    pinyin: ['wù'],
    decomposition: '⿱敄马',
    etymology: {
      type: 'ideographic',
      hint: 'A horse 马 working hard 敄; 敄 also provides the pronunciation',
    },
    radical: '马',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '骜',
    definition: 'wild horse, mustang; wild, free',
    pinyin: ['ào'],
    decomposition: '⿱敖马',
    etymology: {
      type: 'ideographic',
      hint: 'A rambling 敖 horse 马; 敖 also provides the pronunciation',
    },
    radical: '马',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '骝',
    definition: 'a legendary horse',
    pinyin: ['liú'],
    decomposition: '⿰马留',
    etymology: {
      type: 'pictophonetic',
      phonetic: '留',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '骞',
    definition: 'to lift, to raise; to fly, to soar',
    pinyin: ['qiān'],
    decomposition: '⿳宀？马',
    etymology: {
      type: 'ideographic',
      hint: 'A soldier 宀 mounting a horse 马',
    },
    radical: '马',
    matches: [
      [0],
      [0],
      [0],
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '骟',
    definition: 'to castrate, to geld',
    pinyin: ['shàn'],
    decomposition: '⿰马扇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '扇',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '骠',
    definition: 'charger, steed; swift, valiant',
    pinyin: ['biāo'],
    decomposition: '⿰马票',
    etymology: {
      type: 'pictophonetic',
      phonetic: '票',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '骡',
    definition: 'mule',
    pinyin: ['luó'],
    decomposition: '⿰马累',
    etymology: {
      type: 'pictophonetic',
      phonetic: '累',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '骢',
    definition: 'buckskin horse',
    pinyin: ['cōng'],
    decomposition: '⿰马悤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '悤',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '骣',
    definition: 'wild horse, mustang; wild, free',
    pinyin: ['chǎn'],
    decomposition: '⿰马孱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孱',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '骤',
    definition: 'procedure; sudden, abrupt; to gallop',
    pinyin: ['zhòu'],
    decomposition: '⿰马聚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '聚',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '骥',
    definition: 'a thoroughbred horse; refined, virtuous',
    pinyin: ['jì'],
    decomposition: '⿰马冀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冀',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '骦',
    definition: 'horse',
    pinyin: ['shuāng'],
    decomposition: '⿰马霜',
    etymology: {
      type: 'pictophonetic',
      phonetic: '霜',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '骧',
    definition: 'to gallop about with the head uplifted',
    pinyin: ['xiāng'],
    decomposition: '⿰马襄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '襄',
      semantic: '马',
      hint: 'horse',
    },
    radical: '马',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '骨',
    definition: 'bone; skeleton; frame, framework',
    pinyin: ['gǔ'],
    decomposition: '⿵冎⺼',
    etymology: { type: 'ideographic', hint: 'Flesh ⺼ and bones 冎' },
    radical: '骨',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '骯',
    definition: 'dirty, filthy',
    pinyin: ['āng'],
    decomposition: '⿰骨亢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亢',
      semantic: '骨',
      hint: 'bone',
    },
    radical: '骨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '骰',
    definition: 'die, dice',
    pinyin: ['tóu'],
    decomposition: '⿰骨殳',
    etymology: { type: 'ideographic', hint: 'Tools 殳 made of bone 骨' },
    radical: '骨',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '骱',
    definition: 'skeletal joint',
    pinyin: ['jiè'],
    decomposition: '⿰骨介',
    etymology: {
      type: 'ideographic',
      hint: 'A bony 骨 joint 介; 介 also provides the pronunciation',
    },
    radical: '骨',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '骶',
    definition: 'coccyx, sacrum',
    pinyin: ['dǐ'],
    decomposition: '⿰骨氐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '氐',
      semantic: '骨',
      hint: 'bone',
    },
    radical: '骨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '骷',
    definition: 'skeleton',
    pinyin: ['kū'],
    decomposition: '⿰骨古',
    etymology: {
      type: 'pictophonetic',
      phonetic: '古',
      semantic: '骨',
      hint: 'bone',
    },
    radical: '骨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '骸',
    definition: 'skeleton, body; leg bone',
    pinyin: ['hái'],
    decomposition: '⿰骨亥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亥',
      semantic: '骨',
      hint: 'bone',
    },
    radical: '骨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '骺',
    definition: 'epiphysis; the tip of a long bone',
    pinyin: ['hóu'],
    decomposition: '⿰骨后',
    etymology: {
      type: 'ideographic',
      hint: 'The end 后 of a bone 骨; 后 also provides the pronunciation',
    },
    radical: '骨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '骼',
    definition: 'bone, skeleton; corpse',
    pinyin: ['gé'],
    decomposition: '⿰骨各',
    etymology: {
      type: 'pictophonetic',
      phonetic: '各',
      semantic: '骨',
      hint: 'bone',
    },
    radical: '骨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '髀',
    definition: 'buttocks, thigh; thigh bone',
    pinyin: ['bì'],
    decomposition: '⿰骨卑',
    etymology: {
      type: 'ideographic',
      hint: 'A low 卑 bone 骨; 卑 also provides the pronunciation',
    },
    radical: '骨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '髁',
    definition: 'thigh bone, hip bone, kneecap',
    pinyin: ['kē'],
    decomposition: '⿰骨果',
    etymology: {
      type: 'pictophonetic',
      phonetic: '果',
      semantic: '骨',
      hint: 'bone',
    },
    radical: '骨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '髂',
    definition: 'pelvis, hip bone',
    pinyin: ['qià'],
    decomposition: '⿰骨客',
    etymology: {
      type: 'pictophonetic',
      phonetic: '客',
      semantic: '骨',
      hint: 'bone',
    },
    radical: '骨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '髅',
    definition: 'skull, skeleton',
    pinyin: ['lóu'],
    decomposition: '⿰骨娄',
    etymology: {
      type: 'pictophonetic',
      phonetic: '娄',
      semantic: '骨',
      hint: 'bone',
    },
    radical: '骨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '髋',
    definition: 'hip, pelvis',
    pinyin: ['kuān'],
    decomposition: '⿰骨宽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宽',
      semantic: '骨',
      hint: 'bone',
    },
    radical: '骨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '髌',
    definition: 'kneecap',
    pinyin: ['bìn'],
    decomposition: '⿰骨宾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宾',
      semantic: '骨',
      hint: 'bone',
    },
    radical: '骨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '髑',
    definition: 'skull',
    pinyin: ['dú'],
    decomposition: '⿰骨蜀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蜀',
      semantic: '骨',
      hint: 'bone',
    },
    radical: '骨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '髒',
    definition: 'organs, viscera; dirty, filthy',
    pinyin: ['zàng'],
    decomposition: '⿰骨葬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '葬',
      semantic: '骨',
      hint: 'bone',
    },
    radical: '骨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '髓',
    definition: 'substance, essence; bone marrow',
    pinyin: ['suǐ'],
    decomposition: '⿰骨？',
    etymology: {
      type: 'pictophonetic',
      phonetic: '遀',
      semantic: '骨',
      hint: 'bone',
    },
    radical: '骨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    ],
  },
  {
    character: '體',
    definition: 'body; group, class; form, style, system',
    pinyin: ['tǐ'],
    decomposition: '⿰骨豊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豊',
      semantic: '骨',
      hint: 'bone',
    },
    radical: '骨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '髕',
    definition: 'kneecap',
    pinyin: ['bìn'],
    decomposition: '⿰骨賓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '賓',
      semantic: '骨',
      hint: 'bone',
    },
    radical: '骨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '髖',
    definition: 'hip, pelvis',
    pinyin: ['kuān'],
    decomposition: '⿰骨寬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寬',
      semantic: '骨',
      hint: 'bone',
    },
    radical: '骨',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '高',
    definition: 'tall, lofty; high, elevated',
    pinyin: ['gāo'],
    decomposition: '⿳亠口冋',
    etymology: { type: 'pictographic', hint: 'A tall palace' },
    radical: '高',
    matches: [[0], [0], [1], [1], [1], [2], [2], [2], [2], [2]],
  },
  {
    character: '髟',
    definition: 'long hair',
    pinyin: ['biāo'],
    decomposition: '⿰镸彡',
    etymology: { type: 'ideographic', hint: 'Long 镸 hair 彡' },
    radical: '髟',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '髡',
    definition: 'to shear a tree; an ancient punishment',
    pinyin: ['kūn'],
    decomposition: '⿱髟兀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兀',
      semantic: '髟',
      hint: 'shave',
    },
    radical: '髟',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '髦',
    definition: 'fashionable, in vogue; mane, flowing hair',
    pinyin: ['máo'],
    decomposition: '⿱髟毛',
    etymology: {
      type: 'pictophonetic',
      phonetic: '毛',
      semantic: '髟',
      hint: 'hair',
    },
    radical: '髟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '髫',
    definition: "bangs, children's hairstyle; youngster",
    pinyin: ['tiáo'],
    decomposition: '⿱髟召',
    etymology: {
      type: 'pictophonetic',
      phonetic: '召',
      semantic: '髟',
      hint: 'hair',
    },
    radical: '髟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '髭',
    definition: 'mustache',
    pinyin: ['zī'],
    decomposition: '⿱髟此',
    etymology: {
      type: 'pictophonetic',
      phonetic: '此',
      semantic: '髟',
      hint: 'hair',
    },
    radical: '髟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '髮',
    definition: 'to issue, to dispatch, to send out; hair',
    pinyin: ['fā'],
    decomposition: '⿱髟犮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '犮',
      semantic: '髟',
      hint: 'hair',
    },
    radical: '髟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '髯',
    definition: 'mustache, beard',
    pinyin: ['rán'],
    decomposition: '⿱髟冉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冉',
      semantic: '髟',
      hint: 'hair',
    },
    radical: '髟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '髹',
    definition: 'red lacquer; to lacquer',
    pinyin: ['xiū'],
    decomposition: '⿱髟休',
    etymology: {
      type: 'pictophonetic',
      phonetic: '休',
      semantic: '髟',
      hint: 'hair',
    },
    radical: '髟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '髻',
    definition: 'bun, topknot',
    pinyin: ['jì'],
    decomposition: '⿱髟吉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吉',
      semantic: '髟',
      hint: 'hair',
    },
    radical: '髟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鬃',
    definition: 'mane; neck bristles',
    pinyin: ['zōng'],
    decomposition: '⿱髟宗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宗',
      semantic: '髟',
      hint: 'hair',
    },
    radical: '髟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鬄',
    definition: 'wig',
    pinyin: ['dí'],
    decomposition: '⿱髟易',
    etymology: {
      type: 'ideographic',
      hint: 'To exchange 易 hair 髟; 易 also provides the pronunciation',
    },
    radical: '髟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鬆',
    definition: 'pine tree; fir tree',
    pinyin: ['sōng'],
    decomposition: '⿱髟松',
    etymology: {
      type: 'pictophonetic',
      semantic: '木',
      hint: 'tree',
      phonetic: '公',
    },
    radical: '髟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鬈',
    definition: 'curly hair; fine growth of hair',
    pinyin: ['quán'],
    decomposition: '⿱髟卷',
    etymology: {
      type: 'ideographic',
      hint: 'Curled 卷 hair 髟; 卷 also provides the pronunciation',
    },
    radical: '髟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鬍',
    definition: 'recklessly, foolishly; wildly',
    pinyin: ['hú'],
    decomposition: '⿱髟胡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '胡',
      semantic: '髟',
      hint: 'long hair',
    },
    radical: '髟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鬏',
    definition: 'coiffure, topknot',
    pinyin: ['jiū'],
    decomposition: '⿱髟秋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '秋',
      semantic: '髟',
      hint: 'hair',
    },
    radical: '髟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鬒',
    definition: 'glossy black hair',
    pinyin: ['zhěn'],
    decomposition: '⿱髟真',
    etymology: {
      type: 'pictophonetic',
      phonetic: '真',
      semantic: '髟',
      hint: 'hair',
    },
    radical: '髟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鬓',
    definition: 'hair on temples',
    pinyin: ['bìn'],
    decomposition: '⿱髟宾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '宾',
      semantic: '髟',
      hint: 'hair',
    },
    radical: '髟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鬚',
    definition: 'beard; must; necessary',
    pinyin: ['xū'],
    decomposition: '⿱髟須',
    etymology: {
      type: 'pictophonetic',
      phonetic: '須',
      semantic: '髟',
      hint: 'hair',
    },
    radical: '髟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鬟',
    definition: 'to dress the hair in a coiled knot; maid',
    pinyin: ['huán'],
    decomposition: '⿱髟睘',
    etymology: {
      type: 'ideographic',
      hint: 'A round 睘 topknot 髟; 睘 also provides the pronunciation',
    },
    radical: '髟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鬢',
    definition: 'hair on temples',
    pinyin: ['bìn'],
    decomposition: '⿱髟賓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '賓',
      semantic: '髟',
      hint: 'hair',
    },
    radical: '髟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鬣',
    definition: "a man's whiskers; a horse's mane; a fish's fin",
    pinyin: ['liè'],
    decomposition: '⿱髟巤',
    etymology: {
      type: 'ideographic',
      hint: 'Whiskers 巤 of hair 髟; 巤 also provides the pronunciation',
    },
    radical: '髟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鬥',
    definition: 'to struggle, to fight, to contend; measuring cup',
    pinyin: ['dòu'],
    decomposition: '⿻⿰丨亅⿰王王',
    etymology: { type: 'ideographic', hint: 'Two people 丨 boxing 王' },
    radical: '鬥',
    matches: [
      [0, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [0, 1],
    ],
  },
  {
    character: '鬧',
    definition: 'busy, lively; to dispute, to quarrel',
    pinyin: ['nào'],
    decomposition: '⿵鬥市',
    etymology: {
      type: 'ideographic',
      hint: 'As busy as the market 市 gate 鬥',
    },
    radical: '鬥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鬨',
    definition: 'boisterous; clamor, noise',
    pinyin: ['hòng'],
    decomposition: '⿵鬥共',
    etymology: {
      type: 'pictophonetic',
      phonetic: '共',
      semantic: '鬥',
      hint: 'struggle',
    },
    radical: '鬥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鬩',
    definition: 'feud; to fight, to quarrel',
    pinyin: ['xì'],
    decomposition: '⿵鬥兒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兒',
      semantic: '鬥',
      hint: 'fight',
    },
    radical: '鬥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鬭',
    definition: 'to struggle, to fight; woodwork, carpentry',
    pinyin: ['dòu'],
    decomposition: '⿵鬥斲',
    etymology: {
      type: 'ideographic',
      hint: 'To fight 鬥 with an axe 斲; 鬥 also provides the pronunciation',
    },
    radical: '鬥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鬮',
    definition: 'chance, risk; to draw lots',
    pinyin: ['jiū'],
    decomposition: '⿵鬥龜',
    radical: '鬥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鬯',
    definition: 'sacrificial wine; unhindered',
    pinyin: ['chàng'],
    decomposition: '⿱？匕',
    radical: '鬯',
    matches: [null, null, null, null, null, null, null, null, [1], [1]],
  },
  {
    character: '鬱',
    definition: 'melancholy; dense growth',
    pinyin: ['yù'],
    decomposition: '⿱⿻林缶⿱冖⿰鬯彡',
    etymology: {
      type: 'pictophonetic',
      phonetic: '缶',
      semantic: '林',
      hint: 'forest',
    },
    radical: '鬯',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [1, 0],
      [1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
    ],
  },
  {
    character: '鬲',
    definition: 'earthen pot, iron cauldron',
    pinyin: ['gé'],
    decomposition: '⿳一口⿵冂⿱丷？',
    etymology: {
      type: 'pictographic',
      hint: 'A cauldron 口 with three legs 冂丷',
    },
    radical: '鬲',
    matches: [
      [0],
      [1],
      [1],
      [1],
      [2, 0],
      [2, 0],
      [2, 1, 0],
      [2, 1, 0],
      null,
      null,
    ],
  },
  {
    character: '鬳',
    pinyin: ['yàn'],
    decomposition: '⿸虍鬲',
    radical: '鬲',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鬻',
    definition: 'to vend, sell',
    pinyin: ['yù'],
    decomposition: '⿱粥鬲',
    etymology: {
      type: 'ideographic',
      hint: 'To sell porridge 粥 steaming in a pot 鬲',
    },
    radical: '鬲',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鬼',
    definition: 'ghost; demon; sly, mischievous',
    pinyin: ['guǐ'],
    decomposition: '⿸？⿺乚厶',
    etymology: { type: 'pictographic', hint: 'A ghost with a scary face' },
    radical: '鬼',
    matches: [null, null, null, null, null, null, [1, 0], [1, 1], [1, 1]],
  },
  {
    character: '魁',
    definition: 'chief, leader; best; monstrous',
    pinyin: ['kuí'],
    decomposition: '⿺鬼斗',
    etymology: {
      type: 'ideographic',
      hint: 'One who fought 斗 a ghost 鬼; 鬼 also provides the pronunciation',
    },
    radical: '鬼',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '魂',
    definition: 'soul, spirit',
    pinyin: ['hún'],
    decomposition: '⿰云鬼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '云',
      semantic: '鬼',
      hint: 'spirit',
    },
    radical: '鬼',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '魃',
    definition: 'drought demon',
    pinyin: ['bá'],
    decomposition: '⿺鬼犮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '犮',
      semantic: '鬼',
      hint: 'demon',
    },
    radical: '鬼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '魄',
    definition: 'vigor, soul, body; the dark side of the moon',
    pinyin: ['pò'],
    decomposition: '⿰白鬼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '白',
      semantic: '鬼',
      hint: 'spirit',
    },
    radical: '鬼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '魅',
    definition: 'magic, enchantment, charm; a forest demon',
    pinyin: ['mèi'],
    decomposition: '⿺鬼未',
    etymology: {
      type: 'ideographic',
      hint: 'A forest 未 demon 鬼; 未 also provides the pronunciation',
    },
    radical: '鬼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '魆',
    definition: 'black; sudden; to beguile',
    pinyin: ['xū'],
    decomposition: '⿺鬼戉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '戉',
      semantic: '鬼',
      hint: 'demon',
    },
    radical: '鬼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '魇',
    definition: 'nightmare, bad dream',
    pinyin: ['yǎn'],
    decomposition: '⿸厌鬼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厌',
      semantic: '鬼',
      hint: 'ghost',
    },
    radical: '鬼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '魈',
    definition: 'mischievious mountain spirit',
    pinyin: ['xiāo'],
    decomposition: '⿺鬼肖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肖',
      semantic: '鬼',
      hint: 'demon',
    },
    radical: '鬼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '魉',
    definition: 'a kind of monster',
    pinyin: ['liǎng'],
    decomposition: '⿺鬼两',
    etymology: {
      type: 'pictophonetic',
      phonetic: '两',
      semantic: '鬼',
      hint: 'ghost',
    },
    radical: '鬼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '魍',
    definition: 'demon, mountain spirit',
    pinyin: ['wǎng'],
    decomposition: '⿺鬼罔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '罔',
      semantic: '鬼',
      hint: 'demon',
    },
    radical: '鬼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '魎',
    definition: 'a kind of monster',
    pinyin: ['liǎng'],
    decomposition: '⿺鬼兩',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兩',
      semantic: '鬼',
      hint: 'ghost',
    },
    radical: '鬼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '魏',
    definition: 'the kingdom of Wei; surname',
    pinyin: ['wèi'],
    decomposition: '⿰委鬼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '委',
      semantic: '鬼',
      hint: 'ghost',
    },
    radical: '鬼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '魑',
    definition: 'a mountain demon resembling a tiger',
    pinyin: ['chī'],
    decomposition: '⿺鬼离',
    etymology: {
      type: 'pictophonetic',
      phonetic: '离',
      semantic: '鬼',
      hint: 'demon',
    },
    radical: '鬼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '魔',
    definition: 'demon, evil spirit; magic, spell',
    pinyin: ['mó'],
    decomposition: '⿸麻鬼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '麻',
      semantic: '鬼',
      hint: 'demon',
    },
    radical: '鬼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '魖',
    definition: 'black',
    pinyin: ['xū'],
    decomposition: '⿺鬼虚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '虚',
      semantic: '鬼',
      hint: 'black',
    },
    radical: '鬼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '魘',
    definition: 'nightmare, bad dream',
    pinyin: ['yǎn'],
    decomposition: '⿸厭鬼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厭',
      semantic: '鬼',
      hint: 'ghost',
    },
    radical: '鬼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '魚',
    definition: 'fish',
    pinyin: ['yú'],
    decomposition: '⿱⿱⺈田灬',
    etymology: { type: 'pictographic', hint: 'A fish swimming upwards' },
    radical: '魚',
    matches: [
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '魝',
    pinyin: ['jié'],
    decomposition: '⿰魚刂',
    radical: '魚',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '魠',
    definition: 'Japanese mackerel',
    pinyin: ['tuō'],
    decomposition: '⿰魚乇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乇',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '魯',
    definition: 'foolish, stupid, rash; vulgar',
    pinyin: ['lǔ'],
    decomposition: '⿱魚日',
    etymology: { type: 'ideographic', hint: 'To talk 日 like a fish 魚' },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '魷',
    definition: 'cuttlefish',
    pinyin: ['yóu'],
    decomposition: '⿰魚尤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尤',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鮃',
    definition: 'sole',
    pinyin: ['píng'],
    decomposition: '⿰魚平',
    etymology: {
      type: 'pictophonetic',
      phonetic: '平',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鮑',
    definition: 'abalone; dried fish; surname',
    pinyin: ['bào'],
    decomposition: '⿰魚包',
    etymology: {
      type: 'pictophonetic',
      phonetic: '包',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鮨',
    definition: 'sushi; seasoned rice mixed with fish',
    pinyin: ['yì'],
    decomposition: '⿰魚旨',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旨',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鮪',
    definition: 'little tuna; Euthynnus alletteratus',
    pinyin: ['wěi'],
    decomposition: '⿰魚有',
    etymology: {
      type: 'pictophonetic',
      phonetic: '有',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鮫',
    definition: 'shark',
    pinyin: ['jiāo'],
    decomposition: '⿰魚交',
    etymology: {
      type: 'pictophonetic',
      phonetic: '交',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鮭',
    definition: 'salmon; Spheroides vermicularis',
    pinyin: ['guī'],
    decomposition: '⿰魚圭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '圭',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鮮',
    definition: 'fresh; delicious; attractive',
    pinyin: ['xiān'],
    decomposition: '⿰魚羊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羊',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鯇',
    definition: 'carp',
    pinyin: ['huàn'],
    decomposition: '⿰魚完',
    etymology: {
      type: 'pictophonetic',
      phonetic: '完',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鯉',
    definition: 'carp',
    pinyin: ['lǐ'],
    decomposition: '⿰魚里',
    etymology: {
      type: 'pictophonetic',
      phonetic: '里',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鯊',
    definition: 'shark',
    pinyin: ['shā'],
    decomposition: '⿱沙魚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '沙',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鯔',
    definition: 'mullet',
    pinyin: ['zī'],
    decomposition: '⿰魚甾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甾',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鯕',
    definition: 'ray-finned fish; Coryphaena hippurus',
    pinyin: ['qí'],
    decomposition: '⿰魚其',
    etymology: {
      type: 'pictophonetic',
      phonetic: '其',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鯖',
    definition: 'mackerel',
    pinyin: ['qīng'],
    decomposition: '⿰魚青',
    etymology: {
      type: 'pictophonetic',
      phonetic: '青',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鯗',
    definition: 'dried fish',
    pinyin: ['xiǎng'],
    decomposition: '⿱羊魚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羊',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      null,
      null,
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鯛',
    definition: 'porgy; Pagrosomus major',
    pinyin: ['diāo'],
    decomposition: '⿰魚周',
    etymology: {
      type: 'pictophonetic',
      phonetic: '周',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鯡',
    definition: 'herring',
    pinyin: ['fēi'],
    decomposition: '⿰魚非',
    etymology: {
      type: 'pictophonetic',
      phonetic: '非',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鯢',
    definition: 'salamander; Cryptobranchus japonicus',
    pinyin: ['ní'],
    decomposition: '⿰魚兒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兒',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鯤',
    definition: 'spawn; roe; fry',
    pinyin: ['kūn'],
    decomposition: '⿰魚昆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昆',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鯧',
    definition: 'silvery pomfret, Stromateoides argenteus',
    pinyin: ['chāng'],
    decomposition: '⿰魚昌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昌',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鯨',
    definition: 'whale',
    pinyin: ['jīng'],
    decomposition: '⿰魚京',
    etymology: {
      type: 'pictophonetic',
      phonetic: '京',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鯪',
    definition: 'carp',
    pinyin: ['líng'],
    decomposition: '⿰魚夌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夌',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鯫',
    definition: 'small fish; small; minnow',
    pinyin: ['zōu'],
    decomposition: '⿰魚取',
    etymology: {
      type: 'pictophonetic',
      phonetic: '魚',
      semantic: '取',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鯰',
    definition: 'sheatfish',
    pinyin: ['nián'],
    decomposition: '⿰魚念',
    etymology: {
      type: 'pictophonetic',
      phonetic: '念',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鯷',
    definition: 'anchovy',
    pinyin: ['tí'],
    decomposition: '⿰魚是',
    etymology: {
      type: 'pictophonetic',
      phonetic: '是',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鯽',
    definition: 'crucian carp; Carassius auratus',
    pinyin: ['jì'],
    decomposition: '⿰魚即',
    etymology: {
      type: 'pictophonetic',
      phonetic: '即',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鰂',
    definition: 'cuttlefish',
    pinyin: ['zéi'],
    decomposition: '⿰魚則',
    etymology: {
      type: 'pictophonetic',
      phonetic: '則',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鰆',
    definition: 'a kind of long, flat, silver-gray striped fish',
    pinyin: ['chūn'],
    decomposition: '⿰魚春',
    etymology: {
      type: 'pictophonetic',
      phonetic: '春',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鰈',
    definition: 'flatfish; flounder; sole',
    pinyin: ['dié'],
    decomposition: '⿰魚枼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '枼',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鰓',
    definition: 'fish gills',
    pinyin: ['sāi'],
    decomposition: '⿰魚思',
    etymology: {
      type: 'pictophonetic',
      phonetic: '思',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鰟',
    definition: 'carp',
    pinyin: ['páng'],
    decomposition: '⿰魚旁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旁',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鰣',
    definition: "Reeves' shad; hilsa herring",
    pinyin: ['shí'],
    decomposition: '⿰魚時',
    etymology: {
      type: 'pictophonetic',
      phonetic: '時',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鰥',
    definition: 'huge fish; widower; bachelor',
    pinyin: ['guān'],
    decomposition: '⿰魚眔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '眔',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鰭',
    definition: 'fin',
    pinyin: ['qí'],
    decomposition: '⿰魚耆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '耆',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鰱',
    definition: 'silver carp, hypophthalmiathys',
    pinyin: ['lián'],
    decomposition: '⿰魚連',
    etymology: {
      type: 'pictophonetic',
      phonetic: '連',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鰲',
    definition: 'huge sea turtle',
    pinyin: ['áo'],
    decomposition: '⿱敖魚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敖',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鰹',
    definition: 'skipjack, bonito',
    pinyin: ['jiān'],
    decomposition: '⿰魚堅',
    etymology: {
      type: 'pictophonetic',
      phonetic: '堅',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鰻',
    definition: 'eel',
    pinyin: ['mán'],
    decomposition: '⿰魚曼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曼',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鰾',
    definition: 'swim bladder',
    pinyin: ['biào'],
    decomposition: '⿰魚票',
    etymology: {
      type: 'pictophonetic',
      phonetic: '票',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鱀',
    definition: 'Chinese river dolphin',
    pinyin: ['jì'],
    decomposition: '⿱既魚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '既',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鱄',
    definition: 'anchovy',
    pinyin: ['zhuān'],
    decomposition: '⿰魚專',
    etymology: {
      type: 'pictophonetic',
      phonetic: '專',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鱅',
    definition: 'bighead',
    pinyin: ['yōng'],
    decomposition: '⿰魚庸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '庸',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鱆',
    definition: 'octopus, devilfish',
    pinyin: ['zhāng'],
    decomposition: '⿰魚章',
    etymology: {
      type: 'pictophonetic',
      phonetic: '章',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鱈',
    definition: 'codfish',
    pinyin: ['xuě'],
    decomposition: '⿰魚雪',
    etymology: {
      type: 'pictophonetic',
      phonetic: '雪',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鱉',
    definition: 'turtle',
    pinyin: ['biē'],
    decomposition: '⿱敝魚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敝',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鱒',
    definition: 'barbel',
    pinyin: ['zūn'],
    decomposition: '⿰魚尊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尊',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鱔',
    definition: 'eel',
    pinyin: ['shàn'],
    decomposition: '⿰魚善',
    etymology: {
      type: 'pictophonetic',
      phonetic: '善',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鱖',
    definition: 'mandarin fish',
    pinyin: ['guì'],
    decomposition: '⿰魚厥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厥',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鱗',
    definition: 'fish scales',
    pinyin: ['lín'],
    decomposition: '⿰魚粦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '粦',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鱘',
    definition: 'sturgeon',
    pinyin: ['xún'],
    decomposition: '⿰魚尋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尋',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鱠',
    definition: 'minced fish; hash',
    pinyin: ['kuài'],
    decomposition: '⿰魚會',
    etymology: {
      type: 'pictophonetic',
      phonetic: '會',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鱣',
    definition: 'sturgeon',
    pinyin: ['zhān'],
    decomposition: '⿰魚亶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亶',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鱥',
    definition: 'minnow',
    pinyin: ['guì'],
    decomposition: '⿰魚歲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '歲',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鱧',
    definition: 'snakehead',
    pinyin: ['lǐ'],
    decomposition: '⿰魚豊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豊',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鱷',
    definition: 'alligator',
    pinyin: ['è'],
    decomposition: '⿰魚噩',
    etymology: {
      type: 'pictophonetic',
      phonetic: '噩',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鱸',
    definition: 'perch; sea bass',
    pinyin: ['lú'],
    decomposition: '⿰魚盧',
    etymology: {
      type: 'pictophonetic',
      phonetic: '盧',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鱺',
    definition: 'eel',
    pinyin: ['lí'],
    decomposition: '⿰魚麗',
    etymology: {
      type: 'pictophonetic',
      phonetic: '麗',
      semantic: '魚',
      hint: 'fish',
    },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鱻',
    definition: 'fresh, delicious; rare, few',
    pinyin: ['xiān'],
    decomposition: '⿱魚⿰魚魚',
    etymology: { type: 'ideographic', hint: 'A fresh catch of fish 魚' },
    radical: '魚',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '鱼',
    definition: 'fish',
    pinyin: ['yú'],
    decomposition: '⿱⿱⺈田一',
    etymology: { type: 'pictographic', hint: 'A fish swimming upwards' },
    radical: '鱼',
    matches: [[0, 0], [0, 0], [0, 1], [0, 1], [0, 1], [0, 1], [0, 1], [1]],
  },
  {
    character: '鱿',
    definition: 'cuttlefish',
    pinyin: ['yóu'],
    decomposition: '⿰鱼尤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尤',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '鲁',
    definition: 'foolish, stupid, rash; vulgar',
    pinyin: ['lǔ'],
    decomposition: '⿱鱼日',
    etymology: { type: 'ideographic', hint: 'To talk 日 like a fish 鱼' },
    radical: '鱼',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '鲂',
    definition: 'bream',
    pinyin: ['fáng'],
    decomposition: '⿰鱼方',
    etymology: {
      type: 'pictophonetic',
      phonetic: '方',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '鲃',
    definition: 'shark; bonito',
    pinyin: ['bā'],
    decomposition: '⿰鱼巴',
    etymology: {
      type: 'pictophonetic',
      phonetic: '巴',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '鲅',
    definition: 'Chinese mackerel',
    pinyin: ['bà'],
    decomposition: '⿰鱼犮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '犮',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鲆',
    definition: 'sole',
    pinyin: ['píng'],
    decomposition: '⿰鱼平',
    etymology: {
      type: 'pictophonetic',
      phonetic: '平',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鲇',
    definition: 'sheatfish; Parasilurus asotus',
    pinyin: ['nián'],
    decomposition: '⿰鱼占',
    etymology: {
      type: 'pictophonetic',
      phonetic: '占',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鲈',
    definition: 'perch; sea bass',
    pinyin: ['lú'],
    decomposition: '⿰鱼卢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卢',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鲋',
    definition: 'carp; Carassicus auratus',
    pinyin: ['fù'],
    decomposition: '⿰鱼付',
    etymology: {
      type: 'pictophonetic',
      phonetic: '付',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鲍',
    definition: 'abalone; dried fish; surname',
    pinyin: ['bào'],
    decomposition: '⿰鱼包',
    etymology: {
      type: 'pictophonetic',
      phonetic: '包',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鲎',
    definition: 'king crab',
    pinyin: ['hòu'],
    decomposition: '⿳⺍冖鱼',
    etymology: { type: 'pictophonetic', semantic: '鱼', hint: 'fish' },
    radical: '鱼',
    matches: [[0], [0], [0], [1], [1], [2], [2], [2], [2], [2], [2], [2], [2]],
  },
  {
    character: '鲐',
    definition: 'mackerel; Pneumatophorus japonicus',
    pinyin: ['tái'],
    decomposition: '⿰鱼台',
    etymology: {
      type: 'pictophonetic',
      phonetic: '台',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鲑',
    definition: 'salmon; Spheroides vermicularis',
    pinyin: ['guī'],
    decomposition: '⿰鱼圭',
    etymology: {
      type: 'pictophonetic',
      phonetic: '圭',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲒',
    definition: 'clam; oyster',
    pinyin: ['jié'],
    decomposition: '⿰鱼吉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吉',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲔',
    definition: 'little tuna; Euthynnus alletteratus',
    pinyin: ['wěi'],
    decomposition: '⿰鱼有',
    etymology: {
      type: 'pictophonetic',
      phonetic: '有',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲕',
    definition: 'roe',
    pinyin: ['ér'],
    decomposition: '⿰鱼而',
    etymology: {
      type: 'pictophonetic',
      phonetic: '而',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲗',
    definition: 'cuttlefish',
    pinyin: ['zéi'],
    decomposition: '⿰鱼则',
    etymology: {
      type: 'pictophonetic',
      phonetic: '则',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲙',
    definition: 'minced fish; hash',
    pinyin: ['kuài'],
    decomposition: '⿰鱼会',
    etymology: {
      type: 'pictophonetic',
      phonetic: '会',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲚',
    definition: 'anchovy',
    pinyin: ['jì'],
    decomposition: '⿰鱼齐',
    etymology: {
      type: 'pictophonetic',
      phonetic: '齐',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲛',
    definition: 'shark',
    pinyin: ['jiāo'],
    decomposition: '⿰鱼交',
    etymology: {
      type: 'pictophonetic',
      phonetic: '交',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲜',
    definition: 'fresh; delicious; attractive',
    pinyin: ['xiān'],
    decomposition: '⿰鱼羊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '羊',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲞',
    definition: 'dried fish',
    pinyin: ['xiǎng'],
    decomposition: '⿱龹鱼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龹',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲟',
    definition: 'sturgeon',
    pinyin: ['xún'],
    decomposition: '⿰鱼寻',
    etymology: {
      type: 'pictophonetic',
      phonetic: '寻',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲠',
    definition: 'fish bones; honest, upright',
    pinyin: ['gěng'],
    decomposition: '⿰鱼更',
    etymology: {
      type: 'pictophonetic',
      phonetic: '更',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲡',
    definition: 'eel',
    pinyin: ['lí'],
    decomposition: '⿰鱼丽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丽',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲢',
    definition: 'silver carp, hypophthalmiathys',
    pinyin: ['lián'],
    decomposition: '⿰鱼连',
    etymology: {
      type: 'pictophonetic',
      phonetic: '连',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲣',
    definition: 'skipjack, bonito',
    pinyin: ['jiān'],
    decomposition: '⿰鱼坚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '坚',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲤',
    definition: 'carp',
    pinyin: ['lǐ'],
    decomposition: '⿰鱼里',
    etymology: {
      type: 'pictophonetic',
      phonetic: '里',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲥',
    definition: "Reeves' shad; hilsa herring",
    pinyin: ['shí'],
    decomposition: '⿰鱼时',
    etymology: {
      type: 'pictophonetic',
      phonetic: '时',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲦',
    definition: 'minnow',
    pinyin: ['tiáo'],
    decomposition: '⿰鱼条',
    etymology: {
      type: 'pictophonetic',
      phonetic: '条',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲧',
    definition: 'giant fish; Gun, mythical father of the emperor Yu',
    pinyin: ['gǔn'],
    decomposition: '⿰鱼系',
    etymology: {
      type: 'pictophonetic',
      phonetic: '系',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲨',
    definition: 'shark',
    pinyin: ['shā'],
    decomposition: '⿱沙鱼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '沙',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲩',
    definition: 'carp',
    pinyin: ['huàn'],
    decomposition: '⿰鱼完',
    etymology: {
      type: 'pictophonetic',
      phonetic: '完',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲫',
    definition: 'crucian carp; Carassius auratus',
    pinyin: ['jì'],
    decomposition: '⿰鱼即',
    etymology: {
      type: 'pictophonetic',
      phonetic: '即',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲭',
    definition: 'mackerel',
    pinyin: ['qīng'],
    decomposition: '⿰鱼青',
    etymology: {
      type: 'pictophonetic',
      phonetic: '青',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲮',
    definition: 'carp',
    pinyin: ['líng'],
    decomposition: '⿰鱼夌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夌',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲯',
    definition: 'ray-finned fish; Coryphaena hippurus',
    pinyin: ['qí'],
    decomposition: '⿰鱼其',
    etymology: {
      type: 'pictophonetic',
      phonetic: '其',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲰',
    definition: 'small fish; small; minnow',
    pinyin: ['zōu'],
    decomposition: '⿰鱼取',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鱼',
      semantic: '取',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲱',
    definition: 'herring',
    pinyin: ['fēi'],
    decomposition: '⿰鱼非',
    etymology: {
      type: 'pictophonetic',
      phonetic: '非',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲲',
    definition: 'spawn; roe; fry',
    pinyin: ['kūn'],
    decomposition: '⿰鱼昆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昆',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲳',
    definition: 'silvery pomfret, Stromateoides argenteus',
    pinyin: ['chāng'],
    decomposition: '⿰鱼昌',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昌',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲴',
    definition: 'fish guts',
    pinyin: ['gù'],
    decomposition: '⿰鱼固',
    etymology: {
      type: 'pictophonetic',
      phonetic: '固',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲵',
    definition: 'salamander; Cryptobranchus japonicus',
    pinyin: ['ní'],
    decomposition: '⿰鱼兒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兒',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲶',
    definition: 'catfish; sheat',
    pinyin: ['nián'],
    decomposition: '⿰鱼念',
    etymology: {
      type: 'pictophonetic',
      phonetic: '念',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲷',
    definition: 'porgy; Pagrosomus major',
    pinyin: ['diāo'],
    decomposition: '⿰鱼周',
    etymology: {
      type: 'pictophonetic',
      phonetic: '周',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲸',
    definition: 'whale',
    pinyin: ['jīng'],
    decomposition: '⿰鱼京',
    etymology: {
      type: 'pictophonetic',
      phonetic: '京',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲺',
    definition: 'cat fish',
    pinyin: ['shī'],
    decomposition: '⿰鱼虱',
    etymology: {
      type: 'pictophonetic',
      phonetic: '虱',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲻',
    definition: 'mullet',
    pinyin: ['zī'],
    decomposition: '⿰鱼甾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甾',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲼',
    definition: 'fish',
    pinyin: ['fèn'],
    decomposition: '⿰鱼贲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '贲',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鲽',
    definition: 'flatfish; flounder; sole',
    pinyin: ['dié'],
    decomposition: '⿰鱼枼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '枼',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鳀',
    definition: 'anchovy',
    pinyin: ['tí'],
    decomposition: '⿰鱼是',
    etymology: {
      type: 'pictophonetic',
      phonetic: '是',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鳃',
    definition: 'fish gills',
    pinyin: ['sāi'],
    decomposition: '⿰鱼思',
    etymology: {
      type: 'pictophonetic',
      phonetic: '思',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鳄',
    definition: 'alligator',
    pinyin: ['è'],
    decomposition: '⿰鱼咢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咢',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鳅',
    definition: 'loach',
    pinyin: ['qiū'],
    decomposition: '⿰鱼秋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '秋',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鳆',
    definition: 'abalone',
    pinyin: ['fù'],
    decomposition: '⿰鱼复',
    etymology: {
      type: 'pictophonetic',
      phonetic: '复',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鳇',
    definition: 'sturgeon',
    pinyin: ['huáng'],
    decomposition: '⿰鱼皇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皇',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鳊',
    definition: 'bream',
    pinyin: ['biān'],
    decomposition: '⿰鱼扁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '扁',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鳋',
    definition: 'carp',
    pinyin: ['sāo'],
    decomposition: '⿰鱼蚤',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蚤',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鳌',
    definition: 'huge sea turtle',
    pinyin: ['áo'],
    decomposition: '⿱敖鱼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敖',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鳍',
    definition: 'fin',
    pinyin: ['qí'],
    decomposition: '⿰鱼耆',
    etymology: {
      type: 'pictophonetic',
      phonetic: '耆',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鳎',
    definition: 'sole',
    pinyin: ['tǎ'],
    decomposition: '⿰鱼⿱日羽',
    etymology: { type: 'pictophonetic', semantic: '鱼', hint: 'fish' },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '鳏',
    definition: 'huge fish; widower; bachelor',
    pinyin: ['guān'],
    decomposition: '⿰鱼眔',
    etymology: {
      type: 'pictophonetic',
      phonetic: '眔',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鳐',
    definition: 'the nautilus; the ray',
    pinyin: ['yáo'],
    decomposition: '⿰鱼䍃',
    etymology: {
      type: 'pictophonetic',
      phonetic: '䍃',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鳑',
    definition: 'carp',
    pinyin: ['páng'],
    decomposition: '⿰鱼旁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '旁',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鳓',
    definition: 'Chinese herring; shad',
    pinyin: ['lè'],
    decomposition: '⿰鱼勒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '勒',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鳔',
    definition: 'swim bladder',
    pinyin: ['biào'],
    decomposition: '⿰鱼票',
    etymology: {
      type: 'pictophonetic',
      phonetic: '票',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鳕',
    definition: 'codfish',
    pinyin: ['xuě'],
    decomposition: '⿰鱼雪',
    etymology: {
      type: 'pictophonetic',
      phonetic: '雪',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鳖',
    definition: 'turtle',
    pinyin: ['biē'],
    decomposition: '⿱敝鱼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敝',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鳗',
    definition: 'eel',
    pinyin: ['mán'],
    decomposition: '⿰鱼曼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曼',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鳘',
    definition: 'codfish',
    pinyin: ['mǐn'],
    decomposition: '⿱敏鱼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敏',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鳙',
    definition: 'bighead',
    pinyin: ['yōng'],
    decomposition: '⿰鱼庸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '庸',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鳜',
    definition: 'mandarin fish',
    pinyin: ['guì'],
    decomposition: '⿰鱼厥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '厥',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鳝',
    definition: 'eel',
    pinyin: ['shàn'],
    decomposition: '⿰鱼善',
    etymology: {
      type: 'pictophonetic',
      phonetic: '善',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鳞',
    definition: 'fish scales',
    pinyin: ['lín'],
    decomposition: '⿰鱼粦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '粦',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鳟',
    definition: 'barbel',
    pinyin: ['zūn'],
    decomposition: '⿰鱼尊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尊',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鳢',
    definition: 'snakehead',
    pinyin: ['lǐ'],
    decomposition: '⿰鱼豊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '豊',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鳣',
    definition: 'sturgeon',
    pinyin: ['zhān'],
    decomposition: '⿰鱼亶',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亶',
      semantic: '鱼',
      hint: 'fish',
    },
    radical: '鱼',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鳥',
    definition: 'bird',
    pinyin: ['niǎo'],
    decomposition: '⿹？灬',
    etymology: { type: 'pictographic', hint: 'A bird' },
    radical: '鳥',
    matches: [null, null, null, null, null, null, null, [1], [1], [1], [1]],
  },
  {
    character: '鳧',
    definition: 'wild duck; teal; swim',
    pinyin: ['fú'],
    decomposition: '⿱鳥几',
    etymology: {
      type: 'pictophonetic',
      semantic: '鳥',
      hint: 'bird',
      phonetic: '凡',
    },
    radical: '鳥',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '鳩',
    definition: 'pigeon; to collect, to assemble',
    pinyin: ['jiū'],
    decomposition: '⿰九鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '九',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [[0], [0], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '鳳',
    definition: 'male phoenix; symbol of joy',
    pinyin: ['fèng'],
    decomposition: '⿵几⿱一鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '凡',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '鳴',
    definition: 'a bird call or animal cry; to make a sound',
    pinyin: ['míng'],
    decomposition: '⿰口鳥',
    etymology: { type: 'ideographic', hint: 'The sound 口 a bird 鳥 makes' },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鳶',
    definition: 'kite; Milvus species (various)',
    pinyin: ['yuān'],
    decomposition: '⿱弋鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弋',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鴂',
    definition: 'tailorbird; working bird',
    pinyin: ['jué'],
    decomposition: '⿰夬鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夬',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鴆',
    definition: 'a bird resembling the secretary falcon',
    pinyin: ['zhèn'],
    decomposition: '⿰冘鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冘',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鴇',
    definition: 'bustard; procuress; Otis species (various)',
    pinyin: ['bǎo'],
    decomposition: '⿰⿱匕十鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匕',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鴈',
    definition: 'wild goose',
    pinyin: ['yàn'],
    decomposition: '⿸厂⿰亻鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '亻',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '鴉',
    definition: 'crow; Corvus species (various)',
    pinyin: ['yā'],
    decomposition: '⿰牙鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '牙',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鴒',
    definition: 'lark, wagtail; Motacilla species (various)',
    pinyin: ['líng'],
    decomposition: '⿰令鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '令',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鴔',
    definition: 'hoopoe, crested bird',
    pinyin: ['fú'],
    decomposition: '⿰乏鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乏',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鴕',
    definition: 'ostrich',
    pinyin: ['tuó'],
    decomposition: '⿰鳥它',
    etymology: {
      type: 'pictophonetic',
      phonetic: '它',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鴛',
    definition: 'male mandarin duck (Aix galericulata)',
    pinyin: ['yuān'],
    decomposition: '⿱夗鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夗',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鴞',
    definition: 'owl',
    pinyin: ['xiāo'],
    decomposition: '⿰号鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '号',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鴟',
    definition: 'kite, horned owl; wine cups',
    pinyin: ['chī'],
    decomposition: '⿰氐鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '氐',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鴣',
    definition: 'species of Taiwan pigeon',
    pinyin: ['gū'],
    decomposition: '⿰古鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '古',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鴦',
    definition: 'female mandarin duck (Aix galericulata)',
    pinyin: ['yāng'],
    decomposition: '⿱央鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '央',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鴨',
    definition: 'duck; Anas species (various)',
    pinyin: ['yā'],
    decomposition: '⿰甲鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甲',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鴯',
    definition: 'swallow',
    pinyin: ['ér'],
    decomposition: '⿰而鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '而',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鴰',
    definition: 'crow',
    pinyin: ['guā'],
    decomposition: '⿰舌鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '舌',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鴴',
    definition: 'plover, wading bird',
    pinyin: ['héng'],
    decomposition: '⿰行鳥',
    etymology: {
      type: 'ideographic',
      hint: 'A wading 行 bird 鳥; 鳥 also provides the pronunciation',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鴻',
    definition: 'a species of wild swan; vast',
    pinyin: ['hóng'],
    decomposition: '⿰江鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '江',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鴿',
    definition: 'pigeon, dove; Columba species (various)',
    pinyin: ['gē'],
    decomposition: '⿰合鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '合',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鵂',
    definition: 'horned owl, scops chinensis',
    pinyin: ['xiū'],
    decomposition: '⿰休鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '休',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鵑',
    definition: 'cuckoo',
    pinyin: ['juān'],
    decomposition: '⿰肙鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肙',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鵒',
    definition: 'mynah; Acridotheres tristis',
    pinyin: ['yù'],
    decomposition: '⿰谷鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '谷',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鵓',
    definition: 'a species of pigeon',
    pinyin: ['bó'],
    decomposition: '⿰孛鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孛',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鵜',
    definition: 'pelican',
    pinyin: ['tí'],
    decomposition: '⿰弟鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弟',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鵠',
    definition: 'swan',
    pinyin: ['gǔ'],
    decomposition: '⿰告鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '告',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鵡',
    definition: 'species of parrot',
    pinyin: ['wǔ'],
    decomposition: '⿰武鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '武',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鵪',
    definition: 'quail; Coturnix coturnix',
    pinyin: ['ān'],
    decomposition: '⿰奄鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奄',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鵬',
    definition: 'fabulous bird of enormous size',
    pinyin: ['péng'],
    decomposition: '⿰朋鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朋',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鵯',
    definition: 'bulbul, songbird; Pycnonotidae',
    pinyin: ['bēi'],
    decomposition: '⿰卑鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卑',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鵰',
    definition: 'eagle, vulture',
    pinyin: ['diāo'],
    decomposition: '⿰周鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '周',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鵲',
    definition: 'magpie; Pica species (various)',
    pinyin: ['què'],
    decomposition: '⿰昔鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昔',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鵾',
    definition: 'a bird resembling a crane',
    pinyin: ['kūn'],
    decomposition: '⿰昆鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昆',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鶇',
    definition: 'thrush; Turdus species (various)',
    pinyin: ['dōng'],
    decomposition: '⿰東鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '東',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鶉',
    definition: 'quail; Turnix species (various)',
    pinyin: ['chún'],
    decomposition: '⿰享鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '享',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鶊',
    definition: 'oriole',
    pinyin: ['gēng'],
    decomposition: '⿰庚鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '庚',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鶓',
    definition: 'emu',
    pinyin: ['miáo'],
    decomposition: '⿰苗鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '苗',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鶖',
    definition: 'waterfowl; Garrulus glandarius',
    pinyin: ['qiū'],
    decomposition: '⿱秋鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '秋',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鶘',
    definition: 'pelican',
    pinyin: ['hú'],
    decomposition: '⿰胡鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '胡',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鶚',
    definition: 'osprey, fishhawk',
    pinyin: ['è'],
    decomposition: '⿰咢鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咢',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鶩',
    definition: 'duck',
    pinyin: ['wù'],
    decomposition: '⿱敄鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敄',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鶬',
    definition: 'oriole',
    pinyin: ['cāng'],
    decomposition: '⿰倉鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '倉',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鶯',
    definition: 'oriole, green finch; Sylvia species (various)',
    pinyin: ['yīng'],
    decomposition: '⿳炏冖鳥',
    etymology: {
      type: 'ideographic',
      hint: 'A bird 鳥 covered in 冖 green 炏 feathers',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '鶴',
    definition: 'crane; Grus species (various)',
    pinyin: ['hè'],
    decomposition: '⿰隺鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隺',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鶹',
    definition: 'owl',
    pinyin: ['liú'],
    decomposition: '⿰留鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '留',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鶺',
    definition: 'wagtail',
    pinyin: ['jí'],
    decomposition: '⿰脊鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '脊',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鶻',
    definition: 'a kind of pigeon; treron permagna',
    pinyin: ['gǔ'],
    decomposition: '⿰骨鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '骨',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      null,
    ],
  },
  {
    character: '鶼',
    definition: 'phoenix; fabulous mythical bird',
    pinyin: ['jiān'],
    decomposition: '⿰兼鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兼',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鷀',
    definition: 'the fishing cormorant',
    pinyin: ['cí'],
    decomposition: '⿰兹鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兹',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鷂',
    definition: 'sparrow hawk; Circus species (various)',
    pinyin: ['yào'],
    decomposition: '⿰䍃鳥',
    etymology: {
      type: 'pictophonetic',
      semantic: '鳥',
      hint: 'bird',
      phonetic: '䍃',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鷄',
    definition: 'chicken',
    pinyin: ['jī'],
    decomposition: '⿰奚鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奚',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鷈',
    definition: 'a kind of bird',
    pinyin: ['tī'],
    decomposition: '⿰鳥虒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '虒',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鷉',
    definition: 'grebe, duck',
    pinyin: ['tī'],
    decomposition: '⿰虒鳥',
    etymology: {
      type: 'ideographic',
      hint: 'An amphibious 虒 bird 虒; 虒 also provides the pronunciation',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鷓',
    definition: 'partridge',
    pinyin: ['zhè'],
    decomposition: '⿰庶鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '庶',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鷗',
    definition: 'seagull, tern; Larus species (various)',
    pinyin: ['ōu'],
    decomposition: '⿰區鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '區',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鷙',
    definition: 'hawk, vulture',
    pinyin: ['zhì'],
    decomposition: '⿱執鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '執',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鷦',
    definition: 'wren',
    pinyin: ['jiāo'],
    decomposition: '⿰焦鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '焦',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鷫',
    definition: 'the turquoise kingfisher',
    pinyin: ['sù'],
    decomposition: '⿰肅鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肅',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鷯',
    definition: 'wren',
    pinyin: ['liáo'],
    decomposition: '⿰尞鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尞',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鷲',
    definition: 'condor, vulture',
    pinyin: ['jiù'],
    decomposition: '⿱就鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '就',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鷸',
    definition: 'snipe, kingfisher',
    pinyin: ['yù'],
    decomposition: '⿰矞鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '矞',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鷹',
    definition: 'eagle, falcon, hawk',
    pinyin: ['yīng'],
    decomposition: '⿸䧹鳥',
    etymology: {
      type: 'pictophonetic',
      semantic: '鳥',
      hint: 'bird',
      phonetic: '䧹',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鷺',
    definition: 'heron, egret; Ardea species (various)',
    pinyin: ['lù'],
    decomposition: '⿱路鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '路',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鷿',
    definition: 'a duck-like bird',
    pinyin: ['pì'],
    decomposition: '⿱辟鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辟',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鸂',
    definition: 'Mandarin duck, Aix galericulata',
    pinyin: ['xī'],
    decomposition: '⿰氵鷄',
    etymology: {
      type: 'ideographic',
      hint: 'Water 氵 fowl 鷄; 鷄 also provides the pronunciation',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鸊',
    definition: 'a kind of duck; Podiceps ruficolus',
    pinyin: ['pì'],
    decomposition: '⿰辟鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '辟',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鸕',
    definition: 'cormorant',
    pinyin: ['lú'],
    decomposition: '⿰盧鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '盧',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鸘',
    definition: 'eagle',
    pinyin: ['shuāng'],
    decomposition: '⿰霜鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '霜',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鸚',
    definition: 'parrot',
    pinyin: ['yīng'],
    decomposition: '⿰嬰鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '嬰',
      semantic: '鳥',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鸞',
    definition: 'fabulous bird',
    pinyin: ['luán'],
    decomposition: '⿱䜌鳥',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鳥',
      semantic: '䜌',
      hint: 'bird',
    },
    radical: '鳥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鸟',
    definition: 'bird',
    pinyin: ['niǎo'],
    decomposition: '？',
    etymology: { type: 'pictographic', hint: 'Simplified form of 烏, a bird' },
    radical: '鸟',
    matches: [null, null, null, null, null],
  },
  {
    character: '鸠',
    definition: 'pigeon; to collect, to assemble',
    pinyin: ['jiū'],
    decomposition: '⿰九鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '九',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鸡',
    definition: 'chicken',
    pinyin: ['jī'],
    decomposition: '⿰又鸟',
    etymology: { type: 'ideographic', hint: 'Another 又 kind of bird 鸟' },
    radical: '鸟',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鸢',
    definition: 'kite; Milvus species (various)',
    pinyin: ['yuān'],
    decomposition: '⿱弋鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弋',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鸣',
    definition: 'a bird call or animal cry; to make a sound',
    pinyin: ['míng'],
    decomposition: '⿰口鸟',
    etymology: { type: 'ideographic', hint: 'The sound 口 a bird 鸟 makes' },
    radical: '口',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鸥',
    definition: 'seagull, tern; Larus species (various)',
    pinyin: ['ōu'],
    decomposition: '⿰区鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '区',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鸦',
    definition: 'crow; Corvus species (various)',
    pinyin: ['yā'],
    decomposition: '⿰牙鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '牙',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鸧',
    definition: 'oriole',
    pinyin: ['cāng'],
    decomposition: '⿰仓鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '仓',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鸨',
    definition: 'bustard; procuress; Otis species (various)',
    pinyin: ['bǎo'],
    decomposition: '⿰⿱匕十鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匕',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0, 0], [0, 0], [0, 1], [0, 1], [1], [1], [1], [1], [1]],
  },
  {
    character: '鸩',
    definition: 'a bird resembling the secretary falcon',
    pinyin: ['zhèn'],
    decomposition: '⿰冘鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冘',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鸪',
    definition: 'species of Taiwan pigeon',
    pinyin: ['gū'],
    decomposition: '⿰古鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '古',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鸫',
    definition: 'thrush; Turdus species (various)',
    pinyin: ['dōng'],
    decomposition: '⿰东鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '东',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鸬',
    definition: 'cormorant',
    pinyin: ['lú'],
    decomposition: '⿰卢鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卢',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鸭',
    definition: 'duck; Anas species (various)',
    pinyin: ['yā'],
    decomposition: '⿰甲鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甲',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鸮',
    definition: 'owl',
    pinyin: ['xiāo'],
    decomposition: '⿰号鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '号',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鸯',
    definition: 'female mandarin duck (Aix galericulata)',
    pinyin: ['yāng'],
    decomposition: '⿱央鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '央',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鸰',
    definition: 'lark, wagtail; Motacilla species (various)',
    pinyin: ['líng'],
    decomposition: '⿰令鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '令',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鸱',
    definition: 'kite, horned owl; wine cups',
    pinyin: ['chī'],
    decomposition: '⿰氐鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '氐',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鸲',
    definition: 'mynah; Erithacus species (various)',
    pinyin: ['qú'],
    decomposition: '⿰句鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '句',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鸳',
    definition: 'male mandarin duck (Aix galericulata)',
    pinyin: ['yuān'],
    decomposition: '⿱夗鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夗',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鸵',
    definition: 'ostrich',
    pinyin: ['tuó'],
    decomposition: '⿰鸟它',
    etymology: {
      type: 'pictophonetic',
      phonetic: '它',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鸶',
    definition: 'the eastern egret',
    pinyin: ['sī'],
    decomposition: '⿱丝鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丝',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鸷',
    definition: 'hawk, vulture',
    pinyin: ['zhì'],
    decomposition: '⿱执鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '执',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鸸',
    definition: 'swallow',
    pinyin: ['ér'],
    decomposition: '⿰而鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '而',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鸹',
    definition: 'crow',
    pinyin: ['guā'],
    decomposition: '⿰舌鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '舌',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鸺',
    definition: 'horned owl, scops chinensis',
    pinyin: ['xiū'],
    decomposition: '⿰休鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '休',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鸻',
    definition: 'plover, wading bird',
    pinyin: ['héng'],
    decomposition: '⿰行鸟',
    etymology: {
      type: 'ideographic',
      hint: 'A wading 行 bird 鸟; 鸟 also provides the pronunciation',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鸽',
    definition: 'pigeon, dove; Columba species (various)',
    pinyin: ['gē'],
    decomposition: '⿰合鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '合',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鸾',
    definition: 'fabulous bird',
    pinyin: ['luán'],
    decomposition: '⿱亦鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鸟',
      semantic: '亦',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鸿',
    definition: 'a species of wild swan; vast',
    pinyin: ['hóng'],
    decomposition: '⿰江鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '江',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鹁',
    definition: 'a species of pigeon',
    pinyin: ['bó'],
    decomposition: '⿰孛鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '孛',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鹂',
    definition: 'Chinese oriole; Oriolus oriolus',
    pinyin: ['lí'],
    decomposition: '⿰丽鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '丽',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鹃',
    definition: 'cuckoo',
    pinyin: ['juān'],
    decomposition: '⿰肙鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肙',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鹄',
    definition: 'swan',
    pinyin: ['gǔ'],
    decomposition: '⿰告鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '告',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鹅',
    definition: 'goose',
    pinyin: ['é'],
    decomposition: '⿰我鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '我',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鹆',
    definition: 'mynah; Acridotheres tristis',
    pinyin: ['yù'],
    decomposition: '⿰谷鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '谷',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鹇',
    definition:
      'silver pheasant, Lophura nycthemera; Lophura species (various)',
    pinyin: ['xián'],
    decomposition: '⿰闲鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '闲',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鹈',
    definition: 'pelican',
    pinyin: ['tí'],
    decomposition: '⿰弟鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '弟',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鹉',
    definition: 'species of parrot',
    pinyin: ['wǔ'],
    decomposition: '⿰武鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '武',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鹊',
    definition: 'magpie; Pica species (various)',
    pinyin: ['què'],
    decomposition: '⿰昔鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昔',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鹋',
    definition: 'emu',
    pinyin: ['miáo'],
    decomposition: '⿰苗鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '苗',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鹌',
    definition: 'quail; Coturnix coturnix',
    pinyin: ['ān'],
    decomposition: '⿰奄鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奄',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鹍',
    definition: 'a bird resembling a crane',
    pinyin: ['kūn'],
    decomposition: '⿰昆鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '昆',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鹎',
    definition: 'bulbul, songbird; Pycnonotidae',
    pinyin: ['bēi'],
    decomposition: '⿰卑鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '卑',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鹏',
    definition: 'fabulous bird of enormous size',
    pinyin: ['péng'],
    decomposition: '⿰朋鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '朋',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鹑',
    definition: 'quail; Turnix species (various)',
    pinyin: ['chún'],
    decomposition: '⿰享鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '享',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鹒',
    definition: 'oriole',
    pinyin: ['gēng'],
    decomposition: '⿰庚鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '庚',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鹔',
    definition: 'the turquoise kingfisher',
    pinyin: ['sù'],
    decomposition: '⿰肃鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '肃',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '鹕',
    definition: 'pelican',
    pinyin: ['hú'],
    decomposition: '⿰胡鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '胡',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鹗',
    definition: 'osprey, fishhawk',
    pinyin: ['è'],
    decomposition: '⿰咢鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咢',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鹘',
    definition: 'a kind of pigeon; treron permagna',
    pinyin: ['gǔ'],
    decomposition: '⿰骨鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '骨',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鹙',
    definition: 'waterfowl; Garrulus glandarius',
    pinyin: ['qiū'],
    decomposition: '⿱秋鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '秋',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鹚',
    definition: 'cormorant',
    pinyin: ['cí'],
    decomposition: '⿰兹鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兹',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鹛',
    definition: 'cormorant',
    pinyin: ['méi'],
    decomposition: '⿰眉鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '眉',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鹜',
    definition: 'duck',
    pinyin: ['wù'],
    decomposition: '⿱敄鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '敄',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鹞',
    definition: 'sparrow hawk; Circus species (various)',
    pinyin: ['yào'],
    decomposition: '⿰？鸟',
    etymology: { type: 'pictophonetic', semantic: '鸟', hint: 'bird' },
    radical: '鸟',
    matches: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鹠',
    definition: 'owl',
    pinyin: ['liú'],
    decomposition: '⿰留鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '留',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鹡',
    definition: 'wagtail',
    pinyin: ['jí'],
    decomposition: '⿰脊鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '脊',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鹣',
    definition: 'phoenix; fabulous mythical bird',
    pinyin: ['jiān'],
    decomposition: '⿰兼鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兼',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鹤',
    definition: 'crane; Grus species (various)',
    pinyin: ['hè'],
    decomposition: '⿰隺鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '隺',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鹦',
    definition: 'parrot',
    pinyin: ['yīng'],
    decomposition: '⿰婴鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '婴',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鹧',
    definition: 'partridge',
    pinyin: ['zhè'],
    decomposition: '⿰庶鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '庶',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鹨',
    definition: 'Anthus species (various)',
    pinyin: ['liù'],
    decomposition: '⿰翏鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '翏',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鹩',
    definition: 'wren',
    pinyin: ['liáo'],
    decomposition: '⿰尞鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尞',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鹪',
    definition: 'wren',
    pinyin: ['jiāo'],
    decomposition: '⿰焦鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '焦',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鹫',
    definition: 'condor, vulture',
    pinyin: ['jiù'],
    decomposition: '⿱就鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '就',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鹬',
    definition: 'snipe, kingfisher',
    pinyin: ['yù'],
    decomposition: '⿰矞鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '矞',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鹭',
    definition: 'heron, egret; Ardea species (various)',
    pinyin: ['lù'],
    decomposition: '⿱路鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '路',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鹮',
    definition: 'spoonbill, ibis; Threskiornidae',
    pinyin: ['huán'],
    decomposition: '⿰睘鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '睘',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鹰',
    definition: 'eagle, falcon, hawk',
    pinyin: ['yīng'],
    decomposition: '⿸⿸广倠鸟',
    etymology: { type: 'pictophonetic', semantic: '鸟', hint: 'bird' },
    radical: '鸟',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鹱',
    definition: 'waterfowl',
    pinyin: ['hù'],
    decomposition: '⿰鸟蒦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '蒦',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鹳',
    definition: 'crane, stork; Ciconia species (various)',
    pinyin: ['guàn'],
    decomposition: '⿰雚鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '雚',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鹴',
    definition: 'eagle',
    pinyin: ['shuāng'],
    decomposition: '⿰霜鸟',
    etymology: {
      type: 'pictophonetic',
      phonetic: '霜',
      semantic: '鸟',
      hint: 'bird',
    },
    radical: '鸟',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鹵',
    definition: 'salt',
    pinyin: ['lǔ'],
    decomposition: '⿱？⿴囗？',
    etymology: {
      type: 'pictographic',
      hint: 'A container used to brine pickles',
    },
    radical: '鹵',
    matches: [
      null,
      null,
      [1, 0],
      [1, 0],
      null,
      null,
      null,
      null,
      null,
      null,
      [1, 0],
    ],
  },
  {
    character: '鹹',
    definition: 'all, together, united; salted',
    pinyin: ['xián'],
    decomposition: '⿰鹵咸',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咸',
      semantic: '鹵',
      hint: 'salt',
    },
    radical: '鹵',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鹼',
    definition: 'alkaline, alkali, lye, salt',
    pinyin: ['jiǎn'],
    decomposition: '⿰鹵僉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '僉',
      semantic: '鹵',
      hint: 'salt',
    },
    radical: '鹵',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鹽',
    definition: 'salt',
    pinyin: ['yán'],
    decomposition: '⿱⿰臣⿱？鹵皿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '皿',
      semantic: '鹵',
      hint: 'salt',
    },
    radical: '鹵',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      null,
      null,
      [0, 1, 1],
      [0, 1, 1],
      [0, 1, 1],
      [0, 1, 1],
      [0, 1, 1],
      [0, 1, 1],
      [0, 1, 1],
      [0, 1, 1],
      [0, 1, 1],
      [0, 1, 1],
      [0, 1, 1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鹾',
    definition: 'salty; salt',
    pinyin: ['cuó'],
    decomposition: '⿰卤差',
    etymology: {
      type: 'pictophonetic',
      phonetic: '差',
      semantic: '卤',
      hint: 'salt',
    },
    radical: '卤',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鹿',
    definition: 'deer; surname',
    pinyin: ['lù'],
    decomposition: '⿸广⿱？比',
    etymology: {
      type: 'pictographic',
      hint: 'A deer with an antlered head, two legs, and a tail',
    },
    radical: '鹿',
    matches: [
      [0],
      [0],
      [0],
      null,
      null,
      null,
      null,
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '麂',
    definition: 'a species of deer',
    pinyin: ['jǐ'],
    decomposition: '⿸鹿几',
    etymology: {
      type: 'pictophonetic',
      phonetic: '几',
      semantic: '鹿',
      hint: 'deer',
    },
    radical: '鹿',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '麃',
    definition: 'to plow, to till',
    pinyin: ['páo'],
    decomposition: '⿱鹿灬',
    etymology: { type: 'ideographic', hint: 'Tracks 灬 left by a deer 鹿' },
    radical: '鹿',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '麇',
    definition: 'hornless deer; to collect; to band together',
    pinyin: ['jūn'],
    decomposition: '⿸鹿禾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '禾',
      semantic: '鹿',
      hint: 'deer',
    },
    radical: '鹿',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '麈',
    definition: 'a species of deer',
    pinyin: ['zhǔ'],
    decomposition: '⿸鹿主',
    etymology: {
      type: 'pictophonetic',
      phonetic: '主',
      semantic: '鹿',
      hint: 'deer',
    },
    radical: '鹿',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '麋',
    definition: 'elk; surname',
    pinyin: ['mí'],
    decomposition: '⿸鹿米',
    etymology: {
      type: 'pictophonetic',
      phonetic: '米',
      semantic: '鹿',
      hint: 'deer',
    },
    radical: '鹿',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '麒',
    definition: 'mythical unicorn',
    pinyin: ['qí'],
    decomposition: '⿰鹿其',
    etymology: {
      type: 'pictophonetic',
      phonetic: '其',
      semantic: '鹿',
      hint: 'deer',
    },
    radical: '鹿',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '麓',
    definition: 'the base of a hill; foothill',
    pinyin: ['lù'],
    decomposition: '⿱林鹿',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鹿',
      semantic: '林',
      hint: 'forest',
    },
    radical: '鹿',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '麗',
    definition: 'beautiful, elegant, magnificent',
    pinyin: ['lì'],
    decomposition: '⿱丽鹿',
    etymology: { type: 'ideographic', hint: 'The antlers of a deer 鹿' },
    radical: '鹿',
    matches: [
      [0],
      [0],
      [0],
      [0],
      null,
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '麝',
    definition: 'musk deer',
    pinyin: ['shè'],
    decomposition: '⿸鹿射',
    etymology: {
      type: 'pictophonetic',
      phonetic: '射',
      semantic: '鹿',
      hint: 'deer',
    },
    radical: '鹿',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '麟',
    definition: 'female unicorn',
    pinyin: ['lín'],
    decomposition: '⿰鹿粦',
    etymology: {
      type: 'pictophonetic',
      phonetic: '粦',
      semantic: '鹿',
      hint: 'deer',
    },
    radical: '鹿',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '麥',
    definition: 'wheat, barley, oats',
    pinyin: ['mài'],
    decomposition: '⿱來夂',
    etymology: {
      type: 'ideographic',
      hint: 'Grains 來 ready to be harvested 夂; compare 麦',
    },
    radical: '麥',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '麦',
    definition: 'wheat, barley, oats',
    pinyin: ['mài'],
    decomposition: '⿱龶夂',
    etymology: {
      type: 'ideographic',
      hint: 'Simplified form of 麦; grains 來 ready to be harvested 夂',
    },
    radical: '麦',
    matches: [[0], [0], [0], [0], [1], [1], [1]],
  },
  {
    character: '麩',
    definition: 'bran',
    pinyin: ['fū'],
    decomposition: '⿰麥夫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夫',
      semantic: '麥',
      hint: 'wheat',
    },
    radical: '麥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '麯',
    definition: 'yeast, leaven',
    pinyin: ['qū'],
    decomposition: '⿰麥曲',
    etymology: {
      type: 'pictophonetic',
      phonetic: '曲',
      semantic: '麥',
      hint: 'wheat',
    },
    radical: '麥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '麴',
    definition: 'yeast; to leaven; surname',
    pinyin: ['qū'],
    decomposition: '⿰麥匊',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匊',
      semantic: '麥',
      hint: 'wheat',
    },
    radical: '麦',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '麵',
    definition: 'face; surface, side; plane, dimension',
    pinyin: ['miàn'],
    decomposition: '⿰麥面',
    etymology: {
      type: 'pictophonetic',
      phonetic: '麥',
      semantic: '面',
      hint: 'face',
    },
    radical: '麥',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '麸',
    definition: 'bran',
    pinyin: ['fū'],
    decomposition: '⿰麦夫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夫',
      semantic: '麦',
      hint: 'wheat',
    },
    radical: '麦',
    matches: [[0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '麻',
    definition: 'hemp, flax, sesame; numb',
    pinyin: ['má'],
    decomposition: '⿸广林',
    etymology: {
      type: 'ideographic',
      hint: 'Hemp plants 林 growing in a greenhouse 广',
    },
    radical: '麻',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '麼',
    definition: 'interrogative particle',
    pinyin: ['me'],
    decomposition: '⿸麻幺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '麻',
      semantic: '幺',
      hint: 'one',
    },
    radical: '麻',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '麽',
    definition: 'interrogative particle',
    pinyin: ['me'],
    decomposition: '⿸麻么',
    etymology: { type: 'pictophonetic', phonetic: '麻', semantic: '么' },
    radical: '麻',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '麾',
    definition: 'pennant, flag, banner; to signal to',
    pinyin: ['huī'],
    decomposition: '⿸麻毛',
    radical: '麻',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '麿',
    definition: 'I, you, personal name marker',
    pinyin: ['mo'],
    decomposition: '⿸麻吕',
    radical: '麻',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '黃',
    definition: 'yellow; surname',
    pinyin: ['huáng'],
    decomposition: '⿱廿⿱⿱一由八',
    etymology: { type: 'pictographic', hint: 'A jade pendant' },
    radical: '黃',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 0, 0],
      [1, 0, 1],
      [1, 0, 1],
      [1, 0, 1],
      [1, 0, 1],
      [1, 0, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '黄',
    definition: 'yellow; surname',
    pinyin: ['huáng'],
    decomposition: '⿱？⿱由八',
    etymology: { type: 'pictographic', hint: 'A jade pendant' },
    radical: '黄',
    matches: [
      null,
      null,
      null,
      null,
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '黉',
    definition: 'school',
    pinyin: ['hóng'],
    decomposition: '⿳⺍冖黄',
    radical: '黄',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '黍',
    definition: 'broomcorn millet; glutinous millet',
    pinyin: ['shǔ'],
    decomposition: '⿱禾⿱人氺',
    etymology: {
      type: 'ideographic',
      hint: 'Grain 禾 that can be fermented to make wine 氺',
    },
    radical: '黍',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1, 0],
      [1, 0],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
      [1, 1],
    ],
  },
  {
    character: '黎',
    definition: 'many, numerous; black; surname',
    pinyin: ['lí'],
    decomposition: '⿰黍？',
    radical: '黍',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      null,
      null,
      null,
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '黏',
    definition: 'to stick to; glutinous, sticky; glue',
    pinyin: ['nián'],
    decomposition: '⿰黍占',
    etymology: {
      type: 'pictophonetic',
      phonetic: '占',
      semantic: '黍',
      hint: 'millet',
    },
    radical: '黍',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '黑',
    definition: 'black; dark; evil, sinister',
    pinyin: ['hēi'],
    decomposition: '⿱？灬',
    etymology: {
      type: 'ideographic',
      hint: "A man's face blacked by soot from a fire 灬",
    },
    radical: '黑',
    matches: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '黔',
    definition: 'black; the Guizhou province',
    pinyin: ['qián'],
    decomposition: '⿰黑今',
    etymology: {
      type: 'pictophonetic',
      phonetic: '今',
      semantic: '黑',
      hint: 'black',
    },
    radical: '黑',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '默',
    definition: 'silent; quiet, still; dark',
    pinyin: ['mò'],
    decomposition: '⿰黑犬',
    etymology: {
      type: 'pictographic',
      hint: 'A dog 犬 watching in the dark 黑',
    },
    radical: '黑',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '黛',
    definition: "to blacken one's eyebrows; black",
    pinyin: ['dài'],
    decomposition: '⿱代黑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '代',
      semantic: '黑',
      hint: 'black',
    },
    radical: '黑',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '黜',
    definition: 'to dismiss; to downgrade, to demote',
    pinyin: ['chù'],
    decomposition: '⿰黑出',
    etymology: {
      type: 'pictophonetic',
      phonetic: '出',
      semantic: '黑',
      hint: 'black',
    },
    radical: '黑',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '黝',
    definition: 'black',
    pinyin: ['yǒu'],
    decomposition: '⿰黑幼',
    etymology: {
      type: 'pictophonetic',
      phonetic: '幼',
      semantic: '黑',
      hint: 'black',
    },
    radical: '黑',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '點',
    definition: 'dot, point, speck',
    pinyin: ['diǎn'],
    decomposition: '⿰黑占',
    etymology: {
      type: 'pictophonetic',
      phonetic: '占',
      semantic: '黑',
      hint: 'black',
    },
    radical: '黑',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '黟',
    definition: 'ebony; shining black',
    pinyin: ['yī'],
    decomposition: '⿰黑多',
    etymology: {
      type: 'pictophonetic',
      phonetic: '多',
      semantic: '黑',
      hint: 'black',
    },
    radical: '黑',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '黠',
    definition: 'sly, cunning, shrewd; artful',
    pinyin: ['xiá'],
    decomposition: '⿰黑吉',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吉',
      semantic: '黑',
      hint: 'sinister',
    },
    radical: '黑',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '黢',
    definition: 'black',
    pinyin: ['qū'],
    decomposition: '⿰黑夋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '夋',
      semantic: '黑',
      hint: 'black',
    },
    radical: '黑',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '黥',
    definition: 'to tattoo; to brand the face of criminals',
    pinyin: ['qíng'],
    decomposition: '⿰黑京',
    etymology: {
      type: 'pictophonetic',
      phonetic: '京',
      semantic: '黑',
      hint: 'black',
    },
    radical: '黑',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '黧',
    definition: 'a dark, sallow colour',
    pinyin: ['lí'],
    decomposition: '⿱？黑',
    etymology: { type: 'pictophonetic', hint: 'black', semantic: '黑' },
    radical: '黑',
    matches: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '黨',
    definition: 'political party, gang, faction',
    pinyin: ['dǎng'],
    decomposition: '⿱尚黑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '尚',
      semantic: '兄',
      hint: 'dark',
    },
    radical: '黑',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '黩',
    definition: 'to dishonor, to defile, to corrupt; soiled',
    pinyin: ['dú'],
    decomposition: '⿰黑卖',
    etymology: {
      type: 'pictophonetic',
      phonetic: '黑',
      semantic: '卖',
      hint: 'black',
    },
    radical: '黑',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '黪',
    definition: 'grey-black',
    pinyin: ['cǎn'],
    decomposition: '⿰黑参',
    etymology: {
      type: 'pictophonetic',
      phonetic: '参',
      semantic: '黑',
      hint: 'black',
    },
    radical: '黑',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '黯',
    definition: ' black; dark; sullen, dreary',
    pinyin: ['àn'],
    decomposition: '⿰黑音',
    etymology: {
      type: 'pictophonetic',
      phonetic: '音',
      semantic: '黑',
      hint: 'black',
    },
    radical: '音',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '黴',
    definition: 'bacteria, fungi, mold',
    pinyin: ['méi'],
    decomposition: '⿵微黑',
    etymology: {
      type: 'ideographic',
      hint: 'A small 微 black 黑 growth; 微 also provides the pronunciation',
    },
    radical: '黑',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
      [0],
      [0],
      [0],
    ],
  },
  {
    character: '黷',
    definition: 'to dishonor, to defile, to corrupt; soiled',
    pinyin: ['dú'],
    decomposition: '⿰黑賣',
    etymology: {
      type: 'pictophonetic',
      phonetic: '黑',
      semantic: '賣',
      hint: 'black',
    },
    radical: '黑',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '黹',
    definition: 'embroidery, needlework',
    pinyin: ['zhǐ'],
    decomposition: '⿱业？',
    radical: '黹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    ],
  },
  {
    character: '黻',
    definition: 'special pattern of embroidery',
    pinyin: ['fú'],
    decomposition: '⿰黹犮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '犮',
      semantic: '黹',
      hint: 'embroidery',
    },
    radical: '黹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '黼',
    definition: 'embroidered official or sacrificial robe',
    pinyin: ['fǔ'],
    decomposition: '⿰黹甫',
    etymology: {
      type: 'pictophonetic',
      phonetic: '甫',
      semantic: '黹',
      hint: 'embroidery',
    },
    radical: '黹',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '黽',
    definition: 'frog, toad; to strive, to endeavor',
    pinyin: ['miǎn'],
    decomposition: '⿻？？',
    etymology: { type: 'pictographic', hint: 'A frog with bug-eyes' },
    radical: '黽',
    matches: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    ],
  },
  {
    character: '黾',
    definition: 'frog, toad; to strive, to endeavor',
    pinyin: ['miǎn'],
    decomposition: '⿱口电',
    etymology: {
      type: 'pictographic',
      hint: 'Simplified form of 黽; a frog with bug-eyes',
    },
    radical: '黾',
    matches: [[0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '黿',
    definition: 'large turtle, sea turtle',
    pinyin: ['yuán'],
    decomposition: '⿱元黽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '元',
      semantic: '黽',
      hint: 'toad',
    },
    radical: '黽',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鼂',
    definition: 'a kind of sea turtle; surname',
    pinyin: ['cháo'],
    decomposition: '⿱旦黽',
    etymology: { type: 'pictophonetic', semantic: '黽', hint: 'toad' },
    radical: '黽',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鼉',
    definition: 'large reptile, water lizard',
    pinyin: ['tuó'],
    decomposition: '⿳⿰口口⿱田一黽',
    etymology: {
      type: 'pictophonetic',
      semantic: '黽',
      hint: 'frog',
      phonetic: '口',
    },
    radical: '黽',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
      [2],
    ],
  },
  {
    character: '鼋',
    definition: 'large turtle, sea turtle',
    pinyin: ['yuán'],
    decomposition: '⿱元黾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '元',
      semantic: '黾',
      hint: 'toad',
    },
    radical: '龟',
    matches: [[0], [0], [0], [0], [1], [1], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '鼍',
    definition: 'large reptile, water lizard',
    pinyin: ['tuó'],
    decomposition: '⿱⿰口口⿱田⿱一黾',
    etymology: { type: 'pictophonetic', semantic: '黾', hint: 'frog' },
    radical: '黾',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 0],
      [1, 1, 0],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
      [1, 1, 1],
    ],
  },
  {
    character: '鼎',
    definition: 'large, three-legged bronze cauldron',
    pinyin: ['dǐng'],
    decomposition: '⿶？目',
    etymology: {
      type: 'pictographic',
      hint: 'A cauldron on its bronze tripod',
    },
    radical: '鼎',
    matches: [
      [1],
      [1],
      [1],
      [1],
      [1],
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    ],
  },
  {
    character: '鼐',
    definition: 'incense tripod',
    pinyin: ['nài'],
    decomposition: '⿱乃鼎',
    etymology: {
      type: 'pictophonetic',
      phonetic: '乃',
      semantic: '鼎',
      hint: 'tripod',
    },
    radical: '鼎',
    matches: [
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鼓',
    definition: 'drum; to beat, to strike; to rouse',
    pinyin: ['gǔ'],
    decomposition: '⿰壴支',
    etymology: {
      type: 'pictophonetic',
      phonetic: '支',
      semantic: '壴',
      hint: 'drum',
    },
    radical: '鼓',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1]],
  },
  {
    character: '鼕',
    definition: 'the sound of drums',
    pinyin: ['dōng'],
    decomposition: '⿱鼓冬',
    etymology: {
      type: 'pictophonetic',
      phonetic: '冬',
      semantic: '鼓',
      hint: 'drum',
    },
    radical: '鼓',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鼗',
    definition: 'small revolving drum with knobs',
    pinyin: ['táo'],
    decomposition: '⿱兆鼓',
    etymology: {
      type: 'pictophonetic',
      phonetic: '兆',
      semantic: '鼓',
      hint: 'drum',
    },
    radical: '鼓',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鼙',
    definition: 'drum carried on horseback',
    pinyin: ['pí'],
    decomposition: '⿱鼓卑',
    etymology: {
      type: 'pictophonetic',
      phonetic: '鼓',
      semantic: '卑',
      hint: 'drum',
    },
    radical: '鼓',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鼠',
    definition: 'rat, mouse',
    pinyin: ['shǔ'],
    decomposition: '⿱臼？',
    etymology: {
      type: 'pictographic',
      hint: 'A mouse, with two paws to the left and the tail to the right',
    },
    radical: '鼠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    ],
  },
  {
    character: '鼢',
    definition: 'a variety of mole',
    pinyin: ['fén'],
    decomposition: '⿰鼠分',
    etymology: {
      type: 'pictophonetic',
      phonetic: '分',
      semantic: '鼠',
      hint: 'rat',
    },
    radical: '鼠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鼩',
    definition: 'shrew',
    pinyin: ['qú'],
    decomposition: '⿰鼠句',
    etymology: {
      type: 'pictophonetic',
      phonetic: '句',
      semantic: '鼠',
      hint: 'rat',
    },
    radical: '鼠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鼬',
    definition: 'weasel, mustela itatis',
    pinyin: ['yòu'],
    decomposition: '⿰鼠由',
    etymology: {
      type: 'pictophonetic',
      phonetic: '由',
      semantic: '鼠',
      hint: 'rat',
    },
    radical: '鼠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鼯',
    definition: 'flying squirrel',
    pinyin: ['wú'],
    decomposition: '⿰鼠吾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吾',
      semantic: '鼠',
      hint: 'mouse',
    },
    radical: '鼠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鼱',
    definition: 'shrew',
    pinyin: ['jīng'],
    decomposition: '⿰鼠青',
    etymology: {
      type: 'pictophonetic',
      phonetic: '青',
      semantic: '鼠',
      hint: 'rat',
    },
    radical: '鼠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鼴',
    definition: 'a kind of insectivorous rodent',
    pinyin: ['yǎn'],
    decomposition: '⿰鼠匽',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匽',
      semantic: '鼠',
      hint: 'rat',
    },
    radical: '鼠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鼷',
    definition: 'mouse',
    pinyin: ['xī'],
    decomposition: '⿰鼠奚',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奚',
      semantic: '鼠',
      hint: 'mouse',
    },
    radical: '鼠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鼹',
    definition: 'a kind of insectivorous rodent',
    pinyin: ['yǎn'],
    decomposition: '⿰鼠晏',
    etymology: {
      type: 'pictophonetic',
      phonetic: '晏',
      semantic: '鼠',
      hint: 'rat',
    },
    radical: '鼠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鼻',
    definition: 'nose; first',
    pinyin: ['bí'],
    decomposition: '⿱自畀',
    etymology: {
      type: 'pictophonetic',
      phonetic: '畀',
      semantic: '自',
      hint: 'self',
    },
    radical: '鼻',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '鼽',
    definition: 'sclogged nose',
    pinyin: ['qiú'],
    decomposition: '⿰鼻九',
    etymology: {
      type: 'pictophonetic',
      phonetic: '九',
      semantic: '鼻',
      hint: 'nose',
    },
    radical: '鼻',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
    ],
  },
  {
    character: '鼾',
    definition: 'to snore loudly',
    pinyin: ['hān'],
    decomposition: '⿰鼻干',
    etymology: {
      type: 'pictophonetic',
      phonetic: '干',
      semantic: '鼻',
      hint: 'nose',
    },
    radical: '鼻',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '齄',
    definition: 'red sores on the nose',
    pinyin: ['zhā'],
    decomposition: '⿰鼻查',
    etymology: {
      type: 'pictophonetic',
      phonetic: '查',
      semantic: '鼻',
      hint: 'nose',
    },
    radical: '鼻',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '齊',
    definition: 'even, uniform, of equal length',
    pinyin: ['qí'],
    decomposition: '⿱？？',
    etymology: {
      type: 'pictographic',
      hint: 'Three stalks of grain growing evenly',
    },
    radical: '齊',
    matches: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    ],
  },
  {
    character: '齋',
    definition: 'to fast, to abstain; a vegetarian diet',
    pinyin: ['zhāi'],
    decomposition: '⿵齊小',
    etymology: {
      type: 'pictophonetic',
      semantic: '齊',
      hint: 'even',
      phonetic: '小',
    },
    radical: '齊',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '齌',
    definition: 'to rage',
    pinyin: ['jì'],
    decomposition: '⿵齊火',
    etymology: {
      type: 'pictophonetic',
      phonetic: '齊',
      semantic: '火',
      hint: 'rage',
    },
    radical: '齊',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '齎',
    definition: 'gift, present; offering',
    pinyin: ['jī'],
    decomposition: '⿵齊貝',
    etymology: {
      type: 'pictophonetic',
      phonetic: '齊',
      semantic: '貝',
      hint: 'money',
    },
    radical: '齊',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '齐',
    definition: 'even, uniform, of equal length',
    pinyin: ['qí'],
    decomposition: '⿱文？',
    radical: '齐',
    matches: [[0], [0], [0], [0], null, null],
  },
  {
    character: '齑',
    definition: 'to smash into pieces, to pulverize; hash',
    pinyin: ['jī'],
    decomposition: '⿵齐韭',
    etymology: { type: 'pictophonetic', phonetic: '齐', semantic: '韭' },
    radical: '齐',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [0],
    ],
  },
  {
    character: '齒',
    definition: 'teeth; gears, cogs; age',
    pinyin: ['chǐ'],
    decomposition: '⿱止⿶凵⿳从一从',
    etymology: {
      type: 'pictographic',
      hint: 'Upper and lower teeth 从; 止 provides the pronunciation',
    },
    radical: '齒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 0],
      [1, 1, 1],
      [1, 1, 2],
      [1, 1, 2],
      [1, 1, 2],
      [1, 1, 2],
      [1, 0],
      [1, 0],
    ],
  },
  {
    character: '齙',
    definition: 'buck teeth',
    pinyin: ['bāo'],
    decomposition: '⿰齒包',
    etymology: {
      type: 'pictophonetic',
      phonetic: '包',
      semantic: '齒',
      hint: 'teeth',
    },
    radical: '齒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '齜',
    definition: "to bare one's teeth; crooked teeth",
    pinyin: ['zī'],
    decomposition: '⿰齒此',
    etymology: {
      type: 'pictophonetic',
      phonetic: '此',
      semantic: '齒',
      hint: 'teeth',
    },
    radical: '齒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '齟',
    definition: 'irregular teeth; discord',
    pinyin: ['jǔ'],
    decomposition: '⿰齒且',
    etymology: {
      type: 'pictophonetic',
      phonetic: '且',
      semantic: '齒',
      hint: 'teeth',
    },
    radical: '齒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '齡',
    definition: 'age; years',
    pinyin: ['líng'],
    decomposition: '⿰齒令',
    etymology: {
      type: 'pictophonetic',
      phonetic: '令',
      semantic: '齒',
      hint: 'age',
    },
    radical: '齒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '齦',
    definition: 'gums',
    pinyin: ['kěn'],
    decomposition: '⿰齒艮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '艮',
      semantic: '齒',
      hint: 'teeth',
    },
    radical: '齒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '齧',
    definition: 'to bite, to gnaw; to erode, to wear down',
    pinyin: ['niè'],
    decomposition: '⿱㓞齒',
    etymology: {
      type: 'pictophonetic',
      phonetic: '㓞',
      semantic: '齒',
      hint: 'teeth',
    },
    radical: '齒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '齪',
    definition: 'narrow, small-minded; dirty',
    pinyin: ['chuò'],
    decomposition: '⿰齒足',
    etymology: {
      type: 'pictophonetic',
      phonetic: '齒',
      semantic: '足',
      hint: 'teeth',
    },
    radical: '齒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '齬',
    definition: 'uneven teeth; to disagree',
    pinyin: ['yǔ'],
    decomposition: '⿰齒吾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吾',
      semantic: '齒',
      hint: 'teeth',
    },
    radical: '齒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '齮',
    definition: 'to bite',
    pinyin: ['yǐ'],
    decomposition: '⿰齒奇',
    etymology: {
      type: 'pictophonetic',
      phonetic: '奇',
      semantic: '齒',
      hint: 'teeth',
    },
    radical: '齒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '齱',
    definition: 'uneven teeth; buck-toothed',
    pinyin: ['zōu'],
    decomposition: '⿰齒取',
    etymology: {
      type: 'pictophonetic',
      phonetic: '取',
      semantic: '齒',
      hint: 'teeth',
    },
    radical: '齒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '齲',
    definition: 'tooth decay',
    pinyin: ['qǔ'],
    decomposition: '⿰齒禹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '禹',
      semantic: '齒',
      hint: 'teeth',
    },
    radical: '齒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '齵',
    definition: 'uneven teeth; buck-toothed',
    pinyin: ['óu'],
    decomposition: '⿰齒禺',
    etymology: {
      type: 'pictophonetic',
      phonetic: '禺',
      semantic: '齒',
      hint: 'teeth',
    },
    radical: '齒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '齶',
    definition: 'palate, the roof of the mouth',
    pinyin: ['è'],
    decomposition: '⿰齒咢',
    etymology: {
      type: 'pictophonetic',
      phonetic: '咢',
      semantic: '齒',
      hint: 'teeth',
    },
    radical: '齒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '齷',
    definition: 'narrow, small-minded; dirty',
    pinyin: ['wò'],
    decomposition: '⿰齒屋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屋',
      semantic: '齒',
      hint: 'teeth',
    },
    radical: '齒',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '齿',
    definition: 'teeth; gears, cogs; age',
    pinyin: ['chǐ'],
    decomposition: '⿱止⿶凵人',
    etymology: {
      type: 'pictographic',
      hint: 'Teeth 人凵; 止 provides the pronunciation',
    },
    radical: '齿',
    matches: [[0], [0], [0], [0], [1, 1], [1, 1], [1, 0], [1, 0]],
  },
  {
    character: '龀',
    definition: "to lose one's baby teeth",
    pinyin: ['chèn'],
    decomposition: '⿰齿匕',
    etymology: {
      type: 'pictophonetic',
      phonetic: '匕',
      semantic: '齿',
      hint: 'teeth',
    },
    radical: '齿',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1]],
  },
  {
    character: '龃',
    definition: 'irregular teeth; discord',
    pinyin: ['jǔ'],
    decomposition: '⿰齿且',
    etymology: {
      type: 'pictophonetic',
      phonetic: '且',
      semantic: '齿',
      hint: 'teeth',
    },
    radical: '齿',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '龄',
    definition: 'age; years',
    pinyin: ['líng'],
    decomposition: '⿰齿令',
    etymology: {
      type: 'pictophonetic',
      phonetic: '令',
      semantic: '齿',
      hint: 'age',
    },
    radical: '齿',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '龅',
    definition: 'buck teeth',
    pinyin: ['bāo'],
    decomposition: '⿰齿包',
    etymology: {
      type: 'pictophonetic',
      phonetic: '包',
      semantic: '齿',
      hint: 'teeth',
    },
    radical: '齿',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '龆',
    definition: "to lose one's baby teeth",
    pinyin: ['tiáo'],
    decomposition: '⿰齿召',
    etymology: {
      type: 'pictophonetic',
      phonetic: '召',
      semantic: '齿',
      hint: 'teeth',
    },
    radical: '齿',
    matches: [[0], [0], [0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '龇',
    definition: "to bare one's teeth; crooked teeth",
    pinyin: ['zī'],
    decomposition: '⿰齿此',
    etymology: {
      type: 'pictophonetic',
      phonetic: '此',
      semantic: '齿',
      hint: 'teeth',
    },
    radical: '齿',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '龈',
    definition: 'gums',
    pinyin: ['kěn'],
    decomposition: '⿰齿艮',
    etymology: {
      type: 'pictophonetic',
      phonetic: '艮',
      semantic: '齿',
      hint: 'teeth',
    },
    radical: '齿',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '龉',
    definition: 'uneven teeth; to disagree',
    pinyin: ['yǔ'],
    decomposition: '⿰齿吾',
    etymology: {
      type: 'pictophonetic',
      phonetic: '吾',
      semantic: '齿',
      hint: 'teeth',
    },
    radical: '齿',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '龊',
    definition: 'narrow, small-minded; dirty',
    pinyin: ['chuò'],
    decomposition: '⿰齿足',
    etymology: {
      type: 'pictophonetic',
      phonetic: '齿',
      semantic: '足',
      hint: 'teeth',
    },
    radical: '齿',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '龋',
    definition: 'tooth decay',
    pinyin: ['qǔ'],
    decomposition: '⿰齿禹',
    etymology: {
      type: 'pictophonetic',
      phonetic: '禹',
      semantic: '齿',
      hint: 'teeth',
    },
    radical: '齿',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '龌',
    definition: 'narrow, small-minded; dirty',
    pinyin: ['wò'],
    decomposition: '⿰齿屋',
    etymology: {
      type: 'pictophonetic',
      phonetic: '屋',
      semantic: '齿',
      hint: 'teeth',
    },
    radical: '齿',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '龍',
    definition: 'dragon; symbol of the emperor',
    pinyin: ['lóng'],
    decomposition: '⿰⿱立月？',
    etymology: {
      type: 'pictographic',
      hint: 'A dragon facing left and bending downwards',
    },
    radical: '龍',
    matches: [
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 0],
      [0, 1],
      [0, 1],
      [0, 1],
      [0, 1],
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    ],
  },
  {
    character: '龐',
    definition: 'disorderly, messy; huge, big',
    pinyin: ['páng'],
    decomposition: '⿸广龍',
    etymology: { type: 'ideographic', hint: 'A dragon 龍 inside a house 广' },
    radical: '龍',
    matches: [
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '龔',
    definition: 'to give, to present; reverential',
    pinyin: ['gōng'],
    decomposition: '⿱龍共',
    etymology: {
      type: 'pictophonetic',
      phonetic: '共',
      semantic: '龍',
      hint: 'dragon',
    },
    radical: '龍',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '龕',
    definition: 'niche, shrine',
    pinyin: ['kān'],
    decomposition: '⿱合龍',
    etymology: {
      type: 'pictophonetic',
      phonetic: '合',
      semantic: '龍',
      hint: 'dragon',
    },
    radical: '龍',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '龙',
    definition: 'dragon; symbol of the emperor',
    pinyin: ['lóng'],
    decomposition: '⿻尤丿',
    etymology: { type: 'pictographic', hint: 'A dragon' },
    radical: '龙',
    matches: [[0], [0], [0], [1], [0]],
  },
  {
    character: '龚',
    definition: 'to give, to present; reverential',
    pinyin: ['gōng'],
    decomposition: '⿱龙共',
    etymology: {
      type: 'pictophonetic',
      phonetic: '共',
      semantic: '龙',
      hint: 'dragon',
    },
    radical: '龙',
    matches: [[0], [0], [0], [0], [0], [1], [1], [1], [1], [1], [1]],
  },
  {
    character: '龛',
    definition: 'niche, shrine',
    pinyin: ['kān'],
    decomposition: '⿱合龙',
    etymology: {
      type: 'pictophonetic',
      phonetic: '合',
      semantic: '龙',
      hint: 'dragon',
    },
    radical: '龙',
    matches: [[0], [0], [0], [0], [0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '龜',
    definition: 'turtle, tortoise; cuckold',
    pinyin: ['guī'],
    decomposition: '？',
    etymology: {
      type: 'ideographic',
      hint: 'A turtle on its side with its shell to the right',
    },
    radical: '龜',
    matches: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    ],
  },
  {
    character: '龟',
    definition: 'turtle, tortoise; cuckold',
    pinyin: ['guī'],
    decomposition: '⿱⺈电',
    etymology: { type: 'pictographic', hint: 'A turtle; compare 龜' },
    radical: '龟',
    matches: [[0], [0], [1], [1], [1], [1], [1]],
  },
  {
    character: '龠',
    definition: 'flute; pipe, ancient measure',
    pinyin: ['yuè'],
    decomposition: '⿱亼？',
    etymology: { type: 'pictographic', hint: 'Panpipes' },
    radical: '龠',
    matches: [
      [0],
      [0],
      [0],
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    ],
  },
  {
    character: '龥',
    definition: 'to beg, to implore',
    pinyin: ['yù'],
    decomposition: '⿰龠頁',
    etymology: {
      type: 'pictophonetic',
      phonetic: '龠',
      semantic: '頁',
      hint: 'leaf',
    },
    radical: '龠',
    matches: [
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [0],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
      [1],
    ],
  },
  {
    character: '龶',
    pinyin: [],
    decomposition: '？',
    radical: '龶',
    matches: [null, null, null, null],
  },
  {
    character: '龹',
    definition: 'Form of 卷 used as a phonetic component',
    pinyin: ['quǎn'],
    decomposition: '⿻？丿',
    radical: '丿',
    matches: [null, null, null, null, [1], null],
  },
  {
    character: '龺',
    definition: 'sunlight; the rays of the sun',
    pinyin: ['gān'],
    decomposition: '⿳十日十',
    radical: '日',
    matches: [[0], [0], [1], [1], [1], [1], [2], [2]],
  },
]

export default DICTIONARY
